webpackJsonp([0],{

/***/ "./public/locales/de.json":
/***/ (function(module, exports) {

module.exports = {"admin.restaurant.create_restaurant":"Neues Restaurant","admin.restaurant.create_restaurant.currency":"Währung","admin.restaurant.create_restaurant.password":"Passwort","admin.restaurant.create_restaurant.password_verification":"Passwort Überprüfung","admin.restaurant.create_restaurant.restaurant_name":"Restaurant-Name","booking.calendar.add_booking":"Reservierung hinzufügen","booking.calendar.close_period_for_day":"Schließe den Zeitraum für diesen Tag.","booking.calendar.date_in_the_past":"Dieses Datum ist in der Vergangenheit","booking.calendar.error_is_after_max_time_ahead":"Reservierungen sind vorab geöffnet\\n{formattedMaxTimeAhead} .\\nWenn Sie diesen Tag verfügbar machen wollen, ändern Sie bitte die allgemeinen Einstellungen.","booking.calendar.open_period_for_day":"Öffne den Zeitraum für diesen Tag.","booking.calendar.period_cant_be_modified":"Dieser Zeitraum kann nicht verändert werden.","booking.create.confirmation":"Die Reservierung ist für den {date} um {hour} bestätigt ({status})","booking.day_state_chooser.closed":"Schließen","booking.day_state_chooser.open":"Öffnen","booking.draft.add_booking":"Reservierung hinzufügen","booking.draft.canceled":"storniert","booking.draft.no_show":"Nicht anzeigen","booking.draft.placed":"Besetzt","booking.list.table.header.actions":"Aktionen","booking.list.table.header.comment":"Kommentar","booking.list.table.header.date":"Datum","booking.list.table.header.first_name":"Vorname","booking.list.table.header.guest_number":"Nummer des Gastes","booking.list.table.header.hour":"Zeit","booking.list.table.header.last_name":"Nachname","booking.list.table.header.mark_read":"Als gesehen markieren","booking.list.table.header.source":"Quelle","booking.list.table.header.status":"Status","booking.list.table.no_booking":"keine Reservierungen.","booking.new_label":"NEU","booking.on_going.add_booking":"Reservierung hinzufügen","booking.on_going.download_pdf":"Download Zusammenfassung","booking.on_going.error_while_generating_pdf":"Während der PDF-Erstellung ist ein Fehler entstanden","booking.on_going.no_booking_for_this_day":"Es gibt noch keine Buchung für diesen Tag.","booking.on_going.without_period":"kein Zeitraum","booking.settings.capacity_specific.add_specific":"Besonderheit hinzufügen","booking.settings.capacity_specific.confirm_specific_deletion":"Sie sind im Begriff diese Besonderheiten zu löschen, bitte bestätigen","booking.settings.capacity_specific.create":"Besonderheit erstellen","booking.settings.capacity_specific.edit":"Besonderheit bearbeiten","booking.settings.capacity_specific.form.booking.settings.capacity_specific.already_exists":"Für dieses Datum und dieses Gericht existiert bereits eine Besonderheit .","booking.settings.capacity_specific.form.capacity_label":"Wählen sie Kapazität","booking.settings.capacity_specific.form.date_label":"Wählen sie ein Datum","booking.settings.capacity_specific.form.period_label":"Wählen sie ein Gericht","booking.settings.capacity_specific.table.header.capacity":"Kapazität","booking.settings.capacity_specific.table.header.delete":"Löschen","booking.settings.capacity_specific.table.header.edit":"Bearbeiten","booking.settings.capacity_specific.table.header.meal":"Gerichte","booking.settings.capacity.maximum_capacity":"Maximale Kapazität des Restaurants","booking.settings.capacity.maximum_capacity_tooltip":"Maximale Anzahl von Gästen des Restaurants (mit oder ohne Reservierung)","booking.settings.capacity.people":"Gäste","booking.settings.general.notice_activate_restaurant.point_1":"Ein oder Mehrere Gerichte zu Reservierung hinzufügen","booking.settings.general.notice_activate_restaurant.point_2":"Legen Sie die Reservierungsparameter fest","booking.settings.general.notice_activate_restaurant.title":"Um Ihr Restaurant zu aktivieren müssen Sie:","booking.settings.global.automatic_confirmation_input_group_addon":"Gäste (einbezogen)","booking.settings.global.automatic_confirmation_until":"Automatische Bestätigungen bis","booking.settings.global.automatic_confirmation_until_tooltip":"Ihre Kunden erhalten autmatisch eine Bestätigung ihrer Reservierungen. Diese werden direkt ins Reservierungsbuch eingetragen.","booking.settings.global.booking_confirmation_process_title":"Prozess der Reservierungsbestätigung","booking.settings.global.booking_for_current_period_allowed":"Buchung für den aktuellen Zeitraum zulassen","booking.settings.global.booking_for_current_period_allowed_tooltip":"Wenn diese Option aktiviert ist, wird die aktuelle Periode für Buchungen für Kunden verfügbar sein.","booking.settings.global.every_15_minutes":"Alle 15 Minuten","booking.settings.global.every_30_minutes":"Alle 30 Minuten","booking.settings.global.interval_between_slot_label":"Zeit zwischen Zwei Reservierungen","booking.settings.global.max_time_ahead":"Reservierung geöffnet","booking.settings.global.max_time_ahead_input_group_addon":"Tage im Voraus","booking.settings.global.max_time_ahead_tooltip":"Erlaubt ihren Kunden Wochen oder Monate vorher zu buchen","booking.settings.global.min_time_ahead":"Minimale Zeit für sofortige Buchung","booking.settings.global.min_time_ahead_input_group_addon":"Minuten","booking.settings.global.min_time_ahead_tooltip":"Minimale Zeit zwischen dem Zeitpunkt der Einreichung und des Zeitpunkts der Reservierung (z.B: Es ist 12:07 Uhr, Die Zeiträume für Reservierungen sind: 12.00Uhr/12.15Uhr/12.30Uhr und die minimale Zeit für eine sofortige Buchung beträgt 10 minuten => Ihr Kunde kann erst ab 12:30 Uhr buchen)","booking.settings.global.notification_settings_sms_email":"Reservierungen über SMS/Email erhalten","booking.settings.global.notification_settings_sms_email_tooltip":"Antworten sie schnell auf neue Reserverungen und bestätigen sie ausstehende Reservierungen so schnell wie möglich","booking.settings.global.notification_settings.disabled":"Deaktivieren","booking.settings.global.notification_settings.for_all":"Alle Reservierungen","booking.settings.global.notification_settings.for_validate_only":"Nur für zu bestätigende Reservierungen","booking.settings.global.time_before_no_show":"Automatisch \"nicht anzeigen\"Zuweisung für Reservierungen verfallen danach","booking.settings.global.time_before_no_show_input_group_addon":"Minuten","booking.settings.global.time_before_no_show_tooltip":"Diese abgelaufenen Reservierungen werden von \"derzeitige Reservierungen\" gelöscht und zu \"vergangenes\" übertragen","booking.settings.group.manual":"Manuelle Bestätigung des Restaurants bis","booking.settings.group.manual_input_group_addon":"Gäste (einbezogen)","booking.settings.group.manual_tooltip":"Maximale Anzahl an Gästen für eine Reservierung. Diese Reservierungen müssen vom Restaurant bestätigt werden, damit der Kunde eine Bestätigung erhält (diese Reservierungen werden von der verfügbaren Kapazität für diese Zeit abgezogen) ","booking.settings.period_specifics.add_date":"Datum hinzufügen","booking.settings.period_specifics.cant_create_param_message":"Es steht derzeit kein Zeitraum zur Verfügung. Bitte weisen sie nach, dass sie bereits einen verfügbaren Tag und eine Uhrzeit für Ihre Reservierung festgelegt haben.","booking.settings.period_specifics.cant_create_param_no_day_valid_message":"Es gibt keinen Tag mit gültiger Zeit.","booking.settings.period_specifics.cant_create_param_no_day_valid_title":"Parameter nicht akzeptiert","booking.settings.period_specifics.cant_create_param_title":"Parameter nicht akzeptieren","booking.settings.period_specifics.table.header.capacity":"Kapazität","booking.settings.period_specifics.table.header.day_of_week":"Wochentag","booking.settings.period_specifics.table.header.delete":"Löschen","booking.settings.period_specifics.table.header.hours":"Zeit","booking.settings.period_specifics.table.header.room":"Raum","booking.settings.period_specifics.table.row.are_you_sure":"Sind sie sicher?","booking.settings.period.add_period":"Gericht hinzufügen","booking.settings.period.delete_period.confirm_message":"Diese Aktion löscht alle Parameter diese Gerichtes.","booking.settings.period.delete_period.confirm_title":"Sie sind im Begriff dieses Gericht zu löschen, bitte bestätigen","booking.settings.period.list_title":"für Reservierung verfügbare Gerichte","booking.settings.period.table.label.average_duration_of_meal":"Durchschnittliche Zubereitungszeit eines Gerichtes","booking.settings.period.table.label.booking_closing_hour":"Zeitpunkt der letzten Reservierung","booking.settings.period.table.label.booking_opening_hour":"Zeitpunkt der ersten Reservierung","booking.settings.period.table.label.capacity":"Anzahl an Plätzen für Reservierung","booking.settings.period.table.label.status":"Status","booking.settings.rooms":"Räume","booking.settings.rooms.add_room":"Raum hinzufügen (z.B. Hauptraum, Terrasse)","booking.settings.rooms.already_exists_with_name":"Dieser Name wird bereits von einem existierenden Raum genutzt","booking.settings.rooms.ask_room_name":"Wie lautet der Name des Raums?","booking.settings.rooms.delete_room.confirm_message":"Diese Aktion wird alle Parameter dieses Raums löschen.","booking.settings.rooms.delete_room.confirm_title":"Sie sind im Begriff diesen Raum zu löschen, bitte bestätigen","booking.settings.rooms.modify_room.name":"Name des Raumes ändern","booking.settings.sales_contact.contact_for_client":"Kontaktdaten für den Kunden","booking.settings.sales_contact.contact_for_client.email":"Email","booking.settings.sales_contact.contact_for_client.phone":"Telefon","booking.settings.sales_contact.contact_for_client.type.call_back":"Der Kundenservice wird den Kunden kontaktieren","booking.settings.sales_contact.contact_for_client.type.user_must_call":"Der Kunde muss den Kundenservice kontaktieren","booking.settings.sales_contact.manual":"Manuelle Bestätigung des Kundenservices (Gruppe über  (group above {maxNumberOfGuestsForBooking} Gäste)","booking.settings.sales_contact.manual_tooltip":"Nutzen sie diese Funktion, wenn ihr Restaurant einen zugehörigen Service  zum Verwalten von Gruppenreservierungen besitzt (z.B. Menü, Spezielle Preise etc.). Die Reservierung des Kunden ist ausstehend, bis sie von einer authorisierten Person bestätigt wird (Diese ausstehenden Reservierungen werden nicht von der verfügbaren Kapazität in dieser Zeit abgezogen)","booking.settings.sms_email.automatic_confirmation":"Automatische Bestätigung","booking.settings.sms_email.cancel_booking":"Stornierung der Buchung","booking.settings.sms_email.explainaition_1":"Dieser Reiter erlaubt es Ihnen empfangene Nachrichten ihrer Kunden zu verwalten","booking.settings.sms_email.explainaition_2":"Diese Parameter sind nicht veränderbar. Kontaktieren sie den Hersteller für Änderungen.","booking.settings.sms_email.reminder_booking":"Erinnerung an Buchung","booking.settings.sms_email.waiting_booking":"ausstehende Buchungen","booking.settings.sms_email.waiting_booking_confirmation":"Bestätigung der ausstehenden Buchung","booking.settings.tabs.general":"Grundeinstellungen","booking.settings.tabs.sms_email":"SMS / EMAIL","booking.settings.tabs.specifics":"Besonderheiten Einstellungen","booking.tabs.calendar":"Kalender","booking.tabs.draft":"Vergangenes","booking.tabs.on_going":"Derzeitige Reservierungen","booking.tabs.unseens":"Neu","booking.tabs.waiting":"Bestätigung ausstehend","booking.unseen.add_booking":"Reservierung hinzufügen","booking.unseen.canceled_bookings":"Stornierte Reservierungen","booking.unseen.new_bookings":"Neue Reservierung","booking.waiting_label":"ZU BESTÄTIGEN","booking.waiting.add_booking":"Reservierung hinzufügen","booking.waiting.no_waiting_bookings":"Keine ausstehenden Bestätigungen.","booking.waiting.see_more":"Mehr sehen","components.availibility_hours.form.add_opening_hour":"Zeitraum hinzufügen","components.availibility_hours.form.custom_hours":"Stunden","components.availibility_hours.form.custom_hours.content":"Definieren Sie die Stunden für diesen Artikel","components.availibility_hours.form.off":"Aus","components.availibility_hours.form.off.content":"Dieser Artikel wird an diesem Tag nicht verfügbar sein.","components.availibility_hours.form.whole_day":"Tag","components.availibility_hours.form.whole_day.content":"Dieser Artikel wird den ganzen Tag verfügbar sein","components.booking.detail.action":"Aktion","components.booking.detail.action_disabled_explaination":"Diese Aktionen werden {minutes} vor der Buchungszeit aktiviert","components.booking.detail.cancel":"Stornieren","components.booking.detail.cancel_textarea_placeholder":"Kommentar, SMS/Email (nur bei Stornierung)","components.booking.detail.comments":"Kommentare:","components.booking.detail.confirm":"Bestätigen","components.booking.detail.confirmed":"Bestätigt","components.booking.detail.edit_info":"Buchungsinformationen bearbeiten","components.booking.detail.fidelity_cart_number":"Kundenkarte:","components.booking.detail.guest_number":"# Gästes:","components.booking.detail.modal_title":"Buchung(Details)","components.booking.detail.no_show":"Nicht anzeigen","components.booking.detail.not_arrived":"Nicht eingetroffen","components.booking.detail.seated":"Besetzt","components.booking.detail.source":"Herkunft:","components.booking.detail.status":"Status","components.booking.form.comment":"Kommentar","components.booking.form.create_booking":"Buchung erstellen","components.booking.form.fidelity_card_number":"Kundenkarten Nummer","components.booking.form.first_name":"Vorname","components.booking.form.guest_number":"Gästenummer","components.booking.form.last_name":"Nachname","components.booking.form.mobile":"Mobil","components.booking.form.no_slots_for_date":"In diesem Zeitraum ist keine Buchung verfügbar.","components.booking.form.phone_invalid":"Ungültige Telefonnummer","components.booking.form.room":"Raum","components.booking.form.update_booking":"Änderungen speichern","components.booking.modal.add.title":"Reservierung hinzufügen","components.booking.period_picker.placeholder":"Auswählen","components.booking.room_picker.all":"Alles","components.color.picker.modal_title":"Farbauswahl","components.color.picker.validate":"bestätigen","components.contact_modal.call_us_on":"Rufen sie uns an unter","components.contact_modal.send_mail_to":"Oder senden sie uns eine Email an ","components.contact_modal.title":"Kontakt","components.digicode.account_for_code_not_enough_right":"Der Code ist gültig, der Account besitzt jedoch nicht die erforderlichen Rechte für diese Aktion.","components.footer.cgu":"Haftungshinweis","components.footer.rights_reserved":"Alle Rechte vorbehalten","components.form.cancel_modifications":"Abbrechen","components.form.save":"Speichern","components.header.contact":"Kontakt","components.header.logout":"Ausloggen","components.menu.choose_product_modal.choose_products":"Artikel auswählen","components.menu.choose_product_modal.search_no_results":"Es gibt keinen Artikel, der diesen Suchkriterien entspricht.","components.menu.edit_category.delete":"Löschen","components.menu.edit_category.description":"Beschreibung","components.menu.edit_category.edit":"Kategorie bearbeiten","components.menu.edit_category.name":"Name","components.menu.edit_category.new":"Neue Kategorie","components.menu.edit_category.parent_category":"Übergeordnete Kategorie","components.menu.edit_category.submit":"Bestätigen","components.menu.edit_upselling_category.delete":"Löschen","components.menu.edit_upselling_category.description":"Beschreibung","components.menu.edit_upselling_category.description_placeholder":"(Max. 50 Zeichen)","components.menu.edit_upselling_category.edit":"Bearbeiten","components.menu.edit_upselling_category.name":"Name","components.menu.edit_upselling_category.name_placeholder":"(wird nicht veröffentlicht)","components.menu.edit_upselling_category.new":"Neu","components.menu.edit_upselling_category.submit":"Absenden","components.no_permission.label":"Sie besitzen nicht die erforderlichen Rechte für diese Aktion","components.no_permission.permission_required":"Genehmigung erforderlich","components.opening_hours.form_modal.closing":"Geschlossen","components.opening_hours.form_modal.create":"Öffnungszeitraum erstellen","components.opening_hours.form_modal.day":"Tag","components.opening_hours.form_modal.opening":"Geöffnet","components.opening_hours.form_modal.title":"Öffnungszeitraum hinzufügen","components.opening_hours.form.add_opening_hour":"Zeitraum hinzufügen","components.order.cancel.close":"Nein","components.order.cancel.error":"Diese Bestellung konnte nicht storniert werden.","components.order.cancel.refundCancel":"Durch die Stornierung dieser Bestellung wird Ihrem Kunden das Geld zurückerstattet.","components.order.cancel.submit":"Ja, stornieren","components.order.cancel.title":"Bestellung stornieren","components.order.cancel.verifyCancel":"Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?","components.order.detail.arrival_date":"Ankunftszeit:","components.order.detail.delivery_date":"Lieferzeit:","components.order.detail.delivery_price":"Lieferkosten:","components.order.detail.general_comment":"Allgemeiner Kommentar:","components.order.detail.has_paid":"Bezahlt","components.order.detail.kiosk_number":"Kiosk #","components.order.detail.on_site_payment":"Zahlung in Restaurant","components.order.detail.order_detail":"Bestellungsdetails","components.order.detail.order_number":"Bestellung Nr.","components.order.detail.order_total":"Gesamte Bestellung:","components.order.detail.pickup_date":"Abholzeit:","components.order.detail.status":"Status:","components.payment.modes.form.cash":"Bar","components.payment.modes.form.restaurant_ticket":"Essensgutscheine","components.prices_editor.activation":"Aktivierung","components.prices_editor.delivery":"Lieferung","components.prices_editor.mode":"Modus","components.prices_editor.on_site":"Im Haus","components.prices_editor.price_with_tax":"Preis inkl. MwSt.","components.prices_editor.take_away":"Außer Haus","components.prices_editor.vat":"MwSt.","components.restaurants_group.choose.modal_title":"Restaurantgruppe ändern","components.timelapse.picker.custom":"Angepasst","components.timelapse.picker.day":"1 Tag","components.timelapse.picker.month":"1 Monat","components.timelapse.picker.period":"Zeitraum","components.timelapse.picker.validate":"Bestätigen","components.timelapse.picker.week":"1 Woche","components.user.detail.average_payment":"Durchschnittliche Zahlung","components.user.detail.average_rate":"Durchschnittliche Bewertung","components.user.detail.average_tip":"Durchschnittliches Trinkgeld","components.user.detail.client_record":"Kundendatensatz","components.user.detail.last_visit":"Letzter Besuch","components.user.detail.total_visits_count":"Gesamtzahl der Besuche","components.user.payments.table.header.Hour":"Stunde","components.user.payments.table.header.payed_by_client":"Von Kunde bezahlt","components.user.payments.table.header.rate":"Bewertung","components.user.payments.table.header.with_tips":"inklusive Trinkgeld","export.failure":"Export fehlgeschlagen.","export.failure.invalid_time":"Der Zeitrahmen muss innerhalb von 3 Monaten liegen.","export.failure.message":"Ein Fehler ist aufgetreten. Bitte kontaktieren Sie unseren technischen Support.","export.help":"Exportieren Sie Ihre Daten für einen bestimmten Zeitraum (maximal 3 Monate).","export.option.BOOKINGS":"Buchungen","export.option.ORDER":"Bestellungen","export.option.PAYMENTS":"Zahlungen","export.option.REVIEWS":"Rezensionen","export.option.USERS":"Benutzer","export.submit":"Export","export.success":"Export erfolgreich!","export.success.message":"Sie erhalten eine E-Mail mit Ihren Daten.","global.allergen.BALSAM_OF_PERU":"Perubalsam","global.allergen.BUCKWHEAT":"Buchweizen","global.allergen.CELERY":"Sellerie","global.allergen.CHEESE":"Käse","global.allergen.CORN":"Mais","global.allergen.CRUSTACEAN":"Krustentier","global.allergen.EGG":"Ei","global.allergen.FISH":"Fisch","global.allergen.FRUIT":"Obst","global.allergen.GARLIC":"Knoblauch","global.allergen.LACTOSE":"Laktose","global.allergen.LUPINE":"Lupine","global.allergen.MUSTARD":"Senf","global.allergen.PEANUT":"Erdnuss","global.allergen.POULTRY_MEAT":"Geflügelfleisch","global.allergen.RED_MEAT":"Rotes Fleisch","global.allergen.RICE":"Reis","global.allergen.SESAME":"Sesam","global.allergen.SHELLFISH":"Schalentier","global.allergen.SOYA":"Soja","global.allergen.SULPHITES":"Sulfite","global.allergen.TARTRAZINE":"Tartrazin","global.allergen.GLUTEN":"Gluten","global.allergen.GLUTEN_OATS":"Hafer (Gluten)","global.allergen.GLUTEN_WHEAT":"Weizen (Gluten)","global.allergen.GLUTEN_KAMUT":"Kamut (Gluten)","global.allergen.GLUTEN_SPELT":"Dinkel (Gluten)","global.allergen.GLUTEN_GREEN_SPELT":"Grünkern (Gluten)","global.allergen.GLUTEN_EINKORN":"Einkorn (Gluten)","global.allergen.GLUTEN_RYE":"Roggen (Gluten)","global.allergen.GLUTEN_BARLEY":"Gerste (Gluten)","global.allergen.GLUTEN_EMMER":"Emmer (Gluten)","global.allergen.GLUTEN_TRITICALE":"Triticale (Gluten)","global.allergen.NUTS":"Nüsse","global.allergen.NUTS_ALMONDS":"Mandeln (Nüsse)","global.allergen.NUTS_HAZELNUTS":"Haselnüsse","global.allergen.NUTS_WALNUTS":"Walnüsse","global.allergen.NUTS_CASHEW":"Cashewkerne (Nüsse)","global.allergen.NUTS_PECANS":"Pekannüsse","global.allergen.NUTS_BRAZIL":"Paranüsse","global.allergen.NUTS_PISTACHES":"Pistazien (Nüsse)","global.allergen.NUTS_MACADAMIA_OR_QUEENSLAND":"Macadamianüsse (Queenslandüsse)","feature_not_activated":"Dieser Dienst ist auf Ihrem Account nicht aktiviert","forgot_password.description":"","forgot_password.email":"","forgot_password.failure":"","forgot_password.submit":"","forgot_password.success":"","forgot_password.title":"","login.form.connect":"Verbindung","login.form.password":"Passwort","login.form.username":"Login","login.form.forgot_password":"Passwort vergessen","logout.redirect_message":"Sie wurden abgemeldet, sie werden nun zur Login Seite weitergeleitet...","menu.admin":"Admin","menu.admin.restaurant":"Restaurant","menu.booking":"Buchung","menu.booking.book":"Reservierungsbuch","menu.booking.settings":"Einstellungen","menu.category.add_category":"Kategorie hinzufügen","menu.category.add_item.categories":"Kategorien","menu.category.add_item.child_categories":"TODO","menu.category.add_item.main_category":"Hauptkategorie","menu.category.add_item.menus_on_menu":"Menü von Kasse","menu.category.add_item.modal_title":"Kategorie hinzufügen","menu.category.add_item.no_item_selected":"Es ist kein Artikel ausgewählt.","menu.category.add_item.no_menu_selected":"Es ist kein Menü ausgewählt.","menu.category.add_item.products_on_menu":"Artikel von Kasse","menu.category.add_item.search_no_results":"Es gibt keinen Artikel, der diesen Suchkriterien entspricht.","menu.category.add_item.selected":"Ausgewählt","menu.category.ask_name":"Wie lautet der Name der zu erstellenden Kategorie?","menu.category.categories":"Kategorien","menu.category.confirm_deletion":"Sie sind im Begriff diese Kategorie zu löschen, bitte bestätigen","menu.category.confirm_deletion_from_root":"TODO","menu.category.detail.add_product_or_menu":"Artikel oder Menü hinzufügen","menu.category.detail.add_to_category":"Artikel hinzufügen","menu.category.detail.confirm_delete_child_category":"Sie sind dabei, diese untergeordnete Kategorie in dieser Kategorie zu löschen, bestätigen Sie bitte","menu.category.detail.confirm_delete_menu":"Sie sind im Begriff dieses Menü dieser Kategorie zu löschen, bitte bestätigen","menu.category.detail.confirm_delete_product":"Sie sind im Begriff diesen Artikel dieser Kategorie zu löschen, bitte bestätigen","menu.category.detail.delete":"Löschen","menu.category.detail.edit":"Bearbeiten","menu.category.detail.no_description":"Keine Beschreibung","menu.category.detail.table.header.delete_from_category":"Aus der Kategorie löschen","menu.category.detail.table.header.modes_and_price":"Modi & Preis","menu.category.detail.table.header.move":"Bewegen","menu.category.detail.table.header.name":"Name","menu.category.edit_main_category":"Hauptkategorie bearbeiten","menu.category.error_no_products_exists":"Sie müssen einen Artikel erstellen, damit Sie eine Kategorie erstellen können.","menu.category.menus":"Menüs","menu.category.products":"Artikel","menu.category.table.header.delete_from_main_category":"TODO","menu.category.table.header.move":"Bewegen","menu.category.table.header.name":"Name","menu.export":"Export","menu.item_selector.modal_title":"Artikel auswählen","menu.item_selector.no_item_selected":"Es ist kein Artikel ausgewählt.","menu.item_selector.products_on_menu":"Artikel im Menü","menu.item_selector.search_no_results":"Keine Ergebnisse","menu.item_selector.selected":"Ausgewählt","menu.max_with_colon":"Max:","menu.menu_edit.add_part":"Teil hinzufügen","menu.menu_edit.confirm_delete":"Sie sind im Begriff dieses Menü zu löschen, bitte bestätigen","menu.menu_edit.delete":"Dieses Menü löschen","menu.menu_edit.description":"Beschreibung","menu.menu_edit.menu_availability":"Verfügbarkeit","menu.menu_edit.menu_availability_date":"Ändern Sie den Zeitraum, in dem das Produkt verfügbar ist.","menu.menu_edit.menu_availability_date.caption":"z.B.: vom 01.01.2018 bis zum 30.04.2018","menu.menu_edit.menu_availability_hours":"Verfügbarkeitspläne nach Wochentag ändern ","menu.menu_edit.menu_availability_hours.caption":"z.B.: von 7.00 bis 22.00 Uhr, jeden Tag außer am Samstag","menu.menu_edit.menu_availability.caption":"Standardmäßig ist dieser Artikel das ganze Jahr über zu jeder Zeit verfügbar.","menu.menu_edit.name":"Name","menu.menu_edit.no_category_with_menu":"Dieses Menü ist in keiner Kategorie vorhanden.","menu.menu_edit.part.confirm_deletion":"Sie sind im Begriff diesen Teil zu löschen, bitte bestätigen","menu.menu_edit.part.delete":"Löschen","menu.menu_edit.part.edit":"Bearbeiten","menu.menu_edit.part.edit_addtionnal_price":"zusätzlichen Preis ändern","menu.menu_edit.part.edit_part_categories":"Anzeige organisieren","menu.menu_edit.part.form.additionnal_price":"zusätzlicher Preis","menu.menu_edit.part.form.max":"Max","menu.menu_edit.part.form.min":"Min","menu.menu_edit.part.form.name":"Name","menu.menu_edit.part.form.quantities":"Menge","menu.menu_edit.part.modify_products":"Artikel bearbeiten","menu.menu_edit.part.one_product_required":"Sie benötigen mindestens einen Artikel","menu.menu_edit.part.title_create":"Teil erstellen","menu.menu_edit.part.title_edit":"Teil bearbeiten","menu.menu_edit.parts":"Teile","menu.menu_edit.prices":"Preis","menu.menu_list.create_menu":"Menü erstellen","menu.menu_list.name":"Name","menu.menu_part_category.add_item.categories_on_menu":"Kategorien","menu.menu_part_category.add_item.modal_title":"Produkt zur Kategorie hinzufügen","menu.menu_part_category.categories":"Kategorien","menu.menu_part_category.check_all":"Alle aktivieren","menu.menu_part_category.edit.modal_title":"Kategorie bearbeiten","menu.menu_part_category.products":"Produkte","menu.menu_part_category.uncheck_all":"Alle deaktivieren","menu.menu_part.ask_new_category_name":"Neue Kategorie","menu.menu_part.category.delete":"Löschen","menu.menu_part.category.delete.are_you_sure":"Sie sind im Begriff diese Kategorie zu löschen, bitte bestätigen","menu.menu_part.category.edit_category":"Bearbeiten","menu.menu_part.category.modify_items":"Artikel hinzufügen / bearbeiten","menu.menu_part.category.new_category":"Unterkategorie erstellen","menu.menu_part.category.subcategory":"Unterkategorie","menu.menu.detail.categories":"Kategorie","menu.menu.detail.edit":"Bearbeiten","menu.menu.detail.no_category_with_product":"Dieser Artikel ist in keiner Kategorie vorhanden.","menu.menu.detail.no_description":"Keine Beschreibung","menu.menu.detail.parts":"Teile","menu.menu.detail.price":"Preis","menu.menu.detail.table.header.activation":"Aktivieren","menu.menu.detail.table.header.delivery":"Lieferung","menu.menu.detail.table.header.mode":"Modus","menu.menu.detail.table.header.on_site":"Im Haus","menu.menu.detail.table.header.price":"Preise","menu.menu.detail.table.header.take_away":"Außer Haus","menu.menu.detail.table.header.vat":"MwSt.","menu.min_with_colon":"Min:","menu.news":"Neuigkeiten","menu.news.home":"Start","menu.options_list.create_options":"Option erstellen","menu.options_list.name":"Name","menu.options_list.no_options":"Es ist keine Option festgelegt.","menu.order":"Aufträge","menu.order.cart_modifiers":"Angebote","menu.order.cart_modifiers.edit":"Bearbeiten","menu.order.cart_modifiers.new":"Neu","menu.order.orders_list":"erhaltene Aufträge","menu.order.restaurant_menu":"Artikel","menu.order.restaurant_menu.categories":"Kategorien","menu.order.restaurant_menu.edition":"Bearbeiten","menu.order.restaurant_menu.menus":"Menüs","menu.order.restaurant_menu.new":"Neu","menu.order.restaurant_menu.options":"Optionen","menu.order.restaurant_menu.products":"Artikel","menu.order.restaurant_menu.upselling_categories":"Zusatzverkauf","menu.order.settings":"Einstellungen","menu.order.statistics":"Statistiken","menu.payment":"Zahlungen","menu.payment.receipt":"Transaktionen","menu.payment.stat":"Statistiken","menu.pos_connection_loss":"Verbindung zu POS abgebrochen","menu.pos_connection_loss.tooltip":"Bitte überprüfen Sie Ihre POS-Konfiguration und Ihr Netzwerk sowie Ihre Anmeldeinformationen. Stellen Sie außerdem sicher, dass die POS-Dienste ausgeführt und erreichbar sind","menu.pro_accounts":"Benutzer","menu.pro_accounts.restaurants_groups":"Restaurants","menu.pro_accounts.roles":"Zuständigkeit","menu.pro_accounts.users":"Benutzer","menu.product_edit.product_availability":"Verfügbarkeit","menu.product_edit.product_availability_date":"Ändern Sie den Zeitraum, in dem das Produkt verfügbar ist.","menu.product_edit.product_availability_date.caption":"z.B.: vom 01.01.2018 bis zum 30.04.2018","menu.product_edit.product_availability_hours":"Verfügbarkeitspläne nach Wochentag ändern ","menu.product_edit.product_availability_hours.caption":"z.B.: von 7.00 bis 22.00 Uhr, jeden Tag außer am Samstag","menu.product_edit.product_availability.caption":"Standardmäßig ist dieser Artikel das ganze Jahr über zu jeder Zeit verfügbar.","menu.product_option_view.choices":"Angebotene Auswahlmöglichkeiten","menu.product_option_view.products":"Artikel","menu.product_option_view.products_with_option":"Artikel, die diese Option nutzen","menu.product_option.edit":"Bearbeiten","menu.product_option.max_with_colon":"Max:","menu.product_option.min_with_colon":"Min:","menu.product_option.no_products_with_option":"Diese Option ist in keinem Artikel vorhanden.","menu.product_option.option.edit.add_option_value":"Wert hinzufügen","menu.product_option.option.edit.confirm_delete":"Sie sind im Begriff diese Option zu löschen, bitte bestätigen","menu.product_option.option.edit.confirm_delete_value":"Sie sind im Begriff diesen Wert zu löschen, bitte bestätigen","menu.product_option.option.edit.delete_option":"Diese Option löschen","menu.product_option.option.edit.max":"Max","menu.product_option.option.edit.min":"Min","menu.product_option.option.edit.offered_choices":"vorgeschlagene Auswahlmöglichkeiten","menu.product_option.option.edit.quantities":"Menge","menu.product_option.option.value.additionnal_price":"zusätzlicher Preis","menu.product_option.option.value.delete_value":"Diesen Wert löschen","menu.product_option.option.value.edit_choice":"Auswahlmöglichkeit bearbeiten","menu.product_option.option.value.name":"Name","menu.product_option.option.value.new_choice":"Neue Auswahlmöglichkeit","menu.product_option.option.value.no_additionnal_price":"Kein zusätzlicher Preis","menu.product_option.option.value.stock":"Verfügbarkeit","menu.product_option.optionnal":"Optional","menu.product_option.required":"Mandatory Voraussetzung?","menu.product.available":"Verfügbar","menu.product.categories":"Kategorie","menu.product.edit":"Bearbeiten","menu.product.edit.add_category":"Zur Kategorie hinzufügen","menu.product.edit.available":"Verfügbar","menu.product.edit.categories":"Kategorien","menu.product.edit.confirm_delete_option":"Sind sie sicher, dass sie diese Option von diesem Artikel löschen wollen?","menu.product.edit.confirm_delete_product":"Sind sie sich sicher, dass sie diesen Artikel löschen wollen?","menu.product.edit.confirm_delete_product_from_category":"Sind sie sich sicher, dass sie diesen Artikel aus dieser Kategorie löschen wollen?","menu.product.edit.confirm_delete_product_from_menu":"Sind sie sich sicher, dass sie diesen Artikel aus dem Menü löschen wollen?","menu.product.edit.delete_product":"Artikel löschen","menu.product.edit.delete_product.permission_refused":"Nicht genügend Rechte, um dieses Produkt zu löschen","menu.product.edit.description":"Beschreibung","menu.product.edit.menus":"Menüs","menu.product.edit.name":"Name","menu.product.edit.no_category_with_product":"Dieser Artikel ist in keiner Kategorie verfügbar.","menu.product.edit.no_menu_with_product":"Dieser Artikel ist in keinem Menü verfügbar.","menu.product.edit.no_options":"Dieser Artikel besitzt keine Option.","menu.product.edit.options":"Optionen","menu.product.edit.prices":"Preis","menu.product.edit.select_options":"Wählen sie die Optionen","menu.product.edit.unavailable":"Nicht verfügbar","menu.product.list.create_product":"Artikel hinzufügen","menu.product.list.table.header.availibility":"Verfügbarkeit","menu.product.list.table.header.name":"Name","menu.product.list.table.header.prices":"Preis","menu.product.menus":"Menüs","menu.product.no_category_with_product":"Dieser Artikel ist in keiner Kategorie vorhanden.","menu.product.no_description":"Keine Beschreibung","menu.product.no_menu_with_product":"Dieser Artikel ist in keinem Menü vorhanden.","menu.product.no_options":"Dieser Artikel besitzt keine Option.","menu.product.options":"Optionen","menu.product.prices":"Preis","menu.product.table.header.activation":"Aktivieren","menu.product.table.header.delivery":"Lieferung","menu.product.table.header.mode":"Modus","menu.product.table.header.on_site":"Im Haus","menu.product.table.header.price":"Preis","menu.product.table.header.take_away":"Außer Haus","menu.product.table.header.vat":"MwSt.","menu.product.unavailable":"Nicht verfügbar","menu.review":"Kundenrezensionen","menu.review.claims_discussions":"Kundenunterhaltung","menu.review.summary":"Zusammenfassung","menu.select_product_option.add_selected_options":"Ausgewählte Option hinzufügen","menu.select_product_option.search_result_empty":"Es gibt keinen Artikel der mit dieser Suche übereinstimmt.","menu.select_product_option.select_product_options":"Optionen für diesen Artikel auswählen","menu.settings":"Einstellungen","menu.settings.custom_texts":"Benutzerdefinierte Texte","menu.settings.restaurant":"Restaurant","menu.suggestions.error_no_products_exists":"Sie müssen einen Artikel anlegen, um einen Vorschlag zu erstellen.","menu.suggestions.error_no_suggestion_exists":"Sie müssen Produkte erstellen, um einen Vorschlag erstellen zu können.","menu.suggestions.form.add":"Hinzufügen","menu.suggestions.form.add_suggestion":"Vorschlag hinzufügen","menu.suggestions.form.delete":"Löschen","menu.suggestions.form.edit":"Bearbeiten","menu.suggestions.form.edit_suggestion":"Vorschlag bearbeiten","menu.suggestions.form.labelAdd":"wird hinzugefügt mit ","menu.suggestions.form.labelReplace":"wird ersetzt durch","menu.suggestions.suggestions_list_empty":"Sie haben noch keinen Vorschlag gespeichert","menu.synchronize_with_pos":"Synchronisiere mit POS","menu.tabs.categories":"KATEGORIEN","menu.tabs.menus":"MENÜS","menu.tabs.options":"OPTIONEN","menu.tabs.products":"ARTIKEL","menu.tabs.suggestions":"VORSCHLÄGE","menu.tabs.upselling_categories":"ZUSATZVERKAUF","menu.unused_category.no_unused_message":"TODO","menu.unused_category.table.header.name":"Name","menu.unused_category.title":"TODO","menu.upselling_category.add_category":"Kategorie hinzufügen","menu.upselling_category.add_item.menus_on_menu":"Menüs von Kasse","menu.upselling_category.add_item.modal_title":"Kategorie hinzufügen","menu.upselling_category.add_item.no_item_selected":"Es ist kein Artikel ausgewählt.","menu.upselling_category.add_item.no_menu_selected":"Es ist kein Menü ausgewählt.","menu.upselling_category.add_item.products_on_menu":"Artikel von Kasse","menu.upselling_category.add_item.search_no_results":"Es gibt kein Artikel der diesen Suchkriterien entspricht.","menu.upselling_category.add_item.selected":"Ausgewählt","menu.upselling_category.ask_name":"Wie lautet der Name der zu erstellenden Kategorie?","menu.upselling_category.caption":"","menu.upselling_category.confirm_deletion":"Sie sind im Begriff diese Kategorie zu löschen, bitte bestätigen","menu.upselling_category.detail.add_product_or_menu":"Artikel oder Menü hinzufügen","menu.upselling_category.detail.confirm_delete_child_category":"Sie sind im Begriff dieses meisje Kategorie, dieser Kategorie zu löschen, bitte bestätigen","menu.upselling_category.detail.confirm_delete_menu":"Sie sind im Begriff dieses Menü, dieser Kategorie zu löschen, bitte bestätigen","menu.upselling_category.detail.confirm_delete_product":"Sie sind im Begriff diesen Artikel, dieser Kategorie zu löschen, bitte bestätigen","menu.upselling_category.detail.disabled":"Deaktiviert","menu.upselling_category.detail.edit":"Bearbeiten","menu.upselling_category.detail.enabled":"Aktiviert","menu.upselling_category.detail.no_description":"Keine Beschreibung","menu.upselling_category.detail.table.header.delete_category":"Kategorie löschen","menu.upselling_category.detail.table.header.modes_and_price":"Modi & Preis","menu.upselling_category.detail.table.header.move":"bewegen","menu.upselling_category.detail.table.header.name":"Name","menu.upselling_category.error_no_products_exists":"Sie müssen einen Artikel erstellen um eine Kategorie erstellen zu können.","menu.upselling_category.menus":"Menüs","menu.upselling_category.products":"Artikel","menu.upselling_category.table.header.delete":"Löschen","menu.upselling_category.table.header.description":"Beschreibung","menu.upselling_category.table.header.enabled":"Aktivieren","menu.upselling_category.table.header.move":"Bewegen","menu.upselling_category.table.header.name":"Name","news.form.add_news":"Neuigkeiten hinzufügen","news.form.create_news":"Neuigkeiten erstellen","news.form.image_placeholder":"illustratives Bild","news.form.news_content":"Neuigkeiten Text","news.form.news_title":"Neuigkeiten Titel","news.form.save_modifications":"Änderungen speichern","news.home.add_actuality":"Neuigkeiten hinzufügen","news.list.confirm_delete_news":"Sind sie sicher, dass sie diese Neuigkeiten löschen wollen?","notification.booking.for_booking_taken_at_least":"Für Reservierung mindestens vergeben","notification.booking.for_booking_taken_at_least_input_group_addon":"Minuten im Voraus","notification.booking.for_booking_taken_at_least_tooltip":"Erlaubt es Ihnen keine Erinnerung zum Kunden zu senden, der am selben Tag reserviert hat. (z.B. 180 Minuten erlaubte es Ihnen eine Erinnerung nur an Kunden zu schicken, die Ihre Reservierung 3 Std. vor der gewünschten Zeit abgeschickt haben, zu senden)","notification.booking.reminder":"Erinnerungs-SMS","notification.booking.reminder_input_group_addon":"Minuten vor reservierter Zeit","notification.disable":"Deaktivieren","notification.sender":"Sender:","notification.sender_address":"Adresse des Senders:","notification.sender_name":"Name des Senders:","notification.subject":"Betreff:","order.cart_modifiers":"Rabatte","order.cart_modifiers.actions.offering_shipping_cost.none":"Keine","order.cart_modifiers.actions.offering_shipping_cost.reduction":"Rabatt","order.cart_modifiers.actions.offering_shipping_cost.title":"Kostenlose Lieferkosten","order.cart_modifiers.actions.title":"Aktionen","order.cart_modifiers.actiontype.DISCOUNT_AMOUNT":"Betrag","order.cart_modifiers.actiontype.DISCOUNT_PERCENTAGE":"Prozentsatz","order.cart_modifiers.add":"Rabatt hinzufügen","order.cart_modifiers.archive.confirm.message":"Der Rabatt wird gelöscht","order.cart_modifiers.archive.confirm.title":"Sind sie sicher?","order.cart_modifiers.cheapest_item":"Rabatt auf den günstigsten Artikel platziert","order.cart_modifiers.condition_rule.min":"Benötigte Mindestmenge","order.cart_modifiers.conditions_rules.add_rule":"Eine Regel hinzufügen","order.cart_modifiers.conditions_rules.composition.title":"Zusammensetzung des Warenkorbs","order.cart_modifiers.conditions_rules.dateCondition.from":"Startet von","order.cart_modifiers.conditions_rules.dateCondition.title":"Definieren Sie einen bestimmten Zeitraum","order.cart_modifiers.conditions_rules.dateCondition.to":"bis","order.cart_modifiers.conditions_rules.mode.title":"Bestellmodi","order.cart_modifiers.conditions_rules.title":"Bedingungen","order.cart_modifiers.conditions_rules.weekly_availabilities.title":"Spezifischer Wochentag","order.cart_modifiers.general.combinable.label":"Kombinierbar","order.cart_modifiers.general.description.label":"Beschreibung","order.cart_modifiers.general.description.placeholder":"Beschreibung","order.cart_modifiers.general.name.label":"Name","order.cart_modifiers.general.name.placeholder":"Name","order.cart_modifiers.general.tag.label":"Etikett","order.cart_modifiers.general.tag.placeholder":"Etikett","order.cart_modifiers.general.title":"Allgemein","order.cart_modifiers.items_list.0":"Kategorien","order.cart_modifiers.items_list.1":"Menüs","order.cart_modifiers.items_list.2":"Artikel","order.cart_modifiers.list.activate":"Aktivieren","order.cart_modifiers.list.delete":"Löschen","order.cart_modifiers.list.description":"Beschreibung","order.cart_modifiers.list.name":"Name","order.cart_modifiers.list.priority":"Priorität","order.cart_modifiers.no_data":"Kein Rabatt gefunden","order.cart_modifiers.target":"Anwendbar auf","order.cart_modifiers.target.type.title":"Typ","order.history.no_orders":"Keine Bestellungen","order.history.on_site":"Im Haus","order.history.table.header.first_name":"Vorname","order.history.table.header.phone":"Telefon","order.history.table.header.status":"Status","order.history.table.header.total":"Total","order.list.tabs.history":"Historie","order.list.tabs.on_going":"In Bearbeitung","order.manufacture_delay.label":"Herstellungsverzögerung","order.on_going.cancel":"Stornieren","order.on_going.disable_order":"Bestellung abschließen","order.on_going.disable_product":"Artikel deaktivieren","order.on_going.not_cancelable":"Nicht stornierbar","order.on_going.on_site":"Im Haus","order.on_going.online":"Online","order.on_going.order_disabled":"Geschlossen","order.on_going.order_disabled_text":"Dieses Restaurant ist für Bestellungen geschlossen. Sie können es jederzeit manuell reaktivieren.","order.on_going.order_disabled_text_without_permission":"Dieses Restaurant ist für Bestellungen geschlossen.","order.on_going.order_enabled":"Offen","order.on_going.order_ready":"Bestellung fertig","order.on_going.table.header.name":"Name","order.on_going.table.header.payment":"Zahlungsmethode","order.on_going.table.header.phone":"Telefon","order.on_going.table.header.source":"Quelle","order.on_going.table.header.total":"Total","order.on_going.table.header.type":"Typ","order.print":"Drucken","order.settings.delivery.delivery_price":"Liefergebühren","order.settings.delivery.delivery_time.fix.title":"Feste Lieferzeit","order.settings.delivery.delivery_time.fix.title.tooltip":"Die Lieferzeit berücksichtigt nicht die Herstellungsverzögerung. Beispiel: Bei einer Einstellung von 60 Minuten: Ein Kunde der um 7:00 Uhr bestellt wird um 8:00 Uhr beliefert.","order.settings.delivery.max_range_in_meters":"Maximale Lieferungsdistanz","order.settings.delivery.minimum_price":"Minimaler Preis in Warenkorb","order.settings.delivery.minimum_price_for_free_delivery":"Freie Lieferung ab","order.settings.delivery.minimum_price_for_free_delivery_tooltip":"0 bedeutet, dass es keine freie Lieferung gibt","order.settings.delivery.restaurant_address_not_defined":"Sie haben keine Restaurantadresse festgelegt","order.settings.general.delivery":"Lieferung","order.settings.general.menu_managed_by_pos":"Rufen Sie das Restaurantmenü auf, das von einem externen POS verwaltet wird","order.settings.general.notifications":"Benachrichtigungen","order.settings.general.on_site":"Im Haus","order.settings.general.order_modes":"Bestellmodi","order.settings.general.take_away":"Außer Haus","order.settings.irl_payment_allowed.title":"Bezahlung im Geschäft erlaubt","order.settings.itemsSequenced":"Artikel wurden sortiert","order.settings.itemsSequenced.tooltip":"Wenn \"Ein\" aktiviert ist, wird die Produktionsreihenfolge der Artikel eingehalten (d.h. Getränke und Vorspeisen werden direkt in die Produktion geschickt, während die Hauptgerichte auf die manuelle Anweisung des Kellners warten). Wenn \"Aus\" aktiviert ist, werden ALLE Artikel direkt an die Produktion gesendet.","order.settings.kiosk.advertising":"Werbebild","order.settings.kiosk.background":"Hintergrund","order.settings.kiosk.languages":"Sprachen","order.settings.kiosk.modes":"Bestellmodi","order.settings.kiosk.rooms":"Räume","order.settings.kiosk.service_at_table_enabled":"Service am Tisch","order.settings.kiosk.ticket.custom_field.label":"Feld anpassen","order.settings.kiosk.ticket.custom_label":"Text unten auf dem Kundenbeleg einfügen","order.settings.kiosk.ticket.custom_label.tooltip":"Sie können am Ende des Tickets einen Text einfügen, den Ihr Kunde am Ende seiner Bestellung erhält.","order.settings.kiosk.ticket.title":"Ticket","order.settings.nb_days_to_propose_explaination":"0 bedeutet, dass es dem Kunden nur möglich ist, am selben Tag zu bestellen","order.settings.nb_days_to_propose_input_group_addon":"Tage im Voraus","order.settings.nb_days_to_propose_title":"Offene Bestellungen","order.settings.notifications.sms_email":"Bestellung per Email erhalten ","order.settings.notifications.sms_email_tooltip":"Durch Empfang der Bestellung per Email, schnell auf neue Bestellungen reagieren","order.settings.on_site.minimum_price":"Minimaler Preis in Warenkorb","order.settings.on_site.order_at_bar":"Bestellung an der Bar","order.settings.on_site.pre_order_available":"Vorbestellung","order.settings.payment_methods_allowed.cb":"Kreditkarte","order.settings.payment_methods_allowed.irl":"Im Haus","order.settings.payment_methods_allowed.label":"Erlaubte Zahlungsmethoden","order.settings.payment_methods_allowed.user_account":"Benutzerkonto","order.settings.tabs.delivery":"Lieferung","order.settings.tabs.general":"Allgemein","order.settings.tabs.kiosk":"Kiosk","order.settings.tabs.on_site":"Im Haus","order.settings.tabs.opening_hours":"Öffnungszeiten","order.settings.tabs.take_away":"Außer Haus","order.settings.take_away.minimum_price":"Minimaler Preis in Warenkorb","order.source.platform.ANDROID":"Mobil","order.source.platform.BACK_OFFICE_WEB":"Restaurant","order.source.platform.BOT":"Facebook","order.source.platform.IOS":"Mobil","order.source.platform.KIOSK":"Kiosk","order.source.platform.OTHER":"Andere","order.source.platform.PLUGIN_WEB":"Web","order.source.platform.POS":"Bis","order.statistics.average":"Durchschnittlicher Check","order.statistics.filters.average":"Durchschnitt","order.statistics.modes":"Verbrauchsmethode","order.statistics.nbDeliveryOrders":"Lieferung","order.statistics.nbOnSiteOrders":"Im Haus","order.statistics.nbOnSitePaidOrders":"Im Haus","order.statistics.nbOrders":"Bestellnummer","order.statistics.nbPaidOrders":"Kreditkarte","order.statistics.nbTakeAwayOrders":"Außer Haus","order.statistics.no_data":"Für diesen Zeitraum wurde keine Statistik protokolliert","order.statistics.other":"Andere","order.statistics.payments":"Zahlungen","order.statistics.salesFilters.day":"Tag","order.statistics.salesFilters.hour":"Stunde","order.statistics.salesFilters.month":"Monat","order.statistics.salesFilters.week":"Woche","order.statistics.sources":"Quellen","order.statistics.submit":"Berechnen","order.statistics.turnover":"Verkäufe","order.statistics.turnover_average-check":"Verkäufe / Durchschnittlicher Warenkorb","order.statistics.turnover_average-check_by-weekday":"Umsatz pro Stunde (Durchschnitt über den Zeitraum)","order.to_make.name":"Name","order.to_make.total":"Total","order.to_make.type":"Typ","page_not_found":"Die gewünschtre Seite existiert nicht","payins.no_payins":"Sie haben keine PayMyTable Transaktionen in diesem Zeitraum","payins.table.header.date":"Datum","payins.table.header.hour":"Stunde","payins.table.header.including_tips":"Inclusive Trinkgelder","payins.table.header.payed_with_pmt":"Bezahlt mit PMT","payins.table.header.total_table":"Total Tisch","payment_stats.graph.amount_payed":"Bezahlte Beträge","payment_stats.graph.payed_label":"Bezahlt","payment_stats.interval_too_big":"Differenz zwischen Zeiträumen zu hoch!","payment_stats.no_payout":"Sie haben keine PayMyTable Transaktionen in diesem Zeitraum","payment_stats.numbers.amount_payed_with_pmt":"Bezahlter Betrag mit PMT","payment_stats.numbers.amount_payed_with_pmt_tooltip":"Gesamter Betrag der PayMyTable Zahlungen. Dieser Betrag beinhaltet Trinkgelder","payment_stats.numbers.key_numbers_title":"Kennzahlen","payment_stats.numbers.number_of_payments":"Abgeschlossene Zahlungen","payment_stats.numbers.number_of_payments_tooltip":"Gesamte Anzahl von PayMyTable Zahlungen. Eine Rechnung kann auf mehrere Zahlungen aufgeteilt werden","payment_stats.numbers.payed_tables":"Bezahlte Tische","payment_stats.numbers.payed_tables_tooltip":"Anzahl der komplett oder teilweise mit PayMyTable bezahlten Rechnungen ","payment_stats.numbers.tips":"Trinkgelder","payouts.no_payouts":"Keine Überweisung in diesem Zeitraum","payouts.table.header.amount":"Erhaltener Bruttobetrag","payouts.table.header.amount_net":"Bezahlter Betrag","payouts.table.header.commissions_fixed_without_taxes":"Feste Kommission ohne MwSt.","payouts.table.header.commissions_variable_without_taxes":"Variable Kommission ohne MwSt.","payouts.table.header.commissions_with_taxes":"Kommissionen mit MwSt.","payouts.table.header.date":"Datum","payouts.table.header.id":"ID","payouts.table.header.reference":"Referenz","payouts.table.header.status":"Status","payouts.table.header.vat":"MwSt.","receipt.tabs.payins":"Meine Zahlungseingänge","receipt.tabs.payouts":"Meine Überweisungen","restaurant_edit.bank":"Bank","restaurant_edit.configuration.commission_per_transaction":"Kommission pro Transaktion ohne MwSt. (fest)","restaurant_edit.configuration.commission_per_transaction_variable":"Kommission pro Transaktion ohen MwSt. (variabel)","restaurant_edit.configuration.commissions":"Komissionen","restaurant_edit.configuration.fee_vat_percentage":"Mehrwertsteuer (%)","restaurant_edit.configuration.general":"Allgemein","restaurant_edit.configuration.mangopay.bank_id":"Bank ID","restaurant_edit.configuration.mangopay.user_id":"User ID","restaurant_edit.configuration.mangopay.wallet_id":"Geldbörsen ID","restaurant_edit.configuration.password":"Passwort","restaurant_edit.configuration.password_verification":"Passwort-Verifizierung","restaurant_edit.configuration.pos":"POS","restaurant_edit.configuration.pos.credentials":"Anmeldeinformationen","restaurant_edit.configuration.pos.customer_id":"Kunden ID","restaurant_edit.configuration.pos.encryption_key":"Verschlüsselungscode","restaurant_edit.configuration.pos.id":"POS ID","restaurant_edit.configuration.pos.menu_id":"Menü-ID","restaurant_edit.configuration.pos.url":"POS URL","restaurant_edit.configuration.restaurant_id":"Restaurant ID","restaurant_edit.configuration.restaurant_name":"Restaurant Name","restaurant_edit.configuration.status":"Status","restaurant_edit.configuration.statut.not_on_mobile_app":"Dieses Restaurant wird nicht in der mobilen App erscheinen","restaurant_edit.configuration.statut.on_mobile_app":"Dieses Restaurant wird in der mobilen App erscheinen","restaurant_edit.configuration.tips":"Trinkgelder","restaurant_edit.features.booking":"Buchung","restaurant_edit.features.label":"Eigenschaften","restaurant_edit.features.news":"Neuigkeiten","restaurant_edit.features.order":"Bestellung","restaurant_edit.features.pairing":"Kopplung","restaurant_edit.features.payment":"Zahlung","restaurant_edit.features.qr_code":"QR Code","restaurant_edit.features.retrieving_bill_method":"Methode zur Wiederherstellung einer Rechnung","restaurant_edit.features.review":"Kundenrezension","restaurant_edit.features.table_number":"Tischnummer","restaurant_edit.finance.accepted_payment_means":"Erlaubte Zahlungsmethoden","restaurant_edit.finance.automatic_payout_frequency":"Automatische Überweisungsfrequenz ","restaurant_edit.finance.bank_account":"Bankverbindung","restaurant_edit.finance.bic":"Bankinformationen (BIC)","restaurant_edit.finance.bic.invalid":"Ihr BIC-Format ist nicht gültig","restaurant_edit.finance.financial_department_email":"Email von Finanzdirektion","restaurant_edit.finance.iban":"IBAN","restaurant_edit.finance.iban.invalid":"ungültiges IBAN Format","restaurant_edit.finance.money":"Geld","restaurant_edit.finance.other":"Andere","restaurant_edit.finance.rib":"RIB","restaurant_edit.finance.rib.see_file":"Datei ansehen","restaurant_edit.finance.settings_on_restaurantsgroup":"Die Konfiguration des PSP erfolgt auf der Ebene der Restaurantgruppe auf ","restaurant_edit.kyc":"KYC","restaurant_edit.legal.company":"Unternehmen","restaurant_edit.legal.kbis":"Handelsregister","restaurant_edit.legal.kbis.modal_label":"Anmeldenachweis","restaurant_edit.legal.kbis.see_file":"Siehe Datei","restaurant_edit.legal.legal_representative":"Gesetzlicher Vertreter","restaurant_edit.legal.legal.address.city":"Ort","restaurant_edit.legal.legal.address.country":"Land","restaurant_edit.legal.legal.address.label":"Adresse","restaurant_edit.legal.legal.address.post_code":"PLZ","restaurant_edit.legal.legal.cgu_url":"TOU link","restaurant_edit.legal.legal.cgv_url":"AVB link","restaurant_edit.legal.legal.company_name":"Firma","restaurant_edit.legal.legal.siret":"Handelsregisternummer","restaurant_edit.legal.manager.email":"Restaurant Email","restaurant_edit.legal.manager.name":"Manager Name","restaurant_edit.legal.manager.phone":"Manager Telefon","restaurant_edit.legal.representative.address.city":"Ort","restaurant_edit.legal.representative.address.country":"Land","restaurant_edit.legal.representative.address.label":"Adresse","restaurant_edit.legal.representative.address.post_code":"PLZ","restaurant_edit.legal.representative.birthdate":"Geburtsdatum","restaurant_edit.legal.representative.country_of_residence":"Aufenthaltsland","restaurant_edit.legal.representative.first_name":"Vorname","restaurant_edit.legal.representative.identity_document":"Personalausweis","restaurant_edit.legal.representative.identity_document.modal_label":"Personalausweis","restaurant_edit.legal.representative.identity_document.see_file":"Siehe Datei","restaurant_edit.legal.representative.last_name":"Nachname","restaurant_edit.legal.representative.nationality":"Nationalität","restaurant_edit.legal.restaurateur":"Restaurantbesitzer","restaurant_edit.legal.shareholder_declaration":"Gesellschaftererklärung","restaurant_edit.legal.shareholder_declaration.example":"Beispiel","restaurant_edit.legal.shareholder_declaration.modal_label":"Gesellschaftererklärung","restaurant_edit.legal.shareholder_declaration.see_file":"Siehe Datei","restaurant_edit.legal.status_pdf":"Rechtsform (PDF)","restaurant_edit.legal.status_pdf.modal_label":"Rechtsform","restaurant_edit.legal.status_pdf.see_file":"Siehe Datei","restaurant_edit.menu.image":"Menü Bild","restaurant_edit.menu.no_menu_uploaded_yet":"Sie haben noch kein Menü hochgeladen.","restaurant_edit.menu.pdf":"PDF des Menüs","restaurant_edit.menu.pdf_modal_title":"PDF des Menüs","restaurant_edit.menu.see_pdf":"Siehe PDF des Menüs","restaurant_edit.menu.selected_file":"Ausgewählte Datei:","restaurant_edit.public.address.city":"Ort","restaurant_edit.public.address.country":"Land","restaurant_edit.public.address.label":"Adresse","restaurant_edit.public.address.post_code":"PLZ","restaurant_edit.public.description":"Beschreibung","restaurant_edit.public.email":"Kontakt-E-Mail","restaurant_edit.public.gps_coordinates":"GPS Koordinaten","restaurant_edit.public.latitude":"Breitengrad","restaurant_edit.public.logo":"Restaurant Logo","restaurant_edit.public.logo_requirements":"Das Bild muss einen transparenten Hintergrund haben (PNG Datei).","restaurant_edit.public.longitude":"Längengrad","restaurant_edit.public.phone_number":"Telefon","restaurant_edit.public.picture":"Restaurant Bild","restaurant_edit.public.preview":"Vorschau","restaurant_edit.public.tag":"Markierung","restaurant_edit.public.timezone":"Restaurant Zeitzone","restaurant_edit.public.website":"Website","restaurant_edit.restaurants_group.create_group":"Gruppe erstellen","restaurant_edit.restaurants_group.modifications_saved":"Änderungen gespeichert.","restaurant_edit.restaurants_group.select_groups":"Wählen Sie die Gruppen, in welchen das Restaurant enthalten sein wird","restaurant_edit.theme.action_background_color":"Aktion Hintergrundfarbe","restaurant_edit.theme.action_text_color":"Aktion Textfarbe","restaurant_edit.theme.background_color":"Hintergrundfarbe","restaurant_edit.theme.text_color":"Textfarbe","restaurant_edit.theme.title_background_color":"Titel Hintergrundfarbe","restaurant_edit.theme.title_font_color":"Titel Schriftfarbe ","restaurant.edit.footer":"Für weitere Änderungen kontaktieren Sie uns bitte unter","restaurant.edit.footer.or":"oder","restaurant.edit.tabs.configuration":"Konfiguration","restaurant.edit.tabs.features":"Eigenschaften","restaurant.edit.tabs.finance":"Finanzen","restaurant.edit.tabs.legal":"Rechtliche Informationen","restaurant.edit.tabs.menu":"Menü","restaurant.edit.tabs.opening_hours":"Öffnungszeiten","restaurant.edit.tabs.public":"Öffentliche Informationen","restaurant.edit.tabs.restaurants_groups":"Gruppen","restaurant.edit.tabs.theme":"Thema","review.claims_discussions.ask_activate":"Aktivieren?","review.claims_discussions.email.content":"Email Inhalt","review.claims_discussions.email.sender_email":"Sender Email","review.claims_discussions.email.sender_email.label":"Bsp: kate@granand-brasserie.de","review.claims_discussions.email.sender_name":"Sender Name","review.claims_discussions.email.sender_name.placeholder":"Bsp: Kate (Granand Brasserie)","review.claims_discussions.email.subject":"Email Objekt","review.claims_discussions.email.subject.placeholder":"Ihre Meinung zählt","review.claims_discussions.for_rates_less_than":"Für Bewertung schlechter oder gleich?","review.claims_discussions.page_explaination":"Richten Sie hier die Email ein, die automatisch an Kunden gesendet wird. ","review.claims_discussions.time_to_wait":"Zeit zwischen Benachrichtigung und Senden der Email","review.claims_discussions.validate":"Bestätigen","review.summary.general_note":"Durchschnittliche Bewertung:","review.summary.list.title":"Bewertungen","review.summary.no_data_on_period":"Sie haben noch keine Bewertung zu diesem Zeitraum","review.summary.review.check_modal_title":"Rechnung","review.summary.review.comment":"Kommentar","review.summary.review.modal_title":"Kundenbewertung","review.summary.review.reasons":"Angegebene Gründe:","review.summary.review.see_check":"Siehe Rechnung","review.summary.review.see_detail":"Siehe Detail","review.summary.review.tip":"Trinkgelder:","review.summary.review.waiter":"Bedienung:","review.summary.reviews":"Bewertungen","server_error.message":"Bitte entschuldigen sie die Unannehmlichkeiten.","server_error.message_2":"Unser Team wurde über das Problem informiert, und arbeitet mit Hochdruck an einer Lösung.","server_error.title":"Ein Fehler ist aufgetreten."}

/***/ }),

/***/ "./public/locales/en.json":
/***/ (function(module, exports) {

module.exports = {"admin.restaurant.create_restaurant":"New restaurant","admin.restaurant.create_restaurant.currency":"Currency","admin.restaurant.create_restaurant.password":"Password","admin.restaurant.create_restaurant.password_verification":"Password verification","admin.restaurant.create_restaurant.restaurant_name":"Restaurant name","booking.calendar.add_booking":"Add a reservation","booking.calendar.close_period_for_day":"Close the period for this day.","booking.calendar.date_in_the_past":"This date is in the past","booking.calendar.error_is_after_max_time_ahead":"Reservations are opened\\n{formattedMaxTimeAhead} in advance.\\nIf you want to make this day available, please modify general settings.","booking.calendar.open_period_for_day":"Open the period for this day.","booking.calendar.period_cant_be_modified":"You can’t modify this period.","booking.create.confirmation":"The reservation is confirmed for {date} at {hour} ({status})","booking.day_state_chooser.closed":"Close","booking.day_state_chooser.open":"Open","booking.draft.add_booking":"Add a reservation","booking.draft.canceled":"Cancelled","booking.draft.no_show":"No show","booking.draft.placed":"Seated","booking.list.table.header.actions":"Actions","booking.list.table.header.comment":"Comment","booking.list.table.header.date":"Date","booking.list.table.header.first_name":"First name","booking.list.table.header.guest_number":"Guest number","booking.list.table.header.hour":"Time","booking.list.table.header.status":"Status","booking.list.table.no_booking":"No reservation.","booking.new_label":"NEW","booking.on_going.add_booking":"Add a reservation","booking.on_going.download_pdf":"Download summary","booking.on_going.error_while_generating_pdf":"An error occurred during the pdf creation","booking.on_going.no_booking_for_this_day":"There is no booking for this day.","booking.on_going.without_period":"No period","booking.settings.capacity_specific.add_specific":"Add a specific","booking.settings.capacity_specific.confirm_specific_deletion":"You are about to delete this specific, please confirm","booking.settings.capacity_specific.create":"Create specific","booking.settings.capacity_specific.edit":"Modify specific","booking.settings.capacity_specific.form.booking.settings.capacity_specific.already_exists":"A specific already exists for this date and this meal.","booking.settings.capacity_specific.form.capacity_label":"Choose capacity","booking.settings.capacity_specific.form.date_label":"Choose a date","booking.settings.capacity_specific.form.period_label":"Choose a meal","booking.settings.capacity_specific.table.header.capacity":"Capacity","booking.settings.capacity_specific.table.header.delete":"Delete","booking.settings.capacity_specific.table.header.edit":"Edit","booking.settings.capacity_specific.table.header.meal":"Meals","booking.settings.capacity.maximum_capacity":"Maximum capacity of the restaurant","booking.settings.capacity.maximum_capacity_tooltip":"Maximum number of guests of the restaurant (with or without reservation)","booking.settings.capacity.people":"guests","booking.settings.general.notice_activate_restaurant.point_1":"Add one or more meals opened for reservations","booking.settings.general.notice_activate_restaurant.point_2":"Set the reservation parameters","booking.settings.general.notice_activate_restaurant.title":"To activate your restaurant you have to:","booking.settings.global.automatic_confirmation_input_group_addon":"guests (included)","booking.settings.global.automatic_confirmation_until":"Automatic confirmation up to","booking.settings.global.automatic_confirmation_until_tooltip":"Your clients receive automatically a confirmation of their reservations and the reservation book is updated.","booking.settings.global.booking_confirmation_process_title":"Process of reservation confirmation","booking.settings.global.booking_for_current_period_allowed":"Allow booking for the current period","booking.settings.global.booking_for_current_period_allowed_tooltip":"If checked, the current period will be available to bookings for customers.","booking.settings.global.every_15_minutes":"Every 15 minutes","booking.settings.global.every_30_minutes":"Every 30 minutes","booking.settings.global.interval_between_slot_label":"Time between two reservation slots","booking.settings.global.max_time_ahead":"Reservation opened","booking.settings.global.max_time_ahead_input_group_addon":"days in advance","booking.settings.global.max_time_ahead_tooltip":"Allows yours clients to book few weeks or months in advance","booking.settings.global.min_time_ahead":"Minimum time for immediate booking","booking.settings.global.min_time_ahead_input_group_addon":"minutes","booking.settings.global.min_time_ahead_tooltip":"Minimum time between the time when the client submit a reservation and the effective time of his reservation (eg: it’s 12.07pm, your slots are 12.00pm/12.15pm/12.30pm and the minimum time for immediate booking is 10 minutes => your client will be able to book only from 12.30pm onwards)","booking.settings.global.notification_settings_sms_email":"Receive reservations by SMS/Email","booking.settings.global.notification_settings_sms_email_tooltip":"Quickly reply to new reservations and confirm pending reservations as soon as possible","booking.settings.global.notification_settings.disabled":"Disable","booking.settings.global.notification_settings.for_all":"All reservations","booking.settings.global.notification_settings.for_validate_only":"Only for reservations to be validated","booking.settings.global.time_before_no_show":"Automatic \"no show\" allocation for reservations expire after","booking.settings.global.time_before_no_show_input_group_addon":"minutes","booking.settings.global.time_before_no_show_tooltip":"These expired reservations will be deleted from \"Main\" sheet and will be transferred to \"Past\" sheet","booking.settings.group.manual":"Manual confirmation by the restaurant up to","booking.settings.group.manual_input_group_addon":"guests (included)","booking.settings.group.manual_tooltip":"Maximum number of guests for a reservation that a client will be able to réservé. These reservations will have to be validated by the restaurant in order for the client to receive a confirmation (these reservations will be deducted from your available capacity for this time)","booking.settings.period_specifics.add_date":"Add a date","booking.settings.period_specifics.cant_create_param_message":"There is no available slot. Please verify that you already have set a day and time available for reservation.","booking.settings.period_specifics.cant_create_param_no_day_valid_message":"There is no day with valid time.","booking.settings.period_specifics.cant_create_param_no_day_valid_title":"Parameter not accepted","booking.settings.period_specifics.cant_create_param_title":"Parameter not accepted","booking.settings.period_specifics.table.header.capacity":"Capacity","booking.settings.period_specifics.table.header.day_of_week":"Day of the week","booking.settings.period_specifics.table.header.delete":"Delete","booking.settings.period_specifics.table.header.hours":"Time","booking.settings.period_specifics.table.header.room":"Room","booking.settings.period_specifics.table.row.are_you_sure":"Are you sure?","booking.settings.period.add_period":"Add a meal","booking.settings.period.delete_period.confirm_message":"This action will delete all parameters associated to this meal.","booking.settings.period.delete_period.confirm_title":"You are about to delete this meal, please confirm","booking.settings.period.list_title":"Meals available at reservation","booking.settings.period.table.label.average_duration_of_meal":"Average time of a meal","booking.settings.period.table.label.booking_closing_hour":"Time of last reservation","booking.settings.period.table.label.booking_opening_hour":"Time of 1st reservation","booking.settings.period.table.label.capacity":"Number of seats opened for reservation","booking.settings.period.table.label.status":"Status","booking.settings.rooms":"Rooms","booking.settings.rooms.add_room":"Add a room (eg: main room, terrace)","booking.settings.rooms.already_exists_with_name":"This name is already used an existing room","booking.settings.rooms.ask_room_name":"What is the room name?","booking.settings.rooms.delete_room.confirm_message":"This action will delete all parameters associated to this room.","booking.settings.rooms.delete_room.confirm_title":"You are about to delete this room, please confirm","booking.settings.rooms.modify_room.name":"Modify the room name","booking.settings.sales_contact.contact_for_client":"Contact details given to the client","booking.settings.sales_contact.contact_for_client.email":"Email","booking.settings.sales_contact.contact_for_client.phone":"Phone","booking.settings.sales_contact.contact_for_client.type.call_back":"The customer service will contact the client","booking.settings.sales_contact.contact_for_client.type.user_must_call":"The client has to contact the customer service","booking.settings.sales_contact.manual":"Manual confirmation by the customer service (group above {maxNumberOfGuestsForBooking} guests)","booking.settings.sales_contact.manual_tooltip":"Use this functionnality if your restaurant has a dedicated service to manage group reservations (eg: set menu, special prices, etc.). The client reservation will be pending until it is validated by an authorized person (theses pending reservations are not deducted from your available capacity for this time)","booking.settings.sms_email.automatic_confirmation":"Automatic confirmation","booking.settings.sms_email.cancel_booking":"Cancellation of the booking","booking.settings.sms_email.explainaition_1":"This tab allows you to manage messages received by your customers","booking.settings.sms_email.explainaition_2":"This paramters are not editable.  Contact us for any modifications","booking.settings.sms_email.reminder_booking":"Reminder of the booking","booking.settings.sms_email.waiting_booking":"Waiting bookings","booking.settings.sms_email.waiting_booking_confirmation":"Confirmation of the waiting booking","booking.settings.tabs.general":"General","booking.settings.tabs.sms_email":"SMS / EMAIL","booking.settings.tabs.specifics":"Specific","booking.tabs.calendar":"Calendar","booking.tabs.draft":"Past","booking.tabs.on_going":"Main","booking.tabs.unseens":"New","booking.tabs.waiting":"To be confirmed","booking.unseen.add_booking":"Add a reservation","booking.unseen.canceled_bookings":"Cancelled reservations","booking.unseen.new_bookings":"New reservations","booking.waiting_label":"TO BE CONFIRMED","booking.waiting.add_booking":"Add a reservation","booking.waiting.no_waiting_bookings":"No reservation to be confirmed.","booking.waiting.see_more":"See more","components.availibility_hours.form.add_opening_hour":"Add a time range","components.availibility_hours.form.custom_hours":"Hours","components.availibility_hours.form.custom_hours.content":"Define the hours for this item","components.availibility_hours.form.off":"Off","components.availibility_hours.form.off.content":"This item will not be available this day","components.availibility_hours.form.whole_day":"Day","components.availibility_hours.form.whole_day.content":"This item will be available all the day","components.booking.detail.action":"Action","components.booking.detail.action_disabled_explaination":"These actions will be enabled {minutes} minutes before booking time","components.booking.detail.cancel":"Cancel","components.booking.detail.cancel_textarea_placeholder":"Comment, SMS/Email (only on cancellation)","components.booking.detail.comments":"Comments:","components.booking.detail.confirm":"Confirm","components.booking.detail.confirmed":"Confirmed","components.booking.detail.edit_info":"Edit booking information","components.booking.detail.fidelity_cart_number":"Loyalty card:","components.booking.detail.guest_number":"# guests:","components.booking.detail.modal_title":"Booking (details)","components.booking.detail.no_show":"No show","components.booking.detail.not_arrived":"Not arrived","components.booking.detail.seated":"Seated","components.booking.detail.source":"Origin:","components.booking.detail.status":"Status","components.booking.form.comment":"Comment","components.booking.form.create_booking":"Create booking","components.booking.form.fidelity_card_number":"Loyalty card number","components.booking.form.first_name":"First name","components.booking.form.guest_number":"Guests number","components.booking.form.last_name":"Last name","components.booking.form.mobile":"Mobile phone","components.booking.form.no_slots_for_date":"There is no booking available for this time range.","components.booking.form.phone_invalid":"Invalid phone number","components.booking.form.room":"Room","components.booking.form.update_booking":"Save changes","components.booking.modal.add.title":"Add a reservation","components.booking.period_picker.placeholder":"Select","components.booking.room_picker.all":"All","components.color.picker.modal_title":"Color choice","components.color.picker.validate":"Validate","components.contact_modal.send_mail_to":"Send us an email at","components.contact_modal.title":"Contact","components.digicode.account_for_code_not_enough_right":"The code is valid, but the associated account does not have the requested rights for this action.","components.footer.cgu":"Legal notice","components.footer.rights_reserved":"All rights reserved","components.form.cancel_modifications":"Cancel","components.form.save":"Save","components.header.contact":"Contact","components.header.logout":"Log out","components.menu.choose_product_modal.choose_products":"Choose items","components.menu.choose_product_modal.search_no_results":"There is no item matching this search criteria.","components.menu.edit_category.delete":"Delete","components.menu.edit_category.description":"Description","components.menu.edit_category.edit":"Edit category","components.menu.edit_category.name":"Name","components.menu.edit_category.new":"New category","components.menu.edit_category.parent_category":"Parent category","components.menu.edit_category.submit":"Validate","components.menu.edit_upselling_category.delete":"Delete","components.menu.edit_upselling_category.description":"Description","components.menu.edit_upselling_category.description_placeholder":"(50 characters max.)","components.menu.edit_upselling_category.edit":"Edit","components.menu.edit_upselling_category.name":"Name","components.menu.edit_upselling_category.name_placeholder":"(won't be published)","components.menu.edit_upselling_category.new":"New","components.menu.edit_upselling_category.submit":"Submit","components.no_permission.label":"You do not have the requested rights for this action","components.no_permission.permission_required":"Permission required","components.opening_hours.form_modal.closing":"Closed","components.opening_hours.form_modal.create":"Create opening time range","components.opening_hours.form_modal.day":"Day","components.opening_hours.form_modal.opening":"Opened","components.opening_hours.form_modal.title":"Add opening time range","components.opening_hours.form.add_opening_hour":"Add a time range","components.order.cancel.close":"No","components.order.cancel.error":"Unable to cancel this order.","components.order.cancel.noRefundCancel":"( i ) Your customer has paid by credit card on the kiosk and not with our services.\nYou can cancel the order but it will not be refunded.","components.order.cancel.refundCancel":"By cancelling this order, your customer will be refunded.","components.order.cancel.submit":"Yes, cancel","components.order.cancel.title":"Order cancel","components.order.cancel.verifyCancel":"Are you sure you want to cancel this order?","components.order.detail.arrival_date":"Arrival time:","components.order.detail.delivery_date":"Delivery time:","components.order.detail.delivery_price":"Delivery fees:","components.order.detail.general_comment":"Overall comment:","components.order.detail.has_paid":"paid","components.order.detail.kiosk_number":"Kiosk #","components.order.detail.on_site_payment":"Payment at restaurant","components.order.detail.order_detail":"Order details","components.order.detail.order_number":"Order #","components.order.detail.order_total":"Total order:","components.order.detail.pickup_date":"Pickup time:","components.order.detail.status":"Status:","components.payment.modes.form.cash":"Cash","components.payment.modes.form.restaurant_ticket":"Luncheon voucher","components.prices_editor.activation":"Activation","components.prices_editor.delivery":"Delivery","components.prices_editor.mode":"Mode","components.prices_editor.on_site":"On site","components.prices_editor.price_with_tax":"Price VAT incl.","components.prices_editor.take_away":"Take away","components.prices_editor.vat":"VAT","components.restaurants_group.choose.modal_title":"Change restaurant group","components.timelapse.picker.custom":"Customized","components.timelapse.picker.day":"1 day","components.timelapse.picker.month":"1 month","components.timelapse.picker.period":"Time range","components.timelapse.picker.validate":"Validate","components.timelapse.picker.week":"1 week","components.user.detail.average_payment":"Average payment","components.user.detail.average_rate":"Average rating","components.user.detail.average_tip":"Average tips","components.user.detail.client_record":"Customer record","components.user.detail.last_visit":"Last visit","components.user.detail.total_visits_count":"Total number of visits","components.user.payments.table.header.Hour":"Hour","components.user.payments.table.header.payed_by_client":"Paid by customer","components.user.payments.table.header.rate":"Rating","components.user.payments.table.header.with_tips":"Including tips","export.failure":"Export failed.","export.failure.invalid_time":"Timerange must be within 3 months.","export.failure.message":"An error has occurred. Please, contact our technical support.","export.help":"Export your data on a given time range (maximum 3 months)","export.option.label":"Type","export.option.BOOKINGS":"bookings","export.option.ORDER":"Orders","export.option.PAYMENTS":"Payments","export.option.REVIEWS":"Reviews","export.option.USERS":"Users","export.submit":"Export","export.success":"Export successfull!","export.success.message":"You shall receive an email with your datas.","feature_not_activated":"This service is not activated on your account","forgot_password.description":"enter your email to receive the instructions of modifications of your password","forgot_password.email":"Email","forgot_password.failure":"Email unknown","forgot_password.submit":"Submit","forgot_password.success":"Instructions have been sent by email","forgot_password.title":"Forgot password","global.allergen.allergens":"Allergens","global.allergen.BALSAM_OF_PERU":"Balsam of Peru","global.allergen.BUCKWHEAT":"Buckwheat","global.allergen.CELERY":"Celery","global.allergen.CHEESE":"Cheese","global.allergen.CORN":"Corn","global.allergen.CRUSTACEAN":"Crustacean","global.allergen.EGG":"Egg","global.allergen.FISH":"Fish","global.allergen.FRUIT":"Fruit","global.allergen.GARLIC":"Garlic","global.allergen.LACTOSE":"Lactose","global.allergen.LUPINE":"Lupine","global.allergen.MUSTARD":"Mustard","global.allergen.PEANUT":"Peanut","global.allergen.POULTRY_MEAT":"Poultry meat","global.allergen.RED_MEAT":"Red meat","global.allergen.RICE":"Rice","global.allergen.SESAME":"Sesame","global.allergen.SHELLFISH":"Shellfish","global.allergen.SOYA":"Soya","global.allergen.SULPHITES":"Sulphites","global.allergen.TARTRAZINE":"Tartrazine","global.allergen.GLUTEN":"Gluten","global.allergen.GLUTEN_OATS":"Oats (gluten)","global.allergen.GLUTEN_WHEAT":"Wheat (gluten)","global.allergen.GLUTEN_KAMUT":"Kamut (gluten)","global.allergen.GLUTEN_SPELT":"Spelt (gluten)","global.allergen.GLUTEN_GREEN_SPELT":"Green spelt (gluten)","global.allergen.GLUTEN_EINKORN":"Einkorn (gluten)","global.allergen.GLUTEN_RYE":"Rye (gluten)","global.allergen.GLUTEN_BARLEY":"Barley (gluten)","global.allergen.GLUTEN_EMMER":"Emmer (gluten)","global.allergen.GLUTEN_TRITICALE":"Triticale (gluten)","global.allergen.NUTS":"Nuts","global.allergen.NUTS_ALMONDS":"Almonds (nuts)","global.allergen.NUTS_HAZELNUTS":"Hazelnuts","global.allergen.NUTS_WALNUTS":"Walnuts","global.allergen.NUTS_CASHEW":"Cashew nuts","global.allergen.NUTS_PECANS":"Pecans (nuts)","global.allergen.NUTS_BRAZIL":"Brazil nuts","global.allergen.NUTS_PISTACHES":"Pistachios (nuts)","global.allergen.NUTS_MACADAMIA_OR_QUEENSLAND":"Macadamia (Queensland) nuts","global.allergen.PORK":"Pork","login.form.connect":"Connexion","login.form.password":"Password","login.form.username":"Login","login.form.forgot_password":"Forgot password","login.form.password.should_choose_another":"Your password is not secure. Please change it using the forgotten password feature.","logout.redirect_message":"You have been signed out, you will be redirected to the login page...","menu.admin":"Admin","menu.admin.restaurant":"Restaurant","menu.booking":"Booking","menu.booking.book":"Reservations book","menu.booking.settings":"Settings","menu.category.add_category":"Add a category","menu.category.add_item.categories":"Categories","menu.category.add_item.child_categories":"Child categories","menu.category.add_item.main_category":"Main category","menu.category.add_item.menus_on_menu":"Menus from cash register","menu.category.add_item.modal_title":"Add a category","menu.category.add_item.no_item_selected":"There is no item selected.","menu.category.add_item.no_menu_selected":"There is no menu selected.","menu.category.add_item.products_on_menu":"Items from cash register","menu.category.add_item.search_no_results":"There is no item matching this search criteria.","menu.category.add_item.selected":"Selected","menu.category.ask_name":"What is the name of the category to create?","menu.category.categories":"Categories","menu.category.confirm_deletion":"You are about to delete the category, please confirm","menu.category.confirm_deletion_from_root":"You are about to delete the category from the main, please confirm","menu.category.detail.add_product_or_menu":"Add an item or a menu","menu.category.detail.add_to_category":"Add to the category","menu.category.detail.confirm_delete_child_category":"You are about to delete this child category in this category, please confirm","menu.category.detail.confirm_delete_menu":"You are about to delete this menu in this category, please confirm","menu.category.detail.confirm_delete_product":"You are about to delete this item in this category, please confirm","menu.category.detail.delete":"Delete","menu.category.detail.edit":"Edit","menu.category.detail.no_description":"No description","menu.category.detail.table.header.delete_from_category":"Delete from category","menu.category.detail.table.header.modes_and_price":"Modes & Price","menu.category.detail.table.header.move":"Move","menu.category.detail.table.header.name":"Name","menu.category.edit_main_category":"Edit main category","menu.category.error_no_products_exists":"You need to create an item in order to create a category.","menu.category.menus":"Menus","menu.category.products":"Items","menu.category.table.header.delete_from_main_category":"Delete from main category","menu.category.table.header.move":"Move","menu.category.table.header.name":"Name","menu.export":"Export","menu.item_selector.modal_title":"Select items","menu.item_selector.no_item_selected":"No item selected","menu.item_selector.products_on_menu":"Menu items","menu.item_selector.search_no_results":"No result","menu.item_selector.selected":"Selected","menu.max_with_colon":"Max:","menu.menu_edit.add_part":"Add a part","menu.menu_edit.confirm_delete":"You are about to delete this menu, please confirm","menu.menu_edit.delete":"Delete this menu","menu.menu_edit.description":"Description","menu.menu_edit.menu_availability":"Availability","menu.menu_edit.menu_availability_date":"Change the period of time on which the product is available","menu.menu_edit.menu_availability_date.caption":"e.g.: from 01/01/2018 to 04/30/2018","menu.menu_edit.menu_availability_hours":"Change availability schedules by day of the week","menu.menu_edit.menu_availability_hours.caption":"e.g.: from 7am to 10pm, every day except on saturday","menu.menu_edit.menu_availability.caption":"By default, this item is available all year long at every time.","menu.menu_edit.name":"Name","menu.menu_edit.no_category_with_menu":"This menu is not included in any category.","menu.menu_edit.part.confirm_deletion":"You are about to delete this part, please confirm","menu.menu_edit.part.delete":"Delete","menu.menu_edit.part.edit":"Edit","menu.menu_edit.part.edit_addtionnal_price":"Modify the additional price","menu.menu_edit.part.edit_part_categories":"Organize display","menu.menu_edit.part.form.additionnal_price":"Additional price","menu.menu_edit.part.form.max":"Max","menu.menu_edit.part.form.min":"Min","menu.menu_edit.part.form.name":"Name","menu.menu_edit.part.form.quantities":"Quantity","menu.menu_edit.part.modify_products":"Modify items","menu.menu_edit.part.one_product_required":"You need at least one item","menu.menu_edit.part.title_create":"Create the part","menu.menu_edit.part.title_edit":"Edit the part","menu.menu_edit.parts":"Parts","menu.menu_edit.prices":"Price","menu.menu_list.create_menu":"Create a menu","menu.menu_list.name":"Name","menu.menu_part_category.add_item.categories_on_menu":"Categories","menu.menu_part_category.add_item.modal_title":"Add product to the category","menu.menu_part_category.categories":"Categories","menu.menu_part_category.check_all":"Check all","menu.menu_part_category.edit.modal_title":"Edit category","menu.menu_part_category.products":"Products","menu.menu_part_category.uncheck_all":"Uncheck all","menu.menu_part.ask_new_category_name":"New category","menu.menu_part.category.delete":"Delete","menu.menu_part.category.delete.are_you_sure":"You are about to delete this category, please confirm","menu.menu_part.category.edit_category":"Edit","menu.menu_part.category.modify_items":"Add / Edit items","menu.menu_part.category.new_category":"Create sub-category","menu.menu_part.category.subcategory":"sub-category","menu.menu.detail.categories":"Category","menu.menu.detail.edit":"Edit","menu.menu.detail.no_category_with_product":"this item is not included in any category.","menu.menu.detail.no_description":"No description","menu.menu.detail.parts":"Parts","menu.menu.detail.price":"Price","menu.menu.detail.table.header.activation":"Activate","menu.menu.detail.table.header.delivery":"Delivery","menu.menu.detail.table.header.mode":"Mode","menu.menu.detail.table.header.on_site":"On site","menu.menu.detail.table.header.price":"Prices","menu.menu.detail.table.header.take_away":"Take away","menu.menu.detail.table.header.vat":"VAT","menu.min_with_colon":"Min:","menu.news":"News","menu.news.home":"Home","menu.options_list.create_options":"Create an option","menu.options_list.name":"Name","menu.options_list.no_options":"There is no option set.","menu.order":"Orders","menu.order.cart_modifiers":"Promotions","menu.order.cart_modifiers.edit":"Edit","menu.order.cart_modifiers.new":"New","menu.order.orders_list":"Orders received","menu.order.restaurant_menu":"Menu","menu.order.restaurant_menu.categories":"Categories","menu.order.restaurant_menu.edition":"Edit","menu.order.restaurant_menu.menus":"Menus","menu.order.restaurant_menu.new":"New","menu.order.restaurant_menu.options":"Options","menu.order.restaurant_menu.products":"Items","menu.order.restaurant_menu.upselling_categories":"Upselling","menu.order.settings":"Settings","menu.order.statistics":"Statistics","menu.payment":"Payments","menu.payment.receipt":"Transactions","menu.payment.stat":"Statistics","menu.pos_connection_loss":"Loss of POS connection","menu.pos_connection_loss.tooltip":"Please check your POS configuration and network along with credentials. Also make sure the POS services are running and reachable","menu.pro_accounts":"Users","menu.pro_accounts.restaurants_groups":"Restaurants","menu.pro_accounts.roles":"Roles","menu.pro_accounts.users":"Users","menu.product_edit.product_availability":"Availability","menu.product_edit.product_availability_date":"Change the period of time on which the product is available","menu.product_edit.product_availability_date.caption":"e.g.: from 01/01/2018 to 04/30/2018","menu.product_edit.product_availability_hours":"Change availability schedules by day of the week","menu.product_edit.product_availability_hours.caption":"e.g.: from 7am to 10pm, every day except on saturday","menu.product_edit.product_availability.caption":"By default, this item is available all year long at every time.","menu.product_edit.sequences":"Sequences","menu.product_edit.reclaim_later":"Reclaim later","menu.product_edit.reclaim_later.tooltip":"Offers the end customer to reclaim this product later. This choice is not mandatory. This is only offered if \"Item sequencing\" is activated for the order mode concerned.","menu.product_edit.default_sequence":"Default sequence","menu.product_edit.default_sequence.tooltip":"This value is only taken into account if the parameters of the order mode concerned has the \"Item sequencing\" activated.","menu.product_option_view.choices":"Offered choices","menu.product_option_view.products":"Items","menu.product_option_view.products_with_option":"Items using this option","menu.product_option.edit":"Edit","menu.product_option.max_with_colon":"Max:","menu.product_option.min_with_colon":"Min:","menu.product_option.no_products_with_option":"This option is not included in any item.","menu.product_option.option.edit.add_option_value":"Add a value","menu.product_option.option.edit.confirm_delete":"You are about to delete this option, please confirm","menu.product_option.option.edit.confirm_delete_value":"You are about to delete this value, please confirm","menu.product_option.option.edit.delete_option":"Delete this option","menu.product_option.option.edit.max":"Max","menu.product_option.option.edit.min":"Min","menu.product_option.option.edit.offered_choices":"Choice proposed","menu.product_option.option.edit.quantities":"Quantity","menu.product_option.option.value.additionnal_price":"Additional price","menu.product_option.option.value.delete_value":"Delete this value","menu.product_option.option.value.edit_choice":"Edit choice","menu.product_option.option.value.name":"Name","menu.product_option.option.value.new_choice":"New choice","menu.product_option.option.value.no_additionnal_price":"No additional price","menu.product_option.option.value.stock":"Availability","menu.product_option.optionnal":"Optionnal","menu.product_option.required":"Mandatory","menu.product.available":"Available","menu.product.categories":"Category","menu.product.edit":"Edit","menu.product.edit.add_category":"Add to a category","menu.product.edit.allergen":"Choose allergen","menu.product.edit.available":"Available","menu.product.edit.categories":"Categories","menu.product.edit.other":"Other","menu.product.edit.containsAlcohol.label":"Contains alcohol","menu.product.edit.confirm_delete_option":"Do you really want to delete this option from the item?","menu.product.edit.confirm_delete_product":"Do you really want to delete this item?","menu.product.edit.confirm_delete_product_from_category":"Do you really want to delete this item from this category?","menu.product.edit.confirm_delete_product_from_menu":"Do you really want to delete this item from the menu?","menu.product.edit.delete_product":"Delete item","menu.product.edit.delete_product.permission_refused":"Not enough rights to delete this product","menu.product.edit.description":"Description","menu.product.edit.menus":"Menus","menu.product.edit.name":"Name","menu.product.edit.no_category_with_product":"This item is not available in any category.","menu.product.edit.no_menu_with_product":"This item is not available in any menu.","menu.product.edit.no_options":"This item has no option.","menu.product.edit.options":"Options","menu.product.edit.prices":"Price","menu.product.edit.select_options":"Select the options","menu.product.edit.unavailable":"Unavailable","menu.product.list.create_product":"Add an item","menu.product.list.table.header.availibility":"Availibility","menu.product.list.table.header.name":"Name","menu.product.list.table.header.prices":"Price","menu.product.menus":"Menus","menu.product.no_category_with_product":"This item is not included in any category.","menu.product.no_description":"No description","menu.product.no_menu_with_product":"This item is not included in any menu.","menu.product.no_options":"This item has no option.","menu.product.options":"Options","menu.product.prices":"Price","menu.product.table.header.activation":"Enable","menu.product.table.header.delivery":"Delivery","menu.product.table.header.mode":"Mode","menu.product.table.header.on_site":"On site","menu.product.table.header.price":"Price","menu.product.table.header.take_away":"Take away","menu.product.table.header.vat":"VAT","menu.product.unavailable":"Not available","menu.review":"Customer reviews","menu.review.claims_discussions":"Client discussion","menu.review.summary":"Summary","menu.select_product_option.add_selected_options":"Add selected options","menu.select_product_option.search_result_empty":"There is no item matching this search.","menu.select_product_option.select_product_options":"Select options for this item","menu.settings":"Settings","menu.settings.custom_texts":"Custom texts","menu.settings.restaurant":"Restaurant","menu.suggestions.error_no_products_exists":"You need to create an item in order to create a suggestion.","menu.suggestions.error_no_suggestion_exists":"You must create products to be able to create a suggestion.","menu.suggestions.form.add":"Add","menu.suggestions.form.add_suggestion":"Add a suggestion","menu.suggestions.form.delete":"Delete","menu.suggestions.form.edit":"Edit","menu.suggestions.form.edit_suggestion":"Edit a suggestion","menu.suggestions.form.labelAdd":"will be added with","menu.suggestions.form.labelReplace":"will be replaced by","menu.suggestions.suggestions_list_empty":"You have not saved any suggestion yet","menu.suggestions.form.introduction.title":"Introduction sentence (optionnal).","menu.suggestions.form.introduction.explanation":"If no introduction sentence, the default text will be \"Our suggestions\"","menu.synchronize_with_pos":"Synchronize pos","menu.tabs.categories":"CATEGORIES","menu.tabs.menus":"MENUS","menu.tabs.options":"OPTIONS","menu.tabs.products":"ITEMS","menu.tabs.suggestions":"SUGGESTIONS","menu.tabs.upselling_categories":"UPSELLING","menu.unused_category.no_unused_message":"There is no unused category.","menu.unused_category.table.header.name":"Name","menu.unused_category.title":"Unused categories","menu.upselling_category.add_category":"Add an upselling popup","menu.upselling_category.add_item.menus_on_menu":"Menus from cash register","menu.upselling_category.add_item.modal_title":"Add a category","menu.upselling_category.add_item.no_item_selected":"There is no item selected.","menu.upselling_category.add_item.no_menu_selected":"There is no menu selected.","menu.upselling_category.add_item.products_on_menu":"Items from cash register","menu.upselling_category.add_item.search_no_results":"There is no item matching this search criteria.","menu.upselling_category.add_item.selected":"Selected","menu.upselling_category.ask_name":"What is the name of the category to create?","menu.upselling_category.caption":"You can add as many upsellings as you want but only one will be showned to your clients - the one is enabled (toggle on ON).","menu.upselling_category.confirm_deletion":"You are about to delete the category, please confirm","menu.upselling_category.detail.add_product_or_menu":"Add an item or a menu","menu.upselling_category.detail.confirm_delete_child_category":"Are you sure you want to delete this sub-category?","menu.upselling_category.detail.confirm_delete_menu":"You are about to delete this menu in this category, please confirm","menu.upselling_category.detail.confirm_delete_product":"You are about to delete this item in this category, please confirm","menu.upselling_category.detail.disabled":"Disabled","menu.upselling_category.detail.edit":"Edit","menu.upselling_category.detail.enabled":"Enabled","menu.upselling_category.detail.no_description":"No description","menu.upselling_category.detail.table.header.delete_category":"Delete category","menu.upselling_category.detail.table.header.modes_and_price":"Modes & Price","menu.upselling_category.detail.table.header.move":"Move","menu.upselling_category.detail.table.header.name":"Name","menu.upselling_category.error_no_products_exists":"You need to create an item in order to create a category.","menu.upselling_category.menus":"Menus","menu.upselling_category.products":"Items","menu.upselling_category.table.header.delete":"Delete","menu.upselling_category.table.header.description":"Description","menu.upselling_category.table.header.enabled":"Enabled","menu.upselling_category.table.header.move":"Move","menu.upselling_category.table.header.name":"Name","news.form.add_news":"Add a news","news.form.create_news":"Create the news","news.form.image_placeholder":"Illustrative picture","news.form.news_content":"News text","news.form.news_title":"News title","news.form.save_modifications":"Save changes","news.home.add_actuality":"Add a news","news.list.confirm_delete_news":"Do you really want to delete this news?","notification.booking.for_booking_taken_at_least":"For reservations taken at least","notification.booking.for_booking_taken_at_least_input_group_addon":"minutes in advance","notification.booking.for_booking_taken_at_least_tooltip":"Allows to you to not send a reminder to a client that have made a reservation for the same day (eg: 180 minutes allows you to send a reminder only for clients that have submitted a reservation at least 3 hours before the requested time)","notification.booking.reminder":"Reminder SMS","notification.booking.reminder_input_group_addon":"minutes before reserved time","notification.disable":"Disable","notification.sender":"Sender:","notification.sender_address":"Sender’s address:","notification.sender_name":"Sender’s name:","notification.subject":"Subject:","order.cart_modifiers":"Discounts","order.cart_modifiers.actions.offering_shipping_cost.none":"None","order.cart_modifiers.actions.offering_shipping_cost.reduction":"Discount","order.cart_modifiers.actions.offering_shipping_cost.title":"Free delivery fees","order.cart_modifiers.actions.title":"Actions","order.cart_modifiers.actiontype.DISCOUNT_AMOUNT":"Amount","order.cart_modifiers.actiontype.DISCOUNT_PERCENTAGE":"Percentage","order.cart_modifiers.add":"Add a discount","order.cart_modifiers.archive.confirm.message":"The discount will be deleted","order.cart_modifiers.archive.confirm.title":"Are you sure?","order.cart_modifiers.cheapest_item":"Discount placed on the cheapest item","order.cart_modifiers.condition_rule.min":"Minimum items required","order.cart_modifiers.conditions_rules.add_rule":"Add a rule","order.cart_modifiers.conditions_rules.amount.shipingCostExcluded":"Shipping excluded","order.cart_modifiers.conditions_rules.amount.shipingCostIncluded":"Shipping included","order.cart_modifiers.conditions_rules.front.apiConsumerIds.title":"Limit to a single interface","order.cart_modifiers.conditions_rules.max_amount.title":"Maximum order amount","order.cart_modifiers.conditions_rules.min_amount.title":"Minimum order amount","order.cart_modifiers.conditions_rules.composition.title":"Composition of the basket","order.cart_modifiers.conditions_rules.dateCondition.from":"Starting from","order.cart_modifiers.conditions_rules.dateCondition.title":"Define a specific time range","order.cart_modifiers.conditions_rules.dateCondition.to":"to","order.cart_modifiers.conditions_rules.mode.title":"Order modes","order.cart_modifiers.conditions_rules.title":"Conditions","order.cart_modifiers.conditions_rules.weekly_availabilities.title":"Specific week day","order.cart_modifiers.general.code.label":"Code","order.cart_modifiers.general.code.tooltip":"This is the code users should enter to apply the voucher to a cart.","order.cart_modifiers.general.combinable.label":"Combinable","order.cart_modifiers.general.description.label":"Description","order.cart_modifiers.general.description.placeholder":"Description","order.cart_modifiers.general.name.label":"Name","order.cart_modifiers.general.name.placeholder":"Name","order.cart_modifiers.general.tag.label":"Tag","order.cart_modifiers.general.tag.placeholder":"Tag","order.cart_modifiers.general.title":"General","order.cart_modifiers.items_list.0":"Categories","order.cart_modifiers.items_list.1":"Menus","order.cart_modifiers.items_list.2":"Items","order.cart_modifiers.list.activate":"Activate","order.cart_modifiers.list.delete":"Delete","order.cart_modifiers.list.description":"Description","order.cart_modifiers.list.name":"Name","order.cart_modifiers.list.priority":"Priority","order.cart_modifiers.no_data":"No discount found","order.cart_modifiers.target":"Applicable to","order.cart_modifiers.target.type.title":"Type","order.history.no_orders":"No orders","order.history.on_site":"On site","order.history.table.header.first_name":"First name","order.history.table.header.phone":"Phone","order.history.table.header.status":"Status","order.history.table.header.total":"Total","order.list.tabs.history":"History","order.list.tabs.on_going":"In progress","order.manufacture_delay.label":"Manufacture delay","order.on_going.cancel":"Cancel","order.on_going.disable_order":"Close order","order.on_going.disable_product":"Deactivate an item","order.on_going.not_cancelable":"Not cancelable","order.on_going.on_site":"On site","order.on_going.online":"Online","order.on_going.order_disabled":"Closed","order.on_going.order_disabled_text":"This restaurant is closed to order. You can reactivate anytime manually below.","order.on_going.order_disabled_text_without_permission":"This restaurant is closed to order.","order.on_going.order_enabled":"Open","order.on_going.order_ready":"Order ready","order.on_going.table.offline":"You are offline. We are unable to retrieve your orders.","order.on_going.table.header.name":"Name","order.on_going.table.header.payment":"Payment mode","order.on_going.table.header.phone":"Phone","order.on_going.table.header.source":"Source","order.on_going.table.header.total":"Total","order.on_going.table.header.type":"Order modes","order.print":"Print","order.settings.delivery.delivery_price":"Delivery fees","order.settings.delivery.delivery_time.fix.title":"Average delivery time","order.settings.delivery.delivery_time.fix.title.tooltip":"This delay will allow us to inform your customers about the time from which they will receive their order. The manufacture delay (which can be set on the \"Order received\" page) will be added to it. Example: with an average delivery time of 15 minutes and a manufacture delay of 10 minutes, the customer who orders at 12:00 will be delivered at 12:25.","order.settings.delivery.max_range_in_meters":"Maximum delivery distance","order.settings.delivery.minimum_price":"Minimum basket","order.settings.delivery.minimum_price_for_free_delivery":"Free delivery from","order.settings.delivery.minimum_price_for_free_delivery_tooltip":"0 signifies that there is no free delivery","order.settings.delivery.restaurant_address_not_defined":"You have not defined the restaurant address","order.settings.general.delivery":"Delivery","order.settings.general.menu_managed_by_pos":"Retrieve restaurant menu managed by an external POS","order.settings.general.notifications":"Notifications","order.settings.general.on_site":"On site","order.settings.general.order_modes":"Order modes","order.settings.general.take_away":"Take away","order.settings.irl_payment_allowed.title":"Paiement in store allowed","order.settings.itemsSequenced":"Items sequenced","order.settings.itemsSequenced.tooltip":"If \"On\" is activated, production order of items is respected (i.e. drinks and starters directly sent to production while main courses are waiting for manual instruction of the waiter). If “Off” is activated, ALL items are directly sent to production.","order.settings.kiosk.advertising":"Advertising image","order.settings.kiosk.background":"Background","order.settings.kiosk.languages":"Languages","order.settings.kiosk.modes":"Order modes","order.settings.kiosk.rooms":"Rooms","order.settings.kiosk.service_at_table_enabled":"Service at table","order.settings.kiosk.ticket.custom_field.label":"Customize field","order.settings.kiosk.ticket.custom_label":"Insert text at the bottom of the customer receipt","order.settings.kiosk.ticket.custom_label.tooltip":"You can insert text at the bottom of the ticket that your customer will receive at the end of his order","order.settings.kiosk.ticket.title":"Ticket","order.settings.nb_days_to_propose_explaination":"0 means that it is possible for your customers to order only the same day","order.settings.nb_days_to_propose_input_group_addon":"days in advance","order.settings.nb_days_to_propose_title":"Orders open","order.settings.notifications.sms_email":"Receive orders by Email ","order.settings.notifications.sms_email_tooltip":"Quickly react to new orders by receiving them by Email","order.settings.on_site.minimum_price":"Minimum basket","order.settings.on_site.order_at_bar":"Order at bar","order.settings.on_site.pre_order_available":"Pre-order","order.settings.payment_methods_allowed.cb":"Credit card","order.settings.payment_methods_allowed.irl":"On site","order.settings.payment_methods_allowed.label":"Payment methods allowed","order.settings.payment_methods_allowed.trd":"Luncheon voucher","order.settings.payment_methods_allowed.user_account":"User account","order.settings.tabs.delivery":"Delivery","order.settings.tabs.general":"General","order.settings.tabs.kiosk":"Kiosk","order.settings.tabs.on_site":"On site","order.settings.tabs.opening_hours":"Opening hours","order.settings.tabs.take_away":"Take away","order.settings.take_away.minimum_price":"Minimum basket","order.source.platform.ANDROID":"Mobile","order.source.platform.BACK_OFFICE_WEB":"Restaurant","order.source.platform.BOT":"Facebook","order.source.platform.IOS":"Mobile","order.source.platform.KIOSK":"Kiosk","order.source.platform.OTHER":"Other","order.source.platform.PLUGIN_WEB":"Web","order.source.platform.POS":"Till","order.statistics.average":"Average check","order.statistics.filters.average":"average","order.statistics.modes":"Consumption method","order.statistics.nbDeliveryOrders":"Delivery","order.statistics.nbOnSiteOrders":"On site","order.statistics.nbOnSitePaidOrders":"On site","order.statistics.nbOrders":"Orders number","order.statistics.nbPaidOrders":"Credit card","order.statistics.nbTakeAwayOrders":"Take away","order.statistics.no_data":"No statistic logged on this time range","order.statistics.other":"Other","order.statistics.payments":"Payments","order.statistics.salesFilters.day":"day","order.statistics.salesFilters.hour":"hour","order.statistics.salesFilters.month":"month","order.statistics.salesFilters.week":"week","order.statistics.sources":"Sources","order.statistics.submit":"Calculate","order.statistics.turnover":"Sales","order.statistics.turnover_average-check":"Sales / Average cart","order.statistics.turnover_average-check_by-weekday":"Sales hour by hour (average over the period)","order.to_make.name":"Name","order.to_make.total":"Total","order.to_make.type":"Type","page_not_found":"The requested page does not exist","payins.no_payins":"You have no PayMyTable transaction on this time range","payins.table.header.date":"Date","payins.table.header.hour":"Hour","payins.table.header.including_tips":"Including tips","payins.table.header.payed_with_pmt":"Paid with PMT","payins.table.header.total_table":"Total table","payment_stats.graph.amount_payed":"Amounts paid","payment_stats.graph.payed_label":"Paid","payment_stats.interval_too_big":"Time range gap too high!","payment_stats.no_payout":"You have no PayMyTable transaction on this time range","payment_stats.numbers.amount_payed_with_pmt":"Amount paid with PMT","payment_stats.numbers.amount_payed_with_pmt_tooltip":"Total amount of payments made with PayMyTable. This amount includes tips","payment_stats.numbers.key_numbers_title":"Key figures","payment_stats.numbers.number_of_payments":"Payments done","payment_stats.numbers.number_of_payments_tooltip":"Total number of PayMyTable payments. Several payments can be made for one bill","payment_stats.numbers.payed_tables":"Paid tables","payment_stats.numbers.payed_tables_tooltip":"Number of bills fully or partly paid with PayMyTable","payment_stats.numbers.tips":"Tips","payouts.no_payouts":"No bank transfer on this time range","payouts.table.header.amount":"Gross amount received","payouts.table.header.amount_net":"Amount paid","payouts.table.header.commissions_fixed_without_taxes":"Fixed commissions VAT excl.","payouts.table.header.commissions_variable_without_taxes":"Variables commissions VAT excl.","payouts.table.header.commissions_with_taxes":"Commissions VAT incl.","payouts.table.header.date":"Date","payouts.table.header.id":"ID","payouts.table.header.reference":"Reference","payouts.table.header.status":"Status","payouts.table.header.vat":"VAT","receipt.tabs.payins":"My cash receipts","receipt.tabs.payouts":"My bank transfers","restaurant_edit.bank":"Bank","restaurant_edit.configuration.bank":"Bank contract type","restaurant_edit.configuration.bank.acquirer.bank_id":"Acquirer bank id","restaurant_edit.configuration.bank.acquirer.wallet_id":"Acquirer wallet id","restaurant_edit.configuration.bank.choice":"Type","restaurant_edit.configuration.bank.choice.payzen":"Payzen","restaurant_edit.configuration.bank.choice.default":"Default","restaurant_edit.configuration.bank.psp.restaurantId":"PSP restaurant id","restaurant_edit.configuration.commission_per_transaction":"Commission per transaction VAT excl. (fixed)","restaurant_edit.configuration.commission_per_transaction_variable":"Commission per transaction VAT excl. (variable)","restaurant_edit.configuration.commissions":"Commissions","restaurant_edit.configuration.fee_vat_percentage":"VAT to apply (%)","restaurant_edit.configuration.general":"General","restaurant_edit.configuration.password":"Password","restaurant_edit.configuration.password_verification":"Password verification","restaurant_edit.configuration.pos":"POS","restaurant_edit.configuration.pos.credentials":"Credentials","restaurant_edit.configuration.pos.customer_id":"Customer id","restaurant_edit.configuration.pos.comment_id":"Comment id","restaurant_edit.configuration.pos.tip_article_id":"Tip article ID","restaurant_edit.configuration.pos.price_level_id":"Price level ID","restaurant_edit.configuration.pos.use_qsr_order_number":"Use QSR order number","restaurant_edit.configuration.pos.send_article_line_num":"Send linenum in itemList under articles","restaurant_edit.configuration.pos.encryption_key":"Encryption key","restaurant_edit.configuration.pos.id":"POS Id","restaurant_edit.configuration.pos.menu_id":"Menu id","restaurant_edit.configuration.pos.url":"POS URL","restaurant_edit.configuration.restaurant_id":"Restaurant ID","restaurant_edit.configuration.external_id":"External ID","restaurant_edit.configuration.restaurant_name":"Restaurant name","restaurant_edit.configuration.status":"Status","restaurant_edit.configuration.statut.CREATED":"Created","restaurant_edit.configuration.statut.ENABLED":"Enabled","restaurant_edit.configuration.statut.DISABLED":"Disabled","restaurant_edit.configuration.statut.ARCHIVED":"Archived","restaurant_edit.configuration.statut.DISABLED.explain":"This restaurant will not appear on the front","restaurant_edit.configuration.statut.ENABLED.explain":"This restaurant will appear on the front","restaurant_edit.configuration.statut.ARCHIVED.tip":"This store is archived","restaurant_edit.configuration.transferFrequency.DISABLED.tip":"Payouts are disabled for this point of sale","restaurant_edit.configuration.tips":"Tips","restaurant_edit.error.20009":"ID or certificate is invalid. We weren't able to save your modifications. Please, try again.","restaurant_edit.error.default":"An error occurred. We weren't able to save your modifications. Please, try again.","restaurant_edit.features.label":"Features","restaurant_edit.features.order":"Order","restaurant_edit.features.payment":"Payment","restaurant_edit.features.qr_code":"QR Code","restaurant_edit.features.retrieving_bill_method":"Bill retrieving method","restaurant_edit.features.review":"Customer review","restaurant_edit.features.table_number":"Table number","restaurant_edit.finance.accepted_payment_means":"Payment modes allowed","restaurant_edit.finance.automatic_payout_frequency":"Automatic bank transfers frequency","restaurant_edit.finance.bank_account":"Bank account","restaurant_edit.finance.bic":"BIC invalid format","restaurant_edit.finance.bic.invalid":"Your BIC format is not valid","restaurant_edit.finance.financial_department_email":"Email of the finance department","restaurant_edit.finance.iban":"IBAN","restaurant_edit.finance.iban.invalid":"IBAN invalid format","restaurant_edit.finance.money":"Money","restaurant_edit.finance.other":"Other","restaurant_edit.finance.rib":"RIB","restaurant_edit.finance.rib.see_file":"See file","restaurant_edit.finance.settings_on_restaurantsgroup":"The PSP setting is at the restaurant group level on ","restaurant_edit.kyc":"KYC","restaurant_edit.legal.company":"Company","restaurant_edit.legal.kbis":"K-bis","restaurant_edit.legal.kbis.modal_label":"Registration Proof","restaurant_edit.legal.kbis.see_file":"See file","restaurant_edit.legal.legal_representative":"Legal representative","restaurant_edit.legal.legal.address.city":"City","restaurant_edit.legal.legal.address.country":"Country","restaurant_edit.legal.legal.address.label":"Address","restaurant_edit.legal.legal.address.post_code":"Zip code","restaurant_edit.legal.legal.cgu_url":"TOU link","restaurant_edit.legal.legal.cgv_url":"General Terms & Conditions of Sale link","restaurant_edit.legal.legal.company_name":"Company’s legal name","restaurant_edit.legal.legal.siret":"Company’s legal registration number","restaurant_edit.legal.legal.vatNumber":"Vat number","restaurant_edit.legal.legal.vatNumber.automaticallyCalculated":"The vat number will be automatically calculated using your Company’s legal registration number","restaurant_edit.legal.legal.countryRequired":"You must first select your country","restaurant_edit.legal.manager.email":"Restaurant email","restaurant_edit.legal.manager.name":"Legal manager name","restaurant_edit.legal.manager.phone":"Legal manager phone","restaurant_edit.legal.representative.address.city":"City","restaurant_edit.legal.representative.address.country":"Country","restaurant_edit.legal.representative.address.label":"Address","restaurant_edit.legal.representative.address.post_code":"Zip code","restaurant_edit.legal.representative.birthdate":"Birth date","restaurant_edit.legal.representative.country_of_residence":"Country of residence","restaurant_edit.legal.representative.first_name":"First name","restaurant_edit.legal.representative.identity_document":"Identity document","restaurant_edit.legal.representative.identity_document.modal_label":"Identity document","restaurant_edit.legal.representative.identity_document.see_file":"See file","restaurant_edit.legal.representative.last_name":"Last name","restaurant_edit.legal.representative.nationality":"Nationality","restaurant_edit.legal.restaurateur":"Restaurant owner","restaurant_edit.legal.shareholder_declaration":"Shareholder declaration","restaurant_edit.legal.shareholder_declaration.example":"Example","restaurant_edit.legal.shareholder_declaration.modal_label":"Shareholder declaration","restaurant_edit.legal.shareholder_declaration.see_file":"See file","restaurant_edit.legal.status_pdf":"Legal status (PDF)","restaurant_edit.legal.status_pdf.modal_label":"Legal status","restaurant_edit.legal.status_pdf.see_file":"See file","restaurant_edit.menu.image":"Menu picture","restaurant_edit.menu.no_menu_uploaded_yet":"You have not uploaded any menu yet.","restaurant_edit.menu.pdf":"PDF of the menu","restaurant_edit.menu.pdf_modal_title":"PDF of the menu","restaurant_edit.menu.see_pdf":"See PDF of the menu","restaurant_edit.menu.selected_file":"Selected file:","restaurant_edit.public.address.city":"City","restaurant_edit.public.address.country":"Country","restaurant_edit.public.address.label":"Address","restaurant_edit.public.address.post_code":"Zip code","restaurant_edit.public.description":"Description","restaurant_edit.public.email":"Contact email","restaurant_edit.public.gps_coordinates":"GPS coordinates","restaurant_edit.public.latitude":"Latitude","restaurant_edit.public.logo":"Restaurant logo","restaurant_edit.public.logo_requirements":"The picture must have a transparent background (PNG file).","restaurant_edit.public.locale":"Language","restaurant_edit.public.longitude":"Longitude","restaurant_edit.public.phone_number":"Phone","restaurant_edit.public.picture":"Restaurant picture","restaurant_edit.public.preview":"Preview","restaurant_edit.public.tag":"Tag","restaurant_edit.public.timezone":"Restaurant time zone","restaurant_edit.public.website":"Website","restaurant_edit.restaurants_group.create_group":"Create a group","restaurant_edit.restaurants_group.modifications_saved":"Changes saved.","restaurant_edit.restaurants_group.select_groups":"Select the groups in which the restaurant will be included","restaurant_edit.theme.action_background_color":"Action background color","restaurant_edit.theme.action_text_color":"Action text color","restaurant_edit.theme.background_color":"Background color","restaurant_edit.theme.text_color":"Text color","restaurant_edit.theme.title_background_color":"Title background color","restaurant_edit.theme.title_font_color":"Title font color","restaurant.edit.footer":"For any other changes, please contact us at","restaurant.edit.tabs.configuration":"Configuration","restaurant.edit.tabs.features":"Features","restaurant.edit.tabs.finance":"Finance","restaurant.edit.tabs.legal":"Legal information","restaurant.edit.tabs.menu":"Menu","restaurant.edit.tabs.opening_hours":"Opening hours","restaurant.edit.tabs.public":"Public information","restaurant.edit.tabs.restaurants_groups":"Groups","restaurant.edit.tabs.theme":"Theme","review.claims_discussions.ask_activate":"Enable?","review.claims_discussions.email.content":"Email content","review.claims_discussions.email.sender_email":"Sender Email","review.claims_discussions.email.sender_email.label":"ex: kate@granand-brasserie.uk","review.claims_discussions.email.sender_name":"Sender name","review.claims_discussions.email.sender_name.placeholder":"ex: Kate (Granand Brasserie)","review.claims_discussions.email.subject":"Email object","review.claims_discussions.email.subject.placeholder":"Your opinion counts","review.claims_discussions.for_rates_less_than":"For ratings below or equal to ?","review.claims_discussions.page_explaination":"Set up here the email that will be automatically sent to customers not fully satisfied of their experience","review.claims_discussions.time_to_wait":"Time range between notification and email sending","review.claims_discussions.validate":"Validate","review.summary.general_note":"Overall rating:","review.summary.list.title":"Reviews","review.summary.no_data_on_period":"You have no review on this time range","review.summary.review.check_modal_title":"Bill","review.summary.review.comment":"Comment","review.summary.review.modal_title":"Customer review","review.summary.review.reasons":"Reasons given:","review.summary.review.see_check":"See bill","review.summary.review.see_detail":"See detail","review.summary.review.tip":"Tips:","review.summary.review.waiter":"Waiter:","review.summary.reviews":"reviews","server_error.message":"Please apologize for the inconvenience.","server_error.message_2":"Our team has been warned of the problem.","server_error.title":"An error has occurred.","security.hibp.pwned.is_secure":"The chosen password is secure","security.hibp.pwned.checking":"Checking the password security..."}

/***/ }),

/***/ "./public/locales/fr.json":
/***/ (function(module, exports) {

module.exports = {"admin.restaurant.create_restaurant":"Nouveau restaurant","admin.restaurant.create_restaurant.currency":"Devise","admin.restaurant.create_restaurant.password":"Mot de passe","admin.restaurant.create_restaurant.password_verification":"Vérification du mot de passe","admin.restaurant.create_restaurant.restaurant_name":"Nom du restaurant","booking.calendar.add_booking":"Ajouter une réservation","booking.calendar.close_period_for_day":"Fermer la période pour ce jour.","booking.calendar.date_in_the_past":"Cette date est dans le passé","booking.calendar.error_is_after_max_time_ahead":"Les réservations sont ouvertes\\n{formattedMaxTimeAhead} à l'avance.\\nSi vous souhaitez rendre ce jour disponible, veuillez modifier les paramètres généraux.","booking.calendar.open_period_for_day":"Ouvrir la période pour ce jour.","booking.calendar.period_cant_be_modified":"Cette période n'est pas modifiable.","booking.create.confirmation":"La réservation a bien été prise en compte pour le {date} à {hour} ({status})","booking.day_state_chooser.closed":"Fermé","booking.day_state_chooser.open":"Ouvert","booking.draft.add_booking":"Ajouter une réservation","booking.draft.canceled":"Annulées","booking.draft.no_show":"Pas venu","booking.draft.placed":"Placées","booking.list.table.header.actions":"Actions","booking.list.table.header.comment":"Commentaire","booking.list.table.header.date":"Date","booking.list.table.header.first_name":"Prénom","booking.list.table.header.guest_number":"Couverts","booking.list.table.header.hour":"Heure","booking.list.table.header.last_name":"Nom","booking.list.table.header.mark_read":"Marqué vu","booking.list.table.header.source":"Source","booking.list.table.header.status":"Statut","booking.list.table.no_booking":"Il n'y a pas de réservations.","booking.new_label":"NOUVELLES","booking.on_going.add_booking":"Ajouter une réservation","booking.on_going.download_pdf":"Télécharger le récapitulatif","booking.on_going.error_while_generating_pdf":"Une erreur est survenue durant la génération du pdf.","booking.on_going.no_booking_for_this_day":"Il n'y a pas de réservations pour ce jour.","booking.on_going.without_period":"Sans période","booking.settings.capacity_specific.add_specific":"Ajouter un spécifique","booking.settings.capacity_specific.confirm_specific_deletion":"Êtes-vous sûr de vouloir supprimer ce spécifique ?","booking.settings.capacity_specific.create":"Ajouter le spécifique","booking.settings.capacity_specific.edit":"Modifier le spécifique","booking.settings.capacity_specific.form.booking.settings.capacity_specific.already_exists":"Un spécifique existe déja pour ce jour et ce repas.","booking.settings.capacity_specific.form.capacity_label":"Choisir la capacité","booking.settings.capacity_specific.form.date_label":"Choisir la date","booking.settings.capacity_specific.form.period_label":"Choisir le repas","booking.settings.capacity_specific.table.header.capacity":"Capacité","booking.settings.capacity_specific.table.header.delete":"Supprimer","booking.settings.capacity_specific.table.header.edit":"Éditer","booking.settings.capacity_specific.table.header.meal":"Repas","booking.settings.capacity.maximum_capacity":"Capacité maximum du restaurant","booking.settings.capacity.maximum_capacity_tooltip":"Nombre de couverts simultanés maximum du restaurant (réservables ou non)","booking.settings.capacity.people":"personnes","booking.settings.general.notice_activate_restaurant.point_1":"Ajouter un ou plusieurs repas disponibles à la réservation","booking.settings.general.notice_activate_restaurant.point_2":"Configurer les paramètres de la réservation","booking.settings.general.notice_activate_restaurant.title":"Pour activer votre restaurant vous devez :","booking.settings.global.automatic_confirmation_input_group_addon":"couverts (inclus)","booking.settings.global.automatic_confirmation_until":"Confirmation automatique jusqu'à","booking.settings.global.automatic_confirmation_until_tooltip":"Vos clients reçoivent automatiquement la confirmation de leurs réservations et celles-ci sont ajoutées au carnet. (Max 50)","booking.settings.global.booking_confirmation_process_title":"Processus de confirmation des réservations","booking.settings.global.booking_for_current_period_allowed":"Autoriser la réservation pour la période en cours","booking.settings.global.booking_for_current_period_allowed_tooltip":"Si cochée, la période en cours sera disponible aux réservations pour les utilisatieurs.","booking.settings.global.every_15_minutes":"Toute les 15 minutes","booking.settings.global.every_30_minutes":"Toute les 30 minutes","booking.settings.global.interval_between_slot_label":"Interval de temps entre deux créneaux de réservation","booking.settings.global.max_time_ahead":"Réservations ouvertes","booking.settings.global.max_time_ahead_input_group_addon":"jours à l'avance","booking.settings.global.max_time_ahead_tooltip":"Permet à vos clients de réserver plusieurs semaines ou mois à l’avance","booking.settings.global.min_time_ahead":"Délai minimum pour réservation immédiate","booking.settings.global.min_time_ahead_input_group_addon":"minutes","booking.settings.global.min_time_ahead_tooltip":"Délai minimum entre la prise d’une réservation par le client et l’heure effective de la réservation (ex : il est 12h07, vos créneaux ouverts à la réservation sont 12h00/12h15/12h30 et le délai minimum est de 10 minutes => votre client ne pourra réserver qu’a partir de 12h30)","booking.settings.global.notification_settings_sms_email":"Recevoir les réservations par SMS/Email","booking.settings.global.notification_settings_sms_email_tooltip":"Réagissez rapidement aux nouvelles réservations et confirmez les réservations en attente au plus vite","booking.settings.global.notification_settings.disabled":"Désactiver","booking.settings.global.notification_settings.for_all":"Toutes les réservations","booking.settings.global.notification_settings.for_validate_only":"Pour les réservations à valider uniquement","booking.settings.global.time_before_no_show":"Passage automatique des réservations expirées en \"pas venu\" après","booking.settings.global.time_before_no_show_input_group_addon":"minutes","booking.settings.global.time_before_no_show_tooltip":"Ces réservations expirées disparaitront de l'onglet 'En cours' et seront placées dans l'onglet 'Traitées'","booking.settings.group.manual":"Confirmation manuelle par le restaurateur jusqu'à","booking.settings.group.manual_input_group_addon":"couverts (inclus)","booking.settings.group.manual_tooltip":"Nombre de couverts maximum réservables par le client mais qui devront être validés par vos soins pour que vos clients reçoivent la confirmation (ces réservations en attente sont décomptées de votre stock réservable)","booking.settings.period_specifics.add_date":"Ajouter une date","booking.settings.period_specifics.cant_create_param_message":"Il n'y as pas de slots disponibles. Vérifier que vous avez bien un jour avec des horaires définis.","booking.settings.period_specifics.cant_create_param_no_day_valid_message":"Il n'y a pas de jour possédant des horaires valides.","booking.settings.period_specifics.cant_create_param_no_day_valid_title":"Impossible de créer le paramètre","booking.settings.period_specifics.cant_create_param_title":"Impossible de créer le paramètre","booking.settings.period_specifics.table.header.capacity":"Capacité","booking.settings.period_specifics.table.header.day_of_week":"Jour de la semaine","booking.settings.period_specifics.table.header.delete":"Supprimer","booking.settings.period_specifics.table.header.hours":"Horaire","booking.settings.period_specifics.table.header.room":"Salle","booking.settings.period_specifics.table.row.are_you_sure":"Êtes-vous sûr ?","booking.settings.period.add_period":"Ajouter un repas","booking.settings.period.delete_period.confirm_message":"Cette action supprimera les paramètres associés à ce repas.","booking.settings.period.delete_period.confirm_title":"Êtes-vous sûr de vouloir supprimer ce repas ?","booking.settings.period.list_title":"Repas disponibles à la réservation","booking.settings.period.table.label.average_duration_of_meal":"Durée moyenne d'un repas","booking.settings.period.table.label.booking_closing_hour":"Heure dernière réservation","booking.settings.period.table.label.booking_opening_hour":"Heure 1e réservation","booking.settings.period.table.label.capacity":"Capacités à la réservation","booking.settings.period.table.label.status":"Statut","booking.settings.rooms":"Salles","booking.settings.rooms.add_room":"Ajouter une salle (ex : salle, terrasse)","booking.settings.rooms.already_exists_with_name":"Une salle existe déjà avec ce nom","booking.settings.rooms.ask_room_name":"Quel est le nom de la salle ?","booking.settings.rooms.delete_room.confirm_message":"Cette action supprimera les paramètres associés à cette salle.","booking.settings.rooms.delete_room.confirm_title":"Êtes-vous sûr de vouloir supprimer cette salle ?","booking.settings.rooms.modify_room.name":"modifier le nom de la salle","booking.settings.sales_contact.contact_for_client":"Contact communiqué au client","booking.settings.sales_contact.contact_for_client.email":"Email","booking.settings.sales_contact.contact_for_client.phone":"Téléphone","booking.settings.sales_contact.contact_for_client.type.call_back":"Le service commercial rappel le client","booking.settings.sales_contact.contact_for_client.type.user_must_call":"Le client doit contacter le service commercial","booking.settings.sales_contact.manual":"Confirmation manuelle par le service commercial (groupe supérieur à {maxNumberOfGuestsForBooking} couverts)","booking.settings.sales_contact.manual_tooltip":"Utilisez cette fonctionnalité si votre enseigne dispose d’un service commercial dédié pour gérer les groupes (ex : menu imposé, tarifs spéciaux, etc.). La réservation du client sera en attente tant qu’elle ne sera pas validée par une personne habilitée (ces réservations en attente ne sont pas décomptées de votre stock réservable)","booking.settings.sms_email.automatic_confirmation":"Confirmation automatique","booking.settings.sms_email.cancel_booking":"Annulation d'une réservation","booking.settings.sms_email.explainaition_1":"Cet onglet permet de gérer les messages reçus par vos clients lors d'une réservation.","booking.settings.sms_email.explainaition_2":"Ces paramètres ne sont pas modifiables. Contactez-nous pour toute modification.","booking.settings.sms_email.reminder_booking":"Rappel d'une réservation","booking.settings.sms_email.waiting_booking":"Réservations en attente","booking.settings.sms_email.waiting_booking_confirmation":"Confirmation d'une réservation en attente","booking.settings.tabs.general":"Général","booking.settings.tabs.sms_email":"SMS / EMAIL","booking.settings.tabs.specifics":"Spécifiques","booking.tabs.calendar":"Calendrier","booking.tabs.draft":"Traitées","booking.tabs.on_going":"En cours","booking.tabs.unseens":"Nouvelles","booking.tabs.waiting":"En attente","booking.unseen.add_booking":"Ajouter une réservation","booking.unseen.canceled_bookings":"Réservations annulées","booking.unseen.new_bookings":"Nouvelles réservations","booking.waiting_label":"EN ATTENTE","booking.waiting.add_booking":"Ajouter une réservation","booking.waiting.no_waiting_bookings":"Il n'y a pas de réservations en attente.","booking.waiting.see_more":"Voir plus","components.availibility_hours.form.add_opening_hour":"Ajouter un horaire","components.availibility_hours.form.custom_hours":"Horaires","components.availibility_hours.form.custom_hours.content":"Définissez les horaires","components.availibility_hours.form.off":"Off","components.availibility_hours.form.off.content":"Sera indisponible ce jour","components.availibility_hours.form.whole_day":"Journée","components.availibility_hours.form.whole_day.content":"Sera disponible toute la journée","components.booking.detail.action":"Action","components.booking.detail.action_disabled_explaination":"Ces actions seront activées {minutes} minutes avant l'heure de la réservation","components.booking.detail.cancel":"Annuler","components.booking.detail.cancel_textarea_placeholder":"Commentaire SMS / Email (uniquement en cas d'annulation)","components.booking.detail.comments":"Commentaires :","components.booking.detail.confirm":"Confirmer","components.booking.detail.confirmed":"Confirmée","components.booking.detail.edit_info":"Éditer les informations de la réservation","components.booking.detail.fidelity_cart_number":"Carte de fidélité :","components.booking.detail.guest_number":"# couverts :","components.booking.detail.modal_title":"Réservation (détails)","components.booking.detail.no_show":"Pas venu","components.booking.detail.not_arrived":"Pas arrivé","components.booking.detail.seated":"Placé","components.booking.detail.source":"Source :","components.booking.detail.status":"Statut","components.booking.form.comment":"Commentaire","components.booking.form.create_booking":"Créer la réservation","components.booking.form.fidelity_card_number":"Numéro de carte de fidélité","components.booking.form.first_name":"Prénom","components.booking.form.guest_number":"Nombre de couverts","components.booking.form.last_name":"Nom","components.booking.form.mobile":"Mobile","components.booking.form.no_slots_for_date":"Il n'y a pas d'horaire disponible à la reservation pour cette date.","components.booking.form.phone_invalid":"Le numéro de téléphone est invalide","components.booking.form.room":"Salle","components.booking.form.update_booking":"Sauvegarder les modifications","components.booking.modal.add.title":"Ajouter une réservation","components.booking.period_picker.placeholder":"Sélectionner","components.booking.room_picker.all":"Toutes","components.color.picker.modal_title":"Choix de la couleur","components.color.picker.validate":"Valider","components.contact_modal.call_us_on":"Appelez nous au","components.contact_modal.send_mail_to":"Envoyez nous un email à","components.contact_modal.title":"Contact","components.digicode.account_for_code_not_enough_right":"Le code est valide, mais le compte associé n'as pas les droits pour cette action.","components.footer.cgu":"Mentions Légales","components.footer.rights_reserved":"Tous droits réservés","components.form.cancel_modifications":"Annuler les changements","components.form.save":"Sauvegarder","components.header.contact":"Contact","components.header.logout":"Déconnexion","components.menu.choose_product_modal.choose_products":"Choissez les produits","components.menu.choose_product_modal.search_no_results":"Il n'y a pas de produits correspondant à cette recherche.","components.menu.edit_category.delete":"Supprimer","components.menu.edit_category.description":"Description","components.menu.edit_category.edit":"Éditer la catégorie","components.menu.edit_category.name":"Nom","components.menu.edit_category.new":"Nouvelle catégorie","components.menu.edit_category.parent_category":"Catégorie parente","components.menu.edit_category.submit":"Valider","components.menu.edit_upselling_category.delete":"Supprimer","components.menu.edit_upselling_category.description":"Phrase d'accroche","components.menu.edit_upselling_category.description_placeholder":"(max. 50 caractères)","components.menu.edit_upselling_category.edit":"Éditer","components.menu.edit_upselling_category.name":"Nom","components.menu.edit_upselling_category.name_placeholder":"(ne sera pas publié)","components.menu.edit_upselling_category.new":"Nouveau","components.menu.edit_upselling_category.submit":"Valider","components.no_permission.label":"Vous n'avez pas les droits pour cette action","components.no_permission.permission_required":"Permission requise","components.opening_hours.form_modal.closing":"Fermeture","components.opening_hours.form_modal.create":"Créer l'horaire","components.opening_hours.form_modal.day":"Jour","components.opening_hours.form_modal.opening":"Ouverture","components.opening_hours.form_modal.title":"Ajouter un horaire d'ouverture","components.opening_hours.form.add_opening_hour":"Ajouter un horaire","components.order.cancel.close":"Non","components.order.cancel.error":"Impossible d'annuler cette commande.","components.order.cancel.noRefundCancel":"( i ) Votre client a payé en carte bancaire via le TPE présent sur la borne et non via nos services.\nVous pouvez annuler sa commande mais elle ne lui sera pas remboursée.","components.order.cancel.refundCancel":"En annulant cette commande, votre client sera remboursé de l'intégralité de son panier.","components.order.cancel.submit":"Oui, annuler","components.order.cancel.title":"Annulation de commande","components.order.cancel.verifyCancel":"Êtes-vous sûr(e) de vouloir annuler cette commande ?","components.order.detail.arrival_date":"Heure d'arrivée :","components.order.detail.delivery_date":"Heure de livraison :","components.order.detail.delivery_price":"Frais de livraison :","components.order.detail.general_comment":"Commentaire général:","components.order.detail.has_paid":"payé","components.order.detail.kiosk_number":"Borne N⁰","components.order.detail.on_site_payment":"Paiement sur place","components.order.detail.order_detail":"Détail de la commande","components.order.detail.order_number":"Commande N⁰","components.order.detail.order_total":"Total commande :","components.order.detail.pickup_date":"Heure de retrait :","components.order.detail.status":"Statut :","components.payment.modes.form.cash":"Liquide","components.payment.modes.form.restaurant_ticket":"Ticket restaurant","components.prices_editor.activation":"Activation","components.prices_editor.delivery":"Livraison","components.prices_editor.mode":"Mode","components.prices_editor.on_site":"Sur place","components.prices_editor.price_with_tax":"Prix TTC","components.prices_editor.take_away":"À emporter","components.prices_editor.vat":"TVA","components.restaurants_group.choose.modal_title":"Changer de groupe de restaurants","components.timelapse.picker.custom":"Personnalisée","components.timelapse.picker.day":"1 jour","components.timelapse.picker.month":"1 mois","components.timelapse.picker.period":"Période du","components.timelapse.picker.validate":"Valider","components.timelapse.picker.week":"1 semaine","components.user.detail.average_payment":"Paiement moyen","components.user.detail.average_rate":"Note moyenne","components.user.detail.average_tip":"Pourboire moyen","components.user.detail.client_record":"Fiche client","components.user.detail.last_visit":"Dernière visite","components.user.detail.total_visits_count":"Nb total de visites","components.user.payments.table.header.Hour":"Heure","components.user.payments.table.header.payed_by_client":"Réglé par le client","components.user.payments.table.header.rate":"Note","components.user.payments.table.header.with_tips":"Dont pourboire","export.failure":"Export échoué.","export.failure.invalid_time":"L'intervalle de temps doit être inférieur à 3 mois.","export.failure.message":"Une erreur est survenue. Veuillez contacter le service technique.","export.help":"Exportez toutes vos données sur une période donnée (maximum 3 mois)","export.option.label":"Type","export.option.BOOKINGS":"Réservations","export.option.ORDER":"Commandes","export.option.PAYMENTS":"Paiements","export.option.REVIEWS":"Avis","export.option.USERS":"Utilisateurs","export.submit":"Exporter","export.success":"Export réussi !","export.success.message":"Vous allez recevoir un mail contenant les données souhaitées.","feature_not_activated":"Service non activé sur votre compte","forgot_password.description":"veuillez saisir votre email pour recevoir les instructions de modifications de votre mot de passe","forgot_password.email":"Email","forgot_password.failure":"Aucun compte n'est relié à cet email.","forgot_password.submit":"Valider","forgot_password.success":"Les instructions vous ont été envoyées par email","forgot_password.title":"Mot de passe oublié","global.allergen.allergens":"Allergènes","global.allergen.BALSAM_OF_PERU":"Baume du Pérou","global.allergen.BUCKWHEAT":"Sarrasin","global.allergen.CELERY":"Céleri","global.allergen.CHEESE":"Fromage","global.allergen.CORN":"Maïs","global.allergen.CRUSTACEAN":"Crustacés","global.allergen.EGG":"Oeufs","global.allergen.FISH":"Poissons","global.allergen.FRUIT":"Fruits","global.allergen.GARLIC":"Ail","global.allergen.LACTOSE":"Lactose","global.allergen.LUPINE":"Lupin","global.allergen.MUSTARD":"Moutarde","global.allergen.PEANUT":"Arachides","global.allergen.POULTRY_MEAT":"Viande de volaille","global.allergen.RED_MEAT":"Viande rouge","global.allergen.RICE":"Riz","global.allergen.SESAME":"Sésame","global.allergen.SHELLFISH":"Mollusques","global.allergen.SOYA":"Soja","global.allergen.SULPHITES":"Sulfites","global.allergen.TARTRAZINE":"Tartrazine","global.allergen.GLUTEN":"Gluten","global.allergen.GLUTEN_OATS":"Avoine (gluten)","global.allergen.GLUTEN_WHEAT":"Blé (gluten)","global.allergen.GLUTEN_KAMUT":"Kamut (gluten)","global.allergen.GLUTEN_SPELT":"Épeautre (gluten)","global.allergen.GLUTEN_GREEN_SPELT":"Épeautre vert (gluten)","global.allergen.GLUTEN_EINKORN":"Petit épeautre (gluten)","global.allergen.GLUTEN_RYE":"Seigle (gluten)","global.allergen.GLUTEN_BARLEY":"Orge (gluten)","global.allergen.GLUTEN_EMMER":"Amidonnier (gluten)","global.allergen.GLUTEN_TRITICALE":"Triticale (gluten)","global.allergen.NUTS":"Fruits à coque","global.allergen.NUTS_ALMONDS":"Amandes (noix)","global.allergen.NUTS_HAZELNUTS":"Noisettes","global.allergen.NUTS_WALNUTS":"Noix","global.allergen.NUTS_CASHEW":"Noix de cajou","global.allergen.NUTS_PECANS":"Noix de pécan","global.allergen.NUTS_BRAZIL":"Noix du Brésil","global.allergen.NUTS_PISTACHES":"Pistaches (noix)","global.allergen.NUTS_MACADAMIA_OR_QUEENSLAND":"Noix de macadamia","global.allergen.PORK":"Porc","login.form.connect":"Se connecter","login.form.password":"Mot de passe","login.form.username":"Identifiant","login.form.forgot_password":"Mot de passe oublié","login.form.password.should_choose_another":"Votre mot de passe n'est pas sécurisé. Veuillez le changer en utilisant la fonctionnalité de mot de passe oublié.","logout.redirect_message":"Vous avez été deconnecté, vous allez être redirigé vers la page de connexion...","menu.admin":"Admin","menu.admin.restaurant":"Restaurant","menu.booking":"Réservations","menu.booking.book":"Carnet","menu.booking.settings":"Paramètres","menu.category.add_category":"Ajouter une catégorie","menu.category.add_item.categories":"Catégories","menu.category.add_item.child_categories":"Catégorie fille","menu.category.add_item.main_category":"Catégorie principale","menu.category.add_item.menus_on_menu":"Menus de la caisse","menu.category.add_item.modal_title":"Ajouter à la catégorie","menu.category.add_item.no_item_selected":"Il n'y a pas de produits selectionnés.","menu.category.add_item.no_menu_selected":"Il n'y a pas de menus selectionnés.","menu.category.add_item.products_on_menu":"Produits de la caisse","menu.category.add_item.search_no_results":"Il n'y a pas de produits correspondant à cette recherche.","menu.category.add_item.selected":"Sélectionnés","menu.category.ask_name":"Quel est le nom de la catégorie à créer ?","menu.category.categories":"Catégories","menu.category.confirm_deletion":"Voulez-vous vraiment supprimer la catégorie ?","menu.category.confirm_deletion_from_root":"Voulez-vous vraiment supprimer la catégorie de la catégorie principale ?","menu.category.detail.add_product_or_menu":"Ajouter un produit ou un menu","menu.category.detail.add_to_category":"Ajouter à la catégorie","menu.category.detail.confirm_delete_child_category":"Voulez-vous vraiment supprimer cette catégorie fille de la catégorie ?","menu.category.detail.confirm_delete_menu":"Voulez-vous vraiment supprimer ce menu de la catégorie ?","menu.category.detail.confirm_delete_product":"Voulez-vous vraiment supprimer ce produit de la catégorie ?","menu.category.detail.delete":"Supprimer","menu.category.detail.edit":"Éditer","menu.category.detail.no_description":"Pas de description","menu.category.detail.table.header.delete_from_category":"Supprimer de la catégorie","menu.category.detail.table.header.modes_and_price":"Modes & Prix","menu.category.detail.table.header.move":"Déplacer","menu.category.detail.table.header.name":"Nom","menu.category.edit_main_category":"Éditer la catégorie principale","menu.category.error_no_products_exists":"Vous devez créer des produits pour pouvoir créer une catégorie.","menu.category.menus":"Menus","menu.category.products":"Produits","menu.category.table.header.delete_from_main_category":"Supprimer de la catégorie principale","menu.category.table.header.move":"Déplacer","menu.category.table.header.name":"Nom","menu.export":"Export","menu.item_selector.modal_title":"Sélectionnez les éléments","menu.item_selector.no_item_selected":"Aucun élément sélectionné","menu.item_selector.products_on_menu":"Éléments de la carte","menu.item_selector.search_no_results":"Pas de résultat","menu.item_selector.selected":"Sélectionnés","menu.max_with_colon":"Max :","menu.menu_edit.add_part":"Ajouter une partie","menu.menu_edit.confirm_delete":"Êtes-vous sûr de vouloir supprimer ce menu ?","menu.menu_edit.delete":"Supprimer ce menu","menu.menu_edit.description":"Description","menu.menu_edit.menu_availability":"Disponibilité du menu","menu.menu_edit.menu_availability_date":"Modifier la période de temps sur laquelle le menu est disponible","menu.menu_edit.menu_availability_date.caption":"Ex : du 01/01/2018 au 30/04/2018","menu.menu_edit.menu_availability_hours":"Modifier les horaires de disponibilité par jour de la semaine","menu.menu_edit.menu_availability_hours.caption":"Ex : de 7h à 10h, tous les jours sauf le samedi","menu.menu_edit.menu_availability.caption":"Par défaut, ce menu est disponible toute l’année et à toute heure de la journée.","menu.menu_edit.name":"Nom","menu.menu_edit.no_category_with_menu":"Ce menu n'est présent dans aucune catégorie.","menu.menu_edit.part.confirm_deletion":"Êtes-vous sûr de vouloir supprimer cette partie ?","menu.menu_edit.part.delete":"Supprimer","menu.menu_edit.part.edit":"Éditer","menu.menu_edit.part.edit_addtionnal_price":"Modifier le prix additionnel","menu.menu_edit.part.edit_part_categories":"Organiser l'affichage","menu.menu_edit.part.form.additionnal_price":"Prix additionnel","menu.menu_edit.part.form.max":"Max","menu.menu_edit.part.form.min":"Min","menu.menu_edit.part.form.name":"Nom","menu.menu_edit.part.form.quantities":"Quantités","menu.menu_edit.part.modify_products":"Modifier les produits","menu.menu_edit.part.one_product_required":"Il faut au moins un produit","menu.menu_edit.part.title_create":"Créer la partie","menu.menu_edit.part.title_edit":"Éditer la partie","menu.menu_edit.parts":"Parties","menu.menu_edit.prices":"Prix","menu.menu_list.create_menu":"Créer un menu","menu.menu_list.name":"Nom","menu.menu_part_category.add_item.categories_on_menu":"Catégories","menu.menu_part_category.add_item.modal_title":"Ajouter un produit à la catégorie","menu.menu_part_category.categories":"Categories","menu.menu_part_category.check_all":"Sélectionner tout","menu.menu_part_category.edit.modal_title":"Modifier la catégorie","menu.menu_part_category.products":"Produits","menu.menu_part_category.uncheck_all":"Désélectionner tout","menu.menu_part.ask_new_category_name":"Créer une nouvelle catégorie","menu.menu_part.category.delete":"Supprimer","menu.menu_part.category.delete.are_you_sure":"Êtes-vous sûr de vouloir supprimer cette catégorie ?","menu.menu_part.category.edit_category":"Éditer","menu.menu_part.category.modify_items":"Ajouter / Modifier les produits","menu.menu_part.category.new_category":"Créer une sous-catégorie","menu.menu_part.category.subcategory":"sous-catégorie","menu.menu.detail.categories":"Catégories","menu.menu.detail.edit":"Éditer","menu.menu.detail.no_category_with_product":"ce produit n'est présent dans aucune catégorie.","menu.menu.detail.no_description":"Pas de description","menu.menu.detail.parts":"Parties","menu.menu.detail.price":"Prix","menu.menu.detail.table.header.activation":"Activation","menu.menu.detail.table.header.delivery":"Livraison","menu.menu.detail.table.header.mode":"Mode","menu.menu.detail.table.header.on_site":"Sur place","menu.menu.detail.table.header.price":"Prix","menu.menu.detail.table.header.take_away":"A emporter","menu.menu.detail.table.header.vat":"TVA","menu.min_with_colon":"Min :","menu.news":"Actualités","menu.news.home":"Accueil","menu.options_list.create_options":"Créer une option","menu.options_list.name":"Nom","menu.options_list.no_options":"Il n'y a pas d'options de définies.","menu.order":"Commandes","menu.order.cart_modifiers":"Promotions","menu.order.cart_modifiers.edit":"Éditer","menu.order.cart_modifiers.new":"Nouvelle","menu.order.orders_list":"Gestion commandes","menu.order.restaurant_menu":"Carte","menu.order.restaurant_menu.categories":"Catégories","menu.order.restaurant_menu.edition":"Éditer","menu.order.restaurant_menu.menus":"Menus","menu.order.restaurant_menu.new":"Nouveau","menu.order.restaurant_menu.options":"Options","menu.order.restaurant_menu.products":"Produits","menu.order.restaurant_menu.upselling_categories":"Vente additionnelle","menu.order.settings":"Paramètres","menu.order.statistics":"Statistiques","menu.payment":"Paiements","menu.payment.receipt":"Transactions","menu.payment.stat":"Statistiques","menu.pos_connection_loss":"Perte de connexion caisse","menu.pos_connection_loss.tooltip":"Veuillez vérifier la configuration POS. Assurez-vous également que les services POS sont opérationnels et accessibles","menu.pro_accounts":"Utilisateurs","menu.pro_accounts.restaurants_groups":"Restaurants","menu.pro_accounts.roles":"Rôles","menu.pro_accounts.users":"Utilisateurs","menu.product_edit.product_availability":"Disponibilité du produit","menu.product_edit.product_availability_date":"Modifier la période de temps sur laquelle le produit est disponible","menu.product_edit.product_availability_date.caption":"Ex : du 01/01/2018 au 30/04/2018","menu.product_edit.product_availability_hours":"Modifier les horaires de disponibilité par jour de la semaine","menu.product_edit.product_availability_hours.caption":"Ex : de 7h à 10h, tous les jours sauf le samedi","menu.product_edit.product_availability.caption":"Par défaut, ce produit est disponible toute l’année et à toute heure de la journée.","menu.product_edit.sequences":"Gestion des suites","menu.product_edit.reclaim_later":"Remis plus tard","menu.product_edit.reclaim_later.tooltip":"Permet de proposer au client final de récupérer ce produit plus tard. Ce choix n'est pas obligatoire. Cela n'est proposé que si le \"Séquençage des items\" est activé pour le mode de commande concerné.","menu.product_edit.default_sequence":"Niveau de suite par défaut","menu.product_edit.default_sequence.tooltip":"Cette valeur n'est prise en compte que si les paramètres du mode de commande concerné a le \"Séquençage des items\" activé.","menu.product_option_view.choices":"Choix offerts","menu.product_option_view.products":"Produits","menu.product_option_view.products_with_option":"Produits utilisant cette option","menu.product_option.edit":"Éditer","menu.product_option.max_with_colon":"Max:","menu.product_option.min_with_colon":"Min:","menu.product_option.no_products_with_option":"Cette option n'est présente dans aucun produit.","menu.product_option.option.edit.add_option_value":"Ajouter une valeur","menu.product_option.option.edit.confirm_delete":"Êtes-vous sûr de vouloir supprimer cette option ?","menu.product_option.option.edit.confirm_delete_value":"Êtes-vous sûr de vouloir supprimer cette valeur ?","menu.product_option.option.edit.delete_option":"Supprimer cette option","menu.product_option.option.edit.max":"Max","menu.product_option.option.edit.min":"Min","menu.product_option.option.edit.offered_choices":"Choix offerts","menu.product_option.option.edit.quantities":"Quantités","menu.product_option.option.value.additionnal_price":"Prix additionnel","menu.product_option.option.value.delete_value":"Supprimer cette valeur","menu.product_option.option.value.edit_choice":"Éditer le choix","menu.product_option.option.value.name":"Nom","menu.product_option.option.value.new_choice":"Nouveau choix","menu.product_option.option.value.no_additionnal_price":"Pas de prix additionnel","menu.product_option.option.value.stock":"Disponibilité","menu.product_option.optionnal":"Optionnel","menu.product_option.required":"Obligatoire","menu.product.available":"Disponible","menu.product.categories":"Catégories","menu.product.edit":"Éditer","menu.product.edit.add_category":"Ajouter à une catégorie","menu.product.edit.allergen":"Choisir les allergènes","menu.product.edit.available":"Disponible","menu.product.edit.categories":"Catégories","menu.product.edit.other":"Autres","menu.product.edit.containsAlcohol.label":"Contient de l'alcool","menu.product.edit.confirm_delete_option":"Êtes-vous sûr de vouloir supprimer cette option du produit ?","menu.product.edit.confirm_delete_product":"Êtes-vous sûr de vouloir supprimer ce produit ?","menu.product.edit.confirm_delete_product_from_category":"Êtes-vous sûr de vouloir supprimer ce produit de cette catégorie ?","menu.product.edit.confirm_delete_product_from_menu":"Êtes-vous sûr de vouloir supprimer ce produit du menu ?","menu.product.edit.delete_product":"Supprimer le produit","menu.product.edit.delete_product.permission_refused":"Vous n'avez pas la permission de supprimer ce produit","menu.product.edit.description":"Description","menu.product.edit.menus":"Menus","menu.product.edit.name":"Nom","menu.product.edit.no_category_with_product":"Ce produit n'est présent dans aucune catégorie.","menu.product.edit.no_menu_with_product":"Ce produit n'est présent dans aucun menu.","menu.product.edit.no_options":"Ce produit n'a pas d'options.","menu.product.edit.options":"Options","menu.product.edit.prices":"Prix","menu.product.edit.select_options":"Selectionner les options","menu.product.edit.unavailable":"Indisponible","menu.product.list.create_product":"Créer un produit","menu.product.list.table.header.availibility":"Disponibilité","menu.product.list.table.header.name":"Nom","menu.product.list.table.header.prices":"Prix","menu.product.menus":"Menus","menu.product.no_category_with_product":"Ce produit n'est présent dans aucune catégorie.","menu.product.no_description":"Pas de description","menu.product.no_menu_with_product":"Ce produit n'est présent dans aucun menu.","menu.product.no_options":"Ce produit n'a pas d'options.","menu.product.options":"Options","menu.product.prices":"Prix","menu.product.table.header.activation":"Activation","menu.product.table.header.delivery":"Livraison","menu.product.table.header.mode":"Mode","menu.product.table.header.on_site":"Sur place","menu.product.table.header.price":"Prix TTC","menu.product.table.header.take_away":"A emporter","menu.product.table.header.vat":"TVA","menu.product.unavailable":"Indisponible","menu.review":"Avis clients","menu.review.claims_discussions":"Réengagement","menu.review.summary":"Synthèse","menu.select_product_option.add_selected_options":"Ajouter les options sélectionnées","menu.select_product_option.search_result_empty":"Il n'y a pas de produits correspondant à cette recherche.","menu.select_product_option.select_product_options":"Sélectionnez les options de ce produit","menu.settings":"Paramètres","menu.settings.custom_texts":"Textes personnalisés","menu.settings.restaurant":"Restaurant","menu.suggestions.error_no_products_exists":"Vous devez créer des produits pour pouvoir créer une suggestion.","menu.suggestions.error_no_suggestion_exists":"Vous devez créer des produits pour pouvoir ajouter une suggestion.","menu.suggestions.form.add":"Ajouter","menu.suggestions.form.add_suggestion":"Ajouter une suggestion","menu.suggestions.form.delete":"Supprimer","menu.suggestions.form.edit":"Éditer","menu.suggestions.form.edit_suggestion":"Éditer une suggestion","menu.suggestions.form.labelAdd":"sera ajouté avec","menu.suggestions.form.labelReplace":"sera remplacé par","menu.suggestions.form.introduction.title":"Phrase d'introduction (optionnel).","menu.suggestions.form.introduction.explanation":"Si aucune phrase d'introduction n'est ajoutée, le texte par défaut sera \"Nos suggestions\"","menu.suggestions.suggestions_list_empty":"Aucune suggestion enregistrée","menu.synchronize_with_pos":"Synchroniser caisse","menu.tabs.categories":"CATÉGORIES","menu.tabs.menus":"MENUS","menu.tabs.options":"OPTIONS","menu.tabs.products":"PRODUITS","menu.tabs.suggestions":"SUGGESTIONS","menu.tabs.upselling_categories":"VENTE ADDITIONNELLE","menu.unused_category.no_unused_message":"Il n'y a pas de catégorie inutilisée.","menu.unused_category.table.header.name":"Nom","menu.unused_category.title":"Catégories inutilisées","menu.upselling_category.add_category":"Ajouter une pop-up de vente additionnelle","menu.upselling_category.add_item.menus_on_menu":"Menus de la caisse","menu.upselling_category.add_item.modal_title":"Ajouter à la catégorie","menu.upselling_category.add_item.no_item_selected":"Il n'y a pas de produits selectionnés.","menu.upselling_category.add_item.no_menu_selected":"Il n'y a pas de menus selectionnés.","menu.upselling_category.add_item.products_on_menu":"Produits de la caisse","menu.upselling_category.add_item.search_no_results":"Il n'y a pas de produits correspondant à cette recherche.","menu.upselling_category.add_item.selected":"Sélectionnés","menu.upselling_category.ask_name":"Quel est le nom de la vente additionnelle à créer ?","menu.upselling_category.caption":"Vous pouvez créer autant de ventes additionnelles que vous le souhaitez mais vous ne pouvez en présenter qu’une seule à la fois. Seule la vente additionnelle active sera proposée à vos clients sur votre site de commande en ligne.","menu.upselling_category.confirm_deletion":"Voulez-vous vraiment supprimer la catégorie ?","menu.upselling_category.detail.add_product_or_menu":"Ajouter un produit ou un menu","menu.upselling_category.detail.confirm_delete_child_category":"Etes-vous sûr de vouloir supprimer cette sous-catégorie ?","menu.upselling_category.detail.confirm_delete_menu":"Voulez-vous vraiment supprimer ce menu de la catégorie ?","menu.upselling_category.detail.confirm_delete_product":"Voulez-vous vraiment supprimer ce produit de la catégorie ?","menu.upselling_category.detail.disabled":"Désactivé","menu.upselling_category.detail.edit":"Éditer","menu.upselling_category.detail.enabled":"Activé","menu.upselling_category.detail.no_description":"Pas de phrase d'accroche","menu.upselling_category.detail.table.header.delete_category":"Supprimer la catégorie","menu.upselling_category.detail.table.header.modes_and_price":"Modes & Prix","menu.upselling_category.detail.table.header.move":"Déplacer","menu.upselling_category.detail.table.header.name":"Nom","menu.upselling_category.error_no_products_exists":"Vous devez créer des produits pour pouvoir créer une catégorie.","menu.upselling_category.menus":"Menus","menu.upselling_category.products":"Produits","menu.upselling_category.table.header.delete":"Supprimer","menu.upselling_category.table.header.description":"Description","menu.upselling_category.table.header.enabled":"Activation","menu.upselling_category.table.header.move":"Déplacer","menu.upselling_category.table.header.name":"Nom","news.form.add_news":"Ajouter une actualité","news.form.create_news":"Créer l'actualité","news.form.image_placeholder":"Image d'illustration","news.form.news_content":"Texte de l'actualité","news.form.news_title":"Titre de l'actualité","news.form.save_modifications":"Sauvegarder les changements","news.home.add_actuality":"Ajouter une actualité","news.list.confirm_delete_news":"Êtes-vous sûr de vouloir supprimer cette actualité ?","notification.booking.for_booking_taken_at_least":"Pour les réservations prises au moins","notification.booking.for_booking_taken_at_least_input_group_addon":"minutes à l'avance","notification.booking.for_booking_taken_at_least_tooltip":"Permet d'éviter d'envoyer un rappel à un client qui a fait une réservation pour le jour même (ex : 180 minutes permet d'envoyer un rappel uniquement pour les clients qui ont enregistrés une réservation au moins 3 heures à l'avance)","notification.booking.reminder":"Envoi du SMS de rappel","notification.booking.reminder_input_group_addon":"minutes avant l'heure","notification.disable":"Désactivé","notification.sender":"Expéditeur :","notification.sender_address":"Adresse de l'expéditeur :","notification.sender_name":"Nom de l'expéditeur :","notification.subject":"Sujet :","order.cart_modifiers":"Promotions","order.cart_modifiers.actions.offering_shipping_cost.none":"Aucune","order.cart_modifiers.actions.offering_shipping_cost.reduction":"Réduction","order.cart_modifiers.actions.offering_shipping_cost.title":"Frais de livraison offerts","order.cart_modifiers.actions.title":"Actions","order.cart_modifiers.actiontype.DISCOUNT_AMOUNT":"Montant","order.cart_modifiers.actiontype.DISCOUNT_PERCENTAGE":"Pourcentage","order.cart_modifiers.add":"Ajouter une promotion","order.cart_modifiers.archive.confirm.message":"La promotion sera supprimée","order.cart_modifiers.archive.confirm.title":"Êtes-vous sûr ?","order.cart_modifiers.cheapest_item":"Le produit le moins cher","order.cart_modifiers.condition_rule.min":"Nombre d'éléments minimum","order.cart_modifiers.conditions_rules.add_rule":"Ajouter une règle","order.cart_modifiers.conditions_rules.amount.shipingCostExcluded":"Hors frais de livraison","order.cart_modifiers.conditions_rules.amount.shipingCostIncluded":"Frais de livraison inclus","order.cart_modifiers.conditions_rules.front.apiConsumerIds.title":"Limiter à une interface","order.cart_modifiers.conditions_rules.max_amount.title":"Montant maximum de commande","order.cart_modifiers.conditions_rules.min_amount.title":"Montant minimum de commande","order.cart_modifiers.conditions_rules.composition.title":"Composition du panier","order.cart_modifiers.conditions_rules.dateCondition.from":"À partir du","order.cart_modifiers.conditions_rules.dateCondition.title":"Définir une période spécifique","order.cart_modifiers.conditions_rules.dateCondition.to":"Au","order.cart_modifiers.conditions_rules.mode.title":"Mode de consommation","order.cart_modifiers.conditions_rules.title":"Conditions","order.cart_modifiers.conditions_rules.weekly_availabilities.title":"Jour de la semaine spécifique","order.cart_modifiers.general.code.label":"Code","order.cart_modifiers.general.code.tooltip":"Code que les clients doivent entrer pour appliquer la réduction à leur panier.","order.cart_modifiers.general.combinable.label":"Cumulable","order.cart_modifiers.general.description.label":"Description","order.cart_modifiers.general.description.placeholder":"Description","order.cart_modifiers.general.name.label":"Nom","order.cart_modifiers.general.name.placeholder":"Nom","order.cart_modifiers.general.tag.label":"Tag","order.cart_modifiers.general.tag.placeholder":"Tag","order.cart_modifiers.general.title":"Général","order.cart_modifiers.items_list.0":"Catégories","order.cart_modifiers.items_list.1":"Menus","order.cart_modifiers.items_list.2":"Produits","order.cart_modifiers.list.activate":"Activer","order.cart_modifiers.list.delete":"Supprimer","order.cart_modifiers.list.description":"Description","order.cart_modifiers.list.name":"Nom","order.cart_modifiers.list.priority":"Priorité","order.cart_modifiers.no_data":"Aucune promotion trouvée","order.cart_modifiers.target":"Applicable à","order.cart_modifiers.target.type.title":"Type","order.history.no_orders":"Pas de commandes","order.history.on_site":"Sur place","order.history.table.header.first_name":"Prénom","order.history.table.header.phone":"Téléphone","order.history.table.header.status":"Statut","order.history.table.header.total":"Total","order.list.tabs.history":"Historique","order.list.tabs.on_going":"En cours","order.manufacture_delay.label":"Délai de production","order.on_going.cancel":"Annuler","order.on_going.disable_order":"Fermer la commande","order.on_going.disable_product":"Désactiver un produit","order.on_going.not_cancelable":"Non annulable","order.on_going.on_site":"Sur place","order.on_going.online":"En ligne","order.on_going.order_disabled":"Fermé","order.on_going.order_disabled_text":"Ce restaurant est fermé à la commande. Vous pouvez le réactiver à tout moment manuellement.","order.on_going.order_disabled_text_without_permission":"Ce restaurant est fermé à la commande.","order.on_going.order_enabled":"Ouvert","order.on_going.order_ready":"Commande prête","order.on_going.table.offline":"Vous n'avez pas de connexion internet. Impossible de mettre à jour la liste.","order.on_going.table.header.name":"Nom","order.on_going.table.header.payment":"Paiement","order.on_going.table.header.phone":"Téléphone","order.on_going.table.header.source":"Source","order.on_going.table.header.total":"Total","order.on_going.table.header.type":"Mode de consommation","order.print":"Imprimer","order.settings.delivery.delivery_price":"Frais de livraison","order.settings.delivery.delivery_time.fix.title":"Délai de livraison moyen","order.settings.delivery.delivery_time.fix.title.tooltip":"Ce délai nous permettra d'informer vos clients sur l'heure à partir de laquelle ils recevront leur commande. Le temps de fabrication (paramètrable sur la page \"Gestion des commandes\") lui sera additionné. Exemple : avec un délai de livraison moyen à 15 min et un temps de fabrication à 10 min, le client qui commande à 12h00 sera livré à 12h25.","order.settings.delivery.max_range_in_meters":"Distance maximale pour la livraison","order.settings.delivery.minimum_price":"Panier minimum de commande","order.settings.delivery.minimum_price_for_free_delivery":"Livraison gratuite à partir de","order.settings.delivery.minimum_price_for_free_delivery_tooltip":"0 signifie qu'il n'y a pas de livraison gratuite","order.settings.delivery.restaurant_address_not_defined":"Vous n'avez pas défini l'adresse de votre restaurant","order.settings.general.delivery":"Livraison","order.settings.general.menu_managed_by_pos":"Récuperer la carte du restaurant par un POS externe","order.settings.general.notifications":"Notifications","order.settings.general.on_site":"Sur place","order.settings.general.order_modes":"Modes de commandes","order.settings.general.take_away":"A emporter","order.settings.irl_payment_allowed.title":"Paiement sur place accepté","order.settings.itemsSequenced":"Séquençage des items","order.settings.itemsSequenced.tooltip":"Si \"ON\" alors la notion de suite est prise en compte (eg. boissons, entrés, plats, desserts, etc). Si \"OFF\" alors tous les produits seront toujours envoyés en direct (production immediate).","order.settings.kiosk.advertising":"Image de pub","order.settings.kiosk.background":"Image de fond","order.settings.kiosk.languages":"Langues","order.settings.kiosk.modes":"Modes de commande","order.settings.kiosk.rooms":"Salles","order.settings.kiosk.service_at_table_enabled":"Service à table","order.settings.kiosk.ticket.custom_field.label":"Personnaliser le champ","order.settings.kiosk.ticket.custom_label":"Insérer du texte au bas du ticket client","order.settings.kiosk.ticket.custom_label.tooltip":"Vous avez la possibilité d’insérer du texte en bas du ticket que votre client va recevoir à la fin de sa commande","order.settings.kiosk.ticket.title":"Ticket","order.settings.nb_days_to_propose_explaination":"0 signifiant que la commande est possible uniquement le jour même","order.settings.nb_days_to_propose_input_group_addon":"jours à l'avance","order.settings.nb_days_to_propose_title":"Commandes ouvertes","order.settings.notifications.sms_email":"Recevoir les commandes par Email","order.settings.notifications.sms_email_tooltip":"Réagissez rapidement aux nouvelles commandes en les recevant par email","order.settings.on_site.minimum_price":"Panier minimum de commande","order.settings.on_site.order_at_bar":"Commande au bar","order.settings.on_site.pre_order_available":"Pré-commande","order.settings.payment_methods_allowed.cb":"CB","order.settings.payment_methods_allowed.irl":"Sur place","order.settings.payment_methods_allowed.label":"Moyens de paiement acceptés","order.settings.payment_methods_allowed.trd":"Ticket restaurant","order.settings.payment_methods_allowed.user_account":"Compte utilisateur","order.settings.tabs.delivery":"Livraison","order.settings.tabs.general":"Général","order.settings.tabs.kiosk":"Borne","order.settings.tabs.on_site":"Sur place","order.settings.tabs.opening_hours":"Horaires d'ouverture","order.settings.tabs.take_away":"À emporter","order.settings.take_away.minimum_price":"Panier minimum de commande","order.source.platform.ANDROID":"Mobile","order.source.platform.BACK_OFFICE_WEB":"Restaurant","order.source.platform.BOT":"Facebook","order.source.platform.IOS":"Mobile","order.source.platform.KIOSK":"Borne","order.source.platform.OTHER":"Autre","order.source.platform.PLUGIN_WEB":"Web","order.source.platform.POS":"Caisse","order.statistics.average":"Panier moyen TTC","order.statistics.filters.average":"moyenne","order.statistics.modes":"Modes de consommation","order.statistics.nbDeliveryOrders":"Livraison","order.statistics.nbOnSiteOrders":"Sur place","order.statistics.nbOnSitePaidOrders":"Sur place","order.statistics.nbOrders":"Nombre de commandes","order.statistics.nbPaidOrders":"CB","order.statistics.nbTakeAwayOrders":"À emporter","order.statistics.no_data":"Aucune statistique enregistrée sur cette période","order.statistics.other":"Autre","order.statistics.payments":"Paiements","order.statistics.salesFilters.day":"jour","order.statistics.salesFilters.hour":"heure","order.statistics.salesFilters.month":"mois","order.statistics.salesFilters.week":"semaine","order.statistics.sources":"Sources","order.statistics.submit":"Calculer","order.statistics.turnover":"Chiffre d'affaires TTC","order.statistics.turnover_average-check":"Chiffre d'affaires / Panier moyen","order.statistics.turnover_average-check_by-weekday":"Chiffre d'affaires heure par heure (moyenne sur la période)","order.to_make.name":"Nom","order.to_make.total":"Total","order.to_make.type":"Type","page_not_found":"La page n'existe pas","payins.no_payins":"Vous n'avez pas de transaction PayMyTable sur cette période","payins.table.header.date":"Date","payins.table.header.hour":"Heure","payins.table.header.including_tips":"Dont pourboires","payins.table.header.payed_with_pmt":"Réglé avec PMT","payins.table.header.total_table":"Total table","payment_stats.graph.amount_payed":"Montants Payés","payment_stats.graph.payed_label":"Payé","payment_stats.interval_too_big":"L'interval de temps est trop élevé !","payment_stats.no_payout":"Vous n'avez pas de transaction PayMyTable sur cette période","payment_stats.numbers.amount_payed_with_pmt":"Montants réglés avec PMT","payment_stats.numbers.amount_payed_with_pmt_tooltip":"Montant total des paiements réglés avec PayMyTable. Ce montant inclus les pourboires","payment_stats.numbers.key_numbers_title":"Chiffres clés","payment_stats.numbers.number_of_payments":"Paiements Effectués","payment_stats.numbers.number_of_payments_tooltip":"Nombre total de paiements PayMyTable. Plusieurs paiements pouvant être effectués par addition","payment_stats.numbers.payed_tables":"Tables Payées","payment_stats.numbers.payed_tables_tooltip":"Nombre d'additions réglées en totalité ou en partie avec PayMyTable","payment_stats.numbers.tips":"Pourboires","payouts.no_payouts":"Aucun virement effectué sur cette période","payouts.table.header.amount":"Montant brut encaissé","payouts.table.header.amount_net":"Montant net versé","payouts.table.header.commissions_fixed_without_taxes":"Commissions fixes HT","payouts.table.header.commissions_variable_without_taxes":"Commissions variables HT","payouts.table.header.commissions_with_taxes":"Commissions TTC","payouts.table.header.date":"Date","payouts.table.header.id":"ID","payouts.table.header.reference":"Référence","payouts.table.header.status":"Status","payouts.table.header.vat":"TVA","receipt.tabs.payins":"Mes encaissements","receipt.tabs.payouts":"Mes virements","restaurant_edit.bank":"Banque","restaurant_edit.configuration.bank":"Type de contrat bancaire","restaurant_edit.configuration.bank.acquirer.bank_id":"Acquirer bank id","restaurant_edit.configuration.bank.acquirer.wallet_id":"Acquirer wallet id","restaurant_edit.configuration.bank.choice":"Type","restaurant_edit.configuration.bank.choice.payzen":"Payzen","restaurant_edit.configuration.bank.choice.default":"Défaut","restaurant_edit.configuration.bank.psp.restaurantId":"PSP restaurant id","restaurant_edit.configuration.commission_per_transaction":"Commission par transaction HT (fixe)","restaurant_edit.configuration.commission_per_transaction_variable":"Commission par transaction HT (variable)","restaurant_edit.configuration.commissions":"Commissions","restaurant_edit.configuration.fee_vat_percentage":"TVA à appliquer (%)","restaurant_edit.configuration.general":"Général","restaurant_edit.configuration.password":"Mot de passe","restaurant_edit.configuration.password_verification":"Mot de passe confirmation","restaurant_edit.configuration.pos":"POS","restaurant_edit.configuration.pos.credentials":"Identifiants","restaurant_edit.configuration.pos.customer_id":"ID client (customer id)","restaurant_edit.configuration.pos.comment_id":"ID article commentaire","restaurant_edit.configuration.pos.tip_article_id":"ID article tip","restaurant_edit.configuration.pos.price_level_id":"ID niveau de prix","restaurant_edit.configuration.pos.use_qsr_order_number":"Utiliser le numéro de commande QSR","restaurant_edit.configuration.pos.send_article_line_num":"Envoyer le linenum dans l'itemList des articles","restaurant_edit.configuration.pos.encryption_key":"Encryption key","restaurant_edit.configuration.pos.id":"ID du POS","restaurant_edit.configuration.pos.menu_id":"Menu id","restaurant_edit.configuration.pos.url":"Url du POS","restaurant_edit.configuration.restaurant_id":"Id du point de vente","restaurant_edit.configuration.external_id":"ID externe","restaurant_edit.configuration.restaurant_name":"Nom du point de vente","restaurant_edit.configuration.status":"Status","restaurant_edit.configuration.statut.CREATED":"Crée","restaurant_edit.configuration.statut.ENABLED":"Activé","restaurant_edit.configuration.statut.DISABLED":"Désactivé","restaurant_edit.configuration.statut.ARCHIVED":"Archivé","restaurant_edit.configuration.statut.DISABLED.explain":"Ce point de vente n'apparaîtra pas sur les fronts","restaurant_edit.configuration.statut.ENABLED.explain":"Ce point de vente apparaîtra sur les fronts","restaurant_edit.configuration.statut.ARCHIVED.tip":"Ce point de vente est archivé","restaurant_edit.configuration.transferFrequency.DISABLED.tip":"Les virements sont désactivés pour ce point de vente","restaurant_edit.configuration.tips":"Pourboires","restaurant_edit.error.20009":"L'id et/ou le certificat semblent erronés. Nous n'avons pas pu sauvegarder vos modifications. Merci de réessayer.","restaurant_edit.error.default":"Une erreur est survenue. Nous n'avons pas pu sauvegarder vos modifications. Merci de réessayer.","restaurant_edit.features.label":"Fonctionnalités","restaurant_edit.features.order":"Commande","restaurant_edit.features.payment":"Paiement à table","restaurant_edit.features.qr_code":"QR Code","restaurant_edit.features.retrieving_bill_method":"Méthode de récupération de l'addition","restaurant_edit.features.review":"Avis client","restaurant_edit.features.table_number":"Numéro de table","restaurant_edit.finance.accepted_payment_means":"Moyens de paiement acceptés","restaurant_edit.finance.automatic_payout_frequency":"Fréquence des virements automatiques","restaurant_edit.finance.bank_account":"Compte bancaire","restaurant_edit.finance.bic":"Coordonnées bancaires BIC","restaurant_edit.finance.bic.invalid":"Votre BIC n'est pas au bon format","restaurant_edit.finance.financial_department_email":"Email du département financier","restaurant_edit.finance.iban":"IBAN","restaurant_edit.finance.iban.invalid":"Votre IBAN n'est pas au bon format","restaurant_edit.finance.money":"Monnaie","restaurant_edit.finance.other":"Configuration","restaurant_edit.finance.rib":"RIB","restaurant_edit.finance.rib.see_file":"Voir le fichier","restaurant_edit.finance.settings_on_restaurantsgroup":"Le paramétrage PSP se fait au niveau du groupe de restaurants sur ","restaurant_edit.kyc":"KYC","restaurant_edit.legal.company":"Société","restaurant_edit.legal.kbis":"K-bis","restaurant_edit.legal.kbis.modal_label":"RegistrationProof","restaurant_edit.legal.kbis.see_file":"Voir le fichier","restaurant_edit.legal.legal_representative":"Représentant légal","restaurant_edit.legal.legal.address.city":"Ville","restaurant_edit.legal.legal.address.country":"Pays","restaurant_edit.legal.legal.address.label":"Adresse","restaurant_edit.legal.legal.address.post_code":"Code postal","restaurant_edit.legal.legal.cgu_url":"Lien CGU","restaurant_edit.legal.legal.cgv_url":"Lien CGV","restaurant_edit.legal.legal.company_name":"Nom légal de l'entreprise","restaurant_edit.legal.legal.siret":"Numéro d'entreprise (SIRET)","restaurant_edit.legal.legal.vatNumber":"Numéro d'identification TVA","restaurant_edit.legal.legal.vatNumber.automaticallyCalculated":"Le numéro de TVA sera automatiquement calculé à l'aide du numéro d'enregistrement légal de votre entreprise","restaurant_edit.legal.legal.countryRequired":"Vous devez d'abord sélectionner votre pays","restaurant_edit.legal.manager.email":"Email du restaurant","restaurant_edit.legal.manager.name":"Nom du responsable","restaurant_edit.legal.manager.phone":"Téléphone du responsable","restaurant_edit.legal.representative.address.city":"Ville","restaurant_edit.legal.representative.address.country":"Pays","restaurant_edit.legal.representative.address.label":"Adresse","restaurant_edit.legal.representative.address.post_code":"Code postal","restaurant_edit.legal.representative.birthdate":"Date de naissance","restaurant_edit.legal.representative.country_of_residence":"Pays de résidence","restaurant_edit.legal.representative.first_name":"Prénom","restaurant_edit.legal.representative.identity_document":"Pièce d'identité","restaurant_edit.legal.representative.identity_document.modal_label":"Pièce d'identité","restaurant_edit.legal.representative.identity_document.see_file":"Voir le fichier","restaurant_edit.legal.representative.last_name":"Nom","restaurant_edit.legal.representative.nationality":"Nationalité","restaurant_edit.legal.restaurateur":"Restaurateur","restaurant_edit.legal.shareholder_declaration":"Déclaration d'actionnaires","restaurant_edit.legal.shareholder_declaration.example":"Exemple","restaurant_edit.legal.shareholder_declaration.modal_label":"Déclaration d'actionnaires","restaurant_edit.legal.shareholder_declaration.see_file":"Voir le fichier","restaurant_edit.legal.status_pdf":"Statut (PDF)","restaurant_edit.legal.status_pdf.modal_label":"Statut","restaurant_edit.legal.status_pdf.see_file":"Voir le fichier","restaurant_edit.menu.image":"Image du menu","restaurant_edit.menu.no_menu_uploaded_yet":"Vous n'avez pas encore uploadé de menu.","restaurant_edit.menu.pdf":"Pdf du menu","restaurant_edit.menu.pdf_modal_title":"Le fichier pdf du menu","restaurant_edit.menu.see_pdf":"Voir le fichier pdf du menu","restaurant_edit.menu.selected_file":"Fichier selectionné :","restaurant_edit.public.address.city":"Ville","restaurant_edit.public.address.country":"Pays","restaurant_edit.public.address.label":"Adresse","restaurant_edit.public.address.post_code":"Code postal","restaurant_edit.public.description":"Description","restaurant_edit.public.email":"Adresse email de contact","restaurant_edit.public.gps_coordinates":"Coordonnées GPS","restaurant_edit.public.latitude":"Latitude","restaurant_edit.public.logo":"Logo du restaurant","restaurant_edit.public.logo_requirements":"L'image doit avoir un fond transparant (fichier PNG).","restaurant_edit.public.locale":"Langue","restaurant_edit.public.longitude":"Longitude","restaurant_edit.public.phone_number":"Numéro de téléphone","restaurant_edit.public.picture":"Photo du restaurant","restaurant_edit.public.preview":"Aperçu","restaurant_edit.public.tag":"Tag","restaurant_edit.public.timezone":"Fuseau horaire du restaurant","restaurant_edit.public.website":"Site internet","restaurant_edit.restaurants_group.create_group":"Créer un groupe","restaurant_edit.restaurants_group.modifications_saved":"Modifications enregistrées.","restaurant_edit.restaurants_group.select_groups":"Sélectionnez les groupes dans lequel le restaurant doit être présent","restaurant_edit.theme.action_background_color":"Couleur de fond de l'action","restaurant_edit.theme.action_text_color":"Couleur de texte de l'action","restaurant_edit.theme.background_color":"Couleur de fond","restaurant_edit.theme.text_color":"Couleur du texte","restaurant_edit.theme.title_background_color":"Couleur de fond du titre","restaurant_edit.theme.title_font_color":"Couleur du titre","restaurant.edit.footer":"Pour toute autre modification, veuillez nous contacter à","restaurant.edit.tabs.configuration":"Configuration","restaurant.edit.tabs.features":"Fonctionnalités","restaurant.edit.tabs.finance":"Finance","restaurant.edit.tabs.legal":"Info légales","restaurant.edit.tabs.menu":"Menu","restaurant.edit.tabs.opening_hours":"Horaires d'ouverture","restaurant.edit.tabs.public":"Info publiques","restaurant.edit.tabs.restaurants_groups":"Groupes","restaurant.edit.tabs.theme":"Thème","review.claims_discussions.ask_activate":"Activer la fonctionnalité ?","review.claims_discussions.email.content":"Contenu de l' email","review.claims_discussions.email.sender_email":"Email de l' expediteur","review.claims_discussions.email.sender_email.label":"ex: caroline@brasserie-granand.fr","review.claims_discussions.email.sender_name":"Nom de l' expediteur","review.claims_discussions.email.sender_name.placeholder":"ex: Caroline (Brasserie Granand)","review.claims_discussions.email.subject":"Sujet de l'email","review.claims_discussions.email.subject.placeholder":"Votre avis compte pour nous","review.claims_discussions.for_rates_less_than":"Pour les notes inférieures ou égales à ?","review.claims_discussions.page_explaination":"Paramétrez ici l'email automatique qui sera envoyé aux clients n'étant pas pleinement satisfait de leur expérience","review.claims_discussions.time_to_wait":"Temps écoulé entre la notation et l'envoi de l'email","review.claims_discussions.validate":"Valider","review.summary.general_note":"Note générale :","review.summary.list.title":"Avis","review.summary.no_data_on_period":"Vous n'avez pas d'avis clients sur cette période","review.summary.review.check_modal_title":"L'addition","review.summary.review.comment":"Commentaire","review.summary.review.modal_title":"Avis du client","review.summary.review.reasons":"Raisons invoquées :","review.summary.review.see_check":"Voir l'addition","review.summary.review.see_detail":"Voir le détail","review.summary.review.tip":"Pourboire :","review.summary.review.waiter":"Serveur :","review.summary.reviews":"avis","server_error.message":"Veuillez nous excuser pour la gêne occasionnée.","server_error.message_2":"Nos équipes ont été prévenues du problème.","server_error.title":"Une erreur serveur est survenue."}

/***/ }),

/***/ "./scripts/actions/CartModifierAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiCartModifier = __webpack_require__("./sdk/scripts/api/ApiCartModifier.js");

var _ApiCartModifier2 = _interopRequireDefault(_ApiCartModifier);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartModifierAction = function () {
  function CartModifierAction() {
    _classCallCheck(this, CartModifierAction);
  }

  _createClass(CartModifierAction, null, [{
    key: 'loadCartModifiers',
    value: function loadCartModifiers(restaurantId) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_CART_MODIFIERS
      });

      _ApiCartModifier2.default.getCartModifiers(restaurantId, CartModifierAction.receiveCartModifiers, CartModifierAction.receiveCartModifiersError);
    }
  }, {
    key: 'receiveCartModifiers',
    value: function receiveCartModifiers(data) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_CART_MODIFIERS_SUCCESS,
        data: data
      });
    }
  }, {
    key: 'receiveCartModifiersError',
    value: function receiveCartModifiersError(apiError) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_CART_MODIFIERS_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'loadCartModifier',
    value: function loadCartModifier(restaurantId, cartModifierId) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_CART_MODIFIER
      });

      _ApiCartModifier2.default.getCartModifier(restaurantId, cartModifierId, function (cartModifier) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.GET_CART_MODIFIER_SUCCESS,
          data: cartModifier
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.GET_CART_MODIFIER_FAILURE,
          apiError: apiError
        });
      });
    }
  }, {
    key: 'putCartModifier',
    value: function putCartModifier(restaurantId, cartModifier) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.PUT_CART_MODIFIER,
        restaurantId: restaurantId,
        cartModifier: cartModifier
      });

      _ApiCartModifier2.default.putCartModifier(restaurantId, cartModifier, function (updatedCartModifier) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.PUT_CART_MODIFIER_SUCCESS,
          data: updatedCartModifier
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.PUT_CART_MODIFIER_FAILURE,
          apiError: apiError
        });
      });
    }
  }, {
    key: 'postCartModifier',
    value: function postCartModifier(restaurantId, cartModifier) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.POST_CART_MODIFIER,
        restaurantId: restaurantId,
        cartModifier: cartModifier
      });

      _ApiCartModifier2.default.postCartModifier(restaurantId, cartModifier, function (createdCartModifier) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.POST_CART_MODIFIER_SUCCESS,
          data: createdCartModifier
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.POST_CART_MODIFIER_FAILURE,
          apiError: apiError
        });
      });
    }
  }, {
    key: 'putCartModifiersPriorities',
    value: function putCartModifiersPriorities(restaurantId, cartModifiersIds) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.PUT_CART_MODIFIERS_PRIORITIES,
        restaurantId: restaurantId,
        cartModifiersIds: cartModifiersIds
      });

      _ApiCartModifier2.default.putCartModifiersPriorities(restaurantId, cartModifiersIds, function (list) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.PUT_CART_MODIFIERS_PRIORITIES_SUCCESS,
          data: list
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleServerAction({
          type: _ActionTypes2.default.PUT_CART_MODIFIERS_PRIORITIES_FAILURE,
          apiError: apiError
        });
      });
    }
  }]);

  return CartModifierAction;
}();

exports.default = CartModifierAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CartModifierAction, 'CartModifierAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/CartModifierAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/DashboardAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _ApiDashboard = __webpack_require__("./sdk/scripts/api/ApiDashboard.js");

var _ApiDashboard2 = _interopRequireDefault(_ApiDashboard);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RestaurantDashboardInfo = __webpack_require__("./sdk/scripts/entities/dashboard/RestaurantDashboardInfo.js");

var _RestaurantDashboardInfo2 = _interopRequireDefault(_RestaurantDashboardInfo);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardAction = function () {
  function DashboardAction() {
    _classCallCheck(this, DashboardAction);
  }

  _createClass(DashboardAction, null, [{
    key: 'loadRestaurantDashboardInfo',


    /**
     *
     */
    value: function loadRestaurantDashboardInfo() {
      _ApiDashboard2.default.getRestaurantDashboard(_SessionStore2.default.getRestaurantId(), DashboardAction.receiveRestaurantDashboardInfo, DashboardAction.receiveRestaurantDashboardInfoError);
    }
  }, {
    key: 'receiveRestaurantDashboardInfo',
    value: function receiveRestaurantDashboardInfo(restaurantDashboardInfo) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_DASHBOARD_RESPONSE_SUCCESS,
        restaurantDashboardInfo: restaurantDashboardInfo
      });
    }
  }, {
    key: 'receiveRestaurantDashboardInfoError',
    value: function receiveRestaurantDashboardInfoError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_DASHBOARD_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return DashboardAction;
}();

exports.default = DashboardAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardAction, 'DashboardAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/DashboardAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/KioskAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _ApiKiosk = __webpack_require__("./sdk/scripts/api/ApiKiosk.js");

var _ApiKiosk2 = _interopRequireDefault(_ApiKiosk);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _KioskSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskSettings.js");

var _KioskSettings2 = _interopRequireDefault(_KioskSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KioskAction = function () {
  function KioskAction() {
    _classCallCheck(this, KioskAction);
  }

  _createClass(KioskAction, null, [{
    key: 'loadSettings',


    //
    // Order settings - GET
    //

    value: function loadSettings() {
      _ApiKiosk2.default.getSettings(_SessionStore2.default.getRestaurantId(), KioskAction.receiveSettings, KioskAction.receiveSettingsError);
    }
  }, {
    key: 'receiveSettings',
    value: function receiveSettings(kioskSettings) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_KIOSK_SETTINGS_SUCCESS,
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: 'receiveSettingsError',
    value: function receiveSettingsError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_KIOSK_SETTINGS_FAILURE,
        apiError: apiError
      });
    }

    //
    // Order settings - UPDATE
    //

  }, {
    key: 'updateSettings',
    value: function updateSettings(kioskSettings, files) {
      _ApiKiosk2.default.putSettings(_SessionStore2.default.getRestaurantId(), kioskSettings, files, KioskAction.receiveUpdatedSettings, KioskAction.receiveUpdatedSettingsError);
    }
  }, {
    key: 'receiveUpdatedSettings',
    value: function receiveUpdatedSettings(kioskSettings) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_KIOSK_SETTINGS_SUCCESS,
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: 'receiveUpdatedSettingsError',
    value: function receiveUpdatedSettingsError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_KIOSK_SETTINGS_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return KioskAction;
}();

exports.default = KioskAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(KioskAction, 'KioskAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/KioskAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/OrderAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _ApiOrder = __webpack_require__("./sdk/scripts/api/ApiOrder.js");

var _ApiOrder2 = _interopRequireDefault(_ApiOrder);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderAction = function () {
  function OrderAction() {
    _classCallCheck(this, OrderAction);
  }

  _createClass(OrderAction, null, [{
    key: 'loadOnGoingOrdersList',


    //
    // orders list on going - GET
    //

    value: function loadOnGoingOrdersList() {
      _ApiOrder2.default.getOrdersOnGoingForRestaurant(_SessionStore2.default.getRestaurantId(), OrderAction.receiveOrdersListByModificationDate, OrderAction.receiveOrdersListByModificationDateError);
    }
  }, {
    key: 'receiveOnGoingOrdersList',
    value: function receiveOnGoingOrdersList(ordersList) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.ON_GOING_ORDERS_LISTRESPONSE_SUCCESS,
        ordersList: ordersList
      });
    }
  }, {
    key: 'receiveOnGoingOrdersListError',
    value: function receiveOnGoingOrdersListError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.ON_GOING_ORDERS_LISTRESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // orders list - GET
    //

  }, {
    key: 'loadOrdersListByModificationDate',
    value: function loadOrdersListByModificationDate(fromTime, toTime) {
      _ApiOrder2.default.getOrdersListByModificationDate(_SessionStore2.default.getRestaurantId(), fromTime, toTime, OrderAction.receiveOrdersListByModificationDate, OrderAction.receiveOrdersListByModificationDateError);
    }
  }, {
    key: 'receiveOrdersListByModificationDate',
    value: function receiveOrdersListByModificationDate(ordersList, fromTime, toTime) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_SUCCESS,
        ordersList: ordersList,
        fromTime: fromTime,
        toTime: toTime
      });
    }
  }, {
    key: 'receiveOrdersListByModificationDateError',
    value: function receiveOrdersListByModificationDateError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // orders history list - GET
    //

  }, {
    key: 'loadOrdersListByDueDate',
    value: function loadOrdersListByDueDate(fromTime, toTime) {
      _ApiOrder2.default.getOrdersListByDueDate(_SessionStore2.default.getRestaurantId(), fromTime, toTime, OrderAction.receiveOrdersListByDueDate, OrderAction.receiveOrdersListByDueDateError);
    }
  }, {
    key: 'receiveOrdersListByDueDate',
    value: function receiveOrdersListByDueDate(ordersList, fromTime, toTime) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_SUCCESS,
        ordersList: ordersList,
        fromTime: fromTime,
        toTime: toTime
      });
    }
  }, {
    key: 'receiveOrdersListByDueDateError',
    value: function receiveOrdersListByDueDateError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // order - UPDATE
    //

  }, {
    key: 'updateOrder',
    value: function updateOrder(order) {
      _ApiOrder2.default.putOrder(order, OrderAction.receiveUpdatedOrder, OrderAction.receiveUpdatedOrderError);
    }
  }, {
    key: 'receiveUpdatedOrder',
    value: function receiveUpdatedOrder(order) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.UPDATE_ORDER_RESPONSE_SUCCESS,
        order: order
      });
    }
  }, {
    key: 'receiveUpdatedOrderError',
    value: function receiveUpdatedOrderError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.UPDATE_ORDER_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // Order settings - GET
    //

  }, {
    key: 'loadOrderSettings',
    value: function loadOrderSettings() {
      _ApiOrder2.default.getOrderSettings(_SessionStore2.default.getRestaurantId(), OrderAction.receiveOrderSettings, OrderAction.receiveOrderSettingsError);
    }
  }, {
    key: 'receiveOrderSettings',
    value: function receiveOrderSettings(orderSettings) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_ORDER_SETTINGS_SUCCESS,
        orderSettings: orderSettings
      });
    }
  }, {
    key: 'receiveOrderSettingsError',
    value: function receiveOrderSettingsError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_ORDER_SETTINGS_FAILURE,
        apiError: apiError
      });
    }

    //
    // Order settings - UPDATE
    //

  }, {
    key: 'updateOrderSettings',
    value: function updateOrderSettings(orderSettings) {
      _ApiOrder2.default.putOrderSettings(_SessionStore2.default.getRestaurantId(), orderSettings, OrderAction.receiveUpdatedOrderSettings, OrderAction.receiveUpdatedOrderSettingsError);
    }
  }, {
    key: 'receiveUpdatedOrderSettings',
    value: function receiveUpdatedOrderSettings(orderSettings) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_ORDER_SETTINGS_SUCCESS,
        orderSettings: orderSettings
      });
    }
  }, {
    key: 'receiveUpdatedOrderSettingsError',
    value: function receiveUpdatedOrderSettingsError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_ORDER_SETTINGS_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return OrderAction;
}();

exports.default = OrderAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderAction, 'OrderAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/OrderAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/PaymentAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ApiPayment = __webpack_require__("./sdk/scripts/api/ApiPayment.js");

var _ApiPayment2 = _interopRequireDefault(_ApiPayment);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PaymentStatistics = __webpack_require__("./sdk/scripts/entities/PaymentStatistics.js");

var _PaymentStatistics2 = _interopRequireDefault(_PaymentStatistics);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _PayinList = __webpack_require__("./sdk/scripts/entities/PayinList.js");

var _PayinList2 = _interopRequireDefault(_PayinList);

var _PayoutList = __webpack_require__("./sdk/scripts/entities/PayoutList.js");

var _PayoutList2 = _interopRequireDefault(_PayoutList);

var _PaymentsList = __webpack_require__("./sdk/scripts/entities/PaymentsList.js");

var _PaymentsList2 = _interopRequireDefault(_PaymentsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentAction = function () {
  function PaymentAction() {
    _classCallCheck(this, PaymentAction);
  }

  _createClass(PaymentAction, null, [{
    key: 'loadStatistics',


    // -- statistics
    value: function loadStatistics(timelapse) {
      _ApiPayment2.default.getStatistics(_SessionStore2.default.getRestaurantId(), timelapse.getFromTimeAsMilliseconds(), timelapse.getToTimeAsMilliseconds(), PaymentAction.receivePaymentStatistics, PaymentAction.receivePaymentStatisticsError);
    }
  }, {
    key: 'receivePaymentStatistics',
    value: function receivePaymentStatistics(paymentStatistics) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PAYMENT_STATISTICS_RESPONSE_SUCCESS,
        paymentStatistics: paymentStatistics
      });
    }
  }, {
    key: 'receivePaymentStatisticsError',
    value: function receivePaymentStatisticsError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PAYMENT_STATISTICS_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // payins
    //

  }, {
    key: 'loadPayins',
    value: function loadPayins(timelapse) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.PAYMENT_PAYINS_RESPONSE_REQUEST
      });

      _ApiPayment2.default.getPayins(_SessionStore2.default.getRestaurantId(), timelapse.getFromTimeAsMilliseconds(), timelapse.getToTimeAsMilliseconds(), PaymentAction.receivePayinsList, PaymentAction.receivePayinsListError);
    }
  }, {
    key: 'receivePayinsList',
    value: function receivePayinsList(payinList) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PAYMENT_PAYINS_RESPONSE_SUCCESS,
        payinList: payinList
      });
    }
  }, {
    key: 'receivePayinsListError',
    value: function receivePayinsListError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PAYMENT_PAYINS_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // payouts
    //

  }, {
    key: 'loadPayouts',
    value: function loadPayouts(timelapse) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.PAYMENT_PAYOUTS_RESPONSE_REQUEST
      });

      _ApiPayment2.default.getPayouts(_SessionStore2.default.getRestaurantId(), timelapse.getFromTimeAsMilliseconds(), timelapse.getToTimeAsMilliseconds(), PaymentAction.receivePayoutsList, PaymentAction.receivePayoutsListError);
    }
  }, {
    key: 'receivePayoutsList',
    value: function receivePayoutsList(payoutList) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PAYMENT_PAYOUTS_RESPONSE_SUCCESS,
        payoutList: payoutList
      });
    }
  }, {
    key: 'receivePayoutsListError',
    value: function receivePayoutsListError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PAYMENT_STATISTICS_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // user payments
    //

  }, {
    key: 'loadUserPayments',
    value: function loadUserPayments(timelapse, userId) {
      _ApiPayment2.default.getUserPaymentsForRestaurant(_SessionStore2.default.getRestaurantId(), timelapse.getFromTimeAsMilliseconds(), timelapse.getToTimeAsMilliseconds(), userId, PaymentAction.receiveUserPaymentsList, PaymentAction.receiveUserPaymentsListError);
    }
  }, {
    key: 'receiveUserPaymentsList',
    value: function receiveUserPaymentsList(paymentsList) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_USER_PAYMENTS_RESPONSE_SUCCESS,
        paymentsList: paymentsList
      });
    }
  }, {
    key: 'receiveUserPaymentsListError',
    value: function receiveUserPaymentsListError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_USER_PAYMENTS_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return PaymentAction;
}();

exports.default = PaymentAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentAction, 'PaymentAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/PaymentAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/ProAccountAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiProAccount = __webpack_require__("./sdk/scripts/api/ApiProAccount.js");

var _ApiProAccount2 = _interopRequireDefault(_ApiProAccount);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProAccountAction = function () {
  function ProAccountAction() {
    _classCallCheck(this, ProAccountAction);
  }

  _createClass(ProAccountAction, null, [{
    key: 'createAccount',


    //
    // Create account
    //

    value: function createAccount(proAccount) {
      _ApiProAccount2.default.postAccount(proAccount, ProAccountAction.receiveCreateAccount, ProAccountAction.receiveCreateAccountError);
    }
  }, {
    key: 'receiveCreateAccount',
    value: function receiveCreateAccount(proAccount) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_CREATE_SUCCESS,
        proAccount: proAccount
      });
    }
  }, {
    key: 'receiveCreateAccountError',
    value: function receiveCreateAccountError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_CREATE_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(email) {
      _ApiProAccount2.default.getRecoverPassword(email, ProAccountAction.forgotPasswordSuccess, ProAccountAction.forgotPasswordError);
    }
  }, {
    key: 'forgotPasswordSuccess',
    value: function forgotPasswordSuccess(data) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_FORGOT_PASSWORD_SUCCESS,
        data: data
      });
    }
  }, {
    key: 'forgotPasswordError',
    value: function forgotPasswordError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_FORGOT_PASSWORD_FAILURE,
        apiError: apiError
      });
    }

    //
    // Retrieve account
    //

  }, {
    key: 'retrieveMeAccount',
    value: function retrieveMeAccount() {
      var domainId = _stores.ProAccountStore.getSelectedProDomainId();

      if (_lodash2.default.isNil(domainId)) {
        domainId = _stores.SessionStore.getProDomainId();
      }

      var restaurantId = _stores.RestaurantStore.getRestaurantId();

      if (_lodash2.default.isNil(restaurantId)) {
        restaurantId = _stores.SessionStore.getRestaurantId();
      }

      _ApiProAccount2.default.getAccountData(domainId, restaurantId, ProAccountAction.receiveRetrieveMeAccount, ProAccountAction.receiveRetrieveMeAccountError);
    }
  }, {
    key: 'receiveRetrieveMeAccount',
    value: function receiveRetrieveMeAccount(proAccount, restaurant, proDomain) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_GET_ME_SUCCESS,
        proAccount: proAccount,
        restaurant: restaurant,
        proDomain: proDomain
      });
    }
  }, {
    key: 'receiveRetrieveMeAccountError',
    value: function receiveRetrieveMeAccountError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_GET_ME_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'retrieveAccount',
    value: function retrieveAccount(accountId) {
      _ApiProAccount2.default.getAccount(accountId, ProAccountAction.receiveRetrieveAccount, ProAccountAction.receiveRetrieveAccountError);
    }
  }, {
    key: 'receiveRetrieveAccount',
    value: function receiveRetrieveAccount(proAccount) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_GET_SUCCESS,
        proAccount: proAccount
      });
    }
  }, {
    key: 'receiveRetrieveAccountError',
    value: function receiveRetrieveAccountError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_GET_FAILURE,
        apiError: apiError
      });
    }

    //
    // Update account
    //

  }, {
    key: 'updateAccount',
    value: function updateAccount(proAccount) {
      _ApiProAccount2.default.putAccount(proAccount, ProAccountAction.receiveUpdateAccount, ProAccountAction.receiveUpdateAccountError);
    }
  }, {
    key: 'receiveUpdateAccount',
    value: function receiveUpdateAccount(proAccount) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_UPDATE_SUCCESS,
        proAccount: proAccount
      });
    }
  }, {
    key: 'receiveUpdateAccountError',
    value: function receiveUpdateAccountError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_CREATE_FAILURE,
        apiError: apiError
      });
    }

    //
    // Delete account
    //

  }, {
    key: 'deleteAccount',
    value: function deleteAccount(proAccount) {
      _ApiProAccount2.default.deleteAccount(proAccount, ProAccountAction.receiveDeleteAccount, ProAccountAction.receiveDeleteAccountError);
    }
  }, {
    key: 'receiveDeleteAccount',
    value: function receiveDeleteAccount(proAccount) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_DELETE_SUCCESS,
        proAccount: proAccount
      });
    }
  }, {
    key: 'receiveDeleteAccountError',
    value: function receiveDeleteAccountError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_DELETE_FAILURE,
        apiError: apiError
      });
    }

    //
    // Retrieve domains
    //

  }, {
    key: 'retrieveAccountDomains',
    value: function retrieveAccountDomains(proAccount) {
      var loadRole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var loadRestaurantsGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var loadRestaurantsGroupChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      _ApiProAccount2.default.getAccountDomains(proAccount, loadRole, loadRestaurantsGroup, loadRestaurantsGroupChildren, ProAccountAction.receiveAccountDomains, ProAccountAction.receiveAccountDomainsError);
    }
  }, {
    key: 'receiveAccountDomains',
    value: function receiveAccountDomains(proAccount, proDomainsList) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_GET_DOMAINS_SUCCESS,
        proAccount: proAccount,
        proDomainsList: proDomainsList
      });
    }
  }, {
    key: 'receiveAccountDomainsError',
    value: function receiveAccountDomainsError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ACCOUNT_GET_DOMAINS_FAILURE,
        apiError: apiError
      });
    }

    //
    //
    //

  }, {
    key: 'changeProDomain',
    value: function changeProDomain(proDomain) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.CHANGE_PRO_DOMAIN,
        proDomain: proDomain
      });
    }
  }]);

  return ProAccountAction;
}();

exports.default = ProAccountAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProAccountAction, 'ProAccountAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/ProAccountAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/RestaurantAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiRestaurant = __webpack_require__("./sdk/scripts/api/ApiRestaurant.js");

var _ApiRestaurant2 = _interopRequireDefault(_ApiRestaurant);

var _ApiRole = __webpack_require__("./sdk/scripts/api/ApiRole.js");

var _ApiRole2 = _interopRequireDefault(_ApiRole);

var _ApiRestaurantsGroup = __webpack_require__("./sdk/scripts/api/ApiRestaurantsGroup.js");

var _ApiRestaurantsGroup2 = _interopRequireDefault(_ApiRestaurantsGroup);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * TODO: Move restaurantsGroup and roles to own actions.
 */
var RestaurantAction = function () {
  function RestaurantAction() {
    _classCallCheck(this, RestaurantAction);
  }

  _createClass(RestaurantAction, null, [{
    key: 'retrieveCurrentRestaurant',
    value: function retrieveCurrentRestaurant() {
      this.retrieveRestaurant(_stores.RestaurantStore.getRestaurantId());
    }
  }, {
    key: 'retrieveRestaurant',
    value: function retrieveRestaurant(restaurantId) {
      _ApiRestaurant2.default.getRestaurant(restaurantId, RestaurantAction.receiveRestaurant, RestaurantAction.receiveRestaurantError);
    }
  }, {
    key: 'receiveRestaurant',
    value: function receiveRestaurant(restaurant) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_SUCCESS,
        restaurant: restaurant
      });
    }
  }, {
    key: 'receiveRestaurantError',
    value: function receiveRestaurantError(apiError) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_FAILURE,
        apiError: apiError
      });
    }

    //
    //
    //

  }, {
    key: 'retrieveRestaurantForGroup',
    value: function retrieveRestaurantForGroup(restaurant, restaurantsGroup) {
      // Do not remove
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST
      });
      _ApiRestaurant2.default.getRestaurantForGroup(restaurant.id, restaurantsGroup, RestaurantAction.receiveRestaurantForGroup, RestaurantAction.receiveRestaurantForGroupError);
    }
  }, {
    key: 'receiveRestaurantForGroup',
    value: function receiveRestaurantForGroup(restaurant, restaurantsGroup) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_SUCCESS,
        restaurant: restaurant,
        restaurantsGroup: restaurantsGroup
      });
    }
  }, {
    key: 'receiveRestaurantForGroupError',
    value: function receiveRestaurantForGroupError(apiError) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_FAILURE,
        apiError: apiError
      });
    }

    //
    // Create
    //

  }, {
    key: 'createRestaurant',
    value: function createRestaurant(restaurant) {
      _ApiRestaurant2.default.postRestaurant(restaurant,
      // Once the restaurant is created, we have to reload the main restaurants group.
      function (restaurant) {
        _ApiRestaurantsGroup2.default.getRestaurantsGroup(_stores.RestaurantStore.getRestaurantsGroup().id, true, function (restaurantsGroup) {
          RestaurantAction.receiveCreatedRestaurant(restaurant, restaurantsGroup);
        }, RestaurantAction.receiveCreatedRestaurantError);
      }, RestaurantAction.receiveCreatedRestaurantError);
    }
  }, {
    key: 'receiveCreatedRestaurant',
    value: function receiveCreatedRestaurant(restaurant, restaurantsGroup) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_RESPONSE_SUCCESS,
        restaurant: restaurant,
        restaurantsGroup: restaurantsGroup
      });
    }
  }, {
    key: 'receiveCreatedRestaurantError',
    value: function receiveCreatedRestaurantError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // update
    //

  }, {
    key: 'updateRestaurant',
    value: function updateRestaurant(restaurantMultipart) {
      _ApiRestaurant2.default.putRestaurantMultipart(_stores.RestaurantStore.getRestaurantId(), restaurantMultipart, RestaurantAction.receiveUpdateRestaurant, RestaurantAction.receiveUpdateRestaurantError);
    }
  }, {
    key: 'receiveUpdateRestaurant',
    value: function receiveUpdateRestaurant(restaurant) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS,
        restaurant: restaurant
      });
    }
  }, {
    key: 'receiveUpdateRestaurantError',
    value: function receiveUpdateRestaurantError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MULTIPART_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // RestaurantsGroup - retrieve
    //

  }, {
    key: 'retrieveRestaurantsGroup',
    value: function retrieveRestaurantsGroup(restaurantsGroupId) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANTS_GROUP
      });
      _ApiRestaurantsGroup2.default.getRestaurantsGroup(restaurantsGroupId, true, RestaurantAction.receiveRestaurantsGroup, RestaurantAction.receiveRestaurantsGroupError);
    }
  }, {
    key: 'receiveRestaurantsGroup',
    value: function receiveRestaurantsGroup(restaurantsGroup) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANTS_GROUP_SUCCESS,
        restaurantsGroup: restaurantsGroup
      });
    }
  }, {
    key: 'receiveRestaurantsGroupError',
    value: function receiveRestaurantsGroupError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANTS_GROUP_FAILURE,
        apiError: apiError
      });
    }

    //
    // RestaurantsGroup - create
    //

  }, {
    key: 'createRestaurantsGroup',
    value: function createRestaurantsGroup(restaurantsGroup) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.POST_RESTAURANTS_GROUP,
        restaurantsGroup: restaurantsGroup
      });

      _ApiRestaurantsGroup2.default.postRestaurantsGroup(restaurantsGroup, RestaurantAction.receiveCreatedRestaurantsGroup, RestaurantAction.receiveCreatedRestaurantsGroupError);
    }
  }, {
    key: 'receiveCreatedRestaurantsGroup',
    value: function receiveCreatedRestaurantsGroup(restaurantsGroup) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANTS_GROUP_SUCCESS,
        restaurantsGroup: restaurantsGroup
      });
    }
  }, {
    key: 'receiveCreatedRestaurantsGroupError',
    value: function receiveCreatedRestaurantsGroupError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANTS_GROUP_FAILURE,
        apiError: apiError
      });
    }

    //
    // RestaurantsGroup - update
    //

  }, {
    key: 'updateRestaurantsGroup',
    value: function updateRestaurantsGroup(restaurantsGroup) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.PUT_RESTAURANTS_GROUP,
        restaurantsGroup: restaurantsGroup
      });

      _ApiRestaurantsGroup2.default.putRestaurantsGroup(restaurantsGroup, RestaurantAction.receiveUpdatedRestaurantsGroup, RestaurantAction.receiveUpdatedRestaurantsGroupError);
    }
  }, {
    key: 'receiveUpdatedRestaurantsGroup',
    value: function receiveUpdatedRestaurantsGroup(restaurantsGroup) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANTS_GROUP_SUCCESS,
        restaurantsGroup: restaurantsGroup
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantsGroupError',
    value: function receiveUpdatedRestaurantsGroupError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANTS_GROUP_FAILURE,
        apiError: apiError
      });
    }

    //
    // Restaurant group roles
    //

  }, {
    key: 'retrieveRestaurantsGroupRoles',
    value: function retrieveRestaurantsGroupRoles(restaurantsGroupId) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_ROLES,
        restaurantsGroupId: restaurantsGroupId
      });

      _ApiRole2.default.getRestaurantsGroupRoles(restaurantsGroupId, RestaurantAction.receiveRestaurantsGroupRoles, RestaurantAction.receiveRestaurantGroupRolesError);
    }
  }, {
    key: 'receiveRestaurantsGroupRoles',
    value: function receiveRestaurantsGroupRoles(proRolesList) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_ROLES_SUCCESS,
        proRolesList: proRolesList
      });
    }
  }, {
    key: 'receiveRestaurantGroupRolesError',
    value: function receiveRestaurantGroupRolesError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_ROLES_FAILURE,
        apiError: apiError
      });
    }

    //
    // Update role
    //

  }, {
    key: 'updateRole',
    value: function updateRole(proRole) {
      _ApiRole2.default.putRole(proRole, RestaurantAction.receiveUpdateRole, RestaurantAction.receiveUpdateRoleError);
    }
  }, {
    key: 'receiveUpdateRole',
    value: function receiveUpdateRole(proRole) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_ROLE_RESPONSE_SUCCESS,
        proRole: proRole
      });
    }
  }, {
    key: 'receiveUpdateRoleError',
    value: function receiveUpdateRoleError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_ROLE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // Create role
    //

  }, {
    key: 'createRole',
    value: function createRole(proRole) {
      _ApiRole2.default.postRole(proRole, RestaurantAction.receiveCreateRole, RestaurantAction.receiveCreateRoleError);
    }
  }, {
    key: 'receiveCreateRole',
    value: function receiveCreateRole(proRole) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_ROLE_RESPONSE_SUCCESS,
        proRole: proRole
      });
    }
  }, {
    key: 'receiveCreateRoleError',
    value: function receiveCreateRoleError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_ROLE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // Delete role
    //

  }, {
    key: 'deleteRole',
    value: function deleteRole(proRole) {
      _ApiRole2.default.deleteRole(proRole, RestaurantAction.receiveDeleteRole, RestaurantAction.receiveDeleteRoleError);
    }
  }, {
    key: 'receiveDeleteRole',
    value: function receiveDeleteRole(proRole) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_ROLE_RESPONSE_SUCCESS,
        proRole: proRole
      });
    }
  }, {
    key: 'receiveDeleteRoleError',
    value: function receiveDeleteRoleError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_ROLE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return RestaurantAction;
}();

exports.default = RestaurantAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantAction, 'RestaurantAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/RestaurantAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/RestaurantMenuAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- constants


// -- stores


// -- entities


var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ApiRestaurantMenu = __webpack_require__("./sdk/scripts/api/ApiRestaurantMenu.js");

var _ApiRestaurantMenu2 = _interopRequireDefault(_ApiRestaurantMenu);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _RouteStore = __webpack_require__("./scripts/stores/RouteStore.js");

var _RouteStore2 = _interopRequireDefault(_RouteStore);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RestaurantMenuAction = function () {
  function RestaurantMenuAction() {
    _classCallCheck(this, RestaurantMenuAction);
  }

  _createClass(RestaurantMenuAction, null, [{
    key: 'loadRestaurantMenu',

    //
    // RestaurantMenu - Load
    //

    value: function loadRestaurantMenu() {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_RESTAURANT_MENU
      });

      _ApiRestaurantMenu2.default.getLocalMenu(_SessionStore2.default.getRestaurantId(), RestaurantMenuAction.receiveRestaurantMenu, RestaurantMenuAction.receiveRestaurantMenuError);
    }
  }, {
    key: 'receiveRestaurantMenu',
    value: function receiveRestaurantMenu(restaurantMenu) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_MENU_RESPONSE_SUCCESS,
        restaurantMenu: restaurantMenu
      });
    }
  }, {
    key: 'receiveRestaurantMenuError',
    value: function receiveRestaurantMenuError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_MENU_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // RestaurantMenu - Load force refrsh
    //

  }, {
    key: 'loadRestaurantMenuWithSynchronization',
    value: function loadRestaurantMenuWithSynchronization() {
      // To test error handling
      // const apiError = new ApiError();
      // RestaurantMenuAction.receiveRestaurantMenuError(apiError);
      // return;

      _ApiRestaurantMenu2.default.getMenuWithSynchronization(_SessionStore2.default.getRestaurantId(), RestaurantMenuAction.receiveRestaurantMenuWithSynchronization, RestaurantMenuAction.receiveRestaurantMenuError);
    }
  }, {
    key: 'receiveRestaurantMenuWithSynchronization',
    value: function receiveRestaurantMenuWithSynchronization(restaurantMenu) {
      // updating the data on our restaurant menu pages is too complicated, we reload the whole page
      location.reload();
      // AppDispatcher.handleViewAction({
      //   type:
      //     ActionTypes.GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_SUCCESS,
      //   restaurantMenu,
      // });
    }
  }, {
    key: 'receiveRestaurantMenuWithSynchronizationError',
    value: function receiveRestaurantMenuWithSynchronizationError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    //  RestaurantMenu - Update
    //

  }, {
    key: 'saveRestaurantMenu',
    value: function saveRestaurantMenu(restaurantMenu) {
      _ApiRestaurantMenu2.default.putMenu(_SessionStore2.default.getRestaurantId(), restaurantMenu, RestaurantMenuAction.receiveUpdatedRestaurantMenu, RestaurantMenuAction.receiveUpdatedRestaurantMenuError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenu',
    value: function receiveUpdatedRestaurantMenu(restaurantMenu) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_RESPONSE_SUCCESS,
        restaurantMenu: restaurantMenu
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuError',
    value: function receiveUpdatedRestaurantMenuError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // PRODUCT - UPDATE
    //

  }, {
    key: 'saveProduct',
    value: function saveProduct(product, image) {
      _ApiRestaurantMenu2.default.putMenuProduct(_SessionStore2.default.getRestaurantId(), product, image, RestaurantMenuAction.receiveUpdatedRestaurantMenuProduct, RestaurantMenuAction.receiveUpdatedRestaurantMenuProductError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuProduct',
    value: function receiveUpdatedRestaurantMenuProduct(product) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS,
        product: product
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuProductError',
    value: function receiveUpdatedRestaurantMenuProductError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'deleteProductImage',
    value: function deleteProductImage(product) {
      _ApiRestaurantMenu2.default.deleteMenuProductImage(_SessionStore2.default.getRestaurantId(), product, RestaurantMenuAction.receiveDeletedProductImage, RestaurantMenuAction.receiveDeletedProductImageError);
    }
  }, {
    key: 'receiveDeletedProductImage',
    value: function receiveDeletedProductImage(product) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS,
        product: product
      });
    }
  }, {
    key: 'receiveDeletedProductImageError',
    value: function receiveDeletedProductImageError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // PRODUCT - CREATE
    //

  }, {
    key: 'createProduct',
    value: function createProduct(product, image) {
      _ApiRestaurantMenu2.default.postMenuProduct(_SessionStore2.default.getRestaurantId(), product, image, RestaurantMenuAction.receiveCreatedRestaurantMenuProduct, RestaurantMenuAction.receiveCreatedRestaurantMenuProductError);
    }
  }, {
    key: 'receiveCreatedRestaurantMenuProduct',
    value: function receiveCreatedRestaurantMenuProduct(product) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS,
        product: product
      });
    }
  }, {
    key: 'receiveCreatedRestaurantMenuProductError',
    value: function receiveCreatedRestaurantMenuProductError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // PRODUCT - DELETE
    //

  }, {
    key: 'deleteProduct',
    value: function deleteProduct(product) {
      _ApiRestaurantMenu2.default.deleteMenuProduct(_SessionStore2.default.getRestaurantId(), product, RestaurantMenuAction.receiveDeletedRestaurantMenuProduct, RestaurantMenuAction.receiveDeletedRestaurantMenuProductError);
    }
  }, {
    key: 'receiveDeletedRestaurantMenuProduct',
    value: function receiveDeletedRestaurantMenuProduct(product) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS,
        product: product
      });
    }
  }, {
    key: 'receiveDeletedRestaurantMenuProductError',
    value: function receiveDeletedRestaurantMenuProductError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // MENU - UPDATE
    //

  }, {
    key: 'saveMenu',
    value: function saveMenu(menu, image) {
      _ApiRestaurantMenu2.default.putMenuMenu(_SessionStore2.default.getRestaurantId(), menu, image, RestaurantMenuAction.receiveUpdatedRestaurantMenuMenu, RestaurantMenuAction.receiveUpdatedRestaurantMenuMenuError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuMenu',
    value: function receiveUpdatedRestaurantMenuMenu(menu) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS,
        menu: menu
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuMenuError',
    value: function receiveUpdatedRestaurantMenuMenuError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'deleteMenuImage',
    value: function deleteMenuImage(menu) {
      _ApiRestaurantMenu2.default.deleteMenuMenuImage(_SessionStore2.default.getRestaurantId(), menu, RestaurantMenuAction.receiveDeletedRestaurantMenuMenuImage, RestaurantMenuAction.receiveDeletedRestaurantMenuMenuImageError);
    }
  }, {
    key: 'receiveDeletedRestaurantMenuMenuImage',
    value: function receiveDeletedRestaurantMenuMenuImage(menu) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_SUCCESS,
        menu: menu
      });
    }
  }, {
    key: 'receiveDeletedRestaurantMenuMenuImageError',
    value: function receiveDeletedRestaurantMenuMenuImageError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // MENU - CREATE
    //

  }, {
    key: 'createMenu',
    value: function createMenu(menu, image) {
      _ApiRestaurantMenu2.default.postMenuMenu(_SessionStore2.default.getRestaurantId(), menu, image, RestaurantMenuAction.receiveCreatedRestaurantMenuMenu, RestaurantMenuAction.receiveCreatedRestaurantMenuMenuError);
    }
  }, {
    key: 'receiveCreatedRestaurantMenuMenu',
    value: function receiveCreatedRestaurantMenuMenu(menu) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS,
        menu: menu
      });
    }
  }, {
    key: 'receiveCreatedRestaurantMenuMenuError',
    value: function receiveCreatedRestaurantMenuMenuError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_MENU_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // MENU - DELETE
    //

  }, {
    key: 'deleteMenu',
    value: function deleteMenu(menu) {
      _ApiRestaurantMenu2.default.deleteMenuMenu(_SessionStore2.default.getRestaurantId(), menu, RestaurantMenuAction.receiveDeletedRestaurantMenuMenu, RestaurantMenuAction.receiveDeletedRestaurantMenuMenuError);
    }
  }, {
    key: 'receiveDeletedRestaurantMenuMenu',
    value: function receiveDeletedRestaurantMenuMenu(menu) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS,
        menu: menu
      });
    }
  }, {
    key: 'receiveDeletedRestaurantMenuMenuError',
    value: function receiveDeletedRestaurantMenuMenuError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // MenuPart - UPDATE
    //

  }, {
    key: 'updateMenuPart',
    value: function updateMenuPart(menu, menuPart) {
      _ApiRestaurantMenu2.default.updateMenuPart(_SessionStore2.default.getRestaurantId(), menu, menuPart, function (updatedMenuPart) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_SUCCESS,
          menuId: menu.id,
          menuPart: updatedMenuPart
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_FAILURE,
          apiError: apiError
        });
      });
    }

    //
    // MenuPartCategory - UPDATE
    //

  }, {
    key: 'updateMenuPartCategory',
    value: function updateMenuPartCategory(menu, menuPart, menuPartCategory) {
      _ApiRestaurantMenu2.default.updateMenuPartCategory(_SessionStore2.default.getRestaurantId(), menu, menuPart, menuPartCategory, function (updatedMenuPartCategory) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
          menuId: menu.id,
          menuPartId: menuPart.id,
          category: updatedMenuPartCategory
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE,
          apiError: apiError
        });
      });
    }
  }, {
    key: 'uploadMenuPartCategoryImage',
    value: function uploadMenuPartCategoryImage(menu, menuPart, menuPartCategory, image) {
      _ApiRestaurantMenu2.default.uploadMenuPartCategoryImage(_SessionStore2.default.getRestaurantId(), menu, menuPart, menuPartCategory, _ViewUtils2.default.dataUriToFile(image), function (updatedMenuPartCategory) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
          menuId: menu.id,
          menuPartId: menuPart.id,
          category: updatedMenuPartCategory
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE,
          apiError: apiError
        });
      });
    }
  }, {
    key: 'removeMenuPartCategoryImage',
    value: function removeMenuPartCategoryImage(menu, menuPart, menuPartCategory) {
      _ApiRestaurantMenu2.default.removeMenuPartCategoryImage(_SessionStore2.default.getRestaurantId(), menu, menuPart, menuPartCategory, function (updatedMenuPartCategory) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
          menuId: menu.id,
          menuPartId: menuPart.id,
          category: updatedMenuPartCategory
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE,
          apiError: apiError
        });
      });
    }

    //
    // MenuPartCategory - DELETE
    //

  }, {
    key: 'deleteMenuPartCategory',
    value: function deleteMenuPartCategory(menu, menuPart, menuPartCategory) {
      _ApiRestaurantMenu2.default.deleteMenuPartCategory(_SessionStore2.default.getRestaurantId(), menu, menuPart, menuPartCategory, function () {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
          menuId: menu.id,
          menuPartId: menuPart.id,
          category: menuPartCategory
        });
      }, function (apiError) {
        _AppDispatcher2.default.handleViewAction({
          type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE,
          apiError: apiError
        });
      });
    }

    //
    // CATEGORY - UPDATE
    //

  }, {
    key: 'saveCategory',
    value: function saveCategory(category, image) {
      _ApiRestaurantMenu2.default.putMenuCategory(_SessionStore2.default.getRestaurantId(), category, image, RestaurantMenuAction.receiveUpdatedRestaurantMenuCategory, RestaurantMenuAction.receiveUpdatedRestaurantMenuCategoryError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuCategory',
    value: function receiveUpdatedRestaurantMenuCategory(category) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS,
        category: category
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuCategoryError',
    value: function receiveUpdatedRestaurantMenuCategoryError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'deleteCategoryImage',
    value: function deleteCategoryImage(category) {
      _ApiRestaurantMenu2.default.deleteMenuCategoryImage(_SessionStore2.default.getRestaurantId(), category, RestaurantMenuAction.receiveUpdatedRestaurantMenuCategoryImage, RestaurantMenuAction.receiveUpdatedRestaurantMenuCategoryImageError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuCategoryImage',
    value: function receiveUpdatedRestaurantMenuCategoryImage(category) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS,
        category: category
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuCategoryImageError',
    value: function receiveUpdatedRestaurantMenuCategoryImageError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // CATEGORY - CREATE
    //

  }, {
    key: 'createCategory',
    value: function createCategory(category, image) {
      _ApiRestaurantMenu2.default.postMenuCategory(_SessionStore2.default.getRestaurantId(), category, image, RestaurantMenuAction.receiveCreatedRestaurantMenuCategory, RestaurantMenuAction.receiveCreatedRestaurantMenuCategoryError);
    }
  }, {
    key: 'receiveCreatedRestaurantMenuCategory',
    value: function receiveCreatedRestaurantMenuCategory(category) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS,
        category: category
      });
    }
  }, {
    key: 'receiveCreatedRestaurantMenuCategoryError',
    value: function receiveCreatedRestaurantMenuCategoryError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // CATEGORY - DELETE
    //

  }, {
    key: 'deleteCategory',
    value: function deleteCategory(category, image) {
      _ApiRestaurantMenu2.default.deleteMenuCategory(_SessionStore2.default.getRestaurantId(), category, image, RestaurantMenuAction.receiveDeletedRestaurantMenuCategory, RestaurantMenuAction.receiveDeletedRestaurantMenuCategoryError);
    }
  }, {
    key: 'receiveDeletedRestaurantMenuCategory',
    value: function receiveDeletedRestaurantMenuCategory(category) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS,
        category: category
      });
    }
  }, {
    key: 'receiveDeletedRestaurantMenuCategoryError',
    value: function receiveDeletedRestaurantMenuCategoryError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // PRODUCT OPTION - UPDATE
    //

  }, {
    key: 'saveProductOption',
    value: function saveProductOption(productOption, image) {
      _ApiRestaurantMenu2.default.putMenuProductOption(_SessionStore2.default.getRestaurantId(), productOption, image, RestaurantMenuAction.receiveUpdatedRestaurantMenuProductOption, RestaurantMenuAction.receiveUpdatedRestaurantMenuProductOptionError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuProductOption',
    value: function receiveUpdatedRestaurantMenuProductOption(productOption) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS,
        productOption: productOption
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuProductOptionError',
    value: function receiveUpdatedRestaurantMenuProductOptionError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'deleteProductOptionImage',
    value: function deleteProductOptionImage(productOption) {
      _ApiRestaurantMenu2.default.deleteMenuProductOptionImage(_SessionStore2.default.getRestaurantId(), productOption, RestaurantMenuAction.receiveUpdatedRestaurantMenuProductOptionImage, RestaurantMenuAction.receiveUpdatedRestaurantMenuProductOptionImageError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuProductOptionImage',
    value: function receiveUpdatedRestaurantMenuProductOptionImage(productOption) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS,
        productOption: productOption
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuProductOptionImageError',
    value: function receiveUpdatedRestaurantMenuProductOptionImageError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_FAILURE,
        apiError: apiError
      });
    }

    //
    // PRODUCT OPTION - CREATE
    //

  }, {
    key: 'createProductOption',
    value: function createProductOption(productOption, image) {
      _ApiRestaurantMenu2.default.postMenuProductOption(_SessionStore2.default.getRestaurantId(), productOption, image, RestaurantMenuAction.receiveCreatedRestaurantMenuProductOption, RestaurantMenuAction.receiveCreatedRestaurantMenuProductOptionError);
    }
  }, {
    key: 'receiveCreatedRestaurantMenuProductOption',
    value: function receiveCreatedRestaurantMenuProductOption(productOption) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS,
        productOption: productOption
      });
    }
  }, {
    key: 'receiveCreatedRestaurantMenuProductOptionError',
    value: function receiveCreatedRestaurantMenuProductOptionError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE,
        apiError: apiError
      });
    }

    //
    // PRODUCT OPTION - DELETE
    //

  }, {
    key: 'deleteProductOption',
    value: function deleteProductOption(productOption) {
      _ApiRestaurantMenu2.default.deleteMenuProductOption(_SessionStore2.default.getRestaurantId(), productOption, RestaurantMenuAction.receiveDeletedRestaurantMenuProductOption, RestaurantMenuAction.receiveDeletedRestaurantMenuProductOptionError);
    }
  }, {
    key: 'receiveDeletedRestaurantMenuProductOption',
    value: function receiveDeletedRestaurantMenuProductOption(productOption) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS,
        productOption: productOption
      });
    }
  }, {
    key: 'receiveDeletedRestaurantMenuProductOptionError',
    value: function receiveDeletedRestaurantMenuProductOptionError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE,
        apiError: apiError
      });
    }

    //
    // CATEGORY - UPDATE
    //

  }, {
    key: 'saveUpsellingCategory',
    value: function saveUpsellingCategory(upsellingCategory, image) {
      _ApiRestaurantMenu2.default.putMenuUpsellingCategory(_SessionStore2.default.getRestaurantId(), upsellingCategory, image, RestaurantMenuAction.receiveUpdatedRestaurantMenuUpsellingCategory, RestaurantMenuAction.receiveUpdatedRestaurantMenuUpsellingCategoryError);
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuUpsellingCategory',
    value: function receiveUpdatedRestaurantMenuUpsellingCategory(upsellingCategory) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS,
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: 'receiveUpdatedRestaurantMenuUpsellingCategoryError',
    value: function receiveUpdatedRestaurantMenuUpsellingCategoryError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // CATEGORY - CREATE
    //

  }, {
    key: 'createUpsellingCategory',
    value: function createUpsellingCategory(upsellingCategory, image) {
      _ApiRestaurantMenu2.default.postMenuUpsellingCategory(_SessionStore2.default.getRestaurantId(), upsellingCategory, image, RestaurantMenuAction.receiveCreatedRestaurantMenuUpsellingCategory, RestaurantMenuAction.receiveCreatedRestaurantMenuUpsellingCategoryError);
    }
  }, {
    key: 'receiveCreatedRestaurantMenuUpsellingCategory',
    value: function receiveCreatedRestaurantMenuUpsellingCategory(upsellingCategory) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS,
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: 'receiveCreatedRestaurantMenuUpsellingCategoryError',
    value: function receiveCreatedRestaurantMenuUpsellingCategoryError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // CATEGORY - DELETE
    //

  }, {
    key: 'deleteUpsellingCategory',
    value: function deleteUpsellingCategory(upsellingCategory, image) {
      _ApiRestaurantMenu2.default.deleteMenuUpsellingCategory(_SessionStore2.default.getRestaurantId(), upsellingCategory, image, RestaurantMenuAction.receiveDeletedRestaurantMenuUpsellingCategory, RestaurantMenuAction.receiveDeletedRestaurantMenuUpsellingCategoryError);
    }
  }, {
    key: 'receiveDeletedRestaurantMenuUpsellingCategory',
    value: function receiveDeletedRestaurantMenuUpsellingCategory(upsellingCategory) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS,
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: 'receiveDeletedRestaurantMenuUpsellingCategoryError',
    value: function receiveDeletedRestaurantMenuUpsellingCategoryError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return RestaurantMenuAction;
}();

exports.default = RestaurantMenuAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantMenuAction, 'RestaurantMenuAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/RestaurantMenuAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/RestaurantsGroupAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiRestaurantsGroup = __webpack_require__("./sdk/scripts/api/ApiRestaurantsGroup.js");

var _ApiRestaurantsGroup2 = _interopRequireDefault(_ApiRestaurantsGroup);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RestaurantsGroupAction = function () {
  function RestaurantsGroupAction() {
    _classCallCheck(this, RestaurantsGroupAction);
  }

  _createClass(RestaurantsGroupAction, null, [{
    key: 'loadApiConsumers',
    value: function loadApiConsumers(restaurantsGroupId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_API_CONSUMERS
      });

      _ApiRestaurantsGroup2.default.getApiConsumers(restaurantsGroupId, options, RestaurantsGroupAction.receiveApiConsumers, RestaurantsGroupAction.receiveApiConsumersError);
    }
  }, {
    key: 'receiveApiConsumers',
    value: function receiveApiConsumers(data) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_API_CONSUMERS_SUCCESS,
        data: data
      });
    }
  }, {
    key: 'receiveApiConsumersError',
    value: function receiveApiConsumersError(apiError) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_API_CONSUMERS_FAILURE,
        apiError: apiError
      });
    }
  }, {
    key: 'loadOrderStatistics',
    value: function loadOrderStatistics(restaurantsGroupId, timelapse, modes, sourcesList, paymentMethods, restaurantsIds) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_ORDER_STATISTICS
      });

      _ApiRestaurantsGroup2.default.getOrderStatistics(restaurantsGroupId, timelapse.getFromTimeAsMilliseconds(), timelapse.getToTimeAsMilliseconds(), modes, sourcesList, paymentMethods, restaurantsIds, RestaurantsGroupAction.receiveOrderStatistics, RestaurantsGroupAction.receiveOrderStatisticsError);
    }
  }, {
    key: 'receiveOrderStatistics',
    value: function receiveOrderStatistics(data) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_ORDER_STATISTICS_SUCCESS,
        data: data
      });
    }
  }, {
    key: 'receiveOrderStatisticsError',
    value: function receiveOrderStatisticsError(apiError) {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.GET_ORDER_STATISTICS_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return RestaurantsGroupAction;
}();

exports.default = RestaurantsGroupAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantsGroupAction, 'RestaurantsGroupAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/RestaurantsGroupAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/RouteAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _Route = __webpack_require__("./sdk/scripts/flux/Route.js");

var _Route2 = _interopRequireDefault(_Route);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _RouteStore = __webpack_require__("./scripts/stores/RouteStore.js");

var _RouteStore2 = _interopRequireDefault(_RouteStore);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RouteAction = function () {
  function RouteAction() {
    _classCallCheck(this, RouteAction);
  }

  _createClass(RouteAction, null, [{
    key: 'redirect',


    /**
     * TODO: replace by redirectForce in order to avoid already in dispatch errors.
     */
    value: function redirect(route) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.REDIRECT,
        route: route,
        params: params,
        query: query
      });
    }
  }, {
    key: 'redirectForce',
    value: function redirectForce(route) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      _RouteStore2.default.redirectTo(route, params, query);
    }
  }, {
    key: 'redirectTo',
    value: function redirectTo(route) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.redirect(route, params, query);
    }
  }, {
    key: 'redirectToFeatureNonActivated',
    value: function redirectToFeatureNonActivated() {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.REDIRECT,
        route: _RoutingEnum2.default.FEATURE_NON_ACTIVATED
      });
    }
  }, {
    key: 'updateQueryParams',
    value: function updateQueryParams(queryParams) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.QUERY_PARAMS_UPDATE,
        queryParams: queryParams
      });
    }

    //
    // Restaurant menu
    //

  }, {
    key: 'presentMenuDetail',
    value: function presentMenuDetail(menu) {
      var route = _RoutingEnum2.default.RESTAURANT_MENU_MENU_DETAIL;
      _RouteStore2.default.redirectTo(route, { menuId: menu.id });
    }
  }, {
    key: 'presentProductOptionDetail',
    value: function presentProductOptionDetail(productOption) {
      var route = _RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_OPTION_DETAIL;
      _RouteStore2.default.redirectTo(route, { productOptionId: productOption.id });
    }
  }, {
    key: 'presentProductEdit',
    value: function presentProductEdit(product) {
      var route = _RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_EDIT;
      _RouteStore2.default.redirectTo(route, { productId: product.id });
    }
  }, {
    key: 'presentCategoryDetail',
    value: function presentCategoryDetail(category) {
      var route = _RoutingEnum2.default.RESTAURANT_MENU_CATEGORY_DETAIL;
      _RouteStore2.default.redirectTo(route, { categoryId: category.id });
    }
  }, {
    key: 'presentMenusTab',
    value: function presentMenusTab() {
      var route = _RoutingEnum2.default.RESTAURANT_MENU;
      _RouteStore2.default.redirectTo(route, {}, { tab: _RestaurantMenuPage2.default.Tabs.MENUS });
    }
  }, {
    key: 'presentProductsTab',
    value: function presentProductsTab() {
      var route = _RoutingEnum2.default.RESTAURANT_MENU;
      _RouteStore2.default.redirectTo(route, {}, { tab: _RestaurantMenuPage2.default.Tabs.PRODUCTS });
    }
  }, {
    key: 'presentOptionsTab',
    value: function presentOptionsTab() {
      var route = _RoutingEnum2.default.RESTAURANT_MENU;
      _RouteStore2.default.redirectTo(route, {}, { tab: _RestaurantMenuPage2.default.Tabs.OPTIONS });
    }
  }, {
    key: 'presentCategoriesTab',
    value: function presentCategoriesTab() {
      var route = _RoutingEnum2.default.RESTAURANT_MENU;
      _RouteStore2.default.redirectTo(route, {}, { tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES });
    }
  }, {
    key: 'presentUpsellingCategoryDetail',
    value: function presentUpsellingCategoryDetail(upsellingCategory) {
      var route = _RoutingEnum2.default.RESTAURANT_MENU_UPSELLING_CATEGORY_DETAIL;
      _RouteStore2.default.redirectTo(route, { upsellingCategoryId: upsellingCategory.id });
    }
  }]);

  return RouteAction;
}();

exports.default = RouteAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteAction, 'RouteAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/RouteAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/SecurityAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiProAccount = __webpack_require__("./sdk/scripts/api/ApiProAccount.js");

var _ApiProAccount2 = _interopRequireDefault(_ApiProAccount);

var _ProAccountStore = __webpack_require__("./scripts/stores/ProAccountStore.js");

var _ProAccountStore2 = _interopRequireDefault(_ProAccountStore);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecurityAction = function () {
  function SecurityAction() {
    _classCallCheck(this, SecurityAction);
  }

  _createClass(SecurityAction, null, [{
    key: 'getPrivilegeRoleWithElevationCode',


    //
    // Get Pro Role with elevation code
    //

    value: function getPrivilegeRoleWithElevationCode(elevationCode) {
      var domainId = null;
      var domain = _ProAccountStore2.default.getSelectedProDomain();
      if (!_lodash2.default.isNull(domain)) {
        domainId = domain.id;
      }

      _ApiProAccount2.default.getProRoleWithElevationCode(domainId, elevationCode, SecurityAction.receivePrivilegeRoleWithCode, SecurityAction.receivePrivilegeRoleWithCodeError);
    }
  }, {
    key: 'receivePrivilegeRoleWithCode',
    value: function receivePrivilegeRoleWithCode(proRole, elevationCode) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS,
        proRole: proRole,
        elevationCode: elevationCode
      });
    }
  }, {
    key: 'receivePrivilegeRoleWithCodeError',
    value: function receivePrivilegeRoleWithCodeError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.PRO_ROLE_WITH_ELEVATION_CODE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return SecurityAction;
}();

exports.default = SecurityAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SecurityAction, 'SecurityAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/SecurityAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/SessionAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ApiUser = __webpack_require__("./sdk/scripts/api/ApiUser.js");

var _ApiUser2 = _interopRequireDefault(_ApiUser);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionAction = function () {
  function SessionAction() {
    _classCallCheck(this, SessionAction);
  }

  _createClass(SessionAction, null, [{
    key: 'login',
    value: function login(username, password) {
      _ApiUser2.default.login(username, password, _Config2.default.apikey, SessionAction.receiveLogin, SessionAction.receiveLoginError);
    }
  }, {
    key: 'receiveLogin',
    value: function receiveLogin(username, password) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.LOGIN_RESPONSE_SUCCESS,
        username: username,
        password: password
      });
    }
  }, {
    key: 'receiveLoginError',
    value: function receiveLoginError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.LOGIN_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    //
    //

  }, {
    key: 'logout',
    value: function logout() {
      _AppDispatcher2.default.handleServerAction({
        type: _ActionTypes2.default.LOGOUT
      });
    }

    //
    // TODO: move
    //

  }, {
    key: 'receiveRestaurant',
    value: function receiveRestaurant(restaurant) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.RESTAURANT_RESPONSE_SUCCESS,
        restaurant: restaurant
      });
    }
  }, {
    key: 'receiveRestaurantError',
    value: function receiveRestaurantError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.RESTAURANT_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return SessionAction;
}();

exports.default = SessionAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SessionAction, 'SessionAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/SessionAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/UserAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ApiUser = __webpack_require__("./sdk/scripts/api/ApiUser.js");

var _ApiUser2 = _interopRequireDefault(_ApiUser);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _User = __webpack_require__("./sdk/scripts/entities/user/User.js");

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAction = function () {
  function UserAction() {
    _classCallCheck(this, UserAction);
  }

  _createClass(UserAction, null, [{
    key: 'loadUser',


    //
    // load user
    //

    value: function loadUser(userId) {
      _ApiUser2.default.getUser(userId, UserAction.receiveUser, UserAction.receiveUserError);
    }
  }, {
    key: 'receiveUser',
    value: function receiveUser(user) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_USER_RESPONSE_SUCCESS,
        user: user
      });
    }
  }, {
    key: 'receiveUserError',
    value: function receiveUserError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_USER_RESPONSE_FAILURE,
        apiError: apiError
      });
    }

    //
    // load user for payment
    // TODO: Use another ActionTypes: GET_USER_FOR_PAYMENT...
    //

  }, {
    key: 'loadUserForPayment',
    value: function loadUserForPayment(userId, paymentId) {
      _ApiUser2.default.getUserForPayment(userId, paymentId, UserAction.receiveUserForPayment, UserAction.receiveUserForPaymentError);
    }

    //
    // load user for review
    // TODO: Use another ActionTypes: GET_USER_FOR_PAYMENT...
    //

  }, {
    key: 'loadUserForReview',
    value: function loadUserForReview(userId, reviewId) {
      _ApiUser2.default.getUserForReview(userId, reviewId, UserAction.receiveUserForPayment, UserAction.receiveUserForPaymentError);
    }
  }, {
    key: 'receiveUserForPayment',
    value: function receiveUserForPayment(user) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_USER_RESPONSE_SUCCESS,
        user: user
      });
    }
  }, {
    key: 'receiveUserForPaymentError',
    value: function receiveUserForPaymentError(apiError) {
      _AppDispatcher2.default.handleViewAction({
        type: _ActionTypes2.default.GET_USER_RESPONSE_FAILURE,
        apiError: apiError
      });
    }
  }]);

  return UserAction;
}();

exports.default = UserAction;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UserAction, 'UserAction', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/actions/UserAction.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/actions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProAccountAction = exports.UserAction = exports.RouteAction = exports.RestaurantMenuAction = exports.RestaurantsGroupAction = exports.RestaurantAction = exports.PaymentAction = exports.OrderAction = exports.KioskAction = exports.DashboardAction = exports.SecurityAction = exports.SessionAction = undefined;

var _SessionAction2 = __webpack_require__("./scripts/actions/SessionAction.js");

var _SessionAction3 = _interopRequireDefault(_SessionAction2);

var _SecurityAction2 = __webpack_require__("./scripts/actions/SecurityAction.js");

var _SecurityAction3 = _interopRequireDefault(_SecurityAction2);

var _DashboardAction2 = __webpack_require__("./scripts/actions/DashboardAction.js");

var _DashboardAction3 = _interopRequireDefault(_DashboardAction2);

var _KioskAction2 = __webpack_require__("./scripts/actions/KioskAction.js");

var _KioskAction3 = _interopRequireDefault(_KioskAction2);

var _OrderAction2 = __webpack_require__("./scripts/actions/OrderAction.js");

var _OrderAction3 = _interopRequireDefault(_OrderAction2);

var _PaymentAction2 = __webpack_require__("./scripts/actions/PaymentAction.js");

var _PaymentAction3 = _interopRequireDefault(_PaymentAction2);

var _RestaurantAction2 = __webpack_require__("./scripts/actions/RestaurantAction.js");

var _RestaurantAction3 = _interopRequireDefault(_RestaurantAction2);

var _RestaurantsGroupAction2 = __webpack_require__("./scripts/actions/RestaurantsGroupAction.js");

var _RestaurantsGroupAction3 = _interopRequireDefault(_RestaurantsGroupAction2);

var _RestaurantMenuAction2 = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction3 = _interopRequireDefault(_RestaurantMenuAction2);

var _RouteAction2 = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction3 = _interopRequireDefault(_RouteAction2);

var _UserAction2 = __webpack_require__("./scripts/actions/UserAction.js");

var _UserAction3 = _interopRequireDefault(_UserAction2);

var _ProAccountAction2 = __webpack_require__("./scripts/actions/ProAccountAction.js");

var _ProAccountAction3 = _interopRequireDefault(_ProAccountAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SessionAction = _SessionAction3.default; // keep first

exports.SecurityAction = _SecurityAction3.default;
exports.DashboardAction = _DashboardAction3.default;
exports.KioskAction = _KioskAction3.default;
exports.OrderAction = _OrderAction3.default;
exports.PaymentAction = _PaymentAction3.default;
exports.RestaurantAction = _RestaurantAction3.default;
exports.RestaurantsGroupAction = _RestaurantsGroupAction3.default;
exports.RestaurantMenuAction = _RestaurantMenuAction3.default;
exports.RouteAction = _RouteAction3.default;
exports.UserAction = _UserAction3.default;
exports.ProAccountAction = _ProAccountAction3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHotLoader = __webpack_require__("./node_modules/react-hot-loader/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");

var _routes = __webpack_require__("./scripts/routes.js");

var _routes2 = _interopRequireDefault(_routes);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _ApiManagerOptions = __webpack_require__("./scripts/constants/ApiManagerOptions.js");

var _ApiManagerOptions2 = _interopRequireDefault(_ApiManagerOptions);

var _DevelopmentUtils = __webpack_require__("./sdk/scripts/utils/DevelopmentUtils.js");

var _DevelopmentUtils2 = _interopRequireDefault(_DevelopmentUtils);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _fr = __webpack_require__("./public/locales/fr.json");

var _fr2 = _interopRequireDefault(_fr);

var _en = __webpack_require__("./public/locales/en.json");

var _en2 = _interopRequireDefault(_en);

var _de = __webpack_require__("./public/locales/de.json");

var _de2 = _interopRequireDefault(_de);

__webpack_require__("./styles/main.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// -- stores


// -- utils


// -- constants
var localeData = {
  fr: _fr2.default,
  en: _en2.default,
  de: _de2.default
};

/**
 * ---- Logger configuration
 */

// -- router


// -- entities
_Logger2.default.configure({
  SENTRY_URL: _Config2.default.Logger.SENTRY_URL,
  DISPLAY_REPORT_DIALOG: _Config2.default.Logger.DISPLAY_REPORT_DIALOG,
  APP_VERSION: _Config2.default.VERSION
});

// set default user context when we load the page
var proAccount = _stores.ProAccountStore.getMeAccount();
if (!_lodash2.default.isNil(proAccount)) {
  _Logger2.default.setUserContext(_Logger2.default.UserRole.RESTAURANT, proAccount.id);
} else {
  _Logger2.default.setUserContext(_Logger2.default.UserRole.ANONYMOUS, '');
}

/**
 * ---- Why did you update configuration
 */

// import whyDidYouUpdate from 'why-did-you-update';

/**
 * Enable https://github.com/garbles/why-did-you-update tool on development mode.
 */
if (false) {}
//  whyDidYouUpdate(React,  { include: /^pure/, exclude: /^Connect/ });


//
// ApiManager configuration
//

_ApiManager2.default.configure(_ApiManagerOptions2.default);

//
// I18n
//

_I18n2.default.configure(localeData);
_I18n2.default.changeLocale(_stores.SessionStore.getLocale());

//
// Dev configuration
//
if (_Config2.default.IS_DEV) {
  _DevelopmentUtils2.default.setDevMode();
  _DevelopmentUtils2.default.initializeAtomReactInspector();
  _DevelopmentUtils2.default.initializeDevTools({}, _Events2.default);
}

/**
 * ---- Route documentation
 */
var element = document.getElementById('app');
var routerView = _react2.default.createElement(
  _reactHotLoader.AppContainer,
  null,
  _react2.default.createElement(
    _reactIntl.IntlProvider,
    { locale: _I18n2.default.locale, messages: _I18n2.default.messages },
    _react2.default.createElement(_reactRouter.Router, {
      routes: _routes2.default,
      history: _reactRouter.browserHistory
    })
  )
);

_reactDom2.default.render(routerView, element);

//RouteStore.getRouter().run((Handler: Object, state: Object) => {
//  ReactDOM.render(<Handler state={state} />, document.getElementById('app'));
//});
if (false) {
  module.hot.accept();
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(localeData, 'localeData', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/app.js');

  __REACT_HOT_LOADER__.register(proAccount, 'proAccount', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/app.js');

  __REACT_HOT_LOADER__.register(element, 'element', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/app.js');

  __REACT_HOT_LOADER__.register(routerView, 'routerView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/app.js');
}();

;

/***/ }),

/***/ "./scripts/components/AbstractComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _OnLoadingContentView = __webpack_require__("./scripts/components/OnLoadingContentView.js");

var _OnLoadingContentView2 = _interopRequireDefault(_OnLoadingContentView);

var _OnLoadingContentViewForModal = __webpack_require__("./sdk/scripts/components/OnLoadingContentViewForModal.js");

var _OnLoadingContentViewForModal2 = _interopRequireDefault(_OnLoadingContentViewForModal);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AbstractComponent = function (_Component) {
  _inherits(AbstractComponent, _Component);

  function AbstractComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractComponent.__proto__ || Object.getPrototypeOf(AbstractComponent)).call.apply(_ref, [this].concat(args))), _this), _this.showLoading = function () {
      var _this2;

      return (_this2 = _this).__showLoading__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.hideLoading = function () {
      var _this3;

      return (_this3 = _this).__hideLoading__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onChangeQueryUrl = function () {
      var _this4;

      return (_this4 = _this).__onChangeQueryUrl__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- Loading

  _createClass(AbstractComponent, [{
    key: '__onChangeQueryUrl__REACT_HOT_LOADER__',
    value: function __onChangeQueryUrl__REACT_HOT_LOADER__() {
      return this.__onChangeQueryUrl__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__hideLoading__REACT_HOT_LOADER__',
    value: function __hideLoading__REACT_HOT_LOADER__() {
      return this.__hideLoading__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__showLoading__REACT_HOT_LOADER__',
    value: function __showLoading__REACT_HOT_LOADER__() {
      return this.__showLoading__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__showLoading__REACT_HOT_LOADER__',
    value: function __showLoading__REACT_HOT_LOADER__(callback) {
      this.setState({
        loading: true
      }, callback);
    }
  }, {
    key: '__hideLoading__REACT_HOT_LOADER__',
    value: function __hideLoading__REACT_HOT_LOADER__() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      return !_lodash2.default.isUndefined(this.state.loading) && this.state.loading === true;
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      var forceDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!forceDisplay && (_lodash2.default.isNull(this.state) || _lodash2.default.isUndefined(this.state.loading) || this.state.loading === false)) {
        return _react2.default.createElement('div', { className: 'page_loading_hide' });
      }
      return _react2.default.createElement(
        'div',
        { className: 'page_loading_show' },
        _react2.default.createElement(
          'div',
          { className: 'page_loading_show__gif' },
          _react2.default.createElement('img', {
            src: _ViewConstants2.default.Image.LOADING_BAR,
            role: 'presentation'
          })
        )
      );
    }
  }, {
    key: 'renderOnLoadingContent',
    value: function renderOnLoadingContent() {
      return _react2.default.createElement(_OnLoadingContentView2.default, {
        displayMessage: !this.isLoading()
      });
    }
  }, {
    key: 'renderOnLoadingContentForModal',
    value: function renderOnLoadingContentForModal() {
      return _react2.default.createElement(_OnLoadingContentViewForModal2.default, null);
    }

    // -- notifications.

  }, {
    key: 'attachApiError',
    value: function attachApiError(apiError) {
      this.setState({
        apiError: apiError
      });
    }
  }, {
    key: 'renderLocalizedApiErrorBlock',
    value: function renderLocalizedApiErrorBlock() {
      var apiError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (_lodash2.default.isNil(apiError) && !_lodash2.default.isNil(this.state)) {
        apiError = this.state.apiError;
      }

      if (_lodash2.default.isNil(apiError)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'simple_error_block' },
        apiError.localizedMessage || apiError.message
      );
    }

    /**
     * Note: Assume that there is an apiError object on the state.
     * @param func
     * @returns {*}
     */

  }, {
    key: 'renderApiErrorBlock',
    value: function renderApiErrorBlock() {
      var apiError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return this.renderLocalizedApiErrorBlock(apiError);
    }
  }, {
    key: '__onChangeQueryUrl__REACT_HOT_LOADER__',


    //
    // Permissions
    //
    value: function __onChangeQueryUrl__REACT_HOT_LOADER__(newQueryParams) {
      var query = {};

      if (!_lodash2.default.isUndefined(this.props.location)) {
        query = this.props.location.query;
      }

      query = _lodash2.default.assign({}, query, newQueryParams);

      this.context.router.replace({ pathname: this.props.location.pathname, query: query });
    }
  }, {
    key: 'renderPermissionRequired',
    value: function renderPermissionRequired() {
      return _react2.default.createElement(
        'h4',
        null,
        'Vous n\'avez pas la permission pour cette action'
      );
    }
  }, {
    key: 'apiError',
    get: function get() {
      return this.state.apiError;
    }

    /**
     * Returns the query params of the current location.
     * If null returns an empty object.
     */

  }, {
    key: 'queryParams',
    get: function get() {
      if (!_lodash2.default.isNull(this.props.location) && !_lodash2.default.isUndefined(this.props.location) && !_lodash2.default.isNull(this.props.location.query)) {
        return this.props.location.query;
      }

      return {};
    }

    /**
     * This function will change the query params of the url.
     * It require the contextType `router`.
     * @param  {[type]} newQueryParams [description]
     * @return {[type]}                [description]
     */

  }]);

  return AbstractComponent;
}(_react.Component);

AbstractComponent.contextTypes = {
  router: _propTypes2.default.object.isRequired
};
AbstractComponent.propTypes = {
  location: _propTypes2.default.object
};
var _default = AbstractComponent;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AbstractComponent, 'AbstractComponent', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/AbstractComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/AbstractComponent.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/AbstractMenuComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _keymirror = __webpack_require__("./node_modules/keymirror/index.js");

var _keymirror2 = _interopRequireDefault(_keymirror);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _Route = __webpack_require__("./sdk/scripts/flux/Route.js");

var _Route2 = _interopRequireDefault(_Route);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _DevelopmentUtils = __webpack_require__("./sdk/scripts/utils/DevelopmentUtils.js");

var _DevelopmentUtils2 = _interopRequireDefault(_DevelopmentUtils);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- routing


// -- stores


// -- constants


// -- entities


var Menu = (0, _keymirror2.default)({
  PAYMENT: null,
  ORDER: null,
  DASHBOARD: null,
  SETTINGS: null
});

var AbstractMenuComponent = function (_Component) {
  _inherits(AbstractMenuComponent, _Component);

  function AbstractMenuComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractMenuComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractMenuComponent.__proto__ || Object.getPrototypeOf(AbstractMenuComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSectionCollapse: []
    }, _this.onSectionClicked = function () {
      var _this2;

      return (_this2 = _this).__onSectionClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AbstractMenuComponent, [{
    key: '__onSectionClicked__REACT_HOT_LOADER__',
    value: function __onSectionClicked__REACT_HOT_LOADER__() {
      return this.__onSectionClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Dirty trick to display the current submenu when loading the page.
      var liParent = $('.sidebar .current').parent().parent();
      liParent.addClass('active');
      liParent.find('.nav-second-level').addClass('in');
      // Note: the current submenu is not put in isSectionCollapse on start, so we have to
      // double click
      // on the submenu section in order to hide it :/
    }

    // -- events

  }, {
    key: 'isFeatureActivatedForSection',
    value: function isFeatureActivatedForSection(section) {
      var restaurant = _stores.RestaurantStore.getRestaurant();

      if (_lodash2.default.isNull(restaurant)) {
        return false;
      }

      return !(section === Menu.PAYMENT && !restaurant.haveFeaturePayment() && !restaurant.haveFeatureOrder() || section === Menu.ORDER && !restaurant.haveFeatureOrder());
    }
  }, {
    key: '__onSectionClicked__REACT_HOT_LOADER__',


    // -- utils

    value: function __onSectionClicked__REACT_HOT_LOADER__(sections, sectionSelected) {
      var _this3 = this;

      // redirect to the feature non activated page
      var shallPass = false;
      sections.map(function (section) {
        if (_this3.isFeatureActivatedForSection(section)) {
          shallPass = true;
        }
      });

      if (!shallPass) {
        _stores.RouteStore.redirectTo(_RoutingEnum2.default.FEATURE_NON_ACTIVATED);
      } else {
        var isSectionCollapse = this.state.isSectionCollapse;

        if (_lodash2.default.isUndefined(isSectionCollapse[sectionSelected])) {
          isSectionCollapse[sectionSelected] = false;
        } else {
          var currentValue = isSectionCollapse[sectionSelected];
          isSectionCollapse[sectionSelected] = !currentValue;
        }

        this.setState({
          isSectionCollapse: isSectionCollapse
        });
      }
    }
  }, {
    key: 'isActiveForRoute',
    value: function isActiveForRoute(route) {
      /**
       * Retrieve the current route.
       */
      var currentRoutes = this.props.routes;
      var currentRoute = null;
      if (currentRoutes.length > 0) {
        currentRoute = currentRoutes[currentRoutes.length - 1];
        if (_lodash2.default.isUndefined(currentRoute)) {
          currentRoute = null;
        }
      }

      if (_lodash2.default.isUndefined(currentRoute) || _lodash2.default.isUndefined(route)) {
        return false;
      }

      var path = currentRoute.path;
      var routeName = route.name;

      var isRestaurantMenuSubRoute = currentRoute.path.startsWith(_RoutingEnum2.default.RESTAURANT_MENU.path) && routeName.startsWith(_RoutingEnum2.default.RESTAURANT_MENU.name);

      if (currentRoute.name === route.name || isRestaurantMenuSubRoute ||
      // handle default route.
      _lodash2.default.isNull(currentRoute.name) && route.name === _RoutingEnum2.default.DASHBOARD.name) {
        return true;
      }

      return false;
    }
  }, {
    key: 'getClassForRoute',
    value: function getClassForRoute(route) {
      return this.isActiveForRoute(route) ? 'current' : '';
    }
  }, {
    key: 'isActiveForSection',
    value: function isActiveForSection(section) {
      var isSectionCollapse = this.state.isSectionCollapse;

      if (_lodash2.default.isUndefined(isSectionCollapse[section])) {
        return false;
      }
      return isSectionCollapse[section] === false;
    }
  }, {
    key: 'getClassForSection',
    value: function getClassForSection(section) {
      return (0, _classnames2.default)({
        // this class allows us to hide feature that or not activated for the restaurant in the
        // mobile menu
        feature_deactivated: this.isFeatureActivatedForSection(section) === false,

        // is the section the current section where we are?
        active: this.isActiveForSection(section)
      });
    }
  }, {
    key: 'getClassForSecondLevel',
    value: function getClassForSecondLevel(section) {
      var isSectionCollapse = this.state.isSectionCollapse;
      var baseClass = 'nav nav-second-level collapse';

      if (_lodash2.default.isUndefined(isSectionCollapse[section])) {
        return baseClass;
      }
      return baseClass + ' ' + (isSectionCollapse[section] === false ? 'in' : '');
    }
  }, {
    key: 'updateLocale',
    value: function updateLocale(locale) {
      _I18n2.default.changeLocale(locale);

      // save on session
      _stores.SessionStore.saveLocale(locale);
    }

    // -- renderers

  }, {
    key: 'renderDashboard',
    value: function renderDashboard() {
      return null; // deactivate for now.
      // For the moment we handle only the booking on the dashboard, so if the restaurant haven't the
      // feature booking, we don't display iot/
      // if (!RestaurantStore.getRestaurant().haveFeatureBooking()) {
      //   return (null);
      // }
      // const mainClass = `menu_hide_big_screen ${this.getClassForSection(Menu.DASHBOARD)}`;
      //
      // return (
      //   <li className={mainClass}>
      //     <Link to={RoutingEnum.DASHBOARD}>
      //       <i className="fa fa-dashboard" />
      //       &nbsp;&nbsp;
      //       Dashboard
      //     </Link>
      //   </li>
      // );
    }
  }, {
    key: 'renderPayment',
    value: function renderPayment() {
      var _this4 = this;

      if (!_stores.SessionStore.isLoggedIn()) {
        return null;
      }

      var mainClass = (0, _classnames2.default)('menu_hide_big_screen', this.getClassForSection(Menu.PAYMENT));

      return _react2.default.createElement(
        'li',
        { className: mainClass },
        _react2.default.createElement(
          'a',
          {
            onClick: function onClick() {
              return _this4.onSectionClicked([Menu.PAYMENT, Menu.ORDER], Menu.PAYMENT);
            },
            className: 'bold'
          },
          _react2.default.createElement('i', { className: 'fa fa-line-chart' }),
          '\xA0\xA0',
          _I18n2.default.tr('menu.payment'),
          _react2.default.createElement('span', { className: 'fa arrow' })
        ),
        _react2.default.createElement(
          'ul',
          { className: this.getClassForSecondLevel(Menu.PAYMENT) },
          _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.STAT_HOME) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.STAT_HOME },
              _I18n2.default.tr('menu.payment.stat')
            )
          ),
          _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.RECEIPT) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.RECEIPT },
              _I18n2.default.tr('menu.payment.receipt')
            )
          )
        )
      );
    }
  }, {
    key: 'renderOrder',
    value: function renderOrder() {
      var _this5 = this;

      if (!_stores.SessionStore.isLoggedIn()) {
        return null;
      }

      var mainClass = (0, _classnames2.default)('menu_hide_big_screen', this.getClassForSection(Menu.ORDER));

      return _react2.default.createElement(
        'li',
        { className: mainClass },
        _react2.default.createElement(
          'a',
          {
            onClick: function onClick() {
              return _this5.onSectionClicked([Menu.ORDER], Menu.ORDER);
            },
            className: 'bold'
          },
          _react2.default.createElement('i', { className: 'fa fa-shopping-cart' }),
          '\xA0\xA0',
          _I18n2.default.tr('menu.order'),
          _react2.default.createElement('span', { className: 'fa arrow' })
        ),
        _react2.default.createElement(
          'ul',
          { className: this.getClassForSecondLevel(Menu.ORDER) },
          _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.ORDERS_LIST) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.ORDERS_LIST },
              _I18n2.default.tr('menu.order.orders_list')
            )
          ),
          _SecurityContext2.default.restaurantMenu.canRead() && _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.RESTAURANT_MENU) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.RESTAURANT_MENU },
              _I18n2.default.tr('menu.order.restaurant_menu')
            )
          ),
          _SecurityContext2.default.restaurantMenu.canRead() && _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.ORDER_STATISTICS) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.ORDER_STATISTICS },
              _I18n2.default.tr('menu.order.statistics')
            )
          ),
          _SecurityContext2.default.cartModifiers.canRead() && _react2.default.createElement(
            'li',
            {
              className: this.getClassForRoute(_RoutingEnum2.default.ORDERS_CART_MODIFIERS_LIST)
            },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.ORDERS_CART_MODIFIERS_LIST },
              _I18n2.default.tr('menu.order.cart_modifiers')
            )
          ),
          _SecurityContext2.default.orderSettings.canRead() && _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.ORDER_SETTINGS) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.ORDER_SETTINGS },
              _I18n2.default.tr('menu.order.settings')
            )
          )
        )
      );
    }
  }, {
    key: 'renderRestaurantSettings',
    value: function renderRestaurantSettings() {
      var _this6 = this;

      if (!_stores.SessionStore.isLoggedIn() || !_SecurityContext2.default.restaurantSettings.read()) {
        return null;
      }

      var mainClass = (0, _classnames2.default)('menu_hide_big_screen', this.getClassForSection(Menu.SETTINGS));

      return _react2.default.createElement(
        'li',
        { className: mainClass },
        _react2.default.createElement(
          'a',
          {
            onClick: function onClick() {
              return _this6.onSectionClicked([Menu.SETTINGS], Menu.SETTINGS);
            },
            className: 'bold'
          },
          _react2.default.createElement('i', { className: 'fa fa-cog' }),
          '\xA0\xA0',
          _I18n2.default.tr('menu.settings'),
          _react2.default.createElement('span', { className: 'fa arrow' })
        ),
        _react2.default.createElement(
          'ul',
          { className: this.getClassForSecondLevel(Menu.SETTINGS) },
          _react2.default.createElement(
            'li',
            { className: this.getClassForRoute(_RoutingEnum2.default.RESTAURANT_EDIT) },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.RESTAURANT_EDIT },
              _I18n2.default.tr('menu.settings.restaurant')
            )
          )
        )
      );
    }
  }, {
    key: 'renderLocales',
    value: function renderLocales() {
      var _this7 = this;

      var currentLocale = _I18n2.default.getCurrentLanguageWithoutRegionCode();
      var className = (0, _classnames2.default)('flag', currentLocale.toLowerCase());

      return _react2.default.createElement(
        'li',
        { className: 'dropdown', id: 'header' },
        _react2.default.createElement(
          'a',
          {
            href: '#',
            className: 'dropdown-toggle',
            'data-toggle': 'dropdown',
            id: 'header-menu-dropdown'
          },
          _react2.default.createElement('i', { className: 'fa fa-globe' })
        ),
        _react2.default.createElement(
          'ul',
          { className: 'dropdown-menu dropdown-user' },
          _Constants2.default.supportedLocales.map(function (localeInfo) {
            var className = (0, _classnames2.default)({
              selected: currentLocale === localeInfo.locale
            });

            return _react2.default.createElement(
              'li',
              {
                key: localeInfo.locale,
                onClick: function onClick() {
                  return _this7.updateLocale(localeInfo.locale);
                },
                className: className
              },
              _react2.default.createElement(
                'a',
                { href: '' },
                localeInfo.name
              )
            );
          })
        )
      );
    }
  }, {
    key: 'renderTest',
    value: function renderTest() {
      // if (!DevelopmentUtils.isLocalhost()) {
      // return (null);
      // }

      if (!_Config2.default.IS_DEV) {
        return null;
      }

      return _react2.default.createElement(
        'li',
        { className: 'menu_hide_big_screen' },
        _react2.default.createElement(
          _Link2.default,
          { to: _RoutingEnum2.default.TEST_PAGE },
          'test page'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      console.error('this method should be override');
    }
  }]);

  return AbstractMenuComponent;
}(_react.Component);

AbstractMenuComponent.propTypes = {
  /**
   * Cf index.js. We give to our Layout the app state, that contains the
   * current route.
   */
  routes: _propTypes2.default.object.isRequired
};
var _default = AbstractMenuComponent;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Menu, 'Menu', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/AbstractMenuComponent.js');

  __REACT_HOT_LOADER__.register(AbstractMenuComponent, 'AbstractMenuComponent', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/AbstractMenuComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/AbstractMenuComponent.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/ApiErrorView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiErrorView = function ApiErrorView(_ref) {
	var apiError = _ref.apiError;
	return !apiError ? null : _react2.default.createElement(
		'div',
		{ style: { backgroundColor: '#e53935', padding: 16, margin: 8, color: 'white' } },
		apiError.localizedMessage || apiError.message
	);
};

var _default = ApiErrorView;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ApiErrorView, 'ApiErrorView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/ApiErrorView.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/ApiErrorView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/DayChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var DayChooser = function (_Component) {
  _inherits(DayChooser, _Component);

  function DayChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DayChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DayChooser.__proto__ || Object.getPrototypeOf(DayChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DayChooser, [{
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.day !== nextProps.day;
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__(option) {
      this.props.onChange(option.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var options = [{
        value: _Constants2.default.Day.MONDAY,
        label: _I18n2.default.tr('global.days.monday')
      }, {
        value: _Constants2.default.Day.TUESDAY,
        label: _I18n2.default.tr('global.days.tuesday')
      }, {
        value: _Constants2.default.Day.WEDNESDAY,
        label: _I18n2.default.tr('global.days.wednesday')
      }, {
        value: _Constants2.default.Day.THURSDAY,
        label: _I18n2.default.tr('global.days.thursday')
      }, {
        value: _Constants2.default.Day.FRIDAY,
        label: _I18n2.default.tr('global.days.friday')
      }, {
        value: _Constants2.default.Day.SATURDAY,
        label: _I18n2.default.tr('global.days.saturday')
      }, {
        value: _Constants2.default.Day.SUNDAY,
        label: _I18n2.default.tr('global.days.sunday')
      }];

      return _react2.default.createElement(
        'div',
        { className: 'day_chooser' },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'day',
          value: this.props.day,
          options: options,
          onChange: this.onChange,
          clearable: false
        })
      );
    }
  }]);

  return DayChooser;
}(_react.Component);

DayChooser.propTypes = {
  day: _propTypes2.default.number.isRequired,

  // param: number (Constants.Day)
  onChange: _propTypes2.default.func.isRequired
};
var _default = DayChooser;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DayChooser, 'DayChooser', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/DayChooser.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/DayChooser.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/OnLoadingContentView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OnLoadingContentView(props) {
  var message = _react2.default.createElement(
    'h2',
    null,
    _I18n2.default.tr('global.loading'),
    '...'
  );

  if (props.displayMessage === false) {
    message = null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'on_loading_content_view text-center' },
    message
  );
}

OnLoadingContentView.propTypes = {
  /**
   * Should we display a loading message ?
   */
  displayMessage: _propTypes2.default.bool
};

OnLoadingContentView.defaultProps = {
  displayMessage: true
};

var _default = OnLoadingContentView;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OnLoadingContentView, 'OnLoadingContentView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/OnLoadingContentView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/OnLoadingContentView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/RoundButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoundButton = function (_Component) {
  _inherits(RoundButton, _Component);

  function RoundButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RoundButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoundButton.__proto__ || Object.getPrototypeOf(RoundButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this2;

      return (_this2 = _this).__onClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RoundButton, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.text !== nextProps.text || this.props.icon !== this.props.icon;
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__(event) {
      event.preventDefault();
      this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('btn-round', {
        'btn-round-normal': this.props.size === RoundButton.Size.NORMAL,
        'btn-round-small': this.props.size === RoundButton.Size.SMALL
      });
      return _react2.default.createElement(
        'div',
        {
          className: className,
          onClick: this.onClick
        },
        _react2.default.createElement(
          'button',
          { className: 'btn btn-primary' },
          _react2.default.createElement('i', { className: 'fa ' + this.props.icon })
        ),
        _react2.default.createElement(
          'span',
          null,
          this.props.text
        )
      );
    }
  }]);

  return RoundButton;
}(_react.Component);

RoundButton.Size = {
  NORMAL: 0,
  SMALL: 1
};
RoundButton.defaultProps = {
  text: '',
  icon: 'fa-plus',
  size: RoundButton.Size.NORMAL
};
RoundButton.propTypes = {
  icon: _propTypes2.default.string,

  onClick: _propTypes2.default.func.isRequired,

  text: _propTypes2.default.string,

  size: _propTypes2.default.number
};
var _default = RoundButton;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoundButton, 'RoundButton', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/RoundButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/RoundButton.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/color/ColorPickerColorView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- tools


var ColorPickerColorView = function (_Component) {
  _inherits(ColorPickerColorView, _Component);

  function ColorPickerColorView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ColorPickerColorView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorPickerColorView.__proto__ || Object.getPrototypeOf(ColorPickerColorView)).call.apply(_ref, [this].concat(args))), _this), _this.onColorClicked = function () {
      var _this2;

      return (_this2 = _this).__onColorClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ColorPickerColorView, [{
    key: '__onColorClicked__REACT_HOT_LOADER__',
    value: function __onColorClicked__REACT_HOT_LOADER__() {
      return this.__onColorClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onColorClicked__REACT_HOT_LOADER__',
    value: function __onColorClicked__REACT_HOT_LOADER__() {
      this.props.onClicked(this.props.color);
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        background: _ViewUtils2.default.uintColorToRgbaFormat(this.props.color)
      };

      var selectedView = _react2.default.createElement('span', { className: 'color_picker__color_view__not_selected' });

      if (this.props.isSelected) {
        // Setup the check icon color according to the color background.
        var colorClass = 'color_picker__color_view__color_light';
        if (_ViewUtils2.default.isLightColor(this.props.color)) {
          colorClass = 'color_picker__color_view__color_dark';
        }
        selectedView = _react2.default.createElement(
          'span',
          { className: 'color_picker__color_view__selected' },
          _react2.default.createElement('i', { className: 'fa fa-check-circle ' + colorClass })
        );
      }

      return _react2.default.createElement(
        'span',
        {
          className: 'color_picker__color_view pointer',
          onClick: this.onColorClicked,
          style: style
        },
        _react2.default.createElement(
          'span',
          { className: 'color_picker__color_view__color vcenter', style: style },
          selectedView
        )
      );
    }
  }]);

  return ColorPickerColorView;
}(_react.Component);

ColorPickerColorView.propTypes = {
  color: _propTypes2.default.number.isRequired, // uint color

  onClicked: _propTypes2.default.func.isRequired,

  isSelected: _propTypes2.default.bool.isRequired
};
var _default = ColorPickerColorView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ColorPickerColorView, 'ColorPickerColorView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/color/ColorPickerColorView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/color/ColorPickerColorView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/color/ColorPickerModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _ColorPickerViewUtils = __webpack_require__("./scripts/utils/ColorPickerViewUtils.js");

var _ColorPickerViewUtils2 = _interopRequireDefault(_ColorPickerViewUtils);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _ColorPickerColorView = __webpack_require__("./scripts/components/color/ColorPickerColorView.js");

var _ColorPickerColorView2 = _interopRequireDefault(_ColorPickerColorView);

var _reactColor = __webpack_require__("./node_modules/react-color/lib/index.js");

var _reactColor2 = _interopRequireDefault(_reactColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- views


var ColorPickerModal = function (_Component) {
  _inherits(ColorPickerModal, _Component);

  function ColorPickerModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ColorPickerModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorPickerModal.__proto__ || Object.getPrototypeOf(ColorPickerModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      color: _this.props.color
    }, _this.submit = function () {
      var _this2;

      return (_this2 = _this).__submit__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onColorChosen = function () {
      var _this3;

      return (_this3 = _this).__onColorChosen__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onColorPickerChange = function () {
      var _this4;

      return (_this4 = _this).__onColorPickerChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onHide = function () {
      var _this5;

      return (_this5 = _this).__onHide__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onClose = function () {
      var _this6;

      return (_this6 = _this).__onClose__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events colors

  _createClass(ColorPickerModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onColorPickerChange__REACT_HOT_LOADER__',
    value: function __onColorPickerChange__REACT_HOT_LOADER__() {
      return this.__onColorPickerChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onColorChosen__REACT_HOT_LOADER__',
    value: function __onColorChosen__REACT_HOT_LOADER__() {
      return this.__onColorChosen__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__submit__REACT_HOT_LOADER__',
    value: function __submit__REACT_HOT_LOADER__() {
      return this.__submit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__submit__REACT_HOT_LOADER__',
    value: function __submit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!_lodash2.default.isNull(this.state.color)) {
        this.props.onChange(this.state.color);
      } else {
        this.props.onHide();
      }
    }
  }, {
    key: '__onColorChosen__REACT_HOT_LOADER__',


    /**
     * See http://casesandberg.github.io/react-color/#api-onChange
     * @param color
     */
    value: function __onColorChosen__REACT_HOT_LOADER__(color) {
      this.setState({
        color: color
      });
    }
  }, {
    key: '__onColorPickerChange__REACT_HOT_LOADER__',


    // -- events - modal

    value: function __onColorPickerChange__REACT_HOT_LOADER__(color) {
      var uintValue = _ViewUtils2.default.rgbaToUint(color.rgb);
      this.setState({
        color: uintValue
      });
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',


    // -- tools
    // -- renderers

    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this7 = this;

      var colorListView = [];

      this.props.colorsList.forEach(function (color) {
        // get the current color.
        var currentColor = _this7.state.color;
        if (_lodash2.default.isNull(currentColor)) {
          currentColor = _this7.props.color;
        }

        var isSelected = color === currentColor;

        colorListView.push(_react2.default.createElement(_ColorPickerColorView2.default, {
          color: color,
          isSelected: isSelected,
          onClicked: _this7.onColorChosen,
          key: color
        }));
      });

      return _react2.default.createElement(
        'div',
        { className: 'color_picker' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'color_picker__list col-sm-12 col-md-6 vcenter-md vcenter-lg' },
            colorListView
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'color_picker__react_color_picker top-buffer-xs-50 top-buffer-sm-50 col-sm-12 col-md-6 vcenter-md vcenter-lg'
            },
            _react2.default.createElement(_reactColor2.default, {
              display: true,
              onClose: function onClose() {},
              type: 'sketch',
              color: _ViewUtils2.default.uintToRgba(this.state.color),
              onChange: this.onColorPickerChange
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-center top-buffer-50' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary',
              type: 'submit',
              onClick: this.submit
            },
            _I18n2.default.tr('components.color.picker.validate')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.color.picker.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return ColorPickerModal;
}(_react.Component);

ColorPickerModal.defaultProps = {
  color: _ViewUtils2.default.hexadecimalColorToUint(_ViewConstants2.default.ColorPicker.DEFAULT_COLOR),
  colorsList: _ColorPickerViewUtils2.default.getDefaultColorListUint()
};
ColorPickerModal.propTypes = {
  // -- colors

  // uint color
  color: _propTypes2.default.number,

  // array of uint
  colorsList: _propTypes2.default.arrayOf(Number),

  // -- modal

  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  // params: color (int value)
  onChange: _propTypes2.default.func.isRequired
};
var _default = ColorPickerModal;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ColorPickerModal, 'ColorPickerModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/color/ColorPickerModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/color/ColorPickerModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/color/ColorView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _ColorPickerModal = __webpack_require__("./scripts/components/color/ColorPickerModal.js");

var _ColorPickerModal2 = _interopRequireDefault(_ColorPickerModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- views


var ColorView = function (_Component) {
  _inherits(ColorView, _Component);

  function ColorView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ColorView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorView.__proto__ || Object.getPrototypeOf(ColorView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayPicker: false
    }, _this.onOpenPicker = function () {
      var _this2;

      return (_this2 = _this).__onOpenPicker__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClosePicker = function () {
      var _this3;

      return (_this3 = _this).__onClosePicker__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onColorChange = function () {
      var _this4;

      return (_this4 = _this).__onColorChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events


  _createClass(ColorView, [{
    key: '__onColorChange__REACT_HOT_LOADER__',
    value: function __onColorChange__REACT_HOT_LOADER__() {
      return this.__onColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClosePicker__REACT_HOT_LOADER__',
    value: function __onClosePicker__REACT_HOT_LOADER__() {
      return this.__onClosePicker__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOpenPicker__REACT_HOT_LOADER__',
    value: function __onOpenPicker__REACT_HOT_LOADER__() {
      return this.__onOpenPicker__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOpenPicker__REACT_HOT_LOADER__',
    value: function __onOpenPicker__REACT_HOT_LOADER__() {
      if (this.props.enablePicker) {
        this.setState({
          displayPicker: true
        });
      }
    }
  }, {
    key: '__onClosePicker__REACT_HOT_LOADER__',
    value: function __onClosePicker__REACT_HOT_LOADER__() {
      this.setState({
        displayPicker: false
      });
    }
  }, {
    key: '__onColorChange__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onColorChange__REACT_HOT_LOADER__(color) {
      this.onClosePicker();
      this.props.onColorChange(color);
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        backgroundColor: _ViewUtils2.default.uintColorToRgbaFormat(this.props.color),
        width: this.props.size + 'px',
        height: this.props.size + 'px'
      };

      var mainClass = 'color_view';

      if (this.props.enablePicker) {
        mainClass += ' pointer';
      }

      // get the type of color (light or dark) to put the inverse border
      if (_ViewUtils2.default.isVeryLightColor(this.props.color)) {
        mainClass += ' color_view_light';
      } else {
        mainClass += ' color_view_dark';
      }

      return _react2.default.createElement(
        'div',
        {
          className: mainClass,
          style: style,
          onClick: this.onOpenPicker
        },
        this.props.enablePicker && _react2.default.createElement(_ColorPickerModal2.default, {
          show: this.state.displayPicker,
          onHide: this.onClosePicker,
          color: this.props.color,
          onChange: this.onColorChange
        })
      );
    }
  }]);

  return ColorView;
}(_react.Component);

ColorView.defaultProps = {
  color: _ViewConstants2.default.ColorView.DEFAULT_COLOR,

  size: _ViewConstants2.default.ColorView.DEFAULT_SIZE,

  enablePicker: false,

  onColorChange: function onColorChange() {}
};
ColorView.propTypes = {
  color: _propTypes2.default.number,

  size: _propTypes2.default.number,

  enablePicker: _propTypes2.default.bool,

  /**
   * must be set if enablePicker is set tot true.
   * param: number (color)
    */
  onColorChange: _propTypes2.default.func
};
var _default = ColorView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ColorView, 'ColorView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/color/ColorView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/color/ColorView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/footer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Is hidden by default to remove ugly effect. Will be display after page loading (see window.js)
function Footer() {
  return _react2.default.createElement(
    'footer',
    { className: 'footer col-sm-offset-2 col-sm-10 col-xs-12' },
    _react2.default.createElement(
      'div',
      { className: 'footer_links' },
      _react2.default.createElement(
        'div',
        { className: 'footer_info text-center' },
        '\xA9 PayMyTable 2016. ',
        _I18n2.default.tr('components.footer.rights_reserved'),
        '. \xA0',
        _react2.default.createElement(
          _Link2.default,
          { to: _RoutingEnum2.default.CGU },
          _I18n2.default.tr('components.footer.cgu')
        )
      )
    )
  );
}

var _default = Footer;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Footer, 'Footer', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/footer/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/footer/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/form/AbstractFormComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _FixedSubmitArea = __webpack_require__("./sdk/scripts/components/form/FixedSubmitArea.js");

var _FixedSubmitArea2 = _interopRequireDefault(_FixedSubmitArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- components


/**
* Abstract class.
* The following methods must be override:
* - haveModifications(): boolean {}
* - getDefaultState(): Object {}
* - onSubmit = (event) => {};
* - shouldDisableSubmit(): boolean {}
* Notes:
* If you use a <Switch /> you must had key={`${Math.random()}`}
* to force reload the component when we reset the form. Otherwise, it will infinite loop.
*/
var AbstractFormComponent = function (_AbstractComponent) {
  _inherits(AbstractFormComponent, _AbstractComponent);

  function AbstractFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractFormComponent.__proto__ || Object.getPrototypeOf(AbstractFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onReset = function () {
      var _this2;

      return (_this2 = _this).__onReset__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events

  _createClass(AbstractFormComponent, [{
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    //  onSubmit = (event: Object) => {
    //    event.preventDefault();
    //    console.error('on submit must be override');
    //  };

    // -- utils
    value: function __onReset__REACT_HOT_LOADER__() {
      if (!_lodash2.default.isUndefined(this.props.onReset)) {
        this.props.onReset();
      } else {
        this.setState(this.getDefaultState());
      }
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      console.error('getDefaultState must be override');
      return {};
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      console.error('have modifications must be override');
      return true;
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return true;
    }

    // -- checkers

  }, {
    key: 'checkRegex',
    value: function checkRegex(regex, value) {
      return regex.test(value);
    }

    // -- renderers

  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _this3 = this;

      var button = _react2.default.createElement(
        'button',
        {
          className: 'btn btn-primary',
          onClick: function onClick(event) {
            event.preventDefault();_this3.onSubmit(event);
          },
          type: 'submit'
        },
        _I18n2.default.tr('components.form.save')
      );

      if (!this.haveModifications() || this.shouldDisableSubmit()) {
        button = _react2.default.createElement(
          'button',
          { className: 'btn btn-primary', disabled: true },
          _I18n2.default.tr('components.form.save')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'text-center top-buffer-50' },
        this.haveModifications() && _react2.default.createElement(
          'button',
          {
            className: 'btn',
            onClick: function onClick(event) {
              event.preventDefault();_this3.onReset(event);
            },
            type: 'reset'
          },
          _I18n2.default.tr('components.form.cancel_modifications')
        ),
        '\xA0\xA0\xA0\xA0',
        button
      );
    }
  }, {
    key: 'renderFixedButtons',
    value: function renderFixedButtons() {
      return _react2.default.createElement(_FixedSubmitArea2.default, {
        haveModifications: this.haveModifications(),
        onSubmit: this.onSubmit,
        onReset: this.onReset,
        shouldDisableSubmit: this.shouldDisableSubmit()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      console.error('This method should be override.');

      return null;
    }
  }]);

  return AbstractFormComponent;
}(_AbstractComponent3.default);

var _default = AbstractFormComponent;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AbstractFormComponent, 'AbstractFormComponent', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/form/AbstractFormComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/form/AbstractFormComponent.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/form/StoreStateChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StoreStateChooser = function (_Component) {
  _inherits(StoreStateChooser, _Component);

  function StoreStateChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StoreStateChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreStateChooser.__proto__ || Object.getPrototypeOf(StoreStateChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StoreStateChooser, [{
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__(option) {
      // verify has permissions to choose ARCHIVED status
      if (!_SecurityContext2.default.proAccount.canArchiveRestaurant() && option.value === 'ARCHIVED') {
        return;
      }
      // verify has permissions to choose CREATED status.
      if (!_SecurityContext2.default.admin.isAdmin() && option.value === 'CREATED') {
        return;
      }
      if (_lodash2.default.isNull(option)) {
        this.props.onChange(null);
      } else {
        this.props.onChange(option.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var choices = [{
        label: _I18n2.default.tr('restaurant_edit.configuration.statut.CREATED'),
        value: 'CREATED'
      }, {
        label: _I18n2.default.tr('restaurant_edit.configuration.statut.ENABLED'),
        value: 'ENABLED'
      }, {
        label: _I18n2.default.tr('restaurant_edit.configuration.statut.DISABLED'),
        value: 'DISABLED'
      }, _SecurityContext2.default.proAccount.canArchiveRestaurant() && {
        label: _I18n2.default.tr('restaurant_edit.configuration.statut.ARCHIVED'),
        value: 'ARCHIVED'
      }].filter(Boolean);

      return _react2.default.createElement(
        'div',
        { className: 'pos_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.value,
          options: choices,
          onChange: this.onSelect,
          disabled: this.props.disabled,
          clearable: true,
          placeholder: _I18n2.default.tr('restaurant_edit.configuration.status'),
          readOnly: this.props.readOnly
        })
      );
    }
  }]);

  return StoreStateChooser;
}(_react.Component);

StoreStateChooser.defaultProps = {
  readOnly: false
};
StoreStateChooser.propTypes = {
  value: _propTypes2.default.string.isRequired,

  // param: String, the chosen POS
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool,

  disabled: _propTypes2.default.bool
};
exports.default = StoreStateChooser;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(StoreStateChooser, 'StoreStateChooser', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/form/StoreStateChooser.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _AbstractMenuComponent = __webpack_require__("./scripts/components/AbstractMenuComponent.js");

var _AbstractMenuComponent2 = _interopRequireDefault(_AbstractMenuComponent);

var _ChooseRestaurantsGroupListMenu = __webpack_require__("./scripts/components/header/components/ChooseRestaurantsGroupListMenu.js");

var _ChooseRestaurantsGroupListMenu2 = _interopRequireDefault(_ChooseRestaurantsGroupListMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- routing


// -- constants


// -- stores


// -- views


/**
 * Handle the header view.
 * Responsive mode: display the same content as the sidebar
 */
var HeaderComponent = function (_AbstractMenuComponen) {
  _inherits(HeaderComponent, _AbstractMenuComponen);

  function HeaderComponent() {
    _classCallCheck(this, HeaderComponent);

    return _possibleConstructorReturn(this, (HeaderComponent.__proto__ || Object.getPrototypeOf(HeaderComponent)).apply(this, arguments));
  }

  _createClass(HeaderComponent, [{
    key: 'componentDidMount',


    // -- events
    value: function componentDidMount() {
      // hide the header navigation in mobile mode.
      // see https://github.com/react-bootstrap/react-bootstrap/issues/541
      // on no-mobile screen mode, ugly effect is made
      if (PMT.isMobileScreen()) {
        $('.nav a').on('click', function () {
          $('.navbar-toggle').click();
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return true;
      // return shallowCompare(this, nextProps, nextState);
    }

    //
    // renderers
    //

  }, {
    key: 'renderChooseRestaurantsGroupList',
    value: function renderChooseRestaurantsGroupList() {
      return _react2.default.createElement(_ChooseRestaurantsGroupListMenu2.default, null);
    }
  }, {
    key: 'renderSettings',
    value: function renderSettings() {
      var proAccount = _stores.ProAccountStore.getMeAccount();

      var userName = '';
      if (!_lodash2.default.isNull(proAccount)) {
        userName = proAccount.getName();
      }

      return _react2.default.createElement(
        'li',
        { className: 'dropdown', id: 'header' },
        _react2.default.createElement(
          'a',
          {
            href: '#',
            className: 'dropdown-toggle',
            'data-toggle': 'dropdown',
            id: 'header-menu-dropdown'
          },
          _react2.default.createElement('i', { className: 'fa fa-user' }),
          '\xA0',
          userName,
          '\xA0',
          _react2.default.createElement('i', { className: 'fa fa-caret-down' })
        ),
        _react2.default.createElement(
          'ul',
          { className: 'dropdown-menu dropdown-user' },
          _react2.default.createElement(
            'li',
            { className: 'logout' },
            _react2.default.createElement(
              _Link2.default,
              { to: _RoutingEnum2.default.LOGOUT },
              _react2.default.createElement('i', { className: 'fa fa-close' }),
              '\xA0\xA0',
              _I18n2.default.tr('components.header.logout')
            )
          )
        )
      );
    }
  }, {
    key: 'renderContact',
    value: function renderContact() {
      return _react2.default.createElement(
        'li',
        { className: 'clear pointer' },
        _react2.default.createElement(
          'a',
          { onClick: this.props.onDisplayContactModal },
          _react2.default.createElement('i', { className: 'fa fa-phone' }),
          '\xA0',
          _I18n2.default.tr('components.header.contact')
        )
      );
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var rows = [];

      rows.push(this.renderContact());

      var loggedInView = null;
      if (_stores.SessionStore.isLoggedIn()) {
        loggedInView = this.renderSettings();
      }

      return _react2.default.createElement(
        'ul',
        { className: 'nav navbar-nav navbar-right' },
        this.renderOrder(),
        this.renderPayment(),
        this.renderRestaurantSettings(),
        this.renderContact(),
        _stores.SessionStore.isLoggedIn() && this.renderChooseRestaurantsGroupList(),
        loggedInView,
        this.renderLocales()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'header',
        { className: 'js-header' },
        _react2.default.createElement(
          'nav',
          { className: 'navbar navbar-fixed-top', role: 'navigation' },
          _react2.default.createElement(
            'div',
            { className: 'container-fluid' },
            _react2.default.createElement(
              'div',
              { className: 'navbar-header' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'navbar-toggle collapsed',
                  'data-toggle': 'collapse',
                  'data-target': '.navbar-collapse',
                  'aria-expanded': 'false',
                  'aria-controls': '#navbar'
                },
                _react2.default.createElement(
                  'span',
                  { className: 'sr-only' },
                  'Toggle navigation'
                ),
                _react2.default.createElement('span', { className: 'icon-bar' }),
                _react2.default.createElement('span', { className: 'icon-bar' }),
                _react2.default.createElement('span', { className: 'icon-bar' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'logo none' },
                _react2.default.createElement(
                  _Link2.default,
                  { to: _RoutingEnum2.default.DASHBOARD },
                  _react2.default.createElement('img', { src: '/img/paymytable_logo.png', role: 'presentation' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { id: 'navbar', className: 'navbar-collapse collapse' },
              this.renderMenu()
            )
          )
        )
      );
    }
  }]);

  return HeaderComponent;
}(_AbstractMenuComponent2.default);

HeaderComponent.propTypes = {
  onDisplayContactModal: _propTypes2.default.func.isRequired
};
var _default = HeaderComponent;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(HeaderComponent, 'HeaderComponent', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/Header.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/Header.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/components/ChooseProDomainView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _ProDomainRow = __webpack_require__("./scripts/components/header/components/ProDomainRow.js");

var _ProDomainRow2 = _interopRequireDefault(_ProDomainRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var ChooseProDomainView = function (_Component) {
  _inherits(ChooseProDomainView, _Component);

  function ChooseProDomainView() {
    _classCallCheck(this, ChooseProDomainView);

    return _possibleConstructorReturn(this, (ChooseProDomainView.__proto__ || Object.getPrototypeOf(ChooseProDomainView)).apply(this, arguments));
  }

  _createClass(ChooseProDomainView, [{
    key: 'render',


    //
    // Renderers
    //

    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'choose_pro_domain_view'
        },
        this.props.proDomainsList.domains.map(function (proDomain) {
          var isSelected = _this2.props.selectedProDomain.id === proDomain.id;

          return _react2.default.createElement(_ProDomainRow2.default, {
            key: proDomain.id,
            isSelected: isSelected,
            proDomain: proDomain,
            onClick: _this2.props.onClick
          });
        })
      );
    }
  }]);

  return ChooseProDomainView;
}(_react.Component);

ChooseProDomainView.propTypes = {
  proDomainsList: _propTypes2.default.objectOf(_security.ProDomainsList).isRequired,

  selectedProDomain: _propTypes2.default.objectOf(_security.ProDomain).isRequired,

  onClick: _propTypes2.default.func.isRequired
};
exports.default = ChooseProDomainView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChooseProDomainView, 'ChooseProDomainView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/components/ChooseProDomainView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/components/ChooseRestaurantView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseRestaurantView = function (_Component) {
  _inherits(ChooseRestaurantView, _Component);

  function ChooseRestaurantView() {
    _classCallCheck(this, ChooseRestaurantView);

    return _possibleConstructorReturn(this, (ChooseRestaurantView.__proto__ || Object.getPrototypeOf(ChooseRestaurantView)).apply(this, arguments));
  }

  _createClass(ChooseRestaurantView, [{
    key: 'renderRestaurantsList',


    //
    // Renderers
    //

    value: function renderRestaurantsList() {
      var _this2 = this;

      return this.props.restaurantsGroup.restaurantsIds.map(function (restaurantId) {

        // TODO: it's a workaround because we don't have the restaurant name
        var restaurant = new _entities.Restaurant();
        restaurant.id = restaurantId;

        return _react2.default.createElement(
          'div',
          {
            className: 'restaurant_row',
            onClick: function onClick() {
              _this2.props.onClick(restaurant);
            }
          },
          restaurantId
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'choose_restaurant_view'
        },
        _react2.default.createElement(
          'h3',
          { className: 'text-center' },
          this.props.restaurantsGroup.name
        ),
        _react2.default.createElement(
          'a',
          {
            onClick: this.props.onPrevious
          },
          'Pr\xE9c\xE9dent'
        ),
        this.renderRestaurantsList()
      );
    }
  }]);

  return ChooseRestaurantView;
}(_react.Component);

ChooseRestaurantView.defaultProps = {
  level: 0
};
ChooseRestaurantView.propTypes = {
  restaurantsGroup: _propTypes2.default.objectOf(_restaurantsGroup.RestaurantsGroup).isRequired,

  onClick: _propTypes2.default.func.isRequired,

  onPrevious: _propTypes2.default.func.isRequired
};
exports.default = ChooseRestaurantView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChooseRestaurantView, 'ChooseRestaurantView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/components/ChooseRestaurantView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/components/ChooseRestaurantsGroupListMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _ChooseRestaurantsGroupModal = __webpack_require__("./scripts/components/header/components/ChooseRestaurantsGroupModal.js");

var _ChooseRestaurantsGroupModal2 = _interopRequireDefault(_ChooseRestaurantsGroupModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var ChooseRestaurantsGroupListMenu = function (_Component) {
  _inherits(ChooseRestaurantsGroupListMenu, _Component);

  function ChooseRestaurantsGroupListMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseRestaurantsGroupListMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseRestaurantsGroupListMenu.__proto__ || Object.getPrototypeOf(ChooseRestaurantsGroupListMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayModal: false
    }, _this.onDisplayModal = function () {
      var _this2;

      return (_this2 = _this).__onDisplayModal__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHideModal = function () {
      var _this3;

      return (_this3 = _this).__onHideModal__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseRestaurantsGroupListMenu, [{
    key: '__onHideModal__REACT_HOT_LOADER__',
    value: function __onHideModal__REACT_HOT_LOADER__() {
      return this.__onHideModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayModal__REACT_HOT_LOADER__',
    value: function __onDisplayModal__REACT_HOT_LOADER__() {
      return this.__onDisplayModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayModal__REACT_HOT_LOADER__',
    value: function __onDisplayModal__REACT_HOT_LOADER__() {
      var restaurant = _stores.RestaurantStore.getRestaurant;
      var mainRestaurantGroupList = _stores.RestaurantStore.getRestaurantsGroup();

      if (mainRestaurantGroupList.isOnlyForTheRestaurantWithId(restaurant.id)) {
        return;
      }

      this.setState({
        displayModal: true
      });
    }
  }, {
    key: '__onHideModal__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onHideModal__REACT_HOT_LOADER__() {
      this.setState({
        displayModal: false
      });
    }
  }, {
    key: 'renderModal',
    value: function renderModal() {
      if (!this.state.displayModal) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ChooseRestaurantsGroupModal2.default, {
          show: true,
          onHide: this.onHideModal
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var restaurant = _stores.RestaurantStore.getRestaurant();
      var restaurantGroupList = _stores.RestaurantStore.getSelectedRestaurantsGroup();

      if (_lodash2.default.isNull(restaurant) || _lodash2.default.isNull(restaurantGroupList)) {
        return null;
      }

      var restaurantName = '';
      if (!_lodash2.default.isNull(restaurant)) {
        restaurantName = restaurant.name;
      }

      var restaurantGroupName = '';
      if (!_lodash2.default.isNull(restaurantGroupList)) {
        restaurantGroupName = restaurantGroupList.name;
      }

      var roleName = '';
      var meAccount = _stores.ProAccountStore.getMeAccount();
      if (!_lodash2.default.isNull(meAccount) && !_lodash2.default.isNull(meAccount.domainsList) && meAccount.domainsList.numberOfDomains() > 0) {
        roleName = _stores.ProAccountStore.getSelectedProDomain().role.name;
      }

      // we don't want to display AAA - AAA, but AAA
      if (restaurantGroupList.isOnlyForTheRestaurantWithId(restaurant.id)) {
        restaurantGroupName = '';
      }

      return _react2.default.createElement(
        'li',
        {
          onClick: this.onDisplayModal
        },
        _react2.default.createElement(
          'a',
          { href: '#' },
          roleName,
          !_lodash2.default.isEmpty(roleName) && _react2.default.createElement(
            'span',
            null,
            '\xA0-\xA0'
          ),
          restaurantGroupName,
          !_lodash2.default.isEmpty(restaurantGroupName) && _react2.default.createElement(
            'span',
            null,
            '\xA0-\xA0'
          ),
          restaurantName
        ),
        this.renderModal()
      );
    }
  }]);

  return ChooseRestaurantsGroupListMenu;
}(_react.Component);

exports.default = ChooseRestaurantsGroupListMenu;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChooseRestaurantsGroupListMenu, 'ChooseRestaurantsGroupListMenu', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/components/ChooseRestaurantsGroupListMenu.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/components/ChooseRestaurantsGroupModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _ProDomain = __webpack_require__("./sdk/scripts/entities/security/ProDomain.js");

var _ProDomain2 = _interopRequireDefault(_ProDomain);

var _ChooseRestaurantsGroupView = __webpack_require__("./scripts/components/header/components/ChooseRestaurantsGroupView.js");

var _ChooseRestaurantsGroupView2 = _interopRequireDefault(_ChooseRestaurantsGroupView);

var _ChooseRestaurantView = __webpack_require__("./scripts/components/header/components/ChooseRestaurantView.js");

var _ChooseRestaurantView2 = _interopRequireDefault(_ChooseRestaurantView);

var _ChooseProDomainView = __webpack_require__("./scripts/components/header/components/ChooseProDomainView.js");

var _ChooseProDomainView2 = _interopRequireDefault(_ChooseProDomainView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 */
var ChooseRestaurantsGroupModal = function (_Component) {
  _inherits(ChooseRestaurantsGroupModal, _Component);

  function ChooseRestaurantsGroupModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseRestaurantsGroupModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseRestaurantsGroupModal.__proto__ || Object.getPrototypeOf(ChooseRestaurantsGroupModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(), _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onProDomainClick = function () {
      var _this4;

      return (_this4 = _this).__onProDomainClick__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onRestaurantGroupClick = function () {
      var _this5;

      return (_this5 = _this).__onRestaurantGroupClick__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onRestaurantClick = function () {
      var _this6;

      return (_this6 = _this).__onRestaurantClick__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDisplayChooseRestaurantsGroupView = function () {
      var _this7;

      return (_this7 = _this).__onDisplayChooseRestaurantsGroupView__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseRestaurantsGroupModal, [{
    key: '__onDisplayChooseRestaurantsGroupView__REACT_HOT_LOADER__',
    value: function __onDisplayChooseRestaurantsGroupView__REACT_HOT_LOADER__() {
      return this.__onDisplayChooseRestaurantsGroupView__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantClick__REACT_HOT_LOADER__',
    value: function __onRestaurantClick__REACT_HOT_LOADER__() {
      return this.__onRestaurantClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantGroupClick__REACT_HOT_LOADER__',
    value: function __onRestaurantGroupClick__REACT_HOT_LOADER__() {
      return this.__onRestaurantGroupClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProDomainClick__REACT_HOT_LOADER__',
    value: function __onProDomainClick__REACT_HOT_LOADER__() {
      return this.__onProDomainClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      var restaurantGroupList = _stores.RestaurantStore.getRestaurantsGroup();

      var selectedRestaurantGroup = _stores.RestaurantStore.getSelectedRestaurantsGroup();
      var selectedRestaurant = _stores.RestaurantStore.getRestaurant();

      var proDomainsList = _stores.ProAccountStore.getMeAccount().domainsList;

      var selectedProDomain = _stores.ProAccountStore.getSelectedProDomain();

      var haveMultipleDomains = _stores.ProAccountStore.getMeAccount().domainsList.domains.length > 0;

      var haveMultipleGroupsList = selectedRestaurantGroup.haveChilds();

      return {
        restaurantGroupList: restaurantGroupList,
        selectedRestaurantGroup: selectedRestaurantGroup,
        selectedRestaurant: selectedRestaurant,
        proDomainsList: proDomainsList,
        selectedProDomain: selectedProDomain,
        displayDomainsList: haveMultipleDomains,

        // if there is only domain, we display directly the restaurants group list
        displayRestaurantsGroupList: !haveMultipleDomains && haveMultipleGroupsList,

        // if there is only one group without children, we display the restaurants list directly.
        displayRestaurantsList: !haveMultipleDomains && !haveMultipleGroupsList
      };
    }

    // -- events - modal

  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'selectRestaurant',
    value: function selectRestaurant(proDomain, restaurantGroup, restaurant) {
      _actions.ProAccountAction.changeProDomain(proDomain);
      _actions.RestaurantAction.retrieveRestaurantForGroup(restaurant, restaurantGroup);
      this.onClose();
    }

    //
    // Events
    //

  }, {
    key: '__onProDomainClick__REACT_HOT_LOADER__',
    value: function __onProDomainClick__REACT_HOT_LOADER__(selectedProDomain) {
      var selectedProDomainRestaurantGroup = selectedProDomain.restaurantsGroup;
      // const selectedProDomainRestaurantGroup = RestaurantStore.getRestaurantsGroup();

      var displayDomainsList = false;

      // if there is only one group without children, we display the restaurants list directly.
      var displayRestaurantsGroupList = selectedProDomainRestaurantGroup.haveChilds();
      var displayRestaurantsList = !selectedProDomainRestaurantGroup.haveChilds();

      // only one restaurantsGroup with one restaurant, let's go!
      if (!selectedProDomainRestaurantGroup.haveChilds() && !selectedProDomainRestaurantGroup.haveMultipleRestaurants()) {
        // TODO: change when we have restaurant name
        var restaurant = new _entities.Restaurant();
        restaurant.id = selectedProDomainRestaurantGroup.restaurantsIds[0];
        this.selectRestaurant(selectedProDomain, selectedProDomainRestaurantGroup, restaurant);
        return;
      }

      this.setState({
        selectedProDomain: selectedProDomain,
        selectedRestaurantGroup: selectedProDomainRestaurantGroup,
        restaurantGroupList: selectedProDomain.restaurantsGroup,
        displayDomainsList: displayDomainsList,
        displayRestaurantsGroupList: displayRestaurantsGroupList
      });
    }
  }, {
    key: '__onRestaurantGroupClick__REACT_HOT_LOADER__',
    value: function __onRestaurantGroupClick__REACT_HOT_LOADER__(selectedRestaurantGroup) {
      // only one restaurant, let's go!
      if (selectedRestaurantGroup.restaurantsIds.length === 1) {
        // TODO: change when we have restaurant name
        var restaurant = new _entities.Restaurant();
        restaurant.id = selectedRestaurantGroup.restaurantsIds[0];
        this.selectRestaurant(this.state.selectedProDomain, selectedRestaurantGroup, restaurant);
        return;
      }

      this.setState({
        selectedRestaurantGroup: selectedRestaurantGroup,
        displayRestaurantsGroupList: false,
        displayRestaurantsList: true
      });
    }
  }, {
    key: '__onRestaurantClick__REACT_HOT_LOADER__',
    value: function __onRestaurantClick__REACT_HOT_LOADER__(selectedRestaurant) {
      this.selectRestaurant(this.state.selectedProDomain, this.state.selectedRestaurantGroup, selectedRestaurant);
    }
  }, {
    key: '__onDisplayChooseRestaurantsGroupView__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onDisplayChooseRestaurantsGroupView__REACT_HOT_LOADER__() {
      this.setState({
        displayRestaurantsList: false,
        displayRestaurantsGroupList: true
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        { className: 'choose_restaurants_group_modal' },
        this.state.displayDomainsList && _react2.default.createElement(_ChooseProDomainView2.default, {
          proDomainsList: this.state.proDomainsList,
          selectedProDomain: this.state.selectedProDomain,
          onClick: this.onProDomainClick
        }),
        this.state.displayRestaurantsGroupList && _react2.default.createElement(_ChooseRestaurantsGroupView2.default, {
          restaurantsGroup: this.state.restaurantGroupList,
          selectedRestaurantsGroup: this.state.selectedRestaurantGroup,
          onClick: this.onRestaurantGroupClick
        }),
        this.state.displayRestaurantsList && _react2.default.createElement(_ChooseRestaurantView2.default, {
          restaurantsGroup: this.state.selectedRestaurantGroup,
          onClick: this.onRestaurantClick,
          onPrevious: this.onDisplayChooseRestaurantsGroupView
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.restaurants_group.choose.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return ChooseRestaurantsGroupModal;
}(_react.Component);

ChooseRestaurantsGroupModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired
};
exports.default = ChooseRestaurantsGroupModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChooseRestaurantsGroupModal, 'ChooseRestaurantsGroupModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/components/ChooseRestaurantsGroupModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/components/ChooseRestaurantsGroupView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseRestaurantsGroupView = function (_Component) {
  _inherits(ChooseRestaurantsGroupView, _Component);

  function ChooseRestaurantsGroupView() {
    _classCallCheck(this, ChooseRestaurantsGroupView);

    return _possibleConstructorReturn(this, (ChooseRestaurantsGroupView.__proto__ || Object.getPrototypeOf(ChooseRestaurantsGroupView)).apply(this, arguments));
  }

  _createClass(ChooseRestaurantsGroupView, [{
    key: 'renderSubList',


    //
    // Renderers
    //

    value: function renderSubList() {
      var _this2 = this;

      return this.props.restaurantsGroup.children.map(function (childrenRestaurantsGroup) {
        return _react2.default.createElement(ChooseRestaurantsGroupView, {
          key: childrenRestaurantsGroup.id,
          restaurantsGroup: childrenRestaurantsGroup,
          selectedRestaurantsGroup: _this2.props.selectedRestaurantsGroup,
          level: _this2.props.level + 1,
          onClick: _this2.props.onClick
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var className = (0, _classnames2.default)('group_name', {
        current: this.props.restaurantsGroup.id === this.props.selectedRestaurantsGroup.id
      });

      return _react2.default.createElement(
        'div',
        {
          className: 'choose_restaurants_group_view'
        },
        _react2.default.createElement(
          'div',
          {
            className: className,
            onClick: function onClick() {
              _this3.props.onClick(_this3.props.restaurantsGroup);
            }
          },
          this.props.restaurantsGroup.name
        ),
        this.renderSubList()
      );
    }
  }]);

  return ChooseRestaurantsGroupView;
}(_react.Component);

ChooseRestaurantsGroupView.defaultProps = {
  level: 0
};
ChooseRestaurantsGroupView.propTypes = {
  restaurantsGroup: _propTypes2.default.objectOf(_restaurantsGroup.RestaurantsGroup).isRequired,

  selectedRestaurantsGroup: _propTypes2.default.objectOf(_restaurantsGroup.RestaurantsGroup).isRequired,

  level: _propTypes2.default.number,

  onClick: _propTypes2.default.func.isRequired
};
exports.default = ChooseRestaurantsGroupView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChooseRestaurantsGroupView, 'ChooseRestaurantsGroupView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/components/ChooseRestaurantsGroupView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/header/components/ProDomainRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProDomainRow = function (_Component) {
  _inherits(ProDomainRow, _Component);

  function ProDomainRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProDomainRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProDomainRow.__proto__ || Object.getPrototypeOf(ProDomainRow)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this2;

      return (_this2 = _this).__onClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProDomainRow, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onClick__REACT_HOT_LOADER__() {
      this.props.onClick(this.props.proDomain);
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('choose_pro_domain_view__row', {
        current: this.props.isSelected
      });

      return _react2.default.createElement(
        'div',
        {
          className: className,
          onClick: this.onClick
        },
        this.props.proDomain.role.name,
        ' @ ',
        this.props.proDomain.restaurantsGroup.name
      );
    }
  }]);

  return ProDomainRow;
}(_react.Component);

ProDomainRow.propTypes = {
  proDomain: _propTypes2.default.objectOf(_security.ProDomain).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onClick: _propTypes2.default.func.isRequired
};
exports.default = ProDomainRow;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProDomainRow, 'ProDomainRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/header/components/ProDomainRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractComponent = exports.NoPermissionIcon = exports.Footer = exports.RoundButton = exports.OnLoadingContentView = exports.AbstractMenuComponent = exports.DayChooser = undefined;

var _DayChooser2 = __webpack_require__("./scripts/components/DayChooser.js");

var _DayChooser3 = _interopRequireDefault(_DayChooser2);

var _AbstractMenuComponent2 = __webpack_require__("./scripts/components/AbstractMenuComponent.js");

var _AbstractMenuComponent3 = _interopRequireDefault(_AbstractMenuComponent2);

var _OnLoadingContentView2 = __webpack_require__("./scripts/components/OnLoadingContentView.js");

var _OnLoadingContentView3 = _interopRequireDefault(_OnLoadingContentView2);

var _RoundButton2 = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton3 = _interopRequireDefault(_RoundButton2);

var _footer = __webpack_require__("./scripts/components/footer/index.js");

var _footer2 = _interopRequireDefault(_footer);

var _NoPermissionIcon2 = __webpack_require__("./scripts/components/security/NoPermissionIcon.js");

var _NoPermissionIcon3 = _interopRequireDefault(_NoPermissionIcon2);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DayChooser = _DayChooser3.default;
exports.AbstractMenuComponent = _AbstractMenuComponent3.default;
exports.OnLoadingContentView = _OnLoadingContentView3.default;
exports.RoundButton = _RoundButton3.default;
exports.Footer = _footer2.default;

// keep old path for the moment to ensure compatibility

exports.NoPermissionIcon = _NoPermissionIcon3.default;
exports.AbstractComponent = _AbstractComponent3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/components/menu/ItemSelectorModal/Item.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function Item(_ref) {
  var item = _ref.item,
      isSelected = _ref.isSelected,
      isMainCategory = _ref.isMainCategory,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    {
      onClick: onClick,
      className: 'pointer backgroundPrimary--hover colorWhite--hover',
      style: {
        height: '40px',
        lineHeight: '40px',
        fontSize: '13pt',
        paddingLeft: '20px'
      }
    },
    isMainCategory ? _I18n2.default.tr('menu.category.add_item.main_category') : item.name
  );
};

var _default = Item;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Item, 'Item', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/Item.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/Item.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/menu/ItemSelectorModal/ItemSelectorModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _ItemSelectorView = __webpack_require__("./scripts/components/menu/ItemSelectorModal/ItemSelectorView.js");

var _ItemSelectorView2 = _interopRequireDefault(_ItemSelectorView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- views


var ItemSelectorModal = function (_Component) {
  _inherits(ItemSelectorModal, _Component);

  function ItemSelectorModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemSelectorModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemSelectorModal.__proto__ || Object.getPrototypeOf(ItemSelectorModal)).call.apply(_ref, [this].concat(args))), _this), _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemSelectorModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('menu.item_selector.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(_ItemSelectorView2.default, {
            restaurantMenu: this.props.restaurantMenu,
            options: this.props.options,
            values: this.props.values,
            onChange: this.props.onChange
          })
        )
      );
    }
  }]);

  return ItemSelectorModal;
}(_react.Component);

ItemSelectorModal.propTypes = {
  show: _react.PropTypes.bool.isRequired,
  onHide: _react.PropTypes.func.isRequired,

  restaurantMenu: _react.PropTypes.objectOf(_RestaurantMenu2.default).isRequired,
  options: _react.PropTypes.array,
  values: _react.PropTypes.array,

  onChange: _react.PropTypes.func.isRequired
};
exports.default = ItemSelectorModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ItemSelectorModal, 'ItemSelectorModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/ItemSelectorModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/menu/ItemSelectorModal/ItemSelectorView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _SubmitArea = __webpack_require__("./sdk/scripts/components/form/SubmitArea.js");

var _SubmitArea2 = _interopRequireDefault(_SubmitArea);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _ItemTabView = __webpack_require__("./scripts/components/menu/ItemSelectorModal/ItemTabView.js");

var _ItemTabView2 = _interopRequireDefault(_ItemTabView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var ItemSelectorView = function (_Component) {
  _inherits(ItemSelectorView, _Component);

  function ItemSelectorView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemSelectorView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemSelectorView.__proto__ || Object.getPrototypeOf(ItemSelectorView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tab: null,
      values: _lodash2.default.clone(_this.props.values)
    }, _this.onTabChange = function () {
      var _this2;

      return (_this2 = _this).__onTabChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.getValuesFor = function () {
      var _this3;

      return (_this3 = _this).__getValuesFor__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.getOptionsFor = function () {
      var _this4;

      return (_this4 = _this).__getOptionsFor__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onToggleItem = function () {
      var _this5;

      return (_this5 = _this).__onToggleItem__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onSubmit = function () {
      var _this6;

      return (_this6 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onReset = function () {
      var _this7;

      return (_this7 = _this).__onReset__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemSelectorView, [{
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleItem__REACT_HOT_LOADER__',
    value: function __onToggleItem__REACT_HOT_LOADER__() {
      return this.__onToggleItem__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getOptionsFor__REACT_HOT_LOADER__',
    value: function __getOptionsFor__REACT_HOT_LOADER__() {
      return this.__getOptionsFor__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getValuesFor__REACT_HOT_LOADER__',
    value: function __getValuesFor__REACT_HOT_LOADER__() {
      return this.__getValuesFor__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__() {
      return this.__onTabChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !_lodash2.default.isEqual(this.props.values, this.state.values);
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__(tab) {
      this.setState({
        tab: tab
      });
    }
  }, {
    key: '__getValuesFor__REACT_HOT_LOADER__',
    value: function __getValuesFor__REACT_HOT_LOADER__(categoryItemType) {
      return this.state.values.filter(function (value) {
        return value.type === categoryItemType;
      });
    }
  }, {
    key: '__getOptionsFor__REACT_HOT_LOADER__',
    value: function __getOptionsFor__REACT_HOT_LOADER__(categoryItemType) {
      var options = this.props.options.filter(function (option) {
        return option.type === categoryItemType;
      });

      // will contains the items from the restaurantMenu
      var menuItems = [];

      if (categoryItemType === _CategoryItem2.default.Type.CATEGORY) {
        menuItems = this.props.restaurantMenu.categories;
      } else if (categoryItemType === _CategoryItem2.default.Type.MENU) {
        menuItems = this.props.restaurantMenu.menus;
      } else if (categoryItemType === _CategoryItem2.default.Type.PRODUCT) {
        menuItems = this.props.restaurantMenu.products;
      }

      // TODO: keep only the items on options array

      return menuItems;
    }
  }, {
    key: '__onToggleItem__REACT_HOT_LOADER__',


    // -- form
    value: function __onToggleItem__REACT_HOT_LOADER__(item, categoryItemType) {
      var values = this.state.values;

      // item is the restaurantMenu object, we transform it in a categoryItem
      var categoryItem = {
        id: item.id,
        type: categoryItemType
      };

      values = _ArrayUtils2.default.toggleObject(values, categoryItem, function (i) {
        return i.id === categoryItem.id && i.type === categoryItem.type;
      });
      this.setState({
        values: values
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      this.props.onChange(this.state.values);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        values: _lodash2.default.clone(this.props.values)
      });
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(
        'div',
        {
          style: {
            marginTop: '30px',
            textAlign: 'center'
          }
        },
        _react2.default.createElement(_SubmitArea2.default, {
          haveModifications: this.haveModifications(),
          onSubmit: this.onSubmit,
          onReset: this.onReset
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultValue: this.state.tab,
            onSelect: this.onTabChange,
            id: 'item_selector_tabs'
          },
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 1,
              title: _I18n2.default.tr('menu.category.categories')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_ItemTabView2.default, {
                restaurantMenu: this.props.restaurantMenu,
                options: this.getOptionsFor(_CategoryItem2.default.Type.CATEGORY),
                values: this.getValuesFor(_CategoryItem2.default.Type.CATEGORY),
                onToggleItem: function onToggleItem(item) {
                  return _this8.onToggleItem(item, _CategoryItem2.default.Type.CATEGORY);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 2,
              title: _I18n2.default.tr('menu.category.products')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_ItemTabView2.default, {
                restaurantMenu: this.props.restaurantMenu,
                options: this.getOptionsFor(_CategoryItem2.default.Type.PRODUCT),
                values: this.getValuesFor(_CategoryItem2.default.Type.PRODUCT),
                onToggleItem: function onToggleItem(item) {
                  return _this8.onToggleItem(item, _CategoryItem2.default.Type.PRODUCT);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 3,
              title: _I18n2.default.tr('menu.category.menus')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_ItemTabView2.default, {
                restaurantMenu: this.props.restaurantMenu,
                options: this.getOptionsFor(_CategoryItem2.default.Type.MENU),
                values: this.getValuesFor(_CategoryItem2.default.Type.MENU),
                onToggleItem: function onToggleItem(item) {
                  return _this8.onToggleItem(item, _CategoryItem2.default.Type.MENU);
                }
              })
            )
          )
        ),
        this.renderSubmitArea()
      );
    }
  }]);

  return ItemSelectorView;
}(_react.Component);

ItemSelectorView.defaultProps = {
  values: [],
  options: []
};
ItemSelectorView.propTypes = {
  restaurantMenu: _react.PropTypes.objectOf(_RestaurantMenu2.default).isRequired,
  options: _react.PropTypes.array.isRequired,
  values: _react.PropTypes.array.isRequired,
  onChange: _react.PropTypes.func.isRequired
};
var _default = ItemSelectorView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ItemSelectorView, 'ItemSelectorView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/ItemSelectorView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/ItemSelectorView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/menu/ItemSelectorModal/ItemTabView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Item = __webpack_require__("./scripts/components/menu/ItemSelectorModal/Item.js");

var _Item2 = _interopRequireDefault(_Item);

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var ItemTabView = function (_Component) {
  _inherits(ItemTabView, _Component);

  function ItemTabView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemTabView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemTabView.__proto__ || Object.getPrototypeOf(ItemTabView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      itemsQuery: '',

      selectedQuery: ''

      // -- search
    }, _this.onItemsQueryChange = function () {
      var _this2;

      return (_this2 = _this).__onItemsQueryChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onSelectedQueryChange = function () {
      var _this3;

      return (_this3 = _this).__onSelectedQueryChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemTabView, [{
    key: '__onSelectedQueryChange__REACT_HOT_LOADER__',
    value: function __onSelectedQueryChange__REACT_HOT_LOADER__() {
      return this.__onSelectedQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onItemsQueryChange__REACT_HOT_LOADER__',
    value: function __onItemsQueryChange__REACT_HOT_LOADER__() {
      return this.__onItemsQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onItemsQueryChange__REACT_HOT_LOADER__',
    value: function __onItemsQueryChange__REACT_HOT_LOADER__(itemsQuery) {
      this.setState({
        itemsQuery: itemsQuery
      });
    }
  }, {
    key: '__onSelectedQueryChange__REACT_HOT_LOADER__',
    value: function __onSelectedQueryChange__REACT_HOT_LOADER__(selectedQuery) {
      this.setState({
        selectedQuery: selectedQuery
      });
    }
  }, {
    key: 'renderSearchNoResults',
    value: function renderSearchNoResults() {
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'em',
          null,
          _I18n2.default.tr('menu.item_selector.search_no_results')
        )
      );
    }
  }, {
    key: 'renderColumn',
    value: function renderColumn(label, listView, query, onQueryChange) {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6' },
        _react2.default.createElement(
          'h4',
          null,
          label
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: query,
          onSearchInput: onQueryChange
        }),
        _react2.default.createElement(
          'div',
          {
            style: {
              maxHeight: '60vh',
              overflow: 'auto'
            }
          },
          listView
        )
      );
    }
  }, {
    key: 'renderItemsSelected',
    value: function renderItemsSelected(items) {
      var _this4 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(items) && !_lodash2.default.isEmpty(this.state.selectedQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(items) && _lodash2.default.isEmpty(this.state.selectedQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.item_selector.no_item_selected')
          )
        );
      } else {
        var sortedItemsList = _lodash2.default.sortBy(items, ['desc'], function (item) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(item.name).toLowerCase();
        });
        listView = sortedItemsList.map(function (item) {
          return _react2.default.createElement(_Item2.default, {
            key: item.id,
            item: item,
            isMainCategory: _this4.props.restaurantMenu.rootCategoryId === item.id,
            isSelected: true,
            onClick: function onClick() {
              return _this4.props.onToggleItem(item);
            }
          });
        });
      }

      return this.renderColumn(_I18n2.default.tr('menu.item_selector.selected'), listView, this.state.selectedQuery, this.onSelectedQueryChange);
    }
  }, {
    key: 'renderItemsUnselected',
    value: function renderItemsUnselected(items) {
      var _this5 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(items)) {
        listView = this.renderSearchNoResults();
      } else {
        var sortedItemsList = _lodash2.default.sortBy(items, ['desc'], function (item) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(item.name).toLowerCase();
        });
        listView = sortedItemsList.map(function (item) {
          return _react2.default.createElement(_Item2.default, {
            key: item.id,
            item: item,
            isSelected: false,
            isMainCategory: _this5.props.restaurantMenu.rootCategoryId === item.id,
            onClick: function onClick() {
              return _this5.props.onToggleItem(item);
            }
          });
        });
      }

      return this.renderColumn(_I18n2.default.tr('menu.item_selector.products_on_menu'), listView, this.state.itemsQuery, this.onItemsQueryChange);
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _this6 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.props.options, function (option) {
        var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this6.props.values, function (item) {
          return item.id === option.id;
        }));

        var query = isSelected ? _this6.state.selectedQuery : _this6.state.itemsQuery;
        if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, option.name)) {
          isSelected ? selected.push(option) : unselected.push(option);
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__products' },
        this.renderItemsUnselected(unselected),
        this.renderItemsSelected(selected)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderItems()
      );
    }
  }]);

  return ItemTabView;
}(_react.Component);

ItemTabView.propTypes = {
  options: _react.PropTypes.array.isRequired,
  values: _react.PropTypes.array.isRequired,
  onToggleItem: _react.PropTypes.func.isRequired
};
var _default = ItemTabView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ItemTabView, 'ItemTabView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/ItemTabView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/menu/ItemSelectorModal/ItemTabView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/modal/ContactModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _constants = __webpack_require__("./scripts/constants/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @parent Layout.js
 */
var ContactModal = function (_Component) {
  _inherits(ContactModal, _Component);

  function ContactModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactModal.__proto__ || Object.getPrototypeOf(ContactModal)).call.apply(_ref, [this].concat(args))), _this), _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show;
    }

    // -- events - modal

  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        { className: 'row contact_modal' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'h2',
            { className: 'text-center' },
            _I18n2.default.tr('components.contact_modal.send_mail_to'),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'a',
              { href: 'mailto:' + _constants.Constants.CONTACT_EMAIL, target: '_blank' },
              _constants.Constants.CONTACT_EMAIL
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.contact_modal.title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return ContactModal;
}(_react.Component);

ContactModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired
};
exports.default = ContactModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContactModal, 'ContactModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/modal/ContactModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/openingHours/AddOpeningHourModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _OpeningHour = __webpack_require__("./sdk/scripts/entities/OpeningHour.js");

var _OpeningHour2 = _interopRequireDefault(_OpeningHour);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _DayChooser = __webpack_require__("./scripts/components/DayChooser.js");

var _DayChooser2 = _interopRequireDefault(_DayChooser);

var _HourChooser = __webpack_require__("./sdk/scripts/components/form/HourChooser/index.js");

var _HourChooser2 = _interopRequireDefault(_HourChooser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var AddOpeningHourModal = function (_AbstractComponent) {
  _inherits(AddOpeningHourModal, _AbstractComponent);

  function AddOpeningHourModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddOpeningHourModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddOpeningHourModal.__proto__ || Object.getPrototypeOf(AddOpeningHourModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      day: _this.props.defaultDay,

      openingHour: _this.props.defaultOpeningHour
    }, _this.onOpeningHourChange = function () {
      var _this2;

      return (_this2 = _this).__onOpeningHourChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClosingHourChange = function () {
      var _this3;

      return (_this3 = _this).__onClosingHourChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDayChange = function () {
      var _this4;

      return (_this4 = _this).__onDayChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onSubmit = function () {
      var _this5;

      return (_this5 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.close = function () {
      var _this6;

      return (_this6 = _this).__close__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events

  _createClass(AddOpeningHourModal, [{
    key: '__close__REACT_HOT_LOADER__',
    value: function __close__REACT_HOT_LOADER__() {
      return this.__close__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDayChange__REACT_HOT_LOADER__',
    value: function __onDayChange__REACT_HOT_LOADER__() {
      return this.__onDayChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClosingHourChange__REACT_HOT_LOADER__',
    value: function __onClosingHourChange__REACT_HOT_LOADER__() {
      return this.__onClosingHourChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOpeningHourChange__REACT_HOT_LOADER__',
    value: function __onOpeningHourChange__REACT_HOT_LOADER__() {
      return this.__onOpeningHourChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOpeningHourChange__REACT_HOT_LOADER__',
    value: function __onOpeningHourChange__REACT_HOT_LOADER__(opening) {
      var openingHour = this.state.openingHour;
      openingHour.opening = opening;

      this.setState({
        openingHour: openingHour
      });
    }
  }, {
    key: '__onClosingHourChange__REACT_HOT_LOADER__',
    value: function __onClosingHourChange__REACT_HOT_LOADER__(closing) {
      var openingHour = this.state.openingHour;
      openingHour.closing = closing;

      this.setState({
        openingHour: openingHour
      });
    }
  }, {
    key: '__onDayChange__REACT_HOT_LOADER__',
    value: function __onDayChange__REACT_HOT_LOADER__(value) {
      this.setState({
        day: value
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var openingHour = this.state.openingHour;

      // TODO: validation
      if (openingHour.closing - openingHour.opening <= 0) {
        // TODO: display error invalid range.
      } else {
        this.props.onAddOpeningHourForDay(this.state.day, openingHour);
        this.close();
      }
    }
  }, {
    key: '__close__REACT_HOT_LOADER__',


    // -- renderers

    value: function __close__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'renderDayPicker',
    value: function renderDayPicker() {
      return _react2.default.createElement(_DayChooser2.default, {
        day: this.state.day,
        onChange: this.onDayChange
      });
    }
  }, {
    key: 'renderOpeningHour',
    value: function renderOpeningHour() {
      return _react2.default.createElement(_HourChooser2.default, {
        onChange: this.onOpeningHourChange,
        defaultValue: this.state.openingHour.opening
      });
    }
  }, {
    key: 'renderClosingHour',
    value: function renderClosingHour() {
      return _react2.default.createElement(_HourChooser2.default, {
        onChange: this.onClosingHourChange,
        defaultValue: this.state.openingHour.closing,
        withEndOfDay: true
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          {
            className: 'form form-horizontal booking_form',
            role: 'form',
            noValidate: true,
            onSubmit: this.onSubmit
          },
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'required col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('components.opening_hours.form_modal.day')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              this.renderDayPicker()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'required col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('components.opening_hours.form_modal.opening')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              this.renderOpeningHour()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'required col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('components.opening_hours.form_modal.closing')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              this.renderClosingHour()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-center' },
            _react2.default.createElement(
              'button',
              {
                type: 'submit',
                className: 'btn btn-primary',
                onClick: this.onSubmit
              },
              _I18n2.default.tr('components.opening_hours.form_modal.create')
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            bsSize: 'large',
            show: this.props.show,
            onHide: this.props.onHide
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            null,
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'close close-white',
                onClick: this.close
              },
              _react2.default.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              _I18n2.default.tr('components.opening_hours.form_modal.title')
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            this.renderBody()
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return AddOpeningHourModal;
}(_AbstractComponent3.default);

AddOpeningHourModal.defaultProps = {
  defaultOpeningHour: new _OpeningHour2.default(),
  defaultDay: _Constants2.default.Day.MONDAY
};
AddOpeningHourModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,

  onHide: _propTypes2.default.func.isRequired,

  // -- params: Number (Day), openingHour (OpeningHour)
  onAddOpeningHourForDay: _propTypes2.default.func.isRequired,

  defaultOpeningHour: _propTypes2.default.objectOf(_OpeningHour2.default),

  defaultDay: _propTypes2.default.number
};
var _default = AddOpeningHourModal;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddOpeningHourModal, 'AddOpeningHourModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/AddOpeningHourModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/AddOpeningHourModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/openingHours/OpeningHourView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _OpeningHour = __webpack_require__("./sdk/scripts/entities/OpeningHour.js");

var _OpeningHour2 = _interopRequireDefault(_OpeningHour);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var OpeningHourView = function (_Component) {
  _inherits(OpeningHourView, _Component);

  function OpeningHourView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OpeningHourView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpeningHourView.__proto__ || Object.getPrototypeOf(OpeningHourView)).call.apply(_ref, [this].concat(args))), _this), _this.onDelete = function () {
      var _this2;

      return (_this2 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- actions


  _createClass(OpeningHourView, [{
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onDelete__REACT_HOT_LOADER__() {
      this.props.onDelete(this.props.openingHour);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'opening_hours_for_day__hour' },
        this.props.openingHour.getFormatted(),
        !this.props.readOnly && _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0\xA0',
          _react2.default.createElement(
            'a',
            {
              className: 'link',
              onClick: this.onDelete
            },
            _react2.default.createElement('i', { className: 'fa fa-trash' })
          )
        )
      );
    }
  }]);

  return OpeningHourView;
}(_react.Component);

OpeningHourView.defaultProps = {
  readOnly: false
};
OpeningHourView.propTypes = {
  openingHour: _propTypes2.default.objectOf(_OpeningHour2.default).isRequired,

  // params: openingHour (OpeningHour)
  onDelete: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
var _default = OpeningHourView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OpeningHourView, 'OpeningHourView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/OpeningHourView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/OpeningHourView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/openingHours/OpeningHoursForDay.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _OpeningHour = __webpack_require__("./sdk/scripts/entities/OpeningHour.js");

var _OpeningHour2 = _interopRequireDefault(_OpeningHour);

var _OpeningHourView = __webpack_require__("./scripts/components/openingHours/OpeningHourView.js");

var _OpeningHourView2 = _interopRequireDefault(_OpeningHourView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OpeningHoursForDay = function (_Component) {
  _inherits(OpeningHoursForDay, _Component);

  function OpeningHoursForDay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OpeningHoursForDay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpeningHoursForDay.__proto__ || Object.getPrototypeOf(OpeningHoursForDay)).call.apply(_ref, [this].concat(args))), _this), _this.onDelete = function () {
      var _this2;

      return (_this2 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- actions


  _createClass(OpeningHoursForDay, [{
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',


    // -- renderers
    value: function __onDelete__REACT_HOT_LOADER__(openingHour) {
      this.props.onDelete(this.props.day, openingHour);
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this3 = this;

      var openingsHoursListView = [];

      var sortedOpeningHours = _lodash2.default.sortBy(this.props.openingsHours, ['asc'], function (hour) {
        return hour.opening;
      });

      var i = 0; // handle if there is same two hours.
      _lodash2.default.each(sortedOpeningHours, function (openingHour) {
        openingsHoursListView.push(_react2.default.createElement(_OpeningHourView2.default, {
          key: openingHour.opening + '_' + openingHour.closing + '_' + i,
          openingHour: openingHour,
          onDelete: _this3.onDelete,
          readOnly: _this3.props.readOnly
        }));
        ++i;
      });

      return openingsHoursListView;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'opening_hours_for_day' },
        this.renderList()
      );
    }
  }]);

  return OpeningHoursForDay;
}(_react.Component);

OpeningHoursForDay.defaultProps = {
  readOnly: false
};
OpeningHoursForDay.propTypes = {
  openingsHours: _propTypes2.default.arrayOf(_OpeningHour2.default).isRequired,

  day: _propTypes2.default.number.isRequired,

  // params: number (day), openingHour (OpeningHour)
  onDelete: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
var _default = OpeningHoursForDay;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OpeningHoursForDay, 'OpeningHoursForDay', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/OpeningHoursForDay.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/OpeningHoursForDay.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/openingHours/OpeningHoursForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _OpeningHours = __webpack_require__("./sdk/scripts/entities/OpeningHours.js");

var _OpeningHours2 = _interopRequireDefault(_OpeningHours);

var _OpeningHour = __webpack_require__("./sdk/scripts/entities/OpeningHour.js");

var _OpeningHour2 = _interopRequireDefault(_OpeningHour);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _OpeningHoursForDay = __webpack_require__("./scripts/components/openingHours/OpeningHoursForDay.js");

var _OpeningHoursForDay2 = _interopRequireDefault(_OpeningHoursForDay);

var _AddOpeningHourModal = __webpack_require__("./scripts/components/openingHours/AddOpeningHourModal.js");

var _AddOpeningHourModal2 = _interopRequireDefault(_AddOpeningHourModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


// -- views


var OpeningHoursForm = function (_AbstractComponent) {
  _inherits(OpeningHoursForm, _AbstractComponent);

  function OpeningHoursForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OpeningHoursForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpeningHoursForm.__proto__ || Object.getPrototypeOf(OpeningHoursForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayAddOpeningHourModal: false,

      addOpeningHourModalDefaultDay: _Constants2.default.Day.MONDAY
    }, _this.removeOpeningHourForDay = function () {
      var _this2;

      return (_this2 = _this).__removeOpeningHourForDay__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.addOpeningHourForDay = function () {
      var _this3;

      return (_this3 = _this).__addOpeningHourForDay__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.displayAddOpeningHourModal = function () {
      var _this4;

      return (_this4 = _this).__displayAddOpeningHourModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.hideAddOpeningHourModal = function () {
      var _this5;

      return (_this5 = _this).__hideAddOpeningHourModal__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events opening hour


  _createClass(OpeningHoursForm, [{
    key: '__hideAddOpeningHourModal__REACT_HOT_LOADER__',
    value: function __hideAddOpeningHourModal__REACT_HOT_LOADER__() {
      return this.__hideAddOpeningHourModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__displayAddOpeningHourModal__REACT_HOT_LOADER__',
    value: function __displayAddOpeningHourModal__REACT_HOT_LOADER__() {
      return this.__displayAddOpeningHourModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__addOpeningHourForDay__REACT_HOT_LOADER__',
    value: function __addOpeningHourForDay__REACT_HOT_LOADER__() {
      return this.__addOpeningHourForDay__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__removeOpeningHourForDay__REACT_HOT_LOADER__',
    value: function __removeOpeningHourForDay__REACT_HOT_LOADER__() {
      return this.__removeOpeningHourForDay__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__removeOpeningHourForDay__REACT_HOT_LOADER__',
    value: function __removeOpeningHourForDay__REACT_HOT_LOADER__(day, openingHour) {
      var openingHours = this.props.openingHours;
      openingHours.removeForDay(day, openingHour);
      this.props.onChange(openingHours);
    }
  }, {
    key: '__addOpeningHourForDay__REACT_HOT_LOADER__',


    // -- events modal
    value: function __addOpeningHourForDay__REACT_HOT_LOADER__(day, openingHour) {
      var openingHours = this.props.openingHours;
      openingHours.addForDay(day, openingHour);
      this.props.onChange(openingHours);
    }
  }, {
    key: '__displayAddOpeningHourModal__REACT_HOT_LOADER__',
    value: function __displayAddOpeningHourModal__REACT_HOT_LOADER__() {
      var defaultDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Constants2.default.Day.MONDAY;

      this.setState({
        displayAddOpeningHourModal: true,
        addOpeningHourModalDefaultDay: defaultDay
      });
    }
  }, {
    key: '__hideAddOpeningHourModal__REACT_HOT_LOADER__',


    // -- renderers
    value: function __hideAddOpeningHourModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddOpeningHourModal: false
      });
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var _this6 = this;

      if (this.props.readOnly) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary',
            onClick: function onClick(event) {
              event.preventDefault();_this6.displayAddOpeningHourModal();
            }
          },
          _I18n2.default.tr('components.opening_hours.form.add_opening_hour')
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var openingsHours = this.props.openingHours;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.monday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.MONDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.MONDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.MONDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.tuesday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.TUESDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.TUESDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.TUESDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.wednesday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.WEDNESDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.WEDNESDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.WEDNESDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.thursday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.THURSDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.THURSDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.THURSDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.friday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.FRIDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.FRIDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.FRIDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.saturday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.SATURDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.SATURDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.SATURDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block' },
            _react2.default.createElement(
              'h3',
              null,
              _lodash2.default.capitalize(_I18n2.default.tr('global.days.sunday'))
            ),
            this.renderAddForDayBtn(_Constants2.default.Day.SUNDAY),
            _react2.default.createElement(_OpeningHoursForDay2.default, {
              day: _Constants2.default.Day.SUNDAY,
              openingsHours: openingsHours.getForDay(_Constants2.default.Day.SUNDAY),
              onDelete: this.removeOpeningHourForDay,
              readOnly: this.props.readOnly
            })
          )
        )
      );
    }
  }, {
    key: 'renderAddForDayBtn',
    value: function renderAddForDayBtn(day) {
      var _this7 = this;

      if (this.props.readOnly) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'pointer',
          onClick: function onClick() {
            return _this7.displayAddOpeningHourModal(day);
          }
        },
        _react2.default.createElement('i', {
          className: 'fa fa-plus'
        }),
        '\xA0',
        _I18n2.default.tr('components.opening_hours.form.add_opening_hour')
      );
    }
  }, {
    key: 'renderAddOpeningHourModal',
    value: function renderAddOpeningHourModal() {
      if (!this.state.displayAddOpeningHourModal) {
        return null;
      }

      var defaultDay = this.state.addOpeningHourModalDefaultDay;

      // Get a default opening hour suggestion based on all the others opening hours
      var defaultOpeningHour = this.props.openingHours.getSuggestOpeningHourForDay(defaultDay);

      return _react2.default.createElement(_AddOpeningHourModal2.default, {
        show: this.state.displayAddOpeningHourModal,
        onHide: this.hideAddOpeningHourModal,
        onAddOpeningHourForDay: this.addOpeningHourForDay,
        defaultOpeningHour: defaultOpeningHour,
        defaultDay: defaultDay
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_settings_page' },
        _react2.default.createElement(
          'div',
          null,
          this.renderHeader(),
          this.renderBody(),
          this.renderAddOpeningHourModal()
        )
      );
    }
  }]);

  return OpeningHoursForm;
}(_AbstractComponent3.default);

OpeningHoursForm.defaultProps = {
  readOnly: false
};
OpeningHoursForm.propTypes = {
  openingHours: _propTypes2.default.objectOf(_OpeningHour2.default).isRequired,

  /**
   * @param OpeningHours
   */
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
exports.default = OpeningHoursForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OpeningHoursForm, 'OpeningHoursForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/openingHours/OpeningHoursForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/OrderStatusLabel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OrderStatusLabel;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderStatusLabel(_ref) {
  var status = _ref.status;

  return _react2.default.createElement(
    'div',
    {
      className: 'order_status_label order_status_label__' + status + ' label'
    },
    _utils.OrderViewUtils.getStatusLabel(status)
  );
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderStatusLabel, 'OrderStatusLabel', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/OrderStatusLabel.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/RowPricesView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var RowPricesView = function (_Component) {
  _inherits(RowPricesView, _Component);

  function RowPricesView() {
    _classCallCheck(this, RowPricesView);

    return _possibleConstructorReturn(this, (RowPricesView.__proto__ || Object.getPrototypeOf(RowPricesView)).apply(this, arguments));
  }

  _createClass(RowPricesView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'row_prices_view text-left' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_ON_SITE,
            style: styles.svg
          }),
          _react2.default.createElement(_EnabledDisabledIcon2.default, {
            className: 'vcenter',
            value: this.props.prices.onSite.available,
            style: styles.enabledDisabledIcon
          }),
          _react2.default.createElement(
            'span',
            {
              style: styles.price,
              className: 'vcenter'
            },
            _utils.CurrencyUtils.formatPriceWithCurrency(this.props.prices.onSite.priceIncludingTax, this.props.currencyCode)
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_TAKE_AWAY,
            style: styles.svg
          }),
          _react2.default.createElement(_EnabledDisabledIcon2.default, {
            className: 'vcenter',
            value: this.props.prices.takeAway.available,
            style: styles.enabledDisabledIcon
          }),
          _react2.default.createElement(
            'span',
            {
              style: styles.price,
              className: 'vcenter'
            },
            _utils.CurrencyUtils.formatPriceWithCurrency(this.props.prices.takeAway.priceIncludingTax, this.props.currencyCode)
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_DELIVERY,
            style: styles.svg
          }),
          _react2.default.createElement(_EnabledDisabledIcon2.default, {
            className: 'vcenter',
            value: this.props.prices.delivery.available,
            style: styles.enabledDisabledIcon
          }),
          _react2.default.createElement(
            'span',
            {
              style: styles.price,
              className: 'vcenter'
            },
            _utils.CurrencyUtils.formatPriceWithCurrency(this.props.prices.delivery.priceIncludingTax, this.props.currencyCode)
          )
        )
      );
    }
  }]);

  return RowPricesView;
}(_react.Component);

RowPricesView.propTypes = {
  prices: _propTypes2.default.objectOf(_menu.ProductPrices),
  currencyCode: _propTypes2.default.string
};
exports.default = RowPricesView;


var styles = {
  svg: {
    display: 'inline-block',
    width: '20px'
  },
  enabledDisabledIcon: {
    marginLeft: '10px'
  },
  price: {
    marginLeft: '6px',
    marginTop: '-8px'
  }
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RowPricesView, 'RowPricesView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/RowPricesView.js');

  __REACT_HOT_LOADER__.register(styles, 'styles', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/RowPricesView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowPricesView = exports.OrderStatusStepper = exports.OrderStatusLabel = undefined;

var _OrderStatusLabel2 = __webpack_require__("./scripts/components/order/OrderStatusLabel.js");

var _OrderStatusLabel3 = _interopRequireDefault(_OrderStatusLabel2);

var _OrderStatusStepper2 = __webpack_require__("./scripts/components/order/orderStatusStepper/OrderStatusStepper.js");

var _OrderStatusStepper3 = _interopRequireDefault(_OrderStatusStepper2);

var _RowPricesView2 = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView3 = _interopRequireDefault(_RowPricesView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.OrderStatusLabel = _OrderStatusLabel3.default;
exports.OrderStatusStepper = _OrderStatusStepper3.default;
exports.RowPricesView = _RowPricesView3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/components/order/orderCancelModal/OrderCancelModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderCancelModal = undefined;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _isNull = __webpack_require__("./node_modules/lodash/isNull.js");

var _isNull2 = _interopRequireDefault(_isNull);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Button = __webpack_require__("./sdk/scripts/components/Button.js");

var _Button2 = _interopRequireDefault(_Button);

var _OrderDetailView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderDetailView.js");

var _OrderDetailView2 = _interopRequireDefault(_OrderDetailView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderCancelModal = exports.OrderCancelModal = function OrderCancelModal(_ref) {
  var order = _ref.order,
      isLoading = _ref.isLoading,
      onHide = _ref.onHide,
      onSubmit = _ref.onSubmit,
      show = _ref.show,
      errorCancel = _ref.errorCancel,
      restaurantMenu = _ref.restaurantMenu,
      currencyCode = _ref.currencyCode;
  return _react2.default.createElement(
    _reactBootstrap.Modal,
    { bsSize: 'large', show: show, onHide: onHide },
    _react2.default.createElement(
      _reactBootstrap.Modal.Header,
      null,
      _react2.default.createElement(
        'button',
        { type: 'button', className: 'close close-white', onClick: onHide },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Modal.Title,
        null,
        _I18n2.default.tr('components.order.cancel.title')
      )
    ),
    _react2.default.createElement(
      _reactBootstrap.Modal.Body,
      null,
      isLoading && _react2.default.createElement(
        'div',
        { className: 'page_loading_show' },
        _react2.default.createElement(
          'div',
          { className: 'page_loading_show__gif' },
          _react2.default.createElement('img', { src: _ViewConstants2.default.Image.LOADING_BAR, role: 'presentation' })
        )
      ),
      !(0, _isNull2.default)(errorCancel) && _react2.default.createElement(
        'p',
        { className: 'alert alert-danger' },
        !_.isNil(errorCancel) && !_.isNil(errorCancel.localizedMessage) ? errorCancel.localizedMessage : _I18n2.default.tr('components.order.cancel.error')
      ),
      _react2.default.createElement(_OrderDetailView2.default, { order: order, onHide: onHide,
        restaurantMenu: restaurantMenu,
        currencyCode: currencyCode }),
      _react2.default.createElement(
        'p',
        { className: 'top-buffer-50' },
        _I18n2.default.tr('components.order.cancel.verifyCancel')
      ),
      order.isPayed() && _react2.default.createElement(
        'p',
        { style: { color: '#ffc107', whiteSpace: 'pre-line' } },
        order.irlPayment ? _I18n2.default.tr('components.order.cancel.noRefundCancel') : _I18n2.default.tr('components.order.cancel.refundCancel')
      )
    ),
    _react2.default.createElement(
      _reactBootstrap.Modal.Footer,
      null,
      _react2.default.createElement(
        _Button2.default,
        { className: 'btn btn-default', onClick: onHide },
        _I18n2.default.tr('components.order.cancel.close')
      ),
      _react2.default.createElement(
        _Button2.default,
        { className: 'btn btn-primary', onClick: onSubmit, disabled: !(0, _isNull2.default)(errorCancel) },
        _I18n2.default.tr('components.order.cancel.submit')
      )
    )
  );
};
var _default = OrderCancelModal;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderCancelModal, 'OrderCancelModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderCancelModal/OrderCancelModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderCancelModal/OrderCancelModal.js');
}();

;

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderDetailInfoView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _MobileAppInteractor = __webpack_require__("./scripts/utils/MobileAppInteractor.js");

var _MobileAppInteractor2 = _interopRequireDefault(_MobileAppInteractor);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _UserAddress = __webpack_require__("./sdk/scripts/entities/user/UserAddress.js");

var _UserAddress2 = _interopRequireDefault(_UserAddress);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _2 = __webpack_require__("./scripts/components/order/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OrderDetailInfoView = function (_Component) {
  _inherits(OrderDetailInfoView, _Component);

  function OrderDetailInfoView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderDetailInfoView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderDetailInfoView.__proto__ || Object.getPrototypeOf(OrderDetailInfoView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      order: _this.props.order.copy()
    }, _this.onPrintOrder = function () {
      var _this2;

      return (_this2 = _this).__onPrintOrder__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onChangeStatus = function () {
      var _this3;

      return (_this3 = _this).__onChangeStatus__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDisplayDeliveryAddressOnGoogleMap = function () {
      var _this4;

      return (_this4 = _this).__onDisplayDeliveryAddressOnGoogleMap__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderDetailInfoView, [{
    key: '__onDisplayDeliveryAddressOnGoogleMap__REACT_HOT_LOADER__',
    value: function __onDisplayDeliveryAddressOnGoogleMap__REACT_HOT_LOADER__() {
      return this.__onDisplayDeliveryAddressOnGoogleMap__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeStatus__REACT_HOT_LOADER__',
    value: function __onChangeStatus__REACT_HOT_LOADER__() {
      return this.__onChangeStatus__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPrintOrder__REACT_HOT_LOADER__',
    value: function __onPrintOrder__REACT_HOT_LOADER__() {
      return this.__onPrintOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPrintOrder__REACT_HOT_LOADER__',
    value: function __onPrintOrder__REACT_HOT_LOADER__() {
      this.props.onPrintOrder(this.order);
    }
  }, {
    key: '__onChangeStatus__REACT_HOT_LOADER__',
    value: function __onChangeStatus__REACT_HOT_LOADER__(newStatus) {
      var order = this.order;
      order.status = newStatus;
      this.props.onSave(order);
    }
  }, {
    key: '__onDisplayDeliveryAddressOnGoogleMap__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onDisplayDeliveryAddressOnGoogleMap__REACT_HOT_LOADER__() {
      // const url = GmapUtils.getGoogleMapsUrl(this.order.address.geoPt, 12);
      var url = _utils.GmapUtils.getGoogleMapsDirectionUrl(this.order.address.geoPt, _RestaurantStore2.default.getRestaurant().geoPt, 12);
      window.open(url, '_blank');
    }
  }, {
    key: 'renderOnSiteClientInfo',
    value: function renderOnSiteClientInfo() {
      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__client_info__on_site' },
        _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__order_mode_icon' },
          !this.order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_ON_SITE
          }),
          this.order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_AT_BAR
          })
        ),
        !_lodash2.default.isEmpty(this.order.getTableNumberString()) && _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__table_number' },
          'Table : ',
          this.order.getTableNumberString()
        ),
        !_lodash2.default.isEmpty(this.order.getFormattedDueDate()) && _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__pickup_date' },
          _I18n2.default.tr('components.order.detail.arrival_date'),
          ' ',
          this.order.getFormattedDueDate()
        )
      );
    }
  }, {
    key: 'renderTakeAwayClientInfo',
    value: function renderTakeAwayClientInfo() {
      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__client_info__take_away' },
        _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__order_mode_icon' },
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_TAKE_AWAY
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__pickup_date' },
          _I18n2.default.tr('components.order.detail.pickup_date'),
          ' ',
          this.order.getFormattedDueDate()
        )
      );
    }
  }, {
    key: 'renderDeliveryClientInfo',
    value: function renderDeliveryClientInfo() {
      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__client_info__delivery' },
        _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__order_mode_icon' },
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_DELIVERY
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__client_info__pickup_date' },
          _I18n2.default.tr('components.order.detail.delivery_date'),
          ' ',
          this.order.getFormattedDueDate()
        )
      );
    }
  }, {
    key: 'renderHeaderMode',
    value: function renderHeaderMode() {
      switch (this.order.mode) {
        case _order.Order.OrderMode.ON_SITE:
          return this.renderOnSiteClientInfo();
        case _order.Order.OrderMode.TAKE_AWAY:
          return this.renderTakeAwayClientInfo();
        case _order.Order.OrderMode.DELIVERY:
          return this.renderDeliveryClientInfo();
        default:
          _utils.Logger.warning('ORDER', 'Invalid order mode ' + this.order.mode);
          return null;
      }
    }
  }, {
    key: 'renderClientInfo',
    value: function renderClientInfo() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('components.order.detail.order_number'),
          this.order.getOrderNumber()
        ),
        this.order.source.platform === _ApiConstants2.default.Platform.KIOSK ? _react2.default.createElement(
          'p',
          null,
          !_lodash2.default.isEmpty(this.order.source.identifier) && _I18n2.default.tr('components.order.detail.kiosk_number') + ' ' + this.order.source.identifier
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'order_detail_info_view__client_info__client_name' },
            !_lodash2.default.isNull(this.order.user) && (this.order.user.firstName || '') + ' ' + (this.order.user.lastName || '')
          ),
          _react2.default.createElement(
            'div',
            { className: 'order_detail_info_view__client_info__client_phone' },
            !_lodash2.default.isNull(this.order.user) && _react2.default.createElement(
              'a',
              {
                href: 'tel:' + this.order.user.phone,
                className: 'link'
              },
              _utils.PhoneUtils.format(this.order.user.phone)
            )
          )
        )
      );
    }
  }, {
    key: 'renderDeliveryAddress',
    value: function renderDeliveryAddress() {
      if (!this.order.isDeliveryMode()) {
        return null;
      }

      var address = this.order.address;

      if (_lodash2.default.isNil(address)) {
        // handle old orders with no address
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__delivery_address' },
        _react2.default.createElement(
          'div',
          {
            className: 'pointer',
            onClick: this.onDisplayDeliveryAddressOnGoogleMap
          },
          address.street,
          _react2.default.createElement('br', null),
          address.postCode,
          ' - ',
          address.city
        ),
        _react2.default.createElement('br', null),
        address.complement,
        _react2.default.createElement('br', null),
        address.instructions
      );
    }
  }, {
    key: 'renderComment',
    value: function renderComment() {
      if (_lodash2.default.isEmpty(this.order.comment)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__comment_view' },
        _I18n2.default.tr('components.order.detail.general_comment'),
        '\xA0',
        _react2.default.createElement(
          'span',
          { className: 'order_detail_info_view__comment' },
          this.order.comment
        )
      );
    }
  }, {
    key: 'renderStatus',
    value: function renderStatus() {
      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__status_label' },
        _I18n2.default.tr('components.order.detail.status'),
        ' ',
        _utils.OrderViewUtils.getStatusLabel(this.order.status)
      );
    }
  }, {
    key: 'renderTotal',
    value: function renderTotal() {
      if (this.order.isCanceled() || this.order.isFailed()) {
        return null;
      }

      if (!this.order.isPayed()) {
        return _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__total text-danger' },
          _I18n2.default.tr('components.order.detail.order_total'),
          ' ',
          _utils.CurrencyUtils.formatPriceWithCurrency(this.order.getTotalPrice(), this.currencyCode)
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__total' },
        _I18n2.default.tr('components.order.detail.order_total'),
        ' ',
        _utils.CurrencyUtils.formatPriceWithCurrency(this.order.check.total, this.currencyCode)
      );
    }
  }, {
    key: 'renderPaymentStatus',
    value: function renderPaymentStatus() {
      if (this.order.isCanceled() || this.order.isFailed()) {
        return _react2.default.createElement(
          'div',
          { className: 'pull-right' },
          _react2.default.createElement(
            'h3',
            { className: 'text-danger text-uppercase' },
            '\u2716 ',
            _utils.OrderViewUtils.getStatusLabel(this.order.status)
          )
        );
      }
      if (!this.order.isPayed()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'pull-right' },
        _react2.default.createElement(
          'h3',
          { className: 'text-success text-uppercase' },
          '\u2714 ',
          _I18n2.default.tr('components.order.detail.has_paid')
        )
      );
    }
  }, {
    key: 'renderOnSitePayment',
    value: function renderOnSitePayment() {
      if (this.order.isPayed()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__on_site_payment' },
        _I18n2.default.tr('components.order.detail.on_site_payment')
      );
    }
  }, {
    key: 'renderChangeStatus',
    value: function renderChangeStatus() {
      // DELIVERED, nothing more to do.
      if (this.order.status === _order.Order.OrderStatus.DELIVERED) {
        return null;
      }

      var nextStatus = _order.Order.getNextStatusForRestaurateur(this.order.status, this.props.order.mode);

      if (this.state.changingStatus) {
        return _react2.default.createElement(
          'div',
          { className: 'order_detail_info_view__status_change' },
          _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view__status_change' },
        _react2.default.createElement(_2.OrderStatusStepper, {
          status: this.order.status,
          orderMode: this.order.mode,
          nextStatus: nextStatus,
          onNextStatus: this.onChangeStatus
        })
      );
    }
  }, {
    key: 'renderPrint',
    value: function renderPrint() {
      if (!_MobileAppInteractor2.default.printerIsAvailable()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            className: 'btn',
            onClick: this.onPrintOrder
          },
          _react2.default.createElement('i', { className: 'fa fa-print' }),
          ' ',
          _I18n2.default.tr('order.print')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_detail_info_view row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          this.renderHeaderMode()
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          this.renderPaymentStatus(),
          this.renderClientInfo(),
          this.renderDeliveryAddress(),
          this.renderTotal(),
          this.renderOnSitePayment(),
          this.renderComment(),
          this.renderPrint()
        )
      );
    }
  }, {
    key: 'order',
    get: function get() {
      return this.state.order;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }

    //
    // View events
    //

  }]);

  return OrderDetailInfoView;
}(_react.Component);

OrderDetailInfoView.propTypes = {
  order: _propTypes2.default.objectOf(_order.Order).isRequired,

  onSave: _propTypes2.default.func.isRequired,

  onPrintOrder: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};
exports.default = OrderDetailInfoView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderDetailInfoView, 'OrderDetailInfoView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderDetailInfoView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderDetailModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _OrderDetailView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderDetailView.js");

var _OrderDetailView2 = _interopRequireDefault(_OrderDetailView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


/**
 * @parent Layout.js
 */
var OrderDetailModal = function (_Component) {
  _inherits(OrderDetailModal, _Component);

  function OrderDetailModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderDetailModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderDetailModal.__proto__ || Object.getPrototypeOf(OrderDetailModal)).call.apply(_ref, [this].concat(args))), _this), _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderDetailModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show;
    }

    // -- events - modal

  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(_OrderDetailView2.default, {
        order: this.props.order,
        onHide: this.props.onHide,
        currencyCode: this.props.currencyCode
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.order.detail.order_detail')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return OrderDetailModal;
}(_react.Component);

OrderDetailModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,

  onHide: _propTypes2.default.func.isRequired,

  order: _propTypes2.default.objectOf(_order.Order).isRequired,

  currencyCode: _propTypes2.default.string

};
exports.default = OrderDetailModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderDetailModal, 'OrderDetailModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderDetailModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderDetailView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _MobileAppInteractor = __webpack_require__("./scripts/utils/MobileAppInteractor.js");

var _MobileAppInteractor2 = _interopRequireDefault(_MobileAppInteractor);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _OrderDetailInfoView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderDetailInfoView.js");

var _OrderDetailInfoView2 = _interopRequireDefault(_OrderDetailInfoView);

var _OrderProductView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderProductView.js");

var _OrderProductView2 = _interopRequireDefault(_OrderProductView);

var _OrderMenuView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderMenuView.js");

var _OrderMenuView2 = _interopRequireDefault(_OrderMenuView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OrderDetailView = function (_Component) {
  _inherits(OrderDetailView, _Component);

  function OrderDetailView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderDetailView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderDetailView.__proto__ || Object.getPrototypeOf(OrderDetailView)).call.apply(_ref, [this].concat(args))), _this), _this.onOrderUpdate = function () {
      var _this2;

      return (_this2 = _this).__onOrderUpdate__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onError = function () {
      var _this3;

      return (_this3 = _this).__onError__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSaveOrder = function () {
      var _this4;

      return (_this4 = _this).__onSaveOrder__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onPrintOrder = function () {
      var _this5;

      return (_this5 = _this).__onPrintOrder__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderDetailView, [{
    key: '__onPrintOrder__REACT_HOT_LOADER__',
    value: function __onPrintOrder__REACT_HOT_LOADER__() {
      return this.__onPrintOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSaveOrder__REACT_HOT_LOADER__',
    value: function __onSaveOrder__REACT_HOT_LOADER__() {
      return this.__onSaveOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderUpdate__REACT_HOT_LOADER__',
    value: function __onOrderUpdate__REACT_HOT_LOADER__() {
      return this.__onOrderUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.OrdersListStore.addListeners(this.ordersListListeners);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.OrdersListStore.removeListeners(this.ordersListListeners);
    }
  }, {
    key: '__onOrderUpdate__REACT_HOT_LOADER__',
    value: function __onOrderUpdate__REACT_HOT_LOADER__() {
      // TODO: hide only if we have changed the status.
      this.props.onHide();
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      // TODO
    }
  }, {
    key: '__onSaveOrder__REACT_HOT_LOADER__',
    value: function __onSaveOrder__REACT_HOT_LOADER__(order) {
      _actions.OrderAction.updateOrder(order);
    }
  }, {
    key: '__onPrintOrder__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onPrintOrder__REACT_HOT_LOADER__() {
      var restaurant = _RestaurantStore2.default.getRestaurant();
      _MobileAppInteractor2.default.printOrder(this.order, restaurant);
    }
  }, {
    key: 'renderInfo',
    value: function renderInfo() {
      return _react2.default.createElement(_OrderDetailInfoView2.default, {
        order: this.order,
        onSave: this.onSaveOrder,
        onPrintOrder: this.onPrintOrder,
        currencyCode: this.currencyCode

      });
    }
  }, {
    key: 'renderMenus',
    value: function renderMenus() {
      var _this6 = this;

      var menusWithQuantities = this.order.getMenusWithQuantities();

      // Note: we don't trust the orderId as key because the other fronts set it, and some duplicates
      // can appears

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50' },
        menusWithQuantities.map(function (menuWithQuantity, index) {
          var orderMenu = menuWithQuantity.orderMenu;
          var quantity = menuWithQuantity.quantity;

          return _react2.default.createElement(_OrderMenuView2.default, {
            key: orderMenu.orderId + '_' + index,
            orderMenu: orderMenu,
            quantity: quantity,
            currencyCode: _this6.currencyCode
          });
        })
      );
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this7 = this;

      var productsWithQuantities = this.order.getProductsWithQuantities();

      // Note: we don't trust the orderId as key because the other fronts set it, and some duplicates
      // can appears

      return _react2.default.createElement(
        'div',
        null,
        productsWithQuantities.map(function (productWithQuantity, index) {
          var orderProduct = productWithQuantity.orderProduct;
          var quantity = productWithQuantity.quantity;

          return _react2.default.createElement(_OrderProductView2.default, {
            key: orderProduct.orderId + '_' + index,
            orderProduct: orderProduct,
            onMenu: false,
            quantity: quantity,
            currencyCode: _this7.currencyCode
          });
        })
      );
    }
  }, {
    key: 'renderFees',
    value: function renderFees() {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        { className: 'order_detail__fees text-right' },
        (this.order.fees || []).map(function (fee) {
          var name = _ArrayUtils2.default.find(fee.name, function (locale) {
            return locale.locale && _lodash2.default.startsWith(locale.locale.toLowerCase(), _I18n2.default.getCurrentLanguageWithoutRegionCode());
          });
          return _react2.default.createElement(
            'div',
            null,
            (name || fee.name[0]).text + ' : ' + _utils.CurrencyUtils.formatPriceWithCurrency(fee.amountIncludingTax, _this8.currencyCode)
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_detail' },
        this.renderInfo(),
        this.renderMenus(),
        this.renderProducts(),
        _react2.default.createElement(
          'div',
          { className: 'order_detail__prices' },
          this.renderFees(),
          this.order.isPayed() && !this.order.isFailed() ? _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _I18n2.default.tr('components.order.detail.order_total'),
            ' ',
            _utils.CurrencyUtils.formatPriceWithCurrency(this.order.check.total, this.currencyCode)
          ) : _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _I18n2.default.tr('components.order.detail.order_total'),
            ' ',
            _utils.CurrencyUtils.formatPriceWithCurrency(this.order.getTotalPrice(), this.currencyCode)
          )
        )
      );
    }
  }, {
    key: 'ordersListListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.UPDATE_ORDER_SUCCESS, this.onOrderUpdate), new _Listener2.default(_Events2.default.UPDATE_ORDER_FAILURE, this.onError)];
    }
  }, {
    key: 'order',
    get: function get() {
      return this.props.order;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }

    //
    // Api events
    //

  }]);

  return OrderDetailView;
}(_react.Component);

OrderDetailView.propTypes = {
  order: _propTypes2.default.objectOf(_order.Order).isRequired,

  onHide: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string
};
var _default = OrderDetailView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderDetailView, 'OrderDetailView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderDetailView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderDetailView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderMenuPartView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _OrderProductView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderProductView.js");

var _OrderProductView2 = _interopRequireDefault(_OrderProductView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OrderMenuPartView = function (_Component) {
  _inherits(OrderMenuPartView, _Component);

  function OrderMenuPartView() {
    _classCallCheck(this, OrderMenuPartView);

    return _possibleConstructorReturn(this, (OrderMenuPartView.__proto__ || Object.getPrototypeOf(OrderMenuPartView)).apply(this, arguments));
  }

  _createClass(OrderMenuPartView, [{
    key: 'renderName',


    //
    // Renderers
    //

    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'order_menu_part_view__name' },
        this.orderMenuPart.name
      );
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this2 = this;

      // Note: we don't trust the orderId as key because the other fronts set it, and some duplicates
      // can appears

      return _react2.default.createElement(
        'div',
        { className: 'order_menu_part_view__products' },
        this.orderMenuPart.products.map(function (orderProduct, index) {
          return _react2.default.createElement(_OrderProductView2.default, {
            key: orderProduct.orderId + '_' + index,
            orderProduct: orderProduct,
            onMenu: true,
            currencyCode: _this2.currencyCode
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_menu_part_view' },
        this.renderProducts()
      );
    }
  }, {
    key: 'orderMenuPart',
    get: function get() {
      return this.props.orderMenuPart;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return OrderMenuPartView;
}(_react.Component);

OrderMenuPartView.propTypes = {
  orderMenuPart: _propTypes2.default.objectOf(_order.OrderMenuPart).isRequired,
  currencyCode: _propTypes2.default.string

};
exports.default = OrderMenuPartView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderMenuPartView, 'OrderMenuPartView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderMenuPartView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderMenuView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _OrderMenuPartView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderMenuPartView.js");

var _OrderMenuPartView2 = _interopRequireDefault(_OrderMenuPartView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OrderMenuView = function (_Component) {
  _inherits(OrderMenuView, _Component);

  function OrderMenuView() {
    _classCallCheck(this, OrderMenuView);

    return _possibleConstructorReturn(this, (OrderMenuView.__proto__ || Object.getPrototypeOf(OrderMenuView)).apply(this, arguments));
  }

  _createClass(OrderMenuView, [{
    key: 'renderHeader',


    //
    // Renderers
    //

    value: function renderHeader() {
      var price = this.orderMenu.getTotalPrice() * this.props.quantity;

      var className = (0, _classnames2.default)('order_menu_view__header', {
        'order_menu_view__header_with_price': price > 0
      });

      return _react2.default.createElement(
        'div',
        { className: className },
        this.renderQuantity(),
        this.renderName(),
        this.renderPrice(price)
      );
    }
  }, {
    key: 'renderQuantity',
    value: function renderQuantity() {
      return _react2.default.createElement(
        'div',
        { className: 'order_menu_view__quantity' },
        _react2.default.createElement(
          'span',
          null,
          this.props.quantity,
          'x'
        )
      );
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'order_menu_view__name' },
        this.orderMenu.name
      );
    }
  }, {
    key: 'renderPrice',
    value: function renderPrice(price) {
      if (price > 0) {
        return _react2.default.createElement(
          'div',
          { className: 'order_menu_view__price' },
          _utils.CurrencyUtils.formatPriceWithCurrency(price, this.currencyCode)
        );
      }

      return null;
    }
  }, {
    key: 'renderComment',
    value: function renderComment() {
      if (_lodash2.default.isEmpty(this.orderMenu.comment)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_menu_view__comment' },
        this.orderMenu.comment
      );
    }
  }, {
    key: 'renderParts',
    value: function renderParts() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'order_menu_view__parts' },
        this.orderMenu.parts.map(function (orderMenuPart, index) {
          return _react2.default.createElement(_OrderMenuPartView2.default, {
            key: orderMenuPart.id + '_' + index,
            orderMenuPart: orderMenuPart,
            currencyCode: _this2.currencyCode
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_menu_view' },
        this.renderHeader(),
        this.renderComment(),
        this.renderParts()
      );
    }
  }, {
    key: 'orderMenu',
    get: function get() {
      return this.props.orderMenu;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return OrderMenuView;
}(_react.Component);

OrderMenuView.propTypes = {
  orderMenu: _propTypes2.default.objectOf(_order.OrderMenu).isRequired,

  menu: _propTypes2.default.objectOf(_menu.Menu).isRequired,

  quantity: _propTypes2.default.number.isRequired,

  currencyCode: _propTypes2.default.string

};
exports.default = OrderMenuView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderMenuView, 'OrderMenuView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderMenuView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderProductOptionValueView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var OrderProductOptionView = function (_Component) {
  _inherits(OrderProductOptionView, _Component);

  function OrderProductOptionView() {
    _classCallCheck(this, OrderProductOptionView);

    return _possibleConstructorReturn(this, (OrderProductOptionView.__proto__ || Object.getPrototypeOf(OrderProductOptionView)).apply(this, arguments));
  }

  _createClass(OrderProductOptionView, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('order_product_option_value_view', {
        'order_product_option_value_view__with_price': this.props.orderProductOptionValue.additionalPrice > 0
      });

      return _react2.default.createElement(
        'div',
        { className: className },
        this.props.quantity > 0 && _react2.default.createElement(
          'div',
          { className: 'order_product_option_value_view__quantity' },
          this.props.quantity
        ),
        _react2.default.createElement(
          'div',
          { className: 'order_product_option_value_view__name' },
          this.props.orderProductOptionValue.name,
          _react2.default.createElement(
            'div',
            { className: 'order_product_option_value_view__product_option_name' },
            this.props.orderProductOption.name
          )
        )
      );
    }
  }]);

  return OrderProductOptionView;
}(_react.Component);

OrderProductOptionView.propTypes = {
  orderProductOptionValue: _propTypes2.default.objectOf(_order.OrderProductOptionValue).isRequired,

  orderProductOption: _propTypes2.default.objectOf(_order.OrderProductOption).isRequired,

  quantity: _propTypes2.default.number.isRequired
};
exports.default = OrderProductOptionView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderProductOptionView, 'OrderProductOptionView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderProductOptionValueView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderProductOptionView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _OrderProductOptionValueView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderProductOptionValueView.js");

var _OrderProductOptionValueView2 = _interopRequireDefault(_OrderProductOptionValueView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OrderProductOptionView = function (_Component) {
  _inherits(OrderProductOptionView, _Component);

  function OrderProductOptionView() {
    _classCallCheck(this, OrderProductOptionView);

    return _possibleConstructorReturn(this, (OrderProductOptionView.__proto__ || Object.getPrototypeOf(OrderProductOptionView)).apply(this, arguments));
  }

  _createClass(OrderProductOptionView, [{
    key: 'renderName',


    //
    // Renderers
    //

    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'order_product_option_view__name' },
        this.orderProductOption.name
      );
    }
  }, {
    key: 'renderValues',
    value: function renderValues() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'order_product_option_view__values' },
        this.orderProductOption.values.map(function (orderProductOptionValue, index) {
          return _react2.default.createElement(_OrderProductOptionValueView2.default, {
            key: orderProductOptionValue.id + '_' + index,
            orderProductOptionValue: orderProductOptionValue,
            orderProductOption: _this2.orderProductOption,
            quantity: 0
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_product_option_view' },
        this.renderValues()
      );
    }
  }, {
    key: 'orderProductOption',
    get: function get() {
      return this.props.orderProductOption;
    }
  }]);

  return OrderProductOptionView;
}(_react.Component);

OrderProductOptionView.propTypes = {
  orderProductOption: _propTypes2.default.objectOf(_order.OrderProductOption).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired
};
exports.default = OrderProductOptionView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderProductOptionView, 'OrderProductOptionView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderProductOptionView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderDetailModal/OrderProductView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _OrderProductOptionView = __webpack_require__("./scripts/components/order/orderDetailModal/OrderProductOptionView.js");

var _OrderProductOptionView2 = _interopRequireDefault(_OrderProductOptionView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OrderProductView = function (_Component) {
  _inherits(OrderProductView, _Component);

  function OrderProductView() {
    _classCallCheck(this, OrderProductView);

    return _possibleConstructorReturn(this, (OrderProductView.__proto__ || Object.getPrototypeOf(OrderProductView)).apply(this, arguments));
  }

  _createClass(OrderProductView, [{
    key: 'renderHeader',


    //
    // Renderers
    //

    value: function renderHeader() {
      var price = (this.props.onMenu ? this.orderProduct.getTotalAdditionnalPriceForMenu() : this.orderProduct.getTotalPrice()) * this.props.quantity;

      var className = (0, _classnames2.default)('order_product_view__header', {
        'order_product_view__header_with_price': price > 0 && !this.props.onMenu
      });

      return _react2.default.createElement(
        'div',
        { className: className },
        this.renderQuantity(),
        this.renderName(),
        this.renderPrice(price)
      );
    }
  }, {
    key: 'renderQuantity',
    value: function renderQuantity() {
      var className = (0, _classnames2.default)('order_product_view__quantity', {
        order_product_view__quantity_multiple: this.props.quantity > 1
      });
      return _react2.default.createElement(
        'div',
        { className: className },
        this.props.quantity > 0 && _react2.default.createElement(
          'span',
          null,
          this.props.quantity,
          'x'
        )
      );
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'order_product_view__name' },
        this.orderProduct.name
      );
    }
  }, {
    key: 'renderPrice',
    value: function renderPrice(price) {
      if (this.props.onMenu) {
        return null;
      }

      if (price > 0) {
        return _react2.default.createElement(
          'div',
          { className: 'order_product_view__price' },
          _utils.CurrencyUtils.formatPriceWithCurrency(price, this.currencyCode)
        );
      }

      return null;
    }
  }, {
    key: 'renderComment',
    value: function renderComment() {
      if (_lodash2.default.isEmpty(this.orderProduct.comment)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_product_view__comment' },
        this.orderProduct.comment
      );
    }
  }, {
    key: 'renderOptions',
    value: function renderOptions() {
      return _react2.default.createElement(
        'div',
        { className: 'order_product_view__options' },
        this.orderProduct.options.map(function (orderProductOption, index) {
          return _react2.default.createElement(_OrderProductOptionView2.default, {
            key: orderProductOption.id + '_' + index,
            orderProductOption: orderProductOption
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_product_view' },
        this.renderHeader(),
        this.renderComment(),
        this.renderOptions()
      );
    }
  }, {
    key: 'orderProduct',
    get: function get() {
      return this.props.orderProduct;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return OrderProductView;
}(_react.Component);

OrderProductView.defaultProps = {
  quantity: 0
};
OrderProductView.propTypes = {
  orderProduct: _propTypes2.default.objectOf(_order.OrderProduct).isRequired,

  onMenu: _propTypes2.default.bool.isRequired,

  quantity: _propTypes2.default.number,

  currencyCode: _propTypes2.default.string
};
exports.default = OrderProductView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderProductView, 'OrderProductView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderDetailModal/OrderProductView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderStatusStepper/OrderStatusStepper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Step = __webpack_require__("./scripts/components/order/orderStatusStepper/Step.js");

var _Step2 = _interopRequireDefault(_Step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderStatusStepper = function (_Component) {
  _inherits(OrderStatusStepper, _Component);

  function OrderStatusStepper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderStatusStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderStatusStepper.__proto__ || Object.getPrototypeOf(OrderStatusStepper)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
      var _this2;

      return (_this2 = _this).__getStyles__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderStatusStepper, [{
    key: '__getStyles__REACT_HOT_LOADER__',
    value: function __getStyles__REACT_HOT_LOADER__() {
      return this.__getStyles__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getStyles__REACT_HOT_LOADER__',
    value: function __getStyles__REACT_HOT_LOADER__() {
      return {
        root: {
          width: '100%',
          minHeight: 0,
          padding: 0
        },
        stepper: {
          display: 'table',
          width: '100%',
          margin: '0 auto'
        }
      };
    }
  }, {
    key: 'renderStep',
    value: function renderStep(stepInfo, index) {
      var _props = this.props,
          activeStep = _props.activeStep,
          activeColor = _props.activeColor,
          completeColor = _props.completeColor,
          defaultColor = _props.defaultColor,
          circleFontColor = _props.circleFontColor,
          activeTitleColor = _props.activeTitleColor,
          completeTitleColor = _props.completeTitleColor,
          defaultTitleColor = _props.defaultTitleColor,
          size = _props.size,
          circleFontSize = _props.circleFontSize,
          titleFontSize = _props.titleFontSize,
          circleTop = _props.circleTop,
          titleTop = _props.titleTop;


      return _react2.default.createElement(_Step2.default, {
        key: index,
        width: 100 / this.steps.length,
        label: stepInfo.label,
        status: stepInfo.value,
        active: this.props.status === stepInfo.value,
        completed: _order.Order.isStatusBefore(stepInfo.value, this.props.status),
        first: index === 0,
        last: index === this.steps.length - 1,
        index: index,
        isNext: this.props.nextStatus === stepInfo.value,
        onNextStatus: this.props.onNextStatus
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = this.getStyles();

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(
          'div',
          { style: styles.stepper },
          this.steps.map(function (stepInfo, index) {
            return _this3.renderStep(stepInfo, index);
          })
        )
      );
    }
  }, {
    key: 'steps',
    get: function get() {
      var status = this.props.orderMode === _order.Order.OrderMode.DELIVERY ? _order.Order.getStepsWithDelivery() : _order.Order.getStepsWithoutDelivery();

      var steps = [];

      _lodash2.default.each(status, function (status) {
        steps.push({
          label: _utils.OrderViewUtils.getStatusLabel(status),
          value: status
        });
      });

      return steps;
    }
  }]);

  return OrderStatusStepper;
}(_react.Component);

OrderStatusStepper.propTypes = {
  status: _propTypes2.default.string.isRequired,

  nextStatus: _propTypes2.default.string.isRequired,

  onNextStatus: _propTypes2.default.func.isRequired,

  orderMode: _propTypes2.default.number.isRequired,

  /**
  * @param newStatus
  */
  onChange: _propTypes2.default.func
};
exports.default = OrderStatusStepper;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderStatusStepper, 'OrderStatusStepper', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderStatusStepper/OrderStatusStepper.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/order/orderStatusStepper/Step.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Step = function (_Component) {
  _inherits(Step, _Component);

  function Step() {
    _classCallCheck(this, Step);

    return _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
  }

  _createClass(Step, [{
    key: 'getStyles',
    value: function getStyles() {
      var _props = this.props,
          completeColor = _props.completeColor,
          defaultColor = _props.defaultColor,
          circleFontColor = _props.circleFontColor,
          activeTitleColor = _props.activeTitleColor,
          completeTitleColor = _props.completeTitleColor,
          defaultTitleColor = _props.defaultTitleColor,
          size = _props.size,
          circleFontSize = _props.circleFontSize,
          titleFontSize = _props.titleFontSize,
          circleTop = _props.circleTop,
          titleTop = _props.titleTop,
          width = _props.width;


      return {
        step: {
          width: width + '%',
          display: 'table-cell',
          position: 'relative',
          paddingTop: circleTop
        },
        circle: {
          width: size,
          height: size,
          margin: '0 auto',
          backgroundColor: defaultColor,
          borderRadius: '50%',
          textAlign: 'center',
          padding: 1,
          fontSize: circleFontSize,
          color: circleFontColor,
          display: 'block'
        },
        completedCircle: {
          backgroundColor: completeColor
        },
        index: {
          lineHeight: size + circleFontSize / 4 + 'px'
        },
        title: {
          fontSize: titleFontSize
          // color: defaultTitleColor,
        },
        completedTitle: {
          color: completeTitleColor
        },
        leftBar: {
          position: 'absolute',
          top: circleTop + size / 2,
          height: 1,
          left: 0,
          right: '50%',
          marginRight: size / 2 + 1
        },
        rightBar: {
          position: 'absolute',
          top: circleTop + size / 2,
          height: 1,
          right: 0,
          left: '50%',
          marginLeft: size / 2 + 1
        }
      };
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var _this2 = this;

      var _props2 = this.props,
          isNext = _props2.isNext,
          label = _props2.label,
          status = _props2.status,
          active = _props2.active,
          completed = _props2.completed;


      var styles = this.getStyles();

      var titleStyle = _lodash2.default.assign(styles.title, completed ? styles.completedTitle : {});

      if (isNext) {
        return _react2.default.createElement(
          'div',
          {
            style: titleStyle,
            className: 'order_status_stepper__step__title',
            onClick: function onClick() {
              return _this2.props.onNextStatus(status);
            }
          },
          label
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'order_status_stepper__step__title',
          style: titleStyle
        },
        label
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          index = _props3.index,
          active = _props3.active,
          completed = _props3.completed,
          first = _props3.first,
          last = _props3.last,
          isNext = _props3.isNext;


      var styles = this.getStyles();

      var circleStyle = _lodash2.default.assign(styles.circle, completed ? styles.completedCircle : {});

      var leftStyle = _lodash2.default.assign(styles.leftBar, active || completed ? styles.completedBar : {});
      var rightStyle = _lodash2.default.assign(styles.rightBar, completed ? styles.completedBar : {});

      var className = (0, _classnames2.default)(['order_status_stepper__step', {
        order_status_stepper__step__is_next: isNext,
        order_status_stepper__step__is_active: active,
        order_status_stepper__step__is_completed: completed
      }]);

      return _react2.default.createElement(
        'div',
        { style: styles.step, className: className },
        _react2.default.createElement(
          'div',
          { style: circleStyle, className: 'order_status_stepper__step__circle' },
          (completed || active) &&
          // TODO: Add icon check
          _react2.default.createElement(
            'span',
            { style: styles.index },
            _react2.default.createElement('i', { className: 'fa fa-check' })
          ),
          isNext && _react2.default.createElement('span', { style: styles.index })
        ),
        this.renderLabel(),
        !first && _react2.default.createElement('div', {
          style: leftStyle,
          className: 'order_status_stepper__step__first'
        }),
        !last && _react2.default.createElement('div', {
          style: rightStyle,
          className: 'order_status_stepper__step__last'
        })
      );
    }
  }]);

  return Step;
}(_react.Component);

Step.defaultProps = {
  completeColor: '#5096FF',
  defaultColor: '#E0E0E0',
  completeTitleColor: '#000',
  defaultTitleColor: '#757575',
  circleFontColor: '#FFF',
  size: 32,
  circleFontSize: 16,
  titleFontSize: 16,
  circleTop: 24
};
Step.propTypes = {
  status: _propTypes2.default.string,
  label: _propTypes2.default.string,

  width: _propTypes2.default.number.isRequired,
  completeColor: _propTypes2.default.string,
  defaultColor: _propTypes2.default.string,
  completeTitleColor: _propTypes2.default.string,
  defaultTitleColor: _propTypes2.default.string,
  circleFontColor: _propTypes2.default.string,
  size: _propTypes2.default.number,
  circleFontSize: _propTypes2.default.number,
  titleFontSize: _propTypes2.default.number,
  circleTop: _propTypes2.default.number,
  index: _propTypes2.default.number,
  completed: _propTypes2.default.bool,
  first: _propTypes2.default.bool,
  last: _propTypes2.default.bool,

  isNext: _propTypes2.default.bool.isRequired,
  onNextStatus: _propTypes2.default.func.isRequired
};
exports.default = Step;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Step, 'Step', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/order/orderStatusStepper/Step.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/payment/PaymentModesForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _EPaymentMode = __webpack_require__("./sdk/scripts/constants/EPaymentMode.js");

var _EPaymentMode2 = _interopRequireDefault(_EPaymentMode);

var _BitUtils = __webpack_require__("./sdk/scripts/utils/BitUtils.js");

var _BitUtils2 = _interopRequireDefault(_BitUtils);

var _OptionView = __webpack_require__("./sdk/scripts/components/form/OptionView.js");

var _OptionView2 = _interopRequireDefault(_OptionView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var PaymentModesForm = function (_Component) {
  _inherits(PaymentModesForm, _Component);

  function PaymentModesForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentModesForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentModesForm.__proto__ || Object.getPrototypeOf(PaymentModesForm)).call.apply(_ref, [this].concat(args))), _this), _this.onToggleMode = function () {
      var _this2;

      return (_this2 = _this).__onToggleMode__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentModesForm, [{
    key: '__onToggleMode__REACT_HOT_LOADER__',
    value: function __onToggleMode__REACT_HOT_LOADER__() {
      return this.__onToggleMode__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleMode__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onToggleMode__REACT_HOT_LOADER__(mode) {
      var mask = this.props.paymentModes;
      mask = _BitUtils2.default.toggle(mask, mode);
      this.props.onChange(mask);
    }
  }, {
    key: 'renderCreditCards',
    value: function renderCreditCards() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderOption(_EPaymentMode2.default.VISA, 'Visa'),
        this.renderOption(_EPaymentMode2.default.MASTERCARD, 'Mastercard'),
        this.renderOption(_EPaymentMode2.default.AMERICAN_EXPRESS, 'American express')
      );
    }
  }, {
    key: 'renderCash',
    value: function renderCash() {
      return this.renderOption(_EPaymentMode2.default.CASH, _I18n2.default.tr('components.payment.modes.form.cash'));
    }
  }, {
    key: 'renderRestaurantTickets',
    value: function renderRestaurantTickets() {
      return this.renderOption(_EPaymentMode2.default.RESTAURANT_TICKET, _I18n2.default.tr('components.payment.modes.form.restaurant_ticket'));
    }
  }, {
    key: 'renderOption',
    value: function renderOption(paymentMode, label) {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_OptionView2.default, {
          isActivated: _BitUtils2.default.isSet(this.props.paymentModes, paymentMode),
          onChange: function onChange() {
            return _this3.onToggleMode(paymentMode);
          },
          label: label
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          null,
          this.renderCreditCards(),
          this.renderCash(),
          this.renderRestaurantTickets()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return PaymentModesForm;
}(_react.Component);

PaymentModesForm.defaultProps = {
  paymentModes: 0
};
PaymentModesForm.propTypes = {
  // PaymentModes
  paymentModes: _propTypes2.default.number,

  onChange: _propTypes2.default.func.isRequired
};
exports.default = PaymentModesForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentModesForm, 'PaymentModesForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/payment/PaymentModesForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/restaurantMenu/PricesEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var PricesEditor = function (_Component) {
  _inherits(PricesEditor, _Component);

  function PricesEditor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PricesEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PricesEditor.__proto__ || Object.getPrototypeOf(PricesEditor)).call.apply(_ref, [this].concat(args))), _this), _this.onToggleTakeAway = function () {
      var _this2;

      return (_this2 = _this).__onToggleTakeAway__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onToggleDelivery = function () {
      var _this3;

      return (_this3 = _this).__onToggleDelivery__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onToggleOnSite = function () {
      var _this4;

      return (_this4 = _this).__onToggleOnSite__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onOnSiteVatChange = function () {
      var _this5;

      return (_this5 = _this).__onOnSiteVatChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onTakeAwayVatChange = function () {
      var _this6;

      return (_this6 = _this).__onTakeAwayVatChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDeliveryVatChange = function () {
      var _this7;

      return (_this7 = _this).__onDeliveryVatChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onOnSitePriceChange = function () {
      var _this8;

      return (_this8 = _this).__onOnSitePriceChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onTakeAwayPriceChange = function () {
      var _this9;

      return (_this9 = _this).__onTakeAwayPriceChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onDeliveryPriceChange = function () {
      var _this10;

      return (_this10 = _this).__onDeliveryPriceChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PricesEditor, [{
    key: '__onDeliveryPriceChange__REACT_HOT_LOADER__',
    value: function __onDeliveryPriceChange__REACT_HOT_LOADER__() {
      return this.__onDeliveryPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTakeAwayPriceChange__REACT_HOT_LOADER__',
    value: function __onTakeAwayPriceChange__REACT_HOT_LOADER__() {
      return this.__onTakeAwayPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOnSitePriceChange__REACT_HOT_LOADER__',
    value: function __onOnSitePriceChange__REACT_HOT_LOADER__() {
      return this.__onOnSitePriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeliveryVatChange__REACT_HOT_LOADER__',
    value: function __onDeliveryVatChange__REACT_HOT_LOADER__() {
      return this.__onDeliveryVatChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTakeAwayVatChange__REACT_HOT_LOADER__',
    value: function __onTakeAwayVatChange__REACT_HOT_LOADER__() {
      return this.__onTakeAwayVatChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOnSiteVatChange__REACT_HOT_LOADER__',
    value: function __onOnSiteVatChange__REACT_HOT_LOADER__() {
      return this.__onOnSiteVatChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleOnSite__REACT_HOT_LOADER__',
    value: function __onToggleOnSite__REACT_HOT_LOADER__() {
      return this.__onToggleOnSite__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleDelivery__REACT_HOT_LOADER__',
    value: function __onToggleDelivery__REACT_HOT_LOADER__() {
      return this.__onToggleDelivery__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleTakeAway__REACT_HOT_LOADER__',
    value: function __onToggleTakeAway__REACT_HOT_LOADER__() {
      return this.__onToggleTakeAway__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleTakeAway__REACT_HOT_LOADER__',
    value: function __onToggleTakeAway__REACT_HOT_LOADER__() {
      var prices = this.prices;

      prices.takeAway.available = !prices.takeAway.available;

      this.props.onChange(prices);
    }
  }, {
    key: '__onToggleDelivery__REACT_HOT_LOADER__',
    value: function __onToggleDelivery__REACT_HOT_LOADER__() {
      var prices = this.prices;

      prices.delivery.available = !prices.delivery.available;

      this.props.onChange(prices);
    }
  }, {
    key: '__onToggleOnSite__REACT_HOT_LOADER__',


    //
    // Events change tax
    //

    value: function __onToggleOnSite__REACT_HOT_LOADER__() {
      var prices = this.prices;

      prices.onSite.available = !prices.onSite.available;

      this.props.onChange(prices);
    }
  }, {
    key: '__onOnSiteVatChange__REACT_HOT_LOADER__',
    value: function __onOnSiteVatChange__REACT_HOT_LOADER__(tax) {
      var prices = this.prices;
      prices.onSite.vat = tax;
      this.props.onChange(prices);
    }
  }, {
    key: '__onTakeAwayVatChange__REACT_HOT_LOADER__',
    value: function __onTakeAwayVatChange__REACT_HOT_LOADER__(tax) {
      var prices = this.prices;
      prices.takeAway.vat = tax;
      this.props.onChange(prices);
    }
  }, {
    key: '__onDeliveryVatChange__REACT_HOT_LOADER__',


    //
    // Events change price
    //

    value: function __onDeliveryVatChange__REACT_HOT_LOADER__(tax) {
      var prices = this.prices;
      prices.delivery.vat = tax;
      this.props.onChange(prices);
    }
  }, {
    key: '__onOnSitePriceChange__REACT_HOT_LOADER__',
    value: function __onOnSitePriceChange__REACT_HOT_LOADER__(price) {
      var prices = this.prices;
      prices.onSite.setPriceWithTax(price);
      this.props.onChange(prices);
    }
  }, {
    key: '__onTakeAwayPriceChange__REACT_HOT_LOADER__',
    value: function __onTakeAwayPriceChange__REACT_HOT_LOADER__(price) {
      var prices = this.prices;
      prices.takeAway.setPriceWithTax(price);
      this.props.onChange(prices);
    }
  }, {
    key: '__onDeliveryPriceChange__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onDeliveryPriceChange__REACT_HOT_LOADER__(price) {
      var prices = this.prices;
      prices.delivery.setPriceWithTax(price);
      this.props.onChange(prices);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'prices_editor' },
        _react2.default.createElement(
          'table',
          { className: 'table product_modal_view__prices_table' },
          _react2.default.createElement(
            'thead',
            { className: 'thead-inverse' },
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement('th', { className: 'col-xs-1' }),
              _react2.default.createElement(
                'th',
                { className: 'col-xs-2' },
                _I18n2.default.tr('components.prices_editor.mode')
              ),
              _react2.default.createElement(
                'th',
                { className: 'text-center col-xs-2' },
                _I18n2.default.tr('components.prices_editor.price_with_tax')
              ),
              _react2.default.createElement(
                'th',
                { className: 'text-center col-xs-3' },
                _I18n2.default.tr('components.prices_editor.vat')
              ),
              _react2.default.createElement(
                'th',
                { className: 'col-xs-1 text-center' },
                _I18n2.default.tr('components.prices_editor.activation')
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { className: '' },
                _react2.default.createElement(_SvgIcon2.default, { icon: _SvgIcon2.default.ORDER_ON_SITE })
              ),
              _react2.default.createElement(
                'td',
                { className: '' },
                _I18n2.default.tr('components.prices_editor.on_site')
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(_form.PriceInput, {
                  value: this.prices.onSite.priceIncludingTax,
                  currencyCode: this.props.currencyCode,
                  onChange: this.onOnSitePriceChange,
                  readOnly: this.props.disablePriceModification || this.props.readOnly
                })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_form.VatChooser, {
                  onChange: this.onOnSiteVatChange,
                  value: this.prices.onSite.vat,
                  clearable: false,
                  readOnly: this.props.disablePriceModification || this.props.readOnly
                })
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(_reactBootstrapSwitch2.default, {
                  key: _utils.Utils.generateUID(),
                  bsSize: 'mini',
                  value: this.prices.onSite.available,
                  onChange: this.onToggleOnSite,
                  disabled: this.props.readOnly
                })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_SvgIcon2.default, { icon: _SvgIcon2.default.ORDER_TAKE_AWAY })
              ),
              _react2.default.createElement(
                'td',
                null,
                _I18n2.default.tr('components.prices_editor.take_away')
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(_form.PriceInput, {
                  value: this.prices.takeAway.priceIncludingTax,
                  currencyCode: this.props.currencyCode,
                  onChange: this.onTakeAwayPriceChange,
                  readOnly: this.props.disablePriceModification || this.props.readOnly
                })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_form.VatChooser, {
                  onChange: this.onTakeAwayVatChange,
                  value: this.prices.takeAway.vat,
                  clearable: false,
                  readOnly: this.props.disablePriceModification || this.props.readOnly
                })
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(_reactBootstrapSwitch2.default, {
                  key: _utils.Utils.generateUID(),
                  bsSize: 'mini',
                  value: this.prices.takeAway.available,
                  onChange: this.onToggleTakeAway,
                  disabled: this.props.readOnly
                })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_SvgIcon2.default, { icon: _SvgIcon2.default.ORDER_DELIVERY })
              ),
              _react2.default.createElement(
                'td',
                null,
                _I18n2.default.tr('components.prices_editor.delivery')
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(_form.PriceInput, {
                  value: this.prices.delivery.priceIncludingTax,
                  currencyCode: this.props.currencyCode,
                  onChange: this.onDeliveryPriceChange,
                  readOnly: this.props.disablePriceModification || this.props.readOnly
                })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_form.VatChooser, {
                  onChange: this.onDeliveryVatChange,
                  value: this.prices.delivery.vat,
                  clearable: false,
                  readOnly: this.props.disablePriceModification || this.props.readOnly
                })
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-center' },
                _react2.default.createElement(_reactBootstrapSwitch2.default, {
                  key: _utils.Utils.generateUID(),
                  bsSize: 'mini',
                  value: this.prices.delivery.available,
                  onChange: this.onToggleDelivery,
                  disabled: this.props.readOnly
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'prices',
    get: function get() {
      return this.props.prices;
    }

    //
    // Events toggle prices
    //

  }]);

  return PricesEditor;
}(_react.Component);

PricesEditor.defaultProps = {
  disablePriceModification: false,

  readOnly: false
};
PricesEditor.propTypes = {
  prices: _propTypes2.default.objectOf(_menu.ProductPrices).isRequired,

  onChange: _propTypes2.default.func.isRequired,

  /**
   * Disable price and tax modification, but allow to modify availability.
   */
  disablePriceModification: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool,

  currencyCode: _propTypes2.default.string
};
exports.default = PricesEditor;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PricesEditor, 'PricesEditor', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantMenu/PricesEditor.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/restaurantMenu/chooseProductsModal/ProductItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var ProductItem = function (_Component) {
  _inherits(ProductItem, _Component);

  function ProductItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductItem.__proto__ || Object.getPrototypeOf(ProductItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this2;

      return (_this2 = _this).__onClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      this.props.onToggle(this.product);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'product_item pointer',
          onClick: this.onClick
        },
        this.isSelected && _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
        !this.isSelected && _react2.default.createElement('i', { className: 'fa fa-square-o' }),
        '\xA0\xA0',
        this.product.name
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return ProductItem;
}(_react.Component);

ProductItem.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onToggle: _propTypes2.default.func
};
var _default = ProductItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductItem, 'ProductItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantMenu/chooseProductsModal/ProductItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantMenu/chooseProductsModal/ProductItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/restaurantMenu/chooseProductsModal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _ProductItem = __webpack_require__("./scripts/components/restaurantMenu/chooseProductsModal/ProductItem.js");

var _ProductItem2 = _interopRequireDefault(_ProductItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
*/
var ChooseProductsModal = function (_Component) {
  _inherits(ChooseProductsModal, _Component);

  function ChooseProductsModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseProductsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseProductsModal.__proto__ || Object.getPrototypeOf(ChooseProductsModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchQuery: '',

      selectedProducts: _this.props.selectedProducts.slice()
    }, _this.onSubmit = function () {
      var _this2;

      return (_this2 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onToggleProduct = function () {
      var _this3;

      return (_this3 = _this).__onToggleProduct__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSearchQueryChange = function () {
      var _this4;

      return (_this4 = _this).__onSearchQueryChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseProductsModal, [{
    key: '__onSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleProduct__REACT_HOT_LOADER__',
    value: function __onToggleProduct__REACT_HOT_LOADER__() {
      return this.__onToggleProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      this.props.onChooseProducts(this.state.selectedProducts);
    }
  }, {
    key: '__onToggleProduct__REACT_HOT_LOADER__',
    value: function __onToggleProduct__REACT_HOT_LOADER__(product) {
      var selectedProducts = _utils.ArrayUtils.toggleObject(this.state.selectedProducts, product, { id: product.id });

      this.setState({
        selectedProducts: selectedProducts
      });
    }
  }, {
    key: '__onSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onSearchQueryChange__REACT_HOT_LOADER__(searchQuery) {
      this.setState({
        searchQuery: searchQuery
      });
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this5 = this;

      var listView = null;

      var products = [];
      _lodash2.default.each(this.props.restaurantMenu.products, function (product) {
        var query = _this5.state.searchQuery;
        if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, product.name)) {
          products.push(product);
        }
      });

      if (_lodash2.default.isEmpty(products) && !_lodash2.default.isEmpty(this.state.searchQuery)) {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('components.menu.choose_product_modal.search_no_results')
          )
        );
      }

      // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
      var sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (product) {
        return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
      });

      listView = sortedProductsList.map(function (product) {
        return _react2.default.createElement(_ProductItem2.default, {
          key: product.id,
          product: product,
          isSelected: _utils.ArrayUtils.exists(_this5.state.selectedProducts, { id: product.id }),
          onToggle: _this5.onToggleProduct
        });
      });

      return listView;
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        { className: 'choose_products_modal' },
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.searchQuery,
          onSearchInput: this.onSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          this.renderList()
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-center' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary',
              onClick: this.onSubmit
            },
            _I18n2.default.tr('global.validate')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'sm',
          show: this.props.show,
          onHide: this.props.onHide,
          backdrop: 'static'
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.props.onHide
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.menu.choose_product_modal.choose_products')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return ChooseProductsModal;
}(_react.Component);

ChooseProductsModal.defaultProps = {
  selectedProducts: []
};
ChooseProductsModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  /**
  * @param Array<Product>
  */
  onChooseProducts: _propTypes2.default.func.isRequired,

  selectedProducts: _propTypes2.default.arrayOf(_menu.Product)
};
exports.default = ChooseProductsModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ChooseProductsModal, 'ChooseProductsModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantMenu/chooseProductsModal/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/restaurantMenu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricesEditor = exports.EditProductCategoryModal = undefined;

var _EditProductCategoryModal2 = __webpack_require__("./scripts/components/restaurantMenu/productCategoryModal/EditProductCategoryModal.js");

var _EditProductCategoryModal3 = _interopRequireDefault(_EditProductCategoryModal2);

var _PricesEditor2 = __webpack_require__("./scripts/components/restaurantMenu/PricesEditor.js");

var _PricesEditor3 = _interopRequireDefault(_PricesEditor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EditProductCategoryModal = _EditProductCategoryModal3.default;
exports.PricesEditor = _PricesEditor3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/components/restaurantMenu/productCategoryModal/EditProductCategoryModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var EditProductCategoryModal = function (_Component) {
  _inherits(EditProductCategoryModal, _Component);

  function EditProductCategoryModal(props) {
    _classCallCheck(this, EditProductCategoryModal);

    var _this = _possibleConstructorReturn(this, (EditProductCategoryModal.__proto__ || Object.getPrototypeOf(EditProductCategoryModal)).call(this, props));

    _this.onHide = function () {
      return _this.__onHide__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onClose = function () {
      return _this.__onClose__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onDelete = function () {
      return _this.__onDelete__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onChange = function () {
      return _this.__onChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onNameChange = function () {
      return _this.__onNameChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onDescriptionChange = function () {
      return _this.__onDescriptionChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onChangeParents = function () {
      return _this.__onChangeParents__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onValidate = function () {
      return _this.__onValidate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    var parents = !_this.isEditMode() ? [props.restaurantMenu.getRootCategory()] : [];

    _this.state = {
      productCategory: _lodash2.default.isNull(props.productCategory) ? new _menu.ProductCategory() : props.productCategory.copy(),

      validationErrors: [], // contains the productCategory.getValidationErrors() when click on isValid

      parents: parents
    };
    return _this;
  }

  _createClass(EditProductCategoryModal, [{
    key: '__onValidate__REACT_HOT_LOADER__',
    value: function __onValidate__REACT_HOT_LOADER__() {
      return this.__onValidate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeParents__REACT_HOT_LOADER__',
    value: function __onChangeParents__REACT_HOT_LOADER__() {
      return this.__onChangeParents__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__() {
      return this.__onDescriptionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return !_lodash2.default.isNull(this.props.productCategory);
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return !_lodash2.default.isEmpty(this.productCategory.localizedNames);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      this.props.onDelete(this.props.productCategory);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__(productCategory) {
      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var productCategory = this.productCategory;
      productCategory.localizedNames = newValue;
      this.onChange(productCategory);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__(newValue) {
      var productCategory = this.productCategory;
      productCategory.description = newValue;
      this.onChange(productCategory);
    }
  }, {
    key: '__onChangeParents__REACT_HOT_LOADER__',
    value: function __onChangeParents__REACT_HOT_LOADER__(parentsOptions) {
      console.log(parentsOptions);

      var parents = parentsOptions.map(function (option) {
        return option.value;
      });

      this.setState({
        parents: parents
      });
    }
  }, {
    key: '__onValidate__REACT_HOT_LOADER__',


    //
    value: function __onValidate__REACT_HOT_LOADER__(event) {
      var _this2 = this;

      event.preventDefault();

      var productCategory = this.productCategory;

      /**
       * We need to create a unique pos id if  we create a new product
       */
      if (!this.isEditMode()) {
        productCategory.id = 'cat_' + _utils.Utils.generateUID();

        /**
         * Activated by default.
         * @type {boolean}
         */
        //    productCategory.activated = true;
      } else {
        productCategory.id = this.props.productCategory.id;
      }

      if (productCategory.isValid()) {
        if (this.isEditMode()) {
          this.props.onUpdate(productCategory);
          this.onClose();
        } else {
          var restaurantMenu = this.props.restaurantMenu;
          restaurantMenu.categories.push(productCategory);

          var newCategoryItem = new _menu.CategoryItem();
          newCategoryItem.id = productCategory.id;
          newCategoryItem.type = _menu.CategoryItem.Type.CATEGORY;

          _lodash2.default.each(restaurantMenu.categories, function (category) {
            var isParent = _utils.ArrayUtils.exists(_this2.state.parents, function (parent) {
              return parent.id === category.id;
            });

            if (isParent) {
              category.items.unshift(newCategoryItem.copy());
            }
          });

          // send to the api
          this.props.onCreate(restaurantMenu);
          this.onClose();
        }
      } else {
        var validationErrors = productCategory.getValidationErrors();
        console.info('category invalid', validationErrors);
        this.setState({
          validationErrors: validationErrors
        });
      }
    }
  }, {
    key: 'renderBody',


    // -- renderers

    value: function renderBody() {
      return _react2.default.createElement(
        'form',
        {
          className: 'form form-horizontal product_category_create__form',
          role: 'form',
          noValidate: true
        },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-4 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('components.menu.edit_category.name')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(_form.TextInputLocalized, {
              locales: _Constants2.default.localesForTranslation,
              values: this.productCategory.localizedNames,
              isRequired: true,
              className: 'form-control',
              placeholder: 'Nom',
              onChange: this.onNameChange
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form_error col-xs-6 col-xs-offset-4' },
            this.state.validationErrors.name
          )
        ),
        this.renderParentCategoryChooser(),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement('div', { className: 'col-xs-6 text-left' }),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 text-left' },
            _react2.default.createElement(
              'button',
              {
                type: 'submit',
                onClick: this.onValidate,
                className: 'btn btn-primary',
                disabled: !this.isValid()
              },
              _I18n2.default.tr('components.menu.edit_category.submit')
            )
          )
        )
      );
    }
  }, {
    key: 'renderParentCategoryChooser',
    value: function renderParentCategoryChooser() {
      var _this3 = this;

      if (this.isEditMode()) {
        // edit not supported yet.
        return null;
      }

      var selectedParentsValues = [];
      var options = this.props.parentsToPropose.map(function (category) {
        var label = category.id === _this3.props.restaurantMenu.rootCategoryId ? _I18n2.default.tr('menu.category.add_item.main_category') : category.name;
        var option = {
          label: label,
          value: category
        };

        var isSelected = _utils.ArrayUtils.exists(_this3.state.parents, function (parent) {
          return parent.id === category.id;
        });

        if (isSelected) {
          selectedParentsValues.push(option);
        }

        return option;
      });

      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('components.menu.edit_category.parent_category')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_LocalizableSelect2.default, {
            name: 'action',
            value: selectedParentsValues,
            options: options,
            clearable: false,
            onChange: this.onChangeParents,
            multi: true
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            this.title
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }, {
    key: 'productCategory',
    get: function get() {
      return this.state.productCategory;
    }
  }, {
    key: 'title',
    get: function get() {
      if (_lodash2.default.isNull(this.props.productCategory)) {
        return _I18n2.default.tr('components.menu.edit_category.new');
      }
      return _I18n2.default.tr('components.menu.edit_category.edit');
    }
  }]);

  return EditProductCategoryModal;
}(_react.Component);

EditProductCategoryModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  productCategory: _propTypes2.default.objectOf(_menu.ProductCategory),

  parentsToPropose: _propTypes2.default.arrayOf(_menu.ProductCategory),

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu),

  /**
   * @param ProductCategory
   * @type func
   */
  onUpdate: _propTypes2.default.func,

  /**
   * @param RestaurantMenu
   * @type func
   */
  onCreate: _propTypes2.default.func
};
EditProductCategoryModal.defaultProps = {
  productCategory: null,
  parentsToPropose: []
};
exports.default = EditProductCategoryModal;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EditProductCategoryModal, 'EditProductCategoryModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantMenu/productCategoryModal/EditProductCategoryModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/restaurantMenu/upsellingCategoryModal/EditUpsellingCategoryModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var EditUpsellingCategoryModal = function (_Component) {
  _inherits(EditUpsellingCategoryModal, _Component);

  function EditUpsellingCategoryModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditUpsellingCategoryModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditUpsellingCategoryModal.__proto__ || Object.getPrototypeOf(EditUpsellingCategoryModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      upsellingCategory: _lodash2.default.isNull(_this.props.upsellingCategory) ? new _menu.UpsellingCategory() : _this.props.upsellingCategory.copy(),

      validationErrors: [] // contains the upsellingCategory.getValidationErrors() when click on isValid
    }, _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDelete = function () {
      var _this4;

      return (_this4 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onChange = function () {
      var _this5;

      return (_this5 = _this).__onChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onNameChange = function () {
      var _this6;

      return (_this6 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDescriptionChange = function () {
      var _this7;

      return (_this7 = _this).__onDescriptionChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onValidate = function () {
      var _this8;

      return (_this8 = _this).__onValidate__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditUpsellingCategoryModal, [{
    key: '__onValidate__REACT_HOT_LOADER__',
    value: function __onValidate__REACT_HOT_LOADER__() {
      return this.__onValidate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__() {
      return this.__onDescriptionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'isPut',
    value: function isPut() {
      return !_lodash2.default.isNull(this.props.upsellingCategory);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      this.props.onDelete(this.props.upsellingCategory);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__(upsellingCategory) {
      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var upsellingCategory = this.upsellingCategory;
      upsellingCategory.localizedNames = newValue;
      this.onChange(upsellingCategory);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__(newValue) {
      var upsellingCategory = this.upsellingCategory;
      upsellingCategory.localizedDescriptions = newValue;
      this.onChange(upsellingCategory);
    }
  }, {
    key: '__onValidate__REACT_HOT_LOADER__',


    //
    value: function __onValidate__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var upsellingCategory = this.upsellingCategory;

      /**
       * We need to create a unique pos id if  we create a new product
       */
      if (!this.isPut()) {
        upsellingCategory.id = _utils.Utils.generateUID();

        /**
         * Activated by default.
         * @type {boolean}
         */
        //    upsellingCategory.activated = true;
      } else {
        upsellingCategory.id = this.props.upsellingCategory.id;
      }

      if (upsellingCategory.isValid()) {
        if (this.isPut()) {
          this.props.onUpdate(upsellingCategory);
          this.onClose();
        } else {
          // TODO: push to the API
        }
      } else {
        var validationErrors = upsellingCategory.getValidationErrors();
        console.info('category invalid', validationErrors);
        this.setState({
          validationErrors: validationErrors
        });
      }
    }
  }, {
    key: 'renderBody',


    // -- renderers

    value: function renderBody() {
      return _react2.default.createElement(
        'form',
        {
          className: 'form form-horizontal product_category_create__form',
          role: 'form',
          noValidate: true
        },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-4 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('components.menu.edit_upselling_category.name')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(_form.TextInputLocalized, {
              locales: _Constants2.default.localesForTranslation,
              values: this.upsellingCategory.localizedNames,
              isRequired: true,
              className: 'form-control',
              placeholder: _I18n2.default.tr('components.menu.edit_upselling_category.name_placeholder'),
              onChange: this.onNameChange
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form_error col-xs-6 col-xs-offset-4' },
            this.state.validationErrors.name
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-4 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('components.menu.edit_upselling_category.description')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(_form.TextInputLocalized, {
              locales: _Constants2.default.localesForTranslation,
              values: this.upsellingCategory.localizedDescriptions,
              isRequired: true,
              className: 'form-control',
              placeholder: _I18n2.default.tr('components.menu.edit_upselling_category.description_placeholder'),
              onChange: this.onDescriptionChange,
              max: this.upsellingCategory.DESCRIPTION_MAX_LENGTH
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form_error col-xs-6 col-xs-offset-4' },
            this.state.validationErrors.description
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement('div', { className: 'col-xs-6 text-left' }),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 text-left' },
            _react2.default.createElement(
              'button',
              {
                type: 'submit',
                onClick: this.onValidate,
                className: 'btn btn-primary'
              },
              _I18n2.default.tr('components.menu.edit_upselling_category.submit')
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            this.title
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }, {
    key: 'upsellingCategory',
    get: function get() {
      return this.state.upsellingCategory;
    }
  }, {
    key: 'title',
    get: function get() {
      if (_lodash2.default.isNull(this.props.upsellingCategory)) {
        return _I18n2.default.tr('components.menu.edit_upselling_category.new');
      }
      return _I18n2.default.tr('components.menu.edit_upselling_category.edit');
    }
  }]);

  return EditUpsellingCategoryModal;
}(_react.Component);

EditUpsellingCategoryModal.CUSTOM_DESCRIPTION_MAX_LENGTH = 50;
EditUpsellingCategoryModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  upsellingCategory: _propTypes2.default.objectOf(_menu.UpsellingCategory),

  // params: Product
  onUpdate: _propTypes2.default.func.isRequired
};
EditUpsellingCategoryModal.defaultProps = {
  upsellingCategory: null
};
exports.default = EditUpsellingCategoryModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EditUpsellingCategoryModal, 'EditUpsellingCategoryModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantMenu/upsellingCategoryModal/EditUpsellingCategoryModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/restaurantsGroup/RestaurantsGroupHierarchyView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views

var RestaurantsGroupHierarchyView = function (_Component) {
  _inherits(RestaurantsGroupHierarchyView, _Component);

  function RestaurantsGroupHierarchyView() {
    _classCallCheck(this, RestaurantsGroupHierarchyView);

    return _possibleConstructorReturn(this, (RestaurantsGroupHierarchyView.__proto__ || Object.getPrototypeOf(RestaurantsGroupHierarchyView)).apply(this, arguments));
  }

  _createClass(RestaurantsGroupHierarchyView, [{
    key: 'renderSublist',


    //
    // Renderers
    //

    value: function renderSublist() {
      var _this2 = this;

      return this.props.restaurantsGroup.children.map(function (restaurantsGroupChild) {
        return _react2.default.createElement(RestaurantsGroupHierarchyView, {
          key: restaurantsGroupChild.id,
          level: _this2.props.level + 1,
          restaurantsGroup: restaurantsGroupChild,
          selectedRestaurantsGroup: _this2.props.selectedRestaurantsGroup,
          readOnly: _this2.props.readOnly,
          onSelect: _this2.props.onSelect
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var isCurrent = !_lodash2.default.isNull(this.props.selectedRestaurantsGroup) && this.props.selectedRestaurantsGroup.id === this.props.restaurantsGroup.id;

      var mainClassName = (0, _classnames2.default)('restaurants_group_hierarchy', {
        current: isCurrent
      });

      var groupNameClassName = (0, _classnames2.default)('group_name', {
        current: isCurrent
      });

      return _react2.default.createElement(
        'div',
        { className: mainClassName },
        _react2.default.createElement(
          'h3',
          {
            className: groupNameClassName,
            onClick: function onClick() {
              return _this3.props.onSelect(_this3.props.restaurantsGroup);
            }
          },
          this.props.restaurantsGroup.name
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderSublist()
        )
      );
    }
  }]);

  return RestaurantsGroupHierarchyView;
}(_react.Component);

RestaurantsGroupHierarchyView.defaultProps = {
  level: 0,

  selectedRestaurantsGroup: null,

  readOnly: false
};
RestaurantsGroupHierarchyView.propTypes = {
  restaurantsGroup: _propTypes2.default.objectOf(_restaurantsGroup.RestaurantsGroup).isRequired,

  selectedRestaurantsGroup: _propTypes2.default.objectOf(_restaurantsGroup.RestaurantsGroup),

  level: _propTypes2.default.number,

  readOnly: _propTypes2.default.bool,

  onSelect: _propTypes2.default.func };
exports.default = RestaurantsGroupHierarchyView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantsGroupHierarchyView, 'RestaurantsGroupHierarchyView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/restaurantsGroup/RestaurantsGroupHierarchyView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/security/NoPermissionIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _NoPermissionModal = __webpack_require__("./scripts/components/security/NoPermissionModal.js");

var _NoPermissionModal2 = _interopRequireDefault(_NoPermissionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoPermissionIcon = function (_Component) {
  _inherits(NoPermissionIcon, _Component);

  function NoPermissionIcon() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NoPermissionIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoPermissionIcon.__proto__ || Object.getPrototypeOf(NoPermissionIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      shouldDisplayModal: false
    }, _this.onClick = function () {
      var _this2;

      return (_this2 = _this).__onClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHideModal = function () {
      var _this3;

      return (_this3 = _this).__onHideModal__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  // Events
  //


  _createClass(NoPermissionIcon, [{
    key: '__onHideModal__REACT_HOT_LOADER__',
    value: function __onHideModal__REACT_HOT_LOADER__() {
      return this.__onHideModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      this.setState({
        shouldDisplayModal: true
      });
    }
  }, {
    key: '__onHideModal__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onHideModal__REACT_HOT_LOADER__() {
      this.setState({
        shouldDisplayModal: false
      });
    }
  }, {
    key: 'renderModal',
    value: function renderModal() {
      return _react2.default.createElement(_NoPermissionModal2.default, {
        onHide: this.onHideModal,
        show: this.state.shouldDisplayModal,
        permission: this.props.permission
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', {
          className: 'fa fa-lock no_permission_icon',
          onClick: this.onClick
        }),
        this.renderModal()
      );
    }
  }]);

  return NoPermissionIcon;
}(_react.Component);

NoPermissionIcon.propTypes = {
  onPermissionGiven: _propTypes2.default.func,

  permission: _propTypes2.default.func
};
exports.default = NoPermissionIcon;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NoPermissionIcon, 'NoPermissionIcon', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/security/NoPermissionIcon.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/security/NoPermissionModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @parent NoPermissionIcon
 */
var NoPermissionModal = function (_Component) {
  _inherits(NoPermissionModal, _Component);

  function NoPermissionModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NoPermissionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoPermissionModal.__proto__ || Object.getPrototypeOf(NoPermissionModal)).call.apply(_ref, [this].concat(args))), _this), _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NoPermissionModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show;
    }

    //
    // events - modal
    //

  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        { className: 'row no_permission_modal text-center' },
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('components.no_permission.label')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.no_permission.permission_required')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return NoPermissionModal;
}(_react.Component);

NoPermissionModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,

  onHide: _propTypes2.default.func.isRequired,

  onPermissionGiven: _propTypes2.default.func.isRequired,

  permission: _propTypes2.default.func
};
exports.default = NoPermissionModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NoPermissionModal, 'NoPermissionModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/security/NoPermissionModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/sidebar/Sidebar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _AbstractMenuComponent = __webpack_require__("./scripts/components/AbstractMenuComponent.js");

var _AbstractMenuComponent2 = _interopRequireDefault(_AbstractMenuComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- stores


/**
 * Display a sidebar
 *
 * User metisMenu jquery library to handle sub-menus.
 *
 * @parent Layout
 *
 * Handle the header view.
 * Responsive mode: Hidden. The header will display the same content.
 */
var Sidebar = function (_MenuAbstracComponent) {
  _inherits(Sidebar, _MenuAbstracComponent);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
  }

  _createClass(Sidebar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return true;
      // return shallowCompare(this, nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      /**
       * TODO: Add 'active' class to the current route.
       */

      if (!_SessionStore2.default.isLoggedIn()) {
        return null;
      }

      return _react2.default.createElement(
        'nav',
        { role: 'navigation' },
        _react2.default.createElement(
          'ul',
          { className: 'nav nav-sidebar navbar-collapse' },
          this.renderDashboard(),
          this.renderOrder(),
          this.renderPayment(),
          this.renderRestaurantSettings()
        )
      );
    }
  }]);

  return Sidebar;
}(_AbstractMenuComponent2.default);

Sidebar.propTypes = {};
var _default = Sidebar;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Sidebar, 'Sidebar', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/sidebar/Sidebar.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/sidebar/Sidebar.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/components/timelapse/TimelapsePicker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _reactDatetime = __webpack_require__("./node_modules/react-datetime/DateTime.js");

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _Calendar = __webpack_require__("./sdk/scripts/components/Calendar.js");

var _Calendar2 = _interopRequireDefault(_Calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- stores


// -- entities


// -- views


/**
 * Display a picker that allows to choose a timelapse. There is four main choices:
 * - day
 * - week
 * - month
 * - custom
 *
 * Docs:
 * - http://momentjs.com/docs/#/manipulating/add/
 */
var TimelapsePicker = function (_Component) {
  _inherits(TimelapsePicker, _Component);

  function TimelapsePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimelapsePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimelapsePicker.__proto__ || Object.getPrototypeOf(TimelapsePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fromTime: _this.defaultFromTime,
      toTime: _this.defaultToTime,

      id: _Utils2.default.generateUID(),

      displayPickers: false
    }, _this.onSelectDayInterval = function () {
      var _this2;

      return (_this2 = _this).__onSelectDayInterval__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onSelectWeekInterval = function () {
      var _this3;

      return (_this3 = _this).__onSelectWeekInterval__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSelectMonthInterval = function () {
      var _this4;

      return (_this4 = _this).__onSelectMonthInterval__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onFromTimeChange = function () {
      var _this5;

      return (_this5 = _this).__onFromTimeChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onToTimeChange = function () {
      var _this6;

      return (_this6 = _this).__onToTimeChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onToggle = function () {
      var _this7;

      return (_this7 = _this).__onToggle__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.validatePersonalize = function () {
      var _this8;

      return (_this8 = _this).__validatePersonalize__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimelapsePicker, [{
    key: '__validatePersonalize__REACT_HOT_LOADER__',
    value: function __validatePersonalize__REACT_HOT_LOADER__() {
      return this.__validatePersonalize__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggle__REACT_HOT_LOADER__',
    value: function __onToggle__REACT_HOT_LOADER__() {
      return this.__onToggle__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToTimeChange__REACT_HOT_LOADER__',
    value: function __onToTimeChange__REACT_HOT_LOADER__() {
      return this.__onToTimeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFromTimeChange__REACT_HOT_LOADER__',
    value: function __onFromTimeChange__REACT_HOT_LOADER__() {
      return this.__onFromTimeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectMonthInterval__REACT_HOT_LOADER__',
    value: function __onSelectMonthInterval__REACT_HOT_LOADER__() {
      return this.__onSelectMonthInterval__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectWeekInterval__REACT_HOT_LOADER__',
    value: function __onSelectWeekInterval__REACT_HOT_LOADER__() {
      return this.__onSelectWeekInterval__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectDayInterval__REACT_HOT_LOADER__',
    value: function __onSelectDayInterval__REACT_HOT_LOADER__() {
      return this.__onSelectDayInterval__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectDayInterval__REACT_HOT_LOADER__',
    value: function __onSelectDayInterval__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!_lodash2.default.isNull(this.props.onTimelapseSelectionChanged)) {
        this.props.onTimelapseSelectionChanged(_ViewConstants2.default.Timelapse.Selection.DAY);
      } else {
        // default: we save the selection as the global timelapse selection
        _SessionStore2.default.saveTimelapseSelection(_ViewConstants2.default.Timelapse.Selection.DAY);
      }
      var timelapse = void 0;
      if (this.props.futureMode) {
        timelapse = _DateUtils2.default.getTimelapseDayInterval();
      } else {
        timelapse = _DateUtils2.default.getTimelapseDayInterval();
      }
      this.props.onTimelapseChange(timelapse);
      this.onToggle();
    }
  }, {
    key: '__onSelectWeekInterval__REACT_HOT_LOADER__',
    value: function __onSelectWeekInterval__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!_lodash2.default.isNull(this.props.onTimelapseSelectionChanged)) {
        this.props.onTimelapseSelectionChanged(_ViewConstants2.default.Timelapse.Selection.WEEK);
      } else {
        // default: we save the selection as the global timelapse selection
        _SessionStore2.default.saveTimelapseSelection(_ViewConstants2.default.Timelapse.Selection.WEEK);
      }
      var timelapse = void 0;
      if (this.props.futureMode) {
        timelapse = _DateUtils2.default.getTimelapseWeekIntervalInFuture();
      } else {
        timelapse = _DateUtils2.default.getTimelapseWeekInterval();
      }
      this.props.onTimelapseChange(timelapse);
      this.onToggle();
    }
  }, {
    key: '__onSelectMonthInterval__REACT_HOT_LOADER__',
    value: function __onSelectMonthInterval__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!_lodash2.default.isNull(this.props.onTimelapseSelectionChanged)) {
        this.props.onTimelapseSelectionChanged(_ViewConstants2.default.Timelapse.Selection.MONTH);
      } else {
        // default: we save the selection as the global timelapse selection
        _SessionStore2.default.saveTimelapseSelection(_ViewConstants2.default.Timelapse.Selection.MONTH);
      }
      var timelapse = void 0;
      if (this.props.futureMode) {
        timelapse = _DateUtils2.default.getTimelapseMonthIntervalInFuture();
      } else {
        timelapse = _DateUtils2.default.getTimelapseMonthInterval();
      }
      this.props.onTimelapseChange(timelapse);
      this.onToggle();
    }
  }, {
    key: '__onFromTimeChange__REACT_HOT_LOADER__',
    value: function __onFromTimeChange__REACT_HOT_LOADER__(fromTime) {
      this.setState({
        fromTime: fromTime.startOf('day')
      });
    }
  }, {
    key: '__onToTimeChange__REACT_HOT_LOADER__',
    value: function __onToTimeChange__REACT_HOT_LOADER__(toTime) {
      this.setState({
        toTime: toTime.endOf('day')
      });
    }
  }, {
    key: '__onToggle__REACT_HOT_LOADER__',
    value: function __onToggle__REACT_HOT_LOADER__() {
      $('#' + this.state.id).parent().toggleClass('open');
    }
  }, {
    key: '__validatePersonalize__REACT_HOT_LOADER__',


    // -- Tools

    /**
     *
     * @param type ViewConstants.Timelapse.Selection
     * @returns {boolean}
     */
    value: function __validatePersonalize__REACT_HOT_LOADER__() {
      var fromTime = this.state.fromTime;
      var toTime = this.state.toTime;

      _SessionStore2.default.saveTimelapseSelection(_ViewConstants2.default.Timelapse.Selection.CUSTOM);

      var timelapse = new _Timelapse2.default();

      timelapse.setFromTime(fromTime.startOf('day').unix());
      timelapse.setToTime(toTime.endOf('day').unix());

      this.props.onTimelapseChange(timelapse);

      this.onToggle();
    }
  }, {
    key: 'isCurrent',
    value: function isCurrent(type) {
      var timelapseSelection = this.props.timelapseSelection;
      return type === timelapseSelection;
    }

    // -- renderers

  }, {
    key: 'renderPickers',
    value: function renderPickers() {
      var fromTime = this.state.fromTime;
      var toTime = this.state.toTime;

      if (this.state.displayPickers === false) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'row', id: 'daterange' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(_Calendar2.default, {
            defaultDate: fromTime,
            minDate: (0, _moment2.default)().subtract(10, 'years'),
            maxDate: toTime.isBefore((0, _moment2.default)()) ? toTime : (0, _moment2.default)(),
            onChange: this.onFromTimeChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(_Calendar2.default, {
            defaultDate: toTime,
            minDate: fromTime,
            maxDate: (0, _moment2.default)(),
            onChange: this.onToTimeChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary',
              onClick: this.validatePersonalize
            },
            _I18n2.default.tr('components.timelapse.picker.validate')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var timelapse = this.props.timelapse;

      var className = (0, _classnames2.default)('form-inline timelapse_picker', this.props.className, {
        selected: this.props.popinMode
      });

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'dropdown dropdown-accordion' },
          _react2.default.createElement(
            'label',
            { className: 'col-xs-4' },
            _I18n2.default.tr('components.timelapse.picker.period')
          ),
          _react2.default.createElement(
            'button',
            {
              onClick: this.onToggle,
              id: this.state.id,
              className: 'btn btn-default btn-dropdown col-xs-8'
            },
            _react2.default.createElement(
              'span',
              {
                className: 'fromTime'
              },
              timelapse.getFromTimeAsFormattedDate()
            ),
            _react2.default.createElement(
              'span',
              null,
              ' - '
            ),
            _react2.default.createElement(
              'span',
              { className: 'toTime' },
              timelapse.getToTimeAsFormattedDate()
            ),
            _react2.default.createElement('span', { className: 'caret' })
          ),
          _react2.default.createElement(
            'ul',
            {
              className: 'timelapse-menu dropdown-menu dropdown-menu-right col-xs-8',
              role: 'menu'
            },
            _react2.default.createElement(
              'li',
              {
                className: this.isCurrent(_ViewConstants2.default.Timelapse.Selection.DAY) ? 'timelapse_current' : ''
              },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  onClick: this.onSelectDayInterval
                },
                _I18n2.default.tr('components.timelapse.picker.day')
              )
            ),
            _react2.default.createElement(
              'li',
              { className: this.isCurrent(_ViewConstants2.default.Timelapse.Selection.WEEK) ? 'timelapse_current' : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  onClick: this.onSelectWeekInterval
                },
                _I18n2.default.tr('components.timelapse.picker.week')
              )
            ),
            _react2.default.createElement(
              'li',
              { className: this.isCurrent(_ViewConstants2.default.Timelapse.Selection.MONTH) ? 'timelapse_current' : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  onClick: this.onSelectMonthInterval
                },
                _I18n2.default.tr('components.timelapse.picker.month')
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                {
                  className: 'pointer',
                  onClick: function onClick() {
                    _this9.setState({ displayPickers: !_this9.state.displayPickers });
                  }
                },
                _I18n2.default.tr('components.timelapse.picker.custom')
              ),
              this.renderPickers()
            )
          )
        )
      );
    }
  }, {
    key: 'defaultFromTime',
    get: function get() {
      return this.props.timelapse.getFromTime() === -1 ? _DateUtils2.default.getTimelapseMonthInterval().getFromTimeAsDate() : this.props.timelapse.getFromTimeAsDate();
    }
  }, {
    key: 'defaultToTime',
    get: function get() {
      return this.props.timelapse.getToTime() === -1 ? _DateUtils2.default.getTimelapseMonthInterval().getToTimeAsDate() : this.props.timelapse.getToTimeAsDate();
    }

    // -- Events

  }]);

  return TimelapsePicker;
}(_react.Component);

TimelapsePicker.propTypes = {
  timelapse: _propTypes2.default.objectOf(_Timelapse2.default).isRequired,
  onTimelapseChange: _propTypes2.default.func.isRequired,

  className: _propTypes2.default.string,
  popinMode: _propTypes2.default.bool,

  /**
   * The current item menu selected as timelapse.
   * @type ViewsConstants.Timelapse.Selection
   */
  timelapseSelection: _propTypes2.default.number,

  futureMode: _propTypes2.default.bool,

  onTimelapseSelectionChanged: _propTypes2.default.func
};
TimelapsePicker.defaultProps = {
  popinMode: false,

  futureMode: false,

  timelapseSelection: null,

  // param: ViewConstants.Timelapse.Selection
  onTimelapseSelectionChanged: null
};
var _default = TimelapsePicker;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TimelapsePicker, 'TimelapsePicker', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/timelapse/TimelapsePicker.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/components/timelapse/TimelapsePicker.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/constants/ActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror;

var _keymirror = __webpack_require__("./node_modules/keymirror/index.js");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ActionTypes = (0, _keymirror2.default)((_keyMirror = {
  REDIRECT: null,

  ERROR_RESPONSE: null,

  LOGIN_RESPONSE_SUCCESS: null,
  LOGIN_RESPONSE_FAILURE: null,

  RESTAURANT_RESPONSE_SUCCESS: null,
  ME_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_RESPONSE_SUCCESS: null,
  PUT_ME_RESPONSE_FAILURE: null,

  GET_RESTAURANT_SUCCESS: null,
  GET_RESTAURANT_FAILURE: null,

  POST_RESTAURANT_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MULTIPART_RESPONSE_FAILURE: null,

  PAYMENT_STATISTICS_RESPONSE_SUCCESS: null,
  PAYMENT_STATISTICS_RESPONSE_FAILURE: null,

  PAYMENT_PAYOUTS_RESPONSE_REQUEST: null,
  PAYMENT_PAYOUTS_RESPONSE_SUCCESS: null,
  PAYMENT_PAYOUTS_RESPONSE_FAILURE: null,

  PAYMENT_PAYINS_RESPONSE_REQUEST: null,
  PAYMENT_PAYINS_RESPONSE_SUCCESS: null,
  PAYMENT_PAYINS_RESPONSE_FAILURE: null,

  //
  // ORDER
  //

  ON_GOING_ORDERS_LISTRESPONSE_SUCCESS: null,
  ON_GOING_ORDERS_LISTRESPONSE_FAILURE: null,

  ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_SUCCESS: null,
  ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_FAILURE: null,

  GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_SUCCESS: null,
  GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_FAILURE: null,

  GET_ORDER_SETTINGS_SUCCESS: null,
  GET_ORDER_SETTINGS_FAILURE: null,

  PUT_ORDER_SETTINGS_SUCCESS: null,
  PUT_ORDER_SETTINGS_FAILURE: null,

  UPDATE_ORDER_RESPONSE_SUCCESS: null,
  UPDATE_ORDER_RESPONSE_FAILURE: null,

  GET_ORDER_STATISTICS_SUCCESS: null,
  GET_ORDER_STATISTICS_FAILURE: null,

  GET_CART_MODIFIERS: null,
  GET_CART_MODIFIERS_SUCCESS: null,
  GET_CART_MODIFIERS_FAILURE: null,

  GET_CART_MODIFIER: null,
  GET_CART_MODIFIER_SUCCESS: null,
  GET_CART_MODIFIER_FAILURE: null,

  PUT_CART_MODIFIER: null,
  PUT_CART_MODIFIER_SUCCESS: null,
  PUT_CART_MODIFIER_FAILURE: null,

  POST_CART_MODIFIER: null,
  POST_CART_MODIFIER_SUCCESS: null,
  POST_CART_MODIFIER_FAILURE: null,

  PUT_CART_MODIFIERS_PRIORITIES: null,
  PUT_CART_MODIFIERS_PRIORITIES_SUCCESS: null,
  PUT_CART_MODIFIERS_PRIORITIES_FAILURE: null,

  //
  // Reviewns
  //

  GET_REVIEWS_SUMMARY_RESPONSE_SUCCESS: null,
  GET_REVIEWS_SUMMARY_RESPONSE_FAILURE: null,

  GET_USER_REVIEWS_SUMMARY_RESPONSE_SUCCESS: null,
  GET_USER_REVIEWS_SUMMARY_RESPONSE_FAILURE: null,

  GET_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_SUCCESS: null,
  GET_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_FAILURE: null,

  PUT_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_SUCCESS: null,
  PUT_CLAIMS_DISCUSSIONS_SETTINGS_RESPONSE_FAILURE: null,

  GET_USER_RESPONSE_SUCCESS: null,
  GET_USER_RESPONSE_FAILURE: null,

  GET_USER_PAYMENTS_RESPONSE_SUCCESS: null,
  GET_USER_PAYMENTS_RESPONSE_FAILURE: null,

  GET_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_BOOKINGS_RESPONSE_FAILURE: null,

  GET_UPDATED_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_UPDATED_BOOKINGS_RESPONSE_FAILURE: null,

  POST_BOOKING_RESPONSE_SUCCESS: null,
  POST_BOOKING_RESPONSE_FAILURE: null,

  PUT_SHOWN_BOOKING_REQUEST: null, //
  PUT_BOOKING_RESPONSE_SUCCESS: null,
  PUT_BOOKING_RESPONSE_FAILURE: null,

  GET_BOOKING_SETTINGS_RESPONSE_SUCCESS: null,
  GET_BOOKING_SETTINGS_RESPONSE_FAILURE: null,

  GET_CAPACITY_SPECIFICS_SUCCESS: null,
  GET_CAPACITY_SPECIFICS_FAILURE: null,

  PUT_CAPACITY_SPECIFIC_SUCCESS: null,
  PUT_CAPACITY_SPECIFIC_FAILURE: null,

  POST_CAPACITY_SPECIFIC_SUCCESS: null,
  POST_CAPACITY_SPECIFIC_FAILURE: null,

  DELETE_CAPACITY_SPECIFIC_SUCCESS: null,
  DELETE_CAPACITY_SPECIFIC_FAILURE: null,

  GET_UNSEEN_BOOKINGS_REQUEST: null, //
  GET_UNSEEN_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_UNSEEN_BOOKINGS_RESPONSE_FAILURE: null,

  PUT_BOOKING_SETTINGS_RESPONSE_SUCCESS: null,
  PUT_BOOKING_SETTINGS_RESPONSE_FAILURE: null,

  GET_BOOKING_SPECIFICS_SETTINGS_SUCCESS: null,
  GET_BOOKING_SPECIFICS_SETTINGS_FAILURE: null,

  GET_WAITING_BOOKINGS_RESPONSE_SUCCESS: null,
  GET_WAITING_BOOKINGS_RESPONSE_FAILURE: null,

  GET_GUESTS_BOOKED_SUCCESS: null,
  GET_GUESTS_BOOKED_FAILURE: null,

  GET_BOOKING_SLOTS_RESPONSE_SUCCESS: null,
  GET_BOOKING_SLOTS_RESPONSE_FAILURE: null,

  PUT_BOOKING_SPECIFIC_SETTING_SUCCESS: null,
  PUT_BOOKING_SPECIFIC_SETTING_FAILURE: null,

  GET_PDF_BOOKINGS_LIST_LINK_SUCCESS: null,
  GET_PDF_BOOKINGS_LIST_LINK_FAILURE: null,

  //
  // News
  //

  GET_NEWS_LIST_RESPONSE_SUCCESS: null,
  GET_NEWS_LIST_RESPONSE_FAILURE: null,

  POST_NEWS_RESPONSE_SUCCESS: null,
  POST_NEWS_RESPONSE_FAILURE: null,

  PUT_NEWS_RESPONSE_SUCCESS: null,
  PUT_NEWS_RESPONSE_FAILURE: null,

  DELETE_NEWS_RESPONSE_SUCCESS: null,
  DELETE_NEWS_RESPONSE_FAILURE: null,

  //
  // MENU
  //
  GET_RESTAURANT_MENU: null,
  GET_RESTAURANT_MENU_RESPONSE_SUCCESS: null,
  GET_RESTAURANT_MENU_RESPONSE_FAILURE: null,

  GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_SUCCESS: null,
  GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_MENU_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_RESPONSE_FAILURE: null,

  //
  // Menu - Product
  //

  POST_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE: null,

  PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_FAILURE: null,

  //
  // Menu - ProductOption
  //

  PUT_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  PUT_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_FAILURE: null,

  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  DELETE_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE: null,

  POST_RESTAURANT_MENU_PRODUCT_OPTION_REQUEST: null,
  POST_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  POST_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE: null,

  //
  // Menu - Menu
  //

  PUT_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_MENU_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_MENU_RESPONSE_FAILURE: null,

  POST_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_MENU_RESPONSE_FAILURE: null,

  //
  // Menu - MenuPart
  //
  PUT_RESTAURANT_MENU_MENU_PART_SUCCESS: null,
  PUT_RESTAURANT_MENU_MENU_PART_FAILURE: null,

  //
  // Menu - MenuPart - Category
  //
  PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS: null,
  PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE: null,

  DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS: null,
  DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE: null,

  //
  // Menu - category
  //

  PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE: null,

  POST_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE: null,

  //
  // Menu - upsellingCategory
  //

  PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS: null,
  PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE: null,

  POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS: null,
  POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE: null,

  DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS: null,
  DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE: null,

  /**
   * Export
   */
  GET_EXPORT: null,
  GET_EXPORT_SUCCESS: null,
  GET_EXPORT_FAILURE: null,

  //
  // Dahboard
  //

  GET_RESTAURANT_DASHBOARD_RESPONSE_SUCCESS: null,
  GET_RESTAURANT_DASHBOARD_RESPONSE_FAILURE: null,

  //
  // Booking - Notifications
  //

  GET_BOOKING_NOTIFICATIONS_SETTINGS_RESPONSE_SUCCESS: null,
  GET_BOOKING_NOTIFICATIONS_SETTINGS_RESPONSE_FAILURE: null,

  //
  // Pro Accounts
  //
  PRO_FORGOT_PASSWORD_SUCCESS: null,
  PRO_FORGOT_PASSWORD_FAILURE: null,

  PRO_ACCOUNT_GET_ME_SUCCESS: null,
  PRO_ACCOUNT_GET_ME_FAILURE: null,

  PRO_ACCOUNT_CREATE_SUCCESS: null,
  PRO_ACCOUNT_CREATE_FAILURE: null,

  PRO_ACCOUNT_GET_SUCCESS: null,
  PRO_ACCOUNT_GET_FAILURE: null,

  PRO_ACCOUNT_UPDATE_SUCCESS: null,
  PRO_ACCOUNT_UPDATE_FAILURE: null,

  PRO_ACCOUNT_DELETE_SUCCESS: null,
  PRO_ACCOUNT_DELETE_FAILURE: null,

  PRO_ACCOUNT_GET_DOMAINS_SUCCESS: null,
  PRO_ACCOUNT_GET_DOMAINS_FAILURE: null,

  CHANGE_PRO_DOMAIN: null,

  //
  // RestaurantsGroup
  //

  GET_RESTAURANTS_GROUP_SUCCESS: null,
  GET_RESTAURANTS_GROUP_FAILURE: null,

  GET_RESTAURANT_FOR_GROUP_REQUEST: null, //
  GET_RESTAURANT_FOR_GROUP_SUCCESS: null,
  GET_RESTAURANT_FOR_GROUP_FAILURE: null,

  POST_RESTAURANTS_GROUP_SUCCESS: null,
  POST_RESTAURANTS_GROUP_FAILURE: null,

  PUT_RESTAURANTS_GROUP_SUCCESS: null,
  PUT_RESTAURANTS_GROUP_FAILURE: null,

  GET_RESTAURANT_ROLES_SUCCESS: null,
  GET_RESTAURANT_ROLES_FAILURE: null,

  GET_ORDER_STATISTICS: null
}, _defineProperty(_keyMirror, 'GET_ORDER_STATISTICS_SUCCESS', null), _defineProperty(_keyMirror, 'GET_ORDER_STATISTICS_FAILURE', null), _defineProperty(_keyMirror, 'GET_API_CONSUMERS', null), _defineProperty(_keyMirror, 'GET_API_CONSUMERS_SUCCESS', null), _defineProperty(_keyMirror, 'GET_API_CONSUMERS_FAILURE', null), _defineProperty(_keyMirror, 'PUT_ROLE_RESPONSE_SUCCESS', null), _defineProperty(_keyMirror, 'PUT_ROLE_RESPONSE_FAILURE', null), _defineProperty(_keyMirror, 'POST_ROLE_RESPONSE_SUCCESS', null), _defineProperty(_keyMirror, 'POST_ROLE_RESPONSE_FAILURE', null), _defineProperty(_keyMirror, 'DELETE_ROLE_RESPONSE_SUCCESS', null), _defineProperty(_keyMirror, 'DELETE_ROLE_RESPONSE_FAILURE', null), _defineProperty(_keyMirror, 'PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS', null), _defineProperty(_keyMirror, 'PRO_ROLE_WITH_ELEVATION_CODE_FAILURE', null), _defineProperty(_keyMirror, 'GET_KIOSK_SETTINGS_SUCCESS', null), _defineProperty(_keyMirror, 'GET_KIOSK_SETTINGS_FAILURE', null), _defineProperty(_keyMirror, 'PUT_KIOSK_SETTINGS_SUCCESS', null), _defineProperty(_keyMirror, 'PUT_KIOSK_SETTINGS_FAILURE', null), _defineProperty(_keyMirror, 'GET_CUSTOM_TEXTS_CONTAINER_SUCCESS', null), _defineProperty(_keyMirror, 'GET_CUSTOM_TEXTS_CONTAINER_FAILURE', null), _defineProperty(_keyMirror, 'POST_CUSTOM_TEXTS_CONTAINER_SUCCESS', null), _defineProperty(_keyMirror, 'POST_CUSTOM_TEXTS_CONTAINER_FAILURE', null), _defineProperty(_keyMirror, 'PUT_CUSTOM_TEXTS_CONTAINER_SUCCESS', null), _defineProperty(_keyMirror, 'PUT_CUSTOM_TEXTS_CONTAINER_FAILURE', null), _defineProperty(_keyMirror, 'START_TIMER', null), _defineProperty(_keyMirror, 'STOP_TIMER', null), _defineProperty(_keyMirror, 'QUERY_UPDATE', null), _defineProperty(_keyMirror, 'LOGOUT', null), _keyMirror));

var _default = ActionTypes;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ActionTypes, 'ActionTypes', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ActionTypes.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/constants/ApiManagerOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _2 = __webpack_require__("./scripts/constants/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the user credentials for the 'Authorization' header.
 * @returns {string}
 */
function getAuthorizationHeader() {
  return _stores.SessionStore.getAuthorization();
}

function getApiKey() {
  return 'Basic ' + _2.Config.apikey;
}

function getSelectedProDomainId() {
  var domain = _stores.ProAccountStore.getSelectedProDomain();
  if (!_lodash2.default.isNull(domain)) {
    return domain.id;
  }
  return null;
}

function getApiUrl() {
  var apiVersionQueryParam = _utils.UrlUtils.getQueryParam('apiVersion');
  var apiUrl = _2.Config.API_URL;

  // handle the 'apiVersion' query param, that allows to specify which api version we wants to use
  if (!_lodash2.default.isEmpty(apiVersionQueryParam)) {
    apiUrl = apiUrl.replace(/https:\/\/[\w-]*paymytable/, '');
    apiUrl = 'https://' + apiVersionQueryParam + '-dot-paymytable' + apiUrl;
  }

  return apiUrl;
}

var _default = {

  apiUrl: getApiUrl(),

  headersMiddleware: function headersMiddleware() {
    return {
      'Authorization': getAuthorizationHeader(),
      'api-consumer': getApiKey(),
      'restaurant-id': _stores.RestaurantStore.getRestaurantId(),
      'pro-domain-id': getSelectedProDomainId(),
      'Accept-Language': _I18n2.default.getCurrentLanguageWithoutRegionCode()
    };
  },

  errorMiddleware: function errorMiddleware(error, res) {
    if (_lodash2.default.isNil(res)) {
      return false;
    }

    if (res.statusCode === 401) {
      console.error('[API] 401, redirect to login');

      _actions.SessionAction.logout();
      return true;
    }

    if (res.statusCode === 500) {
      _utils.Logger.error('API 500', res);
      _actions.RouteAction.redirect(_RoutingEnum2.default.SERVER_ERROR, null, { sessionId: res.headers['p-session-id'] });
      return true;
    }
  }

};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getAuthorizationHeader, 'getAuthorizationHeader', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ApiManagerOptions.js');

  __REACT_HOT_LOADER__.register(getApiKey, 'getApiKey', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ApiManagerOptions.js');

  __REACT_HOT_LOADER__.register(getSelectedProDomainId, 'getSelectedProDomainId', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ApiManagerOptions.js');

  __REACT_HOT_LOADER__.register(getApiUrl, 'getApiUrl', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ApiManagerOptions.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/ApiManagerOptions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/constants/Config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Env = {

  COMMON: {
    VERSION: '1.0.0',

    Logger: {
      SENTRY_URL: 'https://3136bac98ac7460ca8d5576a9f002a0b@app.getsentry.com/83979',

      DISPLAY_REPORT_DIALOG: true
    },

    Google: {
      Map: {
        API_URL: 'https://maps.googleapis.com/maps/api/js',

        API_VERSION: '3.26',

        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },

    IS_DEV: false,
    IS_PREPROD: false,
    IS_PROD: false
  },

  LOCAL: {
    HOSTNAME: 'localhost',
    API_URL: 'http://localhost:8080/rest',

    apikey: 'NTA5MzgyNDc3MDYwNTA1NjpBTzByMWh1X2Z5YjRuOXp4SUlTTFM4Rm9tQQ==',

    IS_DEV: true,

    Google: {
      Map: {
        // TODO
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.preprod.paymytable.com'
  },

  DEV: {
    HOSTNAME: 'restaurant.dev.paymytable.com',
    API_URL: 'https://bo-dot-paymytabledev.appspot.com/rest',

    apikey: 'NTA5MzgyNDc3MDYwNTA1NjpBTzByMWh1X2Z5YjRuOXp4SUlTTFM4Rm9tQQ==',

    IS_DEV: true,

    Google: {
      Map: {
        // TODO
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.preprod.paymytable.com'
  },

  PREPROD: {
    HOSTNAME: 'restaurant.preprod.paymytable.com',
    API_URL: 'https://1-dot-paymytable-eu-preprod.ew.r.appspot.com/rest',

    apikey: 'NTA5MzgyNDc3MDYwNTA1NjpBTzByMWh1X2Z5YjRuOXp4SUlTTFM4Rm9tQQ==',

    IS_PREPROD: true,

    Google: {
      Map: {
        // TODO for now we use the dev one
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.preprod.paymytable.com'
  },

  PRODUCTION: {
    HOSTNAME: 'restaurant.paymytable.com',
    API_URL: 'https://paymytable-eu.ew.r.appspot.com/rest',

    apikey: 'NTc0NzUwNDE0MDI1NTIzMjpJS3dGSUFQYVhoekI=',

    IS_PROD: true,

    Google: {
      Map: {
        // TODO for now we use the dev one
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.paymytable.com'
  }

};

var currentEnv = Env.DEV;
var hostname = window.location.hostname;

if (hostname === Env.DEV.HOSTNAME || hostname === 'localhost') {
  currentEnv = Env.DEV;
} else if (hostname === Env.PREPROD.HOSTNAME) {
  currentEnv = Env.PREPROD;
} else if (hostname === Env.PRODUCTION.HOSTNAME) {
  currentEnv = Env.PRODUCTION;
}

// if (process.env.__DEV__) {
// currentEnv = Env.PREPROD
// }

var _default = _lodash2.default.merge({}, Env.COMMON, currentEnv);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Env, 'Env', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/Config.js');

  __REACT_HOT_LOADER__.register(currentEnv, 'currentEnv', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/Config.js');

  __REACT_HOT_LOADER__.register(hostname, 'hostname', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/Config.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/Config.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/constants/Constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  supportedLocales: [{
    locale: 'fr',
    name: 'Français'
  }, {
    locale: 'en',
    name: 'English'
  }, {
    locale: 'de',
    name: 'Deutsch'
  }, {
    locale: 'is',
    name: 'Icelandic'
  }],

  localesForTranslation: [
  // too much locales render badly on the bo, we chose to comment some that are not likely to be
  // used
  // { "locale": "af-ZA", "name": "Afrikaans" },
  { locale: 'bg-BG', name: 'Bulgarian' }, { locale: 'ca-AD', name: 'Catalan' }, { locale: 'cs-CZ', name: 'Czech' }, { locale: 'cy-GB', name: 'Welsh' }, { locale: 'da-DK', name: 'Danish' },
  // { "locale": "de-AT", "name": "Deutsch - German (Austria)" },
  // { "locale": "de-CH", "name": "Deutsch - German (Switzerland)" },
  { locale: 'de-DE', name: 'Deutsch - German (Germany)' }, { locale: 'el-GR', name: 'Greek' }, { locale: 'en-GB', name: 'English (UK)' }, { locale: 'en-US', name: 'English (US)' },
  // { "locale": "es-CL", "name": "Spanish (Chile)" },
  { locale: 'es-ES', name: 'Spanish (Spain)' },
  // { "locale": "es-MX", "name": "Spanish (Mexico)" },
  { locale: 'et-EE', name: 'Estonian' },
  // { "locale": "fa-IR", "name": "Persian" },
  { locale: 'fi-FI', name: 'Finnish' },
  // { "locale": "fr-CA", "name": "French (Canada)" },
  { locale: 'fr-FR', name: 'French (France)' },
  // { "locale": "gl-ES", "name": "Galician (Spain)" },
  // { "locale": "he-IL", "name": "Hebrew" },
  // { "locale": "hi-IN", "name": "Hindi" },
  { locale: 'hr-HR', name: 'Croatian' }, { locale: 'hu-HU', name: 'Hungarian' },
  // { "locale": "id-ID", "name": "Indonesian" },
  { locale: 'is-IS', name: 'Icelandic' }, { locale: 'it-IT', name: 'Italian' },
  // { "locale": "ja-JP", "name": "Japanese" },
  // { "locale": "km-KH", "name": "Khmer" },
  // { "locale": "ko-KR", "name": "Korean" },
  { locale: 'lt-LT', name: 'Lithuanian' },
  // { "locale": "lv-LV", "name": "Latvian" },
  // { "locale": "mn-MN", "name": "Mongolian" },
  { locale: 'nb-NO', name: 'Norwegian (Bokmål)' }, { locale: 'nl-NL', name: 'Dutch (Nederlands)' }, { locale: 'nn-NO', name: 'Norwegian (Nynorsk)' },
  // { "locale": "pa-PK", "name": "Punjabi (Shahmukhi)" },
  { locale: 'pl-PL', name: 'Polish' },
  // { "locale": "pt-BR", "name": "Portuguese (Brazil)" },
  { locale: 'pt-PT', name: 'Portuguese (Portugal)' }, { locale: 'ro-RO', name: 'Romanian' },
  // { "locale": "ru-RU", "name": "Russian" },
  { locale: 'sk-SK', name: 'Slovak' }, { locale: 'sl-SI', name: 'Slovenian' }, { locale: 'sr-RS', name: 'Serbian' }, { locale: 'sv-SE', name: 'Swedish' }],

  Order: {
    // Time to wait before sending the new manufacture delay value.
    DELAY_SEND_NEW_MANUFACTURE_DELAY: 3 * 1000, // in seconds

    // Time to wait before check for new order.
    DELAY_CHECK_NEW_ORDERS: _Config2.default.IS_DEV ? 20 * 1000 : 30 * 1000, // in seconds

    MAX_MANUFACTURE_DELAY: 2880 // in minutes 2880 for J&J Boulangerie
  },

  Booking: {
    DELAY_CHECK_UPDATED_BOOKINGS: 30 * 1000, // in seconds

    DELAY_CHECK_CALENDAR: _Config2.default.IS_DEV ? 40 * 1000 : 30 * 1000 // in seconds
  },

  Error: {
    NO_INTERNET: -1,

    UNKNOWN: 0
  },

  CONTACT_EMAIL: 'support@paymytable.com',

  LIMIT_WAITING_BOOKINGS_LIST: _Config2.default.IS_DEV ? 20 : 40,

  Day: {
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6
  },

  Notification: {
    Type: {
      ORDER_NEW: 0
    },
    AudioFile: {
      // filenames
      ORDER_NEW: 'new_order_notification'
    }
  },

  /**
   * Keys for the items stores on the local storage for the current user.
   * !!! Warning: You should remove all the keys that are specific to the user on logout.
   */
  SessionKey: {
    RESTAURANT_ID: 'restaurantId',
    RESTAURANT_GROUPS_ID: 'RESTAURANT_GROUPS_ID',
    ROLES_LIST: 'ROLES', // if change, change also on ProAccountStore and Security context
    ACCOUNT: 'ACCOUNT', // if change, change also on ProAccountStore and Security context
    AUTHORIZATION: 'auth',
    TIMELAPSE: 'timelapse',
    TIMELAPSE_SELECTION: 'TIMELAPSE_SELECTION',
    NEW_BOOKING_DATE: 'NEW_BOOKING_DATE',
    BOOKING_BOOK_DATE: 'BOOKING_BOOK_DATE',
    PRO_DOMAIN_ID: 'PRO_DOMAIN_ID',
    LOCALE: 'locale',

    // -- Those are the id to save the current opened tab.
    EDIT_RESTAURANT_TAB: 'EDIT_RESTAURANT_TAB',
    RECEIPT_PAGE_TAB: 'RECEIPT_PAGE_TAB',
    BOOKING_BOOK_TAB: 'BOOKING_BOOK_TAB',
    BOOKING_SETTINGS_TAB: 'BOOKING_SETTINGS_TAB',
    RESTAURANT_MENU_TAB: 'RESTAURANT_MENU_TAB'
  }
};

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/constants/Events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keymirror = __webpack_require__("./node_modules/keymirror/index.js");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Events = (0, _keymirror2.default)({
  END_LOADING: null,

  CHANGE: null, // TODO: remove

  ON_LOADING_RESTAURANT_SUCCESS: null,

  TIMER_DONE: null,

  ON_ERROR: null,
  ON_LOGIN_ERROR: null,

  ON_LOGIN_SUCCESS: null,

  ON_LOADING_USER: null, // TODO: Change for _SUCCESS
  ON_LOADING_USER_ERROR: null,

  ON_LOADING_USER_REVIEWS_SUMMARY: null, // TODO: Change for _SUCCESS
  ON_LOADING_USER_REVIEWS_SUMMARY_ERROR: null,

  ON_LOADING_BOOKINGS: null, // TODO: Change for _SUCCESS
  ON_LOADING_BOOKINGS_ERROR: null,

  ON_BOOKINGS_DATE_CHANGE: null,

  ON_CREATE_BOOKING: null, // TODO: Change for _SUCCESS
  ON_CREATE_BOOKING_ERROR: null,

  ON_UPDATE_BOOKING: null, // TODO: Change for _SUCCESS
  ON_UPDATE_BOOKING_ERROR: null,

  ON_LOADING_BOOKING_SLOTS_SUCCESS: null,
  ON_LOADING_BOOKING_SLOTS_ERROR: null,

  ON_LOADING_GUESTS_BOOKED_SUCCESS: null,
  ON_LOADING_GUESTS_BOOKED_ERROR: null,

  ON_LOADING_WAITING_BOOKINGS_SUCCESS: null,
  ON_LOADING_WAITING_BOOKINGS_ERROR: null,

  ON_LOADING_UPDATED_BOOKINGS_SUCCESS: null,
  ON_LOADING_UPDATED_BOOKINGS_ERROR: null,

  ON_LOADING_BOOKING_SETTINGS_SUCCESS: null,
  ON_LOADING_BOOKING_SETTINGS_ERROR: null,

  ON_LOADING_BOOKING_SPECIFICS_SETTINGS_SUCCESS: null,
  ON_LOADING_BOOKING_SPECIFICS_SETTINGS_ERROR: null,

  ON_LOADING_CAPACITY_SPECIFICS_SUCCESS: null,
  ON_LOADING_CAPACITY_SPECIFICS_ERROR: null,

  ON_CREATE_CAPACITY_SPECIFIC_SUCCESS: null,
  ON_CREATE_CAPACITY_SPECIFIC_ERROR: null,

  ON_UPDATE_CAPACITY_SPECIFIC_SUCCESS: null,
  ON_UPDATE_CAPACITY_SPECIFIC_ERROR: null,

  ON_DELETE_CAPACITY_SPECIFIC_SUCCESS: null,
  ON_DELETE_CAPACITY_SPECIFIC_ERROR: null,

  ON_UPDATE_BOOKING_SETTINGS_SUCCESS: null,
  ON_UPDATE_BOOKING_SETTINGS_ERROR: null,

  CREATE_RESTAURANT_SUCCESS: null,
  CREATE_RESTAURANT_FAILURE: null,

  //
  // Menu
  //
  ON_LOADING_RESTAURANT_MENU: null,
  ON_LOADING_RESTAURANT_MENU_SUCCESS: null,
  ON_LOADING_RESTAURANT_MENU_ERROR: null,

  ON_UPDATE_RESTAURANT_MENU_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR: null,

  //
  // Menu - Product
  //

  ON_UPDATE_RESTAURANT_MENU_PRODUCT_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_PRODUCT_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_PRODUCT_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_PRODUCT_ERROR: null,

  //
  // Menu - ProductOption
  //

  ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR: null,

  //
  // Menu - Menu
  //

  ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_MENU_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_MENU_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_MENU_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_MENU_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_MENU_ERROR: null,

  //
  // Menu - Menu Part
  //

  ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_MENU_PART_ERROR: null,

  //
  // Menu - Menu Part - Category
  //

  ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR: null,

  //
  // Menu - Category
  //

  ON_UPDATE_RESTAURANT_MENU_CATEGORY_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_CATEGORY_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_CATEGORY_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_CATEGORY_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_CATEGORY_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_CATEGORY_ERROR: null,

  //
  // Menu - UpsellingCategory
  //
  ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS: null,
  ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR: null,

  ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS: null,
  ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR: null,

  ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS: null,
  ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR: null,

  //
  // Dashboard
  //

  ON_LOADING_RESTAURANT_DASHBOARD_INFO_SUCCESS: null,
  ON_LOADING_RESTAURANT_DASHBOARD_INFO_ERROR: null,

  ON_LOADING_BOOKING_NOTIFICATIONS_SETTINGS: null,
  ON_LOADING_BOOKING_NOTIFICATIONS_SETTINGS_ERROR: null,

  ON_PDF_BOOKINGS_LIST_LINK_SUCCESS: null,
  ON_PDF_BOOKINGS_LIST_LINK_FAILURE: null,

  //
  // Pro accounts
  //
  PRO_FORGOT_PASSWORD: null,

  PRO_ACCOUNT_GET_ME_SUCCESS: null,
  PRO_ACCOUNT_GET_ME_FAILURE: null,

  PRO_ACCOUNT_CREATE_SUCCESS: null,
  PRO_ACCOUNT_CREATE_FAILURE: null,

  PRO_ACCOUNT_GET_SUCCESS: null,
  PRO_ACCOUNT_GET_FAILURE: null,

  PRO_ACCOUNT_UPDATE_SUCCESS: null,
  PRO_ACCOUNT_UPDATE_FAILURE: null,

  PRO_ACCOUNT_DELETE_SUCCESS: null,
  PRO_ACCOUNT_DELETE_FAILURE: null,

  PRO_ACCOUNT_GET_DOMAINS_SUCCESS: null,
  PRO_ACCOUNT_GET_DOMAINS_FAILURE: null,

  //
  // Restaurant
  //
  LOAD_RESTAURANT_SUCCESS: null,
  LOAD_RESTAURANT_FAILURE: null,

  UPDATE_RESTAURANT_SUCCESS: null,
  UPDATE_RESTAURANT_FAILURE: null,

  LOAD_RESTAURANTS_GROUP_SUCCESS: null,
  LOAD_RESTAURANTS_GROUP_FAILURE: null,

  CREATE_RESTAURANTS_GROUP_SUCCESS: null,
  CREATE_RESTAURANTS_GROUP_FAILURE: null,

  UPDATE_RESTAURANTS_GROUP_SUCCESS: null,
  UPDATE_RESTAURANTS_GROUP_FAILURE: null,

  LOAD_RESTAURANT_ROLES_SUCCESS: null,
  LOAD_RESTAURANT_ROLES_FAILURE: null,

  // triggered when the user change the selected restaurant / restaurantsGroup
  // we have to re-render the whole page.
  RESTAURANT_CHANGE_REQUEST: null,
  RESTAURANT_CHANGE_SUCCESS: null,
  RESTAURANT_CHANGE_FAILURE: null,

  //
  // Role
  //

  UPDATE_ROLE_SUCCESS: null,
  UPDATE_ROLE_FAILURE: null,

  CREATE_ROLE_SUCCESS: null,
  CREATE_ROLE_FAILURE: null,

  DELETE_ROLE_SUCCESS: null,
  DELETE_ROLE_FAILURE: null,

  //
  // Security
  //

  ON_PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS: null,
  ON_PRO_ROLE_WITH_ELEVATION_CODE_FAILURE: null,

  //
  // Order
  //

  ON_UPDATE_ORDER_SETTINGS_SUCCESS: null,
  ON_UPDATE_ORDER_SETTINGS_FAILURE: null,

  ON_LOAD_ORDER_SETTINGS_SUCCESS: null,
  ON_LOAD_ORDER_SETTINGS_FAILURE: null,

  ON_RETRIEVE_ORDERS_LIST_SUCCESS: null,
  ON_RETRIEVE_ORDERS_LIST_FAILURE: null,

  ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_SUCCESS: null,
  ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_FAILURE: null,

  UPDATE_ORDER_SUCCESS: null,
  UPDATE_ORDER_FAILURE: null,

  GET_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  GET_CUSTOM_TEXTS_CONTAINER_FAILURE: null,
  POST_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  POST_CUSTOM_TEXTS_CONTAINER_FAILURE: null,
  PUT_CUSTOM_TEXTS_CONTAINER_SUCCESS: null,
  PUT_CUSTOM_TEXTS_CONTAINER_FAILURE: null,

  //
  // Other
  //

  ON_QUERY_PARAMS_UPDATE: null
});

var _default = Events;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Events, 'Events', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/Events.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/Events.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/constants/RoutingEnum.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Route = __webpack_require__("./sdk/scripts/flux/Route.js");

var _Route2 = _interopRequireDefault(_Route);

var _LoginPage = __webpack_require__("./scripts/pages/login/LoginPage.js");

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _forgotPassword = __webpack_require__("./scripts/pages/forgotPassword/index.js");

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _LogoutPage = __webpack_require__("./scripts/pages/logout/LogoutPage.js");

var _LogoutPage2 = _interopRequireDefault(_LogoutPage);

var _StatPage = __webpack_require__("./scripts/pages/payment/stat/StatPage.js");

var _StatPage2 = _interopRequireDefault(_StatPage);

var _ReceiptPage = __webpack_require__("./scripts/pages/payment/receipt/ReceiptPage.js");

var _ReceiptPage2 = _interopRequireDefault(_ReceiptPage);

var _OrdersListPage = __webpack_require__("./scripts/pages/order/ordersList/OrdersListPage.js");

var _OrdersListPage2 = _interopRequireDefault(_OrdersListPage);

var _index = __webpack_require__("./scripts/pages/order/cartModifiers/list/index.js");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("./scripts/pages/order/cartModifiers/edit/index.js");

var _index4 = _interopRequireDefault(_index3);

var _OrderSettingsPage = __webpack_require__("./scripts/pages/order/settings/OrderSettingsPage.js");

var _OrderSettingsPage2 = _interopRequireDefault(_OrderSettingsPage);

var _index5 = __webpack_require__("./scripts/pages/order/statistics/index.js");

var _index6 = _interopRequireDefault(_index5);

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _EditRestaurantPage = __webpack_require__("./scripts/pages/restaurant/edit/EditRestaurantPage.js");

var _EditRestaurantPage2 = _interopRequireDefault(_EditRestaurantPage);

var _NotFoundPage = __webpack_require__("./scripts/pages/other/NotFoundPage.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _MenuDetailPage = __webpack_require__("./scripts/pages/menu/menu/MenuDetailPage.js");

var _MenuDetailPage2 = _interopRequireDefault(_MenuDetailPage);

var _MenuEditPage = __webpack_require__("./scripts/pages/menu/menuEdit/MenuEditPage.js");

var _MenuEditPage2 = _interopRequireDefault(_MenuEditPage);

var _ProductEditPage = __webpack_require__("./scripts/pages/menu/productEdit/ProductEditPage.js");

var _ProductEditPage2 = _interopRequireDefault(_ProductEditPage);

var _ProductCategoryDetailPage = __webpack_require__("./scripts/pages/menu/category/ProductCategoryDetailPage.js");

var _ProductCategoryDetailPage2 = _interopRequireDefault(_ProductCategoryDetailPage);

var _MenuPartEditPage = __webpack_require__("./scripts/pages/menu/menuPartEdit/MenuPartEditPage.js");

var _MenuPartEditPage2 = _interopRequireDefault(_MenuPartEditPage);

var _UpsellingCategoryDetailPage = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailPage.js");

var _UpsellingCategoryDetailPage2 = _interopRequireDefault(_UpsellingCategoryDetailPage);

var _ProductOptionDetailPage = __webpack_require__("./scripts/pages/menu/option/ProductOptionDetailPage.js");

var _ProductOptionDetailPage2 = _interopRequireDefault(_ProductOptionDetailPage);

var _ProductOptionEditPage = __webpack_require__("./scripts/pages/menu/optionEdit/ProductOptionEditPage.js");

var _ProductOptionEditPage2 = _interopRequireDefault(_ProductOptionEditPage);

var _DashboardPage = __webpack_require__("./scripts/pages/dashboard/DashboardPage.js");

var _DashboardPage2 = _interopRequireDefault(_DashboardPage);

var _FeatureNonActivatedPage = __webpack_require__("./scripts/pages/other/FeatureNonActivatedPage.js");

var _FeatureNonActivatedPage2 = _interopRequireDefault(_FeatureNonActivatedPage);

var _ServerErrorPage = __webpack_require__("./scripts/pages/other/ServerErrorPage.js");

var _ServerErrorPage2 = _interopRequireDefault(_ServerErrorPage);

var _CGUPage = __webpack_require__("./scripts/pages/other/CGUPage.js");

var _CGUPage2 = _interopRequireDefault(_CGUPage);

var _RestaurantsGroup = __webpack_require__("./scripts/pages/proAccounts/restaurantsGroup/RestaurantsGroup.js");

var _RestaurantsGroup2 = _interopRequireDefault(_RestaurantsGroup);

var _RedirectPage = __webpack_require__("./scripts/pages/other/RedirectPage.js");

var _RedirectPage2 = _interopRequireDefault(_RedirectPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Define all the app routes.
 */
var RoutingEnum = function RoutingEnum() {
  _classCallCheck(this, RoutingEnum);
};

RoutingEnum.DASHBOARD = new _Route2.default('dashboard', '/', _DashboardPage2.default);
RoutingEnum.STAT_HOME = new _Route2.default('stat', '/statistics', _StatPage2.default);
RoutingEnum.LOGIN = new _Route2.default('login', '/login', _LoginPage2.default, false);
RoutingEnum.FORGOT_PASSWORD = new _Route2.default('forgotPassword', '/forgot-password', _forgotPassword2.default, false);
RoutingEnum.LOGOUT = new _Route2.default('logout', '/logout', _LogoutPage2.default);
RoutingEnum.RECEIPT = new _Route2.default('receipts', '/receipts', _ReceiptPage2.default);
RoutingEnum.ORDERS_LIST = new _Route2.default('order_list', '/orders', _OrdersListPage2.default);
RoutingEnum.RESTAURANT_MENU = new _Route2.default('RESTAURANT_MENU', '/restaurant-menu', _RestaurantMenuPage2.default);
RoutingEnum.RESTAURANT_MENU_MENU_NEW = new _Route2.default('RESTAURANT_MENU_MENU_NEW', '/restaurant-menu/menus/new', _MenuEditPage2.default);
RoutingEnum.RESTAURANT_MENU_MENU_DETAIL = new _Route2.default('RESTAURANT_MENU_MENU_DETAIL', '/restaurant-menu/menus/:menuId', _MenuDetailPage2.default);
RoutingEnum.RESTAURANT_MENU_MENU_EDIT = new _Route2.default('RESTAURANT_MENU_MENU_EDIT', '/restaurant-menu/menus/:menuId/edit', _MenuEditPage2.default);
RoutingEnum.RESTAURANT_MENU_PART_EDIT = new _Route2.default('RESTAURANT_MENU_PART_EDIT', '/restaurant-menu/menus/:menuId/parts/:menuPartId/edit', _MenuPartEditPage2.default);
RoutingEnum.RESTAURANT_MENU_PRODUCT_NEW = new _Route2.default('RESTAURANT_MENU_PRODUCT_NEW', '/restaurant-menu/products/new', _ProductEditPage2.default);
RoutingEnum.RESTAURANT_MENU_PRODUCT_EDIT = new _Route2.default('RESTAURANT_MENU_PRODUCT_EDIT', '/restaurant-menu/products/:productId/edit', _ProductEditPage2.default);
RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_NEW = new _Route2.default('RESTAURANT_MENU_OPTION_NEW', '/restaurant-menu/options/new', _ProductOptionEditPage2.default);
RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_DETAIL = new _Route2.default('RESTAURANT_MENU_OPTION_DETAIL', '/restaurant-menu/options/:productOptionId', _ProductOptionDetailPage2.default);
RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_EDIT = new _Route2.default('RESTAURANT_MENU_OPTION_EDIT', '/restaurant-menu/options/:productOptionId/edit', _ProductOptionEditPage2.default);
RoutingEnum.RESTAURANT_MENU_CATEGORY_DETAIL = new _Route2.default('RESTAURANT_MENU_CATEGORY_DETAIL', '/restaurant-menu/categories/:categoryId', _ProductCategoryDetailPage2.default);
RoutingEnum.RESTAURANT_MENU_UPSELLING_CATEGORY_DETAIL = new _Route2.default('RESTAURANT_MENU_CATEGORY_DETAIL', '/restaurant-menu/upselling-categories/:upsellingCategoryId', _UpsellingCategoryDetailPage2.default);
RoutingEnum.ORDERS_CART_MODIFIERS_LIST = new _Route2.default('order_cart_modifiers_list', '/orders/cart-modifiers', _index2.default);
RoutingEnum.ORDERS_CART_MODIFIERS_NEW = new _Route2.default('order_cart_modifiers_new', '/orders/cart-modifiers/new', _index4.default);
RoutingEnum.ORDERS_CART_MODIFIERS_EDIT = new _Route2.default('order_cart_modifiers_edit', '/orders/cart-modifiers/:cartModifierId/edit', _index4.default);
RoutingEnum.ORDER_STATISTICS = new _Route2.default('ORDER_STATISTICS', '/orders/statistics', _index6.default);
RoutingEnum.ORDER_SETTINGS = new _Route2.default('order_settings', '/orders/settings', _OrderSettingsPage2.default);
RoutingEnum.RESTAURANT_EDIT = new _Route2.default('restaurant_edit', '/account', _EditRestaurantPage2.default);
RoutingEnum.FEATURE_NON_ACTIVATED = new _Route2.default('feature_no_activated', '/feature-non-activated', _FeatureNonActivatedPage2.default);
RoutingEnum.RESTAURANTS_GROUP = new _Route2.default('restaurants_group', '/restaurants-group', _RestaurantsGroup2.default);
RoutingEnum.REDIRECT_PAGE = new _Route2.default('redirect', '/redirect', _RedirectPage2.default);
RoutingEnum.SERVER_ERROR = new _Route2.default('server_error', '/server-error', _ServerErrorPage2.default);
RoutingEnum.CGU = new _Route2.default('cgu', '/cgu', _CGUPage2.default, false);
RoutingEnum.NOT_FOUND = new _Route2.default('not_found', '*', _NotFoundPage2.default, false);
var _default = RoutingEnum;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoutingEnum, 'RoutingEnum', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/RoutingEnum.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/constants/RoutingEnum.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/constants/ViewConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  Responsive: {
    LG_MIN: 1200
  },

  Key: {
    ENTER: 13
  },

  Graph: {
    DONUT_SUMMARY_COLORS: ['#D64541', '#E67E22', '#F9BF3B', '#446CB3', '#9dc212'],
    DONUT_ORDERS_COLORS: ['#F9BF3B', '#446CB3', '#9dc212'],
    BAR_PAYMENTS_COLORS: ['#D64541', '#E67E22']
  },

  Image: {
    PLACEHOLDER: '/img/default_restaurant.png', // TODO: change

    // TODO: Use the one on sdk ViewConstants
    DEFAULT_RESTAURANT: '/img/default_restaurant.png',

    // TODO: Use the one on sdk ViewConstants
    DEFAULT_RESTAURANT_LOGO: '/img/user_default_picture.png', // TODO: change

    DEFAULT_RESTAURANT_MENU_PICTURE: '/img/Menu_hippo@3.jpg',

    LOADING_BAR: '/img/loading-bars.svg',

    DEFAULT_NEWS_PICTURE: '/img/draughtboard.png',

    USER_MAP_CURSOR: '/img/ic_user_location.svg',

    RestaurantMenu: {
      NO_IMAGE_FOR_CATEGORY: '/img/placeholder_category.png',

      NO_IMAGE_FOR_PRODUCT: '/img/placeholder_product.png',

      NO_IMAGE_FOR_MENU: '/img/placeholder_product.png',

      NO_IMAGE_FOR_OPTION: '/img/placeholder_product.png',

      NO_IMAGE_FOR_PRODUCT_OPTION: '/img/placeholder_product.png', // TODO: change

      NO_IMAGE_FOR_MENU_PART_CATEGORY_OPTION: '/img/placeholder_product.png'
    }
  },

  Timelapse: {
    Selection: {
      CUSTOM: 0,
      DAY: 1,
      WEEK: 2,
      MONTH: 3
    }
  },

  ColorPicker: {
    DEFAULT_COLOR: '#ccc',
    DEFAULT_COLORS_LIST: ['#468966', '#FFF0A5', '#FFB03B', '#B64926', '#8E2800', '#e1e1e1', '#D24D57', '#F22613', '#D91E18', '#96281B', '#EF4836', '#D64541', '#C0392B', '#CF000F', '#E74C3C', '#DB0A5B', '#F64747', '#F1A9A0', '#D2527F', '#E08283', '#F62459', '#E26A6A', '#DCC6E0', '#663399', '#674172', '#AEA8D3', '#913D88', '#9A12B3', '#BF55EC', '#BE90D4', '#8E44AD', '#9B59B6', '#446CB3', '#E4F1FE', '#4183D7', '#59ABE3', '#81CFE0', '#52B3D9', '#C5EFF7', '#22A7F0', '#3498DB', '#2C3E50', '#19B5FE', '#336E7B', '#22313F', '#6BB9F0', '#1E8BC3', '#3A539B', '#34495E', '#67809F', '#2574A9', '#1F3A93', '#89C4F4', '#4B77BE', '#5C97BF', '#4ECDC4', '#A2DED0', '#87D37C', '#90C695', '#26A65B', '#03C9A9', '#68C3A3', '#65C6BB', '#1BBC9B', '#1BA39C', '#66CC99', '#36D7B7', '#C8F7C5', '#86E2D5', '#2ECC71', '#16A085', '#3FC380', '#019875', '#03A678', '#4DAF7C', '#2ABB9B', '#00B16A', '#1E824C', '#049372', '#26C281', '#FDE3A7', '#F89406', '#EB9532', '#E87E04', '#F4B350', '#F2784B', '#EB974E', '#F5AB35', '#D35400', '#F39C12', '#F9690E', '#F9BF3B', '#F27935', '#E67E22', '#ECECEC', '#6C7A89', '#D2D7D3', '#EEEEEE', '#BDC3C7', '#ECF0F1', '#95A5A6', '#DADFE1', '#ABB7B7', '#F2F1EF', '#BFBFBF']
  },

  ColorView: {
    DEFAULT_COLOR: '#ccc',
    DEFAULT_SIZE: 25
  }

};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/constants/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewConstants = exports.Events = exports.Constants = exports.Config = exports.RoutingEnum = exports.ActionTypes = undefined;

var _ActionTypes2 = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes3 = _interopRequireDefault(_ActionTypes2);

var _RoutingEnum2 = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum3 = _interopRequireDefault(_RoutingEnum2);

var _Config2 = __webpack_require__("./scripts/constants/Config.js");

var _Config3 = _interopRequireDefault(_Config2);

var _Constants2 = __webpack_require__("./scripts/constants/Constants.js");

var _Constants3 = _interopRequireDefault(_Constants2);

var _Events2 = __webpack_require__("./scripts/constants/Events.js");

var _Events3 = _interopRequireDefault(_Events2);

var _ViewConstants2 = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants3 = _interopRequireDefault(_ViewConstants2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ActionTypes = _ActionTypes3.default;
exports.RoutingEnum = _RoutingEnum3.default;
exports.Config = _Config3.default;
exports.Constants = _Constants3.default;
exports.Events = _Events3.default;
exports.ViewConstants = _ViewConstants3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/objects/PayinsForTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents all the payment for a table.
 */
var PayinsForTable = function () {
  function PayinsForTable() {
    _classCallCheck(this, PayinsForTable);

    this.amount = 0;
    this.tips = 0;
    this.fees = 0;
    this.totalTable = 0;
    this.payins = [];
    this.date = 0;
    this.checkId = '';
  }

  /**
   * Contains the total paid by the user (with tips)
   * @type {number}
   */


  _createClass(PayinsForTable, [{
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return _DateUtils2.default.fromSecondsTimestampToString(this.date, format);
    }
  }, {
    key: 'getFormattedHour',
    value: function getFormattedHour() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HH:mm';

      return _DateUtils2.default.fromSecondsTimestampToString(this.date, format);
    }
  }]);

  return PayinsForTable;
}();

exports.default = PayinsForTable;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayinsForTable, 'PayinsForTable', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/objects/PayinsForTable.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/objects/PaymentStatsGraphInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class used for the payment statistics graph.
 */
var PaymentStatsGraphInfo =

// the date of the day as a timestamp in milliseconds (morris require ms).
function PaymentStatsGraphInfo(day, total) {
  _classCallCheck(this, PaymentStatsGraphInfo);

  this.day = 0;
  this.total = 0;

  this.day = Number(day) * 1000;
  if (!_lodash2.default.isNaN(total)) {
    this.total = total;
  } else {
    // cf PaymentStatGraph occurred when multiple payins of same bill have different date.
    console.error('PaymentStatsGraphInfo total is nan for day', day, total);
  }
}

// the total of all the payments for the day (tips include)
;

exports.default = PaymentStatsGraphInfo;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentStatsGraphInfo, 'PaymentStatsGraphInfo', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/objects/PaymentStatsGraphInfo.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/Layout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _SdkConfiguration = __webpack_require__("./sdk/scripts/utils/SdkConfiguration.js");

var _SdkConfiguration2 = _interopRequireDefault(_SdkConfiguration);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Header = __webpack_require__("./scripts/components/header/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _Sidebar = __webpack_require__("./scripts/components/sidebar/Sidebar.js");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _components = __webpack_require__("./scripts/components/index.js");

var _ContactModal = __webpack_require__("./scripts/components/modal/ContactModal.js");

var _ContactModal2 = _interopRequireDefault(_ContactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import { RouteHandler } from 'react-router';


// -- stores


// -- views

// import { Footer } from 'components/footer';


/**
 * @parent index.js
 */
var Layout = function (_AbstractComponent) {
  _inherits(Layout, _AbstractComponent);

  function Layout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Layout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Layout.__proto__ || Object.getPrototypeOf(Layout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayContactModal: false,

      /**
       * The current selected restaurant.
       */
      restaurant: null,

      /**
       * The current user's account.
       */
      meAccount: null,

      /**
       * Is set to true to allow us to reload the whole Layout.
       * Used when we change the restaurant.
       */
      reloadingLayout: false,

      /**
       * Used to know if we are just after the login
       * @type {Boolean}
       */
      onLogin: false
    }, _this.loadAccount = function () {
      var _this2;

      return (_this2 = _this).__loadAccount__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onLogin = function () {
      var _this3;

      return (_this3 = _this).__onLogin__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onLoadMe = function () {
      var _this4;

      return (_this4 = _this).__onLoadMe__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onLoadMeError = function () {
      var _this5;

      return (_this5 = _this).__onLoadMeError__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onRestaurantIsChanging = function () {
      var _this6;

      return (_this6 = _this).__onRestaurantIsChanging__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onRestaurantGroupChange = function () {
      var _this7;

      return (_this7 = _this).__onRestaurantGroupChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onRestaurantChange = function () {
      var _this8;

      return (_this8 = _this).__onRestaurantChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onDisplayContactModal = function () {
      var _this9;

      return (_this9 = _this).__onDisplayContactModal__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onHideContactModal = function () {
      var _this10;

      return (_this10 = _this).__onHideContactModal__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Layout, [{
    key: '__onHideContactModal__REACT_HOT_LOADER__',
    value: function __onHideContactModal__REACT_HOT_LOADER__() {
      return this.__onHideContactModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayContactModal__REACT_HOT_LOADER__',
    value: function __onDisplayContactModal__REACT_HOT_LOADER__() {
      return this.__onDisplayContactModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantChange__REACT_HOT_LOADER__',
    value: function __onRestaurantChange__REACT_HOT_LOADER__() {
      return this.__onRestaurantChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantGroupChange__REACT_HOT_LOADER__',
    value: function __onRestaurantGroupChange__REACT_HOT_LOADER__() {
      return this.__onRestaurantGroupChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantIsChanging__REACT_HOT_LOADER__',
    value: function __onRestaurantIsChanging__REACT_HOT_LOADER__() {
      return this.__onRestaurantIsChanging__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLoadMeError__REACT_HOT_LOADER__',
    value: function __onLoadMeError__REACT_HOT_LOADER__() {
      return this.__onLoadMeError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLoadMe__REACT_HOT_LOADER__',
    value: function __onLoadMe__REACT_HOT_LOADER__() {
      return this.__onLoadMe__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLogin__REACT_HOT_LOADER__',
    value: function __onLogin__REACT_HOT_LOADER__() {
      return this.__onLogin__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__loadAccount__REACT_HOT_LOADER__',
    value: function __loadAccount__REACT_HOT_LOADER__() {
      return this.__loadAccount__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      _SdkConfiguration2.default.setDomainUrl('https://' + _Config2.default.HOSTNAME);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantStore.addListeners(this.restaurantListeners);
      _stores.ProAccountStore.addListeners(this.proAccountListeners);

      _stores.SessionStore.addListener(_constants.Events.ON_LOGIN_SUCCESS, this.onLogin);

      this.loadAccount();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantStore.removeListeners(this.restaurantListeners);
      _stores.ProAccountStore.removeListeners(this.proAccountListeners);

      _stores.SessionStore.removeListener(_constants.Events.ON_LOGIN_SUCCESS, this.onLogin);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return true;
      // return shallowCompare(this, nextProps, nextState);
    }
  }, {
    key: '__loadAccount__REACT_HOT_LOADER__',
    value: function __loadAccount__REACT_HOT_LOADER__() {
      if (_stores.SessionStore.isLoggedIn()) {
        this.showLoading();

        _actions.ProAccountAction.retrieveMeAccount();
      }
    }
  }, {
    key: '__onLogin__REACT_HOT_LOADER__',


    //
    // Listeners
    //

    value: function __onLogin__REACT_HOT_LOADER__() {
      this.showLoading();
      _actions.ProAccountAction.retrieveMeAccount();

      this.setState({
        onLogin: true
      });
    }
  }, {
    key: '__onLoadMe__REACT_HOT_LOADER__',
    value: function __onLoadMe__REACT_HOT_LOADER__() {
      try {
        var onLogin = this.state.onLogin;

        this.setState({
          restaurant: _stores.RestaurantStore.getRestaurant(),
          meAccount: _stores.ProAccountStore.getMeAccount(),
          loading: false,
          onLogin: false
        });

        if (onLogin) {
          _stores.RouteStore.redirectTo(_RoutingEnum2.default.DASHBOARD);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: '__onLoadMeError__REACT_HOT_LOADER__',


    /**
     * The selected restaurant is changing.
     * In order to avoid errors, we reload the layout.
     */
    value: function __onLoadMeError__REACT_HOT_LOADER__() {
      // TODO
    }
  }, {
    key: '__onRestaurantIsChanging__REACT_HOT_LOADER__',


    /**
     * Triggered when the user have changed the selected restaurant / restaurantsGroup
     * we have to reload the whole page.
     */
    value: function __onRestaurantIsChanging__REACT_HOT_LOADER__() {
      this.setState({
        reloadingLayout: true
      });
    }
  }, {
    key: '__onRestaurantGroupChange__REACT_HOT_LOADER__',
    value: function __onRestaurantGroupChange__REACT_HOT_LOADER__() {
      window.location.reload();
    }
  }, {
    key: '__onRestaurantChange__REACT_HOT_LOADER__',


    //
    // events - contact modal
    //

    value: function __onRestaurantChange__REACT_HOT_LOADER__() {
      this.setState({
        restaurant: _stores.RestaurantStore.getRestaurant(),

        // wait for the other api call that retrieve the account
        loading: _lodash2.default.isNull(this.state.meAccount)
      });
    }
  }, {
    key: '__onDisplayContactModal__REACT_HOT_LOADER__',
    value: function __onDisplayContactModal__REACT_HOT_LOADER__() {
      this.setState({
        displayContactModal: true
      });
    }
  }, {
    key: '__onHideContactModal__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onHideContactModal__REACT_HOT_LOADER__() {
      this.setState({
        displayContactModal: false
      });
    }
  }, {
    key: 'renderSidebar',
    value: function renderSidebar() {
      if (!_stores.SessionStore.isLoggedIn()) {
        return null;
      }

      return _react2.default.createElement(_Sidebar2.default, {
        routes: this.props.routes
      });
    }
  }, {
    key: 'renderLayout',
    value: function renderLayout() {
      if (_stores.SessionStore.isLoggedIn()) {
        if (this.state.reloadingLayout === true || _lodash2.default.isNull(this.state.meAccount) || _lodash2.default.isNull(this.state.restaurant)) {
          return this.renderOnLoadingContent();
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Header2.default, {
          onDisplayContactModal: this.onDisplayContactModal,
          routes: this.props.routes
        }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-2 sidebar' },
              this.renderSidebar()
            ),
            _react2.default.createElement(
              'div',
              { id: 'page_wrapper', className: 'col-md-12 col-lg-10 col-lg-offset-2 main' },
              this.props.children
            )
          ),
          _react2.default.createElement(_ContactModal2.default, {
            show: this.state.displayContactModal,
            onHide: this.onHideContactModal
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      /**
      * Render the layout of our page. If an exception occured, we log it and send it to our tracker.
      */
      return _react2.default.createElement(
        'div',
        null,
        this.renderLoading(),
        this.renderLayout()
      );
    }
  }, {
    key: 'restaurantListeners',
    get: function get() {
      return [new _Listener2.default(_constants.Events.LOAD_RESTAURANT_SUCCESS, this.onRestaurantChange), new _Listener2.default(_constants.Events.UPDATE_RESTAURANT_SUCCESS, this.onRestaurantChange), new _Listener2.default(_constants.Events.RESTAURANT_CHANGE_SUCCESS, this.onRestaurantGroupChange), new _Listener2.default(_constants.Events.RESTAURANT_CHANGE_REQUEST, this.onRestaurantIsChanging)];
    }
  }, {
    key: 'proAccountListeners',
    get: function get() {
      return [new _Listener2.default(_constants.Events.PRO_ACCOUNT_GET_ME_SUCCESS, this.onLoadMe), new _Listener2.default(_constants.Events.PRO_ACCOUNT_GET_ME_FAILURE, this.onLoadMeError)];
    }

    //
    // Events
    //

  }]);

  return Layout;
}(_components.AbstractComponent);

Layout.propTypes = {};
var _default = Layout;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Layout, 'Layout', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/Layout.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/Layout.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/dashboard/DashboardPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions

// -- stores


// -- entities

// -- views


var DashboardHomePage = function (_AbstractComponent) {
  _inherits(DashboardHomePage, _AbstractComponent);

  function DashboardHomePage() {
    _classCallCheck(this, DashboardHomePage);

    var _this = _possibleConstructorReturn(this, (DashboardHomePage.__proto__ || Object.getPrototypeOf(DashboardHomePage)).call(this));

    _this.arianeIcon = 'fa-dashboard';
    _this.arianeDetails = [{
      name: 'Accueil',
      link: _RoutingEnum2.default.DASHBOARD
    }];
    return _this;
  }

  _createClass(DashboardHomePage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RouteStore.redirectTo(_RoutingEnum2.default.RESTAURANT_EDIT);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'dashboard_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails })
      );
    }
  }]);

  return DashboardHomePage;
}(_AbstractComponent3.default);

exports.default = DashboardHomePage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardHomePage, 'DashboardHomePage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/dashboard/DashboardPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/forgotPassword/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ForgotPasswordPage = function (_AbstractComponent) {
  _inherits(ForgotPasswordPage, _AbstractComponent);

  function ForgotPasswordPage() {
    _classCallCheck(this, ForgotPasswordPage);

    var _this = _possibleConstructorReturn(this, (ForgotPasswordPage.__proto__ || Object.getPrototypeOf(ForgotPasswordPage)).call(this));

    _this.onForgotPassword = function () {
      return _this.__onForgotPassword__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUsernameChange = function () {
      return _this.__onUsernameChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onSubmit = function () {
      return _this.__onSubmit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      isSuccess: null,
      username: ''
    };
    return _this;
  }

  _createClass(ForgotPasswordPage, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUsernameChange__REACT_HOT_LOADER__',
    value: function __onUsernameChange__REACT_HOT_LOADER__() {
      return this.__onUsernameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onForgotPassword__REACT_HOT_LOADER__',
    value: function __onForgotPassword__REACT_HOT_LOADER__() {
      return this.__onForgotPassword__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.ProAccountStore.addListeners([new _Listener2.default(_constants.Events.PRO_FORGOT_PASSWORD, this.onForgotPassword)]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.ProAccountStore.removeListeners([new _Listener2.default(_constants.Events.PRO_FORGOT_PASSWORD, this.onForgotPassword)]);
    }
  }, {
    key: '__onForgotPassword__REACT_HOT_LOADER__',
    value: function __onForgotPassword__REACT_HOT_LOADER__() {
      var meAccount = _stores.ProAccountStore.getMeAccount();
      this.setState({
        isSuccess: meAccount.forgotPassword
      });

      if (meAccount.forgotPassword) {
        setTimeout(function () {
          _stores.RouteStore.redirectTo(_RoutingEnum2.default.LOGIN);
        }, 2000);
      }
    }
  }, {
    key: '__onUsernameChange__REACT_HOT_LOADER__',
    value: function __onUsernameChange__REACT_HOT_LOADER__() {
      this.setState({
        username: this.refs.username.value
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      this.setState({
        isSuccess: null
      });
      event.preventDefault();
      _actions.ProAccountAction.forgotPassword(this.state.username);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        {
          className: 'login_page__login_form form-horizontal',
          onSubmit: this.onSubmit
        },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-8 col-sm-offset-2' },
            _react2.default.createElement(
              'h2',
              null,
              _I18n2.default.tr('forgot_password.title')
            ),
            _react2.default.createElement(
              'h5',
              { className: 'text-muted' },
              _I18n2.default.tr('forgot_password.description')
            ),
            _react2.default.createElement('input', {
              type: 'email',
              defaultValue: this.state.username,
              name: 'username',
              ref: 'username',
              placeholder: _I18n2.default.tr('forgot_password.email'),
              onChange: this.onUsernameChange,
              className: 'form-control big-form-control'
            }),
            !_lodash2.default.isNil(this.state.isSuccess) ? _react2.default.createElement(
              'h5',
              {
                className: 'text-' + (this.state.isSuccess ? 'primary' : 'danger')
              },
              _I18n2.default.tr('forgot_password.' + (this.state.isSuccess ? 'success' : 'failure'))
            ) : _react2.default.createElement('br', null),
            _react2.default.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary' },
              _I18n2.default.tr('forgot_password.submit')
            )
          )
        )
      );
    }
  }]);

  return ForgotPasswordPage;
}(_AbstractComponent3.default);

exports.default = ForgotPasswordPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ForgotPasswordPage, 'ForgotPasswordPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/forgotPassword/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/login/LoginPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _LoginForm = __webpack_require__("./scripts/pages/login/components/LoginForm.js");

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginPage = function (_AbstractComponent) {
  _inherits(LoginPage, _AbstractComponent);

  function LoginPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call.apply(_ref, [this].concat(args))), _this), _this.onError = function () {
      var _this2;

      return (_this2 = _this).__onError__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onLogin = function () {
      var _this3;

      return (_this3 = _this).__onLogin__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginPage, [{
    key: '__onLogin__REACT_HOT_LOADER__',
    value: function __onLogin__REACT_HOT_LOADER__() {
      return this.__onLogin__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_stores.SessionStore.isLoggedIn()) {
        _stores.RouteStore.redirectTo(_RoutingEnum2.default.DASHBOARD);
      }

      _stores.SessionStore.addListener(_constants.Events.ON_LOGIN_ERROR, this.onError);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.SessionStore.removeListener(_constants.Events.ON_LOGIN_ERROR, this.onError);
    }

    // -- events - API

  }, {
    key: '__onError__REACT_HOT_LOADER__',


    // -- events form
    value: function __onError__REACT_HOT_LOADER__() {
      this.hideLoading();
      var apiError = _stores.SessionStore.getApiError();

      this.attachApiError(apiError);
    }
  }, {
    key: '__onLogin__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onLogin__REACT_HOT_LOADER__(username, password) {
      this.showLoading();
      _actions.SessionAction.login(username, password);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'login_page top-buffer-50' },
        this.renderLoading(),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3' },
          this.renderApiErrorBlock(),
          _react2.default.createElement(_LoginForm2.default, {
            onLogin: this.onLogin
          })
        )
      );
    }
  }]);

  return LoginPage;
}(_AbstractComponent3.default);

exports.default = LoginPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoginPage, 'LoginPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/login/LoginPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/login/components/HibpPassword.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _HibpPasswordRangeContainer = __webpack_require__("./sdk/scripts/components/HibpPasswordRangeContainer.js");

var _HibpPasswordRangeContainer2 = _interopRequireDefault(_HibpPasswordRangeContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HibpPassword = function HibpPassword(_ref) {
  var password = _ref.password,
      pwnedText = _ref.pwnedText,
      _ref$displayIsSecureM = _ref.displayIsSecureMessage,
      displayIsSecureMessage = _ref$displayIsSecureM === undefined ? true : _ref$displayIsSecureM,
      _ref$displayCheckSecu = _ref.displayCheckSecure,
      displayCheckSecure = _ref$displayCheckSecu === undefined ? true : _ref$displayCheckSecu,
      _ref$minPasswordLengt = _ref.minPasswordLength,
      minPasswordLength = _ref$minPasswordLengt === undefined ? 8 : _ref$minPasswordLengt;
  return _react2.default.createElement(
    _HibpPasswordRangeContainer2.default,
    { password: password },
    function (_ref2) {
      var isPwned = _ref2.isPwned,
          isFetching = _ref2.isFetching;

      if (isFetching) {
        if (displayCheckSecure) {
          return _react2.default.createElement(
            'p',
            { className: 'alert alert-info top-buffer-10' },
            _I18n2.default.tr('security.hibp.pwned.checking')
          );
        }
        return null;
      }

      if (isPwned) {
        return _react2.default.createElement(
          'p',
          { className: 'alert alert-warning top-buffer-10' },
          pwnedText
        );
      }

      var isTooSmall = (0, _isEmpty2.default)(password) || password.length < minPasswordLength;
      if (displayIsSecureMessage && !isTooSmall) {
        return _react2.default.createElement(
          'p',
          { className: 'alert alert-info top-buffer-10' },
          _I18n2.default.tr('security.hibp.pwned.is_secure')
        );
      }
      return null;
    }
  );
};

var _default = HibpPassword;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(HibpPassword, 'HibpPassword', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/login/components/HibpPassword.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/login/components/HibpPassword.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/login/components/LoginForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _HibpPassword = __webpack_require__("./scripts/pages/login/components/HibpPassword.js");

var _HibpPassword2 = _interopRequireDefault(_HibpPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginForm = function (_AbstractComponent) {
  _inherits(LoginForm, _AbstractComponent);

  function LoginForm() {
    _classCallCheck(this, LoginForm);

    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this));

    _this.onUsernameChange = function () {
      return _this.__onUsernameChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onPasswordChange = function () {
      return _this.__onPasswordChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onSubmit = function () {
      return _this.__onSubmit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    if (!_Config2.default.IS_PREPROD && !_Config2.default.IS_PROD) {
      _this.state = {
        //username: '15000603', // Zelty PMT
        //        username: '15000403', // Resto Démo
        password: ''
      };
    } else {
      _this.state = {
        username: '',
        password: ''
      };
    }
    return _this;
  }

  _createClass(LoginForm, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPasswordChange__REACT_HOT_LOADER__',
    value: function __onPasswordChange__REACT_HOT_LOADER__() {
      return this.__onPasswordChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUsernameChange__REACT_HOT_LOADER__',
    value: function __onUsernameChange__REACT_HOT_LOADER__() {
      return this.__onUsernameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUsernameChange__REACT_HOT_LOADER__',
    value: function __onUsernameChange__REACT_HOT_LOADER__() {
      this.setState({
        username: this.refs.username.value
      });
    }
  }, {
    key: '__onPasswordChange__REACT_HOT_LOADER__',
    value: function __onPasswordChange__REACT_HOT_LOADER__(value) {
      this.setState({
        password: value
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();
      this.props.onLogin(this.state.username, this.state.password);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        { className: 'login_page__login_form form-horizontal' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-8 col-sm-offset-2' },
            _react2.default.createElement('input', {
              type: 'email',
              defaultValue: this.state.username,
              name: 'username',
              ref: 'username',
              placeholder: _I18n2.default.tr('login.form.username'),
              onChange: this.onUsernameChange,
              className: 'form-control big-form-control'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row top-buffer-30' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-8 col-sm-offset-2' },
            _react2.default.createElement(_form.PasswordInput, {
              onChange: this.onPasswordChange,
              value: this.state.password,
              placeholder: _I18n2.default.tr('login.form.password'),
              className: 'form-control big-form-control'
            }),
            _react2.default.createElement(_HibpPassword2.default, {
              displayCheckSecure: false,
              displayIsSecureMessage: false,
              password: this.state.password,
              pwnedText: _I18n2.default.tr('login.form.password.should_choose_another')
            }),
            _react2.default.createElement(
              'div',
              { className: 'text-right' },
              _react2.default.createElement(
                _Link2.default,
                { to: _RoutingEnum2.default.FORGOT_PASSWORD },
                _I18n2.default.tr('login.form.forgot_password')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-8 col-sm-offset-2 text-center top-buffer-50' },
          _react2.default.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary',
              onClick: this.onSubmit
            },
            _I18n2.default.tr('login.form.connect')
          )
        )
      );
    }
  }]);

  return LoginForm;
}(_AbstractComponent3.default);

LoginForm.propTypes = {
  onLogin: _propTypes2.default.func
};
exports.default = LoginForm;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoginForm, 'LoginForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/login/components/LoginForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/logout/LogoutPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _SessionAction = __webpack_require__("./scripts/actions/SessionAction.js");

var _SessionAction2 = _interopRequireDefault(_SessionAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoutPage = function (_Component) {
  _inherits(LogoutPage, _Component);

  function LogoutPage() {
    _classCallCheck(this, LogoutPage);

    return _possibleConstructorReturn(this, (LogoutPage.__proto__ || Object.getPrototypeOf(LogoutPage)).apply(this, arguments));
  }

  _createClass(LogoutPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _SessionAction2.default.logout();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'logout_page text-center' },
        _react2.default.createElement(
          'h3',
          { className: 'top-buffer-50 text-center' },
          _I18n2.default.tr('logout.redirect_message')
        )
      );
    }
  }]);

  return LogoutPage;
}(_react.Component);

var _default = LogoutPage;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LogoutPage, 'LogoutPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/logout/LogoutPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/logout/LogoutPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/RestaurantMenuPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _OrderAction = __webpack_require__("./scripts/actions/OrderAction.js");

var _OrderAction2 = _interopRequireDefault(_OrderAction);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _CategoriesListPage = __webpack_require__("./scripts/pages/menu/categories/CategoriesListPage.js");

var _CategoriesListPage2 = _interopRequireDefault(_CategoriesListPage);

var _UpsellingCategoriesListPage = __webpack_require__("./scripts/pages/menu/upsellingCategories/list/UpsellingCategoriesListPage.js");

var _UpsellingCategoriesListPage2 = _interopRequireDefault(_UpsellingCategoriesListPage);

var _SuggestionsListPage = __webpack_require__("./scripts/pages/menu/suggestions/SuggestionsListPage.js");

var _SuggestionsListPage2 = _interopRequireDefault(_SuggestionsListPage);

var _MenusListPage = __webpack_require__("./scripts/pages/menu/menus/MenusListPage.js");

var _MenusListPage2 = _interopRequireDefault(_MenusListPage);

var _OptionsListPage = __webpack_require__("./scripts/pages/menu/options/OptionsListPage.js");

var _OptionsListPage2 = _interopRequireDefault(_OptionsListPage);

var _ProductsListPage = __webpack_require__("./scripts/pages/menu/products/ProductsListPage.js");

var _ProductsListPage2 = _interopRequireDefault(_ProductsListPage);

var _SynchronizeMenuView = __webpack_require__("./scripts/pages/menu/components/SynchronizeMenuView.js");

var _SynchronizeMenuView2 = _interopRequireDefault(_SynchronizeMenuView);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- actions


// -- stores


// -- entities


// -- components


var RestaurantMenuPage = function (_AbstractComponent) {
  _inherits(RestaurantMenuPage, _AbstractComponent);

  function RestaurantMenuPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantMenuPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantMenuPage.__proto__ || Object.getPrototypeOf(RestaurantMenuPage)).call.apply(_ref, [this].concat(args))), _this), _this.arianeIcon = 'fa-shopping-cart', _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.order'),
      link: null
    }, {
      name: _I18n2.default.tr('menu.order.restaurant_menu'),
      link: null
    }], _this.state = {
      restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu(),
      restaurant: _stores.RestaurantStore.getRestaurant(),

      orderSettings: _stores.OrderSettingsStore.getOrderSettings(),

      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onError = function () {
      var _this3;

      return (_this3 = _this).__onError__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onOrderSettingsChange = function () {
      var _this4;

      return (_this4 = _this).__onOrderSettingsChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onTabChange = function () {
      var _this5;

      return (_this5 = _this).__onTabChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantMenuPage, [{
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__() {
      return this.__onTabChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderSettingsChange__REACT_HOT_LOADER__',
    value: function __onOrderSettingsChange__REACT_HOT_LOADER__() {
      return this.__onOrderSettingsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_stores.RestaurantStore.getRestaurant().haveFeatureOrder()) {
        _RouteAction2.default.redirectToFeatureNonActivated();
        return;
      }

      _stores.RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);
      _stores.OrderSettingsStore.addListeners(this.orderSettingsStoreListeners);

      this.showLoading();
      _RestaurantMenuAction2.default.loadRestaurantMenu();

      if (_lodash2.default.isNull(_stores.OrderSettingsStore.getOrderSettings())) {
        _OrderAction2.default.loadOrderSettings();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
      _stores.OrderSettingsStore.removeListeners(this.orderSettingsStoreListeners);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      this.setState({
        restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu().copy(),
        loading: false
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _stores.RestaurantMenuStore.getApiError(),
        loading: false
      });
    }
  }, {
    key: '__onOrderSettingsChange__REACT_HOT_LOADER__',


    // -- Tabs

    value: function __onOrderSettingsChange__REACT_HOT_LOADER__() {
      this.setState({
        orderSettings: _stores.OrderSettingsStore.getOrderSettings()
      });
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__(activeKey) {
      if (!_lodash2.default.isUndefined(activeKey)) {
        _stores.SessionStore.saveRestaurantMenuTab(activeKey);

        /*
         * Update the query params.
         */
        this.onChangeQueryUrl({
          tab: activeKey
        });
      }
    }
  }, {
    key: 'renderBody',


    // -- renderers

    value: function renderBody() {
      return _react2.default.createElement(
        _reactBootstrap.Tabs,
        {
          defaultActiveKey: this.defaultTabKey,
          id: 'restaurant_menu__tabs',
          onSelect: this.onTabChange
        },
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: RestaurantMenuPage.Tabs.CATEGORIES,
            title: _I18n2.default.tr('menu.tabs.categories').toUpperCase()
          },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_CategoriesListPage2.default, {
              restaurantMenu: this.state.restaurantMenu
            })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: RestaurantMenuPage.Tabs.UPSELLING_CATEGORIES,
            title: _I18n2.default.tr('menu.tabs.upselling_categories').toUpperCase()
          },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_UpsellingCategoriesListPage2.default, {
              restaurantMenu: this.state.restaurantMenu
            })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: RestaurantMenuPage.Tabs.SUGGESTIONS,
            title: _I18n2.default.tr('menu.tabs.suggestions').toUpperCase()
          },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_SuggestionsListPage2.default, {
              restaurantMenu: this.state.restaurantMenu
            })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: RestaurantMenuPage.Tabs.PRODUCTS,
            title: _I18n2.default.tr('menu.tabs.products').toUpperCase()
          },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_ProductsListPage2.default, {
              restaurantMenu: this.state.restaurantMenu,
              disableStockModification: this.state.orderSettings.menuManagedByPos,
              currencyCode: this.state.restaurant.currency
            })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: RestaurantMenuPage.Tabs.MENUS,
            title: _I18n2.default.tr('menu.tabs.menus').toUpperCase()
          },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_MenusListPage2.default, {
              restaurantMenu: this.state.restaurantMenu,
              currencyCode: this.state.restaurant.currency
            })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: RestaurantMenuPage.Tabs.OPTIONS,
            title: _I18n2.default.tr('menu.tabs.options').toUpperCase()
          },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_OptionsListPage2.default, {
              restaurantMenu: this.state.restaurantMenu
            })
          )
        )
      );
    }
  }, {
    key: 'renderFeatureOrderNotEnabled',
    value: function renderFeatureOrderNotEnabled() {
      // TODO: renderFeatureOrderNotEnabled
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var restaurant = _stores.RestaurantStore.getRestaurant();
      var restaurantMenu = this.state.restaurantMenu;

      var contentView = null;

      if (!restaurant.haveFeatureOrder()) {
        contentView = this.renderFeatureOrderNotEnabled();
      } else if (_lodash2.default.isNull(restaurantMenu) && _lodash2.default.isNull(this.state.apiError)) {
        // is loading
        contentView = this.renderOnLoadingContent();
      } else if (_lodash2.default.isNull(restaurantMenu) && !_lodash2.default.isNull(this.state.apiError)) {
        // error at loading
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            !_lodash2.default.isNull(this.state.orderSettings) && this.state.orderSettings.menuManagedByPos && _react2.default.createElement(_SynchronizeMenuView2.default, { restaurantMenu: restaurantMenu, apiError: this.state.apiError, isLoading: this.state.isLoading })
          ),
          this.state.apiError && _react2.default.createElement(
            'div',
            { style: { width: 360 } },
            this.renderApiErrorBlock()
          )
        );
      } else {
        contentView = this.renderBody();
      }

      return _react2.default.createElement(
        'div',
        { className: 'restaurant_menu' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        !_lodash2.default.isNull(this.state.orderSettings) && this.state.orderSettings.menuManagedByPos && _react2.default.createElement(_SynchronizeMenuView2.default, { restaurantMenu: restaurantMenu, apiError: this.state.apiError, isLoading: this.state.isLoading }),
        this.renderLoading(),
        contentView
      );
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError)];
    }
  }, {
    key: 'orderSettingsStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOAD_ORDER_SETTINGS_SUCCESS, this.onOrderSettingsChange), new _Listener2.default(_Events2.default.ON_UPDATE_ORDER_SETTINGS_SUCCESS, this.onOrderSettingsChange), new _Listener2.default(_Events2.default.ON_UPDATE_ORDER_SETTINGS_FAILURE, this.onError)];
    }

    // -- Event functions

  }, {
    key: 'defaultTabKey',
    get: function get() {
      if (!_lodash2.default.isNull(this.props.location.query)) {
        var tabQuery = this.props.location.query.tab;
        return tabQuery;
      }

      return _stores.SessionStore.getRestaurantMenuTab();
    }
  }]);

  return RestaurantMenuPage;
}(_AbstractComponent3.default);

RestaurantMenuPage.Tabs = {
  CATEGORIES: 'categories',
  UPSELLING_CATEGORIES: 'upselling-categories',
  SUGGESTIONS: 'suggestions',
  PRODUCTS: 'products',
  MENUS: 'menus',
  OPTIONS: 'options'
};
exports.default = RestaurantMenuPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantMenuPage, 'RestaurantMenuPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/RestaurantMenuPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/categories/CategoriesListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _AbstractRestaurantMenuComponent = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js");

var _AbstractRestaurantMenuComponent2 = _interopRequireDefault(_AbstractRestaurantMenuComponent);

var _FixedSubmitArea = __webpack_require__("./sdk/scripts/components/form/FixedSubmitArea.js");

var _FixedSubmitArea2 = _interopRequireDefault(_FixedSubmitArea);

var _CategoryRow = __webpack_require__("./scripts/pages/menu/categories/components/CategoryRow.js");

var _CategoryRow2 = _interopRequireDefault(_CategoryRow);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _restaurantMenu = __webpack_require__("./scripts/components/restaurantMenu/index.js");

var _AddItemToCategoryModal = __webpack_require__("./scripts/pages/menu/category/addItemToCategory/AddItemToCategoryModal.js");

var _AddItemToCategoryModal2 = _interopRequireDefault(_AddItemToCategoryModal);

var _UnusedCategoriesListView = __webpack_require__("./scripts/pages/menu/categories/unusedCategories/UnusedCategoriesListView.js");

var _UnusedCategoriesListView2 = _interopRequireDefault(_UnusedCategoriesListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var CategoriesListPage = function (_AbstractRestaurantMe) {
  _inherits(CategoriesListPage, _AbstractRestaurantMe);

  function CategoriesListPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoriesListPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoriesListPage.__proto__ || Object.getPrototypeOf(CategoriesListPage)).call.apply(_ref, [this].concat(args))), _this), _this.onUpdateRestaurantMenuSuccess = function () {
      var _this2;

      return (_this2 = _this).__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onAddCategoryClick = function () {
      var _this3;

      return (_this3 = _this).__onAddCategoryClick__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onHideCategoryCreateModal = function () {
      var _this4;

      return (_this4 = _this).__onHideCategoryCreateModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onItemsOrderChange = function () {
      var _this5;

      return (_this5 = _this).__onItemsOrderChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onCreateCategory = function () {
      var _this6;

      return (_this6 = _this).__onCreateCategory__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDeleteCategoryFromRoot = function () {
      var _this7;

      return (_this7 = _this).__onDeleteCategoryFromRoot__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onEditClicked = function () {
      var _this8;

      return (_this8 = _this).__onEditClicked__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onHideEditModal = function () {
      var _this9;

      return (_this9 = _this).__onHideEditModal__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.renderRow = function () {
      var _this10;

      return (_this10 = _this).__renderRow__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoriesListPage, [{
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__() {
      return this.__renderRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideEditModal__REACT_HOT_LOADER__',
    value: function __onHideEditModal__REACT_HOT_LOADER__() {
      return this.__onHideEditModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEditClicked__REACT_HOT_LOADER__',
    value: function __onEditClicked__REACT_HOT_LOADER__() {
      return this.__onEditClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteCategoryFromRoot__REACT_HOT_LOADER__',
    value: function __onDeleteCategoryFromRoot__REACT_HOT_LOADER__() {
      return this.__onDeleteCategoryFromRoot__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCreateCategory__REACT_HOT_LOADER__',
    value: function __onCreateCategory__REACT_HOT_LOADER__() {
      return this.__onCreateCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onItemsOrderChange__REACT_HOT_LOADER__',
    value: function __onItemsOrderChange__REACT_HOT_LOADER__() {
      return this.__onItemsOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideCategoryCreateModal__REACT_HOT_LOADER__',
    value: function __onHideCategoryCreateModal__REACT_HOT_LOADER__() {
      return this.__onHideCategoryCreateModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddCategoryClick__REACT_HOT_LOADER__',
    value: function __onAddCategoryClick__REACT_HOT_LOADER__() {
      return this.__onAddCategoryClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__',
    value: function __onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__() {
      return this.__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.restaurantMenu.equals(this.state.restaurantMenu)) {
        this.setState({
          restaurantMenu: nextProps.restaurantMenu.copy()
        });
      }
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      return {
        restaurantMenu: this.props.restaurantMenu.copy(),
        displayCreateCategoryModal: false,
        displayEditModal: false
      };
    }
  }, {
    key: '__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: '__onAddCategoryClick__REACT_HOT_LOADER__',
    value: function __onAddCategoryClick__REACT_HOT_LOADER__() {
      this.setState({
        displayCreateCategoryModal: true
      });
    }
  }, {
    key: '__onHideCategoryCreateModal__REACT_HOT_LOADER__',
    value: function __onHideCategoryCreateModal__REACT_HOT_LOADER__() {
      this.setState({
        displayCreateCategoryModal: false
      });
    }
  }, {
    key: '__onItemsOrderChange__REACT_HOT_LOADER__',
    value: function __onItemsOrderChange__REACT_HOT_LOADER__(categories) {
      var restaurantMenu = this.restaurantMenu;

      var items = [];
      _lodash2.default.each(categories, function (category) {
        var item = new _menu.CategoryItem();
        item.fromCategory(category);

        items.push(item);
      });

      restaurantMenu.getRootCategory().items = items;

      this.setState({
        restaurantMenu: restaurantMenu
      });
    }
  }, {
    key: '__onCreateCategory__REACT_HOT_LOADER__',
    value: function __onCreateCategory__REACT_HOT_LOADER__(restaurantMenu) {
      this.setState({
        restaurantMenu: restaurantMenu,
        loading: true
      }, _RestaurantMenuAction2.default.saveRestaurantMenu(restaurantMenu));
    }
  }, {
    key: '__onDeleteCategoryFromRoot__REACT_HOT_LOADER__',
    value: function __onDeleteCategoryFromRoot__REACT_HOT_LOADER__(category) {
      var _this11 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.category.confirm_deletion_from_root'), function (result) {
        if (result) {
          var restaurantMenu = _this11.restaurantMenu;

          restaurantMenu.removeCategoryFromRoot(category);

          _this11.setState({
            restaurantMenu: restaurantMenu
          });
        }
      });
    }
  }, {
    key: '__onEditClicked__REACT_HOT_LOADER__',
    value: function __onEditClicked__REACT_HOT_LOADER__() {
      this.setState({
        displayEditModal: true
      });
    }
  }, {
    key: '__onHideEditModal__REACT_HOT_LOADER__',


    //
    // getters
    //

    value: function __onHideEditModal__REACT_HOT_LOADER__() {
      this.setState({
        displayEditModal: false
      });
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.state.restaurantMenu.equals(this.props.restaurantMenu);
    }

    //
    // renderers
    //

  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      if (_lodash2.default.isEmpty(this.restaurantMenu.products)) {
        return _react2.default.createElement(
          'p',
          { className: 'bg-warning' },
          _I18n2.default.tr('menu.category.error_no_products_exists')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-sm-12 col-md-6' },
          _react2.default.createElement(_RoundButton2.default, {
            text: _I18n2.default.tr('menu.category.add_category'),
            onClick: this.onAddCategoryClick
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'pull-right' },
          _react2.default.createElement(_RoundButton2.default, {
            icon: 'fa-edit',
            text: _I18n2.default.tr('menu.category.edit_main_category'),
            onClick: this.onEditClicked
          })
        )
      );
    }
  }, {
    key: 'renderTheadContent',
    value: function renderTheadContent() {
      return _react2.default.createElement(
        'div',
        { className: 'thead col-xs-12' },
        _react2.default.createElement('div', { className: 'hidden-xs col-sm-2 text-left' }),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          _I18n2.default.tr('menu.category.table.header.name')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _I18n2.default.tr('menu.category.table.header.delete_from_main_category')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1 text-center' },
          _I18n2.default.tr('menu.category.table.header.move')
        )
      );
    }
  }, {
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__(category) {
      return _react2.default.createElement(_CategoryRow2.default, {
        category: category,
        restaurantMenu: this.restaurantMenu,
        key: category.name,
        onDeleteCategoryFromRoot: this.onDeleteCategoryFromRoot
      });
    }
  }, {
    key: 'renderCategoriesListView',
    value: function renderCategoriesListView() {
      return _react2.default.createElement(_SortableList2.default, {
        items: this.restaurantMenu.getFirstLevelCategories(),
        onChange: this.onItemsOrderChange,
        renderer: this.renderRow,
        displayDragIcon: false
      });
    }
  }, {
    key: 'renderCreateCategoryModal',
    value: function renderCreateCategoryModal() {
      var parentsToPropose = this.restaurantMenu.categories;

      if (this.state.displayCreateCategoryModal) {
        return _react2.default.createElement(_restaurantMenu.EditProductCategoryModal, {
          onCreate: this.onCreateCategory,
          show: true,
          onHide: this.onHideCategoryCreateModal,
          parentsToPropose: parentsToPropose,
          restaurantMenu: this.state.restaurantMenu
        });
      }

      return null;
    }
  }, {
    key: 'renderEditModal',
    value: function renderEditModal() {
      if (this.state.displayEditModal) {
        return _react2.default.createElement(_AddItemToCategoryModal2.default, {
          show: this.state.displayEditModal,
          onHide: this.onHideEditModal,
          restaurantMenu: this.props.restaurantMenu,
          productCategory: this.restaurantMenu.getRootCategory()
        });
      }

      return null;
    }
  }, {
    key: 'renderUnusedCategories',
    value: function renderUnusedCategories() {
      if (_lodash2.default.isNull(this.restaurantMenu) || _lodash2.default.isEmpty(this.restaurantMenu.categories)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('hr', { className: 'top-buffer-50' }),
        _react2.default.createElement(_UnusedCategoriesListView2.default, {
          restaurantMenu: this.restaurantMenu
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'categories_list top-buffer-30' },
          this.renderHeader(),
          !_lodash2.default.isEmpty(this.restaurantMenu.categories) && _react2.default.createElement(
            'div',
            { className: 'table_container table_container_hover top-buffer-50 row' },
            this.renderTheadContent(),
            this.renderCategoriesListView()
          ),
          this.renderUnusedCategories(),
          _SecurityContext2.default.restaurantMenu.canEdit() && this.renderFixedButtons(),
          this.renderLoading(),
          this.renderCreateCategoryModal(),
          this.renderEditModal()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }]);

  return CategoriesListPage;
}(_AbstractRestaurantMenuComponent2.default);

exports.default = CategoriesListPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoriesListPage, 'CategoriesListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/CategoriesListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/categories/components/CategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


// -- views


var CategoryRow = function (_Component) {
  _inherits(CategoryRow, _Component);

  function CategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryRow.__proto__ || Object.getPrototypeOf(CategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDeleteCategoryFromRoot = function () {
      var _this2;

      return (_this2 = _this).__onDeleteCategoryFromRoot__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onUpCategory = function () {
      var _this3;

      return (_this3 = _this).__onUpCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDownCategory = function () {
      var _this4;

      return (_this4 = _this).__onDownCategory__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDisplayDetail = function () {
      var _this5;

      return (_this5 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryRow, [{
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDownCategory__REACT_HOT_LOADER__',
    value: function __onDownCategory__REACT_HOT_LOADER__() {
      return this.__onDownCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpCategory__REACT_HOT_LOADER__',
    value: function __onUpCategory__REACT_HOT_LOADER__() {
      return this.__onUpCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteCategoryFromRoot__REACT_HOT_LOADER__',
    value: function __onDeleteCategoryFromRoot__REACT_HOT_LOADER__() {
      return this.__onDeleteCategoryFromRoot__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category) || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
    }
  }, {
    key: '__onDeleteCategoryFromRoot__REACT_HOT_LOADER__',
    value: function __onDeleteCategoryFromRoot__REACT_HOT_LOADER__() {
      this.props.onDeleteCategoryFromRoot(this.props.category);
    }
  }, {
    key: '__onUpCategory__REACT_HOT_LOADER__',
    value: function __onUpCategory__REACT_HOT_LOADER__() {
      this.props.onMoveUpCategory(this.props.category);
    }
  }, {
    key: '__onDownCategory__REACT_HOT_LOADER__',
    value: function __onDownCategory__REACT_HOT_LOADER__() {
      this.props.onMoveDownCategory(this.props.category);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.props.category);
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var category = this.props.category;

      return _react2.default.createElement(_ImageLoader2.default, {
        className: 'category_row__image',
        src: category.image,
        placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY,
        onClick: this.onDisplayDetail
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var category = this.props.category;

      return _react2.default.createElement(
        'div',
        { className: 'category_row pointer row' },
        _react2.default.createElement(
          'div',
          {
            className: 'hidden-xs col-sm-2',
            onClick: this.onDisplayDetail
          },
          this.renderImage()
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-8 category_row__name',
            onClick: this.onDisplayDetail
          },
          category.name
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer text-center col-xs-1 category_row__delete',
            onClick: this.onDeleteCategoryFromRoot
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer text-center col-xs-1 category_row__drag'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }]);

  return CategoryRow;
}(_react.Component);

CategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_menu.ProductCategory).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  // parameters ProductCategory
  onDeleteCategoryFromRoot: _propTypes2.default.func.isRequired
};
CategoryRow.defaultProps = {
  hideDeactivatedProducts: true
};
var _default = CategoryRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryRow, 'CategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/components/CategoryRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/components/CategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/categories/unusedCategories/UnusedCategoriesListView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _UnusedCategoryRow = __webpack_require__("./scripts/pages/menu/categories/unusedCategories/UnusedCategoryRow.js");

var _UnusedCategoryRow2 = _interopRequireDefault(_UnusedCategoryRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- view


var UnusedCategoriesListView = function (_Component) {
  _inherits(UnusedCategoriesListView, _Component);

  function UnusedCategoriesListView() {
    _classCallCheck(this, UnusedCategoriesListView);

    return _possibleConstructorReturn(this, (UnusedCategoriesListView.__proto__ || Object.getPrototypeOf(UnusedCategoriesListView)).apply(this, arguments));
  }

  _createClass(UnusedCategoriesListView, [{
    key: 'renderBody',


    //
    //
    //

    value: function renderBody() {
      var _this2 = this;

      var unusedCategoriesIds = this.props.restaurantMenu.getUnusedCategoriesIds();

      if (_lodash2.default.isEmpty(unusedCategoriesIds)) {
        return this.renderNoUnused();
      }

      var rows = unusedCategoriesIds.map(function (id) {
        var category = _this2.props.restaurantMenu.getCategoryWithId(id);
        return _this2.renderCategory(category);
      });

      return _react2.default.createElement(
        'div',
        { className: 'table_container table_container_hover top-buffer-50' },
        _react2.default.createElement(
          'table',
          { className: 'table' },
          this.renderTheadContent(),
          _react2.default.createElement(
            'tbody',
            { className: 'body' },
            rows
          )
        )
      );
    }
  }, {
    key: 'renderCategory',
    value: function renderCategory(category) {
      return _react2.default.createElement(_UnusedCategoryRow2.default, {
        key: category.id,
        category: category,
        restaurantMenu: this.props.restaurantMenu
      });
    }
  }, {
    key: 'renderNoUnused',
    value: function renderNoUnused() {
      return _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'p',
          null,
          _I18n2.default.tr('menu.unused_category.no_unused_message')
        )
      );
    }
  }, {
    key: 'renderTheadContent',
    value: function renderTheadContent() {
      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('th', { className: 'hidden-xs col-sm-2 text-left' }),
          _react2.default.createElement(
            'th',
            { className: 'col-xs-8' },
            _I18n2.default.tr('menu.unused_category.table.header.name')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'unused_categories_list_view top-buffer-50' },
          _react2.default.createElement(
            'h3',
            null,
            _I18n2.default.tr('menu.unused_category.title')
          ),
          this.renderBody()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return UnusedCategoriesListView;
}(_react.Component);

UnusedCategoriesListView.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu)
};
var _default = UnusedCategoriesListView;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UnusedCategoriesListView, 'UnusedCategoriesListView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/unusedCategories/UnusedCategoriesListView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/unusedCategories/UnusedCategoriesListView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/categories/unusedCategories/UnusedCategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__("./scripts/pages/menu/categories/unusedCategories/UnusedCategoryRow.scss");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


// -- views


var UnusedCategoryRow = function (_Component) {
  _inherits(UnusedCategoryRow, _Component);

  function UnusedCategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnusedCategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnusedCategoryRow.__proto__ || Object.getPrototypeOf(UnusedCategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnusedCategoryRow, [{
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category) || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.props.category);
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var category = this.props.category;

      return _react2.default.createElement(_ImageLoader2.default, {
        className: 'category_row__image',
        src: category.image,
        placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY,
        onClick: this.onDisplayDetail
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var category = this.props.category;

      return _react2.default.createElement(
        'tr',
        { className: 'unused_category_row pointer' },
        _react2.default.createElement(
          'td',
          {
            className: 'hidden-xs col-sm-2',
            onClick: this.onDisplayDetail
          },
          this.renderImage()
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'pointer col-xs-8 category_row__name',
            onClick: this.onDisplayDetail
          },
          category.name
        )
      );
    }
  }]);

  return UnusedCategoryRow;
}(_react.Component);

UnusedCategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_menu.ProductCategory).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired
};
var _default = UnusedCategoryRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UnusedCategoryRow, 'UnusedCategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/unusedCategories/UnusedCategoryRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/categories/unusedCategories/UnusedCategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/categories/unusedCategories/UnusedCategoryRow.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./scripts/pages/menu/category/ProductCategoryDetailPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _ProductCategoryDetailView = __webpack_require__("./scripts/pages/menu/category/ProductCategoryDetailView.js");

var _ProductCategoryDetailView2 = _interopRequireDefault(_ProductCategoryDetailView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var ProductCategoryDetailPage = function (_AbstractComponent) {
  _inherits(ProductCategoryDetailPage, _AbstractComponent);

  function ProductCategoryDetailPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductCategoryDetailPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductCategoryDetailPage.__proto__ || Object.getPrototypeOf(ProductCategoryDetailPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _RestaurantMenuStore2.default.getRestaurantMenu(),
      restaurant: _RestaurantStore2.default.getRestaurant(),
      productCategory: null,
      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onError = function () {
      var _this3;

      return (_this3 = _this).__onError__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onUpdate = function () {
      var _this4;

      return (_this4 = _this).__onUpdate__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onImageRemove = function () {
      var _this5;

      return (_this5 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductCategoryDetailPage, [{
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__() {
      return this.__onUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListeners(this.restaurantMenuStoreListeners);
      this.loadData(this.props.params.categoryId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // route param have changed (we change the category to display)
      this.loadData(newProps.params.categoryId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'loadData',
    value: function loadData(productCategoryId) {
      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        this.showLoading();
        _RestaurantMenuAction2.default.loadRestaurantMenu();
      } else {
        this.loadProductCategory(productCategoryId);
      }
    }
  }, {
    key: 'loadProductCategory',
    value: function loadProductCategory(productCategoryId) {
      if (!_lodash2.default.isNull(this.state.restaurantMenu)) {
        var productCategory = this.state.restaurantMenu.getCategoryWithId(productCategoryId);

        // category have been deleted are no longer exists
        if (_lodash2.default.isNull(productCategory)) {
          _RouteAction2.default.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU);
        }

        this.setState({
          productCategory: productCategory,
          loading: false
        });
      }
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _RestaurantMenuStore2.default.getRestaurantMenu();
      var productCategory = restaurantMenu.getCategoryWithId(this.props.params.categoryId);

      if (_lodash2.default.isNull(productCategory)) {
        this.setState({
          loading: false
          // TODO: 404
        });
      } else {
        this.setState({
          restaurantMenu: restaurantMenu.copy(),
          productCategory: productCategory.copy(),
          loading: false
        });
      }
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _RestaurantMenuStore2.default.getApiError(),
        loading: false
      });
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__(category) {
      var image = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _utils.ViewUtils.dataUriToFile(image);
      _RestaurantMenuAction2.default.saveCategory(category, imageFile);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onImageRemove__REACT_HOT_LOADER__(category) {
      this.showLoading();
      _RestaurantMenuAction2.default.deleteCategoryImage(category);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.state.productCategory)) {
        return this.renderOnLoadingContent();
      }

      //
      // We use the uid to re-generate the sub view after a changement on the product category.
      //
      return _react2.default.createElement(_ProductCategoryDetailView2.default, {
        key: _utils.Utils.generateUID(),
        productCategory: this.productCategory,
        restaurantMenu: this.restaurantMenu,
        onUpdate: this.onUpdate,
        onImageRemove: this.onImageRemove,
        currencyCode: this.restaurant.currency
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.categories'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: !_lodash2.default.isNull(this.productCategory) ? this.productCategory.name : '',
        link: null
      }];

      return _react2.default.createElement(
        'div',
        { className: 'product_category_detail_page' },
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        this.renderBody(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_CATEGORY_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_CATEGORY_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR, this.onError)];
    }
  }, {
    key: 'productCategory',
    get: function get() {
      return this.state.productCategory;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.state.restaurant;
    }
  }]);

  return ProductCategoryDetailPage;
}(_AbstractComponent3.default);

var _default = ProductCategoryDetailPage;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductCategoryDetailPage, 'ProductCategoryDetailPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/ProductCategoryDetailPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/ProductCategoryDetailPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/ProductCategoryDetailView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _FixedSubmitArea = __webpack_require__("./sdk/scripts/components/form/FixedSubmitArea.js");

var _FixedSubmitArea2 = _interopRequireDefault(_FixedSubmitArea);

var _ImageDropzone = __webpack_require__("./sdk/scripts/components/form/ImageDropzone.js");

var _ImageDropzone2 = _interopRequireDefault(_ImageDropzone);

var _CategoryDetailProductRow = __webpack_require__("./scripts/pages/menu/category/components/CategoryDetailProductRow.js");

var _CategoryDetailProductRow2 = _interopRequireDefault(_CategoryDetailProductRow);

var _CategoryDetailMenuRow = __webpack_require__("./scripts/pages/menu/category/components/CategoryDetailMenuRow.js");

var _CategoryDetailMenuRow2 = _interopRequireDefault(_CategoryDetailMenuRow);

var _CategoryDetailChildCategoryRow = __webpack_require__("./scripts/pages/menu/category/components/CategoryDetailChildCategoryRow.js");

var _CategoryDetailChildCategoryRow2 = _interopRequireDefault(_CategoryDetailChildCategoryRow);

var _components = __webpack_require__("./scripts/components/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _AddItemToCategoryModal = __webpack_require__("./scripts/pages/menu/category/addItemToCategory/AddItemToCategoryModal.js");

var _AddItemToCategoryModal2 = _interopRequireDefault(_AddItemToCategoryModal);

var _restaurantMenu = __webpack_require__("./scripts/components/restaurantMenu/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- actions


// -- utils


// -- entities


// -- views


var ProductCategoryDetailView = function (_AbstractRestaurantMe) {
  _inherits(ProductCategoryDetailView, _AbstractRestaurantMe);

  function ProductCategoryDetailView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductCategoryDetailView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductCategoryDetailView.__proto__ || Object.getPrototypeOf(ProductCategoryDetailView)).call.apply(_ref, [this].concat(args))), _this), _this.onOrderChange = function () {
      var _this2;

      return (_this2 = _this).__onOrderChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteProductFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteProductFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDeleteMenuFromCategory = function () {
      var _this4;

      return (_this4 = _this).__onDeleteMenuFromCategory__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDeleteChildCategoryFromCategory = function () {
      var _this5;

      return (_this5 = _this).__onDeleteChildCategoryFromCategory__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDisplayProductDetail = function () {
      var _this6;

      return (_this6 = _this).__onDisplayProductDetail__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDisplayMenuDetail = function () {
      var _this7;

      return (_this7 = _this).__onDisplayMenuDetail__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onEditClicked = function () {
      var _this8;

      return (_this8 = _this).__onEditClicked__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onDeleteClicked = function () {
      var _this9;

      return (_this9 = _this).__onDeleteClicked__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onHideEditModal = function () {
      var _this10;

      return (_this10 = _this).__onHideEditModal__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onFormSubmit = function () {
      var _this11;

      return (_this11 = _this).__onFormSubmit__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onFormReset = function () {
      var _this12;

      return (_this12 = _this).__onFormReset__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onDisplayAddItemModal = function () {
      var _this13;

      return (_this13 = _this).__onDisplayAddItemModal__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onHideAddItemModal = function () {
      var _this14;

      return (_this14 = _this).__onHideAddItemModal__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onImageChange = function () {
      var _this15;

      return (_this15 = _this).__onImageChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onImageRemove = function () {
      var _this16;

      return (_this16 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onProductCategoryChange = function () {
      var _this17;

      return (_this17 = _this).__onProductCategoryChange__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.renderRow = function () {
      var _this18;

      return (_this18 = _this).__renderRow__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductCategoryDetailView, [{
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__() {
      return this.__renderRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductCategoryChange__REACT_HOT_LOADER__',
    value: function __onProductCategoryChange__REACT_HOT_LOADER__() {
      return this.__onProductCategoryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__() {
      return this.__onImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideAddItemModal__REACT_HOT_LOADER__',
    value: function __onHideAddItemModal__REACT_HOT_LOADER__() {
      return this.__onHideAddItemModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayAddItemModal__REACT_HOT_LOADER__',
    value: function __onDisplayAddItemModal__REACT_HOT_LOADER__() {
      return this.__onDisplayAddItemModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFormReset__REACT_HOT_LOADER__',
    value: function __onFormReset__REACT_HOT_LOADER__() {
      return this.__onFormReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFormSubmit__REACT_HOT_LOADER__',
    value: function __onFormSubmit__REACT_HOT_LOADER__() {
      return this.__onFormSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideEditModal__REACT_HOT_LOADER__',
    value: function __onHideEditModal__REACT_HOT_LOADER__() {
      return this.__onHideEditModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteClicked__REACT_HOT_LOADER__',
    value: function __onDeleteClicked__REACT_HOT_LOADER__() {
      return this.__onDeleteClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEditClicked__REACT_HOT_LOADER__',
    value: function __onEditClicked__REACT_HOT_LOADER__() {
      return this.__onEditClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayMenuDetail__REACT_HOT_LOADER__',
    value: function __onDisplayMenuDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayMenuDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayProductDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayProductDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteChildCategoryFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteChildCategoryFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteChildCategoryFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteMenuFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteMenuFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteMenuFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteProductFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteProductFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderChange__REACT_HOT_LOADER__',
    value: function __onOrderChange__REACT_HOT_LOADER__() {
      return this.__onOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(ProductCategoryDetailView.prototype.__proto__ || Object.getPrototypeOf(ProductCategoryDetailView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        productCategory: props.productCategory.copy(),

        displayAddItemModal: false,

        image: null,

        displayEditModal: false
      };
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.productCategory.equals(nextProps.productCategory);
    }
  }, {
    key: '__onOrderChange__REACT_HOT_LOADER__',
    value: function __onOrderChange__REACT_HOT_LOADER__(items) {
      var productCategory = this.productCategory;

      productCategory.items = items;

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onDeleteProductFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteProductFromCategory__REACT_HOT_LOADER__(product) {
      var _this19 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.category.detail.confirm_delete_product'), function (result) {
        if (result) {
          var productCategory = _this19.productCategory;

          productCategory.removeItemWithId(product.id);

          _this19.setState({
            productCategory: productCategory
          });
        }
      });
    }
  }, {
    key: '__onDeleteMenuFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteMenuFromCategory__REACT_HOT_LOADER__(menu) {
      var _this20 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.category.detail.confirm_delete_menu'), function (result) {
        if (result) {
          var productCategory = _this20.productCategory;

          productCategory.removeItemWithId(menu.id);

          _this20.setState({
            productCategory: productCategory
          });
        }
      });
    }
  }, {
    key: '__onDeleteChildCategoryFromCategory__REACT_HOT_LOADER__',


    // -- events navigation
    value: function __onDeleteChildCategoryFromCategory__REACT_HOT_LOADER__(category) {
      var _this21 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.category.detail.confirm_delete_child_category'), function (result) {
        if (result) {
          var productCategory = _this21.productCategory;

          productCategory.removeItemWithId(category.id);

          _this21.setState({
            productCategory: productCategory
          });
        }
      });
    }
  }, {
    key: '__onDisplayProductDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductDetail__REACT_HOT_LOADER__(product) {
      _actions.RouteAction.presentProductEdit(product);
    }
  }, {
    key: '__onDisplayMenuDetail__REACT_HOT_LOADER__',


    //
    // Edit modal events
    //

    value: function __onDisplayMenuDetail__REACT_HOT_LOADER__(menu) {
      _actions.RouteAction.presentMenuDetail(menu);
    }
  }, {
    key: '__onEditClicked__REACT_HOT_LOADER__',
    value: function __onEditClicked__REACT_HOT_LOADER__() {
      this.setState({
        displayEditModal: true
      });
    }
  }, {
    key: '__onDeleteClicked__REACT_HOT_LOADER__',
    value: function __onDeleteClicked__REACT_HOT_LOADER__() {
      var _this22 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.category.confirm_deletion'), function (result) {
        if (result) {
          var restaurantMenu = _this22.props.restaurantMenu;

          restaurantMenu.removeCategory(_this22.state.productCategory);

          _this22.setState({
            loading: true
          }, function () {
            _actions.RouteAction.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU);
            _actions.RestaurantMenuAction.saveRestaurantMenu(restaurantMenu);
          });
        }
      });
    }
  }, {
    key: '__onHideEditModal__REACT_HOT_LOADER__',


    // -- getters

    value: function __onHideEditModal__REACT_HOT_LOADER__() {
      this.setState({
        displayEditModal: false
      });
    }
  }, {
    key: '__onFormSubmit__REACT_HOT_LOADER__',
    value: function __onFormSubmit__REACT_HOT_LOADER__() {
      this.props.onUpdate(this.productCategory, this.state.image);
    }
  }, {
    key: '__onFormReset__REACT_HOT_LOADER__',


    // -- events add item modal

    value: function __onFormReset__REACT_HOT_LOADER__() {
      this.setState({
        productCategory: this.props.productCategory.copy(),
        image: null
      });
    }
  }, {
    key: '__onDisplayAddItemModal__REACT_HOT_LOADER__',
    value: function __onDisplayAddItemModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddItemModal: true
      });
    }
  }, {
    key: '__onHideAddItemModal__REACT_HOT_LOADER__',


    // -- image

    value: function __onHideAddItemModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddItemModal: false
      });
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__(pictureData) {
      this.setState({
        image: pictureData
      });
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      this.props.onImageRemove(this.productCategory);
    }
  }, {
    key: '__onProductCategoryChange__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onProductCategoryChange__REACT_HOT_LOADER__(productCategory) {
      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      return _react2.default.createElement(_ImageDropzone2.default, {
        editOnly: false,
        readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
        className: 'product_category_view__image',
        placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY,
        image: this.productCategory.image,
        currentImage: this.state.image,
        onChange: this.onImageChange,
        onRemove: this.onImageRemove,
        aspectRatio: _ApiConstants2.default.Image.RestaurantMenu.Category.RATIO,
        width: _ApiConstants2.default.Image.RestaurantMenu.Category.WIDTH,
        height: _ApiConstants2.default.Image.RestaurantMenu.Category.HEIGHT,
        maxSize: _ApiConstants2.default.Image.RestaurantMenu.Category.MAX_SIZE
      });
    }
  }, {
    key: 'renderTheadContentItemList',
    value: function renderTheadContentItemList() {
      return _react2.default.createElement(
        'div',
        { className: 'thead col-xs-12' },
        _react2.default.createElement('div', { className: 'col-md-2 hidden-sm' }),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _I18n2.default.tr('menu.category.detail.table.header.name')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-2 text-left' },
          _I18n2.default.tr('menu.category.detail.table.header.modes_and_price')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1 text-center' },
          _I18n2.default.tr('menu.category.detail.table.header.delete_from_category')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1 text-center' },
          _I18n2.default.tr('menu.category.detail.table.header.move')
        )
      );
    }
  }, {
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__(item) {
      if (item.isProduct()) {
        var product = this.props.restaurantMenu.getProductWithId(item.id);
        if (_lodash2.default.isNull(product)) {
          return null;
        }
        return _react2.default.createElement(_CategoryDetailProductRow2.default, {
          product: product,
          key: product.id,
          onDeleteFromCategory: this.onDeleteProductFromCategory,
          currencyCode: this.currencyCode
        });
      } else if (item.isMenu()) {
        var menu = this.props.restaurantMenu.getMenuWithId(item.id);
        if (_lodash2.default.isNull(menu)) {
          return null;
        }
        return _react2.default.createElement(_CategoryDetailMenuRow2.default, {
          menu: menu,
          key: menu.id,
          onDeleteFromCategory: this.onDeleteMenuFromCategory,
          currencyCode: this.currencyCode
        });
      } else if (item.isCategory()) {
        var category = this.props.restaurantMenu.getCategoryWithId(item.id);
        if (_lodash2.default.isNull(category)) {
          return null;
        }
        return _react2.default.createElement(_CategoryDetailChildCategoryRow2.default, {
          category: category,
          key: category.id,
          onDeleteFromCategory: this.onDeleteChildCategoryFromCategory
        });
      }

      return null;
    }
  }, {
    key: 'renderItemsList',
    value: function renderItemsList() {
      return _react2.default.createElement(_SortableList2.default, {
        items: this.productCategory.items,
        onChange: this.onOrderChange,
        renderer: this.renderRow,
        displayDragIcon: false
      });
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      if (_lodash2.default.isEmpty(this.productCategory.description)) {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.category.detail.no_description')
          )
        );
      }

      return _react2.default.createElement(
        'p',
        null,
        this.productCategory.description
      );
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_FixedSubmitArea2.default, {
        onSubmit: this.onFormSubmit,
        onReset: this.onFormReset,
        haveModifications: this.haveModifications
      });
    }
  }, {
    key: 'renderAddItemToCategoryModal',
    value: function renderAddItemToCategoryModal() {
      return _react2.default.createElement(_AddItemToCategoryModal2.default, {
        show: this.state.displayAddItemModal,
        onHide: this.onHideAddItemModal,
        restaurantMenu: this.props.restaurantMenu,
        productCategory: this.state.productCategory
      });
    }
  }, {
    key: 'renderEditModal',
    value: function renderEditModal() {
      if (this.state.displayEditModal) {
        return _react2.default.createElement(_restaurantMenu.EditProductCategoryModal, {
          productCategory: this.productCategory,
          onUpdate: this.onProductCategoryChange,
          show: this.state.displayEditModal,
          onHide: this.onHideEditModal
        });
      }

      return null;
    }
  }, {
    key: 'renderEditButton',
    value: function renderEditButton() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      return _react2.default.createElement(
        'button',
        {
          className: 'btn btn-primary',
          onClick: this.onEditClicked
        },
        _react2.default.createElement('i', { className: 'fa fa-edit' }),
        '\xA0\xA0',
        _I18n2.default.tr('menu.category.detail.edit')
      );
    }
  }, {
    key: 'renderDeleteButton',
    value: function renderDeleteButton() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      return _react2.default.createElement(
        'button',
        {
          className: 'btn btn-danger',
          onClick: this.onDeleteClicked
        },
        _react2.default.createElement('i', { className: 'fa fa-trash' }),
        '\xA0\xA0',
        _I18n2.default.tr('menu.category.detail.delete')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-4' },
            _react2.default.createElement(
              'h3',
              null,
              this.productCategory.name
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hidden-xs col-md-6' },
            this.renderImage()
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-2' },
            this.renderEditButton(),
            this.renderDeleteButton()
          )
        ),
        _react2.default.createElement('hr', null),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_components.RoundButton, {
            text: _I18n2.default.tr('menu.category.detail.add_to_category'),
            onClick: this.onDisplayAddItemModal
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30 table_container table_container_hover row' },
          this.renderTheadContentItemList(),
          this.renderItemsList()
        ),
        this.renderSubmitArea(),
        this.renderAddItemToCategoryModal(),
        this.renderLoading(),
        this.renderEditModal()
      );
    }
  }, {
    key: 'productCategory',
    get: function get() {
      return this.state.productCategory;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.props.productCategory.equals(this.state.productCategory) || !_lodash2.default.isNull(this.state.image);
    }
  }]);

  return ProductCategoryDetailView;
}(_AbstractRestaurantMenuForm2.default);

ProductCategoryDetailView.propTypes = {
  productCategory: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired,

  onUpdate: _propTypes2.default.func.isRequired,

  onImageRemove: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};
exports.default = ProductCategoryDetailView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductCategoryDetailView, 'ProductCategoryDetailView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/ProductCategoryDetailView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/addItemToCategory/AddItemToCategoryModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _AddItemToCategoryView = __webpack_require__("./scripts/pages/menu/category/addItemToCategory/AddItemToCategoryView.js");

var _AddItemToCategoryView2 = _interopRequireDefault(_AddItemToCategoryView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- constants


// -- stores


// -- views


var AddItemToCategoryModal = function (_Component) {
  _inherits(AddItemToCategoryModal, _Component);

  function AddItemToCategoryModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddItemToCategoryModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddItemToCategoryModal.__proto__ || Object.getPrototypeOf(AddItemToCategoryModal)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHide = function () {
      var _this3;

      return (_this3 = _this).__onHide__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClose = function () {
      var _this4;

      return (_this4 = _this).__onClose__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddItemToCategoryModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show
      // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu) || this.props.productCategory.equals(nextProps.productCategory);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('menu.category.add_item.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(_AddItemToCategoryView2.default, {
            productCategory: this.props.productCategory,
            restaurantMenu: this.props.restaurantMenu
          })
        )
      );
    }
  }]);

  return AddItemToCategoryModal;
}(_react.Component);

AddItemToCategoryModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  productCategory: _propTypes2.default.objectOf(_ProductCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
exports.default = AddItemToCategoryModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddItemToCategoryModal, 'AddItemToCategoryModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/AddItemToCategoryModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/addItemToCategory/AddItemToCategoryView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _ProductItem = __webpack_require__("./scripts/pages/menu/category/addItemToCategory/components/ProductItem.js");

var _ProductItem2 = _interopRequireDefault(_ProductItem);

var _MenuItem = __webpack_require__("./scripts/pages/menu/category/addItemToCategory/components/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _CategoryItemRow = __webpack_require__("./scripts/pages/menu/category/addItemToCategory/components/CategoryItemRow.js");

var _CategoryItemRow2 = _interopRequireDefault(_CategoryItemRow);

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _SubmitArea = __webpack_require__("./sdk/scripts/components/form/SubmitArea.js");

var _SubmitArea2 = _interopRequireDefault(_SubmitArea);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- stores


// -- utils


// -- entities


// -- views


var AddItemToCategoryView = function (_AbstractComponent) {
  _inherits(AddItemToCategoryView, _AbstractComponent);

  function AddItemToCategoryView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddItemToCategoryView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddItemToCategoryView.__proto__ || Object.getPrototypeOf(AddItemToCategoryView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchQuery: '',

      productCategory: _this.props.productCategory.copy(),

      productAddSearchQuery: '',

      productRemoveSearchQuery: '',

      menuAddSearchQuery: '',

      menuRemoveSearchQuery: '',

      categoryAddSearchQuery: '',

      categoryRemoveSearchQuery: ''
    }, _this.onError = function () {
      var _this2;

      return (_this2 = _this).__onError__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselectProduct = function () {
      var _this3;

      return (_this3 = _this).__onDeselectProduct__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSelectProduct = function () {
      var _this4;

      return (_this4 = _this).__onSelectProduct__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDeselectMenu = function () {
      var _this5;

      return (_this5 = _this).__onDeselectMenu__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onSelectMenu = function () {
      var _this6;

      return (_this6 = _this).__onSelectMenu__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDeselectProductCategory = function () {
      var _this7;

      return (_this7 = _this).__onDeselectProductCategory__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onSelectProductCategory = function () {
      var _this8;

      return (_this8 = _this).__onSelectProductCategory__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onProductAddSearchQueryChange = function () {
      var _this9;

      return (_this9 = _this).__onProductAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onProductRemoveSearchQueryChange = function () {
      var _this10;

      return (_this10 = _this).__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onMenuAddSearchQueryChange = function () {
      var _this11;

      return (_this11 = _this).__onMenuAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onMenuRemoveSearchQueryChange = function () {
      var _this12;

      return (_this12 = _this).__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onCategoryAddSearchQueryChange = function () {
      var _this13;

      return (_this13 = _this).__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onCategoryRemoveSearchQueryChange = function () {
      var _this14;

      return (_this14 = _this).__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onSubmit = function () {
      var _this15;

      return (_this15 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onReset = function () {
      var _this16;

      return (_this16 = _this).__onReset__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddItemToCategoryView, [{
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onCategoryAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onMenuAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onProductAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectProductCategory__REACT_HOT_LOADER__',
    value: function __onSelectProductCategory__REACT_HOT_LOADER__() {
      return this.__onSelectProductCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectProductCategory__REACT_HOT_LOADER__',
    value: function __onDeselectProductCategory__REACT_HOT_LOADER__() {
      return this.__onDeselectProductCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectMenu__REACT_HOT_LOADER__',
    value: function __onSelectMenu__REACT_HOT_LOADER__() {
      return this.__onSelectMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectMenu__REACT_HOT_LOADER__',
    value: function __onDeselectMenu__REACT_HOT_LOADER__() {
      return this.__onDeselectMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectProduct__REACT_HOT_LOADER__',
    value: function __onSelectProduct__REACT_HOT_LOADER__() {
      return this.__onSelectProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectProduct__REACT_HOT_LOADER__',
    value: function __onDeselectProduct__REACT_HOT_LOADER__() {
      return this.__onDeselectProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

      _RestaurantMenuStore2.default.addListener(_Events2.default.END_LOADING, this.hideLoading);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

      _RestaurantMenuStore2.default.removeListener(_Events2.default.END_LOADING, this.hideLoading);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',


    // --
    value: function __onError__REACT_HOT_LOADER__() {
      // TODO: onError
    }
  }, {
    key: '__onDeselectProduct__REACT_HOT_LOADER__',
    value: function __onDeselectProduct__REACT_HOT_LOADER__(product) {
      var productCategory = this.productCategory;

      productCategory.removeItemWithId(product.id);

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onSelectProduct__REACT_HOT_LOADER__',
    value: function __onSelectProduct__REACT_HOT_LOADER__(product) {
      var productCategory = this.productCategory;

      var item = new _CategoryItem2.default();
      item.type = _CategoryItem2.default.Type.PRODUCT;
      item.id = product.id;

      productCategory.items.push(item);

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onDeselectMenu__REACT_HOT_LOADER__',
    value: function __onDeselectMenu__REACT_HOT_LOADER__(menu) {
      var productCategory = this.productCategory;

      productCategory.removeItemWithId(menu.id);

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onSelectMenu__REACT_HOT_LOADER__',
    value: function __onSelectMenu__REACT_HOT_LOADER__(menu) {
      var productCategory = this.productCategory;

      var item = new _CategoryItem2.default();
      item.type = _CategoryItem2.default.Type.MENU;
      item.id = menu.id;

      productCategory.items.push(item);

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onDeselectProductCategory__REACT_HOT_LOADER__',
    value: function __onDeselectProductCategory__REACT_HOT_LOADER__(category) {
      var productCategory = this.productCategory;

      productCategory.removeItemWithId(category.id);

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onSelectProductCategory__REACT_HOT_LOADER__',


    // -- search
    value: function __onSelectProductCategory__REACT_HOT_LOADER__(category) {
      var productCategory = this.productCategory;

      var item = new _CategoryItem2.default();
      item.type = _CategoryItem2.default.Type.CATEGORY;
      item.id = category.id;

      productCategory.items.push(item);

      this.setState({
        productCategory: productCategory
      });
    }
  }, {
    key: '__onProductAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductAddSearchQueryChange__REACT_HOT_LOADER__(productAddSearchQuery) {
      this.setState({
        productAddSearchQuery: productAddSearchQuery
      });
    }
  }, {
    key: '__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductRemoveSearchQueryChange__REACT_HOT_LOADER__(productRemoveSearchQuery) {
      this.setState({
        productRemoveSearchQuery: productRemoveSearchQuery
      });
    }
  }, {
    key: '__onMenuAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuAddSearchQueryChange__REACT_HOT_LOADER__(menuAddSearchQuery) {
      this.setState({
        menuAddSearchQuery: menuAddSearchQuery
      });
    }
  }, {
    key: '__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__(menuRemoveSearchQuery) {
      this.setState({
        menuRemoveSearchQuery: menuRemoveSearchQuery
      });
    }
  }, {
    key: '__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onCategoryAddSearchQueryChange__REACT_HOT_LOADER__(categoryAddSearchQuery) {
      this.setState({
        categoryAddSearchQuery: categoryAddSearchQuery
      });
    }
  }, {
    key: '__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__',


    // -- form
    value: function __onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__(categoryRemoveSearchQuery) {
      this.setState({
        categoryRemoveSearchQuery: categoryRemoveSearchQuery
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var restaurantMenu = this.props.restaurantMenu;
      restaurantMenu.updateCategory(this.state.productCategory);

      this.showLoading();
      _RestaurantMenuAction2.default.saveRestaurantMenu(restaurantMenu);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        productCategory: this.props.productCategory.copy()
      });
    }
  }, {
    key: 'renderMenusSelect',
    value: function renderMenusSelect() {
      return null;

      //    _.each(this.restaurantMenu.menus, (menu:Menu) => {
      //      const isSelected = true;
      //      items.push(
      //        <MenuItem
      //          menu={menu}
      //          isSelected={isSelected}
      //          onSelect={this.onSelectMenu}
      //          onDeselect={this.onDeselectMenu}
      //        />
      //      );
      //    });
    }
  }, {
    key: 'renderSearchNoResults',
    value: function renderSearchNoResults() {
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'em',
          null,
          _I18n2.default.tr('menu.category.add_item.search_no_results')
        )
      );
    }
  }, {
    key: 'renderProductsSelected',
    value: function renderProductsSelected(products) {
      var _this17 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(products) && !_lodash2.default.isEmpty(this.state.productRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(products) && _lodash2.default.isEmpty(this.state.productRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.category.add_item.no_item_selected')
          )
        );
      } else {
        var sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (product) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
        });
        listView = sortedProductsList.map(function (product) {
          return _react2.default.createElement(_ProductItem2.default, {
            key: product.id,
            product: product,
            isSelected: true,
            onDeselect: _this17.onDeselectProduct
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__products__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.productRemoveSearchQuery,
          onSearchInput: this.onProductRemoveSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProductsUnselected',
    value: function renderProductsUnselected(products) {
      var _this18 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(products)) {
        listView = this.renderSearchNoResults();
      } else {
        var sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (booking) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(booking.name).toLowerCase();
        });
        listView = sortedProductsList.map(function (product) {
          return _react2.default.createElement(_ProductItem2.default, {
            key: product.id,
            product: product,
            isSelected: false,
            onSelect: _this18.onSelectProduct
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__products__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.category.add_item.products_on_menu')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.productAddSearchQuery,
          onSearchInput: this.onProductAddSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this19 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.restaurantMenu.products, function (product) {
        var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this19.productCategory.items, function (item) {
          return item.isProduct() && item.id === product.id;
        }));

        if (isSelected) {
          var query = _this19.state.productRemoveSearchQuery;
          if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, product.name)) {
            selected.push(product);
          }
        } else {
          var _query = _this19.state.productAddSearchQuery;
          if (_lodash2.default.isEmpty(_query) || _utils.StringUtils.searchStringOn(_query, product.name)) {
            unselected.push(product);
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__products' },
        this.renderProductsUnselected(unselected),
        this.renderProductsSelected(selected)
      );
    }
  }, {
    key: 'renderMenusSelected',
    value: function renderMenusSelected(menus) {
      var _this20 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(menus) && !_lodash2.default.isEmpty(this.state.menuRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(menus) && _lodash2.default.isEmpty(this.state.menuRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.category.add_item.no_menu_selected')
          )
        );
      } else {
        listView = menus.map(function (menu) {
          return _react2.default.createElement(_MenuItem2.default, {
            key: menu.id,
            menu: menu,
            isSelected: true,
            onDeselect: _this20.onDeselectMenu
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__menus__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.menuRemoveSearchQuery,
          onSearchInput: this.onMenuRemoveSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderMenusUnselected',
    value: function renderMenusUnselected(menus) {
      var _this21 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(menus)) {
        listView = this.renderSearchNoResults();
      } else {
        listView = menus.map(function (menu) {
          return _react2.default.createElement(_MenuItem2.default, {
            key: menu.id,
            menu: menu,
            isSelected: false,
            onSelect: _this21.onSelectMenu
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__menus__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.category.add_item.menus_on_menu')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.menuAddSearchQuery,
          onSearchInput: this.onMenuAddSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderMenus',
    value: function renderMenus() {
      var _this22 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.restaurantMenu.menus, function (menu) {
        var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this22.productCategory.items, function (item) {
          return item.isMenu() && item.id === menu.id;
        }));

        if (isSelected) {
          var query = _this22.state.menuRemoveSearchQuery;
          if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, menu.name)) {
            selected.push(menu);
          }
        } else {
          var _query2 = _this22.state.menuAddSearchQuery;
          if (_lodash2.default.isEmpty(_query2) || _utils.StringUtils.searchStringOn(_query2, menu.name)) {
            unselected.push(menu);
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__menus' },
        this.renderMenusUnselected(unselected),
        this.renderMenusSelected(selected)
      );
    }

    //
    //
    //

  }, {
    key: 'renderProductCategoriesSelected',
    value: function renderProductCategoriesSelected(categories) {
      var _this23 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(categories) && !_lodash2.default.isEmpty(this.state.categoryRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(categories) && _lodash2.default.isEmpty(this.state.categoryRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.category.add_item.no_item_selected')
          )
        );
      } else {
        var sortedProductCategoriesList = _lodash2.default.sortBy(categories, ['desc'], function (category) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(category.name).toLowerCase();
        });
        listView = sortedProductCategoriesList.map(function (category, index) {
          return _react2.default.createElement(_CategoryItemRow2.default, {
            key: index + '_' + category.id,
            category: category,
            isSelected: true,
            onDeselect: _this23.onDeselectProductCategory
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__categories__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.categoryRemoveSearchQuery,
          onSearchInput: this.onCategoryRemoveSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProductCategoriesUnselected',
    value: function renderProductCategoriesUnselected(categories) {
      var _this24 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(categories)) {
        listView = this.renderSearchNoResults();
      } else {
        var sortedProductCategoriesList = _lodash2.default.sortBy(categories, ['desc'], function (item) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(item.name).toLowerCase();
        });
        listView = sortedProductCategoriesList.map(function (category, index) {
          return _react2.default.createElement(_CategoryItemRow2.default, {
            key: index + '_' + category.id,
            category: category,
            isSelected: false,
            onSelect: _this24.onSelectProductCategory
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__categories__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.category.add_item.categories')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.categoryAddSearchQuery,
          onSearchInput: this.onCategoryAddSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProductCategories',
    value: function renderProductCategories() {
      var _this25 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.categories, function (category) {
        var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this25.productCategory.items, function (item) {
          return item.isCategory() && item.id === category.id;
        }));

        if (isSelected) {
          var query = _this25.state.categoryRemoveSearchQuery;
          if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, category.name)) {
            selected.push(category);
          }
        } else {
          var _query3 = _this25.state.categoryAddSearchQuery;
          if (_lodash2.default.isEmpty(_query3) || _utils.StringUtils.searchStringOn(_query3, category.name)) {
            unselected.push(category);
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__categories' },
        this.renderProductCategoriesUnselected(unselected),
        this.renderProductCategoriesSelected(selected)
      );
    }

    //
    //
    //

  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_SubmitArea2.default, {
        haveModifications: this.haveModifications,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isProductCategoryRoot = this.productCategory.id !== this.restaurantMenu.getRootCategory().id;

      return _react2.default.createElement(
        'div',
        { className: 'add_to_category_view' },
        this.renderMenusSelect(),
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultActiveKey: isProductCategoryRoot ? 1 : 3,
            id: 'edit_restaurant_page__tabs',
            onSelect: this.onTabChange
          },
          isProductCategoryRoot && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 1,
              title: _I18n2.default.tr('menu.category.products')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderProducts()
            )
          ),
          isProductCategoryRoot && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 2,
              title: _I18n2.default.tr('menu.category.menus')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderMenus()
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 3,
              title: _I18n2.default.tr('menu.category.add_item.child_categories')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderProductCategories()
            )
          )
        ),
        this.renderSubmitArea(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }, {
    key: 'productCategory',
    get: function get() {
      return this.state.productCategory;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.state.productCategory.equals(this.props.productCategory);
    }

    /**
     * We remove from the choices the parents categories
     */

  }, {
    key: 'categories',
    get: function get() {
      var _this26 = this;

      var categories = [];

      _lodash2.default.each(this.props.restaurantMenu.categories, function (category) {
        if (category.id !== _this26.props.restaurantMenu.rootCategoryId && category.id !== _this26.props.productCategory.id) {
          categories.push(category);
        }
      });

      return categories;
    }

    // --

  }]);

  return AddItemToCategoryView;
}(_AbstractComponent3.default);

AddItemToCategoryView.propTypes = {
  productCategory: _propTypes2.default.objectOf(_ProductCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
var _default = AddItemToCategoryView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddItemToCategoryView, 'AddItemToCategoryView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/AddItemToCategoryView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/AddItemToCategoryView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/addItemToCategory/components/CategoryItemRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var CategoryItemRow = function (_Component) {
  _inherits(CategoryItemRow, _Component);

  function CategoryItemRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryItemRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryItemRow.__proto__ || Object.getPrototypeOf(CategoryItemRow)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      onSelect: function onSelect() {},
      onDeselect: function onDeselect() {}
    }, _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselect = function () {
      var _this3;

      return (_this3 = _this).__onDeselect__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClick = function () {
      var _this4;

      return (_this4 = _this).__onClick__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryItemRow, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      return this.__onDeselect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.isSelected !== this.props.isSelected && nextProps.category.id !== this.props.category.id;
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      this.props.onSelect(this.category);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      this.props.onDeselect(this.category);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      if (this.isSelected) {
        this.onDeselect();
      } else {
        this.onSelect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'category_item pointer',
          onClick: this.onClick
        },
        this.category.name
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return CategoryItemRow;
}(_react.Component);

CategoryItemRow.propTypes = {
  category: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = CategoryItemRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryItemRow, 'CategoryItemRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/components/CategoryItemRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/components/CategoryItemRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/addItemToCategory/components/MenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      onSelect: function onSelect() {},
      onDeselect: function onDeselect() {}
    }, _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselect = function () {
      var _this3;

      return (_this3 = _this).__onDeselect__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClick = function () {
      var _this4;

      return (_this4 = _this).__onClick__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      return this.__onDeselect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.isSelected !== this.props.isSelected && nextProps.menu.id !== this.props.menu.id;
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      this.props.onSelect(this.menu);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      this.props.onDeselect(this.menu);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      if (this.isSelected) {
        this.onDeselect();
      } else {
        this.onSelect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'menu_item pointer',
          onClick: this.onClick
        },
        this.menu.name
      );
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = MenuItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuItem, 'MenuItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/components/MenuItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/components/MenuItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/addItemToCategory/components/ProductItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var ProductItem = function (_Component) {
  _inherits(ProductItem, _Component);

  function ProductItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductItem.__proto__ || Object.getPrototypeOf(ProductItem)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      onSelect: function onSelect() {},
      onDeselect: function onDeselect() {}
    }, _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselect = function () {
      var _this3;

      return (_this3 = _this).__onDeselect__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClick = function () {
      var _this4;

      return (_this4 = _this).__onClick__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      return this.__onDeselect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.isSelected !== this.props.isSelected && nextProps.product.id !== this.props.product.id;
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      this.props.onSelect(this.product);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      this.props.onDeselect(this.product);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      if (this.isSelected) {
        this.onDeselect();
      } else {
        this.onSelect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'product_item pointer',
          onClick: this.onClick
        },
        this.product.name
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return ProductItem;
}(_react.Component);

ProductItem.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = ProductItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductItem, 'ProductItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/components/ProductItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/addItemToCategory/components/ProductItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/components/CategoryDetailChildCategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _RowPricesView = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView2 = _interopRequireDefault(_RowPricesView);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var CategoryDetailChildCategoryRow = function (_Component) {
  _inherits(CategoryDetailChildCategoryRow, _Component);

  function CategoryDetailChildCategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryDetailChildCategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryDetailChildCategoryRow.__proto__ || Object.getPrototypeOf(CategoryDetailChildCategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryDetailChildCategoryRow, [{
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.category);
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteFromCategory(this.props.category);
    }
  }, {
    key: 'renderAvailabilities',
    value: function renderAvailabilities() {
      // no availitbilities for a category.
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view__row child_category_row pointer row' },
        _react2.default.createElement(
          'div',
          { className: 'hidden-sm col-md-2 text-left' },
          _react2.default.createElement(_ImageLoader2.default, {
            src: this.category.image,
            className: 'product_category_view__row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'category__name col-xs-6 product_category_view__row__name',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            this.category.name
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-2 text-right',
            onClick: this.onDisplayDetail
          },
          this.renderAvailabilities()
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__remove',
            onClick: this.onDeleteFromCategory
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__drag'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }]);

  return CategoryDetailChildCategoryRow;
}(_react.Component);

CategoryDetailChildCategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired,

  // parameters: Menu
  onDeleteFromCategory: _propTypes2.default.func.isRequired
};
var _default = CategoryDetailChildCategoryRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryDetailChildCategoryRow, 'CategoryDetailChildCategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/components/CategoryDetailChildCategoryRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/components/CategoryDetailChildCategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/components/CategoryDetailMenuRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _RowPricesView = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView2 = _interopRequireDefault(_RowPricesView);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var CategoryDetailMenuRow = function (_Component) {
  _inherits(CategoryDetailMenuRow, _Component);

  function CategoryDetailMenuRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryDetailMenuRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryDetailMenuRow.__proto__ || Object.getPrototypeOf(CategoryDetailMenuRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryDetailMenuRow, [{
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.menu.equals(this.props.menu);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenuDetail(this.menu);
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteFromCategory(this.props.menu);
    }
  }, {
    key: 'renderAvailabilities',
    value: function renderAvailabilities() {
      return _react2.default.createElement(_RowPricesView2.default, {
        prices: this.menu.prices,
        currencyCode: this.currencyCode
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view__row pointer row' },
        _react2.default.createElement(
          'div',
          { className: 'hidden-sm col-md-2 text-left' },
          _react2.default.createElement(_ImageLoader2.default, {
            src: this.menu.image,
            className: 'product_category_view__row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_MENU
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'menu__name col-xs-6 product_category_view__row__name',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            this.menu.name
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-2 text-right',
            onClick: this.onDisplayDetail
          },
          this.renderAvailabilities()
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__remove',
            onClick: this.onDeleteFromCategory
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__drag'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return CategoryDetailMenuRow;
}(_react.Component);

CategoryDetailMenuRow.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired,

  // parameters: Menu
  onDeleteFromCategory: _propTypes2.default.func.isRequired,
  currencyCode: _propTypes2.default.string

};
var _default = CategoryDetailMenuRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryDetailMenuRow, 'CategoryDetailMenuRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/components/CategoryDetailMenuRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/components/CategoryDetailMenuRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/category/components/CategoryDetailProductRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _RowPricesView = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView2 = _interopRequireDefault(_RowPricesView);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var CategoryModalProductRow = function (_Component) {
  _inherits(CategoryModalProductRow, _Component);

  function CategoryModalProductRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryModalProductRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryModalProductRow.__proto__ || Object.getPrototypeOf(CategoryModalProductRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryModalProductRow, [{
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.product.equals(this.props.product);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductEdit(this.product);
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteFromCategory(this.product);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view__row pointer row' },
        _react2.default.createElement(
          'div',
          { className: 'hidden-sm col-md-2 text-left' },
          _react2.default.createElement(_ImageLoader2.default, {
            src: this.product.image,
            className: 'product_category_view__row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-6 product_category_view__row__name',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            this.product.name
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-2 text-right',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(_RowPricesView2.default, {
            prices: this.product.prices,
            currencyCode: this.currencyCode
          })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__remove',
            onClick: this.onDeleteFromCategory
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__drag'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return CategoryModalProductRow;
}(_react.Component);

CategoryModalProductRow.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  // parameters: Product
  onDeleteFromCategory: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};
var _default = CategoryModalProductRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryModalProductRow, 'CategoryModalProductRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/components/CategoryDetailProductRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/category/components/CategoryDetailProductRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// -- constants


// -- actions


// -- stores


// -- entities


// -- views


var AbstractRestaurantMenuComponent = function (_AbstractFormComponen) {
  _inherits(AbstractRestaurantMenuComponent, _AbstractFormComponen);

  function AbstractRestaurantMenuComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractRestaurantMenuComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractRestaurantMenuComponent.__proto__ || Object.getPrototypeOf(AbstractRestaurantMenuComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(), _this.onSubmit = function () {
      var _this2;

      return (_this2 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDisplayCategoryDetail = function () {
      var _this3;

      return (_this3 = _this).__onDisplayCategoryDetail__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDisplayProductDetail = function () {
      var _this4;

      return (_this4 = _this).__onDisplayProductDetail__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDisplayMenuDetail = function () {
      var _this5;

      return (_this5 = _this).__onDisplayMenuDetail__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDisplayProductOptionDetail = function () {
      var _this6;

      return (_this6 = _this).__onDisplayProductOptionDetail__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AbstractRestaurantMenuComponent, [{
    key: '__onDisplayProductOptionDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductOptionDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayProductOptionDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayMenuDetail__REACT_HOT_LOADER__',
    value: function __onDisplayMenuDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayMenuDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayProductDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayProductDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayCategoryDetail__REACT_HOT_LOADER__',
    value: function __onDisplayCategoryDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayCategoryDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return true;
      // return shallowCompare(this, nextProps, nextState);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      return {
        restaurantMenu: this.props.restaurantMenu.copy()
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.props.restaurantMenu.equals(this.restaurantMenu);
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return false;
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      this.showLoading();
      _actions.RestaurantMenuAction.saveRestaurantMenu(this.state.restaurantMenu);
    }
  }, {
    key: '__onDisplayCategoryDetail__REACT_HOT_LOADER__',


    // -- product modal

    value: function __onDisplayCategoryDetail__REACT_HOT_LOADER__(categoryToDisplay) {
      _actions.RouteAction.presentCategoryDetail(categoryToDisplay);
    }
  }, {
    key: '__onDisplayProductDetail__REACT_HOT_LOADER__',


    // -- menu modal

    value: function __onDisplayProductDetail__REACT_HOT_LOADER__(productToDisplay) {
      _actions.RouteAction.presentProductEdit(productToDisplay);
    }
  }, {
    key: '__onDisplayMenuDetail__REACT_HOT_LOADER__',


    // -- product option modal

    value: function __onDisplayMenuDetail__REACT_HOT_LOADER__(menuToDisplay) {
      _actions.RouteAction.presentMenuDetail(menuToDisplay);
    }
  }, {
    key: '__onDisplayProductOptionDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductOptionDetail__REACT_HOT_LOADER__(productOptionToDisplay) {
      _actions.RouteAction.presentProductOptionDetail(productOptionToDisplay);
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }

    // -- category modal

  }]);

  return AbstractRestaurantMenuComponent;
}(_AbstractFormComponent2.default);

AbstractRestaurantMenuComponent.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired
};
exports.default = AbstractRestaurantMenuComponent;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AbstractRestaurantMenuComponent, 'AbstractRestaurantMenuComponent', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/AbstractRestaurantMenuComponent.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/AbstractRestaurantMenuForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


/**
 * You have to implements the following methods:
 * - shouldUpdateState(): boolean returns true if the object on props have changed.
 */
var AbstractRestaurantMenuForm = function (_AbstractFormComponen) {
  _inherits(AbstractRestaurantMenuForm, _AbstractFormComponen);

  function AbstractRestaurantMenuForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractRestaurantMenuForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractRestaurantMenuForm.__proto__ || Object.getPrototypeOf(AbstractRestaurantMenuForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AbstractRestaurantMenuForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // We don't use restaurautMenu because we don't copy it, so the both restaurantMenu on
      // nextProps and props aren't equals.
      if (this.shouldUpdateState(nextProps)) {
        // restaurant menu have changed, we reset the form.
        this.setState(this.getDefaultState(nextProps));
      }
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState() {
      return false;
    }

    /**
     * Should be override.
     * See componentWillReceiveProps
     */

  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return false;
    }
  }]);

  return AbstractRestaurantMenuForm;
}(_AbstractFormComponent2.default);

exports.default = AbstractRestaurantMenuForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AbstractRestaurantMenuForm, 'AbstractRestaurantMenuForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/AbstractRestaurantMenuForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/SynchronizeMenuView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SynchronizeMenuView = function (_Component) {
  _inherits(SynchronizeMenuView, _Component);

  function SynchronizeMenuView(props) {
    _classCallCheck(this, SynchronizeMenuView);

    var _this = _possibleConstructorReturn(this, (SynchronizeMenuView.__proto__ || Object.getPrototypeOf(SynchronizeMenuView)).call(this, props));

    _this.onSynchronize = function () {
      return _this.__onSynchronize__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = { isLoading: false };
    return _this;
  }

  _createClass(SynchronizeMenuView, [{
    key: '__onSynchronize__REACT_HOT_LOADER__',
    value: function __onSynchronize__REACT_HOT_LOADER__() {
      return this.__onSynchronize__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSynchronize__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onSynchronize__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      this.setState({
        isLoading: true
      }, function () {
        return _RestaurantMenuAction2.default.loadRestaurantMenuWithSynchronization();
      });
    }
  }, {
    key: 'renderLastSyncDate',
    value: function renderLastSyncDate() {
      if (_lodash2.default.isNull(this.props.apiError) || _lodash2.default.isNull(this.props.restaurantMenu) || _lodash2.default.isNull(this.props.restaurantMenu.posSyncDate)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        this.props.restaurantMenu.posSyncDate.format('DD/MM - HH:mm')
      );
    }
  }, {
    key: 'renderApiError',
    value: function renderApiError() {
      if (_lodash2.default.isNull(this.props.apiError)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderLastSyncDate(),
        _react2.default.createElement(
          'div',
          { style: { maxWidth: '500px', textAlign: 'right' } },
          _react2.default.createElement('i', { className: 'fa fa-warning' }),
          _react2.default.createElement(
            'span',
            null,
            '\xA0\xA0',
            _I18n2.default.tr('menu.pos_connection_loss.tooltip')
          ),
          _react2.default.createElement(
            'div',
            { style: {
                fontStyle: "italic",
                fontSize: '0.8em',
                marginTop: '5px'
              } },
            'sessionId: ' + this.props.apiError.getSessionId()
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoading = this.props.isLoading || this.state.isLoading;

      var className = (0, _classnames2.default)('btn', {
        'btn-primary': _lodash2.default.isNull(this.props.apiError),
        'btn-danger': !_lodash2.default.isNull(this.props.apiError)
      });

      return _react2.default.createElement(
        'div',
        { className: 'synchronize_menu_view pull-right',
          style: { textAlign: 'right' } },
        _react2.default.createElement(
          'button',
          {
            className: className,
            onClick: this.onSynchronize,
            disabled: isLoading
          },
          isLoading && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' }),
            '\xA0\xA0'
          ),
          _I18n2.default.tr('menu.synchronize_with_pos')
        ),
        this.renderApiError()
      );
    }
  }]);

  return SynchronizeMenuView;
}(_react.Component);

exports.default = SynchronizeMenuView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SynchronizeMenuView, 'SynchronizeMenuView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/SynchronizeMenuView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/availabilityDates/AvailabilityDatesForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNil = __webpack_require__("./node_modules/lodash/isNil.js");

var _isNil2 = _interopRequireDefault(_isNil);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _AvailabilityDates = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDates.js");

var _AvailabilityDates2 = _interopRequireDefault(_AvailabilityDates);

var _AvailabilityDate = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDate.js");

var _AvailabilityDate2 = _interopRequireDefault(_AvailabilityDate);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _DateField = __webpack_require__("./sdk/scripts/components/form/DateField.js");

var _DateField2 = _interopRequireDefault(_DateField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AvailabilityDatesForm = function (_React$PureComponent) {
  _inherits(AvailabilityDatesForm, _React$PureComponent);

  function AvailabilityDatesForm(props) {
    _classCallCheck(this, AvailabilityDatesForm);

    var _this = _possibleConstructorReturn(this, (AvailabilityDatesForm.__proto__ || Object.getPrototypeOf(AvailabilityDatesForm)).call(this, props));

    _this.onDateChange = function () {
      return _this.__onDateChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onDateChange('fromDate', _this.fromDate);
    _this.onDateChange('toDate', _this.toDate);
    return _this;
  }

  _createClass(AvailabilityDatesForm, [{
    key: '__onDateChange__REACT_HOT_LOADER__',
    value: function __onDateChange__REACT_HOT_LOADER__() {
      return this.__onDateChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDateChange__REACT_HOT_LOADER__',
    value: function __onDateChange__REACT_HOT_LOADER__(type, date) {
      var fromDate = type === 'fromDate' ? date : this.fromDate;
      var toDate = type === 'toDate' ? date : this.toDate;

      var availabilityDates = new _AvailabilityDates2.default();

      availabilityDates.add(fromDate.startOf('day'), toDate.endOf('day'));

      this.props.onAvailibilityDatesChange(availabilityDates);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 availability_dates_form' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3' },
            _react2.default.createElement(_DateField2.default, {
              onChange: function onChange(date) {
                return _this2.onDateChange('fromDate', date);
              },
              dateFormat: _DateUtils2.default.DMY_FORMAT,
              date: this.fromDate
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3' },
            _react2.default.createElement(_DateField2.default, {
              onChange: function onChange(date) {
                return _this2.onDateChange('toDate', date);
              },
              dateFormat: _DateUtils2.default.DMY_FORMAT,
              date: this.toDate
            })
          )
        )
      );
    }
  }, {
    key: 'fromDate',
    get: function get() {
      return this.availabilityDate.fromDate || (0, _moment2.default)().startOf('day');
    }
  }, {
    key: 'toDate',
    get: function get() {
      return this.availabilityDate.toDate || (0, _moment2.default)().endOf('day');
    }
  }, {
    key: 'availabilityDate',
    get: function get() {
      var availabilityDate = new _AvailabilityDate2.default();

      if (!(0, _isNil2.default)(this.props.availabilityDates) && !(0, _isEmpty2.default)(this.props.availabilityDates.dates)) {
        availabilityDate = this.props.availabilityDates.dates[0];
      }

      return availabilityDate;
    }
  }]);

  return AvailabilityDatesForm;
}(_react2.default.PureComponent);

AvailabilityDatesForm.defaultProps = {
  availabilityDates: new _AvailabilityDates2.default(),

  readOnly: false
};
AvailabilityDatesForm.propTypes = {
  availabilityDates: _react.PropTypes.objectOf(_AvailabilityDates2.default),

  onAvailibilityDatesChange: _react.PropTypes.func.isRequired,

  readOnly: _react.PropTypes.bool
};
exports.default = AvailabilityDatesForm;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AvailabilityDatesForm, 'AvailabilityDatesForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityDates/AvailabilityDatesForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/availabilityHours/AddAvailabilityHourModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _AvailabilityHour = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour2 = _interopRequireDefault(_AvailabilityHour);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _DayChooser = __webpack_require__("./scripts/components/DayChooser.js");

var _DayChooser2 = _interopRequireDefault(_DayChooser);

var _HourChooser = __webpack_require__("./sdk/scripts/components/form/HourChooser/index.js");

var _HourChooser2 = _interopRequireDefault(_HourChooser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var AddAvailabilityHourModal = function (_AbstractComponent) {
  _inherits(AddAvailabilityHourModal, _AbstractComponent);

  function AddAvailabilityHourModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddAvailabilityHourModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddAvailabilityHourModal.__proto__ || Object.getPrototypeOf(AddAvailabilityHourModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      day: _this.props.defaultDay,

      availabilityHour: _this.props.defaultAvailabilityHour
    }, _this.onAvailabilityHourChange = function () {
      var _this2;

      return (_this2 = _this).__onAvailabilityHourChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClosingHourChange = function () {
      var _this3;

      return (_this3 = _this).__onClosingHourChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDayChange = function () {
      var _this4;

      return (_this4 = _this).__onDayChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onSubmit = function () {
      var _this5;

      return (_this5 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events

  _createClass(AddAvailabilityHourModal, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDayChange__REACT_HOT_LOADER__',
    value: function __onDayChange__REACT_HOT_LOADER__() {
      return this.__onDayChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClosingHourChange__REACT_HOT_LOADER__',
    value: function __onClosingHourChange__REACT_HOT_LOADER__() {
      return this.__onClosingHourChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAvailabilityHourChange__REACT_HOT_LOADER__',
    value: function __onAvailabilityHourChange__REACT_HOT_LOADER__() {
      return this.__onAvailabilityHourChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAvailabilityHourChange__REACT_HOT_LOADER__',
    value: function __onAvailabilityHourChange__REACT_HOT_LOADER__(opening) {
      var availabilityHour = this.state.availabilityHour;
      availabilityHour.opening = opening;

      this.setState({
        availabilityHour: availabilityHour
      });
    }
  }, {
    key: '__onClosingHourChange__REACT_HOT_LOADER__',
    value: function __onClosingHourChange__REACT_HOT_LOADER__(closing) {
      var availabilityHour = this.state.availabilityHour;
      availabilityHour.closing = closing;

      this.setState({
        availabilityHour: availabilityHour
      });
    }
  }, {
    key: '__onDayChange__REACT_HOT_LOADER__',
    value: function __onDayChange__REACT_HOT_LOADER__(value) {
      this.setState({
        day: value
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var availabilityHour = this.state.availabilityHour;

      // TODO: validation
      if (availabilityHour.closing - availabilityHour.opening <= 0) {
        // TODO: display error invalid range.
      } else {
        this.props.onAddAvailabilityHourForDay(this.state.day, availabilityHour);
        this.props.onHide();
      }
    }
  }, {
    key: 'renderDayPicker',
    value: function renderDayPicker() {
      return _react2.default.createElement(_DayChooser2.default, {
        day: this.state.day,
        onChange: this.onDayChange
      });
    }
  }, {
    key: 'renderAvailabilityHour',
    value: function renderAvailabilityHour() {
      return _react2.default.createElement(_HourChooser2.default, {
        onChange: this.onAvailabilityHourChange,
        defaultValue: this.state.availabilityHour.opening
      });
    }
  }, {
    key: 'renderClosingHour',
    value: function renderClosingHour() {
      return _react2.default.createElement(_HourChooser2.default, {
        onChange: this.onClosingHourChange,
        defaultValue: this.state.availabilityHour.closing
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          {
            className: 'form form-horizontal booking_form',
            role: 'form',
            noValidate: true,
            onSubmit: this.onSubmit
          },
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'required col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('components.opening_hours.form_modal.day')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              this.renderDayPicker()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'required col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('components.opening_hours.form_modal.opening')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              this.renderAvailabilityHour()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'required col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('components.opening_hours.form_modal.closing')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              this.renderClosingHour()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-center' },
            _react2.default.createElement(
              'button',
              {
                type: 'submit',
                className: 'btn btn-primary',
                onClick: this.onSubmit
              },
              _I18n2.default.tr('components.opening_hours.form_modal.create')
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.props.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.props.onHide
            },
            _react2.default.createElement('i', { className: 'pmt pmt-cancel' })
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.opening_hours.form_modal.title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return AddAvailabilityHourModal;
}(_AbstractComponent3.default);

AddAvailabilityHourModal.defaultProps = {
  defaultAvailabilityHour: new _AvailabilityHour2.default(),
  defaultDay: _Constants2.default.Day.MONDAY
};
AddAvailabilityHourModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,

  onHide: _propTypes2.default.func.isRequired,

  // -- params: Number (Day), availabilityHour (AvailabilityHour)
  onAddAvailabilityHourForDay: _propTypes2.default.func.isRequired,

  defaultAvailabilityHour: _propTypes2.default.objectOf(_AvailabilityHour2.default),

  defaultDay: _propTypes2.default.number
};
var _default = AddAvailabilityHourModal;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddAvailabilityHourModal, 'AddAvailabilityHourModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AddAvailabilityHourModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AddAvailabilityHourModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/availabilityHours/AvailabilityHourView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _AvailabilityHour = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour2 = _interopRequireDefault(_AvailabilityHour);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var AvailabilityHourView = function (_Component) {
  _inherits(AvailabilityHourView, _Component);

  function AvailabilityHourView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityHourView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityHourView.__proto__ || Object.getPrototypeOf(AvailabilityHourView)).call.apply(_ref, [this].concat(args))), _this), _this.onDelete = function () {
      var _this2;

      return (_this2 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- actions


  _createClass(AvailabilityHourView, [{
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onDelete__REACT_HOT_LOADER__() {
      this.props.onDelete(this.props.availabilityHour);
    }
  }, {
    key: 'render',
    value: function render() {
      /**
       * We want both value to be null because when adding a new availabilityHour
       * opening is set to null and formatted to 00:00
       */
      if (this.props.availabilityHour.opening === null && this.props.availabilityHour.closing === null) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'availability_hours_for_day__hour' },
        this.props.availabilityHour.getFormatted(),
        !this.props.readOnly && _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0\xA0',
          _react2.default.createElement(
            'a',
            {
              className: 'link',
              onClick: this.onDelete
            },
            _react2.default.createElement('i', { className: 'fa fa-trash' })
          )
        )
      );
    }
  }]);

  return AvailabilityHourView;
}(_react.Component);

AvailabilityHourView.defaultProps = {
  readOnly: false
};
AvailabilityHourView.propTypes = {
  availabilityHour: _propTypes2.default.objectOf(_AvailabilityHour2.default).isRequired,

  // params: availabilityHour (AvailabilityHour)
  onDelete: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
var _default = AvailabilityHourView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AvailabilityHourView, 'AvailabilityHourView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AvailabilityHourView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AvailabilityHourView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForDayView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _AvailabilityHour = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour2 = _interopRequireDefault(_AvailabilityHour);

var _AvailabilityHoursForDay = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHoursForDay.js");

var _AvailabilityHoursForDay2 = _interopRequireDefault(_AvailabilityHoursForDay);

var _AvailabilityHourView = __webpack_require__("./scripts/pages/menu/components/availabilityHours/AvailabilityHourView.js");

var _AvailabilityHourView2 = _interopRequireDefault(_AvailabilityHourView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var AvailabilityHoursForDayView = function (_Component) {
  _inherits(AvailabilityHoursForDayView, _Component);

  function AvailabilityHoursForDayView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityHoursForDayView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityHoursForDayView.__proto__ || Object.getPrototypeOf(AvailabilityHoursForDayView)).call.apply(_ref, [this].concat(args))), _this), _this.onClickLabelWholeDay = function () {
      var _this2;

      return (_this2 = _this).__onClickLabelWholeDay__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClickLabelHours = function () {
      var _this3;

      return (_this3 = _this).__onClickLabelHours__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClickLabelOff = function () {
      var _this4;

      return (_this4 = _this).__onClickLabelOff__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDelete = function () {
      var _this5;

      return (_this5 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvailabilityHoursForDayView, [{
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClickLabelOff__REACT_HOT_LOADER__',
    value: function __onClickLabelOff__REACT_HOT_LOADER__() {
      return this.__onClickLabelOff__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClickLabelHours__REACT_HOT_LOADER__',
    value: function __onClickLabelHours__REACT_HOT_LOADER__() {
      return this.__onClickLabelHours__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClickLabelWholeDay__REACT_HOT_LOADER__',
    value: function __onClickLabelWholeDay__REACT_HOT_LOADER__() {
      return this.__onClickLabelWholeDay__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDayLabel',
    value: function getDayLabel() {
      switch (this.props.day) {
        case _Constants2.default.Day.MONDAY:
          return _I18n2.default.tr('global.days.monday');

        case _Constants2.default.Day.TUESDAY:
          return _I18n2.default.tr('global.days.tuesday');

        case _Constants2.default.Day.WEDNESDAY:
          return _I18n2.default.tr('global.days.wednesday');

        case _Constants2.default.Day.THURSDAY:
          return _I18n2.default.tr('global.days.thursday');

        case _Constants2.default.Day.FRIDAY:
          return _I18n2.default.tr('global.days.friday');

        case _Constants2.default.Day.SATURDAY:
          return _I18n2.default.tr('global.days.saturday');

        case _Constants2.default.Day.SUNDAY:
          return _I18n2.default.tr('global.days.sunday');

        default:
          return '';
      }
    }
  }, {
    key: 'getStatus',
    value: function getStatus() {
      if (this.isAvailableForWholeDay() && this.props.availabilityHoursForDay.hours.length > 0) {
        return 'day';
      } else if (!this.isAvailableForWholeDay() && this.props.availabilityHoursForDay.hours.length > 0) {
        return 'hours';
      } else if (!this.isAvailableForWholeDay() && this.props.availabilityHoursForDay.hours.length === 0) {
        return 'off';
      }
    }
    //
    //
    //

  }, {
    key: 'isAvailableForWholeDay',
    value: function isAvailableForWholeDay() {
      return this.props.availabilityHoursForDay.isAvailableForWholeDay();
    }
  }, {
    key: '__onClickLabelWholeDay__REACT_HOT_LOADER__',
    value: function __onClickLabelWholeDay__REACT_HOT_LOADER__() {
      if (this.props.readOnly) {
        return;
      }
      var availabilityHoursForDay = this.props.availabilityHoursForDay;

      availabilityHoursForDay.setAvailableForWholeDay();
      this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
    }
  }, {
    key: '__onClickLabelHours__REACT_HOT_LOADER__',
    value: function __onClickLabelHours__REACT_HOT_LOADER__() {
      if (this.props.readOnly) {
        return;
      }
      var availabilityHoursForDay = this.props.availabilityHoursForDay;

      if (availabilityHoursForDay.isAvailableForWholeDay()) {
        availabilityHoursForDay.resetHours();
      }
      availabilityHoursForDay.addHour(this.props.suggestedHour);

      // if this.props.suggestedHour was for whole day we replace it
      if (availabilityHoursForDay.isAvailableForWholeDay()) {
        availabilityHoursForDay.resetHours();
        availabilityHoursForDay.setAvailableOnDay();
      }

      this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
    }
  }, {
    key: '__onClickLabelOff__REACT_HOT_LOADER__',
    value: function __onClickLabelOff__REACT_HOT_LOADER__() {
      if (this.props.readOnly) {
        return;
      }
      var availabilityHoursForDay = this.props.availabilityHoursForDay;

      availabilityHoursForDay.setNotAvailableForWholeDay();
      this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',


    // -- renderers
    value: function __onDelete__REACT_HOT_LOADER__(availabilityHour) {
      if (this.props.readOnly) {
        return;
      }
      var availabilityHoursForDay = this.props.availabilityHoursForDay;

      availabilityHoursForDay.deleteHour(availabilityHour);

      this.props.onChangeForDay(this.props.day, availabilityHoursForDay);
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this6 = this;

      var availabilityHoursForDayListView = [];

      var sortedOpeningHours = _lodash2.default.sortBy(this.props.availabilityHoursForDay.hours, ['asc'], function (hour) {
        return hour.opening;
      });

      var i = 0; // handle if there is same two hours.
      _lodash2.default.each(sortedOpeningHours, function (availabilityHour) {
        availabilityHoursForDayListView.push(_react2.default.createElement(_AvailabilityHourView2.default, {
          key: i,
          availabilityHour: availabilityHour,
          onDelete: _this6.onDelete,
          readOnly: _this6.props.readOnly
        }));
        ++i;
      });

      return availabilityHoursForDayListView;
    }
  }, {
    key: 'renderAddForDayBtn',
    value: function renderAddForDayBtn() {
      var _this7 = this;

      if (this.props.readOnly) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'btn btn-primary btn-add',
          onClick: function onClick() {
            return _this7.props.onAddAvailabilityClick(_this7.props.day);
          }
        },
        _react2.default.createElement('i', {
          className: 'fa fa-plus'
        }),
        '\xA0',
        _I18n2.default.tr('components.availibility_hours.form.add_opening_hour')
      );
    }
  }, {
    key: 'renderAvailableForWholeDay',
    value: function renderAvailableForWholeDay() {
      var labelClassName = (0, _classnames2.default)('btn btn-primary', {
        'active': !this.isAvailableForWholeDay() && !_lodash2.default.isEmpty(this.props.availabilityHoursForDay.hours.length)
      });

      return _react2.default.createElement(
        'div',
        { className: 'btn-group', 'data-toggle': 'buttons' },
        _react2.default.createElement(
          'label',
          {
            className: 'btn btn-primary btn-xs ' + (this.getStatus() === 'day' && 'active'),
            onClick: this.onClickLabelWholeDay
          },
          _I18n2.default.tr('components.availibility_hours.form.whole_day')
        ),
        _react2.default.createElement(
          'label',
          {
            className: 'btn btn-primary btn-xs ' + (this.getStatus() === 'hours' && 'active'),
            onClick: this.onClickLabelHours
          },
          _I18n2.default.tr('components.availibility_hours.form.custom_hours')
        ),
        _react2.default.createElement(
          'label',
          {
            className: 'btn btn-primary btn-xs ' + (this.getStatus() === 'off' && 'active'),
            onClick: this.onClickLabelOff
          },
          _I18n2.default.tr('components.availibility_hours.form.off')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'availability_hours_for_day' },
        _react2.default.createElement(
          'h3',
          null,
          _lodash2.default.capitalize(this.getDayLabel())
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderAvailableForWholeDay(),
          this.getStatus() === 'day' && _react2.default.createElement(
            'p',
            null,
            _I18n2.default.tr('components.availibility_hours.form.whole_day.content')
          ),
          this.getStatus() === 'hours' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              _I18n2.default.tr('components.availibility_hours.form.custom_hours.content')
            ),
            this.renderList(),
            this.renderAddForDayBtn()
          ),
          this.getStatus() === 'off' && _react2.default.createElement(
            'p',
            null,
            _I18n2.default.tr('components.availibility_hours.form.off.content')
          )
        )
      );
    }
  }]);

  return AvailabilityHoursForDayView;
}(_react.Component);

AvailabilityHoursForDayView.defaultProps = {
  readOnly: false
};
AvailabilityHoursForDayView.propTypes = {
  availabilityHoursForDay: _propTypes2.default.objectOf(_AvailabilityHoursForDay2.default).isRequired,

  suggestedHour: _propTypes2.default.object.isRequired,

  day: _propTypes2.default.number.isRequired,

  readOnly: _propTypes2.default.bool,

  /**
   * @param dayIndex
   */
  onAddAvailabilityClick: _propTypes2.default.func.isRequired,

  /**
   * @param dayIndex
   * @param Array<AvailabilityHour>
   */
  onChangeForDay: _propTypes2.default.func.isRequired
};
var _default = AvailabilityHoursForDayView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AvailabilityHoursForDayView, 'AvailabilityHoursForDayView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AvailabilityHoursForDayView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AvailabilityHoursForDayView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _AvailabilityHours = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHours.js");

var _AvailabilityHours2 = _interopRequireDefault(_AvailabilityHours);

var _AvailabilityHoursForDay = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHoursForDay.js");

var _AvailabilityHoursForDay2 = _interopRequireDefault(_AvailabilityHoursForDay);

var _AvailabilityHour = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour2 = _interopRequireDefault(_AvailabilityHour);

var _AvailabilityHoursForDayView = __webpack_require__("./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForDayView.js");

var _AvailabilityHoursForDayView2 = _interopRequireDefault(_AvailabilityHoursForDayView);

var _AddAvailabilityHourModal = __webpack_require__("./scripts/pages/menu/components/availabilityHours/AddAvailabilityHourModal.js");

var _AddAvailabilityHourModal2 = _interopRequireDefault(_AddAvailabilityHourModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// constants


// entities


// views


var AvailabilityHoursForm = function (_Component) {
  _inherits(AvailabilityHoursForm, _Component);

  function AvailabilityHoursForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityHoursForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityHoursForm.__proto__ || Object.getPrototypeOf(AvailabilityHoursForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayAddAvailabilityHourModal: false,

      addAvailabilityHourModalDefaultDay: _Constants2.default.Day.MONDAY
    }, _this.onChangeForDay = function () {
      var _this2;

      return (_this2 = _this).__onChangeForDay__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.addAvailabilityHourForDay = function () {
      var _this3;

      return (_this3 = _this).__addAvailabilityHourForDay__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.displayAddAvailabilityHourModal = function () {
      var _this4;

      return (_this4 = _this).__displayAddAvailabilityHourModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.hideAddAvailabilityHourModal = function () {
      var _this5;

      return (_this5 = _this).__hideAddAvailabilityHourModal__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(AvailabilityHoursForm, [{
    key: '__hideAddAvailabilityHourModal__REACT_HOT_LOADER__',
    value: function __hideAddAvailabilityHourModal__REACT_HOT_LOADER__() {
      return this.__hideAddAvailabilityHourModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__displayAddAvailabilityHourModal__REACT_HOT_LOADER__',
    value: function __displayAddAvailabilityHourModal__REACT_HOT_LOADER__() {
      return this.__displayAddAvailabilityHourModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__addAvailabilityHourForDay__REACT_HOT_LOADER__',
    value: function __addAvailabilityHourForDay__REACT_HOT_LOADER__() {
      return this.__addAvailabilityHourForDay__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeForDay__REACT_HOT_LOADER__',
    value: function __onChangeForDay__REACT_HOT_LOADER__() {
      return this.__onChangeForDay__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeForDay__REACT_HOT_LOADER__',
    value: function __onChangeForDay__REACT_HOT_LOADER__(day, availabilityHoursForDay) {
      var availabilityHours = this.props.availabilityHours.copy();
      availabilityHours.setForDay(day, availabilityHoursForDay);
      this.props.onAvailibilityHoursChange(availabilityHours);
    }
  }, {
    key: '__addAvailabilityHourForDay__REACT_HOT_LOADER__',


    //
    //
    //

    // -- events modal
    value: function __addAvailabilityHourForDay__REACT_HOT_LOADER__(day, availabilityHour) {
      var availabilityHours = this.props.availabilityHours.copy();
      availabilityHours.addForDay(day, availabilityHour);
      this.props.onAvailibilityHoursChange(availabilityHours);
    }
  }, {
    key: '__displayAddAvailabilityHourModal__REACT_HOT_LOADER__',
    value: function __displayAddAvailabilityHourModal__REACT_HOT_LOADER__() {
      var defaultDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Constants2.default.Day.MONDAY;

      this.setState({
        displayAddAvailabilityHourModal: true,
        addAvailabilityHourModalDefaultDay: defaultDay
      });
    }
  }, {
    key: '__hideAddAvailabilityHourModal__REACT_HOT_LOADER__',


    //
    //
    //


    value: function __hideAddAvailabilityHourModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddAvailabilityHourModal: false
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this6 = this;

      var availabilityHours = this.props.availabilityHours;

      var days = [_Constants2.default.Day.MONDAY, _Constants2.default.Day.TUESDAY, _Constants2.default.Day.WEDNESDAY, _Constants2.default.Day.THURSDAY, _Constants2.default.Day.FRIDAY, _Constants2.default.Day.SATURDAY, _Constants2.default.Day.SUNDAY];

      var suggestedHour = availabilityHours.getSuggestAvailabilityHour();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: 'availability_hours_form__week',
            style: {
              // overflowX: 'auto',
              // whiteSpace: 'nowrap',
              flexDirection: 'row',
              flexWrap: 'wrap'
            }
          },
          days.map(function (day, index) {
            return _react2.default.createElement(
              'div',
              {
                key: day,
                className: 'availability_hours_form__day'
              },
              _react2.default.createElement(_AvailabilityHoursForDayView2.default, {
                key: day,
                day: day,
                availabilityHoursForDay: availabilityHours.getForDay(day),
                suggestedHour: suggestedHour,
                onChangeForDay: _this6.onChangeForDay,
                readOnly: _this6.props.readOnly,
                onAddAvailabilityClick: _this6.displayAddAvailabilityHourModal
              })
            );
          })
        )
      );
    }
  }, {
    key: 'renderAddAvailabilityHourModal',
    value: function renderAddAvailabilityHourModal() {
      if (!this.state.displayAddAvailabilityHourModal) {
        return null;
      }

      var defaultDay = this.state.addAvailabilityHourModalDefaultDay;

      // Get a default opening hour suggestion based on all the others opening hours
      var defaultAvailabilityHour = this.props.availabilityHours.getSuggestAvailabilityHourForDay(defaultDay);

      return _react2.default.createElement(_AddAvailabilityHourModal2.default, {
        show: this.state.displayAddAvailabilityHourModal,
        onHide: this.hideAddAvailabilityHourModal,
        onAddAvailabilityHourForDay: this.addAvailabilityHourForDay,
        defaultAvailabilityHour: defaultAvailabilityHour,
        defaultDay: defaultDay
      });
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'col-xs-12 availability_hours_form' },
          _react2.default.createElement(
            'div',
            null,
            this.renderBody(),
            this.renderAddAvailabilityHourModal()
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return AvailabilityHoursForm;
}(_react.Component);

AvailabilityHoursForm.defaultProps = {
  availabilityHours: new _AvailabilityHours2.default(),

  readOnly: false
};
AvailabilityHoursForm.propTypes = {
  availabilityHours: _react.PropTypes.objectOf(_AvailabilityHours2.default),

  onAvailibilityHoursChange: _react.PropTypes.func.isRequired,

  readOnly: _react.PropTypes.bool
};
exports.default = AvailabilityHoursForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AvailabilityHoursForm, 'AvailabilityHoursForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/components/availabilityHours/AvailabilityHoursForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menu/MenuDetailPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _MenuDetailView = __webpack_require__("./scripts/pages/menu/menu/MenuDetailView.js");

var _MenuDetailView2 = _interopRequireDefault(_MenuDetailView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var MenuDetailPage = function (_AbstractComponent) {
  _inherits(MenuDetailPage, _AbstractComponent);

  function MenuDetailPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuDetailPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuDetailPage.__proto__ || Object.getPrototypeOf(MenuDetailPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu(),
      restaurant: _stores.RestaurantStore.getRestaurant(),
      menu: null,
      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMenuUpdated = function () {
      var _this3;

      return (_this3 = _this).__onMenuUpdated__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onError = function () {
      var _this4;

      return (_this4 = _this).__onError__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onUpdate = function () {
      var _this5;

      return (_this5 = _this).__onUpdate__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onImageRemove = function () {
      var _this6;

      return (_this6 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuDetailPage, [{
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__() {
      return this.__onUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      return this.__onMenuUpdated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        _RestaurantMenuAction2.default.loadRestaurantMenu();
      } else {
        this.loadMenu();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'getMenuOnRestaurantMenu',
    value: function getMenuOnRestaurantMenu(restaurantMenu) {
      var menuId = this.props.params.menuId;
      var menu = restaurantMenu.getMenuWithId(menuId);

      return menu;
    }
  }, {
    key: 'loadMenu',
    value: function loadMenu() {
      var menu = this.getMenuOnRestaurantMenu(this.state.restaurantMenu);
      this.setState({
        menu: menu,
        loading: false
      });
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
      var menu = this.getMenuOnRestaurantMenu(restaurantMenu);

      this.setState({
        restaurantMenu: restaurantMenu,
        menu: menu,
        loading: false
      });
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
      var menu = this.getMenuOnRestaurantMenu(restaurantMenu);

      this.setState({
        restaurantMenu: restaurantMenu,
        menu: menu,
        loading: false
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _stores.RestaurantMenuStore.getApiError()
      });
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__(menu, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _utils.ViewUtils.dataUriToFile(image);
      _RestaurantMenuAction2.default.saveMenu(menu, imageFile);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onImageRemove__REACT_HOT_LOADER__(menu) {
      this.showLoading();
      _RestaurantMenuAction2.default.deleteMenuImage(menu);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.state.menu)) {
        return this.renderOnLoadingContent();
      }

      return _react2.default.createElement(_MenuDetailView2.default, {
        menu: this.menu,
        currencyCode: this.restaurant.currency,
        restaurantMenu: this.restaurantMenu,
        onUpdate: this.onUpdate,
        onImageRemove: this.onImageRemove,
        orderSettings: _stores.OrderSettingsStore.getOrderSettings()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.menus'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.MENUS
        }
      }, {
        name: !_lodash2.default.isNull(this.menu) ? this.menu.name : '',
        link: null
      }];

      return _react2.default.createElement(
        'div',
        { className: 'menu_detail_page' },
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        this.renderBody(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR, this.onError)];
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.state.menu;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.state.restaurant;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }]);

  return MenuDetailPage;
}(_AbstractComponent3.default);

var _default = MenuDetailPage;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuDetailPage, 'MenuDetailPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/MenuDetailPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/MenuDetailPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menu/MenuDetailView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _constants2 = __webpack_require__("./sdk/scripts/constants/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _DietaryConstants = __webpack_require__("./sdk/scripts/constants/DietaryConstants.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _MenuPartView = __webpack_require__("./scripts/pages/menu/menu/components/MenuPartView.js");

var _MenuPartView2 = _interopRequireDefault(_MenuPartView);

var _MenuCategoryRow = __webpack_require__("./scripts/pages/menu/menu/components/MenuCategoryRow.js");

var _MenuCategoryRow2 = _interopRequireDefault(_MenuCategoryRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- entities


// -- views


var MenuDetailView = function (_AbstractRestaurantMe) {
  _inherits(MenuDetailView, _AbstractRestaurantMe);

  function MenuDetailView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuDetailView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuDetailView.__proto__ || Object.getPrototypeOf(MenuDetailView)).call.apply(_ref, [this].concat(args))), _this), _this.onMenuChange = function () {
      var _this2;

      return (_this2 = _this).__onMenuChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onToggleTakeAway = function () {
      var _this3;

      return (_this3 = _this).__onToggleTakeAway__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onToggleDelivery = function () {
      var _this4;

      return (_this4 = _this).__onToggleDelivery__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onToggleOnSite = function () {
      var _this5;

      return (_this5 = _this).__onToggleOnSite__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onSubmit = function () {
      var _this6;

      return (_this6 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onReset = function () {
      var _this7;

      return (_this7 = _this).__onReset__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onImageChange = function () {
      var _this8;

      return (_this8 = _this).__onImageChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onImageRemove = function () {
      var _this9;

      return (_this9 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuDetailView, [{
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__() {
      return this.__onImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleOnSite__REACT_HOT_LOADER__',
    value: function __onToggleOnSite__REACT_HOT_LOADER__() {
      return this.__onToggleOnSite__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleDelivery__REACT_HOT_LOADER__',
    value: function __onToggleDelivery__REACT_HOT_LOADER__() {
      return this.__onToggleDelivery__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleTakeAway__REACT_HOT_LOADER__',
    value: function __onToggleTakeAway__REACT_HOT_LOADER__() {
      return this.__onToggleTakeAway__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuChange__REACT_HOT_LOADER__',
    value: function __onMenuChange__REACT_HOT_LOADER__() {
      return this.__onMenuChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(MenuDetailView.prototype.__proto__ || Object.getPrototypeOf(MenuDetailView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        menu: props.menu.copy(),
        image: null,

        displayEditModal: false
      };
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.menu.equals(nextProps.menu);
    }
  }, {
    key: '__onMenuChange__REACT_HOT_LOADER__',


    // -- toggle
    value: function __onMenuChange__REACT_HOT_LOADER__(menu) {
      this.setState({
        menu: menu
      });
    }
  }, {
    key: '__onToggleTakeAway__REACT_HOT_LOADER__',
    value: function __onToggleTakeAway__REACT_HOT_LOADER__() {
      var menu = this.menu;

      menu.prices.takeAway.available = !menu.prices.takeAway.available;

      this.setState({
        menu: menu
      });
    }
  }, {
    key: '__onToggleDelivery__REACT_HOT_LOADER__',
    value: function __onToggleDelivery__REACT_HOT_LOADER__() {
      var menu = this.menu;

      menu.prices.delivery.available = !menu.prices.delivery.available;

      this.setState({
        menu: menu
      });
    }
  }, {
    key: '__onToggleOnSite__REACT_HOT_LOADER__',


    //
    // submit
    //

    value: function __onToggleOnSite__REACT_HOT_LOADER__() {
      var menu = this.menu;

      menu.prices.onSite.available = !menu.prices.onSite.available;

      this.setState({
        menu: menu
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      this.props.onUpdate(this.menu, this.state.image);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    //
    // image
    //

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        menu: this.props.menu.copy(),
        image: null
      });
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__(pictureData) {
      this.setState({
        image: pictureData
      });
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',


    // -- getters

    value: function __onImageRemove__REACT_HOT_LOADER__() {
      this.props.onImageRemove(this.menu);
    }
  }, {
    key: 'renderEditButton',


    // -- renderers

    value: function renderEditButton() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      return _react2.default.createElement(
        _Link2.default,
        {
          className: 'btn btn-primary',
          to: _RoutingEnum2.default.RESTAURANT_MENU_MENU_EDIT,
          params: { menuId: this.menu.id }
        },
        _react2.default.createElement('i', { className: 'fa fa-edit' }),
        '\xA0\xA0',
        _I18n2.default.tr('menu.menu.detail.edit')
      );
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      if (_lodash2.default.isEmpty(this.menu.description)) {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.menu.detail.no_description')
          )
        );
      }

      return _react2.default.createElement(
        'p',
        null,
        this.menu.description
      );
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var readOnly = _SecurityContext2.default.restaurantMenu.canEdit() && false ? false : true;

      return _react2.default.createElement(_form.ImageDropzone, {
        readOnly: readOnly,
        className: 'menu_view__image',
        placeholder: _constants.ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_MENU,
        currentImage: this.state.image,
        image: this.menu.image,
        onChange: this.onImageChange,
        onRemove: this.onImageRemove,
        aspectRatio: _constants2.ApiConstants.Image.RestaurantMenu.Menu.RATIO,
        width: _constants2.ApiConstants.Image.RestaurantMenu.Menu.WIDTH,
        height: _constants2.ApiConstants.Image.RestaurantMenu.Menu.HEIGHT,
        maxSize: _constants2.ApiConstants.Image.RestaurantMenu.Menu.MAX_SIZE
      });
    }
  }, {
    key: 'renderPricesTable',
    value: function renderPricesTable() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'table',
        { className: 'table menu_modal_view__prices_table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('td', null),
            _react2.default.createElement(
              'td',
              null,
              _I18n2.default.tr('menu.menu.detail.table.header.mode')
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _I18n2.default.tr('menu.menu.detail.table.header.price')
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _I18n2.default.tr('menu.menu.detail.table.header.vat')
            ),
            _react2.default.createElement(
              'td',
              null,
              _I18n2.default.tr('menu.menu.detail.table.header.activation')
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_SvgIcon2.default, { icon: _SvgIcon2.default.ORDER_ON_SITE })
            ),
            _react2.default.createElement(
              'td',
              null,
              _I18n2.default.tr('menu.menu.detail.table.header.on_site')
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _utils.CurrencyUtils.formatPriceWithCurrency(this.menu.prices.onSite.priceIncludingTax, this.props.currencyCode)
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _utils.CurrencyUtils.formatTax(this.menu.prices.onSite.vat)
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                key: _utils.Utils.generateUID(),
                bsSize: 'mini',
                value: this.menu.prices.onSite.available,
                onChange: this.onToggleOnSite,
                disabled: disableModification
              })
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_SvgIcon2.default, { icon: _SvgIcon2.default.ORDER_TAKE_AWAY })
            ),
            _react2.default.createElement(
              'td',
              null,
              _I18n2.default.tr('menu.menu.detail.table.header.take_away')
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _utils.CurrencyUtils.formatPriceWithCurrency(this.menu.prices.takeAway.priceIncludingTax, this.props.currencyCode)
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _utils.CurrencyUtils.formatTax(this.menu.prices.takeAway.vat)
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                key: _utils.Utils.generateUID(),
                bsSize: 'mini',
                value: this.menu.prices.takeAway.available,
                onChange: this.onToggleTakeAway,
                disabled: disableModification
              })
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_SvgIcon2.default, { icon: _SvgIcon2.default.ORDER_DELIVERY })
            ),
            _react2.default.createElement(
              'td',
              null,
              _I18n2.default.tr('menu.menu.detail.table.header.delivery')
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _utils.CurrencyUtils.formatPriceWithCurrency(this.menu.prices.delivery.priceIncludingTax, this.props.currencyCode)
            ),
            _react2.default.createElement(
              'td',
              { className: 'text-center' },
              _utils.CurrencyUtils.formatTax(this.menu.prices.delivery.vat)
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                key: _utils.Utils.generateUID(),
                bsSize: 'mini',
                value: this.menu.prices.delivery.available,
                onChange: this.onToggleDelivery,
                disabled: disableModification
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderPartsList',
    value: function renderPartsList() {
      var _this10 = this;

      var partsListView = this.menu.parts.map(function (part) {
        return _react2.default.createElement(_MenuPartView2.default, {
          key: part.id,
          menuPart: part,
          menu: _this10.menu,
          restaurantMenu: _this10.restaurantMenu,
          currencyCode: _this10.props.currencyCode
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        partsListView
      );
    }
  }, {
    key: 'renderCategoriesList',
    value: function renderCategoriesList() {
      var categories = this.restaurantMenu.getCategoriesWithMenuId(this.menu.id);

      if (_lodash2.default.isEmpty(categories)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.menu.detail.no_category_with_product')
          )
        );
      }

      var categoriesListView = [];

      _lodash2.default.each(categories, function (category) {
        categoriesListView.push(_react2.default.createElement(_MenuCategoryRow2.default, {
          key: category.id,
          category: category
          // onDelete={this.onDeleteMenuFromCategory}
        }));
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          categoriesListView
        )
      );
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_form.FixedSubmitArea, {
        haveModifications: this.haveModifications,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      });
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'menu_view' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-4' },
              _react2.default.createElement(
                'h3',
                null,
                this.menu.name
              ),
              this.renderDescription()
            ),
            _react2.default.createElement(
              'div',
              { className: 'hidden-xs col-md-6' },
              this.renderImage()
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-2' },
              this.renderEditButton()
            ),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-xs-12 col-md-4' },
              this.menu.dietaryInfo && !(0, _isEmpty2.default)(this.menu.dietaryInfo) && _react2.default.createElement(
                'span',
                null,
                _I18n2.default.tr('global.allergen.allergens'),
                ':\xA0',
                this.menu.dietaryInfo.allergens.map(_DietaryConstants.getAllergenLabel).join(', ')
              )
            )
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-xs-12 col-md-4' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.menu.detail.price')
              ),
              this.renderPricesTable()
            ),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-xs-12 col-md-4' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.menu.detail.categories')
              ),
              this.renderCategoriesList()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.menu.detail.parts')
              ),
              this.renderPartsList()
            )
          ),
          this.renderSubmitArea()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.state.menu;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.props.menu.equals(this.state.menu) || !_lodash2.default.isNull(this.state.image);
    }
  }]);

  return MenuDetailView;
}(_AbstractRestaurantMenuForm2.default);

MenuDetailView.propTypes = {
  menu: _propTypes2.default.objectOf(_menu.Menu).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  onUpdate: _propTypes2.default.func.isRequired,

  onImageRemove: _propTypes2.default.func,

  currencyCode: _propTypes2.default.string
};
var _default = MenuDetailView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuDetailView, 'MenuDetailView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/MenuDetailView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/MenuDetailView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menu/components/MenuCategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var CategoryRow = function (_Component) {
  _inherits(CategoryRow, _Component);

  function CategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryRow.__proto__ || Object.getPrototypeOf(CategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.category);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'h4',
          { className: 'link-hover',
            onClick: this.onDisplayDetailClick
          },
          this.category.name
        )
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }]);

  return CategoryRow;
}(_react.Component);

CategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired,

  onDelete: _propTypes2.default.func.isRequired
};
exports.default = CategoryRow;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryRow, 'CategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/components/MenuCategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menu/components/MenuPartProductView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var MenuPartProductView = function (_Component) {
  _inherits(MenuPartProductView, _Component);

  function MenuPartProductView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartProductView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartProductView.__proto__ || Object.getPrototypeOf(MenuPartProductView)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartProductView, [{
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.product.equals(this.props.product);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductEdit(this.props.product);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        { className: 'menu_part_product_view' },
        _react2.default.createElement(
          'td',
          {
            className: 'col-xs-6 pointer link-hover',
            onClick: this.onDisplayDetail
          },
          this.product.name
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-xs-1' },
          '(+',
          _utils.CurrencyUtils.formatPriceWithCurrency(this.menuPartProduct.additionalPrice, this.props.currencyCode),
          ')'
        )
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'menuPartProduct',
    get: function get() {
      return this.props.menuPartProduct;
    }
  }]);

  return MenuPartProductView;
}(_react.Component);

MenuPartProductView.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  menuPartProduct: _propTypes2.default.objectOf(_MenuPartProduct2.default).isRequired,

  currencyCode: _propTypes2.default.string
};
var _default = MenuPartProductView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartProductView, 'MenuPartProductView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/components/MenuPartProductView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/components/MenuPartProductView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menu/components/MenuPartView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuPart = __webpack_require__("./sdk/scripts/entities/menu/MenuPart.js");

var _MenuPart2 = _interopRequireDefault(_MenuPart);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

var _MenuPartProductView = __webpack_require__("./scripts/pages/menu/menu/components/MenuPartProductView.js");

var _MenuPartProductView2 = _interopRequireDefault(_MenuPartProductView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


// -- views


var MenuPartView = function (_Component) {
  _inherits(MenuPartView, _Component);

  function MenuPartView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartView.__proto__ || Object.getPrototypeOf(MenuPartView)).call.apply(_ref, [this].concat(args))), _this), _this.onEditPartCategoriesClicked = function () {
      var _this2;

      return (_this2 = _this).__onEditPartCategoriesClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartView, [{
    key: '__onEditPartCategoriesClicked__REACT_HOT_LOADER__',
    value: function __onEditPartCategoriesClicked__REACT_HOT_LOADER__() {
      return this.__onEditPartCategoriesClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.menuPart.equals(this.props.menuPart) || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
    }
  }, {
    key: '__onEditPartCategoriesClicked__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onEditPartCategoriesClicked__REACT_HOT_LOADER__() {
      _actions.RouteAction.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU_PART_EDIT, {
        menuId: this.props.menu.id,
        menuPartId: this.menuPart.id
      });
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this3 = this;

      var productsListView = this.menuPart.products.map(function (menuPartProduct, index) {
        var product = _this3.restaurantMenu.getProductWithId(menuPartProduct.id);

        if (!_lodash2.default.isNull(product)) {
          return _react2.default.createElement(_MenuPartProductView2.default, {
            key: product.id + '_' + index,
            product: product,
            menuPartProduct: menuPartProduct,
            currencyCode: _this3.props.currencyCode
          });
        }

        return null;
      });

      return _react2.default.createElement(
        'table',
        { className: 'table top-buffer-20' },
        _react2.default.createElement(
          'tbody',
          null,
          productsListView
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'menu_part_view col-sm-12 col-md-6' },
        _react2.default.createElement(
          'h3',
          null,
          this.menuPart.name
        ),
        _react2.default.createElement(
          'p',
          null,
          _I18n2.default.tr('menu.min_with_colon'),
          ' ',
          this.menuPart.min,
          ' | ',
          _I18n2.default.tr('menu.max_with_colon'),
          ' ',
          this.menuPart.max
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn btn-default btn-xs',
            onClick: function onClick(event) {
              event.preventDefault();
              _this4.onEditPartCategoriesClicked();
            }
          },
          _I18n2.default.tr('menu.menu_edit.part.edit_part_categories')
        ),
        '\xA0\xA0',
        this.renderProducts()
      );
    }
  }, {
    key: 'menuPart',
    get: function get() {
      return this.props.menuPart;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }]);

  return MenuPartView;
}(_react.Component);

MenuPartView.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired,

  menuPart: _propTypes2.default.objectOf(_MenuPart2.default).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired,

  currencyCode: _propTypes2.default.string
};
var _default = MenuPartView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartView, 'MenuPartView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/components/MenuPartView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menu/components/MenuPartView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/MenuEditPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _MenuEditView = __webpack_require__("./scripts/pages/menu/menuEdit/MenuEditView.js");

var _MenuEditView2 = _interopRequireDefault(_MenuEditView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var MenuEditPage = function (_AbstractComponent) {
  _inherits(MenuEditPage, _AbstractComponent);

  function MenuEditPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuEditPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuEditPage.__proto__ || Object.getPrototypeOf(MenuEditPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu(),
      restaurant: _stores.RestaurantStore.getRestaurant(),
      menu: _this.isEditMode() ? null : new _menu.Menu(),
      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMenuUpdated = function () {
      var _this3;

      return (_this3 = _this).__onMenuUpdated__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onProductOptionDeleted = function () {
      var _this4;

      return (_this4 = _this).__onProductOptionDeleted__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onProductOptionCreated = function () {
      var _this5;

      return (_this5 = _this).__onProductOptionCreated__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onError = function () {
      var _this6;

      return (_this6 = _this).__onError__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onUpdateMenu = function () {
      var _this7;

      return (_this7 = _this).__onUpdateMenu__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onImageRemove = function () {
      var _this8;

      return (_this8 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onCreateMenu = function () {
      var _this9;

      return (_this9 = _this).__onCreateMenu__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onDeleteMenu = function () {
      var _this10;

      return (_this10 = _this).__onDeleteMenu__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuEditPage, [{
    key: '__onDeleteMenu__REACT_HOT_LOADER__',
    value: function __onDeleteMenu__REACT_HOT_LOADER__() {
      return this.__onDeleteMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCreateMenu__REACT_HOT_LOADER__',
    value: function __onCreateMenu__REACT_HOT_LOADER__() {
      return this.__onCreateMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateMenu__REACT_HOT_LOADER__',
    value: function __onUpdateMenu__REACT_HOT_LOADER__() {
      return this.__onUpdateMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionCreated__REACT_HOT_LOADER__',
    value: function __onProductOptionCreated__REACT_HOT_LOADER__() {
      return this.__onProductOptionCreated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionDeleted__REACT_HOT_LOADER__',
    value: function __onProductOptionDeleted__REACT_HOT_LOADER__() {
      return this.__onProductOptionDeleted__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      return this.__onMenuUpdated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

      if (!_SecurityContext2.default.restaurantMenu.canEdit) {
        // TODO: redirect
      }

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        _actions.RestaurantMenuAction.loadRestaurantMenu();
      } else if (this.isEditMode()) {
        this.loadMenu();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'loadMenu',
    value: function loadMenu() {
      var menu = this.getMenuOnRestaurantMenu(this.state.restaurantMenu);

      // TODO: if menu === null redirect to 404.
      this.setState({
        menu: menu,
        loading: false
      });
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();

      if (this.isEditMode()) {
        var menu = this.getMenuOnRestaurantMenu(restaurantMenu);
        this.setState({
          restaurantMenu: restaurantMenu,
          menu: menu,
          loading: false
        });
      } else {
        this.setState({
          restaurantMenu: restaurantMenu,
          loading: false
        });
      }
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      if (this.isEditMode()) {
        var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
        var menu = this.getMenuOnRestaurantMenu(restaurantMenu);

        this.setState({
          restaurantMenu: restaurantMenu,
          menu: menu,
          loading: false
        });
      }
    }
  }, {
    key: '__onProductOptionDeleted__REACT_HOT_LOADER__',
    value: function __onProductOptionDeleted__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenusTab();
    }
  }, {
    key: '__onProductOptionCreated__REACT_HOT_LOADER__',
    value: function __onProductOptionCreated__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenuDetail(_stores.RestaurantMenuStore.getCreatedMenu());
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _stores.RestaurantMenuStore.getApiError()
      });
    }
  }, {
    key: '__onUpdateMenu__REACT_HOT_LOADER__',
    value: function __onUpdateMenu__REACT_HOT_LOADER__(menu, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _utils.ViewUtils.dataUriToFile(image);
      _actions.RestaurantMenuAction.saveMenu(menu, imageFile);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__(menu) {
      this.showLoading();
      _actions.RestaurantMenuAction.deleteMenuImage(menu);
    }
  }, {
    key: '__onCreateMenu__REACT_HOT_LOADER__',
    value: function __onCreateMenu__REACT_HOT_LOADER__(menu, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _utils.ViewUtils.dataUriToFile(image);
      _actions.RestaurantMenuAction.createMenu(menu, imageFile);
    }
  }, {
    key: '__onDeleteMenu__REACT_HOT_LOADER__',
    value: function __onDeleteMenu__REACT_HOT_LOADER__(menu) {
      this.showLoading();
      _actions.RestaurantMenuAction.deleteMenu(menu);
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return !_lodash2.default.isUndefined(this.props.params.menuId);
    }
  }, {
    key: 'getMenuOnRestaurantMenu',
    value: function getMenuOnRestaurantMenu(restaurantMenu) {
      var menuId = this.props.params.menuId;
      var menu = restaurantMenu.getMenuWithId(menuId);

      return menu;
    }

    // -- renderers

  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.menu) || _lodash2.default.isNull(this.restaurantMenu)) {
        return this.renderLoading(true);
      }

      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.menus'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.MENUS
        }
      }];

      if (this.isEditMode()) {
        arianeDetails.push({
          name: this.menu.name,
          link: _RoutingEnum2.default.RESTAURANT_MENU_MENU_DETAIL,
          params: {
            menuId: this.menu.id
          }
        });
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.edition'),
          link: null
        });
      } else {
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.new'),
          link: null
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        _react2.default.createElement(_MenuEditView2.default, {
          menu: this.menu,
          restaurantMenu: this.restaurantMenu,
          onUpdate: this.onUpdateMenu,
          onImageRemove: this.onImageRemove,
          onCreate: this.onCreateMenu,
          onDelete: this.onDeleteMenu,
          isEditMode: this.isEditMode(),
          orderSettings: _stores.OrderSettingsStore.getOrderSettings(),
          currencyCode: this.state.restaurant.currency
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'menu_detail_page' },
          this.renderBody(),
          this.renderLoading()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_CREATE_RESTAURANT_MENU_MENU_SUCCESS, this.onProductOptionCreated), new _Listener2.default(_Events2.default.ON_CREATE_RESTAURANT_MENU_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_SUCCESS, this.onProductOptionDeleted), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR, this.onError)];
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.state.menu;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.state.restaurant;
    }
  }]);

  return MenuEditPage;
}(_AbstractComponent3.default);

exports.default = MenuEditPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuEditPage, 'MenuEditPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/MenuEditPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/MenuEditView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AllergenChooser = __webpack_require__("./sdk/scripts/components/form/AllergenChooser.js");

var _AllergenChooser2 = _interopRequireDefault(_AllergenChooser);

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _restaurantMenu = __webpack_require__("./scripts/components/restaurantMenu/index.js");

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _MenuPartView = __webpack_require__("./scripts/pages/menu/menuEdit/components/MenuPartView.js");

var _MenuPartView2 = _interopRequireDefault(_MenuPartView);

var _CategoryRow = __webpack_require__("./scripts/pages/menu/menuEdit/components/CategoryRow.js");

var _CategoryRow2 = _interopRequireDefault(_CategoryRow);

var _MenuPartFormModal = __webpack_require__("./scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartFormModal.js");

var _MenuPartFormModal2 = _interopRequireDefault(_MenuPartFormModal);

var _AvailabilityDatesForm = __webpack_require__("./scripts/pages/menu/components/availabilityDates/AvailabilityDatesForm.js");

var _AvailabilityDatesForm2 = _interopRequireDefault(_AvailabilityDatesForm);

var _AvailabilityHoursForm = __webpack_require__("./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForm.js");

var _AvailabilityHoursForm2 = _interopRequireDefault(_AvailabilityHoursForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- entities


// -- views


var MenuEditView = function (_AbstractRestaurantMe) {
  _inherits(MenuEditView, _AbstractRestaurantMe);

  function MenuEditView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuEditView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuEditView.__proto__ || Object.getPrototypeOf(MenuEditView)).call.apply(_ref, [this].concat(args))), _this), _this.onDelete = function () {
      var _this2;

      return (_this2 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMenuChange = function () {
      var _this3;

      return (_this3 = _this).__onMenuChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onNameChange = function () {
      var _this4;

      return (_this4 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDescriptionChange = function () {
      var _this5;

      return (_this5 = _this).__onDescriptionChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onPricesChange = function () {
      var _this6;

      return (_this6 = _this).__onPricesChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onUpMenuPart = function () {
      var _this7;

      return (_this7 = _this).__onUpMenuPart__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onDownMenuPart = function () {
      var _this8;

      return (_this8 = _this).__onDownMenuPart__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onDeleteMenuPart = function () {
      var _this9;

      return (_this9 = _this).__onDeleteMenuPart__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onUpdateMenuPart = function () {
      var _this10;

      return (_this10 = _this).__onUpdateMenuPart__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onAvailibilityHoursChange = function () {
      var _this11;

      return (_this11 = _this).__onAvailibilityHoursChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onToggleAvailibilityHoursChange = function () {
      var _this12;

      return (_this12 = _this).__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onAvailibilityDatesChange = function () {
      var _this13;

      return (_this13 = _this).__onAvailibilityDatesChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onToggleAvailibilityDatesChange = function () {
      var _this14;

      return (_this14 = _this).__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onAllergensChange = function () {
      var _this15;

      return (_this15 = _this).__onAllergensChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onAddMenuPartClicked = function () {
      var _this16;

      return (_this16 = _this).__onAddMenuPartClicked__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onHideAddMenuPartModal = function () {
      var _this17;

      return (_this17 = _this).__onHideAddMenuPartModal__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onAddMenuPart = function () {
      var _this18;

      return (_this18 = _this).__onAddMenuPart__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.onEditMenuPartClicked = function () {
      var _this19;

      return (_this19 = _this).__onEditMenuPartClicked__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _this.onHideEditMenuPartModal = function () {
      var _this20;

      return (_this20 = _this).__onHideEditMenuPartModal__REACT_HOT_LOADER__.apply(_this20, arguments);
    }, _this.onUpdateMenuPartFromModal = function () {
      var _this21;

      return (_this21 = _this).__onUpdateMenuPartFromModal__REACT_HOT_LOADER__.apply(_this21, arguments);
    }, _this.onSubmit = function () {
      var _this22;

      return (_this22 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this22, arguments);
    }, _this.onReset = function () {
      var _this23;

      return (_this23 = _this).__onReset__REACT_HOT_LOADER__.apply(_this23, arguments);
    }, _this.onImageChange = function () {
      var _this24;

      return (_this24 = _this).__onImageChange__REACT_HOT_LOADER__.apply(_this24, arguments);
    }, _this.onImageRemove = function () {
      var _this25;

      return (_this25 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this25, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuEditView, [{
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__() {
      return this.__onImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateMenuPartFromModal__REACT_HOT_LOADER__',
    value: function __onUpdateMenuPartFromModal__REACT_HOT_LOADER__() {
      return this.__onUpdateMenuPartFromModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideEditMenuPartModal__REACT_HOT_LOADER__',
    value: function __onHideEditMenuPartModal__REACT_HOT_LOADER__() {
      return this.__onHideEditMenuPartModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEditMenuPartClicked__REACT_HOT_LOADER__',
    value: function __onEditMenuPartClicked__REACT_HOT_LOADER__() {
      return this.__onEditMenuPartClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddMenuPart__REACT_HOT_LOADER__',
    value: function __onAddMenuPart__REACT_HOT_LOADER__() {
      return this.__onAddMenuPart__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideAddMenuPartModal__REACT_HOT_LOADER__',
    value: function __onHideAddMenuPartModal__REACT_HOT_LOADER__() {
      return this.__onHideAddMenuPartModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddMenuPartClicked__REACT_HOT_LOADER__',
    value: function __onAddMenuPartClicked__REACT_HOT_LOADER__() {
      return this.__onAddMenuPartClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAllergensChange__REACT_HOT_LOADER__',
    value: function __onAllergensChange__REACT_HOT_LOADER__() {
      return this.__onAllergensChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityDatesChange__REACT_HOT_LOADER__() {
      return this.__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityDatesChange__REACT_HOT_LOADER__() {
      return this.__onAvailibilityDatesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityHoursChange__REACT_HOT_LOADER__() {
      return this.__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityHoursChange__REACT_HOT_LOADER__() {
      return this.__onAvailibilityHoursChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateMenuPart__REACT_HOT_LOADER__',
    value: function __onUpdateMenuPart__REACT_HOT_LOADER__() {
      return this.__onUpdateMenuPart__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteMenuPart__REACT_HOT_LOADER__',
    value: function __onDeleteMenuPart__REACT_HOT_LOADER__() {
      return this.__onDeleteMenuPart__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDownMenuPart__REACT_HOT_LOADER__',
    value: function __onDownMenuPart__REACT_HOT_LOADER__() {
      return this.__onDownMenuPart__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpMenuPart__REACT_HOT_LOADER__',
    value: function __onUpMenuPart__REACT_HOT_LOADER__() {
      return this.__onUpMenuPart__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPricesChange__REACT_HOT_LOADER__',
    value: function __onPricesChange__REACT_HOT_LOADER__() {
      return this.__onPricesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__() {
      return this.__onDescriptionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuChange__REACT_HOT_LOADER__',
    value: function __onMenuChange__REACT_HOT_LOADER__() {
      return this.__onMenuChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(MenuEditView.prototype.__proto__ || Object.getPrototypeOf(MenuEditView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.menu.equals(nextProps.menu);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        menu: props.menu.copy(),
        image: null,

        // view
        validationErrors: {},

        // modal
        displayAddPartModal: false,

        displayEditPartModal: false,

        menuPartToEditOnModal: null
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.props.menu.equals(this.state.menu) || !_lodash2.default.isNull(this.state.image);
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return this.props.isEditMode;
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      if (this.props.orderSettings.menuManagedByPos) {
        return this.menu.isValidManagedByPos();
      }
      return this.menu.isValid();
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__(event) {
      var _this26 = this;

      event.preventDefault();
      _Notify2.default.confirmDelete(_I18n2.default.tr('menu.menu_edit.confirm_delete'), function (confirmed) {
        if (confirmed) {
          _this26.props.onDelete(_this26.props.menu);
        }
      });
    }
  }, {
    key: '__onMenuChange__REACT_HOT_LOADER__',
    value: function __onMenuChange__REACT_HOT_LOADER__(menu) {
      this.setState({
        menu: menu
      });
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var menu = this.menu;
      menu.localizedNames = newValue;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__(newValue) {
      var menu = this.menu;
      menu.localizedDescriptions = newValue;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onPricesChange__REACT_HOT_LOADER__',


    //
    // Parts
    //

    value: function __onPricesChange__REACT_HOT_LOADER__(prices) {
      var menu = this.menu;
      menu.prices = prices;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onUpMenuPart__REACT_HOT_LOADER__',
    value: function __onUpMenuPart__REACT_HOT_LOADER__(menuPart) {
      var menu = this.menu;
      menu.movePartUp(menuPart);
      this.onMenuChange(menu);
    }
  }, {
    key: '__onDownMenuPart__REACT_HOT_LOADER__',


    //
    // Parts - Crud
    //

    value: function __onDownMenuPart__REACT_HOT_LOADER__(menuPart) {
      var menu = this.menu;
      menu.movePartDown(menuPart);
      this.onMenuChange(menu);
    }
  }, {
    key: '__onDeleteMenuPart__REACT_HOT_LOADER__',
    value: function __onDeleteMenuPart__REACT_HOT_LOADER__(menuPartToDelete) {
      var menu = this.menu;
      menu.deletePart(menuPartToDelete);
      this.onMenuChange(menu);
    }
  }, {
    key: '__onUpdateMenuPart__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onUpdateMenuPart__REACT_HOT_LOADER__(menuPartToUpdate) {
      var menu = this.menu;
      menu.updatePart(menuPartToUpdate);
      this.onMenuChange(menu);
    }
  }, {
    key: '__onAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityHoursChange__REACT_HOT_LOADER__(availabilityHours) {
      var menu = this.menu;
      menu.availabilityHours = availabilityHours;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityHoursChange__REACT_HOT_LOADER__() {
      var menu = this.menu;
      if (_lodash2.default.isNull(menu.availabilityHours)) {
        menu.availabilityHours = new _menu.AvailabilityHours();
      } else {
        menu.availabilityHours = null;
      }

      this.onMenuChange(menu);
    }
  }, {
    key: '__onAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityDatesChange__REACT_HOT_LOADER__(availabilityDates) {
      var menu = this.menu;
      menu.availabilityDates = availabilityDates;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityDatesChange__REACT_HOT_LOADER__() {
      var menu = this.menu;
      menu.availabilityDates = _lodash2.default.isNull(menu.availabilityDates) ? new _menu.AvailabilityDates() : null;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onAllergensChange__REACT_HOT_LOADER__',


    //
    // Parts - modals - add
    //

    value: function __onAllergensChange__REACT_HOT_LOADER__(allergens) {
      var menu = this.menu;
      if (!menu.dietaryData) {
        menu.dietaryInfo = {};
      }
      menu.dietaryInfo.allergens = allergens;
      this.onMenuChange(menu);
    }
  }, {
    key: '__onAddMenuPartClicked__REACT_HOT_LOADER__',
    value: function __onAddMenuPartClicked__REACT_HOT_LOADER__(event) {
      event.preventDefault();
      this.setState({
        displayAddPartModal: true
      });
    }
  }, {
    key: '__onHideAddMenuPartModal__REACT_HOT_LOADER__',
    value: function __onHideAddMenuPartModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddPartModal: false
      });
    }
  }, {
    key: '__onAddMenuPart__REACT_HOT_LOADER__',


    //
    // Parts - modals - edit
    //

    value: function __onAddMenuPart__REACT_HOT_LOADER__(menuPartToAdd) {
      var menu = this.menu;
      menu.addPart(menuPartToAdd);
      this.setState({
        menu: menu,
        displayAddPartModal: false
      });
    }
  }, {
    key: '__onEditMenuPartClicked__REACT_HOT_LOADER__',
    value: function __onEditMenuPartClicked__REACT_HOT_LOADER__(menuPartToEditOnModal) {
      this.setState({
        displayEditPartModal: true,
        menuPartToEditOnModal: menuPartToEditOnModal
      });
    }
  }, {
    key: '__onHideEditMenuPartModal__REACT_HOT_LOADER__',
    value: function __onHideEditMenuPartModal__REACT_HOT_LOADER__() {
      this.setState({
        displayEditPartModal: false,
        menuPartToEditOnModal: null
      });
    }
  }, {
    key: '__onUpdateMenuPartFromModal__REACT_HOT_LOADER__',


    //
    // submit
    //

    value: function __onUpdateMenuPartFromModal__REACT_HOT_LOADER__(menuPart) {
      var menu = this.menu;
      menu.updatePart(menuPart);
      this.setState({
        menu: menu,
        displayEditPartModal: false
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var _this27 = this;

      event.preventDefault();

      var menu = this.menu;

      /**
       * We need to create a unique pos id if  we create a new menu
       */
      if (!this.isEditMode()) {
        menu.id = _utils.Utils.generateUID();

        /**
         * Activated by default.
         * @type {boolean}
         */
        //    menu.activated = true;
      } else {
        menu.id = this.props.menu.id;
      }

      _lodash2.default.keys(this.menu.availabilityHours).map(function (day) {
        _this27.menu.availabilityHours[day].hours = _this27.menu.availabilityHours[day].hours.filter(function (hour) {
          return !_lodash2.default.isNull(hour.opening) || !_lodash2.default.isNull(hour.closing);
        });
      });

      if (this.isValid()) {
        if (this.isEditMode()) {
          this.props.onUpdate(this.menu, this.state.image);
        } else {
          this.props.onCreate(this.menu, this.state.image);
        }
      } else {
        var validationErrors = menu.getValidationErrors();
        console.info('menu invalid', validationErrors);
        this.setState({
          validationErrors: validationErrors
        });
      }
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    //
    // image
    //

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        menu: this.props.menu.copy(),
        image: null
      });
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__(pictureData) {
      this.setState({
        image: pictureData
      });
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onImageRemove__REACT_HOT_LOADER__() {
      this.props.onImageRemove(this.menu);
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.menu_edit.name')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: this.menu.localizedNames,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.menu_edit.name'),
            onChange: this.onNameChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.name
        )
      );
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.menu_edit.description')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInputLocalized, {
            multiLine: true,
            locales: _Constants2.default.localesForTranslation,
            values: this.menu.localizedDescriptions,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.menu_edit.description'),
            onChange: this.onDescriptionChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.description
        )
      );
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 col-xs-offset-4' },
        _react2.default.createElement(_form.ImageDropzone, {
          editOnly: false,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
          className: 'menu_view__image',
          placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_MENU,
          image: this.menu.image,
          currentImage: this.state.image,
          onChange: this.onImageChange,
          onRemove: this.onImageRemove,
          aspectRatio: _ApiConstants2.default.Image.RestaurantMenu.Menu.RATIO,
          width: _ApiConstants2.default.Image.RestaurantMenu.Menu.WIDTH,
          height: _ApiConstants2.default.Image.RestaurantMenu.Menu.HEIGHT,
          maxSize: _ApiConstants2.default.Image.RestaurantMenu.Menu.MAX_SIZE
        })
      );
    }
  }, {
    key: 'renderAllergen',
    value: function renderAllergen() {
      return _react2.default.createElement(_AllergenChooser2.default, {
        readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
        allergens: this.menu.dietaryInfo ? this.menu.dietaryInfo.allergens : [],
        onChange: this.onAllergensChange
      });
    }
  }, {
    key: 'renderPrices',
    value: function renderPrices() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(_restaurantMenu.PricesEditor, {
            prices: this.menu.prices,
            onChange: this.onPricesChange,
            disablePriceModification: this.props.orderSettings.menuManagedByPos,
            currencyCode: this.props.currencyCode

          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-12' },
          this.state.validationErrors.prices
        )
      );
    }
  }, {
    key: 'renderDeleteMenu',
    value: function renderDeleteMenu() {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 text-center top-buffer-50' },
        _react2.default.createElement('hr', null),
        this.isEditMode() && // only on edit mode
        _react2.default.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-danger',
            onClick: this.onDelete
          },
          _I18n2.default.tr('menu.menu_edit.delete')
        )
      );
    }
  }, {
    key: 'renderPartsList',
    value: function renderPartsList() {
      var _this28 = this;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        !this.props.orderSettings.menuManagedByPos && _react2.default.createElement(
          'button',
          { className: 'btn btn-sm', onClick: this.onAddMenuPartClicked },
          _I18n2.default.tr('menu.menu_edit.add_part')
        ),
        this.menu.parts.map(function (part, index) {
          return _react2.default.createElement(_MenuPartView2.default, {
            key: part.id + '_' + index,
            menuPart: part,
            menu: _this28.menu,
            restaurantMenu: _this28.restaurantMenu,
            menuManagedByPos: _this28.props.orderSettings.menuManagedByPos,
            onDelete: _this28.onDeleteMenuPart,
            onUpdate: _this28.onUpdateMenuPart,
            onEditClicked: _this28.onEditMenuPartClicked,
            onUp: _this28.onUpMenuPart,
            onDown: _this28.onDownMenuPart,
            currencyCode: _this28.props.currencyCode
          });
        })
      );
    }
  }, {
    key: 'renderCategoriesList',
    value: function renderCategoriesList() {
      var categories = this.restaurantMenu.getCategoriesWithMenuId(this.menu.id);

      if (_lodash2.default.isEmpty(categories)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.menu_edit.no_category_with_menu')
          )
        );
      }

      var categoriesListView = [];

      _lodash2.default.each(categories, function (category) {
        categoriesListView.push(_react2.default.createElement(_CategoryRow2.default, { key: category.id, category: category }));
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          categoriesListView
        )
      );
    }
  }, {
    key: 'renderAddMenuPartModal',
    value: function renderAddMenuPartModal() {
      if (!this.state.displayAddPartModal) {
        return null;
      }

      return _react2.default.createElement(_MenuPartFormModal2.default, {
        show: true,
        isEditMode: false,
        menuManagedByPos: this.props.orderSettings.menuManagedByPos,
        onHide: this.onHideAddMenuPartModal,
        onUpdate: this.onAddMenuPart
      });
    }
  }, {
    key: 'renderEditMenuPartModal',
    value: function renderEditMenuPartModal() {
      if (!this.state.displayEditPartModal || _lodash2.default.isNull(this.state.menuPartToEditOnModal)) {
        return null;
      }

      return _react2.default.createElement(_MenuPartFormModal2.default, {
        show: true,
        onHide: this.onHideEditMenuPartModal,
        isEditMode: true,
        menuPart: this.state.menuPartToEditOnModal,
        menuManagedByPos: this.props.orderSettings.menuManagedByPos,
        restaurantMenu: this.props.restaurantMenu,
        onUpdate: this.onUpdateMenuPartFromModal,
        onDelete: this.onDeleteMenuPart
      });
    }
  }, {
    key: 'renderAvailibility',
    value: function renderAvailibility() {
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement('hr', { className: 'col-xs-12' }),
        _react2.default.createElement(
          'div',
          { className: 'availability_title' },
          _react2.default.createElement(
            'h2',
            { className: 'col-xs-12' },
            _I18n2.default.tr('menu.menu_edit.menu_availability')
          ),
          _react2.default.createElement(
            'p',
            { className: 'col-xs-12 availability_intro' },
            _I18n2.default.tr('menu.menu_edit.menu_availability.caption')
          )
        ),
        this.renderAvailibilityDate(),
        this.renderAvailibilityHours()
      );
    }
  }, {
    key: 'renderAvailibilityDate',
    value: function renderAvailibilityDate() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'availability_title' },
          _react2.default.createElement(
            'h4',
            { className: 'col-xs-8' },
            _I18n2.default.tr('menu.menu_edit.menu_availability_date')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-2 top-buffer-10' },
            _react2.default.createElement(_reactBootstrapSwitch2.default, {
              value: !_lodash2.default.isNull(this.menu.availabilityDates),
              bsSize: 'mini',
              onChange: this.onToggleAvailibilityDatesChange,
              disabled: disableModification
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'col-xs-12 availability_intro caption' },
          _I18n2.default.tr('menu.menu_edit.menu_availability_date.caption')
        ),
        !_lodash2.default.isNull(this.menu.availabilityDates) && _react2.default.createElement(_AvailabilityDatesForm2.default, {
          availabilityDates: this.menu.availabilityDates,
          onAvailibilityDatesChange: this.onAvailibilityDatesChange,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
        })
      );
    }
  }, {
    key: 'renderAvailibilityHours',
    value: function renderAvailibilityHours() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'availability_title' },
          _react2.default.createElement(
            'h4',
            { className: 'col-xs-8' },
            _I18n2.default.tr('menu.menu_edit.menu_availability_hours')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-2 top-buffer-10' },
            _react2.default.createElement(_reactBootstrapSwitch2.default, {
              value: !_lodash2.default.isNull(this.menu.availabilityHours),
              bsSize: 'mini',
              onChange: this.onToggleAvailibilityHoursChange,
              disabled: disableModification
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'col-xs-12 availability_intro caption' },
          _I18n2.default.tr('menu.menu_edit.menu_availability_hours.caption')
        ),
        !_lodash2.default.isNull(this.menu.availabilityHours) && _react2.default.createElement(_AvailabilityHoursForm2.default, {
          availabilityHours: this.menu.availabilityHours,
          onAvailibilityHoursChange: this.onAvailibilityHoursChange,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'form',
          {
            className: 'form form-horizontal menu_edit_view',
            role: 'form',
            noValidate: true
          },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            this.renderName(),
            this.renderDescription(),
            this.renderImage()
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-40 col-sm-12' },
                _react2.default.createElement(
                  'h2',
                  null,
                  _I18n2.default.tr('menu.product.edit.allergen')
                ),
                this.renderAllergen()
              )
            )
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-sm-12' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.menu_edit.prices')
              ),
              this.renderPrices()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            this.renderAvailibility()
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-40 col-sm-12' },
            _react2.default.createElement(
              'h2',
              null,
              _I18n2.default.tr('menu.menu_edit.parts')
            ),
            this.renderPartsList()
          ),
          !this.props.orderSettings.menuManagedByPos && this.renderDeleteMenu(),
          this.renderFixedButtons(),
          this.renderAddMenuPartModal(),
          this.renderEditMenuPartModal()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.state.menu;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }]);

  return MenuEditView;
}(_AbstractRestaurantMenuForm2.default);

MenuEditView.propTypes = {
  menu: _propTypes2.default.objectOf(_menu.Menu).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  /**
   * @param: Menu
   * @param: image blob
   */
  onUpdate: _propTypes2.default.func.isRequired,

  /**
   * @param: Menu
   * @param: image blob
   */
  onCreate: _propTypes2.default.func.isRequired,

  onImageRemove: _propTypes2.default.func,

  /**
   * @param: Menu
   */
  onDelete: _propTypes2.default.func.isRequired,

  isEditMode: _propTypes2.default.bool.isRequired,

  currencyCode: _propTypes2.default.string
};
exports.default = MenuEditView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuEditView, 'MenuEditView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/MenuEditView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/components/CategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var CategoryRow = function (_Component) {
  _inherits(CategoryRow, _Component);

  function CategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryRow.__proto__ || Object.getPrototypeOf(CategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.category);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'h4',
          { className: 'link-hover',
            onClick: this.onDisplayDetailClick
          },
          this.category.name
        ),
        _react2.default.createElement('i', {
          onClick: function onClick() {
            _this3.props.onDelete(_this3.props.category);
          },
          className: 'fa fa-trash pointer'
        })
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }]);

  return CategoryRow;
}(_react.Component);

CategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired,

  onDelete: _propTypes2.default.func.isRequired
};
exports.default = CategoryRow;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryRow, 'CategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/CategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/components/MenuPartProductView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var MenuPartProductView = function (_Component) {
  _inherits(MenuPartProductView, _Component);

  function MenuPartProductView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartProductView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartProductView.__proto__ || Object.getPrototypeOf(MenuPartProductView)).call.apply(_ref, [this].concat(args))), _this), _this.onAdditionalPriceClicked = function () {
      var _this2;

      return (_this2 = _this).__onAdditionalPriceClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartProductView, [{
    key: '__onAdditionalPriceClicked__REACT_HOT_LOADER__',
    value: function __onAdditionalPriceClicked__REACT_HOT_LOADER__() {
      return this.__onAdditionalPriceClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAdditionalPriceClicked__REACT_HOT_LOADER__',
    value: function __onAdditionalPriceClicked__REACT_HOT_LOADER__() {
      var _this3 = this;

      if (this.props.menuManagedByPos) {
        return;
      }

      var menuPartProduct = this.menuPartProduct;
      _Notify2.default.promptWithValue(_I18n2.default.tr('menu.menu_edit.part.edit_addtionnal_price'), menuPartProduct.additionalPrice, function (value) {
        var floatValue = parseFloat(value);
        if (value && !_lodash2.default.isNaN(floatValue)) {
          menuPartProduct.additionalPrice = floatValue;
          _this3.props.onUpdate(menuPartProduct);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'menu_part_product_view row' },
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-7'
          },
          this.product.name
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-2 pointer',
            onClick: this.onAdditionalPriceClicked
          },
          this.menuPartProduct.additionalPrice === 0 && _react2.default.createElement(
            'span',
            null,
            '-'
          ),
          this.menuPartProduct.additionalPrice !== 0 && _react2.default.createElement(
            'span',
            null,
            '+',
            _utils.CurrencyUtils.formatPriceWithCurrency(this.menuPartProduct.additionalPrice, this.currencyCode)
          )
        ),
        !this.props.menuManagedByPos && _react2.default.createElement(
          'div',
          {
            className: 'text-center pointer col-xs-1',
            onClick: function onClick() {
              _this4.props.onDelete(_this4.menuPartProduct);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        !this.props.menuManagedByPos && _react2.default.createElement(
          'div',
          {
            className: 'col-xs-1 text-center pointer',
            onClick: this.onAdditionalPriceClicked
          },
          _react2.default.createElement('i', { className: 'fa fa-edit' })
        ),
        !this.props.menuManagedByPos && _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'menuPartProduct',
    get: function get() {
      return this.props.menuPartProduct;
    }
  }]);

  return MenuPartProductView;
}(_react.Component);

MenuPartProductView.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  menuManagedByPos: _propTypes2.default.bool,

  menuPartProduct: _propTypes2.default.objectOf(_MenuPartProduct2.default).isRequired,

  onDelete: _propTypes2.default.func.isRequired,

  onUpdate: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string
};
var _default = MenuPartProductView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartProductView, 'MenuPartProductView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/MenuPartProductView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/MenuPartProductView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/components/MenuPartView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _MenuPartProductView = __webpack_require__("./scripts/pages/menu/menuEdit/components/MenuPartProductView.js");

var _MenuPartProductView2 = _interopRequireDefault(_MenuPartProductView);

var _chooseProductsModal = __webpack_require__("./scripts/components/restaurantMenu/chooseProductsModal/index.js");

var _chooseProductsModal2 = _interopRequireDefault(_chooseProductsModal);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


// -- views


var MenuPartView = function (_Component) {
  _inherits(MenuPartView, _Component);

  function MenuPartView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartView.__proto__ || Object.getPrototypeOf(MenuPartView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayChooseProductsModal: false
    }, _this.onDelete = function () {
      var _this2;

      return (_this2 = _this).__onDelete__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onItemsOrderChange = function () {
      var _this3;

      return (_this3 = _this).__onItemsOrderChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onAddProductClicked = function () {
      var _this4;

      return (_this4 = _this).__onAddProductClicked__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onEditPartCategoriesClicked = function () {
      var _this5;

      return (_this5 = _this).__onEditPartCategoriesClicked__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onChooseProductsOnProductModal = function () {
      var _this6;

      return (_this6 = _this).__onChooseProductsOnProductModal__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onHideChooseProductsModal = function () {
      var _this7;

      return (_this7 = _this).__onHideChooseProductsModal__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onDeleteMenuPartProduct = function () {
      var _this8;

      return (_this8 = _this).__onDeleteMenuPartProduct__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onUpdateMenuPartProduct = function () {
      var _this9;

      return (_this9 = _this).__onUpdateMenuPartProduct__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.renderRow = function () {
      var _this10;

      return (_this10 = _this).__renderRow__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartView, [{
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__() {
      return this.__renderRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateMenuPartProduct__REACT_HOT_LOADER__',
    value: function __onUpdateMenuPartProduct__REACT_HOT_LOADER__() {
      return this.__onUpdateMenuPartProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteMenuPartProduct__REACT_HOT_LOADER__',
    value: function __onDeleteMenuPartProduct__REACT_HOT_LOADER__() {
      return this.__onDeleteMenuPartProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideChooseProductsModal__REACT_HOT_LOADER__',
    value: function __onHideChooseProductsModal__REACT_HOT_LOADER__() {
      return this.__onHideChooseProductsModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChooseProductsOnProductModal__REACT_HOT_LOADER__',
    value: function __onChooseProductsOnProductModal__REACT_HOT_LOADER__() {
      return this.__onChooseProductsOnProductModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEditPartCategoriesClicked__REACT_HOT_LOADER__',
    value: function __onEditPartCategoriesClicked__REACT_HOT_LOADER__() {
      return this.__onEditPartCategoriesClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddProductClicked__REACT_HOT_LOADER__',
    value: function __onAddProductClicked__REACT_HOT_LOADER__() {
      return this.__onAddProductClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onItemsOrderChange__REACT_HOT_LOADER__',
    value: function __onItemsOrderChange__REACT_HOT_LOADER__() {
      return this.__onItemsOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__() {
      return this.__onDelete__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDelete__REACT_HOT_LOADER__',
    value: function __onDelete__REACT_HOT_LOADER__(event) {
      var _this11 = this;

      event.preventDefault();
      _Notify2.default.confirmDelete(_I18n2.default.tr('menu.menu_edit.part.confirm_deletion'), function (result) {
        if (result) {
          _this11.props.onDelete(_this11.menuPart);
        }
      });
    }
  }, {
    key: '__onItemsOrderChange__REACT_HOT_LOADER__',
    value: function __onItemsOrderChange__REACT_HOT_LOADER__(items) {
      var menuPart = this.menuPart;
      menuPart.products = items;
      this.props.onUpdate(menuPart);
    }
  }, {
    key: '__onAddProductClicked__REACT_HOT_LOADER__',
    value: function __onAddProductClicked__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      this.setState({
        displayChooseProductsModal: true
      });
    }
  }, {
    key: '__onEditPartCategoriesClicked__REACT_HOT_LOADER__',
    value: function __onEditPartCategoriesClicked__REACT_HOT_LOADER__() {
      _actions.RouteAction.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU_PART_EDIT, {
        menuId: this.props.menu.id,
        menuPartId: this.menuPart.id
      });
    }
  }, {
    key: '__onChooseProductsOnProductModal__REACT_HOT_LOADER__',
    value: function __onChooseProductsOnProductModal__REACT_HOT_LOADER__(products) {
      var menuPart = this.menuPart;

      menuPart.addProducts(products);

      this.setState({
        displayChooseProductsModal: false
      });

      this.props.onUpdate(menuPart);
    }
  }, {
    key: '__onHideChooseProductsModal__REACT_HOT_LOADER__',
    value: function __onHideChooseProductsModal__REACT_HOT_LOADER__() {
      this.setState({
        displayChooseProductsModal: false
      });
    }
  }, {
    key: '__onDeleteMenuPartProduct__REACT_HOT_LOADER__',
    value: function __onDeleteMenuPartProduct__REACT_HOT_LOADER__(menuPartProductToDelete) {
      var menuPart = this.menuPart;
      menuPart.deleteProduct(menuPartProductToDelete);
      this.props.onUpdate(menuPart);
    }
  }, {
    key: '__onUpdateMenuPartProduct__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onUpdateMenuPartProduct__REACT_HOT_LOADER__(menuPartProductToUpdate) {
      var menuPart = this.menuPart;
      menuPart.updateProduct(menuPartProductToUpdate);
      this.props.onUpdate(menuPart);
    }
  }, {
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__(menuPartProduct) {
      var product = this.restaurantMenu.getProductWithId(menuPartProduct.id);

      if (_lodash2.default.isNil(product)) {
        _utils.Logger.warning('MenuPartView', 'product ' + menuPartProduct.id + ' does not exists for menu part ' + this.menuPart.id);
        return null;
      }

      return _react2.default.createElement(_MenuPartProductView2.default, {
        key: product.id,
        product: product,
        menuManagedByPos: this.props.menuManagedByPos,
        menuPartProduct: menuPartProduct,
        onDelete: this.onDeleteMenuPartProduct,
        onUpdate: this.onUpdateMenuPartProduct,
        currencyCode: this.props.currencyCode
      });
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      if (_lodash2.default.isEmpty(this.menuPart.products)) {
        return _react2.default.createElement(
          'div',
          { className: 'simple_error_block col-xs-12 top-buffer-50' },
          _I18n2.default.tr('menu.menu_edit.part.one_product_required')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-20 table_container table_container_hover row' },
        _react2.default.createElement(_SortableList2.default, {
          items: this.menuPart.products,
          renderer: this.renderRow,
          onChange: this.onItemsOrderChange
        })
      );
    }
  }, {
    key: 'renderChooseProductsModal',
    value: function renderChooseProductsModal() {
      var _this12 = this;

      if (!this.state.displayChooseProductsModal) {
        return null;
      }

      var selectedProducts = this.menuPart.products.map(function (menuPartProduct) {
        return _this12.restaurantMenu.getProductWithId(menuPartProduct.id);
      });

      return _react2.default.createElement(_chooseProductsModal2.default, {
        show: true,
        onHide: this.onHideChooseProductsModal,
        onChooseProducts: this.onChooseProductsOnProductModal,
        restaurantMenu: this.props.restaurantMenu,
        selectedProducts: selectedProducts
      });
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'menu_part_view__name' },
        this.menuPart.name
      );
    }
  }, {
    key: 'renderArrows',
    value: function renderArrows() {
      var _this13 = this;

      if (this.props.menuManagedByPos) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'menu_part_view__arrows' },
        _react2.default.createElement(
          'div',
          {
            className: 'menu_part_view__arrow_up',
            onClick: function onClick() {
              _this13.props.onUp(_this13.menuPart);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-arrow-up' })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'menu_part_view__arrow_down',
            onClick: function onClick() {
              _this13.props.onDown(_this13.menuPart);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-arrow-down' })
        )
      );
    }
  }, {
    key: 'renderMinMax',
    value: function renderMinMax() {
      return _react2.default.createElement(
        'div',
        { className: 'menu_part_view__min_max' },
        _I18n2.default.tr('menu.min_with_colon'),
        ' ',
        this.menuPart.min,
        ' |',
        ' ',
        _I18n2.default.tr('menu.max_with_colon'),
        ' ',
        this.menuPart.max
      );
    }
  }, {
    key: 'renderAdditionalPrice',
    value: function renderAdditionalPrice() {
      var additionalPrice = this.menuPart.additionalPrice;
      return _react2.default.createElement(
        'div',
        { className: 'menu_part_view__additional_price' },
        additionalPrice > 0 && _react2.default.createElement(
          'span',
          null,
          '(+',
          _utils.CurrencyUtils.formatPriceWithCurrency(additionalPrice, this.currencyCode),
          ')'
        )
      );
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _this14 = this;

      return _react2.default.createElement(
        'div',
        { className: 'menu_part_view__buttons' },
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn btn-default btn-xs',
            onClick: function onClick(event) {
              event.preventDefault();
              _this14.onEditPartCategoriesClicked();
            }
          },
          _I18n2.default.tr('menu.menu_edit.part.edit_part_categories')
        ),
        '\xA0\xA0',
        !this.props.menuManagedByPos && _react2.default.createElement(
          'button',
          { className: 'btn btn btn-default btn-xs', onClick: this.onAddProductClicked },
          _I18n2.default.tr('menu.menu_edit.part.modify_products')
        ),
        '\xA0\xA0',
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn btn-default btn-xs',
            onClick: function onClick(event) {
              event.preventDefault();
              _this14.props.onEditClicked(_this14.menuPart);
            }
          },
          _I18n2.default.tr('menu.menu_edit.part.edit')
        ),
        '\xA0\xA0',
        !this.props.menuManagedByPos && _react2.default.createElement(
          'button',
          { className: 'btn btn-danger btn-xs', onClick: this.onDelete },
          _I18n2.default.tr('menu.menu_edit.part.delete')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'menu_part_view col-xs-12 top-buffer-50' },
          this.renderName(),
          this.renderArrows(),
          _react2.default.createElement('div', { className: 'clear' }),
          this.renderMinMax(),
          this.renderAdditionalPrice(),
          this.renderButtons(),
          this.renderProducts(),
          this.renderChooseProductsModal()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'menuPart',
    get: function get() {
      return this.props.menuPart;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }]);

  return MenuPartView;
}(_react.Component);

MenuPartView.propTypes = {
  menu: _propTypes2.default.object.isRequired,

  menuPart: _propTypes2.default.objectOf(_menu.MenuPart).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  menuManagedByPos: _propTypes2.default.bool,

  currencyCode: _propTypes2.default.string,

  /**
   * @param menuPart:MenuPart
   */
  onDelete: _propTypes2.default.func.isRequired,

  /**
   * @param menuPart:MenuPart
   */
  onUpdate: _propTypes2.default.func.isRequired,

  /**
   * @param menuPart:MenuPart
   */
  onUp: _propTypes2.default.func.isRequired,

  /**
   * @param menuPart:MenuPart
   */
  onDown: _propTypes2.default.func.isRequired,

  /**
   * no params
   */
  onEditClicked: _propTypes2.default.func.isRequired
};
var _default = MenuPartView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartView, 'MenuPartView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/MenuPartView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/MenuPartView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 */
var MenuPartForm = function (_AbstractFormComponen) {
  _inherits(MenuPartForm, _AbstractFormComponen);

  function MenuPartForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartForm.__proto__ || Object.getPrototypeOf(MenuPartForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(), _this.onSubmit = function () {
      var _this2;

      return (_this2 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMenuPartChange = function () {
      var _this3;

      return (_this3 = _this).__onMenuPartChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onNameChange = function () {
      var _this4;

      return (_this4 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onMinChange = function () {
      var _this5;

      return (_this5 = _this).__onMinChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onMaxChange = function () {
      var _this6;

      return (_this6 = _this).__onMaxChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onAdditionalPriceChange = function () {
      var _this7;

      return (_this7 = _this).__onAdditionalPriceChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartForm, [{
    key: '__onAdditionalPriceChange__REACT_HOT_LOADER__',
    value: function __onAdditionalPriceChange__REACT_HOT_LOADER__() {
      return this.__onAdditionalPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMaxChange__REACT_HOT_LOADER__',
    value: function __onMaxChange__REACT_HOT_LOADER__() {
      return this.__onMaxChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMinChange__REACT_HOT_LOADER__',
    value: function __onMinChange__REACT_HOT_LOADER__() {
      return this.__onMinChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuPartChange__REACT_HOT_LOADER__',
    value: function __onMenuPartChange__REACT_HOT_LOADER__() {
      return this.__onMenuPartChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var menuPart = this.state.menuPart;

      if (!menuPart.isValidToCreate()) {
        this.setState({
          validationErrors: menuPart.getValidationErrors()
        });
      } else {
        if (!this.props.isEditMode) {
          menuPart.id = _utils.Utils.generateUID();
        }
        this.props.onUpdate(menuPart);
      }
    }
  }, {
    key: '__onMenuPartChange__REACT_HOT_LOADER__',


    //
    // AbstractFormComponent
    //

    value: function __onMenuPartChange__REACT_HOT_LOADER__(menuPart) {
      this.setState({
        menuPart: menuPart,
        validationErrors: menuPart.getValidationErrors()
      });
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.props.menuPart.equals(this.state.menuPart);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      return {
        menuPart: this.props.menuPart.copy(),

        validationErrors: {}
      };
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return !this.state.menuPart.isValidToCreate();
    }

    //
    // Form events
    //

  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var menuPart = this.menuPart;
      menuPart.localizedNames = newValue;
      this.onMenuPartChange(menuPart);
    }
  }, {
    key: '__onMinChange__REACT_HOT_LOADER__',
    value: function __onMinChange__REACT_HOT_LOADER__(min) {
      var menuPart = this.menuPart;
      menuPart.min = min;
      this.onMenuPartChange(menuPart);
    }
  }, {
    key: '__onMaxChange__REACT_HOT_LOADER__',
    value: function __onMaxChange__REACT_HOT_LOADER__(max) {
      var menuPart = this.menuPart;
      menuPart.max = max;
      this.onMenuPartChange(menuPart);
    }
  }, {
    key: '__onAdditionalPriceChange__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onAdditionalPriceChange__REACT_HOT_LOADER__(additionalPrice) {
      var menuPart = this.menuPart;
      menuPart.additionalPrice = additionalPrice;
      this.onMenuPartChange(menuPart);
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.menu_edit.part.form.name')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: this.menuPart.localizedNames,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.menu_edit.name'),
            onChange: this.onNameChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.name
        )
      );
    }
  }, {
    key: 'renderMinMax',
    value: function renderMinMax() {
      if (this.props.menuManagedByPos) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.menu_edit.part.form.quantities')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.menuPart.min,
              onChange: this.onMinChange,
              max: this.menuPart.max,
              min: 0
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _I18n2.default.tr('menu.menu_edit.part.form.min')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.menuPart.max,
              onChange: this.onMaxChange,
              min: this.menuPart.min,
              max: 99
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _I18n2.default.tr('menu.menu_edit.part.form.max')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.min,
          this.state.validationErrors.max
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        {
          className: 'form form-horizontal menu_part_form',
          role: 'form',
          noValidate: true
        },
        this.renderName(),
        this.renderMinMax(),
        this.renderButtons()
      );
    }
  }, {
    key: 'menuPart',
    get: function get() {
      return this.state.menuPart;
    }
  }]);

  return MenuPartForm;
}(_AbstractFormComponent2.default);

MenuPartForm.defaultProps = {
  menuPart: new _menu.MenuPart()
};
MenuPartForm.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  isEditMode: _propTypes2.default.bool.isRequired,

  menuManagedByPos: _propTypes2.default.bool,

  menuPart: _propTypes2.default.objectOf(_menu.MenuPart),

  /**
   * @param MenuPart
   */
  onUpdate: _propTypes2.default.func.isRequired,

  /**
   * @param MenuPart
   */
  onDelete: _propTypes2.default.func
};
exports.default = MenuPartForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartForm, 'MenuPartForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartFormModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _MenuPartForm = __webpack_require__("./scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartForm.js");

var _MenuPartForm2 = _interopRequireDefault(_MenuPartForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 */
var MenuPartFormModal = function (_Component) {
  _inherits(MenuPartFormModal, _Component);

  function MenuPartFormModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartFormModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartFormModal.__proto__ || Object.getPrototypeOf(MenuPartFormModal)).call.apply(_ref, [this].concat(args))), _this), _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartFormModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'menu_part_form' },
          _react2.default.createElement(_MenuPartForm2.default, {
            restaurantMenu: this.props.restaurantMenu,
            isEditMode: this.props.isEditMode,
            menuManagedByPos: this.props.menuManagedByPos,
            menuPart: this.props.menuPart,
            onUpdate: this.props.onUpdate,
            onDelete: this.props.onDelete
          })
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      if (this.props.isEditMode) {
        return _react2.default.createElement(
          'span',
          null,
          _I18n2.default.tr('menu.menu_edit.part.title_edit')
        );
      }

      return _react2.default.createElement(
        'span',
        null,
        _I18n2.default.tr('menu.menu_edit.part.title_create')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            this.renderTitle()
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return MenuPartFormModal;
}(_react.Component);

MenuPartFormModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  isEditMode: _propTypes2.default.bool.isRequired,

  menuManagedByPos: _propTypes2.default.bool,

  menuPart: _propTypes2.default.objectOf(_menu.MenuPart),

  /**
   * @param MenuPart
   */
  onUpdate: _propTypes2.default.func.isRequired,

  /**
   * @param MenuPart
   */
  onDelete: _propTypes2.default.func
};
exports.default = MenuPartFormModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartFormModal, 'MenuPartFormModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartFormModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/MenuPartEditPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__("./scripts/pages/menu/menuPartEdit/style.scss");

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _MenuPartEditView = __webpack_require__("./scripts/pages/menu/menuPartEdit/MenuPartEditView.js");

var _MenuPartEditView2 = _interopRequireDefault(_MenuPartEditView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var Errors = {
  MENU_NOT_FOUND: 'menu_not_found'
};

var MenuPartEditPage = function (_AbstractComponent) {
  _inherits(MenuPartEditPage, _AbstractComponent);

  function MenuPartEditPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartEditPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartEditPage.__proto__ || Object.getPrototypeOf(MenuPartEditPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu(),
      menu: null,
      menuPart: _this.isEditMode() ? null : new _menu.MenuPart(),
      apiError: null,
      // A view error, will contain an `Errors`
      error: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleRestaurantMenuChange = function () {
      var _this3;

      return (_this3 = _this).__handleRestaurantMenuChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onMenuUpdated = function () {
      var _this4;

      return (_this4 = _this).__onMenuUpdated__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onError = function () {
      var _this5;

      return (_this5 = _this).__onError__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.handleAddCategory = function () {
      var _this6;

      return (_this6 = _this).__handleAddCategory__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.handleDeleteCategory = function () {
      var _this7;

      return (_this7 = _this).__handleDeleteCategory__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.handleUploadPartCategoryImage = function () {
      var _this8;

      return (_this8 = _this).__handleUploadPartCategoryImage__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.handleRemovePartCategoryImage = function () {
      var _this9;

      return (_this9 = _this).__handleRemovePartCategoryImage__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartEditPage, [{
    key: '__handleRemovePartCategoryImage__REACT_HOT_LOADER__',
    value: function __handleRemovePartCategoryImage__REACT_HOT_LOADER__() {
      return this.__handleRemovePartCategoryImage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleUploadPartCategoryImage__REACT_HOT_LOADER__',
    value: function __handleUploadPartCategoryImage__REACT_HOT_LOADER__() {
      return this.__handleUploadPartCategoryImage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDeleteCategory__REACT_HOT_LOADER__',
    value: function __handleDeleteCategory__REACT_HOT_LOADER__() {
      return this.__handleDeleteCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleAddCategory__REACT_HOT_LOADER__',
    value: function __handleAddCategory__REACT_HOT_LOADER__() {
      return this.__handleAddCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      return this.__onMenuUpdated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRestaurantMenuChange__REACT_HOT_LOADER__',
    value: function __handleRestaurantMenuChange__REACT_HOT_LOADER__() {
      return this.__handleRestaurantMenuChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

      if (!_SecurityContext2.default.restaurantMenu.canEdit) {
        // TODO: redirect
      }

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        _actions.RestaurantMenuAction.loadRestaurantMenu();
      } else if (this.isEditMode()) {
        this.loadMenu();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'loadMenu',
    value: function loadMenu() {
      var menu = this.getMenuOnRestaurantMenu(this.state.restaurantMenu);

      if (_lodash2.default.isNull(menu)) {
        // TODO: redirect to 404.
        this.setState({
          error: Errors.MENU_NOT_FOUND,
          loading: false
        });
      } else {
        var menuPart = menu.getPartWithId(this.partId);

        this.setState({
          menu: menu,
          menuPart: menuPart,
          loading: false,
          error: null
        });
      }
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();

      if (this.isEditMode()) {
        var menu = this.getMenuOnRestaurantMenu(restaurantMenu);
        if (_lodash2.default.isNull(menu)) {
          // TODO: redirect to 404.
          this.setState({
            error: Errors.MENU_NOT_FOUND,
            loading: false
          });
        } else {
          var menuPart = menu.getPartWithId(this.partId);

          this.setState({
            restaurantMenu: restaurantMenu,
            menu: menu,
            menuPart: menuPart,
            loading: false,
            error: null
          });
        }
      }
    }
  }, {
    key: '__handleRestaurantMenuChange__REACT_HOT_LOADER__',
    value: function __handleRestaurantMenuChange__REACT_HOT_LOADER__(restaurantMenu) {
      this.setState({
        restaurantMenu: restaurantMenu
      });
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      if (this.isEditMode()) {
        var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
        var menu = this.getMenuOnRestaurantMenu(restaurantMenu);
        var menuPart = menu.getPartWithId(this.partId);

        this.setState({
          restaurantMenu: restaurantMenu,
          menu: menu,
          menuPart: menuPart,
          loading: false
        });
      }
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.hideLoading();
      this.setState({
        apiError: _stores.RestaurantMenuStore.getApiError()
      });
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return !_lodash2.default.isUndefined(this.props.params.menuPartId);
    }
  }, {
    key: 'getMenuOnRestaurantMenu',
    value: function getMenuOnRestaurantMenu(restaurantMenu) {
      var menuId = this.props.params.menuId;
      var menu = restaurantMenu.getMenuWithId(menuId);

      return menu;
    }

    // we update the whole menuPart

  }, {
    key: '__handleAddCategory__REACT_HOT_LOADER__',
    value: function __handleAddCategory__REACT_HOT_LOADER__(menuPart, category) {
      var menu = this.state.menu;
      this.showLoading();
      _actions.RestaurantMenuAction.updateMenuPart(menu, menuPart);
    }
  }, {
    key: '__handleDeleteCategory__REACT_HOT_LOADER__',
    value: function __handleDeleteCategory__REACT_HOT_LOADER__(menuPart, category) {
      var menu = this.state.menu;
      this.showLoading();
      _actions.RestaurantMenuAction.deleteMenuPartCategory(menu, menuPart, category);
    }
  }, {
    key: '__handleUploadPartCategoryImage__REACT_HOT_LOADER__',
    value: function __handleUploadPartCategoryImage__REACT_HOT_LOADER__(category, image) {
      this.showLoading();
      _actions.RestaurantMenuAction.uploadMenuPartCategoryImage(this.menu, this.menuPart, category, image);
    }
  }, {
    key: '__handleRemovePartCategoryImage__REACT_HOT_LOADER__',


    // -- renderers

    value: function __handleRemovePartCategoryImage__REACT_HOT_LOADER__(category) {
      this.showLoading();
      _actions.RestaurantMenuAction.removeMenuPartCategoryImage(this.menu, this.menuPart, category);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.menu) || _lodash2.default.isNull(this.restaurantMenu)) {
        return this.renderLoading(true);
      } else if (!_lodash2.default.isNull(this.menu) && _lodash2.default.isNull(this.menuPart)) {
        return _react2.default.createElement(
          'h1',
          null,
          'Not found'
        );
      }

      if (!_lodash2.default.isNull(this.state.error)) {
        return _react2.default.createElement(
          'div',
          null,
          this.state.error
        );
      }

      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.menus'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.MENUS
        }
      }];

      if (this.isEditMode()) {
        arianeDetails.push({
          name: this.menu.name,
          link: _RoutingEnum2.default.RESTAURANT_MENU_MENU_DETAIL,
          params: {
            menuId: this.menu.id
          }
        });

        arianeDetails.push({
          name: this.menuPart.name,
          link: null
        });
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.edition'),
          link: null
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        _react2.default.createElement(_MenuPartEditView2.default, {
          menuPart: this.menuPart,
          menu: this.menu,
          restaurantMenu: this.restaurantMenu,
          onUpdate: this.onUpdateMenu,
          isEditMode: this.isEditMode(),
          orderSettings: _stores.OrderSettingsStore.getOrderSettings(),
          onRestaurantMenuChange: this.handleRestaurantMenuChange,
          onAddCategory: this.handleAddCategory,
          onDeleteCategory: this.handleDeleteCategory,
          onRemovePartCategoryImage: this.handleRemovePartCategoryImage,
          onUploadPartCategoryImage: this.handleUploadPartCategoryImage
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'menu_part_detail_page' },
          this.renderBody(),
          this.renderLoading()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS, this.onMenuUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR, this.onError)];
    }
  }, {
    key: 'partId',
    get: function get() {
      return this.props.params.menuPartId;
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.state.menu;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }, {
    key: 'menuPart',
    get: function get() {
      return this.state.menuPart;
    }
  }]);

  return MenuPartEditPage;
}(_AbstractComponent3.default);

exports.default = MenuPartEditPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Errors, 'Errors', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/MenuPartEditPage.js');

  __REACT_HOT_LOADER__.register(MenuPartEditPage, 'MenuPartEditPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/MenuPartEditPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/MenuPartEditView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _MenuPartMainCategoryView = __webpack_require__("./scripts/pages/menu/menuPartEdit/components/MenuPartMainCategoryView.js");

var _MenuPartMainCategoryView2 = _interopRequireDefault(_MenuPartMainCategoryView);

var _SelectItemsModal = __webpack_require__("./scripts/pages/menu/menuPartEdit/SelectItemsModal/SelectItemsModal.js");

var _SelectItemsModal2 = _interopRequireDefault(_SelectItemsModal);

var _ModifyCategoryModal = __webpack_require__("./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/ModifyCategoryModal.js");

var _ModifyCategoryModal2 = _interopRequireDefault(_ModifyCategoryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var MenuPartEditView = function (_React$Component) {
  _inherits(MenuPartEditView, _React$Component);

  function MenuPartEditView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartEditView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartEditView.__proto__ || Object.getPrototypeOf(MenuPartEditView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addModal: {
        show: false,
        forCategory: null
      },
      modifyCategoryModal: {
        show: false,
        forCategory: null
      }
    }, _this.handleRunAdd = function () {
      var _this2;

      return (_this2 = _this).__handleRunAdd__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleHideAdd = function () {
      var _this3;

      return (_this3 = _this).__handleHideAdd__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.handleAddItems = function () {
      var _this4;

      return (_this4 = _this).__handleAddItems__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.handleNewCategory = function () {
      var _this5;

      return (_this5 = _this).__handleNewCategory__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.handleModifyCategory = function () {
      var _this6;

      return (_this6 = _this).__handleModifyCategory__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.handleHideModifyCategory = function () {
      var _this7;

      return (_this7 = _this).__handleHideModifyCategory__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(MenuPartEditView, [{
    key: '__handleHideModifyCategory__REACT_HOT_LOADER__',
    value: function __handleHideModifyCategory__REACT_HOT_LOADER__() {
      return this.__handleHideModifyCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModifyCategory__REACT_HOT_LOADER__',
    value: function __handleModifyCategory__REACT_HOT_LOADER__() {
      return this.__handleModifyCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleNewCategory__REACT_HOT_LOADER__',
    value: function __handleNewCategory__REACT_HOT_LOADER__() {
      return this.__handleNewCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleAddItems__REACT_HOT_LOADER__',
    value: function __handleAddItems__REACT_HOT_LOADER__() {
      return this.__handleAddItems__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleHideAdd__REACT_HOT_LOADER__',
    value: function __handleHideAdd__REACT_HOT_LOADER__() {
      return this.__handleHideAdd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRunAdd__REACT_HOT_LOADER__',
    value: function __handleRunAdd__REACT_HOT_LOADER__() {
      return this.__handleRunAdd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRunAdd__REACT_HOT_LOADER__',
    value: function __handleRunAdd__REACT_HOT_LOADER__(forCategory) {
      this.setState({
        addModal: {
          show: true,
          forCategory: forCategory
        }
      });
    }
  }, {
    key: '__handleHideAdd__REACT_HOT_LOADER__',
    value: function __handleHideAdd__REACT_HOT_LOADER__() {
      this.setState({
        addModal: {
          show: false,
          forCategory: null
        }
      });
    }
  }, {
    key: '__handleAddItems__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __handleAddItems__REACT_HOT_LOADER__(forCategory, items) {
      this.setState({
        addModal: {
          show: false,
          forCategory: null
        }
      });

      // TODO: add items to the category.
    }
  }, {
    key: '__handleNewCategory__REACT_HOT_LOADER__',
    value: function __handleNewCategory__REACT_HOT_LOADER__(parentCategory) {
      this.setState({
        modifyCategoryModal: {
          show: true,
          isEditMode: false,
          forCategory: new _menu.MenuPartCategory(),
          parentCategory: parentCategory
        }
      });
    }
  }, {
    key: '__handleModifyCategory__REACT_HOT_LOADER__',
    value: function __handleModifyCategory__REACT_HOT_LOADER__(forCategory) {
      this.setState({
        modifyCategoryModal: {
          show: true,
          isEditMode: true,
          forCategory: forCategory
        }
      });
    }
  }, {
    key: '__handleHideModifyCategory__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __handleHideModifyCategory__REACT_HOT_LOADER__() {
      this.setState({
        modifyCategoryModal: {
          show: false,
          forCategory: null
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          menuPart = _props.menuPart,
          menu = _props.menu,
          restaurantMenu = _props.restaurantMenu,
          orderSettings = _props.orderSettings,
          onUpdate = _props.onUpdate;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          {
            style: {
              textAlign: 'center'
            }
          },
          menuPart.name
        ),
        _react2.default.createElement(_MenuPartMainCategoryView2.default, {
          menuInfo: {
            restaurantMenu: restaurantMenu,
            menu: menu,
            menuPart: menuPart,
            onRunAdd: this.handleRunAdd,
            onChange: this.props.onRestaurantMenuChange,
            level: 0,
            onNewCategory: this.handleNewCategory,
            onModifyCategory: this.handleModifyCategory,
            onAddCategory: this.props.onAddCategory,
            onDeleteCategory: this.props.onDeleteCategory
          }
        }),
        this.state.addModal.show && _react2.default.createElement(_SelectItemsModal2.default, {
          show: true,
          category: this.state.addModal.forCategory,
          restaurantMenu: restaurantMenu,
          menuPart: menuPart,
          menu: menu,
          onHide: this.handleHideAdd,
          onSelect: this.handleAddItems
        }),
        this.state.modifyCategoryModal.show && _react2.default.createElement(_ModifyCategoryModal2.default, {
          show: true,
          isEditMode: this.state.modifyCategoryModal.isEditMode,
          category: this.state.modifyCategoryModal.forCategory,
          parentCategory: this.state.modifyCategoryModal.parentCategory,
          restaurantMenu: restaurantMenu,
          menuPart: menuPart,
          menu: menu,
          onHide: this.handleHideModifyCategory,
          onRemovePartCategoryImage: this.props.onRemovePartCategoryImage,
          onUploadPartCategoryImage: this.props.onUploadPartCategoryImage
        })
      );
    }
  }]);

  return MenuPartEditView;
}(_react2.default.Component);

exports.default = MenuPartEditView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartEditView, 'MenuPartEditView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/MenuPartEditView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/Form.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- constants


var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.onNameChange = function () {
      var _this2;

      return (_this2 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(localizedNames) {
      var category = this.props.category;

      category.localizedNames = localizedNames;
      this.props.onChange(category);
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      return _react2.default.createElement(_form.ImageDropzone, {
        editOnly: false,
        readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
        placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_MENU_PART_CATEGORY_OPTION,
        image: this.props.category.image,
        currentImage: this.props.image.imageData,
        onChange: this.props.image.onChange,
        onRemove: this.props.image.onRemove,
        aspectRatio: _ApiConstants2.default.Image.RestaurantMenu.MenuPartCategory.RATIO,
        width: _ApiConstants2.default.Image.RestaurantMenu.MenuPartCategory.WIDTH,
        height: _ApiConstants2.default.Image.RestaurantMenu.MenuPartCategory.HEIGHT,
        maxSize: _ApiConstants2.default.Image.RestaurantMenu.MenuPartCategory.MAX_SIZE
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var category = this.props.category;

      return _react2.default.createElement(
        'div',
        { className: '' },
        _react2.default.createElement(
          'div',
          { style: { marginBottom: 10 } },
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: category.localizedNames,
            isRequired: true,
            className: 'form-control',
            placeholder: 'Nom',
            onChange: this.onNameChange
          })
        ),
        this.props.isEditMode && this.renderImage()
      );
    }
  }]);

  return Form;
}(_react2.default.Component);

Form.propTypes = {
  category: _propTypes2.default.objectOf(_MenuPartCategory2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  isEditMode: _propTypes2.default.bool.isRequired
};
var _default = Form;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Form, 'Form', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/ModifyCategoryModal/Form.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/ModifyCategoryModal/Form.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/ModifyCategoryModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _View = __webpack_require__("./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/View.js");

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- constants


// -- stores


// -- views


var ModifyCategoryModal = function (_Component) {
  _inherits(ModifyCategoryModal, _Component);

  function ModifyCategoryModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModifyCategoryModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModifyCategoryModal.__proto__ || Object.getPrototypeOf(ModifyCategoryModal)).call.apply(_ref, [this].concat(args))), _this), _this.onError = function () {
      var _this2;

      return (_this2 = _this).__onError__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onChange = function () {
      var _this3;

      return (_this3 = _this).__onChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onHide = function () {
      var _this4;

      return (_this4 = _this).__onHide__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModifyCategoryModal, [{
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListeners([new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange)]);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show
      // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu) || this.props.category.equals(nextProps.category);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onHide
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('menu.menu_part_category.edit.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(_View2.default, this.props)
        )
      );
    }
  }]);

  return ModifyCategoryModal;
}(_react.Component);

ModifyCategoryModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,
  isEditMode: _propTypes2.default.bool.isRequired,

  category: _propTypes2.default.objectOf(_MenuPartCategory2.default),
  parentCategory: _propTypes2.default.objectOf(_MenuPartCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
exports.default = ModifyCategoryModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ModifyCategoryModal, 'ModifyCategoryModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/ModifyCategoryModal/ModifyCategoryModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/View.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _SubmitArea = __webpack_require__("./sdk/scripts/components/form/SubmitArea.js");

var _SubmitArea2 = _interopRequireDefault(_SubmitArea);

var _Form = __webpack_require__("./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/Form.js");

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- stores


// -- entities


// -- views


var View = function (_AbstractComponent) {
  _inherits(View, _AbstractComponent);

  function View() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, View);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      category: _this.props.category.copy(),

      imageData: null
    }, _this.onSuccess = function () {
      var _this2;

      return (_this2 = _this).__onSuccess__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onError = function () {
      var _this3;

      return (_this3 = _this).__onError__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSubmit = function () {
      var _this4;

      return (_this4 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onReset = function () {
      var _this5;

      return (_this5 = _this).__onReset__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onChange = function () {
      var _this6;

      return (_this6 = _this).__onChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.handleImageChange = function () {
      var _this7;

      return (_this7 = _this).__handleImageChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(View, [{
    key: '__handleImageChange__REACT_HOT_LOADER__',
    value: function __handleImageChange__REACT_HOT_LOADER__() {
      return this.__handleImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSuccess__REACT_HOT_LOADER__',
    value: function __onSuccess__REACT_HOT_LOADER__() {
      return this.__onSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR, this.onError);

      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS, this.onSuccess);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR, this.onError);

      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS, this.onSuccess);
    }
  }, {
    key: '__onSuccess__REACT_HOT_LOADER__',
    value: function __onSuccess__REACT_HOT_LOADER__() {
      this.hideLoading();
      this.props.onHide();
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',


    // -- form
    value: function __onError__REACT_HOT_LOADER__() {
      // TODO: onError
      this.hideLoading();
      alert('An error occured');
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var restaurantMenu = this.props.restaurantMenu;
      var menuPart = this.props.menuPart;
      var menu = this.props.menu;

      var parentCategory = this.props.parentCategory;
      var menuPartCategory = this.state.category;

      if (this.props.isEditMode) {
        this.showLoading();
        _RestaurantMenuAction2.default.updateMenuPartCategory(menu, menuPart, menuPartCategory);
      } else {
        menuPartCategory.id = _utils.Utils.generateUID();

        parentCategory.addCategory(menuPartCategory);
        menuPart.updateCategory(parentCategory);

        // add to the menu part
        menuPart.addCategory(menuPartCategory);

        // update objects
        menu.updatePart(menuPart);
        restaurantMenu.updateMenu(menu);

        this.showLoading();
        _RestaurantMenuAction2.default.updateMenuPart(menu, menuPart);
      }
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        category: this.props.category.copy()
      });
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__(category) {
      this.setState({
        category: category.copy()
      });
    }
  }, {
    key: '__handleImageChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __handleImageChange__REACT_HOT_LOADER__(imageData) {
      this.props.onUploadPartCategoryImage(this.props.category, imageData);
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_SubmitArea2.default, {
        haveModifications: this.haveModifications,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      });
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this8 = this;

      return _react2.default.createElement(_Form2.default, {
        category: this.state.category,
        isEditMode: this.props.isEditMode,
        onChange: this.onChange,
        image: {
          data: this.state.imageData,
          onChange: this.handleImageChange,
          onRemove: function onRemove() {
            return _this8.props.onRemovePartCategoryImage(_this8.props.category);
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: '' },
        this.renderForm(),
        this.renderSubmitArea(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }, {
    key: 'category',
    get: function get() {
      return this.state.category;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.state.category.equals(this.props.category);
    }

    // --

  }]);

  return View;
}(_AbstractComponent3.default);

View.propTypes = {
  category: _propTypes2.default.objectOf(_MenuPartCategory2.default),
  parentCategory: _propTypes2.default.objectOf(_MenuPartCategory2.default),

  isEditMode: _propTypes2.default.bool.isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
var _default = View;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(View, 'View', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/ModifyCategoryModal/View.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/ModifyCategoryModal/View.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/SelectItemsModal/SelectItemsModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _View = __webpack_require__("./scripts/pages/menu/menuPartEdit/SelectItemsModal/View.js");

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- constants


// -- stores


// -- views


var SelectItems = function (_Component) {
  _inherits(SelectItems, _Component);

  function SelectItems() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectItems);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectItems.__proto__ || Object.getPrototypeOf(SelectItems)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHide = function () {
      var _this3;

      return (_this3 = _this).__onHide__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectItems, [{
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show
      // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu) || this.props.category.equals(nextProps.category);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onHide
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('menu.menu_part_category.add_item.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(_View2.default, this.props)
        )
      );
    }
  }]);

  return SelectItems;
}(_react.Component);

SelectItems.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  category: _propTypes2.default.objectOf(_MenuPartCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
exports.default = SelectItems;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectItems, 'SelectItems', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/SelectItemsModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/SelectItemsModal/View.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuPartItem = __webpack_require__("./sdk/scripts/entities/menu/MenuPartItem.js");

var _MenuPartItem2 = _interopRequireDefault(_MenuPartItem);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _SubmitArea = __webpack_require__("./sdk/scripts/components/form/SubmitArea.js");

var _SubmitArea2 = _interopRequireDefault(_SubmitArea);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _ProductItem = __webpack_require__("./scripts/pages/menu/menuPartEdit/SelectItemsModal/components/ProductItem.js");

var _ProductItem2 = _interopRequireDefault(_ProductItem);

var _CategoryItem = __webpack_require__("./scripts/pages/menu/menuPartEdit/SelectItemsModal/components/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- stores


// -- utils


// -- entities


// -- views


var View = function (_AbstractComponent) {
  _inherits(View, _AbstractComponent);

  function View() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, View);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchQuery: '',

      category: _this.props.category.copy(),

      productAddSearchQuery: '',

      productRemoveSearchQuery: '',

      categoryAddSearchQuery: '',

      categoryRemoveSearchQuery: ''
    }, _this.onError = function () {
      var _this2;

      return (_this2 = _this).__onError__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onSuccess = function () {
      var _this3;

      return (_this3 = _this).__onSuccess__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSelectAllProducts = function () {
      var _this4;

      return (_this4 = _this).__onSelectAllProducts__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDeselectAllProducts = function () {
      var _this5;

      return (_this5 = _this).__onDeselectAllProducts__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDeselectProduct = function () {
      var _this6;

      return (_this6 = _this).__onDeselectProduct__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onSelectProduct = function () {
      var _this7;

      return (_this7 = _this).__onSelectProduct__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onDeselectCategory = function () {
      var _this8;

      return (_this8 = _this).__onDeselectCategory__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onSelectCategory = function () {
      var _this9;

      return (_this9 = _this).__onSelectCategory__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onProductAddSearchQueryChange = function () {
      var _this10;

      return (_this10 = _this).__onProductAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onProductRemoveSearchQueryChange = function () {
      var _this11;

      return (_this11 = _this).__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onCategoryAddSearchQueryChange = function () {
      var _this12;

      return (_this12 = _this).__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onCategoryRemoveSearchQueryChange = function () {
      var _this13;

      return (_this13 = _this).__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onSubmit = function () {
      var _this14;

      return (_this14 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onReset = function () {
      var _this15;

      return (_this15 = _this).__onReset__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(View, [{
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onCategoryAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onProductAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectCategory__REACT_HOT_LOADER__',
    value: function __onSelectCategory__REACT_HOT_LOADER__() {
      return this.__onSelectCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectCategory__REACT_HOT_LOADER__',
    value: function __onDeselectCategory__REACT_HOT_LOADER__() {
      return this.__onDeselectCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectProduct__REACT_HOT_LOADER__',
    value: function __onSelectProduct__REACT_HOT_LOADER__() {
      return this.__onSelectProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectProduct__REACT_HOT_LOADER__',
    value: function __onDeselectProduct__REACT_HOT_LOADER__() {
      return this.__onDeselectProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectAllProducts__REACT_HOT_LOADER__',
    value: function __onDeselectAllProducts__REACT_HOT_LOADER__() {
      return this.__onDeselectAllProducts__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectAllProducts__REACT_HOT_LOADER__',
    value: function __onSelectAllProducts__REACT_HOT_LOADER__() {
      return this.__onSelectAllProducts__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSuccess__REACT_HOT_LOADER__',
    value: function __onSuccess__REACT_HOT_LOADER__() {
      return this.__onSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS, this.onSuccess);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS, this.onSuccess);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      // TODO: onError
      this.hideLoading();
      alert('an error occured');
    }
  }, {
    key: '__onSuccess__REACT_HOT_LOADER__',


    // --

    value: function __onSuccess__REACT_HOT_LOADER__() {
      this.hideLoading();
      this.props.onHide();
    }
  }, {
    key: '__onSelectAllProducts__REACT_HOT_LOADER__',
    value: function __onSelectAllProducts__REACT_HOT_LOADER__(products) {
      var category = this.category;

      _lodash2.default.forEach(products, function (product) {
        var item = new _MenuPartItem2.default();
        item.type = _MenuPartItem2.default.Type.PRODUCT;
        item.id = product.id;

        category.items.push(item);
      });

      this.setState({
        category: category
      });
    }
  }, {
    key: '__onDeselectAllProducts__REACT_HOT_LOADER__',
    value: function __onDeselectAllProducts__REACT_HOT_LOADER__(products) {
      var category = this.category;

      _lodash2.default.forEach(products, function (product) {
        category.removeProductWithId(product.id);
      });

      this.setState({
        category: category
      });
    }
  }, {
    key: '__onDeselectProduct__REACT_HOT_LOADER__',
    value: function __onDeselectProduct__REACT_HOT_LOADER__(product) {
      var category = this.category;

      category.removeProductWithId(product.id);

      this.setState({
        category: category
      });
    }
  }, {
    key: '__onSelectProduct__REACT_HOT_LOADER__',
    value: function __onSelectProduct__REACT_HOT_LOADER__(product) {
      var category = this.category;

      var item = new _MenuPartItem2.default();
      item.type = _MenuPartItem2.default.Type.PRODUCT;
      item.id = product.id;

      category.items.push(item);

      this.setState({
        category: category
      });
    }
  }, {
    key: '__onDeselectCategory__REACT_HOT_LOADER__',
    value: function __onDeselectCategory__REACT_HOT_LOADER__(categoryToDeselect) {
      var category = this.category;

      category.removeCategoryWithId(categoryToDeselect.id);

      this.setState({
        category: category
      });
    }
  }, {
    key: '__onSelectCategory__REACT_HOT_LOADER__',


    // -- search
    value: function __onSelectCategory__REACT_HOT_LOADER__(categoryToSelect) {
      var category = this.category;
      category.addCategory(categoryToSelect);

      this.setState({
        category: category
      });
    }
  }, {
    key: '__onProductAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductAddSearchQueryChange__REACT_HOT_LOADER__(productAddSearchQuery) {
      this.setState({
        productAddSearchQuery: productAddSearchQuery
      });
    }
  }, {
    key: '__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductRemoveSearchQueryChange__REACT_HOT_LOADER__(productRemoveSearchQuery) {
      this.setState({
        productRemoveSearchQuery: productRemoveSearchQuery
      });
    }
  }, {
    key: '__onCategoryAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onCategoryAddSearchQueryChange__REACT_HOT_LOADER__(categoryAddSearchQuery) {
      this.setState({
        categoryAddSearchQuery: categoryAddSearchQuery
      });
    }
  }, {
    key: '__onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__',


    // -- form
    value: function __onCategoryRemoveSearchQueryChange__REACT_HOT_LOADER__(categoryRemoveSearchQuery) {
      this.setState({
        categoryRemoveSearchQuery: categoryRemoveSearchQuery
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var menuPart = this.props.menuPart;
      var menu = this.props.menu;

      this.showLoading();
      _RestaurantMenuAction2.default.updateMenuPartCategory(menu, menuPart, this.state.category);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        category: this.props.category.copy()
      });
    }
  }, {
    key: 'renderSearchNoResults',
    value: function renderSearchNoResults() {
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'em',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.search_no_results')
        )
      );
    }
  }, {
    key: 'renderProductsSelected',
    value: function renderProductsSelected(products) {
      var _this16 = this;

      var listView = null;
      var sortedProductsList = [];

      if (_lodash2.default.isEmpty(products) && !_lodash2.default.isEmpty(this.state.productRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(products) && _lodash2.default.isEmpty(this.state.productRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.upselling_category.add_item.no_item_selected')
          )
        );
      } else {
        sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (product) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
        });
        listView = sortedProductsList.map(function (product) {
          return _react2.default.createElement(_ProductItem2.default, {
            key: product.id,
            product: product,
            isSelected: true,
            onDeselect: _this16.onDeselectProduct
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__products__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.productRemoveSearchQuery,
          onSearchInput: this.onProductRemoveSearchQueryChange
        }),
        listView.length > 0 && _react2.default.createElement(
          'div',
          {
            className: 'product_item pointer',
            onClick: function onClick() {
              return _this16.onDeselectAllProducts(sortedProductsList);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
          '\xA0\xA0',
          _I18n2.default.tr('menu.menu_part_category.uncheck_all')
        ),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProductsUnselected',
    value: function renderProductsUnselected(products) {
      var _this17 = this;

      var listView = null;
      var sortedProductsList = [];

      if (_lodash2.default.isEmpty(products)) {
        listView = this.renderSearchNoResults();
      } else {
        sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (product) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
        });
        listView = sortedProductsList.map(function (product) {
          return _react2.default.createElement(_ProductItem2.default, {
            key: product.id,
            product: product,
            isSelected: false,
            onSelect: _this17.onSelectProduct
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__products__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.products_on_menu')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.productAddSearchQuery,
          onSearchInput: this.onProductAddSearchQueryChange
        }),
        listView.length > 0 && _react2.default.createElement(
          'div',
          {
            className: 'product_item pointer',
            onClick: function onClick() {
              return _this17.onSelectAllProducts(sortedProductsList);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-square-o' }),
          '\xA0\xA0',
          _I18n2.default.tr('menu.menu_part_category.check_all')
        ),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this18 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.props.menuPart.products, function (item) {
        var product = _this18.props.restaurantMenu.getProductWithId(item.id);
        if (!_lodash2.default.isNil(product)) {
          var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this18.category.items, function (item) {
            return item.isProduct() && item.id === product.id;
          }));

          if (isSelected) {
            var query = _this18.state.productRemoveSearchQuery;
            if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, product.name)) {
              selected.push(product);
            }
          } else {
            var _query = _this18.state.productAddSearchQuery;
            if (_lodash2.default.isEmpty(_query) || _utils.StringUtils.searchStringOn(_query, product.name)) {
              unselected.push(product);
            }
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__products' },
        this.renderProductsUnselected(unselected),
        this.renderProductsSelected(selected)
      );
    }
  }, {
    key: 'renderCategoriesSelected',
    value: function renderCategoriesSelected(categories) {
      var _this19 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(categories) && !_lodash2.default.isEmpty(this.state.menuRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(categories) && _lodash2.default.isEmpty(this.state.menuRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.upselling_category.add_item.no_menu_selected')
          )
        );
      } else {
        listView = categories.map(function (category) {
          return _react2.default.createElement(_CategoryItem2.default, {
            key: category.id,
            category: category,
            isSelected: true,
            onDeselect: _this19.onDeselectCategory
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__menus__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.menuRemoveSearchQuery,
          onSearchInput: this.onMenuRemoveSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderCategoriesUnselected',
    value: function renderCategoriesUnselected(categories) {
      var _this20 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(categories)) {
        listView = this.renderSearchNoResults();
      } else {
        listView = categories.map(function (category) {
          return _react2.default.createElement(_CategoryItem2.default, {
            key: category.id,
            category: category,
            isSelected: false,
            onSelect: _this20.onSelectCategory
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__categories__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.menu_part_category.add_item.categories_on_menu')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.categoryAddSearchQuery,
          onSearchInput: this.oncategoryAddSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderCategories',
    value: function renderCategories() {
      var _this21 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.props.menuPart.categories, function (category) {
        if (!category.isRootCategory()) {
          var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this21.category.items, function (item) {
            return item.isCategory() && item.id === category.id;
          }));

          if (isSelected) {
            var query = _this21.state.menuRemoveSearchQuery;
            if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, category.name)) {
              selected.push(category);
            }
          } else {
            var _query2 = _this21.state.menuAddSearchQuery;
            if (_lodash2.default.isEmpty(_query2) || _utils.StringUtils.searchStringOn(_query2, category.name)) {
              unselected.push(category);
            }
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__categories' },
        this.renderCategoriesUnselected(unselected),
        this.renderCategoriesSelected(selected)
      );
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_SubmitArea2.default, {
        haveModifications: this.haveModifications,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'add_to_menu_part_category_view' },
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultActiveKey: 1,
            id: 'edit_restaurant_page__tabs',
            onSelect: this.onTabChange
          },
          _react2.default.createElement(
            _reactBootstrap.Tab,
            { eventKey: 1, title: _I18n2.default.tr('menu.menu_part_category.products') },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderProducts()
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Tab,
            { eventKey: 2, title: _I18n2.default.tr('menu.menu_part_category.categories') },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderCategories()
            )
          )
        ),
        this.renderSubmitArea(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }, {
    key: 'category',
    get: function get() {
      return this.state.category;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.state.category.equals(this.props.category);
    }

    // --

  }]);

  return View;
}(_AbstractComponent3.default);

View.propTypes = {
  category: _propTypes2.default.objectOf(_MenuPartCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
var _default = View;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(View, 'View', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/View.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/View.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/SelectItemsModal/components/CategoryItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var CategoryItem = function (_React$PureComponent) {
  _inherits(CategoryItem, _React$PureComponent);

  function CategoryItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryItem.__proto__ || Object.getPrototypeOf(CategoryItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this2;

      return (_this2 = _this).__onClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      this.props.isSelected === true ? this.props.onDeselect(this.category) : this.props.onSelect(this.category);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'category_item pointer', onClick: this.onClick },
        this.isSelected && _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
        !this.isSelected && _react2.default.createElement('i', { className: 'fa fa-square-o' }),
        '\xA0\xA0',
        this.category.name
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return CategoryItem;
}(_react2.default.PureComponent);

CategoryItem.propTypes = {
  category: _propTypes2.default.objectOf(_MenuPartCategory2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = CategoryItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryItem, 'CategoryItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/components/CategoryItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/components/CategoryItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/SelectItemsModal/components/ProductItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var ProductItem = function (_Component) {
  _inherits(ProductItem, _Component);

  function ProductItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductItem.__proto__ || Object.getPrototypeOf(ProductItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this2;

      return (_this2 = _this).__onClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      this.props.isSelected === true ? this.props.onDeselect(this.product) : this.props.onSelect(this.product);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_item pointer', onClick: this.onClick },
        this.isSelected && _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
        !this.isSelected && _react2.default.createElement('i', { className: 'fa fa-square-o' }),
        '\xA0\xA0',
        this.product.name
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return ProductItem;
}(_react.Component);

ProductItem.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = ProductItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductItem, 'ProductItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/components/ProductItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/SelectItemsModal/components/ProductItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/components/MenuPartCategoryView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _MenuPartItemType = __webpack_require__("./sdk/scripts/entities/menu/MenuPartItemType.js");

var _MenuPartItemType2 = _interopRequireDefault(_MenuPartItemType);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _Product = __webpack_require__("./scripts/pages/menu/menuPartEdit/components/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function Item(_ref) {
  var item = _ref.item,
      menuInfo = _ref.menuInfo;

  if (item.isProduct()) {
    var product = menuInfo.restaurantMenu.getProductWithId(item.id);
    if (_lodash2.default.isNull(product)) {
      return null;
    }

    return _react2.default.createElement(_Product2.default, { product: product, menuInfo: menuInfo });
  }

  var category = menuInfo.menuPart.getCategoryWithId(item.id);
  if (_lodash2.default.isNull(category)) {
    return null;
  }
  return _react2.default.createElement(MenuPartCategoryView, {
    category: category,
    menuInfo: _extends({}, menuInfo, { level: menuInfo.level + 1 })
  });
};

var ItemsList = function ItemsList(_ref2) {
  var style = _ref2.style,
      items = _ref2.items,
      menuInfo = _ref2.menuInfo;

  return _react2.default.createElement(
    'div',
    { style: style },
    items.map(function (item, index) {
      return _react2.default.createElement(Item, {
        key: index + '_' + item.type + '_' + item.id,
        item: item,
        menuInfo: menuInfo
      });
    })
  );
};

var MenuPartCategoryView = function (_React$Component) {
  _inherits(MenuPartCategoryView, _React$Component);

  function MenuPartCategoryView() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartCategoryView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = MenuPartCategoryView.__proto__ || Object.getPrototypeOf(MenuPartCategoryView)).call.apply(_ref3, [this].concat(args))), _this), _this.onDeleteCategory = function () {
      var _this2;

      return (_this2 = _this).__onDeleteCategory__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartCategoryView, [{
    key: '__onDeleteCategory__REACT_HOT_LOADER__',
    value: function __onDeleteCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteCategory__REACT_HOT_LOADER__',
    value: function __onDeleteCategory__REACT_HOT_LOADER__() {
      var _this3 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.menu_part.category.delete.are_you_sure'), function (result) {
        if (result) {
          _this3.props.menuInfo.onDeleteCategory(_this3.props.menuInfo.menuPart, _this3.props.category);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          menuInfo = _props.menuInfo,
          category = _props.category,
          isRoot = _props.isRoot;


      if (category === null) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('category-header', {
              'is-root': isRoot,
              'is-not-root': !isRoot
            })
          },
          !isRoot && _react2.default.createElement(
            'div',
            null,
            category.name,
            !_lodash2.default.isEmpty(category.image) && _react2.default.createElement('i', { className: 'fa fa-camera' }),
            _react2.default.createElement(
              'span',
              {
                className: 'subcategory'
              },
              _I18n2.default.tr('menu.menu_part.category.subcategory')
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              {
                className: 'btn btn-default btn-small',
                onClick: function onClick() {
                  return menuInfo.onRunAdd(category);
                }
              },
              _I18n2.default.tr('menu.menu_part.category.modify_items')
            ),
            _react2.default.createElement(
              'button',
              {
                className: 'btn btn-default btn-small new_category',
                onClick: function onClick() {
                  return menuInfo.onNewCategory(category);
                }
              },
              '+ ',
              _I18n2.default.tr('menu.menu_part.category.new_category')
            ),
            !isRoot && _react2.default.createElement(
              'button',
              {
                className: 'btn btn-default btn-small',
                onClick: function onClick() {
                  return menuInfo.onModifyCategory(category);
                }
              },
              _I18n2.default.tr('menu.menu_part.category.edit_category')
            ),
            !isRoot && _react2.default.createElement(
              'button',
              {
                className: 'btn btn-default btn-small',
                onClick: this.onDeleteCategory
              },
              _I18n2.default.tr('menu.menu_part.category.delete')
            )
          )
        ),
        _react2.default.createElement(ItemsList, {
          style: {
            paddingLeft: 10 * menuInfo.level + 'px'
          },
          items: category.items.filter(function (item) {
            return item.type === _MenuPartItemType2.default.CATEGORY;
          }),
          menuInfo: menuInfo
        }),
        _react2.default.createElement(ItemsList, {
          style: {
            paddingLeft: 10 * menuInfo.level + 'px'
          },
          items: category.items.filter(function (item) {
            return item.type === _MenuPartItemType2.default.PRODUCT;
          }),
          menuInfo: menuInfo
        })
      );
    }
  }]);

  return MenuPartCategoryView;
}(_react2.default.Component);

MenuPartCategoryView.defaultProps = {
  isRoot: false
};

var _default = MenuPartCategoryView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Item, 'Item', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/MenuPartCategoryView.js');

  __REACT_HOT_LOADER__.register(ItemsList, 'ItemsList', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/MenuPartCategoryView.js');

  __REACT_HOT_LOADER__.register(MenuPartCategoryView, 'MenuPartCategoryView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/MenuPartCategoryView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/MenuPartCategoryView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/components/MenuPartMainCategoryView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _MenuPartCategoryView = __webpack_require__("./scripts/pages/menu/menuPartEdit/components/MenuPartCategoryView.js");

var _MenuPartCategoryView2 = _interopRequireDefault(_MenuPartCategoryView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuPartMainCategoryView = function (_React$Component) {
  _inherits(MenuPartMainCategoryView, _React$Component);

  function MenuPartMainCategoryView() {
    _classCallCheck(this, MenuPartMainCategoryView);

    return _possibleConstructorReturn(this, (MenuPartMainCategoryView.__proto__ || Object.getPrototypeOf(MenuPartMainCategoryView)).apply(this, arguments));
  }

  _createClass(MenuPartMainCategoryView, [{
    key: 'render',
    value: function render() {
      var menuInfo = this.props.menuInfo;


      var rootCategory = menuInfo.menuPart.getRootCategory();

      try {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_MenuPartCategoryView2.default, {
            menuInfo: menuInfo,
            category: rootCategory,
            isRoot: true
          })
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return MenuPartMainCategoryView;
}(_react2.default.Component);

var _default = MenuPartMainCategoryView;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuPartMainCategoryView, 'MenuPartMainCategoryView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/MenuPartMainCategoryView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/MenuPartMainCategoryView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/components/Product.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Product = function Product(_ref) {
  var product = _ref.product,
      menuInfo = _ref.menuInfo;

  return _react2.default.createElement(
    "div",
    { className: "menu-part-category-product" },
    product.name
  );
};

var _default = Product;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Product, "Product", "C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/Product.js");

  __REACT_HOT_LOADER__.register(_default, "default", "C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menuPartEdit/components/Product.js");
}();

;
module.exports = exports["default"];

/***/ }),

/***/ "./scripts/pages/menu/menuPartEdit/style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./scripts/pages/menu/menus/MenusListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _OrderSettingsStore = __webpack_require__("./scripts/stores/OrderSettingsStore.js");

var _OrderSettingsStore2 = _interopRequireDefault(_OrderSettingsStore);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _AbstractRestaurantMenuComponent = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js");

var _AbstractRestaurantMenuComponent2 = _interopRequireDefault(_AbstractRestaurantMenuComponent);

var _MenuRow = __webpack_require__("./scripts/pages/menu/menus/components/MenuRow.js");

var _MenuRow2 = _interopRequireDefault(_MenuRow);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var MenusListPage = function (_AbstractRestaurantMe) {
  _inherits(MenusListPage, _AbstractRestaurantMe);

  function MenusListPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenusListPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenusListPage.__proto__ || Object.getPrototypeOf(MenusListPage)).call.apply(_ref, [this].concat(args))), _this), _this.onAddMenuClicked = function () {
      var _this2;

      return (_this2 = _this).__onAddMenuClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onMenuEditClicked = function () {
      var _this4;

      return (_this4 = _this).__onMenuEditClicked__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onMenuEditClicked = function () {
      var _this5;

      return (_this5 = _this).__onMenuEditClicked__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenusListPage, [{
    key: '__onMenuEditClicked__REACT_HOT_LOADER__',
    value: function __onMenuEditClicked__REACT_HOT_LOADER__() {
      return this.__onMenuEditClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuEditClicked__REACT_HOT_LOADER__',
    value: function __onMenuEditClicked__REACT_HOT_LOADER__() {
      return this.__onMenuEditClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteCategory__REACT_HOT_LOADER__',
    value: function __onDeleteCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddMenuClicked__REACT_HOT_LOADER__',
    value: function __onAddMenuClicked__REACT_HOT_LOADER__() {
      return this.__onAddMenuClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddMenuClicked__REACT_HOT_LOADER__',
    value: function __onAddMenuClicked__REACT_HOT_LOADER__() {
      _actions.RouteAction.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU_MENU_NEW);
    }
  }, {
    key: '__onDeleteCategory__REACT_HOT_LOADER__',
    value: function __onDeleteCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteCategory(this.props.category);
    }
  }, {
    key: '__onMenuEditClicked__REACT_HOT_LOADER__',
    value: function __onMenuEditClicked__REACT_HOT_LOADER__(menu) {
      this.props.onMenuEditClicked(menu);
    }
  }, {
    key: '__onMenuEditClicked__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onMenuEditClicked__REACT_HOT_LOADER__(menu) {
      this.props.onMenuEditClicked(menu);
    }
  }, {
    key: 'renderCreateMenuBtn',
    value: function renderCreateMenuBtn() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      if (_OrderSettingsStore2.default.getOrderSettings().menuManagedByPos) {
        return null;
      }

      return _react2.default.createElement(_RoundButton2.default, {
        onClick: this.onAddMenuClicked,
        text: _I18n2.default.tr('menu.menu_list.create_menu')
      });
    }
  }, {
    key: 'renderTheadContent',
    value: function renderTheadContent() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement('th', { className: 'hidden-sm col-md-1 text-left' }),
        _react2.default.createElement(
          'th',
          { className: 'col-md-6' },
          _I18n2.default.tr('menu.menu_list.name')
        ),
        _react2.default.createElement('th', { className: 'col-md-1 text-right' }),
        _react2.default.createElement('th', { className: 'col-md-1 text-center' })
      );
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var menusListView = [];

      _lodash2.default.each(this.restaurantMenu.menus, function (menu) {
        menusListView.push(_react2.default.createElement(_MenuRow2.default, {
          menu: menu,
          key: menu.id
        }));
      });

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-30 table_container' },
        _react2.default.createElement(
          'table',
          { className: 'table table-responsive' },
          _react2.default.createElement(
            'thead',
            null,
            this.renderTheadContent()
          ),
          _react2.default.createElement(
            'tbody',
            null,
            menusListView
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'menus_list_page top-buffer-30' },
        this.renderCreateMenuBtn(),
        this.renderList()
      );
    }
  }]);

  return MenusListPage;
}(_AbstractRestaurantMenuComponent2.default);

MenusListPage.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired
};
MenusListPage.defaultProps = {
  hideDeactivatedMenus: true
};
exports.default = MenusListPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenusListPage, 'MenusListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menus/MenusListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/menus/components/MenuRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var MenuRow = function (_Component) {
  _inherits(MenuRow, _Component);

  function MenuRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuRow.__proto__ || Object.getPrototypeOf(MenuRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onUp = function () {
      var _this3;

      return (_this3 = _this).__onUp__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDown = function () {
      var _this4;

      return (_this4 = _this).__onDown__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this5;

      return (_this5 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuRow, [{
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDown__REACT_HOT_LOADER__',
    value: function __onDown__REACT_HOT_LOADER__() {
      return this.__onDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUp__REACT_HOT_LOADER__',
    value: function __onUp__REACT_HOT_LOADER__() {
      return this.__onUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.menu.equals(this.props.menu);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenuDetail(this.props.menu);
    }
  }, {
    key: '__onUp__REACT_HOT_LOADER__',
    value: function __onUp__REACT_HOT_LOADER__() {}
  }, {
    key: '__onDown__REACT_HOT_LOADER__',
    value: function __onDown__REACT_HOT_LOADER__() {}
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {}
  }, {
    key: 'render',
    value: function render() {
      var menu = this.props.menu;

      return _react2.default.createElement(
        'tr',
        { className: 'menu_row pointer' },
        _react2.default.createElement(
          'td',
          {
            className: 'hidden-sm col-md-1 text-left',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(_ImageLoader2.default, {
            src: menu.image,
            className: 'menu_row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_MENU
          })
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'menu__name col-md-8',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            menu.name
          )
        ),
        _react2.default.createElement('td', {
          className: 'pointer col-md-1 text-right'
        }),
        _react2.default.createElement('td', {
          className: 'pointer col-md-1 text-center'
        })
      );
    }
  }]);

  return MenuRow;
}(_react.Component);

MenuRow.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired
};
var _default = MenuRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuRow, 'MenuRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menus/components/MenuRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/menus/components/MenuRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/option/ProductOptionDetailPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _ProductOptionDetailView = __webpack_require__("./scripts/pages/menu/option/ProductOptionDetailView.js");

var _ProductOptionDetailView2 = _interopRequireDefault(_ProductOptionDetailView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- actions


// -- stores


// -- entities


// -- components


var ProductOptionDetailPage = function (_AbstractComponent) {
  _inherits(ProductOptionDetailPage, _AbstractComponent);

  function ProductOptionDetailPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionDetailPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionDetailPage.__proto__ || Object.getPrototypeOf(ProductOptionDetailPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _RestaurantMenuStore2.default.getRestaurantMenu(),
      restaurant: _RestaurantStore2.default.getRestaurant(),

      productOption: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMenuUpdated = function () {
      var _this3;

      return (_this3 = _this).__onMenuUpdated__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onError = function () {
      var _this4;

      return (_this4 = _this).__onError__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onUpdate = function () {
      var _this5;

      return (_this5 = _this).__onUpdate__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionDetailPage, [{
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__() {
      return this.__onUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      return this.__onMenuUpdated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListeners(this.restaurantMenuStoreListeners);

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        _RestaurantMenuAction2.default.loadRestaurantMenu();
      } else {
        this.loadProductOption();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'getProductOptionOnRestaurantMenu',
    value: function getProductOptionOnRestaurantMenu(restaurantMenu) {
      var productOptionId = this.props.params.productOptionId;
      var productOption = restaurantMenu.getProductOptionWithId(productOptionId);

      return productOption;
    }
  }, {
    key: 'loadProductOption',
    value: function loadProductOption() {
      var productOption = this.getProductOptionOnRestaurantMenu(this.state.restaurantMenu);

      this.setState({
        productOption: productOption,
        loading: false
      });
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _RestaurantMenuStore2.default.getRestaurantMenu();
      var productOption = this.getProductOptionOnRestaurantMenu(restaurantMenu);

      this.setState({
        restaurantMenu: restaurantMenu,
        productOption: productOption,
        loading: false
      });
    }
  }, {
    key: '__onMenuUpdated__REACT_HOT_LOADER__',
    value: function __onMenuUpdated__REACT_HOT_LOADER__() {
      var restaurantMenu = _RestaurantMenuStore2.default.getRestaurantMenu();
      var productOption = this.getProductOptionOnRestaurantMenu(restaurantMenu);

      this.setState({
        restaurantMenu: restaurantMenu,
        productOption: productOption,
        loading: false
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',


    //
    // Form events
    //

    value: function __onError__REACT_HOT_LOADER__() {
      // TODO: onError
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onUpdate__REACT_HOT_LOADER__(productOption) {
      var image = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _ViewUtils2.default.dataUriToFile(image);
      _RestaurantMenuAction2.default.saveProductOption(productOption, imageFile);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (_lodash2.default.isNull(this.productOption)) {
        return this.renderOnLoadingContent();
      }

      return _react2.default.createElement(_ProductOptionDetailView2.default, {
        productOption: this.productOption,
        restaurantMenu: this.restaurantMenu,
        onUpdate: this.onUpdate,
        currencyCode: this.restaurant.currency
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.options'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.OPTIONS
        }
      }, {
        name: !_lodash2.default.isNull(this.productOption) ? this.productOption.name : '',
        link: null
      }];

      return _react2.default.createElement(
        'div',
        { className: 'product_option_detail_page' },
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        this.renderBody(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange),
      // new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError),
      new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onMenuUpdated),
      // new Listener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError),
      new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS, this.onMenuUpdated)];
    }
  }, {
    key: 'productOption',
    get: function get() {
      return this.state.productOption;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.state.restaurant;
    }
  }]);

  return ProductOptionDetailPage;
}(_AbstractComponent3.default);

var _default = ProductOptionDetailPage;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionDetailPage, 'ProductOptionDetailPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/ProductOptionDetailPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/ProductOptionDetailPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/option/ProductOptionDetailView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

var _ProductOptionValue = __webpack_require__("./sdk/scripts/entities/menu/ProductOptionValue.js");

var _ProductOptionValue2 = _interopRequireDefault(_ProductOptionValue);

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _ProductOptionProductRow = __webpack_require__("./scripts/pages/menu/option/components/ProductOptionProductRow.js");

var _ProductOptionProductRow2 = _interopRequireDefault(_ProductOptionProductRow);

var _ProductOptionValueRow = __webpack_require__("./scripts/pages/menu/option/components/ProductOptionValueRow.js");

var _ProductOptionValueRow2 = _interopRequireDefault(_ProductOptionValueRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- actions


// -- entities


// -- views


var ProductOptionDetailView = function (_AbstractRestaurantMe) {
  _inherits(ProductOptionDetailView, _AbstractRestaurantMe);

  function ProductOptionDetailView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionDetailView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionDetailView.__proto__ || Object.getPrototypeOf(ProductOptionDetailView)).call.apply(_ref, [this].concat(args))), _this), _this.onProductOptionChange = function () {
      var _this2;

      return (_this2 = _this).__onProductOptionChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onSubmit = function () {
      var _this3;

      return (_this3 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onReset = function () {
      var _this4;

      return (_this4 = _this).__onReset__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onImageChange = function () {
      var _this5;

      return (_this5 = _this).__onImageChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionDetailView, [{
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__() {
      return this.__onImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionChange__REACT_HOT_LOADER__',
    value: function __onProductOptionChange__REACT_HOT_LOADER__() {
      return this.__onProductOptionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(ProductOptionDetailView.prototype.__proto__ || Object.getPrototypeOf(ProductOptionDetailView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.productOption.equals(nextProps.productOption);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        productOption: props.productOption.copy(),

        image: null,

        displayEditModal: false
      };
    }
  }, {
    key: '__onProductOptionChange__REACT_HOT_LOADER__',


    //
    // Events form
    //

    value: function __onProductOptionChange__REACT_HOT_LOADER__(productOption) {
      this.setState({
        productOption: productOption
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      this.props.onUpdate(this.productOption, this.state.image);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    //
    // Events image
    //

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        productOption: this.props.productOption.copy()
      });
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onImageChange__REACT_HOT_LOADER__(pictureData) {
      this.setState({
        image: pictureData
      });
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var readOnly = _SecurityContext2.default.restaurantMenu.canEdit() && false ? false : true;

      return _react2.default.createElement(_form.ImageDropzone, {
        readOnly: readOnly,
        placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT_OPTION,
        image: this.productOption.image,
        currentImage: this.state.image,
        onChange: this.onImageChange,
        aspectRatio: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.RATIO,
        width: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.WIDTH,
        height: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.HEIGHT,
        maxSize: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.MAX_SIZE
      });
    }
  }, {
    key: 'renderEditButton',
    value: function renderEditButton() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      return _react2.default.createElement(
        _Link2.default,
        {
          className: 'btn btn-primary',
          to: _RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_OPTION_EDIT,
          params: { productOptionId: this.productOption.id }
        },
        _react2.default.createElement('i', { className: 'fa fa-edit' }),
        '\xA0\xA0',
        _I18n2.default.tr('menu.product_option.edit')
      );
    }
  }, {
    key: 'renderOptionValuesList',
    value: function renderOptionValuesList() {
      var _this6 = this;

      var partsListView = this.productOption.values.map(function (productOptionValue) {
        return _react2.default.createElement(_ProductOptionValueRow2.default, {
          key: productOptionValue.id,
          productOptionValue: productOptionValue,
          restaurantMenu: _this6.restaurantMenu,
          currencyCode: _this6.currencyCode
        });
      });

      return _react2.default.createElement(
        'div',
        { className: '' },
        _react2.default.createElement(
          'ul',
          null,
          partsListView
        )
      );
    }
  }, {
    key: 'renderProductsList',
    value: function renderProductsList() {
      var products = this.restaurantMenu.getProductsWithOptionId(this.productOption.id);

      if (_lodash2.default.isEmpty(products)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.product_option.no_products_with_option')
          )
        );
      }

      var productsListView = [];

      _lodash2.default.each(products, function (product) {
        productsListView.push(_react2.default.createElement(_ProductOptionProductRow2.default, { key: product.id, product: product }));
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          productsListView
        )
      );
    }
  }, {
    key: 'renderQuantityLabel',
    value: function renderQuantityLabel() {
      if (this.productOption.quantityMin >= 1) {
        return _react2.default.createElement(
          'span',
          { className: 'label label-danger' },
          _I18n2.default.tr('menu.product_option.required')
        );
      }

      return _react2.default.createElement(
        'span',
        { className: 'label label-info' },
        _I18n2.default.tr('menu.product_option.optionnal')
      );
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_form.FixedSubmitArea, {
        haveModifications: this.haveModifications,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_option_view' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-3' },
            _react2.default.createElement(
              'h3',
              null,
              this.productOption.name
            ),
            _react2.default.createElement(
              'h4',
              null,
              this.renderQuantityLabel(),
              '\xA0\xA0',
              _I18n2.default.tr('menu.product_option.min_with_colon'),
              ' ',
              this.productOption.quantityMin,
              ' |',
              ' ',
              _I18n2.default.tr('menu.product_option.max_with_colon'),
              ' ',
              this.productOption.quantityMax
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hidden-xs col-sm-6' },
            this.renderImage()
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-2 col-sm-3' },
            this.renderEditButton()
          )
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-40 col-xs-12' },
            _react2.default.createElement(
              'h2',
              null,
              _I18n2.default.tr('menu.product_option_view.choices')
            ),
            this.renderOptionValuesList()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-40 col-xs-12' },
            _react2.default.createElement(
              'h2',
              null,
              _I18n2.default.tr('menu.product_option_view.products')
            ),
            _react2.default.createElement(
              'em',
              null,
              _I18n2.default.tr('menu.product_option_view.products_with_option')
            ),
            this.renderProductsList()
          )
        ),
        this.renderSubmitArea()
      );
    }
  }, {
    key: 'productOption',
    get: function get() {
      return this.state.productOption;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.props.productOption.equals(this.state.productOption) || !_lodash2.default.isNull(this.state.image);
    }

    //
    // Events
    //

  }]);

  return ProductOptionDetailView;
}(_AbstractRestaurantMenuForm2.default);

ProductOptionDetailView.propTypes = {
  productOption: _propTypes2.default.objectOf(_ProductOption2.default).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired,

  /**
   * @param: ProductOption
   */
  onUpdate: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};
exports.default = ProductOptionDetailView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionDetailView, 'ProductOptionDetailView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/ProductOptionDetailView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/option/components/ProductOptionProductRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var ProductOptionProductRow = function (_Component) {
  _inherits(ProductOptionProductRow, _Component);

  function ProductOptionProductRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionProductRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionProductRow.__proto__ || Object.getPrototypeOf(ProductOptionProductRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionProductRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.product.equals(this.props.product);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductEdit(this.product);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      return _react2.default.createElement(
        'li',
        {
          onClick: this.onDisplayDetailClick
        },
        _react2.default.createElement(
          'h4',
          { className: 'link-hover' },
          this.product.name
        )
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }]);

  return ProductOptionProductRow;
}(_react.Component);

ProductOptionProductRow.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired
};
var _default = ProductOptionProductRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionProductRow, 'ProductOptionProductRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/components/ProductOptionProductRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/components/ProductOptionProductRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/option/components/ProductOptionValueRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _DietaryConstants = __webpack_require__("./sdk/scripts/constants/DietaryConstants.js");

var _isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ProductOptionValue = __webpack_require__("./sdk/scripts/entities/menu/ProductOptionValue.js");

var _ProductOptionValue2 = _interopRequireDefault(_ProductOptionValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var ProductOptionValueRow = function (_Component) {
  _inherits(ProductOptionValueRow, _Component);

  function ProductOptionValueRow() {
    _classCallCheck(this, ProductOptionValueRow);

    return _possibleConstructorReturn(this, (ProductOptionValueRow.__proto__ || Object.getPrototypeOf(ProductOptionValueRow)).apply(this, arguments));
  }

  _createClass(ProductOptionValueRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.productOptionValue.equals(this.props.productOptionValue);
    }

    // -- getters

  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'h4',
          null,
          this.productOptionValue.name,
          ' ',
          this.formattedPrice
        ),
        this.productOptionValue.dietaryInfo && !(0, _isEmpty2.default)(this.productOptionValue.dietaryInfo) && _react2.default.createElement(
          'span',
          null,
          _I18n2.default.tr('global.allergen.allergens'),
          ':\xA0',
          this.productOptionValue.dietaryInfo.allergens.map(function (allergen) {
            return _react2.default.createElement(
              'span',
              null,
              (0, _DietaryConstants.getAllergenLabel)(allergen)
            );
          })
        )
      );
    }
  }, {
    key: 'productOptionValue',
    get: function get() {
      return this.props.productOptionValue;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'formattedPrice',
    get: function get() {
      if (this.productOptionValue.additionalPrice !== 0) {
        return '(+' + _utils.CurrencyUtils.formatPriceWithCurrency(this.productOptionValue.additionalPrice, this.currencyCode) + ')';
      }
      return '';
    }
  }]);

  return ProductOptionValueRow;
}(_react.Component);

ProductOptionValueRow.propTypes = {
  productOptionValue: _propTypes2.default.objectOf(_ProductOptionValue2.default).isRequired,
  currencyCode: _propTypes2.default.string
};
var _default = ProductOptionValueRow;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionValueRow, 'ProductOptionValueRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/components/ProductOptionValueRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/option/components/ProductOptionValueRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/optionEdit/ProductOptionEditPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _ProductOptionEditView = __webpack_require__("./scripts/pages/menu/optionEdit/ProductOptionEditView.js");

var _ProductOptionEditView2 = _interopRequireDefault(_ProductOptionEditView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var ProductOptionEditPage = function (_AbstractComponent) {
  _inherits(ProductOptionEditPage, _AbstractComponent);

  function ProductOptionEditPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionEditPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionEditPage.__proto__ || Object.getPrototypeOf(ProductOptionEditPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu(),
      restaurant: _stores.RestaurantStore.getRestaurant(),
      productOption: _this.isEditMode() ? null : new _menu.ProductOption(),
      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onProductOptionUpdated = function () {
      var _this3;

      return (_this3 = _this).__onProductOptionUpdated__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onProductOptionCreated = function () {
      var _this4;

      return (_this4 = _this).__onProductOptionCreated__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onProductOptionDeleted = function () {
      var _this5;

      return (_this5 = _this).__onProductOptionDeleted__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onError = function () {
      var _this6;

      return (_this6 = _this).__onError__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onUpdateProductOption = function () {
      var _this7;

      return (_this7 = _this).__onUpdateProductOption__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onDeleteProductOptionImage = function () {
      var _this8;

      return (_this8 = _this).__onDeleteProductOptionImage__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onCreateProductOption = function () {
      var _this9;

      return (_this9 = _this).__onCreateProductOption__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onDeleteProductOption = function () {
      var _this10;

      return (_this10 = _this).__onDeleteProductOption__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionEditPage, [{
    key: '__onDeleteProductOption__REACT_HOT_LOADER__',
    value: function __onDeleteProductOption__REACT_HOT_LOADER__() {
      return this.__onDeleteProductOption__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCreateProductOption__REACT_HOT_LOADER__',
    value: function __onCreateProductOption__REACT_HOT_LOADER__() {
      return this.__onCreateProductOption__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductOptionImage__REACT_HOT_LOADER__',
    value: function __onDeleteProductOptionImage__REACT_HOT_LOADER__() {
      return this.__onDeleteProductOptionImage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateProductOption__REACT_HOT_LOADER__',
    value: function __onUpdateProductOption__REACT_HOT_LOADER__() {
      return this.__onUpdateProductOption__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionDeleted__REACT_HOT_LOADER__',
    value: function __onProductOptionDeleted__REACT_HOT_LOADER__() {
      return this.__onProductOptionDeleted__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionCreated__REACT_HOT_LOADER__',
    value: function __onProductOptionCreated__REACT_HOT_LOADER__() {
      return this.__onProductOptionCreated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionUpdated__REACT_HOT_LOADER__',
    value: function __onProductOptionUpdated__REACT_HOT_LOADER__() {
      return this.__onProductOptionUpdated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        // TODO: redirect
      }

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        _actions.RestaurantMenuAction.loadRestaurantMenu();
      } else if (this.isEditMode()) {
        this.loadProductOption();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'loadProductOption',
    value: function loadProductOption() {
      var productOption = this.getProductOptionOnRestaurantMenu(this.state.restaurantMenu);

      // TODO: if productOption === null redirect to 404.
      this.setState({
        productOption: productOption,
        loading: false
      });
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();

      if (this.isEditMode()) {
        var productOption = this.getProductOptionOnRestaurantMenu(restaurantMenu);
        this.setState({
          restaurantMenu: restaurantMenu,
          productOption: productOption,
          loading: false
        });
      } else {
        this.setState({
          restaurantMenu: restaurantMenu,
          loading: false
        });
      }
    }
  }, {
    key: '__onProductOptionUpdated__REACT_HOT_LOADER__',
    value: function __onProductOptionUpdated__REACT_HOT_LOADER__() {
      if (this.isEditMode()) {
        var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
        var productOption = this.getProductOptionOnRestaurantMenu(restaurantMenu);

        this.setState({
          restaurantMenu: restaurantMenu,
          productOption: productOption,
          loading: false
        });
      }
    }
  }, {
    key: '__onProductOptionCreated__REACT_HOT_LOADER__',
    value: function __onProductOptionCreated__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductOptionDetail(_stores.RestaurantMenuStore.getCreatedProductOption());
    }
  }, {
    key: '__onProductOptionDeleted__REACT_HOT_LOADER__',
    value: function __onProductOptionDeleted__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentOptionsTab();
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _stores.RestaurantMenuStore.getApiError()
      });
    }
  }, {
    key: '__onUpdateProductOption__REACT_HOT_LOADER__',
    value: function __onUpdateProductOption__REACT_HOT_LOADER__(productOption, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _ViewUtils2.default.dataUriToFile(image);
      _actions.RestaurantMenuAction.saveProductOption(productOption, imageFile);
    }
  }, {
    key: '__onDeleteProductOptionImage__REACT_HOT_LOADER__',
    value: function __onDeleteProductOptionImage__REACT_HOT_LOADER__(productOption) {
      this.showLoading();
      _actions.RestaurantMenuAction.deleteProductOptionImage(productOption);
    }
  }, {
    key: '__onCreateProductOption__REACT_HOT_LOADER__',
    value: function __onCreateProductOption__REACT_HOT_LOADER__(productOption, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _ViewUtils2.default.dataUriToFile(image);
      _actions.RestaurantMenuAction.createProductOption(productOption, imageFile);
    }
  }, {
    key: '__onDeleteProductOption__REACT_HOT_LOADER__',
    value: function __onDeleteProductOption__REACT_HOT_LOADER__(productOption) {
      this.showLoading();
      _actions.RestaurantMenuAction.deleteProductOption(productOption);
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return !_lodash2.default.isUndefined(this.props.params.productOptionId);
    }
  }, {
    key: 'getProductOptionOnRestaurantMenu',
    value: function getProductOptionOnRestaurantMenu(restaurantMenu) {
      var productOptionId = this.props.params.productOptionId;
      var productOption = restaurantMenu.getProductOptionWithId(productOptionId);

      return productOption;
    }

    // -- renderers

  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this11 = this;

      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.productOption)) {
        return this.renderLoading(true);
      }

      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.options'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.OPTIONS
        }
      }];

      if (this.isEditMode()) {
        arianeDetails.push({
          name: this.productOption.name,
          link: _RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_OPTION_DETAIL,
          params: {
            productOptionId: this.productOption.id
          }
        });
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.edition'),
          link: null
        });
      } else {
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.new'),
          link: null
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        _react2.default.createElement(_ProductOptionEditView2.default, {
          productOption: this.productOption,
          restaurantMenu: this.restaurantMenu,
          onUpdate: this.onUpdateProductOption,
          onCreate: this.onCreateProductOption,
          onDelete: this.onDeleteProductOption,
          onDeleteImage: function onDeleteImage() {
            return _this11.onDeleteProductOptionImage(_this11.productOption);
          },
          isEditMode: this.isEditMode(),
          orderSettings: _stores.OrderSettingsStore.getOrderSettings(),
          currencyCode: this.restaurant.currency
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'productOption_detail_page' },
          this.renderBody(),
          this.renderLoading()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onProductOptionUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS, this.onProductOptionUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS, this.onProductOptionCreated), new _Listener2.default(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS, this.onProductOptionDeleted), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS, this.onProductOptionUpdated), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_ERROR, this.onError)];
    }
  }, {
    key: 'productOption',
    get: function get() {
      return this.state.productOption;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.state.restaurant;
    }
  }]);

  return ProductOptionEditPage;
}(_AbstractComponent3.default);

exports.default = ProductOptionEditPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionEditPage, 'ProductOptionEditPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/optionEdit/ProductOptionEditPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/optionEdit/ProductOptionEditView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _restaurantMenu = __webpack_require__("./scripts/components/restaurantMenu/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _ProductOptionValueRow = __webpack_require__("./scripts/pages/menu/optionEdit/components/ProductOptionValueRow.js");

var _ProductOptionValueRow2 = _interopRequireDefault(_ProductOptionValueRow);

var _EditProductOptionValueModal = __webpack_require__("./scripts/pages/menu/optionEdit/components/productOptionValue/EditProductOptionValueModal.js");

var _EditProductOptionValueModal2 = _interopRequireDefault(_EditProductOptionValueModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- entities


// -- views


var ProductOptionEditView = function (_AbstractRestaurantMe) {
  _inherits(ProductOptionEditView, _AbstractRestaurantMe);

  function ProductOptionEditView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionEditView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionEditView.__proto__ || Object.getPrototypeOf(ProductOptionEditView)).call.apply(_ref, [this].concat(args))), _this), _this.onProductOptionChange = function () {
      var _this2;

      return (_this2 = _this).__onProductOptionChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteProductOption = function () {
      var _this3;

      return (_this3 = _this).__onDeleteProductOption__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onNameChange = function () {
      var _this4;

      return (_this4 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onQuantityMinChange = function () {
      var _this5;

      return (_this5 = _this).__onQuantityMinChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onQuantityMaxChange = function () {
      var _this6;

      return (_this6 = _this).__onQuantityMaxChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onValuesOrderChange = function () {
      var _this7;

      return (_this7 = _this).__onValuesOrderChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onChangeProductOptionValue = function () {
      var _this8;

      return (_this8 = _this).__onChangeProductOptionValue__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onDeleteProductOptionValue = function () {
      var _this9;

      return (_this9 = _this).__onDeleteProductOptionValue__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onAddProductOptionValue = function () {
      var _this10;

      return (_this10 = _this).__onAddProductOptionValue__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onEditOptionValueClicked = function () {
      var _this11;

      return (_this11 = _this).__onEditOptionValueClicked__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onHideEditOptionValueModal = function () {
      var _this12;

      return (_this12 = _this).__onHideEditOptionValueModal__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onAddOptionValueClicked = function () {
      var _this13;

      return (_this13 = _this).__onAddOptionValueClicked__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onHideAddOptionValueModal = function () {
      var _this14;

      return (_this14 = _this).__onHideAddOptionValueModal__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onImageChange = function () {
      var _this15;

      return (_this15 = _this).__onImageChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onImageRemove = function () {
      var _this16;

      return (_this16 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onSubmit = function () {
      var _this17;

      return (_this17 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onReset = function () {
      var _this18;

      return (_this18 = _this).__onReset__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.renderValueRow = function () {
      var _this19;

      return (_this19 = _this).__renderValueRow__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionEditView, [{
    key: '__renderValueRow__REACT_HOT_LOADER__',
    value: function __renderValueRow__REACT_HOT_LOADER__() {
      return this.__renderValueRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__() {
      return this.__onImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideAddOptionValueModal__REACT_HOT_LOADER__',
    value: function __onHideAddOptionValueModal__REACT_HOT_LOADER__() {
      return this.__onHideAddOptionValueModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddOptionValueClicked__REACT_HOT_LOADER__',
    value: function __onAddOptionValueClicked__REACT_HOT_LOADER__() {
      return this.__onAddOptionValueClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideEditOptionValueModal__REACT_HOT_LOADER__',
    value: function __onHideEditOptionValueModal__REACT_HOT_LOADER__() {
      return this.__onHideEditOptionValueModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEditOptionValueClicked__REACT_HOT_LOADER__',
    value: function __onEditOptionValueClicked__REACT_HOT_LOADER__() {
      return this.__onEditOptionValueClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddProductOptionValue__REACT_HOT_LOADER__',
    value: function __onAddProductOptionValue__REACT_HOT_LOADER__() {
      return this.__onAddProductOptionValue__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductOptionValue__REACT_HOT_LOADER__',
    value: function __onDeleteProductOptionValue__REACT_HOT_LOADER__() {
      return this.__onDeleteProductOptionValue__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeProductOptionValue__REACT_HOT_LOADER__',
    value: function __onChangeProductOptionValue__REACT_HOT_LOADER__() {
      return this.__onChangeProductOptionValue__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onValuesOrderChange__REACT_HOT_LOADER__',
    value: function __onValuesOrderChange__REACT_HOT_LOADER__() {
      return this.__onValuesOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onQuantityMaxChange__REACT_HOT_LOADER__',
    value: function __onQuantityMaxChange__REACT_HOT_LOADER__() {
      return this.__onQuantityMaxChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onQuantityMinChange__REACT_HOT_LOADER__',
    value: function __onQuantityMinChange__REACT_HOT_LOADER__() {
      return this.__onQuantityMinChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductOption__REACT_HOT_LOADER__',
    value: function __onDeleteProductOption__REACT_HOT_LOADER__() {
      return this.__onDeleteProductOption__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionChange__REACT_HOT_LOADER__',
    value: function __onProductOptionChange__REACT_HOT_LOADER__() {
      return this.__onProductOptionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(ProductOptionEditView.prototype.__proto__ || Object.getPrototypeOf(ProductOptionEditView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.productOption.equals(nextProps.productOption);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        productOption: props.productOption.copy(),

        image: null,

        validationErrors: {},

        // view

        displayAddOptionValueModal: false,

        displayEditOptionValueModal: false,
        optionValueToEditOnModal: null
      };
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return this.props.isEditMode;
    }
  }, {
    key: '__onProductOptionChange__REACT_HOT_LOADER__',
    value: function __onProductOptionChange__REACT_HOT_LOADER__(productOption) {
      this.setState({
        productOption: productOption
      });
    }
  }, {
    key: '__onDeleteProductOption__REACT_HOT_LOADER__',


    //
    // Form event
    //

    value: function __onDeleteProductOption__REACT_HOT_LOADER__(event) {
      var _this20 = this;

      event.preventDefault();

      _Notify2.default.confirm(_I18n2.default.tr('menu.product_option.option.edit.confirm_delete'), function (result) {
        if (result) {
          _this20.props.onDelete(_this20.props.productOption);
        }
      });
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var productOption = this.productOption;
      productOption.localizedNames = newValue;
      this.onProductOptionChange(productOption);
    }
  }, {
    key: '__onQuantityMinChange__REACT_HOT_LOADER__',
    value: function __onQuantityMinChange__REACT_HOT_LOADER__(quantityMin) {
      var productOption = this.productOption;
      productOption.quantityMin = quantityMin;
      this.onProductOptionChange(productOption);
    }
  }, {
    key: '__onQuantityMaxChange__REACT_HOT_LOADER__',
    value: function __onQuantityMaxChange__REACT_HOT_LOADER__(quantityMax) {
      var productOption = this.productOption;
      productOption.quantityMax = quantityMax;
      this.onProductOptionChange(productOption);
    }
  }, {
    key: '__onValuesOrderChange__REACT_HOT_LOADER__',


    //
    // OptionValue CRUD
    //

    value: function __onValuesOrderChange__REACT_HOT_LOADER__(values) {
      var productOption = this.productOption;
      productOption.values = values;
      this.onProductOptionChange(productOption);
    }
  }, {
    key: '__onChangeProductOptionValue__REACT_HOT_LOADER__',
    value: function __onChangeProductOptionValue__REACT_HOT_LOADER__(optionValue) {
      var productOption = this.productOption;
      productOption.updateValue(optionValue);
      this.onProductOptionChange(productOption);
    }
  }, {
    key: '__onDeleteProductOptionValue__REACT_HOT_LOADER__',
    value: function __onDeleteProductOptionValue__REACT_HOT_LOADER__(optionValue) {
      var _this21 = this;

      _Notify2.default.confirmDelete(_I18n2.default.tr('menu.product_option.option.edit.confirm_delete_value'), function (confirm) {
        if (confirm) {
          var productOption = _this21.productOption;
          productOption.deleteValue(optionValue);
          _this21.onProductOptionChange(productOption);
        }
      });
    }
  }, {
    key: '__onAddProductOptionValue__REACT_HOT_LOADER__',


    //
    // Edit OptionValue
    //

    value: function __onAddProductOptionValue__REACT_HOT_LOADER__(optionValue) {
      var productOption = this.productOption;
      productOption.addValue(optionValue);
      this.onProductOptionChange(productOption);
    }
  }, {
    key: '__onEditOptionValueClicked__REACT_HOT_LOADER__',
    value: function __onEditOptionValueClicked__REACT_HOT_LOADER__(optionValue) {
      this.setState({
        displayEditOptionValueModal: true,
        optionValueToEditOnModal: optionValue
      });
    }
  }, {
    key: '__onHideEditOptionValueModal__REACT_HOT_LOADER__',


    //
    // Add OptionValue
    //

    value: function __onHideEditOptionValueModal__REACT_HOT_LOADER__() {
      this.setState({
        displayEditOptionValueModal: false,
        optionValueToEditOnModal: null
      });
    }
  }, {
    key: '__onAddOptionValueClicked__REACT_HOT_LOADER__',
    value: function __onAddOptionValueClicked__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      this.setState({
        displayAddOptionValueModal: true
      });
    }
  }, {
    key: '__onHideAddOptionValueModal__REACT_HOT_LOADER__',


    //
    // Events image
    //

    value: function __onHideAddOptionValueModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddOptionValueModal: false
      });
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__(pictureData) {
      this.setState({
        image: pictureData
      });
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',


    //
    // Events form
    //

    value: function __onImageRemove__REACT_HOT_LOADER__() {
      this.props.onDeleteImage();
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var productOption = this.productOption;

      /**
       * We need to create a unique pos id if  we create a new productOption
       */
      if (!this.isEditMode()) {
        productOption.id = _utils.Utils.generateUID();

        /**
         * Activated by default.
         * @type {boolean}
         */
        //    productOption.activated = true;
      } else {
        productOption.id = this.props.productOption.id;
      }

      if (productOption.isValid()) {
        if (this.isEditMode()) {
          this.props.onUpdate(this.productOption, this.state.image);
        } else {
          this.props.onCreate(this.productOption, this.state.image);
        }
      } else {
        var validationErrors = productOption.getValidationErrors();
        this.setState({
          validationErrors: validationErrors
        });
      }
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        productOption: this.props.productOption.copy()
      });
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.props.productOption.equals(this.state.productOption) || !_lodash2.default.isNull(this.state.image);
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return false;
    }

    //
    // getters
    //

  }, {
    key: 'renderName',


    //
    // renderers
    //

    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            'Nom'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: this.productOption.localizedNames,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.product.edit.name'),
            onChange: this.onNameChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.name
        )
      );
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 col-xs-offset-4' },
        _react2.default.createElement(_form.ImageDropzone, {
          editOnly: false,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
          placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT_OPTION,
          image: this.productOption.image,
          currentImage: this.state.image,
          onChange: this.onImageChange,
          onRemove: this.onImageRemove,
          aspectRatio: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.RATIO,
          width: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.WIDTH,
          height: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.HEIGHT,
          maxSize: _ApiConstants2.default.Image.RestaurantMenu.ProductOption.MAX_SIZE
        })
      );
    }
  }, {
    key: 'renderDeleteProductOption',
    value: function renderDeleteProductOption() {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 text-center top-buffer-50' },
        _react2.default.createElement('hr', null),
        this.isEditMode() && // only on edit mode
        _react2.default.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-danger',
            onClick: this.onDeleteProductOption
          },
          _I18n2.default.tr('menu.product_option.option.edit.delete_option')
        )
      );
    }
  }, {
    key: 'renderQuantityMinMax',
    value: function renderQuantityMinMax() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.product_option.option.edit.quantities')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.productOption.quantityMin,
              onChange: this.onQuantityMinChange,
              readOnly: !_SecurityContext2.default.restaurantMenu.canEditOptions(),
              disabled: !_SecurityContext2.default.restaurantMenu.canEditOptions()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _I18n2.default.tr('menu.product_option.option.edit.min')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.productOption.quantityMax,
              onChange: this.onQuantityMaxChange,
              readOnly: !_SecurityContext2.default.restaurantMenu.canEditOptions(),
              disabled: !_SecurityContext2.default.restaurantMenu.canEditOptions(),
              max: 99,
              min: 1
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _I18n2.default.tr('menu.product_option.option.edit.max')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.quantity
        )
      );
    }
  }, {
    key: '__renderValueRow__REACT_HOT_LOADER__',
    value: function __renderValueRow__REACT_HOT_LOADER__(productOptionValue) {
      return _react2.default.createElement(_ProductOptionValueRow2.default, {
        productOptionValue: productOptionValue,
        onEditClicked: this.onEditOptionValueClicked,
        readOnly: !_SecurityContext2.default.restaurantMenu.canEditOptions(),
        currencyCode: this.currencyCode
      });
    }
  }, {
    key: 'renderValues',
    value: function renderValues() {
      return _react2.default.createElement(
        'div',
        { className: 'table_container table_container_hover col-xs-12' },
        !_lodash2.default.isEmpty(this.state.validationErrors.values) && _react2.default.createElement(
          'div',
          { className: 'simple_error_block col-xs-12 top-buffer-50' },
          this.state.validationErrors.values
        ),
        _react2.default.createElement(_SortableList2.default, {
          renderer: this.renderValueRow,
          items: this.productOption.values,
          onChange: this.onValuesOrderChange
        })
      );
    }
  }, {
    key: 'renderAddOptionValueModal',
    value: function renderAddOptionValueModal() {
      if (!this.state.displayAddOptionValueModal) {
        return null;
      }

      return _react2.default.createElement(_EditProductOptionValueModal2.default, {
        show: true,
        isEditMode: false,
        onCreate: this.onAddProductOptionValue,
        onHide: this.onHideAddOptionValueModal,
        currencyCode: this.currencyCode
      });
    }
  }, {
    key: 'renderEditOptionValueModal',
    value: function renderEditOptionValueModal() {
      if (!this.state.displayEditOptionValueModal) {
        return null;
      }

      return _react2.default.createElement(_EditProductOptionValueModal2.default, {
        show: true,
        productOptionValue: this.state.optionValueToEditOnModal,
        isEditMode: true,
        onUpdate: this.onChangeProductOptionValue,
        onDelete: this.onDeleteProductOptionValue,
        onHide: this.onHideEditOptionValueModal,
        currencyCode: this.currencyCode
      });
    }
  }, {
    key: 'renderAddValue',
    value: function renderAddValue() {
      if (!_SecurityContext2.default.restaurantMenu.canEditOptions()) {
        return null;
      }

      return _react2.default.createElement(
        'button',
        { className: 'btn btn-xs', onClick: this.onAddOptionValueClicked },
        _I18n2.default.tr('menu.product_option.option.edit.add_option_value')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'form',
          {
            className: 'form form-horizontal productOption_edit_view',
            role: 'form',
            noValidate: true
          },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            this.renderName(),
            this.renderQuantityMinMax(),
            this.renderImage()
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.product_option.option.edit.offered_choices')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-40' },
                this.renderAddValue()
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderValues()
              )
            )
          ),
          _SecurityContext2.default.restaurantMenu.canEditOptions() && this.renderDeleteProductOption(),
          this.renderFixedButtons(),
          this.renderAddOptionValueModal(),
          this.renderEditOptionValueModal()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'productOption',
    get: function get() {
      return this.state.productOption;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }]);

  return ProductOptionEditView;
}(_AbstractRestaurantMenuForm2.default);

ProductOptionEditView.propTypes = {
  productOption: _propTypes2.default.objectOf(_menu.Product).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  /**
   * @param: ProductOption
   * @param: image blob
   */
  onUpdate: _propTypes2.default.func.isRequired,

  /**
   * @param: ProductOption
   * @param: image blob
   */
  onCreate: _propTypes2.default.func.isRequired,

  /**
   * @param: ProductOption
   */
  onDelete: _propTypes2.default.func.isRequired,

  onImageRemove: _propTypes2.default.func.isRequired,

  isEditMode: _propTypes2.default.bool.isRequired,

  currencyCode: _propTypes2.default.string
};
exports.default = ProductOptionEditView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionEditView, 'ProductOptionEditView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/optionEdit/ProductOptionEditView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/optionEdit/components/ProductOptionValueRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _ProductOptionValue = __webpack_require__("./sdk/scripts/entities/menu/ProductOptionValue.js");

var _ProductOptionValue2 = _interopRequireDefault(_ProductOptionValue);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _DietaryConstants = __webpack_require__("./sdk/scripts/constants/DietaryConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var ProductOptionValueRow = function (_Component) {
  _inherits(ProductOptionValueRow, _Component);

  function ProductOptionValueRow() {
    _classCallCheck(this, ProductOptionValueRow);

    return _possibleConstructorReturn(this, (ProductOptionValueRow.__proto__ || Object.getPrototypeOf(ProductOptionValueRow)).apply(this, arguments));
  }

  _createClass(ProductOptionValueRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.productOptionValue.equals(this.props.productOptionValue);
    }

    // -- getters

  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      var _this2 = this;

      var readOnly = this.props.readOnly;


      return _react2.default.createElement(
        'div',
        { className: 'row product_option_edit__value_row' },
        _react2.default.createElement(
          'div',
          { className: 'product_option_edit__value_row__name col-xs-4' },
          this.productOptionValue.name
        ),
        _react2.default.createElement(
          'div',
          { className: 'product_option_edit__value_row__price col-xs-2' },
          this.formattedPrice
        ),
        _react2.default.createElement(
          'div',
          { className: 'product_option_edit__value_row__price col-xs-2' },
          this.productOptionValue.dietaryInfo && _react2.default.createElement(
            'span',
            null,
            (this.productOptionValue.dietaryInfo.allergens || []).map(_DietaryConstants.getAllergenLabel).join(', ')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-2' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            wrapperClass: 'switch_important',
            value: this.productOptionValue.haveStock(),
            disabled: true
          })
        ),
        !readOnly && _react2.default.createElement(
          'div',
          {
            className: 'product_option_edit__value_row__edit col-xs-1',
            onClick: function onClick() {
              return _this2.props.onEditClicked(_this2.productOptionValue);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-edit' })
        ),
        !readOnly && _react2.default.createElement(
          'div',
          { className: 'product_option_edit__value_row__drag_handle col-xs-1' },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'productOptionValue',
    get: function get() {
      return this.props.productOptionValue;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'formattedPrice',
    get: function get() {
      if (this.productOptionValue.additionalPrice !== 0) {
        return '(+' + _utils.CurrencyUtils.formatPriceWithCurrency(this.productOptionValue.additionalPrice, this.currencyCode) + ')';
      }
      return _I18n2.default.tr('menu.product_option.option.value.no_additionnal_price');
    }
  }]);

  return ProductOptionValueRow;
}(_react.Component);

ProductOptionValueRow.propTypes = {
  productOptionValue: _propTypes2.default.objectOf(_ProductOptionValue2.default).isRequired,
  currencyCode: _propTypes2.default.string,

  /**
   * @param ProductOptionValue
   */
  onEditClicked: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = ProductOptionValueRow;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionValueRow, 'ProductOptionValueRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/optionEdit/components/ProductOptionValueRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/optionEdit/components/productOptionValue/EditProductOptionValueModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _AllergenChooser = __webpack_require__("./sdk/scripts/components/form/AllergenChooser.js");

var _AllergenChooser2 = _interopRequireDefault(_AllergenChooser);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditProductOptionValueModal = function (_AbstractFormComponen) {
  _inherits(EditProductOptionValueModal, _AbstractFormComponen);

  function EditProductOptionValueModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditProductOptionValueModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditProductOptionValueModal.__proto__ || Object.getPrototypeOf(EditProductOptionValueModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      productOptionValue: _this.props.productOptionValue.copy(),

      /*
       * contains the productOption.getValidationErrors() when submit the form
       */
      validationErrors: {}
    }, _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDeleteProductOptionValue = function () {
      var _this4;

      return (_this4 = _this).__onDeleteProductOptionValue__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onChange = function () {
      var _this5;

      return (_this5 = _this).__onChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onNameChange = function () {
      var _this6;

      return (_this6 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onAdditionalPriceChange = function () {
      var _this7;

      return (_this7 = _this).__onAdditionalPriceChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onAllergensChange = function () {
      var _this8;

      return (_this8 = _this).__onAllergensChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onToggleStock = function () {
      var _this9;

      return (_this9 = _this).__onToggleStock__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onSubmit = function () {
      var _this10;

      return (_this10 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditProductOptionValueModal, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleStock__REACT_HOT_LOADER__',
    value: function __onToggleStock__REACT_HOT_LOADER__() {
      return this.__onToggleStock__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAllergensChange__REACT_HOT_LOADER__',
    value: function __onAllergensChange__REACT_HOT_LOADER__() {
      return this.__onAllergensChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAdditionalPriceChange__REACT_HOT_LOADER__',
    value: function __onAdditionalPriceChange__REACT_HOT_LOADER__() {
      return this.__onAdditionalPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductOptionValue__REACT_HOT_LOADER__',
    value: function __onDeleteProductOptionValue__REACT_HOT_LOADER__() {
      return this.__onDeleteProductOptionValue__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'haveModifications',


    //
    //
    //

    value: function haveModifications() {
      return !this.props.productOptionValue.equals(this.state.productOptionValue);
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return !this.productOptionValue.isValid();
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return this.props.isEditMode;
    }

    //
    // Modal
    //

  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onDeleteProductOptionValue__REACT_HOT_LOADER__',
    value: function __onDeleteProductOptionValue__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      this.props.onDelete(this.props.productOptionValue);
      this.props.onHide();
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__(productOptionValue) {
      this.setState({
        productOptionValue: productOptionValue
      });
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var productOptionValue = this.productOptionValue;
      productOptionValue.localizedNames = newValue;
      this.onChange(productOptionValue);
    }
  }, {
    key: '__onAdditionalPriceChange__REACT_HOT_LOADER__',
    value: function __onAdditionalPriceChange__REACT_HOT_LOADER__(newValue) {
      var productOptionValue = this.productOptionValue;
      productOptionValue.additionalPrice = newValue;
      this.onChange(productOptionValue);
    }
  }, {
    key: '__onAllergensChange__REACT_HOT_LOADER__',
    value: function __onAllergensChange__REACT_HOT_LOADER__(allergens) {
      var productOptionValue = this.productOptionValue;
      if (!productOptionValue.dietaryData) {
        productOptionValue.dietaryInfo = {};
      }
      productOptionValue.dietaryInfo.allergens = allergens;
      this.onChange(productOptionValue);
    }
  }, {
    key: '__onToggleStock__REACT_HOT_LOADER__',
    value: function __onToggleStock__REACT_HOT_LOADER__() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit() && !_SecurityContext2.default.restaurantMenu.canEditAvailabilityProducts()) {
        return;
      }

      var productOptionValue = this.productOptionValue;

      productOptionValue.toggleAvailibility();

      this.onChange(productOptionValue);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var productOptionValue = this.productOptionValue;

      /**
       * We need to create a unique pos id if  we create a new productOption
       */
      if (!this.isEditMode()) {
        productOptionValue.id = _utils.Utils.generateUID();

        /**
         * Activated by default.
         * @type {boolean}
         */
        //    productOption.activated = true;
      } else {
        productOptionValue.id = this.props.productOptionValue.id;
      }

      if (productOptionValue.isValid()) {
        if (this.isEditMode()) {
          this.props.onUpdate(productOptionValue);
          this.onClose();
        } else {
          this.props.onCreate(productOptionValue);
          this.onClose();
        }
      } else {
        var validationErrors = productOptionValue.getValidationErrors();
        console.info('productOption invalid', validationErrors);
        this.setState({
          validationErrors: validationErrors
        });
      }
    }
  }, {
    key: 'renderName',


    //
    // renderers
    //

    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.product_option.option.value.name')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: this.productOptionValue.localizedNames,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.product_option.option.value.name'),
            onChange: this.onNameChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.name
        )
      );
    }
  }, {
    key: 'renderAdditionalPrice',
    value: function renderAdditionalPrice() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.product_option.option.value.additionnal_price')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.productOptionValue.additionalPrice,
              onChange: this.onAdditionalPriceChange,
              min: 0
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _utils.CurrencyUtils.getCurrencySymbol(this.props.currencyCode)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.additionalPrice
        )
      );
    }
  }, {
    key: 'renderDelete',
    value: function renderDelete() {
      if (!this.isEditMode()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50 text-left' },
        _react2.default.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-danger',
            onClick: this.onDeleteProductOptionValue
          },
          _I18n2.default.tr('menu.product_option.option.value.delete_value')
        )
      );
    }
  }, {
    key: 'renderAllergens',
    value: function renderAllergens() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('global.allergen.allergens')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_AllergenChooser2.default, {
            allergens: this.productOptionValue.dietaryInfo ? this.productOptionValue.dietaryInfo.allergens : [],
            onChange: this.onAllergensChange
          })
        )
      );
    }
  }, {
    key: 'renderStock',
    value: function renderStock() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.product_option.option.value.stock')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            wrapperClass: 'switch_important',
            value: this.productOptionValue.haveStock(),
            onChange: this.onToggleStock,
            disabled: !_SecurityContext2.default.restaurantMenu.canEdit() && !_SecurityContext2.default.restaurantMenu.canEditAvailabilityProducts()
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'form',
        {
          className: 'form form-horizontal product_pption_value_edit_form',
          role: 'form',
          noValidate: true
        },
        this.renderName(),
        this.renderAdditionalPrice(),
        this.renderAllergens(),
        this.renderStock(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-50 text-center' },
          this.renderButtons()
        ),
        this.renderDelete()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          _reactBootstrap.Modal,
          { bsSize: 'large', show: this.props.show, onHide: this.onHide },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            null,
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'close close-white',
                onClick: this.props.onHide
              },
              _react2.default.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              this.title
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            this.renderBody()
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'productOptionValue',
    get: function get() {
      return this.state.productOptionValue;
    }
  }, {
    key: 'title',
    get: function get() {
      if (!this.isEditMode()) {
        return _I18n2.default.tr('menu.product_option.option.value.new_choice');
      }
      return _I18n2.default.tr('menu.product_option.option.value.edit_choice');
    }
  }]);

  return EditProductOptionValueModal;
}(_AbstractFormComponent2.default);

EditProductOptionValueModal.defaultProps = {
  productOptionValue: new _menu.ProductOptionValue()
};
EditProductOptionValueModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  productOptionValue: _propTypes2.default.objectOf(_menu.ProductOptionValue),

  isEditMode: _propTypes2.default.bool.isRequired,

  /**
   * @param ProductOptionValue
   */
  onUpdate: _propTypes2.default.func,

  /**
   * @param ProductOptionValue
   */
  onCreate: _propTypes2.default.func,

  /**
   * @param ProductOptionValue
   */
  onDelete: _propTypes2.default.func,

  currencyCode: _propTypes2.default.string

};
exports.default = EditProductOptionValueModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EditProductOptionValueModal, 'EditProductOptionValueModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/optionEdit/components/productOptionValue/EditProductOptionValueModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/options/OptionsListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

var _AbstractRestaurantMenuComponent = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js");

var _AbstractRestaurantMenuComponent2 = _interopRequireDefault(_AbstractRestaurantMenuComponent);

var _ProductOptionRow = __webpack_require__("./scripts/pages/menu/options/components/ProductOptionRow.js");

var _ProductOptionRow2 = _interopRequireDefault(_ProductOptionRow);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var OptionsListPage = function (_AbstractRestaurantMe) {
  _inherits(OptionsListPage, _AbstractRestaurantMe);

  function OptionsListPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OptionsListPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OptionsListPage.__proto__ || Object.getPrototypeOf(OptionsListPage)).call.apply(_ref, [this].concat(args))), _this), _this.onAddOptionClicked = function () {
      var _this2;

      return (_this2 = _this).__onAddOptionClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OptionsListPage, [{
    key: '__onAddOptionClicked__REACT_HOT_LOADER__',
    value: function __onAddOptionClicked__REACT_HOT_LOADER__() {
      return this.__onAddOptionClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddOptionClicked__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onAddOptionClicked__REACT_HOT_LOADER__() {
      _actions.RouteAction.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_OPTION_NEW);
    }
  }, {
    key: 'renderCreateOptionBtn',
    value: function renderCreateOptionBtn() {
      if (!_SecurityContext2.default.restaurantMenu.canEditOptions()) {
        return null;
      }

      return _react2.default.createElement(_RoundButton2.default, {
        onClick: this.onAddOptionClicked,
        text: _I18n2.default.tr('menu.options_list.create_options')
      });
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      return _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.options_list.no_options')
        )
      );
    }
  }, {
    key: 'renderTheadContent',
    value: function renderTheadContent() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement('th', { className: 'hidden-sm col-md-1 text-left' }),
        _react2.default.createElement(
          'th',
          { className: 'col-md-3' },
          _I18n2.default.tr('menu.options_list.name')
        ),
        _react2.default.createElement('th', { className: 'col-md-1 text-right' })
      );
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this3 = this;

      var productOptionsListView = [];

      _lodash2.default.each(this.restaurantMenu.options, function (productOption) {
        productOptionsListView.push(_react2.default.createElement(_ProductOptionRow2.default, {
          productOption: productOption,
          restaurantMenu: _this3.restaurantMenu,
          key: productOption.id
        }));
      });

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-30 table_container' },
        _react2.default.createElement(
          'table',
          { className: 'table table-responsive table-hover' },
          _react2.default.createElement(
            'thead',
            null,
            this.renderTheadContent()
          ),
          _react2.default.createElement(
            'tbody',
            null,
            productOptionsListView
          )
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderCreateOptionBtn(),
        _lodash2.default.isEmpty(this.restaurantMenu.options) && this.renderEmpty(),
        !_lodash2.default.isEmpty(this.restaurantMenu.options) && this.renderList()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'categories_list' },
        this.renderBody()
      );
    }
  }]);

  return OptionsListPage;
}(_AbstractRestaurantMenuComponent2.default);

OptionsListPage.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired
};
exports.default = OptionsListPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OptionsListPage, 'OptionsListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/options/OptionsListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/options/components/ProductOptionRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


// -- views

var ProductOptionRow = function (_Component) {
  _inherits(ProductOptionRow, _Component);

  function ProductOptionRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionRow.__proto__ || Object.getPrototypeOf(ProductOptionRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onUp = function () {
      var _this3;

      return (_this3 = _this).__onUp__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDown = function () {
      var _this4;

      return (_this4 = _this).__onDown__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionRow, [{
    key: '__onDown__REACT_HOT_LOADER__',
    value: function __onDown__REACT_HOT_LOADER__() {
      return this.__onDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUp__REACT_HOT_LOADER__',
    value: function __onUp__REACT_HOT_LOADER__() {
      return this.__onUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.productOption.equals(this.props.productOption);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductOptionDetail(this.props.productOption);
    }
  }, {
    key: '__onUp__REACT_HOT_LOADER__',
    value: function __onUp__REACT_HOT_LOADER__() {}
  }, {
    key: '__onDown__REACT_HOT_LOADER__',
    value: function __onDown__REACT_HOT_LOADER__() {}
  }, {
    key: 'render',
    value: function render() {
      var productOption = this.props.productOption;

      return _react2.default.createElement(
        'tr',
        { className: 'option_row pointer' },
        _react2.default.createElement(
          'td',
          { className: 'option__name', onClick: this.onDisplayDetail },
          productOption.name
        ),
        _react2.default.createElement('td', {
          className: 'pointer col-md-1 text-center'
        }),
        _react2.default.createElement('td', {
          className: 'pointer col-md-1 text-center'
        })
      );
    }
  }]);

  return ProductOptionRow;
}(_react.Component);

ProductOptionRow.propTypes = {
  productOption: _propTypes2.default.objectOf(_ProductOption2.default).isRequired
};
var _default = ProductOptionRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionRow, 'ProductOptionRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/options/components/ProductOptionRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/options/components/ProductOptionRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/product/components/ProductDetailCategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var ProductDetailCategoryRow = function (_Component) {
  _inherits(ProductDetailCategoryRow, _Component);

  function ProductDetailCategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductDetailCategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductDetailCategoryRow.__proto__ || Object.getPrototypeOf(ProductDetailCategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductDetailCategoryRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.category);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      return _react2.default.createElement(
        'li',
        {
          onClick: this.onDisplayDetailClick
        },
        _react2.default.createElement(
          'h4',
          { className: 'link-hover' },
          this.category.name
        )
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }]);

  return ProductDetailCategoryRow;
}(_react.Component);

ProductDetailCategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired
};
var _default = ProductDetailCategoryRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductDetailCategoryRow, 'ProductDetailCategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/product/components/ProductDetailCategoryRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/product/components/ProductDetailCategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/product/components/ProductDetailMenuRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var ProductDetailMenuRow = function (_Component) {
  _inherits(ProductDetailMenuRow, _Component);

  function ProductDetailMenuRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductDetailMenuRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductDetailMenuRow.__proto__ || Object.getPrototypeOf(ProductDetailMenuRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductDetailMenuRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.menu.equals(this.props.menu);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenuDetail(this.menu);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      return _react2.default.createElement(
        'li',
        {
          onClick: this.onDisplayDetailClick
        },
        _react2.default.createElement(
          'h4',
          { className: 'link-hover' },
          this.menu.name
        )
      );
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }
  }]);

  return ProductDetailMenuRow;
}(_react.Component);

ProductDetailMenuRow.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired
};
var _default = ProductDetailMenuRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductDetailMenuRow, 'ProductDetailMenuRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/product/components/ProductDetailMenuRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/product/components/ProductDetailMenuRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/ProductEditPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _ProductEditView = __webpack_require__("./scripts/pages/menu/productEdit/ProductEditView.js");

var _ProductEditView2 = _interopRequireDefault(_ProductEditView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var ProductEditPage = function (_AbstractComponent) {
  _inherits(ProductEditPage, _AbstractComponent);

  function ProductEditPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductEditPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductEditPage.__proto__ || Object.getPrototypeOf(ProductEditPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _stores.RestaurantMenuStore.getRestaurantMenu(),
      restaurant: _stores.RestaurantStore.getRestaurant(),
      product: _this.isEditMode() ? null : new _menu.Product(),
      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onProductUpdated = function () {
      var _this3;

      return (_this3 = _this).__onProductUpdated__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onProductCreated = function () {
      var _this4;

      return (_this4 = _this).__onProductCreated__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onProductDeleted = function () {
      var _this5;

      return (_this5 = _this).__onProductDeleted__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onError = function () {
      var _this6;

      return (_this6 = _this).__onError__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onUpdateProduct = function () {
      var _this7;

      return (_this7 = _this).__onUpdateProduct__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onImageRemove = function () {
      var _this8;

      return (_this8 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onCreateProduct = function () {
      var _this9;

      return (_this9 = _this).__onCreateProduct__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onDeleteProduct = function () {
      var _this10;

      return (_this10 = _this).__onDeleteProduct__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductEditPage, [{
    key: '__onDeleteProduct__REACT_HOT_LOADER__',
    value: function __onDeleteProduct__REACT_HOT_LOADER__() {
      return this.__onDeleteProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCreateProduct__REACT_HOT_LOADER__',
    value: function __onCreateProduct__REACT_HOT_LOADER__() {
      return this.__onCreateProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateProduct__REACT_HOT_LOADER__',
    value: function __onUpdateProduct__REACT_HOT_LOADER__() {
      return this.__onUpdateProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductDeleted__REACT_HOT_LOADER__',
    value: function __onProductDeleted__REACT_HOT_LOADER__() {
      return this.__onProductDeleted__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductCreated__REACT_HOT_LOADER__',
    value: function __onProductCreated__REACT_HOT_LOADER__() {
      return this.__onProductCreated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductUpdated__REACT_HOT_LOADER__',
    value: function __onProductUpdated__REACT_HOT_LOADER__() {
      return this.__onProductUpdated__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

      if (!_SecurityContext2.default.restaurantMenu.canEdit) {
        // TODO: redirect
      }

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        _actions.RestaurantMenuAction.loadRestaurantMenu();
      } else if (this.isEditMode()) {
        this.loadProduct();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'loadProduct',
    value: function loadProduct() {
      var product = this.getProductOnRestaurantMenu(this.state.restaurantMenu);

      // TODO: if product === null redirect to 404.
      this.setState({
        product: product,
        loading: false
      });
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();

      if (this.isEditMode()) {
        var product = this.getProductOnRestaurantMenu(restaurantMenu);
        this.setState({
          restaurantMenu: restaurantMenu,
          product: product,
          loading: false
        });
      } else {
        this.setState({
          restaurantMenu: restaurantMenu,
          loading: false
        });
      }
    }
  }, {
    key: '__onProductUpdated__REACT_HOT_LOADER__',
    value: function __onProductUpdated__REACT_HOT_LOADER__() {
      if (this.isEditMode()) {
        var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
        var product = this.getProductOnRestaurantMenu(restaurantMenu);

        this.setState({
          restaurantMenu: restaurantMenu,
          product: product,
          loading: false
        });
      }
    }
  }, {
    key: '__onProductCreated__REACT_HOT_LOADER__',
    value: function __onProductCreated__REACT_HOT_LOADER__() {
      var restaurantMenu = _stores.RestaurantMenuStore.getRestaurantMenu();
      var product = _stores.RestaurantMenuStore.getCreatedProduct();
      _actions.RouteAction.presentProductEdit(product);

      this.setState({
        restaurantMenu: restaurantMenu,
        product: product,
        loading: false
      });
    }
  }, {
    key: '__onProductDeleted__REACT_HOT_LOADER__',
    value: function __onProductDeleted__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductsTab();
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _stores.RestaurantMenuStore.getApiError()
      });
    }
  }, {
    key: '__onUpdateProduct__REACT_HOT_LOADER__',
    value: function __onUpdateProduct__REACT_HOT_LOADER__(product, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _ViewUtils2.default.dataUriToFile(image);
      _actions.RestaurantMenuAction.saveProduct(product, imageFile);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__(product) {
      this.showLoading();
      _actions.RestaurantMenuAction.deleteProductImage(product);
    }
  }, {
    key: '__onCreateProduct__REACT_HOT_LOADER__',
    value: function __onCreateProduct__REACT_HOT_LOADER__(product, image) {
      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _ViewUtils2.default.dataUriToFile(image);
      _actions.RestaurantMenuAction.createProduct(product, imageFile);
    }
  }, {
    key: '__onDeleteProduct__REACT_HOT_LOADER__',
    value: function __onDeleteProduct__REACT_HOT_LOADER__(product) {
      // TODO
      this.showLoading();
      _actions.RestaurantMenuAction.deleteProduct(product);
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return !_lodash2.default.isUndefined(this.props.params.productId);
    }
  }, {
    key: 'getProductOnRestaurantMenu',
    value: function getProductOnRestaurantMenu(restaurantMenu) {
      var productId = this.props.params.productId;
      var product = restaurantMenu.getProductWithId(productId);

      return product;
    }

    // -- renderers

  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.product)) {
        return this.renderLoading(true);
      }

      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.products'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.PRODUCTS
        }
      }];

      if (this.isEditMode()) {
        arianeDetails.push({
          name: this.product.name,
          link: _RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_DETAIL,
          params: {
            productId: this.product.id
          }
        });
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.edition'),
          link: null
        });
      } else {
        arianeDetails.push({
          name: _I18n2.default.tr('menu.order.restaurant_menu.new'),
          link: null
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        _react2.default.createElement(_ProductEditView2.default, {
          product: this.product,
          restaurantMenu: this.restaurantMenu,
          onUpdate: this.onUpdateProduct,
          onImageRemove: this.onImageRemove,
          onCreate: this.onCreateProduct,
          onDelete: this.onDeleteProduct,
          isEditMode: this.isEditMode(),
          orderSettings: _stores.OrderSettingsStore.getOrderSettings(),
          currencyCode: this.state.restaurant.currency
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'product_detail_page' },
          this.renderBody(),
          this.renderLoading()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onProductUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_SUCCESS, this.onProductUpdated), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS, this.onProductUpdated), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_SUCCESS, this.onProductCreated), new _Listener2.default(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_SUCCESS, this.onProductDeleted), new _Listener2.default(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_ERROR, this.onError)];
    }
  }, {
    key: 'product',
    get: function get() {
      return this.state.product;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }]);

  return ProductEditPage;
}(_AbstractComponent3.default);

exports.default = ProductEditPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductEditPage, 'ProductEditPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/ProductEditPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/ProductEditView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _restaurantMenu = __webpack_require__("./scripts/components/restaurantMenu/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _AllergenChooser = __webpack_require__("./sdk/scripts/components/form/AllergenChooser.js");

var _AllergenChooser2 = _interopRequireDefault(_AllergenChooser);

var _CategoryRow = __webpack_require__("./scripts/pages/menu/productEdit/components/CategoryRow.js");

var _CategoryRow2 = _interopRequireDefault(_CategoryRow);

var _MenuRow = __webpack_require__("./scripts/pages/menu/productEdit/components/MenuRow.js");

var _MenuRow2 = _interopRequireDefault(_MenuRow);

var _ProductOptionRow = __webpack_require__("./scripts/pages/menu/productEdit/components/ProductOptionRow.js");

var _ProductOptionRow2 = _interopRequireDefault(_ProductOptionRow);

var _ProductDetailCategoryRow = __webpack_require__("./scripts/pages/menu/product/components/ProductDetailCategoryRow.js");

var _ProductDetailCategoryRow2 = _interopRequireDefault(_ProductDetailCategoryRow);

var _ProductDetailMenuRow = __webpack_require__("./scripts/pages/menu/product/components/ProductDetailMenuRow.js");

var _ProductDetailMenuRow2 = _interopRequireDefault(_ProductDetailMenuRow);

var _SelectProductOptionsModal = __webpack_require__("./scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModal.js");

var _SelectProductOptionsModal2 = _interopRequireDefault(_SelectProductOptionsModal);

var _AvailabilityDatesForm = __webpack_require__("./scripts/pages/menu/components/availabilityDates/AvailabilityDatesForm.js");

var _AvailabilityDatesForm2 = _interopRequireDefault(_AvailabilityDatesForm);

var _AvailabilityHoursForm = __webpack_require__("./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForm.js");

var _AvailabilityHoursForm2 = _interopRequireDefault(_AvailabilityHoursForm);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// -- constants


// -- utils


// -- entities


// -- views


var ProductEditView = function (_AbstractRestaurantMe) {
  _inherits(ProductEditView, _AbstractRestaurantMe);

  function ProductEditView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductEditView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductEditView.__proto__ || Object.getPrototypeOf(ProductEditView)).call.apply(_ref, [this].concat(args))), _this), _this.onProductChange = function () {
      var _this2;

      return (_this2 = _this).__onProductChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDisplaySelectProductOptionsModal = function () {
      var _this3;

      return (_this3 = _this).__onDisplaySelectProductOptionsModal__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onHideSelectProductOptionsModal = function () {
      var _this4;

      return (_this4 = _this).__onHideSelectProductOptionsModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onImageChange = function () {
      var _this5;

      return (_this5 = _this).__onImageChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDeleteProduct = function () {
      var _this6;

      return (_this6 = _this).__onDeleteProduct__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onProductChange = function () {
      var _this7;

      return (_this7 = _this).__onProductChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onNameChange = function () {
      var _this8;

      return (_this8 = _this).__onNameChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onDescriptionProductChange = function () {
      var _this9;

      return (_this9 = _this).__onDescriptionProductChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onPricesChange = function () {
      var _this10;

      return (_this10 = _this).__onPricesChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onDisponibilityToggle = function () {
      var _this11;

      return (_this11 = _this).__onDisponibilityToggle__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onDeleteFromMenu = function () {
      var _this12;

      return (_this12 = _this).__onDeleteFromMenu__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this13;

      return (_this13 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onDeleteProductOption = function () {
      var _this14;

      return (_this14 = _this).__onDeleteProductOption__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onSelectProductOptionss = function () {
      var _this15;

      return (_this15 = _this).__onSelectProductOptionss__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onProductOptionsOrderChange = function () {
      var _this16;

      return (_this16 = _this).__onProductOptionsOrderChange__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onAvailibilityHoursChange = function () {
      var _this17;

      return (_this17 = _this).__onAvailibilityHoursChange__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onToggleAvailibilityHoursChange = function () {
      var _this18;

      return (_this18 = _this).__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.onAvailibilityDatesChange = function () {
      var _this19;

      return (_this19 = _this).__onAvailibilityDatesChange__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _this.onToggleAvailibilityDatesChange = function () {
      var _this20;

      return (_this20 = _this).__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__.apply(_this20, arguments);
    }, _this.onAllergensChange = function () {
      var _this21;

      return (_this21 = _this).__onAllergensChange__REACT_HOT_LOADER__.apply(_this21, arguments);
    }, _this.onContainsAlcoholChange = function () {
      var _this22;

      return (_this22 = _this).__onContainsAlcoholChange__REACT_HOT_LOADER__.apply(_this22, arguments);
    }, _this.onChangeSequence = function () {
      var _this23;

      return (_this23 = _this).__onChangeSequence__REACT_HOT_LOADER__.apply(_this23, arguments);
    }, _this.onToggleReclaimLater = function () {
      var _this24;

      return (_this24 = _this).__onToggleReclaimLater__REACT_HOT_LOADER__.apply(_this24, arguments);
    }, _this.onSubmit = function () {
      var _this25;

      return (_this25 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this25, arguments);
    }, _this.onReset = function () {
      var _this26;

      return (_this26 = _this).__onReset__REACT_HOT_LOADER__.apply(_this26, arguments);
    }, _this.onImageRemove = function () {
      var _this27;

      return (_this27 = _this).__onImageRemove__REACT_HOT_LOADER__.apply(_this27, arguments);
    }, _this.renderProductOptionRow = function () {
      var _this28;

      return (_this28 = _this).__renderProductOptionRow__REACT_HOT_LOADER__.apply(_this28, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductEditView, [{
    key: '__renderProductOptionRow__REACT_HOT_LOADER__',
    value: function __renderProductOptionRow__REACT_HOT_LOADER__() {
      return this.__renderProductOptionRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      return this.__onImageRemove__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleReclaimLater__REACT_HOT_LOADER__',
    value: function __onToggleReclaimLater__REACT_HOT_LOADER__() {
      return this.__onToggleReclaimLater__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeSequence__REACT_HOT_LOADER__',
    value: function __onChangeSequence__REACT_HOT_LOADER__() {
      return this.__onChangeSequence__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onContainsAlcoholChange__REACT_HOT_LOADER__',
    value: function __onContainsAlcoholChange__REACT_HOT_LOADER__() {
      return this.__onContainsAlcoholChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAllergensChange__REACT_HOT_LOADER__',
    value: function __onAllergensChange__REACT_HOT_LOADER__() {
      return this.__onAllergensChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityDatesChange__REACT_HOT_LOADER__() {
      return this.__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityDatesChange__REACT_HOT_LOADER__() {
      return this.__onAvailibilityDatesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityHoursChange__REACT_HOT_LOADER__() {
      return this.__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityHoursChange__REACT_HOT_LOADER__() {
      return this.__onAvailibilityHoursChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductOptionsOrderChange__REACT_HOT_LOADER__',
    value: function __onProductOptionsOrderChange__REACT_HOT_LOADER__() {
      return this.__onProductOptionsOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectProductOptionss__REACT_HOT_LOADER__',
    value: function __onSelectProductOptionss__REACT_HOT_LOADER__() {
      return this.__onSelectProductOptionss__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductOption__REACT_HOT_LOADER__',
    value: function __onDeleteProductOption__REACT_HOT_LOADER__() {
      return this.__onDeleteProductOption__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteFromMenu__REACT_HOT_LOADER__',
    value: function __onDeleteFromMenu__REACT_HOT_LOADER__() {
      return this.__onDeleteFromMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisponibilityToggle__REACT_HOT_LOADER__',
    value: function __onDisponibilityToggle__REACT_HOT_LOADER__() {
      return this.__onDisponibilityToggle__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPricesChange__REACT_HOT_LOADER__',
    value: function __onPricesChange__REACT_HOT_LOADER__() {
      return this.__onPricesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDescriptionProductChange__REACT_HOT_LOADER__',
    value: function __onDescriptionProductChange__REACT_HOT_LOADER__() {
      return this.__onDescriptionProductChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__() {
      return this.__onNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductChange__REACT_HOT_LOADER__',
    value: function __onProductChange__REACT_HOT_LOADER__() {
      return this.__onProductChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProduct__REACT_HOT_LOADER__',
    value: function __onDeleteProduct__REACT_HOT_LOADER__() {
      return this.__onDeleteProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__() {
      return this.__onImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideSelectProductOptionsModal__REACT_HOT_LOADER__',
    value: function __onHideSelectProductOptionsModal__REACT_HOT_LOADER__() {
      return this.__onHideSelectProductOptionsModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplaySelectProductOptionsModal__REACT_HOT_LOADER__',
    value: function __onDisplaySelectProductOptionsModal__REACT_HOT_LOADER__() {
      return this.__onDisplaySelectProductOptionsModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductChange__REACT_HOT_LOADER__',
    value: function __onProductChange__REACT_HOT_LOADER__() {
      return this.__onProductChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(ProductEditView.prototype.__proto__ || Object.getPrototypeOf(ProductEditView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.product.equals(nextProps.product);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        product: props.product.copy(),

        image: null,

        validationErrors: [],

        // Modal

        displaySelectProductOptionsModal: false
      };
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return this.props.isEditMode;
    }
  }, {
    key: '__onProductChange__REACT_HOT_LOADER__',


    //
    // Modal - Add Option
    //

    value: function __onProductChange__REACT_HOT_LOADER__(product) {
      this.setState({
        product: product
      });
    }
  }, {
    key: '__onDisplaySelectProductOptionsModal__REACT_HOT_LOADER__',
    value: function __onDisplaySelectProductOptionsModal__REACT_HOT_LOADER__(event) {
      event.preventDefault();
      this.setState({
        displaySelectProductOptionsModal: true
      });
    }
  }, {
    key: '__onHideSelectProductOptionsModal__REACT_HOT_LOADER__',


    //
    // Events image
    //

    value: function __onHideSelectProductOptionsModal__REACT_HOT_LOADER__() {
      this.setState({
        displaySelectProductOptionsModal: false
      });
    }
  }, {
    key: '__onImageChange__REACT_HOT_LOADER__',
    value: function __onImageChange__REACT_HOT_LOADER__(pictureData) {
      this.setState({
        image: pictureData
      });
    }
  }, {
    key: '__onDeleteProduct__REACT_HOT_LOADER__',
    value: function __onDeleteProduct__REACT_HOT_LOADER__(event) {
      var _this29 = this;

      event.preventDefault();

      _Notify2.default.confirm(_I18n2.default.tr('menu.product.edit.confirm_delete_product'), function (result) {
        if (result) {
          _this29.props.onDelete(_this29.props.product);
        }
      });
    }
  }, {
    key: '__onProductChange__REACT_HOT_LOADER__',
    value: function __onProductChange__REACT_HOT_LOADER__(product) {
      if (_SecurityContext2.default.restaurantMenu.canEdit()) {
        this.setState({
          product: product
        });
      }
    }
  }, {
    key: '__onNameChange__REACT_HOT_LOADER__',
    value: function __onNameChange__REACT_HOT_LOADER__(newValue) {
      var product = this.product;
      product.localizedNames = newValue;
      this.onProductChange(product);
    }
  }, {
    key: '__onDescriptionProductChange__REACT_HOT_LOADER__',
    value: function __onDescriptionProductChange__REACT_HOT_LOADER__(newValue) {
      var product = this.product;
      product.localizedDescriptions = newValue;
      this.onProductChange(product);
    }
  }, {
    key: '__onPricesChange__REACT_HOT_LOADER__',
    value: function __onPricesChange__REACT_HOT_LOADER__(prices) {
      var product = this.product;
      product.prices = prices;
      this.onProductChange(product);
    }
  }, {
    key: '__onDisponibilityToggle__REACT_HOT_LOADER__',
    value: function __onDisponibilityToggle__REACT_HOT_LOADER__() {
      var product = this.product;
      product.toggleAvailibility();
      this.setState({
        product: product
      });
    }
  }, {
    key: '__onDeleteFromMenu__REACT_HOT_LOADER__',
    value: function __onDeleteFromMenu__REACT_HOT_LOADER__(menu) {
      _Notify2.default.confirm(_I18n2.default.tr('menu.product.edit.confirm_delete_product_from_menu'), function (result) {
        if (result) {
          // TODO
        }
      });
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__(category) {
      _Notify2.default.confirm(_I18n2.default.tr('menu.product.edit.confirm_delete_product_from_category'), function (result) {
        if (result) {
          // TODO
        }
      });
    }
  }, {
    key: '__onDeleteProductOption__REACT_HOT_LOADER__',
    value: function __onDeleteProductOption__REACT_HOT_LOADER__(productOption) {
      var _this30 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.product.edit.confirm_delete_option'), function (result) {
        if (result) {
          var product = _this30.product;
          product.optionsIds = _utils.ArrayUtils.deleteObject(product.optionsIds, function (productOptionId) {
            return productOptionId === productOption.id;
          });
          _this30.onProductChange(product);
        }
      });
    }
  }, {
    key: '__onSelectProductOptionss__REACT_HOT_LOADER__',
    value: function __onSelectProductOptionss__REACT_HOT_LOADER__(productOptionsList) {
      var optionsIds = [];
      _lodash2.default.each(productOptionsList, function (productOption) {
        optionsIds.push(productOption.id);
      });

      var product = this.product;
      product.optionsIds = optionsIds;
      this.setState({
        product: product,
        displaySelectProductOptionsModal: false
      });
    }
  }, {
    key: '__onProductOptionsOrderChange__REACT_HOT_LOADER__',
    value: function __onProductOptionsOrderChange__REACT_HOT_LOADER__(optionsIds) {
      var product = this.product;
      product.optionsIds = optionsIds;
      this.onProductChange(product);
    }
  }, {
    key: '__onAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityHoursChange__REACT_HOT_LOADER__(availabilityHours) {
      var product = this.product;
      product.availabilityHours = availabilityHours;
      this.onProductChange(product);
    }
  }, {
    key: '__onToggleAvailibilityHoursChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityHoursChange__REACT_HOT_LOADER__() {
      var product = this.product;
      if (_lodash2.default.isNull(product.availabilityHours)) {
        product.availabilityHours = new _menu.AvailabilityHours();
      } else {
        product.availabilityHours = null;
      }

      this.onProductChange(product);
    }
  }, {
    key: '__onAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onAvailibilityDatesChange__REACT_HOT_LOADER__(availabilityDates) {
      var product = this.product;
      product.availabilityDates = availabilityDates;
      this.onProductChange(product);
    }
  }, {
    key: '__onToggleAvailibilityDatesChange__REACT_HOT_LOADER__',
    value: function __onToggleAvailibilityDatesChange__REACT_HOT_LOADER__() {
      var product = this.product;
      product.availabilityDates = _lodash2.default.isNull(product.availabilityDates) ? new _menu.AvailabilityDates() : null;
      this.onProductChange(product);
    }
  }, {
    key: '__onAllergensChange__REACT_HOT_LOADER__',
    value: function __onAllergensChange__REACT_HOT_LOADER__(allergens) {
      var product = this.product;
      if (!product.dietaryData) {
        product.dietaryInfo = {};
      }
      product.dietaryInfo.allergens = allergens;
      this.onProductChange(product);
    }
  }, {
    key: '__onContainsAlcoholChange__REACT_HOT_LOADER__',
    value: function __onContainsAlcoholChange__REACT_HOT_LOADER__() {
      var product = this.product;
      product.containsAlcohol = !product.containsAlcohol;
      this.onProductChange(product);
    }
  }, {
    key: '__onChangeSequence__REACT_HOT_LOADER__',
    value: function __onChangeSequence__REACT_HOT_LOADER__(value) {
      var product = this.product;
      product.defaultSequence = value;
      this.onProductChange(product);
    }
  }, {
    key: '__onToggleReclaimLater__REACT_HOT_LOADER__',


    //
    // Events form
    //

    value: function __onToggleReclaimLater__REACT_HOT_LOADER__() {
      var product = this.product;
      product.reclaimLaterEnabled = !product.reclaimLaterEnabled;
      this.onProductChange(product);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var _this31 = this;

      event.preventDefault();

      var product = this.product;

      /**
       * We need to create a unique pos id if  we create a new product
       */
      if (!this.isEditMode()) {
        product.id = _utils.Utils.generateUID();

        /**
         * Activated by default.
         * @type {boolean}
         */
        //    product.activated = true;
      } else {
        product.id = this.props.product.id;
      }

      _lodash2.default.keys(this.product.availabilityHours).map(function (day) {
        _this31.product.availabilityHours[day].hours = _this31.product.availabilityHours[day].hours.filter(function (hour) {
          return !_lodash2.default.isNull(hour.opening) || !_lodash2.default.isNull(hour.closing);
        });
      });

      if (product.isValid()) {
        if (this.isEditMode()) {
          this.props.onUpdate(this.product, this.state.image);
        } else {
          this.props.onCreate(this.product, this.state.image);
        }
      } else {
        var validationErrors = product.getValidationErrors();
        this.setState({
          validationErrors: validationErrors
        });
      }
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        product: this.props.product.copy(),
        image: null
      });
    }
  }, {
    key: '__onImageRemove__REACT_HOT_LOADER__',
    value: function __onImageRemove__REACT_HOT_LOADER__() {
      this.props.onImageRemove(this.product);
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.props.product.equals(this.state.product) || !_lodash2.default.isNull(this.state.image);
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return false;
    }

    //
    // getters
    //

  }, {
    key: 'renderName',


    //
    // renderers
    //

    value: function renderName() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.product.edit.name')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: this.product.localizedNames,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.product.edit.name'),
            onChange: this.onNameChange,
            readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.name
        )
      );
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.product.edit.description')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          _react2.default.createElement(_form.TextInputLocalized, {
            multiLine: true,
            locales: _Constants2.default.localesForTranslation,
            values: this.product.localizedDescriptions,
            isRequired: true,
            className: 'form-control',
            placeholder: _I18n2.default.tr('menu.product.edit.description'),
            onChange: this.onDescriptionProductChange,
            readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-6 col-xs-offset-4' },
          this.state.validationErrors.description
        )
      );
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      return _react2.default.createElement(_form.ImageDropzone, {
        editOnly: false,
        readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
        placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT,
        image: this.product.image,
        currentImage: this.state.image,
        onChange: this.onImageChange,
        onRemove: this.onImageRemove,
        aspectRatio: _ApiConstants2.default.Image.RestaurantMenu.Product.RATIO,
        width: _ApiConstants2.default.Image.RestaurantMenu.Product.WIDTH,
        height: _ApiConstants2.default.Image.RestaurantMenu.Product.HEIGHT,
        maxSize: _ApiConstants2.default.Image.RestaurantMenu.Product.MAX_SIZE
      });
    }
  }, {
    key: 'renderAllergen',
    value: function renderAllergen() {
      return _react2.default.createElement(_AllergenChooser2.default, {
        allergens: this.product.dietaryInfo ? this.product.dietaryInfo.allergens : [],
        readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
        onChange: this.onAllergensChange
      });
    }
  }, {
    key: 'renderContainsAlcohol',
    value: function renderContainsAlcohol() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-10 col-md-3' },
          _react2.default.createElement(
            'p',
            { className: 'sequences_subtitle_caption' },
            _I18n2.default.tr('menu.product.edit.containsAlcohol.label')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-2' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            value: this.product.containsAlcohol,
            bsSize: 'mini',
            onChange: this.onContainsAlcoholChange,
            disabled: disableModification
          })
        )
      );
    }
  }, {
    key: 'renderPrices',
    value: function renderPrices() {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(_restaurantMenu.PricesEditor, {
            prices: this.product.prices,
            onChange: this.onPricesChange,
            disablePriceModification: this.props.orderSettings.menuManagedByPos,
            readOnly: !_SecurityContext2.default.restaurantMenu.canEdit(),
            currencyCode: this.props.currencyCode
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form_error col-xs-12' },
          this.state.validationErrors.prices
        )
      );
    }
  }, {
    key: 'renderDeleteProduct',
    value: function renderDeleteProduct() {
      if (this.props.orderSettings.menuManagedByPos) {
        return null;
      }

      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return _react2.default.createElement(
          'div',
          { className: 'col-xs-12 text-center top-buffer-50' },
          _I18n2.default.tr('menu.product.edit.delete_product.permission_refused')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 text-center top-buffer-50' },
        _react2.default.createElement('hr', null),
        this.isEditMode() && // only on edit mode
        _react2.default.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-danger',
            onClick: this.onDeleteProduct
          },
          _I18n2.default.tr('menu.product.edit.delete_product')
        )
      );
    }
  }, {
    key: 'renderCategoriesList',
    value: function renderCategoriesList() {
      var _this32 = this;

      var categories = this.restaurantMenu.getCategoriesWithProductId(this.product.id);

      if (_lodash2.default.isEmpty(categories)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-20' },
            _react2.default.createElement(
              'em',
              null,
              _I18n2.default.tr('menu.product.edit.no_category_with_product')
            )
          )
        );
      }

      var categoriesListView = [];

      _lodash2.default.each(categories, function (category) {
        categoriesListView.push(_react2.default.createElement(_CategoryRow2.default, {
          key: category.id,
          category: category,
          onDelete: _this32.onDeleteFromCategory
        }));
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          categoriesListView
        )
      );
    }
  }, {
    key: 'renderCategoriesListRow',
    value: function renderCategoriesListRow() {
      var categories = this.restaurantMenu.getCategoriesWithProductId(this.product.id);

      if (_lodash2.default.isEmpty(categories)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-20' },
            _react2.default.createElement(
              'em',
              null,
              _I18n2.default.tr('menu.product.edit.no_category_with_product')
            )
          )
        );
      }

      var categoriesListView = [];

      _lodash2.default.each(categories, function (category) {
        categoriesListView.push(_react2.default.createElement(_ProductDetailCategoryRow2.default, { key: category.id, category: category }));
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          categoriesListView
        )
      );
    }
  }, {
    key: 'renderMenusList',
    value: function renderMenusList() {
      var menus = this.restaurantMenu.getMenusWithProductId(this.product.id);

      if (_lodash2.default.isEmpty(menus)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.product.no_menu_with_product')
          )
        );
      }

      var menusListView = [];

      _lodash2.default.each(menus, function (menu) {
        menusListView.push(_react2.default.createElement(_ProductDetailMenuRow2.default, { key: menu.id, menu: menu }));
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          menusListView
        )
      );
    }
  }, {
    key: 'renderSelectProductOptionsBtn',
    value: function renderSelectProductOptionsBtn() {
      if (!_SecurityContext2.default.restaurantMenu.canEditOptions()) {
        return null;
      }
      return _react2.default.createElement(
        'button',
        {
          className: 'btn btn-xs',
          onClick: this.onDisplaySelectProductOptionsModal
        },
        _I18n2.default.tr('menu.product.edit.select_options')
      );
    }
  }, {
    key: '__renderProductOptionRow__REACT_HOT_LOADER__',
    value: function __renderProductOptionRow__REACT_HOT_LOADER__(optionId) {
      var productOption = this.restaurantMenu.getProductOptionWithId(optionId);

      if (!_lodash2.default.isNull(productOption)) {
        return _react2.default.createElement(_ProductOptionRow2.default, {
          key: productOption.id,
          productOption: productOption,
          onDelete: this.onDeleteProductOption,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEditOptions()
        });
      }
      return null;
    }
  }, {
    key: 'renderProductOptionsList',
    value: function renderProductOptionsList() {
      var _this33 = this;

      if (_lodash2.default.isEmpty(this.product.optionsIds)) {
        return _react2.default.createElement(
          'div',
          null,
          _SecurityContext2.default.restaurantMenu.canEditOptions() && this.renderSelectProductOptionsBtn(),
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-20' },
            _react2.default.createElement(
              'em',
              null,
              _I18n2.default.tr('menu.product.edit.no_options')
            )
          )
        );
      }

      if (!_SecurityContext2.default.restaurantMenu.canEditOptions()) {
        return _react2.default.createElement(
          'ul',
          null,
          this.product.optionsIds.map(function (optionId) {
            var productOption = _this33.restaurantMenu.getProductOptionWithId(optionId);

            if (!_lodash2.default.isNull(productOption)) {
              return _react2.default.createElement(
                'li',
                {
                  key: optionId,
                  className: 'pointer',
                  onClick: function onClick() {
                    _actions.RouteAction.presentProductOptionDetail(productOption);
                  }
                },
                productOption.name
              );
            }

            return null;
          })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderSelectProductOptionsBtn(),
        _react2.default.createElement(
          'div',
          { className: 'table_container table_container_hover col-xs-12 top-buffer-20' },
          _react2.default.createElement(_SortableList2.default, {
            items: this.product.optionsIds,
            renderer: this.renderProductOptionRow,
            onChange: this.onProductOptionsOrderChange
          })
        )
      );
    }
  }, {
    key: 'renderSelectProductOptionsModal',
    value: function renderSelectProductOptionsModal() {
      if (!this.state.displaySelectProductOptionsModal) {
        return null;
      }

      var selectedProductOptions = this.restaurantMenu.getProductOptionsWithIds(this.product.optionsIds);

      return _react2.default.createElement(_SelectProductOptionsModal2.default, {
        restaurantMenu: this.restaurantMenu,
        show: this.state.displaySelectProductOptionsModal,
        onHide: this.onHideSelectProductOptionsModal,
        onUpdate: this.onSelectProductOptionss,
        selectedProductOptions: selectedProductOptions
      });
    }
  }, {
    key: 'renderAvailibility',
    value: function renderAvailibility() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('hr', { className: 'col-xs-12' }),
        _react2.default.createElement(
          'div',
          { className: 'availability_title' },
          _react2.default.createElement(
            'h2',
            { className: 'col-xs-12' },
            _I18n2.default.tr('menu.product_edit.product_availability')
          ),
          _react2.default.createElement(
            'p',
            { className: 'col-xs-12 availability_intro' },
            _I18n2.default.tr('menu.product_edit.product_availability.caption')
          )
        ),
        this.renderAvailibilityDate(),
        this.renderAvailibilityHours()
      );
    }
  }, {
    key: 'renderAvailibilityDate',
    value: function renderAvailibilityDate() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'availability_title' },
          _react2.default.createElement(
            'h4',
            { className: 'col-xs-8' },
            _I18n2.default.tr('menu.product_edit.product_availability_date')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-2 top-buffer-10' },
            _react2.default.createElement(_reactBootstrapSwitch2.default, {
              value: !_lodash2.default.isNull(this.product.availabilityDates),
              bsSize: 'mini',
              onChange: this.onToggleAvailibilityDatesChange,
              disabled: disableModification
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'col-xs-12 availability_intro caption' },
          _I18n2.default.tr('menu.product_edit.product_availability_date.caption')
        ),
        !_lodash2.default.isNull(this.product.availabilityDates) && _react2.default.createElement(_AvailabilityDatesForm2.default, {
          availabilityDates: this.product.availabilityDates,
          onAvailibilityDatesChange: this.onAvailibilityDatesChange,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
        })
      );
    }
  }, {
    key: 'renderAvailibilityHours',
    value: function renderAvailibilityHours() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'availability_title' },
          _react2.default.createElement(
            'h4',
            { className: 'col-xs-8' },
            _I18n2.default.tr('menu.product_edit.product_availability_hours')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-2 top-buffer-10' },
            _react2.default.createElement(_reactBootstrapSwitch2.default, {
              value: !_lodash2.default.isNull(this.product.availabilityHours),
              bsSize: 'mini',
              onChange: this.onToggleAvailibilityHoursChange,
              disabled: disableModification
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'col-xs-12 availability_intro caption' },
          _I18n2.default.tr('menu.product_edit.product_availability_hours.caption')
        ),
        !_lodash2.default.isNull(this.product.availabilityHours) && _react2.default.createElement(_AvailabilityHoursForm2.default, {
          availabilityHours: this.product.availabilityHours,
          onAvailibilityHoursChange: this.onAvailibilityHoursChange,
          readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
        })
      );
    }
  }, {
    key: 'renderSequences',
    value: function renderSequences() {
      var disableModification = !_SecurityContext2.default.restaurantMenu.canEdit();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('hr', { className: 'col-xs-12' }),
        _react2.default.createElement(
          'div',
          { className: 'sequences_title col-xs-12' },
          _react2.default.createElement(
            'h2',
            null,
            _I18n2.default.tr('menu.product_edit.sequences')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'sequences_subtitle col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-10 col-md-3' },
              _react2.default.createElement(
                'p',
                { className: 'sequences_subtitle_caption' },
                _I18n2.default.tr('menu.product_edit.default_sequence'),
                _react2.default.createElement(_TipTooltip2.default, { text: _I18n2.default.tr('menu.product_edit.default_sequence.tooltip') })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-2 sequences_input' },
              _react2.default.createElement(_form.NumberInput, {
                value: this.product.defaultSequence,
                onChange: this.onChangeSequence,
                min: 0,
                disabled: disableModification || this.props.orderSettings.menuManagedByPos
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'sequences_subtitle col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-10 col-md-3' },
              _react2.default.createElement(
                'p',
                { className: 'sequences_subtitle_caption' },
                _I18n2.default.tr('menu.product_edit.reclaim_later'),
                _react2.default.createElement(_TipTooltip2.default, {
                  text: _I18n2.default.tr('menu.product_edit.reclaim_later.tooltip')
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-2' },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                value: this.product.reclaimLaterEnabled,
                bsSize: 'mini',
                onChange: this.onToggleReclaimLater,
                disabled: disableModification
              })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'form',
          {
            className: 'form form-horizontal product_edit_view',
            role: 'form',
            noValidate: true
          },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              this.renderName(),
              this.renderDescription(),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                this.renderImage()
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-6' },
                _react2.default.createElement(
                  'h2',
                  null,
                  _I18n2.default.tr('menu.product.edit.categories')
                ),
                this.renderCategoriesListRow()
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-6' },
                _react2.default.createElement(
                  'h2',
                  null,
                  _I18n2.default.tr('menu.product.edit.menus')
                ),
                this.renderMenusList()
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-sm-12' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.product.edit.allergen')
              ),
              this.renderAllergen()
            )
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-sm-12 col-md-8' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.product.edit.prices')
              ),
              this.renderPrices()
            ),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-40 col-sm-12 col-md-4' },
              _react2.default.createElement(
                'h2',
                null,
                _I18n2.default.tr('menu.product.edit.options')
              ),
              this.renderProductOptionsList()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderAvailibility()
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderSequences()
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('hr', { className: 'col-xs-12' }),
              _react2.default.createElement(
                'div',
                { className: 'sequences_title col-xs-12' },
                _react2.default.createElement(
                  'h2',
                  null,
                  _I18n2.default.tr('menu.product.edit.other')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'sequences_subtitle col-xs-12' },
                this.renderContainsAlcohol()
              )
            )
          ),
          this.renderDeleteProduct(),
          this.renderFixedButtons(),
          this.renderSelectProductOptionsModal()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'product',
    get: function get() {
      return this.state.product;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }]);

  return ProductEditView;
}(_AbstractRestaurantMenuForm2.default);

ProductEditView.propTypes = {
  product: _propTypes2.default.objectOf(_menu.Product).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  /**
   * @param: Product
   * @param: image blob
   */
  onUpdate: _propTypes2.default.func.isRequired,

  /**
   * @param: Product
   * @param: image blob
   */
  onCreate: _propTypes2.default.func.isRequired,

  /**
   * @param: Product
   */
  onDelete: _propTypes2.default.func.isRequired,

  isEditMode: _propTypes2.default.bool.isRequired,

  currencyCode: _propTypes2.default.string
};
exports.default = ProductEditView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductEditView, 'ProductEditView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/ProductEditView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/components/CategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var CategoryRow = function (_Component) {
  _inherits(CategoryRow, _Component);

  function CategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryRow.__proto__ || Object.getPrototypeOf(CategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.category.equals(this.props.category);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentCategoryDetail(this.category);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'h4',
          { className: 'link-hover',
            onClick: this.onDisplayDetailClick
          },
          this.category.name
        ),
        _react2.default.createElement('i', {
          onClick: function onClick() {
            _this3.props.onDelete(_this3.props.category);
          },
          className: 'fa fa-trash pointer'
        })
      );
    }
  }, {
    key: 'category',
    get: function get() {
      return this.props.category;
    }
  }]);

  return CategoryRow;
}(_react.Component);

CategoryRow.propTypes = {
  category: _propTypes2.default.objectOf(_ProductCategory2.default).isRequired,

  onDelete: _propTypes2.default.func.isRequired
};
exports.default = CategoryRow;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryRow, 'CategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/components/CategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/components/MenuRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var MenuRow = function (_Component) {
  _inherits(MenuRow, _Component);

  function MenuRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuRow.__proto__ || Object.getPrototypeOf(MenuRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetailClick = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetailClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuRow, [{
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      return this.__onDisplayDetailClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.menu.equals(this.props.menu);
    }
  }, {
    key: '__onDisplayDetailClick__REACT_HOT_LOADER__',
    value: function __onDisplayDetailClick__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenuDetail(this.menu);
    }
  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'h4',
          { className: 'link-hover',
            onClick: this.onDisplayDetailClick
          },
          this.menu.name
        ),
        _react2.default.createElement('i', {
          onClick: function onClick() {
            _this3.props.onDelete(_this3.props.menu);
          },
          className: 'fa fa-trash pointer'
        })
      );
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }
  }]);

  return MenuRow;
}(_react.Component);

MenuRow.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired,

  onDelete: _propTypes2.default.func.isRequired
};
exports.default = MenuRow;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuRow, 'MenuRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/components/MenuRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/components/ProductOptionRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


var ProductOptionRow = function (_Component) {
  _inherits(ProductOptionRow, _Component);

  function ProductOptionRow() {
    _classCallCheck(this, ProductOptionRow);

    return _possibleConstructorReturn(this, (ProductOptionRow.__proto__ || Object.getPrototypeOf(ProductOptionRow)).apply(this, arguments));
  }

  _createClass(ProductOptionRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.productOption.equals(this.props.productOption);
    }
  }, {
    key: 'render',


    //
    // renderers
    //

    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'product_edit_view__product_option_row row' },
        !this.props.readOnly && _react2.default.createElement(
          'div',
          { className: 'product_edit_view__product_option_row__drag_handle' },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        ),
        !this.props.readOnly && _react2.default.createElement('i', {
          onClick: function onClick() {
            _this2.props.onDelete(_this2.props.productOption);
          },
          className: 'fa fa-trash pointer  product_edit_view__product_option_row__delete'
        }),
        _react2.default.createElement(
          'h4',
          {
            className: 'product_edit_view__product_option_row__name'
          },
          this.productOption.name
        )
      );
    }
  }, {
    key: 'productOption',
    get: function get() {
      return this.props.productOption;
    }
  }]);

  return ProductOptionRow;
}(_react.Component);

ProductOptionRow.propTypes = {
  productOption: _propTypes2.default.objectOf(_ProductOption2.default).isRequired,

  onDelete: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = ProductOptionRow;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductOptionRow, 'ProductOptionRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/components/ProductOptionRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _SelectProductOptionsModalProductOptionRow = __webpack_require__("./scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModalProductOptionRow.js");

var _SelectProductOptionsModalProductOptionRow2 = _interopRequireDefault(_SelectProductOptionsModalProductOptionRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 */
var SelectProductOptionsModal = function (_Component) {
  _inherits(SelectProductOptionsModal, _Component);

  function SelectProductOptionsModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectProductOptionsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectProductOptionsModal.__proto__ || Object.getPrototypeOf(SelectProductOptionsModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchQuery: '',

      selectedProductOptions: _this.props.selectedProductOptions.slice()
    }, _this.onHide = function () {
      var _this2;

      return (_this2 = _this).__onHide__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onClose = function () {
      var _this3;

      return (_this3 = _this).__onClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSubmit = function () {
      var _this4;

      return (_this4 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onSearchQueryChange = function () {
      var _this5;

      return (_this5 = _this).__onSearchQueryChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onProductOptionToggle = function () {
      var _this6;

      return (_this6 = _this).__onProductOptionToggle__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectProductOptionsModal, [{
    key: '__onProductOptionToggle__REACT_HOT_LOADER__',
    value: function __onProductOptionToggle__REACT_HOT_LOADER__() {
      return this.__onProductOptionToggle__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      this.props.onUpdate(this.state.selectedProductOptions);
    }
  }, {
    key: '__onSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onSearchQueryChange__REACT_HOT_LOADER__(searchQuery) {
      this.setState({
        searchQuery: searchQuery
      });
    }
  }, {
    key: '__onProductOptionToggle__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onProductOptionToggle__REACT_HOT_LOADER__(productOption) {
      var selectedProductOptions = this.state.selectedProductOptions;
      this.setState({
        selectedProductOptions: _utils.ArrayUtils.toggleObject(selectedProductOptions, productOption, { id: productOption.id })
      });
    }
  }, {
    key: 'renderOptionsList',
    value: function renderOptionsList() {
      var _this7 = this;

      var selectedProductOptions = this.state.selectedProductOptions;

      var productOptions = [];
      _lodash2.default.each(this.props.restaurantMenu.options, function (productOption) {
        var query = _this7.state.searchQuery;
        if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, productOption.name)) {
          productOptions.push(productOption);
        }
      });

      if (_lodash2.default.isEmpty(productOptions) && !_lodash2.default.isEmpty(this.state.searchQuery)) {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.select_product_option.search_result_empty')
          )
        );
      }

      // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
      var sortedOptionsList = _lodash2.default.sortBy(productOptions, ['desc'], function (productOption) {
        return _utils.StringUtils.toAlphaNum(productOption.name).toLowerCase();
      });

      return sortedOptionsList.map(function (productOption) {
        var isSelected = _utils.ArrayUtils.exists(selectedProductOptions, productOption, { id: productOption.id });

        return _react2.default.createElement(_SelectProductOptionsModalProductOptionRow2.default, {
          key: productOption.id,
          productOption: productOption,
          onToggle: _this7.onProductOptionToggle,
          isSelected: isSelected
        });
      });
    }
  }, {
    key: 'renderValidationButtons',
    value: function renderValidationButtons() {
      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50 text-center' },
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary',
            onClick: this.onSubmit
          },
          _I18n2.default.tr('menu.select_product_option.add_selected_options')
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'select_product_options_modal' },
          _react2.default.createElement(_SearchBox2.default, {
            search: this.state.searchQuery,
            onSearchInput: this.onSearchQueryChange
          }),
          _react2.default.createElement(
            'div',
            { className: 'list' },
            this.renderOptionsList()
          ),
          this.renderValidationButtons()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'sm',
          show: this.props.show,
          onHide: this.onHide,
          backdrop: 'static'
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('menu.select_product_option.select_product_options')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }, {
    key: 'productOptionsList',
    get: function get() {
      return this.props.productOptionsList;
    }
  }]);

  return SelectProductOptionsModal;
}(_react.Component);

SelectProductOptionsModal.defaultProps = {
  selectedProductOptions: []
};
SelectProductOptionsModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  selectedProductOptions: _propTypes2.default.arrayOf(_menu.ProductOption),

  // params: Product
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = SelectProductOptionsModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectProductOptionsModal, 'SelectProductOptionsModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModalProductOptionRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var AddProductOptionsModalProductOptionRow = function (_Component) {
  _inherits(AddProductOptionsModalProductOptionRow, _Component);

  function AddProductOptionsModalProductOptionRow() {
    _classCallCheck(this, AddProductOptionsModalProductOptionRow);

    return _possibleConstructorReturn(this, (AddProductOptionsModalProductOptionRow.__proto__ || Object.getPrototypeOf(AddProductOptionsModalProductOptionRow)).apply(this, arguments));
  }

  _createClass(AddProductOptionsModalProductOptionRow, [{
    key: 'render',


    // -- renderers

    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'pointer select_product_options_modal__product_option_row',
          onClick: function onClick() {
            _this2.props.onToggle(_this2.productOption);
          }
        },
        this.props.isSelected && _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
        !this.props.isSelected && _react2.default.createElement('i', { className: 'fa fa-square-o' }),
        '\xA0\xA0',
        this.productOption.name
      );
    }
  }, {
    key: 'productOption',


    // -- getters

    get: function get() {
      return this.props.productOption;
    }
  }]);

  return AddProductOptionsModalProductOptionRow;
}(_react.Component);

AddProductOptionsModalProductOptionRow.propTypes = {
  productOption: _propTypes2.default.objectOf(_menu.ProductOption).isRequired,

  /**
   * @param productOptionValue ProductOptionValue
   */
  onToggle: _propTypes2.default.func.isRequired,

  isSelected: _propTypes2.default.bool.isRequired
};
exports.default = AddProductOptionsModalProductOptionRow;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddProductOptionsModalProductOptionRow, 'AddProductOptionsModalProductOptionRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModalProductOptionRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/products/ProductsListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _OrderSettingsStore = __webpack_require__("./scripts/stores/OrderSettingsStore.js");

var _OrderSettingsStore2 = _interopRequireDefault(_OrderSettingsStore);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _AbstractRestaurantMenuComponent = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js");

var _AbstractRestaurantMenuComponent2 = _interopRequireDefault(_AbstractRestaurantMenuComponent);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _ProductRow = __webpack_require__("./scripts/pages/menu/products/components/ProductRow.js");

var _ProductRow2 = _interopRequireDefault(_ProductRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var ProductsListPage = function (_AbstractRestaurantMe) {
  _inherits(ProductsListPage, _AbstractRestaurantMe);

  function ProductsListPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductsListPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductsListPage.__proto__ || Object.getPrototypeOf(ProductsListPage)).call.apply(_ref, [this].concat(args))), _this), _this.onAddProductClicked = function () {
      var _this2;

      return (_this2 = _this).__onAddProductClicked__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onProductChange = function () {
      var _this3;

      return (_this3 = _this).__onProductChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSearchInput = function () {
      var _this4;

      return (_this4 = _this).__onSearchInput__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductsListPage, [{
    key: '__onSearchInput__REACT_HOT_LOADER__',
    value: function __onSearchInput__REACT_HOT_LOADER__() {
      return this.__onSearchInput__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductChange__REACT_HOT_LOADER__',
    value: function __onProductChange__REACT_HOT_LOADER__() {
      return this.__onProductChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddProductClicked__REACT_HOT_LOADER__',
    value: function __onAddProductClicked__REACT_HOT_LOADER__() {
      return this.__onAddProductClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.hideLoading);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.hideLoading);
    }

    // -- events

  }, {
    key: '__onAddProductClicked__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onAddProductClicked__REACT_HOT_LOADER__() {
      _actions.RouteAction.redirectTo(_RoutingEnum2.default.RESTAURANT_MENU_PRODUCT_NEW);
    }
  }, {
    key: '__onProductChange__REACT_HOT_LOADER__',


    // -- search events

    value: function __onProductChange__REACT_HOT_LOADER__(product) {
      var restaurantMenu = this.restaurantMenu.copy();

      restaurantMenu.updateProduct(product);
      this.setState({
        restaurantMenu: restaurantMenu
      });
    }
  }, {
    key: '__onSearchInput__REACT_HOT_LOADER__',


    // -- utils

    value: function __onSearchInput__REACT_HOT_LOADER__(search) {
      this.setState({
        search: search
      });
    }
  }, {
    key: 'renderAddProductBtn',


    // -- renderers

    value: function renderAddProductBtn() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      if (_OrderSettingsStore2.default.getOrderSettings().menuManagedByPos) {
        return null;
      }

      return _react2.default.createElement(_RoundButton2.default, {
        onClick: this.onAddProductClicked,
        text: _I18n2.default.tr('menu.product.list.create_product')
      });
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30 col-sm-12 col-md-6 col-md-offset-3' },
          _react2.default.createElement(_SearchBox2.default, {
            search: this.search,
            onSearchInput: this.onSearchInput
          })
        )
      );
    }
  }, {
    key: 'renderTheadContent',
    value: function renderTheadContent() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement('th', { className: 'hidden-xs hidden-sm col-md-1 text-left' }),
        _react2.default.createElement(
          'th',
          { className: 'col-xs-10 col-sm-8' },
          _I18n2.default.tr('menu.product.list.table.header.name')
        ),
        _react2.default.createElement(
          'th',
          { className: 'hidden-xs col-sm-3 col-md-2 text-center' },
          _I18n2.default.tr('menu.product.list.table.header.prices')
        ),
        _react2.default.createElement(
          'th',
          { className: 'col-xs-1 col-sm-1 text-center' },
          _I18n2.default.tr('menu.product.list.table.header.availibility')
        )
      );
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this5 = this;

      var productsListView = [];

      var sortedProductsList = _lodash2.default.sortBy(this.restaurantMenu.products, ['desc'], function (product) {
        // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
        return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
      });

      _lodash2.default.each(sortedProductsList, function (product) {

        if (_lodash2.default.isEmpty(_this5.state.search) || _utils.StringUtils.searchStringOn(_this5.state.search, product.name)) {
          productsListView.push(_react2.default.createElement(_ProductRow2.default, {
            product: product,
            key: product.id,
            onChange: _this5.onProductChange,
            disableStockModification: _this5.props.disableStockModification,
            currencyCode: _this5.props.currencyCode
          }));
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-30 table_container' },
        _react2.default.createElement(
          'table',
          { className: 'table table-responsive' },
          _react2.default.createElement(
            'thead',
            null,
            this.renderTheadContent()
          ),
          _react2.default.createElement(
            'tbody',
            null,
            productsListView
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'products_list top-buffer-30' },
        this.renderAddProductBtn(),
        !_lodash2.default.isEmpty(this.restaurantMenu.products) && this.renderSearchBar(),
        !_lodash2.default.isEmpty(this.restaurantMenu.products) && this.renderList(),
        (_SecurityContext2.default.restaurantMenu.canEdit() || _SecurityContext2.default.restaurantMenu.canEditAvailabilityProducts()) && this.renderFixedButtons(),
        this.renderLoading()
      );
    }
  }, {
    key: 'search',
    get: function get() {
      return this.state.search;
    }
  }]);

  return ProductsListPage;
}(_AbstractRestaurantMenuComponent2.default);

ProductsListPage.defaultProps = {
  hideDeactivatedProducts: true
};
ProductsListPage.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired
};
exports.default = ProductsListPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductsListPage, 'ProductsListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/products/ProductsListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/products/components/ProductRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _RowPricesView = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView2 = _interopRequireDefault(_RowPricesView);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var ProductRow = function (_Component) {
  _inherits(ProductRow, _Component);

  function ProductRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductRow.__proto__ || Object.getPrototypeOf(ProductRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onToggleStock = function () {
      var _this3;

      return (_this3 = _this).__onToggleStock__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductRow, [{
    key: '__onToggleStock__REACT_HOT_LOADER__',
    value: function __onToggleStock__REACT_HOT_LOADER__() {
      return this.__onToggleStock__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return true;
      // return !nextProps.product.equals(this.props.product);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return;
      }

      _actions.RouteAction.presentProductEdit(this.props.product);
    }
  }, {
    key: '__onToggleStock__REACT_HOT_LOADER__',
    value: function __onToggleStock__REACT_HOT_LOADER__() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit() && !_SecurityContext2.default.restaurantMenu.canEditAvailabilityProducts()) {
        return;
      }

      var product = this.props.product;

      product.toggleAvailibility();

      this.props.onChange(product);
    }
  }, {
    key: 'render',
    value: function render() {
      var product = this.props.product;

      return _react2.default.createElement(
        'tr',
        { className: 'product_row pointer' },
        _react2.default.createElement(
          'td',
          {
            className: 'hidden-xs hidden-sm col-md-1 text-left',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(_ImageLoader2.default, {
            src: product.image,
            className: 'product_row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT
          })
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'product__name col-xs-10 col-sm-8',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            product.name
          )
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'hidden-xs col-sm-3 col-md-2 text-center pointer'
          },
          _react2.default.createElement(_RowPricesView2.default, {
            prices: product.prices,
            currencyCode: this.props.currencyCode
          })
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'col-xs-1 col-sm-1 text-center'
          },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            wrapperClass: 'switch_important',
            value: product.haveStockAndIsActivated(),
            onChange: this.onToggleStock,
            disabled: !_SecurityContext2.default.restaurantMenu.canEdit() && !_SecurityContext2.default.restaurantMenu.canEditAvailabilityProducts() || this.props.disableStockModification
          })
        )
      );
    }
  }]);

  return ProductRow;
}(_react.Component);

ProductRow.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  disableStockModification: _propTypes2.default.bool.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};
var _default = ProductRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductRow, 'ProductRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/products/components/ProductRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/products/components/ProductRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/suggestions/SuggestionsListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _ItemSuggestion = __webpack_require__("./sdk/scripts/entities/menu/ItemSuggestion.js");

var _ItemSuggestion2 = _interopRequireDefault(_ItemSuggestion);

var _AbstractRestaurantMenuComponent = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js");

var _AbstractRestaurantMenuComponent2 = _interopRequireDefault(_AbstractRestaurantMenuComponent);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

var _SuggestionFormModal = __webpack_require__("./scripts/pages/menu/suggestions/suggestionForm/SuggestionFormModal.js");

var _SuggestionFormModal2 = _interopRequireDefault(_SuggestionFormModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuggestionsListPage = function (_AbstractRestaurantMe) {
  _inherits(SuggestionsListPage, _AbstractRestaurantMe);

  function SuggestionsListPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SuggestionsListPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuggestionsListPage.__proto__ || Object.getPrototypeOf(SuggestionsListPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _this.props.restaurantMenu.copy(),
      displaySuggestionFormModal: false,
      itemSuggestion: new _ItemSuggestion2.default()
    }, _this.onUpdateRestaurantMenuSuccess = function () {
      var _this2;

      return (_this2 = _this).__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDisplaySuggestionFormModal = function () {
      var _this3;

      return (_this3 = _this).__onDisplaySuggestionFormModal__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onHideSuggestionFormModal = function () {
      var _this4;

      return (_this4 = _this).__onHideSuggestionFormModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onSubmitSuggestion = function () {
      var _this5;

      return (_this5 = _this).__onSubmitSuggestion__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDeleteItemSuggestion = function () {
      var _this6;

      return (_this6 = _this).__onDeleteItemSuggestion__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SuggestionsListPage, [{
    key: '__onDeleteItemSuggestion__REACT_HOT_LOADER__',
    value: function __onDeleteItemSuggestion__REACT_HOT_LOADER__() {
      return this.__onDeleteItemSuggestion__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmitSuggestion__REACT_HOT_LOADER__',
    value: function __onSubmitSuggestion__REACT_HOT_LOADER__() {
      return this.__onSubmitSuggestion__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideSuggestionFormModal__REACT_HOT_LOADER__',
    value: function __onHideSuggestionFormModal__REACT_HOT_LOADER__() {
      return this.__onHideSuggestionFormModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplaySuggestionFormModal__REACT_HOT_LOADER__',
    value: function __onDisplaySuggestionFormModal__REACT_HOT_LOADER__() {
      return this.__onDisplaySuggestionFormModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__',
    value: function __onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__() {
      return this.__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.restaurantMenu.equals(this.props.restaurantMenu)) {
        this.setState({
          restaurantMenu: nextProps.restaurantMenu.copy()
        });
      }
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.state.restaurantMenu.equals(this.props.restaurantMenu);
    }
  }, {
    key: '__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__',
    value: function __onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: '__onDisplaySuggestionFormModal__REACT_HOT_LOADER__',
    value: function __onDisplaySuggestionFormModal__REACT_HOT_LOADER__() {
      var itemSuggestion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.setState({
        displaySuggestionFormModal: true,
        itemSuggestion: itemSuggestion
      });
    }
  }, {
    key: '__onHideSuggestionFormModal__REACT_HOT_LOADER__',
    value: function __onHideSuggestionFormModal__REACT_HOT_LOADER__() {
      this.setState({
        displaySuggestionFormModal: false
      });
    }
  }, {
    key: '__onSubmitSuggestion__REACT_HOT_LOADER__',
    value: function __onSubmitSuggestion__REACT_HOT_LOADER__(itemSuggestion) {
      var _this7 = this;

      var restaurantMenu = this.restaurantMenu;
      restaurantMenu.suggestions = _ArrayUtils2.default.updateObjectOrAdd(restaurantMenu.suggestions, itemSuggestion, function (suggestion) {
        return _lodash2.default.isEqual(_this7.state.itemSuggestion, suggestion);
      });

      this.setState({
        restaurantMenu: restaurantMenu,
        displaySuggestionFormModal: false
      });
    }
  }, {
    key: '__onDeleteItemSuggestion__REACT_HOT_LOADER__',
    value: function __onDeleteItemSuggestion__REACT_HOT_LOADER__(itemSuggestion) {
      this.restaurantMenu.suggestions = this.restaurantMenu.suggestions.filter(function (suggestion) {
        return !_lodash2.default.isEqual(itemSuggestion, suggestion);
      });

      this.setState({
        restaurantMenu: this.restaurantMenu
      });
    }
  }, {
    key: 'renderSuggestionForm',
    value: function renderSuggestionForm() {
      var _this8 = this;

      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_RoundButton2.default, {
          text: _I18n2.default.tr('menu.suggestions.form.add_suggestion'),
          onClick: function onClick() {
            return _this8.onDisplaySuggestionFormModal();
          }
        }),
        this.state.displaySuggestionFormModal && _react2.default.createElement(_SuggestionFormModal2.default, {
          show: true,
          onHide: this.onHideSuggestionFormModal,
          restaurantMenu: this.state.restaurantMenu,
          itemSuggestion: this.state.itemSuggestion,
          onSubmit: this.onSubmitSuggestion
        })
      );
    }
  }, {
    key: 'renderSuggestionsList',
    value: function renderSuggestionsList() {
      var _this9 = this;

      return _react2.default.createElement(
        'div',
        { className: 'row suggestions__list top-buffer-30' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'table',
            { className: 'table table-hover' },
            _react2.default.createElement(
              'tbody',
              null,
              !_lodash2.default.isEmpty(this.restaurantMenu.suggestions) ? this.restaurantMenu.suggestions.map(function (itemSuggestion) {
                var linkedItemsToReplace = itemSuggestion.linkedItems.filter(function (linkedItem) {
                  return linkedItem.isActionReplace();
                });
                var linkedItemsToAdd = itemSuggestion.linkedItems.filter(function (linkedItem) {
                  return linkedItem.isActionAdd();
                });

                var item = _this9.restaurantMenu.getItem(itemSuggestion.item);
                if (_lodash2.default.isNull(item)) {
                  return null;
                }

                var introductionText = _I18n2.default.getForCurrentLocale(itemSuggestion.localizedIntroduction);
                var introductionTextIsDefault = false;
                if (_lodash2.default.isEmpty(introductionText)) {
                  introductionText = 'Phrase par défaut';
                  introductionTextIsDefault = true;
                }

                return _react2.default.createElement(
                  'tr',
                  { key: item.id },
                  _react2.default.createElement(
                    'td',
                    { className: 'col-xs-2' },
                    item.name
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: 'col-xs-6' },
                    !_lodash2.default.isEmpty(linkedItemsToReplace) && _react2.default.createElement(
                      'div',
                      { className: 'row' },
                      _react2.default.createElement(
                        'label',
                        { className: 'col-xs-4 text-right' },
                        _I18n2.default.tr('menu.suggestions.form.labelReplace')
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-xs-8' },
                        linkedItemsToReplace.map(function (linkedItem) {
                          var linkedItemItem = _this9.restaurantMenu.getItem(linkedItem);
                          if (_lodash2.default.isNull(linkedItemItem)) {
                            return null;
                          }
                          return _react2.default.createElement(
                            'div',
                            { key: linkedItemItem.id },
                            linkedItemItem.name
                          );
                        })
                      )
                    ),
                    !_lodash2.default.isEmpty(linkedItemsToAdd) && _react2.default.createElement(
                      'div',
                      { className: 'row' },
                      _react2.default.createElement(
                        'label',
                        { className: 'col-xs-4 text-right' },
                        _I18n2.default.tr('menu.suggestions.form.labelAdd')
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        linkedItemsToAdd.map(function (linkedItem) {
                          var linkedItemItem = _this9.restaurantMenu.getItem(linkedItem);
                          if (_lodash2.default.isNull(linkedItemItem)) {
                            return null;
                          }
                          return _react2.default.createElement(
                            'div',
                            { key: linkedItemItem.id },
                            linkedItemItem.name
                          );
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: 'col-xs-4' },
                    _react2.default.createElement(
                      'span',
                      { style: { fontStyle: introductionTextIsDefault ? 'italic' : '' } },
                      introductionText
                    )
                  ),
                  _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
                    'td',
                    { className: 'col-xs-2' },
                    _react2.default.createElement(
                      'button',
                      {
                        className: 'btn btn-xs btn-primary',
                        onClick: function onClick() {
                          return _this9.onDisplaySuggestionFormModal(itemSuggestion);
                        }
                      },
                      _I18n2.default.tr('menu.suggestions.form.edit')
                    ),
                    '\xA0',
                    _react2.default.createElement(
                      'button',
                      {
                        className: 'btn btn-xs btn-primary',
                        onClick: function onClick() {
                          return _this9.onDeleteItemSuggestion(itemSuggestion);
                        }
                      },
                      _I18n2.default.tr('menu.suggestions.form.delete')
                    )
                  )
                );
              }) : _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _I18n2.default.tr('menu.suggestions.suggestions_list_empty')
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!_SecurityContext2.default.restaurantMenu.canRead()) {
        return null;
      }

      if (_lodash2.default.isEmpty(this.restaurantMenu) || _lodash2.default.isEmpty(this.restaurantMenu.products)) {
        return _react2.default.createElement(
          'p',
          { className: 'bg-warning' },
          _I18n2.default.tr('menu.suggestions.error_no_products_exists')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'suggestions top-buffer-30' },
        this.renderSuggestionForm(),
        this.renderSuggestionsList(),
        _SecurityContext2.default.restaurantMenu.canEdit() && this.renderFixedButtons(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }]);

  return SuggestionsListPage;
}(_AbstractRestaurantMenuComponent2.default);

exports.default = SuggestionsListPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SuggestionsListPage, 'SuggestionsListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/suggestions/SuggestionsListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/suggestions/suggestionForm/SuggestionForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _ItemSuggestion = __webpack_require__("./sdk/scripts/entities/menu/ItemSuggestion.js");

var _ItemSuggestion2 = _interopRequireDefault(_ItemSuggestion);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

var _SuggestedItem = __webpack_require__("./sdk/scripts/entities/menu/SuggestedItem.js");

var _SuggestedItem2 = _interopRequireDefault(_SuggestedItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuggestionForm = function (_Component) {
  _inherits(SuggestionForm, _Component);

  function SuggestionForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SuggestionForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuggestionForm.__proto__ || Object.getPrototypeOf(SuggestionForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      itemSuggestion: !_lodash2.default.isNull(_this.props.itemSuggestion) ? _this.props.itemSuggestion.copy() : new _ItemSuggestion2.default()
    }, _this.onItemSelect = function () {
      var _this2;

      return (_this2 = _this).__onItemSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onSuggestionsSelect = function () {
      var _this3;

      return (_this3 = _this).__onSuggestionsSelect__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSuggestionsSelectToAdd = function () {
      var _this4;

      return (_this4 = _this).__onSuggestionsSelectToAdd__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onSuggestionsSelectToReplace = function () {
      var _this5;

      return (_this5 = _this).__onSuggestionsSelectToReplace__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onLocalizedIntroductionChange = function () {
      var _this6;

      return (_this6 = _this).__onLocalizedIntroductionChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SuggestionForm, [{
    key: '__onLocalizedIntroductionChange__REACT_HOT_LOADER__',
    value: function __onLocalizedIntroductionChange__REACT_HOT_LOADER__() {
      return this.__onLocalizedIntroductionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSuggestionsSelectToReplace__REACT_HOT_LOADER__',
    value: function __onSuggestionsSelectToReplace__REACT_HOT_LOADER__() {
      return this.__onSuggestionsSelectToReplace__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSuggestionsSelectToAdd__REACT_HOT_LOADER__',
    value: function __onSuggestionsSelectToAdd__REACT_HOT_LOADER__() {
      return this.__onSuggestionsSelectToAdd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSuggestionsSelect__REACT_HOT_LOADER__',
    value: function __onSuggestionsSelect__REACT_HOT_LOADER__() {
      return this.__onSuggestionsSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onItemSelect__REACT_HOT_LOADER__',
    value: function __onItemSelect__REACT_HOT_LOADER__() {
      return this.__onItemSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_lodash2.default.isNull(nextProps.itemSuggestion) && !nextProps.itemSuggestion.equals(this.props.itemSuggestion)) {
        this.setState({
          itemSuggestion: nextProps.itemSuggestion.copy()
        });
      }
    }

    //
    //
    //

  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return !_lodash2.default.isNull(this.props.itemSuggestion);
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return !_lodash2.default.isNull(this.state.itemSuggestion) && !_lodash2.default.isEmpty(this.state.itemSuggestion.linkedItems);
    }

    //
    //
    //

  }, {
    key: '__onItemSelect__REACT_HOT_LOADER__',
    value: function __onItemSelect__REACT_HOT_LOADER__(option) {
      var itemSuggestion = this.state.itemSuggestion;
      var categoryItem = new _CategoryItem2.default();

      if (!_lodash2.default.isNil(option)) {
        var id = option.value;
        var item = this.props.restaurantMenu.getItemById(id, option.type);

        categoryItem.id = id;
        categoryItem.setTypeForObject(item);
      }

      itemSuggestion.item = categoryItem;
      this.setState({
        itemSuggestion: itemSuggestion
      });
    }
  }, {
    key: '__onSuggestionsSelect__REACT_HOT_LOADER__',
    value: function __onSuggestionsSelect__REACT_HOT_LOADER__(options, action) {
      var _this7 = this;

      var itemSuggestion = this.state.itemSuggestion;

      var linkedItems = options.map(function (option) {
        var suggestedItem = new _SuggestedItem2.default();
        // remove first letter to distinguish item type and avoid id conflict
        var id = option.value.substr(1);
        var item = _this7.props.restaurantMenu.getItemById(id, option.type);

        suggestedItem.id = id;
        suggestedItem.setTypeForObject(item);
        suggestedItem.action = action;
        return suggestedItem;
      });

      itemSuggestion.linkedItems = [].concat(_toConsumableArray(itemSuggestion.linkedItems.filter(function (linkedItem) {
        return linkedItem.action !== action;
      })), _toConsumableArray(linkedItems));

      this.setState({
        itemSuggestion: itemSuggestion
      });
    }
  }, {
    key: '__onSuggestionsSelectToAdd__REACT_HOT_LOADER__',
    value: function __onSuggestionsSelectToAdd__REACT_HOT_LOADER__(options) {
      this.onSuggestionsSelect(options, _SuggestedItem2.default.Action.ADD);
    }
  }, {
    key: '__onSuggestionsSelectToReplace__REACT_HOT_LOADER__',
    value: function __onSuggestionsSelectToReplace__REACT_HOT_LOADER__(options) {
      this.onSuggestionsSelect(options, _SuggestedItem2.default.Action.REPLACE);
    }
  }, {
    key: '__onLocalizedIntroductionChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onLocalizedIntroductionChange__REACT_HOT_LOADER__(localizedData) {
      var itemSuggestion = this.state.itemSuggestion;

      itemSuggestion.localizedIntroduction = localizedData;

      this.setState({
        itemSuggestion: itemSuggestion
      });
    }
  }, {
    key: 'renderSubmit',
    value: function renderSubmit() {
      var _this8 = this;

      return _react2.default.createElement(
        'button',
        {
          className: 'btn btn-primary button_submit col-xs-2 col-xs-offset-5',
          onClick: function onClick() {
            return _this8.props.onSubmit(_this8.state.itemSuggestion);
          },
          disabled: !this.isValid()
        },
        !this.isEditMode() ? _I18n2.default.tr('menu.suggestions.form.add') : _I18n2.default.tr('menu.suggestions.form.edit')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var usedSuggestions = this.props.restaurantMenu.suggestions.map(function (_ref2) {
        var item = _ref2.item;

        if (!_this9.isEditMode() || item.id !== _this9.props.itemSuggestion.item.id && item.type !== _this9.props.itemSuggestion.item.type) {
          return item;
        }
      });

      var filterAddedItems = function filterAddedItems(itemsList, currentItem) {
        return _lodash2.default.find(itemsList, function (item) {
          return item.id === currentItem.id && item.type === currentItem.type;
        }) ? false : true;
      };

      var possibleItems = [].concat(_toConsumableArray(this.props.restaurantMenu.menus), _toConsumableArray(this.props.restaurantMenu.products)).filter(function (item) {
        return filterAddedItems(_this9.state.itemSuggestion.linkedItems, item) && !_lodash2.default.find(usedSuggestions, function (us) {
          return us && us.id === item.id && us.type === item.type;
        });
      });

      var possibleSuggestions = [].concat(_toConsumableArray(this.props.restaurantMenu.menus), _toConsumableArray(this.props.restaurantMenu.products)).filter(function (item) {
        return filterAddedItems(_this9.state.itemSuggestion.linkedItems, item) && (!_lodash2.default.isNil(_this9.state.itemSuggestion.item) ? !(_this9.state.itemSuggestion.item.id === item.id && _this9.state.itemSuggestion.item.type === item.type) : true);
      });

      var selectedItemValue = null;
      if (!_lodash2.default.isNil(this.state.itemSuggestion) && !_lodash2.default.isEmpty(this.state.itemSuggestion.item)) {
        selectedItemValue = {
          value: this.state.itemSuggestion.item.id,
          label: this.props.restaurantMenu.getItemById(this.state.itemSuggestion.item.id, this.state.itemSuggestion.item.type).name
        };
      }

      var selectedSuggestionsToAdd = [];
      if (!_lodash2.default.isNil(this.state.itemSuggestion) && !_lodash2.default.isNil(this.state.itemSuggestion.linkedItems)) {
        selectedSuggestionsToAdd = this.state.itemSuggestion.linkedItems.map(function (linkedItem) {
          if (linkedItem.isActionAdd()) {
            return {
              // add first letter to distinguish item type and avoid id conflict
              value: '' + (linkedItem.type === 1 ? 'm' : 'p') + linkedItem.id,
              label: _this9.props.restaurantMenu.getItemById(linkedItem.id, linkedItem.type).name,
              type: linkedItem.type
            };
          }
        });
      }

      var selectedSuggestionsToReplace = [];
      if (!_lodash2.default.isNil(this.state.itemSuggestion) && !_lodash2.default.isNil(this.state.itemSuggestion.linkedItems)) {
        selectedSuggestionsToReplace = this.state.itemSuggestion.linkedItems.map(function (linkedItem) {
          if (linkedItem.isActionReplace()) {
            return {
              // add first letter to distinguish item type and avoid id conflict
              value: '' + (linkedItem.type === 1 ? 'm' : 'p') + linkedItem.id,
              label: _this9.props.restaurantMenu.getItemById(linkedItem.id, linkedItem.type).name,
              type: linkedItem.type
            };
          }
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'row suggestions__form' },
        _react2.default.createElement(
          'h2',
          { className: 'col-xs-12' },
          !this.isEditMode() ? _I18n2.default.tr('menu.suggestions.form.add_suggestion') : _I18n2.default.tr('menu.suggestions.form.edit_suggestion')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4' },
          _react2.default.createElement(_LocalizableSelect2.default, {
            name: 'form-field-item',
            value: selectedItemValue,
            onChange: this.onItemSelect,
            options: possibleItems.map(function (item) {
              return {
                label: item.name,
                value: item.id,
                type: item.type
              };
            })
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'label',
              { className: 'col-xs-4' },
              _I18n2.default.tr('menu.suggestions.form.labelReplace')
            ),
            _react2.default.createElement(_LocalizableSelect2.default, {
              className: 'col-xs-8',
              multi: true,
              name: 'form-field-suggestions-to-replace',
              value: selectedSuggestionsToReplace,
              onChange: this.onSuggestionsSelectToReplace,
              options: possibleSuggestions.map(function (item) {
                return {
                  label: item.name,
                  // add first letter to distinguish item type and avoid id conflict
                  value: '' + (item.type === 1 ? 'm' : 'p') + item.id,
                  type: item.type
                };
              })
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'label',
              { className: 'col-xs-4' },
              _I18n2.default.tr('menu.suggestions.form.labelAdd')
            ),
            _react2.default.createElement(_LocalizableSelect2.default, {
              className: 'col-xs-8',
              multi: true,
              name: 'form-field-suggestions',
              value: selectedSuggestionsToAdd,
              onChange: this.onSuggestionsSelectToAdd,
              options: possibleSuggestions.map(function (item) {
                return {
                  label: item.name,
                  // add first letter to distinguish item type and avoid id conflict
                  value: '' + (item.type === 1 ? 'm' : 'p') + item.id,
                  type: item.type
                };
              })
            })
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('menu.suggestions.form.introduction.title')
          ),
          _react2.default.createElement(_form.TextInputLocalized, {
            locales: _Constants2.default.localesForTranslation,
            values: this.state.itemSuggestion.localizedIntroduction,
            className: 'form-control',
            onChange: this.onLocalizedIntroductionChange,
            readOnly: !_SecurityContext2.default.restaurantMenu.canEdit()
          }),
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.suggestions.form.introduction.explanation')
          )
        ),
        this.renderSubmit()
      );
    }
  }]);

  return SuggestionForm;
}(_react.Component);

SuggestionForm.defaultProps = {
  itemSuggestion: null
};
SuggestionForm.propTypes = {
  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired,
  itemSuggestion: _propTypes2.default.objectOf(_ItemSuggestion2.default),
  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = SuggestionForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SuggestionForm, 'SuggestionForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/suggestions/suggestionForm/SuggestionForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/suggestions/suggestionForm/SuggestionFormModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _ItemSuggestion = __webpack_require__("./sdk/scripts/entities/menu/ItemSuggestion.js");

var _ItemSuggestion2 = _interopRequireDefault(_ItemSuggestion);

var _SuggestionForm = __webpack_require__("./scripts/pages/menu/suggestions/suggestionForm/SuggestionForm.js");

var _SuggestionForm2 = _interopRequireDefault(_SuggestionForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuggestionFormModal = function (_Component) {
  _inherits(SuggestionFormModal, _Component);

  function SuggestionFormModal() {
    _classCallCheck(this, SuggestionFormModal);

    return _possibleConstructorReturn(this, (SuggestionFormModal.__proto__ || Object.getPrototypeOf(SuggestionFormModal)).apply(this, arguments));
  }

  _createClass(SuggestionFormModal, [{
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(_SuggestionForm2.default, {
        restaurantMenu: this.props.restaurantMenu,
        itemSuggestion: this.props.itemSuggestion,
        onSubmit: this.props.onSubmit
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.props.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.props.onHide
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            !_lodash2.default.isNull(this.props.itemSuggestion) ? _I18n2.default.tr('menu.suggestions.form.edit_suggestion') : _I18n2.default.tr('menu.suggestions.form.add_suggestion')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return SuggestionFormModal;
}(_react.Component);

SuggestionFormModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,
  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired,
  itemSuggestion: _propTypes2.default.objectOf(_ItemSuggestion2.default),
  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = SuggestionFormModal;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SuggestionFormModal, 'SuggestionFormModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/suggestions/suggestionForm/SuggestionFormModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _UpsellingCategory = __webpack_require__("./sdk/scripts/entities/menu/UpsellingCategory.js");

var _UpsellingCategory2 = _interopRequireDefault(_UpsellingCategory);

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _UpsellingCategoryDetailView = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailView.js");

var _UpsellingCategoryDetailView2 = _interopRequireDefault(_UpsellingCategoryDetailView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- actions


// -- stores


// -- entities


// -- components


var UpsellingCategoryDetailPage = function (_AbstractComponent) {
  _inherits(UpsellingCategoryDetailPage, _AbstractComponent);

  function UpsellingCategoryDetailPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpsellingCategoryDetailPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpsellingCategoryDetailPage.__proto__ || Object.getPrototypeOf(UpsellingCategoryDetailPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      restaurantMenu: _RestaurantMenuStore2.default.getRestaurantMenu(),
      restaurant: _RestaurantStore2.default.getRestaurant(),
      upsellingCategory: null,
      apiError: null
    }, _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onError = function () {
      var _this3;

      return (_this3 = _this).__onError__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onUpdate = function () {
      var _this4;

      return (_this4 = _this).__onUpdate__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpsellingCategoryDetailPage, [{
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__() {
      return this.__onUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListeners(this.restaurantMenuStoreListeners);

      if (_lodash2.default.isNull(this.state.restaurantMenu)) {
        this.showLoading();
        _RestaurantMenuAction2.default.loadRestaurantMenu();
      } else {
        this.loadUpsellingCategory();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListeners(this.restaurantMenuStoreListeners);
    }
  }, {
    key: 'getUpsellingCategoryOnRestaurantMenu',
    value: function getUpsellingCategoryOnRestaurantMenu(restaurantMenu) {
      var upsellingCategoryId = this.props.params.upsellingCategoryId;
      return restaurantMenu.getUpsellingCategoryWithId(upsellingCategoryId);
    }
  }, {
    key: 'loadUpsellingCategory',
    value: function loadUpsellingCategory() {
      var upsellingCategory = this.getUpsellingCategoryOnRestaurantMenu(this.restaurantMenu);
      this.setState({
        upsellingCategory: upsellingCategory,
        loading: false
      });
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurantMenu = _RestaurantMenuStore2.default.getRestaurantMenu();
      var upsellingCategory = this.getUpsellingCategoryOnRestaurantMenu(restaurantMenu);

      if (_lodash2.default.isNull(upsellingCategory)) {
        this.setState({
          loading: false
          // TODO: 404
        });
      } else {
        this.setState({
          restaurantMenu: restaurantMenu.copy(),
          upsellingCategory: upsellingCategory.copy(),
          loading: false
        });
      }
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _RestaurantMenuStore2.default.getApiError(),
        loading: false
      });
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onUpdate__REACT_HOT_LOADER__(category) {
      var image = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.showLoading();
      var imageFile = _lodash2.default.isNull(image) ? null : _utils.ViewUtils.dataUriToFile(image);
      _RestaurantMenuAction2.default.saveUpsellingCategory(category, imageFile);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (!_lodash2.default.isNull(this.apiError)) {
        return this.renderApiErrorBlock();
      } else if (_lodash2.default.isNull(this.upsellingCategory)) {
        return this.renderOnLoadingContent();
      }

      //
      // We use the uid to re-generate the sub view after a changement on the product category.
      //
      return _react2.default.createElement(_UpsellingCategoryDetailView2.default, {
        key: _utils.Utils.generateUID(),
        upsellingCategory: this.upsellingCategory,
        restaurantMenu: this.restaurantMenu,
        onUpdate: this.onUpdate,
        currencyCode: this.restaurant.currency
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var arianeIcon = 'fa-shopping-cart';

      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: null
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.CATEGORIES
        }
      }, {
        name: _I18n2.default.tr('menu.order.restaurant_menu.upselling_categories'),
        link: _RoutingEnum2.default.RESTAURANT_MENU,
        query: {
          tab: _RestaurantMenuPage2.default.Tabs.UPSELLING_CATEGORIES
        }
      }, {
        name: !_lodash2.default.isNull(this.upsellingCategory) ? this.upsellingCategory.name : '',
        link: null
      }];

      try {
        return _react2.default.createElement(
          'div',
          { className: 'product_category_detail_page' },
          _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
          this.renderBody(),
          this.renderLoading()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'restaurantMenuStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR, this.onError)];
    }
  }, {
    key: 'upsellingCategory',
    get: function get() {
      return this.state.upsellingCategory;
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.state.restaurant;
    }
  }]);

  return UpsellingCategoryDetailPage;
}(_AbstractComponent3.default);

var _default = UpsellingCategoryDetailPage;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UpsellingCategoryDetailPage, 'UpsellingCategoryDetailPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _UpsellingCategory = __webpack_require__("./sdk/scripts/entities/menu/UpsellingCategory.js");

var _UpsellingCategory2 = _interopRequireDefault(_UpsellingCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _AbstractRestaurantMenuForm = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuForm.js");

var _AbstractRestaurantMenuForm2 = _interopRequireDefault(_AbstractRestaurantMenuForm);

var _FixedSubmitArea = __webpack_require__("./sdk/scripts/components/form/FixedSubmitArea.js");

var _FixedSubmitArea2 = _interopRequireDefault(_FixedSubmitArea);

var _UpsellingCategoryDetailProductRow = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailProductRow.js");

var _UpsellingCategoryDetailProductRow2 = _interopRequireDefault(_UpsellingCategoryDetailProductRow);

var _UpsellingCategoryDetailMenuRow = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailMenuRow.js");

var _UpsellingCategoryDetailMenuRow2 = _interopRequireDefault(_UpsellingCategoryDetailMenuRow);

var _components = __webpack_require__("./scripts/components/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _AddItemToUpsellingCategoryModal = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryModal.js");

var _AddItemToUpsellingCategoryModal2 = _interopRequireDefault(_AddItemToUpsellingCategoryModal);

var _EditUpsellingCategoryModal = __webpack_require__("./scripts/components/restaurantMenu/upsellingCategoryModal/EditUpsellingCategoryModal.js");

var _EditUpsellingCategoryModal2 = _interopRequireDefault(_EditUpsellingCategoryModal);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- actions


// -- utils


// -- entities


// -- views


var UpsellingCategoryDetailView = function (_AbstractRestaurantMe) {
  _inherits(UpsellingCategoryDetailView, _AbstractRestaurantMe);

  function UpsellingCategoryDetailView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpsellingCategoryDetailView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpsellingCategoryDetailView.__proto__ || Object.getPrototypeOf(UpsellingCategoryDetailView)).call.apply(_ref, [this].concat(args))), _this), _this.onOrderChange = function () {
      var _this2;

      return (_this2 = _this).__onOrderChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteProductFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteProductFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDeleteMenuFromCategory = function () {
      var _this4;

      return (_this4 = _this).__onDeleteMenuFromCategory__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDisplayProductDetail = function () {
      var _this5;

      return (_this5 = _this).__onDisplayProductDetail__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDisplayMenuDetail = function () {
      var _this6;

      return (_this6 = _this).__onDisplayMenuDetail__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onEditClicked = function () {
      var _this7;

      return (_this7 = _this).__onEditClicked__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onHideEditModal = function () {
      var _this8;

      return (_this8 = _this).__onHideEditModal__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onFormSubmit = function () {
      var _this9;

      return (_this9 = _this).__onFormSubmit__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onFormReset = function () {
      var _this10;

      return (_this10 = _this).__onFormReset__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onDisplayAddItemModal = function () {
      var _this11;

      return (_this11 = _this).__onDisplayAddItemModal__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onHideAddItemModal = function () {
      var _this12;

      return (_this12 = _this).__onHideAddItemModal__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onUpsellingCategoryChange = function () {
      var _this13;

      return (_this13 = _this).__onUpsellingCategoryChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.renderRow = function () {
      var _this14;

      return (_this14 = _this).__renderRow__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpsellingCategoryDetailView, [{
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__() {
      return this.__renderRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpsellingCategoryChange__REACT_HOT_LOADER__',
    value: function __onUpsellingCategoryChange__REACT_HOT_LOADER__() {
      return this.__onUpsellingCategoryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideAddItemModal__REACT_HOT_LOADER__',
    value: function __onHideAddItemModal__REACT_HOT_LOADER__() {
      return this.__onHideAddItemModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayAddItemModal__REACT_HOT_LOADER__',
    value: function __onDisplayAddItemModal__REACT_HOT_LOADER__() {
      return this.__onDisplayAddItemModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFormReset__REACT_HOT_LOADER__',
    value: function __onFormReset__REACT_HOT_LOADER__() {
      return this.__onFormReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFormSubmit__REACT_HOT_LOADER__',
    value: function __onFormSubmit__REACT_HOT_LOADER__() {
      return this.__onFormSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideEditModal__REACT_HOT_LOADER__',
    value: function __onHideEditModal__REACT_HOT_LOADER__() {
      return this.__onHideEditModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEditClicked__REACT_HOT_LOADER__',
    value: function __onEditClicked__REACT_HOT_LOADER__() {
      return this.__onEditClicked__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayMenuDetail__REACT_HOT_LOADER__',
    value: function __onDisplayMenuDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayMenuDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayProductDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayProductDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteMenuFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteMenuFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteMenuFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteProductFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteProductFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteProductFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderChange__REACT_HOT_LOADER__',
    value: function __onOrderChange__REACT_HOT_LOADER__() {
      return this.__onOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(UpsellingCategoryDetailView.prototype.__proto__ || Object.getPrototypeOf(UpsellingCategoryDetailView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(props) {
      return {
        upsellingCategory: props.upsellingCategory.copy(),

        displayAddItemModal: false,

        image: null,

        displayEditModal: false
      };
    }
  }, {
    key: 'shouldUpdateState',
    value: function shouldUpdateState(nextProps) {
      return !this.props.upsellingCategory.equals(nextProps.upsellingCategory);
    }
  }, {
    key: '__onOrderChange__REACT_HOT_LOADER__',
    value: function __onOrderChange__REACT_HOT_LOADER__(items) {
      var upsellingCategory = this.upsellingCategory;

      upsellingCategory.items = items;

      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: '__onDeleteProductFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteProductFromCategory__REACT_HOT_LOADER__(product) {
      var _this15 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.upselling_category.detail.confirm_delete_product'), function (result) {
        if (result) {
          var upsellingCategory = _this15.upsellingCategory;

          upsellingCategory.removeItemWithId(product.id);

          _this15.setState({
            upsellingCategory: upsellingCategory
          });
        }
      });
    }
  }, {
    key: '__onDeleteMenuFromCategory__REACT_HOT_LOADER__',


    // -- events navigation
    value: function __onDeleteMenuFromCategory__REACT_HOT_LOADER__(menu) {
      var _this16 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.upselling_category.detail.confirm_delete_menu'), function (result) {
        if (result) {
          var upsellingCategory = _this16.upsellingCategory;

          upsellingCategory.removeItemWithId(menu.id);

          _this16.setState({
            upsellingCategory: upsellingCategory
          });
        }
      });
    }
  }, {
    key: '__onDisplayProductDetail__REACT_HOT_LOADER__',
    value: function __onDisplayProductDetail__REACT_HOT_LOADER__(product) {
      _actions.RouteAction.presentProductEdit(product);
    }
  }, {
    key: '__onDisplayMenuDetail__REACT_HOT_LOADER__',


    //
    // Edit modal events
    //

    value: function __onDisplayMenuDetail__REACT_HOT_LOADER__(menu) {
      _actions.RouteAction.presentMenuDetail(menu);
    }
  }, {
    key: '__onEditClicked__REACT_HOT_LOADER__',
    value: function __onEditClicked__REACT_HOT_LOADER__() {
      this.setState({
        displayEditModal: true
      });
    }
  }, {
    key: '__onHideEditModal__REACT_HOT_LOADER__',


    // -- getters

    value: function __onHideEditModal__REACT_HOT_LOADER__() {
      this.setState({
        displayEditModal: false
      });
    }
  }, {
    key: '__onFormSubmit__REACT_HOT_LOADER__',
    value: function __onFormSubmit__REACT_HOT_LOADER__() {
      this.props.onUpdate(this.upsellingCategory, this.state.image);
    }
  }, {
    key: '__onFormReset__REACT_HOT_LOADER__',


    // -- events add item modal

    value: function __onFormReset__REACT_HOT_LOADER__() {
      this.setState({
        upsellingCategory: this.props.upsellingCategory.copy(),
        image: null
      });
    }
  }, {
    key: '__onDisplayAddItemModal__REACT_HOT_LOADER__',
    value: function __onDisplayAddItemModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddItemModal: true
      });
    }
  }, {
    key: '__onHideAddItemModal__REACT_HOT_LOADER__',


    // -- image

    value: function __onHideAddItemModal__REACT_HOT_LOADER__() {
      this.setState({
        displayAddItemModal: false
      });
    }
  }, {
    key: '__onUpsellingCategoryChange__REACT_HOT_LOADER__',


    // -- renderers


    value: function __onUpsellingCategoryChange__REACT_HOT_LOADER__(upsellingCategory) {
      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: 'renderTheadContentItemList',
    value: function renderTheadContentItemList() {
      return _react2.default.createElement(
        'div',
        { className: 'thead col-xs-12' },
        _react2.default.createElement('div', { className: 'col-md-2 hidden-sm' }),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _I18n2.default.tr('menu.upselling_category.detail.table.header.name')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-2 text-left' },
          _I18n2.default.tr('menu.upselling_category.detail.table.header.modes_and_price')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1 text-center' },
          _I18n2.default.tr('menu.upselling_category.detail.table.header.delete_category')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1 text-center' },
          _I18n2.default.tr('menu.upselling_category.detail.table.header.move')
        )
      );
    }
  }, {
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__(item) {
      if (item.isProduct()) {
        var product = this.props.restaurantMenu.getProductWithId(item.id);

        return _react2.default.createElement(_UpsellingCategoryDetailProductRow2.default, {
          product: product,
          key: product.id,
          onDeleteFromCategory: this.onDeleteProductFromCategory,
          currencyCode: this.currencyCode
        });
      } else if (item.isMenu()) {
        var menu = this.props.restaurantMenu.getMenuWithId(item.id);

        return _react2.default.createElement(_UpsellingCategoryDetailMenuRow2.default, {
          menu: menu,
          key: menu.id,
          onDeleteFromCategory: this.onDeleteMenuFromCategory,
          currencyCode: this.currencyCode
        });
      }

      return null;
    }
  }, {
    key: 'renderItemsList',
    value: function renderItemsList() {
      return _react2.default.createElement(_SortableList2.default, {
        items: this.upsellingCategory.items,
        onChange: this.onOrderChange,
        renderer: this.renderRow,
        displayDragIcon: false
      });
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      if (_lodash2.default.isEmpty(this.upsellingCategory.description)) {
        return _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.upselling_category.detail.no_description')
          )
        );
      }

      return _react2.default.createElement(
        'p',
        null,
        this.upsellingCategory.description
      );
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_FixedSubmitArea2.default, {
        onSubmit: this.onFormSubmit,
        onReset: this.onFormReset,
        haveModifications: this.haveModifications
      });
    }
  }, {
    key: 'renderAddItemToUpsellingCategoryModal',
    value: function renderAddItemToUpsellingCategoryModal() {
      return _react2.default.createElement(_AddItemToUpsellingCategoryModal2.default, {
        show: this.state.displayAddItemModal,
        onHide: this.onHideAddItemModal,
        restaurantMenu: this.props.restaurantMenu,
        upsellingCategory: this.state.upsellingCategory
      });
    }
  }, {
    key: 'renderEditModal',
    value: function renderEditModal() {
      if (this.state.displayEditModal) {
        return _react2.default.createElement(_EditUpsellingCategoryModal2.default, {
          upsellingCategory: this.upsellingCategory,
          onUpdate: this.onUpsellingCategoryChange,
          show: this.state.displayEditModal,
          onHide: this.onHideEditModal
        });
      }

      return null;
    }
  }, {
    key: 'renderEditButton',
    value: function renderEditButton() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      return _react2.default.createElement(
        'button',
        {
          className: 'btn btn-primary',
          onClick: this.onEditClicked
        },
        _react2.default.createElement('i', { className: 'fa fa-edit' }),
        '\xA0\xA0',
        _I18n2.default.tr('menu.upselling_category.detail.edit')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-10' },
            _react2.default.createElement(
              'h3',
              null,
              this.upsellingCategory.name
            ),
            this.renderDescription()
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-2' },
            this.renderEditButton()
          )
        ),
        _react2.default.createElement('hr', null),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_components.RoundButton, {
            text: _I18n2.default.tr('menu.upselling_category.detail.add_product_or_menu'),
            onClick: this.onDisplayAddItemModal
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30 table_container table_container_hover row' },
          this.renderTheadContentItemList(),
          this.renderItemsList()
        ),
        this.renderSubmitArea(),
        this.renderAddItemToUpsellingCategoryModal(),
        this.renderLoading(),
        this.renderEditModal()
      );
    }
  }, {
    key: 'upsellingCategory',
    get: function get() {
      return this.state.upsellingCategory;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.props.upsellingCategory.equals(this.state.upsellingCategory) || !_lodash2.default.isNull(this.state.image);
    }
  }]);

  return UpsellingCategoryDetailView;
}(_AbstractRestaurantMenuForm2.default);

UpsellingCategoryDetailView.propTypes = {
  upsellingCategory: _propTypes2.default.objectOf(_UpsellingCategory2.default).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default).isRequired,

  onUpdate: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};
exports.default = UpsellingCategoryDetailView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UpsellingCategoryDetailView, 'UpsellingCategoryDetailView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/UpsellingCategoryDetailView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _UpsellingCategory = __webpack_require__("./sdk/scripts/entities/menu/UpsellingCategory.js");

var _UpsellingCategory2 = _interopRequireDefault(_UpsellingCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _AddItemToUpsellingCategoryView = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryView.js");

var _AddItemToUpsellingCategoryView2 = _interopRequireDefault(_AddItemToUpsellingCategoryView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- constants


// -- stores


// -- views


var AddItemToUpsellingCategoryModal = function (_Component) {
  _inherits(AddItemToUpsellingCategoryModal, _Component);

  function AddItemToUpsellingCategoryModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddItemToUpsellingCategoryModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddItemToUpsellingCategoryModal.__proto__ || Object.getPrototypeOf(AddItemToUpsellingCategoryModal)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHide = function () {
      var _this3;

      return (_this3 = _this).__onHide__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClose = function () {
      var _this4;

      return (_this4 = _this).__onClose__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddItemToUpsellingCategoryModal, [{
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      return this.__onClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      return this.__onHide__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show
      // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu) || this.props.upsellingCategory.equals(nextProps.upsellingCategory);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onHide__REACT_HOT_LOADER__',
    value: function __onHide__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: '__onClose__REACT_HOT_LOADER__',
    value: function __onClose__REACT_HOT_LOADER__() {
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('menu.upselling_category.add_item.modal_title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(_AddItemToUpsellingCategoryView2.default, {
            upsellingCategory: this.props.upsellingCategory,
            restaurantMenu: this.props.restaurantMenu
          })
        )
      );
    }
  }]);

  return AddItemToUpsellingCategoryModal;
}(_react.Component);

AddItemToUpsellingCategoryModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  upsellingCategory: _propTypes2.default.objectOf(_UpsellingCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
exports.default = AddItemToUpsellingCategoryModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddItemToUpsellingCategoryModal, 'AddItemToUpsellingCategoryModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryModal.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _UpsellingCategory = __webpack_require__("./sdk/scripts/entities/menu/UpsellingCategory.js");

var _UpsellingCategory2 = _interopRequireDefault(_UpsellingCategory);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _ProductItem = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/ProductItem.js");

var _ProductItem2 = _interopRequireDefault(_ProductItem);

var _MenuItem = __webpack_require__("./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _SearchBox = __webpack_require__("./sdk/scripts/components/SearchBox.js");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _SubmitArea = __webpack_require__("./sdk/scripts/components/form/SubmitArea.js");

var _SubmitArea2 = _interopRequireDefault(_SubmitArea);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- stores


// -- utils


// -- entities


// -- views


var AddItemToUpsellingCategoryView = function (_AbstractComponent) {
  _inherits(AddItemToUpsellingCategoryView, _AbstractComponent);

  function AddItemToUpsellingCategoryView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddItemToUpsellingCategoryView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddItemToUpsellingCategoryView.__proto__ || Object.getPrototypeOf(AddItemToUpsellingCategoryView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchQuery: '',

      upsellingCategory: _this.props.upsellingCategory.copy(),

      productAddSearchQuery: '',

      productRemoveSearchQuery: '',

      menuAddSearchQuery: '',

      menuRemoveSearchQuery: ''
    }, _this.onError = function () {
      var _this2;

      return (_this2 = _this).__onError__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselectProduct = function () {
      var _this3;

      return (_this3 = _this).__onDeselectProduct__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSelectProduct = function () {
      var _this4;

      return (_this4 = _this).__onSelectProduct__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDeselectMenu = function () {
      var _this5;

      return (_this5 = _this).__onDeselectMenu__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onSelectMenu = function () {
      var _this6;

      return (_this6 = _this).__onSelectMenu__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onProductAddSearchQueryChange = function () {
      var _this7;

      return (_this7 = _this).__onProductAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onProductRemoveSearchQueryChange = function () {
      var _this8;

      return (_this8 = _this).__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onMenuAddSearchQueryChange = function () {
      var _this9;

      return (_this9 = _this).__onMenuAddSearchQueryChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onMenuRemoveSearchQueryChange = function () {
      var _this10;

      return (_this10 = _this).__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onSubmit = function () {
      var _this11;

      return (_this11 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onReset = function () {
      var _this12;

      return (_this12 = _this).__onReset__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddItemToUpsellingCategoryView, [{
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMenuAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onMenuAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductRemoveSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProductAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductAddSearchQueryChange__REACT_HOT_LOADER__() {
      return this.__onProductAddSearchQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectMenu__REACT_HOT_LOADER__',
    value: function __onSelectMenu__REACT_HOT_LOADER__() {
      return this.__onSelectMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectMenu__REACT_HOT_LOADER__',
    value: function __onDeselectMenu__REACT_HOT_LOADER__() {
      return this.__onDeselectMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelectProduct__REACT_HOT_LOADER__',
    value: function __onSelectProduct__REACT_HOT_LOADER__() {
      return this.__onSelectProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselectProduct__REACT_HOT_LOADER__',
    value: function __onDeselectProduct__REACT_HOT_LOADER__() {
      return this.__onDeselectProduct__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _RestaurantMenuStore2.default.addListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

      _RestaurantMenuStore2.default.addListener(_Events2.default.END_LOADING, this.hideLoading);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _RestaurantMenuStore2.default.removeListener(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

      _RestaurantMenuStore2.default.removeListener(_Events2.default.END_LOADING, this.hideLoading);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',


    // --
    value: function __onError__REACT_HOT_LOADER__() {
      // TODO: onError
    }
  }, {
    key: '__onDeselectProduct__REACT_HOT_LOADER__',
    value: function __onDeselectProduct__REACT_HOT_LOADER__(product) {
      var upsellingCategory = this.upsellingCategory;

      upsellingCategory.removeItemWithId(product.id);

      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: '__onSelectProduct__REACT_HOT_LOADER__',
    value: function __onSelectProduct__REACT_HOT_LOADER__(product) {
      var upsellingCategory = this.upsellingCategory;

      var item = new _CategoryItem2.default();
      item.type = _CategoryItem2.default.Type.PRODUCT;
      item.id = product.id;

      upsellingCategory.items.push(item);

      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: '__onDeselectMenu__REACT_HOT_LOADER__',
    value: function __onDeselectMenu__REACT_HOT_LOADER__(menu) {
      var upsellingCategory = this.upsellingCategory;

      upsellingCategory.removeItemWithId(menu.id);

      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: '__onSelectMenu__REACT_HOT_LOADER__',


    // -- search
    value: function __onSelectMenu__REACT_HOT_LOADER__(menu) {
      var upsellingCategory = this.upsellingCategory;

      var item = new _CategoryItem2.default();
      item.type = _CategoryItem2.default.Type.MENU;
      item.id = menu.id;

      upsellingCategory.items.push(item);

      this.setState({
        upsellingCategory: upsellingCategory
      });
    }
  }, {
    key: '__onProductAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductAddSearchQueryChange__REACT_HOT_LOADER__(productAddSearchQuery) {
      this.setState({
        productAddSearchQuery: productAddSearchQuery
      });
    }
  }, {
    key: '__onProductRemoveSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onProductRemoveSearchQueryChange__REACT_HOT_LOADER__(productRemoveSearchQuery) {
      this.setState({
        productRemoveSearchQuery: productRemoveSearchQuery
      });
    }
  }, {
    key: '__onMenuAddSearchQueryChange__REACT_HOT_LOADER__',
    value: function __onMenuAddSearchQueryChange__REACT_HOT_LOADER__(menuAddSearchQuery) {
      this.setState({
        menuAddSearchQuery: menuAddSearchQuery
      });
    }
  }, {
    key: '__onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__',


    // -- form
    value: function __onMenuRemoveSearchQueryChange__REACT_HOT_LOADER__(menuRemoveSearchQuery) {
      this.setState({
        menuRemoveSearchQuery: menuRemoveSearchQuery
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var restaurantMenu = this.props.restaurantMenu;
      restaurantMenu.updateUpsellingCategory(this.state.upsellingCategory);

      this.showLoading();
      _RestaurantMenuAction2.default.saveRestaurantMenu(restaurantMenu);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',


    // -- renderers

    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState({
        upsellingCategory: this.props.upsellingCategory.copy()
      });
    }
  }, {
    key: 'renderMenusSelect',
    value: function renderMenusSelect() {
      return null;

      //    _.each(this.restaurantMenu.menus, (menu:Menu) => {
      //      const isSelected = true;
      //      items.push(
      //        <MenuItem
      //          menu={menu}
      //          isSelected={isSelected}
      //          onSelect={this.onSelectMenu}
      //          onDeselect={this.onDeselectMenu}
      //        />
      //      );
      //    });
    }
  }, {
    key: 'renderSearchNoResults',
    value: function renderSearchNoResults() {
      return _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'em',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.search_no_results')
        )
      );
    }
  }, {
    key: 'renderProductsSelected',
    value: function renderProductsSelected(products) {
      var _this13 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(products) && !_lodash2.default.isEmpty(this.state.productRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(products) && _lodash2.default.isEmpty(this.state.productRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.upselling_category.add_item.no_item_selected')
          )
        );
      } else {
        var sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (product) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
        });
        listView = sortedProductsList.map(function (product) {
          return _react2.default.createElement(_ProductItem2.default, {
            key: product.id,
            product: product,
            isSelected: true,
            onDeselect: _this13.onDeselectProduct
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__products__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.productRemoveSearchQuery,
          onSearchInput: this.onProductRemoveSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProductsUnselected',
    value: function renderProductsUnselected(products) {
      var _this14 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(products)) {
        listView = this.renderSearchNoResults();
      } else {
        var sortedProductsList = _lodash2.default.sortBy(products, ['desc'], function (product) {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return _utils.StringUtils.toAlphaNum(product.name).toLowerCase();
        });
        listView = sortedProductsList.map(function (product) {
          return _react2.default.createElement(_ProductItem2.default, {
            key: product.id,
            product: product,
            isSelected: false,
            onSelect: _this14.onSelectProduct
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__products__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.products_on_menu')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.productAddSearchQuery,
          onSearchInput: this.onProductAddSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this15 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.restaurantMenu.products, function (product) {
        var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this15.upsellingCategory.items, function (item) {
          return item.isProduct() && item.id === product.id;
        }));

        if (isSelected) {
          var query = _this15.state.productRemoveSearchQuery;
          if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, product.name)) {
            selected.push(product);
          }
        } else {
          var _query = _this15.state.productAddSearchQuery;
          if (_lodash2.default.isEmpty(_query) || _utils.StringUtils.searchStringOn(_query, product.name)) {
            unselected.push(product);
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__products' },
        this.renderProductsUnselected(unselected),
        this.renderProductsSelected(selected)
      );
    }
  }, {
    key: 'renderMenusSelected',
    value: function renderMenusSelected(menus) {
      var _this16 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(menus) && !_lodash2.default.isEmpty(this.state.menuRemoveSearchQuery)) {
        listView = this.renderSearchNoResults();
      } else if (_lodash2.default.isEmpty(menus) && _lodash2.default.isEmpty(this.state.menuRemoveSearchQuery)) {
        listView = _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('menu.upselling_category.add_item.no_menu_selected')
          )
        );
      } else {
        listView = menus.map(function (menu) {
          return _react2.default.createElement(_MenuItem2.default, {
            key: menu.id,
            menu: menu,
            isSelected: true,
            onDeselect: _this16.onDeselectMenu
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__menus__selected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.selected')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.menuRemoveSearchQuery,
          onSearchInput: this.onMenuRemoveSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderMenusUnselected',
    value: function renderMenusUnselected(menus) {
      var _this17 = this;

      var listView = null;
      if (_lodash2.default.isEmpty(menus)) {
        listView = this.renderSearchNoResults();
      } else {
        listView = menus.map(function (menu) {
          return _react2.default.createElement(_MenuItem2.default, {
            key: menu.id,
            menu: menu,
            isSelected: false,
            onSelect: _this17.onSelectMenu
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-6 add_to_category_view__menus__unselected' },
        _react2.default.createElement(
          'h4',
          null,
          _I18n2.default.tr('menu.upselling_category.add_item.menus_on_menu')
        ),
        _react2.default.createElement(_SearchBox2.default, {
          search: this.state.menuAddSearchQuery,
          onSearchInput: this.onMenuAddSearchQueryChange
        }),
        _react2.default.createElement(
          'div',
          { className: 'list' },
          listView
        )
      );
    }
  }, {
    key: 'renderMenus',
    value: function renderMenus() {
      var _this18 = this;

      var unselected = [];
      var selected = [];

      _lodash2.default.each(this.restaurantMenu.menus, function (menu) {
        var isSelected = !_lodash2.default.isUndefined(_lodash2.default.find(_this18.upsellingCategory.items, function (item) {
          return item.isMenu() && item.id === menu.id;
        }));

        if (isSelected) {
          var query = _this18.state.menuRemoveSearchQuery;
          if (_lodash2.default.isEmpty(query) || _utils.StringUtils.searchStringOn(query, menu.name)) {
            selected.push(menu);
          }
        } else {
          var _query2 = _this18.state.menuAddSearchQuery;
          if (_lodash2.default.isEmpty(_query2) || _utils.StringUtils.searchStringOn(_query2, menu.name)) {
            unselected.push(menu);
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'row add_to_category_view__menus' },
        this.renderMenusUnselected(unselected),
        this.renderMenusSelected(selected)
      );
    }
  }, {
    key: 'renderSubmitArea',
    value: function renderSubmitArea() {
      return _react2.default.createElement(_SubmitArea2.default, {
        haveModifications: this.haveModifications,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'add_to_category_view' },
        this.renderMenusSelect(),
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultActiveKey: 1,
            id: 'edit_restaurant_page__tabs',
            onSelect: this.onTabChange
          },
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 1,
              title: _I18n2.default.tr('menu.upselling_category.products')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderProducts()
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 2,
              title: _I18n2.default.tr('menu.upselling_category.menus')
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderMenus()
            )
          )
        ),
        this.renderSubmitArea(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.props.restaurantMenu;
    }
  }, {
    key: 'upsellingCategory',
    get: function get() {
      return this.state.upsellingCategory;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return !this.state.upsellingCategory.equals(this.props.upsellingCategory);
    }

    // --

  }]);

  return AddItemToUpsellingCategoryView;
}(_AbstractComponent3.default);

AddItemToUpsellingCategoryView.propTypes = {
  upsellingCategory: _propTypes2.default.objectOf(_UpsellingCategory2.default),

  restaurantMenu: _propTypes2.default.objectOf(_RestaurantMenu2.default)
};
var _default = AddItemToUpsellingCategoryView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AddItemToUpsellingCategoryView, 'AddItemToUpsellingCategoryView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/AddItemToUpsellingCategoryView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/MenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      onSelect: function onSelect() {},
      onDeselect: function onDeselect() {}
    }, _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselect = function () {
      var _this3;

      return (_this3 = _this).__onDeselect__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClick = function () {
      var _this4;

      return (_this4 = _this).__onClick__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      return this.__onDeselect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.isSelected !== this.props.isSelected && nextProps.menu.id !== this.props.menu.id;
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      this.props.onSelect(this.menu);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      this.props.onDeselect(this.menu);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      if (this.isSelected) {
        this.onDeselect();
      } else {
        this.onSelect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'menu_item pointer',
          onClick: this.onClick
        },
        this.menu.name
      );
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = MenuItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuItem, 'MenuItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/MenuItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/MenuItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/ProductItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views

var ProductItem = function (_Component) {
  _inherits(ProductItem, _Component);

  function ProductItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductItem.__proto__ || Object.getPrototypeOf(ProductItem)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      onSelect: function onSelect() {},
      onDeselect: function onDeselect() {}
    }, _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeselect = function () {
      var _this3;

      return (_this3 = _this).__onDeselect__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onClick = function () {
      var _this4;

      return (_this4 = _this).__onClick__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductItem, [{
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      return this.__onClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      return this.__onDeselect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.isSelected !== this.props.isSelected && nextProps.product.id !== this.props.product.id;
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      this.props.onSelect(this.product);
    }
  }, {
    key: '__onDeselect__REACT_HOT_LOADER__',
    value: function __onDeselect__REACT_HOT_LOADER__() {
      this.props.onDeselect(this.product);
    }
  }, {
    key: '__onClick__REACT_HOT_LOADER__',
    value: function __onClick__REACT_HOT_LOADER__() {
      if (this.isSelected) {
        this.onDeselect();
      } else {
        this.onSelect();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'product_item pointer',
          onClick: this.onClick
        },
        this.product.name
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.props.isSelected;
    }
  }]);

  return ProductItem;
}(_react.Component);

ProductItem.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,

  isSelected: _propTypes2.default.bool.isRequired,

  onSelect: _propTypes2.default.func,

  onDeselect: _propTypes2.default.func
};
var _default = ProductItem;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProductItem, 'ProductItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/ProductItem.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/addItemToCategory/components/ProductItem.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailMenuRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _RowPricesView = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView2 = _interopRequireDefault(_RowPricesView);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var CategoryDetailMenuRow = function (_Component) {
  _inherits(CategoryDetailMenuRow, _Component);

  function CategoryDetailMenuRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryDetailMenuRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryDetailMenuRow.__proto__ || Object.getPrototypeOf(CategoryDetailMenuRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryDetailMenuRow, [{
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.menu.equals(this.props.menu);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentMenuDetail(this.menu);
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteFromCategory(this.props.menu);
    }
  }, {
    key: 'renderAvailabilities',
    value: function renderAvailabilities() {
      return _react2.default.createElement(_RowPricesView2.default, {
        prices: this.menu.prices,
        currencyCode: this.currencyCode
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view__row pointer row' },
        _react2.default.createElement(
          'div',
          { className: 'hidden-sm col-md-2 text-left' },
          _react2.default.createElement(_ImageLoader2.default, {
            src: this.menu.image,
            className: 'product_category_view__row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_MENU
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'menu__name col-xs-6 product_category_view__row__name',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            this.menu.name
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-2 text-right',
            onClick: this.onDisplayDetail
          },
          this.renderAvailabilities()
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__remove',
            onClick: this.onDeleteFromCategory
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__drag'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return CategoryDetailMenuRow;
}(_react.Component);

CategoryDetailMenuRow.propTypes = {
  menu: _propTypes2.default.objectOf(_Menu2.default).isRequired,
  currencyCode: _propTypes2.default.string,

  // parameters: Menu
  onDeleteFromCategory: _propTypes2.default.func.isRequired
};
var _default = CategoryDetailMenuRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryDetailMenuRow, 'CategoryDetailMenuRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailMenuRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailMenuRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailProductRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

var _RowPricesView = __webpack_require__("./scripts/components/order/RowPricesView.js");

var _RowPricesView2 = _interopRequireDefault(_RowPricesView);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- constants


// -- entities


// -- views


var CategoryModalProductRow = function (_Component) {
  _inherits(CategoryModalProductRow, _Component);

  function CategoryModalProductRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CategoryModalProductRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryModalProductRow.__proto__ || Object.getPrototypeOf(CategoryModalProductRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDisplayDetail = function () {
      var _this2;

      return (_this2 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onDeleteFromCategory = function () {
      var _this3;

      return (_this3 = _this).__onDeleteFromCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CategoryModalProductRow, [{
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteFromCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.product.equals(this.props.product);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentProductEdit(this.product);
    }
  }, {
    key: '__onDeleteFromCategory__REACT_HOT_LOADER__',
    value: function __onDeleteFromCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteFromCategory(this.product);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'product_category_view__row pointer row' },
        _react2.default.createElement(
          'div',
          { className: 'hidden-sm col-md-2 text-left' },
          _react2.default.createElement(_ImageLoader2.default, {
            src: this.product.image,
            className: 'product_category_view__row__image',
            placeholder: _ViewConstants2.default.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-6 product_category_view__row__name',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(
            'h4',
            null,
            this.product.name
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-2 text-right',
            onClick: this.onDisplayDetail
          },
          _react2.default.createElement(_RowPricesView2.default, {
            prices: this.product.prices,
            currencyCode: this.currencyCode
          })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__remove',
            onClick: this.onDeleteFromCategory
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-1 text-center product_category_view__row__drag'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'product',
    get: function get() {
      return this.props.product;
    }
  }, {
    key: 'currencyCode',
    get: function get() {
      return this.props.currencyCode;
    }
  }]);

  return CategoryModalProductRow;
}(_react.Component);

CategoryModalProductRow.propTypes = {
  product: _propTypes2.default.objectOf(_Product2.default).isRequired,
  currencyCode: _propTypes2.default.string,

  // parameters: Product
  onDeleteFromCategory: _propTypes2.default.func.isRequired
};
var _default = CategoryModalProductRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CategoryModalProductRow, 'CategoryModalProductRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailProductRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/detail/components/UpsellingCategoryDetailProductRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/list/UpsellingCategoriesListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _AbstractRestaurantMenuComponent = __webpack_require__("./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js");

var _AbstractRestaurantMenuComponent2 = _interopRequireDefault(_AbstractRestaurantMenuComponent);

var _FixedSubmitArea = __webpack_require__("./sdk/scripts/components/form/FixedSubmitArea.js");

var _FixedSubmitArea2 = _interopRequireDefault(_FixedSubmitArea);

var _UpsellingCategoryRow = __webpack_require__("./scripts/pages/menu/upsellingCategories/list/components/UpsellingCategoryRow.js");

var _UpsellingCategoryRow2 = _interopRequireDefault(_UpsellingCategoryRow);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _EditUpsellingCategoryModal = __webpack_require__("./scripts/components/restaurantMenu/upsellingCategoryModal/EditUpsellingCategoryModal.js");

var _EditUpsellingCategoryModal2 = _interopRequireDefault(_EditUpsellingCategoryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities


// -- views


var UpsellingCategoriesListPage = function (_AbstractRestaurantMe) {
  _inherits(UpsellingCategoriesListPage, _AbstractRestaurantMe);

  function UpsellingCategoriesListPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpsellingCategoriesListPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpsellingCategoriesListPage.__proto__ || Object.getPrototypeOf(UpsellingCategoriesListPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, _this.getDefaultState(), {
      displayEditCategoryModal: false
    }), _this.onUpdateRestaurantMenuSuccess = function () {
      var _this2;

      return (_this2 = _this).__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onAddCategoryClick = function () {
      var _this3;

      return (_this3 = _this).__onAddCategoryClick__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.hideEditCategoryModal = function () {
      var _this4;

      return (_this4 = _this).__hideEditCategoryModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onOrderChange = function () {
      var _this5;

      return (_this5 = _this).__onOrderChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onToggleActivationUpsellingCategory = function () {
      var _this6;

      return (_this6 = _this).__onToggleActivationUpsellingCategory__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onDeleteUpsellingCategory = function () {
      var _this7;

      return (_this7 = _this).__onDeleteUpsellingCategory__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.renderRow = function () {
      var _this8;

      return (_this8 = _this).__renderRow__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpsellingCategoriesListPage, [{
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__() {
      return this.__renderRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteUpsellingCategory__REACT_HOT_LOADER__',
    value: function __onDeleteUpsellingCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteUpsellingCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleActivationUpsellingCategory__REACT_HOT_LOADER__',
    value: function __onToggleActivationUpsellingCategory__REACT_HOT_LOADER__() {
      return this.__onToggleActivationUpsellingCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderChange__REACT_HOT_LOADER__',
    value: function __onOrderChange__REACT_HOT_LOADER__() {
      return this.__onOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__hideEditCategoryModal__REACT_HOT_LOADER__',
    value: function __hideEditCategoryModal__REACT_HOT_LOADER__() {
      return this.__hideEditCategoryModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddCategoryClick__REACT_HOT_LOADER__',
    value: function __onAddCategoryClick__REACT_HOT_LOADER__() {
      return this.__onAddCategoryClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__',
    value: function __onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__() {
      return this.__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantMenuStore.addListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantMenuStore.removeListener(_constants.Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.restaurantMenu.equals(this.props.restaurantMenu)) {
        this.setState({
          restaurantMenu: nextProps.restaurantMenu.copy()
        });
      }
    }
  }, {
    key: '__onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onUpdateRestaurantMenuSuccess__REACT_HOT_LOADER__() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: '__onAddCategoryClick__REACT_HOT_LOADER__',
    value: function __onAddCategoryClick__REACT_HOT_LOADER__() {
      this.setState({
        displayEditCategoryModal: true
      });
    }
  }, {
    key: '__hideEditCategoryModal__REACT_HOT_LOADER__',
    value: function __hideEditCategoryModal__REACT_HOT_LOADER__() {
      this.setState({
        displayEditCategoryModal: false
      });
    }
  }, {
    key: '__onOrderChange__REACT_HOT_LOADER__',
    value: function __onOrderChange__REACT_HOT_LOADER__(items) {
      var restaurantMenu = this.restaurantMenu;

      restaurantMenu.categories = items;

      this.setState({
        restaurantMenu: restaurantMenu
      });
    }
  }, {
    key: '__onToggleActivationUpsellingCategory__REACT_HOT_LOADER__',
    value: function __onToggleActivationUpsellingCategory__REACT_HOT_LOADER__(category) {
      if (_SecurityContext2.default.restaurantMenu.canEdit()) {
        var restaurantMenu = this.restaurantMenu;
        category.enabled = !category.enabled;

        restaurantMenu.toggleUpsellingCategory(category);

        this.setState({
          restaurantMenu: restaurantMenu
        });
      }
    }
  }, {
    key: '__onDeleteUpsellingCategory__REACT_HOT_LOADER__',


    //
    // getters
    //

    value: function __onDeleteUpsellingCategory__REACT_HOT_LOADER__(category) {
      var _this9 = this;

      _Notify2.default.confirm(_I18n2.default.tr('menu.upselling_category.confirm_deletion'), function (result) {
        if (result) {
          var restaurantMenu = _this9.restaurantMenu;

          restaurantMenu.removeUpsellingCategory(category);

          _this9.setState({
            restaurantMenu: restaurantMenu
          });
        }
      });
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.state.restaurantMenu.equals(this.props.restaurantMenu);
    }

    //
    // renderers
    //

  }, {
    key: 'renderEditModal',
    value: function renderEditModal() {
      var _this10 = this;

      var newUpsellingCategory = new _menu.UpsellingCategory();
      newUpsellingCategory.id = _Utils2.default.generateUID();

      return _react2.default.createElement(_EditUpsellingCategoryModal2.default, {
        isEdit: false,
        upsellingCategory: newUpsellingCategory,
        onUpdate: function onUpdate(upsellingCategory) {
          var restaurantMenu = _this10.restaurantMenu;
          restaurantMenu.addUpsellingCategory(upsellingCategory);
          _this10.setState({
            restaurantMenu: restaurantMenu
          }, function () {
            // when we add a category, we want to click on it to add products, but it fails if the
            // category isn't on the store. So we save it.
            _this10.onSubmit();
          });
        },
        show: this.state.displayEditCategoryModal,
        onHide: this.hideEditCategoryModal
      });
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      if (!_SecurityContext2.default.restaurantMenu.canEdit()) {
        return null;
      }

      if (_lodash2.default.isEmpty(this.restaurantMenu.products)) {
        return _react2.default.createElement(
          'p',
          { className: 'bg-warning' },
          _I18n2.default.tr('menu.upselling_category.error_no_products_exists')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'alert alert-info' },
            _I18n2.default.tr('menu.upselling_category.caption')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-sm-12 col-md-6' },
          _react2.default.createElement(_RoundButton2.default, {
            text: _I18n2.default.tr('menu.upselling_category.add_category'),
            onClick: this.onAddCategoryClick
          })
        )
      );
    }
  }, {
    key: 'renderTheadContent',
    value: function renderTheadContent() {
      return _react2.default.createElement(
        'div',
        { className: 'thead' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8 col-sm-4' },
          _I18n2.default.tr('menu.upselling_category.table.header.name')
        ),
        _react2.default.createElement(
          'div',
          { className: 'hidden-xs col-sm-4' },
          _I18n2.default.tr('menu.upselling_category.table.header.description')
        ),
        _react2.default.createElement(
          'div',
          { className: 'hidden-xs col-sm-2' },
          _I18n2.default.tr('menu.upselling_category.table.header.enabled')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _I18n2.default.tr('menu.upselling_category.table.header.delete')
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-1 text-center' },
          _I18n2.default.tr('menu.upselling_category.table.header.move')
        )
      );
    }
  }, {
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__(upsellingCategory) {
      return _react2.default.createElement(_UpsellingCategoryRow2.default, {
        upsellingCategory: upsellingCategory,
        restaurantMenu: this.restaurantMenu,
        key: upsellingCategory.name,
        onDeleteUpsellingCategory: this.onDeleteUpsellingCategory,
        onToggleActivationUpsellingCategory: this.onToggleActivationUpsellingCategory
      });
    }
  }, {
    key: 'renderCategoriesListView',
    value: function renderCategoriesListView() {
      return _react2.default.createElement(_SortableList2.default, {
        items: this.restaurantMenu.upsellingCategories,
        onChange: this.onOrderChange,
        renderer: this.renderRow,
        displayDragIcon: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'categories_list top-buffer-30' },
        this.renderHeader(),
        !_lodash2.default.isEmpty(this.restaurantMenu.upsellingCategories) && _react2.default.createElement(
          'div',
          { className: 'table_container table_container_hover top-buffer-50 row' },
          this.renderTheadContent(),
          this.renderCategoriesListView()
        ),
        this.renderEditModal(),
        _SecurityContext2.default.restaurantMenu.canEdit() && this.renderFixedButtons(),
        this.renderLoading()
      );
    }
  }, {
    key: 'restaurantMenu',
    get: function get() {
      return this.state.restaurantMenu;
    }
  }]);

  return UpsellingCategoriesListPage;
}(_AbstractRestaurantMenuComponent2.default);

exports.default = UpsellingCategoriesListPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UpsellingCategoriesListPage, 'UpsellingCategoriesListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/list/UpsellingCategoriesListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/menu/upsellingCategories/list/components/UpsellingCategoryRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _EnabledDisabledIcon = __webpack_require__("./sdk/scripts/components/EnabledDisabledIcon.js");

var _EnabledDisabledIcon2 = _interopRequireDefault(_EnabledDisabledIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- actions


// -- entities


// -- views


var UpsellingCategoryRow = function (_Component) {
  _inherits(UpsellingCategoryRow, _Component);

  function UpsellingCategoryRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpsellingCategoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpsellingCategoryRow.__proto__ || Object.getPrototypeOf(UpsellingCategoryRow)).call.apply(_ref, [this].concat(args))), _this), _this.onDeleteCategory = function () {
      var _this2;

      return (_this2 = _this).__onDeleteCategory__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onUpCategory = function () {
      var _this3;

      return (_this3 = _this).__onUpCategory__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDownCategory = function () {
      var _this4;

      return (_this4 = _this).__onDownCategory__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDisplayDetail = function () {
      var _this5;

      return (_this5 = _this).__onDisplayDetail__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onToggleActivationCategory = function () {
      var _this6;

      return (_this6 = _this).__onToggleActivationCategory__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpsellingCategoryRow, [{
    key: '__onToggleActivationCategory__REACT_HOT_LOADER__',
    value: function __onToggleActivationCategory__REACT_HOT_LOADER__() {
      return this.__onToggleActivationCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      return this.__onDisplayDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDownCategory__REACT_HOT_LOADER__',
    value: function __onDownCategory__REACT_HOT_LOADER__() {
      return this.__onDownCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpCategory__REACT_HOT_LOADER__',
    value: function __onUpCategory__REACT_HOT_LOADER__() {
      return this.__onUpCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteCategory__REACT_HOT_LOADER__',
    value: function __onDeleteCategory__REACT_HOT_LOADER__() {
      return this.__onDeleteCategory__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.upsellingCategory.equals(this.props.upsellingCategory) || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
    }
  }, {
    key: '__onDeleteCategory__REACT_HOT_LOADER__',
    value: function __onDeleteCategory__REACT_HOT_LOADER__() {
      this.props.onDeleteUpsellingCategory(this.props.upsellingCategory);
    }
  }, {
    key: '__onUpCategory__REACT_HOT_LOADER__',
    value: function __onUpCategory__REACT_HOT_LOADER__() {
      this.props.onMoveUpUpsellingCategory(this.props.upsellingCategory);
    }
  }, {
    key: '__onDownCategory__REACT_HOT_LOADER__',
    value: function __onDownCategory__REACT_HOT_LOADER__() {
      this.props.onMoveDownUpsellingCategory(this.props.upsellingCategory);
    }
  }, {
    key: '__onDisplayDetail__REACT_HOT_LOADER__',
    value: function __onDisplayDetail__REACT_HOT_LOADER__() {
      _actions.RouteAction.presentUpsellingCategoryDetail(this.props.upsellingCategory);
    }
  }, {
    key: '__onToggleActivationCategory__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onToggleActivationCategory__REACT_HOT_LOADER__() {
      this.props.onToggleActivationUpsellingCategory(this.props.upsellingCategory);
    }
  }, {
    key: 'renderEnabled',
    value: function renderEnabled() {
      return _react2.default.createElement(_reactBootstrapSwitch2.default, {
        bsSize: 'mini',
        value: this.props.upsellingCategory.enabled,
        onChange: this.onToggleActivationCategory,
        disabled: !_SecurityContext2.default.restaurantMenu.canEdit()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var upsellingCategory = this.props.upsellingCategory;

      return _react2.default.createElement(
        'div',
        { className: 'category_row pointer row' },
        _react2.default.createElement(
          'div',
          {
            className: 'pointer col-xs-8 col-sm-4 category_row__name h100',
            onClick: this.onDisplayDetail
          },
          upsellingCategory.name
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'pointer hidden-xs col-sm-4 category_row__description h100',
            onClick: this.onDisplayDetail
          },
          upsellingCategory.description
        ),
        _react2.default.createElement(
          'div',
          { className: 'hidden-xs col-sm-2' },
          this.renderEnabled()
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer text-center col-xs-1 category_row__delete h100',
            onClick: this.onDeleteCategory
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.restaurantMenu.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer text-center col-xs-1 category_row__drag h100'
          },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }]);

  return UpsellingCategoryRow;
}(_react.Component);

UpsellingCategoryRow.propTypes = {
  upsellingCategory: _propTypes2.default.objectOf(_menu.UpsellingCategory).isRequired,

  restaurantMenu: _propTypes2.default.objectOf(_menu.RestaurantMenu).isRequired,

  /**
   * @param UpsellingCategory
   */
  onToggleActivationUpsellingCategory: _propTypes2.default.func.isRequired,

  /**
   * @param UpsellingCategory
   */
  onDeleteUpsellingCategory: _propTypes2.default.func.isRequired,

  /**
   * @param UpsellingCategory
   */
  onMoveUpUpsellingCategory: _propTypes2.default.func.isRequired,

  /**
   * @param UpsellingCategory
   */
  onMoveDownUpsellingCategory: _propTypes2.default.func.isRequired

};
UpsellingCategoryRow.defaultProps = {
  hideDeactivatedProducts: true
};
var _default = UpsellingCategoryRow;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UpsellingCategoryRow, 'UpsellingCategoryRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/list/components/UpsellingCategoryRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/menu/upsellingCategories/list/components/UpsellingCategoryRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/components/ConditionRule.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _ItemsList = __webpack_require__("./scripts/pages/order/cartModifiers/components/ItemsList.js");

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function handleChange(conditionRule, selectedItems, type) {
  // remove all items that were set with the given `type`
  var other = (conditionRule.itemsList || []).filter(function (item) {
    return item.type !== type;
  });

  // map a CategoryItem to {id / type}
  var items = selectedItems.map(function (item) {
    return {
      id: item.id,
      type: type
    };
  });

  conditionRule.itemsList = [].concat(_toConsumableArray(other), _toConsumableArray(items));
  return conditionRule;
}

function filterItemsByType(itemsList, type) {
  return (itemsList || []).filter(function (item) {
    return item.type === type;
  });
}

var ConditionRule = function ConditionRule(_ref) {
  var restaurantMenu = _ref.restaurantMenu,
      conditionRule = _ref.conditionRule,
      _onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onDisplayItemSelector = _ref.onDisplayItemSelector;

  try {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _reactBootstrap.FormGroup,
        null,
        _react2.default.createElement(
          _reactBootstrap.Col,
          { componentClass: 'label', className: 'text-left control-label', sm: 4 },
          _I18n2.default.tr('order.cart_modifiers.condition_rule.min')
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 2 },
          _react2.default.createElement(_reactBootstrap.FormControl, {
            type: 'number',
            value: conditionRule.itemsNumber,
            onChange: function onChange(e) {
              conditionRule.itemsNumber = e.target.value;
              _onChange(conditionRule);
            }
          })
        ),
        _react2.default.createElement(
          'a',
          { className: 'col-xs-1 text-right pull-right link', onClick: function onClick() {
              return onDelete(conditionRule);
            } },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.FormGroup,
        null,
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 12 },
          _react2.default.createElement(
            'div',
            {
              className: 'btn btn-primary btn-cta',
              onClick: function onClick() {
                return onDisplayItemSelector(conditionRule);
              },
              style: {
                marginBottom: '40px'
              }
            },
            'Modifier les \xE9l\xE9ments'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 4 },
          _react2.default.createElement(_ItemsList2.default, {
            restaurantMenu: restaurantMenu,
            type: _CategoryItem2.default.Type.CATEGORY,
            items: filterItemsByType(conditionRule.itemsList, _CategoryItem2.default.Type.CATEGORY)
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 4 },
          _react2.default.createElement(_ItemsList2.default, {
            restaurantMenu: restaurantMenu,
            type: _CategoryItem2.default.Type.PRODUCT,
            items: filterItemsByType(conditionRule.itemsList, _CategoryItem2.default.Type.PRODUCT)
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 4 },
          _react2.default.createElement(_ItemsList2.default, {
            restaurantMenu: restaurantMenu,
            type: _CategoryItem2.default.Type.MENU,
            items: filterItemsByType(conditionRule.itemsList, _CategoryItem2.default.Type.MENU)
          })
        )
      )
    );
  } catch (e) {
    console.error(e);
  }
};

ConditionRule.propTypes = {
  restaurantMenu: _react.PropTypes.object.isRequired,
  conditionRule: _react.PropTypes.object,
  onDelete: _react.PropTypes.func.isRequired
};

var _default = ConditionRule;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(handleChange, 'handleChange', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRule.js');

  __REACT_HOT_LOADER__.register(filterItemsByType, 'filterItemsByType', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRule.js');

  __REACT_HOT_LOADER__.register(ConditionRule, 'ConditionRule', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRule.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRule.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/components/ConditionRules.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ConditionRulesList = __webpack_require__("./scripts/pages/order/cartModifiers/components/ConditionRulesList.js");

var _ConditionRulesList2 = _interopRequireDefault(_ConditionRulesList);

var _ItemSelectorModal = __webpack_require__("./scripts/components/menu/ItemSelectorModal/ItemSelectorModal.js");

var _ItemSelectorModal2 = _interopRequireDefault(_ItemSelectorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Btn = function Btn(_ref) {
  var onChange = _ref.onChange,
      conditionRules = _ref.conditionRules;
  return _react2.default.createElement(
    'div',
    {
      className: 'btn btn-primary btn-add',
      onClick: function onClick() {
        return onChange([].concat(_toConsumableArray(conditionRules), [{
          id: _Utils2.default.generateUID(),
          itemsNumber: 0,
          itemsList: []
          // itemsList: [{
          //   type: null,
          //   id: Utils.generateUID(),
          // }]
        }]));
      }
    },
    _react2.default.createElement('i', { className: 'fa fa-plus' }),
    '\xA0',
    _I18n2.default.tr('order.cart_modifiers.conditions_rules.add_rule')
  );
};

var ConditionRules = function (_React$Component) {
  _inherits(ConditionRules, _React$Component);

  function ConditionRules() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ConditionRules);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ConditionRules.__proto__ || Object.getPrototypeOf(ConditionRules)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      displayItemSelector: false,
      conditionRuleToSelectItems: null
    }, _this.handleDisplayItemSelector = function () {
      var _this2;

      return (_this2 = _this).__handleDisplayItemSelector__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleHideItemSelector = function () {
      var _this3;

      return (_this3 = _this).__handleHideItemSelector__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.hanteItemsChangeForConditionRule = function () {
      var _this4;

      return (_this4 = _this).__hanteItemsChangeForConditionRule__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConditionRules, [{
    key: '__hanteItemsChangeForConditionRule__REACT_HOT_LOADER__',
    value: function __hanteItemsChangeForConditionRule__REACT_HOT_LOADER__() {
      return this.__hanteItemsChangeForConditionRule__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleHideItemSelector__REACT_HOT_LOADER__',
    value: function __handleHideItemSelector__REACT_HOT_LOADER__() {
      return this.__handleHideItemSelector__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDisplayItemSelector__REACT_HOT_LOADER__',
    value: function __handleDisplayItemSelector__REACT_HOT_LOADER__() {
      return this.__handleDisplayItemSelector__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDisplayItemSelector__REACT_HOT_LOADER__',
    value: function __handleDisplayItemSelector__REACT_HOT_LOADER__(conditionRule) {
      this.setState({
        displayItemSelector: true,
        conditionRuleToSelectItems: conditionRule
      });
    }
  }, {
    key: '__handleHideItemSelector__REACT_HOT_LOADER__',
    value: function __handleHideItemSelector__REACT_HOT_LOADER__() {
      this.setState({
        displayItemSelector: false,
        conditionRuleToSelectItems: null
      });
    }
  }, {
    key: '__hanteItemsChangeForConditionRule__REACT_HOT_LOADER__',
    value: function __hanteItemsChangeForConditionRule__REACT_HOT_LOADER__(conditionRule, items) {
      conditionRule.itemsList = items;
      this.props.onChange(_ArrayUtils2.default.updateObject(this.props.conditionRules, conditionRule, function (oldRule) {
        return oldRule.id === conditionRule.id;
      }));
      this.handleHideItemSelector();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      try {
        var _props = this.props,
            restaurantMenu = _props.restaurantMenu,
            conditionRules = _props.conditionRules,
            _props$singleMode = _props.singleMode,
            singleMode = _props$singleMode === undefined ? false : _props$singleMode,
            onChange = _props.onChange;

        return _react2.default.createElement(
          'div',
          null,
          !_lodash2.default.isEmpty(conditionRules) && _react2.default.createElement(_ConditionRulesList2.default, {
            restaurantMenu: restaurantMenu,
            conditionRules: _lodash2.default.clone(conditionRules),
            onChange: onChange,
            onDisplayItemSelector: this.handleDisplayItemSelector
          }),
          !singleMode && _react2.default.createElement(Btn, {
            onChange: onChange,
            conditionRules: conditionRules
          }),
          singleMode && _lodash2.default.isEmpty(conditionRules) && _react2.default.createElement(Btn, {
            onChange: onChange,
            conditionRules: conditionRules
          }),
          this.state.displayItemSelector && _react2.default.createElement(_ItemSelectorModal2.default, {
            show: true,
            onHide: this.handleHideItemSelector,
            restaurantMenu: restaurantMenu,
            values: this.state.conditionRuleToSelectItems.itemsList || [],
            onChange: function onChange(items) {
              return _this5.hanteItemsChangeForConditionRule(_this5.state.conditionRuleToSelectItems, items);
            }
          })
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return ConditionRules;
}(_react2.default.Component);

ConditionRules.propTypes = {
  restaurantMenu: _react.PropTypes.object.isRequired,
  conditionRules: _react.PropTypes.array.isRequired,
  onChange: _react.PropTypes.func.isRequired,

  // Target contains not an array but an object
  singleMode: _react.PropTypes.bool
};

var _default = ConditionRules;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Btn, 'Btn', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRules.js');

  __REACT_HOT_LOADER__.register(ConditionRules, 'ConditionRules', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRules.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRules.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/components/ConditionRulesList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ConditionRule = __webpack_require__("./scripts/pages/order/cartModifiers/components/ConditionRule.js");

var _ConditionRule2 = _interopRequireDefault(_ConditionRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionRulesList = function ConditionRulesList(_ref) {
  var restaurantMenu = _ref.restaurantMenu,
      conditionRules = _ref.conditionRules,
      _onChange = _ref.onChange,
      onDisplayItemSelector = _ref.onDisplayItemSelector;
  return _react2.default.createElement(
    'div',
    null,
    conditionRules.map(function (conditionRule, index) {
      return _react2.default.createElement(_ConditionRule2.default
      // key={conditionRule.id}
      , { key: index,
        restaurantMenu: restaurantMenu,
        conditionRule: conditionRule,
        onChange: function onChange(rule) {
          return _onChange(_ArrayUtils2.default.updateObject(conditionRules, rule, function (oldRule) {
            return oldRule.id === rule.id;
          }));
        },
        onDelete: function onDelete(rule) {
          return _onChange(_ArrayUtils2.default.removeObject(conditionRules, function (oldRule) {
            return oldRule.id === rule.id;
          }));
        },
        onDisplayItemSelector: onDisplayItemSelector
      });
    })
  );
};

ConditionRulesList.propTypes = {
  restaurantMenu: _react.PropTypes.object.isRequired,
  conditionRules: _react.PropTypes.array,
  onChange: _react.PropTypes.func.isRequired
};

var _default = ConditionRulesList;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ConditionRulesList, 'ConditionRulesList', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRulesList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ConditionRulesList.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/components/ItemsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _StringUtils = __webpack_require__("./sdk/scripts/utils/StringUtils.js");

var _StringUtils2 = _interopRequireDefault(_StringUtils);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function Item(_ref) {
  var item = _ref.item,
      isMainCategory = _ref.isMainCategory;
  return _react2.default.createElement(
    'div',
    {
      style: {
        padding: '6px 0'
      }
    },
    isMainCategory || !item ? _I18n2.default.tr('menu.category.add_item.main_category') : item.name
  );
};

var sort = function sort(list) {
  return _.sortBy(_.compact(list), ['desc'], function (item) {
    // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
    return _StringUtils2.default.toAlphaNum(item.name).toLowerCase();
  });
};

var ItemsList = function ItemsList(_ref2) {
  var type = _ref2.type,
      items = _ref2.items,
      restaurantMenu = _ref2.restaurantMenu;

  // items is an {id, type}, we wants the real object from the restaurantMenu
  var itemsList = items.map(function (item) {
    return restaurantMenu.getItem(item);
  });

  return _react2.default.createElement(
    _reactBootstrap.FormGroup,
    { controlId: 'formControlsSelectMultiple' },
    _react2.default.createElement(
      _reactBootstrap.Col,
      { sm: 12 },
      _react2.default.createElement(
        _reactBootstrap.ControlLabel,
        null,
        _I18n2.default.tr('order.cart_modifiers.items_list.' + type)
      ),
      _react2.default.createElement(
        'div',
        {
          style: {
            minHeight: '50px',
            maxHeight: '300px',
            overflowY: 'auto'
          }
        },
        sort(itemsList).map(function (item) {
          return !item ? null : _react2.default.createElement(Item, {
            key: item.id,
            item: item,
            isMainCategory: restaurantMenu.rootCategoryId === item.id
          });
        })
      )
    )
  );
};

ItemsList.propTypes = {
  itemsList: _react.PropTypes.object,
  onChange: _react.PropTypes.func.isRequired
};

var _default = ItemsList;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Item, 'Item', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ItemsList.js');

  __REACT_HOT_LOADER__.register(sort, 'sort', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ItemsList.js');

  __REACT_HOT_LOADER__.register(ItemsList, 'ItemsList', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ItemsList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/components/ItemsList.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/edit/View.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _reactDatetime = __webpack_require__("./node_modules/react-datetime/DateTime.js");

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _AvailabilityHours = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHours.js");

var _AvailabilityHours2 = _interopRequireDefault(_AvailabilityHours);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _OrderViewUtils = __webpack_require__("./sdk/scripts/utils/OrderViewUtils.js");

var _OrderViewUtils2 = _interopRequireDefault(_OrderViewUtils);

var _ObjectUtils = __webpack_require__("./sdk/scripts/utils/ObjectUtils.js");

var _ObjectUtils2 = _interopRequireDefault(_ObjectUtils);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _AvailabilityHoursForm = __webpack_require__("./scripts/pages/menu/components/availabilityHours/AvailabilityHoursForm.js");

var _AvailabilityHoursForm2 = _interopRequireDefault(_AvailabilityHoursForm);

var _ConditionRules = __webpack_require__("./scripts/pages/order/cartModifiers/components/ConditionRules.js");

var _ConditionRules2 = _interopRequireDefault(_ConditionRules);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = function (_AbstractComponent) {
  _inherits(View, _AbstractComponent);

  function View() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, View);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switchPeriod: false,
      switchWeeklyAvailabilities: false,
      switchApiConsumerIds: false,
      switchComposition: false,
      switchShippingCost: false
    }, _this.updateStateWithNextProps = function () {
      var _this2;

      return (_this2 = _this).__updateStateWithNextProps__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleChange = function () {
      var _this3;

      return (_this3 = _this).__handleChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSwitch = function () {
      var _this4;

      return (_this4 = _this).__onSwitch__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(View, [{
    key: '__onSwitch__REACT_HOT_LOADER__',
    value: function __onSwitch__REACT_HOT_LOADER__() {
      return this.__onSwitch__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleChange__REACT_HOT_LOADER__',
    value: function __handleChange__REACT_HOT_LOADER__() {
      return this.__handleChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__updateStateWithNextProps__REACT_HOT_LOADER__',
    value: function __updateStateWithNextProps__REACT_HOT_LOADER__() {
      return this.__updateStateWithNextProps__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateStateWithNextProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateStateWithNextProps(nextProps);
    }
  }, {
    key: '__updateStateWithNextProps__REACT_HOT_LOADER__',
    value: function __updateStateWithNextProps__REACT_HOT_LOADER__(nextProps) {
      var cartModifier = nextProps.cartModifier;


      this.setState({
        switchPeriod: cartModifier.hasDefinedDateCondition(),
        switchWeeklyAvailabilities: cartModifier.hasDefinedWeeklyAvailabilities(),
        switchComposition: cartModifier.hasDefinedComposition(),
        switchApiConsumerIds: cartModifier.hasDefinedApiConsumerIds()
      });
    }
  }, {
    key: '__handleChange__REACT_HOT_LOADER__',
    value: function __handleChange__REACT_HOT_LOADER__(path, value) {
      this.props.onChange(_ObjectUtils2.default.setForPath(this.props.cartModifier.copy(), path, value));
    }
  }, {
    key: '__onSwitch__REACT_HOT_LOADER__',
    value: function __onSwitch__REACT_HOT_LOADER__(key) {
      switch (key) {
        case 'switchPeriod':
          if (this.state[key]) {
            this.handleChange('condition.dateCondition.beginningDate', null);
            this.handleChange('condition.dateCondition.endDate', null);
          } else {
            this.handleChange('condition.dateCondition.beginningDate', (0, _moment2.default)());
            this.handleChange('condition.dateCondition.endDate', (0, _moment2.default)());
          }
          break;

        case 'switchWeeklyAvailabilities':
          if (this.state[key]) {
            this.handleChange('condition.dateCondition.weeklyAvailabilities', null);
          } else {
            this.handleChange('condition.dateCondition.weeklyAvailabilities', new _AvailabilityHours2.default());
          }
          break;

        case 'switchComposition':
          if (this.state[key]) {
            this.handleChange('condition.itemCondition.itemsRequired', null);
            this.handleChange('condition.itemCondition.itemsForbidden', null);
          } else {
            this.handleChange('condition.itemCondition.itemsRequired', []);
            this.handleChange('condition.itemCondition.itemsForbidden', []);
          }
          break;

        case 'switchApiConsumerIds':
          if (this.state[key]) {
            this.handleChange('condition.frontCondition.apiConsumerIds', null);
          } else {
            this.handleChange('condition.frontCondition.apiConsumerIds', []);
          }
          break;

        default:
          var newState = {};
          newState[key] = !this.state[key];
          this.setState(newState);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var apiConsumers = this.props.apiConsumers;
      var cartModifier = this.props.cartModifier;
      var currencyCode = this.props.currencyCode;
      var localizedNames = cartModifier.localizedNames,
          localizedDescriptions = cartModifier.localizedDescriptions,
          localizedTags = cartModifier.localizedTags,
          combinable = cartModifier.combinable,
          code = cartModifier.code,
          condition = cartModifier.condition,
          target = cartModifier.target,
          action = cartModifier.action;


      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            { className: 'page-header' },
            _I18n2.default.tr('order.cart_modifiers.general.title')
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.general.name.label'),
              '\xA0*'
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_form.TextInputLocalized, {
                locales: _Constants2.default.localesForTranslation,
                values: localizedNames,
                isRequired: true,
                className: 'form-control',
                placeholder: _I18n2.default.tr('order.cart_modifiers.general.name.placeholder'),
                onChange: function onChange(value) {
                  return _this5.handleChange('localizedNames', value);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.general.tag.label'),
              '\xA0*'
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_form.TextInputLocalized, {
                locales: _Constants2.default.localesForTranslation,
                values: localizedTags,
                className: 'form-control',
                placeholder: _I18n2.default.tr('order.cart_modifiers.general.tag.placeholder'),
                max: _CartModifier2.default.TAG_LIMIT,
                onChange: function onChange(value) {
                  return _this5.handleChange('localizedTags', value);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.general.description.label')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_form.TextInputLocalized, {
                locales: _Constants2.default.localesForTranslation,
                values: localizedDescriptions,
                className: 'form-control',
                placeholder: _I18n2.default.tr('order.cart_modifiers.general.description.placeholder'),
                onChange: function onChange(value) {
                  return _this5.handleChange('localizedDescriptions', value);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.general.combinable.label')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                bsSize: 'mini',
                onChange: function onChange() {
                  _this5.handleChange('combinable', !combinable);
                },
                value: combinable
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.general.code.label'),
              _react2.default.createElement(_TipTooltip2.default, { text: _I18n2.default.tr('order.cart_modifiers.general.code.tooltip') })
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_form.TextInput, {
                value: code,
                className: 'form-control',
                onChange: function onChange(value) {
                  return _this5.handleChange('code', _lodash2.default.isEmpty(value) ? null : value);
                }
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            { className: 'page-header' },
            _I18n2.default.tr('order.cart_modifiers.conditions_rules.title')
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.dateCondition.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                bsSize: 'mini',
                onChange: function onChange() {
                  return _this5.onSwitch('switchPeriod');
                },
                value: this.state.switchPeriod
              })
            )
          ),
          this.state.switchPeriod && _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, smOffset: 3, md: 4 },
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                null,
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  null,
                  _I18n2.default.tr('order.cart_modifiers.conditions_rules.dateCondition.from')
                ),
                _react2.default.createElement(_reactDatetime2.default, {
                  value: (0, _moment2.default)(condition.dateCondition.beginningDate),
                  onChange: function onChange(date) {
                    return _this5.handleChange('condition.dateCondition.beginningDate', date);
                  }
                })
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, smOffset: 3, md: 4, mdOffset: 0 },
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                null,
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  null,
                  _I18n2.default.tr('order.cart_modifiers.conditions_rules.dateCondition.to')
                ),
                _react2.default.createElement(_reactDatetime2.default, {
                  value: (0, _moment2.default)(condition.dateCondition.endDate),
                  onChange: function onChange(date) {
                    return _this5.handleChange('condition.dateCondition.endDate', date);
                  }
                })
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.weekly_availabilities.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                bsSize: 'mini',
                onChange: function onChange() {
                  return _this5.onSwitch('switchWeeklyAvailabilities');
                },
                value: this.state.switchWeeklyAvailabilities
              })
            )
          ),
          this.state.switchWeeklyAvailabilities && _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { smOffset: 3, xs: 9 },
              _react2.default.createElement(_AvailabilityHoursForm2.default, {
                availabilityHours: condition.dateCondition.weeklyAvailabilities.copy(),
                onAvailibilityHoursChange: function onAvailibilityHoursChange(availabilities) {
                  return _this5.handleChange('condition.dateCondition.weeklyAvailabilities', availabilities);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.mode.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _lodash2.default.values(_Order2.default.OrderMode).map(function (mode) {
                return _react2.default.createElement(
                  _reactBootstrap.Checkbox,
                  {
                    key: mode,
                    checked: cartModifier.isAvailableForMode(mode),
                    value: mode,
                    onChange: function onChange(e) {
                      _this5.handleChange('condition.orderModes', _lodash2.default.isNull(condition.orderModes) ? _lodash2.default.values(_Order2.default.OrderMode).filter(function (v) {
                        return v !== parseInt(e.target.value);
                      }) : condition.orderModes.includes(parseInt(e.target.value)) ? condition.orderModes.filter(function (v) {
                        return v !== parseInt(e.target.value);
                      }) : [].concat(_toConsumableArray(condition.orderModes), [parseInt(e.target.value)]));
                    },
                    inline: true
                  },
                  _OrderViewUtils2.default.getLabelForMode(mode)
                );
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.min_amount.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 2 },
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                null,
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  type: 'number',
                  value: condition.amountCondition.minOrderAmount,
                  onChange: function onChange(e) {
                    _this5.handleChange('condition.amountCondition.minOrderAmount', e.target.value);
                  }
                }),
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  null,
                  _utils.CurrencyUtils.getCurrencySymbol(currencyCode)
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 4 },
              _react2.default.createElement(
                _reactBootstrap.FormControl,
                {
                  componentClass: 'select',
                  placeholder: 'select',
                  value: condition.amountCondition.includeShippingCostInMinOrderAmount,
                  onChange: function onChange(e) {
                    _this5.handleChange('condition.amountCondition.includeShippingCostInMinOrderAmount', e.target.value);
                  }
                },
                _react2.default.createElement(
                  'option',
                  { value: false },
                  _I18n2.default.tr('order.cart_modifiers.conditions_rules.amount.shipingCostExcluded')
                ),
                _react2.default.createElement(
                  'option',
                  { value: true },
                  _I18n2.default.tr('order.cart_modifiers.conditions_rules.amount.shipingCostIncluded')
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.max_amount.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 2 },
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                null,
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  type: 'number',
                  value: condition.amountCondition.maxOrderAmount,
                  onChange: function onChange(e) {
                    _this5.handleChange('condition.amountCondition.maxOrderAmount', e.target.value);
                  }
                }),
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  null,
                  _utils.CurrencyUtils.getCurrencySymbol(currencyCode)
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 4 },
              _react2.default.createElement(
                _reactBootstrap.FormControl,
                {
                  componentClass: 'select',
                  placeholder: 'select',
                  value: condition.amountCondition.includeShippingCostInMaxOrderAmount,
                  onChange: function onChange(e) {
                    _this5.handleChange('condition.amountCondition.includeShippingCostInMaxOrderAmount', e.target.value);
                  }
                },
                _react2.default.createElement(
                  'option',
                  { value: false },
                  _I18n2.default.tr('order.cart_modifiers.conditions_rules.amount.shipingCostExcluded')
                ),
                _react2.default.createElement(
                  'option',
                  { value: true },
                  _I18n2.default.tr('order.cart_modifiers.conditions_rules.amount.shipingCostIncluded')
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.composition.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                bsSize: 'mini',
                onChange: function onChange() {
                  return _this5.onSwitch('switchComposition');
                },
                value: this.state.switchComposition
              })
            )
          ),
          this.state.switchComposition && _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { smOffset: 3, lg: 9 },
              _react2.default.createElement(_ConditionRules2.default, {
                restaurantMenu: this.props.restaurantMenu,
                conditionRules: condition.itemCondition.itemsRequired,
                onChange: function onChange(conditionRules) {
                  return _this5.handleChange('condition.itemCondition.itemsRequired', conditionRules);
                }
              })
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: 'label', className: 'control-label', sm: 3 },
              _I18n2.default.tr('order.cart_modifiers.conditions_rules.front.apiConsumerIds.title')
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { sm: 6, md: 5 },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                bsSize: 'mini',
                onChange: function onChange() {
                  return _this5.onSwitch('switchApiConsumerIds');
                },
                value: this.state.switchApiConsumerIds
              })
            )
          ),
          this.state.switchApiConsumerIds && apiConsumers && _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { smOffset: 3, lg: 9 },
              apiConsumers.map(function (_ref2) {
                var id = _ref2.id,
                    name = _ref2.name;
                return _react2.default.createElement(
                  'div',
                  { key: id },
                  _react2.default.createElement(
                    _reactBootstrap.Checkbox,
                    {
                      checked: (condition.frontCondition.apiConsumerIds || []).includes(id),
                      value: id,
                      onChange: function onChange(e) {
                        var newApiConsumerIds = [].concat(_toConsumableArray(condition.frontCondition.apiConsumerIds));
                        newApiConsumerIds = _ArrayUtils2.default.toggleValue(newApiConsumerIds, id);
                        _this5.handleChange('condition.frontCondition.apiConsumerIds', newApiConsumerIds);
                      },
                      inline: true
                    },
                    name
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            { className: 'page-header' },
            _I18n2.default.tr('order.cart_modifiers.actions.title')
          ),
          !cartModifier.isOfferingShippingCost() && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { componentClass: 'label', className: 'control-label', sm: 3 },
                _I18n2.default.tr('order.cart_modifiers.actions.offering_shipping_cost.reduction')
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 5 },
                _lodash2.default.keys(_CartModifier2.default.ActionType).map(function (type) {
                  return _react2.default.createElement(
                    _reactBootstrap.Radio,
                    {
                      key: type,
                      name: 'discountType',
                      value: type,
                      checked: cartModifier.hasActionType(type),
                      onChange: function onChange(e) {
                        _this5.handleChange('action.type', type);
                      }
                    },
                    _I18n2.default.tr('order.cart_modifiers.actiontype.' + type)
                  );
                })
              ),
              cartModifier.hasDefinedActionType() && _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 3 },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  null,
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    type: 'number',
                    value: action.value,
                    onChange: function onChange(e) {
                      _this5.handleChange('action.value', e.target.value);
                    }
                  }),
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    null,
                    action.type === _CartModifier2.default.ActionType.DISCOUNT_PERCENTAGE ? '%' : action.type === _CartModifier2.default.ActionType.DISCOUNT_AMOUNT ? _utils.CurrencyUtils.getCurrencySymbol(currencyCode) : ''
                  )
                )
              )
            ),
            cartModifier.hasDefinedActionType() && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { componentClass: 'label', className: 'control-label', sm: 3 },
                  _I18n2.default.tr('order.cart_modifiers.target')
                ),
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { sm: 5 },
                  _react2.default.createElement(
                    _reactBootstrap.FormControl,
                    {
                      componentClass: 'select',
                      placeholder: 'select',
                      value: target.type,
                      onChange: function onChange(e) {
                        _this5.handleChange('target.type', e.target.value);
                      }
                    },
                    _react2.default.createElement(
                      'option',
                      {
                        value: false,
                        disabled: true,
                        selected: !cartModifier.hasDefinedTargetType()
                      },
                      _I18n2.default.tr('order.cart_modifiers.target.type.title')
                    ),
                    _lodash2.default.keys(_CartModifier2.default.TargetType).map(function (type) {
                      return _react2.default.createElement(
                        'option',
                        { key: type, value: type },
                        _I18n2.default.tr('order.cart_modifiers.target_type.' + type)
                      );
                    })
                  )
                )
              ),
              (target.type === _CartModifier2.default.TargetType.SPECIFIC_ITEMS || target.type === _CartModifier2.default.TargetType.ALL_ITEMS_EXCEPT) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { componentClass: 'label', className: 'control-label', sm: 3 },
                    _I18n2.default.tr('order.cart_modifiers.cheapest_item')
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 6 },
                    _react2.default.createElement(_reactBootstrapSwitch2.default, {
                      bsSize: 'mini',
                      onChange: function onChange(_ref3) {
                        var state = _ref3.state;

                        _this5.handleChange('target.focusOnCheapestItems', state.value);
                      },
                      value: cartModifier.isFocusOnCheapestItems()
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { smOffset: 3, lg: 9 },
                    _react2.default.createElement(_ConditionRules2.default, {
                      restaurantMenu: this.props.restaurantMenu,
                      singleMode: true
                      // the conditionRules requires an array but here we want just an object
                      , conditionRules: _lodash2.default.isNull(target.items) ? [] : [target.items],
                      onChange: function onChange(conditionRules) {
                        return _this5.handleChange('target.items', conditionRules[0]);
                      }
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return View;
}(_AbstractComponent3.default);

View.propTypes = {
  restaurantMenu: _react.PropTypes.object.isRequired,
  cartModifier: _react.PropTypes.object.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  currencyCode: _react.PropTypes.string
};
exports.default = View;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(View, 'View', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/edit/View.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/edit/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _HourChooser = __webpack_require__("./sdk/scripts/components/form/HourChooser/index.js");

var _HourChooser2 = _interopRequireDefault(_HourChooser);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _ApiConsumersStore = __webpack_require__("./scripts/stores/ApiConsumersStore.js");

var _ApiConsumersStore2 = _interopRequireDefault(_ApiConsumersStore);

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _CartModifierAction = __webpack_require__("./scripts/actions/CartModifierAction.js");

var _CartModifierAction2 = _interopRequireDefault(_CartModifierAction);

var _CartModifierStore = __webpack_require__("./scripts/stores/CartModifierStore.js");

var _CartModifierStore2 = _interopRequireDefault(_CartModifierStore);

var _RestaurantMenuAction = __webpack_require__("./scripts/actions/RestaurantMenuAction.js");

var _RestaurantMenuAction2 = _interopRequireDefault(_RestaurantMenuAction);

var _RestaurantMenuStore = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore2 = _interopRequireDefault(_RestaurantMenuStore);

var _RestaurantsGroupAction = __webpack_require__("./scripts/actions/RestaurantsGroupAction.js");

var _RestaurantsGroupAction2 = _interopRequireDefault(_RestaurantsGroupAction);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _View = __webpack_require__("./scripts/pages/order/cartModifiers/edit/View.js");

var _View2 = _interopRequireDefault(_View);

__webpack_require__("./scripts/pages/order/cartModifiers/edit/style.scss");

var _fixture = __webpack_require__("./scripts/pages/order/cartModifiers/fixture.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromotionsEdit = function (_AbstractFormComponen) {
  _inherits(PromotionsEdit, _AbstractFormComponen);

  function PromotionsEdit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PromotionsEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromotionsEdit.__proto__ || Object.getPrototypeOf(PromotionsEdit)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(), _this.onFetchApiConsumers = function () {
      var _this2;

      return (_this2 = _this).__onFetchApiConsumers__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onCartModifierStoreChange = function () {
      var _this3;

      return (_this3 = _this).__onCartModifierStoreChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onFetchRestaurantMenu = function () {
      var _this4;

      return (_this4 = _this).__onFetchRestaurantMenu__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.handleChange = function () {
      var _this5;

      return (_this5 = _this).__handleChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onSubmit = function () {
      var _this6;

      return (_this6 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PromotionsEdit, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleChange__REACT_HOT_LOADER__',
    value: function __handleChange__REACT_HOT_LOADER__() {
      return this.__handleChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFetchRestaurantMenu__REACT_HOT_LOADER__',
    value: function __onFetchRestaurantMenu__REACT_HOT_LOADER__() {
      return this.__onFetchRestaurantMenu__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCartModifierStoreChange__REACT_HOT_LOADER__',
    value: function __onCartModifierStoreChange__REACT_HOT_LOADER__() {
      return this.__onCartModifierStoreChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFetchApiConsumers__REACT_HOT_LOADER__',
    value: function __onFetchApiConsumers__REACT_HOT_LOADER__() {
      return this.__onFetchApiConsumers__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      var cartModifier = this.isEditMode() ? _CartModifierStore2.default.getState().data : new _CartModifier2.default();
      return {
        restaurantMenuState: _RestaurantMenuStore2.default.getState(),
        cartModifierState: _CartModifierStore2.default.getState(),
        cartModifier: !_lodash2.default.isNull(cartModifier) ? cartModifier.copy() : cartModifier,
        defaultModifier: !_lodash2.default.isNull(cartModifier) ? cartModifier.copy() : cartModifier,
        apiConsumersState: _ApiConsumersStore2.default.getState(),
        restaurant: _RestaurantStore2.default.getRestaurant()
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_RestaurantStore2.default.getRestaurant().haveFeatureOrder()) {
        _RouteAction2.default.redirectToFeatureNonActivated();
        return;
      }

      if (!_SecurityContext2.default.cartModifiers.canRead()) {
        _RouteAction2.default.redirectForce(_RoutingEnum2.default.ORDERS_LIST);
      }

      _CartModifierStore2.default.addListener(this.onCartModifierStoreChange);

      _ApiConsumersStore2.default.addListener(this.onFetchApiConsumers);

      _RestaurantMenuStore2.default.addListeners([new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU, this.onFetchRestaurantMenu), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onFetchRestaurantMenu), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onFetchRestaurantMenu)]);

      _RestaurantMenuAction2.default.loadRestaurantMenu();

      if (!_lodash2.default.isUndefined(this.props.params.cartModifierId)) {
        _CartModifierAction2.default.loadCartModifier(_SessionStore2.default.getRestaurantId(), this.props.params.cartModifierId);
      }

      _RestaurantsGroupAction2.default.loadApiConsumers(_SessionStore2.default.getRestaurantsGroupId(), {
        withOther: false,
        withParents: false
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // TODO: fix, redirect to EditPage on CartModifierStore POST_CART_MODIFIER_SUCCESS
      // from new to edit
      var fromNewToEdit = _lodash2.default.isNil(this.props.params.cartModifierId) && !_lodash2.default.isNil(nextProps.params.cartModifierId);

      // the id on url changed
      var idChanged = !_lodash2.default.isNil(this.props.params.cartModifierId) && this.props.params.cartModifierId !== nextProps.params.cartModifierId;

      if (this.isEditMode() && (fromNewToEdit || idChanged)) {
        _CartModifierAction2.default.loadCartModifier(_SessionStore2.default.getRestaurantId(), this.props.params.cartModifierId);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _ApiConsumersStore2.default.removeListener(this.onFetchApiConsumers);

      _RestaurantMenuStore2.default.removeListeners([new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU, this.onFetchRestaurantMenu), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onFetchRestaurantMenu), new _Listener2.default(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR, this.onFetchRestaurantMenu)]);
    }
  }, {
    key: 'isEditMode',
    value: function isEditMode() {
      return this.props.route.name === _RoutingEnum2.default.ORDERS_CART_MODIFIERS_EDIT.name;
    }
  }, {
    key: '__onFetchApiConsumers__REACT_HOT_LOADER__',
    value: function __onFetchApiConsumers__REACT_HOT_LOADER__() {
      this.setState({
        apiConsumersState: _ApiConsumersStore2.default.getState()
      });
    }
  }, {
    key: '__onCartModifierStoreChange__REACT_HOT_LOADER__',
    value: function __onCartModifierStoreChange__REACT_HOT_LOADER__() {
      this.setState(this.getDefaultState());
    }
  }, {
    key: '__onFetchRestaurantMenu__REACT_HOT_LOADER__',
    value: function __onFetchRestaurantMenu__REACT_HOT_LOADER__() {
      var restaurantMenuState = _RestaurantMenuStore2.default.getState();

      this.setState({
        restaurantMenuState: restaurantMenuState
      });
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return !this.state.cartModifier.isFormValid();
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !_lodash2.default.isNull(this.state.cartModifier) && !this.state.cartModifier.equals(this.state.defaultModifier) && !(!_lodash2.default.isNull(this.state.cartModifier.target.items) && _lodash2.default.isEmpty(this.state.cartModifier.target.items.itemsList));
    }
  }, {
    key: '__handleChange__REACT_HOT_LOADER__',
    value: function __handleChange__REACT_HOT_LOADER__(cartModifier) {
      this.setState({
        cartModifier: new _CartModifier2.default().fromJson(cartModifier)
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var cartModifier = this.state.cartModifier;

      _lodash2.default.keys(cartModifier.condition.dateCondition.weeklyAvailabilities).map(function (day) {
        cartModifier.condition.dateCondition.weeklyAvailabilities[day].hours = cartModifier.condition.dateCondition.weeklyAvailabilities[day].hours.filter(function (hour) {
          return !_lodash2.default.isNull(hour.opening) || !_lodash2.default.isNull(hour.closing);
        });
      });

      var isValid = cartModifier.isFormValid();

      if (isValid) {
        if (this.isEditMode()) {
          _CartModifierAction2.default.putCartModifier(_SessionStore2.default.getRestaurantId(), cartModifier);
        } else {
          _CartModifierAction2.default.postCartModifier(_SessionStore2.default.getRestaurantId(), cartModifier);
        }
      } else {
        _Notify2.default.alert('Formulaire invalide');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var restaurantMenuState = this.state.restaurantMenuState;
      var cartModifierState = this.state.cartModifierState;
      var apiConsumersState = this.state.apiConsumersState;
      var currencyCode = this.state.restaurant.currency;

      if (_lodash2.default.isEqual(_RestaurantMenuStore2.default.getInitialState(), restaurantMenuState)) {
        return this.renderLoading();
      }

      var arianeIcon = 'fa-line-chart';
      var arianeDetails = [{
        name: _I18n2.default.tr('menu.order'),
        link: _RoutingEnum2.default.ORDERS_LIST
      }, {
        name: _I18n2.default.tr('menu.order.cart_modifiers'),
        link: _RoutingEnum2.default.ORDERS_CART_MODIFIERS_LIST
      }, {
        name: this.isEditMode() ? _I18n2.default.tr('menu.order.cart_modifiers.edit') : _I18n2.default.tr('menu.order.cart_modifiers.new'),
        link: null
      }];

      return _react2.default.createElement(
        'div',
        { className: 'order_cart_modifiers' },
        _react2.default.createElement(_Ariane2.default, { icon: arianeIcon, details: arianeDetails }),
        restaurantMenuState.isFetching || this.isEditMode() && cartModifierState.isFetching || apiConsumersState.isFetching ? this.renderOnLoadingContent() : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_View2.default, {
            restaurantMenu: restaurantMenuState.restaurantMenu,
            cartModifier: this.state.cartModifier,
            apiConsumers: this.state.apiConsumersState.data.apiConsumers,
            onChange: this.handleChange,
            currencyCode: currencyCode
          }),
          this.renderFixedButtons()
        )
      );
    }
  }]);

  return PromotionsEdit;
}(_AbstractFormComponent2.default);

exports.default = PromotionsEdit;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PromotionsEdit, 'PromotionsEdit', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/edit/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/edit/style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/fixture.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EditPromotion = exports.EditPromotion = {
  "id": 41301988,
  "restaurantId": "16000106",
  "creationDate": 1498038929018,
  "name": "3 Pizzas achetées = 1 offerte",
  "description": "Lors de l'achat de 3 pizzas à emporter, la moins chère des 3 est offerte",
  "code": null,
  "combinable": false,
  "priority": 0,
  "enabled": true,
  "archived": false,
  "condition": {
    "orderModes": [1, 2],
    "frontCondition": {
      "apiConsumerIds": null,
      "platforms": null
    },
    "dateCondition": {
      "beginningDate": 1498038929018,
      "endDate": 1598038929018,
      "weeklyAvailabilities": null
    },
    "amountCondition": {
      "minOrderAmount": 0,
      "includeShippingCostInMinOrderAmount": false,
      "maxOrderAmount": 0,
      "includeShippingCostInMaxOrderAmount": false,
      "maxOrderAmountToApplyOn": 0,
      "includeShippingCostInMaxOrderAmountToApplyOn": false
    },
    "userCondition": {
      "ids": null,
      "emailAddresses": null,
      "restaurantsGroupId": null
    },
    "numberOfUseCondition": {
      "maxNumberOfUses": 0,
      "maxNumberOfUsesPerUser": 0
    },
    "itemCondition": {
      "itemsRequired": [{
        "itemsNumber": 3,
        "itemsList": [{
          "type": 0,
          "id": "1475508813_1239d"
        }, {
          "type": 2,
          "id": "58CE1331-783F-4BFC-BD13-800FF2112FD8"
        }, {
          "type": 2,
          "id": "4DCC684A-2181-4772-8CDE-D627821EF499"
        }]
      }],
      "itemsForbidden": null
    }
  },
  "target": {
    "type": "SHIPPING_COST",
    "items": null
  },
  "action": {
    "type": "DISCOUNT_PERCENTAGE",
    "value": 100
  }
};

var NewPromotion = exports.NewPromotion = {
  "id": null,
  "restaurantId": null,
  "creationDate": null,
  "name": "",
  "description": "",
  "code": null,
  "combinable": false,
  "priority": 0,
  "enabled": true,
  "archived": false,
  "condition": {
    "orderModes": [],
    "frontCondition": {
      "apiConsumerIds": null,
      "platforms": null
    },
    "dateCondition": {
      "beginningDate": null,
      "endDate": null,
      "weeklyAvailabilities": null
    },
    "amountCondition": {
      "minOrderAmount": 0,
      "includeShippingCostInMinOrderAmount": false,
      "maxOrderAmount": 0,
      "includeShippingCostInMaxOrderAmount": false,
      "maxOrderAmountToApplyOn": 0,
      "includeShippingCostInMaxOrderAmountToApplyOn": false
    },
    "userCondition": {
      "ids": null,
      "emailAddresses": null,
      "restaurantsGroupId": null
    },
    "numberOfUseCondition": {
      "maxNumberOfUses": 0,
      "maxNumberOfUsesPerUser": 0
    },
    "itemCondition": {
      "itemsRequired": null,
      "itemsForbidden": null
    }
  },
  "target": {
    "type": null,
    "items": null
  },
  "action": {
    "type": null,
    "value": null
  }
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EditPromotion, "EditPromotion", "C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/fixture.js");

  __REACT_HOT_LOADER__.register(NewPromotion, "NewPromotion", "C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/fixture.js");
}();

;

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _SortableList = __webpack_require__("./sdk/scripts/components/SortableList.js");

var _SortableList2 = _interopRequireDefault(_SortableList);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _CartModifierAction = __webpack_require__("./scripts/actions/CartModifierAction.js");

var _CartModifierAction2 = _interopRequireDefault(_CartModifierAction);

var _CartModifierListStore = __webpack_require__("./scripts/stores/CartModifierListStore.js");

var _CartModifierListStore2 = _interopRequireDefault(_CartModifierListStore);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _RoundButton = __webpack_require__("./scripts/components/RoundButton.js");

var _RoundButton2 = _interopRequireDefault(_RoundButton);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

__webpack_require__("./scripts/pages/order/cartModifiers/list/style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromotionsList = function (_AbstractComponent) {
  _inherits(PromotionsList, _AbstractComponent);

  function PromotionsList() {
    _classCallCheck(this, PromotionsList);

    var _this = _possibleConstructorReturn(this, (PromotionsList.__proto__ || Object.getPrototypeOf(PromotionsList)).call(this));

    _this.state = {
      cartModifiersState: _CartModifierListStore2.default.getState()
    };

    _this.onCartModifierListStoreChanged = function () {
      return _this.__onCartModifierListStoreChanged__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onCartModifierChange = function () {
      return _this.__onCartModifierChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onEdit = function () {
      return _this.__onEdit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onToggleActivation = function () {
      return _this.__onToggleActivation__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onDeleteCartModifier = function () {
      return _this.__onDeleteCartModifier__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onListOrderChange = function () {
      return _this.__onListOrderChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.renderRow = function () {
      return _this.__renderRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-line-chart';
    _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.order'),
      link: _RoutingEnum2.default.ORDERS_LIST
    }, {
      name: _I18n2.default.tr('menu.order.cart_modifiers'),
      link: null
    }];
    return _this;
  }

  _createClass(PromotionsList, [{
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__() {
      return this.__renderRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onListOrderChange__REACT_HOT_LOADER__',
    value: function __onListOrderChange__REACT_HOT_LOADER__() {
      return this.__onListOrderChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeleteCartModifier__REACT_HOT_LOADER__',
    value: function __onDeleteCartModifier__REACT_HOT_LOADER__() {
      return this.__onDeleteCartModifier__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleActivation__REACT_HOT_LOADER__',
    value: function __onToggleActivation__REACT_HOT_LOADER__() {
      return this.__onToggleActivation__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEdit__REACT_HOT_LOADER__',
    value: function __onEdit__REACT_HOT_LOADER__() {
      return this.__onEdit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCartModifierChange__REACT_HOT_LOADER__',
    value: function __onCartModifierChange__REACT_HOT_LOADER__() {
      return this.__onCartModifierChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onCartModifierListStoreChanged__REACT_HOT_LOADER__',
    value: function __onCartModifierListStoreChanged__REACT_HOT_LOADER__() {
      return this.__onCartModifierListStoreChanged__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_RestaurantStore2.default.getRestaurant().haveFeatureOrder()) {
        _RouteAction2.default.redirectToFeatureNonActivated();
        return;
      }

      if (!_SecurityContext2.default.cartModifiers.canRead()) {
        _RouteAction2.default.redirectForce(_RoutingEnum2.default.ORDERS_LIST);
      }

      _CartModifierListStore2.default.addListener(this.onCartModifierListStoreChanged);

      _CartModifierAction2.default.loadCartModifiers(_SessionStore2.default.getRestaurantId());
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _CartModifierListStore2.default.removeListener(this.onCartModifierListStoreChanged);
    }
  }, {
    key: 'getNotArchivedCartModifiers',
    value: function getNotArchivedCartModifiers() {
      var notArchived = this.state.cartModifiersState.data.filter(function (cartModifier) {
        return cartModifier.archived !== true;
      });

      var sortedByPriority = notArchived.sort(function (a, b) {
        return a.priority - b.priority;
      });

      return sortedByPriority;
    }
  }, {
    key: '__onCartModifierListStoreChanged__REACT_HOT_LOADER__',
    value: function __onCartModifierListStoreChanged__REACT_HOT_LOADER__() {
      this.setState({
        cartModifiersState: _CartModifierListStore2.default.getState()
      });
    }
  }, {
    key: '__onCartModifierChange__REACT_HOT_LOADER__',
    value: function __onCartModifierChange__REACT_HOT_LOADER__(cartModifier) {
      _CartModifierAction2.default.putCartModifier(_RestaurantStore2.default.getRestaurantId(), cartModifier.copy());
    }
  }, {
    key: '__onEdit__REACT_HOT_LOADER__',
    value: function __onEdit__REACT_HOT_LOADER__(cartModifierId) {
      if (_SecurityContext2.default.cartModifiers.canEdit()) {
        _RouteAction2.default.redirectTo(_RoutingEnum2.default.ORDERS_CART_MODIFIERS_EDIT, {
          cartModifierId: cartModifierId
        });
      }
    }
  }, {
    key: '__onToggleActivation__REACT_HOT_LOADER__',
    value: function __onToggleActivation__REACT_HOT_LOADER__(cartModifier) {
      if (_SecurityContext2.default.cartModifiers.canEdit()) {
        cartModifier.enabled = !cartModifier.enabled;
        this.onCartModifierChange(cartModifier);
      }
    }
  }, {
    key: '__onDeleteCartModifier__REACT_HOT_LOADER__',
    value: function __onDeleteCartModifier__REACT_HOT_LOADER__(cartModifier) {
      var _this2 = this;

      _Notify2.default.confirmDeleteWithTitle(_I18n2.default.tr('order.cart_modifiers.archive.confirm.title'), _I18n2.default.tr('order.cart_modifiers.archive.confirm.message'), function (result) {
        if (result) {
          cartModifier.archived = !cartModifier.archived;
          _this2.onCartModifierChange(cartModifier);
        }
      });
    }
  }, {
    key: '__onListOrderChange__REACT_HOT_LOADER__',
    value: function __onListOrderChange__REACT_HOT_LOADER__(newOrderedList) {
      console.log('onListOrderChange', newOrderedList);
      var ids = newOrderedList.map(function (item) {
        return item.id;
      });
      _CartModifierAction2.default.putCartModifiersPriorities(_RestaurantStore2.default.getRestaurantId(), ids);
    }
  }, {
    key: '__renderRow__REACT_HOT_LOADER__',
    value: function __renderRow__REACT_HOT_LOADER__(cartModifier) {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'pointer row' },
        _react2.default.createElement(
          'div',
          { className: 'col-sm-3', onClick: function onClick() {
              return _this3.onEdit(cartModifier.id);
            } },
          cartModifier.name
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-5', onClick: function onClick() {
              return _this3.onEdit(cartModifier.id);
            } },
          cartModifier.description
        ),
        _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(
          'div',
          { className: 'col-xs-2 text-center' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            key: _Utils2.default.generateUID(),
            bsSize: 'mini',
            onChange: function onChange() {
              return _this3.onToggleActivation(cartModifier);
            },
            value: cartModifier.enabled
          })
        ),
        _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(
          'div',
          {
            className: 'pointer text-center col-xs-1',
            onClick: function onClick() {
              return _this3.onDeleteCartModifier(cartModifier);
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-trash' })
        ),
        _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(
          'div',
          { className: 'pointer text-center col-xs-1' },
          _react2.default.createElement(_SortableList2.default.DragHandle, null)
        )
      );
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      return _react2.default.createElement(
        'div',
        { className: 'table_container table_container_hover top-buffer-50 col-xs-12' },
        _react2.default.createElement(
          'div',
          { className: 'thead col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-3' },
              _I18n2.default.tr('order.cart_modifiers.list.name')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-5' },
              _I18n2.default.tr('order.cart_modifiers.list.description')
            ),
            _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(
              'div',
              { className: 'col-xs-2 text-center' },
              _I18n2.default.tr('order.cart_modifiers.list.activate')
            ),
            _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(
              'div',
              { className: 'col-xs-1 text-center' },
              _I18n2.default.tr('order.cart_modifiers.list.delete')
            ),
            _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(
              'div',
              { className: 'col-xs-1 text-center' },
              _I18n2.default.tr('order.cart_modifiers.list.priority')
            )
          )
        ),
        _react2.default.createElement(_SortableList2.default, {
          items: this.getNotArchivedCartModifiers(),
          onChange: this.onListOrderChange,
          renderer: this.renderRow,
          displayDragIcon: false
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var cartModifiersState = this.state.cartModifiersState;

      if (_lodash2.default.isEqual(_CartModifierListStore2.default.getInitialState(), cartModifiersState)) {
        return this.renderLoading();
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_cart_modifiers' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        _SecurityContext2.default.cartModifiers.canEdit() && _react2.default.createElement(_RoundButton2.default, {
          text: _I18n2.default.tr('order.cart_modifiers.add'),
          onClick: function onClick() {
            _RouteAction2.default.redirectTo(_RoutingEnum2.default.ORDERS_CART_MODIFIERS_NEW);
          }
        }),
        cartModifiersState.isFetching ? this.renderOnLoadingContent() : !_lodash2.default.isEmpty(cartModifiersState.data) ? this.renderList() : _react2.default.createElement(
          'div',
          { className: 'no_data' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-xs-offset-3 text-center' },
            _react2.default.createElement('i', { className: 'icon-smiley-down' }),
            _react2.default.createElement(
              'p',
              { className: 'top-buffer-30' },
              _I18n2.default.tr('order.cart_modifiers.no_data')
            )
          )
        )
      );
    }
  }]);

  return PromotionsList;
}(_AbstractComponent3.default);

exports.default = PromotionsList;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PromotionsList, 'PromotionsList', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/cartModifiers/list/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/cartModifiers/list/style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./scripts/pages/order/ordersList/OrdersListPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _OrdersOnGoingListView = __webpack_require__("./scripts/pages/order/ordersList/ordersOnGoing/OrdersOnGoingListView.js");

var _OrdersOnGoingListView2 = _interopRequireDefault(_OrdersOnGoingListView);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _OrdersHistoryPage = __webpack_require__("./scripts/pages/order/ordersList/ordersHistory/OrdersHistoryPage.js");

var _OrdersHistoryPage2 = _interopRequireDefault(_OrdersHistoryPage);

var _notifyOrdersToMakeModal = __webpack_require__("./scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/index.js");

var _notifyOrdersToMakeModal2 = _interopRequireDefault(_notifyOrdersToMakeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var _timer = null;

var OrdersListPage = function (_AbstractComponent) {
  _inherits(OrdersListPage, _AbstractComponent);

  function OrdersListPage() {
    _classCallCheck(this, OrdersListPage);

    var _this = _possibleConstructorReturn(this, (OrdersListPage.__proto__ || Object.getPrototypeOf(OrdersListPage)).call(this));

    _this.state = {
      restaurant: null,

      ordersList: null,

      orderSettings: null,

      ordersToNotify: [],

      // we reduce from one hour just in case.
      lastUpdateTime: _utils.DateUtils.getTodayTimestampAsMilliseconds() - _utils.DateUtils.HOUR_AS_MILLISECONDS
    };

    _this.loadRestaurant = function () {
      return _this.__loadRestaurant__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onRestaurantLoad = function () {
      return _this.__onRestaurantLoad__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onRestaurantUpdate = function () {
      return _this.__onRestaurantUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onLoadOrderSettings = function () {
      return _this.__onLoadOrderSettings__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdateOrderSuccess = function () {
      return _this.__onUpdateOrderSuccess__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onOrdersListChange = function () {
      return _this.__onOrdersListChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleUpdateRestaurantStatus = function () {
      return _this.__handleUpdateRestaurantStatus__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onError = function () {
      return _this.__onError__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onTimerDone = function () {
      return _this.__onTimerDone__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onTabChange = function () {
      return _this.__onTabChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-line-chart';
    _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.order'),
      link: null
    }];
    return _this;
  }

  _createClass(OrdersListPage, [{
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__() {
      return this.__onTabChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTimerDone__REACT_HOT_LOADER__',
    value: function __onTimerDone__REACT_HOT_LOADER__() {
      return this.__onTimerDone__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleUpdateRestaurantStatus__REACT_HOT_LOADER__',
    value: function __handleUpdateRestaurantStatus__REACT_HOT_LOADER__() {
      return this.__handleUpdateRestaurantStatus__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrdersListChange__REACT_HOT_LOADER__',
    value: function __onOrdersListChange__REACT_HOT_LOADER__() {
      return this.__onOrdersListChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateOrderSuccess__REACT_HOT_LOADER__',
    value: function __onUpdateOrderSuccess__REACT_HOT_LOADER__() {
      return this.__onUpdateOrderSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLoadOrderSettings__REACT_HOT_LOADER__',
    value: function __onLoadOrderSettings__REACT_HOT_LOADER__() {
      return this.__onLoadOrderSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantUpdate__REACT_HOT_LOADER__',
    value: function __onRestaurantUpdate__REACT_HOT_LOADER__() {
      return this.__onRestaurantUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantLoad__REACT_HOT_LOADER__',
    value: function __onRestaurantLoad__REACT_HOT_LOADER__() {
      return this.__onRestaurantLoad__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__loadRestaurant__REACT_HOT_LOADER__',
    value: function __loadRestaurant__REACT_HOT_LOADER__() {
      return this.__loadRestaurant__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_stores.RestaurantStore.getRestaurant().haveFeatureOrder()) {
        _actions.RouteAction.redirectToFeatureNonActivated();
        return;
      }

      _stores.RestaurantStore.addListeners(this.restaurantStoreListeners);
      this.loadRestaurant();

      _stores.OrdersListStore.addListeners(this.ordersListListeners);

      _stores.OrderSettingsStore.addListener(_Events2.default.ON_LOAD_ORDER_SETTINGS_SUCCESS, this.onLoadOrderSettings);
      _stores.OrderSettingsStore.addListener(_Events2.default.ON_UPDATE_ORDER_SETTINGS_SUCCESS, this.onLoadOrderSettings);

      _actions.OrderAction.loadOrderSettings();

      this.loadOrdersListOnGoing();
      // NotificationUtils.autoEnableOnMobile();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantStore.removeListeners(this.restaurantStoreListeners);

      _stores.OrdersListStore.removeListeners(this.ordersListListeners);

      clearTimeout(_timer);
    }
  }, {
    key: '__loadRestaurant__REACT_HOT_LOADER__',


    /**
     * Load the orders created during the given timelapse.
     */
    value: function __loadRestaurant__REACT_HOT_LOADER__() {
      this.showLoading();
      _actions.RestaurantAction.retrieveCurrentRestaurant();
    }
  }, {
    key: 'loadOrdersListOnGoing',
    value: function loadOrdersListOnGoing() {
      var displayLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (displayLoading) {
        this.showLoading();
      }
      _actions.OrderAction.loadOnGoingOrdersList();
    }

    /**
     * Load the orders created during the given timelapse.
     */

  }, {
    key: 'loadOrdersListByModificationDate',
    value: function loadOrdersListByModificationDate(fromTime, toTime) {
      var displayLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (displayLoading) {
        this.showLoading();
      }
      _actions.OrderAction.loadOrdersListByModificationDate(fromTime, toTime);
    }
  }, {
    key: '__onRestaurantLoad__REACT_HOT_LOADER__',
    value: function __onRestaurantLoad__REACT_HOT_LOADER__() {
      var restaurant = _stores.RestaurantStore.getRestaurant().copy();

      this.setState({
        restaurant: restaurant,
        loading: _lodash2.default.isNull(this.state.ordersList) || _lodash2.default.isNull(this.state.orderSettings)
      });
    }
  }, {
    key: '__onRestaurantUpdate__REACT_HOT_LOADER__',


    /**
     *
     * @param  boolean calculLastUpdateTime Define if we have to calcul the latest update time.
     *                                      Must be true ONLY if the function is called right after
     *                                      a call to the API to retrieve the new orders
     *                                      (OrderAction.loadOrdersListByModificationDate)
     */
    value: function __onRestaurantUpdate__REACT_HOT_LOADER__() {
      var restaurant = _stores.RestaurantStore.getRestaurant().copy();

      this.setState({
        restaurant: restaurant,
        loading: _lodash2.default.isNull(this.state.ordersList) || _lodash2.default.isNull(this.state.orderSettings)
      });
    }
  }, {
    key: 'updateListOnState',
    value: function updateListOnState() {
      var _this2 = this;

      var calculLastUpdateTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var ordersList = _stores.OrdersListStore.getOrdersList();

      //
      //
      //

      // lastUpdateTime is the timestamp of the latest updated order (default: now minus 5 minutes).
      // we subtract 5 minutes just in case.
      var lastUpdateTime = void 0;
      if (calculLastUpdateTime) {
        lastUpdateTime = (0, _moment2.default)().subtract(5, 'minutes').valueOf();
        var lastUpdatedOrder = ordersList.getLastUpdateOrder();
        if (!_lodash2.default.isNull(lastUpdatedOrder)) {
          // add 1 milliseconds to not retrieve again this order.
          lastUpdateTime = lastUpdatedOrder.modificationDate.valueOf() + 1;
        }
      } else {
        // we don't re-calculate the last update time.
        // When we receive an updated order for example, we don't want to because we couldn't have
        // the new orders made between the lastUpdateTime and the order's put time (who would
        // become the new lastUpdateTime).
        lastUpdateTime = this.state.lastUpdateTime;
      }

      // lastUpdateTime can't be more than 31 days, otherwise api returns and error
      var updateLimit = (0, _moment2.default)().valueOf() - _utils.DateUtils.DAY_AS_MILLISECONDS * 30;
      if (lastUpdateTime < updateLimit) {
        lastUpdateTime = updateLimit;
      }

      //
      // find orders to notify
      //

      // -- get all orders that could be notify
      var ordersToNotify = [];
      if (!_lodash2.default.isNil(this.state.orderSettings)) {
        var manufactureDelay = this.state.orderSettings.manufactureDelay;

        // get on going
        ordersToNotify = ordersList.getOnGoingOrders();

        // filter not later
        ordersToNotify = _lodash2.default.filter(ordersToNotify, function (order) {
          return order.isSent();
        });

        // remove already displayed
        ordersToNotify = _lodash2.default.filter(ordersToNotify, function (order) {
          var delay = _this2.state.orderSettings.getOrderDelay(order.mode);
          return order.getPriority(delay) !== _order.Order.Priority.LATER;
        });
      }

      //
      // update state
      //
      this.setState({
        ordersList: ordersList,
        loading: _lodash2.default.isNull(this.state.restaurant) || _lodash2.default.isNull(this.state.orderSettings),
        lastUpdateTime: lastUpdateTime,
        ordersToNotify: ordersToNotify
      }, function () {
        _this2.updateBadge();
      });

      this.resetTimer();
    }
  }, {
    key: 'updateBadge',
    value: function updateBadge() {
      // Set badge on tab
      // -- set badge for waiting bookings
      var nb = this.state.ordersList.getOnGoingOrders().length;
      var element = $('#orders_list_page__tabs-tab-on-going');

      if (nb > 0) {
        element.html(_I18n2.default.tr('order.list.tabs.on_going').toUpperCase() + ' <span class="badge badge-error">' + nb + '<span>');
      } else {
        element.html(_I18n2.default.tr('order.list.tabs.on_going').toUpperCase());
      }
    }

    //
    // Api events - order settings
    //

  }, {
    key: '__onLoadOrderSettings__REACT_HOT_LOADER__',


    //
    // Api events - order
    //

    value: function __onLoadOrderSettings__REACT_HOT_LOADER__() {
      this.setState({
        orderSettings: _stores.OrderSettingsStore.getOrderSettings(),
        loading: _lodash2.default.isNull(this.state.ordersList) || _lodash2.default.isNull(this.state.restaurant)
      });
    }
  }, {
    key: '__onUpdateOrderSuccess__REACT_HOT_LOADER__',
    value: function __onUpdateOrderSuccess__REACT_HOT_LOADER__() {
      this.updateListOnState(false);
    }
  }, {
    key: '__onOrdersListChange__REACT_HOT_LOADER__',
    value: function __onOrdersListChange__REACT_HOT_LOADER__() {
      this.updateListOnState(true);
    }
  }, {
    key: '__handleUpdateRestaurantStatus__REACT_HOT_LOADER__',
    value: function __handleUpdateRestaurantStatus__REACT_HOT_LOADER__(status) {
      var restaurantMultipart = new _RestaurantMultipart2.default();
      restaurantMultipart.id = this.state.restaurant.id;
      restaurantMultipart.status = status;

      this.showLoading(function () {
        _actions.RestaurantAction.updateRestaurant(restaurantMultipart);
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.resetTimer();
      this.setState({
        loading: false,
        error: _stores.OrdersListStore.getApiError()
      });
    }
  }, {
    key: 'resetTimer',
    value: function resetTimer() {
      clearTimeout(_timer);
      _timer = setTimeout(this.onTimerDone, _constants.Constants.Order.DELAY_CHECK_NEW_ORDERS);
    }

    //
    // Timer
    //

  }, {
    key: '__onTimerDone__REACT_HOT_LOADER__',


    //
    // Tabs
    //

    value: function __onTimerDone__REACT_HOT_LOADER__() {
      var fromTime = this.state.lastUpdateTime;
      var toTime = (0, _moment2.default)().valueOf();
      this.loadOrdersListByModificationDate(fromTime, toTime, false);
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onTabChange__REACT_HOT_LOADER__(activeKey) {
      if (!_lodash2.default.isUndefined(activeKey)) {
        /*
         * Update the query params.
         */
        this.onChangeQueryUrl({
          tab: activeKey
        });
      }
    }
  }, {
    key: 'renderWarnings',
    value: function renderWarnings() {
      return _react2.default.createElement(
        'div',
        null,
        this.state.restaurant && this.state.restaurant.status === 'ARCHIVED' && _react2.default.createElement(
          'p',
          { className: 'bg-warning', style: { padding: 16, marginTop: 16 } },
          _I18n2.default.tr('restaurant_edit.configuration.statut.ARCHIVED.tip')
        )
      );
    }
  }, {
    key: 'renderNotifyOrdersToMakeModal',
    value: function renderNotifyOrdersToMakeModal() {
      var ordersToNotify = this.state.ordersToNotify;
      if (_lodash2.default.isNil(ordersToNotify) || _lodash2.default.isEmpty(ordersToNotify)) {
        return null;
      }

      return _react2.default.createElement(_notifyOrdersToMakeModal2.default, {
        show: true,
        orders: ordersToNotify,
        orderSettings: this.state.orderSettings,
        currencyCode: this.state.restaurant.currency
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var isLoading = _lodash2.default.isNull(this.state.restaurant) || _lodash2.default.isNull(this.state.ordersList) || _lodash2.default.isNull(this.state.orderSettings);

      return _react2.default.createElement(
        _reactBootstrap.Tabs,
        {
          defaultActiveKey: this.defaultTabKey,
          id: 'orders_list_page__tabs',
          onSelect: this.onTabChange
        },
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: OrdersListPage.Tab.ON_GOING,
            title: _I18n2.default.tr('order.list.tabs.on_going').toUpperCase()
          },
          this.renderWarnings(),
          !this.state.apiError && this.renderApiErrorBlock(),
          !isLoading && !this.state.apiError && _react2.default.createElement(_OrdersOnGoingListView2.default, {
            restaurant: this.state.restaurant,
            location: this.props.location,
            ordersList: this.state.ordersList,
            orderSettings: this.state.orderSettings,
            onUpdateRestaurantStatus: this.handleUpdateRestaurantStatus
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Tab,
          {
            eventKey: OrdersListPage.Tab.HISTORY,
            title: _I18n2.default.tr('order.list.tabs.history').toUpperCase()
          },
          this.renderWarnings(),
          this.defaultTabKey === OrdersListPage.Tab.HISTORY && !isLoading && _react2.default.createElement(
            'div',
            { className: 'top-buffer-30' },
            _react2.default.createElement(_OrdersHistoryPage2.default, {
              location: this.props.location
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'orders_list_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        this.renderBody(),
        this.renderLoading(),
        this.renderNotifyOrdersToMakeModal()
      );
    }
  }, {
    key: 'ordersListListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_RETRIEVE_ORDERS_LIST_SUCCESS, this.onOrdersListChange), new _Listener2.default(_Events2.default.ON_RETRIEVE_ORDERS_LIST_FAILURE, this.onError), new _Listener2.default(_Events2.default.UPDATE_ORDER_SUCCESS, this.onUpdateOrderSuccess), new _Listener2.default(_Events2.default.UPDATE_ORDER_FAILURE, this.onError)];
    }
  }, {
    key: 'restaurantStoreListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.LOAD_RESTAURANT_SUCCESS, this.onRestaurantLoad), new _Listener2.default(_Events2.default.UPDATE_RESTAURANT_SUCCESS, this.onRestaurantUpdate), new _Listener2.default(_Events2.default.LOAD_RESTAURANT_FAILURE, this.onError)];
    }
  }, {
    key: 'defaultTabKey',
    get: function get() {
      if (!_lodash2.default.isUndefined(this.props.location.query.tab)) {
        return this.props.location.query.tab;
      }

      return OrdersListPage.Tab.ON_GOING;
    }
  }]);

  return OrdersListPage;
}(_AbstractComponent3.default);

OrdersListPage.Tab = {
  ON_GOING: 'on-going',
  HISTORY: 'history'
};
exports.default = OrdersListPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_timer, '_timer', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/OrdersListPage.js');

  __REACT_HOT_LOADER__.register(OrdersListPage, 'OrdersListPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/OrdersListPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/OrdersToMakeList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _OrderSettings = __webpack_require__("./sdk/scripts/entities/order/OrderSettings.js");

var _OrderSettings2 = _interopRequireDefault(_OrderSettings);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


/**
*
*/
var OrdersToMakeList = function (_Component) {
  _inherits(OrdersToMakeList, _Component);

  function OrdersToMakeList() {
    _classCallCheck(this, OrdersToMakeList);

    return _possibleConstructorReturn(this, (OrdersToMakeList.__proto__ || Object.getPrototypeOf(OrdersToMakeList)).apply(this, arguments));
  }

  _createClass(OrdersToMakeList, [{
    key: 'renderRow',


    //
    // renderers
    //
    value: function renderRow(order) {

      return _react2.default.createElement(
        'tr',
        { className: 'PRIORITY_' + order.getPriority(this.props.orderSettings.manufactureDelay) },
        _react2.default.createElement(
          'td',
          {
            className: 'text-left pickup_date_countdown',
            ref: 'countdown'
          },
          order.getRemainingTimeLabel()
        ),
        _react2.default.createElement(
          'td',
          null,
          !order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
            icon: _utils.OrderViewUtils.getIconForMode(order.mode),
            style: styles.icon
          }),
          order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_AT_BAR,
            style: styles.icon
          })
        ),
        _react2.default.createElement(
          'td',
          null,
          !_lodash2.default.isNull(order.user) && !_lodash2.default.isNull(order.user.firstName) && !_lodash2.default.isNull(order.user.lastName) && order.user.firstName + ' ' + order.user.lastName
        ),
        _react2.default.createElement(
          'td',
          null,
          !_lodash2.default.isNull(order.check) && _react2.default.createElement(
            'span',
            null,
            _utils.CurrencyUtils.formatPriceWithCurrency(order.check.total, this.props.currencyCode)
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sortedOnGoingOrders = _lodash2.default.sortBy(this.props.orders, ['desc'], function (order) {
        return order.dueDate.valueOf();
      });

      var rows = sortedOnGoingOrders.map(function (order) {
        return _this2.renderRow(order);
      });

      return _react2.default.createElement(
        'div',
        { className: 'table_container table-responsive' },
        _react2.default.createElement(
          'table',
          { className: 'orders_ready table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { className: 'text-left' },
                _react2.default.createElement('i', { className: 'fa fa-clock-o' })
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('order.to_make.type')
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('order.to_make.name')
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('order.to_make.total')
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            rows
          )
        )
      );
    }
  }]);

  return OrdersToMakeList;
}(_react.Component);

OrdersToMakeList.propTypes = {
  orders: _propTypes2.default.arrayOf(_Order2.default).isRequired,

  orderSettings: _propTypes2.default.objectOf(_OrderSettings2.default).isRequired,
  currencyCode: _propTypes2.default.string

};
exports.default = OrdersToMakeList;


var styles = {
  icon: {
    height: '25px',
    width: 'auto'
  }
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrdersToMakeList, 'OrdersToMakeList', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/OrdersToMakeList.js');

  __REACT_HOT_LOADER__.register(styles, 'styles', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/OrdersToMakeList.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _NotificationUtils = __webpack_require__("./scripts/utils/NotificationUtils.js");

var _NotificationUtils2 = _interopRequireDefault(_NotificationUtils);

var _MobileAppInteractor = __webpack_require__("./scripts/utils/MobileAppInteractor.js");

var _MobileAppInteractor2 = _interopRequireDefault(_MobileAppInteractor);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _OrderAction = __webpack_require__("./scripts/actions/OrderAction.js");

var _OrderAction2 = _interopRequireDefault(_OrderAction);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _OrderSettings = __webpack_require__("./sdk/scripts/entities/order/OrderSettings.js");

var _OrderSettings2 = _interopRequireDefault(_OrderSettings);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _OnLoadingContentViewForModal = __webpack_require__("./sdk/scripts/components/OnLoadingContentViewForModal.js");

var _OnLoadingContentViewForModal2 = _interopRequireDefault(_OnLoadingContentViewForModal);

var _OrdersToMakeList = __webpack_require__("./scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/OrdersToMakeList.js");

var _OrdersToMakeList2 = _interopRequireDefault(_OrdersToMakeList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


/**
*
*/
var NotifyOrdersToMakeModal = function (_Component) {
  _inherits(NotifyOrdersToMakeModal, _Component);

  function NotifyOrdersToMakeModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotifyOrdersToMakeModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotifyOrdersToMakeModal.__proto__ || Object.getPrototypeOf(NotifyOrdersToMakeModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoading: false
    }, _this.onValidate = function () {
      var _this2;

      return (_this2 = _this).__onValidate__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotifyOrdersToMakeModal, [{
    key: '__onValidate__REACT_HOT_LOADER__',
    value: function __onValidate__REACT_HOT_LOADER__() {
      return this.__onValidate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _NotificationUtils2.default.notifyNewOrder();
    }

    //
    //
    //

  }, {
    key: '__onValidate__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onValidate__REACT_HOT_LOADER__() {
      this.setState({
        isLoading: true
      });

      _NotificationUtils2.default.stopNotifyNewOrder();

      if (_MobileAppInteractor2.default.printerIsAvailable()) {
        var restaurant = _RestaurantStore2.default.getRestaurant();
        _lodash2.default.each(this.props.orders, function (order) {
          _MobileAppInteractor2.default.printOrder(order, restaurant);
        });
      }

      _lodash2.default.each(this.props.orders, function (order) {
        order.status = _Order2.default.OrderStatus.RECEIVED;
        _OrderAction2.default.updateOrder(order);
      });
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      return _react2.default.createElement(_OrdersToMakeList2.default, {
        orders: this.props.orders,
        orderSettings: this.props.orderSettings,
        currencyCode: this.props.currencyCode
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (this.state.isLoading) {
        return _react2.default.createElement(_OnLoadingContentViewForModal2.default, null);
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderList(),
        _react2.default.createElement(
          'div',
          { className: 'text-center' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary btn-lg',
              onClick: this.onValidate
            },
            'Accepter'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: function onHide() {/* do nothing */}
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            this.props.orders.length === 1 && _react2.default.createElement(
              'span',
              null,
              'Nouvelle commande'
            ),
            this.props.orders.length > 1 && _react2.default.createElement(
              'span',
              null,
              'Nouvelles commandes'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return NotifyOrdersToMakeModal;
}(_react.Component);

NotifyOrdersToMakeModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  orders: _propTypes2.default.arrayOf(_Order2.default).isRequired,

  orderSettings: _propTypes2.default.objectOf(_OrderSettings2.default).isRequired,
  currencyCode: _propTypes2.default.string

};
exports.default = NotifyOrdersToMakeModal;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NotifyOrdersToMakeModal, 'NotifyOrdersToMakeModal', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ModalType = exports.ModalType = {
  CANCEL: 'CANCEL',
  DETAIL: 'DETAIL'
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ModalType, 'ModalType', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/constants.js');
}();

;

/***/ }),

/***/ "./scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _OrderSettingsStore = __webpack_require__("./scripts/stores/OrderSettingsStore.js");

var _OrderSettingsStore2 = _interopRequireDefault(_OrderSettingsStore);

var _OrderAction = __webpack_require__("./scripts/actions/OrderAction.js");

var _OrderAction2 = _interopRequireDefault(_OrderAction);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_MANUFACTURE_DELAY_VALUE = -1;

var timer = null;

var OrderManufactureDelaySettingsView = function (_Component) {
  _inherits(OrderManufactureDelaySettingsView, _Component);

  function OrderManufactureDelaySettingsView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderManufactureDelaySettingsView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderManufactureDelaySettingsView.__proto__ || Object.getPrototypeOf(OrderManufactureDelaySettingsView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoadingManufactureDelay: false,

      newManufactureDelay: _this.props.orderSettings.manufactureDelay
    }, _this.sendNewManufactureDelay = function () {
      var _this2;

      return (_this2 = _this).__sendNewManufactureDelay__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMinus = function () {
      var _this3;

      return (_this3 = _this).__onMinus__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onPlus = function () {
      var _this4;

      return (_this4 = _this).__onPlus__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderManufactureDelaySettingsView, [{
    key: '__onPlus__REACT_HOT_LOADER__',
    value: function __onPlus__REACT_HOT_LOADER__() {
      return this.__onPlus__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMinus__REACT_HOT_LOADER__',
    value: function __onMinus__REACT_HOT_LOADER__() {
      return this.__onMinus__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__sendNewManufactureDelay__REACT_HOT_LOADER__',
    value: function __sendNewManufactureDelay__REACT_HOT_LOADER__() {
      return this.__sendNewManufactureDelay__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newManufactureDelay = this.state.newManufactureDelay;

      if (this.props.orderSettings.manufactureDelay !== nextProps.orderSettings.manufactureDelay) {
        newManufactureDelay = nextProps.orderSettings.manufactureDelay;
      }

      this.setState({
        isLoadingManufactureDelay: false,

        newManufactureDelay: newManufactureDelay
      });
    }

    //
    // getters
    //

  }, {
    key: 'getManufactureDelayAsMinutes',
    value: function getManufactureDelayAsMinutes() {
      // manufactureDelay is store as milliseconds. we need minutes
      return _DateUtils2.default.millisecondsToMinutes(this.state.newManufactureDelay);
    }

    //
    // actions
    //

  }, {
    key: '__sendNewManufactureDelay__REACT_HOT_LOADER__',
    value: function __sendNewManufactureDelay__REACT_HOT_LOADER__() {
      this.setState({
        isLoadingManufactureDelay: true
      });

      var orderSettings = this.props.orderSettings;
      orderSettings.manufactureDelay = this.state.newManufactureDelay;
      _OrderAction2.default.updateOrderSettings(orderSettings);
    }
  }, {
    key: 'changeManufactureDelay',
    value: function changeManufactureDelay(newManufactureDelay) {
      this.setState({
        newManufactureDelay: newManufactureDelay
      });

      clearTimeout(timer);
      timer = setTimeout(this.sendNewManufactureDelay, _Constants2.default.Order.DELAY_SEND_NEW_MANUFACTURE_DELAY);
    }

    //
    // events
    //

  }, {
    key: '__onMinus__REACT_HOT_LOADER__',
    value: function __onMinus__REACT_HOT_LOADER__() {
      var manufactureDelay = this.state.newManufactureDelay;

      manufactureDelay -= _DateUtils2.default.MINUTE_AS_MILLISECONDS * 5;

      if (manufactureDelay < 0) {
        manufactureDelay = 0;
      }

      this.changeManufactureDelay(manufactureDelay);
    }
  }, {
    key: '__onPlus__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onPlus__REACT_HOT_LOADER__() {
      var manufactureDelay = this.state.newManufactureDelay;

      manufactureDelay += _DateUtils2.default.MINUTE_AS_MILLISECONDS * 5;

      var manufactureDelayAsMinutes = _DateUtils2.default.millisecondsToMinutes(manufactureDelay);

      if (manufactureDelayAsMinutes > _Constants2.default.Order.MAX_MANUFACTURE_DELAY) {
        manufactureDelay = _DateUtils2.default.MINUTE_AS_MILLISECONDS * _Constants2.default.Order.MAX_MANUFACTURE_DELAY;
      }

      this.changeManufactureDelay(manufactureDelay);
    }
  }, {
    key: 'renderSpinnerManufactureDelay',
    value: function renderSpinnerManufactureDelay() {
      return _react2.default.createElement(
        'div',
        { className: 'order_manufacture_delay_settings__spinner' },
        _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
      );
    }
  }, {
    key: 'renderManufactureDelaySettings',
    value: function renderManufactureDelaySettings() {
      return _react2.default.createElement(
        'div',
        { className: 'order_manufacture_delay_settings__action_block' },
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('order.manufacture_delay.label')
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'order_manufacture_delay_settings__minus',
            onClick: this.onMinus
          },
          _react2.default.createElement('i', { className: 'fa fa-minus' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'order_manufacture_delay_settings__value' },
          this.getManufactureDelayAsMinutes(),
          ' min'
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'order_manufacture_delay_settings__plus',
            onClick: this.onPlus
          },
          _react2.default.createElement('i', { className: 'fa fa-plus' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        var contentView = null;

        if (_lodash2.default.isNull(this.props.orderSettings)) {
          contentView = null;
        } else if (this.state.isLoadingManufactureDelay) {
          contentView = this.renderSpinnerManufactureDelay();
        } else {
          contentView = this.renderManufactureDelaySettings();
        }

        return _react2.default.createElement(
          'div',
          { className: 'order_manufacture_delay_settings' },
          contentView
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return OrderManufactureDelaySettingsView;
}(_react.Component);

OrderManufactureDelaySettingsView.propTypes = {
  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings)
};
var _default = OrderManufactureDelaySettingsView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DEFAULT_MANUFACTURE_DELAY_VALUE, 'DEFAULT_MANUFACTURE_DELAY_VALUE', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js');

  __REACT_HOT_LOADER__.register(timer, 'timer', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js');

  __REACT_HOT_LOADER__.register(OrderManufactureDelaySettingsView, 'OrderManufactureDelaySettingsView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/ordersHistory/OrderRowView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _PhoneUtils = __webpack_require__("./sdk/scripts/utils/PhoneUtils.js");

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _order = __webpack_require__("./scripts/components/order/index.js");

var _constants = __webpack_require__("./scripts/pages/order/ordersList/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- utils


// -- views


/**
 * @parents OrdersReadyView, OrdersNotReadyView
 */
var OrderRowView = function (_Component) {
  _inherits(OrderRowView, _Component);

  function OrderRowView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderRowView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderRowView.__proto__ || Object.getPrototypeOf(OrderRowView)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderRowView, [{
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__(modalType) {
      this.props.onSelected(this.props.order, modalType);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var order = this.props.order;
      var currencyCode = this.props.currencyCode;

      var className = (0, _classnames2.default)('order_row_view', 'pointer', {
        selected: this.props.selected
      });

      try {
        return _react2.default.createElement(
          'tr',
          { className: className, onClick: function onClick() {
              return _this3.onSelect(_constants.ModalType.DETAIL);
            } },
          _react2.default.createElement(
            'td',
            { className: 'text-left' },
            order.dueDate.format('HH:mm')
          ),
          _react2.default.createElement(
            'td',
            null,
            !order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
              icon: _utils.OrderViewUtils.getIconForMode(order.mode),
              style: styles.icon
            }),
            order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
              icon: _SvgIcon2.default.ORDER_AT_BAR,
              style: styles.icon
            })
          ),
          _react2.default.createElement(
            'td',
            null,
            !_lodash2.default.isNull(order.user) && (order.user.firstName || '') + ' ' + (order.user.lastName || '')
          ),
          _react2.default.createElement(
            'td',
            { className: 'hidden-xs hidden-sm' },
            !_lodash2.default.isNull(order.user) && _PhoneUtils2.default.format(order.user.phone)
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'span',
              null,
              _utils.CurrencyUtils.formatPriceWithCurrency(order.check.total, currencyCode)
            )
          ),
          _react2.default.createElement(
            'td',
            { className: 'text-right' },
            order.isCancelable() ? _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-sm btn-link btn-cancel',
                onClick: function onClick(e) {
                  e.stopPropagation();
                  e.preventDefault();
                  _this3.onSelect(_constants.ModalType.CANCEL);
                }
              },
              _I18n2.default.tr('order.on_going.cancel')
            ) : _react2.default.createElement(
              'span',
              { className: 'btn btn-sm text-muted disabled' },
              _I18n2.default.tr('order.on_going.not_cancelable')
            )
          ),
          _react2.default.createElement(
            'td',
            { className: 'text-center' },
            _react2.default.createElement(_order.OrderStatusLabel, {
              status: order.status
            })
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return OrderRowView;
}(_react.Component);

OrderRowView.propTypes = {
  order: _propTypes2.default.objectOf(_Order2.default),

  selected: _propTypes2.default.bool.isRequired,

  /**
   * parameter: Order
   */
  onSelected: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string

};


var styles = {
  icon: {
    height: '25px',
    width: 'auto'
  }
};

var _default = OrderRowView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderRowView, 'OrderRowView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersHistory/OrderRowView.js');

  __REACT_HOT_LOADER__.register(styles, 'styles', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersHistory/OrderRowView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersHistory/OrderRowView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/ordersHistory/OrdersHistoryPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _OrdersListStore = __webpack_require__("./scripts/stores/OrdersListStore.js");

var _OrdersListStore2 = _interopRequireDefault(_OrdersListStore);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _OrderRowView = __webpack_require__("./scripts/pages/order/ordersList/ordersHistory/OrderRowView.js");

var _OrderRowView2 = _interopRequireDefault(_OrderRowView);

var _OrderCancelModal = __webpack_require__("./scripts/components/order/orderCancelModal/OrderCancelModal.js");

var _OrderCancelModal2 = _interopRequireDefault(_OrderCancelModal);

var _OrderDetailModal = __webpack_require__("./scripts/components/order/orderDetailModal/OrderDetailModal.js");

var _OrderDetailModal2 = _interopRequireDefault(_OrderDetailModal);

var _DateField = __webpack_require__("./sdk/scripts/components/form/DateField.js");

var _DateField2 = _interopRequireDefault(_DateField);

var _constants2 = __webpack_require__("./scripts/pages/order/ordersList/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- stores


// -- entities


// -- views


var _timer = null;

var OrdersHistoryPage = function (_AbstractComponent) {
  _inherits(OrdersHistoryPage, _AbstractComponent);

  function OrdersHistoryPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrdersHistoryPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrdersHistoryPage.__proto__ || Object.getPrototypeOf(OrdersHistoryPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ordersList: null,
      restaurant: _RestaurantStore2.default.getRestaurant(),

      // order to disaply details
      selectedOrder: null,

      date: _this.getDefaultDate(),
      openedModalType: null,
      errorCancel: null,
      isLoadingCancelOrder: false
    }, _this.onOrdersListLoaded = function () {
      var _this2;

      return (_this2 = _this).__onOrdersListLoaded__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onOrderListLoadError = function () {
      var _this3;

      return (_this3 = _this).__onOrderListLoadError__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onOrderUpdateSuccess = function () {
      var _this4;

      return (_this4 = _this).__onOrderUpdateSuccess__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onOrderUpdateError = function () {
      var _this5;

      return (_this5 = _this).__onOrderUpdateError__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onDateChange = function () {
      var _this6;

      return (_this6 = _this).__onDateChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onOrderSelected = function () {
      var _this7;

      return (_this7 = _this).__onOrderSelected__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.handleCancelOrder = function () {
      var _this8;

      return (_this8 = _this).__handleCancelOrder__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onHideModal = function () {
      var _this9;

      return (_this9 = _this).__onHideModal__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrdersHistoryPage, [{
    key: '__onHideModal__REACT_HOT_LOADER__',
    value: function __onHideModal__REACT_HOT_LOADER__() {
      return this.__onHideModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCancelOrder__REACT_HOT_LOADER__',
    value: function __handleCancelOrder__REACT_HOT_LOADER__() {
      return this.__handleCancelOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderSelected__REACT_HOT_LOADER__',
    value: function __onOrderSelected__REACT_HOT_LOADER__() {
      return this.__onOrderSelected__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDateChange__REACT_HOT_LOADER__',
    value: function __onDateChange__REACT_HOT_LOADER__() {
      return this.__onDateChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderUpdateError__REACT_HOT_LOADER__',
    value: function __onOrderUpdateError__REACT_HOT_LOADER__() {
      return this.__onOrderUpdateError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderUpdateSuccess__REACT_HOT_LOADER__',
    value: function __onOrderUpdateSuccess__REACT_HOT_LOADER__() {
      return this.__onOrderUpdateSuccess__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderListLoadError__REACT_HOT_LOADER__',
    value: function __onOrderListLoadError__REACT_HOT_LOADER__() {
      return this.__onOrderListLoadError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrdersListLoaded__REACT_HOT_LOADER__',
    value: function __onOrdersListLoaded__REACT_HOT_LOADER__() {
      return this.__onOrdersListLoaded__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _OrdersListStore2.default.addListeners(this.ordersListListeners);

      this.loadOrdersListForDate(this.state.date);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _OrdersListStore2.default.removeListeners(this.ordersListListeners);
    }
  }, {
    key: 'getDefaultDate',
    value: function getDefaultDate() {
      var defaultDate = null;

      if (!_lodash2.default.isUndefined(this.queryParams.date)) {
        defaultDate = (0, _moment2.default)(this.queryParams.date, OrdersHistoryPage.DATE_QUERY_PARAM_FORMAT);
      }

      return !_lodash2.default.isNull(defaultDate) ? defaultDate : (0, _moment2.default)();
    }

    /**
     * Load the orders created during the given timelapse.
     */

  }, {
    key: 'loadOrdersListForDate',
    value: function loadOrdersListForDate(date) {
      var fromTime = date.startOf('day').valueOf();
      var toTime = date.endOf('day').valueOf();

      this.showLoading();
      _actions.OrderAction.loadOrdersListByDueDate(fromTime, toTime);
    }
  }, {
    key: 'setSelectedOrder',
    value: function setSelectedOrder(selectedOrder, openedModalType) {
      this.setState({
        selectedOrder: selectedOrder,
        openedModalType: openedModalType,
        errorCancel: null
      });
    }

    //
    // Api events - order
    //

  }, {
    key: '__onOrdersListLoaded__REACT_HOT_LOADER__',
    value: function __onOrdersListLoaded__REACT_HOT_LOADER__() {
      var ordersList = _OrdersListStore2.default.getDueDateOrdersList();

      this.setState({
        ordersList: ordersList,
        loading: false
      });
    }
  }, {
    key: '__onOrderListLoadError__REACT_HOT_LOADER__',
    value: function __onOrderListLoadError__REACT_HOT_LOADER__() {
      // TODO.
    }
  }, {
    key: '__onOrderUpdateSuccess__REACT_HOT_LOADER__',
    value: function __onOrderUpdateSuccess__REACT_HOT_LOADER__() {
      this.setState({
        isLoadingCancelOrder: false,
        ordersList: _OrdersListStore2.default.getDueDateOrdersList()
      });
      this.onHideModal();
    }
  }, {
    key: '__onOrderUpdateError__REACT_HOT_LOADER__',


    //
    // Date events
    //

    value: function __onOrderUpdateError__REACT_HOT_LOADER__() {
      this.setState({
        isLoadingCancelOrder: false,
        errorCancel: _OrdersListStore2.default.getApiError()
      });
    }
  }, {
    key: '__onDateChange__REACT_HOT_LOADER__',
    value: function __onDateChange__REACT_HOT_LOADER__(newDate) {
      this.loadOrdersListForDate(newDate);

      /*
       * Update the query params.
       */
      this.onChangeQueryUrl({
        date: newDate.format(OrdersHistoryPage.DATE_QUERY_PARAM_FORMAT)
      });

      this.setState({
        date: newDate
      });
    }
  }, {
    key: '__onOrderSelected__REACT_HOT_LOADER__',
    value: function __onOrderSelected__REACT_HOT_LOADER__(order, openedModalType) {
      this.setSelectedOrder(order, openedModalType);
    }
  }, {
    key: '__handleCancelOrder__REACT_HOT_LOADER__',


    //
    // Order detail modal
    //

    value: function __handleCancelOrder__REACT_HOT_LOADER__() {
      var order = this.state.selectedOrder.copy();
      order.status = _order.Order.OrderStatus.CANCELED;

      _actions.OrderAction.updateOrder(order);
      this.setState({
        isLoadingCancelOrder: true
      });
    }
  }, {
    key: '__onHideModal__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onHideModal__REACT_HOT_LOADER__() {
      this.setState({
        selectedOrder: null,
        errorCancel: null,
        openedModalType: null
      });
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      return _react2.default.createElement(
        'div',
        { className: 'row col-xs-12' },
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-12 col-md-4 col-md-offset-4 top-buffer-sm-20 top-buffer-xs-20'
          },
          _react2.default.createElement(_DateField2.default, {
            onChange: this.onDateChange,
            date: this.state.date,
            maxDate: (0, _moment2.default)().endOf('day')
          })
        )
      );
    }
  }, {
    key: 'renderOrderDetailModal',
    value: function renderOrderDetailModal() {
      if (!_lodash2.default.isNull(this.state.selectedOrder) && this.state.openedModalType === _constants2.ModalType.DETAIL) {
        return _react2.default.createElement(_OrderDetailModal2.default, {
          order: this.state.selectedOrder,
          show: true,
          onHide: this.onHideModal,
          currencyCode: this.state.restaurant.currency
        });
      }
    }
  }, {
    key: 'renderOrderCancelModal',
    value: function renderOrderCancelModal() {
      if (!_lodash2.default.isNull(this.state.selectedOrder) && this.state.openedModalType === _constants2.ModalType.CANCEL) {
        return _react2.default.createElement(_OrderCancelModal2.default, {
          order: this.state.selectedOrder,
          show: true,
          isLoading: this.state.isLoadingCancelOrder,
          onHide: this.onHideModal,
          onSubmit: this.handleCancelOrder,
          errorCancel: this.state.errorCancel,
          currencyCode: this.state.restaurant.currency
        });
      }
    }
  }, {
    key: 'renderNoOrders',
    value: function renderNoOrders() {
      return _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('order.history.no_orders')
        )
      );
    }
  }, {
    key: 'renderOrders',
    value: function renderOrders() {
      var _this10 = this;

      var historyOrders = this.state.ordersList.getHistoryOrders();

      if (_lodash2.default.isEmpty(historyOrders)) {
        return this.renderNoOrders();
      }

      var sortedHistoryOrders = _lodash2.default.sortBy(historyOrders, ['desc'], function (order) {
        return order.dueDate.valueOf();
      });

      var rows = sortedHistoryOrders.map(function (order) {
        if (!order.isFailed()) {
          var selected = !_lodash2.default.isNull(_this10.state.selectedOrder) && _this10.state.selectedOrder.id === order.id;

          return _react2.default.createElement(_OrderRowView2.default, {
            order: order,
            key: order.id,
            onOrdersListChange: _this10.onOrderChange,
            onSelected: _this10.onOrderSelected,
            selected: selected,
            currencyCode: _this10.state.restaurant.currency
          });
        }
        return null;
      });

      return _react2.default.createElement(
        'div',
        { className: 'table_container table-responsive' },
        _react2.default.createElement(
          'table',
          { className: 'orders_ready table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { className: 'text-left' },
                _react2.default.createElement('i', { className: 'fa fa-clock-o' })
              ),
              _react2.default.createElement('th', null),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('order.history.table.header.first_name')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'hidden-xs hidden-sm'
                },
                _I18n2.default.tr('order.history.table.header.phone')
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('order.history.table.header.total')
              ),
              _react2.default.createElement('th', null),
              _react2.default.createElement(
                'th',
                { className: 'text-center' },
                _I18n2.default.tr('order.history.table.header.status')
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            rows
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var ordersList = this.state.ordersList;

      var contentView = null;

      try {
        if (_lodash2.default.isNull(ordersList)) {
          contentView = this.renderLoading();
        } else {
          contentView = _react2.default.createElement(
            'div',
            { className: 'order_list__content row' },
            this.renderHeader(),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 order_list__list top-buffer-50' },
              this.renderOrders()
            ),
            this.renderOrderDetailModal(),
            this.renderOrderCancelModal()
          );
        }

        return _react2.default.createElement(
          'div',
          { className: 'order_list' },
          this.renderLoading(),
          contentView
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'ordersListListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_SUCCESS, this.onOrdersListLoaded), new _Listener2.default(_Events2.default.ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_FAILURE, this.onOrderListLoadError), new _Listener2.default(_Events2.default.UPDATE_ORDER_SUCCESS, this.onOrderUpdateSuccess), new _Listener2.default(_Events2.default.UPDATE_ORDER_FAILURE, this.onOrderUpdateError)];
    }
  }]);

  return OrdersHistoryPage;
}(_AbstractComponent3.default);

OrdersHistoryPage.DATE_QUERY_PARAM_FORMAT = 'DD-MM-YYYY';
exports.default = OrdersHistoryPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_timer, '_timer', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersHistory/OrdersHistoryPage.js');

  __REACT_HOT_LOADER__.register(OrdersHistoryPage, 'OrdersHistoryPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersHistory/OrdersHistoryPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/ordersOnGoing/OrderRowView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _OrderAction = __webpack_require__("./scripts/actions/OrderAction.js");

var _OrderAction2 = _interopRequireDefault(_OrderAction);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _PhoneUtils = __webpack_require__("./sdk/scripts/utils/PhoneUtils.js");

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _order = __webpack_require__("./scripts/components/order/index.js");

var _constants = __webpack_require__("./scripts/pages/order/ordersList/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- utils


// -- views


/**
 * @parents OrdersReadyView, OrdersNotReadyView
 */
var OrderRowView = function (_Component) {
  _inherits(OrderRowView, _Component);

  function OrderRowView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderRowView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderRowView.__proto__ || Object.getPrototypeOf(OrderRowView)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function () {
      var _this2;

      return (_this2 = _this).__onSelect__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHistorizeOrder = function () {
      var _this3;

      return (_this3 = _this).__onHistorizeOrder__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // timeInterval = null;
  //
  // componentDidMount() {
  //   this.initCountdownTimer();
  // }
  //
  // componentDidUpdate() {
  //   this.initCountdownTimer();
  // }
  //
  // componentWillUnmount() {
  //   clearInterval(this.timeInterval);
  // }
  //
  // initCountdownTimer() {
  //   clearInterval(this.timeInterval);
  //
  //   const clock = this.refs.countdown;
  //   console.log('clock', clock);
  //   this.timeInterval = setInterval(() => {
  //     clock.innerHTML = `${.format()}
  //   }, 1000);
  // }

  _createClass(OrderRowView, [{
    key: '__onHistorizeOrder__REACT_HOT_LOADER__',
    value: function __onHistorizeOrder__REACT_HOT_LOADER__() {
      return this.__onHistorizeOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__() {
      return this.__onSelect__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSelect__REACT_HOT_LOADER__',
    value: function __onSelect__REACT_HOT_LOADER__(modalType) {
      this.props.onSelected(this.props.order, modalType);
    }
  }, {
    key: '__onHistorizeOrder__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onHistorizeOrder__REACT_HOT_LOADER__(event) {
      event.stopPropagation();

      var order = this.props.order;

      order.status = _Order2.default.OrderStatus.DELIVERED;
      _OrderAction2.default.updateOrder(order);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var order = this.props.order;
      var currencyCode = this.props.currencyCode;

      var className = (0, _classnames2.default)('order_row_view', 'pointer', 'PRIORITY_' + this.props.priority, {
        selected: this.props.selected
      });

      return _react2.default.createElement(
        'tr',
        { className: className, onClick: function onClick() {
            return _this4.onSelect(_constants.ModalType.DETAIL);
          } },
        _react2.default.createElement(
          'td',
          null,
          '#',
          order.getOrderNumber()
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-left pickup_date_countdown',
            ref: 'countdown'
          },
          order.getRemainingTimeLabel()
        ),
        _react2.default.createElement(
          'td',
          null,
          !order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
            icon: _utils.OrderViewUtils.getIconForMode(order.mode),
            style: styles.icon
          }),
          order.isOnBar() && _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.ORDER_AT_BAR,
            style: styles.icon
          })
        ),
        _react2.default.createElement(
          'td',
          null,
          !_lodash2.default.isNull(order.user) && (order.user.firstName || '') + ' ' + (order.user.lastName || '')
        ),
        _react2.default.createElement(
          'td',
          { className: 'hidden-xs hidden-sm hidden-md' },
          !_lodash2.default.isNull(order.user) && _PhoneUtils2.default.format(order.user.phone)
        ),
        _react2.default.createElement(
          'td',
          null,
          order.isPayed() ? _react2.default.createElement(
            'span',
            null,
            _utils.CurrencyUtils.formatPriceWithCurrency(order.check.total, currencyCode)
          ) : _react2.default.createElement(
            'span',
            null,
            _utils.CurrencyUtils.formatPriceWithCurrency(order.getTotalPrice(), currencyCode)
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-center' },
          !order.isPayed() ? _react2.default.createElement(
            'span',
            null,
            _I18n2.default.tr('order.on_going.on_site')
          ) : _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('i', { className: 'pmt pmt-check' })
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          order.isCancelable() ? _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-sm btn-link btn-cancel',
              onClick: function onClick(e) {
                e.stopPropagation();
                e.preventDefault();
                _this4.onSelect(_constants.ModalType.CANCEL);
              }
            },
            _I18n2.default.tr('order.on_going.cancel')
          ) : _react2.default.createElement(
            'span',
            { className: 'btn btn-sm text-muted disabled' },
            _I18n2.default.tr('order.on_going.not_cancelable')
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          this.props.priority !== _Order2.default.Priority.LATER && order.isReceived() && _react2.default.createElement(
            'button',
            {
              className: 'btn btn-sm btn-default',
              onClick: this.onHistorizeOrder
            },
            _I18n2.default.tr('order.on_going.order_ready')
          )
        )
      );
    }
  }]);

  return OrderRowView;
}(_react.Component);

OrderRowView.propTypes = {
  order: _propTypes2.default.objectOf(_Order2.default),

  selected: _propTypes2.default.bool.isRequired,

  /**
   * parameter: Order
   */
  onSelected: _propTypes2.default.func.isRequired,

  priority: _propTypes2.default.string,

  currencyCode: _propTypes2.default.string

};


var styles = {
  icon: {
    height: '25px',
    width: 'auto'
  }
};

var _default = OrderRowView;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderRowView, 'OrderRowView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersOnGoing/OrderRowView.js');

  __REACT_HOT_LOADER__.register(styles, 'styles', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersOnGoing/OrderRowView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersOnGoing/OrderRowView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/ordersList/ordersOnGoing/OrdersOnGoingListView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _OrdersListStore = __webpack_require__("./scripts/stores/OrdersListStore.js");

var _OrdersListStore2 = _interopRequireDefault(_OrdersListStore);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _RestaurantMenuPage = __webpack_require__("./scripts/pages/menu/RestaurantMenuPage.js");

var _RestaurantMenuPage2 = _interopRequireDefault(_RestaurantMenuPage);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _OrderRowView = __webpack_require__("./scripts/pages/order/ordersList/ordersOnGoing/OrderRowView.js");

var _OrderRowView2 = _interopRequireDefault(_OrderRowView);

var _OrderCancelModal = __webpack_require__("./scripts/components/order/orderCancelModal/OrderCancelModal.js");

var _OrderCancelModal2 = _interopRequireDefault(_OrderCancelModal);

var _OrderDetailModal = __webpack_require__("./scripts/components/order/orderDetailModal/OrderDetailModal.js");

var _OrderDetailModal2 = _interopRequireDefault(_OrderDetailModal);

var _OrderModeChooser = __webpack_require__("./sdk/scripts/components/form/OrderModeChooser.js");

var _OrderModeChooser2 = _interopRequireDefault(_OrderModeChooser);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _OrderManufactureDelaySettingsView = __webpack_require__("./scripts/pages/order/ordersList/orderManufactureDelay/OrderManufactureDelaySettingsView.js");

var _OrderManufactureDelaySettingsView2 = _interopRequireDefault(_OrderManufactureDelaySettingsView);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

var _TextInput = __webpack_require__("./sdk/scripts/components/form/TextInput.js");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _constants2 = __webpack_require__("./scripts/pages/order/ordersList/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- stores


// -- entities


// -- views


var OrdersOnGoingListView = function (_AbstractComponent) {
  _inherits(OrdersOnGoingListView, _AbstractComponent);

  function OrdersOnGoingListView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrdersOnGoingListView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrdersOnGoingListView.__proto__ || Object.getPrototypeOf(OrdersOnGoingListView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedFilter: null,
      filterName: null,
      filterPayment: null,
      filterSource: null,
      filterOrderMode: null,
      openedModalType: null,
      // order to disaply details
      selectedOrder: null,
      errorCancel: null,
      isLoadingCancelOrder: false,
      isNavigatorOnline: true
    }, _this.updateOnlineStatus = function () {
      var _this2;

      return (_this2 = _this).__updateOnlineStatus__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onOrderUpdate = function () {
      var _this3;

      return (_this3 = _this).__onOrderUpdate__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onError = function () {
      var _this4;

      return (_this4 = _this).__onError__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.isFilterActive = function () {
      var _this5;

      return (_this5 = _this).__isFilterActive__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onOrderSelected = function () {
      var _this6;

      return (_this6 = _this).__onOrderSelected__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.handleCancelOrder = function () {
      var _this7;

      return (_this7 = _this).__handleCancelOrder__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.toggleFilter = function () {
      var _this8;

      return (_this8 = _this).__toggleFilter__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.setFilterName = function () {
      var _this9;

      return (_this9 = _this).__setFilterName__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.setFilterSource = function () {
      var _this10;

      return (_this10 = _this).__setFilterSource__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.setFilterPayment = function () {
      var _this11;

      return (_this11 = _this).__setFilterPayment__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.setFilterOrderMode = function () {
      var _this12;

      return (_this12 = _this).__setFilterOrderMode__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.handleDisableOrder = function () {
      var _this13;

      return (_this13 = _this).__handleDisableOrder__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onHideModal = function () {
      var _this14;

      return (_this14 = _this).__onHideModal__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.runSound = function () {
      var _this15;

      return (_this15 = _this).__runSound__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrdersOnGoingListView, [{
    key: '__runSound__REACT_HOT_LOADER__',
    value: function __runSound__REACT_HOT_LOADER__() {
      return this.__runSound__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideModal__REACT_HOT_LOADER__',
    value: function __onHideModal__REACT_HOT_LOADER__() {
      return this.__onHideModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDisableOrder__REACT_HOT_LOADER__',
    value: function __handleDisableOrder__REACT_HOT_LOADER__() {
      return this.__handleDisableOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__setFilterOrderMode__REACT_HOT_LOADER__',
    value: function __setFilterOrderMode__REACT_HOT_LOADER__() {
      return this.__setFilterOrderMode__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__setFilterPayment__REACT_HOT_LOADER__',
    value: function __setFilterPayment__REACT_HOT_LOADER__() {
      return this.__setFilterPayment__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__setFilterSource__REACT_HOT_LOADER__',
    value: function __setFilterSource__REACT_HOT_LOADER__() {
      return this.__setFilterSource__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__setFilterName__REACT_HOT_LOADER__',
    value: function __setFilterName__REACT_HOT_LOADER__() {
      return this.__setFilterName__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__toggleFilter__REACT_HOT_LOADER__',
    value: function __toggleFilter__REACT_HOT_LOADER__() {
      return this.__toggleFilter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCancelOrder__REACT_HOT_LOADER__',
    value: function __handleCancelOrder__REACT_HOT_LOADER__() {
      return this.__handleCancelOrder__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderSelected__REACT_HOT_LOADER__',
    value: function __onOrderSelected__REACT_HOT_LOADER__() {
      return this.__onOrderSelected__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__isFilterActive__REACT_HOT_LOADER__',
    value: function __isFilterActive__REACT_HOT_LOADER__() {
      return this.__isFilterActive__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderUpdate__REACT_HOT_LOADER__',
    value: function __onOrderUpdate__REACT_HOT_LOADER__() {
      return this.__onOrderUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__updateOnlineStatus__REACT_HOT_LOADER__',
    value: function __updateOnlineStatus__REACT_HOT_LOADER__() {
      return this.__updateOnlineStatus__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this16 = this;

      _OrdersListStore2.default.addListeners(this.ordersListListeners);
      window.addEventListener('offline', function () {
        _this16.updateOnlineStatus(false);
      }, false);
      window.addEventListener('online', function () {
        _this16.updateOnlineStatus(true);
      }, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _OrdersListStore2.default.removeListeners(this.ordersListListeners);
    }
  }, {
    key: '__updateOnlineStatus__REACT_HOT_LOADER__',
    value: function __updateOnlineStatus__REACT_HOT_LOADER__(status) {
      this.setState({
        isNavigatorOnline: status
      });
    }
  }, {
    key: '__onOrderUpdate__REACT_HOT_LOADER__',
    value: function __onOrderUpdate__REACT_HOT_LOADER__() {
      this.onHideModal();
      this.setState({
        isLoadingCancelOrder: false
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        isLoadingCancelOrder: false,
        errorCancel: _OrdersListStore2.default.getApiError()
      });
    }
  }, {
    key: '__isFilterActive__REACT_HOT_LOADER__',
    value: function __isFilterActive__REACT_HOT_LOADER__(value) {
      return value === this.state.selectedFilter ? 'active' : '';
    }
  }, {
    key: '__onOrderSelected__REACT_HOT_LOADER__',
    value: function __onOrderSelected__REACT_HOT_LOADER__(order, openedModalType) {
      this.setSelectedOrder(order, openedModalType);
    }
  }, {
    key: '__handleCancelOrder__REACT_HOT_LOADER__',
    value: function __handleCancelOrder__REACT_HOT_LOADER__() {
      var order = this.state.selectedOrder.copy();
      order.status = _order.Order.OrderStatus.CANCELED;

      _actions.OrderAction.updateOrder(order);
      this.setState({
        isLoadingCancelOrder: true
      });
    }
  }, {
    key: 'setSelectedOrder',
    value: function setSelectedOrder(selectedOrder, openedModalType) {
      this.setState({
        selectedOrder: selectedOrder,
        openedModalType: openedModalType,
        errorCancel: null
      });
    }
  }, {
    key: '__toggleFilter__REACT_HOT_LOADER__',
    value: function __toggleFilter__REACT_HOT_LOADER__(filter) {
      this.setState({
        selectedFilter: filter
      });
    }
  }, {
    key: '__setFilterName__REACT_HOT_LOADER__',
    value: function __setFilterName__REACT_HOT_LOADER__(filterName) {
      this.setState({
        filterName: filterName
      });
    }
  }, {
    key: '__setFilterSource__REACT_HOT_LOADER__',
    value: function __setFilterSource__REACT_HOT_LOADER__(option) {
      this.setState({
        filterSource: _lodash2.default.isNull(option) ? null : option.value
      });
    }
  }, {
    key: '__setFilterPayment__REACT_HOT_LOADER__',
    value: function __setFilterPayment__REACT_HOT_LOADER__(option) {
      this.setState({
        filterPayment: _lodash2.default.isNull(option) ? null : option.value
      });
    }
  }, {
    key: '__setFilterOrderMode__REACT_HOT_LOADER__',
    value: function __setFilterOrderMode__REACT_HOT_LOADER__(mode) {
      this.setState({
        filterOrderMode: mode
      });
    }
  }, {
    key: '__handleDisableOrder__REACT_HOT_LOADER__',


    //
    // Order detail modal
    //

    value: function __handleDisableOrder__REACT_HOT_LOADER__() {
      var status = this.props.restaurant.status === 'ENABLED' ? 'DISABLED' : 'ENABLED';

      this.props.onUpdateRestaurantStatus(status);
    }
  }, {
    key: '__onHideModal__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onHideModal__REACT_HOT_LOADER__() {
      this.setState({
        selectedOrder: null,
        openedModalType: null,
        errorCancel: null
      });
    }
  }, {
    key: 'renderOrderDetailModal',
    value: function renderOrderDetailModal() {
      if (!_lodash2.default.isNull(this.state.selectedOrder) && this.state.openedModalType === _constants2.ModalType.DETAIL) {
        return _react2.default.createElement(_OrderDetailModal2.default, {
          order: this.state.selectedOrder,
          show: true,
          onHide: this.onHideModal,
          currencyCode: this.props.restaurant.currency
        });
      }
    }
  }, {
    key: 'renderOrderCancelModal',
    value: function renderOrderCancelModal() {
      if (!_lodash2.default.isNull(this.state.selectedOrder) && this.state.openedModalType === _constants2.ModalType.CANCEL) {
        return _react2.default.createElement(_OrderCancelModal2.default, {
          order: this.state.selectedOrder,
          show: true,
          isLoading: this.state.isLoadingCancelOrder,
          onHide: this.onHideModal,
          onSubmit: this.handleCancelOrder,
          errorCancel: this.state.errorCancel,
          currencyCode: this.props.restaurant.currency
        });
      }
    }
  }, {
    key: 'renderOrders',
    value: function renderOrders() {
      var _this17 = this;

      var onGoingOrders = this.props.ordersList.getOnGoingOrders();

      var sortedOnGoingOrders = _lodash2.default.sortBy(onGoingOrders, ['desc'], function (order) {
        return order.dueDate.valueOf();
      });

      // we need to stringify/parse filterSource in order to match label/value pair in LocalizableSelect
      var filteredOnGoingOrder = sortedOnGoingOrders.filter(function (order) {
        return (_lodash2.default.isEmpty(_this17.state.filterName) || !_lodash2.default.isNil(order.user) && _utils.StringUtils.searchStringOn(_this17.state.filterName, order.user.firstName + ' ' + order.user.lastName)) && (_lodash2.default.isEmpty(_this17.state.filterPayment) || _this17.state.filterPayment == order.isPayed().toString()) && (_lodash2.default.isEmpty(_this17.state.filterSource) || _lodash2.default.find(JSON.parse(_this17.state.filterSource), function (source) {
          return source == order.source.platform;
        })) && (_lodash2.default.isNull(_this17.state.filterOrderMode) || _this17.state.filterOrderMode === order.mode);
      });

      var platform = [];
      _lodash2.default.forEach(_ApiConstants2.default.Platform, function (value, label) {
        if (label == _ApiConstants2.default.Platform.IOS) {
          platform.push({ label: _utils.OrderViewUtils.getLabelForPlatform(label), value: JSON.stringify([value, _ApiConstants2.default.Platform.ANDROID]) });
        } else if (label != _ApiConstants2.default.Platform.ANDROID) {
          platform.push({ label: _utils.OrderViewUtils.getLabelForPlatform(label), value: JSON.stringify([value]) });
        }
      });

      // create dates for calculs
      var manufactureDelay = this.props.orderSettings.manufactureDelay;

      var rows = filteredOnGoingOrder.map(function (order) {

        var selected = !_lodash2.default.isNull(_this17.state.selectedOrder) && _this17.state.selectedOrder.id === order.id;

        var delay = _this17.props.orderSettings.getOrderDelay(order.mode);

        var priority = order.getPriority(delay);

        return _react2.default.createElement(_OrderRowView2.default, {
          order: order,
          key: order.id,
          onOrdersListChange: _this17.onOrderChange,
          onSelected: _this17.onOrderSelected,
          selected: selected,
          priority: priority,
          currencyCode: _this17.props.restaurant.currency
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'table_container table-responsive' },
        _react2.default.createElement(
          'table',
          { className: 'orders_ready table table-striped table-hover' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement('th', null),
              _react2.default.createElement(
                'th',
                { className: 'text-left' },
                _react2.default.createElement('i', { className: 'fa fa-clock-o' })
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_OrderModeChooser2.default, {
                  placeholder: _I18n2.default.tr('order.on_going.table.header.type'),
                  onChange: this.setFilterOrderMode,
                  multi: false,
                  value: this.state.filterOrderMode,
                  modes: _lodash2.default.values(_order.Order.OrderMode)
                })
              ),
              _react2.default.createElement(
                'th',
                { className: 'filters' },
                _react2.default.createElement(_TextInput2.default, {
                  type: 'text',
                  value: this.state.filterName,
                  placeholder: _I18n2.default.tr('order.on_going.table.header.name'),
                  className: this.isFilterActive('name'),
                  onFocus: function onFocus() {
                    _this17.toggleFilter('name');
                  },
                  onBlur: function onBlur() {
                    _this17.toggleFilter('');
                  },
                  onChange: function onChange(value, event) {
                    return _this17.setFilterName(value);
                  }
                }),
                _react2.default.createElement('i', { className: 'fa fa-search' })
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'hidden-xs hidden-sm hidden-md'
                },
                _I18n2.default.tr('order.on_going.table.header.phone')
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('order.on_going.table.header.total')
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_LocalizableSelect2.default, {
                  name: 'filterPayment',
                  placeholder: _I18n2.default.tr('order.on_going.table.header.payment'),
                  value: this.state.filterPayment,
                  options: [{
                    label: _I18n2.default.tr('order.on_going.on_site'),
                    value: 'false'
                  }, {
                    label: _I18n2.default.tr('order.on_going.online'),
                    value: 'true'
                  }],
                  onChange: this.setFilterPayment,
                  multi: false
                })
              ),
              _react2.default.createElement('th', null),
              _react2.default.createElement('th', null)
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            !this.state.isNavigatorOnline && _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { colSpan: 9, style: { padding: 0 } },
                _react2.default.createElement(
                  'div',
                  { className: 'alert-danger text-center', style: { padding: '12px' } },
                  _I18n2.default.tr('order.on_going.table.offline')
                )
              )
            ),
            rows
          )
        )
      );
    }
  }, {
    key: '__runSound__REACT_HOT_LOADER__',
    value: function __runSound__REACT_HOT_LOADER__() {
      // init bunch of sounds
      ion.sound({
        sounds: [{ name: "new_order_notification" }],

        // main config
        path: 'public/sounds/',
        preload: true,
        multiplay: true,
        volume: 1
      });

      // play sound
      ion.sound.play("new_order_notification");
    }
  }, {
    key: 'render',
    value: function render() {
      var ordersList = this.props.ordersList;

      var contentView = null;

      if (_lodash2.default.isNull(ordersList)) {
        contentView = this.renderLoading();
      } else {
        contentView = _react2.default.createElement(
          'div',
          { className: 'order_list__content orders_on_going' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            !this.props.restaurant.status === 'DISABLED' && _react2.default.createElement(
              'div',
              { className: 'col-xs-12 top-buffer-20' },
              _react2.default.createElement(
                'div',
                { className: 'alert alert-danger' },
                _SecurityContext2.default.restaurantSettings.editConfigurationGeneralActivation() ? _I18n2.default.tr('order.on_going.order_disabled_text') : _I18n2.default.tr('order.on_going.order_disabled_text_without_permission')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-lg-6' },
              _react2.default.createElement(_OrderManufactureDelaySettingsView2.default, {
                orderSettings: this.props.orderSettings
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-lg-6 top-buffer-10 order_list__settings' },
              (_SecurityContext2.default.restaurantMenu.canEdit() || _SecurityContext2.default.restaurantMenu.canEditAvailabilityProducts()) && _react2.default.createElement(
                _Link2.default,
                {
                  to: _RoutingEnum2.default.RESTAURANT_MENU,
                  query: { tab: _RestaurantMenuPage2.default.Tabs.PRODUCTS },
                  target: '_blank'
                },
                _react2.default.createElement(
                  'button',
                  { className: 'btn btn-default btn-with-link order_list__disable_item' },
                  _I18n2.default.tr('order.on_going.disable_product')
                )
              ),
              this.props.restaurant.status !== 'ARCHIVED' && _SecurityContext2.default.restaurantSettings.editConfigurationGeneralActivation() && _react2.default.createElement(
                'div',
                { className: 'order_list__disable_order' },
                _react2.default.createElement(
                  'span',
                  { className: 'order_list__disable_order__text text-left' },
                  _I18n2.default.tr('order.on_going.disable_order')
                ),
                _react2.default.createElement(_reactBootstrapSwitch2.default, {
                  value: this.props.restaurant.status === 'ENABLED',
                  onChange: this.handleDisableOrder,
                  bsSize: 'mini',
                  onColor: 'default',
                  onText: _I18n2.default.tr('order.on_going.order_enabled'),
                  offColor: 'danger',
                  offText: _I18n2.default.tr('order.on_going.order_disabled')
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 order_list__list' },
              this.renderOrders()
            )
          ),
          this.renderOrderDetailModal(),
          this.renderOrderCancelModal()
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'order_list' },
        this.renderLoading(),
        contentView
      );
    }
  }, {
    key: 'ordersListListeners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.UPDATE_ORDER_SUCCESS, this.onOrderUpdate), new _Listener2.default(_Events2.default.UPDATE_ORDER_FAILURE, this.onError)];
    }
  }]);

  return OrdersOnGoingListView;
}(_AbstractComponent3.default);

OrdersOnGoingListView.propTypes = {
  ordersList: _propTypes2.default.objectOf(_order.OrdersList).isRequired,
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant).isRequired,

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired
};
exports.default = OrdersOnGoingListView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrdersOnGoingListView, 'OrdersOnGoingListView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/ordersList/ordersOnGoing/OrdersOnGoingListView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/OrderSettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = __webpack_require__("./scripts/utils/index.js");

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _OrderGeneralSettingsPage = __webpack_require__("./scripts/pages/order/settings/components/OrderGeneralSettingsPage.js");

var _OrderGeneralSettingsPage2 = _interopRequireDefault(_OrderGeneralSettingsPage);

var _OrderOpeningHoursSettingsPage = __webpack_require__("./scripts/pages/order/settings/components/OrderOpeningHoursSettingsPage.js");

var _OrderOpeningHoursSettingsPage2 = _interopRequireDefault(_OrderOpeningHoursSettingsPage);

var _OnSiteSettingsPage = __webpack_require__("./scripts/pages/order/settings/modes/OnSiteSettingsPage.js");

var _OnSiteSettingsPage2 = _interopRequireDefault(_OnSiteSettingsPage);

var _TakeAwaySettingsPage = __webpack_require__("./scripts/pages/order/settings/modes/TakeAwaySettingsPage.js");

var _TakeAwaySettingsPage2 = _interopRequireDefault(_TakeAwaySettingsPage);

var _DeliverySettingsPage = __webpack_require__("./scripts/pages/order/settings/modes/DeliverySettingsPage.js");

var _DeliverySettingsPage2 = _interopRequireDefault(_DeliverySettingsPage);

var _KioskSettingsPage = __webpack_require__("./scripts/pages/order/settings/kiosk/KioskSettingsPage.js");

var _KioskSettingsPage2 = _interopRequireDefault(_KioskSettingsPage);

var _ApiErrorView = __webpack_require__("./scripts/components/ApiErrorView.js");

var _ApiErrorView2 = _interopRequireDefault(_ApiErrorView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- stores


// -- entities


// -- views


var OrdersSettingsPage = function (_AbstractComponent) {
  _inherits(OrdersSettingsPage, _AbstractComponent);

  function OrdersSettingsPage() {
    _classCallCheck(this, OrdersSettingsPage);

    var _this = _possibleConstructorReturn(this, (OrdersSettingsPage.__proto__ || Object.getPrototypeOf(OrdersSettingsPage)).call(this));

    _this.state = {
      restaurant: null,
      orderSettings: null
    };

    _this.loadCurrentRestaurant = function () {
      return _this.__loadCurrentRestaurant__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onChange = function () {
      return _this.__onChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onError = function () {
      return _this.__onError__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdateOrderSettings = function () {
      return _this.__onUpdateOrderSettings__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdateOrderSettingsError = function () {
      return _this.__onUpdateOrderSettingsError__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onTabChange = function () {
      return _this.__onTabChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onSubmit = function () {
      return _this.__onSubmit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-line-chart';
    _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.order'),
      link: _RoutingEnum2.default.ORDERS_LIST
    }, {
      name: _I18n2.default.tr('menu.order.settings'),
      link: null
    }];
    return _this;
  }

  _createClass(OrdersSettingsPage, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__() {
      return this.__onTabChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateOrderSettingsError__REACT_HOT_LOADER__',
    value: function __onUpdateOrderSettingsError__REACT_HOT_LOADER__() {
      return this.__onUpdateOrderSettingsError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateOrderSettings__REACT_HOT_LOADER__',
    value: function __onUpdateOrderSettings__REACT_HOT_LOADER__() {
      return this.__onUpdateOrderSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__loadCurrentRestaurant__REACT_HOT_LOADER__',
    value: function __loadCurrentRestaurant__REACT_HOT_LOADER__() {
      return this.__loadCurrentRestaurant__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_stores.RestaurantStore.getRestaurant().haveFeatureOrder()) {
        _actions.RouteAction.redirectToFeatureNonActivated();
        return;
      }

      if (!_utils.SecurityContext.orderSettings.canRead()) {
        _actions.RouteAction.redirectForce(_RoutingEnum2.default.ORDERS_LIST);
        return;
      }

      _stores.RestaurantStore.addListeners(this.restaurantStoreListerners);
      _stores.OrderSettingsStore.addListeners(this.orderStoreListerners);

      this.loadCurrentRestaurant();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantStore.removeListeners(this.restaurantStoreListerners);
      _stores.OrderSettingsStore.removeListeners(this.orderStoreListerners);
    }
  }, {
    key: '__loadCurrentRestaurant__REACT_HOT_LOADER__',


    //
    // events - API Restaurant
    //

    value: function __loadCurrentRestaurant__REACT_HOT_LOADER__() {
      this.showLoading();
      _actions.RestaurantAction.retrieveCurrentRestaurant();
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var restaurant = _stores.RestaurantStore.getRestaurant();

      this.setState({
        restaurant: restaurant,
        orderSettings: restaurant.orderSettings,
        loading: false
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',


    //
    // Events OrderSettings
    //

    value: function __onError__REACT_HOT_LOADER__() {}
  }, {
    key: '__onUpdateOrderSettings__REACT_HOT_LOADER__',
    value: function __onUpdateOrderSettings__REACT_HOT_LOADER__() {
      var orderSettings = _stores.OrderSettingsStore.getOrderSettings();

      // update, just in case.
      var restaurant = _stores.RestaurantStore.getRestaurant();
      restaurant.orderSettings = orderSettings;

      this.setState({
        orderSettings: orderSettings,
        restaurant: restaurant,
        loading: false
      });
    }
  }, {
    key: '__onUpdateOrderSettingsError__REACT_HOT_LOADER__',


    //
    // Tabs
    //

    value: function __onUpdateOrderSettingsError__REACT_HOT_LOADER__() {
      // const orderSettings = OrderSettingsStore.getOrderSettings();

      //  // update, just in case.
      //  const restaurant: Restaurant = RestaurantStore.getRestaurant();
      //  restaurant.orderSettings = orderSettings;

      var apiError = _stores.OrderSettingsStore.getApiError();
      this.setState({
        apiError: apiError,
        loading: false
      });
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__(activeKey) {
      if (!_lodash2.default.isUndefined(activeKey)) {
        /*
         * Update the query params.
         */
        this.onChangeQueryUrl({
          tab: activeKey
        });
      }
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onSubmit__REACT_HOT_LOADER__(orderSettings) {
      this.showLoading();
      _actions.OrderAction.updateOrderSettings(orderSettings);
    }
  }, {
    key: 'renderWarnings',
    value: function renderWarnings() {
      return _react2.default.createElement(
        'div',
        null,
        this.state.restaurant && this.state.restaurant.status === 'ARCHIVED' && _react2.default.createElement(
          'p',
          { className: 'bg-warning', style: { padding: 16, marginTop: 16 } },
          _I18n2.default.tr('restaurant_edit.configuration.statut.ARCHIVED.tip')
        )
      );
    }
  }, {
    key: 'renderGeneral',
    value: function renderGeneral() {
      return _react2.default.createElement(
        _reactBootstrap.Tab,
        {
          eventKey: OrdersSettingsPage.Tabs.GENERAL,
          title: _I18n2.default.tr('order.settings.tabs.general').toUpperCase()
        },
        this.renderWarnings(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_OrderGeneralSettingsPage2.default, {
            restaurant: this.state.restaurant,
            orderSettings: this.state.orderSettings,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }, {
    key: 'renderOpeningHours',
    value: function renderOpeningHours() {
      return _react2.default.createElement(
        _reactBootstrap.Tab,
        {
          eventKey: OrdersSettingsPage.Tabs.OPENING_HOURS,
          title: _I18n2.default.tr('order.settings.tabs.opening_hours').toUpperCase()
        },
        this.renderWarnings(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_OrderOpeningHoursSettingsPage2.default, {
            restaurant: this.state.restaurant,
            orderSettings: this.state.orderSettings,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }, {
    key: 'renderOnSite',
    value: function renderOnSite() {
      // if (!this.state.orderSettings.onSiteSettings.enabled) {
      //   return (null);
      // }

      return _react2.default.createElement(
        _reactBootstrap.Tab,
        {
          eventKey: OrdersSettingsPage.Tabs.ON_SITE,
          title: _I18n2.default.tr('order.settings.tabs.on_site').toUpperCase()
        },
        this.renderWarnings(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_OnSiteSettingsPage2.default, {
            restaurant: this.state.restaurant,
            orderSettings: this.state.orderSettings,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }, {
    key: 'renderTakeAway',
    value: function renderTakeAway() {
      // if (!this.state.orderSettings.takeAwaySettings.enabled) {
      //   return (null);
      // }

      return _react2.default.createElement(
        _reactBootstrap.Tab,
        {
          eventKey: OrdersSettingsPage.Tabs.TAKE_AWAY,
          title: _I18n2.default.tr('order.settings.tabs.take_away').toUpperCase()
        },
        this.renderWarnings(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_TakeAwaySettingsPage2.default, {
            restaurant: this.state.restaurant,
            orderSettings: this.state.orderSettings,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }, {
    key: 'renderDelivery',
    value: function renderDelivery() {
      // if (!this.state.orderSettings.deliverySettings.enabled) {
      //   return (null);
      // }

      return _react2.default.createElement(
        _reactBootstrap.Tab,
        {
          eventKey: OrdersSettingsPage.Tabs.DELIVERY,
          title: _I18n2.default.tr('order.settings.tabs.delivery').toUpperCase()
        },
        this.renderWarnings(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_DeliverySettingsPage2.default, {
            restaurant: this.state.restaurant,
            orderSettings: this.state.orderSettings,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }, {
    key: 'renderKiosk',
    value: function renderKiosk() {
      return _react2.default.createElement(
        _reactBootstrap.Tab,
        {
          eventKey: OrdersSettingsPage.Tabs.KIOSK,
          title: _I18n2.default.tr('order.settings.tabs.kiosk').toUpperCase()
        },
        this.renderWarnings(),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-30' },
          _react2.default.createElement(_KioskSettingsPage2.default, {
            restaurant: this.state.restaurant,
            orderSettings: this.state.orderSettings,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (_lodash2.default.isNull(this.state.restaurant)) {
        return this.renderOnLoadingContent();
      }

      return _react2.default.createElement(
        _reactBootstrap.Tabs,
        {
          defaultActiveKey: this.defaultTabKey,
          id: 'order_settings__tabs',
          onSelect: this.onTabChange
        },
        this.renderGeneral(),
        this.renderOpeningHours(),
        this.renderKiosk(),
        this.renderOnSite(),
        this.renderTakeAway(),
        this.renderDelivery()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'order_settings_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        this.renderLoading(),
        _react2.default.createElement(_ApiErrorView2.default, { apiError: this.state.apiError }),
        this.renderBody()
      );
    }
  }, {
    key: 'restaurantStoreListerners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.LOAD_RESTAURANT_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.UPDATE_RESTAURANT_SUCCESS, this.onChange), new _Listener2.default(_Events2.default.LOAD_RESTAURANT_FAILURE, this.onError)];
    }
  }, {
    key: 'orderStoreListerners',
    get: function get() {
      return [new _Listener2.default(_Events2.default.ON_UPDATE_ORDER_SETTINGS_SUCCESS, this.onUpdateOrderSettings), new _Listener2.default(_Events2.default.ON_UPDATE_ORDER_SETTINGS_FAILURE, this.onUpdateOrderSettingsError)];
    }
  }, {
    key: 'defaultTabKey',
    get: function get() {
      if (!_lodash2.default.isNull(this.props.location.query)) {
        var tabQuery = this.props.location.query.tab;
        return tabQuery;
      }

      return null;
    }

    //
    // events
    //

  }]);

  return OrdersSettingsPage;
}(_AbstractComponent3.default);

OrdersSettingsPage.Tabs = {
  GENERAL: 'general',
  OPENING_HOURS: 'opening-hours',
  KIOSK: 'kiosk',
  ON_SITE: 'on-site',
  TAKE_AWAY: 'take-away',
  DELIVERY: 'delivery'
};
exports.default = OrdersSettingsPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrdersSettingsPage, 'OrdersSettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/OrderSettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

var _utils = __webpack_require__("./scripts/utils/index.js");

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AbstractOrderSettingsForm = function (_AbstractFormComponen) {
  _inherits(AbstractOrderSettingsForm, _AbstractFormComponen);

  function AbstractOrderSettingsForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractOrderSettingsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractOrderSettingsForm.__proto__ || Object.getPrototypeOf(AbstractOrderSettingsForm)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeOrderSettings = function () {
      var _this2;

      return (_this2 = _this).__onChangeOrderSettings__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onReset = function () {
      var _this3;

      return (_this3 = _this).__onReset__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSubmit = function () {
      var _this4;

      return (_this4 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onPaymentMethodsChange = function () {
      var _this5;

      return (_this5 = _this).__onPaymentMethodsChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AbstractOrderSettingsForm, [{
    key: '__onPaymentMethodsChange__REACT_HOT_LOADER__',
    value: function __onPaymentMethodsChange__REACT_HOT_LOADER__() {
      return this.__onPaymentMethodsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOrderSettings__REACT_HOT_LOADER__',
    value: function __onChangeOrderSettings__REACT_HOT_LOADER__() {
      return this.__onChangeOrderSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.orderSettings.equals(nextProps.orderSettings)) {
        // orderSettings have changed, we reset the form.
        this.setState(this.getDefaultState(nextProps.orderSettings));
      }
    }
  }, {
    key: 'canReadSettings',
    value: function canReadSettings() {
      return _utils.SecurityContext.orderSettings.canRead();
    }
  }, {
    key: 'canEditSettings',
    value: function canEditSettings() {
      return _utils.SecurityContext.orderSettings.canEdit();
    }

    // -- events

  }, {
    key: '__onChangeOrderSettings__REACT_HOT_LOADER__',
    value: function __onChangeOrderSettings__REACT_HOT_LOADER__(orderSettings) {
      this.setState({
        orderSettings: orderSettings
      });
    }
  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState(this.getDefaultState(this.props.orderSettings));
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(orderSettings) {
      return {
        orderSettings: orderSettings.copy()
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !this.props.orderSettings.equals(this.orderSettings);
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return !this.canEditSettings();
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    /**
     * TODO: refactor with bitfield when it will be implemented on API
     * TODO: if number of payment methods increase, we need to review
     *       the way to define the default one
     */
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      if (this.canEditSettings()) {
        this.props.onSubmit(this.orderSettings);
      }
    }
  }, {
    key: '__onPaymentMethodsChange__REACT_HOT_LOADER__',
    value: function __onPaymentMethodsChange__REACT_HOT_LOADER__(value, modeSettings) {
      if (modeSettings.havePaymentMethodAllowed(value)) {
        modeSettings.paymentMethodsAllowed -= value;
      } else {
        modeSettings.paymentMethodsAllowed += value;
      }

      if (modeSettings.paymentMethodsAllowed === 0) {
        modeSettings.paymentMethodsAllowed = value == _ApiConstants2.default.OrderPaymentMethodsAllowed.IRL ? _ApiConstants2.default.OrderPaymentMethodsAllowed.CREDIT_CARD : _ApiConstants2.default.OrderPaymentMethodsAllowed.IRL;
      }

      this.onChangeOrderSettings(this.orderSettings);
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.props.restaurant;
    }
  }, {
    key: 'orderSettings',
    get: function get() {
      return this.state.orderSettings;
    }
  }]);

  return AbstractOrderSettingsForm;
}(_AbstractFormComponent2.default);

exports.default = AbstractOrderSettingsForm;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AbstractOrderSettingsForm, 'AbstractOrderSettingsForm', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/components/AbstractOrderSettingsForm.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/components/OrderGeneralSettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _utils = __webpack_require__("./scripts/utils/index.js");

var _AbstractOrderSettingsForm = __webpack_require__("./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js");

var _AbstractOrderSettingsForm2 = _interopRequireDefault(_AbstractOrderSettingsForm);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _OrderNotificationSettingsView = __webpack_require__("./scripts/pages/order/settings/components/OrderNotificationSettingsView.js");

var _OrderNotificationSettingsView2 = _interopRequireDefault(_OrderNotificationSettingsView);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var OrderGeneralSettingsPage = function (_AbstractOrderSetting) {
  _inherits(OrderGeneralSettingsPage, _AbstractOrderSetting);

  function OrderGeneralSettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderGeneralSettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderGeneralSettingsPage.__proto__ || Object.getPrototypeOf(OrderGeneralSettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.orderSettings), _this.onChangeOrderSettings = function () {
      var _this2;

      return (_this2 = _this).__onChangeOrderSettings__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onOnSiteEnabledChange = function () {
      var _this3;

      return (_this3 = _this).__onOnSiteEnabledChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onTakeAwayEnabledChange = function () {
      var _this4;

      return (_this4 = _this).__onTakeAwayEnabledChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onDeliveryEnabledChange = function () {
      var _this5;

      return (_this5 = _this).__onDeliveryEnabledChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onMenuManagedByPosChange = function () {
      var _this6;

      return (_this6 = _this).__onMenuManagedByPosChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(OrderGeneralSettingsPage, [{
    key: '__onMenuManagedByPosChange__REACT_HOT_LOADER__',
    value: function __onMenuManagedByPosChange__REACT_HOT_LOADER__() {
      return this.__onMenuManagedByPosChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeliveryEnabledChange__REACT_HOT_LOADER__',
    value: function __onDeliveryEnabledChange__REACT_HOT_LOADER__() {
      return this.__onDeliveryEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTakeAwayEnabledChange__REACT_HOT_LOADER__',
    value: function __onTakeAwayEnabledChange__REACT_HOT_LOADER__() {
      return this.__onTakeAwayEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOnSiteEnabledChange__REACT_HOT_LOADER__',
    value: function __onOnSiteEnabledChange__REACT_HOT_LOADER__() {
      return this.__onOnSiteEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOrderSettings__REACT_HOT_LOADER__',
    value: function __onChangeOrderSettings__REACT_HOT_LOADER__() {
      return this.__onChangeOrderSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOrderSettings__REACT_HOT_LOADER__',
    value: function __onChangeOrderSettings__REACT_HOT_LOADER__(orderSettings) {
      this.setState({
        orderSettings: orderSettings
      });
    }
  }, {
    key: '__onOnSiteEnabledChange__REACT_HOT_LOADER__',
    value: function __onOnSiteEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.enabled = !orderSettings.onSiteSettings.enabled;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onTakeAwayEnabledChange__REACT_HOT_LOADER__',
    value: function __onTakeAwayEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.takeAwaySettings.enabled = !orderSettings.takeAwaySettings.enabled;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onDeliveryEnabledChange__REACT_HOT_LOADER__',
    value: function __onDeliveryEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.deliverySettings.enabled = !orderSettings.deliverySettings.enabled;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onMenuManagedByPosChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onMenuManagedByPosChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.menuManagedByPos = !orderSettings.menuManagedByPos;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: 'renderGeneral',
    value: function renderGeneral() {
      return _react2.default.createElement('div', { className: 'top-buffer-50' });
    }
  }, {
    key: 'renderOnSite',
    value: function renderOnSite() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.general.on_site')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.onSiteSettings.enabled,
            onChange: this.onOnSiteEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderTakeAway',
    value: function renderTakeAway() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.general.take_away')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.takeAwaySettings.enabled,
            onChange: this.onTakeAwayEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderDelivery',
    value: function renderDelivery() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.general.delivery')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.deliverySettings.enabled,
            onChange: this.onDeliveryEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderModes',
    value: function renderModes() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('order.settings.general.order_modes')
        ),
        this.renderOnSite(),
        this.renderTakeAway(),
        this.renderDelivery(),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('hr', null)
      );
    }
  }, {
    key: 'renderNotificationsSettings',
    value: function renderNotificationsSettings() {
      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50' },
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('order.settings.general.notifications')
        ),
        _react2.default.createElement(_OrderNotificationSettingsView2.default, {
          orderSettings: this.orderSettings,
          onChange: this.onChangeOrderSettings,
          readOnly: !this.canEditSettings()
        })
      );
    }
  }, {
    key: 'renderMenuManagedByPos',
    value: function renderMenuManagedByPos() {
      if (!_utils.SecurityContext.orderSettings.canEditMenuManagedByPos()) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50' },
        _react2.default.createElement(
          'h3',
          null,
          _I18n2.default.tr('order.settings.general.menu_managed_by_pos')
        ),
        _react2.default.createElement(
          _FormGroupView2.default,
          null,
          _react2.default.createElement(
            _FormGroupView2.default.Label,
            null,
            _I18n2.default.tr('order.settings.general.menu_managed_by_pos')
          ),
          _react2.default.createElement(
            _FormGroupView2.default.Content,
            null,
            _react2.default.createElement(_reactBootstrapSwitch2.default, {
              bsSize: 'mini',
              value: this.orderSettings.menuManagedByPos,
              onChange: this.onMenuManagedByPosChange
              // TODO:
              , disabled: !_utils.SecurityContext.orderSettings.canEditMenuManagedByPos()
            })
          )
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true },
        this.renderGeneral(),
        this.renderModes(),
        this.renderNotificationsSettings(),
        this.renderMenuManagedByPos(),
        this.renderFixedButtons()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          null,
          this.renderBody()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return OrderGeneralSettingsPage;
}(_AbstractOrderSettingsForm2.default);

OrderGeneralSettingsPage.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant),

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings),

  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = OrderGeneralSettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderGeneralSettingsPage, 'OrderGeneralSettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/components/OrderGeneralSettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/components/OrderNotificationSettingsView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- components


var OrderNotificationSettingsView = function (_Component) {
  _inherits(OrderNotificationSettingsView, _Component);

  function OrderNotificationSettingsView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderNotificationSettingsView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderNotificationSettingsView.__proto__ || Object.getPrototypeOf(OrderNotificationSettingsView)).call.apply(_ref, [this].concat(args))), _this), _this.onTogglePhoneNotification = function () {
      var _this2;

      return (_this2 = _this).__onTogglePhoneNotification__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onToggleEmailNotification = function () {
      var _this3;

      return (_this3 = _this).__onToggleEmailNotification__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onNotificationSettingsPhonesChange = function () {
      var _this4;

      return (_this4 = _this).__onNotificationSettingsPhonesChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onEmailsChange = function () {
      var _this5;

      return (_this5 = _this).__onEmailsChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //  events
  //

  _createClass(OrderNotificationSettingsView, [{
    key: '__onEmailsChange__REACT_HOT_LOADER__',
    value: function __onEmailsChange__REACT_HOT_LOADER__() {
      return this.__onEmailsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNotificationSettingsPhonesChange__REACT_HOT_LOADER__',
    value: function __onNotificationSettingsPhonesChange__REACT_HOT_LOADER__() {
      return this.__onNotificationSettingsPhonesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onToggleEmailNotification__REACT_HOT_LOADER__',
    value: function __onToggleEmailNotification__REACT_HOT_LOADER__() {
      return this.__onToggleEmailNotification__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTogglePhoneNotification__REACT_HOT_LOADER__',
    value: function __onTogglePhoneNotification__REACT_HOT_LOADER__() {
      return this.__onTogglePhoneNotification__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTogglePhoneNotification__REACT_HOT_LOADER__',
    value: function __onTogglePhoneNotification__REACT_HOT_LOADER__() {
      var orderSettings = this.props.orderSettings;
      orderSettings.notificationSettings.phoneEnabled = !orderSettings.notificationSettings.phoneEnabled;
      this.props.onChange(orderSettings);
    }
  }, {
    key: '__onToggleEmailNotification__REACT_HOT_LOADER__',
    value: function __onToggleEmailNotification__REACT_HOT_LOADER__() {
      var orderSettings = this.props.orderSettings;
      orderSettings.notificationSettings.emailEnabled = !orderSettings.notificationSettings.emailEnabled;
      this.props.onChange(orderSettings);
    }
  }, {
    key: '__onNotificationSettingsPhonesChange__REACT_HOT_LOADER__',
    value: function __onNotificationSettingsPhonesChange__REACT_HOT_LOADER__(phonesList) {
      var orderSettings = this.props.orderSettings;
      orderSettings.notificationSettings.phones = phonesList;
      this.props.onChange(orderSettings);
    }
  }, {
    key: '__onEmailsChange__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onEmailsChange__REACT_HOT_LOADER__(emailsList) {
      var orderSettings = this.props.orderSettings;
      orderSettings.notificationSettings.emails = emailsList;
      this.props.onChange(orderSettings);
    }
  }, {
    key: 'renderNotificationsSettings',
    value: function renderNotificationsSettings() {
      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-20' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'p',
              null,
              _I18n2.default.tr('order.settings.notifications.sms_email'),
              _react2.default.createElement(_TipTooltip2.default, {
                text: _I18n2.default.tr('order.settings.notifications.sms_email_tooltip')
              })
            )
          )
        ),
        _SecurityContext2.default.admin.isAdmin() && _react2.default.createElement(
          'div',
          { className: 'row top-buffer-20' },
          _react2.default.createElement(
            'div',
            { className: 'row col-sm-offset-2 col-xs-12 col-sm-4' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                'p',
                null,
                _I18n2.default.tr('global.sms')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-2' },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                key: this.props.orderSettings.notificationSettings.phoneEnabled + '_' + Math.random(),
                bsSize: 'mini',
                value: this.props.orderSettings.notificationSettings.phoneEnabled,
                onChange: this.onTogglePhoneNotification,
                disabled: this.props.readOnly
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-lg-3' },
            _react2.default.createElement(_form.PhonesList, {
              list: this.props.orderSettings.notificationSettings.phones,
              onChange: this.onNotificationSettingsPhonesChange,
              disabled: this.props.readOnly
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row top-buffer-20' },
          _react2.default.createElement(
            'div',
            { className: 'row col-sm-offset-2 col-xs-12 col-sm-4' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                'p',
                null,
                _I18n2.default.tr('global.email')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-2' },
              _react2.default.createElement(_reactBootstrapSwitch2.default, {
                key: this.props.orderSettings.notificationSettings.emailEnabled + '_' + Math.random(),
                bsSize: 'mini',
                value: this.props.orderSettings.notificationSettings.emailEnabled,
                onChange: this.onToggleEmailNotification,
                disabled: this.props.readOnly
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-lg-3' },
            _react2.default.createElement(_form.EmailsList, {
              list: this.props.orderSettings.notificationSettings.emails,
              onChange: this.onEmailsChange,
              disabled: this.props.readOnly
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: '' },
          this.renderNotificationsSettings()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return OrderNotificationSettingsView;
}(_react.Component);

OrderNotificationSettingsView.propTypes = {
  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  /**
   * @param OrderSettings
   */
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = OrderNotificationSettingsView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderNotificationSettingsView, 'OrderNotificationSettingsView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/components/OrderNotificationSettingsView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/components/OrderOpeningHoursSettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractOrderSettingsForm = __webpack_require__("./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js");

var _AbstractOrderSettingsForm2 = _interopRequireDefault(_AbstractOrderSettingsForm);

var _OpeningHoursForDay = __webpack_require__("./scripts/components/openingHours/OpeningHoursForDay.js");

var _OpeningHoursForDay2 = _interopRequireDefault(_OpeningHoursForDay);

var _AddOpeningHourModal = __webpack_require__("./scripts/components/openingHours/AddOpeningHourModal.js");

var _AddOpeningHourModal2 = _interopRequireDefault(_AddOpeningHourModal);

var _OpeningHoursForm = __webpack_require__("./scripts/components/openingHours/OpeningHoursForm.js");

var _OpeningHoursForm2 = _interopRequireDefault(_OpeningHoursForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var OrderGeneralSettingsPage = function (_AbstractOrderSetting) {
  _inherits(OrderGeneralSettingsPage, _AbstractOrderSetting);

  function OrderGeneralSettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderGeneralSettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderGeneralSettingsPage.__proto__ || Object.getPrototypeOf(OrderGeneralSettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.orderSettings), _this.onOpeningHoursChange = function () {
      var _this2;

      return (_this2 = _this).__onOpeningHoursChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  // events opening hours
  //

  _createClass(OrderGeneralSettingsPage, [{
    key: '__onOpeningHoursChange__REACT_HOT_LOADER__',
    value: function __onOpeningHoursChange__REACT_HOT_LOADER__() {
      return this.__onOpeningHoursChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOpeningHoursChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onOpeningHoursChange__REACT_HOT_LOADER__(openingHours) {
      var orderSettings = this.orderSettings;

      orderSettings.openingHours = openingHours;

      this.setState({
        orderSettings: orderSettings
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var openingsHours = this.orderSettings.openingHours;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_OpeningHoursForm2.default, {
          openingHours: openingsHours,
          onChange: this.onOpeningHoursChange,
          readOnly: !this.canEditSettings()
        }),
        this.renderFixedButtons()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          null,
          this.renderBody()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return OrderGeneralSettingsPage;
}(_AbstractOrderSettingsForm2.default);

OrderGeneralSettingsPage.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant),

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings),

  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = OrderGeneralSettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderGeneralSettingsPage, 'OrderGeneralSettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/components/OrderOpeningHoursSettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/kiosk/KioskSettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ViewConstants = __webpack_require__("./sdk/scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _KioskAction = __webpack_require__("./scripts/actions/KioskAction.js");

var _KioskAction2 = _interopRequireDefault(_KioskAction);

var _KioskSettingsStore = __webpack_require__("./scripts/stores/KioskSettingsStore.js");

var _KioskSettingsStore2 = _interopRequireDefault(_KioskSettingsStore);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _KioskSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskSettings.js");

var _KioskSettings2 = _interopRequireDefault(_KioskSettings);

var _RestaurantRoom = __webpack_require__("./sdk/scripts/entities/restaurant/RestaurantRoom.js");

var _RestaurantRoom2 = _interopRequireDefault(_RestaurantRoom);

var _KioskOrderTicketSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskOrderTicketSettings.js");

var _KioskOrderTicketSettings2 = _interopRequireDefault(_KioskOrderTicketSettings);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _AbstractOrderSettingsForm = __webpack_require__("./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js");

var _AbstractOrderSettingsForm2 = _interopRequireDefault(_AbstractOrderSettingsForm);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _ImageDropzone = __webpack_require__("./sdk/scripts/components/form/ImageDropzone.js");

var _ImageDropzone2 = _interopRequireDefault(_ImageDropzone);

var _KioskTicketView = __webpack_require__("./scripts/pages/order/settings/kiosk/KioskTicketView.js");

var _KioskTicketView2 = _interopRequireDefault(_KioskTicketView);

var _IrlPaymentAllowedView = __webpack_require__("./scripts/pages/order/settings/modes/components/IrlPaymentAllowedView.js");

var _IrlPaymentAllowedView2 = _interopRequireDefault(_IrlPaymentAllowedView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var KioskSettingsPage = function (_AbstractOrderSetting) {
  _inherits(KioskSettingsPage, _AbstractOrderSetting);

  function KioskSettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KioskSettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KioskSettingsPage.__proto__ || Object.getPrototypeOf(KioskSettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.orderSettings), _this.onStateChange = function () {
      var _this2;

      return (_this2 = _this).__onStateChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onSubmit = function () {
      var _this3;

      return (_this3 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onChangeOrderSettings = function () {
      var _this4;

      return (_this4 = _this).__onChangeOrderSettings__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onBackgroundImageChange = function () {
      var _this5;

      return (_this5 = _this).__onBackgroundImageChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onAdvertisingImageChange = function () {
      var _this6;

      return (_this6 = _this).__onAdvertisingImageChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onOrderModesChange = function () {
      var _this7;

      return (_this7 = _this).__onOrderModesChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onLanguagesChange = function () {
      var _this8;

      return (_this8 = _this).__onLanguagesChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onServiceAtTableEnabledChange = function () {
      var _this9;

      return (_this9 = _this).__onServiceAtTableEnabledChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onIrlPaymentAllowedChange = function () {
      var _this10;

      return (_this10 = _this).__onIrlPaymentAllowedChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onRoomsChange = function () {
      var _this11;

      return (_this11 = _this).__onRoomsChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onTicketSettingsChange = function () {
      var _this12;

      return (_this12 = _this).__onTicketSettingsChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KioskSettingsPage, [{
    key: '__onTicketSettingsChange__REACT_HOT_LOADER__',
    value: function __onTicketSettingsChange__REACT_HOT_LOADER__() {
      return this.__onTicketSettingsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRoomsChange__REACT_HOT_LOADER__',
    value: function __onRoomsChange__REACT_HOT_LOADER__() {
      return this.__onRoomsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onIrlPaymentAllowedChange__REACT_HOT_LOADER__',
    value: function __onIrlPaymentAllowedChange__REACT_HOT_LOADER__() {
      return this.__onIrlPaymentAllowedChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onServiceAtTableEnabledChange__REACT_HOT_LOADER__',
    value: function __onServiceAtTableEnabledChange__REACT_HOT_LOADER__() {
      return this.__onServiceAtTableEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLanguagesChange__REACT_HOT_LOADER__',
    value: function __onLanguagesChange__REACT_HOT_LOADER__() {
      return this.__onLanguagesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOrderModesChange__REACT_HOT_LOADER__',
    value: function __onOrderModesChange__REACT_HOT_LOADER__() {
      return this.__onOrderModesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAdvertisingImageChange__REACT_HOT_LOADER__',
    value: function __onAdvertisingImageChange__REACT_HOT_LOADER__() {
      return this.__onAdvertisingImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onBackgroundImageChange__REACT_HOT_LOADER__',
    value: function __onBackgroundImageChange__REACT_HOT_LOADER__() {
      return this.__onBackgroundImageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOrderSettings__REACT_HOT_LOADER__',
    value: function __onChangeOrderSettings__REACT_HOT_LOADER__() {
      return this.__onChangeOrderSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onStateChange__REACT_HOT_LOADER__',
    value: function __onStateChange__REACT_HOT_LOADER__() {
      return this.__onStateChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _KioskSettingsStore2.default.addListener(this.onStateChange);

      this.loadSettings();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _KioskSettingsStore2.default.removeListener(this.onStateChange);
    }
  }, {
    key: 'loadSettings',
    value: function loadSettings() {
      this.setState({
        loading: true
      }, function () {
        _KioskAction2.default.loadSettings();
      });
    }

    //
    //
    //

  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      return !(this.defaultKioskSettings.equals(this.kioskSettings) && _lodash2.default.isNull(this.state.backgroundImage) && _lodash2.default.isNull(this.state.advertisingImage));
    }

    //
    //
    //

  }, {
    key: 'getDefaultState',
    value: function getDefaultState(orderSettings) {
      return {
        orderSettings: orderSettings.copy(),
        kioskSettings: this.defaultKioskSettings,
        backgroundImage: null,
        advertisingImage: null
      };
    }
  }, {
    key: 'isReadOnly',
    value: function isReadOnly() {
      return !_SecurityContext2.default.orderSettings.canEdit();
    }

    //
    //
    //

  }, {
    key: '__onStateChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onStateChange__REACT_HOT_LOADER__() {
      this.setState({
        kioskSettings: _KioskSettingsStore2.default.getSettings(),
        apiError: _KioskSettingsStore2.default.getApiError(),
        loading: false
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      var _this13 = this;

      if (!this.canEditSettings()) {
        return;
      }

      var backgroundImageData = !_lodash2.default.isNull(this.state.backgroundImage) ? _ViewUtils2.default.dataUriToFile(this.state.backgroundImage) : null;

      var advertisingImageData = !_lodash2.default.isNull(this.state.advertisingImage) ? _ViewUtils2.default.dataUriToFile(this.state.advertisingImage) : null;

      var files = {
        'background-image': backgroundImageData,
        'advertising-image': advertisingImageData
      };

      this.setState({
        loading: true
      }, function () {
        _KioskAction2.default.updateSettings(_this13.kioskSettings, files);
      });
    }
  }, {
    key: '__onChangeOrderSettings__REACT_HOT_LOADER__',
    value: function __onChangeOrderSettings__REACT_HOT_LOADER__(orderSettings) {
      this.setState({
        orderSettings: orderSettings
      });
    }
  }, {
    key: '__onBackgroundImageChange__REACT_HOT_LOADER__',
    value: function __onBackgroundImageChange__REACT_HOT_LOADER__(backgroundImage) {
      this.setState({
        backgroundImage: backgroundImage
      });
    }
  }, {
    key: '__onAdvertisingImageChange__REACT_HOT_LOADER__',
    value: function __onAdvertisingImageChange__REACT_HOT_LOADER__(advertisingImage) {
      this.setState({
        advertisingImage: advertisingImage
      });
    }
  }, {
    key: '__onOrderModesChange__REACT_HOT_LOADER__',
    value: function __onOrderModesChange__REACT_HOT_LOADER__(modes) {
      var kioskSettings = this.state.kioskSettings;

      kioskSettings.order.modes = modes;

      this.setState({
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: '__onLanguagesChange__REACT_HOT_LOADER__',
    value: function __onLanguagesChange__REACT_HOT_LOADER__(locales) {
      var kioskSettings = this.state.kioskSettings;

      kioskSettings.order.locales = locales;

      this.setState({
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: '__onServiceAtTableEnabledChange__REACT_HOT_LOADER__',
    value: function __onServiceAtTableEnabledChange__REACT_HOT_LOADER__() {
      var kioskSettings = this.state.kioskSettings;

      kioskSettings.order.serviceAtTableEnabled = !kioskSettings.order.serviceAtTableEnabled;

      this.setState({
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: '__onIrlPaymentAllowedChange__REACT_HOT_LOADER__',
    value: function __onIrlPaymentAllowedChange__REACT_HOT_LOADER__() {
      var kioskSettings = this.state.kioskSettings;

      kioskSettings.order.irlPaymentAllowed = !kioskSettings.order.irlPaymentAllowed;

      this.setState({
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: '__onRoomsChange__REACT_HOT_LOADER__',
    value: function __onRoomsChange__REACT_HOT_LOADER__(roomsOptions) {
      var kioskSettings = this.state.kioskSettings;

      var rooms = roomsOptions.map(function (option) {
        var room = void 0;
        if (!_lodash2.default.isNull(option.value)) {
          room = option.value;
        } else {
          // create a new room.
          room = new _RestaurantRoom2.default();
          room.id = _Utils2.default.generateUID();
        }
        room.name = option.label;
        return room;
      });

      kioskSettings.order.rooms = rooms;

      this.setState({
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: '__onTicketSettingsChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onTicketSettingsChange__REACT_HOT_LOADER__(ticketSettings) {
      var kioskSettings = this.state.kioskSettings;

      kioskSettings.order.ticketSettings = ticketSettings;

      this.setState({
        kioskSettings: kioskSettings
      });
    }
  }, {
    key: 'renderBackgroundImage',
    value: function renderBackgroundImage() {
      var placeholder = _lodash2.default.isEmpty(this.kioskSettings.order.backgroundImage) ? null : this.kioskSettings.order.backgroundImage;

      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.background')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_ImageDropzone2.default, {
            placeholder: placeholder,
            image: this.state.backgroundImage,
            onChange: this.onBackgroundImageChange,
            aspectRatio: _ApiConstants2.default.Kiosk.Order.BackgroundImage.RATIO,
            width: _ApiConstants2.default.Kiosk.Order.BackgroundImage.WIDTH,
            height: _ApiConstants2.default.Kiosk.Order.BackgroundImage.HEIGHT,
            maxSize: _ApiConstants2.default.Kiosk.Order.BackgroundImage.MAX_SIZE,
            readOnly: this.isReadOnly()
          })
        )
      );
    }
  }, {
    key: 'renderAdvertisingImage',
    value: function renderAdvertisingImage() {
      var placeholder = _lodash2.default.isEmpty(this.kioskSettings.order.advertisingImage) ? null : this.kioskSettings.order.advertisingImage;

      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.advertising')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_ImageDropzone2.default, {
            placeholder: placeholder,
            image: this.state.advertisingImage,
            onChange: this.onAdvertisingImageChange,
            aspectRatio: _ApiConstants2.default.Kiosk.Order.AdvertisingImage.RATIO,
            width: _ApiConstants2.default.Kiosk.Order.AdvertisingImage.WIDTH,
            height: _ApiConstants2.default.Kiosk.Order.AdvertisingImage.HEIGHT,
            maxSize: _ApiConstants2.default.Kiosk.Order.AdvertisingImage.MAX_SIZE,
            readOnly: this.isReadOnly()
          })
        )
      );
    }
  }, {
    key: 'renderOrderModes',
    value: function renderOrderModes() {
      var modes = [_order.Order.OrderMode.ON_SITE, _order.Order.OrderMode.TAKE_AWAY];

      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.modes')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_form.OrderModeChooser, {
            modes: modes,
            readOnly: this.isReadOnly(),
            multi: true,
            onChange: this.onOrderModesChange,
            values: this.state.kioskSettings.order.modes
          })
        )
      );
    }
  }, {
    key: 'renderLanguages',
    value: function renderLanguages() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.languages')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_form.LocaleChooser, {
            locales: _constants.Constants.localesForTranslation.map(function (l) {
              return l.locale.replace('-', '_');
            }).filter(function (s) {
              return _ViewConstants2.default.KIOSK_ORDER_LOCALES().includes(s);
            }),
            readOnly: this.isReadOnly(),
            multi: true,
            onChange: this.onLanguagesChange,
            values: this.state.kioskSettings.order.locales
          })
        )
      );
    }
  }, {
    key: 'renderIrlPaymentAllowed',
    value: function renderIrlPaymentAllowed() {
      return _react2.default.createElement(_IrlPaymentAllowedView2.default, {
        enabled: this.state.kioskSettings.order.irlPaymentAllowed,
        onChange: this.onIrlPaymentAllowedChange,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderServiceAtTableEnabled',
    value: function renderServiceAtTableEnabled() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.service_at_table_enabled')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            disabled: this.isReadOnly(),
            onChange: this.onServiceAtTableEnabledChange,
            value: this.kioskSettings.order.serviceAtTableEnabled
          })
        )
      );
    }
  }, {
    key: 'renderRooms',
    value: function renderRooms() {
      // TODO: user rooms service
      var list = this.state.kioskSettings.order.rooms.map(function (room) {
        return {
          label: room.name,
          value: room
        };
      });
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.rooms')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_form.OptionsList, {
            list: list,
            onChange: this.onRoomsChange,
            addLabel: _I18n2.default.tr('global.add'),
            max: 2,
            maxChars: _RestaurantRoom2.default.NAME_MAX_LENGTH
          })
        )
      );
    }
  }, {
    key: 'renderTicket',
    value: function renderTicket() {
      return _react2.default.createElement(_KioskTicketView2.default, {
        restaurant: this.props.restaurant,
        orderSettings: this.state.orderSettings,
        ticketSettings: this.state.kioskSettings.order.ticketSettings,
        onChange: this.onTicketSettingsChange,
        readOnly: this.isReadOnly()
      });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true },
        this.renderBackgroundImage(),
        this.renderAdvertisingImage(),
        this.renderOrderModes(),
        this.renderLanguages(),
        this.renderIrlPaymentAllowed(),
        this.renderServiceAtTableEnabled(),
        this.renderTicket(),
        this.renderFixedButtons()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        if (this.state.loading || _lodash2.default.isNull(this.state.kioskSettings)) {
          return this.renderLoading();
        }
        return this.renderBody();
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'defaultKioskSettings',
    get: function get() {
      return _KioskSettingsStore2.default.getSettings();
    }
  }, {
    key: 'kioskSettings',
    get: function get() {
      return this.state.kioskSettings;
    }
  }]);

  return KioskSettingsPage;
}(_AbstractOrderSettingsForm2.default);

KioskSettingsPage.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant),

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings),

  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = KioskSettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(KioskSettingsPage, 'KioskSettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/kiosk/KioskSettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/kiosk/KioskTicketView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _KioskOrderTicketSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskOrderTicketSettings.js");

var _KioskOrderTicketSettings2 = _interopRequireDefault(_KioskOrderTicketSettings);

var _TextareaInput = __webpack_require__("./sdk/scripts/components/form/TextareaInput.js");

var _TextareaInput2 = _interopRequireDefault(_TextareaInput);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var KioskTicketView = function (_Component) {
  _inherits(KioskTicketView, _Component);

  function KioskTicketView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KioskTicketView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KioskTicketView.__proto__ || Object.getPrototypeOf(KioskTicketView)).call.apply(_ref, [this].concat(args))), _this), _this.parseCustomTextLines = function () {
      var _this2;

      return (_this2 = _this).__parseCustomTextLines__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onCustomTextChange = function () {
      var _this3;

      return (_this3 = _this).__onCustomTextChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(KioskTicketView, [{
    key: '__onCustomTextChange__REACT_HOT_LOADER__',
    value: function __onCustomTextChange__REACT_HOT_LOADER__() {
      return this.__onCustomTextChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__parseCustomTextLines__REACT_HOT_LOADER__',
    value: function __parseCustomTextLines__REACT_HOT_LOADER__() {
      return this.__parseCustomTextLines__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__parseCustomTextLines__REACT_HOT_LOADER__',
    value: function __parseCustomTextLines__REACT_HOT_LOADER__(lines) {
      var _this4 = this;

      _lodash2.default.forEach(lines, function (line, i) {
        if (line.length > 40) {
          lines[i] = line.substr(0, 40);
          lines.splice(i + 1, 0, line.substr(40));
          lines = _this4.parseCustomTextLines(lines);
        } else {
          lines[i] = line;
        }
      });

      return lines;
    }
  }, {
    key: '__onCustomTextChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onCustomTextChange__REACT_HOT_LOADER__(customText) {
      var ticketSettings = this.props.ticketSettings;
      var lines = customText.split("\n");

      lines = this.parseCustomTextLines(lines);
      customText = lines.join("\n");
      ticketSettings.customText = customText;

      this.props.onChange(ticketSettings);
    }
  }, {
    key: 'renderTicketCustomText',
    value: function renderTicketCustomText() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.ticket.custom_label'),
          _react2.default.createElement(_TipTooltip2.default, {
            text: _I18n2.default.tr('order.settings.kiosk.ticket.custom_label.tooltip')
          })
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_TextareaInput2.default, {
            rows: 10,
            onChange: this.onCustomTextChange,
            value: this.props.ticketSettings.customText,
            readOnly: this.props.readOnly,
            max: _KioskOrderTicketSettings2.default.CUSTOM_TEXT_MAX_LENGTH
          })
        )
      );
    }
  }, {
    key: 'renderTicketLabels',
    value: function renderTicketLabels() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.kiosk.ticket.custom_field.label')
        ),
        _react2.default.createElement(_FormGroupView2.default.Content, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            {
              className: 'text-center'
            },
            _I18n2.default.tr('order.settings.kiosk.ticket.title')
          ),
          this.renderTicketCustomText()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return KioskTicketView;
}(_react.Component);

KioskTicketView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant).isRequired,

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  ticketSettings: _propTypes2.default.objectOf(_KioskOrderTicketSettings2.default).isRequired,

  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = KioskTicketView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(KioskTicketView, 'KioskTicketView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/kiosk/KioskTicketView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/DeliverySettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractOrderSettingsForm = __webpack_require__("./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js");

var _AbstractOrderSettingsForm2 = _interopRequireDefault(_AbstractOrderSettingsForm);

var _NumberOfDaysToProposeView = __webpack_require__("./scripts/pages/order/settings/modes/components/NumberOfDaysToProposeView.js");

var _NumberOfDaysToProposeView2 = _interopRequireDefault(_NumberOfDaysToProposeView);

var _PaymentModesView = __webpack_require__("./scripts/pages/order/settings/modes/components/PaymentModesView.js");

var _PaymentModesView2 = _interopRequireDefault(_PaymentModesView);

var _PaymentMethodsAllowed = __webpack_require__("./scripts/pages/order/settings/modes/components/PaymentMethodsAllowed.js");

var _PaymentMethodsAllowed2 = _interopRequireDefault(_PaymentMethodsAllowed);

var _DeliveryRangeMap = __webpack_require__("./scripts/pages/order/settings/modes/components/maps/DeliveryRangeMap.js");

var _DeliveryRangeMap2 = _interopRequireDefault(_DeliveryRangeMap);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _NumberInput = __webpack_require__("./sdk/scripts/components/form/NumberInput.js");

var _NumberInput2 = _interopRequireDefault(_NumberInput);

var _PriceInput = __webpack_require__("./sdk/scripts/components/form/PriceInput.js");

var _PriceInput2 = _interopRequireDefault(_PriceInput);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

var _DeliveryTimeSettingsView = __webpack_require__("./scripts/pages/order/settings/modes/components/DeliveryTimeSettingsView.js");

var _DeliveryTimeSettingsView2 = _interopRequireDefault(_DeliveryTimeSettingsView);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var DeliverySettingsPage = function (_AbstractOrderSetting) {
  _inherits(DeliverySettingsPage, _AbstractOrderSetting);

  function DeliverySettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeliverySettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliverySettingsPage.__proto__ || Object.getPrototypeOf(DeliverySettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.orderSettings), _this.onNumberOfDaysToProposeChange = function () {
      var _this2;

      return (_this2 = _this).__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onMaxRangeInMetersChange = function () {
      var _this3;

      return (_this3 = _this).__onMaxRangeInMetersChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onMinimumPriceChange = function () {
      var _this4;

      return (_this4 = _this).__onMinimumPriceChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onMaxRangeInMetersChangeOnMap = function () {
      var _this5;

      return (_this5 = _this).__onMaxRangeInMetersChangeOnMap__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onChangeOnSitePaymentModesSettings = function () {
      var _this6;

      return (_this6 = _this).__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onItemsSequencedEnabledChange = function () {
      var _this7;

      return (_this7 = _this).__onItemsSequencedEnabledChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(DeliverySettingsPage, [{
    key: '__onItemsSequencedEnabledChange__REACT_HOT_LOADER__',
    value: function __onItemsSequencedEnabledChange__REACT_HOT_LOADER__() {
      return this.__onItemsSequencedEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__',
    value: function __onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__() {
      return this.__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMaxRangeInMetersChangeOnMap__REACT_HOT_LOADER__',
    value: function __onMaxRangeInMetersChangeOnMap__REACT_HOT_LOADER__() {
      return this.__onMaxRangeInMetersChangeOnMap__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMinimumPriceChange__REACT_HOT_LOADER__',
    value: function __onMinimumPriceChange__REACT_HOT_LOADER__() {
      return this.__onMinimumPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMaxRangeInMetersChange__REACT_HOT_LOADER__',
    value: function __onMaxRangeInMetersChange__REACT_HOT_LOADER__() {
      return this.__onMaxRangeInMetersChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__',
    value: function __onNumberOfDaysToProposeChange__REACT_HOT_LOADER__() {
      return this.__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__',
    value: function __onNumberOfDaysToProposeChange__REACT_HOT_LOADER__(newValue) {
      var orderSettings = this.orderSettings;
      orderSettings.deliverySettings.setMaxTimeAheadWithDays(newValue);
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onMaxRangeInMetersChange__REACT_HOT_LOADER__',
    value: function __onMaxRangeInMetersChange__REACT_HOT_LOADER__(maxRangeInMeters) {
      if (_lodash2.default.isNumber(_lodash2.default.toNumber(maxRangeInMeters))) {
        var orderSettings = this.orderSettings;
        orderSettings.deliverySettings.maxRangeInMeters = _lodash2.default.toNumber(maxRangeInMeters);
        this.onChangeOrderSettings(orderSettings);
      }
    }
  }, {
    key: '__onMinimumPriceChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onMinimumPriceChange__REACT_HOT_LOADER__(minimumPrice) {
      var orderSettings = this.orderSettings;
      orderSettings.deliverySettings.minimumPrice = minimumPrice;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onMaxRangeInMetersChangeOnMap__REACT_HOT_LOADER__',
    value: function __onMaxRangeInMetersChangeOnMap__REACT_HOT_LOADER__(newRange) {
      console.log('onMaxRangeInMetersChangeOnMap', newRange);
    }
  }, {
    key: '__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__',
    value: function __onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__(newValue) {
      var orderSettings = this.orderSettings;
      orderSettings.deliverySettings.onSite = newValue;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onItemsSequencedEnabledChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onItemsSequencedEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.deliverySettings.itemsSequenced = !orderSettings.deliverySettings.itemsSequenced;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: 'renderMinimumCart',
    value: function renderMinimumCart() {
      return null;
    }
  }, {
    key: 'renderNumberOfDaysToPropose',
    value: function renderNumberOfDaysToPropose() {
      return _react2.default.createElement(_NumberOfDaysToProposeView2.default, {
        numberOfDays: this.orderSettings.deliverySettings.getMaxTimeAheadAsDays(),
        onChange: this.onNumberOfDaysToProposeChange,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderPaymentMethods',
    value: function renderPaymentMethods() {
      var _this8 = this;

      return _react2.default.createElement(_PaymentMethodsAllowed2.default, {
        restaurant: this.props.restaurant,
        modeSettings: this.orderSettings.deliverySettings,
        onClick: function onClick(value) {
          return _this8.onPaymentMethodsChange(value, _this8.orderSettings.deliverySettings);
        },
        disabled: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderPaymentsModes',
    value: function renderPaymentsModes() {
      return _react2.default.createElement(_PaymentModesView2.default, {
        onSitePaymentModes: this.orderSettings.deliverySettings.onSite,
        onChange: this.onChangeOnSitePaymentModesSettings,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderMaxRangeInMeters',
    value: function renderMaxRangeInMeters() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        {
          name: 'max_range_in_meters'
        },
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.delivery.max_range_in_meters')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_NumberInput2.default, {
              value: this.orderSettings.deliverySettings.maxRangeInMeters,
              onChange: this.onMaxRangeInMetersChange,
              format: _NumberInput2.default.INT_FORMAT,
              min: 1,
              max: 50000 // 50km
              , disabled: !this.canEditSettings()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('global.meters')
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderMinimumPrice',
    value: function renderMinimumPrice() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.delivery.minimum_price')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_PriceInput2.default, {
            value: this.orderSettings.deliverySettings.minimumPrice,
            onChange: this.onMinimumPriceChange,
            currencyCode: this.props.restaurant.currency,
            readOnly: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderDeliveryTime',
    value: function renderDeliveryTime() {
      return _react2.default.createElement(_DeliveryTimeSettingsView2.default, {
        orderSettings: this.state.orderSettings,
        onChange: this.onChangeOrderSettings,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderMaxRangeInMetersMap',
    value: function renderMaxRangeInMetersMap() {
      if (_lodash2.default.isNil(this.props.restaurant.geoPt)) {
        return _react2.default.createElement(
          'p',
          null,
          _I18n2.default.tr('order.settings.delivery.restaurant_address_not_defined')
        );
      }

      // TODO:
      // handle onRadiusChange by setting editable to true on editable.
      // Note: find a way to not let the user move the circle, juste the radius

      return _react2.default.createElement(_DeliveryRangeMap2.default, {
        maxRangeInMeters: this.orderSettings.deliverySettings.maxRangeInMeters,
        restaurantLocation: this.props.restaurant.geoPt,
        onRadiusChange: this.onMaxRangeInMetersChangeOnMap,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderItemsSequenced',
    value: function renderItemsSequenced() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.itemsSequenced'),
          _react2.default.createElement(_TipTooltip2.default, {
            text: _I18n2.default.tr('order.settings.itemsSequenced.tooltip')
          })
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.deliverySettings.itemsSequenced,
            onChange: this.onItemsSequencedEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true },
        this.renderMinimumCart(),
        this.renderNumberOfDaysToPropose(),
        this.renderPaymentMethods(),
        this.renderMinimumPrice(),
        this.renderItemsSequenced(),
        _react2.default.createElement('hr', null),
        this.renderDeliveryTime(),
        _react2.default.createElement('hr', null),
        this.renderMaxRangeInMeters(),
        this.renderMaxRangeInMetersMap(),
        this.renderFixedButtons()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'delivery_settings_page'
        },
        this.renderBody()
      );
    }
  }]);

  return DeliverySettingsPage;
}(_AbstractOrderSettingsForm2.default);

DeliverySettingsPage.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant),

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings),

  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = DeliverySettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeliverySettingsPage, 'DeliverySettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/DeliverySettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/OnSiteSettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractOrderSettingsForm = __webpack_require__("./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js");

var _AbstractOrderSettingsForm2 = _interopRequireDefault(_AbstractOrderSettingsForm);

var _NumberOfDaysToProposeView = __webpack_require__("./scripts/pages/order/settings/modes/components/NumberOfDaysToProposeView.js");

var _NumberOfDaysToProposeView2 = _interopRequireDefault(_NumberOfDaysToProposeView);

var _PaymentModesView = __webpack_require__("./scripts/pages/order/settings/modes/components/PaymentModesView.js");

var _PaymentModesView2 = _interopRequireDefault(_PaymentModesView);

var _PaymentMethodsAllowed = __webpack_require__("./scripts/pages/order/settings/modes/components/PaymentMethodsAllowed.js");

var _PaymentMethodsAllowed2 = _interopRequireDefault(_PaymentMethodsAllowed);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _PriceInput = __webpack_require__("./sdk/scripts/components/form/PriceInput.js");

var _PriceInput2 = _interopRequireDefault(_PriceInput);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var OnSiteSettingsPage = function (_AbstractOrderSetting) {
  _inherits(OnSiteSettingsPage, _AbstractOrderSetting);

  function OnSiteSettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OnSiteSettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnSiteSettingsPage.__proto__ || Object.getPrototypeOf(OnSiteSettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.orderSettings), _this.onOnSiteAtBarEnabledChange = function () {
      var _this2;

      return (_this2 = _this).__onOnSiteAtBarEnabledChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onOnSitePreOrderEnabledChange = function () {
      var _this3;

      return (_this3 = _this).__onOnSitePreOrderEnabledChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onItemsSequencedEnabledChange = function () {
      var _this4;

      return (_this4 = _this).__onItemsSequencedEnabledChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onNumberOfDaysToProposeChange = function () {
      var _this5;

      return (_this5 = _this).__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onChangeOnSitePaymentModesSettings = function () {
      var _this6;

      return (_this6 = _this).__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onMinimumPriceChange = function () {
      var _this7;

      return (_this7 = _this).__onMinimumPriceChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(OnSiteSettingsPage, [{
    key: '__onMinimumPriceChange__REACT_HOT_LOADER__',
    value: function __onMinimumPriceChange__REACT_HOT_LOADER__() {
      return this.__onMinimumPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__',
    value: function __onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__() {
      return this.__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__',
    value: function __onNumberOfDaysToProposeChange__REACT_HOT_LOADER__() {
      return this.__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onItemsSequencedEnabledChange__REACT_HOT_LOADER__',
    value: function __onItemsSequencedEnabledChange__REACT_HOT_LOADER__() {
      return this.__onItemsSequencedEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOnSitePreOrderEnabledChange__REACT_HOT_LOADER__',
    value: function __onOnSitePreOrderEnabledChange__REACT_HOT_LOADER__() {
      return this.__onOnSitePreOrderEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOnSiteAtBarEnabledChange__REACT_HOT_LOADER__',
    value: function __onOnSiteAtBarEnabledChange__REACT_HOT_LOADER__() {
      return this.__onOnSiteAtBarEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onOnSiteAtBarEnabledChange__REACT_HOT_LOADER__',
    value: function __onOnSiteAtBarEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.orderAtBarAvailable = !orderSettings.onSiteSettings.orderAtBarAvailable;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onOnSitePreOrderEnabledChange__REACT_HOT_LOADER__',
    value: function __onOnSitePreOrderEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.preOrderAvailable = !orderSettings.onSiteSettings.preOrderAvailable;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onItemsSequencedEnabledChange__REACT_HOT_LOADER__',
    value: function __onItemsSequencedEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.itemsSequenced = !orderSettings.onSiteSettings.itemsSequenced;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__',
    value: function __onNumberOfDaysToProposeChange__REACT_HOT_LOADER__(newValue) {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.setMaxTimeAheadWithDays(newValue);
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__',
    value: function __onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__(newValue) {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.onSite = newValue;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onMinimumPriceChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onMinimumPriceChange__REACT_HOT_LOADER__(minimumPrice) {
      var orderSettings = this.orderSettings;
      orderSettings.onSiteSettings.minimumPrice = minimumPrice;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: 'renderAtBar',
    value: function renderAtBar() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.on_site.order_at_bar')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.onSiteSettings.orderAtBarAvailable,
            onChange: this.onOnSiteAtBarEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderPaymentMethods',
    value: function renderPaymentMethods() {
      var _this8 = this;

      return _react2.default.createElement(_PaymentMethodsAllowed2.default, {
        restaurant: this.props.restaurant,
        modeSettings: this.orderSettings.onSiteSettings,
        onClick: function onClick(value) {
          return _this8.onPaymentMethodsChange(value, _this8.orderSettings.onSiteSettings);
        },
        disabled: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderMinimumPrice',
    value: function renderMinimumPrice() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.on_site.minimum_price')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_PriceInput2.default, {
            value: this.orderSettings.onSiteSettings.minimumPrice,
            onChange: this.onMinimumPriceChange,
            currencyCode: this.props.restaurant.currency,
            readOnly: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderNumberOfDaysToPropose',
    value: function renderNumberOfDaysToPropose() {
      return _react2.default.createElement(_NumberOfDaysToProposeView2.default, {
        numberOfDays: this.orderSettings.onSiteSettings.getMaxTimeAheadAsDays(),
        onChange: this.onNumberOfDaysToProposeChange,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderPaymentsModes',
    value: function renderPaymentsModes() {
      return _react2.default.createElement(_PaymentModesView2.default, {
        onSitePaymentModes: this.orderSettings.onSiteSettings.onSite,
        onChange: this.onChangeOnSitePaymentModesSettings,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderPreOrder',
    value: function renderPreOrder() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.on_site.pre_order_available')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.onSiteSettings.preOrderAvailable,
            onChange: this.onOnSitePreOrderEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderItemsSequenced',
    value: function renderItemsSequenced() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.itemsSequenced'),
          _react2.default.createElement(_TipTooltip2.default, {
            text: _I18n2.default.tr('order.settings.itemsSequenced.tooltip')
          })
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.onSiteSettings.itemsSequenced,
            onChange: this.onItemsSequencedEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true },
        this.renderAtBar(),
        this.renderNumberOfDaysToPropose(),
        this.renderPaymentMethods(),
        this.renderMinimumPrice(),
        this.renderPreOrder(),
        this.renderItemsSequenced(),
        _react2.default.createElement('hr', null),
        this.renderFixedButtons()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderBody()
      );
    }
  }]);

  return OnSiteSettingsPage;
}(_AbstractOrderSettingsForm2.default);

OnSiteSettingsPage.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant),

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings),

  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = OnSiteSettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OnSiteSettingsPage, 'OnSiteSettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/OnSiteSettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/TakeAwaySettingsPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _AbstractOrderSettingsForm = __webpack_require__("./scripts/pages/order/settings/components/AbstractOrderSettingsForm.js");

var _AbstractOrderSettingsForm2 = _interopRequireDefault(_AbstractOrderSettingsForm);

var _NumberOfDaysToProposeView = __webpack_require__("./scripts/pages/order/settings/modes/components/NumberOfDaysToProposeView.js");

var _NumberOfDaysToProposeView2 = _interopRequireDefault(_NumberOfDaysToProposeView);

var _PaymentModesView = __webpack_require__("./scripts/pages/order/settings/modes/components/PaymentModesView.js");

var _PaymentModesView2 = _interopRequireDefault(_PaymentModesView);

var _PaymentMethodsAllowed = __webpack_require__("./scripts/pages/order/settings/modes/components/PaymentMethodsAllowed.js");

var _PaymentMethodsAllowed2 = _interopRequireDefault(_PaymentMethodsAllowed);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _PriceInput = __webpack_require__("./sdk/scripts/components/form/PriceInput.js");

var _PriceInput2 = _interopRequireDefault(_PriceInput);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var TakeAwaySettingsPage = function (_AbstractOrderSetting) {
  _inherits(TakeAwaySettingsPage, _AbstractOrderSetting);

  function TakeAwaySettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TakeAwaySettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TakeAwaySettingsPage.__proto__ || Object.getPrototypeOf(TakeAwaySettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.orderSettings), _this.onNumberOfDaysToProposeChange = function () {
      var _this2;

      return (_this2 = _this).__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onChangeOnSitePaymentModesSettings = function () {
      var _this3;

      return (_this3 = _this).__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onMinimumPriceChange = function () {
      var _this4;

      return (_this4 = _this).__onMinimumPriceChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onItemsSequencedEnabledChange = function () {
      var _this5;

      return (_this5 = _this).__onItemsSequencedEnabledChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(TakeAwaySettingsPage, [{
    key: '__onItemsSequencedEnabledChange__REACT_HOT_LOADER__',
    value: function __onItemsSequencedEnabledChange__REACT_HOT_LOADER__() {
      return this.__onItemsSequencedEnabledChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onMinimumPriceChange__REACT_HOT_LOADER__',
    value: function __onMinimumPriceChange__REACT_HOT_LOADER__() {
      return this.__onMinimumPriceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__',
    value: function __onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__() {
      return this.__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__',
    value: function __onNumberOfDaysToProposeChange__REACT_HOT_LOADER__() {
      return this.__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onNumberOfDaysToProposeChange__REACT_HOT_LOADER__',
    value: function __onNumberOfDaysToProposeChange__REACT_HOT_LOADER__(newValue) {
      var orderSettings = this.orderSettings;
      orderSettings.takeAwaySettings.setMaxTimeAheadWithDays(newValue);
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__',
    value: function __onChangeOnSitePaymentModesSettings__REACT_HOT_LOADER__(newValue) {
      var orderSettings = this.orderSettings;
      orderSettings.takeAwaySettings.onSite = newValue;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onMinimumPriceChange__REACT_HOT_LOADER__',
    value: function __onMinimumPriceChange__REACT_HOT_LOADER__(minimumPrice) {
      var orderSettings = this.orderSettings;
      orderSettings.takeAwaySettings.minimumPrice = minimumPrice;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: '__onItemsSequencedEnabledChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onItemsSequencedEnabledChange__REACT_HOT_LOADER__() {
      var orderSettings = this.orderSettings;
      orderSettings.takeAwaySettings.itemsSequenced = !orderSettings.takeAwaySettings.itemsSequenced;
      this.onChangeOrderSettings(orderSettings);
    }
  }, {
    key: 'renderMinimumPrice',
    value: function renderMinimumPrice() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.take_away.minimum_price')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_PriceInput2.default, {
            value: this.orderSettings.takeAwaySettings.minimumPrice,
            onChange: this.onMinimumPriceChange,
            currencyCode: this.props.restaurant.currency,
            readOnly: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderNumberOfDaysToPropose',
    value: function renderNumberOfDaysToPropose() {
      return _react2.default.createElement(_NumberOfDaysToProposeView2.default, {
        numberOfDays: this.orderSettings.takeAwaySettings.getMaxTimeAheadAsDays(),
        onChange: this.onNumberOfDaysToProposeChange,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderPaymentMethods',
    value: function renderPaymentMethods() {
      var _this6 = this;

      return _react2.default.createElement(_PaymentMethodsAllowed2.default, {
        restaurant: this.props.restaurant,
        modeSettings: this.orderSettings.takeAwaySettings,
        onClick: function onClick(value) {
          return _this6.onPaymentMethodsChange(value, _this6.orderSettings.takeAwaySettings);
        },
        disabled: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderPaymentsModes',
    value: function renderPaymentsModes() {
      return _react2.default.createElement(_PaymentModesView2.default, {
        onSitePaymentModes: this.orderSettings.takeAwaySettings.onSite,
        onChange: this.onChangeOnSitePaymentModesSettings,
        readOnly: !this.canEditSettings()
      });
    }
  }, {
    key: 'renderItemsSequenced',
    value: function renderItemsSequenced() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.itemsSequenced'),
          _react2.default.createElement(_TipTooltip2.default, {
            text: _I18n2.default.tr('order.settings.itemsSequenced.tooltip')
          })
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.orderSettings.takeAwaySettings.itemsSequenced,
            onChange: this.onItemsSequencedEnabledChange,
            disabled: !this.canEditSettings()
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true },
        this.renderNumberOfDaysToPropose(),
        this.renderPaymentMethods(),
        this.renderMinimumPrice(),
        this.renderItemsSequenced(),
        _react2.default.createElement('hr', null),
        this.renderFixedButtons()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          null,
          this.renderBody()
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return TakeAwaySettingsPage;
}(_AbstractOrderSettingsForm2.default);

TakeAwaySettingsPage.propTypes = {
  restaurant: _propTypes2.default.objectOf(_entities.Restaurant),

  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings),

  onSubmit: _propTypes2.default.func.isRequired
};
exports.default = TakeAwaySettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TakeAwaySettingsPage, 'TakeAwaySettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/TakeAwaySettingsPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/DeliveryTimeSettingsView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _NumberInput = __webpack_require__("./sdk/scripts/components/form/NumberInput.js");

var _NumberInput2 = _interopRequireDefault(_NumberInput);

var _OptionView = __webpack_require__("./sdk/scripts/components/form/OptionView.js");

var _OptionView2 = _interopRequireDefault(_OptionView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var DeliverySettingsPage = function (_Component) {
  _inherits(DeliverySettingsPage, _Component);

  function DeliverySettingsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeliverySettingsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliverySettingsPage.__proto__ || Object.getPrototypeOf(DeliverySettingsPage)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeDeliveryTimeSettings = function () {
      var _this2;

      return (_this2 = _this).__onChangeDeliveryTimeSettings__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onTypeChange = function () {
      var _this3;

      return (_this3 = _this).__onTypeChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onDeliveryManArrivalTimeChange = function () {
      var _this4;

      return (_this4 = _this).__onDeliveryManArrivalTimeChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onFixTimeChange = function () {
      var _this5;

      return (_this5 = _this).__onFixTimeChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeliverySettingsPage, [{
    key: '__onFixTimeChange__REACT_HOT_LOADER__',
    value: function __onFixTimeChange__REACT_HOT_LOADER__() {
      return this.__onFixTimeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDeliveryManArrivalTimeChange__REACT_HOT_LOADER__',
    value: function __onDeliveryManArrivalTimeChange__REACT_HOT_LOADER__() {
      return this.__onDeliveryManArrivalTimeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTypeChange__REACT_HOT_LOADER__',
    value: function __onTypeChange__REACT_HOT_LOADER__() {
      return this.__onTypeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeDeliveryTimeSettings__REACT_HOT_LOADER__',
    value: function __onChangeDeliveryTimeSettings__REACT_HOT_LOADER__() {
      return this.__onChangeDeliveryTimeSettings__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChangeDeliveryTimeSettings__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onChangeDeliveryTimeSettings__REACT_HOT_LOADER__(deliveryTimeSettings) {
      var orderSettings = this.props.orderSettings;
      orderSettings.deliveryTimeSettings = deliveryTimeSettings;
      this.props.onChange(orderSettings);
    }
  }, {
    key: '__onTypeChange__REACT_HOT_LOADER__',
    value: function __onTypeChange__REACT_HOT_LOADER__(newType) {
      var deliveryTimeSettings = this.deliveryTimeSettings;

      this.deliveryTimeSettings.settingsType = newType;

      this.onChangeDeliveryTimeSettings(deliveryTimeSettings);
    }
  }, {
    key: '__onDeliveryManArrivalTimeChange__REACT_HOT_LOADER__',
    value: function __onDeliveryManArrivalTimeChange__REACT_HOT_LOADER__(arrivalTime) {
      var deliveryTimeSettings = this.deliveryTimeSettings;

      this.deliveryTimeSettings.adaptableTimeSettings.setDeliveryManArrivalTimeFromMinutes(arrivalTime);

      this.onChangeDeliveryTimeSettings(deliveryTimeSettings);
    }
  }, {
    key: '__onFixTimeChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onFixTimeChange__REACT_HOT_LOADER__(time) {
      var deliveryTimeSettings = this.deliveryTimeSettings;

      this.deliveryTimeSettings.fixTimeSettings.setTimeFromMinutes(time);

      this.onChangeDeliveryTimeSettings(deliveryTimeSettings);
    }
  }, {
    key: 'renderFixPart',
    value: function renderFixPart() {
      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.delivery.delivery_time.fix.title'),
          _react2.default.createElement(_TipTooltip2.default, {
            text: _I18n2.default.tr('order.settings.delivery.delivery_time.fix.title.tooltip')
          })
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_NumberInput2.default, {
              value: this.deliveryTimeSettings.fixTimeSettings.getTimeAsMinutes(),
              onChange: this.onFixTimeChange,
              disabled: this.props.readOnly
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('global.minutes')
              )
            )
          )
        )
      );
    }

    //
    //
    //

  }, {
    key: 'renderAdaptablePart',
    value: function renderAdaptablePart() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'h4',
            null,
            _react2.default.createElement(_OptionView2.default, {
              label: '2. Temps ajustable',
              isActivated: this.deliveryTimeSettings.settingsType === _order.DeliveryTimeSettings.Type.ADAPTABLE,
              onChange: function onChange() {
                return _this6.onTypeChange(_order.DeliveryTimeSettings.Type.ADAPTABLE);
              },
              readOnly: this.props.readOnly
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8 col-md-6 top-buffer-50' },
          this.renderManufactureDelay(),
          this.renderDeliveryManArrivalTime(),
          this.renderDeliveryTime()
        )
      );
    }
  }, {
    key: 'renderManufactureDelay',
    value: function renderManufactureDelay() {
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4' },
          'a. D\xE9lai de production',
          _react2.default.createElement(_TipTooltip2.default, {
            text: 'TODO'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          this.props.orderSettings.getManufactureDelayAsMinutes(),
          ' ',
          _I18n2.default.tr('global.minutes')
        )
      );
    }
  }, {
    key: 'renderDeliveryManArrivalTime',
    value: function renderDeliveryManArrivalTime() {
      return _react2.default.createElement(
        'div',
        { className: 'row top-buffer-30' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4' },
          'b. D\xE9lai d\'arriv\xE9e du livreur'
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_NumberInput2.default, {
              value: this.deliveryTimeSettings.adaptableTimeSettings.getDeliveryManArrivalTimeAsMinutes(),
              onChange: this.onDeliveryManArrivalTimeChange,
              disabled: this.props.readOnly
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _I18n2.default.tr('global.minutes')
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderDeliveryTime',
    value: function renderDeliveryTime() {
      return _react2.default.createElement(
        'div',
        { className: 'row top-buffer-30' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4' },
          'c. Temps de livraison'
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8' },
          'Calcul\xE9 automatiquement'
        )
      );
    }

    //
    //
    //

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'delivery_time_settings_view'
        },
        this.renderFixPart()
      );
    }
  }, {
    key: 'deliveryTimeSettings',
    get: function get() {
      return this.props.orderSettings.deliverySettings.deliveryTimeSettings;
    }
  }]);

  return DeliverySettingsPage;
}(_react.Component);

DeliverySettingsPage.propTypes = {
  orderSettings: _propTypes2.default.objectOf(_order.OrderSettings).isRequired,

  deliveryTimeSettings: _propTypes2.default.objectOf(_order.DeliveryTimeSettings).isRequired,

  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = DeliverySettingsPage;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeliverySettingsPage, 'DeliverySettingsPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/DeliveryTimeSettingsView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/IrlPaymentAllowedView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// components
//


var IrlPaymentAllowedView = function (_Component) {
  _inherits(IrlPaymentAllowedView, _Component);

  function IrlPaymentAllowedView() {
    _classCallCheck(this, IrlPaymentAllowedView);

    return _possibleConstructorReturn(this, (IrlPaymentAllowedView.__proto__ || Object.getPrototypeOf(IrlPaymentAllowedView)).apply(this, arguments));
  }

  _createClass(IrlPaymentAllowedView, [{
    key: 'render',


    //
    //
    //

    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.irl_payment_allowed.title')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: this.props.enabled,
            onChange: function onChange() {
              return _this2.props.onChange(!_this2.props.enabled);
            },
            disabled: this.props.readOnly
          })
        )
      );
    }
  }]);

  return IrlPaymentAllowedView;
}(_react.Component);

IrlPaymentAllowedView.propTypes = {
  enabled: _propTypes2.default.bool.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = IrlPaymentAllowedView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IrlPaymentAllowedView, 'IrlPaymentAllowedView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/IrlPaymentAllowedView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/NumberOfDaysToProposeView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _NumberInput = __webpack_require__("./sdk/scripts/components/form/NumberInput.js");

var _NumberInput2 = _interopRequireDefault(_NumberInput);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

var _TipTooltip = __webpack_require__("./sdk/scripts/components/TipTooltip.js");

var _TipTooltip2 = _interopRequireDefault(_TipTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var NumberOfDaysToProposeView = function (_Component) {
  _inherits(NumberOfDaysToProposeView, _Component);

  function NumberOfDaysToProposeView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberOfDaysToProposeView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberOfDaysToProposeView.__proto__ || Object.getPrototypeOf(NumberOfDaysToProposeView)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var _this2;

      return (_this2 = _this).__onChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberOfDaysToProposeView, [{
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onChange__REACT_HOT_LOADER__(newValue) {
      if (_lodash2.default.isNumber(_lodash2.default.toNumber(newValue))) {
        this.props.onChange(_lodash2.default.toNumber(newValue));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormGroupView2.default,
          null,
          _react2.default.createElement(
            _FormGroupView2.default.Label,
            null,
            _I18n2.default.tr('order.settings.nb_days_to_propose_title'),
            _react2.default.createElement(_TipTooltip2.default, {
              text: _I18n2.default.tr('order.settings.nb_days_to_propose_explaination')
            })
          ),
          _react2.default.createElement(
            _FormGroupView2.default.Content,
            null,
            _react2.default.createElement(
              'div',
              { className: 'input-group' },
              _react2.default.createElement(_NumberInput2.default, {
                value: this.props.numberOfDays,
                onChange: this.onChange,
                format: _NumberInput2.default.INT_FORMAT,
                min: 0,
                max: 60,
                disabled: this.props.readOnly
              }),
              _react2.default.createElement(
                'div',
                { className: 'input-group-addon' },
                _react2.default.createElement(
                  'label',
                  null,
                  _I18n2.default.tr('order.settings.nb_days_to_propose_input_group_addon')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NumberOfDaysToProposeView;
}(_react.Component);

NumberOfDaysToProposeView.defaultProps = {
  numberOfDays: 0
};
NumberOfDaysToProposeView.propTypes = {
  numberOfDays: _propTypes2.default.number,

  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = NumberOfDaysToProposeView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NumberOfDaysToProposeView, 'NumberOfDaysToProposeView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/NumberOfDaysToProposeView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/PaymentMethodsAllowed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _FormGroupView = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView2 = _interopRequireDefault(_FormGroupView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentMethodsAllowed = function PaymentMethodsAllowed(_ref) {
  var modeSettings = _ref.modeSettings,
      restaurant = _ref.restaurant,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;


  return _react2.default.createElement(
    _FormGroupView2.default,
    null,
    _react2.default.createElement(
      _FormGroupView2.default.Label,
      null,
      _I18n2.default.tr('order.settings.payment_methods_allowed.label')
    ),
    _react2.default.createElement(
      _FormGroupView2.default.Content,
      null,
      _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.payment_methods_allowed.irl')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: modeSettings.havePaymentMethodAllowedIrl(),
            onChange: function onChange() {
              return onClick(modeSettings.orderPaymentMethodsAllowed.IRL);
            },
            disabled: disabled
          })
        )
      ),
      _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.payment_methods_allowed.cb')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: modeSettings.havePaymentMethodAllowedCreditCard(),
            onChange: function onChange() {
              return onClick(modeSettings.orderPaymentMethodsAllowed.CREDIT_CARD);
            },
            disabled: disabled
          })
        )
      ),
      restaurant.psp === 'PAYGREEN' && _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.payment_methods_allowed.trd')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: modeSettings.havePaymentMethodAllowedTRD(),
            onChange: function onChange() {
              return onClick(modeSettings.orderPaymentMethodsAllowed.TRD);
            },
            disabled: disabled
          })
        )
      ),
      _react2.default.createElement(
        _FormGroupView2.default,
        null,
        _react2.default.createElement(
          _FormGroupView2.default.Label,
          null,
          _I18n2.default.tr('order.settings.payment_methods_allowed.user_account')
        ),
        _react2.default.createElement(
          _FormGroupView2.default.Content,
          null,
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini',
            value: modeSettings.havePaymentMethodAllowedUserAccount(),
            onChange: function onChange() {
              return onClick(modeSettings.orderPaymentMethodsAllowed.USER_ACCOUNT);
            },
            disabled: disabled
          })
        )
      )
    )
  );
};


PaymentMethodsAllowed.propTypes = {
  onClick: _react.PropTypes.func.isRequired,
  modeSettings: _react.PropTypes.object.isRequired,
  disabled: _react.PropTypes.bool
};

var _default = PaymentMethodsAllowed;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentMethodsAllowed, 'PaymentMethodsAllowed', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/PaymentMethodsAllowed.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/PaymentMethodsAllowed.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/PaymentModesView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _PaymentModesForm = __webpack_require__("./scripts/components/payment/PaymentModesForm.js");

var _PaymentModesForm2 = _interopRequireDefault(_PaymentModesForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentModesView = function (_Component) {
  _inherits(PaymentModesView, _Component);

  function PaymentModesView() {
    _classCallCheck(this, PaymentModesView);

    return _possibleConstructorReturn(this, (PaymentModesView.__proto__ || Object.getPrototypeOf(PaymentModesView)).apply(this, arguments));
  }

  _createClass(PaymentModesView, [{
    key: 'renderBody',


    //
    // Renderers
    //

    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Paiement sur place'
        ),
        _react2.default.createElement(
          'p',
          null,
          'D\xE9finissez ici les diff\xE9rents modes de paiement accept\xE9s par votre restaurant.'
        ),
        this.renderPaymentModesForm()
      );
    }
  }, {
    key: 'renderPaymentModesForm',
    value: function renderPaymentModesForm() {
      return _react2.default.createElement(_PaymentModesForm2.default, {
        paymentModes: this.props.onSitePaymentModes,
        onChange: this.props.onChange,
        readOnly: this.props.readOnly
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderBody()
      );
    }
  }]);

  return PaymentModesView;
}(_react.Component);

PaymentModesView.propTypes = {
  // PaymentMode
  onSitePaymentModes: _propTypes2.default.number,

  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool.isRequired
};
exports.default = PaymentModesView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentModesView, 'PaymentModesView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/PaymentModesView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/maps/DeliveryRangeMap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

var _GoogleMapUtils = __webpack_require__("./scripts/utils/GoogleMapUtils.js");

var _GoogleMapUtils2 = _interopRequireDefault(_GoogleMapUtils);

var _GeolocUtils = __webpack_require__("./sdk/scripts/utils/GeolocUtils.js");

var _GeolocUtils2 = _interopRequireDefault(_GeolocUtils);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _RestaurantMarkerInfo = __webpack_require__("./sdk/scripts/entities/map/RestaurantMarkerInfo.js");

var _RestaurantMarkerInfo2 = _interopRequireDefault(_RestaurantMarkerInfo);

var _GoogleApiComponent = __webpack_require__("./sdk/scripts/components/GoogleApiComponent.js");

var _GoogleApiComponent2 = _interopRequireDefault(_GoogleApiComponent);

var _TextInput = __webpack_require__("./sdk/scripts/components/form/TextInput.js");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _GoogleMapView = __webpack_require__("./scripts/pages/order/settings/modes/components/maps/GoogleMapView.js");

var _GoogleMapView2 = _interopRequireDefault(_GoogleMapView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


// import withScriptjs from "react-google-maps/lib/async/withScriptjs";


/**
 * Note: geolocator import does not work well, we include it on the index.html
 *
 * - https://tomchentw.github.io/react-google-maps/basics/pop-up-window
 * - https://developers.google.com/maps/documentation/javascript/3.exp/reference
 * - https://developers.google.com/maps/documentation/javascript/tutorial#zoom-levels
 */
var DeliveryRangeMap = function (_Component) {
  _inherits(DeliveryRangeMap, _Component);

  function DeliveryRangeMap() {
    _classCallCheck(this, DeliveryRangeMap);

    return _possibleConstructorReturn(this, (DeliveryRangeMap.__proto__ || Object.getPrototypeOf(DeliveryRangeMap)).apply(this, arguments));
  }

  _createClass(DeliveryRangeMap, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(nextProps.maxRangeInMetters === this.props.maxRangeInMetters && nextProps.restaurantLocation === this.props.restaurantLocation);
    }
  }, {
    key: 'render',
    value: function render() {
      /**
       * Notes about the zoom:
       * 1: World
       * 5: Landmass/continent
       * 10: City
       * 15: Streets
       * 20: Buildings
       *
       * https://developers.google.com/maps/documentation/javascript/tutorial#zoom-levels
       */

      if (!this.props.loaded) {
        // GoogleApiComponent
        return _react2.default.createElement(
          'div',
          null,
          'Loading google maps...'
        );
      }

      var restaurantLocationShortGeoPt = _GeolocUtils2.default.geoPtToShortGeoPt(this.props.restaurantLocation);
      var center = restaurantLocationShortGeoPt;

      return _react2.default.createElement(
        'div',
        {
          className: 'map'
        },
        _react2.default.createElement(_GoogleMapView2.default, {
          googleMapURL: _GoogleMapUtils2.default.getApiUrlWithVersion(),
          loadingElement: _react2.default.createElement(
            'div',
            { style: { height: '100%' } },
            _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
          ),
          containerElement: _react2.default.createElement('div', { style: { height: '400px', width: '100%' } }),
          mapElement: _react2.default.createElement('div', { style: { height: '100%', width: '100%' } }),

          google: this.props.google,

          defaultCenter: restaurantLocationShortGeoPt,

          zoom: 12,

          location: restaurantLocationShortGeoPt,

          userCircleRadius: this.props.maxRangeInMeters,

          onMapLoad: _lodash2.default.noop,

          onMapClick: _lodash2.default.noop,

          onRadiusChange: this.props.onRadiusChange
        })
      );
    }
  }]);

  return DeliveryRangeMap;
}(_react.Component);

DeliveryRangeMap.propTypes = {
  maxRangeInMeters: _propTypes2.default.number,

  restaurantLocation: _propTypes2.default.object.isRequired,

  onRadiusChange: _propTypes2.default.func.isRequired
};

var _default = (0, _GoogleApiComponent2.default)({
  apiKey: _Config2.default.Google.Map.API_KEY,
  version: _Config2.default.Google.Map.API_VERSION,
  url: _Config2.default.Google.Map.API_URL
})(DeliveryRangeMap);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeliveryRangeMap, 'DeliveryRangeMap', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/maps/DeliveryRangeMap.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/maps/DeliveryRangeMap.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/settings/modes/components/maps/GoogleMapView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _reactGoogleMaps = __webpack_require__("./node_modules/react-google-maps/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleMapView = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
  return _react2.default.createElement(
    _reactGoogleMaps.GoogleMap,
    {
      ref: props.onMapLoad,
      defaultZoom: props.zoom,
      defaultCenter: props.defaultCenter,
      onLoad: props.onMapLoad,
      onClick: props.onMapClick
    },
    props.location &&
    // see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
    _react2.default.createElement(_reactGoogleMaps.Marker, {
      key: 'restaurant_marker',
      position: props.location,
      icon: {
        // url: `http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=${index + 1}|FE6256|000000`,
        url: _ViewConstants2.default.Image.USER_MAP_CURSOR,
        origin: new props.google.maps.Point(0, 0),
        // define size here
        scaledSize: new props.google.maps.Size(20, 20)
      },
      options: {},
      defaultAnimation: 2
    }),
    _react2.default.createElement(_reactGoogleMaps.Circle, {
      center: props.location,
      radius: props.userCircleRadius,
      onClick: _lodash2.default.noop,
      options: {
        // editable: true,
        onRadiusChanged: props.onRadiusChange,
        onCenterChanged: _lodash2.default.noop,
        fillColor: 'red',
        fillOpacity: 0.20,
        strokeColor: 'red',
        strokeOpacity: 1,
        strokeWeight: 1
      }
    })
  );
});

var _default = GoogleMapView;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GoogleMapView, 'GoogleMapView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/maps/GoogleMapView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/settings/modes/components/maps/GoogleMapView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/statistics/View.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Graph = __webpack_require__("./scripts/pages/order/statistics/components/Graph.js");

var _Graph2 = _interopRequireDefault(_Graph);

var _KeyFigures = __webpack_require__("./scripts/pages/order/statistics/components/KeyFigures.js");

var _KeyFigures2 = _interopRequireDefault(_KeyFigures);

var _StatsTable = __webpack_require__("./scripts/pages/order/statistics/components/StatsTable.js");

var _StatsTable2 = _interopRequireDefault(_StatsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = function View(_ref) {
  var data = _ref.data,
      orderModes = _ref.orderModes,
      sourcesList = _ref.sourcesList,
      paymentMethods = _ref.paymentMethods,
      apiError = _ref.apiError,
      salesFilters = _ref.salesFilters,
      salesFiltersState = _ref.salesFiltersState,
      weekdaysFilters = _ref.weekdaysFilters,
      weekdaysFiltersState = _ref.weekdaysFiltersState,
      _changeFilters = _ref.changeFilters,
      currencyCode = _ref.currencyCode;

  var thead = ['', _I18n2.default.tr('order.statistics.nbOrders'), _I18n2.default.tr('order.statistics.turnover'), _I18n2.default.tr('order.statistics.average')];

  return !_lodash2.default.isNull(data) && !_lodash2.default.isEmpty(data.items) ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-4' },
        _react2.default.createElement(_KeyFigures2.default, {
          color: 'primary',
          icon: 'fa-shopping-cart',
          text: _I18n2.default.tr('order.statistics.nbOrders'),
          figure: data.sums.total.nbOrders
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-4' },
        _react2.default.createElement(_KeyFigures2.default, {
          color: 'green',
          icon: 'fa-eur',
          text: _I18n2.default.tr('order.statistics.turnover'),
          figure: _CurrencyUtils2.default.formatMillionPriceWithCurrency(data.sums.total.turnoverTTC, currencyCode)
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-4' },
        _react2.default.createElement(_KeyFigures2.default, {
          color: 'yellow',
          icon: 'fa-credit-card',
          text: _I18n2.default.tr('order.statistics.average'),
          figure: _CurrencyUtils2.default.formatMillionPriceWithCurrency(data.sums.total.averageTTC, currencyCode)
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12' },
        _react2.default.createElement(_Graph2.default, {
          graphId: 'area',
          name: _I18n2.default.tr('order.statistics.turnover_average-check'),
          filters: salesFilters,
          filtersState: salesFiltersState,
          changeFilters: function changeFilters(filter) {
            return _changeFilters('salesFilters', [filter]);
          }
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-md-9' },
        _react2.default.createElement(_StatsTable2.default, {
          name: _I18n2.default.tr('order.statistics.modes'),
          thead: thead,
          iterator: orderModes,
          data: data.sums.modes,
          currencyCode: currencyCode
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-md-3' },
        _react2.default.createElement(_Graph2.default, { graphId: 'donut-modes', name: _I18n2.default.tr('order.statistics.turnover') })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-md-9' },
        _react2.default.createElement(_StatsTable2.default, {
          name: _I18n2.default.tr('order.statistics.sources'),
          thead: thead,
          iterator: sourcesList,
          data: data.sums.sources,
          currencyCode: currencyCode
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-md-3' },
        _react2.default.createElement(_Graph2.default, { graphId: 'donut-sources', name: _I18n2.default.tr('order.statistics.turnover') })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-md-9' },
        _react2.default.createElement(_StatsTable2.default, {
          name: _I18n2.default.tr('order.statistics.payments'),
          thead: thead,
          iterator: paymentMethods,
          data: data.sums.payments,
          currencyCode: currencyCode
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-md-3' },
        _react2.default.createElement(_Graph2.default, { graphId: 'donut-payments', name: _I18n2.default.tr('order.statistics.turnover') })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12' },
        _react2.default.createElement(_Graph2.default, {
          graphId: 'area-by-weekday',
          name: _I18n2.default.tr('order.statistics.turnover_average-check_by-weekday'),
          filters: weekdaysFilters,
          filtersState: weekdaysFiltersState,
          changeFilters: function changeFilters(filter) {
            return _changeFilters('weekdaysFilters', _ArrayUtils2.default.toggleValue(weekdaysFiltersState, filter));
          }
        })
      )
    )
  ) : !_lodash2.default.isNull(apiError) ? _react2.default.createElement(
    'span',
    { className: 'alert alert-danger' },
    apiError.message
  ) : _react2.default.createElement(
    'div',
    { className: 'stat_page__no_data' },
    _react2.default.createElement(
      'div',
      { className: 'col-xs-6 col-xs-offset-3 text-center' },
      _react2.default.createElement('i', { className: 'icon-smiley-down' }),
      _react2.default.createElement(
        'p',
        { className: 'top-buffer-30' },
        _I18n2.default.tr('order.statistics.no_data')
      )
    )
  );
};

View.propTypes = {
  data: _react.PropTypes.object.isRequired,
  orderModes: _react.PropTypes.array.isRequired,
  sourcesList: _react.PropTypes.array.isRequired,
  paymentMethods: _react.PropTypes.array.isRequired,
  apiError: _react.PropTypes.object,
  salesFilters: _react.PropTypes.object.isRequired,
  salesFiltersState: _react.PropTypes.array,
  weekdaysFilters: _react.PropTypes.object.isRequired,
  weekdaysFiltersState: _react.PropTypes.array,
  changeFilters: _react.PropTypes.function,
  currencyCode: _react.PropTypes.string
};

var _default = View;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(View, 'View', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/View.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/View.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/statistics/components/Filters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__("./sdk/scripts/components/Button.js");

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _OrderModeChooser = __webpack_require__("./sdk/scripts/components/form/OrderModeChooser.js");

var _OrderModeChooser2 = _interopRequireDefault(_OrderModeChooser);

var _PaymentMethod = __webpack_require__("./sdk/scripts/constants/PaymentMethod.js");

var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _ApiConsumersStore = __webpack_require__("./scripts/stores/ApiConsumersStore.js");

var _ApiConsumersStore2 = _interopRequireDefault(_ApiConsumersStore);

var _OrderStatisticsStore = __webpack_require__("./scripts/stores/OrderStatisticsStore.js");

var _OrderStatisticsStore2 = _interopRequireDefault(_OrderStatisticsStore);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _TimelapsePicker = __webpack_require__("./scripts/components/timelapse/TimelapsePicker.js");

var _TimelapsePicker2 = _interopRequireDefault(_TimelapsePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filters = function Filters(_ref) {
  var sourcesList = _ref.sourcesList,
      modes = _ref.modes,
      paymentMethods = _ref.paymentMethods,
      timelapse = _ref.timelapse,
      isLoading = _ref.isLoading,
      updateFilters = _ref.updateFilters,
      updateModes = _ref.updateModes,
      updateTimelapse = _ref.updateTimelapse,
      onSubmit = _ref.onSubmit;
  return _react2.default.createElement(
    'div',
    { className: 'order_statistics_filters row' },
    _react2.default.createElement(
      'div',
      { className: 'col-xs-12 col-sm-6 col-lg-3' },
      _react2.default.createElement(_LocalizableSelect2.default, {
        name: 'filterSource',
        placeholder: _I18n2.default.tr('order.on_going.table.header.source'),
        value: sourcesList,
        options: _ApiConsumersStore2.default.getOptions(),
        onChange: function onChange(options) {
          return updateFilters(options, 'sourcesList');
        },
        multi: true
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-xs-12 col-sm-6 col-lg-3' },
      _react2.default.createElement(_OrderModeChooser2.default, {
        placeholder: _I18n2.default.tr('order.on_going.table.header.type'),
        onChange: function onChange(modes) {
          return updateModes(modes);
        },
        multi: true,
        values: modes,
        modes: _.values(_Order2.default.OrderMode)
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-xs-12 col-sm-6 col-lg-3' },
      _react2.default.createElement(_LocalizableSelect2.default, {
        name: 'filterPayment',
        placeholder: _I18n2.default.tr('order.on_going.table.header.payment'),
        value: paymentMethods,
        options: (0, _PaymentMethod.getPaymentMethodOptions)(),
        onChange: function onChange(options) {
          return updateFilters(options, 'paymentMethods');
        },
        multi: true
      })
    ),
    _react2.default.createElement(_TimelapsePicker2.default, {
      className: 'col-xs-12 col-sm-6 col-lg-3',
      timelapse: timelapse,
      onTimelapseChange: updateTimelapse
    })
  );
};

Filters.propTypes = {
  sourcesList: _react.PropTypes.array.isRequired,
  modes: _react.PropTypes.array.isRequired,
  paymentMethods: _react.PropTypes.array.isRequired,
  isLoading: _react.PropTypes.bool.isRequired,
  updateModes: _react.PropTypes.func.isRequired,
  updateFilters: _react.PropTypes.func.isRequired,
  updateTimelapse: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired
};

var _default = Filters;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Filters, 'Filters', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/Filters.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/Filters.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/statistics/components/Graph.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Graph = function Graph(_ref) {
  var graphId = _ref.graphId,
      name = _ref.name,
      filters = _ref.filters,
      filtersState = _ref.filtersState,
      changeFilters = _ref.changeFilters;
  return _react2.default.createElement(
    'div',
    { className: 'panel panel-default' },
    _react2.default.createElement(
      'div',
      { className: 'panel-heading' },
      _react2.default.createElement('i', { className: 'fa fa-bar-chart-o fa-fw' }),
      ' ',
      name,
      !_lodash2.default.isEmpty(filters) && !_lodash2.default.isNull(changeFilters) && _react2.default.createElement(
        'div',
        { className: 'pull-right' },
        _react2.default.createElement(
          'div',
          { className: 'btn-group', 'data-toggle': 'buttons' },
          _lodash2.default.keys(filters).map(function (filter) {
            return _react2.default.createElement(
              'label',
              {
                className: 'btn btn-xs ' + (filtersState.includes(filter) ? 'btn-primary' : 'btn-default'),
                onClick: function onClick() {
                  return changeFilters(filter);
                }
              },
              filters[filter].label
            );
          })
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'panel-body' },
      _react2.default.createElement('div', { id: graphId })
    )
  );
};

Graph.propTypes = {
  graphId: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  filters: _react.PropTypes.object,
  filtersState: _react.PropTypes.array,
  changeFilters: _react.PropTypes.function
};

var _default = Graph;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Graph, 'Graph', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/Graph.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/Graph.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/statistics/components/KeyFigures.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyFigures = function KeyFigures(_ref) {
  var color = _ref.color,
      icon = _ref.icon,
      text = _ref.text,
      figure = _ref.figure;
  return _react2.default.createElement(
    "div",
    { className: "panel panel-" + color },
    _react2.default.createElement(
      "div",
      { className: "panel-heading" },
      _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col-xs-3" },
          _react2.default.createElement("i", { className: "fa " + icon + " fa-5x" })
        ),
        _react2.default.createElement(
          "div",
          { className: "col-xs-9 text-right" },
          _react2.default.createElement(
            "div",
            { className: "huge" },
            figure
          ),
          _react2.default.createElement(
            "div",
            null,
            text
          )
        )
      )
    )
  );
};

KeyFigures.propTypes = {
  color: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string.isRequired,
  text: _react.PropTypes.string.isRequired,
  figure: _react.PropTypes.any.isRequired
};

var _default = KeyFigures;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(KeyFigures, "KeyFigures", "C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/KeyFigures.js");

  __REACT_HOT_LOADER__.register(_default, "default", "C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/KeyFigures.js");
}();

;
module.exports = exports["default"];

/***/ }),

/***/ "./scripts/pages/order/statistics/components/StatsTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatsTable = function StatsTable(_ref) {
  var name = _ref.name,
      thead = _ref.thead,
      iterator = _ref.iterator,
      data = _ref.data,
      currencyCode = _ref.currencyCode;
  return _react2.default.createElement(
    'div',
    { className: 'panel panel-default' },
    _react2.default.createElement(
      'div',
      { className: 'panel-heading' },
      _react2.default.createElement('i', { className: 'fa fa-bar-chart-o fa-fw' }),
      ' ',
      name
    ),
    _react2.default.createElement(
      'div',
      { className: 'panel-body' },
      _react2.default.createElement(
        _reactBootstrap.Table,
        { striped: true, bordered: true, condensed: true, hover: true },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            thead.map(function (th) {
              return _react2.default.createElement(
                'th',
                { className: 'text-right' },
                th
              );
            })
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          iterator.map(function (iteratee) {
            if (_lodash2.default.isEmpty(data[iteratee.value]) && _lodash2.default.isEmpty(data[iteratee.value]) && _lodash2.default.isEmpty(data[iteratee.value])) {
              return null;
            }

            return _react2.default.createElement(
              'tr',
              { key: 'sums-' + iteratee.value },
              _react2.default.createElement(
                'td',
                null,
                iteratee.label
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-right' },
                !_lodash2.default.isEmpty(data[iteratee.value]) ? data[iteratee.value].nbOrders : '-'
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-right' },
                !_lodash2.default.isEmpty(data[iteratee.value]) ? _CurrencyUtils2.default.formatMillionPriceWithCurrency(data[iteratee.value].turnoverTTC, currencyCode) : '-'
              ),
              _react2.default.createElement(
                'td',
                { className: 'text-right' },
                !_lodash2.default.isEmpty(data[iteratee.value]) ? _CurrencyUtils2.default.formatMillionPriceWithCurrency(data[iteratee.value].averageTTC, currencyCode) : '-'
              )
            );
          })
        )
      )
    )
  );
};

StatsTable.propTypes = {
  name: _react.PropTypes.string.isRequired,
  thead: _react.PropTypes.array.isRequired,
  iterator: _react.PropTypes.array.isRequired,
  data: _react.PropTypes.object.isRequired
};

var _default = StatsTable;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(StatsTable, 'StatsTable', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/StatsTable.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/components/StatsTable.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/statistics/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _OrderModeChooser = __webpack_require__("./sdk/scripts/components/form/OrderModeChooser.js");

var _OrderModeChooser2 = _interopRequireDefault(_OrderModeChooser);

var _OrderViewUtils = __webpack_require__("./sdk/scripts/utils/OrderViewUtils.js");

var _OrderViewUtils2 = _interopRequireDefault(_OrderViewUtils);

var _PaymentMethod = __webpack_require__("./sdk/scripts/constants/PaymentMethod.js");

var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Filters = __webpack_require__("./scripts/pages/order/statistics/components/Filters.js");

var _Filters2 = _interopRequireDefault(_Filters);

var _View = __webpack_require__("./scripts/pages/order/statistics/View.js");

var _View2 = _interopRequireDefault(_View);

__webpack_require__("./scripts/pages/order/statistics/style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderStatistics = function (_AbstractComponent) {
  _inherits(OrderStatistics, _AbstractComponent);

  function OrderStatistics() {
    _classCallCheck(this, OrderStatistics);

    var _this = _possibleConstructorReturn(this, (OrderStatistics.__proto__ || Object.getPrototypeOf(OrderStatistics)).call(this));

    _this.state = {
      orderStatisticsState: _stores.OrderStatisticsStore.getState(),
      apiConsumersState: _stores.ApiConsumersStore.getState(),
      sourcesList: [],
      modes: [],
      paymentMethods: [],
      timelapse: _stores.SessionStore.getTimelapse(),
      salesFilters: ['hour'],
      weekdaysFilters: _lodash2.default.keys(_this.weekdaysFilters),
      restaurantsIds: [_stores.SessionStore.getRestaurantId()],
      restaurant: _stores.RestaurantStore.getRestaurant()
    };

    _this.onUpdateTimelapse = function () {
      return _this.__onUpdateTimelapse__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdateModes = function () {
      return _this.__onUpdateModes__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdateFilters = function () {
      return _this.__onUpdateFilters__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onFetchApiConsumers = function () {
      return _this.__onFetchApiConsumers__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onFetchStatistics = function () {
      return _this.__onFetchStatistics__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleChangeFraphFilters = function () {
      return _this.__handleChangeFraphFilters__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdateGraph = function () {
      return _this.__onUpdateGraph__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-line-chart';
    _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.order'),
      link: ''
    }, {
      name: _I18n2.default.tr('menu.order.statistics'),
      link: ''
    }];

    _this.sourcesList = [];
    return _this;
  }

  _createClass(OrderStatistics, [{
    key: '__onUpdateGraph__REACT_HOT_LOADER__',
    value: function __onUpdateGraph__REACT_HOT_LOADER__() {
      return this.__onUpdateGraph__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleChangeFraphFilters__REACT_HOT_LOADER__',
    value: function __handleChangeFraphFilters__REACT_HOT_LOADER__() {
      return this.__handleChangeFraphFilters__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFetchStatistics__REACT_HOT_LOADER__',
    value: function __onFetchStatistics__REACT_HOT_LOADER__() {
      return this.__onFetchStatistics__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFetchApiConsumers__REACT_HOT_LOADER__',
    value: function __onFetchApiConsumers__REACT_HOT_LOADER__() {
      return this.__onFetchApiConsumers__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateFilters__REACT_HOT_LOADER__',
    value: function __onUpdateFilters__REACT_HOT_LOADER__() {
      return this.__onUpdateFilters__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateModes__REACT_HOT_LOADER__',
    value: function __onUpdateModes__REACT_HOT_LOADER__() {
      return this.__onUpdateModes__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onUpdateTimelapse__REACT_HOT_LOADER__',
    value: function __onUpdateTimelapse__REACT_HOT_LOADER__() {
      return this.__onUpdateTimelapse__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_stores.RestaurantStore.getRestaurant().haveFeatureOrder()) {
        _actions.RouteAction.redirectToFeatureNonActivated();
        return;
      }

      _stores.ApiConsumersStore.addListener(this.onFetchApiConsumers);
      _stores.OrderStatisticsStore.addListener(this.onFetchStatistics);

      this.loadApiConsumers();
      this.loadStatistics();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.ApiConsumersStore.removeListener(this.onFetchApiConsumers);
      _stores.OrderStatisticsStore.removeListener(this.onFetchStatistics);
    }
  }, {
    key: 'loadApiConsumers',
    value: function loadApiConsumers() {
      _actions.RestaurantsGroupAction.loadApiConsumers(_stores.SessionStore.getRestaurantsGroupId(), {
        withOther: true,
        withParents: false
      });
    }

    /**
     * API method allows us to filter directly through the call
     * however, for better ux we let the front filter the data
     */

  }, {
    key: 'loadStatistics',
    value: function loadStatistics() {
      _actions.RestaurantsGroupAction.loadOrderStatistics(_stores.SessionStore.getRestaurantsGroupId(), _stores.SessionStore.getTimelapse(), [], //this.state.modes,
      [], //this.state.sourcesList,
      [], //this.state.paymentMethods,
      this.state.restaurantsIds);
    }
  }, {
    key: '__onUpdateTimelapse__REACT_HOT_LOADER__',
    value: function __onUpdateTimelapse__REACT_HOT_LOADER__(timelapse) {
      _stores.SessionStore.saveTimelapse(timelapse);

      this.setState({
        timelapse: timelapse
      }, this.loadStatistics);
    }
  }, {
    key: '__onUpdateModes__REACT_HOT_LOADER__',
    value: function __onUpdateModes__REACT_HOT_LOADER__(modes) {
      this.setState({
        modes: modes
      }, this.onFetchStatistics);
    }
  }, {
    key: '__onUpdateFilters__REACT_HOT_LOADER__',
    value: function __onUpdateFilters__REACT_HOT_LOADER__(options, key) {
      var newState = {};

      newState[key] = options.map(function (option) {
        return key == 'modes' ? option : option.value;
      });

      this.setState(newState, this.onFetchStatistics);
    }
  }, {
    key: '__onFetchApiConsumers__REACT_HOT_LOADER__',
    value: function __onFetchApiConsumers__REACT_HOT_LOADER__() {
      var apiConsumersState = _stores.ApiConsumersStore.getState();

      if (!_lodash2.default.isNull(apiConsumersState.data)) {
        this.sourcesList = apiConsumersState.data.apiConsumers.map(function (_ref) {
          var id = _ref.id,
              name = _ref.name;

          return {
            label: name,
            value: id
          };
        });
        this.sourcesList.push({
          label: _I18n2.default.tr('order.statistics.other'),
          value: 0
        });
      }

      this.setState({
        apiConsumersState: apiConsumersState
      });
    }
  }, {
    key: '__onFetchStatistics__REACT_HOT_LOADER__',
    value: function __onFetchStatistics__REACT_HOT_LOADER__() {
      var _this2 = this;

      try {
        var orderStatisticsState = _stores.OrderStatisticsStore.getState();

        if (!_lodash2.default.isNull(orderStatisticsState.data)) {
          var orderStatistics = orderStatisticsState.data;

          if (!_lodash2.default.isEmpty(orderStatistics.items)) {
            var defaultValues = {
              nbOrders: 0,
              averageTTC: 0,
              turnoverTTC: 0
            };

            orderStatistics.sums = {
              modes: {},
              sources: {},
              payments: {},
              total: _lodash2.default.clone(defaultValues)
            };

            _lodash2.default.forEach(orderStatistics.items, function (item) {
              // item.hour is a string formatted, on a UTC date.
              // We need to update it to be a current timezone date
              var format = 'YYYY-MM-DD HH:mm';
              item.hour = _moment2.default.utc(item.hour, format).local().format(format);

              if ((_lodash2.default.isEmpty(_this2.state.modes) || _this2.state.modes.includes(_Order2.default.OrderMode[item.mode])) && (_lodash2.default.isEmpty(_this2.state.paymentMethods) || _this2.state.paymentMethods.includes(item.paymentMethod)) && (_lodash2.default.isEmpty(_this2.state.sourcesList) || _this2.state.sourcesList.includes(item.source))) {
                if (_lodash2.default.isEmpty(orderStatistics.sums.modes[item.mode])) {
                  orderStatistics.sums.modes[item.mode] = _lodash2.default.clone(defaultValues);
                }
                if (_lodash2.default.isEmpty(orderStatistics.sums.sources[item.source])) {
                  orderStatistics.sums.sources[item.source] = _lodash2.default.clone(defaultValues);
                }
                if (_lodash2.default.isEmpty(orderStatistics.sums.payments[item.paymentMethod])) {
                  orderStatistics.sums.payments[item.paymentMethod] = _lodash2.default.clone(defaultValues);
                }

                orderStatistics.sums.modes[item.mode].nbOrders += item.nbOrders;
                orderStatistics.sums.modes[item.mode].turnoverTTC += item.turnoverTTC;
                orderStatistics.sums.modes[item.mode].averageTTC = orderStatistics.sums.modes[item.mode].turnoverTTC / orderStatistics.sums.modes[item.mode].nbOrders;

                orderStatistics.sums.sources[item.source].nbOrders += item.nbOrders;
                orderStatistics.sums.sources[item.source].turnoverTTC += item.turnoverTTC;
                orderStatistics.sums.sources[item.source].averageTTC = orderStatistics.sums.sources[item.source].turnoverTTC / orderStatistics.sums.sources[item.source].nbOrders;

                orderStatistics.sums.payments[item.paymentMethod].nbOrders += item.nbOrders;
                orderStatistics.sums.payments[item.paymentMethod].turnoverTTC += item.turnoverTTC;
                orderStatistics.sums.payments[item.paymentMethod].averageTTC = orderStatistics.sums.payments[item.paymentMethod].turnoverTTC / orderStatistics.sums.payments[item.paymentMethod].nbOrders;

                orderStatistics.sums.total.nbOrders += item.nbOrders;
                orderStatistics.sums.total.turnoverTTC += item.turnoverTTC;
                orderStatistics.sums.total.averageTTC = orderStatistics.sums.total.turnoverTTC / orderStatistics.sums.total.nbOrders;
              }
            });
          }
        }

        this.setState({
          orderStatisticsState: orderStatisticsState
        }, !_lodash2.default.isEmpty(orderStatisticsState.data) && !_lodash2.default.isEmpty(orderStatisticsState.data.items) ? this.onUpdateGraph : null);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: '__handleChangeFraphFilters__REACT_HOT_LOADER__',
    value: function __handleChangeFraphFilters__REACT_HOT_LOADER__(key, filters) {
      var newState = this.state;
      newState[key] = filters;

      this.setState(newState, this.onUpdateGraph);
    }
  }, {
    key: '__onUpdateGraph__REACT_HOT_LOADER__',
    value: function __onUpdateGraph__REACT_HOT_LOADER__() {
      var _this3 = this;

      var format = !_lodash2.default.isNull(this.salesFilters[this.state.salesFilters[0]]) ? this.salesFilters[this.state.salesFilters[0]].filter : 'YYYY-MM-DD HH:mm';

      var graphDataByFilterView = {};
      _lodash2.default.forEach(this.state.orderStatisticsState.data.items, function (_ref2) {
        var mode = _ref2.mode,
            paymentMethod = _ref2.paymentMethod,
            source = _ref2.source,
            hour = _ref2.hour,
            turnoverTTC = _ref2.turnoverTTC,
            nbOrders = _ref2.nbOrders;

        if ((_lodash2.default.isEmpty(_this3.state.modes) || _this3.state.modes.includes(_Order2.default.OrderMode[mode])) && (_lodash2.default.isEmpty(_this3.state.paymentMethods) || _this3.state.paymentMethods.includes(paymentMethod)) && (_lodash2.default.isEmpty(_this3.state.sourcesList) || _this3.state.sourcesList.includes(source))) {
          var period = (0, _moment2.default)(hour).format(format);
          if (_this3.state.salesFilters.includes('week')) {
            period = (0, _moment2.default)((0, _moment2.default)(hour).format('YYYY')).add((0, _moment2.default)(hour).isoWeek() - 1, 'weeks').add(1, 'day').format('YYYY-MM-DD');
          }

          if (_lodash2.default.isEmpty(graphDataByFilterView[period])) {
            graphDataByFilterView[period] = {
              averageTTC: 0,
              turnoverTTC: 0,
              nbOrders: 0
            };
          }

          graphDataByFilterView[period].turnoverTTC += turnoverTTC;
          graphDataByFilterView[period].nbOrders += nbOrders;
          graphDataByFilterView[period].averageTTC = graphDataByFilterView[period].turnoverTTC / graphDataByFilterView[period].nbOrders;
        }
      });

      var graphData = _lodash2.default.keys(graphDataByFilterView).map(function (moment) {
        return {
          moment: moment,
          turnoverTTC: graphDataByFilterView[moment].turnoverTTC,
          averageTTC: graphDataByFilterView[moment].averageTTC
        };
      });

      var filledGraphData = [];
      var m = (0, _moment2.default)(this.state.timelapse.getFromTimeAsDate());

      for (var i = 0; i < graphData.length; i++) {
        while (!m.isSame((0, _moment2.default)(graphData[i].moment), this.state.salesFilters[0])) {
          filledGraphData.push({
            moment: m.format(format),
            turnoverTTC: 0,
            averageTTC: 0
          });
          m = m.add(1, this.state.salesFilters[0]);
        }
        filledGraphData.push(graphData[i]);
        m = m.add(1, this.state.salesFilters[0]);
      }

      while (m.diff((0, _moment2.default)(this.state.timelapse.getToTimeAsDate())) < 0) {
        filledGraphData.push({
          moment: m.format(format),
          turnoverTTC: 0,
          averageTTC: 0
        });
        m = m.add(1, this.state.salesFilters[0]);
      }

      var dataByWeekday = {};
      for (var j = 0; j <= 24; j++) {
        var _m = (0, _moment2.default)(j * 3600000);
        dataByWeekday[_m.format('1970-01-01 HH:mm')] = [0, 0, 0, 0, 0, 0, 0, 0];
        _m = _m.add(1, 'hour');
      }

      _lodash2.default.forEach(this.state.orderStatisticsState.data.items, function (_ref3) {
        var mode = _ref3.mode,
            paymentMethod = _ref3.paymentMethod,
            source = _ref3.source,
            hour = _ref3.hour,
            turnoverTTC = _ref3.turnoverTTC;

        if ((_lodash2.default.isEmpty(_this3.state.modes) || _this3.state.modes.includes(_Order2.default.OrderMode[mode])) && (_lodash2.default.isEmpty(_this3.state.paymentMethods) || _this3.state.paymentMethods.includes(paymentMethod)) && (_lodash2.default.isEmpty(_this3.state.sourcesList) || _this3.state.sourcesList.includes(source))) {
          var period = (0, _moment2.default)(hour).format('1970-01-01 HH:mm');
          var weekday = (0, _moment2.default)(hour).isoWeekday();

          if (_lodash2.default.isEmpty(dataByWeekday[period])) {
            dataByWeekday[period] = [0, 0, 0, 0, 0, 0, 0, 0];
          }

          dataByWeekday[period][weekday] += turnoverTTC;
        }
      });

      var nbDays = [];
      for (var _i = 1; _i <= 7; _i++) {
        nbDays.push(_DateUtils2.default.nbWeekdaysBetween(this.state.timelapse.getFromTimeAsDate(), this.state.timelapse.getToTimeAsDate(), _i));
      }

      var nbTotalDays = nbDays.reduce(function (a, b) {
        return a + b;
      });

      var graphDataByWeekday = _lodash2.default.keys(dataByWeekday).map(function (moment) {
        var data = { moment: moment };

        _this3.state.weekdaysFilters.map(function (filter) {
          switch (filter) {
            case 'average':
              data['average'] = (dataByWeekday[moment][1] + dataByWeekday[moment][2] + dataByWeekday[moment][3] + dataByWeekday[moment][4] + dataByWeekday[moment][5] + dataByWeekday[moment][6] + dataByWeekday[moment][7]) / nbTotalDays;
              break;
            default:
              data[filter] = nbDays[_this3.weekdaysFilters[filter].filter - 1] > 0 ? dataByWeekday[moment][_this3.weekdaysFilters[filter].filter] / nbDays[_this3.weekdaysFilters[filter].filter - 1] : 0;
          }
        });

        return data;
      });

      $('#area, #donut-sources, #donut-modes, #donut-payments, #area-by-weekday').html('');

      Morris.Area({
        element: 'area',
        data: filledGraphData,
        xkey: 'moment',
        ykeys: ['turnoverTTC', 'averageTTC'],
        labels: [_I18n2.default.tr('order.statistics.turnover'), _I18n2.default.tr('order.statistics.average')],
        hideHover: 'auto',
        resize: true,
        pointSize: 0,
        lineWidth: 2,
        smooth: false,
        fillOpacity: 0.1,
        lineColors: ['#5CB85C', '#337AB7'],
        behaveLikeLine: true,
        dateFormat: function dateFormat(date) {
          return (0, _moment2.default)(date).format(format);
        },
        yLabelFormat: function yLabelFormat(value) {
          return _CurrencyUtils2.default.formatMillionPriceWithCurrency(value, _this3.state.restaurant.currency);
        }
      });

      Morris.Donut({
        element: 'donut-modes',
        colors: _ViewConstants2.default.Graph.DONUT_ORDERS_COLORS,
        data: _lodash2.default.keys(this.state.orderStatisticsState.data.sums.modes).map(function (mode) {
          return {
            label: _OrderViewUtils2.default.getLabelForMode(_Order2.default.OrderMode[mode]),
            value: (_this3.state.orderStatisticsState.data.sums.modes[mode].turnoverTTC * 100 / _this3.state.orderStatisticsState.data.sums.total.turnoverTTC).toFixed(2)
          };
        }),
        formatter: function formatter(value) {
          return value + ' %';
        },
        resize: true
      });

      Morris.Donut({
        element: 'donut-sources',
        colors: _ViewConstants2.default.Graph.DONUT_ORDERS_COLORS,
        data: _lodash2.default.keys(this.state.orderStatisticsState.data.sums.sources).map(function (source) {
          var sourceObj = _lodash2.default.find(_this3.sourcesList, function (s) {
            // s.value is integer, source is string, but there are both the int id.
            return s.value === _lodash2.default.toInteger(source);
          });

          return {
            label: source == 0 ? _I18n2.default.tr('order.statistics.other') : _lodash2.default.isNil(sourceObj) ? 'N/A' : sourceObj.label,
            value: (_this3.state.orderStatisticsState.data.sums.sources[source].turnoverTTC * 100 / _this3.state.orderStatisticsState.data.sums.total.turnoverTTC).toFixed(2)
          };
        }),
        formatter: function formatter(value) {
          return value + ' %';
        },
        resize: true
      });

      Morris.Donut({
        element: 'donut-payments',
        colors: _ViewConstants2.default.Graph.DONUT_ORDERS_COLORS,
        data: _lodash2.default.keys(this.state.orderStatisticsState.data.sums.payments).map(function (payment) {
          return {
            label: _I18n2.default.tr('payments.method.' + payment),
            value: (_this3.state.orderStatisticsState.data.sums.payments[payment].turnoverTTC * 100 / _this3.state.orderStatisticsState.data.sums.total.turnoverTTC).toFixed(2)
          };
        }),
        formatter: function formatter(value) {
          return value + ' %';
        },
        resize: true
      });

      Morris.Area({
        element: 'area-by-weekday',
        data: graphDataByWeekday,
        xkey: 'moment',
        ykeys: this.state.weekdaysFilters,
        labels: this.state.weekdaysFilters.map(function (filter) {
          return _this3.weekdaysFilters[filter].label;
        }),
        hideHover: 'auto',
        resize: true,
        pointSize: 0,
        lineWidth: 2,
        smooth: false,
        fillOpacity: 0.1,
        lineColors: this.state.weekdaysFilters.map(function (filter) {
          return _this3.weekdaysFilters[filter].color;
        }),
        behaveLikeLine: true,
        dateFormat: function dateFormat(date) {
          return (0, _moment2.default)(date).format('HH:mm');
        },
        xLabelFormat: function xLabelFormat(date) {
          return (0, _moment2.default)(date).format('HH:mm');
        },
        yLabelFormat: function yLabelFormat(value) {
          return _CurrencyUtils2.default.formatMillionPriceWithCurrency(value, _this3.state.restaurant.currency);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var orderStatisticsState = this.state.orderStatisticsState;
      var apiConsumersState = this.state.apiConsumersState;

      if (_lodash2.default.isEqual(_stores.OrderStatisticsStore.getInitialState(), orderStatisticsState) || _lodash2.default.isEqual(_stores.ApiConsumersStore.getInitialState(), apiConsumersState)) {
        return this.renderLoading();
      }

      return _react2.default.createElement(
        'div',
        { className: 'stat_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        !apiConsumersState.isFetching && _react2.default.createElement(_Filters2.default, {
          isLoading: this.state.orderStatisticsState.isFetching,
          sourcesList: this.state.sourcesList,
          modes: this.state.modes,
          paymentMethods: this.state.paymentMethods,
          timelapse: this.state.timelapse,
          updateFilters: this.onUpdateFilters,
          updateModes: this.onUpdateModes,
          updateTimelapse: this.onUpdateTimelapse
        }),
        orderStatisticsState.isFetching ? this.renderOnLoadingContent() : _react2.default.createElement(_View2.default, {
          data: orderStatisticsState.data,
          orderModes: this.orderModes,
          paymentMethods: this.paymentMethods,
          sourcesList: this.sourcesList,
          apiError: orderStatisticsState.apiError,
          salesFilters: this.salesFilters,
          salesFiltersState: this.state.salesFilters,
          weekdaysFilters: this.weekdaysFilters,
          weekdaysFiltersState: this.state.weekdaysFilters,
          changeFilters: this.handleChangeFraphFilters,
          currencyCode: this.state.restaurant.currency
        })
      );
    }
  }, {
    key: 'orderModes',
    get: function get() {
      return _lodash2.default.keys(_Order2.default.OrderMode).map(function (mode) {
        return {
          label: _OrderViewUtils2.default.getLabelForMode(_Order2.default.OrderMode[mode]),
          value: mode
        };
      });
    }
  }, {
    key: 'paymentMethods',
    get: function get() {
      return _lodash2.default.keys(_PaymentMethod2.default).map(function (value) {
        return {
          label: _I18n2.default.tr('payments.method.' + value),
          value: value
        };
      });
    }
  }, {
    key: 'salesFilters',
    get: function get() {
      return {
        hour: {
          label: _I18n2.default.tr('order.statistics.salesFilters.hour'),
          filter: 'YYYY-MM-DD HH:mm'
        },
        day: {
          label: _I18n2.default.tr('order.statistics.salesFilters.day'),
          filter: 'YYYY-MM-DD'
        },
        week: {
          label: _I18n2.default.tr('order.statistics.salesFilters.week'),
          filter: 'YYYY-MM-DD'
        },
        month: {
          label: _I18n2.default.tr('order.statistics.salesFilters.month'),
          filter: 'YYYY-MM'
        }
      };
    }
  }, {
    key: 'weekdaysFilters',
    get: function get() {
      return {
        monday: {
          label: _I18n2.default.tr('global.days.monday'),
          filter: 1,
          color: '#0074D9'
        },
        tuesday: {
          label: _I18n2.default.tr('global.days.tuesday'),
          filter: 2,
          color: '#7FDBFF'
        },
        wednesday: {
          label: _I18n2.default.tr('global.days.wednesday'),
          filter: 3,
          color: '#2ECC40'
        },
        thursday: {
          label: _I18n2.default.tr('global.days.thursday'),
          filter: 4,
          color: '#94FFA6'
        },
        friday: {
          label: _I18n2.default.tr('global.days.friday'),
          filter: 5,
          color: '#FFDC00'
        },
        saturday: {
          label: _I18n2.default.tr('global.days.saturday'),
          filter: 6,
          color: '#FF851B'
        },
        sunday: {
          label: _I18n2.default.tr('global.days.sunday'),
          filter: 7,
          color: '#FF4136'
        },
        average: {
          label: _I18n2.default.tr('order.statistics.filters.average'),
          filter: -1,
          color: '#000000'
        }
      };
    }
  }]);

  return OrderStatistics;
}(_AbstractComponent3.default);

exports.default = OrderStatistics;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderStatistics, 'OrderStatistics', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/order/statistics/index.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/order/statistics/style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./scripts/pages/other/CGUPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CGUPage;

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CGUPage(props) {
  return _react2.default.createElement(
    'div',
    { id: 'cgu' },
    _react2.default.createElement(
      'h1',
      null,
      'CONDITIONS G\xC9N\xC9RALES D\u2019UTILISATION PAYMYTABLE'
    ),
    _react2.default.createElement(
      'p',
      { className: 'subtitle' },
      'LES PR\xC9SENTES CONDITIONS G\xC9N\xC9RALES D\u2019UTILISATION D\xC9CRIVENT LES CONDITIONS DANS LESQUELLES LES UTILISATEURS PARTICULIERS B\xC9N\xC9FICIENT DES SERVICES PAYMYTABLE. ELLES DOIVENT IMP\xC9RATIVEMENT \xCATRE LUES ET ACCEPT\xC9ES.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '1. Objet'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les pr\xE9sentes Conditions G\xE9n\xE9rales d\u2019Utilisation (ci-apr\xE8s les ',
      _react2.default.createElement(
        'b',
        null,
        'CGU'
      ),
      ') visent \xE0 d\xE9crire les conditions d\u2019utilisation des services propos\xE9s par PAYMYTABLE, soci\xE9t\xE9 par actions simplifi\xE9e au capital social de 1,000 euros dont le si\xE8ge social est situ\xE9 au 4 rue Amont-Thi\xE9ville, 75017 Paris, immatricul\xE9e au registre du commerce et des soci\xE9t\xE9s de Paris sous le num\xE9ro 809 471 121 (ci-apr\xE8s ',
      _react2.default.createElement(
        'b',
        null,
        'PAYMYTABLE'
      ),
      '). Les services propos\xE9s permettent aux Utilisateurs Particuliers PAYMYTABLE :',
      _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
          'li',
          null,
          'de r\xE9gler leur addition en totalit\xE9 ou en partie,par l\u2019interm\xE9diaire d\u2019un compte de monnaie \xE9lectronique, en se connectant sur l\u2019application PAYMYTABLE \xE0 la fin du repas ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          'de localiser les \xE9tablissements acceptant le mode de paiement PAYMYTABLE ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          'de b\xE9n\xE9ficier d\u2019offres promotionnelles.'
        )
      ),
      'Durant la phase de pr\xE9 d\xE9ploiement du Service PAYMYTABLE qui s\u2019ach\xE8ve le [\u2026], PAYMYTABLE ne peut garantir le parfait fonctionnement de son Service, ce que son Utilisateur Particulier, ayant choisi de participer \xE0 ladite exp\xE9rimentation, accepte par avance.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '2.                  D\xE9finitions'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Pour les besoins des pr\xE9sentes CGU, les mots ou expressions suivants ont le sens qui leur est attribu\xE9 ci-dessous :'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Achat de Monnaie \xC9lectronique :'
      ),
      ' une op\xE9ration visant la recharge du Compte de Monnaie \xC9lectronique de l\u2019Utilisateur Particulier du montant renseign\xE9 par ce dernier sur l\u2019Application mobile PAYMYTABLE en vue du paiement d\u2019un B\xE9n\xE9ficiaire.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Application mobile :'
      ),
      ' programme t\xE9l\xE9chargeable et ex\xE9cutable \xE0 partir du syst\xE8me d\u2019exploitation d\u2019un appareil \xE9lectronique mobile, ci-apr\xE8s appel\xE9 \xAB Smartphone \xBB, qui permet une connexion \xE0 internet.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Banque :'
      ),
      ' Cr\xE9dit Mutuel Ark\xE9a et ING Luxembourg ou tout autre \xE9tablissement de cr\xE9dit agr\xE9\xE9 dans un pays membre de l\u2019Espace \xC9conomique Europ\xE9en, que l\u2019\xC9metteur pourrait lui substituer \xE0 l\'avenir.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'B\xE9n\xE9ficiaire :'
      ),
      ' Utilisateur Professionnel au profit duquel est transf\xE9r\xE9e la Monnaie \xC9lectronique dans le cadre d\u2019une Op\xE9ration de Paiement.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Carte bancaire :'
      ),
      ' une carte de paiement ou de cr\xE9dit, valable en France et en cours de validit\xE9, sous r\xE9serve de son acceptation par l\u2019\xC9metteur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Conditions G\xE9n\xE9rales d\u2019Utilisation ou Contrat :'
      ),
      ' les pr\xE9sentes Conditions G\xE9n\xE9rales d\u2019Utilisation\xE9tant entendu que celles-ci int\xE8grent les Conditions Particuli\xE8res d\u2019Utilisation telles que d\xE9crites \xE0 l\u2019article 8.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Compte :'
      ),
      ' le compte de monnaie \xE9lectronique cr\xE9\xE9 au nom de l\u2019Utilisateur sur demande du Distributeur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Distributeur :'
      ),
      ' PAYMYTABLE SAS, exploitant le Site et offrant \xE0 ses Utilisateurs d\u2019ouvrir un compte, d\u2019acqu\xE9rir de la Monnaie \xC9lectronique \xE9mise par l\u2019\xC9metteur par l\u2019interm\xE9diaire du Site et d\u2019utiliser la Monnaie \xC9lectronique en vue de r\xE9aliser une Op\xE9ration de Paiement aupr\xE8s d\u2019un Utilisateur Professionnel.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        '\xC9metteur :'
      ),
      ' Leetchi Corp. SA, soci\xE9t\xE9 anonyme de droit luxembourgeois, au capital de 500,000 euros, dont le si\xE8ge social est situ\xE9 14 rue Aldringen, L-1118 Luxembourg, immatricul\xE9e au registre du commerce et des soci\xE9t\xE9s luxembourgeois sous le num\xE9ro B173459, agr\xE9\xE9 en tant qu\u2019\xC9tablissement de Monnaie \xC9lectronique par la Commission de Surveillance du Secteur Financier du Luxembourg et habilit\xE9e \xE0 exercer en France  par  l\u2019Autorit\xE9 de Contr\xF4le Prudentiel et de R\xE9solution sous la r\xE9f\xE9rence 74521.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Espace personnel :'
      ),
      ' l\u2019espace personnel de l\u2019Utilisateur sur le Site accessible par la saisine des Identifiants de connexion et permettant l\u2019acc\xE8s aux Services PAYMYTABLE.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Identifiant :'
      ),
      ' les donn\xE9es n\xE9cessaires \xE0 l\u2019identification d\u2019un Utilisateur par l\u2019\xC9metteur se composant d\'un User (adresse email valide) et d\'un mot de passe.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Jour ouvr\xE9 :'
      ),
      ' un jour calendrier, \xE0 l\u2019exception des samedis, dimanches et jours f\xE9ri\xE9s en France m\xE9tropolitaine.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'MANGOPAY :'
      ),
      ' l\u2019interface de programmation (Application Programming Interface) mis \xE0 la disposition de PAYMYTABLE par l\u2019\xC9metteur pour les besoins de la mise en \u0153uvre sur le site d\u2019une fonctionnalit\xE9 de paiement par \xE9mission de Monnaie \xC9lectronique.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Monnaie \xC9lectronique :'
      ),
      ' la valeur mon\xE9taire stock\xE9e sous forme \xE9lectronique sur le serveur de l\u2019\xC9metteur et repr\xE9sentant une cr\xE9ance de l\u2019Utilisateur sur ce dernier. La Monnaie \xC9lectronique est \xE9mise par l\u2019\xC9metteur contre la remise des fonds correspondants par l\u2019Utilisateur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Op\xE9ration de Paiement :'
      ),
      ' le paiement \xE0 partir du Compte \xC9lectronique d\u2019un Utilisateur vers le Compte \xC9lectronique PAYMYTABLE en vue de cr\xE9diter le Compte \xC9lectronique du Restaurateur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Remboursement :'
      ),
      ' l\u2019op\xE9ration de remboursement par l\u2019\xC9metteur de tout ou partie de la cr\xE9ance de Monnaie \xC9lectronique d\xE9tenue par un Utilisateur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Retrait :'
      ),
      ' une demande de virement sur son compte bancaire par le B\xE9n\xE9ficiaire de tout ou partie du montant de sa cr\xE9ance de Monnaie \xC9lectronique sur l\u2019\xC9metteur, diminu\xE9 des frais applicables, et en tout \xE9tat de cause dans la limite de la r\xE8glementation applicable.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Site :'
      ),
      ' Application mobile ou site internet PAYMYTABLE permettant l\u2019acc\xE8s aux Services PAYMYTABLE.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Services :'
      ),
      ' l\u2019ensemble des services fournis par PAYMYTABLE, payants ou gratuits.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Transaction :'
      ),
      ' transaction conclue par un Utilisateur Particulier et un Utilisateur Professionnel dans les conditions vis\xE9es aux pr\xE9sentes et donnant lieu \xE0 une Op\xE9ration de Paiement.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Utilisateur :'
      ),
      ' tout utilisateur PAYMYTABLE, Particulier ou Professionnel.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Utilisateur Particulier :'
      ),
      ' personne physique ayant install\xE9 l\u2019Application Mobile PAYMYTABLE et ayant lu et accept\xE9 les pr\xE9sentes Conditions G\xE9n\xE9rales d\u2019Utilisation.'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Utilisateur Professionnel :'
      ),
      ' tout commer\xE7ant acceptant le mode de paiement PAYMYTABLE et ayant accept\xE9 les Conditions G\xE9n\xE9rales de Vente.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '3. Champ d\u2019application'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les pr\xE9sentes CGU s\u2019appliquent sans restriction ni r\xE9serve, \xE0 l\u2019ensemble des Services propos\xE9es par PAYMYTABLE sur son Site.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Ces CGU pr\xE9valent sur toutes autres conditions g\xE9n\xE9rales ou particuli\xE8res non express\xE9ment agr\xE9\xE9es par PAYMYTABLE. Nous attirons votre attention sur le fait que seuls les Utilisateurs ayant lu et accept\xE9 les pr\xE9sentes CGU peuvent b\xE9n\xE9ficier des Services propos\xE9s par PAYMYTABLE.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '4. Identifiant et mot de passe'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Lors de son inscription aux Services PAYMYTABLE, l\u2019Utilisateur sera invit\xE9 \xE0 cr\xE9er un identifiant et un mot de passe lui permettant d\u2019acc\xE9der \xE0 son Espace Personnel. Ces identifiants sont personnels et confidentiels. Ils ne peuvent \xEAtre chang\xE9s que sur demande de l\u2019Utilisateur ou \xE0 l\u2019initiative de PAYMYTABLE.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur est seul et enti\xE8rement responsable de l\u2019utilisation des identifiants le concernant et s\u2019engage \xE0 mettre tout en \u0153uvre pour conserver secret ses identifiants et \xE0 ne pas les divulguer, \xE0 qui que ce soit, sous quelque forme que ce soit et pour quelque raison que ce soit.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Par ailleurs, PAYMYTABLE recommande aux Utilisateurs de param\xE9trer un mot de passe \xE0 4 chiffres qui s\u2019activera \xE0 chaque ouverture de l\u2019Application.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur sera responsable de l\u2019utilisation de ses identifiants par des tiers ou des actions ou d\xE9clarations faites par l\u2019interm\xE9diaire de son Compte PAYMYTABLE, qu\u2019elles soient frauduleuses ou non et garantir PAYMYTABLE contre toute demande \xE0 ce titre.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'PAYMYTABLE n\u2019ayant pas l\u2019obligation et en disposant pas des moyens techniques de v\xE9rification des identit\xE9s des personnes qui s\u2019inscrivent sur son Site, celui-ci ne sera pas responsable en cas d\u2019usurpation d\u2019identit\xE9 de l\u2019Utilisateur. Si l\u2019Utilisateur a des raisons de penser que son identit\xE9 a \xE9t\xE9 frauduleusement utilis\xE9e, il doit en informer PAYMYTABLE imm\xE9diatement.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'En cas de perte ou de vol de son Smartphone, l\u2019Utilisateur est responsable de toute cons\xE9quence dommageable de cette perte ou de ce vol, et doit utiliser la proc\xE9dure ad\xE9quate afin de changer ses identifiants.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Dans l\u2019hypoth\xE8se o\xF9 il aurait connaissance de l\u2019acc\xE8s d\u2019une autre personne \xE0 son Espace Personnel, l\u2019Utilisateur en informera imm\xE9diatement le responsable du Site par e-mail \xE0 l\u2019adresse [\u2026].'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '5. Fonctionnement des paiements'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Lorsque l\u2019Utilisateur souhaite r\xE9gler son addition, il ouvrira l\u2019Application PAYMYTABLE et suivra les instructions. PAYMYTABLE offre la possibilit\xE9 \xE0 ses Utilisateurs soit de r\xE9gler la totalit\xE9 de l\u2019addition soit de partager celle-ci avec d\u2019autres Utilisateurs Particuliers.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le Compte de Monnaie \xC9lectronique sera automatiquement recharg\xE9 du montant renseign\xE9 par l\u2019Utilisateur  en vue du paiement de l\u2019Utilisateur Professionnel.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '6. Compte PAYMYTABLE limit\xE9'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le compte cr\xE9\xE9 par d\xE9faut est un compte limit\xE9, permettant \xE0 l\u2019Utilisateur d\u2019effectuer des Op\xE9rations de paiement dans les limites de 2 500 (deux mille cinq cent) euros par ann\xE9e civile et d\u2019effectuer des remboursements d\u2019un montant maximum de 1000 (mille) euros par ann\xE9e civile.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Lorsque l\u2019Utilisateur souhaite d\xE9passer ces montants il sera invit\xE9 \xE0 fournir les documents requis par loi dont les d\xE9tails se trouvent ci-dessous \xE0 l\u2019article 8.3.3.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '7. Compte PAYMYTABLE illimit\xE9'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Lorsqu\u2019un Utilisateur aura fourni toute la documentation requise par la loiil pourra b\xE9n\xE9ficier des Services PAYMYTABLE sans limitation de montant.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '8. Conditions particuli\xE8res d\u2019utilisation de la Monnaie \xC9lectronique'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Vous trouverez ci-dessous les conditions particuli\xE8res tenant \xE0 la cr\xE9ation et \xE0 l\u2019utilisation de la Monnaie \xC9lectronique \xE9mise par l\u2019\xC9metteur et mise \xE0 disposition de l\u2019Utilisateur par l\u2019interm\xE9diaire de MANGOPAY.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les pr\xE9sentes Conditions Particuli\xE8res d\u2019Utilisation sont conclues entre :'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le client, personne physique majeure capable, utilisant la monnaie \xE9lectronique \xE9mise par Leetchi Corp. S.A \xE0 travers la solution MANGOPAY., en son propre nom ou pour le compte d\u2019une personne morale ou une association, ci-apr\xE8s d\xE9nomm\xE9 \xAB Vous \xBB ou l\u2019\xAB Utilisateur \xBB, d\u2019une part ;'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Leetchi Corp. S.A., soci\xE9t\xE9 anonyme de droit luxembourgeois, au capital de 500 000 euros, dont le si\xE8ge social est situ\xE9 14 rue Aldringen, L-1118 Luxembourg. et immatricul\xE9e au registre du commerce et des soci\xE9t\xE9s luxembourgeois sous le num\xE9ro B173459, ci-apr\xE8s d\xE9nomm\xE9e \xAB Leetchi\xBB ou \xAB l\u2019\xC9metteur\xBB, d\u2019autre part ;'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Ci-apr\xE8s ensemble d\xE9nomm\xE9es les \xAB Parties \xBB,'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Veuillez lire attentivement les pr\xE9sentes Conditions Particuli\xE8res du service MANGOPAY et d\'Utilisation de la Monnaie \xC9lectronique. Si vous souhaitez devenir Utilisateur, vous devez lire les pr\xE9sentes Conditions Particuli\xE8resd\'Utilisation et les accepter dans le cadre du processus d\'inscription. Vous d\xE9clarez que vous \xEAtes r\xE9sident enFrance. Le cas \xE9ch\xE9ant, vous vous engagez \xE0 quitter le site r\xE9serv\xE9 \xE0 ces utilisateurs et \xE0 vous connecter sur le site correspondant \xE0 votre pays de r\xE9sidence sur lequel vous trouverez les conditions g\xE9n\xE9rales d\u2019utilisation qui vous sont applicables.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.1 Objet'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les pr\xE9sentes Conditions Particuli\xE8res d\u2019Utilisation ont pour objet de d\xE9finir les conditions dans lesquelles l\u2019\xC9metteur fournit \xE0 l\u2019Utilisateur les services d\u2019\xE9mission, utilisation et gestion de la Monnaie \xC9lectronique \xE9mise par l\u2019\xC9metteur, pour les besoins des Op\xE9rations de Paiement.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les pr\xE9sentes Conditions Particuli\xE8res constituent l\'int\xE9gralit\xE9 du Contrat conclu entre les Parties au titre de l\u2019\xE9mission, de l\u2019utilisation et de la gestion de la Monnaie \xC9lectronique \xE9mise par l\u2019\xC9metteur ; elles sont incorpor\xE9es par r\xE9f\xE9rence aux Conditions G\xE9n\xE9rales du Site liant le Distributeur et l\u2019Utilisateur au titre des modalit\xE9s de paiement aff\xE9rentes aux Transactions.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur peut \xE0 tout moment et sans frais se procurer une copie de ces documents en se rendant sur le Site.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Seul le Contrat fera foi entre les Parties en cas de litige.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.2 Inscription de l\u2019Utilisateur'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.2.1        Conditions n\xE9cessaires et pr\xE9alables \xE0 l\u2019inscription'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Afin de s\u2019inscrire, l\u2019Utilisateur doit \xEAtre une personne physique \xE2g\xE9e d\u2019au moins 18 (dix-huit) ans et \xEAtre juridiquement capable. Il d\xE9clare agir pour son compte pendant toute la dur\xE9e du Contrat.'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.2.2 Proc\xE9dure d\u2019inscription et d\u2019ouverture d\u2019un Compte d\u2019Utilisateur'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Lors de son inscription, l\u2019Utilisateur devra notamment transmettre son nom, pr\xE9nom, adresse mail et date de naissance ; nationalit\xE9 ; pays de r\xE9sidence.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur devra indiquer un Identifiant, compos\xE9 d\'un User (adresse email valide) et un mot de passe. Il est enti\xE8rement responsable du maintien de la confidentialit\xE9 de son Identifiant. Il accepte de ne pas utiliser lesComptes, nom ou Identifiant d\'un autre utilisateur \xE0 aucun moment, ni de divulguer son Identifiant \xE0 un tiers. Il accepte d\'avertir imm\xE9diatement le Distributeur, dans le cas o\xF9 il soup\xE7onne une utilisation non autoris\xE9e de sonIdentifiant \xE0 l\u2019adresse suivante : [Adresse service Client]. Il est seul responsable de toute utilisation de son Identifiant.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'En acceptant les pr\xE9sentes Conditions Particuli\xE8res d\u2019Utilisation, vous acceptez que le Distributeur r\xE9alise votre inscription au service de l\u2019\xC9metteur d\xE8s qu\u2019il le jugera n\xE9cessaire. La cr\xE9ation de votre Compte Utilisateur formalise la formation du Contrat. L\u2019\xC9metteur et le Distributeur pourront, sans motivation, ni droit \xE0 indemnit\xE9 pour l\u2019Utilisateur, ne pas donner suite \xE0 une demande d\u2019inscription. L\u2019\xC9metteur se r\xE9serve \xE0 tout moment le droit de demander, par l\u2019interm\xE9diaire du Distributeur, des informations et donn\xE9es d\u2019identification compl\xE9mentaires, ainsi que toutes pi\xE8ces justificatives qu\u2019il estimera utiles.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur d\xE9clare au moment de son inscription et pendant toute la dur\xE9e du Contrat :',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '(a) qu\u2019il est \xE2g\xE9 d\'au moins 18 (dix-huit) ans ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          '(b) que toutes les informations fournies lors de son inscription sont sinc\xE8res et exactes et \xE0 jour.'
        )
      )
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.2.3 Limites d\u2019utilisation du Compte de Monnaie \xC9lectronique'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Tant que l\u2019Utilisateur n\u2019aura pas transmis les documents vis\xE9s ci-apr\xE8s requis par l\u2019\xC9metteur et lui permettant de contr\xF4ler son identit\xE9, les limites suivantes s\u2019imposeront \xE0 l\u2019Utilisateur :',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 un montant total de 2.500 euros maximum de Monnaie \xC9lectronique d\xE9tenue par un Utilisateur aucours d\u2019une m\xEAme ann\xE9e civile par l\u2019interm\xE9diaire du m\xEAme Site, et'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 un montant total de 1.000 euros maximum de remboursement de Monnaie \xC9lectronique au cours d\u2019une m\xEAme ann\xE9e civile par l\u2019interm\xE9diaire du m\xEAme Site.'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'A r\xE9ception des documents suivants sous r\xE9serve qu\u2019ils soient jug\xE9s satisfaisants par l\u2019\xC9metteur, celui-ci pourra d\xE9bloquer les limites applicables \xE0 l\u2019Utilisateur personne physique :',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 une copie d\u2019un document officiel d\u2019identit\xE9 en cours de validit\xE9 : pour les citoyens fran\xE7ais, carted\u2019identit\xE9 fran\xE7aise (recto-verso), pour les \xE9trangers r\xE9sidant en France ou \xE0 l\u2019\xE9tranger, passeport,'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'Si le B\xE9n\xE9ficiaire n\u2019est pas le b\xE9n\xE9ficiaire effectif des fonds, l\u2019identit\xE9 du b\xE9n\xE9ficiaire effectif avec une copie de sa pi\xE8ce d\u2019identit\xE9 fran\xE7aise ou de passeport si le b\xE9n\xE9ficiaire effectif est \xE9tranger, et\xE9ventuellement,',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 un justificatif de domicile qui pourra \xEAtre demand\xE9 \xE0 la discr\xE9tion de l\u2019\xC9metteur.'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'A r\xE9ception des documents suivants sous r\xE9serve qu\u2019ils soient jug\xE9s satisfaisants par l\u2019\xC9metteur, celui-ci pourrad\xE9bloquer les limites applicables \xE0 l\u2019Utilisateur personne morale:',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 les statuts'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 un extrait r\xE9cent du registre de commerce,'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 l\u2019adresse du si\xE8ge social et droit r\xE9gissant la constitution et le fonctionnement de la soci\xE9t\xE9,'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 justificatif d\u2019identit\xE9 du dirigeant ou de la personne ayant pouvoir pour engager la soci\xE9t\xE9 dans le cadredes op\xE9rations r\xE9alis\xE9es.'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 un relev\xE9 d\u2019identit\xE9 bancaire au nom de la soci\xE9t\xE9,'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 d\xE9claration de l\u2019ensemble des b\xE9n\xE9ficiaires \xE9conomiques d\xE9tenant plus de 10% du capital, sign\xE9 par leou les dirigeants et obtention d\u2019une pi\xE8ce justificative d\u2019identit\xE9 des b\xE9n\xE9ficiaires effectifs personnesphysiques pourra \xEAtre demand\xE9 \xE0 la discr\xE9tion de l\u2019\xC9metteur.'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'A r\xE9ception des documents suivants sous r\xE9serve qu\u2019ils soient jug\xE9s satisfaisants par l\u2019\xC9metteur, celui-ci pourra d\xE9bloquer les limites applicables \xE0 l\u2019Utilisateur association:',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 statuts'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 justificatif d\u2019identit\xE9 du Pr\xE9sident de l\u2019association'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 r\xE9c\xE9piss\xE9 de d\xE9claration de cr\xE9ation.'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'En outre, il est express\xE9ment pr\xE9vu que l\u2019\xC9metteur se garde la possibilit\xE9 de demander les documents pr\xE9cit\xE9s permettant d\u2019identifier l\u2019Utilisateur et le b\xE9n\xE9ficiaire effectif du Compte conform\xE9ment \xE0 la r\xE9glementation applicable d\xE8s l\u2019ouverture du Compte.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.3 Fonctionnement d\'un Compte'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.3.1 Achat de Monnaie \xC9lectronique'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019acquisition de Monnaie \xC9lectronique peut \xEAtre r\xE9alis\xE9e, par carte bancaire ou tout autre moyen de paiement disponible \xE0 travers la solution MANGOPAY, en une ou plusieurs fois. Le montant en num\xE9raire vers\xE9 par l\u2019Utilisateur est collect\xE9 par l\u2019\xC9metteur en contrepartie d\u2019\xE9mission d\u2019unit\xE9s de Monnaie \xC9lectronique pour une valeur nominale \xE9quivalente et stock\xE9e sur le Compte de l\u2019Utilisateur.'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.3.2 Remboursement li\xE9 \xE0 l\u2019annulation d\u2019achat de Monnaie \xC9lectronique'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur d\xE9tenteur de la Monnaie \xC9lectronique peut demander le Remboursement de tout ou partie de la Monnaie \xC9lectronique \xE0 tout moment avant toute utilisation au profit d\u2019un B\xE9n\xE9ficiaire. Un Remboursement doit \xEAtre valablement demand\xE9 par email \xE0 l\'adresse  [Adresse mail Service Client].'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Il doit indiquer le montant du Remboursement demand\xE9 qui peut \xEAtre partiel ou total. L\u2019\xC9metteur ajuste, en cons\xE9quence, le nombre d\u2019unit\xE9s de Monnaie \xC9lectronique \xE9mises par lui et d\xE9tenues par l\u2019Utilisateur sur le Compte. L\u2019\xC9metteur initie un ordre de cr\xE9dit de la Carte Bancaire dans un d\xE9lai de 5 (cinq) Jours Ouvr\xE9s suivants la r\xE9ception de la demande de l\u2019Utilisateur.'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.3.3 D\xE9tention de Monnaie \xC9lectronique'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le montant de Monnaie \xC9lectronique est d\xE9tenu, \xE0 due concurrence, par l\u2019Utilisateur sur le Compte :',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 jusqu\u2019\xE0 la date de Remboursement, ou'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 jusqu\'\xE0 la date de r\xE9alisation d\u2019une Op\xE9ration de paiement.'
        )
      )
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.3.4 Utilisation de la Monnaie \xC9lectronique en vue de r\xE9aliser une Op\xE9ration de paiement'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le montant des Op\xE9rations de paiement vient s\u2019imputer sur le montant de Monnaie \xC9lectronique inscrite sur leCompte. Lorsque le montant ainsi inscrit est inf\xE9rieur au prix de l\u2019Op\xE9ration de Paiement, l\u2019Utilisateur peut s\u2019acquitter du compl\xE9ment de prix n\xE9cessaire en utilisant l\u2019un des moyens de paiement accept\xE9s le cas \xE9ch\xE9ant par le Site. A l\u2019inverse, lorsqu\u2019il existe un solde r\xE9siduel de Monnaie \xC9lectronique sur le Compte, apr\xE8s l\u2019Op\xE9ration de Paiement, ce dernier peut donner lieu, suivant la d\xE9cision de l\u2019Utilisateur \xE0 une nouvelle Op\xE9ration de Paiement.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteuret le Distributeur demeurent \xE9trangers au lien de droit existant entre l\u2019Utilisateur et le B\xE9n\xE9ficiaire de l\u2019Op\xE9ration de paiement. L\u2019\xC9metteur et le Distributeur ne sauraient \xEAtre tenus responsables des fautes, manquements ou n\xE9gligence de l\u2019Utilisateur ou du B\xE9n\xE9ficiaire l\u2019un envers l\u2019autre.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'La Monnaie \xC9lectronique est transf\xE9r\xE9e \xE0 la suite de l\u2019ex\xE9cution d\u2019une Op\xE9ration de paiement au profit du ou desB\xE9n\xE9ficiaires.'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.3.5 Transmission et ex\xE9cution d\u2019un ordre de Remboursement'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Lorsqu\u2019il souhaite effectuer un Remboursement, l\u2019Utilisateur du Compte proc\xE8de \xE0 son identification sur le Site en indiquant son User (adresse mail valide) et son mot de passe. Il remplit le formulaire de demande de Remboursement dans la section ad\xE9quate et communique le cas \xE9ch\xE9ant les pi\xE8ces justificatives demand\xE9es par l\u2019\xC9metteur. La demande de Remboursement devient irr\xE9vocable, lorsque l\u2019Utilisateur clique sur l\u2019onglet de validation du formulaire. Le Distributeur adresse alors un email de confirmation \xE0 l\u2019Utilisateur, puis proc\xE8de \xE0 l\u2019op\xE9ration de Remboursement suivant le formulaire.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.4 Opposition d\u2019Identifiant contestation d\u2019Op\xE9ration et Reporting'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.4.1 Opposition d\u2019Identifiant'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur doit informer le Distributeur de la perte ou du vol de son Identifiant, du d\xE9tournement ou de touteutilisation non autoris\xE9e de celui-ci ou de ses donn\xE9es d\xE8s qu\u2019il en a connaissance afin d\u2019en demander le blocage. Cette d\xE9claration doit \xEAtre r\xE9alis\xE9e par l\u2019un des moyens suivants:',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7 par appel t\xE9l\xE9phonique au service client du Distributeur au num\xE9ro : [num\xE9ro de t\xE9l\xE9phone Service Client] ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7 directement par message \xE9lectronique \xE0 l\u2019adresse suivante : [Adresse mail Service Client].'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur par l\u2019interm\xE9diaire du Distributeur ex\xE9cutera imm\xE9diatement la demande de mise en opposition de l\u2019Identifiant concern\xE9. L\u2019\xE9v\xE9nement sera enregistr\xE9 et horodat\xE9. Un num\xE9ro d\u2019opposition avec horodatage sera communiqu\xE9 \xE0 l\u2019Utilisateur. Une confirmation \xE9crite de cette mise en opposition sera adress\xE9e par leDistributeur \xE0 l\u2019Utilisateur concern\xE9 par message \xE9lectronique. L\u2019\xC9metteur prend en charge le dossier sur le plan administratif et conserve toutes les traces pendant 18 (dix-huit) mois. Sur demande \xE9crite de l\u2019Utilisateur et avant l\u2019expiration de ce d\xE9lai, l\u2019\xC9metteur communiquera une copie de cette opposition.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Toute demande d\u2019opposition doit \xEAtre confirm\xE9e sans d\xE9lai par l\u2019Utilisateur concern\xE9, par lettre sign\xE9e de ce dernier, remise ou exp\xE9di\xE9e sous pli recommand\xE9, ou email, \xE0 l\u2019\xC9metteur\xE0 l\u2019adresse postale en t\xEAte des pr\xE9sentes ou \xE0 l\u2019adresse suivante : [Adresse mail Service Client]'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur et le Distributeur ne sauraient \xEAtre tenus pour responsable des cons\xE9quences d\u2019une opposition par t\xE9l\xE9copie ou courriel, qui n\u2019\xE9manerait pas de l\u2019Utilisateur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Une demande d\u2019opposition est r\xE9put\xE9e faite \xE0 la date et \xE0 l\u2019heure de r\xE9ception effective de la demande par le Distributeur. En cas de vol ou d\u2019utilisation frauduleuse de l\u2019Identifiant, l\u2019\xC9metteur est habilit\xE9 \xE0 demander par l\u2019interm\xE9diaire du Distributeur, un r\xE9c\xE9piss\xE9 ou une copie du d\xE9p\xF4t de plainte \xE0 l\u2019Utilisateur qui s\u2019engage \xE0 y r\xE9pondre dans les plus brefs d\xE9lais.'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.4.2 Contestation d\u2019une Op\xE9ration'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Pour toute r\xE9clamation relative aux op\xE9rations r\xE9alis\xE9es par l\u2019\xC9metteur dans le cadre des pr\xE9sentes, telles qu\u2019une Op\xE9ration de Paiement ou toute op\xE9ration de d\xE9bit ou de cr\xE9dit du Compte de l\u2019Utilisateur au titre notamment d\u2019un Achat de Monnaie \xC9lectronique, d\u2019un Retrait ou d\u2019un Remboursement, l\u2019Utilisateur est invit\xE9 \xE0 s\u2019adresser au service client du Distributeur ou \xE0 l\u2019adresse indiqu\xE9e \xE0 cet effet dans les Conditions G\xE9n\xE9rales du Site.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur qui souhaite ainsi contester une Op\xE9ration qu\u2019il estime non autoris\xE9e ou mal ex\xE9cut\xE9e doit transmettre sa demande au Distributeur dans les plus brefs d\xE9lais et avant l\u2019expiration d\u2019un d\xE9lai de 13 (treize) mois \xE0 compter de la date de l\u2019Op\xE9ration en question (une \xAB Contestation \xBB).'
    ),
    _react2.default.createElement(
      'p',
      null,
      'La responsabilit\xE9 de l\u2019\xC9metteur et du Distributeur ne sauraient en aucun cas \xEAtre engag\xE9e en cas de faute de l\u2019Utilisateur, de manquement intentionnel ou constitutif d\u2019une n\xE9gligence grave \xE0 ses obligations, de transmission tardive d\u2019une Opposition ou d\u2019une Contestation ou de mauvaise foi.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Apr\xE8s validation d\u2019une Contestation par l\u2019\xC9metteur, ce dernier veillera \xE0 r\xE9tablir sous forme d\u2019un cr\xE9dit temporaire en unit\xE9s de Monnaie \xC9lectronique le Compte de Monnaie \xC9lectronique de l\u2019Utilisateur dans l\u2019\xE9tat dans lequel il \xE9tait avant la r\xE9alisation de l\u2019Op\xE9ration contest\xE9e.'
    ),
    _react2.default.createElement(
      'h4',
      null,
      '8.4.3 Reporting'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur maintiendra dans ses livres le Compte de l\u2019Utilisateur pendant une dur\xE9e r\xE9siduelle de 13 (treize) mois \xE0 compter de la date de chaque Op\xE9ration de Paiement afin de permettre \xE0 l\u2019Utilisateur de formuler d\u2019\xE9ventuelles Contestations. L\u2019Utilisateur peut \xE0 tout moment obtenir, en ligne sur le Site, un \xE9tat d\xE9taill\xE9 des Op\xE9rations de Paiement qu\u2019il a r\xE9alis\xE9es.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Apr\xE8s l\u2019ex\xE9cution de toute Op\xE9ration, l\u2019Utilisateur recevra par courrier du Distributeur les informations suivantes :',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          'a) Une r\xE9f\xE9rence permettant d\'identifier l\'Op\xE9ration concern\xE9e ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          'b) Le cas \xE9ch\xE9ant, les informations relatives aux parties impliqu\xE9es dans l\u2019Op\xE9ration ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          'c) Le montant de l\'Op\xE9ration concern\xE9e ainsi que, le cas \xE9ch\xE9ant, l\u2019objet de l\u2019Op\xE9ration r\xE9alis\xE9e ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          'd) Le montant d\xE9taill\xE9 des Frais applicables le cas \xE9ch\xE9ant ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          'e) Le cas \xE9ch\xE9ant, la date de r\xE9ception de l\'ordre correspondant et/ou la date \xE0 laquelle est ex\xE9cut\xE9 letransfert de Monnaie \xC9lectronique correspondant.'
        )
      )
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.5 Modification du Contrat'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur se r\xE9serve le droit, \xE0 tout moment, de modifier les Conditions Particuli\xE8res d\u2019Utilisation. Elles sont rendues accessibles par le Distributeur \xE0 tous les Utilisateurs \xE0 l\u2019adresse fournie lors de leur inscription.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Tout Utilisateur peut refuser les modifications propos\xE9es et doit notifier son refus au Service Client du Distributeur par lettre recommand\xE9e avec avis de r\xE9ception avant la date d\u2019entr\xE9e en vigueur des modifications propos\xE9es (cachet de la Poste faisant foi) \xE0 [Adresse Distributeur] d\xE9faut d\u2019avoir notifi\xE9 son refus avant la date d\u2019entr\xE9e en vigueur indiqu\xE9e, ou, \xE0 d\xE9faut, avant un d\xE9lai de [7] jours \xE0 compter de leur mise en ligne sur le Site, l\u2019Utilisateur est r\xE9put\xE9 accepter les modifications propos\xE9es. Les relations entre les Parties apr\xE8s la date d\u2019entr\xE9e en vigueur seront alors r\xE9gies par la nouvelle version des Conditions Particuli\xE8res d\u2019Utilisation.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Il est par cons\xE9quent important que l\u2019Utilisateur consulte ses emails et lise r\xE9guli\xE8rement les Conditions Particuli\xE8res d\u2019Utilisation accessibles en ligne sur le Site \xE0 tout moment.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'En cas de refus par l\u2019Utilisateur, ce refus donnera lieu, sans frais, la r\xE9siliation des Conditions Particuli\xE8resd\u2019Utilisation, ainsi qu\u2019au Remboursement des unit\xE9s de Monnaie \xC9lectronique lui appartenant.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.6 Responsabilit\xE9 de l\u2019\xC9metteur au titre de l\'acc\xE8s au Site'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur ne saurait \xEAtre tenu responsable \xE0 l\u2019\xE9gard de l\u2019Utilisateur des \xE9ventuelles erreurs, omissions, interruptions ou retards des op\xE9rations r\xE9alis\xE9es via le Site r\xE9sultant d\u2019un acc\xE8s non autoris\xE9 \xE0 ce dernier.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur ne saurait d\u2019avantage \xEAtre tenu responsable des vols, destructions ou communications non autoris\xE9es de donn\xE9es r\xE9sultant d\u2019un acc\xE8s non autoris\xE9 au Site.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur se r\xE9serve le droit de suspendre temporairement l\'acc\xE8s au Compte en ligne pour des raisonstechniques ou de maintenance sans que ces op\xE9rations n\'ouvrent droit \xE0 une quelconque indemnit\xE9. Il s\'engage \xE0limiter ce type d\'interruptions au strict n\xE9cessaire.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le Distributeur est seul responsable de la s\xE9curit\xE9 et de la confidentialit\xE9 des donn\xE9es \xE9chang\xE9es dans le cadre de l\'utilisation du Site conform\xE9ment aux Conditions G\xE9n\xE9rales du Site, l\u2019\xC9metteur \xE9tant responsable de la s\xE9curit\xE9 et de la confidentialit\xE9 des donn\xE9es qu\u2019il \xE9change avec l\u2019Utilisateur dans le cadre des pr\xE9sentes au titre de la cr\xE9ation et de la gestion de son Compte, ainsi que des Op\xE9rations aff\xE9rentes au Compte.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.7 Cas d\u2019exclusion de responsabilit\xE9 de l\u2019\xC9metteur'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur n\'intervient en aucune mani\xE8re dans les Transactions. L\u2019\xC9metteur n\'exerce aucun contr\xF4le sur la conformit\xE9, la s\xE9curit\xE9, la lic\xE9it\xE9, les caract\xE9ristiques et le caract\xE8re appropri\xE9 des produits objet d\u2019une Transaction. \xC0 cet \xE9gard, il appartient \xE0 l\u2019Utilisateur de prendre toutes les informations utiles avant de proc\xE9der \xE0 une Transaction en toute connaissance de cause. Chaque Transaction r\xE9alis\xE9e par l\u2019Utilisateur donne naissance \xE0 un contrat directement form\xE9 entre lui et le ou les B\xE9n\xE9ficiaires auquel l\u2019\xC9metteur est \xE9tranger. Ce dernier ne pourra en cons\xE9quence \xEAtre tenu responsable de l\u2019inex\xE9cution ou de la mauvaise ex\xE9cution des obligations qui en r\xE9sulte, ni des pr\xE9judices \xE9ventuels caus\xE9 \xE0 l\u2019Utilisateur \xE0 ce titre.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Nonobstant toute disposition contraire dans le pr\xE9sent Contrat, la responsabilit\xE9 de l\u2019\xC9metteur \xE0 l\u2019\xE9gard d\u2019un Utilisateur est limit\xE9e \xE0 la r\xE9paration des dommages directs caus\xE9s par l\u2019inex\xE9cution d\u2019une obligation contractuelle pr\xE9vue aux pr\xE9sentes.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.8 Engagements de l\u2019Utilisateur'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur garantit qu\u2019aucun \xE9l\xE9ment de son profil sur le Site ne porte atteinte aux droits de tiers ni n\'est contraire \xE0 la loi, \xE0 l\u2019ordre public et aux bonnes m\u0153urs.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Il s\u2019engage \xE0 ne pas :',
      _react2.default.createElement(
        'ul',
        { className: 'no-list-type' },
        _react2.default.createElement(
          'li',
          null,
          '\xB7         Ex\xE9cuter le Contrat d\u2019une mani\xE8re ill\xE9gale ou dans des conditions susceptibles d\'endommager, ded\xE9sactiver, de surcharger ou d\'alt\xE9rer le Site ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7         Usurper l\'identit\xE9 d\'une autre personne ou entit\xE9, falsifier ou dissimuler son identit\xE9, son \xE2ge ou cr\xE9erune fausse identit\xE9 quelconque ;'
        ),
        _react2.default.createElement(
          'li',
          null,
          '\xB7         Diffuser des donn\xE9es ou informations personnelles relatives \xE0 un tiers, telles que des adresses postales,num\xE9ros de t\xE9l\xE9phone, adresses \xE9lectroniques, num\xE9ros de cartes bancaire, etc.'
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      'En cas de manquement \xE0 ces obligations, l\u2019\xC9metteur se r\xE9serve le droit de prendre toute mesure appropri\xE9e afin de faire cesser les agissements concern\xE9s. Il sera \xE9galement en droit de suspendre, supprimer et/ou bloquer son acc\xE8s au Compte.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Sans pr\xE9judice des actions judiciaires engag\xE9es par des tiers, l\u2019\xC9metteur est en droit d\u2019exercer \xE0 titre personnel toute action en justice visant \xE0 r\xE9parer les pr\xE9judices qu\u2019il aurait personnellement subis du fait des manquements qui lui sont imputables au titre du pr\xE9sent Contrat.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Si l\u2019Utilisateur constate un manquement aux obligations pr\xE9cit\xE9es, il est invit\xE9 \xE0 signaler \xE0 l\u2019\xC9metteur ces agissements en contactant le service client \xE0 contact@Leetchi-corp.com.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.9 Dur\xE9e des Conditions Particuli\xE8res d\u2019Utilisation et r\xE9siliation'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les Conditions Particuli\xE8res d\u2019Utilisation sont conclues pour une dur\xE9e ind\xE9termin\xE9e \xE0 compter de la r\xE9ception parl\u2019Utilisateur de l\u2019email de confirmation de son inscription. L\u2019Utilisateur peut \xE0 tout moment et moyennant lerespect d\u2019un pr\xE9avis de 30 (trente) jours calendaires, proc\xE9der \xE0 la r\xE9siliation des Conditions Particuli\xE8resd\u2019Utilisation. Cette r\xE9siliation emporte r\xE9siliation de l\u2019ensemble du Contrat et en cons\xE9quence fermeture du Compte. L\u2019Utilisateur doit, pour ce faire, adresser sa notification de r\xE9siliation des pr\xE9sentes au service client, par lettre recommand\xE9e avec accus\xE9 de r\xE9ception, \xE0 l\u2019adresse postale suivante : [Adresse Distributeur]'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur devra d\xE9signer les coordonn\xE9es de son compte bancaire permettant \xE0 l\u2019\xC9metteur de rembourser \xE0 l\u2019Utilisateur la Monnaie \xC9lectronique figurant au cr\xE9dit de son Compte. En l\u2019absence d\u2019indication, il appartient \xE0 l\u2019\xC9metteur de suivre les instructions de Remboursement impliquant le remboursement par cr\xE9dit de la CarteBancaire ayant servi \xE0 l\u2019acquisition de la Monnaie \xC9lectronique. L\u2019\xC9metteur est d\xE9charg\xE9 de toute obligation d\xE8s lors qu\u2019il aura confirm\xE9 \xE0 l\u2019Utilisateur le virement sur le compte bancaire indiqu\xE9 ou le cr\xE9dit sur sa Carte Bancaire du montant de Monnaie \xC9lectronique.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'En cas de nomination d\u2019un successeur de l\u2019\xC9metteur pour \xE9mettre la Monnaie \xC9lectronique distribu\xE9e sur le Site, il appartient au Distributeur de recueillir l\u2019accord express et \xE9crit de l\u2019Utilisateur sur ce changement et d\u2019indiquer \xE0 l\u2019\xC9metteur les modalit\xE9s de transfert des fonds correspondants \xE0 la Monnaie \xC9lectronique diminu\xE9s des frais applicables.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'En cas de manquement grave, fraude, ou impay\xE9s de la part de l\u2019Utilisateur, l\u2019\xC9metteur se r\xE9serve le droit de suspendre ou r\xE9silier les pr\xE9sentes par l\u2019envoi d\u2019un email accompagn\xE9 en cas de r\xE9siliation d\u2019une lettre recommand\xE9e avec avis de r\xE9ception. La r\xE9siliation entraine la suppression du Compte, le cas \xE9ch\xE9ant leRemboursement de l\u2019Utilisateur. Ces Remboursements pourront dans certains cas \xEAtre bloqu\xE9s conform\xE9ment \xE0 la l\xE9gislation en mati\xE8re de lutte contre le blanchiment de capitaux et le financement du terrorisme.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'La r\xE9siliation des Conditions G\xE9n\xE9rales d\u2019Utilisation \xE0 l\u2019initiative de l\u2019\xC9metteurne peut entrainer aucun droit \xE0 indemnit\xE9 au profit de l\u2019Utilisateur, du Distributeur ou du B\xE9n\xE9ficiaire.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.10 Droit de r\xE9tractation'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur dispose d\u2019un d\xE9lai de 14 (quatorze) jours calendaires r\xE9volus pour exercer son droit de r\xE9tractation, sans avoir \xE0 justifier de motif ni supporter de p\xE9nalit\xE9. Ce d\xE9lai de r\xE9tractation commence \xE0 courir \xE0 compter du jour de son inscription en tant qu\u2019Utilisateur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur doit notifier sa demande de r\xE9tractation dans le d\xE9lai imparti au service client du Distributeur par t\xE9l\xE9phone ou par email et adresser un courrier de confirmation \xE0 l\u2019adresse du service client du Distributeur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Au titre de l\u2019exercice de son droit de r\xE9tractation, le Contrat sera r\xE9sili\xE9 sans frais dans les conditions et sous les r\xE9serves pr\xE9vues aux articles L.121-20-8 et suivants du Code de la consommation.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.11 R\xE8gles de lutte contre le blanchiment et le financement du terrorisme'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur est soumis \xE0 l\u2019ensemble de la r\xE9glementation luxembourgeoise et fran\xE7aise relative \xE0 la lutte contre le blanchiment et le financement du terrorisme.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'En application des dispositions de droit fran\xE7ais et luxembourgeois, relatifs \xE0 la participation des organismes financiers \xE0 la lutte contre le blanchiment des capitaux et le financement des activit\xE9s terroristes, l\u2019\xC9metteur est tenu de s\u2019informer aupr\xE8s de tout Utilisateur pour toute op\xE9ration ou relation d\u2019affaires de l\u2019origine, de l\u2019objet etde la destination de l\u2019op\xE9ration ou de l\u2019ouverture du compte. Il doit, par ailleurs, r\xE9aliser toutes les diligencesn\xE9cessaires \xE0 l\u2019identification de l\u2019Utilisateur et le cas \xE9ch\xE9ant, du b\xE9n\xE9ficiaire effectif du Compte et/ou desOp\xE9rations li\xE9es \xE0 celui-ci. L\u2019Utilisateur s\u2019engage \xE0 faire toute diligence pour permettre \xE0 l\u2019\xC9metteur d\u2019effectuer un examen approfondi de l\u2019op\xE9ration, \xE0 l\u2019informer de toute op\xE9ration exceptionnelle par rapport aux op\xE9rations habituellement enregistr\xE9es dans le cadre des pr\xE9sentes et \xE0 lui fournir tout document ou information requis.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur reconna\xEEt que l\u2019\xC9metteur peut mettre un terme ou reporter \xE0 tout moment l\u2019usage d\u2019un identifiant, l\u2019acc\xE8s \xE0 un Compte ou l\u2019ex\xE9cution d\u2019une op\xE9ration ou d\u2019un Remboursement en l\u2019absence d\u2019\xE9l\xE9ment suffisant sur son objet ou sa nature. Il est inform\xE9 qu\u2019une op\xE9ration r\xE9alis\xE9e dans le cadre des pr\xE9sentes peut faire l\u2019objet de l\u2019exercice du droit \xE0 la communication de la cellule de renseignement financier nationale.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur peut, conform\xE9ment \xE0 la r\xE9glementation, acc\xE9der \xE0 toutes les informations ainsi communiqu\xE9es sous r\xE9serve que ce droit d\u2019acc\xE8s ne remette pas en cause la finalit\xE9 de lutte contre le blanchiment des capitaux et le financement du terrorisme lorsque ces donn\xE9es sont relatives au demandeur.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Aucune poursuite et aucune action en responsabilit\xE9 civile ne peut \xEAtre intent\xE9e ni aucune sanction professionnelle prononc\xE9e contre l\u2019\xC9metteur, ses dirigeants ou ses pr\xE9pos\xE9s qui ont fait de bonne foi les d\xE9clarations de soup\xE7on aupr\xE8s de leur autorit\xE9 nationale.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.12 Donn\xE9es \xE0 caract\xE8re personnel et secret professionnel'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019Utilisateur accepte que les coordonn\xE9es et informations nominatives le concernant recueillies par l\u2019\xC9metteur dans le cadre des pr\xE9sentes soient transmises aux soci\xE9t\xE9s du groupe auquel appartiennent l\u2019\xC9metteur ainsi qu\u2019aux prestataires op\xE9rationnels avec lesquelles celui-ci est en relation contractuelle aux fins d\u2019ex\xE9cution des transactions et services propos\xE9s sous r\xE9serve que ces tiers destinataires des donn\xE9es \xE0 caract\xE8re personnel soient soumis \xE0 une r\xE9glementation garantissant un niveau de protection suffisante tel que d\xE9fini \xE0 l\u2019article 561-7 II b du Code Mon\xE9taire et Financier. La liste des tiers destinataires d\u2019informations couvertes par le secret professionnel est accessible sur simple demande aupr\xE8s du responsable de la conformit\xE9 de l\u2019\xC9metteur. Ces informations sont conserv\xE9es par lui ou toute soci\xE9t\xE9 mandat\xE9e \xE0 cet effet, dans les conditions l\xE9gales et r\xE9glementaires.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Certaines informations recueillies et d\xE9tenues par l\u2019\xC9metteur dans le cadre des pr\xE9sentes peuvent donner lieu \xE0 l\u2019exercice du droit d\u2019acc\xE8s et de rectification dans les conditions pr\xE9vues par la loi n\xB078-17 du 6 janvier 1978 modifi\xE9e relative \xE0 l\u2019informatique, aux fichiers et aux libert\xE9s. Tout Utilisateur peut \xE0 tout moment obtenir une copie des informations le concernant sur simple demande adress\xE9e au correspondant CNIL de l\u2019\xC9metteur. Il peut solliciter \xE0 cette m\xEAme adresse une suppression ou une rectification de ces informations par \xE9crit. Il peut \xE0 tout moment s\u2019opposer \xE0 la r\xE9ception de sollicitations commerciales, faire modifier ses coordonn\xE9es, s\u2019opposer \xE0 leur communication en adressant une notification par courrier recommand\xE9e ou courriel suivie d\u2019un accus\xE9 de r\xE9ception \xE0 l\u2019adresse du service client de l\u2019\xC9metteur. Ce courrier devra indiquer nom, pr\xE9nom, et Identifiant.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Conform\xE9ment \xE0 la r\xE9glementation en vigueur, il doit \xE9galement \xEAtre sign\xE9, accompagn\xE9 de la photocopie d\u2019un titre d\u2019identit\xE9 portant la signature de l\u2019Utilisateur et pr\xE9ciser l\u2019adresse \xE0 laquelle il souhaite recevoir la r\xE9ponse.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Une r\xE9ponse lui sera adress\xE9e \xE0 l\u2019adresse indiqu\xE9e dans un d\xE9lai de 2 (deux) mois suivant la r\xE9ception de sa demande.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'L\u2019\xC9metteur conservera les informations et donn\xE9es \xE0 caract\xE8re personnel pendant la dur\xE9e maximum l\xE9gale ou r\xE9glementaire applicable en fonction de la finalit\xE9 de chacun des traitements de donn\xE9es.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les conditions de collecte, de d\xE9tention et d\u2019acc\xE8s des donn\xE9es \xE0 caract\xE8re personnel recueillies par le Distributeur et sous sa responsabilit\xE9 au titre de l\u2019acc\xE8s au Site, sont r\xE9gies aux termes des Conditions G\xE9n\xE9ralesdu Site ainsi que de la charte de confidentialit\xE9 accessible sur le Site.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.13 Comptes inactifs'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le Distributeur et l\u2019\xC9metteur se r\xE9servent le droit de cl\xF4turer des comptes inactifs depuis plus de 24 mois.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.14 Force majeure'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les Parties ne seront pas tenues pour responsables, ou consid\xE9r\xE9es comme ayant failli au titre des pr\xE9sentes, en cas de retard ou inex\xE9cution, lorsque leur cause est li\xE9e \xE0 un cas de force majeure tel que d\xE9fini par la jurisprudence des tribunaux fran\xE7ais.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.15 Incessibilit\xE9'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Le Contrat ne peut faire l\'objet d\'une cession totale ou partielle par l\u2019Utilisateur, \xE0 titre on\xE9reux ou gratuit. Il est par suite interdit de c\xE9der \xE0 un tiers l\'un quelconque des droits ou obligations qu\u2019il tient des pr\xE9sentes. En cas de manquement \xE0 cette interdiction, outre la r\xE9siliation imm\xE9diate des pr\xE9sentes, sa responsabilit\xE9 pourra \xEAtre engag\xE9e par l\u2019\xC9metteur.'
    ),
    _react2.default.createElement(
      'h3',
      null,
      '8.16 Convention de preuve'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Toutes les donn\xE9es reprises de fa\xE7on inalt\xE9rable, fiable, et s\xE9curis\xE9e dans la base de donn\xE9es informatique de l\u2019\xC9metteur relatives notamment aux ordres de paiement et confirmations re\xE7ues de l\u2019Utilisateur, aux notifications envoy\xE9es, aux acc\xE8s, Retrait, Remboursement feront foi entre les parties jusqu\u2019\xE0 preuve du contraire.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '9. Propri\xE9t\xE9 intellectuelle'
    ),
    _react2.default.createElement(
      'p',
      null,
      'PAYMYTABLE conserve la propri\xE9t\xE9 exclusive des droits attach\xE9s aux applications mobiles, logiciels et site internet PAYMYTABLE, ainsi qu\u2019aux noms, marques, noms de domaines, logos ou autres signes distinctifs respectifs qu\u2019elle d\xE9tient.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Les Utilisateurs reconnaissent que seul leur usage au titre du pr\xE9sent Contrat ne leur permet pas de revendiquer des droits de propri\xE9t\xE9 intellectuelle d\u2019aucune sorte sur ceux-ci, demeurant la propri\xE9t\xE9 enti\xE8re de PAYMYTABLE. Le pr\xE9sent Contrat ne conf\xE8re en cons\xE9quence aucune cession ou licence de droits.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '10. Ind\xE9pendance des stipulations contractuelles'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Si l\'une quelconque des stipulations des pr\xE9sentes est tenue pour nulle ou sans objet, elle sera r\xE9put\xE9e non \xE9crite et n\'entra\xEEnera pas la nullit\xE9 des autres stipulations.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Si une ou plusieurs stipulations des pr\xE9sentes deviennent caduques ou sont d\xE9clar\xE9es comme telles en application d\'une loi, d\'un r\xE8glement ou \xE0 la suite d\'une d\xE9cision d\xE9finitive rendue par une juridiction comp\xE9tente, les autres stipulations conserveront leur force obligatoire et leur port\xE9e. Les stipulations d\xE9clar\xE9es nulles et non valides seront alors remplac\xE9es par les stipulations qui se rapprocheront le plus quant \xE0 leur sens et \xE0 leur port\xE9e des stipulations initialement convenues.'
    ),
    _react2.default.createElement(
      'h2',
      null,
      '11. Droit applicable et juridiction comp\xE9tente'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Sauf en cas d\'application d\'une loi d\u2019ordre public (laquelle ne s\'appliquera que dans les strictes limites de sonobjet), il est express\xE9ment stipul\xE9 que les Conditions G\xE9n\xE9rales d\u2019Utilisation ainsi que les Conditions Particuli\xE8res relatives \xE0 la monnaie \xE9lectronique sont soumises \xE0 la loi fran\xE7aise et que tout litige entre les Parties autitre de ces derni\xE8res seront soumises \xE0 la juridiction des tribunaux fran\xE7ais comp\xE9tents.'
    )
  );
}

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CGUPage, 'CGUPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/CGUPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/other/FeatureNonActivatedPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FeatureNonActivatedPage(props) {
  return _react2.default.createElement(
    'div',
    { className: 'top-buffer-50 text-center' },
    _react2.default.createElement('i', { className: 'icon-smiley-down' }),
    _react2.default.createElement(
      'h1',
      { className: 'text-center' },
      _I18n2.default.tr('feature_not_activated')
    )
  );
}

var _default = FeatureNonActivatedPage;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FeatureNonActivatedPage, 'FeatureNonActivatedPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/FeatureNonActivatedPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/FeatureNonActivatedPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/other/NotFoundPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFoundPage(props) {
  return _react2.default.createElement(
    'div',
    { className: 'not_found_page top-buffer-50' },
    _react2.default.createElement(
      'h1',
      { className: 'text-center' },
      _I18n2.default.tr('page_not_found')
    )
  );
}

var _default = NotFoundPage;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NotFoundPage, 'NotFoundPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/NotFoundPage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/NotFoundPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/other/RedirectPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedirectPage = function (_React$Component) {
  _inherits(RedirectPage, _React$Component);

  function RedirectPage(props) {
    _classCallCheck(this, RedirectPage);

    var _this = _possibleConstructorReturn(this, (RedirectPage.__proto__ || Object.getPrototypeOf(RedirectPage)).call(this, props));

    var dataQueryParam = _utils.UrlUtils.getQueryParam('data');

    // - domainId
    // -restaurantId
    // - redirectTo
    var data = JSON.parse(window.atob(dataQueryParam));

    _SessionStore2.default.saveRestaurantsGroupId(data.restaurantsGroupId);
    _SessionStore2.default.saveRestaurantId(data.restaurantId);
    _SessionStore2.default.saveProDomainId(data.domainId);

    window.location = data.redirectTo;
    return _this;
  }

  _createClass(RedirectPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'p',
        null,
        'Redirecting...'
      );
    }
  }]);

  return RedirectPage;
}(_react2.default.Component);

exports.default = RedirectPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RedirectPage, 'RedirectPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/RedirectPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/other/ServerErrorPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ServerErrorPage;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServerErrorPage() {
  return _react2.default.createElement(
    'div',
    { id: 'server_error_page' },
    _react2.default.createElement(
      'h1',
      { className: 'text-center' },
      _I18n2.default.tr('server_error.title')
    ),
    _react2.default.createElement(
      'div',
      { className: 'top-buffer-50 text-center' },
      _react2.default.createElement(
        'h2',
        { className: 'text-center' },
        _I18n2.default.tr('server_error.message')
      ),
      _react2.default.createElement(
        'p',
        { style: { fontStyle: 'italic' }, className: 'top-buffer-50' },
        'Session-id: ' + new URLSearchParams(window.location.search).get('sessionId')
      )
    )
  );
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ServerErrorPage, 'ServerErrorPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/other/ServerErrorPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/ReceiptPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _PaymentAction = __webpack_require__("./scripts/actions/PaymentAction.js");

var _PaymentAction2 = _interopRequireDefault(_PaymentAction);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _PayoutList = __webpack_require__("./sdk/scripts/entities/PayoutList.js");

var _PayoutList2 = _interopRequireDefault(_PayoutList);

var _PayinList = __webpack_require__("./sdk/scripts/entities/PayinList.js");

var _PayinList2 = _interopRequireDefault(_PayinList);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _TimelapsePicker = __webpack_require__("./scripts/components/timelapse/TimelapsePicker.js");

var _TimelapsePicker2 = _interopRequireDefault(_TimelapsePicker);

var _PayinsView = __webpack_require__("./scripts/pages/payment/receipt/components/PayinsView.js");

var _PayinsView2 = _interopRequireDefault(_PayinsView);

var _PayoutsView = __webpack_require__("./scripts/pages/payment/receipt/components/PayoutsView.js");

var _PayoutsView2 = _interopRequireDefault(_PayoutsView);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- stores


// -- actions


// -- stores


// -- constants


// -- entities


// -- components


var ReceiptPage = function (_AbstractComponent) {
  _inherits(ReceiptPage, _AbstractComponent);

  function ReceiptPage() {
    _classCallCheck(this, ReceiptPage);

    var _this = _possibleConstructorReturn(this, (ReceiptPage.__proto__ || Object.getPrototypeOf(ReceiptPage)).call(this));

    _this.state = {
      timelapse: _SessionStore2.default.getTimelapse(),
      payinList: _stores.PaymentReceiptStore.getPayinList(),
      payoutList: _stores.PaymentReceiptStore.getPayoutList(),
      restaurant: _stores.RestaurantStore.getRestaurant()
    };

    _this.onTabChange = function () {
      return _this.__onTabChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onChange = function () {
      return _this.__onChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onTimelapseChange = function () {
      return _this.__onTimelapseChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-line-chart';
    _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.payment'),
      link: _RoutingEnum2.default.STAT_HOME
    }, {
      name: _I18n2.default.tr('menu.payment.stat'),
      link: null
    }];
    return _this;
  }

  _createClass(ReceiptPage, [{
    key: '__onTimelapseChange__REACT_HOT_LOADER__',
    value: function __onTimelapseChange__REACT_HOT_LOADER__() {
      return this.__onTimelapseChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__() {
      return this.__onTabChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_stores.RestaurantStore.getRestaurant().haveFeaturePayment() && !_stores.RestaurantStore.getRestaurant().haveFeatureOrder()) {
        _RouteAction2.default.redirectToFeatureNonActivated();
        return;
      }

      _stores.PaymentReceiptStore.addListener(this.onChange);

      this.loadPayins(this.state.timelapse);
      this.loadPayouts(this.state.timelapse);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.PaymentReceiptStore.removeListener(this.onChange);
    }
  }, {
    key: 'loadPayins',
    value: function loadPayins(timelapse) {
      this.showLoading();
      _PaymentAction2.default.loadPayins(timelapse);
    }
  }, {
    key: 'loadPayouts',
    value: function loadPayouts(timelapse) {
      this.showLoading();
      _PaymentAction2.default.loadPayouts(timelapse);
    }

    // -- actions

  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__(activeKey) {
      if (!_lodash2.default.isUndefined(activeKey)) {
        _SessionStore2.default.saveReceiptPageTab(activeKey);
      }
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var payinList = _stores.PaymentReceiptStore.getPayinList();
      var payoutList = _stores.PaymentReceiptStore.getPayoutList();

      if (!_lodash2.default.isNull(payinList)) {
        _SessionStore2.default.saveTimelapse(payinList.timelapse);
      } else if (!_lodash2.default.isNull(payoutList)) {
        _SessionStore2.default.saveTimelapse(payoutList.timelapse);
      }
      this.setState({
        payinList: payinList,
        payoutList: payoutList,
        timelapse: _SessionStore2.default.getTimelapse(),
        loading: false,
        apiError: _stores.PaymentReceiptStore.getApiError()
      });
    }
  }, {
    key: '__onTimelapseChange__REACT_HOT_LOADER__',
    value: function __onTimelapseChange__REACT_HOT_LOADER__(timelapse) {
      _SessionStore2.default.saveTimelapse(timelapse);

      this.setState({
        payinList: null,
        payoutList: null
      });

      this.loadPayins(timelapse);
      this.loadPayouts(timelapse);
    }
  }, {
    key: 'renderPayinsView',
    value: function renderPayinsView() {
      if (_lodash2.default.isNull(this.state.payinList)) {
        return this.renderOnLoadingContent();
      }

      return _react2.default.createElement(_PayinsView2.default, {
        payinList: this.state.payinList,
        currencyCode: this.state.restaurant.currency
      });
    }
  }, {
    key: 'renderPayoutsView',
    value: function renderPayoutsView() {
      if (_lodash2.default.isNull(this.state.payoutList)) {
        return this.renderOnLoadingContent();
      }

      return _react2.default.createElement(_PayoutsView2.default, {
        payoutList: this.state.payoutList,
        currencyCode: this.state.restaurant.currency
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'receipt_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        this.renderLoading(),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(_TimelapsePicker2.default, {
            className: 'col-xs-12 col-md-6 float-right text-right',
            timelapse: this.state.timelapse,
            onTimelapseChange: this.onTimelapseChange,
            timelapseSelection: _SessionStore2.default.getTimelapseSelection()
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultActiveKey: _SessionStore2.default.getReceiptPageTab(),
            id: 'receipt_page__tabs',
            onSelect: this.onTabChange
          },
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 1,
              title: _I18n2.default.tr('receipt.tabs.payins').toUpperCase()
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderPayinsView()
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: 2,
              title: _I18n2.default.tr('receipt.tabs.payouts').toUpperCase()
            },
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              this.renderPayoutsView()
            )
          )
        )
      );
    }
  }]);

  return ReceiptPage;
}(_AbstractComponent3.default);

exports.default = ReceiptPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ReceiptPage, 'ReceiptPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/ReceiptPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayinsTableView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

var _PayinsForTable = __webpack_require__("./scripts/objects/PayinsForTable.js");

var _PayinsForTable2 = _interopRequireDefault(_PayinsForTable);

var _PayinsTableViewRow = __webpack_require__("./scripts/pages/payment/receipt/components/PayinsTableViewRow.js");

var _PayinsTableViewRow2 = _interopRequireDefault(_PayinsTableViewRow);

var _PayinsTableViewRowDetail = __webpack_require__("./scripts/pages/payment/receipt/components/PayinsTableViewRowDetail.js");

var _PayinsTableViewRowDetail2 = _interopRequireDefault(_PayinsTableViewRowDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PayinsTableView = function (_Component) {
  _inherits(PayinsTableView, _Component);

  function PayinsTableView() {
    _classCallCheck(this, PayinsTableView);

    // bind functions
    var _this = _possibleConstructorReturn(this, (PayinsTableView.__proto__ || Object.getPrototypeOf(PayinsTableView)).call(this));

    _this.state = {
      payinsForTableDetailsToDisplay: [] // Array<PayinsForTable>
    };
    _this._toggleToDisplayDetailList = _this._toggleToDisplayDetailList.bind(_this);
    return _this;
  }

  _createClass(PayinsTableView, [{
    key: '_toggleToDisplayDetailList',
    value: function _toggleToDisplayDetailList(payinsForTableToToggle) {

      var payinsForTableDetailsToDisplay = this.state.payinsForTableDetailsToDisplay;

      // remove on the array to hide the detail
      if (this.isPayinsForTableDetailMustBeDisplay(payinsForTableToToggle)) {
        payinsForTableDetailsToDisplay = _lodash2.default.remove(payinsForTableDetailsToDisplay, function (elem) {
          return elem.checkId !== payinsForTableToToggle.checkId;
        });
      } else {
        // add on the array to display the detail
        payinsForTableDetailsToDisplay.push(payinsForTableToToggle);
      }

      this.setState({
        payinsForTableDetailsToDisplay: payinsForTableDetailsToDisplay
      });
    }

    // -- tools

  }, {
    key: 'isPayinsForTableDetailMustBeDisplay',
    value: function isPayinsForTableDetailMustBeDisplay(payin) {

      var payinsForTableDetailsToDisplay = this.state.payinsForTableDetailsToDisplay;

      var found = _lodash2.default.find(payinsForTableDetailsToDisplay, function (elem) {
        return elem.checkId === payin.checkId;
      });

      return !_lodash2.default.isUndefined(found);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var bodyView = [];

      var payins = this.props.payins;

      _lodash2.default.forEach(payins, function (payinsForTable, key) {

        var mustDisplayDetail = _this2.isPayinsForTableDetailMustBeDisplay(payinsForTable);

        bodyView.push(_react2.default.createElement(_PayinsTableViewRow2.default, {
          payinsForTable: payinsForTable,
          onToggleDetail: _this2._toggleToDisplayDetailList,
          key: payinsForTable.checkId,
          detailIsDisplay: mustDisplayDetail,
          currencyCode: _this2.props.currencyCode
        }));

        // -- Display detail if necessary. Detail is just different rows under the parent row.
        if (mustDisplayDetail) {

          var i = 0;
          payinsForTable.payins.forEach(function (payin) {
            i++;
            bodyView.push(_react2.default.createElement(_PayinsTableViewRowDetail2.default, { payin: payin, key: payin.checkId + '_' + i, currencyCode: _this2.props.currencyCode }));
          });
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'payins_table_view table_container table-responsive' },
        _react2.default.createElement(
          'table',
          { className: 'table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { className: 'col-xs-2' },
                _I18n2.default.tr('payins.table.header.date')
              ),
              _react2.default.createElement(
                'th',
                { className: 'col-xs-1' },
                _I18n2.default.tr('payins.table.header.hour')
              ),
              _react2.default.createElement(
                'th',
                { className: 'text-right col-xs-2' },
                _I18n2.default.tr('payins.table.header.total_table')
              ),
              _react2.default.createElement(
                'th',
                { className: 'text-right col-xs-2' },
                _I18n2.default.tr('payins.table.header.payed_with_pmt')
              ),
              _react2.default.createElement(
                'th',
                { className: 'text-right col-xs-2' },
                _I18n2.default.tr('payins.table.header.including_tips')
              ),
              _react2.default.createElement('th', { className: 'col-xs-1' })
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            bodyView
          )
        )
      );
    }
  }]);

  return PayinsTableView;
}(_react.Component);

PayinsTableView.propTypes = {
  payins: _propTypes2.default.arrayOf(_PayinsForTable2.default),
  totalAmount: _propTypes2.default.number.isRequired,
  totalTips: _propTypes2.default.number.isRequired,
  totalFees: _propTypes2.default.number.isRequired,
  totalTable: _propTypes2.default.number.isRequired,
  currencyCode: _propTypes2.default.string
};
exports.default = PayinsTableView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayinsTableView, 'PayinsTableView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayinsTableView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayinsTableViewRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _PayinsForTable = __webpack_require__("./scripts/objects/PayinsForTable.js");

var _PayinsForTable2 = _interopRequireDefault(_PayinsForTable);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PayinsTableViewRow = function (_Component) {
  _inherits(PayinsTableViewRow, _Component);

  function PayinsTableViewRow() {
    _classCallCheck(this, PayinsTableViewRow);

    // bind functions
    var _this = _possibleConstructorReturn(this, (PayinsTableViewRow.__proto__ || Object.getPrototypeOf(PayinsTableViewRow)).call(this));

    _this._toggleDetail = _this._toggleDetail.bind(_this);
    return _this;
  }

  _createClass(PayinsTableViewRow, [{
    key: '_toggleDetail',
    value: function _toggleDetail() {
      this.props.onToggleDetail(this.props.payinsForTable);
    }
  }, {
    key: 'renderIconZoom',
    value: function renderIconZoom() {
      if (this.props.detailIsDisplay) {
        return _react2.default.createElement('i', { className: 'glyphicon glyphicon-zoom-out' });
      }
      return _react2.default.createElement('i', { className: 'glyphicon glyphicon-zoom-in' });
    }
  }, {
    key: 'render',
    value: function render() {
      var payinsForTable = this.props.payinsForTable;
      var currencyCode = this.props.currencyCode;

      var iconZoomView = this.renderIconZoom();

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          payinsForTable.getFormattedDate()
        ),
        _react2.default.createElement(
          'td',
          null,
          payinsForTable.getFormattedHour()
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          _CurrencyUtils2.default.formatPriceWithCurrency(payinsForTable.totalTable, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          _CurrencyUtils2.default.formatPriceWithCurrency(payinsForTable.amount, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          payinsForTable.tips > 0 && _react2.default.createElement(
            'span',
            null,
            _CurrencyUtils2.default.formatPriceWithCurrency(payinsForTable.tips, currencyCode)
          ),
          payinsForTable.tips === 0 && _react2.default.createElement(
            'span',
            { className: 'empty' },
            ' - '
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          payinsForTable.payins.length > 1 && _react2.default.createElement(
            'button',
            {
              className: 'btn btn-link',
              type: 'button',
              onClick: this._toggleDetail
            },
            iconZoomView
          )
        )
      );
    }
  }]);

  return PayinsTableViewRow;
}(_react.Component);

PayinsTableViewRow.propTypes = {
  onToggleDetail: _propTypes2.default.func.isRequired,
  payinsForTable: _propTypes2.default.objectOf(_PayinsForTable2.default).isRequired,
  detailIsDisplay: _propTypes2.default.bool.isRequired,
  currencyCode: _propTypes2.default.string

};
exports.default = PayinsTableViewRow;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayinsTableViewRow, 'PayinsTableViewRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayinsTableViewRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayinsTableViewRowDetail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PayinsTableViewRowDetail = function (_Component) {
  _inherits(PayinsTableViewRowDetail, _Component);

  function PayinsTableViewRowDetail() {
    _classCallCheck(this, PayinsTableViewRowDetail);

    return _possibleConstructorReturn(this, (PayinsTableViewRowDetail.__proto__ || Object.getPrototypeOf(PayinsTableViewRowDetail)).apply(this, arguments));
  }

  _createClass(PayinsTableViewRowDetail, [{
    key: 'render',
    value: function render() {
      var payin = this.props.payin;
      var currencyCode = this.props.currencyCode;

      return _react2.default.createElement(
        'tr',
        { className: 'payins_table_view_row_detail' },
        _react2.default.createElement(
          'td',
          null,
          payin.getFormattedDate()
        ),
        _react2.default.createElement(
          'td',
          null,
          payin.getFormattedHour()
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          _react2.default.createElement(
            'span',
            { className: 'empty' },
            ' - '
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          _CurrencyUtils2.default.formatPriceWithCurrency(payin.amount + payin.tips, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          payin.tips > 0 && _react2.default.createElement(
            'span',
            null,
            _CurrencyUtils2.default.formatPriceWithCurrency(payin.tips, currencyCode)
          ),
          payin.tips === 0 && _react2.default.createElement(
            'span',
            { className: 'empty' },
            ' - '
          )
        ),
        _react2.default.createElement('td', null)
      );
    }
  }]);

  return PayinsTableViewRowDetail;
}(_react.Component);

PayinsTableViewRowDetail.propTypes = {
  payin: _propTypes2.default.objectOf(_Payin2.default),
  currencyCode: _propTypes2.default.string
};
exports.default = PayinsTableViewRowDetail;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayinsTableViewRowDetail, 'PayinsTableViewRowDetail', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayinsTableViewRowDetail.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayinsView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _PayinList = __webpack_require__("./sdk/scripts/entities/PayinList.js");

var _PayinList2 = _interopRequireDefault(_PayinList);

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

var _PayinsForTable = __webpack_require__("./scripts/objects/PayinsForTable.js");

var _PayinsForTable2 = _interopRequireDefault(_PayinsForTable);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _PayinsTableView = __webpack_require__("./scripts/pages/payment/receipt/components/PayinsTableView.js");

var _PayinsTableView2 = _interopRequireDefault(_PayinsTableView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- objects


// -- components


/**
 * @parent ReceiptPage
 */
var PayinsView = function (_AbstractComponent) {
  _inherits(PayinsView, _AbstractComponent);

  function PayinsView() {
    _classCallCheck(this, PayinsView);

    return _possibleConstructorReturn(this, (PayinsView.__proto__ || Object.getPrototypeOf(PayinsView)).apply(this, arguments));
  }

  _createClass(PayinsView, [{
    key: 'renderNoData',
    value: function renderNoData() {
      // no information to display

      return _react2.default.createElement(
        'div',
        { className: 'payment_payins__no_data' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-xs-offset-3 text-center' },
          _react2.default.createElement('i', { className: 'icon-smiley-down' }),
          _react2.default.createElement(
            'p',
            { className: 'top-buffer-30' },
            _I18n2.default.tr('payins.no_payins')
          )
        )
      );
    }
  }, {
    key: 'renderPayins',
    value: function renderPayins(payinList) {
      var groupedPayinsDic = {};
      payinList.payins.forEach(function (payin) {

        if (_lodash2.default.isUndefined(groupedPayinsDic[payin.checkId])) {
          groupedPayinsDic[payin.checkId] = new _PayinsForTable2.default();
        }

        if (groupedPayinsDic[payin.checkId].date < payin.date) {
          groupedPayinsDic[payin.checkId].date = payin.date;
        }

        groupedPayinsDic[payin.checkId].checkId = payin.checkId;

        // Update check info
        groupedPayinsDic[payin.checkId].totalTable = payin.totalTable;
        groupedPayinsDic[payin.checkId].amount += payin.amount + payin.tips;
        groupedPayinsDic[payin.checkId].tips += payin.tips;
        groupedPayinsDic[payin.checkId].fees += payin.amount + payin.tips - payin.fees;

        // Add the payin to the check
        groupedPayinsDic[payin.checkId].payins.push(payin);
      });

      // -- transform to array
      var groupedPayins = [];

      for (var key in groupedPayinsDic) {
        groupedPayins.push(groupedPayinsDic[key]);
      }

      // -- Calculate totals
      var totalAmount = 0;
      var totalTips = 0;
      var totalFees = 0;
      var totalTable = 0;

      groupedPayins.forEach(function (payinsForTable) {
        totalFees += payinsForTable.fees;
        totalTable += payinsForTable.amount;
        totalAmount += payinsForTable.amount + payinsForTable.tips;
        totalTips += payinsForTable.tips;
      });

      // -- View
      return _react2.default.createElement(
        'div',
        { className: 'payment_payins__data' },
        _react2.default.createElement(_PayinsTableView2.default, {
          payins: groupedPayins,
          totalAmount: totalAmount,
          totalTips: totalTips,
          totalFees: totalFees,
          totalTable: totalTable,
          currencyCode: this.props.currencyCode
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var payinList = this.props.payinList;

      var contentView = null;
      if (!_lodash2.default.isEmpty(payinList.payins)) {
        contentView = this.renderPayins(payinList);
      } else {
        contentView = this.renderNoData();
      }

      return _react2.default.createElement(
        'div',
        { className: 'payment_payins' },
        contentView
      );
    }
  }]);

  return PayinsView;
}(_AbstractComponent3.default);

PayinsView.propTypes = {
  payinList: _propTypes2.default.objectOf(_PayinList2.default).isRequired,
  currencyCode: _propTypes2.default.string

};
exports.default = PayinsView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayinsView, 'PayinsView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayinsView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayoutsTableView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Payout = __webpack_require__("./sdk/scripts/entities/Payout.js");

var _Payout2 = _interopRequireDefault(_Payout);

var _PayoutsTableViewRow = __webpack_require__("./scripts/pages/payment/receipt/components/PayoutsTableViewRow.js");

var _PayoutsTableViewRow2 = _interopRequireDefault(_PayoutsTableViewRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PayoutsTableView = function (_Component) {
  _inherits(PayoutsTableView, _Component);

  function PayoutsTableView() {
    _classCallCheck(this, PayoutsTableView);

    return _possibleConstructorReturn(this, (PayoutsTableView.__proto__ || Object.getPrototypeOf(PayoutsTableView)).apply(this, arguments));
  }

  _createClass(PayoutsTableView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rows = [];

      var payouts = this.props.payouts;

      _lodash2.default.forEach(payouts, function (payout) {
        rows.push(_react2.default.createElement(_PayoutsTableViewRow2.default, {
          payout: payout,
          key: payout.payoutId,
          currencyCode: _this2.props.currencyCode
        }));
      });

      return _react2.default.createElement(
        'div',
        { className: 'payins_table_view table_container table-responsive' },
        _react2.default.createElement(
          'table',
          { className: 'table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('payouts.table.header.id')
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('payouts.table.header.reference')
              ),
              _react2.default.createElement(
                'th',
                null,
                _I18n2.default.tr('payouts.table.header.date')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.amount')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.commissions_fixed_without_taxes')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.commissions_variable_without_taxes')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.vat')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.commissions_with_taxes')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.amount_net')
              ),
              _react2.default.createElement(
                'th',
                {
                  className: 'text-center'
                },
                _I18n2.default.tr('payouts.table.header.status')
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            rows
          )
        )
      );
    }
  }]);

  return PayoutsTableView;
}(_react.Component);

PayoutsTableView.propTypes = {
  payouts: _propTypes2.default.arrayOf(_Payout2.default),
  currencyCode: _propTypes2.default.string
};
exports.default = PayoutsTableView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayoutsTableView, 'PayoutsTableView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayoutsTableView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayoutsTableViewRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _Payout = __webpack_require__("./sdk/scripts/entities/Payout.js");

var _Payout2 = _interopRequireDefault(_Payout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- tools


// -- views


var PayoutsTableViewRow = function (_Component) {
  _inherits(PayoutsTableViewRow, _Component);

  function PayoutsTableViewRow() {
    _classCallCheck(this, PayoutsTableViewRow);

    return _possibleConstructorReturn(this, (PayoutsTableViewRow.__proto__ || Object.getPrototypeOf(PayoutsTableViewRow)).apply(this, arguments));
  }

  _createClass(PayoutsTableViewRow, [{
    key: 'render',
    value: function render() {
      var payout = this.props.payout;
      var currencyCode = this.props.currencyCode;

      console.log("payout", payout);

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          payout.id
        ),
        _react2.default.createElement(
          'td',
          null,
          payout.reference
        ),
        _react2.default.createElement(
          'td',
          null,
          payout.getFormattedDate()
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          _CurrencyUtils2.default.formatPriceWithCurrency(payout.grossAmount, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          _CurrencyUtils2.default.formatPriceWithCurrency(payout.feesFixedAmountExcludingVat, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          _CurrencyUtils2.default.formatPriceWithCurrency(payout.feesVariableAmountExcludingVat, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          _CurrencyUtils2.default.formatPriceWithCurrency(payout.vatAmount, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          _CurrencyUtils2.default.formatPriceWithCurrency(payout.getCommissionWithTax(), currencyCode)
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          _CurrencyUtils2.default.formatPriceWithCurrency(payout.netAmount, currencyCode)
        ),
        _react2.default.createElement(
          'td',
          {
            className: 'text-center'
          },
          payout.getFormattedStatus()
        )
      );
    }
  }]);

  return PayoutsTableViewRow;
}(_react.Component);

PayoutsTableViewRow.propTypes = {
  payout: _propTypes2.default.objectOf(_Payout2.default).isRequired,
  currencyCode: _propTypes2.default.string
};
exports.default = PayoutsTableViewRow;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayoutsTableViewRow, 'PayoutsTableViewRow', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayoutsTableViewRow.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/receipt/components/PayoutsView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Payout = __webpack_require__("./sdk/scripts/entities/Payout.js");

var _Payout2 = _interopRequireDefault(_Payout);

var _PayoutList = __webpack_require__("./sdk/scripts/entities/PayoutList.js");

var _PayoutList2 = _interopRequireDefault(_PayoutList);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _PayoutsTableView = __webpack_require__("./scripts/pages/payment/receipt/components/PayoutsTableView.js");

var _PayoutsTableView2 = _interopRequireDefault(_PayoutsTableView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- components


/**
 * @parent ReceiptPage
 */
var PayoutsView = function (_AbstractComponent) {
  _inherits(PayoutsView, _AbstractComponent);

  function PayoutsView() {
    _classCallCheck(this, PayoutsView);

    return _possibleConstructorReturn(this, (PayoutsView.__proto__ || Object.getPrototypeOf(PayoutsView)).apply(this, arguments));
  }

  _createClass(PayoutsView, [{
    key: 'renderNoData',
    value: function renderNoData() {
      // no information to display

      return _react2.default.createElement(
        'div',
        { className: 'payment_payins__no_data' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-xs-offset-3 text-center' },
          _react2.default.createElement('i', { className: 'icon-smiley-down' }),
          _react2.default.createElement(
            'p',
            { className: 'top-buffer-30' },
            _I18n2.default.tr('payouts.no_payouts')
          )
        )
      );
    }
  }, {
    key: 'renderPayouts',
    value: function renderPayouts(payoutList) {
      // -- View
      return _react2.default.createElement(
        'div',
        { className: 'payment_payins__data' },
        _react2.default.createElement(_PayoutsTableView2.default, {
          payouts: payoutList.payouts,
          currencyCode: this.props.currencyCode
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var payoutList = this.props.payoutList;

      var contentView = null;
      if (!_lodash2.default.isEmpty(payoutList.payouts)) {
        contentView = this.renderPayouts(payoutList);
      } else {
        contentView = this.renderNoData();
      }

      return _react2.default.createElement(
        'div',
        { className: 'payment_payins' },
        contentView
      );
    }
  }]);

  return PayoutsView;
}(_AbstractComponent3.default);

PayoutsView.propTypes = {
  payoutList: _propTypes2.default.objectOf(_PayoutList2.default).isRequired,
  currencyCode: _propTypes2.default.string
};
exports.default = PayoutsView;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayoutsView, 'PayoutsView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/receipt/components/PayoutsView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/stat/StatPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _PaymentStatistics = __webpack_require__("./sdk/scripts/entities/PaymentStatistics.js");

var _PaymentStatistics2 = _interopRequireDefault(_PaymentStatistics);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

var _PaymentStatsGraphInfo = __webpack_require__("./scripts/objects/PaymentStatsGraphInfo.js");

var _PaymentStatsGraphInfo2 = _interopRequireDefault(_PaymentStatsGraphInfo);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _TimelapsePicker = __webpack_require__("./scripts/components/timelapse/TimelapsePicker.js");

var _TimelapsePicker2 = _interopRequireDefault(_TimelapsePicker);

var _PaymentStatsGraph = __webpack_require__("./scripts/pages/payment/stat/components/PaymentStatsGraph.js");

var _PaymentStatsGraph2 = _interopRequireDefault(_PaymentStatsGraph);

var _PaymentStatsKeyNumbers = __webpack_require__("./scripts/pages/payment/stat/components/PaymentStatsKeyNumbers.js");

var _PaymentStatsKeyNumbers2 = _interopRequireDefault(_PaymentStatsKeyNumbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- stores


// -- actions


// -- constants


// -- entities


// -- utils


// -- components


var StatPage = function (_AbstractComponent) {
  _inherits(StatPage, _AbstractComponent);

  function StatPage() {
    _classCallCheck(this, StatPage);

    var _this = _possibleConstructorReturn(this, (StatPage.__proto__ || Object.getPrototypeOf(StatPage)).call(this));

    _this.state = {
      paymentStatistics: _stores.PaymentStatStore.getPaymentStatistics(),
      timelapse: _stores.SessionStore.getTimelapse(),
      restaurant: _stores.RestaurantStore.getRestaurant()
    };

    _this.onChange = function () {
      return _this.__onChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onTimelapseChange = function () {
      return _this.__onTimelapseChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-line-chart';
    _this.arianeDetails = [{
      name: _I18n2.default.tr('menu.payment'),
      link: ''
    }, {
      name: _I18n2.default.tr('menu.payment.stat'),
      link: ''
    }];
    return _this;
  }

  _createClass(StatPage, [{
    key: '__onTimelapseChange__REACT_HOT_LOADER__',
    value: function __onTimelapseChange__REACT_HOT_LOADER__() {
      return this.__onTimelapseChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      return this.__onChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_stores.RestaurantStore.getRestaurant().haveFeaturePayment() && !_stores.RestaurantStore.getRestaurant().haveFeatureOrder()) {
        _actions.RouteAction.redirectToFeatureNonActivated();
        return;
      }

      _stores.PaymentStatStore.addListener(this.onChange);

      this.loadStatistics(this.state.timelapse);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.PaymentStatStore.removeListener(this.onChange);
    }
  }, {
    key: 'loadStatistics',
    value: function loadStatistics(timelapse) {
      this.showLoading();
      _actions.PaymentAction.loadStatistics(timelapse);
    }

    // -- Event functions

  }, {
    key: '__onChange__REACT_HOT_LOADER__',
    value: function __onChange__REACT_HOT_LOADER__() {
      var paymentStatistics = _stores.PaymentStatStore.getPaymentStatistics();

      var timelapse = null;
      if (!_lodash2.default.isNull(paymentStatistics)) {
        timelapse = paymentStatistics.timelapse;
        _stores.SessionStore.saveTimelapse(timelapse);
      }

      this.setState({
        paymentStatistics: paymentStatistics,
        timelapse: _stores.SessionStore.getTimelapse(),
        loading: false,
        apiError: _stores.PaymentStatStore.getApiError()
      });
    }
  }, {
    key: '__onTimelapseChange__REACT_HOT_LOADER__',


    // -- Renderers

    value: function __onTimelapseChange__REACT_HOT_LOADER__(timelapse) {
      this.loadStatistics(timelapse);
    }
  }, {
    key: 'renderPayins',
    value: function renderPayins(paymentStatistics) {
      var payins = [];

      var minDate = this.state.timelapse.getFromTimeAsSeconds();
      var maxDate = this.state.timelapse.getToTimeAsSeconds();

      paymentStatistics.payins.forEach(function (payin) {
        if (payin.date < minDate) {
          minDate = payin.date;
        }
        if (payin.date > maxDate) {
          maxDate = payin.date;
        }
      });

      var SECONDS_IN_DAY = 86400; // to ms
      var MAX_INTERVAL = SECONDS_IN_DAY * 365; // approximately one year)

      // -- verify that the interval is not too big
      if (maxDate < minDate || maxDate - minDate > MAX_INTERVAL) {
        // interval to big;
        return _react2.default.createElement(
          'div',
          null,
          _I18n2.default.tr('payment_stats.interval_too_big')
        );
      }

      function getDayTimestampFromTimestamp(timestamp) {
        // <-- inner function
        var format = 'DD-MM-YY';
        // get the string according to the format
        var dateString = _DateUtils2.default.fromTimestamp(timestamp).format(format);
        // convert the string to a date, and get the unix timestamp (seconds).
        return _DateUtils2.default.stringDateWithFormatToUnix(dateString, format);
      }

      // initiate the table. We need to create a default value from minDate to maxDate index.
      // Otherwise the graph will not be correct.
      for (var dateTimestamp = minDate; dateTimestamp < maxDate; dateTimestamp += SECONDS_IN_DAY) {
        payins[getDayTimestampFromTimestamp(dateTimestamp)] = 0;
      }

      // populate payins array
      paymentStatistics.payins.forEach(function (payin) {
        var key = getDayTimestampFromTimestamp(payin.date);
        var alreadySet = _lodash2.default.isUndefined(key) || _lodash2.default.isNaN(key) ? 0 : payins[key];
        payins[key] = alreadySet + (payin.amount + payin.tips);
      });

      // format payins array to array of {period, total}
      var payinsFormatted = [];

      // Note: DO NOT USE _.mapKeys, it will crash.
      for (var key in payins) {
        if (payins.hasOwnProperty(key)) {
          var value = payins[key];
          payinsFormatted.push(new _PaymentStatsGraphInfo2.default(key, value));
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'stat_page__data' },
        this.state.timelapse.isSameDay() === false && _react2.default.createElement(_PaymentStatsGraph2.default, { data: payinsFormatted,
          currencyCode: this.state.restaurant.currency }),
        _react2.default.createElement('div', { className: 'top-buffer-50' }),
        _react2.default.createElement(_PaymentStatsKeyNumbers2.default, { paymentStatistics: paymentStatistics,
          currencyCode: this.state.restaurant.currency })
      );
    }
  }, {
    key: 'renderNoData',
    value: function renderNoData() {
      // no information to display
      return _react2.default.createElement(
        'div',
        { className: 'stat_page__no_data' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-xs-offset-3 text-center' },
          _react2.default.createElement('i', { className: 'icon-smiley-down' }),
          _react2.default.createElement(
            'p',
            { className: 'top-buffer-30' },
            _I18n2.default.tr('payment_stats.no_payout')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var paymentStatistics = this.state.paymentStatistics;

      var contentView = null;

      var timelapsePickerView = _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(_TimelapsePicker2.default, {
          className: 'col-xs-12 col-md-6 float-right text-right',
          timelapse: this.state.timelapse,
          onTimelapseChange: this.onTimelapseChange,
          timelapseSelection: _stores.SessionStore.getTimelapseSelection()
        })
      );

      if (_lodash2.default.isNull(paymentStatistics)) {
        contentView = this.renderOnLoadingContent();
        timelapsePickerView = null;
      } else if (!_lodash2.default.isEmpty(paymentStatistics.payins)) {
        contentView = this.renderPayins(paymentStatistics);
      } else {
        contentView = this.renderNoData();
      }

      return _react2.default.createElement(
        'div',
        { className: 'stat_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        this.renderLoading(),
        timelapsePickerView,
        contentView
      );
    }
  }]);

  return StatPage;
}(_AbstractComponent3.default);

exports.default = StatPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(StatPage, 'StatPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/stat/StatPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/stat/components/PaymentStatsGraph.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _PaymentStatsGraphInfo = __webpack_require__("./scripts/objects/PaymentStatsGraphInfo.js");

var _PaymentStatsGraphInfo2 = _interopRequireDefault(_PaymentStatsGraphInfo);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentStatsGraph = function (_Component) {
  _inherits(PaymentStatsGraph, _Component);

  function PaymentStatsGraph() {
    _classCallCheck(this, PaymentStatsGraph);

    return _possibleConstructorReturn(this, (PaymentStatsGraph.__proto__ || Object.getPrototypeOf(PaymentStatsGraph)).apply(this, arguments));
  }

  _createClass(PaymentStatsGraph, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateGraphView();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!_lodash2.default.isEqual(this.props.data, prevProps.data)) {
        this.updateGraphView();
      }
    }
  }, {
    key: 'updateGraphView',
    value: function updateGraphView() {
      var data = this.props.data;
      var element = 'payment_stat_graph__placeholder';
      var currencySymbol = _utils.CurrencyUtils.getCurrencySymbol(this.props.currencyCode);

      // We must clear the chart before updated it.
      $('#' + element).html('');

      Morris.Line({
        element: element,
        data: data,
        xkey: 'day',
        ykeys: ['total'],
        // Labels for the ykeys -- will be displayed when you hover over the
        // chart
        labels: [_I18n2.default.tr('payment_stats.graph.payed_label') + ' '],
        stacked: true,
        pointSize: 2,
        hideHover: 'auto',
        resize: true,
        lineColors: ['#9dc212'],
        behaveLikeLine: true,
        xLabels: 'day',
        dateFormat: function dateFormat(dateTimestamp) {
          var date = (0, _moment2.default)(dateTimestamp);
          // TODO: Localize
          return date.format('DD/MM/Y');
        },
        xLabelFormat: function xLabelFormat(amount) {
          if (!_lodash2.default.isUndefined(amount)) {
            // TODO: Localize
            return amount.toLocaleString('fr', { year: 'numeric', month: 'long', day: 'numeric' });
          }
          return '';
        },
        yLabelFormat: function yLabelFormat(value) {
          var y = parseFloat(value);
          if (!_lodash2.default.isNaN(y)) {
            return y.toFixed(2) + ' ' + currencySymbol;
          }
          return '';
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'payment_stat_graph' },
        _react2.default.createElement(
          'h2',
          null,
          _I18n2.default.tr('payment_stats.graph.amount_payed')
        ),
        _react2.default.createElement(
          'div',
          { className: 'graph_container' },
          _react2.default.createElement('div', { id: 'payment_stat_graph__placeholder', className: 'graph_placeholder' })
        )
      );
    }
  }]);

  return PaymentStatsGraph;
}(_react.Component);

PaymentStatsGraph.propTypes = {
  data: _propTypes2.default.arrayOf(_PaymentStatsGraphInfo2.default),
  currencyCode: _propTypes2.default.string

};
var _default = PaymentStatsGraph;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentStatsGraph, 'PaymentStatsGraph', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/stat/components/PaymentStatsGraph.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/stat/components/PaymentStatsGraph.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/payment/stat/components/PaymentStatsKeyNumbers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _PaymentStatistics = __webpack_require__("./sdk/scripts/entities/PaymentStatistics.js");

var _PaymentStatistics2 = _interopRequireDefault(_PaymentStatistics);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Display payment statistic key numbers.
 */
var PaymentStatsKeyNumbers = function (_Component) {
  _inherits(PaymentStatsKeyNumbers, _Component);

  function PaymentStatsKeyNumbers() {
    _classCallCheck(this, PaymentStatsKeyNumbers);

    return _possibleConstructorReturn(this, (PaymentStatsKeyNumbers.__proto__ || Object.getPrototypeOf(PaymentStatsKeyNumbers)).apply(this, arguments));
  }

  _createClass(PaymentStatsKeyNumbers, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // -- bootstrap tooltip
      $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var paymentStatistics = this.props.paymentStatistics;
      var tipsDetailView = [];
      var currencyCode = this.props.currencyCode;

      if (!_lodash2.default.isEmpty(paymentStatistics.tips)) {
        var i = 0;
        _lodash2.default.forEach(paymentStatistics.tips, function (tip) {
          if (tip.tips !== 0) {
            var waiterName = tip.waiterName;

            if (waiterName === 'null null' || _lodash2.default.isEmpty(waiterName)) {
              waiterName = 'Non renseigné';
            }

            tipsDetailView.push(_react2.default.createElement(
              'li',
              { key: i },
              _react2.default.createElement(
                'span',
                {
                  className: 'payment_stats_key_numbers__tip_name'
                },
                waiterName
              ),
              _react2.default.createElement(
                'span',
                {
                  className: 'payment_stats_key_numbers__tip_value'
                },
                _CurrencyUtils2.default.formatPriceWithCurrency(tip.tips, currencyCode)
              )
            ));
            ++i;
          }
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'payment_stats_key_numbers' },
        _react2.default.createElement(
          'h2',
          null,
          _I18n2.default.tr('payment_stats.numbers.key_numbers_title')
        ),
        _react2.default.createElement(
          'div',
          { className: 'row top-buffer-40' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-lg-3' },
            _react2.default.createElement(
              'span',
              { className: 'payment_stats_key_numbers__stat_title' },
              _I18n2.default.tr('payment_stats.numbers.payed_tables'),
              '\xA0',
              _react2.default.createElement(
                'sup',
                null,
                _react2.default.createElement('i', {
                  className: 'glyphicon glyphicon-question-sign',
                  'data-toggle': 'tooltip',
                  'data-placement': 'top',
                  title: _I18n2.default.tr('payment_stats.numbers.payed_tables_tooltip')
                })
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'payment_stats_key_numbers__stat_value' },
              paymentStatistics.checksNumber
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-lg-4' },
            _react2.default.createElement(
              'span',
              { className: 'payment_stats_key_numbers__stat_title' },
              _I18n2.default.tr('payment_stats.numbers.number_of_payments'),
              '\xA0',
              _react2.default.createElement(
                'sup',
                null,
                _react2.default.createElement('i', {
                  className: 'glyphicon glyphicon-question-sign',
                  'data-toggle': 'tooltip',
                  'data-placement': 'top',
                  title: _I18n2.default.tr('payment_stats.numbers.number_of_payments_tooltip')
                })
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'payment_stats_key_numbers__stat_value' },
              paymentStatistics.paymentsNumber
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-lg-4' },
            _react2.default.createElement(
              'span',
              { className: 'payment_stats_key_numbers__stat_title' },
              _I18n2.default.tr('payment_stats.numbers.amount_payed_with_pmt'),
              '\xA0',
              _react2.default.createElement(
                'sup',
                null,
                _react2.default.createElement('i', {
                  className: 'glyphicon glyphicon-question-sign',
                  'data-toggle': 'tooltip',
                  'data-placement': 'top',
                  title: _I18n2.default.tr('payment_stats.numbers.amount_payed_with_pmt_tooltip')
                })
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'payment_stats_key_numbers__stat_value' },
              _CurrencyUtils2.default.formatPriceWithCurrency(paymentStatistics.totalAmountPaid, currencyCode)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'row payment_stats_key_numbers__tip' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-md-3' },
                _react2.default.createElement(
                  'span',
                  { className: 'payment_stats_key_numbers__stat_title' },
                  _I18n2.default.tr('payment_stats.numbers.tips')
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'payment_stats_key_numbers__stat_value' },
                  _CurrencyUtils2.default.formatPriceWithCurrency(paymentStatistics.totalTipsPaid, currencyCode)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-md-9' },
                _react2.default.createElement(
                  'ul',
                  { className: 'payment_stats_key_numbers__tip_list' },
                  tipsDetailView
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentStatsKeyNumbers;
}(_react.Component);

PaymentStatsKeyNumbers.propTypes = {
  paymentStatistics: _propTypes2.default.objectOf(_PaymentStatistics2.default),
  currencyCode: _propTypes2.default.string

};
var _default = PaymentStatsKeyNumbers;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentStatsKeyNumbers, 'PaymentStatsKeyNumbers', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/stat/components/PaymentStatsKeyNumbers.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/payment/stat/components/PaymentStatsKeyNumbers.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/proAccounts/restaurantsGroup/RestaurantsGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _actions = __webpack_require__("./scripts/actions/index.js");

var _stores = __webpack_require__("./scripts/stores/index.js");

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _components = __webpack_require__("./scripts/components/index.js");

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _RestaurantsGroupHierarchyView = __webpack_require__("./scripts/components/restaurantsGroup/RestaurantsGroupHierarchyView.js");

var _RestaurantsGroupHierarchyView2 = _interopRequireDefault(_RestaurantsGroupHierarchyView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var RestaurantsGroupPage = function (_AbstractComponent) {
  _inherits(RestaurantsGroupPage, _AbstractComponent);

  function RestaurantsGroupPage() {
    _classCallCheck(this, RestaurantsGroupPage);

    var _this = _possibleConstructorReturn(this, (RestaurantsGroupPage.__proto__ || Object.getPrototypeOf(RestaurantsGroupPage)).call(this));

    _this.state = {
      restaurantsGroup: null
    };

    _this.onLoadRestaurantsGroup = function () {
      return _this.__onLoadRestaurantsGroup__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onLoadRestaurantsGroupError = function () {
      return _this.__onLoadRestaurantsGroupError__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onShowRestaurantsGroupDetail = function () {
      return _this.__onShowRestaurantsGroupDetail__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-users';
    _this.arianeDetails = [{
      name: 'Utilisateurs',
      link: _RoutingEnum2.default.PRO_accountS_LIST_PAGE
    }, {
      name: 'Restaurants',
      link: null
    }];
    return _this;
  }

  _createClass(RestaurantsGroupPage, [{
    key: '__onShowRestaurantsGroupDetail__REACT_HOT_LOADER__',
    value: function __onShowRestaurantsGroupDetail__REACT_HOT_LOADER__() {
      return this.__onShowRestaurantsGroupDetail__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLoadRestaurantsGroupError__REACT_HOT_LOADER__',
    value: function __onLoadRestaurantsGroupError__REACT_HOT_LOADER__() {
      return this.__onLoadRestaurantsGroupError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLoadRestaurantsGroup__REACT_HOT_LOADER__',
    value: function __onLoadRestaurantsGroup__REACT_HOT_LOADER__() {
      return this.__onLoadRestaurantsGroup__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _stores.RestaurantStore.addListeners(this.restaurantListeners);

      this.loadRestaurantsGroup();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantStore.removeListeners(this.restaurantListeners);
    }
  }, {
    key: 'loadRestaurantsGroup',
    value: function loadRestaurantsGroup() {
      this.showLoading();

      var restaurantsGroupId = _stores.ProAccountStore.getMeAccount().domainsList[0].restaurantsGroupId;
      _actions.RestaurantAction.retrieveRestaurantsGroup(restaurantsGroupId);
    }

    //
    // Listeners
    //

  }, {
    key: '__onLoadRestaurantsGroup__REACT_HOT_LOADER__',
    value: function __onLoadRestaurantsGroup__REACT_HOT_LOADER__() {
      this.setState({
        loading: false,
        restaurantsGroup: _stores.RestaurantStore.getRestaurantsGroup()
      });
    }
  }, {
    key: '__onLoadRestaurantsGroupError__REACT_HOT_LOADER__',


    //
    // Table event
    //

    value: function __onLoadRestaurantsGroupError__REACT_HOT_LOADER__() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: '__onShowRestaurantsGroupDetail__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onShowRestaurantsGroupDetail__REACT_HOT_LOADER__(restaurantsGroup) {}
  }, {
    key: 'renderAddRole',
    value: function renderAddRole() {
      return _react2.default.createElement(_components.RoundButton, {
        onClick: this.onAddRoleClicked,
        text: 'Ajouter un r\xF4le'
      });
    }
  }, {
    key: 'renderRestaurantsGroupList',
    value: function renderRestaurantsGroupList() {
      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-md-4' },
          _react2.default.createElement(
            'h3',
            null,
            'Liste de vos restaurants'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 top-buffer-50' },
          _react2.default.createElement(_RestaurantsGroupHierarchyView2.default, {
            restaurantsGroup: this.state.restaurantsGroup,
            onShowRoleDetail: this.onShowRoleDetail
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (_lodash2.default.isNull(this.state.restaurantsGroup)) {
        return this.renderOnLoadingContent();
      }

      return _react2.default.createElement(
        'div',
        { className: 'top-buffer-50' },
        _react2.default.createElement(
          'p',
          null,
          'Voici la liste de vos restaurant accessibles suivant votre profil utilisateur. Chaque nouvel utilisateur doit \xEAtre rattach\xE9 \xE0 (i) un restaurant ou un groupe de restaurants et \xE0 (ii) un r\xF4le.'
        ),
        this.renderRestaurantsGroupList()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'roles_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        this.renderLoading(),
        this.renderBody()
      );
    }
  }, {
    key: 'restaurantListeners',
    get: function get() {
      return [new _Listener2.default(_constants.Events.LOAD_RESTAURANTS_GROUP_SUCCESS, this.onLoadRestaurantsGroup), new _Listener2.default(_constants.Events.LOAD_RESTAURANTS_GROUP_FAILURE, this.onLoadRestaurantsGroupError)];
    }

    //
    // Events
    //

  }]);

  return RestaurantsGroupPage;
}(_components.AbstractComponent);

exports.default = RestaurantsGroupPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantsGroupPage, 'RestaurantsGroupPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/proAccounts/restaurantsGroup/RestaurantsGroup.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/EditRestaurantPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _actions = __webpack_require__("./scripts/actions/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

var _stores = __webpack_require__("./scripts/stores/index.js");

var _constants = __webpack_require__("./scripts/constants/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _AbstractComponent2 = __webpack_require__("./scripts/components/AbstractComponent.js");

var _AbstractComponent3 = _interopRequireDefault(_AbstractComponent2);

var _Ariane = __webpack_require__("./sdk/scripts/components/Ariane.js");

var _Ariane2 = _interopRequireDefault(_Ariane);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _PublicFormView = __webpack_require__("./scripts/pages/restaurant/edit/components/PublicFormView.js");

var _PublicFormView2 = _interopRequireDefault(_PublicFormView);

var _LegalFormView = __webpack_require__("./scripts/pages/restaurant/edit/components/LegalFormView.js");

var _LegalFormView2 = _interopRequireDefault(_LegalFormView);

var _FinanceFormView = __webpack_require__("./scripts/pages/restaurant/edit/components/FinanceFormView.js");

var _FinanceFormView2 = _interopRequireDefault(_FinanceFormView);

var _ConfigurationFormView = __webpack_require__("./scripts/pages/restaurant/edit/components/ConfigurationFormView.js");

var _ConfigurationFormView2 = _interopRequireDefault(_ConfigurationFormView);

var _FeaturesFormView = __webpack_require__("./scripts/pages/restaurant/edit/components/FeaturesFormView.js");

var _FeaturesFormView2 = _interopRequireDefault(_FeaturesFormView);

var _ThemeFormView = __webpack_require__("./scripts/pages/restaurant/edit/components/ThemeFormView.js");

var _ThemeFormView2 = _interopRequireDefault(_ThemeFormView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- stores


// -- constants


// -- entities


// -- components

// import OpeningHoursFormView from './components/OpeningHoursFormView';


var EditRestaurantPage = function (_AbstractComponent) {
  _inherits(EditRestaurantPage, _AbstractComponent);

  function EditRestaurantPage() {
    _classCallCheck(this, EditRestaurantPage);

    var _this = _possibleConstructorReturn(this, (EditRestaurantPage.__proto__ || Object.getPrototypeOf(EditRestaurantPage)).call(this));

    _this.state = {
      restaurant: null,

      lastUpdateTime: (0, _moment2.default)().valueOf()
    };

    _this.loadRestaurant = function () {
      return _this.__loadRestaurant__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onRestaurantLoad = function () {
      return _this.__onRestaurantLoad__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onRestaurantUpdate = function () {
      return _this.__onRestaurantUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onError = function () {
      return _this.__onError__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onTabChange = function () {
      return _this.__onTabChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.onUpdate = function () {
      return _this.__onUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.arianeIcon = 'fa-user';
    _this.arianeDetails = [{
      name: 'Paramètres',
      link: null
    }];
    return _this;
  }

  _createClass(EditRestaurantPage, [{
    key: '__onUpdate__REACT_HOT_LOADER__',
    value: function __onUpdate__REACT_HOT_LOADER__() {
      return this.__onUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__() {
      return this.__onTabChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',
    value: function __onError__REACT_HOT_LOADER__() {
      return this.__onError__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantUpdate__REACT_HOT_LOADER__',
    value: function __onRestaurantUpdate__REACT_HOT_LOADER__() {
      return this.__onRestaurantUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantLoad__REACT_HOT_LOADER__',
    value: function __onRestaurantLoad__REACT_HOT_LOADER__() {
      return this.__onRestaurantLoad__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__loadRestaurant__REACT_HOT_LOADER__',
    value: function __loadRestaurant__REACT_HOT_LOADER__() {
      return this.__loadRestaurant__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_SecurityContext2.default.restaurantSettings.read()) {
        // TODO: redirect
      }
      _stores.RestaurantStore.addListeners(this.restaurantStoreListeners);

      this.loadRestaurant();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _stores.RestaurantStore.removeListeners(this.restaurantStoreListeners);
    }
  }, {
    key: '__loadRestaurant__REACT_HOT_LOADER__',


    // -- Event functions

    value: function __loadRestaurant__REACT_HOT_LOADER__() {
      this.showLoading();
      _actions.RestaurantAction.retrieveCurrentRestaurant();
    }
  }, {
    key: '__onRestaurantLoad__REACT_HOT_LOADER__',
    value: function __onRestaurantLoad__REACT_HOT_LOADER__() {
      var restaurant = _stores.RestaurantStore.getRestaurant().copy();

      this.setState({
        restaurant: restaurant,
        loading: false
      });
    }
  }, {
    key: '__onRestaurantUpdate__REACT_HOT_LOADER__',
    value: function __onRestaurantUpdate__REACT_HOT_LOADER__() {
      var restaurant = _stores.RestaurantStore.getRestaurant().copy();

      this.setState({
        restaurant: restaurant,
        lastUpdateTime: (0, _moment2.default)().valueOf(),
        loading: false,
        apiError: null
      });
    }
  }, {
    key: '__onError__REACT_HOT_LOADER__',


    // -- Tabs

    value: function __onError__REACT_HOT_LOADER__() {
      this.setState({
        apiError: _stores.RestaurantStore.getApiError(),
        loading: false
      });
    }
  }, {
    key: '__onTabChange__REACT_HOT_LOADER__',
    value: function __onTabChange__REACT_HOT_LOADER__(activeKey) {
      if (!_lodash2.default.isUndefined(activeKey)) {
        _stores.SessionStore.saveEditRestaurantTab(activeKey);

        /*
         * Update the query params.
         */
        this.onChangeQueryUrl({
          tab: activeKey
        });
      }
    }
  }, {
    key: '__onUpdate__REACT_HOT_LOADER__',


    //
    // Renderers
    //

    value: function __onUpdate__REACT_HOT_LOADER__(restaurantMultipart) {
      this.showLoading(function () {
        _actions.RestaurantAction.updateRestaurant(restaurantMultipart);
      });
    }
  }, {
    key: 'renderWarnings',
    value: function renderWarnings() {
      return _react2.default.createElement(
        'div',
        null,
        this.state.restaurant && (this.state.restaurant.status === 'ENABLED' || this.state.restaurant.status === 'DISABLED') && this.state.restaurant.legal && this.state.restaurant.legal.bank && this.state.restaurant.legal.bank.transferFrequency === 'DISABLED' && _react2.default.createElement(
          'p',
          { className: 'bg-warning', style: { padding: 16, marginTop: 16 } },
          _I18n2.default.tr('restaurant_edit.configuration.transferFrequency.DISABLED.tip')
        ),
        this.state.restaurant && this.state.restaurant.status === 'ARCHIVED' && _react2.default.createElement(
          'p',
          { className: 'bg-warning', style: { padding: 16, marginTop: 16 } },
          _I18n2.default.tr('restaurant_edit.configuration.statut.ARCHIVED.tip')
        )
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var error = null;
      if (this.state.apiError) {
        switch (this.state.apiError.code) {
          case '20009':
            error = _I18n2.default.tr('restaurant_edit.error.20009');
            break;
          default:
            error = _I18n2.default.tr('restaurant_edit.error.default');
        }

        return error && _react2.default.createElement(
          'div',
          { className: 'alert alert-danger top-buffer-30' },
          error
        );
      }

      return null;
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        {
          className: 'edit_restaurant_form_view',
          key: this.state.lastUpdateTime
        },
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultActiveKey: this.defaultTabKey,
            id: 'edit_restaurant_page__tabs',
            onSelect: this.onTabChange
          },
          _SecurityContext2.default.restaurantSettings.readPublicInfo() && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: EditRestaurantPage.Tab.PUBLIC,
              title: _I18n2.default.tr('restaurant.edit.tabs.public').toUpperCase()
            },
            this.renderWarnings(),
            this.renderError(),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_PublicFormView2.default, {
                restaurant: this.state.restaurant,
                onUpdate: this.onUpdate
              })
            )
          ),
          _SecurityContext2.default.restaurantSettings.readLegal() && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: EditRestaurantPage.Tab.LEGAL,
              title: _I18n2.default.tr('restaurant.edit.tabs.legal').toUpperCase()
            },
            this.renderWarnings(),
            this.renderError(),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_LegalFormView2.default, {
                restaurant: this.state.restaurant,
                onUpdate: this.onUpdate
              })
            )
          ),
          _SecurityContext2.default.restaurantSettings.readFinance() && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: EditRestaurantPage.Tab.FINANCE,
              title: _I18n2.default.tr('restaurant.edit.tabs.finance').toUpperCase()
            },
            this.renderWarnings(),
            this.renderError(),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_FinanceFormView2.default, {
                restaurant: this.state.restaurant,
                onUpdate: this.onUpdate
              })
            )
          ),
          _SecurityContext2.default.restaurantSettings.readFeatures() && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: EditRestaurantPage.Tab.FEATURES,
              title: _I18n2.default.tr('restaurant.edit.tabs.features').toUpperCase()
            },
            this.renderWarnings(),
            this.renderError(),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_FeaturesFormView2.default, {
                restaurant: this.state.restaurant,
                onUpdate: this.onUpdate
              })
            )
          ),
          _SecurityContext2.default.restaurantSettings.readConfiguration() && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: EditRestaurantPage.Tab.CONFIGURATION,
              title: _I18n2.default.tr('restaurant.edit.tabs.configuration').toUpperCase()
            },
            this.renderWarnings(),
            this.renderError(),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_ConfigurationFormView2.default, {
                restaurant: this.state.restaurant,
                onUpdate: this.onUpdate
              })
            )
          ),
          _SecurityContext2.default.restaurantSettings.readTheme() && _react2.default.createElement(
            _reactBootstrap.Tab,
            {
              eventKey: EditRestaurantPage.Tab.THEME,
              title: _I18n2.default.tr('restaurant.edit.tabs.theme').toUpperCase()
            },
            this.renderWarnings(),
            this.renderError(),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-30' },
              _react2.default.createElement(_ThemeFormView2.default, {
                restaurant: this.state.restaurant,
                onUpdate: this.onUpdate
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-40 text-center' },
          _I18n2.default.tr('restaurant.edit.footer'),
          '\xA0',
          _react2.default.createElement(
            'a',
            { href: 'mailto:' + _constants.Constants.CONTACT_EMAIL },
            _constants.Constants.CONTACT_EMAIL
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var contentView = null;

      if (this.state.loading) {
        return this.renderLoading();
      }

      if (_lodash2.default.isNull(this.state.restaurant)) {
        contentView = this.renderOnLoadingContent();
      } else {
        contentView = this.renderBody();
      }

      return _react2.default.createElement(
        'div',
        { className: 'edit_restaurant_page' },
        _react2.default.createElement(_Ariane2.default, { icon: this.arianeIcon, details: this.arianeDetails }),
        contentView
      );
    }
  }, {
    key: 'restaurantStoreListeners',
    get: function get() {
      return [new _Listener2.default(_constants.Events.LOAD_RESTAURANT_SUCCESS, this.onRestaurantLoad), new _Listener2.default(_constants.Events.UPDATE_RESTAURANT_SUCCESS, this.onRestaurantUpdate), new _Listener2.default(_constants.Events.UPDATE_RESTAURANT_FAILURE, this.onError), new _Listener2.default(_constants.Events.LOAD_RESTAURANT_FAILURE, this.onError)];
    }
  }, {
    key: 'defaultTabKey',
    get: function get() {
      if (!_lodash2.default.isNull(this.props.location.query)) {
        var tabQuery = this.props.location.query.tab;
        _stores.SessionStore.saveEditRestaurantTab(tabQuery);
        return tabQuery;
      }

      return _stores.SessionStore.getEditRestaurantTab();
    }

    // -- Event form

  }]);

  return EditRestaurantPage;
}(_AbstractComponent3.default);

EditRestaurantPage.Tab = {
  PUBLIC: 'public',
  MENU: 'menu',
  OPENING_HOURS: 'opening-hours',
  LEGAL: 'legal',
  FINANCE: 'finance',
  FEATURES: 'features',
  CONFIGURATION: 'configuration',
  THEME: 'theme',
  GROUPS: 'groups'
};
exports.default = EditRestaurantPage;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EditRestaurantPage, 'EditRestaurantPage', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/EditRestaurantPage.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/ConfigurationFormView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _RestaurantFormComponent = __webpack_require__("./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js");

var _RestaurantFormComponent2 = _interopRequireDefault(_RestaurantFormComponent);

var _StoreStateChooser = __webpack_require__("./scripts/components/form/StoreStateChooser.js");

var _StoreStateChooser2 = _interopRequireDefault(_StoreStateChooser);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// -- entities

// -- views


var AdminFormView = function (_RestaurantFormCompon) {
  _inherits(AdminFormView, _RestaurantFormCompon);

  function AdminFormView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdminFormView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminFormView.__proto__ || Object.getPrototypeOf(AdminFormView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.restaurant), _this.onExternalIdChange = function () {
      var _this2;

      return (_this2 = _this).__onExternalIdChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onRestaurantNameChange = function () {
      var _this3;

      return (_this3 = _this).__onRestaurantNameChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onStatusChange = function () {
      var _this4;

      return (_this4 = _this).__onStatusChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onPosChange = function () {
      var _this5;

      return (_this5 = _this).__onPosChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onPosIdChange = function () {
      var _this6;

      return (_this6 = _this).__onPosIdChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onPosUrlChange = function () {
      var _this7;

      return (_this7 = _this).__onPosUrlChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onPosCustomerIdChange = function () {
      var _this8;

      return (_this8 = _this).__onPosCustomerIdChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onPosCommentIdChange = function () {
      var _this9;

      return (_this9 = _this).__onPosCommentIdChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onPosTipArticleIdChange = function () {
      var _this10;

      return (_this10 = _this).__onPosTipArticleIdChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onPosPriceLevelIdChange = function () {
      var _this11;

      return (_this11 = _this).__onPosPriceLevelIdChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onPosUseQsrOrderNumberChange = function () {
      var _this12;

      return (_this12 = _this).__onPosUseQsrOrderNumberChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onPosSendArticleLineNumChange = function () {
      var _this13;

      return (_this13 = _this).__onPosSendArticleLineNumChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onPosMenuIdChange = function () {
      var _this14;

      return (_this14 = _this).__onPosMenuIdChange__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onPosCredentialsChange = function () {
      var _this15;

      return (_this15 = _this).__onPosCredentialsChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onPosEncryptionKeyChange = function () {
      var _this16;

      return (_this16 = _this).__onPosEncryptionKeyChange__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onPasswordChange = function () {
      var _this17;

      return (_this17 = _this).__onPasswordChange__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onPasswordVerificationChange = function () {
      var _this18;

      return (_this18 = _this).__onPasswordVerificationChange__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.onSubmit = function () {
      var _this19;

      return (_this19 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdminFormView, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPasswordVerificationChange__REACT_HOT_LOADER__',
    value: function __onPasswordVerificationChange__REACT_HOT_LOADER__() {
      return this.__onPasswordVerificationChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPasswordChange__REACT_HOT_LOADER__',
    value: function __onPasswordChange__REACT_HOT_LOADER__() {
      return this.__onPasswordChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosEncryptionKeyChange__REACT_HOT_LOADER__',
    value: function __onPosEncryptionKeyChange__REACT_HOT_LOADER__() {
      return this.__onPosEncryptionKeyChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosCredentialsChange__REACT_HOT_LOADER__',
    value: function __onPosCredentialsChange__REACT_HOT_LOADER__() {
      return this.__onPosCredentialsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosMenuIdChange__REACT_HOT_LOADER__',
    value: function __onPosMenuIdChange__REACT_HOT_LOADER__() {
      return this.__onPosMenuIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosSendArticleLineNumChange__REACT_HOT_LOADER__',
    value: function __onPosSendArticleLineNumChange__REACT_HOT_LOADER__() {
      return this.__onPosSendArticleLineNumChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosUseQsrOrderNumberChange__REACT_HOT_LOADER__',
    value: function __onPosUseQsrOrderNumberChange__REACT_HOT_LOADER__() {
      return this.__onPosUseQsrOrderNumberChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosPriceLevelIdChange__REACT_HOT_LOADER__',
    value: function __onPosPriceLevelIdChange__REACT_HOT_LOADER__() {
      return this.__onPosPriceLevelIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosTipArticleIdChange__REACT_HOT_LOADER__',
    value: function __onPosTipArticleIdChange__REACT_HOT_LOADER__() {
      return this.__onPosTipArticleIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosCommentIdChange__REACT_HOT_LOADER__',
    value: function __onPosCommentIdChange__REACT_HOT_LOADER__() {
      return this.__onPosCommentIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosCustomerIdChange__REACT_HOT_LOADER__',
    value: function __onPosCustomerIdChange__REACT_HOT_LOADER__() {
      return this.__onPosCustomerIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosUrlChange__REACT_HOT_LOADER__',
    value: function __onPosUrlChange__REACT_HOT_LOADER__() {
      return this.__onPosUrlChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosIdChange__REACT_HOT_LOADER__',
    value: function __onPosIdChange__REACT_HOT_LOADER__() {
      return this.__onPosIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPosChange__REACT_HOT_LOADER__',
    value: function __onPosChange__REACT_HOT_LOADER__() {
      return this.__onPosChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onStatusChange__REACT_HOT_LOADER__',
    value: function __onStatusChange__REACT_HOT_LOADER__() {
      return this.__onStatusChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantNameChange__REACT_HOT_LOADER__',
    value: function __onRestaurantNameChange__REACT_HOT_LOADER__() {
      return this.__onRestaurantNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onExternalIdChange__REACT_HOT_LOADER__',
    value: function __onExternalIdChange__REACT_HOT_LOADER__() {
      return this.__onExternalIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDefaultState',


    //
    // RestaurantFormComponent override.
    //

    value: function getDefaultState(restaurant) {
      return {
        externalId: restaurant.externalId,
        pos: restaurant.pos,
        posId: restaurant.posId,
        posUrl: restaurant.posUrl,
        posMenuId: restaurant.posMenuId,
        posCredentials: restaurant.posCredentials,
        posCustomerId: restaurant.posCustomerId,
        posCommentId: restaurant.posCommentId,
        posTipArticleId: restaurant.posTipArticleId,
        posPriceLevelId: restaurant.posPriceLevelId,
        posUseQsrOrderNumber: restaurant.posUseQsrOrderNumber,
        posSendArticleLineNum: restaurant.posSendArticleLineNum,
        posEncryptionKey: restaurant.posEncryptionKey,

        status: restaurant.status,

        restaurantName: restaurant.name,

        password: '',
        passwordVerification: ''
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      var restaurant = this.props.restaurant;
      var state = this.state;

      return !(state.externalId === restaurant.externalId && state.pos === restaurant.pos && state.posId === restaurant.posId && state.posUrl === restaurant.posUrl && state.posCustomerId === restaurant.posCustomerId && state.posCommentId === restaurant.posCommentId && state.posTipArticleId === restaurant.posTipArticleId && state.posPriceLevelId === restaurant.posPriceLevelId && state.posUseQsrOrderNumber === restaurant.posUseQsrOrderNumber && state.posSendArticleLineNum === restaurant.posSendArticleLineNum && state.posMenuId === restaurant.posMenuId && state.posCredentials === restaurant.posCredentials && state.posEncryptionKey === restaurant.posEncryptionKey && state.status === restaurant.status && restaurant.name === state.restaurantName && _lodash2.default.isEmpty(state.password));
    }

    //
    // form actions
    //

    //
    //
    //

  }, {
    key: '__onExternalIdChange__REACT_HOT_LOADER__',
    value: function __onExternalIdChange__REACT_HOT_LOADER__(externalId) {
      this.setState({
        externalId: externalId
      });
    }
  }, {
    key: '__onRestaurantNameChange__REACT_HOT_LOADER__',
    value: function __onRestaurantNameChange__REACT_HOT_LOADER__(restaurantName) {
      this.setState({
        restaurantName: restaurantName
      });
    }
  }, {
    key: '__onStatusChange__REACT_HOT_LOADER__',


    //
    // POS
    //

    value: function __onStatusChange__REACT_HOT_LOADER__(status) {
      this.setState({
        status: status
      });
    }
  }, {
    key: '__onPosChange__REACT_HOT_LOADER__',
    value: function __onPosChange__REACT_HOT_LOADER__(pos) {
      this.setState({
        pos: pos
      });
    }
  }, {
    key: '__onPosIdChange__REACT_HOT_LOADER__',
    value: function __onPosIdChange__REACT_HOT_LOADER__(posId) {
      this.setState({
        posId: posId
      });
    }
  }, {
    key: '__onPosUrlChange__REACT_HOT_LOADER__',
    value: function __onPosUrlChange__REACT_HOT_LOADER__(posUrl) {
      this.setState({
        posUrl: posUrl
      });
    }
  }, {
    key: '__onPosCustomerIdChange__REACT_HOT_LOADER__',
    value: function __onPosCustomerIdChange__REACT_HOT_LOADER__(posCustomerId) {
      this.setState({
        posCustomerId: posCustomerId
      });
    }
  }, {
    key: '__onPosCommentIdChange__REACT_HOT_LOADER__',
    value: function __onPosCommentIdChange__REACT_HOT_LOADER__(posCommentId) {
      this.setState({
        posCommentId: posCommentId
      });
    }
  }, {
    key: '__onPosTipArticleIdChange__REACT_HOT_LOADER__',
    value: function __onPosTipArticleIdChange__REACT_HOT_LOADER__(posTipArticleId) {
      this.setState({
        posTipArticleId: posTipArticleId
      });
    }
  }, {
    key: '__onPosPriceLevelIdChange__REACT_HOT_LOADER__',
    value: function __onPosPriceLevelIdChange__REACT_HOT_LOADER__(posPriceLevelId) {
      this.setState({
        posPriceLevelId: posPriceLevelId
      });
    }
  }, {
    key: '__onPosUseQsrOrderNumberChange__REACT_HOT_LOADER__',
    value: function __onPosUseQsrOrderNumberChange__REACT_HOT_LOADER__() {
      this.setState({
        posUseQsrOrderNumber: !this.state.posUseQsrOrderNumber
      });
    }
  }, {
    key: '__onPosSendArticleLineNumChange__REACT_HOT_LOADER__',
    value: function __onPosSendArticleLineNumChange__REACT_HOT_LOADER__() {
      this.setState({
        posSendArticleLineNum: !this.state.posSendArticleLineNum
      });
    }
  }, {
    key: '__onPosMenuIdChange__REACT_HOT_LOADER__',
    value: function __onPosMenuIdChange__REACT_HOT_LOADER__(posMenuId) {
      this.setState({
        posMenuId: posMenuId
      });
    }
  }, {
    key: '__onPosCredentialsChange__REACT_HOT_LOADER__',
    value: function __onPosCredentialsChange__REACT_HOT_LOADER__(posCredentials) {
      this.setState({
        posCredentials: posCredentials
      });
    }
  }, {
    key: '__onPosEncryptionKeyChange__REACT_HOT_LOADER__',


    //
    // Password
    //

    value: function __onPosEncryptionKeyChange__REACT_HOT_LOADER__(posEncryptionKey) {
      this.setState({
        posEncryptionKey: posEncryptionKey
      });
    }
  }, {
    key: '__onPasswordChange__REACT_HOT_LOADER__',
    value: function __onPasswordChange__REACT_HOT_LOADER__(password) {
      this.setState({
        password: password
      });
    }
  }, {
    key: '__onPasswordVerificationChange__REACT_HOT_LOADER__',


    //
    // submit
    //

    value: function __onPasswordVerificationChange__REACT_HOT_LOADER__(passwordVerification) {
      this.setState({
        passwordVerification: passwordVerification
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    // renderers
    //

    //
    //
    //

    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var restaurantMultipart = new _RestaurantMultipart2.default();

      restaurantMultipart.name = this.state.restaurantName;

      restaurantMultipart.externalId = this.state.externalId;
      restaurantMultipart.pos = this.state.pos;
      restaurantMultipart.posId = this.state.posId;
      restaurantMultipart.posUrl = this.state.posUrl;
      restaurantMultipart.posMenuId = this.state.posMenuId;
      restaurantMultipart.posCredentials = this.state.posCredentials;
      restaurantMultipart.posCustomerId = this.state.posCustomerId;
      restaurantMultipart.posCommentId = this.state.posCommentId;
      restaurantMultipart.posTipArticleId = this.state.posTipArticleId;
      restaurantMultipart.posPriceLevelId = this.state.posPriceLevelId;
      restaurantMultipart.posUseQsrOrderNumber = this.state.posUseQsrOrderNumber;
      restaurantMultipart.posSendArticleLineNum = this.state.posSendArticleLineNum;
      restaurantMultipart.posEncryptionKey = this.state.posEncryptionKey;

      restaurantMultipart.status = this.state.status;

      restaurantMultipart.password = this.state.password;
      restaurantMultipart.passwordVerification = this.state.passwordVerification;

      this.props.onUpdate(restaurantMultipart);
    }
  }, {
    key: 'renderRestaurantName',
    value: function renderRestaurantName() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.restaurant_name')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            value: this.state.restaurantName,
            onChange: this.onRestaurantNameChange,
            placeholder: '',
            required: true,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationGeneral()
          })
        )
      );
    }
  }, {
    key: 'renderRestaurantId',
    value: function renderRestaurantId() {
      var restaurant = this.props.restaurant;
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.restaurant_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, { value: restaurant.id, placeholder: '', readOnly: true })
        )
      );
    }
  }, {
    key: 'renderExternalId',
    value: function renderExternalId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.external_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, { value: this.state.externalId, onChange: this.onExternalIdChange, placeholder: '', autoComplete: 'off' })
        )
      );
    }
  }, {
    key: 'renderPassword',
    value: function renderPassword() {
      if (!_SecurityContext2.default.restaurantSettings.editConfigurationGeneral()) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.password')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PasswordInput, {
            onChange: this.onPasswordChange,
            value: this.state.password,
            autoComplete: 'off'
          })
        )
      );
    }
  }, {
    key: 'renderPasswordVerification',
    value: function renderPasswordVerification() {
      if (!_SecurityContext2.default.restaurantSettings.editConfigurationGeneral()) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'required col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.password_verification')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PasswordInput, {
            onChange: this.onPasswordVerificationChange,
            value: this.state.passwordVerification,
            autoComplete: 'off'
          })
        )
      );
    }
  }, {
    key: 'renderStatus',
    value: function renderStatus() {
      var messages = {
        ENABLED: _I18n2.default.tr('restaurant_edit.configuration.statut.ENABLED.explain'),
        DISABLED: _I18n2.default.tr('restaurant_edit.configuration.statut.DISABLED.explain')
      };

      var message = messages[this.state.status];

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 text-right' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.status')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_StoreStateChooser2.default, {
            value: this.state.status,
            onChange: this.onStatusChange,
            disabled: !_SecurityContext2.default.restaurantSettings.editConfigurationGeneral() && !_SecurityContext2.default.restaurantSettings.editConfigurationGeneralActivation() ||
            // only admin can "un-archive" the store
            this.props.restaurant.status === 'ARCHIVED' && !_SecurityContext2.default.admin.isAdmin(),
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          }),
          '\xA0\xA0',
          _react2.default.createElement(
            'span',
            null,
            message
          )
        )
      );
    }

    //
    // POS
    //

  }, {
    key: 'renderPos',
    value: function renderPos() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.POSChooser, {
            value: this.state.pos,
            onChange: this.onPosChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosUrl',
    value: function renderPosUrl() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.url')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posUrl,
            onChange: this.onPosUrlChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosId',
    value: function renderPosId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posId,
            onChange: this.onPosIdChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosCustomerId',
    value: function renderPosCustomerId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.customer_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posCustomerId,
            onChange: this.onPosCustomerIdChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosCommentId',
    value: function renderPosCommentId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.comment_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posCommentId,
            onChange: this.onPosCommentIdChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosTipArticleId',
    value: function renderPosTipArticleId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.tip_article_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posTipArticleId,
            onChange: this.onPosTipArticleIdChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosPriceLevelId',
    value: function renderPosPriceLevelId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.price_level_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posPriceLevelId,
            onChange: this.onPosPriceLevelIdChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosUseQsrOrderNumber',
    value: function renderPosUseQsrOrderNumber() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.use_qsr_order_number')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            value: this.state.posUseQsrOrderNumber,
            bsSize: 'mini',
            onChange: this.onPosUseQsrOrderNumberChange,
            disabled: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosSendArticleLineNum',
    value: function renderPosSendArticleLineNum() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.send_article_line_num')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            value: this.state.posSendArticleLineNum,
            bsSize: 'mini',
            onChange: this.onPosSendArticleLineNumChange,
            disabled: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosMenuId',
    value: function renderPosMenuId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.menu_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posMenuId,
            onChange: this.onPosMenuIdChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosCredentials',
    value: function renderPosCredentials() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.credentials')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posCredentials,
            onChange: this.onPosCredentialsChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'renderPosEncryptionKey',
    value: function renderPosEncryptionKey() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.pos.encryption_key')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.posEncryptionKey,
            onChange: this.onPosEncryptionKeyChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationPos()
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'edit_restaurant_form_view__private' },
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal', autoComplete: 'off' },
          _SecurityContext2.default.restaurantSettings.readConfigurationGeneral() && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              { className: 'text-center' },
              _I18n2.default.tr('restaurant_edit.configuration.general')
            ),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              this.renderRestaurantName(),
              this.renderRestaurantId(),
              this.renderExternalId(),
              this.renderPassword(),
              this.renderPasswordVerification(),
              this.renderStatus()
            ),
            _react2.default.createElement('hr', { className: 'top-buffer-50' })
          ),
          _SecurityContext2.default.restaurantSettings.readConfigurationPos() && _react2.default.createElement(
            'div',
            { className: 'top-buffer-50' },
            _react2.default.createElement(
              'h3',
              { className: 'text-center' },
              _I18n2.default.tr('restaurant_edit.configuration.pos')
            ),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              this.renderPos(),
              this.renderPosUrl(),
              this.renderPosId(),
              this.renderPosMenuId(),
              this.renderPosCredentials(),
              this.renderPosCustomerId(),
              this.renderPosCommentId(),
              this.renderPosTipArticleId(),
              this.renderPosPriceLevelId(),
              this.renderPosUseQsrOrderNumber(),
              this.renderPosSendArticleLineNum(),
              this.renderPosEncryptionKey()
            ),
            _react2.default.createElement('hr', { className: 'top-buffer-50' })
          ),
          this.renderButtons()
        )
      );
    }
  }]);

  return AdminFormView;
}(_RestaurantFormComponent2.default);

AdminFormView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_Restaurant2.default),

  /**
   * @param RestaurantMultipart
   */
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = AdminFormView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AdminFormView, 'AdminFormView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/ConfigurationFormView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/FeaturesFormView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _RestaurantFormComponent = __webpack_require__("./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js");

var _RestaurantFormComponent2 = _interopRequireDefault(_RestaurantFormComponent);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


// -- views


var AdminFormView = function (_RestaurantFormCompon) {
  _inherits(AdminFormView, _RestaurantFormCompon);

  function AdminFormView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdminFormView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminFormView.__proto__ || Object.getPrototypeOf(AdminFormView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.restaurant), _this.onFeaturesChange = function () {
      var _this2;

      return (_this2 = _this).__onFeaturesChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onServiceTypeChange = function () {
      var _this3;

      return (_this3 = _this).__onServiceTypeChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onSubmit = function () {
      var _this4;

      return (_this4 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdminFormView, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onServiceTypeChange__REACT_HOT_LOADER__',
    value: function __onServiceTypeChange__REACT_HOT_LOADER__() {
      return this.__onServiceTypeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFeaturesChange__REACT_HOT_LOADER__',
    value: function __onFeaturesChange__REACT_HOT_LOADER__() {
      return this.__onFeaturesChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDefaultState',


    //
    // RestaurantFormComponent override.
    //

    value: function getDefaultState(restaurant) {
      return {
        serviceType: restaurant.serviceType,

        features: restaurant.features
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      var restaurant = this.props.restaurant;
      var state = this.state;

      return !(state.serviceType === restaurant.serviceType && state.features === restaurant.features);
    }

    //
    // form actions
    //

  }, {
    key: '__onFeaturesChange__REACT_HOT_LOADER__',
    value: function __onFeaturesChange__REACT_HOT_LOADER__(features) {
      this.setState({
        features: features
      });
    }
  }, {
    key: '__onServiceTypeChange__REACT_HOT_LOADER__',


    //
    // submit
    //

    value: function __onServiceTypeChange__REACT_HOT_LOADER__(serviceType) {
      this.setState({
        serviceType: serviceType
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var restaurantMultipart = new _RestaurantMultipart2.default();

      restaurantMultipart.serviceType = this.state.serviceType;
      restaurantMultipart.features = this.state.features;

      this.props.onUpdate(restaurantMultipart);
    }
  }, {
    key: 'renderServiceType',
    value: function renderServiceType() {
      var options = [{
        label: _I18n2.default.tr('restaurant_edit.features.table_number'),
        value: 1
      }, {
        label: _I18n2.default.tr('restaurant_edit.features.qr_code'),
        value: 2
      }, {
        label: _I18n2.default.tr('restaurant_edit.features.pairing'),
        value: 4
      }];

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.features.retrieving_bill_method')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.BitfieldChooser, {
            options: options,
            mask: this.state.serviceType,
            onChange: this.onServiceTypeChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFeatures()
          })
        )
      );
    }
  }, {
    key: 'renderFeatures',
    value: function renderFeatures() {
      var options = [{
        label: _I18n2.default.tr('restaurant_edit.features.payment'),
        value: 1
      }, {
        label: _I18n2.default.tr('restaurant_edit.features.order'),
        value: 2
      }];

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.features.label')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.BitfieldChooser, {
            options: options,
            mask: this.state.features,
            onChange: this.onFeaturesChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFeatures()
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var restaurant = this.props.restaurant;

      return _react2.default.createElement(
        'div',
        { className: 'edit_restaurant_form_view__private' },
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal' },
          _react2.default.createElement(
            'div',
            null,
            this.renderFeatures(),
            this.renderServiceType(),
            _react2.default.createElement('hr', null)
          ),
          this.renderButtons()
        )
      );
    }
  }]);

  return AdminFormView;
}(_RestaurantFormComponent2.default);

AdminFormView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_Restaurant2.default),

  /**
  * @param RestaurantMultipart
  */
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = AdminFormView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AdminFormView, 'AdminFormView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/FeaturesFormView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/FinanceFormView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _cloneDeepWith = __webpack_require__("./node_modules/lodash/cloneDeepWith.js");

var _cloneDeepWith2 = _interopRequireDefault(_cloneDeepWith);

var _ApiManagerOptions = __webpack_require__("./scripts/constants/ApiManagerOptions.js");

var _ApiManagerOptions2 = _interopRequireDefault(_ApiManagerOptions);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _TaxesType = __webpack_require__("./sdk/scripts/constants/TaxesType.js");

var _TaxesType2 = _interopRequireDefault(_TaxesType);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _RestaurantLegalBank = __webpack_require__("./sdk/scripts/entities/RestaurantLegalBank.js");

var _RestaurantLegalBank2 = _interopRequireDefault(_RestaurantLegalBank);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _RestaurantFormComponent = __webpack_require__("./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js");

var _RestaurantFormComponent2 = _interopRequireDefault(_RestaurantFormComponent);

var _PdfViewerModal = __webpack_require__("./sdk/scripts/components/pdfViewer/PdfViewerModal.js");

var _PdfViewerModal2 = _interopRequireDefault(_PdfViewerModal);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _PayGreenConfigurationView = __webpack_require__("./scripts/pages/restaurant/edit/components/PayGreenConfigurationView.js");

var _PayGreenConfigurationView2 = _interopRequireDefault(_PayGreenConfigurationView);

var _SaferpayConfigurationView = __webpack_require__("./scripts/pages/restaurant/edit/components/SaferpayConfigurationView.js");

var _SaferpayConfigurationView2 = _interopRequireDefault(_SaferpayConfigurationView);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


// -- views


var PrivateFormView = function (_RestaurantFormCompon) {
  _inherits(PrivateFormView, _RestaurantFormCompon);

  function PrivateFormView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PrivateFormView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivateFormView.__proto__ || Object.getPrototypeOf(PrivateFormView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.restaurant), _this.onShowRibPdfModal = function () {
      var _this2;

      return (_this2 = _this).__onShowRibPdfModal__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHideRibPdfModal = function () {
      var _this3;

      return (_this3 = _this).__onHideRibPdfModal__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onShowProofOfIncomePdfModal = function () {
      var _this4;

      return (_this4 = _this).__onShowProofOfIncomePdfModal__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onHideProofOfIncomePdfModal = function () {
      var _this5;

      return (_this5 = _this).__onHideProofOfIncomePdfModal__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onLegalBankBicChange = function () {
      var _this6;

      return (_this6 = _this).__onLegalBankBicChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onLegalBankIbanChange = function () {
      var _this7;

      return (_this7 = _this).__onLegalBankIbanChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onLegalFinancialDepartmentEmailChange = function () {
      var _this8;

      return (_this8 = _this).__onLegalFinancialDepartmentEmailChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onLegalBankTransferFrequencyChange = function () {
      var _this9;

      return (_this9 = _this).__onLegalBankTransferFrequencyChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onLegalBankRibFileChange = function () {
      var _this10;

      return (_this10 = _this).__onLegalBankRibFileChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onProofOfIncomeFileChange = function () {
      var _this11;

      return (_this11 = _this).__onProofOfIncomeFileChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onPspRestaurantIdChange = function () {
      var _this12;

      return (_this12 = _this).__onPspRestaurantIdChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.handleBankChoice = function () {
      var _this13;

      return (_this13 = _this).__handleBankChoice__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.handlePspSettingsChange = function () {
      var _this14;

      return (_this14 = _this).__handlePspSettingsChange__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onFeeFixedChange = function () {
      var _this15;

      return (_this15 = _this).__onFeeFixedChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onFeeVariableChange = function () {
      var _this16;

      return (_this16 = _this).__onFeeVariableChange__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onFeeVatPercentageChange = function () {
      var _this17;

      return (_this17 = _this).__onFeeVatPercentageChange__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onAllowTipsChange = function () {
      var _this18;

      return (_this18 = _this).__onAllowTipsChange__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.onSubmit = function () {
      var _this19;

      return (_this19 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PrivateFormView, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAllowTipsChange__REACT_HOT_LOADER__',
    value: function __onAllowTipsChange__REACT_HOT_LOADER__() {
      return this.__onAllowTipsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFeeVatPercentageChange__REACT_HOT_LOADER__',
    value: function __onFeeVatPercentageChange__REACT_HOT_LOADER__() {
      return this.__onFeeVatPercentageChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFeeVariableChange__REACT_HOT_LOADER__',
    value: function __onFeeVariableChange__REACT_HOT_LOADER__() {
      return this.__onFeeVariableChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFeeFixedChange__REACT_HOT_LOADER__',
    value: function __onFeeFixedChange__REACT_HOT_LOADER__() {
      return this.__onFeeFixedChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handlePspSettingsChange__REACT_HOT_LOADER__',
    value: function __handlePspSettingsChange__REACT_HOT_LOADER__() {
      return this.__handlePspSettingsChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleBankChoice__REACT_HOT_LOADER__',
    value: function __handleBankChoice__REACT_HOT_LOADER__() {
      return this.__handleBankChoice__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPspRestaurantIdChange__REACT_HOT_LOADER__',
    value: function __onPspRestaurantIdChange__REACT_HOT_LOADER__() {
      return this.__onPspRestaurantIdChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onProofOfIncomeFileChange__REACT_HOT_LOADER__',
    value: function __onProofOfIncomeFileChange__REACT_HOT_LOADER__() {
      return this.__onProofOfIncomeFileChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalBankRibFileChange__REACT_HOT_LOADER__',
    value: function __onLegalBankRibFileChange__REACT_HOT_LOADER__() {
      return this.__onLegalBankRibFileChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalBankTransferFrequencyChange__REACT_HOT_LOADER__',
    value: function __onLegalBankTransferFrequencyChange__REACT_HOT_LOADER__() {
      return this.__onLegalBankTransferFrequencyChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalFinancialDepartmentEmailChange__REACT_HOT_LOADER__',
    value: function __onLegalFinancialDepartmentEmailChange__REACT_HOT_LOADER__() {
      return this.__onLegalFinancialDepartmentEmailChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalBankIbanChange__REACT_HOT_LOADER__',
    value: function __onLegalBankIbanChange__REACT_HOT_LOADER__() {
      return this.__onLegalBankIbanChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalBankBicChange__REACT_HOT_LOADER__',
    value: function __onLegalBankBicChange__REACT_HOT_LOADER__() {
      return this.__onLegalBankBicChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideProofOfIncomePdfModal__REACT_HOT_LOADER__',
    value: function __onHideProofOfIncomePdfModal__REACT_HOT_LOADER__() {
      return this.__onHideProofOfIncomePdfModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onShowProofOfIncomePdfModal__REACT_HOT_LOADER__',
    value: function __onShowProofOfIncomePdfModal__REACT_HOT_LOADER__() {
      return this.__onShowProofOfIncomePdfModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHideRibPdfModal__REACT_HOT_LOADER__',
    value: function __onHideRibPdfModal__REACT_HOT_LOADER__() {
      return this.__onHideRibPdfModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onShowRibPdfModal__REACT_HOT_LOADER__',
    value: function __onShowRibPdfModal__REACT_HOT_LOADER__() {
      return this.__onShowRibPdfModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDefaultState',


    //
    // RestaurantFormComponent override.
    //

    value: function getDefaultState(restaurant) {
      return {
        acquirer: restaurant.acquirer,
        psp: restaurant.psp,
        pspSettings: restaurant.pspSettings ? (0, _cloneDeepWith2.default)(restaurant.pspSettings) : {},
        allowTips: restaurant.allowTips,

        bank: restaurant.legal.bank.copy(),
        legalBankRibFile: null,

        proofOfIncomeFile: null,

        // UI state
        displayRibPdfModal: false,
        displayProofOfIncomePdfModal: false,

        // form's warnings
        formWarnings: {}
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      var restaurant = this.props.restaurant;
      var state = this.state;

      return !(restaurant.acquirer === state.acquirer && state.allowTips === restaurant.allowTips && restaurant.psp === state.psp && _lodash2.default.isEqual(restaurant.pspSettings, state.pspSettings) && _lodash2.default.isNull(state.legalBankRibFile) && _lodash2.default.isNull(state.proofOfIncomeFile) && state.bank.equals(this.props.restaurant.legal.bank));
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      if (this.state.psp === 'MANGOPAY') {
        return this.isBicValid(this.state.bank.bic) && this.isIbanValid(this.state.bank.iban);
      }
      return true; // consider it as valid to allow adding values that we have
      // https://paymytable.atlassian.net/browse/PP-1083
      //: !_.isEmpty(this.state.bank.pspRestaurantId) &&
      //    (!_.isEmpty(this.state.pspSettings) || !_.isEmpty(this.props.restaurant.pspSettings));
    }
  }, {
    key: 'isBicValid',
    value: function isBicValid(bic) {
      var bicRegex = /^[a-zA-Z]{6}\w{2}(\w{3})?$/;
      return _lodash2.default.isEmpty(bic) || this.checkRegex(bicRegex, bic);
    }
  }, {
    key: 'isIbanValid',
    value: function isIbanValid(iban) {
      var ibanRegex = /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;
      return _lodash2.default.isEmpty(iban) || this.checkRegex(ibanRegex, iban);
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return !this.isValid();
    }

    //
    //
    //

  }, {
    key: '__onShowRibPdfModal__REACT_HOT_LOADER__',
    value: function __onShowRibPdfModal__REACT_HOT_LOADER__() {
      this.setState({
        displayRibPdfModal: true
      });
    }
  }, {
    key: '__onHideRibPdfModal__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onHideRibPdfModal__REACT_HOT_LOADER__() {
      this.setState({
        displayRibPdfModal: false
      });
    }
  }, {
    key: '__onShowProofOfIncomePdfModal__REACT_HOT_LOADER__',
    value: function __onShowProofOfIncomePdfModal__REACT_HOT_LOADER__() {
      this.setState({
        displayProofOfIncomePdfModal: true
      });
    }
  }, {
    key: '__onHideProofOfIncomePdfModal__REACT_HOT_LOADER__',


    //
    // form actions
    //

    value: function __onHideProofOfIncomePdfModal__REACT_HOT_LOADER__() {
      this.setState({
        displayProofOfIncomePdfModal: false
      });
    }
  }, {
    key: '__onLegalBankBicChange__REACT_HOT_LOADER__',
    value: function __onLegalBankBicChange__REACT_HOT_LOADER__(bic) {
      var bank = this.state.bank;
      bank.bic = bic;

      this.setState({
        bank: bank,
        formWarnings: _extends({}, this.state.formWarnings, {
          bic: this.isBicValid(bic) ? '' : _I18n2.default.tr('restaurant_edit.finance.bic.invalid')
        })
      });
    }
  }, {
    key: '__onLegalBankIbanChange__REACT_HOT_LOADER__',
    value: function __onLegalBankIbanChange__REACT_HOT_LOADER__(iban) {
      var bank = this.state.bank;
      bank.iban = iban;
      this.setState({
        bank: bank,
        formWarnings: _extends({}, this.state.formWarnings, {
          iban: this.isIbanValid(iban) ? '' : _I18n2.default.tr('restaurant_edit.finance.iban.invalid')
        })
      });
    }
  }, {
    key: '__onLegalFinancialDepartmentEmailChange__REACT_HOT_LOADER__',
    value: function __onLegalFinancialDepartmentEmailChange__REACT_HOT_LOADER__(financialDepartmentEmail) {
      var bank = this.state.bank;
      bank.financialDepartmentEmail = financialDepartmentEmail;
      this.setState({
        bank: bank
      });
    }
  }, {
    key: '__onLegalBankTransferFrequencyChange__REACT_HOT_LOADER__',
    value: function __onLegalBankTransferFrequencyChange__REACT_HOT_LOADER__(transferFrequency) {
      var bank = this.state.bank;
      bank.transferFrequency = transferFrequency;
      this.setState({
        bank: bank
      });
    }
  }, {
    key: '__onLegalBankRibFileChange__REACT_HOT_LOADER__',
    value: function __onLegalBankRibFileChange__REACT_HOT_LOADER__(file) {
      this.setState({
        legalBankRibFile: file
      });
    }
  }, {
    key: '__onProofOfIncomeFileChange__REACT_HOT_LOADER__',
    value: function __onProofOfIncomeFileChange__REACT_HOT_LOADER__(file) {
      this.setState({
        proofOfIncomeFile: file
      });
    }
  }, {
    key: '__onPspRestaurantIdChange__REACT_HOT_LOADER__',
    value: function __onPspRestaurantIdChange__REACT_HOT_LOADER__(pspRestaurantId) {
      var bank = this.state.bank;
      bank.pspRestaurantId = pspRestaurantId;
      this.setState({
        bank: bank
      });
    }
  }, {
    key: '__handleBankChoice__REACT_HOT_LOADER__',
    value: function __handleBankChoice__REACT_HOT_LOADER__(psp) {
      var acquirer = psp;

      var isSameAsInit = psp === this.props.restaurant.psp;

      this.setState({
        acquirer: acquirer,
        psp: psp,
        bank: isSameAsInit ? this.props.restaurant.legal.bank.copy() : new _RestaurantLegalBank2.default(),
        pspSettings: {}
      });
    }
  }, {
    key: '__handlePspSettingsChange__REACT_HOT_LOADER__',


    //
    // Fee
    //

    value: function __handlePspSettingsChange__REACT_HOT_LOADER__(pspSettings) {
      this.setState({
        pspSettings: pspSettings
      });
    }
  }, {
    key: '__onFeeFixedChange__REACT_HOT_LOADER__',
    value: function __onFeeFixedChange__REACT_HOT_LOADER__(feeFixed) {
      var bank = this.state.bank;
      bank.feeFixed = feeFixed;
      this.setState({
        bank: bank
      });
    }
  }, {
    key: '__onFeeVariableChange__REACT_HOT_LOADER__',
    value: function __onFeeVariableChange__REACT_HOT_LOADER__(feeVariable) {
      var bank = this.state.bank;
      bank.feeVariable = feeVariable;
      this.setState({
        bank: bank
      });
    }
  }, {
    key: '__onFeeVatPercentageChange__REACT_HOT_LOADER__',
    value: function __onFeeVatPercentageChange__REACT_HOT_LOADER__(_ref2) {
      var value = _ref2.value;

      var bank = this.state.bank;
      bank.feeVatPercentage = value;
      this.setState({
        bank: bank
      });
    }
  }, {
    key: '__onAllowTipsChange__REACT_HOT_LOADER__',
    value: function __onAllowTipsChange__REACT_HOT_LOADER__() {
      this.setState({
        allowTips: !this.state.allowTips
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    // renderers
    //

    /**
     * TODO: multiple select
     */
    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!this.isValid()) {
        return;
      }

      var restaurantMultipart = new _RestaurantMultipart2.default();

      restaurantMultipart.acquirer = this.state.acquirer;
      restaurantMultipart.psp = this.state.psp;
      restaurantMultipart.pspSettings = this.state.pspSettings;
      restaurantMultipart.allowTips = this.state.allowTips;

      restaurantMultipart.legal = this.props.restaurant.legal.copy();
      restaurantMultipart.legal.bank = this.state.bank.copy();

      if (!_lodash2.default.isNull(this.state.menuImage)) {
        restaurantMultipart.legalBankIdentityDocument = this.state.legalBankRibFile;
      }

      if (!_lodash2.default.isNull(this.state.menuImage)) {
        restaurantMultipart.proofOfIncome = this.state.proofOfIncomeFile;
      }

      this.props.onUpdate(restaurantMultipart);
    }
  }, {
    key: 'renderInAcceptedCreditCard',
    value: function renderInAcceptedCreditCard() {
      var acceptedCreditCards = [];

      if (this.restaurant.isAcceptingVisa()) {
        acceptedCreditCards.push('Visa');
      }
      if (this.restaurant.isAcceptingAmex()) {
        acceptedCreditCards.push('American express');
      }
      if (this.restaurant.isAcceptingMastercard()) {
        acceptedCreditCards.push('Mastercard');
      }

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.accepted_payment_means')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 input-group fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              acceptedCreditCards.join(', ')
            )
          )
        )
      );
    }
  }, {
    key: 'renderBic',
    value: function renderBic() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.bic'),
            this.renderBankIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.bank.bic,
            onChange: this.onLegalBankBicChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFinanceBankAccount()
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'alert alert-danger top-buffer-10' + (_lodash2.default.isEmpty(this.state.formWarnings.bic) ? ' hide' : '')
            },
            this.state.formWarnings.bic
          )
        )
      );
    }
  }, {
    key: 'renderCurrency',
    value: function renderCurrency() {
      var value = _utils.CurrencyUtils.getNameForCode(this.props.restaurant.currency) + ' (' + this.props.restaurant.currency + ')';

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.money')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, { readOnly: true, value: value })
        )
      );
    }
  }, {
    key: 'renderIban',
    value: function renderIban() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.iban'),
            this.renderBankIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.bank.iban,
            onChange: this.onLegalBankIbanChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFinanceBankAccount()
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'alert alert-danger top-buffer-10' + (_lodash2.default.isEmpty(this.state.formWarnings.iban) ? ' hide' : '')
            },
            this.state.formWarnings.iban
          )
        )
      );
    }
  }, {
    key: 'renderRibPdfModal',
    value: function renderRibPdfModal() {
      var ribUrl = this.props.restaurant.legal.bank.identityDocument;

      var httpHeaders = _ApiManagerOptions2.default.headersMiddleware();

      return _react2.default.createElement(_PdfViewerModal2.default, {
        show: this.state.displayRibPdfModal,
        onHide: this.onHideRibPdfModal,
        file: ribUrl,
        httpHeaders: httpHeaders,
        title: _I18n2.default.tr('restaurant_edit.finance.rib')
      });
    }
  }, {
    key: 'renderProofOfIncomePdfModal',
    value: function renderProofOfIncomePdfModal() {
      var url = this.props.restaurant.legal.proofOfIncome;

      var httpHeaders = _ApiManagerOptions2.default.headersMiddleware();

      return _react2.default.createElement(_PdfViewerModal2.default, {
        show: this.state.displayProofOfIncomePdfModal,
        onHide: this.onHideProofOfIncomePdfModal,
        file: url,
        httpHeaders: httpHeaders,
        title: 'Proof of income'
      });
    }
  }, {
    key: 'renderRib',
    value: function renderRib() {
      var ribUrl = this.props.restaurant.legal.bank.identityDocument;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.rib')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PdfDropzone, {
            onChange: this.onLegalBankRibFileChange,
            file: this.state.legalBankRibFile,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFinanceBankAccount()
          }),
          _react2.default.createElement('br', null),
          !_lodash2.default.isEmpty(ribUrl) && _react2.default.createElement(
            'a',
            { onClick: this.onShowRibPdfModal },
            _I18n2.default.tr('restaurant_edit.finance.rib.see_file')
          )
        )
      );
    }
  }, {
    key: 'renderBankTransferFrequency',
    value: function renderBankTransferFrequency() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.automatic_payout_frequency')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TransferFrequencyChooser, {
            value: this.state.bank.transferFrequency,
            onChange: this.onLegalBankTransferFrequencyChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFinanceOther()
          })
        )
      );
    }
  }, {
    key: 'renderFinancialDepartmentEmail',
    value: function renderFinancialDepartmentEmail() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.finance.financial_department_email')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.bank.financialDepartmentEmail,
            onChange: this.onLegalFinancialDepartmentEmailChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editFinanceOther()
          })
        )
      );
    }
  }, {
    key: 'rendersBankChoice',
    value: function rendersBankChoice() {
      var _this20 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row form-group' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-4 text-right' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.configuration.bank.choice')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this20.handleBankChoice('MANGOPAY');
                },
                style: {
                  padding: 20,
                  background: this.state.psp === 'MANGOPAY' ? 'red' : ''
                }
              },
              'Mangopay'
            ),
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this20.handleBankChoice('PAYGREEN');
                },
                style: {
                  padding: 20,
                  background: this.state.psp === 'PAYGREEN' ? 'red' : ''
                }
              },
              'PayGreen'
            ),
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this20.handleBankChoice('SAFERPAY');
                },
                style: {
                  padding: 20,
                  background: this.state.psp === 'SAFERPAY' ? 'red' : ''
                }
              },
              'Saferpay'
            ),
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this20.handleBankChoice('ADYEN');
                },
                style: {
                  padding: 20,
                  background: this.state.psp === 'ADYEN' ? 'red' : ''
                }
              },
              'Adyen'
            ),
            _SecurityContext2.default.admin.isAdmin() && _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this20.handleBankChoice('FAKE');
                },
                style: {
                  padding: 20,
                  background: this.state.psp === 'FAKE' ? 'red' : ''
                }
              },
              'Fake PSP'
            )
          )
        ),
        this.renderPspRestaurantId(),
        this.renderAcquirerWalletId(),
        this.renderAcquirerBankId()
      );
    }
  }, {
    key: 'renderPspRestaurantId',
    value: function renderPspRestaurantId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.bank.psp.restaurantId')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            value: this.state.bank.pspRestaurantId,
            onChange: this.onPspRestaurantIdChange
          })
        )
      );
    }
  }, {
    key: 'renderAcquirerWalletId',
    value: function renderAcquirerWalletId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.bank.acquirer.wallet_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, { value: this.state.bank.acquirerWalletId })
        )
      );
    }
  }, {
    key: 'renderAcquirerBankId',
    value: function renderAcquirerBankId() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.bank.acquirer.bank_id')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, { value: this.state.bank.acquirerBankAccountId })
        )
      );
    }

    //
    // Fee
    //

  }, {
    key: 'renderFeeFixed',
    value: function renderFeeFixed() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.commission_per_transaction')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.state.bank.feeFixed,
              onChange: this.onFeeFixedChange,
              min: 0,
              readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationCommission()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _utils.CurrencyUtils.getCurrencySymbol(this.props.restaurant.currency)
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderFeeVariable',
    value: function renderFeeVariable() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.commission_per_transaction_variable')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: this.state.bank.feeVariable,
              onChange: this.onFeeVariableChange,
              readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationCommission()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                '%'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderFeeVatPercentage',
    value: function renderFeeVatPercentage() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 text-right' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.fee_vat_percentage')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.LocalizableSelect, {
            clearable: false,
            value: this.state.bank.feeVatPercentage,
            options: _TaxesType2.default.getLegalBankFeeTaxes(),
            onChange: this.onFeeVatPercentageChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editConfigurationCommission()
          })
        )
      );
    }
  }, {
    key: 'renderAllowTips',
    value: function renderAllowTips() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 text-right' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.configuration.tips')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_reactBootstrapSwitch2.default, {
            bsSize: 'mini'
            // defaultValue={this.props.retaurant.allowTips}
            , value: this.state.allowTips,
            onChange: this.onAllowTipsChange,
            disabled: !_SecurityContext2.default.restaurantSettings.editConfigurationCommission()
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this21 = this;

      return _react2.default.createElement(
        'div',
        { className: 'edit_restaurant_form_view__private' },
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal' },
          this.renderIconsLegend(),
          _SecurityContext2.default.restaurantSettings.readConfigurationMangoPay() && _react2.default.createElement(
            'div',
            { className: 'top-buffer-50' },
            _react2.default.createElement(
              'h3',
              { className: 'text-center' },
              _I18n2.default.tr('restaurant_edit.configuration.bank')
            ),
            _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              this.rendersBankChoice()
            ),
            _react2.default.createElement('hr', { className: 'top-buffer-50' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-buffer-50' },
            this.renderCurrency(),
            _react2.default.createElement('hr', { className: 'top-buffer-50' })
          ),
          (this.state.psp === 'MANGOPAY' || this.state.psp === 'PAYGREEN') && _react2.default.createElement(
            'div',
            null,
            _SecurityContext2.default.restaurantSettings.readFinanceBankAccount() && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                { className: 'text-center' },
                _I18n2.default.tr('restaurant_edit.finance.bank_account')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderIban(),
                this.renderRib(),
                this.renderBic()
              ),
              _react2.default.createElement('hr', { className: 'top-buffer-50' })
            ),
            _SecurityContext2.default.restaurantSettings.readFinanceOther() && _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              _react2.default.createElement(
                'h3',
                { className: 'text-center' },
                _I18n2.default.tr('restaurant_edit.finance.other')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderInAcceptedCreditCard(),
                this.renderBankTransferFrequency(),
                this.renderFinancialDepartmentEmail()
              ),
              _react2.default.createElement('hr', { className: 'top-buffer-50' })
            ),
            _SecurityContext2.default.restaurantSettings.readConfigurationCommission() && _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              _react2.default.createElement(
                'h3',
                { className: 'text-center' },
                _I18n2.default.tr('restaurant_edit.configuration.commissions')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderFeeFixed(),
                this.renderFeeVariable(),
                this.renderFeeVatPercentage(),
                this.renderAllowTips()
              ),
              _react2.default.createElement('hr', { className: 'top-buffer-50' })
            )
          ),
          this.state.psp === 'PAYGREEN' && _react2.default.createElement(_PayGreenConfigurationView2.default, {
            onChange: function onChange(pspSettings) {
              return _this21.setState({ pspSettings: pspSettings });
            },
            pspSettings: this.state.pspSettings,
            bank: this.state.bank,
            legal: this.props.restaurant.legal,
            onChangeBank: function onChangeBank(bank) {
              return _this21.setState({ bank: bank });
            },
            restaurant: this.props.restaurant
          }),
          this.state.psp === 'SAFERPAY' && _react2.default.createElement(_SaferpayConfigurationView2.default, {
            onChange: function onChange(pspSettings) {
              return _this21.setState({ pspSettings: pspSettings });
            },
            pspSettings: this.state.pspSettings
          }),
          this.state.psp === 'PAYGREEN' && _react2.default.createElement(
            'div',
            { className: 'row form-group' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4 control-label' },
              _react2.default.createElement(
                'label',
                null,
                'Proof of income'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(_form.PdfDropzone, {
                onChange: this.onProofOfIncomeFileChange,
                file: this.state.proofOfIncomeFile,
                readOnly: !_SecurityContext2.default.restaurantSettings.editFinanceBankAccount()
              }),
              _react2.default.createElement('br', null),
              !_lodash2.default.isEmpty(_lodash2.default.get(this.props.restaurant, 'legal.proofOfIncome', null)) && _react2.default.createElement(
                'a',
                { onClick: this.onShowProofOfIncomePdfModal },
                _I18n2.default.tr('restaurant_edit.finance.rib.see_file')
              )
            )
          ),
          this.state.psp === 'ADYEN' && _react2.default.createElement(
            'div',
            { className: 'row form-group text-center' },
            _react2.default.createElement(
              'span',
              null,
              _I18n2.default.tr('restaurant_edit.finance.settings_on_restaurantsgroup'),
              _react2.default.createElement(
                'a',
                { href: _Config2.default.BOV2_URL,
                  target: "_blank" },
                _Config2.default.BOV2_URL
              )
            )
          ),
          this.renderButtons(),
          this.renderRibPdfModal(),
          this.renderProofOfIncomePdfModal()
        )
      );
    }
  }]);

  return PrivateFormView;
}(_RestaurantFormComponent2.default);

PrivateFormView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_Restaurant2.default),

  /**
   * @param RestaurantMultipart
   */
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = PrivateFormView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PrivateFormView, 'PrivateFormView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/FinanceFormView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/LegalFormView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiManagerOptions = __webpack_require__("./scripts/constants/ApiManagerOptions.js");

var _ApiManagerOptions2 = _interopRequireDefault(_ApiManagerOptions);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _RestaurantFormComponent = __webpack_require__("./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js");

var _RestaurantFormComponent2 = _interopRequireDefault(_RestaurantFormComponent);

var _PdfViewerModal = __webpack_require__("./sdk/scripts/components/pdfViewer/PdfViewerModal.js");

var _PdfViewerModal2 = _interopRequireDefault(_PdfViewerModal);

var _Calendar = __webpack_require__("./sdk/scripts/components/Calendar.js");

var _Calendar2 = _interopRequireDefault(_Calendar);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


// -- views


var LegalFormView = function (_RestaurantFormCompon) {
  _inherits(LegalFormView, _RestaurantFormCompon);

  function LegalFormView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LegalFormView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LegalFormView.__proto__ || Object.getPrototypeOf(LegalFormView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.restaurant), _this.onShowPdfModal = function () {
      var _this2;

      return (_this2 = _this).__onShowPdfModal__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onHidePdfModal = function () {
      var _this3;

      return (_this3 = _this).__onHidePdfModal__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onRestaurantEmailChange = function () {
      var _this4;

      return (_this4 = _this).__onRestaurantEmailChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onLegalManagerNameChange = function () {
      var _this5;

      return (_this5 = _this).__onLegalManagerNameChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onLegalManagerPhoneChange = function () {
      var _this6;

      return (_this6 = _this).__onLegalManagerPhoneChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onLegalSirenChange = function () {
      var _this7;

      return (_this7 = _this).__onLegalSirenChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onLegalVatNumberChange = function () {
      var _this8;

      return (_this8 = _this).__onLegalVatNumberChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onLegalCompanyNameChange = function () {
      var _this9;

      return (_this9 = _this).__onLegalCompanyNameChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onLegalCompanyAddressStreetChange = function () {
      var _this10;

      return (_this10 = _this).__onLegalCompanyAddressStreetChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onLegalCompanyAddressPostCodeChange = function () {
      var _this11;

      return (_this11 = _this).__onLegalCompanyAddressPostCodeChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onLegalCompanyAddressCityChange = function () {
      var _this12;

      return (_this12 = _this).__onLegalCompanyAddressCityChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onLegalCompanyAddressCountryChange = function () {
      var _this13;

      return (_this13 = _this).__onLegalCompanyAddressCountryChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onLegalStatuteChange = function () {
      var _this14;

      return (_this14 = _this).__onLegalStatuteChange__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onLegalRegistrationProofChange = function () {
      var _this15;

      return (_this15 = _this).__onLegalRegistrationProofChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onLegalShareholderDeclarationChange = function () {
      var _this16;

      return (_this16 = _this).__onLegalShareholderDeclarationChange__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onLegalRepresentativeFirstNameChange = function () {
      var _this17;

      return (_this17 = _this).__onLegalRepresentativeFirstNameChange__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onLegalRepresentativeLastNameChange = function () {
      var _this18;

      return (_this18 = _this).__onLegalRepresentativeLastNameChange__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.onLegalRepresentativeEmailChange = function () {
      var _this19;

      return (_this19 = _this).__onLegalRepresentativeEmailChange__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _this.onLegalRepresentativeBirthdateChange = function () {
      var _this20;

      return (_this20 = _this).__onLegalRepresentativeBirthdateChange__REACT_HOT_LOADER__.apply(_this20, arguments);
    }, _this.onLegalRepresentativeNationalityChange = function () {
      var _this21;

      return (_this21 = _this).__onLegalRepresentativeNationalityChange__REACT_HOT_LOADER__.apply(_this21, arguments);
    }, _this.onLegalRepresentativeCountryOfResidenceChange = function () {
      var _this22;

      return (_this22 = _this).__onLegalRepresentativeCountryOfResidenceChange__REACT_HOT_LOADER__.apply(_this22, arguments);
    }, _this.onLegalRepresentativeAddressStreetChange = function () {
      var _this23;

      return (_this23 = _this).__onLegalRepresentativeAddressStreetChange__REACT_HOT_LOADER__.apply(_this23, arguments);
    }, _this.onLegalRepresentativePostCodeChange = function () {
      var _this24;

      return (_this24 = _this).__onLegalRepresentativePostCodeChange__REACT_HOT_LOADER__.apply(_this24, arguments);
    }, _this.onLegalRepresentativeCityChange = function () {
      var _this25;

      return (_this25 = _this).__onLegalRepresentativeCityChange__REACT_HOT_LOADER__.apply(_this25, arguments);
    }, _this.onLegalRepresentativeCountryChange = function () {
      var _this26;

      return (_this26 = _this).__onLegalRepresentativeCountryChange__REACT_HOT_LOADER__.apply(_this26, arguments);
    }, _this.onLegalRepresentativeIdentityPdfChange = function () {
      var _this27;

      return (_this27 = _this).__onLegalRepresentativeIdentityPdfChange__REACT_HOT_LOADER__.apply(_this27, arguments);
    }, _this.onSubmit = function () {
      var _this28;

      return (_this28 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this28, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LegalFormView, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeIdentityPdfChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeIdentityPdfChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeIdentityPdfChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeCountryChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeCountryChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeCountryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeCityChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeCityChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeCityChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativePostCodeChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativePostCodeChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativePostCodeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeAddressStreetChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeAddressStreetChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeAddressStreetChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeCountryOfResidenceChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeCountryOfResidenceChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeCountryOfResidenceChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeNationalityChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeNationalityChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeNationalityChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeBirthdateChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeBirthdateChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeBirthdateChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeEmailChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeEmailChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeEmailChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeLastNameChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeLastNameChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeLastNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRepresentativeFirstNameChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeFirstNameChange__REACT_HOT_LOADER__() {
      return this.__onLegalRepresentativeFirstNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalShareholderDeclarationChange__REACT_HOT_LOADER__',
    value: function __onLegalShareholderDeclarationChange__REACT_HOT_LOADER__() {
      return this.__onLegalShareholderDeclarationChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalRegistrationProofChange__REACT_HOT_LOADER__',
    value: function __onLegalRegistrationProofChange__REACT_HOT_LOADER__() {
      return this.__onLegalRegistrationProofChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalStatuteChange__REACT_HOT_LOADER__',
    value: function __onLegalStatuteChange__REACT_HOT_LOADER__() {
      return this.__onLegalStatuteChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalCompanyAddressCountryChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressCountryChange__REACT_HOT_LOADER__() {
      return this.__onLegalCompanyAddressCountryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalCompanyAddressCityChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressCityChange__REACT_HOT_LOADER__() {
      return this.__onLegalCompanyAddressCityChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalCompanyAddressPostCodeChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressPostCodeChange__REACT_HOT_LOADER__() {
      return this.__onLegalCompanyAddressPostCodeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalCompanyAddressStreetChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressStreetChange__REACT_HOT_LOADER__() {
      return this.__onLegalCompanyAddressStreetChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalCompanyNameChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyNameChange__REACT_HOT_LOADER__() {
      return this.__onLegalCompanyNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalVatNumberChange__REACT_HOT_LOADER__',
    value: function __onLegalVatNumberChange__REACT_HOT_LOADER__() {
      return this.__onLegalVatNumberChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalSirenChange__REACT_HOT_LOADER__',
    value: function __onLegalSirenChange__REACT_HOT_LOADER__() {
      return this.__onLegalSirenChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalManagerPhoneChange__REACT_HOT_LOADER__',
    value: function __onLegalManagerPhoneChange__REACT_HOT_LOADER__() {
      return this.__onLegalManagerPhoneChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLegalManagerNameChange__REACT_HOT_LOADER__',
    value: function __onLegalManagerNameChange__REACT_HOT_LOADER__() {
      return this.__onLegalManagerNameChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onRestaurantEmailChange__REACT_HOT_LOADER__',
    value: function __onRestaurantEmailChange__REACT_HOT_LOADER__() {
      return this.__onRestaurantEmailChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onHidePdfModal__REACT_HOT_LOADER__',
    value: function __onHidePdfModal__REACT_HOT_LOADER__() {
      return this.__onHidePdfModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onShowPdfModal__REACT_HOT_LOADER__',
    value: function __onShowPdfModal__REACT_HOT_LOADER__() {
      return this.__onShowPdfModal__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'getDefaultState',


    //
    // RestaurantFormComponent override.
    //

    value: function getDefaultState(restaurant) {
      var legal = restaurant.legal;

      return {
        legal: legal.copy(),
        legalStatuteFile: null,
        legalRegistrationProofFile: null,
        legalShareholderDeclarationFile: null,

        legalRepresentativeIdentityPdf: null,

        // UI state
        displayPdfModal: false,
        pdfModalTitle: null, // the title to set to the pdf modal
        pdfModalUrl: null, // the url of the pdf to display on the pdf modal

        // form's warnings
        formWarnings: {}
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      var legal = this.props.restaurant.legal;
      var state = this.state;

      return !(legal.equals(state.legal) && _lodash2.default.isNull(state.legalStatuteFile) && _lodash2.default.isNull(state.legalRegistrationProofFile) && _lodash2.default.isNull(state.legalShareholderDeclarationFile) && _lodash2.default.isNull(state.legalRepresentativeIdentityPdf));
    }

    //
    //
    //

    // checkMail(mail: string) {
    //   const regexMail = /([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
    //   return regexMail.test(mail);
    // }

  }, {
    key: 'updateLegalState',
    value: function updateLegalState(legal) {
      this.setState({
        legal: legal
      });
    }
  }, {
    key: '__onShowPdfModal__REACT_HOT_LOADER__',
    value: function __onShowPdfModal__REACT_HOT_LOADER__(pdfModalTitle, pdfModalUrl) {
      this.setState({
        displayPdfModal: true,
        pdfModalTitle: pdfModalTitle, // the title to set to the pdf modal
        pdfModalUrl: pdfModalUrl // the url of the pdf to display on the pdf modal
      });
    }
  }, {
    key: '__onHidePdfModal__REACT_HOT_LOADER__',


    //
    // form actions
    //

    //
    //
    //

    value: function __onHidePdfModal__REACT_HOT_LOADER__() {
      this.setState({
        displayPdfModal: false,
        pdfModalTitle: null, // the title to set to the pdf modal
        pdfModalUrl: null // the url of the pdf to display on the pdf modal
      });
    }
  }, {
    key: '__onRestaurantEmailChange__REACT_HOT_LOADER__',
    value: function __onRestaurantEmailChange__REACT_HOT_LOADER__(restaurantEmail) {
      var legal = this.state.legal;
      legal.email = restaurantEmail;
      this.updateLegalState(legal);

      var formWarnings = null;
      if (!_utils.Validation.email(restaurantEmail)) {
        formWarnings = {
          restaurantMail: 'Votre email n\'est pas au bon format'
        };
      }

      this.setState({
        formWarnings: formWarnings
      });
    }
  }, {
    key: '__onLegalManagerNameChange__REACT_HOT_LOADER__',
    value: function __onLegalManagerNameChange__REACT_HOT_LOADER__(legalManagerName) {
      var legal = this.state.legal;
      legal.managerName = legalManagerName;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalManagerPhoneChange__REACT_HOT_LOADER__',


    //
    // Society
    //

    value: function __onLegalManagerPhoneChange__REACT_HOT_LOADER__(legalManagerPhone) {
      var legal = this.state.legal;
      legal.managerPhone = legalManagerPhone;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalSirenChange__REACT_HOT_LOADER__',
    value: function __onLegalSirenChange__REACT_HOT_LOADER__(legalSiren) {
      var legal = this.state.legal;
      legal.siren = legalSiren;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalVatNumberChange__REACT_HOT_LOADER__',
    value: function __onLegalVatNumberChange__REACT_HOT_LOADER__(vatNumber) {
      var legal = this.state.legal;
      legal.vatNumber = vatNumber;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalCompanyNameChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyNameChange__REACT_HOT_LOADER__(legalCompanyName) {
      var legal = this.state.legal;
      legal.name = legalCompanyName;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalCompanyAddressStreetChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressStreetChange__REACT_HOT_LOADER__(street) {
      var legal = this.state.legal;
      legal.address.street = street;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalCompanyAddressPostCodeChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressPostCodeChange__REACT_HOT_LOADER__(postCode) {
      var legal = this.state.legal;
      legal.address.postCode = postCode;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalCompanyAddressCityChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressCityChange__REACT_HOT_LOADER__(city) {
      var legal = this.state.legal;
      legal.address.city = city;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalCompanyAddressCountryChange__REACT_HOT_LOADER__',
    value: function __onLegalCompanyAddressCountryChange__REACT_HOT_LOADER__(country) {
      var legal = this.state.legal;
      legal.address.country = country;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalStatuteChange__REACT_HOT_LOADER__',
    value: function __onLegalStatuteChange__REACT_HOT_LOADER__(legalStatuteFile) {
      this.setState({
        legalStatuteFile: legalStatuteFile
      });
    }
  }, {
    key: '__onLegalRegistrationProofChange__REACT_HOT_LOADER__',
    value: function __onLegalRegistrationProofChange__REACT_HOT_LOADER__(legalRegistrationProofFile) {
      this.setState({
        legalRegistrationProofFile: legalRegistrationProofFile
      });
    }
  }, {
    key: '__onLegalShareholderDeclarationChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onLegalShareholderDeclarationChange__REACT_HOT_LOADER__(legalShareholderDeclarationFile) {
      this.setState({
        legalShareholderDeclarationFile: legalShareholderDeclarationFile
      });
    }
  }, {
    key: '__onLegalRepresentativeFirstNameChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeFirstNameChange__REACT_HOT_LOADER__(firstName) {
      var legal = this.state.legal;
      legal.representative.firstName = firstName;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeLastNameChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeLastNameChange__REACT_HOT_LOADER__(lastName) {
      var legal = this.state.legal;
      legal.representative.lastName = lastName;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeEmailChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeEmailChange__REACT_HOT_LOADER__(email) {
      var legal = this.state.legal;
      legal.representative.email = email;
      this.updateLegalState(legal);

      var formWarnings = null;
      if (!_utils.Validation.email(email)) {
        formWarnings = {
          representativeMail: 'Votre email n\'est pas au bon format'
        };
      }

      this.setState({
        formWarnings: formWarnings
      });
    }
  }, {
    key: '__onLegalRepresentativeBirthdateChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeBirthdateChange__REACT_HOT_LOADER__(birthdate) {
      var legal = this.state.legal;
      legal.representative.birthday = birthdate.valueOf();
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeNationalityChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeNationalityChange__REACT_HOT_LOADER__(nationality) {
      var legal = this.state.legal;
      legal.representative.nationality = nationality;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeCountryOfResidenceChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeCountryOfResidenceChange__REACT_HOT_LOADER__(countryOfResidence) {
      var legal = this.state.legal;
      legal.representative.countryOfResidence = countryOfResidence;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeAddressStreetChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeAddressStreetChange__REACT_HOT_LOADER__(street) {
      var legal = this.state.legal;
      legal.representative.address.street = street;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativePostCodeChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativePostCodeChange__REACT_HOT_LOADER__(postCode) {
      var legal = this.state.legal;
      legal.representative.address.postCode = postCode;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeCityChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeCityChange__REACT_HOT_LOADER__(city) {
      var legal = this.state.legal;
      legal.representative.address.city = city;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeCountryChange__REACT_HOT_LOADER__',
    value: function __onLegalRepresentativeCountryChange__REACT_HOT_LOADER__(country) {
      var legal = this.state.legal;
      legal.representative.address.country = country;
      this.updateLegalState(legal);
    }
  }, {
    key: '__onLegalRepresentativeIdentityPdfChange__REACT_HOT_LOADER__',


    //
    //
    //

    value: function __onLegalRepresentativeIdentityPdfChange__REACT_HOT_LOADER__(legalRepresentativeIdentityPdf) {
      this.setState({
        legalRepresentativeIdentityPdf: legalRepresentativeIdentityPdf
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    // renderers
    //

    //
    // Restaurateur
    //

    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!_lodash2.default.isEmpty(this.state.formWarnings)) {
        return;
      }

      var restaurantMultipart = new _RestaurantMultipart2.default();
      restaurantMultipart.legal = this.state.legal.copy();

      // set files
      restaurantMultipart.legalShareholderDeclarationFile = this.state.legalShareholderDeclarationFile;
      restaurantMultipart.legalRegistrationProofFile = this.state.legalRegistrationProofFile;
      restaurantMultipart.legalStatuteFile = this.state.legalStatuteFile;
      restaurantMultipart.legalRepresentativeIdentityDocument = this.state.legalRepresentativeIdentityPdf;

      this.props.onUpdate(restaurantMultipart);
    }
  }, {
    key: 'renderLegalManagerPhone',
    value: function renderLegalManagerPhone() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.manager.phone')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.SimplePhoneInput, {
              className: 'form-control',
              value: this.state.legal.managerPhone,
              onChange: this.onLegalManagerPhoneChange,
              readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRestaurateur()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-phone' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderLegalManagerName',
    value: function renderLegalManagerName() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.manager.name')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.managerName,
            onChange: this.onLegalManagerNameChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRestaurateur()
          })
        )
      );
    }
  }, {
    key: 'renderEmail',
    value: function renderEmail() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.manager.email'),
            this.renderMangoPayIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              type: 'email',
              placeholder: '',
              value: this.state.legal.email,
              onChange: this.onRestaurantEmailChange,
              readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRestaurateur()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-envelope' })
              )
            )
          ),
          !_lodash2.default.isNil(this.state.formWarnings) && !_lodash2.default.isEmpty(this.state.formWarnings.restaurantMail) && _react2.default.createElement(
            'p',
            { className: 'alert alert-danger top-buffer-10' },
            this.state.formWarnings.restaurantMail
          )
        )
      );
    }

    //
    // Society
    //

  }, {
    key: 'renderSiret',
    value: function renderSiret() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.siret')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _lodash2.default.isEmpty(this.state.legal.address.country) ? _react2.default.createElement(
            'div',
            { style: { marginTop: 8, marginBottom: 8 } },
            _I18n2.default.tr('restaurant_edit.legal.legal.countryRequired')
          ) : _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.siren,
            onChange: this.onLegalSirenChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          })
        )
      );
    }
  }, {
    key: 'isCountryForGeneratedVatNumber',
    value: function isCountryForGeneratedVatNumber() {
      return ['FR'].includes(this.state.legal.address.country);
    }
  }, {
    key: 'renderVatNumber',
    value: function renderVatNumber() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.vatNumber')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _lodash2.default.isEmpty(this.state.legal.address.country) ? _react2.default.createElement(
            'div',
            { style: { marginTop: 8, marginBottom: 8 } },
            _I18n2.default.tr('restaurant_edit.legal.legal.countryRequired')
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_form.TextInput, {
              placeholder: '',
              value: this.state.legal.vatNumber,
              disabled: this.isCountryForGeneratedVatNumber(),
              onChange: this.onLegalVatNumberChange,
              readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
            }),
            this.isCountryForGeneratedVatNumber() && _react2.default.createElement(
              'div',
              { style: { marginTop: 8, marginBottom: 8 } },
              _I18n2.default.tr('restaurant_edit.legal.legal.vatNumber.automaticallyCalculated')
            )
          )
        )
      );
    }
  }, {
    key: 'renderLegalCompanyName',
    value: function renderLegalCompanyName() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.company_name'),
            this.renderMangoPayIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.name,
            onChange: this.onLegalCompanyNameChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          })
        )
      );
    }
  }, {
    key: 'renderLegalCompanyAddressStreet',
    value: function renderLegalCompanyAddressStreet() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.address.label'),
            this.renderBankIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.address.street,
            onChange: this.onLegalCompanyAddressStreetChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          })
        )
      );
    }
  }, {
    key: 'renderLegalCompanyAddressPostCode',
    value: function renderLegalCompanyAddressPostCode() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.address.post_code'),
            this.renderBankIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.address.postCode,
            onChange: this.onLegalCompanyAddressPostCodeChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          })
        )
      );
    }
  }, {
    key: 'renderLegalCompanyAddressCity',
    value: function renderLegalCompanyAddressCity() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.address.city'),
            this.renderBankIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.address.city,
            onChange: this.onLegalCompanyAddressCityChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          })
        )
      );
    }
  }, {
    key: 'renderLegalCompanyAddressCountry',
    value: function renderLegalCompanyAddressCountry() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.legal.address.country'),
            this.renderBankIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.CountryChooser, {
            country: this.state.legal.address.country,
            onChange: this.onLegalCompanyAddressCountryChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          })
        )
      );
    }
  }, {
    key: 'renderLegalStatute',
    value: function renderLegalStatute() {
      var _this29 = this;

      var url = this.props.restaurant.legal.statute;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.status_pdf'),
            this.renderKycIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PdfDropzone, {
            onChange: this.onLegalStatuteChange,
            file: this.state.legalStatuteFile,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          }),
          _react2.default.createElement('br', null),
          !_lodash2.default.isEmpty(url) && _react2.default.createElement(
            'a',
            {
              className: 'link',
              onClick: function onClick() {
                _this29.onShowPdfModal(_I18n2.default.tr('restaurant_edit.legal.status_pdf.modal_label'), url);
              }
            },
            _I18n2.default.tr('restaurant_edit.legal.status_pdf.see_file')
          )
        )
      );
    }
  }, {
    key: 'renderLegalRegistrationProof',
    value: function renderLegalRegistrationProof() {
      var _this30 = this;

      var url = this.props.restaurant.legal.registrationProof;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.kbis'),
            this.renderKycIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PdfDropzone, {
            onChange: this.onLegalRegistrationProofChange,
            file: this.state.legalRegistrationProofFile,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          }),
          _react2.default.createElement('br', null),
          !_lodash2.default.isEmpty(url) && _react2.default.createElement(
            'a',
            {
              className: 'link',
              onClick: function onClick() {
                _this30.onShowPdfModal(_I18n2.default.tr('restaurant_edit.legal.kbis.modal_label'), url);
              }
            },
            _I18n2.default.tr('restaurant_edit.legal.kbis.see_file')
          )
        )
      );
    }
  }, {
    key: 'renderLegalShareholderDeclaration',
    value: function renderLegalShareholderDeclaration() {
      var _this31 = this;

      var url = this.props.restaurant.legal.shareholderDeclaration;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.shareholder_declaration'),
            this.renderKycIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PdfDropzone, {
            onChange: this.onLegalShareholderDeclarationChange,
            file: this.state.legalShareholderDeclarationFile,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalSociety()
          }),
          _react2.default.createElement('br', null),
          !_lodash2.default.isEmpty(url) && _react2.default.createElement(
            'a',
            {
              className: 'link',
              onClick: function onClick() {
                _this31.onShowPdfModal(_I18n2.default.tr('restaurant_edit.legal.shareholder_declaration.modal_label'), url);
              }
            },
            _I18n2.default.tr('restaurant_edit.legal.shareholder_declaration.see_file')
          ),
          _react2.default.createElement('br', null)
        )
      );
    }

    //
    // Legal representative
    //

  }, {
    key: 'renderLegalRepresentativeFirstName',
    value: function renderLegalRepresentativeFirstName() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.first_name'),
            this.renderMangoPayIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.representative.firstName,
            onChange: this.onLegalRepresentativeFirstNameChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeLastName',
    value: function renderLegalRepresentativeLastName() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.last_name'),
            this.renderMangoPayIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.representative.lastName,
            onChange: this.onLegalRepresentativeLastNameChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeBirthdate',
    value: function renderLegalRepresentativeBirthdate() {
      try {
        var defaultDate = (0, _moment2.default)().subtract(35, 'years');
        var minDate = (0, _moment2.default)().subtract(80, 'years');
        var maxDate = (0, _moment2.default)().subtract(18, 'years');

        if (this.state.legal.representative.birthday !== 0) {
          defaultDate = _utils.DateUtils.fromMsTimestamp(this.state.legal.representative.birthday);
        }

        // value={this.state.legal.representative.birthday}
        return _react2.default.createElement(
          'div',
          { className: 'row form-group' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-4 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.legal.representative.birthdate'),
              this.renderMangoPayIcon()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement(_Calendar2.default, {
              defaultDate: defaultDate,
              maxDate: maxDate,
              minDate: minDate,
              onChange: this.onLegalRepresentativeBirthdateChange,
              readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
              // inline={false}
            })
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'renderLegalRepresentativeNationality',
    value: function renderLegalRepresentativeNationality() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.nationality'),
            this.renderMangoPayIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.CountryChooser, {
            country: this.state.legal.representative.nationality,
            onChange: this.onLegalRepresentativeNationalityChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeCountryOfResidence',
    value: function renderLegalRepresentativeCountryOfResidence() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.country_of_residence'),
            this.renderMangoPayIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.CountryChooser, {
            country: this.state.legal.representative.countryOfResidence,
            onChange: this.onLegalRepresentativeCountryOfResidenceChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeEmail',
    value: function renderLegalRepresentativeEmail() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('global.email')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.EmailInput, {
            placeholder: '',
            value: this.state.legal.representative.email,
            onChange: this.onLegalRepresentativeEmailChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          }),
          !_lodash2.default.isNil(this.state.formWarnings) && !_lodash2.default.isEmpty(this.state.formWarnings.representativeMail) && _react2.default.createElement(
            'p',
            { className: 'alert alert-danger top-buffer-10' },
            this.state.formWarnings.representativeMail
          )
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeAddressStreet',
    value: function renderLegalRepresentativeAddressStreet() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.address.label')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.representative.address.street,
            onChange: this.onLegalRepresentativeAddressStreetChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativePostCode',
    value: function renderLegalRepresentativePostCode() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.address.post_code')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.representative.address.postCode,
            onChange: this.onLegalRepresentativePostCodeChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeCity',
    value: function renderLegalRepresentativeCity() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.address.city')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextInput, {
            placeholder: '',
            value: this.state.legal.representative.address.city,
            onChange: this.onLegalRepresentativeCityChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeCountry',
    value: function renderLegalRepresentativeCountry() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.address.country')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.CountryChooser, {
            country: this.state.legal.representative.address.country,
            onChange: this.onLegalRepresentativeCountryChange,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          })
        )
      );
    }
  }, {
    key: 'renderLegalRepresentativeIdentityPdf',
    value: function renderLegalRepresentativeIdentityPdf() {
      var _this32 = this;

      var url = this.props.restaurant.legal.representative.identityDocument;
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.legal.representative.identity_document'),
            this.renderKycIcon()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.PdfDropzone, {
            onChange: this.onLegalRepresentativeIdentityPdfChange,
            file: this.state.legalRepresentativeIdentityPdf,
            readOnly: !_SecurityContext2.default.restaurantSettings.editLegalRepresentative()
          }),
          _react2.default.createElement('br', null),
          !_lodash2.default.isEmpty(url) && _react2.default.createElement(
            'a',
            {
              className: 'link',
              onClick: function onClick() {
                _this32.onShowPdfModal(_I18n2.default.tr('restaurant_edit.legal.representative.identity_document.modal_label'), url);
              }
            },
            _I18n2.default.tr('restaurant_edit.legal.representative.identity_document.see_file')
          )
        )
      );
    }
  }, {
    key: 'renderPdfModal',
    value: function renderPdfModal() {
      if (_lodash2.default.isNull(this.state.pdfModalUrl)) {
        return null;
      }

      var httpHeaders = _ApiManagerOptions2.default.headersMiddleware();

      return _react2.default.createElement(_PdfViewerModal2.default, {
        show: this.state.displayPdfModal,
        onHide: this.onHidePdfModal,
        file: this.state.pdfModalUrl,
        httpHeaders: httpHeaders,
        title: this.state.pdfModalTitle
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var restaurant = this.props.restaurant;

      try {
        return _react2.default.createElement(
          'div',
          { className: 'edit_restaurant_form_view__private' },
          _react2.default.createElement(
            'form',
            { className: 'form-horizontal' },
            this.renderIconsLegend(),
            _SecurityContext2.default.restaurantSettings.readLegalRestaurateur() && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                { className: 'text-center' },
                _I18n2.default.tr('restaurant_edit.legal.restaurateur')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderLegalManagerName(),
                this.renderLegalManagerPhone(),
                this.renderEmail()
              ),
              _react2.default.createElement('hr', { className: 'top-buffer-50' })
            ),
            _SecurityContext2.default.restaurantSettings.readLegalSociety() && _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              _react2.default.createElement(
                'h3',
                { className: 'text-center' },
                _I18n2.default.tr('restaurant_edit.legal.company')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderLegalCompanyName(),
                this.renderLegalCompanyAddressStreet(),
                this.renderLegalCompanyAddressPostCode(),
                this.renderLegalCompanyAddressCity(),
                this.renderLegalCompanyAddressCountry(),
                this.renderSiret(),
                this.renderVatNumber(),
                this.renderLegalStatute(),
                this.renderLegalRegistrationProof(),
                this.renderLegalShareholderDeclaration()
              ),
              _react2.default.createElement('hr', { className: 'top-buffer-50' })
            ),
            _SecurityContext2.default.restaurantSettings.readLegalRepresentative() && _react2.default.createElement(
              'div',
              { className: 'top-buffer-50' },
              _react2.default.createElement(
                'h3',
                { className: 'text-center' },
                _I18n2.default.tr('restaurant_edit.legal.legal_representative')
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-50' },
                this.renderLegalRepresentativeFirstName(),
                this.renderLegalRepresentativeLastName(),
                this.renderLegalRepresentativeBirthdate(),
                this.renderLegalRepresentativeNationality(),
                this.renderLegalRepresentativeCountryOfResidence(),
                this.renderLegalRepresentativeAddressStreet(),
                this.renderLegalRepresentativePostCode(),
                this.renderLegalRepresentativeCity(),
                this.renderLegalRepresentativeCountry(),
                this.renderLegalRepresentativeEmail(),
                this.renderLegalRepresentativeIdentityPdf()
              ),
              _react2.default.createElement('hr', { className: 'top-buffer-50' })
            ),
            this.renderButtons(),
            this.renderPdfModal()
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return LegalFormView;
}(_RestaurantFormComponent2.default);

LegalFormView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_Restaurant2.default),

  /**
   * @param RestaurantMultipart
   */
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = LegalFormView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LegalFormView, 'LegalFormView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/LegalFormView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/PayGreenConfigurationView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _get = __webpack_require__("./node_modules/lodash/get.js");

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__("./node_modules/lodash/set.js");

var _set2 = _interopRequireDefault(_set);

var _isNull = __webpack_require__("./node_modules/lodash/isNull.js");

var _isNull2 = _interopRequireDefault(_isNull);

var _isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _reactBootstrapSwitch = __webpack_require__("./node_modules/react-bootstrap-switch/dist/js/index.js");

var _reactBootstrapSwitch2 = _interopRequireDefault(_reactBootstrapSwitch);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormGroup = function FormGroup(_ref) {
  var label = _ref.label,
      style = _ref.style,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'row form-group', style: style },
    _react2.default.createElement(
      'div',
      { className: 'col-xs-4 control-label' },
      _react2.default.createElement(
        'label',
        null,
        label
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-xs-6' },
      children
    )
  );
};

var ChangeStatusView = function ChangeStatusView(_ref2) {
  var status = _ref2.status,
      pspSettings = _ref2.pspSettings,
      bank = _ref2.bank,
      legal = _ref2.legal,
      onChange = _ref2.onChange;

  // status is the current status, not the modified one.
  // retrieve the status from the state
  var statusToSet = (0, _get2.default)(pspSettings, 'payGreen.status');

  if (status !== statusToSet) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        'Le status va \xEAtre modifi\xE9 pour: ',
        statusToSet
      ),
      _react2.default.createElement(
        'button',
        {
          className: 'btn',
          onClick: function onClick(event) {
            event.preventDefault();
            onChange(status);
          }
        },
        'Ne pas modifier le status'
      )
    );
  }

  switch (status) {
    default:
    case 'WAITING_CONFIGURATION':
      // We must configure the psp settings and ask to create the shop using TO_CREATE.
      var isValidToCreate = true;

      if ((0, _isEmpty2.default)(legal.siren)) {
        isValidToCreate = false;
      }

      var acquisitionType = (0, _get2.default)(pspSettings, 'payGreen.acquisitionType', null);
      if ((0, _isNull2.default)(acquisitionType)) {
        isValidToCreate = false;
      }

      if (acquisitionType === 'EXTERNAL_BANK') {
        if ((0, _isEmpty2.default)((0, _get2.default)(pspSettings, 'payGreen.paylineConfiguration.vadNumber', null))) {
          isValidToCreate = false;
        }

        if ((0, _isEmpty2.default)((0, _get2.default)(pspSettings, 'payGreen.paylineConfiguration.mccNumber', null))) {
          isValidToCreate = false;
        }

        if ((0, _isEmpty2.default)((0, _get2.default)(pspSettings, 'payGreen.paylineConfiguration.maxAmount', null))) {
          isValidToCreate = false;
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        isValidToCreate ? _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary',
            onClick: function onClick(event) {
              event.preventDefault();
              onChange('TO_CREATE');
            }
          },
          'Cr\xE9er la boutique chez PayGreen'
        ) : _react2.default.createElement(
          'div',
          null,
          'Il manque des informations pour cr\xE9er la boutique. Sont requis:',
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              'Le mode (avec wallet packag\xE9 ou banque externe)'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Si banque externe, la configuration'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Le siren'
            )
          )
        )
      );

    case 'CREATED':
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'La boutique a bien \xE9t\xE9 cr\xE9\xE9e chez PayGreen. L\'activer ?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Attention: Pour activer la boutique chez PayGreen, vous devez avoir re\xE7u la confirmation par email de PayGreen: la boutique doit \xEAtre correctement configur\xE9e manuellement de leur cot\xE9.'
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-danger',
            onClick: function onClick(event) {
              event.preventDefault();
              onChange('ENABLED');
            }
          },
          'Activer la boutique chez PayGreen'
        )
      );

    case 'ENABLED':
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Attention: Vous devriez \xE9galement d\xE9sactiver le restaurant'
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-danger',
            onClick: function onClick(event) {
              event.preventDefault();
              onChange('DISABLED');
            }
          },
          'D\xE9sactiver la boutique'
        )
      );

    case 'DISABLED':
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-danger',
            onClick: function onClick(event) {
              event.preventDefault();
              onChange('ENABLED');
            }
          },
          'Activer la boutique'
        )
      );
  }
};

var PayGreenConfigurationView = function PayGreenConfigurationView(_ref3) {
  var pspSettings = _ref3.pspSettings,
      restaurant = _ref3.restaurant,
      bank = _ref3.bank,
      legal = _ref3.legal,
      _onChange = _ref3.onChange,
      onChangeBank = _ref3.onChangeBank;

  // we use the current data, not the modified one
  var status = (0, _get2.default)(restaurant, 'pspSettings.payGreen.status', null);

  var isStatusWaitingConfiguration = status === 'WAITING_CONFIGURATION';

  return _react2.default.createElement(
    'div',
    { className: 'top-buffer-50' },
    _react2.default.createElement(
      'h3',
      { className: 'text-center', style: { marginBottom: 50 } },
      'PayGreen configuration - General'
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Status' },
      _react2.default.createElement(_form.TextInput, { value: status, readOnly: true })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Changement du status' },
      _react2.default.createElement(ChangeStatusView, {
        status: status,
        onChange: function onChange(status) {
          _onChange((0, _set2.default)(pspSettings, 'payGreen.status', status));
        },
        pspSettings: pspSettings,
        bank: bank,
        legal: legal
      })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'shop id', style: { marginTop: 50 } },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'payGreen.shopId', null),
        readOnly: !isStatusWaitingConfiguration,
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'payGreen.shopId', value));
        }
      })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'shop private key' },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'payGreen.shopPrivateKey', null),
        readOnly: !isStatusWaitingConfiguration,
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'payGreen.shopPrivateKey', value));
        }
      })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Avec banque externe ? (D\xE9sactiv\xE9: avec wallet)' },
      _react2.default.createElement(_reactBootstrapSwitch2.default, {
        value: (0, _get2.default)(pspSettings, 'payGreen.acquisitionType', null) === 'EXTERNAL_BANK',
        disabled: !isStatusWaitingConfiguration,
        onChange: function onChange() {
          _onChange((0, _set2.default)(pspSettings, 'payGreen.acquisitionType', (0, _get2.default)(pspSettings, 'payGreen.acquisitionType', null) === 'EXTERNAL_BANK' ? 'PACKAGED_WALLET' : 'EXTERNAL_BANK'));
        },
        bsSize: 'mini'
      })
    ),
    (0, _get2.default)(pspSettings, 'payGreen.acquisitionType', null) === 'EXTERNAL_BANK' && _react2.default.createElement(
      FormGroup,
      { label: 'Configuration de la banque externe - vad number' },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'payGreen.paylineConfiguration.vadNumber', null),
        readOnly: !isStatusWaitingConfiguration,
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'payGreen.paylineConfiguration.vadNumber', value));
        }
      })
    ),
    (0, _get2.default)(pspSettings, 'payGreen.acquisitionType', null) === 'EXTERNAL_BANK' && _react2.default.createElement(
      FormGroup,
      { label: 'Configuration de la banque externe - mcc number' },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'payGreen.paylineConfiguration.mccNumber', null),
        readOnly: !isStatusWaitingConfiguration,
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'payGreen.paylineConfiguration.mccNumber', value));
        }
      })
    ),
    (0, _get2.default)(pspSettings, 'payGreen.acquisitionType', null) === 'EXTERNAL_BANK' && _react2.default.createElement(
      FormGroup,
      { label: 'Configuration de la banque externe - max amount' },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'payGreen.paylineConfiguration.maxAmount', null),
        readOnly: !isStatusWaitingConfiguration,
        onChange: function onChange(value) {
          return _onChange((0, _set2.default)(pspSettings, 'payGreen.paylineConfiguration.maxAmount', value));
        }
      })
    )
  );
};

var _default = PayGreenConfigurationView;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FormGroup, 'FormGroup', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/PayGreenConfigurationView.js');

  __REACT_HOT_LOADER__.register(ChangeStatusView, 'ChangeStatusView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/PayGreenConfigurationView.js');

  __REACT_HOT_LOADER__.register(PayGreenConfigurationView, 'PayGreenConfigurationView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/PayGreenConfigurationView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/PayGreenConfigurationView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/PublicFormView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _RestaurantFormComponent = __webpack_require__("./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js");

var _RestaurantFormComponent2 = _interopRequireDefault(_RestaurantFormComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- entities


// -- views


var PublicFormView = function (_RestaurantFormCompon) {
  _inherits(PublicFormView, _RestaurantFormCompon);

  function PublicFormView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PublicFormView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PublicFormView.__proto__ || Object.getPrototypeOf(PublicFormView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.restaurant), _this.onTimeZoneChange = function () {
      var _this2;

      return (_this2 = _this).__onTimeZoneChange__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onLocaleChange = function () {
      var _this3;

      return (_this3 = _this).__onLocaleChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onLogoChange = function () {
      var _this4;

      return (_this4 = _this).__onLogoChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onPictureChange = function () {
      var _this5;

      return (_this5 = _this).__onPictureChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onTagChange = function () {
      var _this6;

      return (_this6 = _this).__onTagChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onFacebookChange = function () {
      var _this7;

      return (_this7 = _this).__onFacebookChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onTwitterChange = function () {
      var _this8;

      return (_this8 = _this).__onTwitterChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _this.onPhonePubChange = function () {
      var _this9;

      return (_this9 = _this).__onPhonePubChange__REACT_HOT_LOADER__.apply(_this9, arguments);
    }, _this.onEmailPubChange = function () {
      var _this10;

      return (_this10 = _this).__onEmailPubChange__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this.onWebsiteChange = function () {
      var _this11;

      return (_this11 = _this).__onWebsiteChange__REACT_HOT_LOADER__.apply(_this11, arguments);
    }, _this.onDescriptionChange = function () {
      var _this12;

      return (_this12 = _this).__onDescriptionChange__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this.onAddressStreetChange = function () {
      var _this13;

      return (_this13 = _this).__onAddressStreetChange__REACT_HOT_LOADER__.apply(_this13, arguments);
    }, _this.onAddressPostcodeChange = function () {
      var _this14;

      return (_this14 = _this).__onAddressPostcodeChange__REACT_HOT_LOADER__.apply(_this14, arguments);
    }, _this.onAddressCityChange = function () {
      var _this15;

      return (_this15 = _this).__onAddressCityChange__REACT_HOT_LOADER__.apply(_this15, arguments);
    }, _this.onAddressCountryChange = function () {
      var _this16;

      return (_this16 = _this).__onAddressCountryChange__REACT_HOT_LOADER__.apply(_this16, arguments);
    }, _this.onLatitudeChange = function () {
      var _this17;

      return (_this17 = _this).__onLatitudeChange__REACT_HOT_LOADER__.apply(_this17, arguments);
    }, _this.onLongitudeChange = function () {
      var _this18;

      return (_this18 = _this).__onLongitudeChange__REACT_HOT_LOADER__.apply(_this18, arguments);
    }, _this.onSubmit = function () {
      var _this19;

      return (_this19 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this19, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PublicFormView, [{
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLongitudeChange__REACT_HOT_LOADER__',
    value: function __onLongitudeChange__REACT_HOT_LOADER__() {
      return this.__onLongitudeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLatitudeChange__REACT_HOT_LOADER__',
    value: function __onLatitudeChange__REACT_HOT_LOADER__() {
      return this.__onLatitudeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddressCountryChange__REACT_HOT_LOADER__',
    value: function __onAddressCountryChange__REACT_HOT_LOADER__() {
      return this.__onAddressCountryChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddressCityChange__REACT_HOT_LOADER__',
    value: function __onAddressCityChange__REACT_HOT_LOADER__() {
      return this.__onAddressCityChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddressPostcodeChange__REACT_HOT_LOADER__',
    value: function __onAddressPostcodeChange__REACT_HOT_LOADER__() {
      return this.__onAddressPostcodeChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onAddressStreetChange__REACT_HOT_LOADER__',
    value: function __onAddressStreetChange__REACT_HOT_LOADER__() {
      return this.__onAddressStreetChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__() {
      return this.__onDescriptionChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onWebsiteChange__REACT_HOT_LOADER__',
    value: function __onWebsiteChange__REACT_HOT_LOADER__() {
      return this.__onWebsiteChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onEmailPubChange__REACT_HOT_LOADER__',
    value: function __onEmailPubChange__REACT_HOT_LOADER__() {
      return this.__onEmailPubChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPhonePubChange__REACT_HOT_LOADER__',
    value: function __onPhonePubChange__REACT_HOT_LOADER__() {
      return this.__onPhonePubChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTwitterChange__REACT_HOT_LOADER__',
    value: function __onTwitterChange__REACT_HOT_LOADER__() {
      return this.__onTwitterChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFacebookChange__REACT_HOT_LOADER__',
    value: function __onFacebookChange__REACT_HOT_LOADER__() {
      return this.__onFacebookChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTagChange__REACT_HOT_LOADER__',
    value: function __onTagChange__REACT_HOT_LOADER__() {
      return this.__onTagChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onPictureChange__REACT_HOT_LOADER__',
    value: function __onPictureChange__REACT_HOT_LOADER__() {
      return this.__onPictureChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLogoChange__REACT_HOT_LOADER__',
    value: function __onLogoChange__REACT_HOT_LOADER__() {
      return this.__onLogoChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onLocaleChange__REACT_HOT_LOADER__',
    value: function __onLocaleChange__REACT_HOT_LOADER__() {
      return this.__onLocaleChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTimeZoneChange__REACT_HOT_LOADER__',
    value: function __onTimeZoneChange__REACT_HOT_LOADER__() {
      return this.__onTimeZoneChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return _SecurityContext2.default.restaurantSettings.editPublicInfo();
    }

    // -- tools

    //
    // RestaurantFormComponent override.
    //

  }, {
    key: 'getDefaultState',
    value: function getDefaultState() {
      var restaurant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return {
        image: null,
        imageFullSize: null,
        logo: null,
        logoFullSize: null, // didn't used for the moment.
        phonePub: _utils.PhoneUtils.format(restaurant.phonePub),
        webSitePub: restaurant.webSitePub,
        emailPub: restaurant.emailPub,
        desc: restaurant.desc,
        tag: this.getTagValue(restaurant.tag),
        facebookPub: restaurant.facebookPub,
        twitterPub: restaurant.twitterPub,
        address: restaurant.address.copy(),
        timeZone: restaurant.timeZone,
        geoPt: restaurant.geoPt.copy(),
        locale: restaurant.locale
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      var restaurant = this.restaurant;

      return !(_lodash2.default.isNull(this.state.image) && _utils.PhoneUtils.format(restaurant.phonePub) === _utils.PhoneUtils.format(this.state.phonePub) && restaurant.webSitePub === this.state.webSitePub && restaurant.emailPub === this.state.emailPub && restaurant.desc === this.state.desc && restaurant.twitterPub === this.state.twitterPub && restaurant.facebookPub === this.state.facebookPub && this.getTagValue(restaurant.tag) === this.state.tag && restaurant.timeZone === this.state.timeZone && restaurant.address.equals(this.state.address) && restaurant.geoPt.equals(this.state.geoPt) && restaurant.locale === this.state.locale && _lodash2.default.isNull(this.state.logo));
    }
  }, {
    key: 'getTagValue',
    value: function getTagValue(tag) {
      return _I18n2.default.tr(tag);
    }

    //
    // actions form
    //

  }, {
    key: '__onTimeZoneChange__REACT_HOT_LOADER__',
    value: function __onTimeZoneChange__REACT_HOT_LOADER__(timeZone) {
      this.setState({
        timeZone: timeZone
      });
    }
  }, {
    key: '__onLocaleChange__REACT_HOT_LOADER__',
    value: function __onLocaleChange__REACT_HOT_LOADER__(locale) {
      this.setState({
        locale: locale
      });
    }
  }, {
    key: '__onLogoChange__REACT_HOT_LOADER__',
    value: function __onLogoChange__REACT_HOT_LOADER__(pictureData, logoFullSizeData) {
      this.setState({
        logo: pictureData,
        logoFullSize: _lodash2.default.isNull(pictureData) ? null : logoFullSizeData
      });
    }
  }, {
    key: '__onPictureChange__REACT_HOT_LOADER__',


    /**
    * See react-chooser
    * @param tag
    */
    value: function __onPictureChange__REACT_HOT_LOADER__(pictureData, pictureFullSizeData) {
      this.setState({
        image: pictureData,
        imageFullSize: _lodash2.default.isNull(pictureData) ? null : pictureFullSizeData
      });
    }
  }, {
    key: '__onTagChange__REACT_HOT_LOADER__',
    value: function __onTagChange__REACT_HOT_LOADER__(tag) {
      this.setState({
        tag: tag
      });
    }
  }, {
    key: '__onFacebookChange__REACT_HOT_LOADER__',
    value: function __onFacebookChange__REACT_HOT_LOADER__(facebookPub) {
      this.setState({
        facebookPub: facebookPub
      });
    }
  }, {
    key: '__onTwitterChange__REACT_HOT_LOADER__',
    value: function __onTwitterChange__REACT_HOT_LOADER__(twitterPub) {
      this.setState({
        twitterPub: twitterPub
      });
    }
  }, {
    key: '__onPhonePubChange__REACT_HOT_LOADER__',
    value: function __onPhonePubChange__REACT_HOT_LOADER__(phonePub) {
      this.setState({
        phonePub: phonePub
      });
    }
  }, {
    key: '__onEmailPubChange__REACT_HOT_LOADER__',
    value: function __onEmailPubChange__REACT_HOT_LOADER__(emailPub) {
      this.setState({
        emailPub: emailPub
      });
    }
  }, {
    key: '__onWebsiteChange__REACT_HOT_LOADER__',
    value: function __onWebsiteChange__REACT_HOT_LOADER__(webSitePub) {
      this.setState({
        webSitePub: webSitePub
      });
    }
  }, {
    key: '__onDescriptionChange__REACT_HOT_LOADER__',
    value: function __onDescriptionChange__REACT_HOT_LOADER__(desc) {
      this.setState({
        desc: desc
      });
    }
  }, {
    key: '__onAddressStreetChange__REACT_HOT_LOADER__',
    value: function __onAddressStreetChange__REACT_HOT_LOADER__(street) {
      var address = this.state.address;
      address.street = street;
      this.setState({
        address: address
      });
    }
  }, {
    key: '__onAddressPostcodeChange__REACT_HOT_LOADER__',
    value: function __onAddressPostcodeChange__REACT_HOT_LOADER__(postCode) {
      var address = this.state.address;
      address.postCode = postCode;
      this.setState({
        address: address
      });
    }
  }, {
    key: '__onAddressCityChange__REACT_HOT_LOADER__',
    value: function __onAddressCityChange__REACT_HOT_LOADER__(city) {
      var address = this.state.address;
      address.city = city;
      this.setState({
        address: address
      });
    }
  }, {
    key: '__onAddressCountryChange__REACT_HOT_LOADER__',
    value: function __onAddressCountryChange__REACT_HOT_LOADER__(country) {
      var address = this.state.address;
      address.country = country;
      this.setState({
        address: address
      });
    }
  }, {
    key: '__onLatitudeChange__REACT_HOT_LOADER__',
    value: function __onLatitudeChange__REACT_HOT_LOADER__(latitude) {
      var geoPt = this.state.geoPt;
      geoPt.latitude = latitude;
      this.setState({
        geoPt: geoPt
      });
    }
  }, {
    key: '__onLongitudeChange__REACT_HOT_LOADER__',
    value: function __onLongitudeChange__REACT_HOT_LOADER__(longitude) {
      var geoPt = this.state.geoPt;
      geoPt.longitude = longitude;
      this.setState({
        geoPt: geoPt
      });
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    //
    // renderers
    //

    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      if (!this.canEdit()) {
        return;
      }

      var restaurantMultipart = new _RestaurantMultipart2.default();

      if (!_lodash2.default.isNull(this.state.logo)) {
        restaurantMultipart.logo = _utils.ViewUtils.dataUriToFile(this.state.logo);
      }

      if (!_lodash2.default.isNull(this.state.image)) {
        restaurantMultipart.coverPicture = _utils.ViewUtils.dataUriToFile(this.state.image);
      }

      if (!_lodash2.default.isNull(this.state.imageFullSize)) {
        restaurantMultipart.coverPictureFullSize = _utils.ViewUtils.dataUriToFile(this.state.imageFullSize);
      }

      restaurantMultipart.externalId = this.state.externalId;
      restaurantMultipart.webSitePub = this.state.webSitePub;
      restaurantMultipart.desc = this.state.desc;
      restaurantMultipart.tag = this.state.tag;
      restaurantMultipart.facebookPub = this.state.facebookPub;
      restaurantMultipart.twitterPub = this.state.twitterPub;
      restaurantMultipart.emailPub = this.state.emailPub;
      restaurantMultipart.phonePub = this.state.phonePub;
      restaurantMultipart.address = this.state.address.copy();
      restaurantMultipart.geoPt = this.state.geoPt;
      restaurantMultipart.timeZone = this.state.timeZone;
      restaurantMultipart.locale = this.state.locale;

      this.props.onUpdate(restaurantMultipart);
    }
  }, {
    key: 'renderTimeZone',
    value: function renderTimeZone() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.timezone')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 fake-input-group' },
          _react2.default.createElement(_form.TimeZoneChooser, {
            value: this.state.timeZone,
            onChange: this.onTimeZoneChange,
            clearable: false,
            readOnly: !this.canEdit()
          })
        )
      );
    }
  }, {
    key: 'renderLocale',
    value: function renderLocale() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.locale')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 fake-input-group' },
          _react2.default.createElement(_form.LocaleChooser, {
            locales: _constants.Constants.localesForTranslation.map(function (l) {
              return l.locale.replace('-', '_');
            }),
            readOnly: !this.canEdit(),
            onChange: this.onLocaleChange,
            value: this.state.locale,
            multi: false
          })
        )
      );
    }
  }, {
    key: 'renderLogo',
    value: function renderLogo() {
      var placeholder = _lodash2.default.isNull(this.restaurant.logo) ? _ViewConstants2.default.Image.DEFAULT_RESTAURANT_LOGO : this.restaurant.logo;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.logo')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8 dropzone_restaurant_logo' },
          _react2.default.createElement(_form.ImageDropzone, {
            placeholder: placeholder,
            image: this.state.logo,
            onChange: this.onLogoChange,
            aspectRatio: _ApiConstants2.default.Image.RestaurantLogo.RATIO,
            width: _ApiConstants2.default.Image.RestaurantLogo.WIDTH,
            height: _ApiConstants2.default.Image.RestaurantLogo.HEIGHT,
            maxSize: _ApiConstants2.default.Image.RestaurantLogo.MAX_SIZE,
            readOnly: !this.canEdit()
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'em',
            null,
            _I18n2.default.tr('restaurant_edit.public.logo_requirements')
          )
        )
      );
    }
  }, {
    key: 'renderPicture',
    value: function renderPicture() {
      var placeholder = _lodash2.default.isNull(this.restaurant.picture) ? _ViewConstants2.default.Image.DEFAULT_RESTAURANT : this.restaurant.picture;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.picture')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-8 dropzone_restaurant_image' },
          _react2.default.createElement(_form.ImageDropzone, {
            placeholder: placeholder,
            image: this.state.image,
            onChange: this.onPictureChange,
            aspectRatio: _ApiConstants2.default.Image.RESTAURANT_PICTURE_RATIO,
            maxSize: _ApiConstants2.default.Image.RESTAURANT_PICTURE_MAX_SIZE,
            readOnly: !this.canEdit(),
            width: _ApiConstants2.default.Image.RESTAURANT_PICTURE_WIDTH,
            height: _ApiConstants2.default.Image.RESTAURANT_PICTURE_HEIGHT
          })
        )
      );
    }
  }, {
    key: 'renderTag',
    value: function renderTag() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.tag')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.RestaurantTagChooser, {
            tag: this.state.tag,
            onChange: this.onTagChange,
            readOnly: !this.canEdit()
          })
        )
      );
    }
  }, {
    key: 'renderFacebook',
    value: function renderFacebook() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            'Facebook'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              type: 'url',
              placeholder: 'https://www.facebook.com/paymytable/',
              value: this.state.facebookPub,
              onChange: this.onFacebookChange,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-facebook' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderTwitter',
    value: function renderTwitter() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            'Twitter'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              type: 'url',
              placeholder: 'https://twitter.com/PayMyTable',
              value: this.state.twitterPub,
              onChange: this.onTwitterChange,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-twitter' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderEmail',
    value: function renderEmail() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.email')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              type: 'email',
              placeholder: _constants.Constants.CONTACT_EMAIL,
              value: this.state.emailPub,
              onChange: this.onEmailPubChange,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-envelope' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderPhoneNumber',
    value: function renderPhoneNumber() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.phone_number')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.SimplePhoneInput, {
              className: 'form-control',
              value: this.state.phonePub,
              onChange: this.onPhonePubChange,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-phone' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderWebsite',
    value: function renderWebsite() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.website')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              type: 'text',
              placeholder: 'https://paymytable.com',
              value: this.state.webSitePub,
              onChange: this.onWebsiteChange,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-external-link' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderStreet',
    value: function renderStreet() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.address.label')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              value: this.state.address.street,
              onChange: this.onAddressStreetChange,
              isRequired: true,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-map-marker' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderPostalCode',
    value: function renderPostalCode() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.address.post_code')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              value: this.state.address.postCode,
              onChange: this.onAddressPostcodeChange,
              isRequired: true,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-map-marker' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderCity',
    value: function renderCity() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.address.city')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.TextInput, {
              value: this.state.address.city,
              onChange: this.onAddressCityChange,
              isRequired: true,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('i', { className: 'fa fa-map-marker' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderCountry',
    value: function renderCountry() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.address.country')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 fake-input-group' },
          _react2.default.createElement(_form.CountryChooser, {
            country: this.state.address.country,
            onChange: this.onAddressCountryChange,
            clearable: false,
            readOnly: !this.canEdit()
          })
        )
      );
    }
  }, {
    key: 'renderCoordinates',
    value: function renderCoordinates() {
      var geoPt = this.state.geoPt;
      var googleMapUrl = 'https://www.google.com/maps?q=' + geoPt.latitude + ',' + geoPt.longitude;

      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.gps_coordinates')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: geoPt.latitude,
              onChange: this.onLatitudeChange,
              readOnly: !this.canEdit(),
              format: _form.NumberInput.GEOPT_FORMAT
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _I18n2.default.tr('restaurant_edit.public.latitude')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement(_form.NumberInput, {
              value: geoPt.longitude,
              onChange: this.onLongitudeChange,
              format: _form.NumberInput.GEOPT_FORMAT,
              readOnly: !this.canEdit()
            }),
            _react2.default.createElement(
              'div',
              { className: 'input-group-addon' },
              _I18n2.default.tr('restaurant_edit.public.longitude')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-xs-offset-4 top-buffer-10' },
          _react2.default.createElement(
            'a',
            {
              href: googleMapUrl,
              target: '_blank'
            },
            _I18n2.default.tr('restaurant_edit.public.preview')
          )
        )
      );
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      return _react2.default.createElement(
        'div',
        { className: 'row form-group' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 control-label' },
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.public.description')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_form.TextareaInput, {
            placeholder: '',
            rows: 6,
            value: this.state.desc,
            onChange: this.onDescriptionChange,
            readOnly: !this.canEdit()
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        var restaurant = this.props.restaurant;
        return _react2.default.createElement(
          'div',
          { className: 'edit_restaurant_form_view__public' },
          _react2.default.createElement(
            'form',
            {
              className: 'form-horizontal',
              noValidate: true,
              onSubmit: this.onSubmit
            },
            this.renderTimeZone(),
            this.renderLocale(),
            this.renderLogo(),
            this.renderPicture(),
            this.renderTag(),
            this.renderWebsite(),
            this.renderFacebook(),
            this.renderTwitter(),
            this.renderEmail(),
            this.renderPhoneNumber(),
            this.renderStreet(),
            this.renderPostalCode(),
            this.renderCity(),
            this.renderCountry(),
            this.renderCoordinates(),
            this.renderDescription(),
            this.renderButtons()
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return PublicFormView;
}(_RestaurantFormComponent2.default);

PublicFormView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_Restaurant2.default),

  /**
  * @param RestaurantMultipart
  */
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = PublicFormView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PublicFormView, 'PublicFormView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/PublicFormView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _AbstractFormComponent = __webpack_require__("./scripts/components/form/AbstractFormComponent.js");

var _AbstractFormComponent2 = _interopRequireDefault(_AbstractFormComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantFormComponent = function (_AbstractFormComponen) {
  _inherits(RestaurantFormComponent, _AbstractFormComponen);

  function RestaurantFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantFormComponent.__proto__ || Object.getPrototypeOf(RestaurantFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onReset = function () {
      var _this2;

      return (_this2 = _this).__onReset__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantFormComponent, [{
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      return this.__onReset__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.restaurant.equals(nextProps.restaurant)) {
        // restaurant have changed, we reset the form.
        this.setState(this.getDefaultState(nextProps.restaurant));
      }
    }

    // -- events

  }, {
    key: '__onReset__REACT_HOT_LOADER__',
    value: function __onReset__REACT_HOT_LOADER__() {
      this.setState(this.getDefaultState(this.props.restaurant));
    }
  }, {
    key: 'shouldDisableSubmit',
    value: function shouldDisableSubmit() {
      return false;
    }

    //
    // renderers
    //

  }, {
    key: 'renderKycIcon',
    value: function renderKycIcon() {
      return _react2.default.createElement(
        'span',
        {
          className: 'restaurant_edit__kyc_icon'
        },
        '*'
      );
    }
  }, {
    key: 'renderBankIcon',
    value: function renderBankIcon() {
      return _react2.default.createElement(
        'span',
        {
          className: 'restaurant_edit__bank_icon'
        },
        '*'
      );
    }
  }, {
    key: 'renderMangoPayIcon',
    value: function renderMangoPayIcon() {
      return _react2.default.createElement(
        'span',
        {
          className: 'restaurant_edit__mango_pay_icon'
        },
        '*'
      );
    }
  }, {
    key: 'renderIconsLegend',
    value: function renderIconsLegend() {
      return _react2.default.createElement(
        'div',
        { className: 'restaurant_edit__icons_legend' },
        _react2.default.createElement(
          'div',
          null,
          this.renderMangoPayIcon(),
          _react2.default.createElement(
            'label',
            null,
            'MangoPay'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderKycIcon(),
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.kyc')
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderBankIcon(),
          _react2.default.createElement(
            'label',
            null,
            _I18n2.default.tr('restaurant_edit.bank')
          )
        )
      );
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      return this.renderFixedButtons();
    }
  }, {
    key: 'render',
    value: function render() {
      console.error('This method should be override.');

      return null;
    }
  }, {
    key: 'restaurant',
    get: function get() {
      return this.props.restaurant;
    }
  }]);

  return RestaurantFormComponent;
}(_AbstractFormComponent2.default);

exports.default = RestaurantFormComponent;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantFormComponent, 'RestaurantFormComponent', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/RestaurantFormComponent.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/SaferpayConfigurationView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _get = __webpack_require__("./node_modules/lodash/get.js");

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__("./node_modules/lodash/set.js");

var _set2 = _interopRequireDefault(_set);

var _form = __webpack_require__("./sdk/scripts/components/form/index.js");

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormGroup = function FormGroup(_ref) {
  var label = _ref.label,
      style = _ref.style,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'row form-group', style: style },
    _react2.default.createElement(
      'div',
      { className: 'col-xs-4 control-label' },
      _react2.default.createElement(
        'label',
        null,
        label
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-xs-6' },
      children
    )
  );
};

var SaferpayConfigurationView = function SaferpayConfigurationView(_ref2) {
  var pspSettings = _ref2.pspSettings,
      _onChange = _ref2.onChange;

  return _react2.default.createElement(
    'div',
    { className: 'top-buffer-50' },
    _react2.default.createElement(
      'h3',
      { className: 'text-center', style: { marginBottom: 50 } },
      'Saferpay configuration'
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Customer ID', style: { marginTop: 50 } },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'saferpay.customerID', null),
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'saferpay.customerID', value));
        }
      })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Terminal ID' },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'saferpay.terminalID', null),
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'saferpay.terminalID', value));
        }
      })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Auth token' },
      _react2.default.createElement(_form.TextInput, {
        value: (0, _get2.default)(pspSettings, 'saferpay.authToken', null),
        onChange: function onChange(value) {
          _onChange((0, _set2.default)(pspSettings, 'saferpay.authToken', value));
        }
      })
    ),
    _react2.default.createElement(
      FormGroup,
      { label: 'Api Url' },
      _react2.default.createElement(_reactSelect2.default, {
        value: (0, _get2.default)(pspSettings, 'saferpay.saferpayApiUrl', null) || '',
        onChange: function onChange(option) {
          _onChange((0, _set2.default)(pspSettings, 'saferpay.saferpayApiUrl', option.value === '' ? null : option.value));
        },
        options: [{
          value: '',
          label: 'DEFAULT (' + (_Config2.default.IS_PROD ? 'PROD' : 'TEST') + ')'
        }, { value: 'https://www.saferpay.com/api', label: 'PROD' }, { value: 'https://test.saferpay.com/api', label: 'TEST' }],
        clearable: false

      })
    )
  );
};

var _default = SaferpayConfigurationView;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FormGroup, 'FormGroup', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/SaferpayConfigurationView.js');

  __REACT_HOT_LOADER__.register(SaferpayConfigurationView, 'SaferpayConfigurationView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/SaferpayConfigurationView.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/SaferpayConfigurationView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/pages/restaurant/edit/components/ThemeFormView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantColors = __webpack_require__("./sdk/scripts/entities/RestaurantColors.js");

var _RestaurantColors2 = _interopRequireDefault(_RestaurantColors);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _RestaurantFormComponent = __webpack_require__("./scripts/pages/restaurant/edit/components/RestaurantFormComponent.js");

var _RestaurantFormComponent2 = _interopRequireDefault(_RestaurantFormComponent);

var _ColorView = __webpack_require__("./scripts/components/color/ColorView.js");

var _ColorView2 = _interopRequireDefault(_ColorView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


// -- views


var ThemeFormView = function (_RestaurantFormCompon) {
  _inherits(ThemeFormView, _RestaurantFormCompon);

  function ThemeFormView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThemeFormView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeFormView.__proto__ || Object.getPrototypeOf(ThemeFormView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getDefaultState(_this.props.restaurant), _this.onSubmit = function () {
      var _this2;

      return (_this2 = _this).__onSubmit__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.onBackgroundColorChange = function () {
      var _this3;

      return (_this3 = _this).__onBackgroundColorChange__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.onFontColorChange = function () {
      var _this4;

      return (_this4 = _this).__onFontColorChange__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.onTitleBackgroundColorChange = function () {
      var _this5;

      return (_this5 = _this).__onTitleBackgroundColorChange__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.onTitleFontColorChange = function () {
      var _this6;

      return (_this6 = _this).__onTitleFontColorChange__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _this.onActionBackgroundColorChange = function () {
      var _this7;

      return (_this7 = _this).__onActionBackgroundColorChange__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this.onActionFontColorChange = function () {
      var _this8;

      return (_this8 = _this).__onActionFontColorChange__REACT_HOT_LOADER__.apply(_this8, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- actions

  _createClass(ThemeFormView, [{
    key: '__onActionFontColorChange__REACT_HOT_LOADER__',
    value: function __onActionFontColorChange__REACT_HOT_LOADER__() {
      return this.__onActionFontColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onActionBackgroundColorChange__REACT_HOT_LOADER__',
    value: function __onActionBackgroundColorChange__REACT_HOT_LOADER__() {
      return this.__onActionBackgroundColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTitleFontColorChange__REACT_HOT_LOADER__',
    value: function __onTitleFontColorChange__REACT_HOT_LOADER__() {
      return this.__onTitleFontColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onTitleBackgroundColorChange__REACT_HOT_LOADER__',
    value: function __onTitleBackgroundColorChange__REACT_HOT_LOADER__() {
      return this.__onTitleBackgroundColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onFontColorChange__REACT_HOT_LOADER__',
    value: function __onFontColorChange__REACT_HOT_LOADER__() {
      return this.__onFontColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onBackgroundColorChange__REACT_HOT_LOADER__',
    value: function __onBackgroundColorChange__REACT_HOT_LOADER__() {
      return this.__onBackgroundColorChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',
    value: function __onSubmit__REACT_HOT_LOADER__() {
      return this.__onSubmit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSubmit__REACT_HOT_LOADER__',


    // -- events colors changed

    value: function __onSubmit__REACT_HOT_LOADER__(event) {
      event.preventDefault();

      var restaurantMultipart = new _RestaurantMultipart2.default();
      restaurantMultipart.colors = this.state.restaurantColors;

      this.props.onUpdate(restaurantMultipart);
    }
  }, {
    key: '__onBackgroundColorChange__REACT_HOT_LOADER__',
    value: function __onBackgroundColorChange__REACT_HOT_LOADER__(uintColor) {
      var restaurantColors = this.state.restaurantColors;
      restaurantColors.backgroundColor = uintColor;
      this.updateRestaurantColors(restaurantColors);
    }
  }, {
    key: '__onFontColorChange__REACT_HOT_LOADER__',
    value: function __onFontColorChange__REACT_HOT_LOADER__(uintColor) {
      var restaurantColors = this.state.restaurantColors;
      restaurantColors.fontColor = uintColor;
      this.updateRestaurantColors(restaurantColors);
    }
  }, {
    key: '__onTitleBackgroundColorChange__REACT_HOT_LOADER__',
    value: function __onTitleBackgroundColorChange__REACT_HOT_LOADER__(uintColor) {
      var restaurantColors = this.state.restaurantColors;
      restaurantColors.titleBackgroundColor = uintColor;
      this.updateRestaurantColors(restaurantColors);
    }
  }, {
    key: '__onTitleFontColorChange__REACT_HOT_LOADER__',
    value: function __onTitleFontColorChange__REACT_HOT_LOADER__(uintColor) {
      var restaurantColors = this.state.restaurantColors;
      restaurantColors.titleFontColor = uintColor;
      this.updateRestaurantColors(restaurantColors);
    }
  }, {
    key: '__onActionBackgroundColorChange__REACT_HOT_LOADER__',
    value: function __onActionBackgroundColorChange__REACT_HOT_LOADER__(uintColor) {
      var restaurantColors = this.state.restaurantColors;
      restaurantColors.actionBackgroundColor = uintColor;
      this.updateRestaurantColors(restaurantColors);
    }
  }, {
    key: '__onActionFontColorChange__REACT_HOT_LOADER__',


    // -- tools

    value: function __onActionFontColorChange__REACT_HOT_LOADER__(uintColor) {
      var restaurantColors = this.state.restaurantColors;
      restaurantColors.actionFontColor = uintColor;
      this.updateRestaurantColors(restaurantColors);
    }
  }, {
    key: 'getDefaultState',
    value: function getDefaultState(restaurant) {
      return {
        restaurantColors: restaurant.colors.copy()
      };
    }
  }, {
    key: 'haveModifications',
    value: function haveModifications() {
      var restaurantColors = this.props.restaurant.colors;

      return !(restaurantColors.backgroundColor === this.state.restaurantColors.backgroundColor && restaurantColors.fontColor === this.state.restaurantColors.fontColor && restaurantColors.titleBackgroundColor === this.state.restaurantColors.titleBackgroundColor && restaurantColors.titleFontColor === this.state.restaurantColors.titleFontColor && restaurantColors.actionBackgroundColor === this.state.restaurantColors.actionBackgroundColor && restaurantColors.actionFontColor === this.state.restaurantColors.actionFontColor);
    }
  }, {
    key: 'updateRestaurantColors',
    value: function updateRestaurantColors(restaurantColors) {
      this.setState({
        restaurantColors: restaurantColors
      });
    }

    // -- renderers

  }, {
    key: 'renderBackgroundColor',
    value: function renderBackgroundColor() {
      var restaurantColors = this.state.restaurantColors;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-5 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.theme.background_color')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-1 fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              _react2.default.createElement(_ColorView2.default, {
                onColorChange: this.onBackgroundColorChange,
                color: restaurantColors.backgroundColor,
                enablePicker: _SecurityContext2.default.restaurantSettings.editTheme()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderFontColor',
    value: function renderFontColor() {
      var restaurantColors = this.state.restaurantColors;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-5 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.theme.text_color')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-1 fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              _react2.default.createElement(_ColorView2.default, {
                onColorChange: this.onFontColorChange,
                color: restaurantColors.fontColor,
                enablePicker: _SecurityContext2.default.restaurantSettings.editTheme()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderTitleBackgroundColor',
    value: function renderTitleBackgroundColor() {
      var restaurantColors = this.state.restaurantColors;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-5 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.theme.title_background_color')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-1 fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              _react2.default.createElement(_ColorView2.default, {
                onColorChange: this.onTitleBackgroundColorChange,
                color: restaurantColors.titleBackgroundColor,
                enablePicker: _SecurityContext2.default.restaurantSettings.editTheme()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderTitleFontColor',
    value: function renderTitleFontColor() {
      var restaurantColors = this.state.restaurantColors;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-5 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.theme.title_font_color')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-1 fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              _react2.default.createElement(_ColorView2.default, {
                onColorChange: this.onTitleFontColorChange,
                color: restaurantColors.titleFontColor,
                enablePicker: _SecurityContext2.default.restaurantSettings.editTheme()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderActionBackgroundColor',
    value: function renderActionBackgroundColor() {
      var restaurantColors = this.state.restaurantColors;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-5 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.theme.action_background_color')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-1 fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              _react2.default.createElement(_ColorView2.default, {
                onColorChange: this.onActionBackgroundColorChange,
                color: restaurantColors.actionBackgroundColor,
                enablePicker: _SecurityContext2.default.restaurantSettings.editTheme()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderActionFontColor',
    value: function renderActionFontColor() {
      var restaurantColors = this.state.restaurantColors;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'required col-xs-5 control-label' },
            _react2.default.createElement(
              'label',
              null,
              _I18n2.default.tr('restaurant_edit.theme.action_text_color')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-1 fake-input-group' },
            _react2.default.createElement(
              'div',
              { className: 'form-control' },
              _react2.default.createElement(_ColorView2.default, {
                onColorChange: this.onActionFontColorChange,
                color: restaurantColors.actionFontColor,
                enablePicker: _SecurityContext2.default.restaurantSettings.editTheme()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'edit_restaurant_form_view__theme' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'form',
            {
              className: 'form-horizontal',
              noValidate: true,
              onSubmit: this.onSubmit
            },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-5' },
              this.renderBackgroundColor(),
              this.renderFontColor(),
              this.renderTitleBackgroundColor(),
              this.renderTitleFontColor(),
              this.renderActionBackgroundColor(),
              this.renderActionFontColor()
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              this.renderButtons()
            )
          )
        )
      );
    }
  }]);

  return ThemeFormView;
}(_RestaurantFormComponent2.default);

ThemeFormView.propTypes = {
  restaurant: _propTypes2.default.objectOf(_Restaurant2.default),

  /**
   * @param RestaurantMultipart
   */
  onUpdate: _propTypes2.default.func.isRequired
};
exports.default = ThemeFormView;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ThemeFormView, 'ThemeFormView', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/pages/restaurant/edit/components/ThemeFormView.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/routes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");

var _Layout = __webpack_require__("./scripts/pages/Layout.js");

var _Layout2 = _interopRequireDefault(_Layout);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var subRoutes = [];

function requireAuth(nextState, replace) {
  if (!_SessionStore2.default.isLoggedIn()) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname }
    });
  }
}

_lodash2.default.each(_RoutingEnum2.default, function (route) {
  if (!route.disable) {
    subRoutes.push(_react2.default.createElement(_reactRouter.Route, {
      name: route.name,
      path: route.path,
      component: route.handler,
      key: route.name,
      onEnter: route.authRequired ? requireAuth : null
    }));
  }
});

var routes = _react2.default.createElement(
  _reactRouter.Route,
  { name: 'app', component: _Layout2.default },
  subRoutes
);

var _default = routes;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(subRoutes, 'subRoutes', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/routes.js');

  __REACT_HOT_LOADER__.register(requireAuth, 'requireAuth', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/routes.js');

  __REACT_HOT_LOADER__.register(routes, 'routes', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/routes.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/routes.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/ApiConsumersStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApiConsumersStore = function (_ReduceStore) {
  _inherits(ApiConsumersStore, _ReduceStore);

  function ApiConsumersStore() {
    _classCallCheck(this, ApiConsumersStore);

    return _possibleConstructorReturn(this, (ApiConsumersStore.__proto__ || Object.getPrototypeOf(ApiConsumersStore)).apply(this, arguments));
  }

  _createClass(ApiConsumersStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        data: null,
        apiError: null,
        isFetching: false
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        data: {},
        isFetching: false
      };
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      if (!_.isNull(this._state.data)) {
        var sourcesList = this._state.data.apiConsumers.map(function (_ref) {
          var id = _ref.id,
              name = _ref.name;

          return {
            label: name,
            value: id
          };
        });
        sourcesList.push({
          label: _I18n2.default.tr('order.statistics.other'),
          value: 0
        });

        return sourcesList;
      }

      return null;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_API_CONSUMERS:
          nextState.data = null;
          nextState.isFetching = true;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.GET_API_CONSUMERS_SUCCESS:
          nextState.data = action.data;
          nextState.isFetching = false;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.GET_API_CONSUMERS_FAILURE:
          nextState.data = null;
          nextState.isFetching = false;
          nextState.apiError = action.apiError;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return ApiConsumersStore;
}(_ReduceStore3.default);

var _default = new ApiConsumersStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ApiConsumersStore, 'ApiConsumersStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/ApiConsumersStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/ApiConsumersStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/CartModifierListStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartModifierListStore = function (_ReduceStore) {
  _inherits(CartModifierListStore, _ReduceStore);

  function CartModifierListStore() {
    _classCallCheck(this, CartModifierListStore);

    return _possibleConstructorReturn(this, (CartModifierListStore.__proto__ || Object.getPrototypeOf(CartModifierListStore)).apply(this, arguments));
  }

  _createClass(CartModifierListStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        data: [new _CartModifier2.default()],
        apiError: null,
        isFetching: false
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        data: [],
        isFetching: false
      };
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {
        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_CART_MODIFIERS:
          nextState.isFetching = true;
          nextState.apiError = null;
          nextState.data = null;
          return nextState;

        case _ActionTypes2.default.GET_CART_MODIFIERS_SUCCESS:
          nextState.isFetching = false;
          nextState.apiError = null;
          nextState.data = action.data;
          return nextState;

        case _ActionTypes2.default.GET_CART_MODIFIERS_FAILURE:
          nextState.isFetching = false;
          nextState.data = null;
          nextState.apiError = action.apiError;
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIER:
          // TODO: fix nextState considered as equal
          nextState.data = _ArrayUtils2.default.updateObjectOrAdd(nextState.data, new _CartModifier2.default().fromJson(_extends({}, action.cartModifier, { isFetching: true })), function (cartModifier) {
            return cartModifier.id === action.cartModifier.id;
          });
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIER_SUCCESS:
          // TODO: fix nextState considered as equal
          nextState.data = _ArrayUtils2.default.updateObjectOrAdd(nextState.data, new _CartModifier2.default().fromJson(_extends({}, action.data, { isFetching: false })), function (cartModifier) {
            return cartModifier.id === action.data.id;
          });
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIERS_PRIORITIES:
          nextState.isFetching = false;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIERS_PRIORITIES_SUCCESS:
          // TODO: update data instead of replacing it
          nextState.data = action.data;
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIERS_PRIORITIES_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return CartModifierListStore;
}(_ReduceStore3.default);

var _default = new CartModifierListStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CartModifierListStore, 'CartModifierListStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/CartModifierListStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/CartModifierListStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/CartModifierStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isNull = __webpack_require__("./node_modules/lodash/isNull.js");

var _isNull2 = _interopRequireDefault(_isNull);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _RouteStore = __webpack_require__("./scripts/stores/RouteStore.js");

var _RouteStore2 = _interopRequireDefault(_RouteStore);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartModifierStore = function (_ReduceStore) {
  _inherits(CartModifierStore, _ReduceStore);

  function CartModifierStore() {
    _classCallCheck(this, CartModifierStore);

    return _possibleConstructorReturn(this, (CartModifierStore.__proto__ || Object.getPrototypeOf(CartModifierStore)).apply(this, arguments));
  }

  _createClass(CartModifierStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        data: new _CartModifier2.default(),
        apiError: null,
        isFetching: false
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        data: {},
        isFetching: false
      };
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {
        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_CART_MODIFIER:
          nextState.isFetching = true;
          nextState.apiError = null;
          nextState.data = null;
          return nextState;

        case _ActionTypes2.default.GET_CART_MODIFIER_SUCCESS:
          nextState.isFetching = false;
          nextState.apiError = null;
          nextState.data = action.data;
          return nextState;

        case _ActionTypes2.default.GET_CART_MODIFIER_FAILURE:
          nextState.isFetching = false;
          nextState.data = null;
          nextState.apiError = action.apiError;
          return nextState;

        case _ActionTypes2.default.POST_CART_MODIFIER:
          nextState.isFetching = true;
          return nextState;

        case _ActionTypes2.default.POST_CART_MODIFIER_SUCCESS:
          _RouteStore2.default.redirectTo(_RoutingEnum2.default.ORDERS_CART_MODIFIERS_LIST);
          // TODO: uncomment and debug when creating a new cart modifier
          // RouteStore.redirectTo(RoutingEnum.ORDERS_CART_MODIFIERS_EDIT, { cartModifierId: action.data.id })
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIER:
          nextState.isFetching = true;
          return nextState;

        case _ActionTypes2.default.PUT_CART_MODIFIER_SUCCESS:
          if (!(0, _isNull2.default)(nextState.data) && nextState.data.id === action.data.id) {
            nextState.isFetching = false;
            nextState.data = action.data;
          }
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return CartModifierStore;
}(_ReduceStore3.default);

var _default = new CartModifierStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CartModifierStore, 'CartModifierStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/CartModifierStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/CartModifierStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/DashboardStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _RestaurantDashboardInfo = __webpack_require__("./sdk/scripts/entities/dashboard/RestaurantDashboardInfo.js");

var _RestaurantDashboardInfo2 = _interopRequireDefault(_RestaurantDashboardInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


var DashboardStore = function (_ReduceStore) {
  _inherits(DashboardStore, _ReduceStore);

  function DashboardStore() {
    _classCallCheck(this, DashboardStore);

    return _possibleConstructorReturn(this, (DashboardStore.__proto__ || Object.getPrototypeOf(DashboardStore)).apply(this, arguments));
  }

  _createClass(DashboardStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        apiError: null, // ApiError
        restaurantDashboardInfo: null // RestaurantDashboardInfo
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        payoutList: new _ApiError2.default(),
        restaurantDashboardInfo: new _RestaurantDashboardInfo2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getRestaurantDashboardInfo',
    value: function getRestaurantDashboardInfo() {
      return this._state.restaurantDashboardInfo;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        //
        // Get for date
        //

        case _ActionTypes2.default.GET_RESTAURANT_DASHBOARD_RESPONSE_SUCCESS:
          nextState.restaurantDashboardInfo = action.restaurantDashboardInfo;
          nextState.apiError = null;

          return nextState;

        case _ActionTypes2.default.GET_RESTAURANT_DASHBOARD_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return DashboardStore;
}(_ReduceStore3.default);

var _default = new DashboardStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DashboardStore, 'DashboardStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/DashboardStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/DashboardStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/KioskSettingsStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _KioskSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskSettings.js");

var _KioskSettings2 = _interopRequireDefault(_KioskSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


function objectCopy(obj) {
  return _lodash2.default.isNil(obj) ? obj : obj.copy();
}

var KioskSettingsStore = function (_ReduceStore) {
  _inherits(KioskSettingsStore, _ReduceStore);

  function KioskSettingsStore() {
    _classCallCheck(this, KioskSettingsStore);

    return _possibleConstructorReturn(this, (KioskSettingsStore.__proto__ || Object.getPrototypeOf(KioskSettingsStore)).apply(this, arguments));
  }

  _createClass(KioskSettingsStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        // ApiError
        apiError: null,

        // KioskSettings
        kioskSettings: null
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        payoutList: new _ApiError2.default(),
        kioskSettings: new _KioskSettings2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return objectCopy(this._state.apiError);
    }
  }, {
    key: 'getSettings',
    value: function getSettings() {
      return objectCopy(this._state.kioskSettings);
    }
  }, {
    key: 'areEqual',
    value: function areEqual(one, two) {
      var isEqual = _lodash2.default.isEqual(one, two);
      return isEqual;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_KIOSK_SETTINGS_SUCCESS:
        case _ActionTypes2.default.PUT_KIOSK_SETTINGS_SUCCESS:
          nextState.kioskSettings = action.kioskSettings;
          return nextState;

        case _ActionTypes2.default.GET_KIOSK_SETTINGS_FAILURE:
        case _ActionTypes2.default.PUT_KIOSK_SETTINGS_FAILURE:
          nextState.apiError = null;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return KioskSettingsStore;
}(_ReduceStore3.default);

var _default = new KioskSettingsStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(objectCopy, 'objectCopy', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/KioskSettingsStore.js');

  __REACT_HOT_LOADER__.register(KioskSettingsStore, 'KioskSettingsStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/KioskSettingsStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/KioskSettingsStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/OrderSettingsStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


var OrderSettingsStore = function (_ReduceStore) {
  _inherits(OrderSettingsStore, _ReduceStore);

  function OrderSettingsStore() {
    _classCallCheck(this, OrderSettingsStore);

    return _possibleConstructorReturn(this, (OrderSettingsStore.__proto__ || Object.getPrototypeOf(OrderSettingsStore)).apply(this, arguments));
  }

  _createClass(OrderSettingsStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        orderSettings: null, // OrderSettings
        apiError: null // ApiError
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        orderSettings: new _order.OrderSettings()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getOrderSettings',
    value: function getOrderSettings() {
      return this._state.orderSettings;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_RESTAURANT_SUCCESS:
        case _ActionTypes2.default.PUT_RESTAURANT_SUCCESS:

        // Disabled update with PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS. The data does not contain the
        // real orderSettings data of the store, but an empty orderSettings object.
        // This make the order settings on our store invalid (reseted data) and lead to bugs, such as
        // "Sometime the "Synchronize POS" button doesn't appear on the RestaurantMenu page and user 
        // has to refresh the page to see it and click it. This might be related to some information 
        // loaded after the display (in some case)."
        // https://www.notion.so/paymytable/Bugfix-PMT-BO-v1-c9fc99cdb0eb446f9e4ff90dd54a8abd?pvs=4
        // case ActionTypes.PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS:
        case _ActionTypes2.default.PRO_ACCOUNT_GET_ME_SUCCESS:
          if (!_lodash2.default.isUndefined(action.restaurant) && !_lodash2.default.isUndefined(action.restaurant.orderSettings) && !_lodash2.default.isNull(action.restaurant.orderSettings)) {
            nextState.orderSettings = action.restaurant.orderSettings;
          } else {
            // TODO: fix
            console.warn('could not find order settings in ', action);
          }
          return nextState;

        case _ActionTypes2.default.GET_ORDER_SETTINGS_SUCCESS:
          nextState.orderSettings = action.orderSettings;
          this.emitEvent(_Events2.default.ON_LOAD_ORDER_SETTINGS_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_ORDER_SETTINGS_SUCCESS:
          nextState.orderSettings = action.orderSettings;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_ORDER_SETTINGS_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_ORDER_SETTINGS_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_ORDER_SETTINGS_FAILURE);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return OrderSettingsStore;
}(_ReduceStore3.default);

var _default = new OrderSettingsStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderSettingsStore, 'OrderSettingsStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrderSettingsStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrderSettingsStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/OrderStatisticsStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderStatisticsStore = function (_ReduceStore) {
  _inherits(OrderStatisticsStore, _ReduceStore);

  function OrderStatisticsStore() {
    _classCallCheck(this, OrderStatisticsStore);

    return _possibleConstructorReturn(this, (OrderStatisticsStore.__proto__ || Object.getPrototypeOf(OrderStatisticsStore)).apply(this, arguments));
  }

  _createClass(OrderStatisticsStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        data: null,
        apiError: null,
        isFetching: false
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        data: {},
        isFetching: false
      };
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_ORDER_STATISTICS:
          nextState.data = null;
          nextState.isFetching = true;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.GET_ORDER_STATISTICS_SUCCESS:
          nextState.data = action.data;
          nextState.isFetching = false;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.GET_ORDER_STATISTICS_FAILURE:
          nextState.data = null;
          nextState.isFetching = false;
          nextState.apiError = action.apiError;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return OrderStatisticsStore;
}(_ReduceStore3.default);

var _default = new OrderStatisticsStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderStatisticsStore, 'OrderStatisticsStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrderStatisticsStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrderStatisticsStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/OrdersListStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _OrdersList = __webpack_require__("./sdk/scripts/entities/order/OrdersList.js");

var _OrdersList2 = _interopRequireDefault(_OrdersList);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


function updateOrder(state, order) {

  if (!_lodash2.default.isNull(state.ordersList)) {
    state.ordersList.updateOrder(order);
  }

  if (!_lodash2.default.isNull(state.dueDateOrdersList)) {
    state.dueDateOrdersList.updateOrder(order);
  }

  return state;
}

var OrdersListStore = function (_ReduceStore) {
  _inherits(OrdersListStore, _ReduceStore);

  function OrdersListStore() {
    _classCallCheck(this, OrdersListStore);

    return _possibleConstructorReturn(this, (OrdersListStore.__proto__ || Object.getPrototypeOf(OrdersListStore)).apply(this, arguments));
  }

  _createClass(OrdersListStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        apiError: null, // ApiError
        ordersList: null, // OrdersList
        dueDateOrdersList: null, // OrdersList
        updatedOrder: null, // Order
        lastUpdateTime: null // number
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        ordersList: new _OrdersList2.default(),
        dueDateOrdersList: new _OrdersList2.default(),
        updatedOrder: new _Order2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getOrdersList',
    value: function getOrdersList() {
      return this._state.ordersList;
    }
  }, {
    key: 'getDueDateOrdersList',
    value: function getDueDateOrdersList() {
      return this._state.dueDateOrdersList;
    }
  }, {
    key: 'getLastUpdateTime',
    value: function getLastUpdateTime() {
      return this._state.lastUpdateTime;
    }
  }, {
    key: 'getUpdatedOrder',
    value: function getUpdatedOrder() {
      return this._state.updatedOrder;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_SUCCESS:
        case _ActionTypes2.default.ON_GOING_ORDERS_LISTRESPONSE_SUCCESS:
          var newOrdersList = action.ordersList;

          nextState.lastUpdateTime = action.toTime;

          if (!_lodash2.default.isNull(nextState.ordersList)) {
            var haveNewOrders = false;

            // update orders
            _lodash2.default.each(newOrdersList.orders, function (order) {
              var exists = _utils.ArrayUtils.exists(nextState.ordersList.orders, { id: order.id });
              if (!exists) {
                if (!order.isCanceled()) {
                  // a new order exists, we set it, the front will notify the user.
                  haveNewOrders = true;
                }
                nextState.ordersList.addOrder(order);
              } else {
                nextState.ordersList.updateOrder(order);
              }
            });
            nextState.ordersList.haveNewOrders = haveNewOrders;
          } else {
            nextState.ordersList = newOrdersList;
          }

          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_RETRIEVE_ORDERS_LIST_SUCCESS);
          return nextState;

        case _ActionTypes2.default.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_FAILURE:
        case _ActionTypes2.default.ON_GOING_ORDERS_LISTRESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_RETRIEVE_ORDERS_LIST_FAILURE);
          return nextState;

        case _ActionTypes2.default.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_SUCCESS:
          // if (_.isNull(nextState.dueDateOrdersList)) {
          nextState.dueDateOrdersList = action.ordersList;
          // } else {
          // _.each(action.ordersList.orders, (order:Order) => {
          // nextState.dueDateOrdersList.updateOrder(order);
          // });
          // }
          this.emitEvent(_Events2.default.ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_RETRIEVE_ORDERS_LIST_BY_DUE_DATE_FAILURE);
          return nextState;

        case _ActionTypes2.default.UPDATE_ORDER_RESPONSE_SUCCESS:
          updateOrder(nextState, action.order);
          nextState.updatedOrder = action.order;
          this.emitEvent(_Events2.default.UPDATE_ORDER_SUCCESS);
          return nextState;

        case _ActionTypes2.default.UPDATE_ORDER_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.UPDATE_ORDER_FAILURE);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return OrdersListStore;
}(_ReduceStore3.default);

var _default = new OrdersListStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(updateOrder, 'updateOrder', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrdersListStore.js');

  __REACT_HOT_LOADER__.register(OrdersListStore, 'OrdersListStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrdersListStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/OrdersListStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/PaymentReceiptStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _PayinList = __webpack_require__("./sdk/scripts/entities/PayinList.js");

var _PayinList2 = _interopRequireDefault(_PayinList);

var _PayoutList = __webpack_require__("./sdk/scripts/entities/PayoutList.js");

var _PayoutList2 = _interopRequireDefault(_PayoutList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


var PaymentReceiptStore = function (_ReduceStore) {
  _inherits(PaymentReceiptStore, _ReduceStore);

  function PaymentReceiptStore() {
    _classCallCheck(this, PaymentReceiptStore);

    return _possibleConstructorReturn(this, (PaymentReceiptStore.__proto__ || Object.getPrototypeOf(PaymentReceiptStore)).apply(this, arguments));
  }

  _createClass(PaymentReceiptStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        payoutList: null,
        payinList: null,

        /**
         * @type ApiError
         */
        apiError: null
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        payoutList: new _ApiError2.default(),
        payinList: new _PayinList2.default(),
        apiError: new _ApiError2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getPayoutList',
    value: function getPayoutList() {
      return this._state.payoutList;
    }
  }, {
    key: 'getPayinList',
    value: function getPayinList() {
      return this._state.payinList;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
        case _ActionTypes2.default.PAYMENT_PAYINS_RESPONSE_REQUEST:
        case _ActionTypes2.default.PAYMENT_PAYOUTS_RESPONSE_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.PAYMENT_PAYINS_RESPONSE_SUCCESS:
          nextState.payinList = action.payinList;
          nextState.apiError = null;

          return nextState;

        case _ActionTypes2.default.PAYMENT_PAYOUTS_RESPONSE_SUCCESS:
          nextState.payoutList = action.payoutList;
          nextState.apiError = null;

          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return PaymentReceiptStore;
}(_ReduceStore3.default);

var _default = new PaymentReceiptStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentReceiptStore, 'PaymentReceiptStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/PaymentReceiptStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/PaymentReceiptStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/PaymentStatStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _PaymentStatistics = __webpack_require__("./sdk/scripts/entities/PaymentStatistics.js");

var _PaymentStatistics2 = _interopRequireDefault(_PaymentStatistics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


var PaymentStatStore = function (_ReduceStore) {
  _inherits(PaymentStatStore, _ReduceStore);

  function PaymentStatStore() {
    _classCallCheck(this, PaymentStatStore);

    return _possibleConstructorReturn(this, (PaymentStatStore.__proto__ || Object.getPrototypeOf(PaymentStatStore)).apply(this, arguments));
  }

  _createClass(PaymentStatStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        /**
         * @type PaymentStatistics
         */
        paymentStatistics: null,

        /**
         * @type ApiError
         */
        apiError: null
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        paymentStatistics: new _PaymentStatistics2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getPaymentStatistics',
    value: function getPaymentStatistics() {
      return this._state.paymentStatistics;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.PAYMENT_STATISTICS_RESPONSE_SUCCESS:
          nextState.paymentStatistics = action.paymentStatistics;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.PAYMENT_STATISTICS_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return PaymentStatStore;
}(_ReduceStore3.default);

var _default = new PaymentStatStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentStatStore, 'PaymentStatStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/PaymentStatStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/PaymentStatStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/PaymentStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _PaymentsList = __webpack_require__("./sdk/scripts/entities/PaymentsList.js");

var _PaymentsList2 = _interopRequireDefault(_PaymentsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


var PaymentStore = function (_ReduceStore) {
  _inherits(PaymentStore, _ReduceStore);

  function PaymentStore() {
    _classCallCheck(this, PaymentStore);

    return _possibleConstructorReturn(this, (PaymentStore.__proto__ || Object.getPrototypeOf(PaymentStore)).apply(this, arguments));
  }

  _createClass(PaymentStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        paymentsList: null,
        apiError: null
      };
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        paymentsList: new _PaymentsList2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getPaymentsList',
    value: function getPaymentsList() {
      return this._state.paymentsList;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        // -- user payments

        case _ActionTypes2.default.GET_USER_PAYMENTS_RESPONSE_SUCCESS:
          nextState.paymentsList = action.paymentsList;
          nextState.apiError = null;
          return nextState;

        case _ActionTypes2.default.GET_USER_PAYMENTS_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return PaymentStore;
}(_ReduceStore3.default);

var _default = new PaymentStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaymentStore, 'PaymentStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/PaymentStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/PaymentStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/ProAccountStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _2 = __webpack_require__("./scripts/stores/index.js");

var _constants = __webpack_require__("./scripts/constants/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entity


/**
 * Handle pro accounts.
 * - `Me` is used for the for the current logged in user
 * - It also handle other pro account that the logged in user could modify (depends of
 * its permissions)
 */
var ProAccountStore = function (_ReduceStore) {
  _inherits(ProAccountStore, _ReduceStore);

  function ProAccountStore() {
    _classCallCheck(this, ProAccountStore);

    return _possibleConstructorReturn(this, (ProAccountStore.__proto__ || Object.getPrototypeOf(ProAccountStore)).apply(this, arguments));
  }

  _createClass(ProAccountStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      // -- me account default
      var meAccount = null;
      var json = _utils.SessionUtils.getItemFromSession(_constants.Constants.SessionKey.ACCOUNT);
      if (!_lodash2.default.isNil(json)) {
        meAccount = new _security.ProAccount();
        meAccount.fromJson(json);
      }

      return {
        /**
         * @type ProDomain
         */
        selectedProDomain: null,

        /**
         * @type ApiError
         */
        apiError: null,

        /**
         * The current user's account.
         * @type ProAccount
         */
        meAccount: null,

        /**
         * The created account.
         *
         * @type ProAccount
         */
        newAccount: null,

        /**
         * The updated account.
         * @type ProAccount
         */
        updateAccount: null,

        /**
         * The account to display.
         *
         * @type ProAccount
         */
        account: null,

        forgotPassword: null
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        selectedProDomain: new _security.ProDomain(),
        meAccount: new _security.ProAccount(),
        newAccount: new _security.ProAccount(),
        updateAccount: new _security.ProAccount(),
        account: new _security.ProAccount()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getNewAccount',
    value: function getNewAccount() {
      return this._state.newAccount;
    }
  }, {
    key: 'getUpdateAccount',
    value: function getUpdateAccount() {
      return this._state.updateAccount;
    }
  }, {
    key: 'getAccount',
    value: function getAccount() {
      return this._state.account;
    }
  }, {
    key: 'getSelectedProDomain',
    value: function getSelectedProDomain() {
      return this._state.selectedProDomain;
    }
  }, {
    key: 'getSelectedProDomainId',
    value: function getSelectedProDomainId() {
      if (!_lodash2.default.isNull(this._state.selectedProDomain)) {
        return this._state.selectedProDomain.id;
      }
      return null;
    }

    /**
     * The current logged in user account is saved in session.
     */

  }, {
    key: 'getMeAccount',
    value: function getMeAccount() {
      if (_lodash2.default.isNull(this._state.meAccount)) {
        var json = _utils.SessionUtils.getItemFromSession(_constants.Constants.SessionKey.ACCOUNT);
        this._state.meAccount = new _security.ProAccount();
        this._state.meAccount.fromJson(json);
      }

      return this._state.meAccount;
    }
  }, {
    key: 'saveMeAccount',
    value: function saveMeAccount(proAccount, state) {
      _utils.SessionUtils.saveItemToSession('ACCOUNT', proAccount);
      state.meAccount = proAccount;

      return state;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {
        case _constants.ActionTypes.LOGOUT:
          // -- clear user context
          _utils.Logger.clearUserContext();

          nextState.apiError = null;
          return nextState;

        case _constants.ActionTypes.PRO_FORGOT_PASSWORD_SUCCESS:
          this.emitEvent(_constants.Events.PRO_FORGOT_PASSWORD);
          nextState.meAccount.forgotPassword = true;
          return nextState;

        case _constants.ActionTypes.PRO_FORGOT_PASSWORD_FAILURE:
          this.emitEvent(_constants.Events.PRO_FORGOT_PASSWORD);
          nextState.meAccount.forgotPassword = false;
          return nextState;

        case _constants.ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
          nextState.apiError = null;
          return nextState;

        //
        // Create
        //

        case _constants.ActionTypes.PRO_ACCOUNT_CREATE_SUCCESS:
          nextState.newAccount = action.proAccount;
          nextState.apiError = null;
          return nextState;

        case _constants.ActionTypes.PRO_ACCOUNT_CREATE_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        //
        // Retrieve
        //

        case _constants.ActionTypes.PRO_ACCOUNT_GET_SUCCESS:
          nextState.account = action.proAccount;
          nextState.apiError = null;
          return nextState;

        case _constants.ActionTypes.PRO_ACCOUNT_GET_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        //
        // Me account
        //
        case _constants.ActionTypes.PRO_ACCOUNT_GET_ME_SUCCESS:
          this.waitFor([_2.RestaurantStore.getDispatchToken()]);

          this.saveMeAccount(action.proAccount, nextState);
          nextState.apiError = null;

          nextState.selectedProDomain = action.proDomain;
          _2.SessionStore.saveProDomainId(nextState.selectedProDomain.id);

          _utils.Logger.setUserContext(_utils.Logger.UserRole.RESTAURANT, action.proAccount.id);

          this.emitEvent(_constants.Events.PRO_ACCOUNT_GET_ME_SUCCESS);
          return nextState;

        case _constants.ActionTypes.PRO_ACCOUNT_GET_ME_FAILURE:
          nextState.meAccount = action.apiError;
          this.emitEvent(_constants.Events.PRO_ACCOUNT_GET_ME_FAILURE);
          return nextState;

        //
        // Update
        //

        case _constants.ActionTypes.PRO_ACCOUNT_UPDATE_SUCCESS:
          nextState.updateAccount = action.proAccount;
          nextState.apiError = null;
          return nextState;

        case _constants.ActionTypes.PRO_ACCOUNT_UPDATE_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        //
        // Delete
        //

        case _constants.ActionTypes.PRO_ACCOUNT_DELETE_SUCCESS:
          nextState.apiError = null;
          return nextState;

        case _constants.ActionTypes.PRO_ACCOUNT_DELETE_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        //
        // Domains
        //

        case _constants.ActionTypes.PRO_ACCOUNT_GET_DOMAINS_SUCCESS:
          nextState.meAccount = action.account; // to be sure.
          nextState.meAccount.domainsList = action.proDomainsList;
          nextState.apiError = null;
          return nextState;

        case _constants.ActionTypes.PRO_ACCOUNT_GET_DOMAINS_FAILURE:
          nextState.apiError = action.apiError;
          return nextState;

        //
        //
        //
        case _constants.ActionTypes.CHANGE_PRO_DOMAIN:
          nextState.selectedProDomain = action.proDomain;

          nextState.meAccount.role = nextState.selectedProDomain.role;
          nextState.meAccount.restaurantsGroup = nextState.selectedProDomain.restaurantsGroup;

          _2.SessionStore.saveProDomainId(nextState.selectedProDomain.id);

        default:
          return nextState;
      }
    }
  }]);

  return ProAccountStore;
}(_ReduceStore3.default);

var _default = new ProAccountStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProAccountStore, 'ProAccountStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/ProAccountStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/ProAccountStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/RestaurantMenuStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


// -- vars


var RestaurantMenuStore = function (_ReduceStore) {
  _inherits(RestaurantMenuStore, _ReduceStore);

  function RestaurantMenuStore() {
    _classCallCheck(this, RestaurantMenuStore);

    return _possibleConstructorReturn(this, (RestaurantMenuStore.__proto__ || Object.getPrototypeOf(RestaurantMenuStore)).apply(this, arguments));
  }

  _createClass(RestaurantMenuStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isFetching: false,
        /**
        * @type RestaurantMenu
        */
        restaurantMenu: null,
        /**
        * @type ApiError
        */
        apiError: null,
        /**
        * @type Menu
        */
        createdMenu: null,
        /**
        * @type Product
        */
        createdProduct: null,
        /**
        * @type ProductCategory
        */
        createdCategory: null,
        /**
        * @type ProductOption
        */
        createdProductOption: null,
        /**
        * @type UpsellingCategory
        */
        createdUpsellingCategory: null
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        isFetching: false,
        apiError: new _ApiError2.default(),
        restaurantMenu: new _menu.RestaurantMenu(),
        createdMenu: new _menu.Menu(),
        createdProduct: new _menu.Product(),
        createdCategory: new _menu.ProductCategory(),
        createdProductOption: new _menu.ProductOption(),
        createdUpsellingCategory: new _menu.UpsellingCategory()
      };
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getRestaurantMenu',
    value: function getRestaurantMenu() {
      return this._state.restaurantMenu;
    }
  }, {
    key: 'getCreatedMenu',
    value: function getCreatedMenu() {
      return this._state.createdMenu;
    }
  }, {
    key: 'getCreatedProduct',
    value: function getCreatedProduct() {
      return this._state.createdProduct;
    }
  }, {
    key: 'getCreatedCategory',
    value: function getCreatedCategory() {
      return this._state.createdCategory;
    }
  }, {
    key: 'getCreatedProductOption',
    value: function getCreatedProductOption() {
      return this._state.createdProductOption;
    }
  }, {
    key: 'getCreatedUpsellingCategory',
    value: function getCreatedUpsellingCategory() {
      return this._state.createdUpsellingCategory;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        //
        // RestaurantMenu - GET
        //

        case _ActionTypes2.default.GET_RESTAURANT_MENU:
          nextState.isFetching = true;
          nextState.restaurantMenu = null;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_LOADING_RESTAURANT_MENU);
          return nextState;

        case _ActionTypes2.default.GET_RESTAURANT_MENU_RESPONSE_SUCCESS:
        case _ActionTypes2.default.GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_SUCCESS:
          nextState.isFetching = false;
          nextState.restaurantMenu = action.restaurantMenu;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_LOADING_RESTAURANT_MENU_SUCCESS);
          return nextState;

        case _ActionTypes2.default.GET_RESTAURANT_MENU_RESPONSE_FAILURE:
        case _ActionTypes2.default.GET_RESTAURANT_MENU_WITH_SYNCHRONIZATION_FAILURE:
          nextState.isFetching = false;
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_LOADING_RESTAURANT_MENU_ERROR);
          return nextState;

        //
        // RestaurantMenu - UPDATED
        //

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_RESPONSE_SUCCESS:
          nextState.restaurantMenu = action.restaurantMenu;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_ERROR);
          return nextState;

        //
        // PRODUCT - UPDATED
        //

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateProduct(action.product);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_ERROR);
          return nextState;

        //
        // PRODUCT - DELETED IMAGE
        //

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateProduct(action.product);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_IMAGE_RESPONSE_ERROR);
          return nextState;

        //
        // PRODUCT - DELETED
        //

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS:
          nextState.restaurantMenu.deleteProduct(action.product);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_ERROR);
          return nextState;

        //
        // PRODUCT - CREATED
        //

        case _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_RESPONSE_SUCCESS:
          nextState.restaurantMenu.addProduct(action.product);
          nextState.createdProduct = action.product;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_ERROR);
          return nextState;

        //
        // PRODUCT OPTION - UPDATED
        //

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS:
          nextState.restaurantMenu.updateProductOption(action.productOption);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS:
          nextState.restaurantMenu.updateProductOption(action.productOption);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_IMAGE_ERROR);
          return nextState;

        //
        // PRODUCT OPTION - DELETED
        //

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS:
          nextState.restaurantMenu.deleteProductOption(action.productOption);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR);
          return nextState;

        //
        // PRODUCT OPTION - CREATED
        //

        case _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS:
          nextState.restaurantMenu.addProductOption(action.productOption);
          nextState.createdProductOption = action.productOption;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_SUCCESS);
          return nextState;

        case _ActionTypes2.default.POST_RESTAURANT_MENU_PRODUCT_OPTION_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_PRODUCT_OPTION_ERROR);
          return nextState;

        //
        // MENU - UPDATED
        //

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateMenu(action.menu);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_ERROR);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateMenu(action.menu);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_IMAGE_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_IMAGE_ERROR);
          return nextState;

        //
        // MENU - DELETED
        //

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS:
          nextState.restaurantMenu.deleteMenu(action.menu);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_MENU_ERROR);
          return nextState;

        //
        // MENU - CREATED
        //

        case _ActionTypes2.default.POST_RESTAURANT_MENU_MENU_RESPONSE_SUCCESS:
          nextState.restaurantMenu.addMenu(action.menu);
          nextState.createdMenu = action.menu;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_MENU_SUCCESS);
          return nextState;

        case _ActionTypes2.default.POST_RESTAURANT_MENU_MENU_RESPONSE_FAILURE:
        case _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_FAILURE:
        case _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_MENU_ERROR);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_SUCCESS:
          var updatePutPart = function updatePutPart(state, action) {
            var menu = state.restaurantMenu.getMenuWithId(action.menuId);
            menu.updatePart(action.menuPart);
            state.restaurantMenu.updateMenu(menu);
            return state;
          };
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS);
          return updatePutPart(nextState, action);

        //
        // MENU - MENU_PART - CATEGORY
        //
        case _ActionTypes2.default.PUT_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS:
          var updatePutCategory = function updatePutCategory(state, action) {
            var menu = state.restaurantMenu.getMenuWithId(action.menuId);
            var menuPart = menu.getPartWithId(action.menuPartId);
            menuPart.updateCategory(action.category);
            menu.updatePart(menuPart);
            state.restaurantMenu.updateMenu(menu);
            return state;
          };
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS);
          return updatePutCategory(nextState, action);

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS:
          var deleteCategory = function deleteCategory(state, action) {
            var menu = state.restaurantMenu.getMenuWithId(action.menuId);
            var menuPart = menu.getPartWithId(action.menuPartId);
            menuPart.deleteCategory(action.category);
            menu.updatePart(menuPart);
            state.restaurantMenu.updateMenu(menu);
            return state;
          };
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS);
          return deleteCategory(nextState, action);

        //
        // CATEGORY - UPDATED
        //

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateCategory(new _menu.ProductCategory().fromJson(action.category));
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_CATEGORY_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_CATEGORY_ERROR);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateCategory(new _menu.ProductCategory().fromJson(action.category));
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_CATEGORY_IMAGE_RESPONSE_ERROR);
          return nextState;

        //
        // CATEGORY - DELETED
        //

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS:
          nextState.restaurantMenu.deleteCategory(action.category);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_CATEGORY_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_CATEGORY_ERROR);
          return nextState;

        //
        // CATEGORY - CREATED
        //

        case _ActionTypes2.default.POST_RESTAURANT_MENU_CATEGORY_RESPONSE_SUCCESS:
          nextState.restaurantMenu.addCategory(action.category);
          nextState.createdCategory = action.category;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_CATEGORY_SUCCESS);
          return nextState;

        case _ActionTypes2.default.POST_RESTAURANT_MENU_CATEGORY_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_CATEGORY_ERROR);
          return nextState;

        //
        // UPSELLING_CATEGORY - UPDATED
        //

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS:
          nextState.restaurantMenu.updateUpsellingCategory(action.upsellingCategory);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR);
          return nextState;

        //
        // UPSELLING_CATEGORY - DELETED
        //

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS:
          nextState.restaurantMenu.deleteUpsellingCategory(action.upsellingCategory);
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_DELETE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR);
          return nextState;

        //
        // UPSELLING_CATEGORY - CREATED
        //

        case _ActionTypes2.default.POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_SUCCESS:
          nextState.restaurantMenu.addUpsellingCategory(action.upsellingCategory);
          nextState.createdUpsellingCategory = action.upsellingCategory;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS);
          return nextState;

        case _ActionTypes2.default.POST_RESTAURANT_MENU_UPSELLING_CATEGORY_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.ON_CREATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return RestaurantMenuStore;
}(_ReduceStore3.default);

var _default = new RestaurantMenuStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantMenuStore, 'RestaurantMenuStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RestaurantMenuStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RestaurantMenuStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/RestaurantStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _2 = __webpack_require__("./scripts/stores/index.js");

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _OrderSettingsStore = __webpack_require__("./scripts/stores/OrderSettingsStore.js");

var _OrderSettingsStore2 = _interopRequireDefault(_OrderSettingsStore);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


function updateRestaurantsGroups(nextState, restaurantsGroupToUpdate) {
  nextState.restaurantsGroup.updateRestaurantsGroups(restaurantsGroupToUpdate);
  nextState.selectedRestaurantsGroup.updateRestaurantsGroups(restaurantsGroupToUpdate);

  return nextState;
}

/**
 * Handle the current selected restaurant and it's associate restaurant group.
 */

var RestaurantStore = function (_ReduceStore) {
  _inherits(RestaurantStore, _ReduceStore);

  function RestaurantStore() {
    _classCallCheck(this, RestaurantStore);

    return _possibleConstructorReturn(this, (RestaurantStore.__proto__ || Object.getPrototypeOf(RestaurantStore)).apply(this, arguments));
  }

  _createClass(RestaurantStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        /**
        * @type Restaurant
        */
        restaurant: null,

        /**
        * @type Restaurant
        */
        createdRestaurant: null,

        /**
        * @type ApiError
        */
        apiError: null,

        /**
        * @type RestaurantsGroup
        */
        restaurantsGroup: null,

        /**
        * @type RestaurantsGroup
        */
        selectedRestaurantsGroup: null,

        /**
        * @type RestaurantsGroup
        */
        updatedRestaurantsGroup: null,

        /**
        * @type ProRolesList
        */
        rolesList: null,

        /**
        * @type RestaurantsGroup
        */
        newRestaurantsGroup: null
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        restaurant: new _entities.Restaurant(),
        createdRestaurant: new _entities.Restaurant(),
        restaurantsGroup: new _restaurantsGroup.RestaurantsGroup(),
        selectedRestaurantsGroup: new _restaurantsGroup.RestaurantsGroup(),
        updatedRestaurantsGroup: new _restaurantsGroup.RestaurantsGroup(),
        rolesList: new _security.ProRolesList(),
        newRestaurantsGroup: new _restaurantsGroup.RestaurantsGroup()
      };
    }
  }, {
    key: 'resetState',
    value: function resetState(nextState) {
      nextState.restaurant = null;
      nextState.createdRestaurant = null;
      nextState.apiError = null;
      // nextState.restaurantsGroup = null;
      nextState.selectedRestaurantsGroup = null;
      nextState.updatedRestaurantsGroup = null;
      // nextState.rolesList = null;
      nextState.newRestaurantsGroup = null;

      return nextState;
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getRestaurant',
    value: function getRestaurant() {
      return this._state.restaurant;
    }
  }, {
    key: 'getCreatedRestaurant',
    value: function getCreatedRestaurant() {
      return this._state.createdRestaurant;
    }
  }, {
    key: 'getUpdatedRestaurantsGroup',
    value: function getUpdatedRestaurantsGroup() {
      return this._state.updatedRestaurantsGroup;
    }
  }, {
    key: 'getRestaurantId',
    value: function getRestaurantId() {
      if (!_lodash2.default.isNull(this._state.restaurant)) {
        return this._state.restaurant.id;
      }

      return null;
    }

    /**
     * Save the parent restaurantsGroup.
     * If there is no selected restaurant group, we set by default the saved RestaurantsGroup id on
     * session, otherwise,we use the parent.
     */

  }, {
    key: 'setRestaurantsGroup',
    value: function setRestaurantsGroup(nextState, restaurantsGroup) {
      nextState.restaurantsGroup = restaurantsGroup;

      // set default _selectedRestaurantsGroup
      if (_lodash2.default.isNull(nextState.selectedRestaurantsGroup)) {
        nextState.selectedRestaurantsGroup = nextState.restaurantsGroup.findWithId(_2.SessionStore.getRestaurantsGroupId());

        // there is no selected restaurant group before, or its not found, we set the firt
        // restaurants group.
        if (_lodash2.default.isNull(nextState.selectedRestaurantsGroup)) {
          nextState.selectedRestaurantsGroup = nextState.restaurantsGroup;
        }
      }

      return nextState;
    }
  }, {
    key: 'getRestaurantsGroup',
    value: function getRestaurantsGroup() {
      return this._state.restaurantsGroup;
    }
  }, {
    key: 'getSelectedRestaurantsGroup',
    value: function getSelectedRestaurantsGroup() {
      return this._state.selectedRestaurantsGroup;
    }
  }, {
    key: 'getRolesList',
    value: function getRolesList() {
      return this._state.rolesList;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        /**
         * On logout we reset our store objects.
         */
        case _ActionTypes2.default.LOGOUT:
          return this.resetState(nextState);

        case _ActionTypes2.default.PRO_ACCOUNT_GET_ME_SUCCESS:
          this.waitFor([_OrderSettingsStore2.default.getDispatchToken()]);
          nextState.restaurant = action.restaurant;
          _2.SessionStore.saveRestaurantId(nextState.restaurant.id);
          _2.SessionStore.saveRestaurantsGroupId(action.proAccount.restaurantsGroup.id);
          return this.setRestaurantsGroup(nextState, action.proAccount.restaurantsGroup);

        case _ActionTypes2.default.GET_RESTAURANT_SUCCESS:
          this.waitFor([_OrderSettingsStore2.default.getDispatchToken()]);
          nextState.restaurant = action.restaurant;

          this.emitEvent(_Events2.default.LOAD_RESTAURANT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS:
          nextState.restaurant = action.restaurant;

          this.emitEvent(_Events2.default.UPDATE_RESTAURANT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_RESTAURANT_MULTIPART_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.UPDATE_RESTAURANT_FAILURE);
          return nextState;

        case _ActionTypes2.default.GET_RESTAURANT_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.LOAD_RESTAURANT_FAILURE);
          this.emitEvent(_Events2.default.END_LOADING);
          return nextState;

        case _ActionTypes2.default.POST_RESTAURANT_RESPONSE_SUCCESS:
          nextState.createdRestaurant = action.restaurant;
          nextState.restaurantsGroup = action.restaurantsGroup;

          nextState.apiError = null;
          this.emitEvent(_Events2.default.CREATE_RESTAURANT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.POST_RESTAURANT_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.CREATE_RESTAURANT_FAILURE);
          return nextState;

        //
        // RestaurantsGroup - GET
        //

        case _ActionTypes2.default.GET_RESTAURANTS_GROUP_SUCCESS:
          nextState.apiError = null;
          this.emitEvent(_Events2.default.LOAD_RESTAURANTS_GROUP_SUCCESS);
          return this.setRestaurantsGroup(nextState, action.restaurantsGroup);

        case _ActionTypes2.default.GET_RESTAURANTS_GROUP_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.LOAD_RESTAURANTS_GROUP_FAILURE);
          return nextState;

        //
        // RestaurantsGroup - POST
        //

        case _ActionTypes2.default.POST_RESTAURANTS_GROUP_SUCCESS:
          nextState.newRestaurantsGroup = action.restaurantsGroup;

          this.emitEvent(_Events2.default.CREATE_RESTAURANTS_GROUP_SUCCESS);
          return updateRestaurantsGroups(nextState, nextState.newRestaurantsGroup);

        case _ActionTypes2.default.POST_RESTAURANTS_GROUP_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.CREATE_RESTAURANTS_GROUP_FAILURE);
          return nextState;

        //
        // RestaurantsGroup - PUT
        //

        case _ActionTypes2.default.PUT_RESTAURANTS_GROUP_SUCCESS:
          nextState.updatedRestaurantsGroup = action.restaurantsGroup;

          this.emitEvent(_Events2.default.UPDATE_RESTAURANTS_GROUP_SUCCESS);
          return updateRestaurantsGroups(nextState, nextState.updatedRestaurantsGroup);

        case _ActionTypes2.default.PUT_RESTAURANTS_GROUP_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.UPDATE_RESTAURANTS_GROUP_FAILURE);
          return nextState;

        //
        // Choose current restaurant
        //

        /**
         * Send an event during the request for the Layout to be prepared for the changes.
         */
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          this.emitEvent(_Events2.default.RESTAURANT_CHANGE_REQUEST);
          return this.resetState(nextState);

        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_SUCCESS:
          nextState.selectedRestaurantsGroup = action.restaurantsGroup;
          nextState.restaurant = action.restaurant;

          _2.SessionStore.saveRestaurantsGroupId(action.restaurantsGroup.id);
          _2.SessionStore.saveRestaurantId(nextState.restaurant.id);

          nextState.apiError = null;

          // redirect to DASHBOARD, unless the restaurant is not configured.
          if (action.restaurant.features !== 0) {
            _2.RouteStore.redirectTo(_RoutingEnum2.default.DASHBOARD);
          } else {
            _2.RouteStore.redirectTo(_RoutingEnum2.default.RESTAURANT_EDIT);
          }

          this.emitEvent(_Events2.default.RESTAURANT_CHANGE_SUCCESS);
          this.emitEvent(_Events2.default.LOAD_RESTAURANT_SUCCESS);
          return nextState;

        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_FAILURE:
          nextState.apiError = action.apiError;
          // TODO
          return nextState;

        //
        // RestaurantGroupsRole - GET
        //

        case _ActionTypes2.default.GET_RESTAURANT_ROLES_SUCCESS:
          nextState.apiError = null;

          nextState.rolesList = action.proRolesList;

          this.emitEvent(_Events2.default.LOAD_RESTAURANT_ROLES_SUCCESS);
          return nextState;

        case _ActionTypes2.default.GET_RESTAURANT_ROLES_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_Events2.default.LOAD_RESTAURANT_ROLES_FAILURE);
          return nextState;

        //
        // ----------------- ROLES
        //

        //
        // Update
        //

        case _ActionTypes2.default.PUT_ROLE_RESPONSE_SUCCESS:
          nextState.rolesList.update(action.proRole);
          this.emitEvent(_Events2.default.UPDATE_ROLE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.PUT_ROLE_RESPONSE_FAILURE:
          // TODO
          this.emitEvent(_Events2.default.UPDATE_ROLE_FAILURE);
          return nextState;

        //
        // Create
        //

        case _ActionTypes2.default.POST_ROLE_RESPONSE_SUCCESS:
          if (_lodash2.default.isNull(nextState.rolesList)) {
            nextState.rolesList = new _security.ProRolesList();
          }
          nextState.rolesList.push(action.proRole);
          this.emitEvent(_Events2.default.CREATE_ROLE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.POST_ROLE_RESPONSE_FAILURE:
          // TODO
          this.emitEvent(_Events2.default.CREATE_ROLE_FAILURE);
          return nextState;

        //
        // Delete
        //

        case _ActionTypes2.default.DELETE_ROLE_RESPONSE_SUCCESS:
          nextState.rolesList.remove(action.proRole);
          this.emitEvent(_Events2.default.DELETE_ROLE_SUCCESS);
          return nextState;

        case _ActionTypes2.default.DELETE_ROLE_RESPONSE_FAILURE:
          // TODO
          this.emitEvent(_Events2.default.DELETE_ROLE_FAILURE);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return RestaurantStore;
}(_ReduceStore3.default);

var _default = new RestaurantStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(updateRestaurantsGroups, 'updateRestaurantsGroups', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RestaurantStore.js');

  __REACT_HOT_LOADER__.register(RestaurantStore, 'RestaurantStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RestaurantStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RestaurantStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/RouteStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _reactRouter = __webpack_require__("./node_modules/react-router/lib/index.js");

var _Route = __webpack_require__("./sdk/scripts/flux/Route.js");

var _Route2 = _interopRequireDefault(_Route);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _RouteAction = __webpack_require__("./scripts/actions/RouteAction.js");

var _RouteAction2 = _interopRequireDefault(_RouteAction);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RouteStore = function (_ReduceStore) {
  _inherits(RouteStore, _ReduceStore);

  function RouteStore() {
    _classCallCheck(this, RouteStore);

    return _possibleConstructorReturn(this, (RouteStore.__proto__ || Object.getPrototypeOf(RouteStore)).apply(this, arguments));
  }

  _createClass(RouteStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        queryParams: null
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {};
    }
  }, {
    key: 'redirectToHome',
    value: function redirectToHome() {
      _reactRouter.browserHistory.push('app');
    }
  }, {
    key: 'redirectTo',
    value: function redirectTo(route) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (_lodash2.default.isNull(params)) {
        _reactRouter.browserHistory.push({
          pathname: route.path,
          query: query
        });
      } else {
        _reactRouter.browserHistory.push({
          pathname: route.generatePathWithParams(params),
          query: query
        });
      }
    }
  }, {
    key: 'getNewQueryParams',
    value: function getNewQueryParams() {
      return this._state.queryParams;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _constants.ActionTypes.REDIRECT:
          this.redirectTo(action.route, action.params, action.query);
          return nextState;

        case _constants.ActionTypes.LOGOUT:
          setTimeout(function () {
            _RouteAction2.default.redirect(_RoutingEnum2.default.LOGIN);
          }, 2000);
          return nextState;

        case _constants.ActionTypes.QUERY_PARAMS_UPDATE:
          nextState.queryParams = action.queryParams;
          this.emitEvent(_constants.Events.ON_QUERY_PARAMS_UPDATE);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return RouteStore;
}(_ReduceStore3.default);

var _default = new RouteStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteStore, 'RouteStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RouteStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/RouteStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/SecurityStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entity


var SecurityStore = function (_ReduceStore) {
  _inherits(SecurityStore, _ReduceStore);

  function SecurityStore() {
    _classCallCheck(this, SecurityStore);

    return _possibleConstructorReturn(this, (SecurityStore.__proto__ || Object.getPrototypeOf(SecurityStore)).apply(this, arguments));
  }

  _createClass(SecurityStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        /**
         * @type ApiError
         */
        apiError: null,

        /**
         * @type ProRole
         */
        elevationProRole: null,

        /**
         * @type string
         */
        elevationCode: null
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        elevationProRole: new _security.ProRole()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getElevationProRole',
    value: function getElevationProRole() {
      return this._state.elevationProRole;
    }
  }, {
    key: 'getElevationCode',
    value: function getElevationCode() {
      return this._state.elevationCode;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _constants.ActionTypes.LOGOUT:
        case _constants.ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _constants.ActionTypes.PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS:
          nextState.elevationProRole = action.proRole;
          nextState.elevationCode = action.elevationCode;
          nextState.apiError = null;

          this.emitEvent(_constants.Events.ON_PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS);
          return nextState;

        case _constants.ActionTypes.PRO_ROLE_WITH_ELEVATION_CODE_FAILURE:
          nextState.apiError = action.apiError;
          this.emitEvent(_constants.Events.ON_PRO_ROLE_WITH_ELEVATION_CODE_FAILURE);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return SecurityStore;
}(_ReduceStore3.default);

var _default = new SecurityStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SecurityStore, 'SecurityStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/SecurityStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/SecurityStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/SessionStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _2 = __webpack_require__("./scripts/stores/index.js");

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _SessionUtils = __webpack_require__("./sdk/scripts/utils/SessionUtils.js");

var _SessionUtils2 = _interopRequireDefault(_SessionUtils);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

var _RoutingEnum = __webpack_require__("./scripts/constants/RoutingEnum.js");

var _RoutingEnum2 = _interopRequireDefault(_RoutingEnum);

var _constants = __webpack_require__("./scripts/constants/index.js");

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities


function getTimelapseAtItem(timelapseKey, timelapseSelectionKey) {
  var inFuture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var jsonObject = _SessionUtils2.default.getItemFromSession(timelapseKey);
  var timelapse = new _Timelapse2.default();
  var timelapseSelection = _SessionUtils2.default.getIntItemFromSession(timelapseSelectionKey, _constants.ViewConstants.Timelapse.Selection.CUSTOM);

  // if null, we create the default values.
  // Use TIMELAPSE_SELECTION to choose the default value.
  // .CUSTOM must be consider a to .MONTH for default date.
  // Note that the default TIMELAPSE_SELECTION is .CUSTOM.
  if (_lodash2.default.isNull(jsonObject) || _lodash2.default.isNull(jsonObject._fromTime) || _lodash2.default.isNull(jsonObject._toTime)) {
    if (_lodash2.default.isNull(jsonObject) || _lodash2.default.isUndefined(jsonObject)) {
      switch (timelapseSelection) {
        case _constants.ViewConstants.Timelapse.Selection.DAY:
          timelapse = _DateUtils2.default.getTimelapseDayInterval();
          break;
        case _constants.ViewConstants.Timelapse.Selection.WEEK:
          if (inFuture) {
            timelapse = _DateUtils2.default.getTimelapseWeekIntervalInFuture();
          } else {
            timelapse = _DateUtils2.default.getTimelapseWeekInterval();
          }
          break;
        case _constants.ViewConstants.Timelapse.Selection.MONTH:
        case _constants.ViewConstants.Timelapse.Selection.CUSTOM:
        default:
          if (inFuture) {
            timelapse = _DateUtils2.default.getTimelapseMonthIntervalInFuture();
          } else {
            timelapse = _DateUtils2.default.getTimelapseMonthInterval();
          }
      }
    }
  } else {
    // If exists, we use the timelapse selection to recreate the object with the good values.
    // If an user is not logout during more than one day, it will result false values without
    // that.
    switch (timelapseSelection) {
      case _constants.ViewConstants.Timelapse.Selection.DAY:
        timelapse = _DateUtils2.default.getTimelapseDayInterval();
        break;
      case _constants.ViewConstants.Timelapse.Selection.WEEK:
        if (inFuture) {
          timelapse = _DateUtils2.default.getTimelapseWeekIntervalInFuture();
        } else {
          timelapse = _DateUtils2.default.getTimelapseWeekInterval();
        }
        break;
      case _constants.ViewConstants.Timelapse.Selection.MONTH:
        if (inFuture) {
          timelapse = _DateUtils2.default.getTimelapseMonthIntervalInFuture();
        } else {
          timelapse = _DateUtils2.default.getTimelapseMonthInterval();
        }
        break;
      case _constants.ViewConstants.Timelapse.Selection.CUSTOM:
      default:
        timelapse.setFromTime(jsonObject._fromTime);
        timelapse.setToTime(jsonObject._toTime);
    }
  }

  return timelapse;
}

var SessionStore = function (_ReduceStore) {
  _inherits(SessionStore, _ReduceStore);

  function SessionStore() {
    _classCallCheck(this, SessionStore);

    return _possibleConstructorReturn(this, (SessionStore.__proto__ || Object.getPrototypeOf(SessionStore)).apply(this, arguments));
  }

  _createClass(SessionStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      var authorization = _SessionUtils2.default.getItemFromSession(_constants.Constants.SessionKey.AUTHORIZATION);

      return {
        /**
         * @type ApiError
         */
        apiError: null,

        /**
         * @type string
         */
        authorization: authorization
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default()
      };
    }
  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      var authorization = this.getAuthorization();
      return !_lodash2.default.isUndefined(authorization) && !_lodash2.default.isNull(authorization);
    }

    //
    // Me account
    //

  }, {
    key: 'saveMeAccount',
    value: function saveMeAccount(account) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.ACCOUNT, account);
    }

    // -- restaurant and session

  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'saveRestaurantId',
    value: function saveRestaurantId(restaurantId) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.RESTAURANT_ID, restaurantId);
    }
  }, {
    key: 'getRestaurantId',
    value: function getRestaurantId() {
      return _SessionUtils2.default.getItemFromSession(_constants.Constants.SessionKey.RESTAURANT_ID);
    }
  }, {
    key: 'saveRestaurantsGroupId',
    value: function saveRestaurantsGroupId(restaurantGroupsId) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.RESTAURANT_GROUPS_ID, restaurantGroupsId);
    }
  }, {
    key: 'getRestaurantsGroupId',
    value: function getRestaurantsGroupId() {
      return _SessionUtils2.default.getItemFromSession(_constants.Constants.SessionKey.RESTAURANT_GROUPS_ID);
    }
  }, {
    key: 'saveProDomainId',
    value: function saveProDomainId(proDomainId) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.PRO_DOMAIN_ID, proDomainId);
    }
  }, {
    key: 'getProDomainId',
    value: function getProDomainId() {
      return _SessionUtils2.default.getItemFromSession(_constants.Constants.SessionKey.PRO_DOMAIN_ID);
    }
  }, {
    key: 'saveAuthorization',
    value: function saveAuthorization(authorization) {
      _SessionUtils2.default.saveObjectToSession(_constants.Constants.SessionKey.AUTHORIZATION, authorization);

      this._state.authorization = authorization;
    }
  }, {
    key: 'getAuthorization',
    value: function getAuthorization() {
      if (_lodash2.default.isNull(this._state.authorization)) {
        this._state.authorization = _SessionUtils2.default.getItemFromSession(_constants.Constants.SessionKey.AUTHORIZATION);
      }
      return this._state.authorization;
    }

    // -- Bookings

    // -- booking book date to display

    /**
     * Return the date as milliseconds to display.
     * @returns Number
     */

  }, {
    key: 'getBookingBookDate',
    value: function getBookingBookDate() {
      var date = _SessionUtils2.default.getFloatItemFromSession(_constants.Constants.SessionKey.BOOKING_BOOK_DATE, _DateUtils2.default.getTodayTimestampAsMilliseconds());
      return date;
    }
  }, {
    key: 'saveBookingBookDate',
    value: function saveBookingBookDate(date) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.BOOKING_BOOK_DATE, date);
    }

    // -- timelapse

    /**
     *
     * @param selection ViewConstants.Timelapse.Selection
     */

  }, {
    key: 'saveTimelapseSelection',
    value: function saveTimelapseSelection(selection) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.TIMELAPSE_SELECTION, selection);
    }

    /**
     * Default: .CUSTOM
     * @return ViewConstants.Timelapse.Selection
     */

  }, {
    key: 'getTimelapseSelection',
    value: function getTimelapseSelection() {
      return _SessionUtils2.default.getIntItemFromSession(_constants.Constants.SessionKey.TIMELAPSE_SELECTION, _constants.ViewConstants.Timelapse.Selection.CUSTOM);
    }
  }, {
    key: 'saveTimelapse',
    value: function saveTimelapse(timelapse) {
      _SessionUtils2.default.saveItemToSession(_constants.Constants.SessionKey.TIMELAPSE, timelapse);
    }
  }, {
    key: 'getTimelapse',
    value: function getTimelapse() {
      return getTimelapseAtItem(_constants.Constants.SessionKey.TIMELAPSE, _constants.Constants.SessionKey.TIMELAPSE_SELECTION, false);
    }

    // -- tabs

  }, {
    key: 'saveEditRestaurantTab',
    value: function saveEditRestaurantTab(id) {
      _SessionUtils2.default.saveObjectToSession(_constants.Constants.SessionKey.EDIT_RESTAURANT_TAB, id);
    }
  }, {
    key: 'getEditRestaurantTab',
    value: function getEditRestaurantTab() {
      return _SessionUtils2.default.getIntItemFromSession(_constants.Constants.SessionKey.EDIT_RESTAURANT_TAB, 1);
    }
  }, {
    key: 'saveReceiptPageTab',
    value: function saveReceiptPageTab(id) {
      _SessionUtils2.default.saveObjectToSession(_constants.Constants.SessionKey.RECEIPT_PAGE_TAB, id);
    }
  }, {
    key: 'getReceiptPageTab',
    value: function getReceiptPageTab() {
      return _SessionUtils2.default.getIntItemFromSession(_constants.Constants.SessionKey.RECEIPT_PAGE_TAB, 1);
    }
  }, {
    key: 'saveBookingSettingsTab',
    value: function saveBookingSettingsTab(id) {
      _SessionUtils2.default.saveObjectToSession(_constants.Constants.SessionKey.BOOKING_SETTINGS_TAB, id);
    }
  }, {
    key: 'getBookingSettingsTab',
    value: function getBookingSettingsTab() {
      return _SessionUtils2.default.getIntItemFromSession(_constants.Constants.SessionKey.BOOKING_SETTINGS_TAB, 1);
    }
  }, {
    key: 'saveRestaurantMenuTab',
    value: function saveRestaurantMenuTab(id) {
      _SessionUtils2.default.saveObjectToSession(_constants.Constants.SessionKey.RESTAURANT_MENU_TAB, id);
    }
  }, {
    key: 'getRestaurantMenuTab',
    value: function getRestaurantMenuTab() {
      return _SessionUtils2.default.getIntItemFromSession(_constants.Constants.SessionKey.RESTAURANT_MENU_TAB, 1);
    }
  }, {
    key: 'saveLocale',
    value: function saveLocale(locale) {
      _SessionUtils2.default.saveObjectToSession(_constants.Constants.SessionKey.LOCALE, locale);
    }
  }, {
    key: 'getLocale',
    value: function getLocale() {
      return _SessionUtils2.default.getItemFromSession(_constants.Constants.SessionKey.LOCALE, 'fr');
    }
  }, {
    key: 'logout',
    value: function logout() {
      localStorage.removeItem(_constants.Constants.SessionKey.ACCOUNT);
      localStorage.removeItem(_constants.Constants.SessionKey.AUTHORIZATION);
      localStorage.removeItem(_constants.Constants.SessionKey.RESTAURANT_ID);
      localStorage.removeItem(_constants.Constants.SessionKey.RESTAURANT_GROUPS_ID);
      localStorage.removeItem(_constants.Constants.SessionKey.PRO_DOMAIN_ID);
      localStorage.removeItem(_constants.Constants.SessionKey.BOOKINGS);

      // if the user come back after 1 day, the timelapse is not good anymore.
      localStorage.removeItem(_constants.Constants.SessionKey.TIMELAPSE);

      // if the user come back after 1 day, the booking date is not good anymore.
      localStorage.removeItem(_constants.Constants.SessionKey.NEW_BOOKING_DATE);

      localStorage.removeItem(_constants.Constants.SessionKey.BOOKING_BOOK_DATE);
    }
  }, {
    key: 'reduce',
    value: function reduce(store, action, nextState) {
      switch (action.type) {

        // -- login

        case _constants.ActionTypes.LOGIN_RESPONSE_SUCCESS:

          this.saveAuthorization('Basic ' + btoa('pro_' + action.username + ':' + action.password));

          this.emitEvent(_constants.Events.ON_LOGIN_SUCCESS);
          return nextState;

        case _constants.ActionTypes.LOGIN_RESPONSE_FAILURE:
          if (action.apiError) {
            nextState.apiError = action.apiError;
          }
          this.emitEvent(_constants.Events.ON_LOGIN_ERROR);
          return nextState;

        //
        // logout
        //

        case _constants.ActionTypes.LOGOUT:
          nextState.authorization = null;
          /**
           * Remove Constants.SessionKey of the user.
           * !!! Warning: You should remove all the keys that are specific to the user.
           */
          this.logout();
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return SessionStore;
}(_ReduceStore3.default);

var _default = new SessionStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getTimelapseAtItem, 'getTimelapseAtItem', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/SessionStore.js');

  __REACT_HOT_LOADER__.register(SessionStore, 'SessionStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/SessionStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/SessionStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/UserStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduceStore2 = __webpack_require__("./sdk/scripts/flux/ReduceStore.js");

var _ReduceStore3 = _interopRequireDefault(_ReduceStore2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Events = __webpack_require__("./scripts/constants/Events.js");

var _Events2 = _interopRequireDefault(_Events);

var _ActionTypes = __webpack_require__("./scripts/constants/ActionTypes.js");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _User = __webpack_require__("./sdk/scripts/entities/user/User.js");

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constant


// -- entity


var UserStore = function (_ReduceStore) {
  _inherits(UserStore, _ReduceStore);

  function UserStore() {
    _classCallCheck(this, UserStore);

    return _possibleConstructorReturn(this, (UserStore.__proto__ || Object.getPrototypeOf(UserStore)).apply(this, arguments));
  }

  _createClass(UserStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        /**
         * @type ApiError
         */
        apiError: null,

        /**
         * @type User
         */
        user: null
      };
    }
  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return true;
    }
  }, {
    key: 'getStateObjectsMap',
    value: function getStateObjectsMap() {
      return {
        apiError: new _ApiError2.default(),
        user: new _User2.default()
      };
    }
  }, {
    key: 'getApiError',
    value: function getApiError() {
      return this._state.apiError;
    }
  }, {
    key: 'getUser',
    value: function getUser() {
      return this._state.user;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action, nextState) {
      switch (action.type) {

        case _ActionTypes2.default.LOGOUT:
        case _ActionTypes2.default.GET_RESTAURANT_FOR_GROUP_REQUEST:
          return this.getInitialState();

        case _ActionTypes2.default.GET_USER_RESPONSE_SUCCESS:
          nextState.user = action.user;
          nextState.apiError = null;

          this.emitEvent(_Events2.default.ON_LOADING_USER);
          return nextState;

        case _ActionTypes2.default.GET_USER_RESPONSE_FAILURE:
          nextState.apiError = action.apiError;

          this.emitEvent(_Events2.default.ON_LOADING_USER_ERROR);
          return nextState;

        default:
          return nextState;
      }
    }
  }]);

  return UserStore;
}(_ReduceStore3.default);

var _default = new UserStore();

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UserStore, 'UserStore', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/UserStore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/stores/UserStore.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/stores/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityStore = exports.RestaurantStore = exports.ProAccountStore = exports.UserStore = exports.SessionStore = exports.RouteStore = exports.RestaurantMenuStore = exports.PaymentStore = exports.PaymentStatStore = exports.PaymentReceiptStore = exports.OrderStatisticsStore = exports.OrdersListStore = exports.OrderSettingsStore = exports.KioskSettingsStore = exports.DashboardStore = exports.ApiConsumersStore = undefined;

var _ApiConsumersStore2 = __webpack_require__("./scripts/stores/ApiConsumersStore.js");

var _ApiConsumersStore3 = _interopRequireDefault(_ApiConsumersStore2);

var _DashboardStore2 = __webpack_require__("./scripts/stores/DashboardStore.js");

var _DashboardStore3 = _interopRequireDefault(_DashboardStore2);

var _KioskSettingsStore2 = __webpack_require__("./scripts/stores/KioskSettingsStore.js");

var _KioskSettingsStore3 = _interopRequireDefault(_KioskSettingsStore2);

var _OrderSettingsStore2 = __webpack_require__("./scripts/stores/OrderSettingsStore.js");

var _OrderSettingsStore3 = _interopRequireDefault(_OrderSettingsStore2);

var _OrdersListStore2 = __webpack_require__("./scripts/stores/OrdersListStore.js");

var _OrdersListStore3 = _interopRequireDefault(_OrdersListStore2);

var _OrderStatisticsStore2 = __webpack_require__("./scripts/stores/OrderStatisticsStore.js");

var _OrderStatisticsStore3 = _interopRequireDefault(_OrderStatisticsStore2);

var _PaymentReceiptStore2 = __webpack_require__("./scripts/stores/PaymentReceiptStore.js");

var _PaymentReceiptStore3 = _interopRequireDefault(_PaymentReceiptStore2);

var _PaymentStatStore2 = __webpack_require__("./scripts/stores/PaymentStatStore.js");

var _PaymentStatStore3 = _interopRequireDefault(_PaymentStatStore2);

var _PaymentStore2 = __webpack_require__("./scripts/stores/PaymentStore.js");

var _PaymentStore3 = _interopRequireDefault(_PaymentStore2);

var _RestaurantMenuStore2 = __webpack_require__("./scripts/stores/RestaurantMenuStore.js");

var _RestaurantMenuStore3 = _interopRequireDefault(_RestaurantMenuStore2);

var _RouteStore2 = __webpack_require__("./scripts/stores/RouteStore.js");

var _RouteStore3 = _interopRequireDefault(_RouteStore2);

var _SessionStore2 = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore3 = _interopRequireDefault(_SessionStore2);

var _UserStore2 = __webpack_require__("./scripts/stores/UserStore.js");

var _UserStore3 = _interopRequireDefault(_UserStore2);

var _ProAccountStore2 = __webpack_require__("./scripts/stores/ProAccountStore.js");

var _ProAccountStore3 = _interopRequireDefault(_ProAccountStore2);

var _RestaurantStore2 = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore3 = _interopRequireDefault(_RestaurantStore2);

var _SecurityStore2 = __webpack_require__("./scripts/stores/SecurityStore.js");

var _SecurityStore3 = _interopRequireDefault(_SecurityStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ApiConsumersStore = _ApiConsumersStore3.default;
exports.DashboardStore = _DashboardStore3.default;
exports.KioskSettingsStore = _KioskSettingsStore3.default;
exports.OrderSettingsStore = _OrderSettingsStore3.default;
exports.OrdersListStore = _OrdersListStore3.default;
exports.OrderStatisticsStore = _OrderStatisticsStore3.default;
exports.PaymentReceiptStore = _PaymentReceiptStore3.default;
exports.PaymentStatStore = _PaymentStatStore3.default;
exports.PaymentStore = _PaymentStore3.default;
exports.RestaurantMenuStore = _RestaurantMenuStore3.default;
exports.RouteStore = _RouteStore3.default;
exports.SessionStore = _SessionStore3.default;
exports.UserStore = _UserStore3.default;
exports.ProAccountStore = _ProAccountStore3.default;
exports.RestaurantStore = _RestaurantStore3.default;
exports.SecurityStore = _SecurityStore3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/utils/ColorPickerViewUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ViewConstants = __webpack_require__("./scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ColorPickerViewUtils = function () {
  function ColorPickerViewUtils() {
    _classCallCheck(this, ColorPickerViewUtils);
  }

  _createClass(ColorPickerViewUtils, null, [{
    key: 'getDefaultColorListUint',


    // --

    value: function getDefaultColorListUint() {
      var hexList = _ViewConstants2.default.ColorPicker.DEFAULT_COLORS_LIST;
      var uintList = [];

      _lodash2.default.each(hexList, function (hexValue) {
        uintList.push(_ViewUtils2.default.hexadecimalColorToUint(hexValue));
      });

      return uintList;
    }
  }]);

  return ColorPickerViewUtils;
}();

exports.default = ColorPickerViewUtils;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ColorPickerViewUtils, 'ColorPickerViewUtils', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/ColorPickerViewUtils.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/GoogleMapUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Config = __webpack_require__("./scripts/constants/Config.js");

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleMapUtils = {

  getApiUrlWithVersion: function getApiUrlWithVersion() {
    return _Config2.default.Google.Map.API_URL + '?key=' + _Config2.default.Google.Map.API_KEY + '&v=' + _Config2.default.Google.Map.API_VERSION;
  }
};

var _default = GoogleMapUtils;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GoogleMapUtils, 'GoogleMapUtils', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/GoogleMapUtils.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/GoogleMapUtils.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/MobileAppInteractor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// @global EpsonBridge

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _EsponPrinter = __webpack_require__("./scripts/utils/printers/EsponPrinter.js");

var _EsponPrinter2 = _interopRequireDefault(_EsponPrinter);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class allow us to interact with the BO mobile app. Those mobile app allow us to use
 * native functions by using an interface defined on the mobile app.
 */
var MobileAppInteractor = function () {
  function MobileAppInteractor() {
    _classCallCheck(this, MobileAppInteractor);
  }

  _createClass(MobileAppInteractor, null, [{
    key: 'haveEpsonBridge',
    value: function haveEpsonBridge() {
      return typeof EpsonBridge !== 'undefined';
    }
  }, {
    key: 'printerIsAvailable',
    value: function printerIsAvailable() {
      if (!this.haveEpsonBridge()) {
        return false;
      }
      return EpsonBridge.isPrinterConnected();
    }
  }, {
    key: 'print',
    value: function print(content) {
      if (this.haveEpsonBridge()) {
        EpsonBridge.print(content);
      }
    }
  }, {
    key: 'printOrder',
    value: function printOrder(order, restaurant) {
      // if (!this.haveEpsonBridge()) {
      //   return ;
      // }

      var epsonPrinter = new _EsponPrinter2.default();
      var message = epsonPrinter.formatOrderTicket(order, restaurant);

      this.print(message);

      return message;
    }
  }]);

  return MobileAppInteractor;
}();

var _default = MobileAppInteractor;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MobileAppInteractor, 'MobileAppInteractor', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/MobileAppInteractor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/MobileAppInteractor.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/NotificationUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Constants = __webpack_require__("./scripts/constants/Constants.js");

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isInit = false;

var _mobileAutoEnable = true;

/**
 * On mobile we have to trick in order to allow us to play songs without direct user interaction.
 * _mobileEnabled allow us to know if the trick have been successfull.
 */
var _mobileEnabled = false;

var _ctx = null;

var NotificationUtils = function () {
  function NotificationUtils() {
    _classCallCheck(this, NotificationUtils);
  }

  _createClass(NotificationUtils, null, [{
    key: 'initSounds',


    /**
     * See http://ionden.com/a/plugins/ion.sound/en.html
     */
    value: function initSounds() {
      if (isInit === true) {
        return;
      }

      console.info('init sounds');

      ion.sound({
        sounds: [{
          name: _Constants2.default.Notification.AudioFile.ORDER_NEW,
          volume: 1,
          preload: false
        }],
        volume: 1,
        path: '/sounds/',
        preload: true,
        multiplay: false,
        loop: 100
      });
      isInit = true;
    }

    /**
     * Work in progress.
     *
     *
     * Inspired by howler library.
     * By default, audio on iOS, Android, etc is locked until a sound is played within a user interaction, and then it plays normally the rest of the page session (Apple documentation: ). The default behavior of howler.js is to attempt to silently unlock audio playback by playing an empty buffer on the first touchend event.
     * See https://github.com/goldfire/howler.js/blob/cdcb68faff2f4187239ebc203efa7cb6c94087f5/dist/howler.js#L261
     *
     * https://developer.apple.com/library/safari/documentation/audiovideo/conceptual/using_html5_audio_video/PlayingandSynthesizingSounds/PlayingandSynthesizingSounds.html
     *
     * https://developer.apple.com/library/content/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
     *
     */

  }, {
    key: 'autoEnableOnMobile',
    value: function autoEnableOnMobile() {
      console.log('AudioMobile');

      if (!_mobileAutoEnable) {
        console.log('AudioMobile, not auto enable');
        return;
      }

      /**
       * Call this method on touch start to create and play a buffer,
       * then check if the audio actually played to determine if
       * audio has now been unlocked on iOS, Android, etc.
       */
      var unlock = function unlock() {
        if (!_mobileAutoEnable) {
          console.log('AudioMobile, not auto enable');
          return;
        }

        console.log('AudioMobile touch end');

        // see http://stackoverflow.com/questions/24119684/web-audio-api-memory-leaks-on-mobile-platforms

        // If we don't have an AudioContext created yet, run the setup.
        if (!_ctx) {
          NotificationUtils.setupAudioContext();
        }

        // Create an empty buffer.
        var source = _ctx.createBufferSource();
        source.buffer = _ctx.createBuffer(1, 1, 22050);
        source.connect(_ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          console.log('AudioMobile  source start undefined');
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function () {
          console.log('AudioMobile onended');

          source.disconnect(0);

          // Prevent this check from happening again.
          _mobileAutoEnable = false;

          // Set to true to notify that our trick worked.
          _mobileEnabled = true;

          console.log('AudioMobile enabled');

          // Remove the touch start listener.
          document.removeEventListener('touchend', unlock, true);
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchend', unlock, true);
    }
  }, {
    key: 'setupAudioContext',
    value: function setupAudioContext() {
      var usingWebAudio = true;

      // Check if we are using Web Audio and setup the AudioContext if we are.
      try {
        if (typeof AudioContext !== 'undefined') {
          console.log('AudioMobile AudioContext');
          _ctx = new AudioContext();
        } else if (typeof webkitAudioContext !== 'undefined') {
          console.log('AudioMobile webkitAudioContext');
          _ctx = new webkitAudioContext();
        } else {
          usingWebAudio = false;
        }
      } catch (e) {
        usingWebAudio = false;
      }

      // No audio is available on this system
      if (!usingWebAudio) {
        console.warn('AudioMobile No audio available on this system');
      }
    }
  }, {
    key: 'getFileForNotification',
    value: function getFileForNotification(notification) {
      switch (notification) {
        case _Constants2.default.Notification.ORDER_NEW:
          return _Constants2.default.Notification.AudioFile.ORDER_NEW;
        default:
          return _Constants2.default.Notification.AudioFile.ORDER_NEW;
      }
    }
  }, {
    key: 'hasIon',
    value: function hasIon() {
      return !_lodash2.default.isNil(ion) && !_lodash2.default.isNil(ion.sound);
    }
  }, {
    key: 'notify',
    value: function notify(notification) {
      NotificationUtils.initSounds();

      if (NotificationUtils.hasIon()) {
        ion.sound.play(NotificationUtils.getFileForNotification(notification));
      } else {
        console.warn('no ion found, can\'t play notification');
      }
    }
  }, {
    key: 'stopNotification',
    value: function stopNotification(notification) {
      if (NotificationUtils.hasIon()) {
        ion.sound.stop(NotificationUtils.getFileForNotification(notification));
      } else {
        console.warn('no ion found, can\'t play notification');
      }
    }
  }, {
    key: 'notifyNewOrder',
    value: function notifyNewOrder() {
      NotificationUtils.notify(_Constants2.default.Notification.ORDER_NEW);
    }
  }, {
    key: 'stopNotifyNewOrder',
    value: function stopNotifyNewOrder() {
      NotificationUtils.stopNotification(_Constants2.default.Notification.ORDER_NEW);
    }
  }]);

  return NotificationUtils;
}();

exports.default = NotificationUtils;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isInit, 'isInit', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/NotificationUtils.js');

  __REACT_HOT_LOADER__.register(_mobileAutoEnable, '_mobileAutoEnable', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/NotificationUtils.js');

  __REACT_HOT_LOADER__.register(_mobileEnabled, '_mobileEnabled', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/NotificationUtils.js');

  __REACT_HOT_LOADER__.register(_ctx, '_ctx', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/NotificationUtils.js');

  __REACT_HOT_LOADER__.register(NotificationUtils, 'NotificationUtils', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/NotificationUtils.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityContext = exports.PermissionsListing = exports.NotificationUtils = exports.ColorPickerViewUtils = undefined;

var _ColorPickerViewUtils2 = __webpack_require__("./scripts/utils/ColorPickerViewUtils.js");

var _ColorPickerViewUtils3 = _interopRequireDefault(_ColorPickerViewUtils2);

var _NotificationUtils2 = __webpack_require__("./scripts/utils/NotificationUtils.js");

var _NotificationUtils3 = _interopRequireDefault(_NotificationUtils2);

var _PermissionsListing2 = __webpack_require__("./scripts/utils/permissions/PermissionsListing.js");

var _PermissionsListing3 = _interopRequireDefault(_PermissionsListing2);

var _SecurityContext2 = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext3 = _interopRequireDefault(_SecurityContext2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ColorPickerViewUtils = _ColorPickerViewUtils3.default;
exports.NotificationUtils = _NotificationUtils3.default;
exports.PermissionsListing = _PermissionsListing3.default;
exports.SecurityContext = _SecurityContext3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/utils/permissions/AdminPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminPermissions = function () {
  function AdminPermissions() {
    _classCallCheck(this, AdminPermissions);
  }

  _createClass(AdminPermissions, [{
    key: 'isAdmin',
    value: function isAdmin() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('admin', proRole);
    }
  }]);

  return AdminPermissions;
}();

exports.default = AdminPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AdminPermissions, 'AdminPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/AdminPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/BookingPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BookingPermissions = function () {
  function BookingPermissions() {
    _classCallCheck(this, BookingPermissions);
  }

  _createClass(BookingPermissions, [{
    key: 'canReadBook',
    value: function canReadBook() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book', proRole);
    }
  }, {
    key: 'canCreateBooking',
    value: function canCreateBooking() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canCreateBooking', proRole);
    }
  }, {
    key: 'canCreateBookingOverLimit',
    value: function canCreateBookingOverLimit() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canCreateBookingOverLimit', proRole);
    }
  }, {
    key: 'canEditBooking',
    value: function canEditBooking() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canEditBooking', proRole);
    }
  }, {
    key: 'canConfirmWaitingBooking',
    value: function canConfirmWaitingBooking() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canConfirmWaitingBooking', proRole);
    }
  }, {
    key: 'canCancelBooking',
    value: function canCancelBooking() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canCancelBooking', proRole);
    }
  }, {
    key: 'canFinalizeBooking',
    value: function canFinalizeBooking() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canFinalizeBooking', proRole);
    }
  }, {
    key: 'canMarkBookingAsSeen',
    value: function canMarkBookingAsSeen() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canMarkBookingAsSeen', proRole);
    }
  }, {
    key: 'canEditPeriodStateForDay',
    value: function canEditPeriodStateForDay() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.book.canEditPeriodStateForDay', proRole);
    }
  }, {
    key: 'canReadBookingSettings',
    value: function canReadBookingSettings() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.settings', proRole);
    }
  }, {
    key: 'canEditBookingSettings',
    value: function canEditBookingSettings() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('booking.settings.canEditSettings', proRole);
    }
  }]);

  return BookingPermissions;
}();

exports.default = BookingPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BookingPermissions, 'BookingPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/BookingPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/CartModifiersPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartModifiersPermissions = function () {
  function CartModifiersPermissions() {
    _classCallCheck(this, CartModifiersPermissions);
  }

  _createClass(CartModifiersPermissions, [{
    key: 'canRead',
    value: function canRead() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantMenu.cartModifiers', proRole);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantMenu.cartModifiers.canEdit', proRole);
    }
  }]);

  return CartModifiersPermissions;
}();

exports.default = CartModifiersPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CartModifiersPermissions, 'CartModifiersPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/CartModifiersPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/ExportPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExportPermissions = function () {
  function ExportPermissions() {
    _classCallCheck(this, ExportPermissions);
  }

  _createClass(ExportPermissions, [{
    key: 'canExport',
    value: function canExport() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('export.canExport', proRole);
    }
  }]);

  return ExportPermissions;
}();

exports.default = ExportPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExportPermissions, 'ExportPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/ExportPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/OrderSettingsPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSettingsPermissions = function () {
  function OrderSettingsPermissions() {
    _classCallCheck(this, OrderSettingsPermissions);
  }

  _createClass(OrderSettingsPermissions, [{
    key: 'canRead',
    value: function canRead() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('order.settings', proRole);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('order.settings.canEditSettings', proRole);
    }
  }, {
    key: 'canEditMenuManagedByPos',
    value: function canEditMenuManagedByPos() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('order.settings.canEditMenuManagedByPos', proRole);
    }
  }]);

  return OrderSettingsPermissions;
}();

exports.default = OrderSettingsPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrderSettingsPermissions, 'OrderSettingsPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/OrderSettingsPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/PermissionsListing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PermissionsListing = {

  //
  // Booking
  //

  booking: {
    book: {
      label: 'book',
      permissions: {
        canCreateBooking: { label: 'canCreateBooking' },
        canCreateBookingOverLimit: { label: 'canCreateBookingOverLimit' },
        canEditBooking: { label: 'canEditBooking' },
        canConfirmWaitingBooking: { label: 'canConfirmWaitingBooking' },
        canCancelBooking: { label: 'canCancelBooking' },
        canFinalizeBooking: { label: 'canFinalizeBooking' },
        canMarkBookingAsSeen: { label: 'canMarkBookingAsSeen' },
        canEditPeriodStateForDay: { label: 'canEditPeriodStateForDay' }
      }
    },
    settings: {
      label: 'settings',
      permissions: {
        canEditSettings: { label: 'canEditSettings' }
      }
    }
  },

  //
  // Pro account
  //

  proAccount: {
    self: {
      label: 'self',
      permissions: {
        canEditAccount: { label: 'canEditAccount' }
      }
    },
    role: {
      label: 'role',
      permissions: {
        canCreateRole: { label: 'canCreateRole' }
      }
    },
    domain: {
      label: 'domain',
      permissions: {
        canCreateDomain: { label: 'canCreateDomain' }
      }
    },
    restaurantsGroup: {
      label: 'restaurantsGroup',
      permissions: {
        canCreateRestaurantsGroup: { label: 'canCreateRestaurantsGroup' }
      }
    },
    restaurant: {
      label: 'restaurant',
      permissions: {
        canCreateRestaurant: { label: 'canCreateRestaurant' }
      }
    }

  },

  //
  // RestaurantMenu
  //

  restaurantMenu: {
    settings: {
      label: 'settings',
      permissions: {
        canEditSettings: { label: 'canEditSettings' }
      }
    }
  },

  //
  // Order
  //

  order: {
    settings: {
      label: 'settings',
      permissions: {
        canEditSettings: { label: 'canEditSettings' }
      }
    }
  },

  //
  // RestaurantSettings
  //

  restaurantSettings: {
    publicInfo: {
      label: 'publicInfo',
      permissions: {
        canEdit: { label: 'canEdit' }
      }
    },
    menu: {
      label: 'menu',
      permissions: {
        canEdit: { label: 'canEdit' }
      }
    },
    openingHours: {
      label: 'openingHours',
      permissions: {
        canEdit: { label: 'canEdit' }
      }
    },
    legal: {
      label: 'legal',
      permissions: {
        restaurateur: {
          label: 'restaurateur',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        },
        society: {
          label: 'society',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        },
        representative: {
          label: 'representative',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        }
      }
    },
    finance: {
      label: 'finance',
      permissions: {
        bankAccount: {
          label: 'bankAccount',
          permissions: {
            canEdit: { label: 'canEdit' },
            canCreate: { label: 'canCreate' }
          }
        },
        other: {
          label: 'other',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        }
      }
    },
    features: {
      label: 'features',
      permissions: {
        canEdit: { label: 'canEdit' }
      }
    },
    configuration: {
      label: 'configuration',
      permissions: {
        general: {
          label: 'general',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        },
        pos: {
          label: 'pos',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        },
        mangoPay: {
          label: 'mangoPay',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        },
        commission: {
          label: 'commission',
          permissions: {
            canEdit: { label: 'canEdit' }
          }
        }
      }
    },
    theme: {
      label: 'theme',
      permissions: {
        canEdit: { label: 'canEdit' }
      }
    }
  }
};

var _default = PermissionsListing;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PermissionsListing, 'PermissionsListing', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/PermissionsListing.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/PermissionsListing.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/ProAccountPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProAccountPermissions = function () {
  function ProAccountPermissions() {
    _classCallCheck(this, ProAccountPermissions);
  }

  _createClass(ProAccountPermissions, [{
    key: 'canCreateRestaurant',
    value: function canCreateRestaurant() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.restaurant.canCreateRestaurant', proRole);
    }
  }, {
    key: 'canArchiveRestaurant',
    value: function canArchiveRestaurant() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.restaurant.canDelete', proRole);
    }
  }, {
    key: 'canReadRole',
    value: function canReadRole() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.role', proRole);
    }
  }, {
    key: 'canEditRole',
    value: function canEditRole() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.role.canCreateRole', proRole);
    }
  }, {
    key: 'canDeleteRole',
    value: function canDeleteRole() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.role.canCreateRole', proRole);
    }
  }, {
    key: 'canCreateRole',
    value: function canCreateRole() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.role.canCreateRole', proRole);
    }
  }, {
    key: 'canEditSelfAccount',
    value: function canEditSelfAccount() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('proAccount.self.canEditAccount', proRole);
    }
  }]);

  return ProAccountPermissions;
}();

exports.default = ProAccountPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProAccountPermissions, 'ProAccountPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/ProAccountPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/RestaurantMenuPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

var _POSType = __webpack_require__("./sdk/scripts/constants/POSType.js");

var _POSType2 = _interopRequireDefault(_POSType);

var _RestaurantStore = __webpack_require__("./scripts/stores/RestaurantStore.js");

var _RestaurantStore2 = _interopRequireDefault(_RestaurantStore);

var _OrderSettingsStore = __webpack_require__("./scripts/stores/OrderSettingsStore.js");

var _OrderSettingsStore2 = _interopRequireDefault(_OrderSettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RestaurantMenuPermissions = function () {
  function RestaurantMenuPermissions() {
    _classCallCheck(this, RestaurantMenuPermissions);
  }

  _createClass(RestaurantMenuPermissions, [{
    key: 'canRead',
    value: function canRead() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantMenu.settings', proRole);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantMenu.settings.canEditSettings', proRole);
    }
  }, {
    key: 'canEditAvailabilityProducts',
    value: function canEditAvailabilityProducts() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantMenu.settings.canEditAvailabilityProducts', proRole);
    }
  }, {
    key: 'canEditOptions',
    value: function canEditOptions(proRole) {
      var canEdit = this.canEdit(proRole);
      var menuManagedByPos = _OrderSettingsStore2.default.getOrderSettings().menuManagedByPos;
      var pos = _RestaurantStore2.default.getRestaurant().pos;
      return canEdit && (!menuManagedByPos ||
      // csi does not handle options on its side, we allow create them from here
      pos === _POSType2.default.POS_CSI);
    }
  }]);

  return RestaurantMenuPermissions;
}();

exports.default = RestaurantMenuPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantMenuPermissions, 'RestaurantMenuPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/RestaurantMenuPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/RestaurantSettingsPermissions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SecurityContext = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext2 = _interopRequireDefault(_SecurityContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RestaurantSettingsPermissions = function () {
  function RestaurantSettingsPermissions() {
    _classCallCheck(this, RestaurantSettingsPermissions);
  }

  _createClass(RestaurantSettingsPermissions, [{
    key: 'read',
    value: function read() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings', proRole);
    }
  }, {
    key: 'readPublicInfo',
    value: function readPublicInfo() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.publicInfo', proRole);
    }
  }, {
    key: 'editPublicInfo',
    value: function editPublicInfo() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.publicInfo.canEdit', proRole);
    }
  }, {
    key: 'readMenu',
    value: function readMenu() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.menu', proRole);
    }
  }, {
    key: 'editMenu',
    value: function editMenu() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.menu.canEdit', proRole);
    }
  }, {
    key: 'readOpeningHours',
    value: function readOpeningHours() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.openingHours', proRole);
    }
  }, {
    key: 'editOpeningHours',
    value: function editOpeningHours() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.openingHours.canEdit', proRole);
    }
  }, {
    key: 'readLegal',
    value: function readLegal() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal', proRole);
    }
  }, {
    key: 'readLegalRestaurateur',
    value: function readLegalRestaurateur() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal.restaurateur', proRole);
    }
  }, {
    key: 'editLegalRestaurateur',
    value: function editLegalRestaurateur() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal.restaurateur.canEdit', proRole);
    }
  }, {
    key: 'readLegalSociety',
    value: function readLegalSociety() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal.society', proRole);
    }
  }, {
    key: 'editLegalSociety',
    value: function editLegalSociety() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal.society.canEdit', proRole);
    }
  }, {
    key: 'readLegalRepresentative',
    value: function readLegalRepresentative() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal.representative', proRole);
    }
  }, {
    key: 'editLegalRepresentative',
    value: function editLegalRepresentative() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.legal.representative.canEdit', proRole);
    }
  }, {
    key: 'readFinance',
    value: function readFinance() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.finance', proRole);
    }
  }, {
    key: 'readFinanceBankAccount',
    value: function readFinanceBankAccount() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.finance.bankAccount', proRole);
    }
  }, {
    key: 'editFinanceBankAccount',
    value: function editFinanceBankAccount() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.finance.bankAccount.canEdit', proRole);
    }

    /**
     * TODO: to implement
     */

  }, {
    key: 'createFinanceBankAccount',
    value: function createFinanceBankAccount() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return false;
      return _SecurityContext2.default.havePermission('restaurantSettings.finance.bankAccount.canCreate', proRole);
    }
  }, {
    key: 'readFinanceOther',
    value: function readFinanceOther() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.finance.other', proRole);
    }
  }, {
    key: 'editFinanceOther',
    value: function editFinanceOther() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.finance.other.canEdit', proRole);
    }
  }, {
    key: 'readFeatures',
    value: function readFeatures() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.features', proRole);
    }
  }, {
    key: 'editFeatures',
    value: function editFeatures() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.features.canEdit', proRole);
    }

    /**
     * TODO: handle sub permissions read all to false.
     */

  }, {
    key: 'readConfiguration',
    value: function readConfiguration() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration', proRole);
    }
  }, {
    key: 'readConfigurationGeneral',
    value: function readConfigurationGeneral() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.general', proRole);
    }
  }, {
    key: 'editConfigurationGeneral',
    value: function editConfigurationGeneral() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.general.canEdit', proRole);
    }
  }, {
    key: 'editConfigurationGeneralActivation',
    value: function editConfigurationGeneralActivation() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.general.canEditActivation', proRole);
    }
  }, {
    key: 'readConfigurationPos',
    value: function readConfigurationPos() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.pos', proRole);
    }
  }, {
    key: 'editConfigurationPos',
    value: function editConfigurationPos() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.pos.canEdit', proRole);
    }
  }, {
    key: 'readConfigurationMangoPay',
    value: function readConfigurationMangoPay() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.mangoPay', proRole);
    }

    /**
     * Didn't used for the moment.
     */

  }, {
    key: 'editConfigurationMangoPay',
    value: function editConfigurationMangoPay() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.mangoPay.canEdit', proRole);
    }
  }, {
    key: 'readConfigurationCommission',
    value: function readConfigurationCommission() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.commission', proRole);
    }
  }, {
    key: 'editConfigurationCommission',
    value: function editConfigurationCommission() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.configuration.commission.canEdit', proRole);
    }
  }, {
    key: 'readTheme',
    value: function readTheme() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.theme', proRole);
    }
  }, {
    key: 'editTheme',
    value: function editTheme() {
      var proRole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return _SecurityContext2.default.havePermission('restaurantSettings.theme.canEdit', proRole);
    }
  }]);

  return RestaurantSettingsPermissions;
}();

exports.default = RestaurantSettingsPermissions;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RestaurantSettingsPermissions, 'RestaurantSettingsPermissions', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/RestaurantSettingsPermissions.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/SecurityContext.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Note: those two import made the app crash. Why?
// So we save the account on the session and retrieve it.
// import RestaurantStore from 'stores/RestaurantStore';
// import ProAccountStore from '../stores/ProAccountStore';

// but this import works.. why?
// import SessionStore from 'stores/SessionStore';

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _2 = __webpack_require__("./scripts/utils/permissions/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecurityContext = function () {
  function SecurityContext() {
    _classCallCheck(this, SecurityContext);

    this.admin = new _2.AdminPermissions();
    this.proAccount = new _2.ProAccountPermissions();
    this.booking = new _2.BookingPermissions();
    this.restaurantMenu = new _2.RestaurantMenuPermissions();
    this.orderSettings = new _2.OrderSettingsPermissions();
    this.cartModifiers = new _2.CartModifiersPermissions();
    this.restaurantSettings = new _2.RestaurantSettingsPermissions();
    this.export = new _2.ExportPermissions();
  }

  //
  // Roles for proRoles
  //

  //
  // Roles for booking
  //

  //
  // Restaurant Menu
  //

  //
  // Order
  //

  //
  // Restaurant settings
  //

  _createClass(SecurityContext, [{
    key: 'canEscaladePermission',
    value: function canEscaladePermission(permission) {
      var allowed = [this.booking.canCancelBooking, this.booking.canCreateBookingOverLimit];

      var res = false;

      _lodash2.default.each(allowed, function (func) {
        if (func === permission) {
          res = true;
          return false; // quit loop
        }
      });

      return res;
    }

    /**
     * @param permission The permission to check. Example: 'booking.canEdit..'
     * @param proRole The permission will be checked for the given proRole. If null, we retrieve the
     * proRole set on the session.
     */

  }, {
    key: 'havePermission',
    value: function havePermission(permission) {
      var proRole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var role = null;

      if (_lodash2.default.isNull(proRole)) {
        /**
         * The role is attached to the account on ApiProAccount.getMeAccount()
         */
        var account = _utils.SessionUtils.getObjectFromSession('ACCOUNT');

        if (_lodash2.default.isNull(account)) {
          return false;
        }

        role = account.role;
      } else {
        role = proRole;
      }

      if (_lodash2.default.isNull(role) || _lodash2.default.isUndefined(role)) {
        return false;
      }

      try {
        var obj = permission.split('.').reduce(function (object, key) {
          return object[key];
        }, role.permissions);

        /**
         * The permission is ok if the object equals true or is an object that contains child
         * permissions.
         */
        return !_lodash2.default.isUndefined(obj) && !_lodash2.default.isNull(obj) && obj !== false;
      } catch (e) {
        // do nothing
      }

      return false;
    }
  }]);

  return SecurityContext;
}();

var securityContextInstance = new SecurityContext();

var _default = securityContextInstance;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SecurityContext, 'SecurityContext', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/SecurityContext.js');

  __REACT_HOT_LOADER__.register(securityContextInstance, 'securityContextInstance', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/SecurityContext.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/permissions/SecurityContext.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./scripts/utils/permissions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionsListing = exports.RestaurantSettingsPermissions = exports.RestaurantMenuPermissions = exports.CartModifiersPermissions = exports.ProAccountPermissions = exports.OrderSettingsPermissions = exports.ExportPermissions = exports.BookingPermissions = exports.AdminPermissions = exports.SecurityContext = undefined;

var _SecurityContext2 = __webpack_require__("./scripts/utils/permissions/SecurityContext.js");

var _SecurityContext3 = _interopRequireDefault(_SecurityContext2);

var _AdminPermissions2 = __webpack_require__("./scripts/utils/permissions/AdminPermissions.js");

var _AdminPermissions3 = _interopRequireDefault(_AdminPermissions2);

var _BookingPermissions2 = __webpack_require__("./scripts/utils/permissions/BookingPermissions.js");

var _BookingPermissions3 = _interopRequireDefault(_BookingPermissions2);

var _ExportPermissions2 = __webpack_require__("./scripts/utils/permissions/ExportPermissions.js");

var _ExportPermissions3 = _interopRequireDefault(_ExportPermissions2);

var _OrderSettingsPermissions2 = __webpack_require__("./scripts/utils/permissions/OrderSettingsPermissions.js");

var _OrderSettingsPermissions3 = _interopRequireDefault(_OrderSettingsPermissions2);

var _ProAccountPermissions2 = __webpack_require__("./scripts/utils/permissions/ProAccountPermissions.js");

var _ProAccountPermissions3 = _interopRequireDefault(_ProAccountPermissions2);

var _CartModifiersPermissions2 = __webpack_require__("./scripts/utils/permissions/CartModifiersPermissions.js");

var _CartModifiersPermissions3 = _interopRequireDefault(_CartModifiersPermissions2);

var _RestaurantMenuPermissions2 = __webpack_require__("./scripts/utils/permissions/RestaurantMenuPermissions.js");

var _RestaurantMenuPermissions3 = _interopRequireDefault(_RestaurantMenuPermissions2);

var _RestaurantSettingsPermissions2 = __webpack_require__("./scripts/utils/permissions/RestaurantSettingsPermissions.js");

var _RestaurantSettingsPermissions3 = _interopRequireDefault(_RestaurantSettingsPermissions2);

var _PermissionsListing2 = __webpack_require__("./scripts/utils/permissions/PermissionsListing.js");

var _PermissionsListing3 = _interopRequireDefault(_PermissionsListing2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SecurityContext = _SecurityContext3.default;
exports.AdminPermissions = _AdminPermissions3.default;
exports.BookingPermissions = _BookingPermissions3.default;
exports.ExportPermissions = _ExportPermissions3.default;
exports.OrderSettingsPermissions = _OrderSettingsPermissions3.default;
exports.ProAccountPermissions = _ProAccountPermissions3.default;
exports.CartModifiersPermissions = _CartModifiersPermissions3.default;
exports.RestaurantMenuPermissions = _RestaurantMenuPermissions3.default;
exports.RestaurantSettingsPermissions = _RestaurantSettingsPermissions3.default;
exports.PermissionsListing = _PermissionsListing3.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./scripts/utils/printers/EsponPrinter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PAPER_WIDTH = {
  PAPER_WIDTH_58MM: 0, // 58mm Reciept
  PAPER_WIDTH_80MM: 1 // 80mm Reciept
};

var WIDTH_58mm_FONT_B = 35;
var WIDTH_58mm_SUBTITLE = 25;
var WIDTH_80mm_FONT_B = 43;
var WIDTH_SMALL_TEXT = 53;

/**
 * Format the amount to display
 * @param	str	String	String to put a comma to separate thousands
 */
function formatPrice(amount) {
  return _CurrencyUtils2.default.formatPrice(amount);
}

/**
 * TODO: translations I18n
 * TODO: currency
 */

var EspsonPrinter = function () {
  function EspsonPrinter() {
    _classCallCheck(this, EspsonPrinter);

    this.order = null;
    this.restaurant = null;
    this.builder = new epson.ePOSBuilder();
    this.paperWidth = PAPER_WIDTH.PAPER_WIDTH_80MM;
    this.DEFAULT_LEFT_BORDER = 5;
    this.MARGIN_LEFT = 35;
    this.MARGIN_LEFT_SECOND_COL = 65;
  }

  _createClass(EspsonPrinter, [{
    key: 'formatOrderTicket',
    value: function formatOrderTicket(order, restaurant) {
      this.order = order;
      this.restaurant = restaurant;

      // Open drawer
      // TODO: ?
      // this.builder.addPulse(this.builder.DRAWER_1, this.builder.PULSE_100);

      // empty first line
      this.builder.addText('\n');

      this.renderHeader();

      this.renderMenus();

      this.renderProducts();

      this.renderFooter();

      this.builder.addFeedLine(3);
      this.builder.addCut(this.builder.CUT_FEED);

      var message = this.builder.toString();

      console.log(message);

      return message;
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      this.builder.addTextAlign(this.builder.ALIGN_CENTER);

      this.setSubtitle('PayMyTable\n', { bold: true });

      this.builder.addFeedLine(1);

      this.renderRestaurant();

      this.builder.addFeedLine(1);

      this.setTitle('Commande ' + this.order.getOrderNumber() + '\n', { bold: true });

      this.builder.addFeedLine(1);

      if (this.order.isPayed()) {
        if (this.order.userAccountPayment !== null) {
          this.setTitle('Payée (Compte)\n');
        } else {
          this.setTitle('Payée (CB)\n');
        }
      } else {
        this.setTitle('Non payée\n');
      }

      this.builder.addFeedLine(1);

      if (this.order.isDeliveryMode()) {
        this.setSubtitle(_utils.OrderViewUtils.getLabelForMode(this.order.mode) + '\n', {
          bold: true
        });
        this.builder.addFeedLine(1);
        this.renderOrderDueDate();
      } else if (this.order.isOnSiteMode()) {
        if (this.order.isOnBar()) {
          this.setSubtitle('Au bar\n'); // TODO: I18n
        } else {
          this.setSubtitle(_utils.OrderViewUtils.getLabelForMode(this.order.mode) + '\n', { bold: true });
        }
        this.builder.addFeedLine(1);
        this.renderOrderDueDate();
      } else if (this.order.isTakeAwayMode()) {
        this.setSubtitle(_utils.OrderViewUtils.getLabelForMode(this.order.mode) + '\n', {
          bold: true
        });
        this.builder.addFeedLine(1);
        this.renderOrderDueDate();
      }

      this.renderClientInfo();

      // -- global comment
      var globalComment = this.order.comment;
      if (!_lodash2.default.isEmpty(globalComment)) {
        this.builder.addText('\n');
        this.builder.addTextAlign(this.builder.ALIGN_LEFT);
        this.builder.addTextPosition(this.DEFAULT_LEFT_BORDER);
        this.setSubtitle('*** Commentaire g\xE9n\xE9ral :\n', { bold: true });
        this.setText(globalComment.toUpperCase() + '\n', { bold: true });
      }

      // this.builder.addFeedLine(1);
      //
      // this.builder.addTextAlign(this.builder.ALIGN_CENTER);
      // this.setSmallText(`${this.order.countItems()} produit(s)`);

      this.builder.addFeedLine(2);
    }
  }, {
    key: 'renderOrderDueDate',
    value: function renderOrderDueDate() {
      this.setSubtitle('Pour le ' + this.order.dueDate.format('DD/MM') + ' \xE0 ' + this.order.dueDate.format('HH:mm') + '\n');
    }
  }, {
    key: 'renderRestaurant',
    value: function renderRestaurant() {
      this.setText(this.restaurant.name.toUpperCase() + '\n');

      var address = this.restaurant.address;

      if (!_lodash2.default.isNil(address)) {
        var addressTxt = address.street + '\n' + address.postCode + ' ' + address.city + '\n';
        this.setSmallText(addressTxt);
      }

      if (!_lodash2.default.isEmpty(this.restaurant.legal.siren)) {
        this.setSmallText('SIRET: ' + this.restaurant.legal.siren + '\n');
      }
    }
  }, {
    key: 'renderClientInfo',
    value: function renderClientInfo() {
      var user = this.order.user;

      this.builder.addFeedLine(1);

      if (user) {
        var clientName = user.firstName + ' ' + user.lastName;
        this.setText('Client : ' + clientName.toUpperCase() + '\n');
        this.setText('Tel : ' + _utils.PhoneUtils.format(user.phone) + '\n');
      }

      if (this.order.isDeliveryMode()) {
        // address
        var address = this.order.address;
        if (!_lodash2.default.isNil(address)) {
          this.builder.addFeedLine(1);
          this.setText(address.street + '\n');
          this.setText(address.postCode + ' ' + address.city + '\n');

          if (!_lodash2.default.isEmpty(address.complement)) {
            this.setText(address.complement + '\n');
          }
          if (!_lodash2.default.isEmpty(address.instructions)) {
            this.setText(address.instructions + '\n');
          }
        }
      } else if (!_lodash2.default.isEmpty(this.order.tableNumber)) {
        this.builder.addFeedLine(1);
        this.setSubtitle('Table ' + this.order.tableNumber + '\n', { bold: true });
      }
    }
  }, {
    key: 'renderMenus',
    value: function renderMenus() {
      var _this = this;

      this.builder.addTextAlign(this.builder.ALIGN_LEFT);

      this.order.getMenusWithQuantities().forEach(function (menuWithQuantity) {
        var quantity = menuWithQuantity.quantity;
        var orderMenu = menuWithQuantity.orderMenu;

        _this.builder.addTextPosition(_this.DEFAULT_LEFT_BORDER);

        _this.renderItemTitle(orderMenu.name, quantity, quantity * orderMenu.getTotalPrice());

        orderMenu.parts.forEach(function (orderMenuPart) {
          orderMenuPart.products.forEach(function (orderProduct) {
            _this.builder.addTextPosition(_this.MARGIN_LEFT);
            _this.setText(orderProduct.name + '\n');

            orderProduct.options.forEach(function (orderProductOption) {
              orderProductOption.values.forEach(function (orderProductOptionValue) {
                _this.builder.addTextPosition(_this.MARGIN_LEFT_SECOND_COL);
                _this.setText(orderProductOption.name + ': ' + orderProductOptionValue.name + '\n');
              });
            });

            // comment
            var comment = '';
            if (!_lodash2.default.isEmpty(orderProduct.comment)) {
              comment = '' + orderProduct.comment.toUpperCase();
            }
            if (!_lodash2.default.isEmpty(comment)) {
              _this.builder.addTextPosition(_this.MARGIN_LEFT_SECOND_COL);
              _this.setText('*** Commentaire\n', { bold: true });
              _this.builder.addTextPosition(_this.MARGIN_LEFT_SECOND_COL);
              _this.setText(comment.toUpperCase() + '\n', { bold: true });
            }
          });
        });

        _this.builder.addFeedLine(1);
      });
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var _this2 = this;

      this.builder.addTextAlign(this.builder.ALIGN_LEFT);

      this.order.getProductsWithQuantities().forEach(function (productWithQuantity) {
        var quantity = productWithQuantity.quantity;
        var orderProduct = productWithQuantity.orderProduct;

        _this2.builder.addTextPosition(_this2.DEFAULT_LEFT_BORDER);
        _this2.renderItemTitle(orderProduct.name, quantity, quantity * orderProduct.getTotalPrice());

        orderProduct.options.forEach(function (orderProductOption) {
          orderProductOption.values.forEach(function (orderProductOptionValue) {
            _this2.builder.addTextPosition(_this2.MARGIN_LEFT_SECOND_COL);
            _this2.setText(orderProductOption.name + ': ' + orderProductOptionValue.name + '\n');
          });
        });

        if (!_lodash2.default.isEmpty(orderProduct.comment)) {
          _this2.builder.addTextPosition(_this2.MARGIN_LEFT);
          _this2.setText('*** Commentaire\n', { bold: true });
          _this2.builder.addTextPosition(_this2.MARGIN_LEFT);
          _this2.setText(orderProduct.comment.toUpperCase() + '\n', { bold: true });
        }

        _this2.builder.addFeedLine(1);
      });
    }
  }, {
    key: 'renderItemTitle',
    value: function renderItemTitle(name, quantity, amount) {
      var strName = '';
      var strQuantity = '';
      var strSubtotal = '';
      var spaces = '';
      var prefix = '';

      switch (this.paperWidth) {
        case PAPER_WIDTH.PAPER_WIDTH_58MM:
          // Product name
          strName = name;

          // Quantity
          strQuantity = quantity + 'x  ';

          // Subtotal
          strSubtotal = formatPrice(amount);

          spaces = this.fillWithSpaces(prefix.length + strQuantity.length + strName.length + strSubtotal.length, WIDTH_58mm_FONT_B);
          break;

        case PAPER_WIDTH.PAPER_WIDTH_80MM:
          // Product name
          strName = name;

          // Quantity
          strQuantity = quantity + 'x  ';

          // Subtotal
          strSubtotal = formatPrice(amount);

          spaces = this.fillWithSpaces(prefix.length + strQuantity.length + strName.length + strSubtotal.length, WIDTH_80mm_FONT_B);
          break;

        default:
          break;
      }

      this.setText('' + prefix + strQuantity + strName + spaces + strSubtotal + '\u20AC\n', { bold: true });
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _this3 = this;

      this.builder.addText('\n\n');

      // Set total, net and tax for reciept printing
      var strTotal = formatPrice(this.order.getTotalPrice());

      var taxesLines = [];

      var accountPaymentLines = [];

      // net
      // strTotal - strTax

      var userAccountPayment = this.order.userAccountPayment;

      var totalLabel = 'TOTAL';

      // TODO: i18n
      var accountPaymentLabel = 'paiement compte :';

      switch (this.paperWidth) {
        case PAPER_WIDTH.PAPER_WIDTH_58MM:
          // Total
          strTotal = '' + this.fillWithSpaces(totalLabel.length + strTotal.length + 1, WIDTH_58mm_SUBTITLE) + strTotal + '\u20AC';

          if (!_lodash2.default.isNil(userAccountPayment)) {
            var accountPaymentTotal = formatPrice(userAccountPayment.amountFromAccount);

            accountPaymentLines[0] = accountPaymentLabel + this.fillWithSpaces(accountPaymentLabel.length + accountPaymentTotal.length + 1, WIDTH_58mm_SUBTITLE) + accountPaymentTotal + '\u20AC';

            if (userAccountPayment.grantAmount !== 0) {
              var grantAmount = formatPrice(userAccountPayment.grantAmount);

              var grantLabel = _lodash2.default.isNil(userAccountPayment.grantLabel) ? '' : userAccountPayment.grantLabel;
              accountPaymentLines[1] = grantLabel + this.fillWithSpaces(grantLabel.length + grantAmount.length + 1, WIDTH_58mm_SUBTITLE) + grantAmount + '\u20AC';
            }
          }

          // Tax
          taxesLines = _lodash2.default.map(this.order.check.tax, function (taxDetail) {
            var tax = parseFloat(taxDetail.amoutOfTax);
            if (!tax || tax === 0) {
              return null;
            }
            var strTax = formatPrice(tax);
            var tvaPrefix = taxDetail.name.toLowerCase().indexOf('tva') === -1 ? 'TVA ' : '';
            var taxLabel = '' + tvaPrefix + taxDetail.name;
            return '' + taxLabel + _this3.fillWithSpaces(taxLabel.length + strTax.length + 1, WIDTH_58mm_SUBTITLE) + strTax + '\u20AC';
          }).filter(function (taxLine) {
            return taxLine !== null;
          });
          break;

        case PAPER_WIDTH.PAPER_WIDTH_80MM:
          // Total
          strTotal = '' + this.fillWithSpaces(totalLabel.length + strTotal.length + 1, 27) + strTotal + '\u20AC';

          if (!_lodash2.default.isNil(userAccountPayment)) {
            var _accountPaymentTotal = formatPrice(userAccountPayment.amountFromAccount);

            accountPaymentLines[0] = accountPaymentLabel + this.fillWithSpaces(accountPaymentLabel.length + _accountPaymentTotal.length + 1, WIDTH_SMALL_TEXT) + _accountPaymentTotal + '\u20AC';

            if (userAccountPayment.grantAmount !== 0) {
              var _grantAmount = formatPrice(userAccountPayment.grantAmount);
              var _grantLabel = _lodash2.default.isNil(userAccountPayment.grantLabel) ? '' : userAccountPayment.grantLabel;

              accountPaymentLines[1] = _grantLabel + this.fillWithSpaces(_grantLabel.length + _grantAmount.length + 1, WIDTH_SMALL_TEXT) + _grantAmount + '\u20AC';
            }
          }

          // Tax
          taxesLines = _lodash2.default.map(this.order.check.tax, function (taxDetail) {
            var tax = parseFloat(taxDetail.amoutOfTax);
            if (tax === 0 || !tax) {
              return null;
            }
            var strTax = formatPrice(tax);
            var tvaPrefix = taxDetail.name.toLowerCase().indexOf('tva') === -1 ? 'TVA ' : '';
            var taxLabel = '' + tvaPrefix + taxDetail.name;
            return '' + taxLabel + _this3.fillWithSpaces(taxLabel.length + strTax.length + 1, WIDTH_SMALL_TEXT) + strTax + '\u20AC';
          }).filter(function (taxLine) {
            return taxLine !== null;
          });
          break;

        default:
      }

      // Fees
      _lodash2.default.each(this.order.fees, function (fee) {
        var name = _ArrayUtils2.default.find(fee.name, function (locale) {
          return locale.locale && _lodash2.default.startsWith(locale.locale.toLowerCase(), _I18n2.default.getCurrentLanguageWithoutRegionCode());
        });
        _this3.setSmallText((name || fee.name[0]).text + ' : ' + formatPrice(fee.amountIncludingTax) + '\u20AC\n');
      });

      // Total
      this.setSubtitle('' + totalLabel + strTotal + '\n');

      this.builder.addFeedLine(1);

      if (!_lodash2.default.isEmpty(accountPaymentLines)) {
        _lodash2.default.each(accountPaymentLines, function (str) {
          _this3.setSmallText(str + '\n');
          _this3.builder.addTextSize(1);
        });
      }

      if (this.order.isPayed()) {
        _lodash2.default.each(taxesLines, function (strTax) {
          if (strTax) {
            _this3.setSmallText(strTax + '\n');
            _this3.builder.addTextSize(1);
          }
        });
      }

      this.builder.addFeedLine(1);
      var createdDate = this.order.creationDate.format('DD/MM/YYYY') + ' - ' + this.order.creationDate.format('HH:mm');

      this.setSmallText('Commande pass\xE9e le : ' + createdDate + '\n');

      this.builder.addFeedLine(2);
    }

    //
    // --------------------------------------------------------------------------------------------
    //        UTILS
    // --------------------------------------------------------------------------------------------
    //

  }, {
    key: 'setTitle',
    value: function setTitle(title) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.builder.addTextFont(this.builder.FONT_A);
      this.builder.addTextSize(2, 2);
      this.handleOptionsBegin(options);
      this.builder.addText(title);
      this.handleOptionsEnd(options);
    }
  }, {
    key: 'setSubtitle',
    value: function setSubtitle(subtitle) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.builder.addTextFont(this.builder.FONT_B);
      this.builder.addTextSize(2, 2);
      this.handleOptionsBegin(options);
      this.builder.addText(subtitle);
      this.handleOptionsEnd(options);
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.builder.addTextFont(this.builder.FONT_A);
      this.builder.addTextSize(1, 1);
      this.handleOptionsBegin(options);
      this.builder.addText(text);
      this.handleOptionsEnd(options);
    }
  }, {
    key: 'setSmallText',
    value: function setSmallText(text) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.builder.addTextFont(this.builder.FONT_B);
      this.builder.addTextSize(1, 1);
      this.handleOptionsBegin(options);
      this.builder.addText(text);
      this.handleOptionsEnd(options);
    }
  }, {
    key: 'handleOptionsBegin',
    value: function handleOptionsBegin(options) {
      if (options.bold === true) {
        this.beginBold();
      }
    }
  }, {
    key: 'handleOptionsEnd',
    value: function handleOptionsEnd(options) {
      if (options.bold === true) {
        this.endBold();
      }
    }
  }, {
    key: 'beginBold',
    value: function beginBold() {
      this.builder.addTextStyle(false, false, true, this.builder.COLOR_1);
    }
  }, {
    key: 'endBold',
    value: function endBold() {
      this.builder.addTextStyle(false, false, false, this.builder.COLOR_1);
    }

    /*
     * Note: only work for FONT_A
     */

  }, {
    key: 'fillWithSpaces',
    value: function fillWithSpaces(nb, width) {
      return this.generateSpaces(width - nb);
    }
  }, {
    key: 'generateSpaces',
    value: function generateSpaces(nb) {
      var str = '';

      for (var i = 0; i < nb; i++) {
        str += ' ';
      }

      return str;
    }
  }]);

  return EspsonPrinter;
}();

var _default = EspsonPrinter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PAPER_WIDTH, 'PAPER_WIDTH', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(WIDTH_58mm_FONT_B, 'WIDTH_58mm_FONT_B', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(WIDTH_58mm_SUBTITLE, 'WIDTH_58mm_SUBTITLE', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(WIDTH_80mm_FONT_B, 'WIDTH_80mm_FONT_B', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(WIDTH_SMALL_TEXT, 'WIDTH_SMALL_TEXT', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(formatPrice, 'formatPrice', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(EspsonPrinter, 'EspsonPrinter', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'C:/Users/quemar.OTPOS/IdeaProjects/pmt_web_pro/scripts/utils/printers/EsponPrinter.js');
}();

;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiCartModifier.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiCartModifier = function () {
  function ApiCartModifier() {
    _classCallCheck(this, ApiCartModifier);
  }

  _createClass(ApiCartModifier, null, [{
    key: 'getCartModifiers',
    value: function getCartModifiers(restaurantId, _success, _failure) {
      var endpoint = _APIEndpoints2.default.CART_MODIFIERS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[GET CART MODIFIERS] SUCCESS: ', json);

          var cartModifiers = json.map(function (data) {
            var cartModifier = new _CartModifier2.default();
            cartModifier.fromJson(data);
            return cartModifier;
          });

          _success(cartModifiers);
        },
        failure: function failure(apiError) {
          console.log('[GET CART MODIFIERS] FAILURE: ', apiError);
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getCartModifier',
    value: function getCartModifier(restaurantId, cartModifierId, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.CART_MODIFIER.replace('{restaurantId}', restaurantId).replace('{cartModifierId}', cartModifierId);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[GET CART MODIFIER] SUCCESS: ', json);

          var cartModifier = new _CartModifier2.default();
          cartModifier.fromJson(json);

          _success2(cartModifier);
        },
        failure: function failure(apiError) {
          console.log('[GET CART MODIFIER] FAILURE: ', apiError);
          _failure2(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'postCartModifier',
    value: function postCartModifier(restaurantId, data, _success3, _failure3) {
      var endpoint = _APIEndpoints2.default.CART_MODIFIERS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        data: data,
        success: function success(json) {
          console.log('[POST CART MODIFIERS] SUCCESS: ', json);

          var cartModifier = new _CartModifier2.default();
          cartModifier.fromJson(json);

          _success3(cartModifier);
        },
        failure: function failure(apiError) {
          console.log('[POST CART MODIFIERS] FAILURE: ', apiError);
          _failure3(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'putCartModifier',
    value: function putCartModifier(restaurantId, data, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.CART_MODIFIER.replace('{restaurantId}', restaurantId).replace('{cartModifierId}', data.id);

      var requestOptions = {
        endpoint: endpoint,
        data: data,
        success: function success(json) {
          console.log('[PUT CART MODIFIERS] SUCCESS: ', json);

          var cartModifier = new _CartModifier2.default();
          cartModifier.fromJson(json);

          _success4(cartModifier);
        },
        failure: function failure(apiError) {
          console.log('[PUT CART MODIFIERS] FAILURE: ', apiError);
          _failure4(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }, {
    key: 'putCartModifiersPriorities',
    value: function putCartModifiersPriorities(restaurantId, ids, _success5, _failure5) {

      var endpoint = _APIEndpoints2.default.CART_MODIFIERS_PRIORITIES.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        data: ids,
        success: function success(json) {
          console.log('[PUT CART MODIFIERS PRIORITIES] SUCCESS: ', json);

          var cartModifiers = json.map(function (data) {
            var cartModifier = new _CartModifier2.default();
            cartModifier.fromJson(data);

            return cartModifier;
          });

          _success5(cartModifiers);
        },
        failure: function failure(apiError) {
          console.log('[PUT CART MODIFIERS PRIORITIES] FAILURE: ', apiError);
          _failure5(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }]);

  return ApiCartModifier;
}();

exports.default = ApiCartModifier;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiDashboard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// entities.


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _RestaurantDashboardInfo = __webpack_require__("./sdk/scripts/entities/dashboard/RestaurantDashboardInfo.js");

var _RestaurantDashboardInfo2 = _interopRequireDefault(_RestaurantDashboardInfo);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiDashboard = function () {
  function ApiDashboard() {
    _classCallCheck(this, ApiDashboard);
  }

  _createClass(ApiDashboard, null, [{
    key: 'getRestaurantDashboard',


    /**
    *
    *
    */
    value: function getRestaurantDashboard(restaurantId, _success, _failure) {
      var endpoint = _APIEndpoints2.default.DASHBOARD_INFO_RESTAURANT.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {
          console.log('[BOOKINGS_FOR_DATE] SUCCESS: ', json);

          var restaurantDashboardInfo = new _RestaurantDashboardInfo2.default();
          restaurantDashboardInfo.fromJson(json);

          _success(restaurantDashboardInfo);
        },
        failure: function failure(apiError) {
          console.log('[BOOKINGS_FOR_DATE] FAILURE: ', apiError);
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }]);

  return ApiDashboard;
}();

exports.default = ApiDashboard;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiKiosk.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// constants


// entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _KioskApiErrors = __webpack_require__("./sdk/scripts/utils/apiErrors/KioskApiErrors.js");

var _KioskApiErrors2 = _interopRequireDefault(_KioskApiErrors);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _KioskSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskSettings.js");

var _KioskSettings2 = _interopRequireDefault(_KioskSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiKiosk = function () {
  function ApiKiosk() {
    _classCallCheck(this, ApiKiosk);
  }

  _createClass(ApiKiosk, null, [{
    key: 'getSettings',


    //
    // Settings
    //

    /**
    * Put the order settings
    */
    value: function getSettings(restaurantId, _success, _failure) {
      var endpoint = _APIEndpoints2.default.KIOSK_SETTINGS.replace(':restaurantId', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {
          console.log('[GET KIOSK SETTINGS] SUCCESS: ', json);

          var kioskSettings = new _KioskSettings2.default();
          kioskSettings.fromJson(json);

          _success(kioskSettings);
        },
        failure: function failure(apiError) {
          console.log('[GET KIOSK SETTINGS] FAILURE: ', apiError);
          apiError.localizedMessage = _KioskApiErrors2.default.get(apiError);
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
    * Put the order settings
    */

  }, {
    key: 'putSettings',
    value: function putSettings(restaurantId, kioskSettingsToUpdate, files, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.KIOSK_SETTINGS.replace(':restaurantId', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        data: {
          settings: JSON.stringify(kioskSettingsToUpdate)
        },
        files: files,
        success: function success(json) {
          console.log('[PUT KIOSK SETTINGS] SUCCESS: ', json);

          var kioskSettings = new _KioskSettings2.default();
          kioskSettings.fromJson(json);

          _success2(kioskSettings);
        },
        failure: function failure(apiError) {
          console.log('[PUT KIOSK SETTINGS] FAILURE: ', apiError);
          apiError.localizedMessage = _KioskApiErrors2.default.put(apiError);
          _failure2(apiError);
        }
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }]);

  return ApiKiosk;
}();

exports.default = ApiKiosk;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _superagent = __webpack_require__("./node_modules/superagent/lib/client.js");

var _superagent2 = _interopRequireDefault(_superagent);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _PMTConstants = __webpack_require__("./sdk/scripts/constants/PMTConstants.js");

var _PMTConstants2 = _interopRequireDefault(_PMTConstants);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Types = __webpack_require__("./sdk/scripts/utils/Types.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiManager = function () {
  function ApiManager() {
    _classCallCheck(this, ApiManager);

    this.ContentTypes = {
      FORM_URL_ENCODE: 'application/x-www-form-urlencoded'
    };
    this.config = {

      /**
      * A middleware used in case of error.
      * Must return true if the middleware have taking care of the error.
      * Use to handle 401, 500, etc.
      *
      * @param error
      * @param res If undefined, the request have encounter a connexion error.
      * @type Function
      *
      * Example of middleware:
      *
      * ```
      * errorMiddleware: (error, res, success, failure) => {
      * if (!_.isNil(res)) {
      *       if (res.statusCode === 401) {
      *         console.error('[API] 401, redirect to login');
      *         return true;
      *       }
      *
      *       if (res.statusCode === 500) {
      *         console.log(res);
      *         Logger.error('API 500', res);
      *         // redirect to error 500 page
      *         return true;
      *       }
      *     }
      *     return false;
      *   }
      * ```
      */
      errorMiddleware: function errorMiddleware(error, res, success, failure) {
        return false;
      },

      /**
      * Function that must return an object.
      *
      * Example:
      * {
      *  Authorization:  'toto',
      *  OtherHeader: 'toto42'
      * }
      *
      * Note that the headers set to the request's params have the priority over the headers given
      * by the middleware.
      *
      * @type Function
      */
      headersMiddleware: function headersMiddleware() {
        return {};
      },

      /**
      * @type string
      */
      apiUrl: ''
    };
  }

  /**
  * The default ApiManager configuration.
  * @type {Object}
  */


  _createClass(ApiManager, [{
    key: 'configure',
    value: function configure(configuration) {
      this.config = _lodash2.default.merge(this.config, configuration);
    }

    //
    // ------------- Tools
    //

  }, {
    key: 'getApiUrl',
    value: function getApiUrl() {
      return this.config.apiUrl;
    }

    /**
    * Merge headersParam with the headers given by the headersMiddleware.
    * Priority is given to the params headers over the middleware headers.
    */

  }, {
    key: 'getHeaders',
    value: function getHeaders(headersParam) {
      var headersToSet = _lodash2.default.merge(this.config.headersMiddleware(), headersParam);

      return headersToSet;
    }

    /**
    * Format the user credentials for the 'Authorization' header.
      * @param username The user username
    * @param password The user password
    * @param type The type of account: pro, user, ...
    * @returns {string} The string to put as 'Authorization' header on the HTTP request.
    */

  }, {
    key: 'formatAuthorizationHeader',
    value: function formatAuthorizationHeader(username, password) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pro';

      var base64Credentials = btoa(type + '_' + username + ':' + password);
      return 'Basic ' + base64Credentials;
    }
  }, {
    key: 'formatAuthorizationHeaderLight',
    value: function formatAuthorizationHeaderLight(username) {
      var base64Credentials = btoa('user_light_' + username + ':');
      return 'Basic ' + base64Credentials;
    }

    /**
    * Handle an HTTP response.
    * Calls the success callback in case of success
    * Calls the failure callback in case of error and if the errorMiddleware does not handle the error.
    *
    * @param error
    * @param res
    * @param success the closure called on success. Take a json object as parameter.
    * @param failure the closure called on failure. Take an ApiError as parameter.
    */

  }, {
    key: 'handleResponse',
    value: function handleResponse(error, res, success, failure) {
      if (!_lodash2.default.isUndefined(res) && this.isSuccessResponse(res.statusCode)) {
        if (!_lodash2.default.isEmpty(res.text)) {
          try {
            success(JSON.parse(res.text));
          } catch (e) {
            success(res.text);
          }
        } else {
          success();
        }
      } else {
        var errorMiddlewareUsed = this.config.errorMiddleware(error, res, success, failure);

        if (!errorMiddlewareUsed) {
          if (_lodash2.default.isUndefined(res)) {
            // no internet connexion / no response
            var apiError = new _ApiError2.default(_PMTConstants2.default.Error.NO_INTERNET, 'No internet connectivity');
            apiError.localizedMessage = _I18n2.default.tr('api_error.no_internet');
            failure(apiError);
          } else {
            console.log('get api errors');
            failure(this.createApiError(res.text, res.headers['p-session-id']));
          }
        }
      }
    }

    /**
    * Parse the HTTP response body to create an ApiError object.
    * @param responseBody The HTTP response body.
    * @returns {ApiError} A populate ApiError object.
    */

  }, {
    key: 'createApiError',
    value: function createApiError(responseBody, sessionId) {
      var error = new _ApiError2.default(_PMTConstants2.default.Error.UNKNOWN, 'Something went wrong, please try again');

      if (!_lodash2.default.isNull(responseBody) && !_lodash2.default.isUndefined(responseBody)) {
        try {
          var json = JSON.parse(responseBody);

          if (json) {
            if (!_lodash2.default.isEmpty(json.code)) {
              error.setCode(json.code);
              error.setMessage(json.message);
            }
          }
        } catch (syntaxError) {
          // SyntaxError exception
          error.setDetail(responseBody);
        }
      }

      if (sessionId) {
        error.setSessionId(sessionId);
      }

      return error;
    }

    /**
    *
    * @param statusCode the response status code
    * @returns {boolean} True if the status code indicate a successful response
    */

  }, {
    key: 'isSuccessResponse',
    value: function isSuccessResponse(statusCode) {
      return statusCode >= 200 && statusCode < 300;
    }

    //
    // ------------- Requests tools for PMT API
    //

    /**
    * Create an HTTP GET request.
    * @param endpoint The API endpoint (see ApiEndpoints).
    * @param query The query use on the url.
    * @param success the closure called on success. Take a json object as parameter.
    * @param failure the closure called on failure. Take an ApiError as parameter.
    */

  }, {
    key: 'get',
    value: function get(options) {
      var _this = this;

      var endpoint = options.endpoint,
          query = options.query,
          headers = options.headers,
          success = options.success,
          failure = options.failure;


      _superagent2.default.get('' + this.getApiUrl() + endpoint, null, null).query(query).set('Accept', 'application/json').set(this.getHeaders(headers)).end(function (error, res) {
        _this.handleResponse(error, res, function (json) {
          success(json);
        }, function (apiError) {
          failure(apiError);
        });
      });
    }

    /**
    * Create an HTTP GET request.
    * @param endpoint The API endpoint (see ApiEndpoints).
    * @param query The query use on the url.
    * @param success the closure called on success. Take a json object as parameter.
    * @param failure the closure called on failure. Take an ApiError as parameter.
    */

  }, {
    key: 'delete',
    value: function _delete(options) {
      var _this2 = this;

      var endpoint = options.endpoint,
          query = options.query,
          headers = options.headers,
          success = options.success,
          failure = options.failure;


      _superagent2.default.delete('' + this.getApiUrl() + endpoint, null).query(query).set('Accept', 'application/json').set(this.getHeaders(headers)).end(function (error, res) {
        _this2.handleResponse(error, res, function (json) {
          success(json);
        }, function (apiError) {
          failure(apiError);
        });
      });
    }
  }, {
    key: 'post',
    value: function post(options) {
      var _this3 = this;

      var endpoint = options.endpoint,
          data = options.data,
          headers = options.headers,
          query = options.query,
          success = options.success,
          failure = options.failure;


      _superagent2.default.post('' + this.getApiUrl() + endpoint, null, null).type('json').query(query).send(JSON.stringify(data)).set('Accept', 'application/json').set(this.getHeaders(headers)).end(function (error, res) {
        _this3.handleResponse(error, res, function (json) {
          success(json);
        }, function (apiError) {
          failure(apiError);
        });
      });
    }

    /**
    * Send a multipart form
    *
    * @param endpoint
    * @param data: example: { otherParameters: JSON.stringify(entity) }
    * @param files: example: { imageCover: // png file here // }
    * @param success
    * @param failure
    */

  }, {
    key: 'postMultipart',
    value: function postMultipart(options) {
      var _this4 = this;

      var endpoint = options.endpoint,
          data = options.data,
          files = options.files,
          headers = options.headers,
          query = options.query,
          success = options.success,
          failure = options.failure;


      var req = _superagent2.default.post('' + this.getApiUrl() + endpoint, null, null).query(query);

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          req.field(key, data[key]);
        }
      }

      for (var _key in files) {
        if (files.hasOwnProperty(_key)) {
          console.log('put multipart, attach file', _key);
          req.attach(_key, files[_key]);
        }
      }

      req.set('Accept', 'application/json').set(this.getHeaders(headers)).end(function (error, res) {
        _this4.handleResponse(error, res, function (json) {
          success(json);
        }, function (apiError) {
          failure(apiError);
        });
      });
    }

    /**
    * Create an HTTP PUT request.
    * Note this function will use the 'json' (application/json) format instead of the 'form' format
    * (application/x-www-form-urlencoded)
    *
    * See: https://visionmedia.github.io/superagent/#post-/-put-requests
    *
    * @param endpoint The API endpoint (see ApiEndpoints).
    * @param data The data to send.
    * @param success the closure called on success. Take a json object as parameter.
    * @param failure the closure called on failure. Take an ApiError as parameter.
    */

  }, {
    key: 'put',
    value: function put(options) {
      var _this5 = this;

      var endpoint = options.endpoint,
          data = options.data,
          headers = options.headers,
          query = options.query,
          success = options.success,
          failure = options.failure;


      _superagent2.default.put('' + this.getApiUrl() + endpoint, null, null).type('json').send(JSON.stringify(data)).query(query).set('Accept', 'application/json').set(this.getHeaders(headers)).end(function (error, res) {
        _this5.handleResponse(error, res, function (json) {
          success(json);
        }, function (apiError) {
          failure(apiError);
        });
      });
    }

    /**
    * Send a multipart form
    *
    * @param endpoint
    * @param data: example: { otherParameters: JSON.stringify(entity) }
    * @param files: example: { imageCover: // png file here // }
    * @param success
    * @param failure
    */

  }, {
    key: 'putMultipart',
    value: function putMultipart(options) {
      var _this6 = this;

      var endpoint = options.endpoint,
          data = options.data,
          files = options.files,
          headers = options.headers,
          query = options.query,
          success = options.success,
          failure = options.failure;


      var req = _superagent2.default.put('' + this.getApiUrl() + endpoint, null, null).query(query);

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          req.field(key, data[key]);
        }
      }

      console.log('[put multipart] files', files);
      for (var _key2 in files) {
        if (files.hasOwnProperty(_key2)) {
          var file = files[_key2];

          // handle file keys with '.' in it.
          if (!_lodash2.default.isUndefined(file) && !_lodash2.default.isNull(file)) {
            console.log('[put multipart] attach file', _key2);
            req.attach(_key2, file);
          } else {
            console.log('[put multipart] could not attach file', _key2);
          }
        }
      }

      req.set('Accept', 'application/json').set(this.getHeaders(headers)).end(function (error, res) {
        _this6.handleResponse(error, res, function (json) {
          success(json);
        }, function (apiError) {
          failure(apiError);
        });
      });
    }

    //
    // Requests tools for extern APIs
    //

    /**
    * Create an HTTP GET request.
    */

  }, {
    key: 'getExtern',
    value: function getExtern(options) {
      var _this7 = this;

      var url = options.url,
          query = options.query,
          headers = options.headers,
          success = options.success,
          failure = options.failure;


      _superagent2.default.get(options.url).query(query).set(headers).end(function (error, res) {
        if (!_lodash2.default.isNil(res) && _this7.isSuccessResponse(res.statusCode)) {
          success(res);
        } else {
          failure(error, res);
        }
      });
    }

    /**
    * Create an HTTP GET request.
    */

  }, {
    key: 'postExtern',
    value: function postExtern(options) {
      var _this8 = this;

      var url = options.url,
          data = options.data,
          headers = options.headers,
          success = options.success,
          failure = options.failure;


      _superagent2.default.post(options.url).send(data).set(headers).end(function (error, res) {
        if (!_lodash2.default.isNil(res) && _this8.isSuccessResponse(res.statusCode)) {
          success(res);
        } else {
          failure(error, res);
        }
      });
    }
  }]);

  return ApiManager;
}();

var _apiManagerInstance = new ApiManager();

exports.default = _apiManagerInstance;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiOrder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// constants


// api


// entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _ApiPayment = __webpack_require__("./sdk/scripts/api/ApiPayment.js");

var _ApiPayment2 = _interopRequireDefault(_ApiPayment);

var _ApiUser = __webpack_require__("./sdk/scripts/api/ApiUser.js");

var _ApiUser2 = _interopRequireDefault(_ApiUser);

var _OrderApiErrors = __webpack_require__("./sdk/scripts/utils/apiErrors/OrderApiErrors.js");

var _OrderApiErrors2 = _interopRequireDefault(_OrderApiErrors);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _OrdersList = __webpack_require__("./sdk/scripts/entities/order/OrdersList.js");

var _OrdersList2 = _interopRequireDefault(_OrdersList);

var _Check = __webpack_require__("./sdk/scripts/entities/Check.js");

var _Check2 = _interopRequireDefault(_Check);

var _ChecksList = __webpack_require__("./sdk/scripts/entities/ChecksList.js");

var _ChecksList2 = _interopRequireDefault(_ChecksList);

var _User = __webpack_require__("./sdk/scripts/entities/user/User.js");

var _User2 = _interopRequireDefault(_User);

var _UsersList = __webpack_require__("./sdk/scripts/entities/user/UsersList.js");

var _UsersList2 = _interopRequireDefault(_UsersList);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiOrder = function () {
  function ApiOrder() {
    _classCallCheck(this, ApiOrder);
  }

  _createClass(ApiOrder, null, [{
    key: 'getOrdersOnGoingForRestaurant',


    //
    // Orders List - On Going
    //

    /**
     * Retrieve the on going orders list for the restaurant.
    */
    value: function getOrdersOnGoingForRestaurant(restaurantId, _success, _failure) {

      var requestOptions = {
        endpoint: _APIEndpoints2.default.ORDERS_ON_GOING,
        query: {
          restaurantId: restaurantId,
          v2: true
        },
        success: function success(json) {
          var ordersList = new _OrdersList2.default();
          // OrdersList deserialize an array with the key 'orders' but we just receive an array.
          ordersList.fromJson(json);

          _success(ordersList);
        },
        failure: function failure(apiError) {
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Orders List - By Modification Date
    //

    /**
    * Retrieve the orders list for the restaurant in the given timelapse.
    * It will returns all the orders with the modificationDate on this interval.
    *
    * @param fromTime
    * @param toTime
    */

  }, {
    key: 'getOrdersListByModificationDate',
    value: function getOrdersListByModificationDate(restaurantId, fromTime, toTime, _success2, _failure2) {
      var requestOptions = {
        endpoint: _APIEndpoints2.default.ORDERS,
        query: {
          restaurantId: restaurantId,
          fromTime: fromTime,
          toTime: toTime,
          filterBy: 'modificationDate',
          v2: true,
          limit: 200
        },
        success: function success(json) {
          var ordersList = new _OrdersList2.default();
          // OrdersList deserialize an array with the key 'orders' but we just receive an array.
          ordersList.fromJson(json);

          _success2(ordersList);
        },
        failure: function failure(apiError) {
          _failure2(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Orders List - By Due Date
    //

    /**
    * Retrieve the orders history list for the restaurant in the given timelapse.
    * It will returns all the orders with the dueDate on this interval.
    *
    * @param fromTime
    * @param toTime
    */

  }, {
    key: 'getOrdersListByDueDate',
    value: function getOrdersListByDueDate(restaurantId, fromTime, toTime, _success3, _failure3) {

      var requestOptions = {
        endpoint: _APIEndpoints2.default.ORDERS,
        query: {
          restaurantId: restaurantId,
          fromTime: fromTime,
          toTime: toTime,
          filterBy: 'dueDate',
          v2: true,
          limit: 200
        },
        success: function success(json) {
          var ordersList = new _OrdersList2.default();
          // OrdersList deserialize an array with the key 'orders' but we just receive an array.
          ordersList.fromJson(json);

          _success3(ordersList);
        },
        failure: function failure(apiError) {
          _failure3(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Order
    //

    /**
    * Post the given order
    */

  }, {
    key: 'postOrder',
    value: function postOrder(orderToCreate, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.ORDERS;

      var requestOptions = {
        endpoint: endpoint,
        headers: {
          'session-id': orderToCreate.sessionId || ''
        },
        data: orderToCreate,
        success: function success(json) {

          var order = new _order.Order();
          order.fromJson(json);

          // Retrieve checks objects
          _ApiPayment2.default.getChecks([order.checkId], function (checksList) {

            var check = checksList.findById(order.checkId);
            if (!_lodash2.default.isNull(check)) {
              order.check = check.copy();
            }

            _lodash2.default.each(order.products, function (product) {
              product.prices = orderToCreate.getProductWithId(product.id).prices;
            });
            _lodash2.default.each(order.menus, function (menu) {
              menu.prices = orderToCreate.getMenuWithId(menu.id).prices;
            });
            order.mergeUiDatas(orderToCreate);

            _success4(order);
          }, function (apiError) {
            _failure4(apiError);
          });
        },
        failure: function failure(apiError) {
          apiError.localizedMessage = _OrderApiErrors2.default.post(apiError);
          _failure4(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }

    /**
    * Post the given light order
    */

  }, {
    key: 'postOrderLight',
    value: function postOrderLight(orderToCreate, email, apiKey, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.ORDERS;

      var requestOptions = {
        endpoint: endpoint,
        headers: {
          Accept: 'application/json',
          Authorization: _ApiManager2.default.formatAuthorizationHeaderLight(email),
          'api-consumer': apiKey,
          'session-id': orderToCreate.sessionId || ''
        },
        data: orderToCreate,
        success: function success(json) {

          var order = new _order.Order();
          order.fromJson(json);

          // _.each(order.products, (product) => {
          //   product.prices = orderToCreate.getProductWithId(product.id).prices;
          // });
          // _.each(order.menus, (menu) => {
          //   menu.prices = orderToCreate.getMenuWithId(menu.id).prices;
          // });

          _success5(order);
        },
        failure: function failure(apiError) {
          apiError.localizedMessage = _OrderApiErrors2.default.post(apiError);
          _failure5(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'postOrderPreview',
    value: function postOrderPreview(orderToCreate, _success6, _failure6) {
      var applyCartModifiers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var endpoint = _APIEndpoints2.default.ORDERS_PREVIEW;

      var getMaxGrantableAmount = !_lodash2.default.isNull(orderToCreate.userAccountPayment) ? true : false;
      var getAdmissionFeesAmount = !_lodash2.default.isNull(orderToCreate.userAccountPayment) ? true : false;
      var verifyUserAccount = !_lodash2.default.isNull(orderToCreate.userAccountPayment) ? true : false;

      var requestOptions = {
        endpoint: endpoint,
        query: {
          applyCartModifiers: applyCartModifiers,
          getMaxGrantableAmount: getMaxGrantableAmount,
          getAdmissionFeesAmount: getAdmissionFeesAmount,
          verifyUserAccount: verifyUserAccount
        },
        headers: {
          'session-id': orderToCreate.sessionId || ''
        },
        data: orderToCreate,
        success: function success(json) {

          if (typeof json.succeeded !== 'undefined' && json.succeeded) {
            var order = new _order.Order();
            order.fromJson(json.order);

            // merge data
            order.populateListItemsCart(orderToCreate.listItemsCart);
            order.mergeUiDatas(orderToCreate);

            _success6(order, json.verifications);
          } else {
            _failure6();
          }
        },
        failure: function failure(apiError) {
          _failure6(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }

    /**
    * Put the given order
    */

  }, {
    key: 'putOrder',
    value: function putOrder(orderToUpdate, _success7, _failure7) {
      var endpoint = _APIEndpoints2.default.ORDER.replace('{orderId}', orderToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        data: orderToUpdate,
        success: function success(json) {

          var order = new _order.Order();
          order.fromJson(json);

          // TODO: retrieve from the API ?
          order.check = orderToUpdate.check;
          order.user = orderToUpdate.user;

          _success7(order);
        },
        failure: function failure(apiError) {
          apiError.localizedMessage = _OrderApiErrors2.default.put(apiError);
          _failure7(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }

    //
    // Order Settings
    //

    /**
    * Put the order settings
    */

  }, {
    key: 'getOrderSettings',
    value: function getOrderSettings(restaurantId, _success8, _failure8) {
      var endpoint = _APIEndpoints2.default.ORDER_SETTINGS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {

          var orderSettings = new _order.OrderSettings();
          orderSettings.fromJson(json);

          _success8(orderSettings);
        },
        failure: function failure(apiError) {
          _failure8(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
    * Put the order settings
    */

  }, {
    key: 'putOrderSettings',
    value: function putOrderSettings(restaurantId, orderSettings, _success9, _failure9) {
      var endpoint = _APIEndpoints2.default.ORDER_SETTINGS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        data: orderSettings,
        success: function success(json) {

          var orderSettings = new _order.OrderSettings();
          orderSettings.fromJson(json);

          _success9(orderSettings);
        },
        failure: function failure(apiError) {
          _failure9(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }]);

  return ApiOrder;
}();

exports.default = ApiOrder;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiPayment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// constants


// -- utils


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _PaymentsList = __webpack_require__("./sdk/scripts/entities/PaymentsList.js");

var _PaymentsList2 = _interopRequireDefault(_PaymentsList);

var _PaymentStatistics = __webpack_require__("./sdk/scripts/entities/PaymentStatistics.js");

var _PaymentStatistics2 = _interopRequireDefault(_PaymentStatistics);

var _PayinList = __webpack_require__("./sdk/scripts/entities/PayinList.js");

var _PayinList2 = _interopRequireDefault(_PayinList);

var _PayoutList = __webpack_require__("./sdk/scripts/entities/PayoutList.js");

var _PayoutList2 = _interopRequireDefault(_PayoutList);

var _ChecksList = __webpack_require__("./sdk/scripts/entities/ChecksList.js");

var _ChecksList2 = _interopRequireDefault(_ChecksList);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiPayment = function () {
  function ApiPayment() {
    _classCallCheck(this, ApiPayment);
  }

  _createClass(ApiPayment, null, [{
    key: 'getStatistics',


    /**
    *
    * @param fromTime
    * @param toTime
    */
    value: function getStatistics(restaurantId, fromTime, toTime, _success, _failure) {
      var endpoint = _APIEndpoints2.default.STATISTICS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          fromTime: fromTime,
          toTime: toTime
        },
        success: function success(json) {
          // -- create the payment statistics object.
          var paymentStatistics = new _PaymentStatistics2.default();
          paymentStatistics.fromJson(json);

          _success(paymentStatistics);
        },
        failure: function failure(apiError) {
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getPayins',
    value: function getPayins(restaurantId, fromTime, toTime, _success2, _failure2) {

      var endpoint = _APIEndpoints2.default.PAYINS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          fromTime: fromTime,
          toTime: toTime
        },
        success: function success(json) {

          var payinList = new _PayinList2.default();
          payinList.fromJson(json);

          _success2(payinList);
        },
        failure: function failure(apiError) {
          _failure2(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getPayouts',
    value: function getPayouts(restaurantId, fromTime, toTime, _success3, _failure3) {
      var endpoint = _APIEndpoints2.default.PAYOUTS.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          fromTime: fromTime,
          toTime: toTime
        },
        success: function success(json) {

          // json = {"fromTime":1477778400000,"toTime":1480546799000,"payouts":[{"id":5765687410688000,"restId":"16000208","vatPercent":0.2,"vatAmount":0.01,"feesFixedPerPayin":0.01,"feesFixedAmountExcludingVat":0.03,"feesVariablePercent":0.1,"feesVariableAmountExcludingVat":0.04,"amount":35.0,"grossAmount":35.98,"netAmount":35.0,"date":1479877211,"creationDate":1479877211396,"dateOfFirstPayment":1479816724491,"dateOfLastPayment":1479817389538,"status":"SUCCEEDED","reference":"Pizza-161122"},{"id":6597081946914816,"restId":"16000208","vatPercent":0.2,"vatAmount":0.01,"feesFixedPerPayin":0.01,"feesFixedAmountExcludingVat":0.01,"feesVariablePercent":0.1,"feesVariableAmountExcludingVat":0.03,"amount":32.0,"grossAmount":32.5,"netAmount":32.0,"date":1479358812,"creationDate":1479358813000,"dateOfFirstPayment":1479299276921,"dateOfLastPayment":1479299276921,"status":"SUCCEEDED","reference":"Pizza-161116"},{"id":6301139976847360,"restId":"16000208","vatPercent":0.2,"vatAmount":0.01,"feesFixedPerPayin":0.01,"feesFixedAmountExcludingVat":0.01,"feesVariablePercent":0.1,"feesVariableAmountExcludingVat":0.02,"amount":15.0,"grossAmount":15.6,"netAmount":15.0,"date":1478667611,"creationDate":1478667611593,"dateOfFirstPayment":1478606568455,"dateOfLastPayment":1478606568455,"status":"SUCCEEDED","reference":"Pizza-161108"}]};

          var payoutList = new _PayoutList2.default();
          payoutList.fromJson(json);

          _success3(payoutList);
        },
        failure: function failure(apiError) {
          _failure3(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getChecks',
    value: function getChecks(checksIds, _success4, _failure4) {

      if (_lodash2.default.isEmpty(checksIds)) {
        _success4(new _PayoutList2.default());
        return;
      }

      var requestOptions = {
        endpoint: _APIEndpoints2.default.CHECKS,
        query: {
          ids: _lodash2.default.join(_lodash2.default.uniq(checksIds), ',')
        },
        success: function success(json) {

          var checksList = new _ChecksList2.default();
          checksList.fromJson(json);

          _success4(checksList);
        },
        failure: function failure(apiError) {
          _failure4(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getUserPaymentsForRestaurant',
    value: function getUserPaymentsForRestaurant(restaurantId, fromTime, toTime) {
      var userId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var _success5 = arguments[4];
      var _failure5 = arguments[5];


      var requestOptions = {
        endpoint: _APIEndpoints2.default.PAYMENTS,
        query: {
          restaurantId: restaurantId,
          userId: userId,
          fromTime: fromTime,
          toTime: toTime
        },
        success: function success(json) {

          var paymentsList = new _PaymentsList2.default();
          paymentsList.fromJson(json);

          _success5(paymentsList);
        },
        failure: function failure(apiError) {
          _failure5(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }]);

  return ApiPayment;
}();

exports.default = ApiPayment;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiProAccount.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- constants


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _ApiRestaurant = __webpack_require__("./sdk/scripts/api/ApiRestaurant.js");

var _ApiRestaurant2 = _interopRequireDefault(_ApiRestaurant);

var _ApiRole = __webpack_require__("./sdk/scripts/api/ApiRole.js");

var _ApiRole2 = _interopRequireDefault(_ApiRole);

var _ApiRestaurantsGroup = __webpack_require__("./sdk/scripts/api/ApiRestaurantsGroup.js");

var _ApiRestaurantsGroup2 = _interopRequireDefault(_ApiRestaurantsGroup);

var _ProRoleApiErrors = __webpack_require__("./sdk/scripts/utils/apiErrors/ProRoleApiErrors.js");

var _ProRoleApiErrors2 = _interopRequireDefault(_ProRoleApiErrors);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _SessionStore = __webpack_require__("./scripts/stores/SessionStore.js");

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

var _restaurantsGroup2 = _interopRequireDefault(_restaurantsGroup);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiProAccount = function () {
  function ApiProAccount() {
    _classCallCheck(this, ApiProAccount);
  }

  _createClass(ApiProAccount, null, [{
    key: 'getRecoverPassword',
    value: function getRecoverPassword(email, _success, _failure) {
      _ApiManager2.default.get({
        endpoint: _APIEndpoints2.default.PRO_FORGOT_PASSWORD,
        query: {
          email: email
        },
        success: function success(json) {
          _success(json);
        },
        failure: function failure(apiError) {
          _failure(apiError);
        }
      });
    }
  }, {
    key: 'postAccount',
    value: function postAccount(account, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.PRO_ACCOUNTS;

      var requestOptions = {
        endpoint: endpoint,
        data: account,
        success: function success(json) {

          var proAccount = new _security.ProAccount();
          proAccount.fromJson(json);

          _success2(proAccount);
        },
        failure: function failure(apiError) {
          _failure2(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'getMeAccount',
    value: function getMeAccount(_success3, _failure3) {
      var endpoint = _APIEndpoints2.default.PRO_ME_ACCOUNT;

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {

          var proAccount = new _security.ProAccount();
          proAccount.fromJson(json);

          _success3(proAccount);
        },
        failure: function failure(apiError) {
          _failure3(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getAccountData',
    value: function getAccountData(defaultDomainId, defaultRestaurantId, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.PRO_ME_ACCOUNT_DOMAINS;

      //
      // Load account domains
      //
      var requestOptions = {
        endpoint: endpoint,
        query: {
          loadProRole: true,
          loadRestaurantsGroup: true,
          loadRestaurantsGroupChildren: true
        },
        success: function success(json) {
          var domainsList = new _security.ProDomainsList();
          domainsList.fromJson(json);

          if (_lodash2.default.isEmpty(domainsList)) {
            // TODO: tell the user to fuck off.
            alert('Votre compte est désactivé');
            _SessionStore2.default.logout();
            window.location.pathname = "/login";
            return _failure4(null);
          }

          var domainId = defaultDomainId;

          var domain = void 0;
          if (_lodash2.default.isNull(domainId)) {
            domain = domainsList.domains[0];

            if (_lodash2.default.isNull(domain)) {
              // TODO: error at login, no domains.
              _failure4(null);
            }
          } else {
            domain = domainsList.getDomainWithId(domainId);

            if (_lodash2.default.isNull(domain)) {
              domain = domainsList.domains[0];
            }
          }

          var restaurantsGroupId = domain.restaurantsGroupId;

          //
          // Load me account
          //

          ApiProAccount.getMeAccount(function (proAccount) {

            proAccount.domainsList = domainsList;

            //
            // Load restaurantsGroup
            //

            _ApiRestaurantsGroup2.default.getRestaurantsGroupWithDomain(restaurantsGroupId, domain, true, function (restaurantsGroup) {
              if (_lodash2.default.isEmpty(restaurantsGroup.restaurantsIds)) {
                // TODO: tell the user to fuck off.
              }

              proAccount.restaurantsGroup = restaurantsGroup;

              var restaurantId = defaultRestaurantId;

              if (_lodash2.default.isNil(restaurantId)) {
                restaurantId = restaurantsGroup.restaurantsIds[0];
              }

              // find restaurantId on restaurantsGroup, otherwise use a default restaurantId.
              if (!restaurantsGroup.haveRestaurantWithId(restaurantId)) {
                restaurantId = restaurantsGroup.restaurantsIds[0];
              }

              //
              // Load restaurant
              //

              _ApiRestaurant2.default.getRestaurantWithDomain(restaurantId, domain.id, function (restaurant) {

                _ApiRole2.default.getRoleWithDomain(domain.roleId, domain.id, function (proRole) {

                  proAccount.role = proRole;
                  domain.role = proRole;
                  domain.restaurantsGroup = restaurantsGroup;

                  _success4(proAccount, restaurant, domain);
                }, function (apiError) {
                  _failure4(apiError);
                });
              }, function (apiError) {
                _failure4(apiError);
              });
            }, function (apiError) {
              _failure4(apiError);
            });
          }, function (apiError) {
            _failure4(apiError);
          });
        },
        failure: function failure(apiError) {
          _failure4(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getAccount',
    value: function getAccount(accountId, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.PRO_ACCOUNT.replace(':accountId', accountId);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {

          var proAccount = new _security.ProAccount();
          proAccount.fromJson(json);

          _success5(proAccount);
        },
        failure: function failure(apiError) {
          _failure5(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'putAccount',
    value: function putAccount(account, _success6, _failure6) {
      var endpoint = _APIEndpoints2.default.PRO_ACCOUNT.replace(':accountId', account.id);

      var requestOptions = {
        endpoint: endpoint,
        data: account,
        success: function success(json) {
          var proAccount = new _security.ProAccount();
          proAccount.fromJson(json);

          _success6(proAccount);
        },
        failure: function failure(apiError) {
          _failure6(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }, {
    key: 'deleteAccount',
    value: function deleteAccount(account, _success7, _failure7) {
      var endpoint = _APIEndpoints2.default.PRO_ACCOUNT.replace(':accountId', account.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success7(account);
        },
        failure: function failure(apiError) {
          _failure7(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'getAccountDomains',
    value: function getAccountDomains(account, loadRole, loadRestaurantsGroup, loadRestaurantsGroupChildren, _success8, _failure8) {
      var endpoint = _APIEndpoints2.default.PRO_ACCOUNT_DOMAINS.replace(':accountId', account.id);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          loadProRole: loadRole,
          loadRestaurantsGroup: loadRestaurantsGroup,
          loadRestaurantsGroupChildren: loadRestaurantsGroupChildren
        },
        success: function success(json) {
          var domainsList = new _security.ProDomainsList();
          domainsList.fromJson(json);

          _success8(account, domainsList);
        },
        failure: function failure(apiError) {
          _failure8(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Get roles with code
    //

  }, {
    key: 'getProRoleWithElevationCode',
    value: function getProRoleWithElevationCode(proDomainId, elevationCode, _success9, _failure9) {
      var endpoint = _APIEndpoints2.default.PRO_DOMAIN_ROLE.replace(':domainId', proDomainId);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        headers: {
          'pro-elevation-code': elevationCode
        },
        success: function success(json) {
          var proRole = new _security.ProRole();
          proRole.fromJson(json);

          _success9(proRole, elevationCode);
        },
        failure: function failure(apiError) {
          apiError.localizedMessage = _ProRoleApiErrors2.default.getOne(apiError);
          _failure9(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }]);

  return ApiProAccount;
}();

exports.default = ApiProAccount;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiRestaurant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- contants


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _RestaurantMultipart = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart2 = _interopRequireDefault(_RestaurantMultipart);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _RestaurantsList = __webpack_require__("./sdk/scripts/entities/RestaurantsList.js");

var _RestaurantsList2 = _interopRequireDefault(_RestaurantsList);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiRestaurant = function () {
  function ApiRestaurant() {
    _classCallCheck(this, ApiRestaurant);
  }

  _createClass(ApiRestaurant, null, [{
    key: 'getRestaurantsList',
    value: function getRestaurantsList(query, _success, _failure) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS;

      var requestOptions = {
        endpoint: endpoint,
        query: query,
        success: function success(json) {
          var restaurantsList = new _RestaurantsList2.default();
          restaurantsList.fromJson(json);

          _success(restaurantsList);
        },
        failure: function failure(apiError) {
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurantsListByGeoPt',
    value: function getRestaurantsListByGeoPt(latitude, longitude, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS;

      var requestOptions = {
        endpoint: endpoint,
        query: {
          latitude: latitude,
          longitude: longitude,
          loadOrderSettings: false
        },
        success: function success(json) {
          var restaurantsList = new _RestaurantsList2.default();
          restaurantsList.fromJson(json);

          _success2(restaurantsList);
        },
        failure: function failure(apiError) {
          _failure2(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurantsListByGeoPtWithOrderSettings',
    value: function getRestaurantsListByGeoPtWithOrderSettings(latitude, longitude, _success3, _failure3) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS;

      var requestOptions = {
        endpoint: endpoint,
        query: {
          // TODO: change when we load order settings via the service
          loadOrderSettings: true,
          latitude: latitude,
          longitude: longitude
        },
        success: function success(json) {
          var restaurantsList = new _RestaurantsList2.default();
          restaurantsList.fromJson(json);

          _success3(restaurantsList);
        },
        failure: function failure(apiError) {
          _failure3(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurant',
    value: function getRestaurant(restaurantId, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.RESTAURANT.replace(':restaurantId', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          // TODO: change when we load order settings via the service
          loadOrderSettings: true
        },
        headers: {
          'restaurant-id': restaurantId
        },
        success: function success(json) {

          var restaurant = new _Restaurant2.default();
          restaurant.fromJson(json);

          _success4(restaurant);
        },
        failure: function failure(apiError) {
          _failure4(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurantWithDomain',
    value: function getRestaurantWithDomain(restaurantId, domainId, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.RESTAURANT.replace(':restaurantId', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          // TODO: change when we load order settings via the service
          loadOrderSettings: true
        },
        headers: {
          'restaurant-id': restaurantId,
          'pro-domain-id': domainId
        },
        success: function success(json) {

          var restaurant = new _Restaurant2.default();
          restaurant.fromJson(json);

          _success5(restaurant);
        },
        failure: function failure(apiError) {
          _failure5(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurantWithoutOrderSettings',
    value: function getRestaurantWithoutOrderSettings(restaurantId, _success6, _failure6) {
      var endpoint = _APIEndpoints2.default.RESTAURANT.replace(':restaurantId', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          loadOrderSettings: false
        },
        headers: {
          'restaurant-id': restaurantId
        },
        success: function success(json) {

          var restaurant = new _Restaurant2.default();
          restaurant.fromJson(json);

          _success6(restaurant);
        },
        failure: function failure(apiError) {
          _failure6(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurantForGroup',
    value: function getRestaurantForGroup(restaurantId, restaurantsGroup, success, failure) {
      ApiRestaurant.getRestaurant(restaurantId, function (restaurant) {
        success(restaurant, restaurantsGroup);
      }, function (apiError) {
        failure(apiError);
      });
    }

    /*
    * Update the logged in restaurant.
    *
    * @param restaurant
    */

  }, {
    key: 'putRestaurantMultipart',
    value: function putRestaurantMultipart(restaurantId, restaurantMultipart, _success7, _failure7) {
      var endpoint = _APIEndpoints2.default.RESTAURANT.replace(':restaurantId', restaurantId);

      var data = restaurantMultipart.getData();
      var files = restaurantMultipart.getFiles();

      var requestOptions = {
        endpoint: endpoint,
        data: data,
        files: files,
        success: function success(json) {
          // -- create restaurant object.
          var restaurant = new _Restaurant2.default();
          restaurant.fromJson(json.data);

          _success7(restaurant);
        },
        failure: function failure(apiError) {
          _failure7(apiError);
        }
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }, {
    key: 'postRestaurant',
    value: function postRestaurant(restaurantToPost, _success8, _failure8) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS;

      var requestOptions = {
        endpoint: endpoint,
        data: restaurantToPost,
        success: function success(json) {

          // -- create restaurant object.
          var restaurant = new _Restaurant2.default();
          restaurant.fromJson(json);

          _success8(restaurant);
        },
        failure: function failure(apiError) {
          _failure8(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }]);

  return ApiRestaurant;
}();

exports.default = ApiRestaurant;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiRestaurantMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- contants


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _keymirror = __webpack_require__("./node_modules/keymirror/index.js");

var _keymirror2 = _interopRequireDefault(_keymirror);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _menu = __webpack_require__("./sdk/scripts/entities/menu/index.js");

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Defines the differents values that can be used for the `menuSource` parameter for the
 * get restaurant menu requests.
 */
var StocksSource = (0, _keymirror2.default)({
  /**
   * to use only the local menu information
   */
  LOCAL_ONLY: null,

  /**
   * to use only the POS menu information (can cause performance issues, depending on the POS)
   */
  POS_ONLY: null
});

/*
 * Defines the differents values that can be used for the `menuSource` parameter for the
 * get restaurant menu requests.
 */
var MenuSource = (0, _keymirror2.default)({
  /**
   * to use only the local menu information
   */
  LOCAL_ONLY: null,

  /**
   * to use both local and POS menu information merged (can cause performance issues, depending on
   * the POS).
   */
  LOCAL_AND_POS: null,

  /**
   * to use only the POS menu information (can cause performance issues, depending on the POS)
   */
  POS_ONLY: null
});

var ApiRestaurantMenu = function () {
  function ApiRestaurantMenu() {
    _classCallCheck(this, ApiRestaurantMenu);
  }

  _createClass(ApiRestaurantMenu, null, [{
    key: 'getMenu',

    //
    // Menu
    //

    /**
     * Retrieve the restaurant menu
     * This request can take > 10 seconds.
     */
    value: function getMenu(restaurantId, _success, _failure) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          stocksSource: StocksSource.POS_ONLY,
          menuSource: MenuSource.LOCAL_ONLY,
          loadCartModifiers: true
        },
        success: function success(json) {
          var restaurantMenu = new _menu.RestaurantMenu();
          restaurantMenu.fromJson(json);

          _success(restaurantMenu);
        },
        failure: function failure(apiError) {
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getMenuWithSynchronization',
    value: function getMenuWithSynchronization(restaurantId, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          stocksSource: StocksSource.POS_ONLY, // default true
          menuSource: MenuSource.LOCAL_AND_POS
        },
        success: function success(json) {
          var restaurantMenu = new _menu.RestaurantMenu();
          restaurantMenu.fromJson(json);

          _success2(restaurantMenu);
        },
        failure: function failure(apiError) {
          _failure2(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
     * Retrieve the restaurant menu without synchronize him with the pos
     * The `stocksSource` set to false tell the api to not synchronize, but the stocks will be on the
     * response (without being updated with the POS).
     * @type {[type]}
     */

  }, {
    key: 'getLocalMenu',
    value: function getLocalMenu(restaurantId, _success3, _failure3) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          stocksSource: StocksSource.LOCAL_ONLY, // default true
          menuSource: MenuSource.LOCAL_ONLY
        },
        success: function success(json) {
          var restaurantMenu = new _menu.RestaurantMenu();
          restaurantMenu.fromJson(json);

          _success3(restaurantMenu);
        },
        failure: function failure(apiError) {
          _failure3(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
     *
     */

  }, {
    key: 'putMenu',
    value: function putMenu(restaurantId, restaurantMenu, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU.replace('{restaurantId}', restaurantId);

      var requestOptions = {
        endpoint: endpoint,
        data: restaurantMenu,
        success: function success(json) {
          var restaurantMenu = new _menu.RestaurantMenu();
          restaurantMenu.fromJson(json);

          _success4(restaurantMenu);
        },
        failure: function failure(apiError) {
          _failure4(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }

    //
    // Menu - Product
    //

  }, {
    key: 'postMenuProduct',
    value: function postMenuProduct(restaurantId, productToCreate, image, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCTS.replace('{restaurantId}', restaurantId);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          product: JSON.stringify(productToCreate)
        },
        files: files,
        success: function success(json) {

          var product = new _menu.Product();
          product.fromJson(json);

          _success5(product);
        },
        failure: function failure(apiError) {
          _failure5(apiError);
        }
      };

      _ApiManager2.default.postMultipart(requestOptions);
    }
  }, {
    key: 'putMenuProduct',
    value: function putMenuProduct(restaurantId, productToUpdate, image, _success6, _failure6) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT.replace('{restaurantId}', restaurantId).replace('{productId}', productToUpdate.id);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          product: JSON.stringify(productToUpdate)
        },
        files: files,
        success: function success(json) {

          var product = new _menu.Product();
          product.fromJson(json);

          _success6(product);
        },
        failure: function failure(apiError) {
          _failure6(apiError);
        }
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }, {
    key: 'deleteMenuProductImage',
    value: function deleteMenuProductImage(restaurantId, productToUpdate, _success7, _failure7) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT_IMAGE.replace('{restaurantId}', restaurantId).replace('{productId}', productToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {

          var product = new _menu.Product();
          product.fromJson(json);

          _success7(product);
        },
        failure: function failure(apiError) {
          _failure7(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'deleteMenuProduct',
    value: function deleteMenuProduct(restaurantId, productToDelete, _success8, _failure8) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT.replace('{restaurantId}', restaurantId).replace('{productId}', productToDelete.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success8(productToDelete);
        },
        failure: function failure(apiError) {
          _failure8(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }

    //
    // Menu - Menu
    //

  }, {
    key: 'postMenuMenu',
    value: function postMenuMenu(restaurantId, menuToCreate, image, _success9, _failure9) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENUS.replace('{restaurantId}', restaurantId);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          menu: JSON.stringify(menuToCreate)
        },
        files: files,
        success: function success(json) {

          var menu = new _menu.Menu();
          menu.fromJson(json);

          _success9(menu);
        },
        failure: function failure(apiError) {
          _failure9(apiError);
        }
      };

      _ApiManager2.default.postMultipart(requestOptions);
    }
  }, {
    key: 'putMenuMenu',
    value: function putMenuMenu(restaurantId, menuToUpdate, image, _success10, _failure10) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU.replace('{restaurantId}', restaurantId).replace('{menuId}', menuToUpdate.id);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          menu: JSON.stringify(menuToUpdate)
        },
        files: files,
        success: function success(json) {

          var menu = new _menu.Menu();
          menu.fromJson(json);

          _success10(menu);
        },
        failure: function failure(apiError) {
          _failure10(apiError);
        }
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }, {
    key: 'deleteMenuMenu',
    value: function deleteMenuMenu(restaurantId, menuToDelete, _success11, _failure11) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU.replace('{restaurantId}', restaurantId).replace('{menuId}', menuToDelete.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success11(menuToDelete);
        },
        failure: function failure(apiError) {
          _failure11(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'deleteMenuMenuImage',
    value: function deleteMenuMenuImage(restaurantId, menuToUpdate, _success12, _failure12) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU_IMAGE.replace('{restaurantId}', restaurantId).replace('{menuId}', menuToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        headers: { 'restaurant-id': restaurantId },
        success: function success(json) {

          var menu = new _menu.Menu();
          menu.fromJson(json);

          _success12(menu);
        },
        failure: function failure(apiError) {
          _failure12(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }

    //
    // Menu - Category
    //

  }, {
    key: 'postMenuCategory',
    value: function postMenuCategory(restaurantId, categoryToCreate, image, _success13, _failure13) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_CATEGORIES.replace('{restaurantId}', restaurantId);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          category: JSON.stringify(categoryToCreate)
        },
        files: files,
        success: function success(json) {

          var category = new _menu.ProductCategory();
          category.fromJson(json);

          _success13(category);
        },
        failure: function failure(apiError) {
          _failure13(apiError);
        }
      };

      _ApiManager2.default.postMultipart(requestOptions);
    }
  }, {
    key: 'putMenuCategory',
    value: function putMenuCategory(restaurantId, categoryToUpdate, image, success, failure) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_CATEGORY.replace('{restaurantId}', restaurantId).replace('{categoryId}', categoryToUpdate.id);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          category: JSON.stringify(categoryToUpdate)
        },
        files: files,
        success: success,
        failure: failure
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }, {
    key: 'deleteMenuCategoryImage',
    value: function deleteMenuCategoryImage(restaurantId, categoryToUpdate, _success14, _failure14) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_CATEGORY_IMAGE.replace('{restaurantId}', restaurantId).replace('{categoryId}', categoryToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          var category = new _menu.ProductCategory();
          category.fromJson(json);

          _success14(category);
        },
        failure: function failure(apiError) {
          _failure14(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'deleteMenuCategory',
    value: function deleteMenuCategory(restaurantId, categoryToDelete, image, _success15, _failure15) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_CATEGORY.replace('{restaurantId}', restaurantId).replace('{categoryId}', categoryToDelete.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success15(categoryToDelete);
        },
        failure: function failure(apiError) {
          _failure15(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }

    //
    // Menu - ProductOption
    //

  }, {
    key: 'postMenuProductOption',
    value: function postMenuProductOption(restaurantId, productOptionToCreate, image, _success16, _failure16) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT_OPTIONS.replace('{restaurantId}', restaurantId);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          option: JSON.stringify(productOptionToCreate)
        },
        files: files,
        success: function success(json) {

          var productOption = new _menu.ProductOption();
          productOption.fromJson(json);

          _success16(productOption);
        },
        failure: function failure(apiError) {
          _failure16(apiError);
        }
      };

      _ApiManager2.default.postMultipart(requestOptions);
    }
  }, {
    key: 'putMenuProductOption',
    value: function putMenuProductOption(restaurantId, productOptionToUpdate, image, _success17, _failure17) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT_OPTION.replace('{restaurantId}', restaurantId).replace('{productOptionId}', productOptionToUpdate.id);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          option: JSON.stringify(productOptionToUpdate)
        },
        files: files,
        success: function success(json) {

          var productOption = new _menu.ProductOption();
          productOption.fromJson(json);

          _success17(productOption);
        },
        failure: function failure(apiError) {
          _failure17(apiError);
        }
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }, {
    key: 'deleteMenuProductOptionImage',
    value: function deleteMenuProductOptionImage(restaurantId, productOptionToUpdate, _success18, _failure18) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT_OPTION_IMAGE.replace('{restaurantId}', restaurantId).replace('{productOptionId}', productOptionToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {

          var productOption = new _menu.ProductOption();
          productOption.fromJson(json);

          _success18(productOption);
        },
        failure: function failure(apiError) {
          _failure18(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'deleteMenuProductOption',
    value: function deleteMenuProductOption(restaurantId, productOptionToDelete, _success19, _failure19) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_PRODUCT_OPTION.replace('{restaurantId}', restaurantId).replace('{productOptionId}', productOptionToDelete.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success19(productOptionToDelete);
        },
        failure: function failure(apiError) {
          _failure19(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }

    //
    // Menu - Category
    //

  }, {
    key: 'postMenuUpsellingCategory',
    value: function postMenuUpsellingCategory(restaurantId, upsellingCategoryToCreate, image, _success20, _failure20) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_UPSELLING_CATEGORIES.replace('{restaurantId}', restaurantId);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          upsellingCategory: JSON.stringify(upsellingCategoryToCreate)
        },
        files: files,
        success: function success(json) {

          var upsellingCategory = new _menu.UpsellingCategory();
          upsellingCategory.fromJson(json);

          _success20(upsellingCategory);
        },
        failure: function failure(apiError) {
          _failure20(apiError);
        }
      };

      _ApiManager2.default.postMultipart(requestOptions);
    }
  }, {
    key: 'putMenuUpsellingCategory',
    value: function putMenuUpsellingCategory(restaurantId, upsellingCategoryToUpdate, image, _success21, _failure21) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_UPSELLING_CATEGORY.replace('{restaurantId}', restaurantId).replace('{upsellingCategoryId}', upsellingCategoryToUpdate.id);

      var files = {};
      if (!_lodash2.default.isNil(image)) {
        files.image = image;
      }

      var requestOptions = {
        endpoint: endpoint,
        data: {
          upsellingCategory: JSON.stringify(upsellingCategoryToUpdate)
        },
        files: files,
        success: function success(json) {

          var upsellingCategory = new _menu.UpsellingCategory();
          upsellingCategory.fromJson(json);

          _success21(upsellingCategory);
        },
        failure: function failure(apiError) {
          _failure21(apiError);
        }
      };

      _ApiManager2.default.putMultipart(requestOptions);
    }
  }, {
    key: 'deleteMenuUpsellingCategory',
    value: function deleteMenuUpsellingCategory(restaurantId, upsellingCategoryToDelete, image, _success22, _failure22) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_UPSELLING_CATEGORY.replace('{restaurantId}', restaurantId).replace('{upsellingCategoryId}', upsellingCategoryToDelete.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success22(upsellingCategoryToDelete);
        },
        failure: function failure(apiError) {
          _failure22(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }

    //
    // MenuPart
    //

  }, {
    key: 'updateMenuPart',
    value: function updateMenuPart(restaurantId, menu, menuPart, _success23, _failure23) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU_PART.replace('{restaurantId}', restaurantId).replace('{menuId}', menu.id).replace('{partId}', menuPart.id);

      var requestOptions = {
        endpoint: endpoint,
        data: menuPart,
        success: function success(json) {
          var updatedMenuPart = new _menu.MenuPart();
          updatedMenuPart.fromJson(json);

          _success23(updatedMenuPart);
        },
        failure: function failure(apiError) {
          _failure23(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }

    //
    // MenuPartCategory
    //

  }, {
    key: 'updateMenuPartCategory',
    value: function updateMenuPartCategory(restaurantId, menu, menuPart, menuPartCategory, _success24, _failure24) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU_PART_CATEGORY.replace('{restaurantId}', restaurantId).replace('{menuId}', menu.id).replace('{partId}', menuPart.id).replace('{categoryId}', menuPartCategory.id);

      var requestOptions = {
        endpoint: endpoint,
        data: menuPartCategory,
        success: function success(json) {

          var updatedMenuPartCategory = new _menu.MenuPartCategory();
          updatedMenuPartCategory.fromJson(json);

          _success24(updatedMenuPartCategory);
        },
        failure: function failure(apiError) {
          _failure24(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }, {
    key: 'uploadMenuPartCategoryImage',
    value: function uploadMenuPartCategoryImage(restaurantId, menu, menuPart, menuPartCategory, image, _success25, _failure25) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU_PART_CATEGORY_IMAGE.replace('{restaurantId}', restaurantId).replace('{menuId}', menu.id).replace('{partId}', menuPart.id).replace('{categoryId}', menuPartCategory.id);

      var files = {};
      files.image = image;

      var requestOptions = {
        endpoint: endpoint,
        files: files,
        success: function success(json) {
          var updatedMenuPartCategory = new _menu.MenuPartCategory();
          updatedMenuPartCategory.fromJson(json);

          _success25(updatedMenuPartCategory);
        },
        failure: function failure(apiError) {
          _failure25(apiError);
        }
      };

      _ApiManager2.default.postMultipart(requestOptions);
    }
  }, {
    key: 'removeMenuPartCategoryImage',
    value: function removeMenuPartCategoryImage(restaurantId, menu, menuPart, menuPartCategory, _success26, _failure26) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU_PART_CATEGORY_IMAGE.replace('{restaurantId}', restaurantId).replace('{menuId}', menu.id).replace('{partId}', menuPart.id).replace('{categoryId}', menuPartCategory.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {

          var updatedMenuPartCategory = new _menu.MenuPartCategory();
          updatedMenuPartCategory.fromJson(json);

          _success26(updatedMenuPartCategory);
        },
        failure: function failure(apiError) {
          _failure26(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'deleteMenuPartCategory',
    value: function deleteMenuPartCategory(restaurantId, menu, menuPart, menuPartCategory, _success27, _failure27) {
      var endpoint = _APIEndpoints2.default.RESTAURANT_MENU_MENU_PART_CATEGORY.replace('{restaurantId}', restaurantId).replace('{menuId}', menu.id).replace('{partId}', menuPart.id).replace('{categoryId}', menuPartCategory.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success27();
        },
        failure: function failure(apiError) {
          _failure27(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }]);

  return ApiRestaurantMenu;
}();

exports.default = ApiRestaurantMenu;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiRestaurantsGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- constants


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiObject = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject2 = _interopRequireDefault(_ApiObject);

var _RestaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/RestaurantsGroup.js");

var _RestaurantsGroup2 = _interopRequireDefault(_RestaurantsGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiRestaurantsGroup = function () {
  function ApiRestaurantsGroup() {
    _classCallCheck(this, ApiRestaurantsGroup);
  }

  _createClass(ApiRestaurantsGroup, null, [{
    key: 'getRestaurantsGroupWithDomain',
    value: function getRestaurantsGroupWithDomain(restaurantsGroupId, proDomain, loadChildren, _success, _failure) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUP.replace(':restaurantsGroupId', restaurantsGroupId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          loadChildren: loadChildren
        },
        headers: {
          'pro-domain-id': proDomain.id
        },
        success: function success(json) {
          console.log('[GET_RESTAURANT_GROUPS] SUCCESS: ', json);

          var restaurantsGroup = new _RestaurantsGroup2.default();
          restaurantsGroup.fromJson(json);

          _success(restaurantsGroup);
        },
        failure: function failure(apiError) {
          console.log('[GET_RESTAURANT_GROUPS] FAILURE: ', apiError);
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRestaurantsGroup',
    value: function getRestaurantsGroup(restaurantsGroupId, loadChildren, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUP.replace(':restaurantsGroupId', restaurantsGroupId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          loadChildren: loadChildren
        },
        success: function success(json) {
          console.log('[GET_RESTAURANT_GROUPS] SUCCESS: ', json);

          var restaurantsGroup = new _RestaurantsGroup2.default();
          restaurantsGroup.fromJson(json);

          _success2(restaurantsGroup);
        },
        failure: function failure(apiError) {
          console.log('[GET_RESTAURANT_GROUPS] FAILURE: ', apiError);
          _failure2(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
     * Create a new restaurantsGroup.
     */

  }, {
    key: 'postRestaurantsGroup',
    value: function postRestaurantsGroup(restaurantsGroup, _success3, _failure3) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUPS;

      var requestOptions = {
        endpoint: endpoint,
        data: restaurantsGroup,
        success: function success(json) {
          console.log('[POST_RESTAURANT_GROUPS] SUCCESS: ', json);

          var restaurantsGroup = new _RestaurantsGroup2.default();
          restaurantsGroup.fromJson(json);

          _success3(restaurantsGroup);
        },
        failure: function failure(apiError) {
          console.log('[POST_RESTAURANT_GROUPS] FAILURE: ', apiError);
          _failure3(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }

    /**
     * Update the restaurantsGroup.
     */

  }, {
    key: 'putRestaurantsGroup',
    value: function putRestaurantsGroup(restaurantsGroup, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUP.replace(':restaurantsGroupId', restaurantsGroup.id);

      var requestOptions = {
        endpoint: endpoint,
        data: restaurantsGroup,
        success: function success(json) {
          console.log('[PUT_RESTAURANT_GROUPS] SUCCESS: ', json);

          var restaurantsGroup = new _RestaurantsGroup2.default();
          restaurantsGroup.fromJson(json);

          _success4(restaurantsGroup);
        },
        failure: function failure(apiError) {
          console.log('[PUT_RESTAURANT_GROUPS] FAILURE: ', apiError);
          _failure4(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }, {
    key: 'getOrderStatistics',
    value: function getOrderStatistics(restaurantsGroupId, fromTime, toTime, modes, sourcesList, paymentMethods, restaurantsIds, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUP_ORDER_STATISTICS.replace('{restaurantsGroupId}', restaurantsGroupId);

      var requestOptions = {
        endpoint: endpoint,
        data: {
          fromTime: fromTime,
          toTime: toTime,
          modes: modes,
          sourcesList: sourcesList,
          //paymentMethods,
          restaurantsIds: restaurantsIds
        },
        success: function success(json) {
          console.log('[RESTAURANTS_GROUPS_GET_ORDER_STATISTICS] SUCCESS: ', json);

          // -- create the payment statistics object.
          var data = new _ApiObject2.default();
          data.fromJson(json);

          _success5(data);
        },
        failure: function failure(apiError) {
          console.log('[RESTAURANTS_GROUPS_GET_ORDER_STATISTICS] FAILURE: ', apiError);
          _failure5(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'getApiConsumers',
    value: function getApiConsumers(restaurantsGroupId, query, _success6, _failure6) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUP_API_CONSUMERS.replace('{restaurantsGroupId}', restaurantsGroupId);

      var requestOptions = {
        endpoint: endpoint,
        query: query,
        success: function success(json) {
          console.log('[RESTAURANTS_GROUPS_GET_API_CONSUMERS] SUCCESS: ', json);

          // -- create the payment statistics object.
          var data = new _ApiObject2.default();
          data.fromJson(json);

          _success6(data);
        },
        failure: function failure(apiError) {
          console.log('[RESTAURANTS_GROUPS_GET_API_CONSUMERS] FAILURE: ', apiError);
          _failure6(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }]);

  return ApiRestaurantsGroup;
}();

exports.default = ApiRestaurantsGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiRole.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- constants


// -- utils


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ProRole = __webpack_require__("./sdk/scripts/entities/security/ProRole.js");

var _ProRole2 = _interopRequireDefault(_ProRole);

var _ProRolesList = __webpack_require__("./sdk/scripts/entities/security/ProRolesList.js");

var _ProRolesList2 = _interopRequireDefault(_ProRolesList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiRole = function () {
  function ApiRole() {
    _classCallCheck(this, ApiRole);
  }

  _createClass(ApiRole, null, [{
    key: 'getRestaurantsGroupRoles',


    //
    // RestaurantsGroup Roles
    //

    value: function getRestaurantsGroupRoles(restaurantGroupIp, _success, _failure) {
      var endpoint = _APIEndpoints2.default.RESTAURANTS_GROUP_ROLES.replace(':restaurantsGroupId', restaurantGroupIp);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {

          var proRolesList = new _ProRolesList2.default();
          proRolesList.fromJson(json);

          _success(proRolesList);
        },
        failure: function failure(apiError) {
          _failure(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Role
    //

  }, {
    key: 'putRole',
    value: function putRole(proRoleToUpdate, _success2, _failure2) {
      var endpoint = _APIEndpoints2.default.PRO_ROLE.replace(':roleId', proRoleToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        data: proRoleToUpdate,
        success: function success(json) {

          var proRole = new _ProRole2.default();
          proRole.fromJson(json);

          _success2(proRole);
        },
        failure: function failure(apiError) {
          _failure2(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }, {
    key: 'postRole',
    value: function postRole(proRoleToCreate, _success3, _failure3) {
      var endpoint = _APIEndpoints2.default.PRO_ROLES;

      var requestOptions = {
        endpoint: endpoint,
        data: proRoleToCreate,
        success: function success(json) {

          var proRole = new _ProRole2.default();
          proRole.fromJson(json);

          _success3(proRole);
        },
        failure: function failure(apiError) {
          _failure3(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'deleteRole',
    value: function deleteRole(proRole, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.PRO_ROLE.replace(':roleId', proRole.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          _success4(proRole);
        },
        failure: function failure(apiError) {
          _failure4(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'getRole',
    value: function getRole(proRoleId, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.PRO_ROLE.replace(':roleId', proRoleId);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {

          var proRole = new _ProRole2.default();
          proRole.fromJson(json);

          _success5(proRole);
        },
        failure: function failure(apiError) {
          _failure5(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getRoleWithDomain',
    value: function getRoleWithDomain(proRoleId, domainId, _success6, _failure6) {
      var endpoint = _APIEndpoints2.default.PRO_ROLE.replace(':roleId', proRoleId);

      var requestOptions = {
        endpoint: endpoint,
        headers: {
          'pro-domain-id': domainId
        },
        success: function success(json) {

          var proRole = new _ProRole2.default();
          proRole.fromJson(json);

          _success6(proRole);
        },
        failure: function failure(apiError) {
          _failure6(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }]);

  return ApiRole;
}();

exports.default = ApiRole;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/api/ApiUser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// -- contants


// -- entities


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiManager = __webpack_require__("./sdk/scripts/api/ApiManager.js");

var _ApiManager2 = _interopRequireDefault(_ApiManager);

var _UserApiErrors = __webpack_require__("./sdk/scripts/utils/apiErrors/UserApiErrors.js");

var _UserApiErrors2 = _interopRequireDefault(_UserApiErrors);

var _MangoPayApiErrors = __webpack_require__("./sdk/scripts/utils/apiErrors/MangoPayApiErrors.js");

var _MangoPayApiErrors2 = _interopRequireDefault(_MangoPayApiErrors);

var _APIEndpoints = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints2 = _interopRequireDefault(_APIEndpoints);

var _entities = __webpack_require__("./sdk/scripts/entities/index.js");

var _user = __webpack_require__("./sdk/scripts/entities/user/index.js");

var _CreditCard = __webpack_require__("./sdk/scripts/entities/user/CreditCard.js");

var _CreditCard2 = _interopRequireDefault(_CreditCard);

var _CreditCardsList = __webpack_require__("./sdk/scripts/entities/user/CreditCardsList.js");

var _CreditCardsList2 = _interopRequireDefault(_CreditCardsList);

var _UserAccount = __webpack_require__("./sdk/scripts/entities/user/UserAccount.js");

var _UserAccount2 = _interopRequireDefault(_UserAccount);

var _UserAddress = __webpack_require__("./sdk/scripts/entities/user/UserAddress.js");

var _UserAddress2 = _interopRequireDefault(_UserAddress);

var _UserAddressesList = __webpack_require__("./sdk/scripts/entities/user/UserAddressesList.js");

var _UserAddressesList2 = _interopRequireDefault(_UserAddressesList);

var _security = __webpack_require__("./sdk/scripts/entities/security/index.js");

var _restaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiUser = function () {
  function ApiUser() {
    _classCallCheck(this, ApiUser);
  }

  _createClass(ApiUser, null, [{
    key: 'login',


    //
    // Current user
    //

    /**
     * Log the pro user on the API. Currently, there is no specific login route,
     * we test on the /me to retrieve the user info.
     *
     * @param username
     * @param password
     *
     * TODO: rename to LoginPro
     */
    value: function login(username, password, apiKey, _success, _failure) {

      // We don't use parent 'get' method, because we want to handle the 401 in a different way.

      var options = {
        url: _ApiManager2.default.config.apiUrl + _APIEndpoints2.default.LOGIN,
        headers: {
          Accept: 'application/json',
          Authorization: _ApiManager2.default.formatAuthorizationHeader(username, password),
          'api-consumer': apiKey
        },
        success: function success(res) {
          _success(username, password);
        },
        failure: function failure(error, res) {
          var apiError = _ApiManager2.default.createApiError(res.text);
          apiError.localizedMessage = _UserApiErrors2.default.login(apiError);
          _failure(apiError);
        }
      };

      _ApiManager2.default.getExtern(options);
    }

    /**
     * Log the pro user on the API. Currently, there is no specific login route,
     * we test on the /me to retrieve the user info.
     *
     * @param username
     * @param password
     */

  }, {
    key: 'loginSimpleUser',
    value: function loginSimpleUser(username, password, apiKey, _success2, _failure2) {

      // We don't use parent 'get' method, because we want to handle the 401 in a different way.

      var options = {
        url: _ApiManager2.default.config.apiUrl + _APIEndpoints2.default.USER_ME,
        headers: {
          Accept: 'application/json',
          Authorization: _ApiManager2.default.formatAuthorizationHeader(username, password, 'user'),
          'api-consumer': apiKey
        },
        success: function success(res) {
          var user = new _user.User().fromJson(JSON.parse(res.text));

          _success2(user, username, password);
        },
        failure: function failure(error, res) {
          var apiError = _ApiManager2.default.createApiError(res.text);
          apiError.localizedMessage = _UserApiErrors2.default.login(apiError);
          _failure2(apiError);
        }
      };

      _ApiManager2.default.getExtern(options);
    }

    //
    // Users
    //

    /**
     * Retrieve a list of users with the given users ids.
     * Note that a not found user will be given as an empty user object.
     *
     * @param usersIds
     * @param failureCallback
     */

  }, {
    key: 'getUsers',
    value: function getUsers(usersIds, _success3, _failure3) {
      if (_lodash2.default.isEmpty(usersIds)) {
        console.log('[USERS] array of ids empty');
        _success3(new _user.UsersList());
        return;
      }

      var requestOptions = {
        endpoint: _APIEndpoints2.default.USERS,
        query: {
          ids: _lodash2.default.join(_lodash2.default.uniq(usersIds), ',')
        },
        success: function success(json) {
          console.log('[USERS] SUCCESS: ', json);

          var usersList = new _user.UsersList();
          usersList.fromJson(json);

          _success3(usersList);
        },
        failure: function failure(apiError) {
          console.log('[USERS] FAILURE: ', apiError);
          _failure3(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Get single user
    //

    /**
     * Get the user's information for the logged in restaurant.
     * @param userId
     */

  }, {
    key: 'getUser',
    value: function getUser(userId, _success4, _failure4) {
      var endpoint = _APIEndpoints2.default.USER.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[USERS] SUCCESS: ', json);

          var user = new _user.User();
          user.fromJson(json);

          _success4(user);
        },
        failure: function failure(apiError) {
          console.log('[USERS] FAILURE: ', apiError);
          _failure4(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
     * Retrieve the user's information for a payment.
     * For now, it is used to retrieve the user's information for the logged in restaurant.
     * See UserModal, SummaryPage, ReviewView.
     *
     * @param userId
     * @param paymentId
     */

  }, {
    key: 'getUserForPayment',
    value: function getUserForPayment(userId, paymentId, _success5, _failure5) {
      var endpoint = _APIEndpoints2.default.USER.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          paymentId: paymentId
        },
        success: function success(json) {
          console.log('[USERS FOR PAYMENT] SUCCESS: ', json);

          var user = new _user.User();
          user.fromJson(json);

          _success5(user);
        },
        failure: function failure(apiError) {
          console.log('[USERS FOR PAYMENT] FAILURE: ', apiError);
          _failure5(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    /**
     * Retrieve the user's information for a review.
     * For now, it is used to retrieve the user's information for the logged in restaurant.
     * See UserModal, SummaryPage, ReviewView.
     *
     * @param userId
     * @param paymentId
     */

  }, {
    key: 'getUserForReview',
    value: function getUserForReview(userId, reviewId, _success6, _failure6) {
      var endpoint = _APIEndpoints2.default.USER.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        query: {
          reviewId: reviewId
        },
        success: function success(json) {
          console.log('[USERS FOR PAYMENT] SUCCESS: ', json);

          var user = new _user.User();
          user.fromJson(json);

          _success6(user);
        },
        failure: function failure(apiError) {
          console.log('[USERS FOR PAYMENT] FAILURE: ', apiError);
          _failure6(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // Create user
    //

  }, {
    key: 'postUser',
    value: function postUser(userToCreate, _success7, _failure7) {
      var endpoint = _APIEndpoints2.default.USERS;

      var requestOptions = {
        endpoint: endpoint,
        data: userToCreate,
        success: function success(json) {
          console.log('[POST USER] SUCCESS: ', json);

          var user = new _user.User().fromJson(json);
          user.generateRegisterId();

          _success7(user, userToCreate.email, userToCreate.password);
        },
        failure: function failure(apiError) {
          console.log('[POST USER] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postUser(apiError);
          _failure7(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'postUserWithoutSmsConfirmation',
    value: function postUserWithoutSmsConfirmation(userToCreate, _success8, _failure8) {
      var endpoint = _APIEndpoints2.default.USERS;

      var requestOptions = {
        endpoint: endpoint,
        data: userToCreate,
        query: {
          sendPhoneVerificationCode: false
        },
        success: function success(json) {
          console.log('[POST USER] SUCCESS: ', json);

          var user = new _user.User().fromJson(json);
          user.generateRegisterId();

          _success8(user, userToCreate.email, userToCreate.password);
        },
        failure: function failure(apiError) {
          console.log('[POST USER] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postUser(apiError);
          _failure8(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'postUserWithoutEmailAndSmsConfirmation',
    value: function postUserWithoutEmailAndSmsConfirmation(userToCreate, _success9, _failure9) {
      var endpoint = _APIEndpoints2.default.USERS;

      var requestOptions = {
        endpoint: endpoint,
        data: userToCreate,
        query: {
          sendPhoneVerificationCode: false,
          sendRegistrationEmail: false
        },
        success: function success(json) {
          console.log('[POST USER] SUCCESS: ', json);

          var user = new _user.User().fromJson(json);
          user.generateRegisterId();

          _success9(user, userToCreate.email, userToCreate.password);
        },
        failure: function failure(apiError) {
          console.log('[POST USER] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postUser(apiError);
          _failure9(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'postUserLightWithoutEmailAndSmsConfirmation',
    value: function postUserLightWithoutEmailAndSmsConfirmation(userToCreate, apiKey, _success10, _failure10) {
      var endpoint = _APIEndpoints2.default.USERS;

      var requestOptions = {
        endpoint: endpoint,
        data: userToCreate,
        query: {
          isUserLight: true,
          sendPhoneVerificationCode: false,
          sendRegistrationEmail: false
        },
        success: function success(json) {
          console.log('[POST USER LIGHT] SUCCESS: ', json);

          _success10(userToCreate);
        },
        failure: function failure(apiError) {
          if (apiError.code === "107") {
            _success10(userToCreate);
            return;
          }
          console.log('[POST USER LIGHT] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postUser(apiError);
          _failure10(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'postUserForRestaurantsGroup',
    value: function postUserForRestaurantsGroup(userToCreate, _success11, _failure11) {
      var endpoint = _APIEndpoints2.default.USERS;

      var requestOptions = {
        endpoint: endpoint,
        data: userToCreate,
        query: {
          sendPhoneVerificationCode: false,
          sendRegistrationEmail: false
        },
        success: function success(json) {
          console.log('[POST USER] SUCCESS: ', json);

          _success11(new _user.User().fromJson(json), userToCreate.email, userToCreate.password);
        },
        failure: function failure(apiError) {
          console.log('[POST USER] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postUser(apiError);
          _failure11(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }

    //
    // Update user
    //

  }, {
    key: 'putUser',
    value: function putUser(userId, userToUpdate, _success12, _failure12) {
      var endpoint = _APIEndpoints2.default.USER.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        data: userToUpdate,
        query: {
          sendPhoneVerificationCode: false
        },
        success: function success(json) {
          console.log('[PUT USER] SUCCESS: ', json);
          _success12(new _user.User().fromJson(json));
        },
        failure: function failure(apiError) {
          console.log('[PUT USER] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.putUser(apiError);
          _failure12(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }

    //
    // -------------- Credit card
    //

    //
    // CreditCard - GET
    //

  }, {
    key: 'getUserCreditCards',
    value: function getUserCreditCards(userId, _success13, _failure13) {
      var endpoint = _APIEndpoints2.default.USER_CREDIT_CARDS.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        query: {},
        success: function success(json) {
          console.log('[USER CREDIT CARDS] SUCCESS: ', json);

          var creditCardsList = new _CreditCardsList2.default();
          creditCardsList.fromJson(json);

          _success13(creditCardsList);
        },
        failure: function failure(apiError) {
          console.log('[USER CREDIT CARDS] FAILURE: ', apiError);
          _failure13(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }

    //
    // CreditCard - POST
    //

  }, {
    key: 'postUserCreditCard',
    value: function postUserCreditCard(userId, creditCard, success, failure) {
      ApiUser.registerCreditCard(userId, creditCard, function (registrationId, registrationData) {
        ApiUser.postCreditCard(userId, registrationId, registrationData, success, failure);
      }, failure);
    }
  }, {
    key: 'registerCreditCard',
    value: function registerCreditCard(userId, creditCard, _success14, _failure14) {
      var endpoint = _APIEndpoints2.default.ME_CREDIT_CARD_REGISTRATION;
      // const endpoint = APIEndpoints.USER_CREDIT_CARD_REGISTRATION.replace(':userId', userId);


      //	the id previously returned by POST /users/{user_id}/cards-registration
      var registrationId = void 0;

      // he content returned by the POST on the URL returned by the POST /users/{user_id}/cards-registration itself
      var registrationData = void 0;

      var options = {
        endpoint: endpoint,
        data: {
          /**
           * ISO_4217 format expected
           * @link https://www.wikiwand.com/en/ISO_4217
           */
          currency: creditCard.currency,

          /**
           * A custom short label describing the card (eg. "Biz", "Pro", "Perso", "Wife", ...)
           */
          name: creditCard.name
        },
        success: function success(json) {
          console.log('[REGISTER USER CREDIT CARD] SUCCESS: ', json);

          // {
          //  "id": "135813513",
          //  "data": "nqxcjnoNOZut09Q6d513q5DQ3z81z5ddZDSCXVV",
          //  "accessKeyRef": "AH546AAZ214567ZdzZD",
          //  "url": "https://payline.com/card-register"
          // }

          var url = json.url,
              id = json.id,
              data = json.data,
              accessKeyRef = json.accessKeyRef;


          registrationId = id;
          registrationData = data;

          _ApiManager2.default.postExtern({
            url: url,
            headers: {
              // 'Access-Control-Allow-Headers': '*',
              'Content-Type': _ApiManager2.default.ContentTypes.FORM_URL_ENCODE
            },
            data: {
              cardNumber: creditCard.getCleanNumber(),

              /**
               * should be formated as MMYY where MM are the 2 digits of the month (from 01 to 12) and YY are the 2 last digits of the year.
               */
              cardExpirationDate: creditCard.expirationDate.format('MMYY'),

              cardCvx: creditCard.cvv,

              data: registrationData,

              accessKeyRef: accessKeyRef
            },
            success: function success(response) {
              var registrationData = response.text;

              //
              // The mangopay api returns a 201 but with an errorCode inside..
              //
              if (_lodash2.default.includes(registrationData, 'errorCode=')) {
                console.log('POST EXTERN REGISTRAION CARD FAILURE', response.text);
                // get errorCode int
                var errorCode = _lodash2.default.replace(registrationData, 'errorCode=', '');

                var apiError = new _entities.ApiError();
                apiError.code = errorCode.trim();
                apiError.message = 'MangoPay error';

                apiError.localizedMessage = _MangoPayApiErrors2.default.registerCreditCart(apiError);
                _failure14(apiError);
              } else {
                console.log('POST EXTERN REGISTRAION CARD', response.text);
                _success14(registrationId, registrationData);
              }
            },
            failure: function failure(error, res) {
              // TODO
              _failure14();
            }
          });
        },
        failure: function failure(apiError) {
          console.log('[REGISTER USER CREDIT CARD] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postCreditCard(apiError);
          _failure14(apiError);
        }
      };

      _ApiManager2.default.post(options);
    }
  }, {
    key: 'postCreditCard',
    value: function postCreditCard(userId, registrationId, registrationData, _success15, _failure15) {

      /**
       * TODO: change ME for USER_CREDIT_CARDS when api updated.
       */
      var endpoint = _APIEndpoints2.default.ME_CREDIT_CARDS;

      //const endpoint = APIEndpoints.USER_CREDIT_CARDS.replace(':userId', userId); const endpoint = APIEndpoints.USER_CREDIT_CARDS.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        data: {
          registrationId: registrationId,
          registrationData: registrationData
        },
        success: function success(json) {
          console.log('[POST USER CREDIT CARD] SUCCESS: ', json);

          var newCreditCard = new _CreditCard2.default();
          newCreditCard.fromJson(json);

          _success15(newCreditCard);
        },
        failure: function failure(apiError) {
          console.log('[POST USER CREDIT CARD] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postCreditCard(apiError);
          _failure15(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'deleteCreditCard',
    value: function deleteCreditCard(userId, creditCard, _success16, _failure16) {
      /**
       * TODO: change ME for USER_CREDIT_CARDS when api updated.
       */
      var endpoint = _APIEndpoints2.default.ME_CREDIT_CARD.replace(':userId', userId).replace(':creditCardId', creditCard.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[DELETE USER CREDIT CARD] SUCCESS: ', json);

          _success16(creditCard);
        },
        failure: function failure(apiError) {
          console.log('[DELETE USER CREDIT CARD] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.deleteCreditCard(apiError);
          _failure16(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }

    //
    // -------------- Addresses
    //

  }, {
    key: 'getAddressesList',
    value: function getAddressesList(userId, _success17, _failure17) {
      var endpoint = _APIEndpoints2.default.USER_ADDRESSES.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[GET USER ADDRESSES] SUCCESS: ', json);

          var addressesList = new _UserAddressesList2.default();
          addressesList.fromJson(json);

          _success17(addressesList);
        },
        failure: function failure(apiError) {
          console.log('[GET USER ADDRESSES] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.getAddresses(apiError);
          _failure17(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'postAddress',
    value: function postAddress(userId, address, _success18, _failure18) {
      var endpoint = _APIEndpoints2.default.USER_ADDRESSES.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        data: address,
        success: function success(json) {
          console.log('[POST USER ADDRESS] SUCCESS: ', json);

          var newAddress = new _UserAddress2.default();
          newAddress.fromJson(json);

          _success18(newAddress);
        },
        failure: function failure(apiError) {
          console.log('[POST USER ADDRESS] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.postAddress(apiError);
          _failure18(apiError);
        }
      };

      _ApiManager2.default.post(requestOptions);
    }
  }, {
    key: 'putAddress',
    value: function putAddress(userId, addressToUpdate, _success19, _failure19) {
      var endpoint = _APIEndpoints2.default.USER_ADDRESS.replace(':userId', userId).replace(':addressId', addressToUpdate.id);

      var requestOptions = {
        endpoint: endpoint,
        data: addressToUpdate,
        success: function success(json) {
          console.log('[PUT USER ADDRESS] SUCCESS: ', json);

          var address = new _UserAddress2.default();
          address.fromJson(json);

          _success19(address);
        },
        failure: function failure(apiError) {
          console.log('[PUT USER ADDRESS] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.putAddress(apiError);
          _failure19(apiError);
        }
      };

      _ApiManager2.default.put(requestOptions);
    }
  }, {
    key: 'deleteAddress',
    value: function deleteAddress(userId, address, _success20, _failure20) {
      var endpoint = _APIEndpoints2.default.USER_ADDRESS.replace(':userId', userId).replace(':addressId', address.id);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[DELETE USER ADDRESS] SUCCESS: ', json);

          _success20(address);
        },
        failure: function failure(apiError) {
          console.log('[DELETE USER ADDRESS] FAILURE: ', apiError);
          apiError.localizedMessage = _UserApiErrors2.default.deleteAddress(apiError);
          _failure20(apiError);
        }
      };

      _ApiManager2.default.delete(requestOptions);
    }
  }, {
    key: 'getRecoverPassword',
    value: function getRecoverPassword(email, apiKey, _success21, _failure21) {
      var endpoint = _APIEndpoints2.default.USER_RECOVER_PASSWORD.replace(':userEmail', email);

      var requestOptions = {
        endpoint: endpoint,
        headers: {
          'api-consumer': apiKey
        },
        success: function success(json) {
          console.log('[POST RECOVER PASSWORD] SUCCESS: ', json);

          _success21();
        },
        failure: function failure(apiError) {
          console.log('[POST RECOVER PASSWORD] FAILURE: ', apiError);
          _failure21(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }, {
    key: 'getUserAccounts',
    value: function getUserAccounts(userId, _success22, _failure22) {
      var endpoint = _APIEndpoints2.default.USER_ACCOUNTS.replace(':userId', userId);

      var requestOptions = {
        endpoint: endpoint,
        success: function success(json) {
          console.log('[GET USER ACCOUNTS] SUCCESS: ', json);

          var userAccounts = [];
          userAccounts = json.map(function (userAccountJson) {
            var userAccount = new _UserAccount2.default();
            return userAccount.fromJson(userAccountJson);
          });

          _success22(userAccounts);
        },
        failure: function failure(apiError) {
          console.log('[GET USER ACCOUNTS] FAILURE: ', apiError);
          _failure22(apiError);
        }
      };

      _ApiManager2.default.get(requestOptions);
    }
  }]);

  return ApiUser;
}();

exports.default = ApiUser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/Ariane.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _Link = __webpack_require__("./sdk/scripts/components/Link.js");

var _Link2 = _interopRequireDefault(_Link);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Ariane = function (_Component) {
  _inherits(Ariane, _Component);

  function Ariane() {
    _classCallCheck(this, Ariane);

    return _possibleConstructorReturn(this, (Ariane.__proto__ || Object.getPrototypeOf(Ariane)).apply(this, arguments));
  }

  _createClass(Ariane, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var arianeNames = [];

      var details = this.props.details;

      for (var i = 0; i < details.length; i++) {
        var name = details[i].name;
        var link = details[i].link;
        var params = details[i].params;
        var query = details[i].query;

        // -- Setup name class
        var className = (0, _classnames2.default)('ariane__name', 'ariane_level__' + i);

        // -- Setup link if exists. We just put the name otherwise.
        var nameView = _react2.default.createElement(
          'span',
          { className: className },
          name
        );

        if (!_lodash2.default.isNull(link) && !_lodash2.default.isEmpty(link)) {
          // handle null or empty string link.
          nameView = _react2.default.createElement(
            _Link2.default,
            { to: link, params: params, className: className, query: query },
            name
          );
        }

        arianeNames.push(_react2.default.createElement(
          'span',
          { key: i },
          nameView,
          i !== details.length - 1 && _react2.default.createElement(
            'span',
            { className: 'ariane_separator' },
            '>'
          )
        ));
      }

      return _react2.default.createElement(
        'div',
        { id: 'ariane' },
        _react2.default.createElement('i', { className: 'fa ' + this.props.icon }),
        arianeNames
      );
    }
  }]);

  return Ariane;
}(_react.Component);

Ariane.propTypes = {
  icon: _propTypes2.default.string.isRequired,

  /**
   * Array of {
      name: 'Commande',
      link: null or Route (ex: RoutingEnum.ORDER_LIST). It also handle an empty string
      params: object,
      query: object
    }
   */
  details: _propTypes2.default.array.isRequired
};
exports.default = Ariane;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/Button.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Button(props) {
  return _react2.default.createElement(
    'button',
    {
      className: props.className,
      onClick: props.onClick,
      type: props.type,
      disabled: props.disabled
    },
    props.children
  );
}

Button.defaultProps = {
  disabled: false,
  className: '',
  type: 'button'
};

Button.propTypes = {
  /**
   * Handler to be called when the user click the button
   */
  onClick: _propTypes2.default.func.isRequired,

  /**
   * If true, disable all interactions for this component.
   */
  disabled: _propTypes2.default.bool,

  className: _propTypes2.default.string,

  type: _propTypes2.default.string
};

exports.default = Button;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/Calendar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flatpickr = __webpack_require__("./node_modules/flatpickr/dist/flatpickr.js");

var _flatpickr2 = _interopRequireDefault(_flatpickr);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * TODO: better readOnly
 */
var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.id = _Utils2.default.generateUID(), _this.onChange = function (date) {
      if (!_this.props.readOnly) {
        _this.props.onChange((0, _moment2.default)(date));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Calendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateCalendarView();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.updateCalendarView();
    }
  }, {
    key: 'updateCalendarView',
    value: function updateCalendarView() {
      // change the first day of the week to Monday
      _flatpickr2.default.init.prototype.l10n.firstDayOfWeek = 1;

      // Localize. See https://github.com/chmln/flatpickr/blob/gh-pages/src/flatpickr.l10n.fr.js

      _flatpickr2.default.init.prototype.l10n = _I18n2.default.localizeFlatpickr(_flatpickr2.default.init.prototype.l10n);
      var dateFormat = 'd-M-Y';

      // -- find default date

      var minDate = this.props.minDate;
      var maxDate = this.props.maxDate;

      (0, _flatpickr2.default)('#' + this.id, {
        dateFormat: dateFormat,
        defaultDate: this.props.defaultDate.toDate(),
        minDate: _lodash2.default.isNull(minDate) ? null : minDate.toDate(),
        maxDate: _lodash2.default.isNull(maxDate) ? null : maxDate.toDate(),
        onChange: this.onChange,
        disable: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.inline) {
        return _react2.default.createElement(
          'div',
          { className: 'calendar' },
          _react2.default.createElement('input', {
            id: this.id,
            className: 'hidden',
            'data-inline': true
          })
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'calendar-not-inline' },
          _react2.default.createElement('input', {
            className: 'form-control',
            id: this.id
          })
        );
      }
    }
  }]);

  return Calendar;
}(_react.Component);

Calendar.defaultProps = {
  readOnly: false,

  inline: true,

  maxDate: null,

  minDate: null
};
Calendar.propTypes = {
  defaultDate: _propTypes2.default.object.isRequired, // moment object
  maxDate: _propTypes2.default.object, // moment object
  minDate: _propTypes2.default.object, // moment object
  onChange: _propTypes2.default.func.isRequired, // param: moment object
  readOnly: _propTypes2.default.bool,

  // Should we dislpay a button to open the calendar.
  inline: _propTypes2.default.bool
};
exports.default = Calendar;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/EnabledDisabledIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnabledDisabledIcon = function (_Component) {
  _inherits(EnabledDisabledIcon, _Component);

  function EnabledDisabledIcon() {
    _classCallCheck(this, EnabledDisabledIcon);

    return _possibleConstructorReturn(this, (EnabledDisabledIcon.__proto__ || Object.getPrototypeOf(EnabledDisabledIcon)).apply(this, arguments));
  }

  _createClass(EnabledDisabledIcon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.value !== nextProps.value || this.props.isDisable !== nextProps.isDisable;
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('enabled_disabled_icon', {
        enabled: this.value === true,
        disabled: this.value === false,
        force_disabled: this.props.isDisable === true
      });

      return _react2.default.createElement('span', {
        'data-toggle': 'tooltip',
        'data-title': this.props.placeholder,
        className: className,
        style: this.props.style
      });
    }
  }, {
    key: 'value',
    get: function get() {
      return this.props.value;
    }
  }]);

  return EnabledDisabledIcon;
}(_react.Component);

EnabledDisabledIcon.propTypes = {
  value: _propTypes2.default.bool.isRequired,

  isDisable: _propTypes2.default.bool,

  placeholder: _propTypes2.default.string,

  style: _propTypes2.default.object
};
EnabledDisabledIcon.defaultProps = {
  isDisable: false,

  style: null
};
exports.default = EnabledDisabledIcon;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/GoogleApiComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ScriptCache = __webpack_require__("./sdk/scripts/utils/ScriptCache.js");

var _ScriptCache2 = _interopRequireDefault(_ScriptCache);

var _GoogleApi = __webpack_require__("./sdk/scripts/utils/GoogleApi.js");

var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * https://gist.github.com/auser/1d55aa3897f15d17caf21dc39b85b663#file-googleapi-js-L1-Lundefined
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var defaultMapConfig = {};
var wrapper = exports.wrapper = function wrapper(options) {
  return function (WrappedComponent) {
    var apiKey = options.apiKey;
    var libraries = options.libraries || ['places'];
    var version = options.version;
    var url = options.url;

    var Wrapper = function (_React$Component) {
      _inherits(Wrapper, _React$Component);

      function Wrapper(props, context) {
        _classCallCheck(this, Wrapper);

        var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

        _this.state = {
          loaded: false,
          google: null
        };
        return _this;
      }

      _createClass(Wrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.scriptCache.google.onLoad(function (err, tag) {
            var props = _lodash2.default.assign({}, _this2.props, {
              loaded: _this2.state.loaded
            });

            _this2.setState({
              loaded: true,
              google: window.google
            });
          });
        }
      }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.scriptCache = (0, _ScriptCache2.default)({
            google: (0, _GoogleApi2.default)({
              apiKey: apiKey,
              libraries: libraries,
              version: version,
              url: url
            })
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var props = _lodash2.default.assign({}, this.props, {
            loaded: this.state.loaded,
            google: this.state.google
          });

          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(WrappedComponent, props)
          );
        }
      }]);

      return Wrapper;
    }(_react2.default.Component);

    return Wrapper;
  };
};

exports.default = wrapper;

/***/ }),

/***/ "./sdk/scripts/components/HibpPasswordRangeContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hibp = __webpack_require__("./node_modules/hibp/es/hibp.js");

var _isEmpty = __webpack_require__("./sdk/node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _debounce = __webpack_require__("./sdk/node_modules/lodash/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _find = __webpack_require__("./sdk/node_modules/lodash/find.js");

var _find2 = _interopRequireDefault(_find);

var _Sha = __webpack_require__("./sdk/scripts/utils/Sha1.js");

var _Sha2 = _interopRequireDefault(_Sha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * see https://haveibeenpwned.com/API/v2#SearchingPwnedPasswordsByRange
 */
var HibpPasswordRangeContainer = function (_React$Component) {
  _inherits(HibpPasswordRangeContainer, _React$Component);

  function HibpPasswordRangeContainer(props) {
    _classCallCheck(this, HibpPasswordRangeContainer);

    var _this = _possibleConstructorReturn(this, (HibpPasswordRangeContainer.__proto__ || Object.getPrototypeOf(HibpPasswordRangeContainer)).call(this, props));

    _this.check = (0, _debounce2.default)(function (password) {
      if ((0, _isEmpty2.default)(password) || password.length < _this.props.minLength) {
        _this.setState({
          isPwned: false,
          count: 0,
          isFetching: false
        });
        return;
      }

      var shaValue = _Sha2.default.hash(password);
      var prefix = shaValue.substring(0, 5).toUpperCase();
      var suffix = shaValue.substring(5).toUpperCase();

      _this.setState({
        isFetching: true
      });

      (0, _hibp.pwnedPasswordRange)(prefix).then(function (results) {
        var pwdData = (0, _find2.default)(results, function (data) {
          return data.suffix === suffix;
        });

        var isPwned = pwdData !== undefined;

        _this.setState({
          isPwned: isPwned,
          count: isPwned ? pwdData.count : 0,
          isFetching: false
        });
      });
    }, 300);


    _this.state = {
      isPwned: false,
      count: 0,
      isFetching: false
    };
    return _this;
  }

  _createClass(HibpPasswordRangeContainer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.password !== this.props.password) {
        this.check(this.props.password);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          isPwned = _state.isPwned,
          count = _state.count,
          isFetching = _state.isFetching;


      return children({
        isPwned: isPwned,
        count: count,
        isFetching: isFetching
      });
    }
  }]);

  return HibpPasswordRangeContainer;
}(_react2.default.Component);

HibpPasswordRangeContainer.defaultProps = {
  minLength: 4
};

HibpPasswordRangeContainer.propTypes = {
  children: _propTypes2.default.func.isRequired,

  password: _propTypes2.default.string,

  /**
   * min length after which we begin to test the password
   */
  minLength: _propTypes2.default.number
};

exports.default = HibpPasswordRangeContainer;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/ImageLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

var _ViewConstants = __webpack_require__("./sdk/scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * See https://github.com/hzdg/react-imageloader/blob/master/src/index.js
 */


var span = _react2.default.DOM.span;


var Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed'
};

var ImageLoader = function (_Component) {
  _inherits(ImageLoader, _Component);

  function ImageLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageLoader.__proto__ || Object.getPrototypeOf(ImageLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      status: _this.props.src ? Status.LOADING : Status.PENDING
    }, _this.handleLoad = function (event) {
      _this.destroyLoader();
      _this.setState({
        status: Status.LOADED
      });

      if (_this.props.onLoad) _this.props.onLoad(event);
    }, _this.handleError = function (error) {
      _this.destroyLoader();
      _this.setState({
        status: Status.FAILED
      });

      console.warn('Could not load the image with url ' + _this.props.src);
      if (_this.props.onError) _this.props.onError(error);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.status === Status.LOADING) {
        this.createLoader();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.src !== nextProps.src) {
        this.setState({
          status: nextProps.src ? Status.LOADING : Status.PENDING
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, newState) {
      return this.props.src !== nextProps.src || this.state.status !== newState.status;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.status === Status.LOADING && !this.img) {
        this.createLoader();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroyLoader();
    }
  }, {
    key: 'createLoader',
    value: function createLoader() {
      this.destroyLoader(); // We can only have one loader at a time.

      this.img = new Image();
      this.img.onload = this.handleLoad;
      this.img.onerror = this.handleError;

      if (!_lodash2.default.isEmpty(this.props.src)) {
        this.img.src = this.props.src;
      }
    }
  }, {
    key: 'destroyLoader',
    value: function destroyLoader() {
      if (this.img) {
        this.img.src = ''; // https://github.com/hzdg/react-imageloader/pull/28/files
        this.img.onload = null;
        this.img.onerror = null;
        this.img = null;
      }
    }
  }, {
    key: 'renderImg',
    value: function renderImg() {
      var _props = this.props,
          src = _props.src,
          imgProps = _props.imgProps;

      var props = { src: src };

      for (var k in imgProps) {
        if (imgProps.hasOwnProperty(k)) {
          props[k] = imgProps[k];
        }
      }

      return _react2.default.createElement('img', _extends({}, props, { role: 'presentation', className: this.props.className }));
    }
  }, {
    key: 'renderDefaultPreloader',
    value: function renderDefaultPreloader() {
      return _react2.default.createElement(
        'div',
        { className: 'image_loader image_loader__preloader' },
        _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
      );
    }
  }, {
    key: 'renderDefaultFailed',
    value: function renderDefaultFailed() {
      return _react2.default.createElement(
        'div',
        {
          className: 'image_loader image_loader__failed'
        },
        _react2.default.createElement('i', { className: 'fa fa-chain-broken' })
      );
    }
  }, {
    key: 'renderPlaceholder',
    value: function renderPlaceholder() {
      var placeholderImg = this.props.placeholder;

      var className = (0, _classnames2.default)('image_loader image_loader__placeholder', _defineProperty({}, '' + this.props.className, !_lodash2.default.isNull(this.props.className)));

      return _react2.default.createElement('img', {
        className: className,
        role: 'presentation',
        src: _lodash2.default.isNull(placeholderImg) ? _ViewConstants2.default.IMAGE_UPLOAD_PLACEHOLDER() : placeholderImg
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2;

      var wrapperProps = {};

      if (this.props.style) {
        wrapperProps.style = this.props.style;
      }

      wrapperProps.onClick = this.props.onClick;

      var wrapperArgs = [wrapperProps];

      if (_lodash2.default.isNull(this.props.src) || _lodash2.default.isEmpty(this.props.src) || this.props.src === 'https://storage.googleapis.com/null') {
        return this.renderPlaceholder();
      }

      switch (this.state.status) {
        case Status.LOADED:
          // TIP uncomment this line and comment the other to design test the loading spinner
          // use the .image_loader__preloader class
          // wrapperArgs.push(this.renderDefaultPreloader());

          wrapperArgs.push(this.renderImg());
          break;

        case Status.FAILED:
          if (this.props.children) {
            wrapperArgs.push(this.props.children);
          } else {
            wrapperArgs.push(this.renderDefaultFailed());
          }
          break;

        default:
          if (this.props.preloader) {
            wrapperArgs.push(this.props.preloader());
          } else {
            wrapperArgs.push(this.renderDefaultPreloader());
          }
          break;
      }

      return (_props2 = this.props).wrapper.apply(_props2, wrapperArgs);
    }
  }, {
    key: 'className',
    get: function get() {
      return (0, _classnames2.default)('imageloader', this.state.status, _defineProperty({}, '' + this.props.className, !_lodash2.default.isNull(this.props.className)));
    }
  }]);

  return ImageLoader;
}(_react.Component);

ImageLoader.propTypes = {
  src: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  wrapper: _propTypes2.default.func,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  preloader: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  imgProps: _propTypes2.default.object,
  children: _propTypes2.default.object,
  onClick: _propTypes2.default.func
};
ImageLoader.defaultProps = {
  wrapper: span,
  className: null,
  placeholder: null,
  onClick: function onClick() {}
};
exports.default = ImageLoader;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/Link.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bool = _propTypes2.default.bool,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string,
    func = _propTypes2.default.func,
    any = _propTypes2.default.any;


var routerShape = _propTypes2.default.shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query,
      hash = _ref.hash,
      state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

function constructPathWithParams(path, params) {
  if (!_lodash2.default.isNull(params)) {
    // replace params. On url definition, params start with ':'
    _lodash2.default.forIn(params, function (param, key) {
      path = path.replace(':' + key, param);
    });
  }

  return path;
}

/**
 * inspired by https://github.com/reactjs/react-router/blob/master/modules/Link.js/**
 *
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * You could use the following component to link to a route:
 *
 *   <Link to={RoutingEnum.DASHBOARD} />
 *   where RoutingEnum.DASHBOARD is a Route object.
 *
 * or
 *
 *    <Link path="/users" />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */

var Link = function (_Component) {
  _inherits(Link, _Component);

  function Link() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref2, [this].concat(args))), _this), _this.handleClick = function (event) {
      var allowTransition = true;

      if (!_lodash2.default.isUndefined(_this.props.onClick)) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        allowTransition = false;
      }

      // If target prop is set (e.g. to "_blank") let browser handle link.
      /* istanbul ignore if: untestable with Karma */
      if (_this.props.target) {
        if (!allowTransition) {
          event.preventDefault();
        }
        return;
      }

      event.preventDefault();

      if (allowTransition) {
        var _this$props = _this.props,
            to = _this$props.to,
            query = _this$props.query,
            hash = _this$props.hash,
            state = _this$props.state,
            params = _this$props.params;


        var path = constructPathWithParams(to.path, params);

        var location = createLocationDescriptor(path, { query: query, hash: hash, state: state });

        //      console.log('[LINK]', this, location);
        _this.context.router.push(location);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- action

  _createClass(Link, [{
    key: 'render',


    // -- renderers

    value: function render() {
      var _props = this.props,
          to = _props.to,
          query = _props.query,
          hash = _props.hash,
          state = _props.state,
          activeClassName = _props.activeClassName,
          activeStyle = _props.activeStyle,
          onlyActiveOnIndex = _props.onlyActiveOnIndex,
          className = _props.className,
          params = _props.params,
          target = _props.target;


      var props = {
        target: target
      };

      props.className = className;

      // Ignore if rendered outside the context of router, simplifies unit testing.
      var router = this.context.router;

      // console.log(this.context);

      if (router && to) {
        var path = constructPathWithParams(to.path, params);

        var location = createLocationDescriptor(path, { query: query, hash: hash, state: state });

        props.href = router.createHref(location);

        //     console.log('[LINK]', props.href);

        if (activeClassName || activeStyle !== null && !_lodash2.default.isEmpty(activeStyle)) {
          if (router.isActive(location, onlyActiveOnIndex)) {
            if (activeClassName) {
              props.className += props.className === '' ? activeClassName : ' ' + activeClassName;
            }

            if (activeStyle) {
              props.style = _lodash2.default.merge(this.props.style, activeStyle);
            }
          }
        }
      }

      // console.log('[LINK]', props);

      return _react2.default.createElement(
        'a',
        _extends({}, props, {
          onClick: this.handleClick
        }),
        this.props.children
      );
    }
  }]);

  return Link;
}(_react.Component);

Link.propTypes = {
  to: object.isRequired,
  query: object,
  hash: string,
  state: object,
  activeStyle: object,
  activeClassName: string,
  onlyActiveOnIndex: bool.isRequired,
  onClick: func,
  target: object,
  className: string,
  style: object,
  children: any
};
Link.defaultProps = {
  onlyActiveOnIndex: false,
  className: '',
  style: {}
};


Link.contextTypes = {
  router: routerShape
};

exports.default = Link;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/OnLoadingContentViewForModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OnLoadingContentViewForModal(props) {
  return _react2.default.createElement(
    'div',
    { className: 'on_loading_content_view_for_modal text-center' },
    props.displayMessage && _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
  );
}

OnLoadingContentViewForModal.propTypes = {
  /**
   * Should we display a loading message ?
   */
  displayMessage: _propTypes2.default.bool
};

OnLoadingContentViewForModal.defaultProps = {
  displayMessage: true
};

exports.default = OnLoadingContentViewForModal;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/SearchBox.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBox = function (_Component) {
  _inherits(SearchBox, _Component);

  function SearchBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call.apply(_ref, [this].concat(args))), _this), _this.onHandleSubmit = function () {
      var value = _this.refs.filterTextInput.value;
      _this.props.onSearchSubmit(value);
    }, _this.onHandleChange = function () {
      var value = _this.refs.filterTextInput.value;
      _this.props.onSearchInput(value);
    }, _this.onClear = function () {
      _this.props.onSearchInput('');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBox, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.search !== this.props.search;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        {
          className: 'search_box form-horizontal',
          onSubmit: this.onHandleSubmit
        },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            { className: 'input-group' },
            _react2.default.createElement('input', {
              type: 'text',
              placeholder: _I18n2.default.tr('components.search_box.search'),
              value: this.props.search,
              ref: 'filterTextInput',
              onChange: this.onHandleChange,
              className: 'form-control'
            }),
            _react2.default.createElement(
              'div',
              {
                className: 'input-group-addon pointer',
                onClick: this.onClear
              },
              _react2.default.createElement('i', { className: 'fa fa-close' })
            )
          )
        )
      );
    }
  }]);

  return SearchBox;
}(_react.Component);

SearchBox.propTypes = {
  search: _propTypes2.default.string,
  onSearchInput: _propTypes2.default.func.isRequired,
  onSearchSubmit: _propTypes2.default.func
};
SearchBox.defaultProps = {
  search: '',
  onSearchSubmit: function onSearchSubmit() {}
};
exports.default = SearchBox;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/SortableList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSortableHoc = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/index.js");

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * See doc here: https://github.com/clauderic/react-sortable-hoc
 *
 * The renderer must return a component with a class 'row'.
 * Each 'case' of the component have to use a col-* class.
 * The container have to use the class 'row' and can use the class 'table_container'
 */
var SortableList = function (_Component) {
  _inherits(SortableList, _Component);

  function SortableList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SortableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortableList.__proto__ || Object.getPrototypeOf(SortableList)).call.apply(_ref, [this].concat(args))), _this), _this.onSortEnd = function (_ref2) {
      var oldIndex = _ref2.oldIndex,
          newIndex = _ref2.newIndex;
      var items = _this.props.items;


      _this.props.onChange((0, _reactSortableHoc.arrayMove)(items, oldIndex, newIndex));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SortableList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.props.items;


      var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref3) {
        var value = _ref3.value;

        //
        // Render view
        //

        var _props = _this2.props,
            renderer = _props.renderer,
            displayDragIcon = _props.displayDragIcon;

        var view = null;

        if (!_lodash2.default.isNull(renderer)) {
          view = _react2.default.createElement(
            'div',
            { className: 'custom_renderer_sortable_item' },
            renderer(value)
          );
        } else {
          // default rendering.
          view = _react2.default.createElement(
            'div',
            { className: 'default_renderer_sortable_item' },
            value
          );
        }

        //
        // Drag icon
        //

        var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
          return _react2.default.createElement(
            'span',
            { className: 'drag_icon' },
            _react2.default.createElement('i', { className: 'fa fa-bars' })
          );
        });

        //
        // Render
        //

        return _react2.default.createElement(
          'div',
          { className: 'sortable_item' },
          displayDragIcon && _react2.default.createElement(DragHandle, null),
          view
        );
      });

      var SortableListContainer = (0, _reactSortableHoc.SortableContainer)(function (_ref4) {
        var items = _ref4.items;

        return _react2.default.createElement(
          'div',
          { className: 'sortable_list__container' },
          items.map(function (value, index) {
            return _react2.default.createElement(SortableItem, {
              key: 'item-' + index,
              index: index,
              value: value
            });
          })
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'sortable_list col-xs-12' },
        _react2.default.createElement(SortableListContainer, {
          items: items,
          onSortEnd: this.onSortEnd,
          useDragHandle: true
        })
      );
    }
  }]);

  return SortableList;
}(_react.Component);

SortableList.DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react2.default.createElement('i', { className: 'fa fa-bars sortable_list__drag_handle pointer' });
});
SortableList.SortableHandle = _reactSortableHoc.SortableHandle;
SortableList.defaultProps = {
  renderer: null,

  displayDragIcon: false
};
SortableList.propTypes = {
  className: _propTypes2.default.object,

  /**
  * A function that will render each row.
  * @type func
  * @param item
  */
  renderer: _propTypes2.default.func,

  items: _propTypes2.default.array.isRequired,

  /**
   * Should we display a drag icon ?
   * @type {[type]}
   */
  displayDragIcon: _propTypes2.default.bool,

  /**
   * The function called
   * @type func
   *
   * @param array of items
   */
  onChange: _propTypes2.default.func.isRequired
};
exports.default = SortableList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/SvgIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SvgIcon = function (_Component) {
  _inherits(SvgIcon, _Component);

  function SvgIcon() {
    _classCallCheck(this, SvgIcon);

    return _possibleConstructorReturn(this, (SvgIcon.__proto__ || Object.getPrototypeOf(SvgIcon)).apply(this, arguments));
  }

  _createClass(SvgIcon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.icon !== this.props.icon;
    }
  }, {
    key: 'renderLoadingBar',
    value: function renderLoadingBar(style, className) {
      return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 32 32', width: '32', height: '32',
          fill: 'white', style: style, className: className },
        _react2.default.createElement(
          'path',
          { transform: 'translate(2)', d: 'M0 12 V20 H4 V12z' },
          _react2.default.createElement('animate', { attributeName: 'd',
            values: 'M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z',
            dur: '1.2s', repeatCount: 'indefinite', begin: '0', keyTimes: '0;.2;.5;1',
            keySplines: '0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8', calcMode: 'spline' })
        ),
        _react2.default.createElement(
          'path',
          { transform: 'translate(8)', d: 'M0 12 V20 H4 V12z' },
          _react2.default.createElement('animate', { attributeName: 'd',
            values: 'M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z',
            dur: '1.2s', repeatCount: 'indefinite', begin: '0.2', keyTimes: '0;.2;.5;1',
            keySplines: '0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8', calcMode: 'spline' })
        ),
        _react2.default.createElement(
          'path',
          { transform: 'translate(14)', d: 'M0 12 V20 H4 V12z' },
          _react2.default.createElement('animate', { attributeName: 'd',
            values: 'M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z',
            dur: '1.2s', repeatCount: 'indefinite', begin: '0.4', keyTimes: '0;.2;.5;1',
            keySplines: '0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8', calcMode: 'spline' })
        ),
        _react2.default.createElement(
          'path',
          { transform: 'translate(20)', d: 'M0 12 V20 H4 V12z' },
          _react2.default.createElement('animate', { attributeName: 'd',
            values: 'M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z',
            dur: '1.2s', repeatCount: 'indefinite', begin: '0.6', keyTimes: '0;.2;.5;1',
            keySplines: '0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8', calcMode: 'spline' })
        ),
        _react2.default.createElement(
          'path',
          { transform: 'translate(26)', d: 'M0 12 V20 H4 V12z' },
          _react2.default.createElement('animate', { attributeName: 'd',
            values: 'M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z',
            dur: '1.2s', repeatCount: 'indefinite', begin: '0.8', keyTimes: '0;.2;.5;1',
            keySplines: '0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8', calcMode: 'spline' })
        )
      );
    }
  }, {
    key: 'renderDownloadIcon',
    value: function renderDownloadIcon(style, className) {
      return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 481 481', style: style, className: className },
        _react2.default.createElement('path', {
          d: 'M230.95,394.3c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l87.7-87.7c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-64.7,64.7\r V13.5c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v338.6l-64.7-64.7c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1L230.95,394.3z'
        }),
        _react2.default.createElement('path', {
          d: 'M439.55,354.7c-7.5,0-13.5,6-13.5,13.5V454H54.85v-85.8c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v99.3\r c0,7.5,6,13.5,13.5,13.5h398.3c7.5,0,13.5-6,13.5-13.5v-99.3C453.05,360.7,447.05,354.7,439.55,354.7z'
        })
      );
    }
  }, {
    key: 'renderUploadIcon',
    value: function renderUploadIcon(style, className) {
      return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px',
          viewBox: '0 0 384.97 384.97', style: style, className: className },
        _react2.default.createElement('path', { d: 'M372.939,264.641c-6.641,0-12.03,5.39-12.03,12.03v84.212H24.061v-84.212c0-6.641-5.39-12.03-12.03-12.03\r S0,270.031,0,276.671v96.242c0,6.641,5.39,12.03,12.03,12.03h360.909c6.641,0,12.03-5.39,12.03-12.03v-96.242\r C384.97,270.019,379.58,264.641,372.939,264.641z' }),
        _react2.default.createElement('path', { d: 'M117.067,103.507l63.46-62.558v235.71c0,6.641,5.438,12.03,12.151,12.03c6.713,0,12.151-5.39,12.151-12.03V40.95\r l63.46,62.558c4.74,4.704,12.439,4.704,17.179,0c4.74-4.704,4.752-12.319,0-17.011l-84.2-82.997\r c-4.692-4.656-12.584-4.608-17.191,0L99.888,86.496c-4.752,4.704-4.74,12.319,0,17.011\r C104.628,108.211,112.327,108.211,117.067,103.507z' })
      );
    }
  }, {
    key: 'renderOrderDeliveryIcon',
    value: function renderOrderDeliveryIcon(style, className) {
      return _react2.default.createElement(
        'svg',
        { viewBox: '0 0 436.842 436.842', style: style, className: className },
        _react2.default.createElement('path', { d: 'M343.746,154.841c-12.696,0-24.804,2.558-35.842,7.18l-26.394-51.211h36.89c4.002,0,7.258,3.256,7.258,7.258\r s-3.256,7.258-7.258,7.258h-7.871c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h7.871c12.273,0,22.258-9.985,22.258-22.258\r s-9.984-22.258-22.258-22.258h-49.192c-2.615,0-5.042,1.363-6.404,3.596c-1.361,2.233-1.461,5.015-0.263,7.34l13.125,25.467H167.423\r l-10.92-21.403h17.269c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-49.193c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h15.084\r l14.576,28.568l-17.132,26.543c-13.113-7.065-28.101-11.08-44.011-11.08C41.763,154.841,0,196.603,0,247.936\r c0,51.333,41.763,93.096,93.096,93.096c48.808,0,88.961-37.757,92.793-85.596h22.007l-8.549,27.818h-4.922\r c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h27c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-6.386l9.869-32.114l62.406-96.327\r l7.269,14.103c-26.357,16.458-43.933,45.723-43.933,79.02c0,51.333,41.763,93.096,93.097,93.096\r c51.333,0,93.096-41.763,93.096-93.096C436.842,196.603,395.079,154.841,343.746,154.841z M162.121,154.826l43.678,85.61h-19.911\r c-2.162-26.985-15.882-50.758-36.193-66.359L162.121,154.826z M170.824,240.436h-63.96l34.661-53.699\r C157.734,199.592,168.745,218.724,170.824,240.436z M93.096,326.032C50.033,326.032,15,290.999,15,247.936\r c0-43.062,35.033-78.096,78.096-78.096c12.914,0,25.095,3.17,35.837,8.743l-42.139,65.285c-1.489,2.307-1.598,5.244-0.284,7.655\r c1.313,2.411,3.84,3.912,6.586,3.912h77.728C167.036,294.992,133.628,326.032,93.096,326.032z M218.819,232.949l-43.743-85.737\r h99.289L218.819,232.949z M343.746,326.032c-43.063,0-78.097-35.034-78.097-78.096c0-27.498,14.298-51.704,35.838-65.623\r l35.592,69.059c1.332,2.583,3.954,4.065,6.673,4.065c1.157,0,2.331-0.269,3.43-0.835c3.683-1.897,5.129-6.42,3.231-10.103\r l-35.603-69.079c8.956-3.586,18.714-5.581,28.936-5.581c43.063,0,78.096,35.034,78.096,78.096\r C421.842,290.999,386.809,326.032,343.746,326.032z' })
      );
    }
  }, {
    key: 'renderOrderOnSite',
    value: function renderOrderOnSite(style, className) {
      return _react2.default.createElement(
        'svg',
        { viewBox: '-5.5 -4.849 258 235', style: style, className: className },
        _react2.default.createElement('path', { d: 'M-0.963,126.016v29.012L-1,227.301h7.667v-64.982h72v64.982H86l0.443-66.508c8.548-2.89,14.722-10.978,14.722-20.486\r c0-11.922-9.699-21.623-21.621-21.623l-72.877,0.299V0h-7.333L-0.963,126.016z M6.838,127.488h76.375\r c4.938,0,8.952,5.899,8.952,13.151s-4.017,13.154-8.952,13.154H6.838V127.488L6.838,127.488z' }),
        _react2.default.createElement('path', { d: 'M249.667,0h-7.333v118.981l-72.878-0.299c-11.922,0-21.621,9.7-21.621,21.623c0,9.51,6.174,17.598,14.722,20.485\r l0.443,66.51l7.334-0.002v-64.981h72v64.981H250l-0.037-72.272v-29.012L249.667,0z M242.162,153.795h-76.375\r c-4.936,0-8.951-5.903-8.951-13.155s4.016-13.151,8.951-13.151h76.375V153.795z' }),
        _react2.default.createElement('polygon', { points: '39.5,89.651 210,89.651 210,98.151 129,98.151 129,226.651 121,226.651 121,98.151 39.5,98.151 \t' })
      );
    }
  }, {
    key: 'renderOrderTakeAway',
    value: function renderOrderTakeAway(style, className) {
      return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 235.503 235.503', style: style, className: className },
        _react2.default.createElement('path', {
          d: 'M202.127,124.088c-1.395-0.581-2.974-0.276-4.048,0.813l-6.636,6.624V83.959c0-13.312-7.923-25.503-19.934-31.095V20.1\r c0.461-0.607,0.865-1.274,0.865-2.098V3.723c0-2.058-1.654-3.723-3.719-3.723h-0.865h-21.443h-0.89\r c-2.052,0-3.711,1.665-3.711,3.723v14.279c0,0.832,0.417,1.523,0.882,2.136v32.719c-12.027,5.574-19.932,17.761-19.932,31.096\r v43.098l-2.174-2.164c-0.675-0.674-1.701-0.982-2.717-1.01V95.72c0-5.252-2.347-9.883-5.941-13.171\r c3.484-2.005,5.941-5.624,5.941-9.916c0-6.376-5.202-11.582-11.578-11.582H54.094c-6.398,0-11.604,5.2-11.604,11.582\r c0,4.292,2.457,7.902,5.943,9.908c-3.597,3.296-5.943,7.927-5.943,13.179v34.228l-5.071-5.069\r c-1.076-1.078-2.659-1.387-4.051-0.806c-1.387,0.553-2.292,1.903-2.292,3.43v104.27c0,2.06,1.665,3.731,3.715,3.731h165.765\r c2.048,0,3.703-1.655,3.719-3.715l0.152-104.286C204.427,126.012,203.509,124.649,202.127,124.088z M196.853,228.093H38.509\r v-91.622l3.99,3.991l3.715,3.728l3.711,3.711l2.829,2.837c1.395,1.379,3.859,1.379,5.25,0l18.174-18.186l18.174,18.186\r c1.395,1.379,3.863,1.379,5.251,0l10.764-10.78l3.713-3.727l3.643-3.631l0.068,0.076l4.907,4.89l7.42,7.413l4.793,4.785\r l0.949,0.95c1.395,1.426,3.863,1.382,5.246,0l0.966-0.95l17.216-17.248l17.236,17.248l0.949,0.95c1.395,1.382,3.863,1.382,5.246,0\r l0.949-0.95h0.321v-0.309l7.43-7.45l5.534-5.534L196.853,228.093z M49.917,72.633c0-2.292,1.87-4.144,4.17-4.144h52.132\r c2.296,0,4.154,1.851,4.154,4.144c0,2.292-1.857,4.155-4.154,4.155H54.086C51.794,76.794,49.917,74.925,49.917,72.633z\r M60.492,85.148h39.321c5.827,0,10.568,4.741,10.568,10.58v10.866H49.925V95.728C49.917,89.889,54.649,85.148,60.492,85.148z\r M49.917,114.003h60.456v15.443l-13.393,13.396l-17.953-17.965c-1.396-1.387-4.294-1.387-5.692,0l-17.959,17.965l-5.458-5.454\r V114.003z M150.059,7.418h14.029v6.862h-14.029V7.418z M130.125,83.943c0-11.122,7.037-21.231,17.513-25.148\r c1.471-0.545,2.421-1.925,2.421-3.48V21.716h14.029v33.598c0,1.555,0.966,2.936,2.408,3.473\r c10.488,3.939,17.525,14.04,17.525,25.156v4.178h-53.896V83.943z M130.125,95.555h53.896v43.401l-3.896,3.887l-17.953-17.965\r c-1.411-1.387-4.341-1.387-5.719,0l-17.941,17.965l-8.363-8.367v-38.92H130.125z'
        }),
        _react2.default.createElement('path', {
          d: 'M175.971,163.81h-0.017c-2.052,0-3.711,1.655-3.711,3.695l-0.028,15.625l-0.016,7.409l-0.048,17.833H63.255v-17.833\r v-3.723v-3.711v-15.609c0-2.039-1.663-3.71-3.713-3.71c-2.048,0-3.715,1.671-3.715,3.71v14.399v3.971v3.723v22.51\r c0,2.04,1.667,3.72,3.715,3.72h116.32c2.048,0,3.702-1.655,3.719-3.72l0.048-21.56l0.012-7.409l0.057-15.598\r C179.681,165.48,178.01,163.81,175.971,163.81z'
        })
      );
    }
  }, {
    key: 'renderOrderAtBar',
    value: function renderOrderAtBar(style, className) {
      return _react2.default.createElement(
        'svg',
        { viewBox: '0 0 463 463', style: style, className: className },
        _react2.default.createElement('path', { d: 'M455.5,220H7.5c-4.142,0-7.5,3.358-7.5,7.5v32c0,4.142,3.358,7.5,7.5,7.5H8v136.5c0,4.142,3.358,7.5,7.5,7.5H120v17\r h-16.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h48c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H135v-17\r h193v17h-16.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h48c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5\r H343v-17h104.5c4.142,0,7.5-3.358,7.5-7.5V267h0.5c4.142,0,7.5-3.358,7.5-7.5v-32C463,223.358,459.642,220,455.5,220z M120,396\r H23V267h52.262l10.133,45.598C87.802,323.433,97.236,331,108.335,331H120V396z M108.335,316c-4.015,0-7.427-2.737-8.298-6.656\r L97.739,299H159.5c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5H108.335z M328,364h-24.5c-4.142,0-7.5,3.358-7.5,7.5\r c0,4.142,3.358,7.5,7.5,7.5H328v17H135v-17h24.5c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H135v-33h24.5\r c12.958,0,23.5-10.542,23.5-23.5S172.458,284,159.5,284h-64c-0.366,0-0.726,0.026-1.078,0.077L90.627,267h281.745l-3.795,17.077\r c-0.352-0.051-0.711-0.077-1.078-0.077h-64c-12.958,0-23.5,10.542-23.5,23.5s10.542,23.5,23.5,23.5H328V364z M303.5,316\r c-4.687,0-8.5-3.813-8.5-8.5s3.813-8.5,8.5-8.5h61.761l-2.298,10.344c-0.871,3.919-4.283,6.656-8.298,6.656H303.5z M440,396h-97\r v-65h11.665c11.099,0,20.533-7.567,22.94-18.402L387.738,267H440V396z M448,252h-0.5h-56.525\r c0.247-3.636-2.181-7.007-5.848-7.821c-4.04-0.898-8.049,1.651-8.948,5.694L375.706,252H87.294l-0.473-2.127\r c-0.899-4.043-4.902-6.594-8.948-5.694c-3.666,0.814-6.095,4.186-5.848,7.821H15.5H15v-17h433V252z' }),
        _react2.default.createElement('path', { d: 'M455.5,20H7.5C3.358,20,0,23.358,0,27.5v32C0,63.642,3.358,67,7.5,67H96v25.723c-18.205,3.515-32,19.561-32,38.777\r c0,4.142,3.358,7.5,7.5,7.5H96v0.5c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V139h24.5c4.142,0,7.5-3.358,7.5-7.5\r c0-19.216-13.795-35.262-32-38.777V67h113v25.723c-18.205,3.515-32,19.561-32,38.777c0,4.142,3.358,7.5,7.5,7.5H224v0.5\r c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V139h24.5c4.142,0,7.5-3.358,7.5-7.5c0-19.216-13.795-35.262-32-38.777V67\r h113v25.723c-18.205,3.515-32,19.561-32,38.777c0,4.142,3.358,7.5,7.5,7.5H352v0.5c0,4.142,3.358,7.5,7.5,7.5\r c4.142,0,7.5-3.358,7.5-7.5V139h24.5c4.142,0,7.5-3.358,7.5-7.5c0-19.216-13.795-35.262-32-38.777V67h88.5\r c4.142,0,7.5-3.358,7.5-7.5v-32C463,23.358,459.642,20,455.5,20z M126.826,124H80.174c3.175-9.853,12.432-17,23.326-17\r S123.651,114.147,126.826,124z M254.826,124h-46.652c3.175-9.853,12.432-17,23.326-17C242.394,107,251.651,114.147,254.826,124z\r M382.826,124h-46.652c3.175-9.853,12.432-17,23.326-17S379.651,114.147,382.826,124z M448,52H15V35h433V52z' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderers = [{
        icon: SvgIcon.LOADING_BAR,
        handler: this.renderLoadingBar
      }, {
        icon: SvgIcon.DOWNLOAD,
        handler: this.renderDownloadIcon
      }, {
        icon: SvgIcon.UPLOAD,
        handler: this.renderUploadIcon
      }, {
        icon: SvgIcon.ORDER_DELIVERY,
        handler: this.renderOrderDeliveryIcon
      }, {
        icon: SvgIcon.ORDER_ON_SITE,
        handler: this.renderOrderOnSite
      }, {
        icon: SvgIcon.ORDER_TAKE_AWAY,
        handler: this.renderOrderTakeAway
      }, {
        icon: SvgIcon.ORDER_AT_BAR,
        handler: this.renderOrderAtBar
      }];

      var info = _lodash2.default.find(renderers, function (info) {
        return info.icon === _this2.props.icon;
      });

      if (_lodash2.default.isUndefined(info)) {
        _Logger2.default.notImplemented('SvgIcon', 'Invalid SvgIcon icon: ' + this.props.icon);
        return null;
      }

      return info.handler(this.props.style, this.props.className);
    }
  }]);

  return SvgIcon;
}(_react.Component);

SvgIcon.LOADING_BAR = 0;
SvgIcon.DOWNLOAD = 1;
SvgIcon.UPLOAD = 2;
SvgIcon.ORDER_DELIVERY = 3;
SvgIcon.ORDER_ON_SITE = 4;
SvgIcon.ORDER_TAKE_AWAY = 5;
SvgIcon.ORDER_AT_BAR = 6;
SvgIcon.propTypes = {
  icon: _propTypes2.default.number.isRequired,

  style: _propTypes2.default.object,

  className: _propTypes2.default.string
};
SvgIcon.defaultProps = {
  style: {},
  className: ""
};
exports.default = SvgIcon;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/TipTooltip.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TipTooltip = function (_Component) {
  _inherits(TipTooltip, _Component);

  function TipTooltip() {
    _classCallCheck(this, TipTooltip);

    return _possibleConstructorReturn(this, (TipTooltip.__proto__ || Object.getPrototypeOf(TipTooltip)).apply(this, arguments));
  }

  _createClass(TipTooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // -- bootstrap tooltip
      $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className || "glyphicon glyphicon-question-sign";

      return _react2.default.createElement(
        'sup',
        { className: 'tip_tooltip' },
        _react2.default.createElement('i', {
          className: className,
          'data-toggle': 'tooltip',
          'data-placement': this.props.placement,
          title: this.props.text
        })
      );
    }
  }]);

  return TipTooltip;
}(_react.Component);

TipTooltip.Placement = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom'
};
TipTooltip.propTypes = {
  text: _propTypes2.default.string.isRequired,

  placement: _propTypes2.default.string
};
TipTooltip.defaultProps = {
  placement: TipTooltip.Placement.TOP
};
exports.default = TipTooltip;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/AllergenChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _DietaryConstants = __webpack_require__("./sdk/scripts/constants/DietaryConstants.js");

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var AllergenChooser = function (_Component) {
  _inherits(AllergenChooser, _Component);

  function AllergenChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AllergenChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AllergenChooser.__proto__ || Object.getPrototypeOf(AllergenChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (options) {
      if (_lodash2.default.isNull(options)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(options.map(function (option) {
          return option.value;
        }));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AllergenChooser, [{
    key: 'render',
    value: function render() {
      var options = (0, _DietaryConstants.getAllergenOptions)();

      return _react2.default.createElement(
        'div',
        { className: 'allergen_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.allergens,
          options: options,
          onChange: this.onChange,
          clearable: this.props.clearable,
          readOnly: this.props.readOnly,
          multi: true
        })
      );
    }
  }]);

  return AllergenChooser;
}(_react.Component);

AllergenChooser.defaultProps = {
  clearable: true,

  readOnly: false
};
AllergenChooser.propTypes = {
  allergens: _propTypes2.default.array.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool
};
exports.default = AllergenChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/BitfieldChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _BitUtils = __webpack_require__("./sdk/scripts/utils/BitUtils.js");

var _BitUtils2 = _interopRequireDefault(_BitUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views

var BitfieldChooser = function (_Component) {
  _inherits(BitfieldChooser, _Component);

  function BitfieldChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BitfieldChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BitfieldChooser.__proto__ || Object.getPrototypeOf(BitfieldChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (mask) {
      if (_lodash2.default.isNull(mask)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(mask);
      }
    }, _this.onToggleItem = function (item) {
      var mask = _this.props.mask;
      var value = item.value;

      if (_this.props.multiple) {
        _this.onChange(_BitUtils2.default.toggle(mask, value));
      } else {
        _this.onChange(value);
      }
    }, _this.renderSelected = function () {
      return _react2.default.createElement('i', { className: 'fa fa-check-' + (_this.props.multiple ? 'square' : 'circle') + '-o' });
    }, _this.renderUnselected = function () {
      return _react2.default.createElement('i', { className: 'fa fa-' + (_this.props.multiple ? 'square' : 'circle') + '-o' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  //
  //
  //

  _createClass(BitfieldChooser, [{
    key: 'renderItem',
    value: function renderItem(item) {
      var _this2 = this;

      var bitIsSet = this.props.multiple ? _BitUtils2.default.isSet(this.props.mask, item.value) : this.props.mask === item.value;

      return _react2.default.createElement(
        'div',
        {
          key: item.value,
          className: 'bitfield_chooser__item',
          onClick: function onClick() {
            !_this2.props.readOnly && _this2.onToggleItem(item);
          }
        },
        bitIsSet && this.renderSelected(),
        !bitIsSet && this.renderUnselected(),
        '\xA0\xA0',
        item.label
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'bitfield_chooser disable-user-select' },
        this.props.options.map(function (item) {
          return _this3.renderItem(item);
        })
      );
    }
  }]);

  return BitfieldChooser;
}(_react.Component);

BitfieldChooser.defaultProps = {
  mask: 0,
  multiple: true,
  readOnly: false
};
BitfieldChooser.propTypes = {
  mask: _propTypes2.default.number,
  multiple: _propTypes2.default.bool,

  /**
  * @type array { label: string, value: number }
  */
  options: _propTypes2.default.array.isRequired,

  // param: String, the chosen POS
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
exports.default = BitfieldChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/CountryChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _CountriesList = __webpack_require__("./sdk/scripts/constants/CountriesList.js");

var _CountriesList2 = _interopRequireDefault(_CountriesList);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var CountryChooser = function (_Component) {
  _inherits(CountryChooser, _Component);

  function CountryChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CountryChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountryChooser.__proto__ || Object.getPrototypeOf(CountryChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (option) {
      if (_lodash2.default.isNull(option)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CountryChooser, [{
    key: 'render',
    value: function render() {
      var options = _CountriesList2.default.getCountriesListForPicker();

      return _react2.default.createElement(
        'div',
        { className: 'country_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.country,
          options: options,
          onChange: this.onChange,
          clearable: this.props.clearable,
          readOnly: this.props.readOnly
        })
      );
    }
  }]);

  return CountryChooser;
}(_react.Component);

CountryChooser.defaultProps = {
  clearable: false,

  readOnly: false
};
CountryChooser.propTypes = {
  // 'FR' for example
  country: _propTypes2.default.string.isRequired,

  // param: String (Country code 'FR' for example.)
  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool
};
exports.default = CountryChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/CropImageModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _reactCropper = __webpack_require__("./node_modules/react-cropper/dist/react-cropper.js");

var _reactCropper2 = _interopRequireDefault(_reactCropper);

var _OnLoadingContentViewForModal = __webpack_require__("./sdk/scripts/components/OnLoadingContentViewForModal.js");

var _OnLoadingContentViewForModal2 = _interopRequireDefault(_OnLoadingContentViewForModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


/**
 */
var CropImageModal = function (_Component) {
  _inherits(CropImageModal, _Component);

  function CropImageModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CropImageModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CropImageModal.__proto__ || Object.getPrototypeOf(CropImageModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false
    }, _this.onHide = function () {
      _this.props.onHide();
    }, _this.onClose = function () {
      _this.props.onHide();
    }, _this.onValidate = function () {
      var canvas = _this.refs.cropper.getCroppedCanvas();
      _this.setState({
        loading: true
      }, function () {
        if (!_lodash2.default.isNull(_this.props.width) && !_lodash2.default.isNull(_this.props.height)) {
          // resize image
          _ViewUtils2.default.resizeCanvasImg(canvas, _this.props.width, _this.props.height).then(function (newImgDataUrl) {
            _this.setState({
              loading: false
            }, function () {
              _this.props.onValidate(newImgDataUrl);
              _this.props.onHide();
            });
          });
        } else {
          var imageDataUrl = canvas.toDataURL();
          _this.setState({
            loading: false
          }, function () {
            _this.props.onValidate(imageDataUrl);
            _this.props.onHide();
          });
        }
      });

      // test:
      //    const png = imageDataUrl.split(',')[1];
      //    const file = new Blob([window.atob(png)], { type: 'image/png', encoding: 'utf-8' });
      //    console.log(file);
    }, _this.onCrop = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events - modal

  // -- events crop

  _createClass(CropImageModal, [{
    key: 'renderBody',


    // -- renderers

    value: function renderBody() {
      if (this.state.loading) {
        return _react2.default.createElement(_OnLoadingContentViewForModal2.default, null);
      }

      return _react2.default.createElement(
        'div',
        { className: 'crop_modal' },
        _react2.default.createElement(
          'div',
          { className: 'top-buffer-20' },
          _react2.default.createElement(_reactCropper2.default, {
            ref: 'cropper',
            src: this.props.imageUrl,
            style: { height: 400, width: '100%' }
            // Cropper.js options. See https://github.com/fengyuanchen/cropperjs#aspectratio
            , aspectRatio: this.props.aspectRatio,
            guides: false,
            crop: this.onCrop,
            viewMode: 1
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-center top-buffer-30' },
          _react2.default.createElement(
            'button',
            {
              onClick: this.onValidate,
              className: 'btn btn-primary'
            },
            _I18n2.default.tr('components.crop_image.submit')
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onClose,
          backdrop: 'static'
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _I18n2.default.tr('components.crop_image.title')
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return CropImageModal;
}(_react.Component);

CropImageModal.defaultProps = {
  width: null,

  height: null
};
CropImageModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,

  onHide: _propTypes2.default.func.isRequired,

  imageUrl: _propTypes2.default.string.isRequired,

  aspectRatio: _propTypes2.default.number.isRequired,

  onValidate: _propTypes2.default.func.isRequired,

  /**
   * The width to set to the cropped image.
   * @type {[type]}
   */
  width: _propTypes2.default.number,

  /**
   * The height to set to the cropped image.
   */
  height: _propTypes2.default.number
};
exports.default = CropImageModal;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/CurrencyChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var CurrencyChooser = function (_Component) {
  _inherits(CurrencyChooser, _Component);

  function CurrencyChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CurrencyChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CurrencyChooser.__proto__ || Object.getPrototypeOf(CurrencyChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (option) {
      if (_lodash2.default.isNull(option)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CurrencyChooser, [{
    key: 'render',
    value: function render() {
      var options = _CurrencyUtils2.default.getApiCurrencyOptions();

      return _react2.default.createElement(
        'div',
        { className: 'country_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.value,
          options: options,
          onChange: this.onChange,
          clearable: this.props.clearable
        })
      );
    }
  }]);

  return CurrencyChooser;
}(_react.Component);

CurrencyChooser.defaultProps = {
  clearable: false
};
CurrencyChooser.propTypes = {
  // 'EUR' for example
  value: _propTypes2.default.string.isRequired,

  // param: String (Country code 'FR' for example.)
  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool
};
exports.default = CurrencyChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/DateField.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _Calendar = __webpack_require__("./sdk/scripts/components/Calendar.js");

var _Calendar2 = _interopRequireDefault(_Calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var DateField = function (_Component) {
  _inherits(DateField, _Component);

  function DateField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateField.__proto__ || Object.getPrototypeOf(DateField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayCalendar: false
    }, _this.onToggle = function () {
      _this.setState({
        displayCalendar: !_this.state.displayCalendar
      });
    }, _this.onChange = function (date) {
      _this.props.onChange(date);
      _this.onToggle();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateField, [{
    key: 'render',
    value: function render() {
      var dateTimeFieldValue = this.props.date.locale(_I18n2.default.getCurrentLanguageWithoutRegionCode()).format(this.props.dateFormat);

      return _react2.default.createElement(
        'div',
        {
          className: 'date_field input-group'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'form-control',
            onClick: this.onToggle
          },
          dateTimeFieldValue
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'input-group-addon',
            onClick: this.onToggle
          },
          _react2.default.createElement('i', { className: 'fa fa-calendar' })
        ),
        this.state.displayCalendar && _react2.default.createElement(_Calendar2.default, {
          minDate: this.props.minDate,
          maxDate: this.props.maxDate,
          inline: true,
          readOnly: this.props.readOnly,
          onChange: this.onChange,
          defaultDate: this.props.date
        })
      );
    }
  }]);

  return DateField;
}(_react.Component);

DateField.DEFAULT_DATE_FORMAT = 'dddd DD MMMM YYYY';
DateField.defaultProps = {
  readOnly: false,

  dateFormat: DateField.DEFAULT_DATE_FORMAT,

  date: new _moment2.default(),
  maxDate: null,
  minDate: null
};
DateField.propTypes = {
  // param: moment date
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool,

  dateFormat: _propTypes2.default.string,

  date: _propTypes2.default.object.isRequired,
  maxDate: _propTypes2.default.object, // moment object
  minDate: _propTypes2.default.object // moment object
};
exports.default = DateField;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/EmailInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailInput = function (_Component) {
    _inherits(EmailInput, _Component);

    function EmailInput() {
        _classCallCheck(this, EmailInput);

        return _possibleConstructorReturn(this, (EmailInput.__proto__ || Object.getPrototypeOf(EmailInput)).apply(this, arguments));
    }

    _createClass(EmailInput, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var className = (0, _classnames2.default)('form-control', this.props.className, {
                error: this.props.error
            });

            return _react2.default.createElement('input', {
                type: 'email',
                onChange: function onChange(event) {
                    _this2.props.onChange(event.target.value);
                },
                onBlur: this.props.onBlur,
                placeholder: this.props.placeholder,
                value: this.props.value || '',
                className: className,
                disabled: this.props.readOnly
            });
        }
    }]);

    return EmailInput;
}(_react.Component);

EmailInput.defaultProps = {
    readOnly: false,

    required: false,

    onBlur: function onBlur() {},

    error: false
};
EmailInput.propTypes = {
    value: _propTypes2.default.string,

    placeholder: _propTypes2.default.string,

    /**
     * @param number The phone number
     */
    onChange: _propTypes2.default.func.isRequired,

    onBlur: _propTypes2.default.func,

    className: _propTypes2.default.string,

    readOnly: _propTypes2.default.bool,

    required: _propTypes2.default.bool,

    error: _propTypes2.default.bool
};
exports.default = EmailInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/EmailsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _EmailInput = __webpack_require__("./sdk/scripts/components/form/EmailInput.js");

var _EmailInput2 = _interopRequireDefault(_EmailInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailsList = function (_Component) {
  _inherits(EmailsList, _Component);

  function EmailsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EmailsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailsList.__proto__ || Object.getPrototypeOf(EmailsList)).call.apply(_ref, [this].concat(args))), _this), _this.onAddClicked = function () {
      var emailsList = _this.emailsList;

      emailsList.push('');

      _this.props.onChange(emailsList);
    }, _this.onChange = function (email, index) {
      var emailsList = _this.emailsList;

      emailsList[index] = email;

      _this.props.onChange(emailsList);
    }, _this.onDelete = function (index) {
      var emailsList = _this.emailsList;
      var emailToDelete = emailsList[index];

      if (emailToDelete.length === 0) {
        // empty, delete it without asking confirmation
        emailsList.splice(index, 1);
        _this.props.onChange(emailsList);
      } else {
        _Notify2.default.confirmDelete(_I18n2.default.tr('components.emails_list.are_you_sure'), function (result) {
          if (result) {
            emailsList.splice(index, 1);
            _this.props.onChange(emailsList);
          }
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EmailsList, [{
    key: 'renderEmailsList',


    //
    // Renderers
    //

    value: function renderEmailsList(emailsList) {
      var _this2 = this;

      var listView = [];

      _lodash2.default.each(emailsList, function (email, index) {
        listView.push(_react2.default.createElement(
          'div',
          { className: 'input-group', style: style.listItem },
          _react2.default.createElement(_EmailInput2.default, {
            key: index,
            className: 'form-control',
            value: email,
            onChange: function onChange(email) {
              _this2.onChange(email, index);
            },
            readOnly: _this2.props.disabled
          }),
          _react2.default.createElement(
            'div',
            { className: 'input-group-addon' },
            !_this2.props.disabled && _react2.default.createElement('i', {
              className: 'fa fa-trash pointer',
              onClick: function onClick() {
                _this2.onDelete(index);
              }
            })
          )
        ));
      });

      return listView;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'emails_list' },
        this.renderEmailsList(this.emailsList),
        !this.props.disabled && _react2.default.createElement(
          'div',
          {
            style: style.link,
            className: 'link',
            onClick: this.onAddClicked
          },
          _I18n2.default.tr('components.emails_list.add_email')
        )
      );
    }
  }, {
    key: 'emailsList',
    get: function get() {
      return this.props.list;
    }
  }]);

  return EmailsList;
}(_react.Component);

EmailsList.defaultProps = {
  disabled: false
};
EmailsList.propTypes = {
  value: _propTypes2.default.string.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  disabled: _propTypes2.default.bool,

  list: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};
exports.default = EmailsList;


var style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/FixedSubmitArea.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FixedSubmitArea = function (_Component) {
  _inherits(FixedSubmitArea, _Component);

  function FixedSubmitArea() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FixedSubmitArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FixedSubmitArea.__proto__ || Object.getPrototypeOf(FixedSubmitArea)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onSubmit(event);
    }, _this.onReset = function (event) {
      event.preventDefault();
      _this.props.onReset(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FixedSubmitArea, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.haveModifications !== this.props.haveModifications || nextProps.shouldDisableSubmit !== this.props.shouldDisableSubmit;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var className = (0, _classnames2.default)('fixed_submit_area', {
        hidden: !this.haveModifications
      });

      var saveButton = _react2.default.createElement(
        'button',
        {
          className: 'btn btn-primary',
          onClick: function onClick(event) {
            event.preventDefault();_this2.onSubmit(event);
          },
          type: 'submit'
        },
        _I18n2.default.tr('components.fixed_submit_area.save')
      );

      if (!this.haveModifications || this.shouldDisableSubmit) {
        saveButton = _react2.default.createElement(
          'button',
          { className: 'btn btn-primary', disabled: true },
          _I18n2.default.tr('components.fixed_submit_area.save')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: className, key: this.haveModifications },
        _react2.default.createElement(
          'button',
          {
            className: 'btn',
            onClick: function onClick(event) {
              event.preventDefault();_this2.onReset(event);
            },
            type: 'reset'
          },
          _I18n2.default.tr('components.fixed_submit_area.cancel')
        ),
        '\xA0\xA0\xA0\xA0',
        saveButton
      );
    }
  }, {
    key: 'shouldDisableSubmit',
    get: function get() {
      return this.props.shouldDisableSubmit;
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return this.props.haveModifications;
    }
  }]);

  return FixedSubmitArea;
}(_react.Component);

FixedSubmitArea.defaultProps = {
  shouldDisableSubmit: false
};
FixedSubmitArea.propTypes = {
  haveModifications: _propTypes2.default.bool.isRequired,

  onSubmit: _propTypes2.default.func.isRequired,

  onReset: _propTypes2.default.func.isRequired,

  shouldDisableSubmit: _propTypes2.default.bool
};
exports.default = FixedSubmitArea;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/FormGroupView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormGroupView = function (_Component) {
  _inherits(FormGroupView, _Component);

  function FormGroupView() {
    _classCallCheck(this, FormGroupView);

    return _possibleConstructorReturn(this, (FormGroupView.__proto__ || Object.getPrototypeOf(FormGroupView)).apply(this, arguments));
  }

  _createClass(FormGroupView, [{
    key: 'getComponent',
    value: function getComponent(key) {
      return this.props.children.filter(function (comp) {
        return comp.key === key;
      });
    }

    // see https://react-bootstrap.github.io/components.html#forms
    // TODO: find better way for children

  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          _reactBootstrap.FormGroup,
          {
            controlId: this.props.name
          },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { componentClass: _reactBootstrap.ControlLabel, sm: 4 },
            !_lodash2.default.isNil(this.props.children[0]) && this.props.children[0]
          ),
          _react2.default.createElement(
            _reactBootstrap.Col,
            { sm: 8, md: 6, lg: 4 },
            !_lodash2.default.isNil(this.props.children[1]) && this.props.children[1]
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }]);

  return FormGroupView;
}(_react.Component);

FormGroupView.Label = function (_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    null,
    children
  );
};

FormGroupView.Content = function (_ref2) {
  var children = _ref2.children;

  return _react2.default.createElement(
    'div',
    null,
    children
  );
};

exports.default = FormGroupView;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/HourChooser/Hour.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hour = function (_Component) {
  _inherits(Hour, _Component);

  function Hour() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Hour);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hour.__proto__ || Object.getPrototypeOf(Hour)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.onChange(_this.props.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hour, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('col-xs-3', 'hour_chooser__hour', {
        selected: this.props.isSelected
      });

      return _react2.default.createElement(
        'div',
        {
          className: className,
          onClick: this.onChange
        },
        this.props.value
      );
    }
  }]);

  return Hour;
}(_react.Component);

Hour.propTypes = {
  value: _propTypes2.default.number.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  isSelected: _propTypes2.default.bool
};
exports.default = Hour;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/HourChooser/Minute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Minute = function (_Component) {
  _inherits(Minute, _Component);

  function Minute() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Minute);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Minute.__proto__ || Object.getPrototypeOf(Minute)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      _this.props.onChange(_this.props.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Minute, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('col-xs-4', 'hour_chooser__minute', {
        selected: this.props.isSelected
      });

      return _react2.default.createElement(
        'div',
        {
          className: className,
          onClick: this.onChange
        },
        this.props.value
      );
    }
  }]);

  return Minute;
}(_react.Component);

Minute.defaultProps = {
  isSelected: false
};
Minute.propTypes = {
  value: _propTypes2.default.number.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  isSelected: _propTypes2.default.bool
};
exports.default = Minute;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/HourChooser/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _Hour = __webpack_require__("./sdk/scripts/components/form/HourChooser/Hour.js");

var _Hour2 = _interopRequireDefault(_Hour);

var _Minute = __webpack_require__("./sdk/scripts/components/form/HourChooser/Minute.js");

var _Minute2 = _interopRequireDefault(_Minute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HourChooser = function (_Component) {
  _inherits(HourChooser, _Component);

  function HourChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HourChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HourChooser.__proto__ || Object.getPrototypeOf(HourChooser)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedHour: null,
      identifier: 'hour_chooser_' + _Utils2.default.generateUID()
    }, _this.displayChoseHourMenu = function (event) {
      event.preventDefault();

      if (!_this.props.disabled) {
        _this.toggleMenu();
      }
    }, _this.onHourSelected = function (hour) {
      _this.setState({
        selectedHour: hour
      });
    }, _this.onMinuteSelected = function (minute) {
      _this.onClose();

      // handle 23:59 and 00:00
      if (_this.state.selectedHour === 23 && minute === 59 || _this.props.withEndOfDay && _this.state.selectedHour === 0 && minute === 0) {
        _this.props.onChange(86340000);
      } else {
        _this.props.onChange(_DateUtils2.default.getMsTimestampForHourAndMinute(_this.state.selectedHour, minute));
      }
    }, _this.onClose = function (e) {
      if (!_lodash2.default.isUndefined(e)) {
        e.preventDefault();
      }
      _this.toggleMenu();
      _this.setState({
        selectedHour: null
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // --


  _createClass(HourChooser, [{
    key: 'toggleMenu',
    value: function toggleMenu() {
      var selector = $('#' + this.state.identifier);

      if (!selector.parent().hasClass('open')) {
        // hide other hour chooser if displayed.
        $('.hour_chooser').removeClass('open');
      }

      // toggle the dropdown.
      selector.parent().toggleClass('open');
    }

    // -- renderers

  }, {
    key: 'renderHoursList',
    value: function renderHoursList() {
      var list = [];

      var defaultValueHour = _DateUtils2.default.getHourFromMsHourTimestamp(this.props.defaultValue);

      for (var i = 0; i < 24; i++) {
        var isSelected = defaultValueHour === i;

        list.push(_react2.default.createElement(_Hour2.default, {
          key: 'hour_' + i,
          value: i,
          onChange: this.onHourSelected,
          isSelected: isSelected
        }));
      }

      return list;
    }
  }, {
    key: 'renderMinutesList',
    value: function renderMinutesList() {
      var list = [];

      for (var i = 0; i <= 45; i += 15) {
        var isSelected = _DateUtils2.default.getMinuteFromMsHourTimestamp(this.props.defaultValue) === i;

        list.push(_react2.default.createElement(_Minute2.default, {
          key: 'minute_' + i,
          value: i,
          onChange: this.onMinuteSelected,
          isSelected: isSelected
        }));
      }

      if (this.props.withEndOfDay && this.state.selectedHour === 23) {
        var _isSelected = _DateUtils2.default.getMinuteFromMsHourTimestamp(this.props.defaultValue) === 59;

        list.push(_react2.default.createElement(_Minute2.default, {
          key: 'minute_' + 59,
          value: 59,
          onChange: this.onMinuteSelected,
          isSelected: _isSelected
        }));
      }

      return list;
    }
  }, {
    key: 'renderButtonView',
    value: function renderButtonView() {
      var label = _DateUtils2.default.getFormattedHourWithMsHour(this.props.defaultValue);

      if (this.props.disabled) {
        return _react2.default.createElement(
          'span',
          {
            className: 'form-control disabled'
          },
          label
        );
      }

      return _react2.default.createElement(
        'span',
        {
          className: 'form-control dropdown-toggle',
          id: this.state.identifier,
          onClick: this.displayChoseHourMenu,
          'aria-haspopup': 'true',
          'aria-expanded': 'false'
        },
        label
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var listView = [];
      var title = '';

      if (_lodash2.default.isNull(this.state.selectedHour)) {
        // display hours
        listView = this.renderHoursList();
        title = 'Sélectionner une heure';
      } else {
        // display minutes
        listView = this.renderMinutesList();
        title = 'Sélectionner les minutes';
      }

      return _react2.default.createElement(
        'span',
        { className: 'dropdown hour_chooser' },
        this.renderButtonView(),
        _react2.default.createElement(
          'div',
          {
            className: 'dropdown-menu pull-right',
            'aria-labelledby': this.state.identifier
          },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'h3',
                { className: 'text-center col-xs-12' },
                title
              ),
              _react2.default.createElement(
                'div',
                { className: 'top-buffer-20' },
                listView
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 text-center' },
                _react2.default.createElement(
                  'button',
                  {
                    className: 'btn btn-default',
                    onClick: this.onClose
                  },
                  'Fermer'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return HourChooser;
}(_react.Component);

HourChooser.defaultProps = {
  disabled: false,
  withEndOfDay: false
};
HourChooser.propTypes = {
  // timestamp as ms.
  defaultValue: _propTypes2.default.number.isRequired,

  // param: number (Timestamp as ms)
  onChange: _propTypes2.default.func.isRequired,

  disabled: _propTypes2.default.bool,

  withEndOfDay: _propTypes2.default.bool
};
exports.default = HourChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/ImageDropzone.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ViewConstants = __webpack_require__("./sdk/scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropzone = __webpack_require__("./node_modules/react-dropzone/dist/index.js");

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _CropImageModal = __webpack_require__("./sdk/scripts/components/form/CropImageModal.js");

var _CropImageModal2 = _interopRequireDefault(_CropImageModal);

var _ImageLoader = __webpack_require__("./sdk/scripts/components/ImageLoader.js");

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- tools


// -- views


/**
 *
 */
var ImageDropzone = function (_Component) {
  _inherits(ImageDropzone, _Component);

  function ImageDropzone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageDropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageDropzone.__proto__ || Object.getPrototypeOf(ImageDropzone)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      imageFile: null,

      displayCrop: false
    }, _this.onPictureCropChange = function (dataPng) {
      _ViewUtils2.default.fileToDataUri(_this.state.imageFile, function (data) {
        _this.props.onChange(dataPng, data);
      });
    }, _this.onRestorePicture = function () {
      _this.props.onChange(null);
    }, _this.onDeletePicture = function () {
      _this.props.onRemove();
    }, _this.onPictureChange = function (files) {
      var file = files[0];
      var filesize = file.size;

      if (filesize >= _this.props.maxSize) {
        // TODO: check the filesize.
      }

      _this.setState({
        imageFile: file,
        displayCrop: true
      });
    }, _this.onHideCropImageModal = function () {
      _this.setState({
        displayCrop: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageDropzone, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, newState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, newState);
    }

    // -- actions picture

  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      var pictureClassName = (0, _classnames2.default)('image_dropzone__picture', this.props.className);

      var pictureView = null;
      var optionView = null;

      if (!_lodash2.default.isNil(this.props.currentImage)) {
        pictureView = _react2.default.createElement(_ImageLoader2.default, {
          className: pictureClassName,
          src: this.props.currentImage,
          placeholder: _ViewConstants2.default.IMAGE_UPLOAD_PLACEHOLDER()
        });
      } else if (!_lodash2.default.isEmpty(this.props.image)) {
        pictureView = _react2.default.createElement(_ImageLoader2.default, {
          className: pictureClassName,
          src: this.props.image,
          placeholder: _ViewConstants2.default.IMAGE_UPLOAD_PLACEHOLDER()
        });

        if (!this.props.editOnly) {
          optionView = _react2.default.createElement('i', {
            className: 'upload_delete_icon fa fa-trash fa-2x',
            title: _I18n2.default.tr('components.image_dropzone.delete'),
            onClick: this.onDeletePicture
          });
        }
      } else {
        pictureView = _react2.default.createElement(_ImageLoader2.default, {
          className: pictureClassName,
          src: this.props.placeholder,
          placeholder: _ViewConstants2.default.IMAGE_UPLOAD_PLACEHOLDER()
        });
      }

      var style = {
        border: 'none'
      };

      if (this.props.readOnly) {
        return _react2.default.createElement(
          'div',
          { className: 'image_dropzone' },
          _react2.default.createElement(
            'div',
            null,
            pictureView
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'image_dropzone' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactDropzone2.default,
            {
              ref: 'dropzone',
              onDrop: this.onPictureChange,
              multiple: false,
              accept: 'image/*',
              style: style
            },
            _react2.default.createElement('i', {
              className: 'upload_update_icon fa fa-edit fa-2x',
              title: _I18n2.default.tr('components.image_dropzone.edit')
            }),
            pictureView
          ),
          optionView,
          this.state.displayCrop && _react2.default.createElement(_CropImageModal2.default, {
            show: !_lodash2.default.isNull(this.state.imageFile) && this.state.displayCrop,
            onHide: this.onHideCropImageModal,
            imageUrl: this.state.imageFile.preview,
            aspectRatio: this.props.aspectRatio,
            onValidate: this.onPictureCropChange,
            width: this.props.width,
            height: this.props.height
          })
        )
      );
    }
  }]);

  return ImageDropzone;
}(_react.Component);

ImageDropzone.defaultProps = {
  maxSize: _ApiConstants2.default.Image.MAX_SIZE,

  aspectRatio: 16 / 9,

  currentImage: null,

  image: null,

  className: '',

  readOnly: false,

  width: null,

  height: null,

  removeOriginalImage: null,

  editOnly: true
};
ImageDropzone.propTypes = {
  placeholder: _propTypes2.default.string.isRequired,

  currentImage: _propTypes2.default.string,

  image: _propTypes2.default.string,

  className: _propTypes2.default.string,

  /*
   * @param String (data base64) The cropped image
   * @param String (data base64) The full size image
   */
  onChange: _propTypes2.default.func.isRequired,

  maxSize: _propTypes2.default.number,

  aspectRatio: _propTypes2.default.number,

  readOnly: _propTypes2.default.bool,

  editOnly: _propTypes2.default.bool,

  /**
   * The width to set to the cropped image.
   * @type {[type]}
   */
  width: _propTypes2.default.number,

  /**
   * The height to set to the cropped image.
   */
  height: _propTypes2.default.number
};
exports.default = ImageDropzone;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/LocaleChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var LocaleChooser = function (_Component) {
  _inherits(LocaleChooser, _Component);

  function LocaleChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LocaleChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocaleChooser.__proto__ || Object.getPrototypeOf(LocaleChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (options) {
      if (_this.props.multi) {
        var locales = options.map(function (option) {
          return option.value;
        });

        _this.props.onChange(locales);
      } else {
        if (_lodash2.default.isNull(options)) {
          _this.props.onChange(null);
        } else {
          _this.props.onChange(options.value);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LocaleChooser, [{
    key: 'render',
    value: function render() {
      var values = !_lodash2.default.isNull(this.props.value) ? [this.props.value] : this.props.values;

      var selectValues = [];
      var options = this.props.locales.map(function (locale) {
        var option = {
          label: _I18n2.default.getLocale(locale),
          value: locale
        };

        var found = _ArrayUtils2.default.exists(values, function (value) {
          return value === locale;
        });
        if (found) {
          selectValues.push(option);
        }

        return option;
      });

      return _react2.default.createElement(
        'div',
        { className: 'locale_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.multi ? selectValues : selectValues[0],
          options: options,
          onChange: this.onSelect,
          clearable: this.props.clearable,
          disabled: this.props.readOnly,
          multi: this.props.multi
        })
      );
    }
  }]);

  return LocaleChooser;
}(_react.Component);

LocaleChooser.defaultProps = {
  clearable: true,

  readOnly: false,

  multi: false,

  values: [],

  value: null
};
LocaleChooser.propTypes = {
  values: _propTypes2.default.array,

  value: _propTypes2.default.string,

  multi: _propTypes2.default.bool,

  // param: number, the chosen vat
  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool,

  /**
   * The locales to propose
   */
  locales: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};
exports.default = LocaleChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/LocalizableSelect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// -- views


exports.default = LocalizableSelect;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LocalizableSelect(props) {
  return _react2.default.createElement(_reactSelect2.default, _extends({
    searchPromptText: _I18n2.default.tr('components.select.search_prompt_text'),
    searchingText: _I18n2.default.tr('components.select.searching_text'),
    noResultsText: _I18n2.default.tr('components.select.no_results_text'),
    clearAllText: _I18n2.default.tr('components.select.clear_all_text'),
    clearValueText: _I18n2.default.tr('components.select.clear_value_text')
    // the `{label}` is taken as parameter by our i18n, but should not. Tricks: we set a parameter and set `{label}` again.
    , addLabelText: _I18n2.default.tr('components.select.add_label_text', { label: '{label}' }),
    placeholder: _I18n2.default.tr('components.select.placeholder'),
    disabled: props.readOnly || props.disabled
  }, props));
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/NumberButtonView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- entities

var NumberButtonView = function (_Component) {
  _inherits(NumberButtonView, _Component);

  function NumberButtonView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberButtonView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberButtonView.__proto__ || Object.getPrototypeOf(NumberButtonView)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      _this.props.onSelect(_this.props.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberButtonView, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('number_button_view', {
        selected: this.props.isSelected
      });
      return _react2.default.createElement(
        'div',
        {
          className: className,
          onClick: this.onClick
        },
        this.props.value
      );
    }
  }]);

  return NumberButtonView;
}(_react.Component);

NumberButtonView.propTypes = {
  value: _propTypes2.default.number.isRequired,

  /**
   *  @param number
   */
  onSelect: _propTypes2.default.func.isRequired,

  isSelected: _propTypes2.default.bool
};
NumberButtonView.defaultProps = {
  isSelected: false
};
exports.default = NumberButtonView;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/NumberChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NumberChooser = function (_Component) {
  _inherits(NumberChooser, _Component);

  function NumberChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberChooser.__proto__ || Object.getPrototypeOf(NumberChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (option) {
      _this.props.onChange(option.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events


  _createClass(NumberChooser, [{
    key: 'render',


    // -- renderers

    value: function render() {
      var options = _lodash2.default.range(this.props.min, this.props.max + 1, this.props.step);

      if (this.props.reverse) {
        options.reverse();
      }

      return _react2.default.createElement(_reactSelect2.default, {
        onChange: this.onChange,
        value: this.props.value,
        options: options.map(function (value) {
          return { label: value, value: value };
        })
      });
    }
  }]);

  return NumberChooser;
}(_react.Component);

NumberChooser.defaultProps = {
  min: 0,
  max: 500,
  step: 1,
  reverse: false
};
NumberChooser.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  min: _propTypes2.default.number.isRequired,
  max: _propTypes2.default.number.isRequired,
  step: _propTypes2.default.number,
  reverse: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};
exports.default = NumberChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/NumberInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
// See https://github.com/hongymagic/react-number-input/blob/master/src/react-number-input.js
//


exports.isNumber = isNumber;
exports.toNumeral = toNumeral;
exports.parseNumber = parseNumber;
exports.formatNumber = formatNumber;

var _objectAssign = __webpack_require__("./sdk/node_modules/object-assign/index.js");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/react.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Check if a given value is a valid number.
 *
 * @returns {boolean} True if given value is a valid number.
 * @param value
 */
function isNumber(value) {
  return typeof value === 'number' && isFinite(value) && !isNaN(value);
}

/**
 * Safe conversion to numeral object. Numeral crashes with the value is
 * object or function.
 *
 * @returns {numeral}
 * @param value
 */
function toNumeral(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

  if (type === 'object' || type === 'function' || type === 'boolean') {
    return null;
  }

  var n = (0, _numeral2.default)(value);

  // numeral.js converts empty strings into 0 for no reason, so if given
  // value was not '0' or 0, treat it as null.
  if (n.value() === 0 && value !== 0 && value !== '0') {
    return null;
  }

  // numeral.js can sometimes convert values (like '4.5.2') into NaN
  // and we would rather null than NaN.
  if (isNaN(n.value())) {
    return null;
  }

  return n;
}

/**
 * Convert given value to a number type. If conversion fails, returns NaN.
 *
 * @returns {Number} NaN if conversion fails.
 * @param value
 */
function parseNumber(value) {
  var n = toNumeral(value);
  return n ? n.value() : NaN;
}

/**
 * Apply number formatting to given number value. If given value cannot be
 * converted to a number, returns null.
 *
 * @returns {string|null}
 * @param value
 * @param format
 */
function formatNumber(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NumberInput.DEFAULT_NUMBER_FORMAT;

  var n = toNumeral(value);
  return n ? n.format(format) : null;
}

/**
 * <NumberInput /> component
 *
 * @param   {Number} value
 * @returns {Component}
 */

var NumberInput = function (_Component) {
  _inherits(NumberInput, _Component);

  /*
   * See numeral.js formats
   * http://numeraljs.com/
   */
  function NumberInput(props) {
    _classCallCheck(this, NumberInput);

    var _this = _possibleConstructorReturn(this, (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call(this, props));

    _initialiseProps.call(_this);

    var value = parseNumber(_this.props.value);

    // focused: keep track of the input's focus state
    // numeral: keep track of the input's current value (numeral object)
    _this.state = {
      focused: false,
      value: isNumber(value) ? value : ''
    };
    return _this;
  }

  _createClass(NumberInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // focused: check if component is focused after mounting and set state
      this.setState({
        focused: global.document.activeElement === this.refs.input
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoFocus) {
        _reactDom2.default.findDOMNode(this.refs.input).focus();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      // Prevent changing the value via external entry when editing.
      if (!this.state.focused && 'value' in props) {
        var value = parseNumber(props.value);
        this.setState({ value: isNumber(value) ? value : '' });
      }
    }
  }, {
    key: 'valueAsFormatted',
    value: function valueAsFormatted() {
      var value = this.state.value;
      var n = toNumeral(value);

      return n ? n.format(this.props.format) : '';
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.state.focused ? this.state.value : this.valueAsFormatted();

      return (0, _react.createElement)('input', (0, _objectAssign2.default)({}, this.props, {
        ref: 'input',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        autoFocus: this.props.autoFocus,
        value: value,
        className: 'form-control'
      }));
    }
  }]);

  return NumberInput;
}(_react.Component);

NumberInput.DEFAULT_NUMBER_FORMAT = '0,0[.][00]';
NumberInput.GEOPT_FORMAT = '0,0[.][00000000]';
NumberInput.CURRENCY_FORMAT = '0,0[.]00';
NumberInput.INT_FORMAT = '0';
NumberInput.propTypes = {
  value: _propTypes2.default.number,
  type: _propTypes2.default.string,
  format: _propTypes2.default.string,
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  autoFocus: _propTypes2.default.bool
};
NumberInput.defaultProps = {
  value: null,
  type: 'tel', // to allow non-numeric characters
  format: NumberInput.DEFAULT_NUMBER_FORMAT,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  autoFocus: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onChange = function (event) {
    event.persist();

    // handle comma on price.
    var value = event.target.value.replace(',', '.');

    _this2.setState({ value: value }, function () {
      if (_lodash2.default.isNull(value)) {
        _this2.props.onChange(null, event);
      } else {
        var valueNumber = parseFloat(value);
        if (_lodash2.default.isNaN(valueNumber)) {
          _this2.props.onChange(null, event);
        } else if (_lodash2.default.isNumber(valueNumber)) {
          _this2.props.onChange(valueNumber, event);
        } else {}
      }
    });
  };

  this.onBlur = function (event) {
    event.persist();
    var n = toNumeral(event.target.value);

    // If given value is lower than minimum, set the value to minimum
    if (n && 'min' in _this2.props && n.value() < _this2.props.min) {
      n = toNumeral(_this2.props.min);
    }

    // If given value is greater than maximum, set the value to maximum
    if (n && 'max' in _this2.props && n.value() > _this2.props.max) {
      n = toNumeral(_this2.props.max);
    }

    // if we have a min and the value is null, we set it to the min.
    if (_lodash2.default.isNaN(n) || _lodash2.default.isNil(n)) {
      if ('min' in _this2.props) {
        n = toNumeral(_this2.props.min);
      }
    }

    // Set the event target value to corrected value
    event.target.value = n ? n.value() : '';

    _this2.setState({
      focused: false,
      value: n ? n.format(_this2.props.format) : ''
    }, function () {
      return _this2.props.onBlur(event);
    });
  };

  this.onFocus = function (event) {
    event.persist();
    var n = toNumeral(event.target.value);
    _this2.setState({
      focused: true,
      value: n ? n.value() : '' //,
      //() => this.props.onFocus(event)
    });
  };
};

exports.default = NumberInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./sdk/scripts/components/form/NumberInputModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _NumberInput = __webpack_require__("./sdk/scripts/components/form/NumberInput.js");

var _NumberInput2 = _interopRequireDefault(_NumberInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NumberInputModal = function (_Component) {
  _inherits(NumberInputModal, _Component);

  function NumberInputModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberInputModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInputModal.__proto__ || Object.getPrototypeOf(NumberInputModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: _this.props.value
    }, _this.onHide = function () {
      _this.props.onHide();
    }, _this.onClose = function () {
      _this.props.onHide();
    }, _this.onChange = function (value) {
      _this.setState({
        value: parseInt(value, 10)
      });
    }, _this.onSubmit = function () {
      _this.props.onChange(_this.state.value);
      _this.props.onHide();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- events - modal

  _createClass(NumberInputModal, [{
    key: 'renderBody',


    // -- renderers

    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(_NumberInput2.default, {
          className: 'form-control',
          value: this.state.value,
          onChange: this.onChange,
          min: this.props.min,
          max: this.props.max,
          format: _NumberInput2.default.INT_FORMAT,
          autoFocus: true
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary submit text-center',
            type: 'submit',
            disabled: this.state.value > this.props.max,
            onClick: this.onSubmit
          },
          _I18n2.default.tr('components.numner_input_modal.submit')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'small',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            this.props.title
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return NumberInputModal;
}(_react.Component);

NumberInputModal.defaultProps = _defineProperty({
  value: null,

  min: 0,

  max: null

}, 'value', null);
NumberInputModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  onHide: _propTypes2.default.func.isRequired,

  title: _propTypes2.default.string.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  value: _propTypes2.default.number,

  min: _propTypes2.default.number,

  max: _propTypes2.default.number
};
exports.default = NumberInputModal;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/NumberSelector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _NumberInputModal = __webpack_require__("./sdk/scripts/components/form/NumberInputModal.js");

var _NumberInputModal2 = _interopRequireDefault(_NumberInputModal);

var _NumberButtonView = __webpack_require__("./sdk/scripts/components/form/NumberButtonView.js");

var _NumberButtonView2 = _interopRequireDefault(_NumberButtonView);

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var NumberSelector = function (_Component) {
  _inherits(NumberSelector, _Component);

  function NumberSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberSelector.__proto__ || Object.getPrototypeOf(NumberSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayInputModal: false
    }, _this.onNumberChange = function (value) {
      if (value > _this.props.max) {
        _this.props.onChange(_this.props.max);
      } else {
        _this.props.onChange(value);
      }
    }, _this.onSelectClicked = function () {
      _this.setState({
        displayInputModal: true
      });
    }, _this.onHideInputModal = function () {
      _this.setState({
        displayInputModal: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberSelector, [{
    key: 'renderNumberButtons',


    // -- renderers

    value: function renderNumberButtons() {
      var buttonsView = [];

      var max = this.props.nbButtons > this.props.max ? this.props.max : this.props.nbButtons;
      for (var i = 1; i <= max; i++) {
        buttonsView.push(_react2.default.createElement(_NumberButtonView2.default, {
          key: i,
          value: i,
          onSelect: this.onNumberChange,
          isSelected: this.props.value === i
        }));
      }

      return buttonsView;
    }

    // Disabled because of bug on Edge. The scroll by touch does not work.

    // renderNumberPicker() {
    //   const options = [];
    //
    //   if (this.props.nbButtons > this.props.max) {
    //     return (null);
    //   }
    //
    //   for (let i = this.props.nbButtons + 1; i <= this.props.max; i++) {
    //     options.push({
    //       label: i,
    //       value: i
    //     });
    //   }
    //
    //   return (
    //     <div className="number_selector__select">
    //       <Select
    //         options={options}
    //         value={this.props.value}
    //         onChange={(option: Object) => { this.onNumberChange(option.value); }}
    //         clearable={false}
    //         searchable={false}
    //         placeholder="+"
    //       />
    //     </div>
    //   );
    // }

  }, {
    key: 'renderInputModal',
    value: function renderInputModal() {
      if (this.state.displayInputModal !== true) {
        return _react2.default.createElement('span', null);
      }

      return _react2.default.createElement(_NumberInputModal2.default, {
        show: true,
        onHide: this.onHideInputModal,
        title: 'Nombre de couverts',
        onChange: this.onNumberChange,
        max: this.props.max,
        min: this.props.min
      });
    }
  }, {
    key: 'renderNumberPicker',
    value: function renderNumberPicker() {
      var options = [];

      if (this.props.nbButtons > this.props.max) {
        return null;
      }

      for (var i = this.props.nbButtons + 1; i <= this.props.max; i++) {
        options.push({
          label: i,
          value: i
        });
      }

      var isPlusMode = this.props.value <= this.props.nbButtons;

      var className = (0, _classnames2.default)('modal_btn', {
        active: !isPlusMode
      });

      return _react2.default.createElement(
        'div',
        { className: 'number_selector__select number_button_view' },
        _react2.default.createElement(
          'div',
          {
            className: className,
            onClick: this.onSelectClicked
          },
          isPlusMode && _react2.default.createElement(
            'span',
            null,
            '+'
          ),
          !isPlusMode && _react2.default.createElement(
            'span',
            null,
            this.props.value
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'number_selector' },
        this.renderNumberButtons(),
        this.renderNumberPicker(),
        this.renderInputModal()
      );
    }
  }]);

  return NumberSelector;
}(_react.Component);

NumberSelector.propTypes = {
  onChange: _propTypes2.default.func.isRequired,

  nbButtons: _propTypes2.default.number,

  value: _propTypes2.default.number,

  min: _propTypes2.default.number,

  max: _propTypes2.default.number
};
NumberSelector.defaultProps = {
  nbButtons: 7,

  max: 1000,

  value: null
};
exports.default = NumberSelector;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/OptionView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionView = function (_Component) {
  _inherits(OptionView, _Component);

  function OptionView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OptionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OptionView.__proto__ || Object.getPrototypeOf(OptionView)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      if (!_this.props.isDisabled && !_this.props.readOnly) {
        _this.props.onChange(!_this.props.isActivated);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OptionView, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.isActivated !== this.props.isActivated || nextProps.isDisabled !== this.props.isDisabled;
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      var className = 'fa fa-square-o';

      if (this.props.isDisabled) {
        className = 'fa fa-square-o';
      } else if (this.props.isActivated === true) {
        className = 'fa fa-check-square-o';
      }

      return _react2.default.createElement('i', { className: className });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('option_view', this.props.className, {
        disabled: this.props.isDisabled,
        activated: this.props.isActivated,
        read_only: this.props.readOnly
      });

      return _react2.default.createElement(
        'div',
        { className: className, onClick: this.onClick },
        this.renderIcon(),
        '\xA0\xA0',
        this.props.label
      );
    }
  }]);

  return OptionView;
}(_react.Component);

OptionView.propTypes = {
  isActivated: _propTypes2.default.bool.isRequired,

  onChange: _propTypes2.default.func,

  label: _propTypes2.default.string.isRequired,

  // Set to true to disable the interaction (will display a full black square)
  isDisabled: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool,

  className: _propTypes2.default.string // TODO: could be an object too.
};
OptionView.defaultProps = {
  onChange: function onChange() {},
  isDisabled: false,
  readOnly: false,
  className: ''
};
exports.default = OptionView;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/OptionsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _TextInput = __webpack_require__("./sdk/scripts/components/form/TextInput.js");

var _TextInput2 = _interopRequireDefault(_TextInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsList = function (_Component) {
  _inherits(OptionsList, _Component);

  function OptionsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OptionsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OptionsList.__proto__ || Object.getPrototypeOf(OptionsList)).call.apply(_ref, [this].concat(args))), _this), _this.onAddClicked = function () {
      var list = _this.list;

      list.push({
        label: '',
        value: null
      });

      _this.props.onChange(list);
    }, _this.onChange = function (text, index) {
      var list = _this.list;

      list[index].label = text;

      _this.props.onChange(list);
    }, _this.onDelete = function (index) {
      var list = _this.list;
      var textToDelete = list[index];

      if (textToDelete.length === 0) {
        // empty, delete it without asking confirmation
        list.splice(index, 1);
        _this.props.onChange(list);
      } else {
        _Notify2.default.confirmDelete(_I18n2.default.tr('global.are_you_sure'), function (result) {
          if (result) {
            list.splice(index, 1);
            _this.props.onChange(list);
          }
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OptionsList, [{
    key: 'renderList',


    //
    // Renderers
    //

    value: function renderList(list) {
      var _this2 = this;

      var listView = [];

      _lodash2.default.each(list, function (option, index) {
        listView.push(_react2.default.createElement(
          'div',
          {
            className: 'input-group',
            style: style.listItem,
            key: index
          },
          _react2.default.createElement(_TextInput2.default, {
            key: index,
            className: 'form-control',
            value: option.label,
            onChange: function onChange(text) {
              _this2.onChange(text, index);
            },
            disabled: _this2.props.disabled,
            max: _this2.props.maxChars
          }),
          _react2.default.createElement(
            'div',
            { className: 'input-group-addon' },
            !_this2.props.disabled && _react2.default.createElement('i', {
              className: 'fa fa-trash pointer',
              onClick: function onClick() {
                _this2.onDelete(index);
              }
            })
          )
        ));
      });

      return listView;
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'texts_list' },
          this.renderList(this.list),
          !this.props.disabled && this.props.max !== 0 && this.list.length <= this.props.max && _react2.default.createElement(
            'div',
            {
              style: style.link,
              className: 'link',
              onClick: this.onAddClicked
            },
            this.props.addLabel
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'list',
    get: function get() {
      return this.props.list;
    }
  }]);

  return OptionsList;
}(_react.Component);

OptionsList.defaultProps = {
  disabled: false,

  addLabel: _I18n2.default.tr('global.add'),

  max: 0
};
OptionsList.propTypes = {
  /**
   * Array of { label, value }
   */
  list: _propTypes2.default.array.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  disabled: _propTypes2.default.bool,

  addLabel: _propTypes2.default.func,

  /*
   * The maximum number of values
   */
  max: _propTypes2.default.number,

  /**
   * The `max` chars to set on the `TextInput`
   */
  maxChars: _propTypes2.default.number
};
exports.default = OptionsList;


var style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/OrderModeChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _OrderViewUtils = __webpack_require__("./sdk/scripts/utils/OrderViewUtils.js");

var _OrderViewUtils2 = _interopRequireDefault(_OrderViewUtils);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var OrderModeChooser = function (_Component) {
  _inherits(OrderModeChooser, _Component);

  function OrderModeChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderModeChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderModeChooser.__proto__ || Object.getPrototypeOf(OrderModeChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (options) {
      if (_this.props.multi) {
        var modes = options.map(function (option) {
          return option.value;
        });

        _this.props.onChange(modes);
      } else {
        if (_lodash2.default.isNull(options)) {
          _this.props.onChange(null);
        } else {
          _this.props.onChange(options.value);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderModeChooser, [{
    key: 'render',
    value: function render() {
      var values = !_lodash2.default.isNull(this.props.value) ? [this.props.value] : this.props.values;

      var selectValues = [];
      var options = this.props.modes.map(function (mode) {
        var option = {
          label: _OrderViewUtils2.default.getLabelForMode(mode),
          value: mode
        };

        var found = _ArrayUtils2.default.exists(values, function (value) {
          return value === mode;
        });
        if (found) {
          selectValues.push(option);
        }

        return option;
      });

      return _react2.default.createElement(
        'div',
        { className: 'order_mode_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          placeholder: this.props.placeholder,
          name: 'action',
          value: !this.props.multi && !_lodash2.default.isEmpty(selectValues) ? selectValues[0].value : _lodash2.default.isEmpty(selectValues) ? null : selectValues,
          options: options,
          onChange: this.onSelect,
          clearable: this.props.clearable,
          disabled: this.props.readOnly,
          multi: this.props.multi
        })
      );
    }
  }]);

  return OrderModeChooser;
}(_react.Component);

OrderModeChooser.defaultProps = {
  clearable: true,

  readOnly: false,

  multi: false,

  values: [],

  value: null,

  placeholder: ""
};
OrderModeChooser.propTypes = {
  placeholder: _propTypes2.default.string,

  values: _propTypes2.default.array,

  value: _propTypes2.default.string,

  multi: _propTypes2.default.bool,

  // param: number, the chosen vat
  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool,

  /**
   * The modes to propose
   */
  modes: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired
};
exports.default = OrderModeChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/POSChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _POSType = __webpack_require__("./sdk/scripts/constants/POSType.js");

var _POSType2 = _interopRequireDefault(_POSType);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var POSChooser = function (_Component) {
  _inherits(POSChooser, _Component);

  function POSChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, POSChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = POSChooser.__proto__ || Object.getPrototypeOf(POSChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (option) {
      if (_lodash2.default.isNull(option)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(POSChooser, [{
    key: 'render',
    value: function render() {
      var choices = _POSType2.default.getChoices();

      return _react2.default.createElement(
        'div',
        { className: 'pos_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.value,
          options: choices,
          onChange: this.onSelect,
          clearable: true,
          placeholder: _I18n2.default.tr('components.pos_chooser.placeholder'),
          readOnly: this.props.readOnly
        })
      );
    }
  }]);

  return POSChooser;
}(_react.Component);

POSChooser.defaultProps = {
  readOnly: false
};
POSChooser.propTypes = {
  value: _propTypes2.default.string.isRequired,

  // param: String, the chosen POS
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
exports.default = POSChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/PasswordInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordInput = function (_Component) {
  _inherits(PasswordInput, _Component);

  function PasswordInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PasswordInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false
    }, _this.onIconClicked = function () {
      if (_this.props.optionDisplayPassword === true) {
        _this.setState({
          isVisible: !_this.state.isVisible
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PasswordInput, [{
    key: 'renderIcon',


    // -- renderers

    value: function renderIcon() {
      if (this.props.optionDisplayPassword === false) {
        return _react2.default.createElement('i', { className: 'fa fa-lock' });
      }

      if (this.state.isVisible) {
        return _react2.default.createElement('i', { className: 'fa fa-eye-slash' });
      }

      return _react2.default.createElement('i', { className: 'fa fa-eye' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var className = (0, _classnames2.default)('password_input', this.props.className);
      var type = this.state.isVisible ? 'text' : 'password';
      var classNameinput = (0, _classnames2.default)('form-control', { error: this.props.error });

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement('input', {
          type: type,
          className: classNameinput,
          placeholder: this.props.placeholder,
          value: this.props.value,
          onChange: function onChange(event) {
            _this2.props.onChange(event.target.value);
          },
          onBlur: this.props.onBlur,
          autoComplete: this.props.autoComplete
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'input-group-addon pointer',
            onClick: this.onIconClicked
          },
          this.renderIcon()
        )
      );
    }
  }]);

  return PasswordInput;
}(_react.Component);

PasswordInput.propTypes = {
  value: _propTypes2.default.string,
  optionDisplayPassword: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  error: _propTypes2.default.bool
};
PasswordInput.defaultProps = {
  value: '',
  optionDisplayPassword: true,
  onBlur: function onBlur() {},
  className: null,
  placeholder: '',
  error: false
};
exports.default = PasswordInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/PdfDropzone.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsShallowCompare = __webpack_require__("./node_modules/react-addons-shallow-compare/index.js");

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropzone = __webpack_require__("./node_modules/react-dropzone/dist/index.js");

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- tools


// -- views


/**
 * Component that handle a single pdf file drop.
 */
var PdfDropzone = function (_Component) {
  _inherits(PdfDropzone, _Component);

  function PdfDropzone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PdfDropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PdfDropzone.__proto__ || Object.getPrototypeOf(PdfDropzone)).call.apply(_ref, [this].concat(args))), _this), _this.onDelete = function () {
      _this.props.onChange(null);
    }, _this.onDrop = function (files) {
      if (_this.props.readOnly) {
        return;
      }

      var file = files[0];
      var filesize = file.size;

      if (filesize >= _this.props.maxSize) {
        // TODO: check the filesize.
      }

      _this.props.onChange(file);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PdfDropzone, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, newState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, newState);
    }
  }, {
    key: 'renderReadOnly',


    //
    //  renderers
    //

    value: function renderReadOnly() {
      return _react2.default.createElement(
        'div',
        { className: 'pdf_dropzone disabled' },
        _react2.default.createElement(_SvgIcon2.default, {
          icon: _SvgIcon2.default.UPLOAD
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.readOnly) {
        return this.renderReadOnly();
      }
      return _react2.default.createElement(
        'div',
        { className: 'pdf_dropzone' },
        _react2.default.createElement(
          _reactDropzone2.default,
          {
            onDrop: this.onDrop,
            multiple: false,
            accept: 'application/pdf',
            className: 'dropzone'
          },
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.UPLOAD
          })
        ),
        !_lodash2.default.isNull(this.props.file) && _react2.default.createElement(
          'span',
          null,
          '"',
          this.props.file.name,
          '"',
          _react2.default.createElement('i', {
            className: 'fa fa-trash pdf_dropzone__delete',
            onClick: this.onDelete
          })
        )
      );
    }
  }]);

  return PdfDropzone;
}(_react.Component);

PdfDropzone.defaultProps = {
  className: '',

  readOnly: false,

  file: null
};
PdfDropzone.propTypes = {
  className: _propTypes2.default.string,

  /*
   * @param String (data base64) The cropped image
   * @param String (data base64) The full size image
   */
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool,

  /**
   * The current selected file
   */
  file: _propTypes2.default.object
};
exports.default = PdfDropzone;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/PhoneInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _CountriesList = __webpack_require__("./sdk/scripts/constants/CountriesList.js");

var _CountriesList2 = _interopRequireDefault(_CountriesList);

var _PhoneUtils = __webpack_require__("./sdk/scripts/utils/PhoneUtils.js");

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

var _ViewConstants = __webpack_require__("./sdk/scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


/**
 * TODO: work in progress.
 * Resources:
 *  - https://github.com/razagill/react-phone-input
 *  - https://github.com/googlei18n/libphonenumber
 *  -
 */
var PhoneInput = function (_Component) {
  _inherits(PhoneInput, _Component);

  function PhoneInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PhoneInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInput.__proto__ || Object.getPrototypeOf(PhoneInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getInitialState(), _this.onCountryChange = function (option) {
      var countryIso = option.value;

      if (countryIso !== _this.state.countryIso) {
        _this.updateFormattedNumber(_this.state.numberInfo.national_number, countryIso);
      }
    }, _this.onNumberChange = function (event) {
      var value = event.target.value;

      _this.updateFormattedNumber(value, _this.state.countryIso);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PhoneInput, [{
    key: 'getInitialState',
    value: function getInitialState() {
      var countryIso = this.getPropsValueIso();

      return {
        countryIso: countryIso,

        /**
         * See https://github.com/googlei18n/libphonenumber PhoneNumber class.
         * - country_code
         * - national_number
         */
        numberInfo: _PhoneUtils2.default.parseWithIso(this.props.value, countryIso)
      };
    }
  }, {
    key: 'getPropsValueIso',
    value: function getPropsValueIso() {
      var iso = _PhoneUtils2.default.getCountryIsoForNumber(this.props.value);

      if (!_lodash2.default.isNull(iso)) {
        return iso;
      }

      return this.props.defaultCountryIso;
    }

    // -- events

  }, {
    key: 'updateFormattedNumber',
    value: function updateFormattedNumber(number, countryIso) {
      var numberInfo = _PhoneUtils2.default.parseWithIso(number, countryIso);

      var haveIndicator = numberInfo.national_number.indexOf('+') !== -1;
      var firstSpaceIndex = numberInfo.national_number.indexOf(' ');

      if (firstSpaceIndex !== -1) {
        numberInfo.national_number = numberInfo.national_number.substring(firstSpaceIndex + 1);
      }

      this.setState({
        countryIso: countryIso,
        numberInfo: numberInfo
      });
    }

    // -- renderers

  }, {
    key: 'render',
    value: function render() {
      var options = _CountriesList2.default.getCountriesListForPicker();

      return _react2.default.createElement(
        'div',
        { className: 'phone_input' },
        _react2.default.createElement('div', { className: 'phone_input__country_select' }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { className: 'phone_input__phone_input' },
          _react2.default.createElement(
            'div',
            { className: 'input-group-addon' },
            this.state.numberInfo.country_code !== -1 && _react2.default.createElement(
              'span',
              { className: 'phone_input__country_code' },
              '+',
              this.state.numberInfo.country_code
            )
          ),
          _react2.default.createElement('input', {
            type: 'tel',
            autoComplete: 'off',
            className: 'form-control',
            value: _PhoneUtils2.default.removeIndicatorOnPhoneNumber(this.state.numberInfo.national_number),
            onChange: this.onNumberChange,
            placeholder: this.props.placeholder
          })
        )
      );
    }
  }]);

  return PhoneInput;
}(_react.Component);

PhoneInput.defaultProps = {
  defaultCountryIso: 'FR',

  value: '',

  placeholder: '6 00 00 00 00'
};
PhoneInput.propTypes = {
  // (Country code 'FR' for example.)
  defaultCountryIso: _propTypes2.default.string,

  value: _propTypes2.default.string,

  placeholder: _propTypes2.default.string,

  /**
   * @param number The phone number
   */
  onChange: _propTypes2.default.func.isRequired
};

var CountryOption = function (_Component2) {
  _inherits(CountryOption, _Component2);

  function CountryOption() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, CountryOption);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = CountryOption.__proto__ || Object.getPrototypeOf(CountryOption)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleMouseDown = function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this2.props.onSelect(_this2.option, event);
    }, _this2.handleMouseEnter = function (event) {
      _this2.props.onFocus(_this2.option, event);
    }, _this2.handleMouseMove = function (event) {
      if (_this2.props.isFocused) return;
      _this2.props.onFocus(_this2.option, event);
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(CountryOption, [{
    key: 'render',
    value: function render() {
      var flagClass = 'flag flag-' + this.option.value.toLowerCase();
      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          onMouseDown: this.handleMouseDown,
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          title: this.props.option.title
        },
        _react2.default.createElement('span', { className: flagClass }),
        '\xA0\xA0',
        this.props.children
      );
    }
  }, {
    key: 'option',
    get: function get() {
      return this.props.option;
    }
  }]);

  return CountryOption;
}(_react.Component);

CountryOption.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  isDisabled: _propTypes2.default.bool,
  isFocused: _propTypes2.default.bool,
  isSelected: _propTypes2.default.bool,
  onFocus: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  option: _propTypes2.default.object.isRequired
};


function CountryValue(props) {
  var flagClass = 'flag flag-' + props.value.value.toLowerCase();

  return _react2.default.createElement(
    'div',
    { className: 'Select-value', title: props.value.label },
    _react2.default.createElement(
      'span',
      { className: 'Select-value-label' },
      _react2.default.createElement('span', { className: flagClass }),
      '\xA0\xA0',
      props.children
    )
  );
}

CountryValue.propTypes = {
  children: _propTypes2.default.node,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.object
};

exports.default = PhoneInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/PhonesList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _SimplePhoneInput = __webpack_require__("./sdk/scripts/components/form/SimplePhoneInput.js");

var _SimplePhoneInput2 = _interopRequireDefault(_SimplePhoneInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PhonesList = function (_Component) {
  _inherits(PhonesList, _Component);

  function PhonesList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PhonesList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhonesList.__proto__ || Object.getPrototypeOf(PhonesList)).call.apply(_ref, [this].concat(args))), _this), _this.onAddClicked = function () {
      var phonesList = _this.phonesList;

      phonesList.push('');

      _this.props.onChange(phonesList);
    }, _this.onChange = function (phone, index) {
      var phonesList = _this.phonesList;

      phonesList[index] = phone;

      _this.props.onChange(phonesList);
    }, _this.onDelete = function (index) {
      var phonesList = _this.phonesList;
      var phoneToDelete = phonesList[index];

      if (phoneToDelete.length === 0) {
        // empty, delete it without asking confirmation
        phonesList.splice(index, 1);
        _this.props.onChange(phonesList);
      } else {
        _Notify2.default.confirmDelete(_I18n2.default.tr('components.phones_list.are_you_sure'), function (result) {
          if (result) {
            phonesList.splice(index, 1);
            _this.props.onChange(phonesList);
          }
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PhonesList, [{
    key: 'renderPhonesList',


    //
    // Renderers
    //

    value: function renderPhonesList(phonesList) {
      var _this2 = this;

      var listView = [];

      _lodash2.default.each(phonesList, function (phone, index) {
        listView.push(_react2.default.createElement(
          'div',
          { className: 'input-group', style: style.listItem, key: index },
          _react2.default.createElement(_SimplePhoneInput2.default, {
            key: index,
            className: 'form-control',
            value: phone,
            onChange: function onChange(phone) {
              _this2.onChange(phone, index);
            },
            disabled: _this2.props.disabled
          }),
          _react2.default.createElement(
            'div',
            { className: 'input-group-addon' },
            !_this2.props.disabled && _react2.default.createElement('i', {
              className: 'fa fa-trash pointer',
              onClick: function onClick() {
                _this2.onDelete(index);
              }
            })
          )
        ));
      });

      return listView;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'phones_list' },
        this.renderPhonesList(this.phonesList),
        !this.props.disabled && _react2.default.createElement(
          'div',
          {
            style: style.link,
            className: 'link',
            onClick: this.onAddClicked
          },
          _I18n2.default.tr('components.phones_list.add_number')
        )
      );
    }
  }, {
    key: 'phonesList',
    get: function get() {
      return this.props.list;
    }
  }]);

  return PhonesList;
}(_react.Component);

PhonesList.defaultProps = {
  disabled: false
};
PhonesList.propTypes = {
  value: _propTypes2.default.string,

  onChange: _propTypes2.default.func.isRequired,

  disabled: _propTypes2.default.bool
};
exports.default = PhonesList;


var style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/PriceInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NumberInput = __webpack_require__("./sdk/scripts/components/form/NumberInput.js");

var _NumberInput2 = _interopRequireDefault(_NumberInput);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var PriceInput = function (_Component) {
  _inherits(PriceInput, _Component);

  function PriceInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PriceInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PriceInput.__proto__ || Object.getPrototypeOf(PriceInput)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value) {
      if (!_this.props.readOnly) {
        _this.props.onChange(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PriceInput, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'price_input input-group' },
        _react2.default.createElement(_NumberInput2.default, {
          className: 'form-control',
          value: this.props.value,
          onChange: this.onChange,
          min: 0,
          max: 10000,
          format: _NumberInput2.default.CURRENCY_FORMAT,
          disabled: this.props.readOnly
        }),
        _react2.default.createElement(
          'div',
          { className: 'input-group-addon' },
          _utils.CurrencyUtils.getCurrencySymbol(this.props.currencyCode)
        )
      );
    }
  }]);

  return PriceInput;
}(_react.Component);

PriceInput.defaultProps = {
  readOnly: false
};
PriceInput.propTypes = {
  value: _propTypes2.default.number.isRequired,

  // param: number, the chosen vat
  onChange: _propTypes2.default.func.isRequired,

  currencyCode: _propTypes2.default.string.isRequired,

  readOnly: _propTypes2.default.bool
};
exports.default = PriceInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/RestaurantTagChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _RestaurantTagsList = __webpack_require__("./sdk/scripts/constants/RestaurantTagsList.js");

var _RestaurantTagsList2 = _interopRequireDefault(_RestaurantTagsList);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var RestaurantTagChooser = function (_Component) {
  _inherits(RestaurantTagChooser, _Component);

  function RestaurantTagChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantTagChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantTagChooser.__proto__ || Object.getPrototypeOf(RestaurantTagChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (selection) {
      if (_lodash2.default.isNull(selection)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(selection.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantTagChooser, [{
    key: 'render',
    value: function render() {
      var options = _RestaurantTagsList2.default.getTagsListForPicker();

      return _react2.default.createElement(
        'div',
        { className: 'restaurant_tag_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.tag,
          options: options,
          onChange: this.onChange,
          readOnly: this.props.readOnly
        })
      );
    }
  }]);

  return RestaurantTagChooser;
}(_react.Component);

RestaurantTagChooser.defaultProps = {
  tag: ''
};
RestaurantTagChooser.propTypes = {
  tag: _propTypes2.default.string,

  /**
   * @param String
   */
  onChange: _propTypes2.default.func.isRequired
};
exports.default = RestaurantTagChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/SimplePhoneInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactPhoneInput = __webpack_require__("./sdk/scripts/components/reactPhoneInput/index.js");

var _reactPhoneInput2 = _interopRequireDefault(_reactPhoneInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimplePhoneInput = function (_Component) {
  _inherits(SimplePhoneInput, _Component);

  function SimplePhoneInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SimplePhoneInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimplePhoneInput.__proto__ || Object.getPrototypeOf(SimplePhoneInput)).call.apply(_ref, [this].concat(args))), _this), _this.onNumberChange = function (value) {
      // delete spaces
      if (_lodash2.default.isNull(value) || _lodash2.default.isNull(_this.props.value) || value.replace(/ /g, '') !== _this.props.value.replace(/ /g, '')) {
        _this.props.onChange(value.replace(/ /g, ''));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SimplePhoneInput, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.value !== nextProps.value || this.props.error !== nextProps.error;
    }

    // -- events

  }, {
    key: 'render',


    // -- renderers

    value: function render() {
      var number = this.props.value;
      var className = (0, _classnames2.default)('phone_input', {
        error: this.props.error
      });

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(_reactPhoneInput2.default, {
          defaultCountry: 'fr',
          value: number,
          onChange: this.onNumberChange,
          placeholder: this.props.placeholder,
          disabled: this.props.disabled || this.props.readOnly
        })
      );
    }
  }]);

  return SimplePhoneInput;
}(_react.Component);

SimplePhoneInput.defaultProps = {
  value: '',

  placeholder: '6 00 00 00 00',

  disabled: false,

  readOnly: false,

  error: false
};
SimplePhoneInput.propTypes = {
  value: _propTypes2.default.string,

  placeholder: _propTypes2.default.string,

  /**
   * @param number The phone number
   */
  onChange: _propTypes2.default.func.isRequired,

  disabled: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool,

  error: _propTypes2.default.bool
};
exports.default = SimplePhoneInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/StringsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Notify = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify2 = _interopRequireDefault(_Notify);

var _TextInput = __webpack_require__("./sdk/scripts/components/form/TextInput.js");

var _TextInput2 = _interopRequireDefault(_TextInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StringsList = function (_Component) {
  _inherits(StringsList, _Component);

  function StringsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StringsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StringsList.__proto__ || Object.getPrototypeOf(StringsList)).call.apply(_ref, [this].concat(args))), _this), _this.onAddClicked = function () {
      var list = _this.list;

      list.push('');

      _this.props.onChange(list);
    }, _this.onChange = function (text, index) {
      var list = _this.list;

      list[index] = text;

      _this.props.onChange(list);
    }, _this.onDelete = function (index) {
      var list = _this.list;
      var textToDelete = list[index];

      if (textToDelete.length === 0) {
        // empty, delete it without asking confirmation
        list.splice(index, 1);
        _this.props.onChange(list);
      } else {
        _Notify2.default.confirmDelete(_I18n2.default.tr('global.are_you_sure'), function (result) {
          if (result) {
            list.splice(index, 1);
            _this.props.onChange(list);
          }
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StringsList, [{
    key: 'renderStringsList',


    //
    // Renderers
    //

    value: function renderStringsList(list) {
      var _this2 = this;

      var listView = [];

      _lodash2.default.each(list, function (text, index) {
        listView.push(_react2.default.createElement(
          'div',
          {
            className: 'input-group',
            style: style.listItem,
            key: index
          },
          _react2.default.createElement(_TextInput2.default, {
            key: index,
            className: 'form-control',
            value: text,
            onChange: function onChange(text) {
              _this2.onChange(text, index);
            },
            disabled: _this2.props.disabled
          }),
          _react2.default.createElement(
            'div',
            { className: 'input-group-addon' },
            !_this2.props.disabled && _react2.default.createElement('i', {
              className: 'fa fa-trash pointer',
              onClick: function onClick() {
                _this2.onDelete(index);
              }
            })
          )
        ));
      });

      return listView;
    }
  }, {
    key: 'render',
    value: function render() {
      try {
        return _react2.default.createElement(
          'div',
          { className: 'texts_list' },
          this.renderStringsList(this.list),
          !this.props.disabled && _react2.default.createElement(
            'div',
            {
              style: style.link,
              className: 'link',
              onClick: this.onAddClicked
            },
            this.props.addLabel
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'list',
    get: function get() {
      return this.props.list;
    }
  }]);

  return StringsList;
}(_react.Component);

StringsList.defaultProps = {
  disabled: false,

  addLabel: _I18n2.default.tr('global.add')
};
StringsList.propTypes = {
  list: _propTypes2.default.string.isRequired,

  onChange: _propTypes2.default.func.isRequired,

  disabled: _propTypes2.default.bool,

  addLabel: _propTypes2.default.func
};
exports.default = StringsList;


var style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/SubmitArea.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmitArea = function (_Component) {
  _inherits(SubmitArea, _Component);

  function SubmitArea() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubmitArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubmitArea.__proto__ || Object.getPrototypeOf(SubmitArea)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onSubmit(event);
    }, _this.onReset = function (event) {
      event.preventDefault();
      _this.props.onReset(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubmitArea, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.haveModifications !== this.props.haveModifications;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.haveModifications) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'submit_area' },
        _react2.default.createElement(
          'button',
          {
            className: 'btn',
            onClick: this.onReset,
            type: 'reset'
          },
          _I18n2.default.tr('components.submit_area.cancel')
        ),
        '\xA0\xA0\xA0\xA0',
        _react2.default.createElement(
          'button',
          {
            className: 'btn btn-primary',
            onClick: this.onSubmit,
            type: 'submit'
          },
          _I18n2.default.tr('components.submit_area.save')
        )
      );
    }
  }, {
    key: 'haveModifications',
    get: function get() {
      return this.props.haveModifications;
    }
  }]);

  return SubmitArea;
}(_react.Component);

SubmitArea.propTypes = {
  haveModifications: _propTypes2.default.bool.isRequired,

  onSubmit: _propTypes2.default.func.isRequired,

  onReset: _propTypes2.default.func.isRequired
};
exports.default = SubmitArea;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/TextInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInput = function (_Component) {
    _inherits(TextInput, _Component);

    function TextInput() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TextInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
            var value = event.target.value;
            var _this$props = _this.props,
                type = _this$props.type,
                max = _this$props.max,
                onMaxReached = _this$props.onMaxReached;


            if (type !== "number" && max !== 0 && value.length > max) {
                if (_lodash2.default.isFunction(onMaxReached)) {
                    onMaxReached();
                }
            } else {
                _this.props.onChange(value, event);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isRequired = _props.isRequired,
                value = _props.value,
                max = _props.max,
                type = _props.type;


            var className = (0, _classnames2.default)('form-control', this.props.className, {
                'read-only': this.props.readOnly,
                'error': this.props.error
            });

            return _react2.default.createElement(
                'span',
                { className: 'text_input' },
                _react2.default.createElement('input', _extends({}, this.props, {
                    ref: this.props.inputRef,
                    type: type,
                    onChange: this.onChange,
                    onBlur: this.props.onBlur,
                    value: value || '',
                    className: className,
                    required: isRequired === true ? "required" : "",
                    readOnly: this.props.readOnly
                })),
                type !== "number" && max !== 0 && _react2.default.createElement(
                    'div',
                    {
                        className: 'text_input__counter'
                    },
                    value.length,
                    ' / ',
                    max
                )
            );
        }
    }]);

    return TextInput;
}(_react.Component);

TextInput.defaultProps = {
    isRequired: false,

    type: 'text',

    readOnly: false,

    onChange: function onChange() {
        console.error('TextInput onChange not specified');
    },

    onBlur: function onBlur() {},

    max: 0,

    error: false,

    inputRef: null
};
TextInput.propTypes = {
    value: _propTypes2.default.string,

    onChange: _propTypes2.default.func,

    onBlur: _propTypes2.default.func,

    className: _propTypes2.default.string,

    isRequired: _propTypes2.default.bool,

    type: _propTypes2.default.string,

    readOnly: _propTypes2.default.bool,

    max: _propTypes2.default.number,

    onMaxReached: _propTypes2.default.func,

    error: _propTypes2.default.bool,

    inputRef: _propTypes2.default.func
};
exports.default = TextInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/TextInputLocalized.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _TextareaInput = __webpack_require__("./sdk/scripts/components/form/TextareaInput.js");

var _TextareaInput2 = _interopRequireDefault(_TextareaInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInputLocalized = function (_Component) {
  _inherits(TextInputLocalized, _Component);

  function TextInputLocalized() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextInputLocalized);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextInputLocalized.__proto__ || Object.getPrototypeOf(TextInputLocalized)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentLocale: _lodash2.default.find(_this.props.locales, function (locale) {
        return locale.locale.indexOf(_I18n2.default.getCurrentLanguageWithoutRegionCode()) > -1;
      })
    }, _this.onChange = function (event) {
      var value = event.target.value;
      var _this$props = _this.props,
          type = _this$props.type,
          max = _this$props.max,
          onMaxReached = _this$props.onMaxReached;


      if (type !== "number" && max !== 0 && value.length > max) {
        if (_lodash2.default.isFunction(onMaxReached)) {
          onMaxReached();
        }
      } else {
        var values = _this.props.values || [];

        if (_lodash2.default.find(values, { locale: _this.state.currentLocale.locale })) {
          if (!_lodash2.default.isEmpty(value)) {
            values = _ArrayUtils2.default.updateObject(values, {
              locale: _this.state.currentLocale.locale,
              text: value
            }, function (oldValue) {
              return oldValue && oldValue.locale === _this.state.currentLocale.locale;
            });
          } else {
            values = _ArrayUtils2.default.removeObject(values, function (oldValue) {
              return oldValue.locale === _this.state.currentLocale.locale;
            });
          }
        } else {
          values = [].concat(_toConsumableArray(values), [{
            locale: _this.state.currentLocale.locale,
            text: value
          }]);
        }

        _this.props.onChange(values);
      }
    }, _this.handleChangeLocale = function (locale) {
      _this.setState({
        currentLocale: locale
      }, _this.input.focus());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextInputLocalized, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          locales = _props.locales,
          isRequired = _props.isRequired,
          values = _props.values,
          max = _props.max,
          type = _props.type,
          multiLine = _props.multiLine;


      var classNameWrapper = (0, _classnames2.default)('text_input text_input_localized', {
        multiLine: multiLine
      });

      var className = (0, _classnames2.default)('form-control', this.props.className, {
        'read-only': this.props.readOnly,
        'error': this.props.error
      });

      var localizedValue = _lodash2.default.find(values, { locale: this.state.currentLocale.locale });

      return _react2.default.createElement(
        'span',
        { className: classNameWrapper },
        _react2.default.createElement(
          'div',
          { className: 'input-group' },
          _react2.default.createElement(
            'div',
            { className: 'input-group-btn' },
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default dropdown-toggle',
                'data-toggle': 'dropdown',
                'aria-haspopup': 'true',
                'aria-expanded': 'false'
              },
              this.state.currentLocale.name,
              ' ',
              _react2.default.createElement('span', { className: 'caret' })
            ),
            _react2.default.createElement(
              'ul',
              { className: 'dropdown-menu' },
              locales.map(function (locale) {
                return _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { onClick: function onClick() {
                        return _this2.handleChangeLocale(locale);
                      } },
                    locale.name
                  )
                );
              })
            )
          ),
          !multiLine ? _react2.default.createElement('input', _extends({
            ref: function ref(input) {
              return _this2.input = input;
            }
          }, this.props, {
            type: type,
            onChange: this.onChange,
            onBlur: this.props.onBlur,
            value: localizedValue ? localizedValue.text : '',
            className: className,
            required: isRequired === true ? "required" : "",
            readOnly: this.props.readOnly
          })) : _react2.default.createElement('textarea', _extends({
            ref: function ref(input) {
              return _this2.input = input;
            }
          }, this.props, {
            type: type,
            onChange: this.onChange,
            onBlur: this.props.onBlur,
            value: localizedValue ? localizedValue.text : '',
            className: className,
            required: isRequired === true ? "required" : "",
            readOnly: this.props.readOnly
          }))
        ),
        type !== "number" && max !== 0 && _react2.default.createElement(
          'div',
          {
            className: 'text_input__counter'
          },
          localizedValue ? localizedValue.text.length : 0,
          ' / ',
          max
        )
      );
    }
  }]);

  return TextInputLocalized;
}(_react.Component);

TextInputLocalized.defaultProps = {
  isRequired: false,

  type: 'text',

  readOnly: false,

  onChange: function onChange() {
    console.error('TextInputLocalized onChange not specified');
  },

  onBlur: function onBlur() {},

  max: 0,

  error: false,

  multiLine: false,

  values: []
};
TextInputLocalized.propTypes = {
  locales: _propTypes2.default.array,

  values: _propTypes2.default.array,

  onChange: _propTypes2.default.func,

  onBlur: _propTypes2.default.func,

  className: _propTypes2.default.string,

  isRequired: _propTypes2.default.bool,

  type: _propTypes2.default.string,

  readOnly: _propTypes2.default.bool,

  max: _propTypes2.default.number,

  onMaxReached: _propTypes2.default.func,

  error: _propTypes2.default.bool,

  multiLine: _propTypes2.default.bool
};
exports.default = TextInputLocalized;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/TextareaInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextareaInput = function (_Component) {
  _inherits(TextareaInput, _Component);

  function TextareaInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextareaInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextareaInput.__proto__ || Object.getPrototypeOf(TextareaInput)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
      var value = event.target.value;
      var _this$props = _this.props,
          max = _this$props.max,
          onMaxReached = _this$props.onMaxReached;


      if (max !== 0 && value.length > max) {
        if (_lodash2.default.isFunction(onMaxReached)) {
          onMaxReached();
        }
      } else {
        _this.props.onChange(value, event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextareaInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rows = _props.rows,
          placeholder = _props.placeholder,
          isRequired = _props.isRequired,
          value = _props.value,
          max = _props.max;


      var className = (0, _classnames2.default)('form-control', this.props.className, {
        'resize-none': !this.props.resizable
      });

      return _react2.default.createElement(
        'span',
        { className: 'textarea_input' },
        _react2.default.createElement('textarea', {
          onChange: this.onChange,
          placeholder: placeholder,
          value: value || '',
          className: className,
          required: isRequired === true ? 'required' : '',
          rows: rows,
          disabled: this.props.readOnly
        }),
        max !== 0 && _react2.default.createElement(
          'div',
          {
            className: 'textarea_input__counter'
          },
          value.length,
          ' / ',
          max
        )
      );
    }
  }]);

  return TextareaInput;
}(_react.Component);

TextareaInput.defaultProps = {
  isRequired: false,

  rows: 4,

  readOnly: false,

  resizable: false,

  max: 0,

  value: ''
};
TextareaInput.propTypes = {
  value: _propTypes2.default.string,

  placeholder: _propTypes2.default.string,

  /**
   * @param number The phone number
   */
  onChange: _propTypes2.default.func.isRequired,

  className: _propTypes2.default.string,

  isRequired: _propTypes2.default.bool,

  rows: _propTypes2.default.number,

  readOnly: _propTypes2.default.bool,

  resizable: _propTypes2.default.bool,

  max: _propTypes2.default.number,

  onMaxReached: _propTypes2.default.func
};
exports.default = TextareaInput;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/TimeZoneChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__("./node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var TimeZoneChooser = function (_Component) {
  _inherits(TimeZoneChooser, _Component);

  function TimeZoneChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeZoneChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeZoneChooser.__proto__ || Object.getPrototypeOf(TimeZoneChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (option) {
      if (_lodash2.default.isNull(option)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeZoneChooser, [{
    key: 'render',
    value: function render() {
      var options = [];
      var zonesNames = _momentTimezone2.default.tz.names();

      _lodash2.default.each(zonesNames, function (zoneName) {
        var utcOffset = _momentTimezone2.default.tz(zoneName).utcOffset() / 60; // to hour
        var isPositive = utcOffset > 0;
        var utcOffsetString = isPositive ? '+' + utcOffset : '' + utcOffset;

        options.push({
          label: zoneName + ' (' + utcOffsetString + ')',
          value: zoneName
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'country_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.value,
          options: options,
          onChange: this.onChange,
          clearable: this.props.clearable,
          readOnly: this.props.readOnly
        })
      );
    }
  }]);

  return TimeZoneChooser;
}(_react.Component);

TimeZoneChooser.defaultProps = {
  clearable: false,

  readOnly: false
};
TimeZoneChooser.propTypes = {
  // 'Europe/Paris' for example
  value: _propTypes2.default.string.isRequired,

  // param: String (Country code 'FR' for example.)
  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool
};
exports.default = TimeZoneChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/TransferFrequencyChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _TransferFrequency = __webpack_require__("./sdk/scripts/constants/TransferFrequency.js");

var _TransferFrequency2 = _interopRequireDefault(_TransferFrequency);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var TransferFrequencyChooser = function (_Component) {
  _inherits(TransferFrequencyChooser, _Component);

  function TransferFrequencyChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TransferFrequencyChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TransferFrequencyChooser.__proto__ || Object.getPrototypeOf(TransferFrequencyChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (option) {
      if (_lodash2.default.isNull(option)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TransferFrequencyChooser, [{
    key: 'render',
    value: function render() {
      var choices = _TransferFrequency2.default.getChoices();

      return _react2.default.createElement(
        'div',
        { className: 'transfer_frequency_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.value,
          options: choices,
          onChange: this.onSelect,
          clearable: true,
          placeholder: _I18n2.default.tr('components.transfer_frequency_chooser.placeholder'),
          readOnly: this.props.readOnly
        })
      );
    }
  }]);

  return TransferFrequencyChooser;
}(_react.Component);

TransferFrequencyChooser.defaultProps = {
  readOnly: false
};
TransferFrequencyChooser.propTypes = {
  value: _propTypes2.default.string.isRequired,

  // param: String, the chosen POS
  onChange: _propTypes2.default.func.isRequired,

  readOnly: _propTypes2.default.bool
};
exports.default = TransferFrequencyChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/VatChooser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _TaxesType = __webpack_require__("./sdk/scripts/constants/TaxesType.js");

var _TaxesType2 = _interopRequireDefault(_TaxesType);

var _LocalizableSelect = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect2 = _interopRequireDefault(_LocalizableSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var VatChooser = function (_Component) {
  _inherits(VatChooser, _Component);

  function VatChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VatChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VatChooser.__proto__ || Object.getPrototypeOf(VatChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (option) {
      if (_lodash2.default.isNull(option)) {
        _this.props.onChange(0);
      } else {
        _this.props.onChange(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VatChooser, [{
    key: 'render',
    value: function render() {
      var taxesChoices = _TaxesType2.default.getChoices();

      return _react2.default.createElement(
        'div',
        { className: 'vat_chooser' },
        _react2.default.createElement(_LocalizableSelect2.default, {
          name: 'action',
          value: this.props.value,
          options: taxesChoices,
          onChange: this.onSelect,
          clearable: this.props.clearable,
          placeholder: _I18n2.default.tr('components.vat_chooser.placeholder'),
          disabled: this.props.readOnly
        })
      );
    }
  }]);

  return VatChooser;
}(_react.Component);

VatChooser.defaultProps = {
  clearable: true,

  readOnly: false
};
VatChooser.propTypes = {
  value: _propTypes2.default.number.isRequired,

  // param: number, the chosen vat
  onChange: _propTypes2.default.func.isRequired,

  clearable: _propTypes2.default.bool,

  readOnly: _propTypes2.default.bool
};
exports.default = VatChooser;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VatChooser = exports.TransferFrequencyChooser = exports.TimeZoneChooser = exports.TextareaInput = exports.TextInputLocalized = exports.TextInput = exports.SubmitArea = exports.StringsList = exports.SimplePhoneInput = exports.RestaurantTagChooser = exports.PriceInput = exports.PhonesList = exports.PhoneInput = exports.PdfDropzone = exports.PasswordInput = exports.POSChooser = exports.OrderModeChooser = exports.OptionView = exports.OptionsList = exports.NumberSelector = exports.NumberInputModal = exports.NumberInput = exports.NumberChooser = exports.NumberButtonView = exports.LocalizableSelect = exports.LocaleChooser = exports.ImageDropzone = exports.FormGroupView = exports.FixedSubmitArea = exports.EmailsList = exports.EmailInput = exports.DateField = exports.CurrencyChooser = exports.CropImageModal = exports.CountryChooser = exports.BitfieldChooser = undefined;

var _BitfieldChooser2 = __webpack_require__("./sdk/scripts/components/form/BitfieldChooser.js");

var _BitfieldChooser3 = _interopRequireDefault(_BitfieldChooser2);

var _CountryChooser2 = __webpack_require__("./sdk/scripts/components/form/CountryChooser.js");

var _CountryChooser3 = _interopRequireDefault(_CountryChooser2);

var _CropImageModal2 = __webpack_require__("./sdk/scripts/components/form/CropImageModal.js");

var _CropImageModal3 = _interopRequireDefault(_CropImageModal2);

var _CurrencyChooser2 = __webpack_require__("./sdk/scripts/components/form/CurrencyChooser.js");

var _CurrencyChooser3 = _interopRequireDefault(_CurrencyChooser2);

var _DateField2 = __webpack_require__("./sdk/scripts/components/form/DateField.js");

var _DateField3 = _interopRequireDefault(_DateField2);

var _EmailInput2 = __webpack_require__("./sdk/scripts/components/form/EmailInput.js");

var _EmailInput3 = _interopRequireDefault(_EmailInput2);

var _EmailsList2 = __webpack_require__("./sdk/scripts/components/form/EmailsList.js");

var _EmailsList3 = _interopRequireDefault(_EmailsList2);

var _FixedSubmitArea2 = __webpack_require__("./sdk/scripts/components/form/FixedSubmitArea.js");

var _FixedSubmitArea3 = _interopRequireDefault(_FixedSubmitArea2);

var _FormGroupView2 = __webpack_require__("./sdk/scripts/components/form/FormGroupView.js");

var _FormGroupView3 = _interopRequireDefault(_FormGroupView2);

var _ImageDropzone2 = __webpack_require__("./sdk/scripts/components/form/ImageDropzone.js");

var _ImageDropzone3 = _interopRequireDefault(_ImageDropzone2);

var _LocaleChooser2 = __webpack_require__("./sdk/scripts/components/form/LocaleChooser.js");

var _LocaleChooser3 = _interopRequireDefault(_LocaleChooser2);

var _LocalizableSelect2 = __webpack_require__("./sdk/scripts/components/form/LocalizableSelect.js");

var _LocalizableSelect3 = _interopRequireDefault(_LocalizableSelect2);

var _NumberButtonView2 = __webpack_require__("./sdk/scripts/components/form/NumberButtonView.js");

var _NumberButtonView3 = _interopRequireDefault(_NumberButtonView2);

var _NumberChooser2 = __webpack_require__("./sdk/scripts/components/form/NumberChooser.js");

var _NumberChooser3 = _interopRequireDefault(_NumberChooser2);

var _NumberInput2 = __webpack_require__("./sdk/scripts/components/form/NumberInput.js");

var _NumberInput3 = _interopRequireDefault(_NumberInput2);

var _NumberInputModal2 = __webpack_require__("./sdk/scripts/components/form/NumberInputModal.js");

var _NumberInputModal3 = _interopRequireDefault(_NumberInputModal2);

var _NumberSelector2 = __webpack_require__("./sdk/scripts/components/form/NumberSelector.js");

var _NumberSelector3 = _interopRequireDefault(_NumberSelector2);

var _OptionsList2 = __webpack_require__("./sdk/scripts/components/form/OptionsList.js");

var _OptionsList3 = _interopRequireDefault(_OptionsList2);

var _OptionView2 = __webpack_require__("./sdk/scripts/components/form/OptionView.js");

var _OptionView3 = _interopRequireDefault(_OptionView2);

var _OrderModeChooser2 = __webpack_require__("./sdk/scripts/components/form/OrderModeChooser.js");

var _OrderModeChooser3 = _interopRequireDefault(_OrderModeChooser2);

var _POSChooser2 = __webpack_require__("./sdk/scripts/components/form/POSChooser.js");

var _POSChooser3 = _interopRequireDefault(_POSChooser2);

var _PasswordInput2 = __webpack_require__("./sdk/scripts/components/form/PasswordInput.js");

var _PasswordInput3 = _interopRequireDefault(_PasswordInput2);

var _PdfDropzone2 = __webpack_require__("./sdk/scripts/components/form/PdfDropzone.js");

var _PdfDropzone3 = _interopRequireDefault(_PdfDropzone2);

var _PhoneInput2 = __webpack_require__("./sdk/scripts/components/form/PhoneInput.js");

var _PhoneInput3 = _interopRequireDefault(_PhoneInput2);

var _PhonesList2 = __webpack_require__("./sdk/scripts/components/form/PhonesList.js");

var _PhonesList3 = _interopRequireDefault(_PhonesList2);

var _PriceInput2 = __webpack_require__("./sdk/scripts/components/form/PriceInput.js");

var _PriceInput3 = _interopRequireDefault(_PriceInput2);

var _RestaurantTagChooser2 = __webpack_require__("./sdk/scripts/components/form/RestaurantTagChooser.js");

var _RestaurantTagChooser3 = _interopRequireDefault(_RestaurantTagChooser2);

var _SimplePhoneInput2 = __webpack_require__("./sdk/scripts/components/form/SimplePhoneInput.js");

var _SimplePhoneInput3 = _interopRequireDefault(_SimplePhoneInput2);

var _StringsList2 = __webpack_require__("./sdk/scripts/components/form/StringsList.js");

var _StringsList3 = _interopRequireDefault(_StringsList2);

var _SubmitArea2 = __webpack_require__("./sdk/scripts/components/form/SubmitArea.js");

var _SubmitArea3 = _interopRequireDefault(_SubmitArea2);

var _TextInput2 = __webpack_require__("./sdk/scripts/components/form/TextInput.js");

var _TextInput3 = _interopRequireDefault(_TextInput2);

var _TextInputLocalized2 = __webpack_require__("./sdk/scripts/components/form/TextInputLocalized.js");

var _TextInputLocalized3 = _interopRequireDefault(_TextInputLocalized2);

var _TextareaInput2 = __webpack_require__("./sdk/scripts/components/form/TextareaInput.js");

var _TextareaInput3 = _interopRequireDefault(_TextareaInput2);

var _TimeZoneChooser2 = __webpack_require__("./sdk/scripts/components/form/TimeZoneChooser.js");

var _TimeZoneChooser3 = _interopRequireDefault(_TimeZoneChooser2);

var _TransferFrequencyChooser2 = __webpack_require__("./sdk/scripts/components/form/TransferFrequencyChooser.js");

var _TransferFrequencyChooser3 = _interopRequireDefault(_TransferFrequencyChooser2);

var _VatChooser2 = __webpack_require__("./sdk/scripts/components/form/VatChooser.js");

var _VatChooser3 = _interopRequireDefault(_VatChooser2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BitfieldChooser = _BitfieldChooser3.default;
exports.CountryChooser = _CountryChooser3.default;
exports.CropImageModal = _CropImageModal3.default;
exports.CurrencyChooser = _CurrencyChooser3.default;
exports.DateField = _DateField3.default;
exports.EmailInput = _EmailInput3.default;
exports.EmailsList = _EmailsList3.default;
exports.FixedSubmitArea = _FixedSubmitArea3.default;
exports.FormGroupView = _FormGroupView3.default;
exports.ImageDropzone = _ImageDropzone3.default;
exports.LocaleChooser = _LocaleChooser3.default;
exports.LocalizableSelect = _LocalizableSelect3.default;
exports.NumberButtonView = _NumberButtonView3.default;
exports.NumberChooser = _NumberChooser3.default;
exports.NumberInput = _NumberInput3.default;
exports.NumberInputModal = _NumberInputModal3.default;
exports.NumberSelector = _NumberSelector3.default;
exports.OptionsList = _OptionsList3.default;
exports.OptionView = _OptionView3.default;
exports.OrderModeChooser = _OrderModeChooser3.default;
exports.POSChooser = _POSChooser3.default;
exports.PasswordInput = _PasswordInput3.default;
exports.PdfDropzone = _PdfDropzone3.default;
exports.PhoneInput = _PhoneInput3.default;
exports.PhonesList = _PhonesList3.default;
exports.PriceInput = _PriceInput3.default;
exports.RestaurantTagChooser = _RestaurantTagChooser3.default;
exports.SimplePhoneInput = _SimplePhoneInput3.default;
exports.StringsList = _StringsList3.default;
exports.SubmitArea = _SubmitArea3.default;
exports.TextInput = _TextInput3.default;
exports.TextInputLocalized = _TextInputLocalized3.default;
exports.TextareaInput = _TextareaInput3.default;
exports.TimeZoneChooser = _TimeZoneChooser3.default;
exports.TransferFrequencyChooser = _TransferFrequencyChooser3.default;
exports.VatChooser = _VatChooser3.default;

/***/ }),

/***/ "./sdk/scripts/components/pdfViewer/PdfView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Setting worker path to worker bundle.
// https://github.com/mozilla/pdf.js/blob/master/examples/webpack/main.js#L11
// https://github.com/mozilla/pdf.js/blob/master/examples/webpack/webpack.config.js#L8

__webpack_require__("./node_modules/pdfjs-dist/build/pdf.js");
__webpack_require__("./node_modules/pdfjs-dist/web/pdf_viewer.js"); // Only if you need `PDFJS.PDFViewer`

PDFJS.workerSrc = 'pdf.worker.bundle.js';

// -- views

var PdfView = function (_Component) {
  _inherits(PdfView, _Component);

  function PdfView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PdfView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PdfView.__proto__ || Object.getPrototypeOf(PdfView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pageInfo: null,

      pdf: null
    }, _this.onDocumentComplete = function (pdf) {
      //    if (!this.isMounted()) {
      // return;
      //  }
      _this.setState({
        pdf: pdf
      });

      _this.props.onDocumentComplete(pdf.numPages);

      pdf.getPage(_this.props.page).then(_this.onPageCompleted);
    }, _this.onPageCompleted = function (pageInfo) {

      _this.setState({
        pageInfo: pageInfo
      });

      _this.renderPdf();

      _this.props.onPageCompleted(pageInfo.pageIndex + 1);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PdfView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadPDFDocument(this.props);
      this.renderPdf();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.file && newProps.file !== this.props.file || newProps.content && newProps.content !== this.props.content) {
        this.loadPDFDocument(newProps);
      }
      if (!!this.state.pdf && !!newProps.page && newProps.page !== this.props.page) {
        this.setState({
          pageInfo: null
        });
        this.state.pdf.getPage(newProps.page).then(this.onPageCompleted);
      }
    }

    // -- pdf loading

  }, {
    key: 'loadByteArray',
    value: function loadByteArray(byteArray) {
      PDFJS.getDocument(byteArray).then(this.onDocumentComplete);
    }
  }, {
    key: 'loadPDFDocument',
    value: function loadPDFDocument(props) {
      var _this2 = this;

      if (!!props.file) {
        if (_lodash2.default.isString(props.file)) {
          if (!_lodash2.default.isNull(this.props.httpHeaders)) {
            // see https://groups.google.com/forum/#!topic/mozilla.dev.pdf-js/iDUqbjMRcGc
            var docInitParams = {
              url: props.file,
              httpHeaders: this.props.httpHeaders
            };
            return PDFJS.getDocument(docInitParams).then(this.onDocumentComplete);
          }

          return PDFJS.getDocument(props.file).then(this.onDocumentComplete);
        }
        // Is a File object
        var reader = new FileReader();
        reader.onload = function () {
          var content = new Uint8Array(reader.result);
          _this2.loadByteArray(content);
        };
        reader.readAsArrayBuffer(props.file);
      } else if (!!props.content) {
        var bytes = window.atob(props.content);
        var byteLength = bytes.length;
        var byteArray = new Uint8Array(new ArrayBuffer(byteLength));
        for (var index = 0; index < byteLength; index++) {
          byteArray[index] = bytes.charCodeAt(index);
        }
        this.loadByteArray(byteArray);
      } else {
        console.error('pdfViewer works with a file(URL) or (base64)content. At least one needs to be provided!');
      }
    }
  }, {
    key: 'renderCanvas',
    value: function renderCanvas() {
      return _react2.default.createElement('canvas', {
        className: 'pdf_canvas',
        ref: 'pdfCanvas',
        onClick: this.props.onClick
      });
    }
  }, {
    key: 'renderPdf',
    value: function renderPdf() {
      var pageInfo = this.state.pageInfo;

      if (!_lodash2.default.isNull(pageInfo)) {

        // see http://mozilla.github.io/pdf.js/examples/
        var canvas = _reactDom2.default.findDOMNode(this.refs.pdfCanvas);
        var context = canvas.getContext('2d');
        var scale = this.props.scale;
        var viewport = pageInfo.getViewport(scale);

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };

        pageInfo.render(renderContext);
      }
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      if (_lodash2.default.isNull(this.props.loading)) {
        return _react2.default.createElement(
          'div',
          { className: 'pdf_canvas_loading' },
          _react2.default.createElement(_SvgIcon2.default, {
            icon: _SvgIcon2.default.LOADING_BAR
          })
        );
      }
      return this.props.loading;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!_lodash2.default.isNull(this.state.pageInfo)) {
        return this.renderCanvas();
      }

      return this.renderLoading();
    }
  }]);

  return PdfView;
}(_react.Component);

PdfView.propTypes = {
  file: _propTypes2.default.object,

  content: _propTypes2.default.string,

  page: _propTypes2.default.number,

  httpHeaders: _propTypes2.default.object,

  scale: _propTypes2.default.number,
  loading: _propTypes2.default.object,

  onClick: _propTypes2.default.func.isRequired,

  onDocumentComplete: _propTypes2.default.func.isRequired,

  onPageCompleted: _propTypes2.default.func.isRequired
};
PdfView.defaultProps = {
  page: 1,

  scale: 1.0,

  loading: null,

  httpHeaders: null
};
exports.default = PdfView;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/pdfViewer/PdfViewerModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__("./node_modules/react-bootstrap/es/index.js");

var _pdfViewer = __webpack_require__("./sdk/scripts/components/pdfViewer/index.js");

var _pdfViewer2 = _interopRequireDefault(_pdfViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PdfViewerModal = function (_Component) {
  _inherits(PdfViewerModal, _Component);

  function PdfViewerModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PdfViewerModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PdfViewerModal.__proto__ || Object.getPrototypeOf(PdfViewerModal)).call.apply(_ref, [this].concat(args))), _this), _this.onHide = function () {
      _this.props.onHide();
    }, _this.onClose = function () {
      _this.props.onHide();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PdfViewerModal, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.show !== this.props.show;
    }

    // -- events - modal

  }, {
    key: 'renderBody',


    // -- renderers

    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        { className: 'row pdf_viewer_modal' },
        _react2.default.createElement(_pdfViewer2.default, {
          file: this.props.file,
          httpHeaders: this.props.httpHeaders
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          bsSize: 'large',
          show: this.props.show,
          onHide: this.onHide
        },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'close close-white',
              onClick: this.onClose
            },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            this.props.title
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this.renderBody()
        )
      );
    }
  }]);

  return PdfViewerModal;
}(_react.Component);

PdfViewerModal.defaultProps = {
  title: '',

  httpHeaders: {}
};
PdfViewerModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,

  onHide: _propTypes2.default.func.isRequired,

  file: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,

  httpHeaders: _propTypes2.default.object,

  // the modal title
  title: _propTypes2.default.string
};
exports.default = PdfViewerModal;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/pdfViewer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _PdfView = __webpack_require__("./sdk/scripts/components/pdfViewer/PdfView.js");

var _PdfView2 = _interopRequireDefault(_PdfView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- views


var PdfViewer = function (_Component) {
  _inherits(PdfViewer, _Component);

  function PdfViewer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PdfViewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PdfViewer.__proto__ || Object.getPrototypeOf(PdfViewer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      page: _this.props.page,

      nbPages: null
    }, _this.onDocumentComplete = function (nbPages) {
      _this.setState({
        nbPages: nbPages
      });
    }, _this.onPageCompleted = function (page) {
      _this.setState({ page: page });
    }, _this.onPreviousPage = function () {
      var newPageIndex = _this.state.page - 1;

      if (newPageIndex <= 0) {
        return;
      }

      _this.setState({
        page: newPageIndex
      });
    }, _this.onNextPage = function () {
      var newPageIndex = _this.state.page + 1;

      if (newPageIndex > _this.state.nbPages) {
        return;
      }

      _this.setState({
        page: newPageIndex
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // -- pdf loading


  // --

  _createClass(PdfViewer, [{
    key: 'renderPagination',


    // -- renderers

    value: function renderPagination() {
      // we are loading the pdf or there is only one page
      if (_lodash2.default.isNull(this.state.nbPages) || this.state.nbPages === 1) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'row pdf_viewer__pagination' },
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-4 pagination__previous'
          },
          this.state.page !== 1 && _react2.default.createElement(
            'button',
            {
              className: 'btn',
              onClick: this.onPreviousPage
            },
            _react2.default.createElement('i', { className: 'fa fa-arrow-left' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-4 pagination__page' },
          this.state.page,
          ' / ',
          this.state.nbPages
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-4 pagination__next'
          },
          this.state.page !== this.state.nbPages && _react2.default.createElement(
            'button',
            {
              className: 'btn',
              onClick: this.onNextPage
            },
            _react2.default.createElement('i', { className: 'fa fa-arrow-right' })
          )
        )
      );
    }
  }, {
    key: 'renderPdfView',
    value: function renderPdfView() {
      return _react2.default.createElement(_PdfView2.default, {
        file: this.props.file,
        page: this.state.page,
        scale: this.props.scale,
        httpHeaders: this.props.httpHeaders,
        onClick: this.onNextPage,
        onDocumentComplete: this.onDocumentComplete,
        onPageCompleted: this.onPageCompleted
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'pdf_viewer' },
        this.renderPagination(),
        this.renderPdfView()
      );
    }
  }]);

  return PdfViewer;
}(_react.Component);

PdfViewer.propTypes = {
  // String url or File object.
  file: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  httpHeaders: _propTypes2.default.object,

  content: _propTypes2.default.string,
  page: _propTypes2.default.number,
  scale: _propTypes2.default.number,
  loading: _propTypes2.default.object
};
PdfViewer.defaultProps = {
  page: 1,

  scale: 1.0
};
exports.default = PdfViewer;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/components/reactPhoneInput/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _collection = __webpack_require__("./sdk/node_modules/lodash/collection.js");

var _array = __webpack_require__("./sdk/node_modules/lodash/array.js");

var _function = __webpack_require__("./sdk/node_modules/lodash/function.js");

var _string = __webpack_require__("./sdk/node_modules/lodash/string.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CountryData = __webpack_require__("./sdk/scripts/utils/CountryData.js");

var _CountryData2 = _interopRequireDefault(_CountryData);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// See https://github.com/razagill/react-phone-input

// TODO - fix the onlyCountries props. Currently expects that as an array of
// country object, but users should be able to send in array of country isos

var allCountries = _CountryData2.default.allCountries;

var isModernBrowser = Boolean(document.createElement('input').setSelectionRange);

var keys = {
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  LEFT: 37,
  ENTER: 13,
  ESC: 27,
  PLUS: 43,
  A: 65,
  Z: 90,
  SPACE: 32
};

function isNumberValid(inputNumber) {
  var countries = _CountryData2.default.allCountries;
  return (0, _collection.some)(countries, function (country) {
    return (0, _string.startsWith)(inputNumber, country.dialCode) || (0, _string.startsWith)(country.dialCode, inputNumber);
  });
}

function getOnlyCountries(onlyCountriesArray) {
  if (onlyCountriesArray.length === 0) {
    return allCountries;
  }
  var selectedCountries = [];
  allCountries.map(function (country) {
    onlyCountriesArray.map(function (selCountry) {
      if (country.iso2 === selCountry) {
        selectedCountries.push(country);
      }
    });
  });
  return selectedCountries;
}

function excludeCountries(selectedCountries, excludedCountries) {
  if (excludedCountries.length === 0) {
    return selectedCountries;
  }
  return (0, _collection.filter)(selectedCountries, function (selCountry) {
    return !(0, _collection.includes)(excludedCountries, selCountry.iso2);
  });
}

var ReactPhoneInput = function (_React$Component) {
  _inherits(ReactPhoneInput, _React$Component);

  function ReactPhoneInput(props) {
    _classCallCheck(this, ReactPhoneInput);

    var _this = _possibleConstructorReturn(this, (ReactPhoneInput.__proto__ || Object.getPrototypeOf(ReactPhoneInput)).call(this, props));

    _this.resetNumber = function () {
      var formattedNumber = _this.formatNumber(_this.state.selectedCountry.dialCode, _this.state.selectedCountry.format);
      _this.setState({
        formattedNumber: formattedNumber
      });
    };

    _this.handleFlagDropdownClick = function () {
      if (_this.props.disabled === true) {
        return;
      }

      // need to put the highlight on the current selected country if the dropdown is going to open up
      _this.setState({
        showDropDown: !_this.state.showDropDown,
        highlightCountry: (0, _collection.find)(_this.state.onlyCountries, _this.state.selectedCountry),
        highlightCountryIndex: (0, _array.findIndex)(_this.state.onlyCountries, _this.state.selectedCountry)
      }, function () {
        if (_this.state.showDropDown) {
          _this.scrollTo(_this.getElement(_this.state.highlightCountryIndex + _this.state.preferredCountries.length));
        }
      });
    };

    _this.onChangeWithoutDialCode = function (event) {
      event.target.value = '+' + _this.state.selectedCountry.dialCode + event.target.value;
      _this.handleInput(event);
    };

    _this.handleInput = function (event) {
      var formattedNumber = '+';
      var newSelectedCountry = _this.state.selectedCountry;
      var freezeSelection = _this.state.freezeSelection;

      // Does not exceed 16 digit phone number limit
      if (event.target.value.replace(/\D/g, '').length > 16) {
        return;
      }

      // if the input is the same as before, must be some special key like enter etc.
      if (event.target.value === _this.state.formattedNumber) {
        return;
      }

      // ie hack
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }

      if (event.target.value.length > 0) {
        // before entering the number in new format, lets check if the dial code now
        // matches some other country
        var inputNumber = event.target.value.replace(/\D/g, '');

        // we don't need to send the whole number to guess the country... only the first 6 characters
        // are enough
        // the guess country function can then use memoization much more effectively since the set of
        // input it gets has drastically reduced
        if (!_this.state.freezeSelection || _this.state.selectedCountry.dialCode.length > inputNumber.length) {
          newSelectedCountry = _this.guessSelectedCountry(inputNumber.substring(0, 6), _this.state.onlyCountries);
          freezeSelection = false;
        }
        // const us remove all non numerals from the input
        formattedNumber = _this.formatNumber(inputNumber, newSelectedCountry.format);
      }

      var caretPosition = event.target.selectionStart;
      var oldFormattedText = _this.state.formattedNumber;
      var diff = formattedNumber.length - oldFormattedText.length;

      var selectedCountry = newSelectedCountry.dialCode.length > 0 ? newSelectedCountry : _this.state.selectedCountry;

      _this.setState({
        formattedNumber: formattedNumber,
        freezeSelection: freezeSelection,
        selectedCountry: selectedCountry
      }, function () {
        if (isModernBrowser) {
          if (diff > 0) {
            caretPosition = caretPosition - diff;
          }

          if (caretPosition > 0 && oldFormattedText.length >= formattedNumber.length) {
            _reactDom2.default.findDOMNode(_this.numberInput).setSelectionRange(caretPosition, caretPosition);
          }
        }

        if (_this.props.onChange) {
          if (_this.state.formattedNumber === '+' + _this.state.selectedCountry.dialCode) {
            _this.props.onChange('');
          } else {
            _this.props.onChange(_this.state.formattedNumber);
          }
        }
      });
    };

    _this.handleInputClick = function (evt) {
      _this.setState({ showDropDown: false });
      if (_this.props.onClick) {
        _this.props.onClick(evt);
      }
    };

    _this.handleFlagItemClick = function (country) {
      var currentSelectedCountry = _this.state.selectedCountry;
      var nextSelectedCountry = (0, _collection.find)(_this.state.onlyCountries, country);

      if (currentSelectedCountry.iso2 !== nextSelectedCountry.iso2) {
        // TODO - the below replacement is a bug. It will replace stuff from middle too
        var newNumber = _this.state.formattedNumber.replace(currentSelectedCountry.dialCode, nextSelectedCountry.dialCode);
        var formattedNumber = _this.formatNumber(newNumber.replace(/\D/g, ''), nextSelectedCountry.format);

        _this.setState({
          showDropDown: false,
          selectedCountry: nextSelectedCountry,
          freezeSelection: true,
          formattedNumber: formattedNumber
        }, function () {
          _this._cursorToEnd();
          if (_this.props.onChange) {
            _this.props.onChange(formattedNumber);
          }
        });
      }
    };

    _this.handleInputFocus = function (evt) {
      var node = _reactDom2.default.findDOMNode(_this.numberInput).value === '+';
      // if the input is blank, insert dial code of the selected country
      if (node && node.value === '+') {
        _this.setState({
          formattedNumber: '+' + _this.state.selectedCountry.dialCode + ')'
        }, function () {
          return setTimeout(_this._cursorToEnd, 10);
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(evt);
      }
    };

    _this._getHighlightCountryIndex = function (direction) {
      // had to write own function because underscore does not have findIndex. lodash has it
      var highlightCountryIndex = _this.state.highlightCountryIndex + direction;

      if (highlightCountryIndex < 0 || highlightCountryIndex >= _this.state.onlyCountries.length + _this.state.preferredCountries.length) {
        return highlightCountryIndex - direction;
      }

      return highlightCountryIndex;
    };

    _this.searchCountry = function () {
      var probableCandidate = _this._searchCountry(_this.state.queryString) || _this.state.onlyCountries[0];
      var probableCandidateIndex = (0, _array.findIndex)(_this.state.onlyCountries, probableCandidate) + _this.state.preferredCountries.length;

      _this.scrollTo(_this.getElement(probableCandidateIndex), true);

      _this.setState({
        queryString: '',
        highlightCountryIndex: probableCandidateIndex
      });
    };

    _this.handleKeydown = function (event) {
      if (!_this.state.showDropDown) {
        return;
      }

      // ie hack
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }

      function _moveHighlight(direction) {
        var _this2 = this;

        this.setState({
          highlightCountryIndex: this._getHighlightCountryIndex(direction)
        }, function () {
          _this2.scrollTo(_this2.getElement(_this2.state.highlightCountryIndex), true);
        });
      }

      switch (event.which) {
        case keys.DOWN:
          _moveHighlight(1);
          break;
        case keys.UP:
          _moveHighlight(-1);
          break;
        case keys.ENTER:
          _this.handleFlagItemClick(_this.state.onlyCountries[_this.state.highlightCountryIndex], event);
          break;
        case keys.ESC:
          _this.setState({ showDropDown: false }, _this._cursorToEnd);
          break;
        default:
          if (event.which >= keys.A && event.which <= keys.Z || event.which === keys.SPACE) {
            _this.setState({
              queryString: _this.state.queryString + String.fromCharCode(event.which)
            }, _this.state.debouncedQueryStingSearcher);
          }
      }
    };

    _this.handleInputKeyDown = function (event) {
      if (event.which === keys.ENTER) {
        _this.props.onEnterKeyPress(event);
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    };

    _this.handleClickOutside = function () {
      if (_this.state.showDropDown) {
        _this.setState({
          showDropDown: false
        });
      }
    };

    _this.renderCountryDropDownList = function () {
      var countryDropDownList = (0, _collection.map)(_this.state.preferredCountries.concat(_this.state.onlyCountries), function (country, index) {
        var itemClasses = (0, _classnames2.default)({
          country: true,
          preferred: country.iso2 === 'us' || country.iso2 === 'gb',
          active: country.iso2 === 'us',
          highlight: _this.state.highlightCountryIndex === index
        });

        var inputFlagClasses = 'flag ' + country.iso2;

        return _react2.default.createElement(
          'li',
          {
            ref: 'flag_no_' + index,
            key: 'flag_no_' + index,
            'data-flag-key': 'flag_no_' + index,
            className: itemClasses,
            'data-dial-code': '1',
            'data-country-code': country.iso2,
            onClick: function onClick() {
              _this.handleFlagItemClick(country);
            }
          },
          _react2.default.createElement('div', { className: inputFlagClasses }),
          _react2.default.createElement(
            'span',
            { className: 'country-name' },
            country.name
          ),
          _react2.default.createElement(
            'span',
            { className: 'dial-code' },
            '+' + country.dialCode
          )
        );
      });

      var dashedLi = _react2.default.createElement('li', { key: 'dashes', className: 'divider' });
      // let's insert a dashed line in between preffered countries and the rest
      countryDropDownList.splice(_this.state.preferredCountries.length, 0, dashedLi);

      var dropDownClasses = (0, _classnames2.default)({
        'country-list': true,
        hide: !_this.state.showDropDown
      });

      return _react2.default.createElement(
        'ul',
        { ref: 'flagDropdownList', className: dropDownClasses },
        countryDropDownList
      );
    };

    _this.state = _this.updateState(props);
    return _this;
  }

  _createClass(ReactPhoneInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // on certain devices (samsung), cursor "jumps" on previous char
      // we position it at the end on setState callback
      // setTimeout is necessary to ensure it's working
      this.setState(this.updateState(nextProps), function () {
        return setTimeout(_this3._cursorToEnd.bind(_this3), 0);
      });
    }
  }, {
    key: 'updateState',
    value: function updateState(props) {
      var inputNumber = props.value || '';

      var onlyCountries = excludeCountries(getOnlyCountries(props.onlyCountries), props.excludeCountries);

      var selectedCountryGuess = this.guessSelectedCountry(inputNumber.replace(/\D/g, ''), onlyCountries);

      var selectedCountryGuessIndex = (0, _array.findIndex)(allCountries, selectedCountryGuess);

      var dialCode = selectedCountryGuess && !(0, _string.startsWith)(inputNumber.replace(/\D/g, ''), selectedCountryGuess.dialCode) ? selectedCountryGuess.dialCode : '';

      var formattedNumber = this.formatNumber(dialCode + inputNumber.replace(/\D/g, ''), selectedCountryGuess ? selectedCountryGuess.format : null);

      var preferredCountries = (0, _collection.filter)(allCountries, function (country) {
        return (0, _collection.some)(props.preferredCountries, function (preferredCountry) {
          return preferredCountry === country.iso2;
        });
      });

      return {
        preferredCountries: preferredCountries,
        selectedCountry: selectedCountryGuess,
        highlightCountryIndex: selectedCountryGuessIndex,
        formattedNumber: formattedNumber,
        showDropDown: false,
        queryString: '',
        freezeSelection: false,
        debouncedQueryStingSearcher: (0, _function.debounce)(this.searchCountry, 100),
        onlyCountries: onlyCountries
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: 'getNumber',
    value: function getNumber() {
      return this.state.formattedNumber !== '+' ? this.state.formattedNumber : '';
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.getNumber();
    }
  }, {
    key: 'getElement',
    value: function getElement(index) {
      return _reactDom2.default.findDOMNode(this.refs['flag_no_' + index]);
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(country, middle) {
      if (!country) {
        return;
      }

      var container = _reactDom2.default.findDOMNode(this.refs.flagDropdownList);

      if (!container) {
        return;
      }

      var containerHeight = container.offsetHeight;
      var containerOffset = container.getBoundingClientRect();
      var containerTop = containerOffset.top + document.body.scrollTop;
      var containerBottom = containerTop + containerHeight;

      var element = country;
      var elementOffset = element.getBoundingClientRect();

      var elementHeight = element.offsetHeight;
      var elementTop = elementOffset.top + document.body.scrollTop;
      var elementBottom = elementTop + elementHeight;
      var newScrollTop = elementTop - containerTop + container.scrollTop;
      var middleOffset = containerHeight / 2 - elementHeight / 2;

      if (elementTop < containerTop) {
        // scroll up
        if (middle) {
          newScrollTop -= middleOffset;
        }
        container.scrollTop = newScrollTop;
      } else if (elementBottom > containerBottom) {
        // scroll down
        if (middle) {
          newScrollTop += middleOffset;
        }
        var heightDifference = containerHeight - elementHeight;
        container.scrollTop = newScrollTop - heightDifference;
      }
    }
  }, {
    key: 'formatNumber',
    value: function formatNumber(text, pattern) {
      if (!text || text.length === 0) {
        return '+';
      }

      // for all strings with length less than 3, just return it (1, 2 etc.)
      // also return the same text if the selected country has no fixed format
      if (text && text.length < 2 || !pattern || !this.props.autoFormat) {
        return '+' + text;
      }

      var formattedObject = (0, _collection.reduce)(pattern, function (acc, character) {
        if (acc.remainingText.length === 0) {
          return acc;
        }

        if (character !== '.') {
          return {
            formattedText: acc.formattedText + character,
            remainingText: acc.remainingText
          };
        }

        return {
          formattedText: acc.formattedText + (0, _array.head)(acc.remainingText),
          remainingText: (0, _array.tail)(acc.remainingText)
        };
      }, { formattedText: '', remainingText: text.split('') });

      return formattedObject.formattedText + formattedObject.remainingText.join('');
    }

    // put the cursor to the end of the input (usually after a focus event)

  }, {
    key: '_cursorToEnd',
    value: function _cursorToEnd() {
      var input = _reactDom2.default.findDOMNode(this.numberInput);
      input.focus();
      if (isModernBrowser) {
        var len = input.value.length;
        input.setSelectionRange(len, len);
      }
    }

    /**
     * This function is a tricks. We remove the dial code from the number in order to display it in
     * the phone input. Otherwise, the handleInput function work with the dial code, so we add it.
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */


    // -- renderers

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var arrowClasses = (0, _classnames2.default)({
        arrow: true,
        up: this.state.showDropDown
      });

      var inputClasses = (0, _classnames2.default)({
        'form-control': true,
        'invalid-number': !this.props.isValid(this.state.formattedNumber.replace(/\D/g, ''))
      });

      var flagViewClasses = (0, _classnames2.default)({
        'flag-dropdown': true,
        'open-dropdown': this.state.showDropDown
      });

      var inputFlagClasses = 'flag ' + this.state.selectedCountry.iso2;

      // remove dial code from number
      var value = this.state.formattedNumber.replace('+' + this.state.selectedCountry.dialCode, '');

      // handle padding for dial code with 2 digit and 3 digit
      var paddingLeft = this.state.selectedCountry.dialCode.length === 2 ? 70 : 80;
      var inputStyle = {
        paddingLeft: paddingLeft + 'px'
      };

      var globalClasses = (0, _classnames2.default)('react-tel-input', {
        disabled: this.props.disabled
      });

      return _react2.default.createElement(
        'div',
        { className: globalClasses },
        _react2.default.createElement('input', {
          autoComplete: 'on',
          placeholder: this.props.placeholder,
          style: inputStyle,
          onChange: this.onChangeWithoutDialCode,
          onClick: this.handleInputClick,
          onFocus: this.handleInputFocus,
          onKeyDown: this.handleInputKeyDown,
          value: value,
          ref: function ref(input) {
            _this4.numberInput = input;
          },
          type: 'tel',
          className: inputClasses,
          disabled: this.props.disabled
        }),
        _react2.default.createElement(
          'div',
          { className: 'phone-dial-code' },
          '+',
          this.state.selectedCountry.dialCode
        ),
        _react2.default.createElement(
          'div',
          {
            ref: 'flagDropDownButton',
            className: flagViewClasses,
            onKeyDown: this.handleKeydown
          },
          _react2.default.createElement(
            'div',
            {
              ref: 'selectedFlag',
              onClick: this.handleFlagDropdownClick,
              className: 'selected-flag',
              title: this.state.selectedCountry.name + ': + ' + this.state.selectedCountry.dialCode
            },
            _react2.default.createElement(
              'div',
              { className: inputFlagClasses },
              _react2.default.createElement('div', { className: arrowClasses })
            )
          ),
          this.state.showDropDown ? this.renderCountryDropDownList() : ''
        )
      );
    }
  }]);

  return ReactPhoneInput;
}(_react2.default.Component);

ReactPhoneInput.defaultProps = {
  value: '',
  autoFormat: true,
  onlyCountries: [],
  excludeCountries: [],
  defaultCountry: allCountries[0].iso2,
  isValid: isNumberValid,
  flagsImagePath: '/img/flags.png',
  onEnterKeyPress: function onEnterKeyPress() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  disabled: false
};
ReactPhoneInput.propTypes = {
  value: _propTypes2.default.string,
  autoFormat: _propTypes2.default.bool,
  defaultCountry: _propTypes2.default.string,
  onlyCountries: _propTypes2.default.arrayOf(_propTypes2.default.string),
  preferredCountries: _propTypes2.default.arrayOf(_propTypes2.default.string),
  excludeCountries: _propTypes2.default.arrayOf(_propTypes2.default.string),
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onEnterKeyPress: _propTypes2.default.func,
  isValid: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};
exports.default = ReactPhoneInput;


ReactPhoneInput.prototype._searchCountry = (0, _function.memoize)(function (queryString) {
  if (!queryString || queryString.length === 0) {
    return null;
  }
  // don't include the preferred countries in search
  var probableCountries = (0, _collection.filter)(this.state.onlyCountries, function (country) {
    return (0, _string.startsWith)(country.name.toLowerCase(), queryString.toLowerCase());
  }, this);

  return probableCountries[0];
});

ReactPhoneInput.prototype.guessSelectedCountry = (0, _function.memoize)(function (inputNumber, onlyCountries) {
  var secondBestGuess = (0, _collection.find)(allCountries, { iso2: this.props.defaultCountry }) || onlyCountries[0];
  var bestGuess = void 0;
  if ((0, _string.trim)(inputNumber) !== '') {
    bestGuess = (0, _collection.reduce)(onlyCountries, function (selectedCountry, country) {
      if ((0, _string.startsWith)(inputNumber, country.dialCode)) {
        if (country.dialCode.length > selectedCountry.dialCode.length) {
          return country;
        }
        if (country.dialCode.length === selectedCountry.dialCode.length && country.priority < selectedCountry.priority) {
          return country;
        }
      }
      return selectedCountry;
    }, { dialCode: '', priority: 10001 }, this);
  } else {
    return secondBestGuess;
  }

  if (!bestGuess.name) {
    return secondBestGuess;
  }

  return bestGuess;
});
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/APIEndpoints.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * TODO: replace {var} by :var
 */
var APIEndpoints = {
  API_CONSUMERS: '/restaurants-groups/:restaurantsGroupId/api-consumers',

  OAUTH_AUTHORIZE_APP: '/oauth/authorize',

  RESTAURANTS: '/restaurants',

  RESTAURANT: '/restaurants/:restaurantId',

  STATISTICS: '/restaurant/{restaurantId}/stats',

  PAYINS: '/restaurant/{restaurantId}/payin',

  PAYOUTS: '/restaurant/{restaurantId}/payout',

  RESTAURANT_MENU: '/restaurants/{restaurantId}/menu',

  RESTAURANT_MENU_PRODUCTS: '/restaurants/{restaurantId}/menu/products',

  RESTAURANT_MENU_PRODUCT: '/restaurants/{restaurantId}/menu/products/{productId}',

  RESTAURANT_MENU_PRODUCT_IMAGE: '/restaurants/{restaurantId}/menu/products/{productId}/image',

  RESTAURANT_MENU_MENUS: '/restaurants/{restaurantId}/menu/menus',

  RESTAURANT_MENU_MENU: '/restaurants/{restaurantId}/menu/menus/{menuId}',

  RESTAURANT_MENU_MENU_IMAGE: '/restaurants/{restaurantId}/menu/menus/{menuId}/image',

  RESTAURANT_MENU_MENU_PART: '/restaurants/{restaurantId}/menu/menus/{menuId}/parts/{partId}',

  RESTAURANT_MENU_MENU_PART_CATEGORY: '/restaurants/{restaurantId}/menu/menus/{menuId}/parts/{partId}/categories/{categoryId}',

  RESTAURANT_MENU_MENU_PART_CATEGORY_IMAGE: '/restaurants/{restaurantId}/menu/menus/{menuId}/parts/{partId}/categories/{categoryId}/image',

  RESTAURANT_MENU_CATEGORIES: '/restaurants/{restaurantId}/menu/categories',

  RESTAURANT_MENU_CATEGORY: '/restaurants/{restaurantId}/menu/categories/{categoryId}',

  RESTAURANT_MENU_CATEGORY_IMAGE: '/restaurants/{restaurantId}/menu/categories/{categoryId}/image',

  RESTAURANT_MENU_UPSELLING_CATEGORIES: '/restaurants/{restaurantId}/menu/upselling-categories',

  RESTAURANT_MENU_UPSELLING_CATEGORY: '/restaurants/{restaurantId}/menu/upselling-categories/{upsellingCategoryId}',

  RESTAURANT_MENU_PRODUCT_OPTIONS: '/restaurants/{restaurantId}/menu/options',

  RESTAURANT_MENU_PRODUCT_OPTION: '/restaurants/{restaurantId}/menu/options/{productOptionId}',

  RESTAURANT_MENU_PRODUCT_OPTION_IMAGE: '/restaurants/{restaurantId}/menu/options/{productOptionId}/image',

  CART_MODIFIERS: '/restaurants/{restaurantId}/menu/cart-modifiers',

  CART_MODIFIER: '/restaurants/{restaurantId}/menu/cart-modifiers/{cartModifierId}',

  CART_MODIFIERS_PRIORITIES: '/restaurants/{restaurantId}/menu/cart-modifiers/priorities',

  //
  // Order
  //

  ORDERS: '/orders',

  ORDERS_PREVIEW: '/orders-previews',

  ORDERS_ON_GOING: '/orders/on-goings',

  ORDER: '/orders/{orderId}',

  ORDER_SETTINGS: '/restaurants/{restaurantId}/order-settings',

  CHECKS: '/checks',

  REVIEWS_SUMMARY: '/reviews',

  CLAIMS_DISCUSSIONS_SETTINGS: '/restaurants/{restaurantId}/claims-discussions-settings',

  PAYMENTS: '/payments',

  PAYMENT_PDF: '/payments/{paymentId}/pdf',

  //
  // Bookings
  //

  BOOKINGS: '/bookings',

  WAITING_BOOKINGS: '/bookings/waitings',

  UNSEEN_BOOKINGS: '/bookings/unseen',

  BOOKING: '/bookings/{bookingId}',

  UPDATED_BOOKINGS: '/bookings/updated',

  BOOKINGS_SLOTS: '/bookings/slots',

  BOOKINGS_SETTINGS: '/bookings/settings',

  BOOKINGS_SPECIFICS_SETTINGS: '/bookings/settings/specifics',

  BOOKINGS_CAPACITY_SPECIFICS: '/bookings/settings/capacity-specifics',

  BOOKINGS_CAPACITY_SPECIFIC: '/bookings/settings/capacity-specifics/{capacitySpecificId}',

  BOOKINGS_GUESTS_BOOKED: '/bookings/guests-booked',

  PDF_BOOKINGS_LIST_LINK: '/bookings/pdf-link',

  NOTIFICATIONS_SETTINGS_BOOKING: '/notifications/settings/features/4',

  //
  // News
  //

  NEWS_LIST: '/restaurants/{restaurantId}/news',

  NEWS: '/restaurants/{restaurantId}/news/{newsId}',

  DASHBOARD_INFO_RESTAURANT: '/dashboards/restaurants/{restaurantId}',

  //
  // Restaurants group
  //

  RESTAURANTS_GROUP: '/restaurants-groups/:restaurantsGroupId',

  RESTAURANTS_GROUPS: '/restaurants-groups',

  RESTAURANTS_GROUP_ROLES: '/restaurants-groups/:restaurantsGroupId/pro/roles',

  RESTAURANTS_GROUP_DOMAINS: '/restaurants-groups/:restaurantsGroupId/pro/domains',

  RESTAURANTS_GROUP_ORDER_STATISTICS: '/restaurants-groups/{restaurantsGroupId}/stats/order/general-stats',

  RESTAURANTS_GROUP_API_CONSUMERS: '/restaurants-groups/{restaurantsGroupId}/api-consumers',

  /**
   * Export
   */
  EXPORT: '/restaurants-groups/:restaurantsGroupId/export',

  //
  // Roles
  //

  PRO_ROLE: '/pro/roles/:roleId',

  PRO_ROLES: '/pro/roles',

  //
  // Pro account
  //
  LOGIN: '/pro/accounts/me/domains',

  PRO_FORGOT_PASSWORD: '/pro/password-recovery/recover',

  PRO_ME_ACCOUNT: '/pro/accounts/me',

  PRO_ME_ACCOUNT_DOMAINS: '/pro/accounts/me/domains',

  PRO_ACCOUNTS: '/pro/accounts',

  PRO_ACCOUNT: '/pro/accounts/:accountId',

  PRO_ACCOUNT_DOMAINS: '/pro/accounts/:accountId/domains',

  PRO_DOMAIN_ROLE: '/pro/domains/:domainId/roles',

  //
  // notifications
  //

  EMAIL: '/emails',

  SMS: '/sms',

  //
  // Users
  //

  USERS: '/users',

  USER: '/users/:userId',

  USER_ME: '/users/me',

  USER_CREDIT_CARDS: '/users/:userId/cards',

  ME_CREDIT_CARDS: '/users/me/cards',

  ME_CREDIT_CARD: '/users/me/cards/:creditCardId',

  ME_CREDIT_CARD_REGISTRATION: '/users/me/cards-registration',

  USER_CREDIT_CARD_REGISTRATION: '/users/:userId/cards-registration',

  USER_ADDRESSES: '/users/:userId/addresses',

  USER_ADDRESS: '/users/:userId/addresses/:addressId',

  CRM_ACCOUNT: '/crm/{restaurantId}/account',

  USER_RECOVER_PASSWORD: '/users/password-recovery/recover?email=:userEmail',

  USER_ACCOUNTS: '/users/:userId/accounts',

  //
  // Kiosk
  //
  KIOSK_SETTINGS: '/restaurants/:restaurantId/kiosk-settings',

  POST_CUSTOM_TEXTS_CONTAINERS: '/customs/texts-containers/',
  GET_CUSTOM_TEXTS_CONTAINERS: '/customs/texts-containers/:customTextsContainerId',
  PUT_CUSTOM_TEXTS_CONTAINERS: '/customs/texts-containers/:customTextsContainerId'
};

exports.default = APIEndpoints;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/ApiConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EPaymentMode = __webpack_require__("./sdk/scripts/constants/EPaymentMode.js");

var _EPaymentMode2 = _interopRequireDefault(_EPaymentMode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiConstants = {
  Platform: {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    BACK_OFFICE_WEB: 'BACK_OFFICE_WEB',
    PLUGIN_WEB: 'PLUGIN_WEB',
    BOT: 'BOT',
    POS: 'POS',
    KIOSK: 'KIOSK',
    OTHER: 'OTHER'
  },

  Day: {
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6
  },

  // -- Restaurant

  RestaurantFeatures: {
    PAYMENT: 1,

    ORDER: 2,

    BOOKING: 4,

    NEWS: 8,

    REVIEW: 16
  },

  RestaurantTag: ['restaurant.tag.africain', 'restaurant.tag.algerien', 'restaurant.tag.allemand', 'restaurant.tag.americain', 'restaurant.tag.amerique_latine', 'restaurant.tag.anglais', 'restaurant.tag.apero', 'restaurant.tag.argentin', 'restaurant.tag.asiatique', 'restaurant.tag.autrichien', 'restaurant.tag.bagel', 'restaurant.tag.bar', 'restaurant.tag.bbq', 'restaurant.tag.belge', 'restaurant.tag.bio', 'restaurant.tag.boulettes', 'restaurant.tag.brasserie', 'restaurant.tag.bresilien', 'restaurant.tag.brunch_and_petit_dejeuner', 'restaurant.tag.bubble_tea', 'restaurant.tag.burger', 'restaurant.tag.canadien', 'restaurant.tag.cafétéria', 'restaurant.tag.casher', 'restaurant.tag.ceviche', 'restaurant.tag.chilien', 'restaurant.tag.chinois', 'restaurant.tag.cocktail', 'restaurant.tag.colombien', 'restaurant.tag.coreen', 'restaurant.tag.corse', 'restaurant.tag.creole', 'restaurant.tag.croque_monsieur', 'restaurant.tag.cubain', 'restaurant.tag.cuisine_du_marche', 'restaurant.tag.dim_sum', 'restaurant.tag.epice', 'restaurant.tag.espagnol', 'restaurant.tag.europe__est', 'restaurant.tag.fish_and_chips', 'restaurant.tag.francais', 'restaurant.tag.frozen_yoghurt', 'restaurant.tag.fruits_de_mer_crustacés', 'restaurant.tag.grand_groupe', 'restaurant.tag.grec', 'restaurant.tag.halal', 'restaurant.tag.healthy', 'restaurant.tag.homard', 'restaurant.tag.hot_dog', 'restaurant.tag.indien', 'restaurant.tag.indonesien', 'restaurant.tag.iranien', 'restaurant.tag.italien', 'restaurant.tag.japonais', 'restaurant.tag.jus_smoothies', 'restaurant.tag.laotien', 'restaurant.tag.libanais', 'restaurant.tag.marocain', 'restaurant.tag.mediterranéen', 'restaurant.tag.mexicain', 'restaurant.tag.moyen_orient', 'restaurant.tag.oriental', 'restaurant.tag.patisserie', 'restaurant.tag.peruvien', 'restaurant.tag.pizza', 'restaurant.tag.polonais', 'restaurant.tag.portugais', 'restaurant.tag.rotisserie', 'restaurant.tag.russe', 'restaurant.tag.salade', 'restaurant.tag.sandwich', 'restaurant.tag.sans_gluten', 'restaurant.tag.scandinave', 'restaurant.tag.soupe', 'restaurant.tag.suisse', 'restaurant.tag.sushi', 'restaurant.tag.syrien', 'restaurant.tag.tapas', 'restaurant.tag.tarte_salée', 'restaurant.tag.terroir', 'restaurant.tag.thailandais', 'restaurant.tag.tibetain', 'restaurant.tag.tunisien', 'restaurant.tag.turc', 'restaurant.tag.vegan', 'restaurant.tag.veggie', 'restaurant.tag.venezuelien', 'restaurant.tag.vietnamien'],

  RestaurantTheme: {
    DEFAULT_BACKGROUND_COLOR: 0xFFFFFFFF,

    DEFAULT_FONT_COLOR: 0xFF454545,

    DEFAULT_TITLE_BACKGROUND_COLOR: 0xFF232323,

    DEFAULT_TITLE_FONT_COLOR: 0xFFFFFFFF,

    DEFAULT_ACTION_BACKGROUND_COLOR: 0xFF9DC212,

    DEFAULT_ACTION_FONT_COLOR: 0xFFFFFFFF
  },

  // -- Payment
  BankType: {
    MANGOPAY: 'MANGOPAY',
    PAYZEN: 'PAYZEN'
  },

  // keep old way to call.
  // @deprecated
  CreditCardType: _EPaymentMode2.default,

  // -- Order
  // Bitfield enum (1, 2, 4, 8, 16, 32, ...)
  OrderPaymentMethodsAllowed: {
    IRL: 1,

    CREDIT_CARD: 2,

    USER_ACCOUNT: 4,

    TRD: 8
  },

  OrderStatus: {
    CREATED: 'CREATED', // object is created but not yet paid nor sent to the POS
    SENT: 'SENT', // paid (if needed) and successfully sent to the POS
    RECEIVED: 'RECEIVED', // order received and accepted by the restaurant
    //PRODUCING: 'PRODUCING', // order sent to production by the restaurant
    READY: 'READY', // order ready to be picked-up by the user who ordered
    IN_DELIVERY: 'IN_DELIVERY', // order picked-up by the delivery man
    DELIVERED: 'DELIVERED', // order retrieved by the user who ordered
    CANCELED: 'CANCELED', // order manually canceled
    FAILED: 'FAILED' // order failed, probably because the payment failed or we weren't able to send it to the POS
  },

  // -- Review

  Review: {
    REASONS: {
      WAIT_ARRIVAL: 'Attente à l’arrivée',
      SERVICE: 'Service',
      PRODUCT_QUALITY: 'Qualité de la nourriture',
      WAIT_DINNING: 'Attente durant le repas',
      DECORATION: 'Décoration',
      OTHER: 'Autre'
    }
  },

  Image: {
    MAX_SIZE: 1000000,

    RestaurantMenuPdfPicture: {
      RATIO: 960 / 639,
      WIDTH: 960,
      HEIGHT: 639,
      MAX_SIZE: 100000 // unused
    },

    RestaurantLogo: {
      RATIO: 254 / 254,
      WIDTH: 450,
      HEIGHT: 450,
      MAX_SIZE: 100000 // unused
    },

    News: {
      RATIO: 840 / 420,
      WIDTH: 840,
      HEIGHT: 420,
      MAX_SIZE: 10000 // unused
    },

    RestaurantMenu: {
      Product: {
        RATIO: 840 / 420,
        WIDTH: 840,
        HEIGHT: 420,
        MAX_SIZE: 10000 // unused
      },

      Menu: {
        RATIO: 840 / 420,
        WIDTH: 840,
        HEIGHT: 420,
        MAX_SIZE: 10000 // unused
      },

      Category: {
        RATIO: 840 / 840,
        WIDTH: 250,
        HEIGHT: 250,
        MAX_SIZE: 10000 // unused
      },

      ProductOption: {
        RATIO: 840 / 840,
        WIDTH: 250,
        HEIGHT: 250,
        MAX_SIZE: 10000 // unused
      },

      MenuPartCategory: {
        RATIO: 840 / 840,
        WIDTH: 250,
        HEIGHT: 250,
        MAX_SIZE: 10000 // unused 
      }
    }
  },

  Kiosk: {
    Order: {
      BackgroundImage: {
        RATIO: 1280 / 1920,
        WIDTH: 1280,
        HEIGHT: 1920,
        MAX_SIZE: 10000 // unused
      },
      AdvertisingImage: {
        RATIO: 880 / 275,
        WIDTH: 880,
        HEIGHT: 275,
        MAX_SIZE: 10000 // unused
      }
    }
  }
};

exports.default = ApiConstants;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/BookingConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Defines the constants for the booking services.
 */
exports.default = {

  HIDE_ACTION_UNTIL_IN_MINUTES: 30,

  /**
   * The source of the booking: where the booking have been made.
   */
  Source: {
    /**
     * The booking have been made on the PayMyTable mobile application.
     */
    APP: 0,

    /**
     * The booking have been made on the PayMyTable website.
     */
    WEBSITE: 1,

    /**
     * The booking have been made on the PayMyTable restaurant.
     */
    RESTAURANT: 2,

    /**
     * The booking have been made by phone call.
     */
    PHONE: 3,

    /**
     * The booking have been made by another way than the describes ones.
     */
    THIRD_PARTY: 4,

    /**
     * The booking have been made with the plugin.
     */
    PLUGIN: 5
  },

  /**
   * The status of the booking.
   */
  Status: {
    /**
     * The booking is waiting for validation.
     */
    WAITING: 0,

    /**
     * The booking is confirmed. When confirmed, the booking's action can be change.
     * See BookingConstants.Actions.
     */
    CONFIRMED: 1
  },

  /**
   * The current action for the booking.
   */
  Action: {
    /**
     * Default. The client is not arrived.
     */
    NOT_ARRIVED: 0,

    /**
     * The client is placed at the table.
     */
    SEATED: 1,

    /**
     * The booking is canceled.
     */
    CANCELED: 2,

    /**
     * The client haven't come to the restaurant.
     */
    NO_SHOW: 3
  },

  /**
   * The settings for the notifications.
   */
  NotificationType: {
    /**
     * The notifications will be send for each modifications and for automatic validations.
     */
    FOR_ALL: 0,

    /**
     * The notifications will be send for each modifications but not for automatic validations.
     */
    FOR_VALIDATE_ONLY: 1
  },

  State: {
    OPEN: 0,

    CLOSED: 1,

    FULL: 2
  },

  /**
   * Warning: if change, we also need to change on BookingViewUtils.
   */
  Period: {

    /**
     * Used to impact all the periods.
     */
    ALL: 0,

    MORNING: 1,

    NOON: 2,

    BRUNCH: 3,

    EVENING: 4
  }

};
module.exports = exports["default"];

/***/ }),

/***/ "./sdk/scripts/constants/CountriesList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * TODO: localize
 */
var CountriesList = function () {
  function CountriesList() {
    _classCallCheck(this, CountriesList);
  }

  _createClass(CountriesList, null, [{
    key: 'getCountriesList',
    value: function getCountriesList() {
      return [{
        id: '4',
        alpha3: 'AFG',
        iso: 'AF',
        name: _I18n2.default.getCountry('AF')
      }, {
        id: '710',
        alpha3: 'ZAF',
        iso: 'ZA',
        name: _I18n2.default.getCountry('ZA')
      }, {
        id: '248',
        alpha3: 'ALA',
        iso: 'AX',
        name: _I18n2.default.getCountry('AX')
      }, {
        id: '8',
        alpha3: 'ALB',
        iso: 'AL',
        name: _I18n2.default.getCountry('AL')
      }, {
        id: '12',
        alpha3: 'DZA',
        iso: 'DZ',
        name: _I18n2.default.getCountry('DZ')
      }, {
        id: '276',
        alpha3: 'DEU',
        iso: 'DE',
        name: _I18n2.default.getCountry('DE')
      }, {
        id: '20',
        alpha3: 'AND',
        iso: 'AD',
        name: _I18n2.default.getCountry('AD')
      }, {
        id: '24',
        alpha3: 'AGO',
        iso: 'AO',
        name: _I18n2.default.getCountry('AO')
      }, {
        id: '660',
        alpha3: 'AIA',
        iso: 'AI',
        name: _I18n2.default.getCountry('AI')
      }, {
        id: '10',
        alpha3: 'ATA',
        iso: 'AQ',
        name: _I18n2.default.getCountry('AQ')
      }, {
        id: '28',
        alpha3: 'ATG',
        iso: 'AG',
        name: _I18n2.default.getCountry('AG')
      }, {
        id: '682',
        alpha3: 'SAU',
        iso: 'SA',
        name: _I18n2.default.getCountry('SA')
      }, {
        id: '32',
        alpha3: 'ARG',
        iso: 'AR',
        name: _I18n2.default.getCountry('AR')
      }, {
        id: '51',
        alpha3: 'ARM',
        iso: 'AM',
        name: _I18n2.default.getCountry('AM')
      }, {
        id: '533',
        alpha3: 'ABW',
        iso: 'AW',
        name: _I18n2.default.getCountry('AW')
      }, {
        id: '36',
        alpha3: 'AUS',
        iso: 'AU',
        name: _I18n2.default.getCountry('AU')
      }, {
        id: '40',
        alpha3: 'AUT',
        iso: 'AT',
        name: _I18n2.default.getCountry('AT')
      }, {
        id: '31',
        alpha3: 'AZE',
        iso: 'AZ',
        name: _I18n2.default.getCountry('AZ')
      }, {
        id: '44',
        alpha3: 'BHS',
        iso: 'BS',
        name: _I18n2.default.getCountry('BS')
      }, {
        id: '48',
        alpha3: 'BHR',
        iso: 'BH',
        name: _I18n2.default.getCountry('BH')
      }, {
        id: '50',
        alpha3: 'BGD',
        iso: 'BD',
        name: _I18n2.default.getCountry('BD')
      }, {
        id: '52',
        alpha3: 'BRB',
        iso: 'BB',
        name: _I18n2.default.getCountry('BB')
      }, {
        id: '112',
        alpha3: 'BLR',
        iso: 'BY',
        name: _I18n2.default.getCountry('BY')
      }, {
        id: '56',
        alpha3: 'BEL',
        iso: 'BE',
        name: _I18n2.default.getCountry('BE')
      }, {
        id: '84',
        alpha3: 'BLZ',
        iso: 'BZ',
        name: _I18n2.default.getCountry('BZ')
      }, {
        id: '204',
        alpha3: 'BEN',
        iso: 'BJ',
        name: _I18n2.default.getCountry('BJ')
      }, {
        id: '60',
        alpha3: 'BMU',
        iso: 'BM',
        name: _I18n2.default.getCountry('BM')
      }, {
        id: '64',
        alpha3: 'BTN',
        iso: 'BT',
        name: _I18n2.default.getCountry('BT')
      }, {
        id: '68',
        alpha3: 'BOL',
        iso: 'BO',
        name: _I18n2.default.getCountry('BO')
      }, {
        id: '535',
        alpha3: 'BES',
        iso: 'BQ',
        name: _I18n2.default.getCountry('BQ')
      }, {
        id: '70',
        alpha3: 'BIH',
        iso: 'BA',
        name: _I18n2.default.getCountry('BA')
      }, {
        id: '72',
        alpha3: 'BWA',
        iso: 'BW',
        name: _I18n2.default.getCountry('BW')
      }, {
        id: '74',
        alpha3: 'BVT',
        iso: 'BV',
        name: _I18n2.default.getCountry('BV')
      }, {
        id: '76',
        alpha3: 'BRA',
        iso: 'BR',
        name: _I18n2.default.getCountry('BR')
      }, {
        id: '96',
        alpha3: 'BRN',
        iso: 'BN',
        name: _I18n2.default.getCountry('BN')
      }, {
        id: '100',
        alpha3: 'BGR',
        iso: 'BG',
        name: _I18n2.default.getCountry('BG')
      }, {
        id: '854',
        alpha3: 'BFA',
        iso: 'BF',
        name: _I18n2.default.getCountry('BF')
      }, {
        id: '108',
        alpha3: 'BDI',
        iso: 'BI',
        name: _I18n2.default.getCountry('BI')
      }, {
        id: '136',
        alpha3: 'CYM',
        iso: 'KY',
        name: _I18n2.default.getCountry('KY')
      }, {
        id: '116',
        alpha3: 'KHM',
        iso: 'KH',
        name: _I18n2.default.getCountry('KH')
      }, {
        id: '120',
        alpha3: 'CMR',
        iso: 'CM',
        name: _I18n2.default.getCountry('CM')
      }, {
        id: '124',
        alpha3: 'CAN',
        iso: 'CA',
        name: _I18n2.default.getCountry('CA')
      }, {
        id: '132',
        alpha3: 'CPV',
        iso: 'CV',
        name: _I18n2.default.getCountry('CV')
      }, {
        id: '140',
        alpha3: 'CAF',
        iso: 'CF',
        name: _I18n2.default.getCountry('CF')
      }, {
        id: '152',
        alpha3: 'CHL',
        iso: 'CL',
        name: _I18n2.default.getCountry('CL')
      }, {
        id: '156',
        alpha3: 'CHN',
        iso: 'CN',
        name: _I18n2.default.getCountry('CN')
      }, {
        id: '162',
        alpha3: 'CXR',
        iso: 'CX',
        name: _I18n2.default.getCountry('CX')
      }, {
        id: '196',
        alpha3: 'CYP',
        iso: 'CY',
        name: _I18n2.default.getCountry('CY')
      }, {
        id: '166',
        alpha3: 'CCK',
        iso: 'CC',
        name: _I18n2.default.getCountry('CC')
      }, {
        id: '170',
        alpha3: 'COL',
        iso: 'CO',
        name: _I18n2.default.getCountry('CO')
      }, {
        id: '174',
        alpha3: 'COM',
        iso: 'KM',
        name: _I18n2.default.getCountry('KM')
      }, {
        id: '178',
        alpha3: 'COG',
        iso: 'CG',
        name: _I18n2.default.getCountry('CG')
      }, {
        id: '180',
        alpha3: 'COD',
        iso: 'CD',
        name: _I18n2.default.getCountry('CD')
      }, {
        id: '184',
        alpha3: 'COK',
        iso: 'CK',
        name: _I18n2.default.getCountry('CK')
      }, {
        id: '410',
        alpha3: 'KOR',
        iso: 'KR',
        name: _I18n2.default.getCountry('KR')
      }, {
        id: '408',
        alpha3: 'PRK',
        iso: 'KP',
        name: _I18n2.default.getCountry('KP')
      }, {
        id: '188',
        alpha3: 'CRI',
        iso: 'CR',
        name: _I18n2.default.getCountry('CR')
      }, {
        id: '384',
        alpha3: 'CIV',
        iso: 'CI',
        name: _I18n2.default.getCountry('CI')
      }, {
        id: '191',
        alpha3: 'HRV',
        iso: 'HR',
        name: _I18n2.default.getCountry('HR')
      }, {
        id: '192',
        alpha3: 'CUB',
        iso: 'CU',
        name: _I18n2.default.getCountry('CU')
      }, {
        id: '531',
        alpha3: 'CUW',
        iso: 'CW',
        name: _I18n2.default.getCountry('CW')
      }, {
        id: '208',
        alpha3: 'DNK',
        iso: 'DK',
        name: _I18n2.default.getCountry('DK')
      }, {
        id: '262',
        alpha3: 'DJI',
        iso: 'DJ',
        name: _I18n2.default.getCountry('DJ')
      }, {
        id: '214',
        alpha3: 'DOM',
        iso: 'DO',
        name: _I18n2.default.getCountry('DO')
      }, {
        id: '212',
        alpha3: 'DMA',
        iso: 'DM',
        name: _I18n2.default.getCountry('DM')
      }, {
        id: '818',
        alpha3: 'EGY',
        iso: 'EG',
        name: _I18n2.default.getCountry('EG')
      }, {
        id: '222',
        alpha3: 'SLV',
        iso: 'SV',
        name: _I18n2.default.getCountry('SV')
      }, {
        id: '784',
        alpha3: 'ARE',
        iso: 'AE',
        name: _I18n2.default.getCountry('AE')
      }, {
        id: '218',
        alpha3: 'ECU',
        iso: 'EC',
        name: _I18n2.default.getCountry('EC')
      }, {
        id: '232',
        alpha3: 'ERI',
        iso: 'ER',
        name: _I18n2.default.getCountry('ER')
      }, {
        id: '724',
        alpha3: 'ESP',
        iso: 'ES',
        name: _I18n2.default.getCountry('ES')
      }, {
        id: '233',
        alpha3: 'EST',
        iso: 'EE',
        name: _I18n2.default.getCountry('EE')
      }, {
        id: '840',
        alpha3: 'USA',
        iso: 'US',
        name: _I18n2.default.getCountry('US')
      }, {
        id: '231',
        alpha3: 'ETH',
        iso: 'ET',
        name: _I18n2.default.getCountry('ET')
      }, {
        id: '238',
        alpha3: 'FLK',
        iso: 'FK',
        name: _I18n2.default.getCountry('FK')
      }, {
        id: '234',
        alpha3: 'FRO',
        iso: 'FO',
        name: _I18n2.default.getCountry('FO')
      }, {
        id: '242',
        alpha3: 'FJI',
        iso: 'FJ',
        name: _I18n2.default.getCountry('FJ')
      }, {
        id: '246',
        alpha3: 'FIN',
        iso: 'FI',
        name: _I18n2.default.getCountry('FI')
      }, {
        id: '250',
        alpha3: 'FRA',
        iso: 'FR',
        name: _I18n2.default.getCountry('FR')
      }, {
        id: '266',
        alpha3: 'GAB',
        iso: 'GA',
        name: _I18n2.default.getCountry('GA')
      }, {
        id: '270',
        alpha3: 'GMB',
        iso: 'GM',
        name: _I18n2.default.getCountry('GM')
      }, {
        id: '268',
        alpha3: 'GEO',
        iso: 'GE',
        name: _I18n2.default.getCountry('GE')
      }, {
        id: '239',
        alpha3: 'SGS',
        iso: 'GS',
        name: _I18n2.default.getCountry('GS')
      }, {
        id: '288',
        alpha3: 'GHA',
        iso: 'GH',
        name: _I18n2.default.getCountry('GH')
      }, {
        id: '292',
        alpha3: 'GIB',
        iso: 'GI',
        name: _I18n2.default.getCountry('GI')
      }, {
        id: '300',
        alpha3: 'GRC',
        iso: 'GR',
        name: _I18n2.default.getCountry('GR')
      }, {
        id: '308',
        alpha3: 'GRD',
        iso: 'GD',
        name: _I18n2.default.getCountry('GD')
      }, {
        id: '304',
        alpha3: 'GRL',
        iso: 'GL',
        name: _I18n2.default.getCountry('GL')
      }, {
        id: '312',
        alpha3: 'GLP',
        iso: 'GP',
        name: _I18n2.default.getCountry('GP')
      }, {
        id: '316',
        alpha3: 'GUM',
        iso: 'GU',
        name: _I18n2.default.getCountry('GU')
      }, {
        id: '320',
        alpha3: 'GTM',
        iso: 'GT',
        name: _I18n2.default.getCountry('GT')
      }, {
        id: '831',
        alpha3: 'GGY',
        iso: 'GG',
        name: _I18n2.default.getCountry('GG')
      }, {
        id: '324',
        alpha3: 'GIN',
        iso: 'GN',
        name: _I18n2.default.getCountry('GN')
      }, {
        id: '624',
        alpha3: 'GNB',
        iso: 'GW',
        name: _I18n2.default.getCountry('GW')
      }, {
        id: '226',
        alpha3: 'GNQ',
        iso: 'GQ',
        name: _I18n2.default.getCountry('GQ')
      }, {
        id: '328',
        alpha3: 'GUY',
        iso: 'GY',
        name: _I18n2.default.getCountry('GY')
      }, {
        id: '254',
        alpha3: 'GUF',
        iso: 'GF',
        name: _I18n2.default.getCountry('GF')
      }, {
        id: '332',
        alpha3: 'HTI',
        iso: 'HT',
        name: _I18n2.default.getCountry('HT')
      }, {
        id: '334',
        alpha3: 'HMD',
        iso: 'HM',
        name: _I18n2.default.getCountry('HM')
      }, {
        id: '340',
        alpha3: 'HND',
        iso: 'HN',
        name: _I18n2.default.getCountry('HN')
      }, {
        id: '344',
        alpha3: 'HKG',
        iso: 'HK',
        name: _I18n2.default.getCountry('HK')
      }, {
        id: '348',
        alpha3: 'HUN',
        iso: 'HU',
        name: _I18n2.default.getCountry('HU')
      }, {
        id: '833',
        alpha3: 'IMN',
        iso: 'IM',
        name: _I18n2.default.getCountry('IM')
      }, {
        id: '581',
        alpha3: 'UMI',
        iso: 'UM',
        name: _I18n2.default.getCountry('UM')
      }, {
        id: '92',
        alpha3: 'VGB',
        iso: 'VG',
        name: _I18n2.default.getCountry('VG')
      }, {
        id: '850',
        alpha3: 'VIR',
        iso: 'VI',
        name: _I18n2.default.getCountry('VI')
      }, {
        id: '356',
        alpha3: 'IND',
        iso: 'IN',
        name: _I18n2.default.getCountry('IN')
      }, {
        id: '360',
        alpha3: 'IDN',
        iso: 'ID',
        name: _I18n2.default.getCountry('ID')
      }, {
        id: '364',
        alpha3: 'IRN',
        iso: 'IR',
        name: _I18n2.default.getCountry('IR')
      }, {
        id: '368',
        alpha3: 'IRQ',
        iso: 'IQ',
        name: _I18n2.default.getCountry('IQ')
      }, {
        id: '372',
        alpha3: 'IRL',
        iso: 'IE',
        name: _I18n2.default.getCountry('IE')
      }, {
        id: '352',
        alpha3: 'ISL',
        iso: 'IS',
        name: _I18n2.default.getCountry('IS')
      }, {
        id: '376',
        alpha3: 'ISR',
        iso: 'IL',
        name: _I18n2.default.getCountry('IL')
      }, {
        id: '380',
        alpha3: 'ITA',
        iso: 'IT',
        name: _I18n2.default.getCountry('IT')
      }, {
        id: '388',
        alpha3: 'JAM',
        iso: 'JM',
        name: _I18n2.default.getCountry('JM')
      }, {
        id: '392',
        alpha3: 'JPN',
        iso: 'JP',
        name: _I18n2.default.getCountry('JP')
      }, {
        id: '832',
        alpha3: 'JEY',
        iso: 'JE',
        name: _I18n2.default.getCountry('JE')
      }, {
        id: '400',
        alpha3: 'JOR',
        iso: 'JO',
        name: _I18n2.default.getCountry('JO')
      }, {
        id: '398',
        alpha3: 'KAZ',
        iso: 'KZ',
        name: _I18n2.default.getCountry('KZ')
      }, {
        id: '404',
        alpha3: 'KEN',
        iso: 'KE',
        name: _I18n2.default.getCountry('KE')
      }, {
        id: '417',
        alpha3: 'KGZ',
        iso: 'KG',
        name: _I18n2.default.getCountry('KG')
      }, {
        id: '296',
        alpha3: 'KIR',
        iso: 'KI',
        name: _I18n2.default.getCountry('KI')
      }, {
        id: '414',
        alpha3: 'KWT',
        iso: 'KW',
        name: _I18n2.default.getCountry('KW')
      }, {
        id: '418',
        alpha3: 'LAO',
        iso: 'LA',
        name: _I18n2.default.getCountry('LA')
      }, {
        id: '426',
        alpha3: 'LSO',
        iso: 'LS',
        name: _I18n2.default.getCountry('LS')
      }, {
        id: '428',
        alpha3: 'LVA',
        iso: 'LV',
        name: _I18n2.default.getCountry('LV')
      }, {
        id: '422',
        alpha3: 'LBN',
        iso: 'LB',
        name: _I18n2.default.getCountry('LB')
      }, {
        id: '430',
        alpha3: 'LBR',
        iso: 'LR',
        name: _I18n2.default.getCountry('LR')
      }, {
        id: '434',
        alpha3: 'LBY',
        iso: 'LY',
        name: _I18n2.default.getCountry('LY')
      }, {
        id: '438',
        alpha3: 'LIE',
        iso: 'LI',
        name: _I18n2.default.getCountry('LI')
      }, {
        id: '440',
        alpha3: 'LTU',
        iso: 'LT',
        name: _I18n2.default.getCountry('LT')
      }, {
        id: '442',
        alpha3: 'LUX',
        iso: 'LU',
        name: _I18n2.default.getCountry('LU')
      }, {
        id: '446',
        alpha3: 'MAC',
        iso: 'MO',
        name: _I18n2.default.getCountry('MO')
      }, {
        id: '807',
        alpha3: 'MKD',
        iso: 'MK',
        name: _I18n2.default.getCountry('MK')
      }, {
        id: '450',
        alpha3: 'MDG',
        iso: 'MG',
        name: _I18n2.default.getCountry('MG')
      }, {
        id: '458',
        alpha3: 'MYS',
        iso: 'MY',
        name: _I18n2.default.getCountry('MY')
      }, {
        id: '454',
        alpha3: 'MWI',
        iso: 'MW',
        name: _I18n2.default.getCountry('MW')
      }, {
        id: '462',
        alpha3: 'MDV',
        iso: 'MV',
        name: _I18n2.default.getCountry('MV')
      }, {
        id: '466',
        alpha3: 'MLI',
        iso: 'ML',
        name: _I18n2.default.getCountry('ML')
      }, {
        id: '470',
        alpha3: 'MLT',
        iso: 'MT',
        name: _I18n2.default.getCountry('MT')
      }, {
        id: '580',
        alpha3: 'MNP',
        iso: 'MP',
        name: _I18n2.default.getCountry('MP')
      }, {
        id: '504',
        alpha3: 'MAR',
        iso: 'MA',
        name: _I18n2.default.getCountry('MA')
      }, {
        id: '584',
        alpha3: 'MHL',
        iso: 'MH',
        name: _I18n2.default.getCountry('MH')
      }, {
        id: '474',
        alpha3: 'MTQ',
        iso: 'MQ',
        name: _I18n2.default.getCountry('MQ')
      }, {
        id: '480',
        alpha3: 'MUS',
        iso: 'MU',
        name: _I18n2.default.getCountry('MU')
      }, {
        id: '478',
        alpha3: 'MRT',
        iso: 'MR',
        name: _I18n2.default.getCountry('MR')
      }, {
        id: '175',
        alpha3: 'MYT',
        iso: 'YT',
        name: _I18n2.default.getCountry('YT')
      }, {
        id: '484',
        alpha3: 'MEX',
        iso: 'MX',
        name: _I18n2.default.getCountry('MX')
      }, {
        id: '583',
        alpha3: 'FSM',
        iso: 'FM',
        name: _I18n2.default.getCountry('FM')
      }, {
        id: '498',
        alpha3: 'MDA',
        iso: 'MD',
        name: _I18n2.default.getCountry('MD')
      }, {
        id: '492',
        alpha3: 'MCO',
        iso: 'MC',
        name: _I18n2.default.getCountry('MC')
      }, {
        id: '496',
        alpha3: 'MNG',
        iso: 'MN',
        name: _I18n2.default.getCountry('MN')
      }, {
        id: '499',
        alpha3: 'MNE',
        iso: 'ME',
        name: _I18n2.default.getCountry('ME')
      }, {
        id: '500',
        alpha3: 'MSR',
        iso: 'MS',
        name: _I18n2.default.getCountry('MS')
      }, {
        id: '508',
        alpha3: 'MOZ',
        iso: 'MZ',
        name: _I18n2.default.getCountry('MZ')
      }, {
        id: '104',
        alpha3: 'MMR',
        iso: 'MM',
        name: _I18n2.default.getCountry('MM')
      }, {
        id: '516',
        alpha3: 'NAM',
        iso: 'NA',
        name: _I18n2.default.getCountry('NA')
      }, {
        id: '520',
        alpha3: 'NRU',
        iso: 'NR',
        name: _I18n2.default.getCountry('NR')
      }, {
        id: '524',
        alpha3: 'NPL',
        iso: 'NP',
        name: _I18n2.default.getCountry('NP')
      }, {
        id: '558',
        alpha3: 'NIC',
        iso: 'NI',
        name: _I18n2.default.getCountry('NI')
      }, {
        id: '562',
        alpha3: 'NER',
        iso: 'NE',
        name: _I18n2.default.getCountry('NE')
      }, {
        id: '566',
        alpha3: 'NGA',
        iso: 'NG',
        name: _I18n2.default.getCountry('NG')
      }, {
        id: '570',
        alpha3: 'NIU',
        iso: 'NU',
        name: _I18n2.default.getCountry('NU')
      }, {
        id: '574',
        alpha3: 'NFK',
        iso: 'NF',
        name: _I18n2.default.getCountry('NF')
      }, {
        id: '578',
        alpha3: 'NOR',
        iso: 'NO',
        name: _I18n2.default.getCountry('NO')
      }, {
        id: '540',
        alpha3: 'NCL',
        iso: 'NC',
        name: _I18n2.default.getCountry('NC')
      }, {
        id: '554',
        alpha3: 'NZL',
        iso: 'NZ',
        name: _I18n2.default.getCountry('NZ')
      }, {
        id: '86',
        alpha3: 'IOT',
        iso: 'IO',
        name: _I18n2.default.getCountry('IO')
      }, {
        id: '512',
        alpha3: 'OMN',
        iso: 'OM',
        name: _I18n2.default.getCountry('OM')
      }, {
        id: '800',
        alpha3: 'UGA',
        iso: 'UG',
        name: _I18n2.default.getCountry('UG')
      }, {
        id: '860',
        alpha3: 'UZB',
        iso: 'UZ',
        name: _I18n2.default.getCountry('UZ')
      }, {
        id: '586',
        alpha3: 'PAK',
        iso: 'PK',
        name: _I18n2.default.getCountry('PK')
      }, {
        id: '585',
        alpha3: 'PLW',
        iso: 'PW',
        name: _I18n2.default.getCountry('PW')
      }, {
        id: '275',
        alpha3: 'PSE',
        iso: 'PS',
        name: _I18n2.default.getCountry('PS')
      }, {
        id: '591',
        alpha3: 'PAN',
        iso: 'PA',
        name: _I18n2.default.getCountry('PA')
      }, {
        id: '598',
        alpha3: 'PNG',
        iso: 'PG',
        name: _I18n2.default.getCountry('PG')
      }, {
        id: '600',
        alpha3: 'PRY',
        iso: 'PY',
        name: _I18n2.default.getCountry('PY')
      }, {
        id: '528',
        alpha3: 'NLD',
        iso: 'NL',
        name: _I18n2.default.getCountry('NL')
      }, {
        id: '604',
        alpha3: 'PER',
        iso: 'PE',
        name: _I18n2.default.getCountry('PE')
      }, {
        id: '608',
        alpha3: 'PHL',
        iso: 'PH',
        name: _I18n2.default.getCountry('PH')
      }, {
        id: '612',
        alpha3: 'PCN',
        iso: 'PN',
        name: _I18n2.default.getCountry('PN')
      }, {
        id: '616',
        alpha3: 'POL',
        iso: 'PL',
        name: _I18n2.default.getCountry('PL')
      }, {
        id: '258',
        alpha3: 'PYF',
        iso: 'PF',
        name: _I18n2.default.getCountry('PF')
      }, {
        id: '630',
        alpha3: 'PRI',
        iso: 'PR',
        name: _I18n2.default.getCountry('PR')
      }, {
        id: '620',
        alpha3: 'PRT',
        iso: 'PT',
        name: _I18n2.default.getCountry('PT')
      }, {
        id: '634',
        alpha3: 'QAT',
        iso: 'QA',
        name: _I18n2.default.getCountry('QA')
      }, {
        id: '638',
        alpha3: 'REU',
        iso: 'RE',
        name: _I18n2.default.getCountry('RE')
      }, {
        id: '642',
        alpha3: 'ROU',
        iso: 'RO',
        name: _I18n2.default.getCountry('RO')
      }, {
        id: '826',
        alpha3: 'GBR',
        iso: 'GB',
        name: _I18n2.default.getCountry('GB')
      }, {
        id: '643',
        alpha3: 'RUS',
        iso: 'RU',
        name: _I18n2.default.getCountry('RU')
      }, {
        id: '646',
        alpha3: 'RWA',
        iso: 'RW',
        name: _I18n2.default.getCountry('RW')
      }, {
        id: '732',
        alpha3: 'ESH',
        iso: 'EH',
        name: _I18n2.default.getCountry('EH')
      }, {
        id: '652',
        alpha3: 'BLM',
        iso: 'BL',
        name: _I18n2.default.getCountry('BL')
      }, {
        id: '659',
        alpha3: 'KNA',
        iso: 'KN',
        name: _I18n2.default.getCountry('KN')
      }, {
        id: '674',
        alpha3: 'SMR',
        iso: 'SM',
        name: _I18n2.default.getCountry('SM')
      }, {
        id: '663',
        alpha3: 'MAF',
        iso: 'MF',
        name: _I18n2.default.getCountry('MF')
      }, {
        id: '534',
        alpha3: 'SXM',
        iso: 'SX',
        name: _I18n2.default.getCountry('SX')
      }, {
        id: '666',
        alpha3: 'SPM',
        iso: 'PM',
        name: _I18n2.default.getCountry('PM')
      }, {
        id: '336',
        alpha3: 'VAT',
        iso: 'VA',
        name: _I18n2.default.getCountry('VA')
      }, {
        id: '670',
        alpha3: 'VCT',
        iso: 'VC',
        name: _I18n2.default.getCountry('VC')
      }, {
        id: '654',
        alpha3: 'SHN',
        iso: 'SH',
        name: _I18n2.default.getCountry('SH')
      }, {
        id: '662',
        alpha3: 'LCA',
        iso: 'LC',
        name: _I18n2.default.getCountry('LC')
      }, {
        id: '90',
        alpha3: 'SLB',
        iso: 'SB',
        name: _I18n2.default.getCountry('SB')
      }, {
        id: '882',
        alpha3: 'WSM',
        iso: 'WS',
        name: _I18n2.default.getCountry('WS')
      }, {
        id: '16',
        alpha3: 'ASM',
        iso: 'AS',
        name: _I18n2.default.getCountry('AS')
      }, {
        id: '678',
        alpha3: 'STP',
        iso: 'ST',
        name: _I18n2.default.getCountry('ST')
      }, {
        id: '686',
        alpha3: 'SEN',
        iso: 'SN',
        name: _I18n2.default.getCountry('SN')
      }, {
        id: '688',
        alpha3: 'SRB',
        iso: 'RS',
        name: _I18n2.default.getCountry('RS')
      }, {
        id: '690',
        alpha3: 'SYC',
        iso: 'SC',
        name: _I18n2.default.getCountry('SC')
      }, {
        id: '694',
        alpha3: 'SLE',
        iso: 'SL',
        name: _I18n2.default.getCountry('SL')
      }, {
        id: '702',
        alpha3: 'SGP',
        iso: 'SG',
        name: _I18n2.default.getCountry('SG')
      }, {
        id: '703',
        alpha3: 'SVK',
        iso: 'SK',
        name: _I18n2.default.getCountry('SK')
      }, {
        id: '705',
        alpha3: 'SVN',
        iso: 'SI',
        name: _I18n2.default.getCountry('SI')
      }, {
        id: '706',
        alpha3: 'SOM',
        iso: 'SO',
        name: _I18n2.default.getCountry('SO')
      }, {
        id: '729',
        alpha3: 'SDN',
        iso: 'SD',
        name: _I18n2.default.getCountry('SD')
      }, {
        id: '728',
        alpha3: 'SSD',
        iso: 'SS',
        name: _I18n2.default.getCountry('SS')
      }, {
        id: '144',
        alpha3: 'LKA',
        iso: 'LK',
        name: _I18n2.default.getCountry('LK')
      }, {
        id: '752',
        alpha3: 'SWE',
        iso: 'SE',
        name: _I18n2.default.getCountry('SE')
      }, {
        id: '756',
        alpha3: 'CHE',
        iso: 'CH',
        name: _I18n2.default.getCountry('CH')
      }, {
        id: '740',
        alpha3: 'SUR',
        iso: 'SR',
        name: _I18n2.default.getCountry('SR')
      }, {
        id: '744',
        alpha3: 'SJM',
        iso: 'SJ',
        name: _I18n2.default.getCountry('SJ')
      }, {
        id: '748',
        alpha3: 'SWZ',
        iso: 'SZ',
        name: _I18n2.default.getCountry('SZ')
      }, {
        id: '760',
        alpha3: 'SYR',
        iso: 'SY',
        name: _I18n2.default.getCountry('SY')
      }, {
        id: '762',
        alpha3: 'TJK',
        iso: 'TJ',
        name: _I18n2.default.getCountry('TJ')
      }, {
        id: '158',
        alpha3: 'TWN',
        iso: 'TW',
        name: _I18n2.default.getCountry('TW')
      }, {
        id: '834',
        alpha3: 'TZA',
        iso: 'TZ',
        name: _I18n2.default.getCountry('TZ')
      }, {
        id: '148',
        alpha3: 'TCD',
        iso: 'TD',
        name: _I18n2.default.getCountry('TD')
      }, {
        id: '203',
        alpha3: 'CZE',
        iso: 'CZ',
        name: _I18n2.default.getCountry('CZ')
      }, {
        id: '260',
        alpha3: 'ATF',
        iso: 'TF',
        name: _I18n2.default.getCountry('TF')
      }, {
        id: '764',
        alpha3: 'THA',
        iso: 'TH',
        name: _I18n2.default.getCountry('TH')
      }, {
        id: '626',
        alpha3: 'TLS',
        iso: 'TL',
        name: _I18n2.default.getCountry('TL')
      }, {
        id: '768',
        alpha3: 'TGO',
        iso: 'TG',
        name: _I18n2.default.getCountry('TG')
      }, {
        id: '772',
        alpha3: 'TKL',
        iso: 'TK',
        name: _I18n2.default.getCountry('TK')
      }, {
        id: '776',
        alpha3: 'TON',
        iso: 'TO',
        name: _I18n2.default.getCountry('TO')
      }, {
        id: '780',
        alpha3: 'TTO',
        iso: 'TT',
        name: _I18n2.default.getCountry('TT')
      }, {
        id: '788',
        alpha3: 'TUN',
        iso: 'TN',
        name: _I18n2.default.getCountry('TN')
      }, {
        id: '795',
        alpha3: 'TKM',
        iso: 'TM',
        name: _I18n2.default.getCountry('TM')
      }, {
        id: '796',
        alpha3: 'TCA',
        iso: 'TC',
        name: _I18n2.default.getCountry('TC')
      }, {
        id: '792',
        alpha3: 'TUR',
        iso: 'TR',
        name: _I18n2.default.getCountry('TR')
      }, {
        id: '798',
        alpha3: 'TUV',
        iso: 'TV',
        name: _I18n2.default.getCountry('TV')
      }, {
        id: '804',
        alpha3: 'UKR',
        iso: 'UA',
        name: _I18n2.default.getCountry('UA')
      }, {
        id: '858',
        alpha3: 'URY',
        iso: 'UY',
        name: _I18n2.default.getCountry('UY')
      }, {
        id: '548',
        alpha3: 'VUT',
        iso: 'VU',
        name: _I18n2.default.getCountry('VU')
      }, {
        id: '862',
        alpha3: 'VEN',
        iso: 'VE',
        name: _I18n2.default.getCountry('VE')
      }, {
        id: '704',
        alpha3: 'VNM',
        iso: 'VN',
        name: _I18n2.default.getCountry('VN')
      }, {
        id: '876',
        alpha3: 'WLF',
        iso: 'WF',
        name: _I18n2.default.getCountry('WF')
      }, {
        id: '887',
        alpha3: 'YEM',
        iso: 'YE',
        name: _I18n2.default.getCountry('YE')
      }, {
        id: '894',
        alpha3: 'ZMB',
        iso: 'ZM',
        name: _I18n2.default.getCountry('ZM')
      }, {
        id: '716',
        alpha3: 'ZWE',
        iso: 'ZW',
        name: _I18n2.default.getCountry('ZW')
      }];
    }

    /**
     * Returns a list of countries for the choice picker.
     * Use the name as label and the iso as value.
     * Used by CountryActionChoose
     */

  }, {
    key: 'getCountriesListForPicker',
    value: function getCountriesListForPicker() {
      var countriesList = [];
      _lodash2.default.each(CountriesList.getCountriesList(), function (countryInfo) {
        countriesList.push({
          label: countryInfo.name,
          value: countryInfo.iso
        });
      });

      return countriesList;
    }

    /**
     * Returns the name of the given country code or the country code if the name is not found.
     * @param code the country code to find.
     * @returns {String}
     */

  }, {
    key: 'getCountryNameByCode',
    value: function getCountryNameByCode(code) {
      var foundCountryInfo = _lodash2.default.find(CountriesList.getCountriesList(), function (countryInfo) {
        return countryInfo.iso === code;
      });

      if (!_lodash2.default.isUndefined(foundCountryInfo)) {
        return foundCountryInfo.name;
      }

      return code;
    }
  }]);

  return CountriesList;
}();

exports.default = CountriesList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/DietaryConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllergenOptions = exports.getAllergenLabel = undefined;

var _map = __webpack_require__("./sdk/node_modules/lodash/map.js");

var _map2 = _interopRequireDefault(_map);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Allergen = {
  BALSAM_OF_PERU: 'BALSAM_OF_PERU',
  BUCKWHEAT: 'BUCKWHEAT',
  CELERY: 'CELERY',
  CHEESE: 'CHEESE',
  CORN: 'CORN',
  CRUSTACEAN: 'CRUSTACEAN',
  EGG: 'EGG',
  FISH: 'FISH',
  FRUIT: 'FRUIT',
  GARLIC: 'GARLIC',
  LACTOSE: 'LACTOSE',
  LUPINE: 'LUPINE',
  MUSTARD: 'MUSTARD',
  PEANUT: 'PEANUT',
  POULTRY_MEAT: 'POULTRY_MEAT',
  RED_MEAT: 'RED_MEAT',
  RICE: 'RICE',
  SESAME: 'SESAME',
  SHELLFISH: 'SHELLFISH',
  SOYA: 'SOYA',
  SULPHITES: 'SULPHITES',
  TARTRAZINE: 'TARTRAZINE',

  // Gluten-related
  GLUTEN: 'GLUTEN', // Generic
  GLUTEN_OATS: 'GLUTEN_OATS',
  GLUTEN_WHEAT: 'GLUTEN_WHEAT',
  GLUTEN_KAMUT: 'GLUTEN_KAMUT',
  GLUTEN_SPELT: 'GLUTEN_SPELT',
  GLUTEN_GREEN_SPELT: 'GLUTEN_GREEN_SPELT',
  GLUTEN_EINKORN: 'GLUTEN_EINKORN',
  GLUTEN_RYE: 'GLUTEN_RYE',
  GLUTEN_BARLEY: 'GLUTEN_BARLEY',
  GLUTEN_EMMER: 'GLUTEN_EMMER',
  GLUTEN_TRITICALE: 'GLUTEN_TRITICALE',

  // Nuts-related
  NUTS: 'NUTS', // Generic
  NUTS_ALMONDS: 'NUTS_ALMONDS',
  NUTS_HAZELNUTS: 'NUTS_HAZELNUTS',
  NUTS_WALNUTS: 'NUTS_WALNUTS',
  NUTS_CASHEW: 'NUTS_CASHEW',
  NUTS_PECANS: 'NUTS_PECANS',
  NUTS_BRAZIL: 'NUTS_BRAZIL',
  NUTS_PISTACHES: 'NUTS_PISTACHES',
  NUTS_MACADAMIA_OR_QUEENSLAND: 'NUTS_MACADAMIA_OR_QUEENSLAND'
};

var getAllergenLabel = exports.getAllergenLabel = function getAllergenLabel(allergen) {
  return _I18n2.default.tr('global.allergen.' + allergen);
};

var getAllergenOptions = exports.getAllergenOptions = function getAllergenOptions() {
  return (0, _map2.default)(Allergen, function (value) {
    return {
      label: getAllergenLabel(value),
      value: value
    };
  });
};

/***/ }),

/***/ "./sdk/scripts/constants/EPaymentMode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var EPaymentMode = {
  AMERICAN_EXPRESS: 1,

  VISA: 2,

  MASTERCARD: 4,

  CASH: 8,

  RESTAURANT_TICKET: 16
};

exports.default = EPaymentMode;
module.exports = exports["default"];

/***/ }),

/***/ "./sdk/scripts/constants/PMTConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  Error: {
    NO_INTERNET: -1,

    UNKNOWN: 0
  }
};

/***/ }),

/***/ "./sdk/scripts/constants/POSType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var POSType = function () {
  function POSType() {
    _classCallCheck(this, POSType);
  }

  _createClass(POSType, null, [{
    key: 'getChoices',


    /**
     * @return array
     */
    value: function getChoices() {
      return [{
        label: 'Demo',
        value: POSType.POS_DEMO
      }, {
        label: 'Cashpad',
        value: POSType.POS_CASHPAD
      }, {
        label: 'CSI - CashSystemes',
        value: POSType.POS_CSI
      }, {
        label: 'Ikentoo',
        value: POSType.POS_IKENTOO
      }, {
        label: 'Oracle',
        value: POSType.POS_ORACLE
      }, {
        label: 'Orchestra',
        value: POSType.POS_ORCHESTRA
      }, {
        label: 'Orchestra v2',
        value: POSType.POS_ORCHESTRA_V2
      }, {
        label: 'PayMyTable',
        value: POSType.POS_PAYMYTABLE
      }, {
        label: 'SequoiaSoft',
        value: POSType.POS_SEQUOIASOFT
      }, {
        label: 'Tiller',
        value: POSType.POS_TILLER
      }, {
        label: 'Tcpos',
        value: POSType.POS_TCPOS
      }, {
        label: 'Tcpos 7.1',
        value: POSType.POS_TCPOS_7_1
      }, {
        label: 'Tcpos 7.4',
        value: POSType.POS_TCPOS_7_4
      }, {
        label: 'Zely',
        value: POSType.POS_ZELTY
      }];
    }
  }]);

  return POSType;
}();

POSType.POS_DEMO = '';
POSType.POS_CASHPAD = 'cashpad';
POSType.POS_CSI = 'csi';
POSType.POS_IKENTOO = 'ikentoo';
POSType.POS_ORCHESTRA = 'orchestra';
POSType.POS_ORCHESTRA_V2 = 'orchestra-v2';
POSType.POS_PAYMYTABLE = 'paymytable';
POSType.POS_TILLER = 'tiller';
POSType.POS_TCPOS = 'tcpos';
POSType.POS_TCPOS_7_1 = 'tcpos7.1';
POSType.POS_TCPOS_7_4 = 'tcpos7.4';
POSType.POS_ZELTY = 'zelty';
POSType.POS_SEQUOIASOFT = 'sequoiasoft';
POSType.POS_ORACLE = 'oracle';
exports.default = POSType;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/PaymentMethod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentMethodOptions = undefined;

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentMethod = {
  /**
   * user CB
   * Paypal
   * etc
   */
  PAYMENT: 'PAYMENT',

  /**
   * payment by user account.
   */
  USER_ACCOUNT: 'USER_ACCOUNT',

  /**
   * the payment has been made IRL (kiosk TPE)
   */
  IRL_PAYMENT: 'IRL_PAYMENT',

  NOT_PRE_PAYED: 'NOT_PRE_PAYED'

};

var getPaymentMethodOptions = exports.getPaymentMethodOptions = function getPaymentMethodOptions() {
  return _lodash2.default.keys(PaymentMethod).map(function (value) {
    return {
      label: _I18n2.default.tr('payments.method.' + value),
      value: value
    };
  });
};

exports.default = PaymentMethod;

/***/ }),

/***/ "./sdk/scripts/constants/RestaurantTagsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RestaurantTagsList = function () {
  function RestaurantTagsList() {
    _classCallCheck(this, RestaurantTagsList);
  }

  _createClass(RestaurantTagsList, null, [{
    key: 'getTagsListForPicker',


    /**
     * Returns a list of countries for the choice picker.
     * Use the name as label and the alpha2 as value.
     * Used by CountryActionChoose
     */
    value: function getTagsListForPicker() {
      var list = [];
      _lodash2.default.each(_ApiConstants2.default.RestaurantTag, function (tag) {
        list.push({
          label: _I18n2.default.tr(tag),
          value: _I18n2.default.tr(tag)
        });
      });

      return list;
    }
  }]);

  return RestaurantTagsList;
}();

exports.default = RestaurantTagsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/TaxesType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaxesType = function () {
  function TaxesType() {
    _classCallCheck(this, TaxesType);
  }

  _createClass(TaxesType, null, [{
    key: 'getChoices',


    /**
     * Return all feature type choice
     *
     * @return array
     */
    value: function getChoices() {
      return _lodash2.default.flatten(_lodash2.default.sortBy(TaxesType.getTaxes(), ['label']).map(function (tax) {
        return _lodash2.default.concat(tax, tax.taxes);
      }));
    }
  }]);

  return TaxesType;
}();

TaxesType.getLegalBankFeeTaxes = function () {
  return [{
    label: _I18n2.default.tr('components.vat_chooser.bank.0'),
    value: 0
  }, {
    label: _I18n2.default.tr('components.vat_chooser.bank.8'),
    value: 8.5
  }, {
    label: _I18n2.default.tr('components.vat_chooser.bank.20'),
    value: 20.0
  }];
};

TaxesType.getTaxes = function () {
  return [{
    label: _I18n2.default.tr('components.vat_chooser.countries.be'),
    value: 'be',
    disabled: true,
    taxes: [{
      label: '6.0 %',
      value: 6.0,
      disabled: false
    }, {
      label: '12.0 %',
      value: 12.0,
      disabled: false
    }, {
      label: '21.0 %',
      value: 21.0,
      disabled: false
    }]
  }, {
    label: _I18n2.default.tr('components.vat_chooser.countries.de'),
    value: 'de',
    disabled: true,
    taxes: [{
      label: '7.0 %',
      value: 7.0,
      disabled: false
    }, {
      label: '19.0 %',
      value: 19.0,
      disabled: false
    }]
  }, {
    label: _I18n2.default.tr('components.vat_chooser.countries.fr'),
    value: 'fr',
    disabled: true,
    taxes: [{
      label: '5.5 %',
      value: 5.5,
      disabled: false
    }, {
      label: '10.0 %',
      value: 10,
      disabled: false
    }, {
      label: '20.0 %',
      value: 20,
      disabled: false
    }]
  }, {
    label: 'La réunion',
    value: '',
    disabled: true,
    taxes: [{
      label: '2.1 %',
      value: 2.1
    }, {
      label: '8.5 %',
      value: 8.5
    }]
  }, {
    label: _I18n2.default.tr('components.vat_chooser.countries.lu'),
    value: 'lu',
    disabled: true,
    taxes: [{
      label: '3.0 %',
      value: 3.0,
      disabled: false
    }, {
      label: '14.0 %',
      value: 14.0,
      disabled: false
    }, {
      label: '17.0 %',
      value: 17.0,
      disabled: false
    }]
  }];
};

exports.default = TaxesType;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/TransferFrequency.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Note: we only handle DAILY on the API for now.

var TransferFrequency = function () {
  function TransferFrequency() {
    _classCallCheck(this, TransferFrequency);
  }

  _createClass(TransferFrequency, null, [{
    key: 'getChoices',


    /**
     * @return array
     */
    value: function getChoices() {
      return [{
        value: TransferFrequency.DISABLED,
        label: _I18n2.default.tr('components.frequency.DISABLED')
      }, {
        value: TransferFrequency.DAILY,
        label: _I18n2.default.tr('components.frequency.DAILY')
      }];
    }
  }]);

  return TransferFrequency;
}();

TransferFrequency.DISABLED = 'DISABLED';
TransferFrequency.DAILY = 'DAILY';
TransferFrequency.WEEKLY = 'WEEKLY';
TransferFrequency.MONTHLY = 'MONTHLY';
exports.default = TransferFrequency;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/ViewConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SdkConfiguration = __webpack_require__("./sdk/scripts/utils/SdkConfiguration.js");

var _SdkConfiguration2 = _interopRequireDefault(_SdkConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewConstants = function () {
  function ViewConstants() {
    _classCallCheck(this, ViewConstants);
  }

  _createClass(ViewConstants, null, [{
    key: 'IMAGE_DEFAULT_RESTAURANT_LOGO',
    value: function IMAGE_DEFAULT_RESTAURANT_LOGO() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/user_default_picture.png'; // TODO: change
    }
  }, {
    key: 'IMAGE_DEFAULT_RESTAURANT',
    value: function IMAGE_DEFAULT_RESTAURANT() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/default_restaurant.png';
    }
  }, {
    key: 'IMAGE_UPLOAD_BTN',
    value: function IMAGE_UPLOAD_BTN() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/upload_update.png';
    }
  }, {
    key: 'IMAGE_DELETE_BTN',
    value: function IMAGE_DELETE_BTN() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/upload_delete.png';
    }
  }, {
    key: 'IMAGE_RESTORE_BTN',
    value: function IMAGE_RESTORE_BTN() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/upload_restore.png';
    }
  }, {
    key: 'IMAGE_UPLOAD_PLACEHOLDER',
    value: function IMAGE_UPLOAD_PLACEHOLDER() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/draughtboard.png';
    }
  }, {
    key: 'IMAGE_LOADING_BAR',
    value: function IMAGE_LOADING_BAR() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/loading-bars.svg';
    }
  }, {
    key: 'IMAGE_DEFAULT_USER_PICTURE',
    value: function IMAGE_DEFAULT_USER_PICTURE() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/user_default_picture.png';
    }
  }, {
    key: 'IMAGE_USER_DEFAULT_PICTURE',
    value: function IMAGE_USER_DEFAULT_PICTURE() {
      return _SdkConfiguration2.default.getDomainUrl() + '/img/user_default_picture.png';
    }
  }, {
    key: 'KIOSK_ORDER_LOCALES',
    value: function KIOSK_ORDER_LOCALES() {
      return ['fr_FR', 'en_GB', 'de_DE', 'es_ES'];
    }
  }]);

  return ViewConstants;
}();

exports.default = ViewConstants;
;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/constants/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewConstants = exports.TransferFrequency = exports.TaxesType = exports.RestaurantTagsList = exports.POSType = exports.PMTConstants = exports.CountriesList = exports.BookingConstants = exports.APIEndpoints = exports.ApiConstants = undefined;

var _ApiConstants2 = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants3 = _interopRequireDefault(_ApiConstants2);

var _APIEndpoints2 = __webpack_require__("./sdk/scripts/constants/APIEndpoints.js");

var _APIEndpoints3 = _interopRequireDefault(_APIEndpoints2);

var _BookingConstants2 = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants3 = _interopRequireDefault(_BookingConstants2);

var _CountriesList2 = __webpack_require__("./sdk/scripts/constants/CountriesList.js");

var _CountriesList3 = _interopRequireDefault(_CountriesList2);

var _PMTConstants2 = __webpack_require__("./sdk/scripts/constants/PMTConstants.js");

var _PMTConstants3 = _interopRequireDefault(_PMTConstants2);

var _POSType2 = __webpack_require__("./sdk/scripts/constants/POSType.js");

var _POSType3 = _interopRequireDefault(_POSType2);

var _RestaurantTagsList2 = __webpack_require__("./sdk/scripts/constants/RestaurantTagsList.js");

var _RestaurantTagsList3 = _interopRequireDefault(_RestaurantTagsList2);

var _TaxesType2 = __webpack_require__("./sdk/scripts/constants/TaxesType.js");

var _TaxesType3 = _interopRequireDefault(_TaxesType2);

var _TransferFrequency2 = __webpack_require__("./sdk/scripts/constants/TransferFrequency.js");

var _TransferFrequency3 = _interopRequireDefault(_TransferFrequency2);

var _ViewConstants2 = __webpack_require__("./sdk/scripts/constants/ViewConstants.js");

var _ViewConstants3 = _interopRequireDefault(_ViewConstants2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ApiConstants = _ApiConstants3.default;
exports.APIEndpoints = _APIEndpoints3.default;
exports.BookingConstants = _BookingConstants3.default;
exports.CountriesList = _CountriesList3.default;
exports.PMTConstants = _PMTConstants3.default;
exports.POSType = _POSType3.default;
exports.RestaurantTagsList = _RestaurantTagsList3.default;
exports.TaxesType = _TaxesType3.default;
exports.TransferFrequency = _TransferFrequency3.default;
exports.ViewConstants = _ViewConstants3.default;

/***/ }),

/***/ "./sdk/scripts/decorators/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = debounce;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * Postpone the execution of the decorated function until after wait milliseconds have elapsed
 * since the last time it was invoked. The function will be called with the arguments of the last
 * invocation. You can pass true as second parameter to cause debounce to trigger the function on
 * the leading instead of the trailing edge of the wait interval.
 *
 * Example:
 *
 * class Button extends React.Component {
 *
 *  @debounce(750, true)
 *  onClick(e) {
 *      // supposing that a user is clicking repeatedly the button
 *      // (< 750ms from the previous click),
 *      // this function logs only the first time
 *      // (because of the true as second parameter that indicate the leading edge)
 *      console.log('Clicked!');
 *    }
 *
 *    render() {
 *      return (
 *        <input
 *          type="button"
 *          onClick={this.onClick}
 *          {...this.props}
 *        />
 *      );
 *    }
 *  }
 *
 *
 * @param  {Number}  [wait=300]        Time to wait between two invocation of the function
 * @param  {Boolean} [immediate=false]
 */
function debounce() {
  var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (target, key, descriptor) {
    var userFunc = descriptor.value;

    (0, _validators.validateFunction)(userFunc, 'debounce');

    var timeout = void 0;

    return _extends({}, descriptor, {
      value: function debouncer() {
        var _this = this;

        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        var callNow = immediate && !timeout;
        clearTimeout(timeout);

        timeout = setTimeout(function () {
          timeout = null;
          if (!immediate) {
            userFunc.apply(_this, [].concat(params));
          }
        }, wait);

        if (callNow) {
          userFunc.apply(this, [].concat(params));
        }
      }
    });
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/defaultProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultProps;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * @defaultProps(props: Object)
 *
 * Defines component's defaultProps.

Example

@defaultProps({
  foo: 'bar',
})
class TextField extends React.Component {

  render() {
    const { foo, ...others } = this.props;
    return (
      <input type="text" value={foo} {...others} />
    );
  }
}
 *
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
function defaultProps(props) {
  return function (target) {
    (0, _validators.validateClass)(target, 'defaultProps');

    // eslint-disable-next-line
    target.defaultProps = props;
  };
}

module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/deprecated.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = deprecated;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

var _utils = __webpack_require__("./sdk/scripts/decorators/utils/utils.js");

/**
* Inspired by https://github.com/jayphelps/core-decorators.js/blob/master/src/deprecate.js
*/

var DEFAULT_MSG = 'This function will be removed in future versions.';

/**
 *
 * @param  {[type]} target            [description]
 * @param  {[type]} key               [description]
 * @param  {[type]} descriptor        [description]
 * @param  {[type]} [msg=DEFAULT_MSG] The message to display.
 * @param  {Object} [options={}]]     OPtions to pass, can contains: 'url'
 */
function handleDescriptor(target, key, descriptor, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      msg = _ref2$ === undefined ? DEFAULT_MSG : _ref2$,
      _ref2$2 = _ref2[1],
      options = _ref2$2 === undefined ? {} : _ref2$2;

  (0, _validators.validateFunction)(descriptor.value, 'extractFromEvent');

  var className = (0, _utils.functionName)(target);
  var methodSignature = className + '_' + target.constructor.name + '#' + key;

  if (options.url) {
    msg += '\n\n    See ' + options.url + ' for more details.\n\n';
  }

  return _extends({}, descriptor, {
    value: function deprecationWrapper() {
      console.warn('DEPRECATION ' + methodSignature + ': ' + msg);
      return descriptor.value.apply(this, arguments);
    }
  });
}

function deprecated() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _utils.decorate)(handleDescriptor, args);
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/extractFromEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = extractFromEvent;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * @extractFromEvent(attribute: string)

Creates a new decorator that extracts the specified attribute from an event and passes it as parameter to the decorated function.

Example

const extractTarget = extractFromEvent('target');

class TextField extends React.Component {

  state = {
    value: '',
  }

  @extractTarget // or directly @extractFromEvent('target')
  onChange(target) {
    this.setState({
      value: target.value,
    });
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        onChange={this.onChange}
        {...this.props}
      />
    );
  }
}

 * @param  {[type]} property [description]
 */
function extractFromEvent(property) {
  if (!property) {
    throw new Error('@extractFromEvent: invalid property specified in decorator');
  }

  return function (target, key, descriptor) {
    var userHandler = descriptor && descriptor.value;

    (0, _validators.validateFunction)(userHandler, 'extractFromEvent');

    return _extends({}, descriptor, {
      value: function processEvent(event) {
        for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        userHandler.apply(this, [property.split('.').reduce(function (current, next) {
          return current[next];
        }, event)].concat(params));
      }
    });
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/extractValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extractFromEvent = __webpack_require__("./sdk/scripts/decorators/extractFromEvent.js");

var _extractFromEvent2 = _interopRequireDefault(_extractFromEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @extractValue

Extracts event's value and passes it as parameter to the decorated function.

Example

class TextField extends React.Component {

  state = {
    value: '',
  }

  @extractValue
  onChange(value) {
    this.setState({
      value,
    });
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        onChange={this.onChange}
        {...this.props}
      />
    );
  }
}
 */
exports.default = (0, _extractFromEvent2.default)('target.value');
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = exports.throttle = exports.stopPropagation = exports.propTypes = exports.preventDefault = exports.notSupported = exports.log = exports.injectState = exports.injectProps = exports.inject = exports.initialState = exports.getEventPreprocessor = exports.extractValue = exports.extractFromEvent = exports.deprecated = exports.defaultProps = exports.debounce = undefined;

var _debounce2 = __webpack_require__("./sdk/scripts/decorators/debounce.js");

var _debounce3 = _interopRequireDefault(_debounce2);

var _defaultProps2 = __webpack_require__("./sdk/scripts/decorators/defaultProps.js");

var _defaultProps3 = _interopRequireDefault(_defaultProps2);

var _deprecated2 = __webpack_require__("./sdk/scripts/decorators/deprecated.js");

var _deprecated3 = _interopRequireDefault(_deprecated2);

var _extractFromEvent2 = __webpack_require__("./sdk/scripts/decorators/extractFromEvent.js");

var _extractFromEvent3 = _interopRequireDefault(_extractFromEvent2);

var _extractValue2 = __webpack_require__("./sdk/scripts/decorators/extractValue.js");

var _extractValue3 = _interopRequireDefault(_extractValue2);

var _getEventPreprocessor2 = __webpack_require__("./sdk/scripts/decorators/utils/getEventPreprocessor.js");

var _getEventPreprocessor3 = _interopRequireDefault(_getEventPreprocessor2);

var _initialState2 = __webpack_require__("./sdk/scripts/decorators/initialState.js");

var _initialState3 = _interopRequireDefault(_initialState2);

var _inject2 = __webpack_require__("./sdk/scripts/decorators/inject.js");

var _inject3 = _interopRequireDefault(_inject2);

var _injectProps2 = __webpack_require__("./sdk/scripts/decorators/injectProps.js");

var _injectProps3 = _interopRequireDefault(_injectProps2);

var _injectState2 = __webpack_require__("./sdk/scripts/decorators/injectState.js");

var _injectState3 = _interopRequireDefault(_injectState2);

var _log2 = __webpack_require__("./sdk/scripts/decorators/log.js");

var _log3 = _interopRequireDefault(_log2);

var _notSupported2 = __webpack_require__("./sdk/scripts/decorators/notSupported.js");

var _notSupported3 = _interopRequireDefault(_notSupported2);

var _preventDefault2 = __webpack_require__("./sdk/scripts/decorators/preventDefault.js");

var _preventDefault3 = _interopRequireDefault(_preventDefault2);

var _propTypes2 = __webpack_require__("./sdk/scripts/decorators/propTypes.js");

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _stopPropagation2 = __webpack_require__("./sdk/scripts/decorators/stopPropagation.js");

var _stopPropagation3 = _interopRequireDefault(_stopPropagation2);

var _throttle2 = __webpack_require__("./sdk/scripts/decorators/throttle.js");

var _throttle3 = _interopRequireDefault(_throttle2);

var _validators2 = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

var _validators3 = _interopRequireDefault(_validators2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.debounce = _debounce3.default;
exports.defaultProps = _defaultProps3.default;
exports.deprecated = _deprecated3.default;
exports.extractFromEvent = _extractFromEvent3.default;
exports.extractValue = _extractValue3.default;
exports.getEventPreprocessor = _getEventPreprocessor3.default;
exports.initialState = _initialState3.default;
exports.inject = _inject3.default;
exports.injectProps = _injectProps3.default;
exports.injectState = _injectState3.default;
exports.log = _log3.default;
exports.notSupported = _notSupported3.default;
exports.preventDefault = _preventDefault3.default;
exports.propTypes = _propTypes3.default;
exports.stopPropagation = _stopPropagation3.default;
exports.throttle = _throttle3.default;
exports.validators = _validators3.default;

/***/ }),

/***/ "./sdk/scripts/decorators/initialState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initialState;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * @initialState(state: Object)

Defines component's initialState.

Example

@initialState({
  foo: 'bar',
})
class TextField extends React.Component {

  render() {
    return (
      <input type="text" value={this.state.foo} {...this.props} />
    );
  }
}
 */

function initialState(state) {
  return function (target) {
    (0, _validators.validateClass)(target, 'initialState');

    // eslint-disable-next-line
    target.prototype.state = state;
  };
}

module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/inject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = inject;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

function inject(value) {
  return function (target, key, descriptor) {
    var userFunc = descriptor.value;

    (0, _validators.validateFunction)(userFunc, 'inject' + value.charAt(0).toUpperCase() + value.slice(1));

    return _extends({}, descriptor, {
      value: function Injector() {
        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        return userFunc.apply(this, [this[value]].concat(params));
      }
    });
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/injectProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inject = __webpack_require__("./sdk/scripts/decorators/inject.js");

var _inject2 = _interopRequireDefault(_inject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Injects component's props in the decorated function as first parameter.
 *
    class User extends React.Component {

     static propTypes = {
       name: PropTypes.string,
       surname: PropTypes.string,
     }

     @injectProps
     getFullName({ name, surname }, separator) {
       return `${name}${separator}${surname}`;
     }

     render() {
       return (
         <div>
           {this.getUsername('-')}
         </div>
       );
     }
    }
 */
exports.default = (0, _inject2.default)('props');
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/injectState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inject = __webpack_require__("./sdk/scripts/decorators/inject.js");

var _inject2 = _interopRequireDefault(_inject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * Injects component's state in the decorated function as first parameter.
 *
 * class TextField extends React.Component {

    state = {
      value: '',
    }

    @injectState
    checkValue({ value }) {
      return !isNaN(new Date(value));
    }

    render() {
      return (
        <div>
          <input type="text" value={this.state.value} {...this.props} />
          {
            !this.checkValue() && (
              Formatting error
            )
          }
        </div>
      );
    }
  }
 */
exports.default = (0, _inject2.default)('state');
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/log.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = log;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * Log name and parameters of the decorated function whenever it is called.
 *
 * class TextField extends React.Component {

  state = {
    value: '',
  }

  @log
  onChange(e) {
    // this evaluates console.log('Calling function "onChange" with params: ', e)
    this.setState({
      value: e.target.value,
    });
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        onChange={this.onChange}
        {...this.props}
      />
    );
  }
}
 *
 * @param  {[type]} target     [description]
 * @param  {[type]} key        [description]
 * @param  {[type]} descriptor [description]
 */
function log(target, key, descriptor) {
  var userFunc = descriptor.value;
  (0, _validators.validateFunction)(userFunc, 'log');

  return _extends({}, descriptor, {
    value: function logger() {
      var _console;

      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      //eslint-disable-next-line
      (_console = console).info.apply(_console, ['Calling function "' + key + '" with params: '].concat(params));
      return userFunc.apply(this, [].concat(params));
    }
  });
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/notSupported.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = deprecated;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

var _utils = __webpack_require__("./sdk/scripts/decorators/utils/utils.js");

/**
* Inspired by https://github.com/jayphelps/core-decorators.js/blob/master/src/deprecate.js
*/

var DEFAULT_MSG = 'This function is not supported.';

/**
 *
 * @param  {[type]} target            [description]
 * @param  {[type]} key               [description]
 * @param  {[type]} descriptor        [description]
 * @param  {[type]} [msg=DEFAULT_MSG] The message to display.
 * @param  {Object} [options={}]]     OPtions to pass, can contains: 'url'
 */
function handleDescriptor(target, key, descriptor, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      msg = _ref2$ === undefined ? DEFAULT_MSG : _ref2$,
      _ref2$2 = _ref2[1],
      options = _ref2$2 === undefined ? {} : _ref2$2;

  (0, _validators.validateFunction)(descriptor.value, 'extractFromEvent');

  var className = (0, _utils.functionName)(target);
  var methodSignature = className + '_' + target.constructor.name + '#' + key;

  if (options.url) {
    msg += '\n\n    See ' + options.url + ' for more details.\n\n';
  }

  return _extends({}, descriptor, {
    value: function deprecationWrapper() {
      console.warn('NOT SUPPORTED ' + methodSignature + ': ' + msg);
      return descriptor.value.apply(this, arguments);
    }
  });
}

function deprecated() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _utils.decorate)(handleDescriptor, args);
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/preventDefault.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getEventPreprocessor = __webpack_require__("./sdk/scripts/decorators/utils/getEventPreprocessor.js");

var _getEventPreprocessor2 = _interopRequireDefault(_getEventPreprocessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @preventDefault

Executes event.preventDefault() for you.

Example

class TextField extends React.Component {

  state = {
    value: '',
  }

  @preventDefault
  onChange(e) {
    this.setState({
      value: e.target.value,
    });
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        onChange={this.onChange}
        {...this.props}
      />
    );
  }
}
 */
exports.default = (0, _getEventPreprocessor2.default)('preventDefault', 'preventDefault');
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/propTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = propTypes;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * Defines component's propTypes.
 *
 * Example

@propTypes({
  foo: PropTypes.string,
})
class TextField extends React.Component {

  render() {
    const { foo, ...others } = this.props;
    return (
      <input type="text" value={foo} {...others} />
    );
  }
}
 *
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
function propTypes(props) {
  return function (target) {
    (0, _validators.validateClass)(target, 'defaultProps');

    // eslint-disable-next-line
    target.propTypes = props;
  };
}

module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/stopPropagation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getEventPreprocessor = __webpack_require__("./sdk/scripts/decorators/utils/getEventPreprocessor.js");

var _getEventPreprocessor2 = _interopRequireDefault(_getEventPreprocessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @stopPropagation

Executes event.stopPropagation() for you.

Example

class TextField extends React.Component {

  state = {
    value: '',
  }

  @stopPropagation
  onChange(e) {
    this.setState({
      value: e.target.value,
    });
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        onChange={this.onChange}
        {...this.props}
      />
    );
  }
}
 */
exports.default = (0, _getEventPreprocessor2.default)('stopPropagation', 'stopPropagation');
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/throttle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = throttle;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

/**
 * @throttle(wait: number = 300, options: Object = { leading: true, trailing: true })
 *
 * Executes the decorated function as soon as you call it for the first time, and, if you call it
 * again any number of times during the wait period, as soon as that period is over. You can pass {
 * leading: false } or { trailing: false } as second parameter to disable the leading or the
 * trailing edge call.
 *
 * Example:
 *
 * class Button extends React.Component {
 *
 *  @throttle(750, { trailing: false })
 *  onClick(e) {
    // supposing that a user is clicking repeatedly the button
    // this function logs one time every 750ms
    // (because of { trailing: false } as second parameter that disables the trailing edge)
    console.log('Clicked!');
  }

  render() {
    return (
      <input
        type="button"
        onClick={this.onClick}
        {...this.props}
      />
    );
  }
}

 * @param  {Number} [wait=300]   [description]
 * @param  {Object} [options={}] [description]
 */
function throttle() {
  var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (target, key, descriptor) {
    var userFunc = descriptor.value;

    (0, _validators.validateFunction)(userFunc, 'throttle');

    var result = void 0;
    var timeout = void 0;
    var args = void 0;
    var previous = 0;

    return _extends({}, descriptor, {
      value: function throttler() {
        var _this = this;

        var now = Date.now();
        if (!previous && options.leading === false) {
          previous = now;
        }
        var remaining = wait - (now - previous);

        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        args = [].concat(params);
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          result = userFunc.apply(this, args);
          if (!timeout) {
            args = null;
          }
        } else if (!timeout && options.trailing !== false) {
          timeout = setTimeout(function () {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = userFunc.apply(_this, args);
            if (!timeout) {
              args = null;
            }
          }, remaining);
        }
        return result;
      }
    });
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/utils/getEventPreprocessor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = getEventPreprocessor;

var _validators = __webpack_require__("./sdk/scripts/decorators/utils/validators.js");

function getEventPreprocessor(decorator) {
  for (var _len = arguments.length, methods = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    methods[_key - 1] = arguments[_key];
  }

  if (methods.length === 0) {
    throw new Error('Invalid method list');
  }

  return function (target, key, descriptor) {
    var userHandler = target;

    if (typeof userHandler !== 'function') {
      userHandler = descriptor && descriptor.value;
    }

    (0, _validators.validateFunction)(userHandler, decorator);

    return _extends({}, descriptor, {
      value: function processEvent(event) {
        methods.forEach(function (method) {
          if (event && method && typeof event[method] === 'function') {
            event[method]();
          }
        });

        for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }

        userHandler.apply(this, [event].concat(params));
      }
    });
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/decorators/utils/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.functionName = functionName;
exports.isDescriptor = isDescriptor;
exports.decorate = decorate;

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function functionName(fun) {
  var ret = fun.toString();

  if (_lodash2.default.isUndefined(ret)) {
    return '';
  }
  ret = ret.substr('function '.length);
  ret = ret.substr(0, ret.indexOf('('));
  return ret;
}

function isDescriptor(desc) {
  if (!desc || !desc.hasOwnProperty) {
    return false;
  }

  var keys = ['value', 'initializer', 'get', 'set'];

  for (var i = 0, l = keys.length; i < l; i++) {
    if (desc.hasOwnProperty(keys[i])) {
      return true;
    }
  }

  return false;
}

function decorate(handleDescriptor, entryArgs) {
  if (isDescriptor(entryArgs[entryArgs.length - 1])) {
    return handleDescriptor.apply(undefined, _toConsumableArray(entryArgs).concat([[]]));
  } else {
    return function () {
      return handleDescriptor.apply(undefined, Array.prototype.slice.call(arguments).concat([entryArgs]));
    };
  }
}

/***/ }),

/***/ "./sdk/scripts/decorators/utils/validators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var validateClass = exports.validateClass = function validateClass(clazz, decorator) {
  if (typeof clazz !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to class not: ' + (typeof clazz === 'undefined' ? 'undefined' : _typeof(clazz)));
  }
};

var validateFunction = exports.validateFunction = function validateFunction(func, decorator) {
  if (typeof func !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to methods not: ' + (typeof func === 'undefined' ? 'undefined' : _typeof(func)));
  }
};

/***/ }),

/***/ "./sdk/scripts/entities/Address.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Address = function (_ApiObject) {
  _inherits(Address, _ApiObject);

  // a two letters identifier like 'FR'
  function Address() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Address);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Address.__proto__ || Object.getPrototypeOf(Address)).call.apply(_ref, [this].concat(args))), _this), _this.street = '', _this.city = '', _this.postCode = '', _this.country = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Address;
}(_ApiObject3.default);

exports.default = Address;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/ApiError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiError = function () {

  /*
   * Generate on the api request when an error occured.
   * User /utils/apiErrors utils to get the localizedMessage.
   */
  function ApiError() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var sessionId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    _classCallCheck(this, ApiError);

    this.code = code;
    this.message = message;
    this.detail = detail;
    this.sessionId = sessionId;
  }

  _createClass(ApiError, [{
    key: 'getCode',
    value: function getCode() {
      return this.code;
    }
  }, {
    key: 'getMessage',
    value: function getMessage() {
      return this.message;
    }
  }, {
    key: 'setCode',
    value: function setCode(code) {
      this.code = code;
    }
  }, {
    key: 'setMessage',
    value: function setMessage(message) {
      this.message = message;
    }
  }, {
    key: 'setDetail',
    value: function setDetail(detail) {
      this.detail = detail;
    }
  }, {
    key: 'getDetail',
    value: function getDetail() {
      if (_lodash2.default.isEmpty(this.detail) || _lodash2.default.isNull(this.detail)) {
        console.error('Unknown api error', this.code, this.message);
        // TODO: localized
        return 'Erreur inconnue';
      }
      return this.detail;
    }
  }, {
    key: 'getSessionId',
    value: function getSessionId() {
      return this.sessionId;
    }
  }, {
    key: 'setSessionId',
    value: function setSessionId(sessionId) {
      this.sessionId = sessionId;
    }
  }]);

  return ApiError;
}();

exports.default = ApiError;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/ApiObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Equals = __webpack_require__("./sdk/scripts/utils/Equals.js");

var _Equals2 = _interopRequireDefault(_Equals);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @abstract
 * Abstract object used by all the objects retrieve from an API.
 * It declare functions to handle serialization, deserialization, object copy.
 */
var ApiObject = function () {
  function ApiObject() {
    _classCallCheck(this, ApiObject);
  }

  _createClass(ApiObject, [{
    key: 'fromJson',
    value: function fromJson() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      try {
        if (data !== null) {
          // Ex: PaymentsStatistics, we use our own object Timelapse,
          // we don't want the fromTime toTime to be set on the object.

          // we remove the unwanted keys from the data.
          // we keep only the keys that exists in the object.
          //      const keys = _.keys(this);
          //      console.log('KEYS', keys);
          //      const dataWithOnlyKeys = _.pick(data, keys);
          //      console.log('dataWithOnlyKeys', dataWithOnlyKeys);
          //      Object.assign(this, dataWithOnlyKeys);

          // TODO: remove data keys that are not on the object. see Object.keys(this)
          // _.merge(this, _.omit(data, keys));
          _lodash2.default.merge(this, data);

          if (typeof this.postJsonAssignation === 'function') {
            this.postJsonAssignation(data);
          }
        }
      } catch (e) {
        _Logger2.default.error('Error deserializing from Json', e);
      }

      return this;
    }

    /**
     * Override this to handle custom deserialization for the object
     *
     * @abstract
     */

  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {}
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var objectVars = _lodash2.default.omit(this, []);
      return _lodash2.default.clone(objectVars);
    }
  }, {
    key: 'copy',
    value: function copy() {
      // This code does not deep copy the object. The bug is visible on the opening hours, add
      // a new opening hour, it will consider that there is no modification on the opening hours
      // object.
      //    const copy = Object.assign({ __proto__: Object.getPrototypeOf(this)}, this);
      //    return copy;
      //
      //    see http://stackoverflow.com/questions/16024940/how-do-i-clone-a-javascript-class-instance
      //    return $.extend(true, Object.create(Object.getPrototypeOf(this)), JSON.parse(JSON.stringify(this)));
      //
      //    also tried deepcopy package
      //    return deepcopy(this);

      return _lodash2.default.cloneDeepWith(this);
    }

    // -- tools

  }, {
    key: 'equals',
    value: function equals(other) {
      return _Equals2.default.objectEquals(this, other);
    }
  }]);

  return ApiObject;
}();

exports.default = ApiObject;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/CRMSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CRMSettings = function (_ApiObject) {
  _inherits(CRMSettings, _ApiObject);

  function CRMSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CRMSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CRMSettings.__proto__ || Object.getPrototypeOf(CRMSettings)).call.apply(_ref, [this].concat(args))), _this), _this.enabled = false, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
  * Set to true if there is a CRM attached.
  * Set to false if there is no CRM attached, or if it's disable.
  */


  /**
  * The crm type
  */


  /**
  * The url to use for development purpose.
  */


  return CRMSettings;
}(_ApiObject3.default);

CRMSettings.CRMType = {
  NEOLANE_HIPPO: 'NEOLANE_HIPPO'
};
exports.default = CRMSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Check.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Check = function (_ApiObject) {
  _inherits(Check, _ApiObject);

  function Check() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Check);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Check.__proto__ || Object.getPrototypeOf(Check)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.tableNumber = '', _this.subtotal = 0, _this.tax = 0, _this.total = 0, _this.outstandingBalance = 0, _this.guestcount = 0, _this.currency = '', _this.date = 0, _this.posCheckId = '', _this.restaurant = '', _this.serveurFirstName = '', _this.serveurFullName = '', _this.serveurLastName = '', _this.tips = 0, _this.total = 0, _this.entries = [], _temp), _possibleConstructorReturn(_this, _ret);
  } // TODO

  // TODO

  // equals to checkId who will be removed

  /**
   * Restaurant name
   */


  /**
   * Serializable: 'entries'. TODO
   */


  _createClass(Check, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(Check.prototype.__proto__ || Object.getPrototypeOf(Check.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize payments
      // this.entries = []
      // _.each(data.entries, (dataEntry:Object) => {
      //   const entry:
      //   this.entries.push(entry);
      // });
    }
  }]);

  return Check;
}(_ApiObject3.default);

exports.default = Check;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/ChecksList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Check = __webpack_require__("./sdk/scripts/entities/Check.js");

var _Check2 = _interopRequireDefault(_Check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChecksList = function (_ApiObject) {
  _inherits(ChecksList, _ApiObject);

  function ChecksList() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, ChecksList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = ChecksList.__proto__ || Object.getPrototypeOf(ChecksList)).call.apply(_ref, [this].concat(args))), _this2), _this2.checks = [], _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(ChecksList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(ChecksList.prototype.__proto__ || Object.getPrototypeOf(ChecksList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize checks
      this.checks = [];
      var _this = this;

      // -- handle the case were the api responds a json with the array directly.
      var dataChecks = [];
      if (!_lodash2.default.isUndefined(data.checks)) {
        dataChecks = data.checks;
      } else {
        dataChecks = data;
      }

      _lodash2.default.each(dataChecks, function (checkData) {
        var check = new _Check2.default();
        check.fromJson(checkData);
        _this.checks.push(check);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      return _ArrayUtils2.default.find(this.checks, function (check) {
        return check.id == idToFind;
      });
    }
  }]);

  return ChecksList;
}(_ApiObject3.default);

exports.default = ChecksList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/ClaimsDiscussionsSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Validation = __webpack_require__("./sdk/scripts/utils/Validation.js");

var _Validation2 = _interopRequireDefault(_Validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClaimsDiscussionsSettings = function (_ApiObject) {
  _inherits(ClaimsDiscussionsSettings, _ApiObject);

  function ClaimsDiscussionsSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ClaimsDiscussionsSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClaimsDiscussionsSettings.__proto__ || Object.getPrototypeOf(ClaimsDiscussionsSettings)).call.apply(_ref, [this].concat(args))), _this), _this.countdown = 0, _this.maxRate = 1, _this.enabled = false, _this.emailSubject = '', _this.senderName = '', _this.senderEmail = '', _this.emailBody = '', _this.restaurantId = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * the number of stars maximum to send the mail.
   * @type {number}
   */


  _createClass(ClaimsDiscussionsSettings, [{
    key: 'setCountdown',


    // -- setters

    /**
     * set the given coutdown as minutes to a timestamp
     * @param minutes
     */
    value: function setCountdown(minutes) {
      this.countdown = minutes * 60 * 1000;
    }
  }, {
    key: 'getCountdownAsMinutes',
    value: function getCountdownAsMinutes() {
      return this.countdown / (60 * 1000);
    }

    // ---- Validation

    // TODO: validation

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'validate',
    value: function validate() {
      var errors = this.getValidationErrors();
      return errors.length === 0;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {

      var validationErrorsInfo = [{
        key: 'countdown',
        error: 'Le temps est invalide',
        func: this.validateCountdown.bind(this)
      }, {
        key: 'maxRate',
        error: '',
        func: this.validateMaxRate.bind(this)
      }, {
        key: 'emailSubject',
        error: 'Le sujet est requis',
        func: this.validateSubject.bind(this)
      }, {
        key: 'senderName',
        error: 'Le nom de l\'expediteur est requis',
        func: this.validateSenderName.bind(this)
      }, {
        key: 'emailBody',
        error: 'Le contenu de l\'email est requis',
        func: this.validateContent.bind(this)
      }, {
        key: 'senderEmail',
        error: 'Email invalide',
        func: this.validateSenderEmail.bind(this)
      }];

      var errors = [];
      _lodash2.default.each(validationErrorsInfo, function (validationInfo) {
        if (!validationInfo.func()) {
          errors[validationInfo.key] = validationInfo.error;
        }
      });

      return errors;
    }
  }, {
    key: 'validateCountdown',
    value: function validateCountdown() {
      return _lodash2.default.isNumber(parseFloat(this.countdown)) && this.countdown > 0;
    }
  }, {
    key: 'validateMaxRate',
    value: function validateMaxRate() {
      return !_lodash2.default.isNull(this.maxRate) && this.maxRate >= 1 && this.maxRate <= 5;
    }
  }, {
    key: 'validateSubject',
    value: function validateSubject() {
      return !_lodash2.default.isEmpty(this.emailSubject);
    }
  }, {
    key: 'validateSenderName',
    value: function validateSenderName() {
      return !_lodash2.default.isEmpty(this.senderName);
    }
  }, {
    key: 'validateSenderEmail',
    value: function validateSenderEmail() {
      return !_lodash2.default.isEmpty(this.senderEmail) && _Validation2.default.email(this.senderEmail);
    }
  }, {
    key: 'validateContent',
    value: function validateContent() {
      return !_lodash2.default.isEmpty(this.emailBody);
    }
  }]);

  return ClaimsDiscussionsSettings;
}(_ApiObject3.default);

exports.default = ClaimsDiscussionsSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/GeoPt.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeoPt = function (_ApiObject) {
  _inherits(GeoPt, _ApiObject);

  function GeoPt() {
    _classCallCheck(this, GeoPt);

    return _possibleConstructorReturn(this, (GeoPt.__proto__ || Object.getPrototypeOf(GeoPt)).apply(this, arguments));
  }

  return GeoPt;
}(_ApiObject3.default);

exports.default = GeoPt;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/News.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var News = function (_ApiObject) {
  _inherits(News, _ApiObject);

  function News() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, News);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = News.__proto__ || Object.getPrototypeOf(News)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.creationDate = 0, _this.title = '', _this.content = '', _this.picture = '', _temp), _possibleConstructorReturn(_this, _ret);
  } // Default value is the current display date.

  _createClass(News, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(News.prototype.__proto__ || Object.getPrototypeOf(News.prototype), 'postJsonAssignation', this).call(this, data);
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dddd DD/MM/Y';

      return _DateUtils2.default.fromSecondsTimestampToString(this.creationDate / 1000, format);
    }
  }, {
    key: 'getFormattedHour',
    value: function getFormattedHour() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HH:mm';

      return _DateUtils2.default.fromSecondsTimestampToString(this.creationDate / 1000, format);
    }
  }, {
    key: 'getMomentDate',
    value: function getMomentDate() {
      return _DateUtils2.default.fromTimestamp(this.creationDate, _DateUtils2.default.MS_FORMAT);
    }
  }, {
    key: 'getHour',
    value: function getHour() {
      return _DateUtils2.default.fromTimestamp(this.creationDate, _DateUtils2.default.MS_FORMAT).hour();
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return !_lodash2.default.isEmpty(this.title) && !_lodash2.default.isEmpty(this.content);
    }
  }]);

  return News;
}(_ApiObject3.default);

exports.default = News;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/NewsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _News = __webpack_require__("./sdk/scripts/entities/News.js");

var _News2 = _interopRequireDefault(_News);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsList = function (_ApiObject) {
  _inherits(NewsList, _ApiObject);

  function NewsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsList.__proto__ || Object.getPrototypeOf(NewsList)).call.apply(_ref, [this].concat(args))), _this), _this.list = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(NewsList.prototype.__proto__ || Object.getPrototypeOf(NewsList.prototype), 'postJsonAssignation', this).call(this, data);

      this.list = [];
      _lodash2.default.each(data.list, function (newsData) {
        var news = new _News2.default();
        news.fromJson(newsData);

        _this2.list.push(news);
      });
    }
  }, {
    key: 'updateNews',
    value: function updateNews(newsToUpdate) {
      var tmp = [];

      _lodash2.default.each(this.list, function (news) {
        if (news.id !== newsToUpdate.id) {
          tmp.push(news);
        } else {
          tmp.push(newsToUpdate);
        }
      });

      this.list = tmp;
    }
  }, {
    key: 'deleteNews',
    value: function deleteNews(newsToDelete) {
      var tmp = [];

      _lodash2.default.each(this.list, function (news) {
        if (news.id !== newsToDelete.id) {
          tmp.push(news);
        }
      });

      this.list = tmp;
    }
  }]);

  return NewsList;
}(_ApiObject3.default);

exports.default = NewsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/OpeningHour.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OpeningHour = function (_ApiObject) {
  _inherits(OpeningHour, _ApiObject);

  function OpeningHour() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OpeningHour);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpeningHour.__proto__ || Object.getPrototypeOf(OpeningHour)).call.apply(_ref, [this].concat(args))), _this), _this.opening = 0, _this.closing = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OpeningHour, [{
    key: 'getOpeningHourAsDate',
    value: function getOpeningHourAsDate() {
      return (0, _moment2.default)(this.opening, _DateUtils2.default.MS_FORMAT);
    }
  }, {
    key: 'getClosingHourAsDate',
    value: function getClosingHourAsDate() {
      return (0, _moment2.default)(this.closing, _DateUtils2.default.MS_FORMAT);
    }

    //
    // format
    //

  }, {
    key: 'getOpeningHour',
    value: function getOpeningHour() {
      return _DateUtils2.default.getHourFromMsHourTimestamp(this.opening);
    }
  }, {
    key: 'getOpeningMinute',
    value: function getOpeningMinute() {
      return _DateUtils2.default.getMinuteFromMsHourTimestamp(this.opening);
    }
  }, {
    key: 'getClosingHour',
    value: function getClosingHour() {
      return _DateUtils2.default.getHourFromMsHourTimestamp(this.closing);
    }
  }, {
    key: 'getClosingMinute',
    value: function getClosingMinute() {
      return _DateUtils2.default.getMinuteFromMsHourTimestamp(this.closing);
    }
  }, {
    key: 'getFormatted',
    value: function getFormatted() {
      return this.getOpeningHourAsFormattedDate() + ' - ' + this.getClosingHourAsFormattedDate();
    }
  }, {
    key: 'formatTwoDigits',
    value: function formatTwoDigits(number) {
      return number > 9 ? '' + number : '0' + number;
    }
  }, {
    key: 'getOpeningHourAsFormattedDate',
    value: function getOpeningHourAsFormattedDate() {
      return _DateUtils2.default.getFormattedHourWithMsHour(this.opening);
    }
  }, {
    key: 'getClosingHourAsFormattedDate',
    value: function getClosingHourAsFormattedDate() {
      return _DateUtils2.default.getFormattedHourWithMsHour(this.closing);
    }
  }, {
    key: 'getInterval',
    value: function getInterval() {
      var minuteInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;

      var hours = [];

      var intervalAsMs = minuteInterval * _DateUtils2.default.MINUTE_AS_MILLISECONDS;

      for (var i = this.opening; i <= this.closing; i += intervalAsMs) {
        hours.push(i);
      }

      return hours;
    }
  }]);

  return OpeningHour;
}(_ApiObject3.default);

exports.default = OpeningHour;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/OpeningHours.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _OpeningHour = __webpack_require__("./sdk/scripts/entities/OpeningHour.js");

var _OpeningHour2 = _interopRequireDefault(_OpeningHour);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OpeningHours = function (_ApiObject) {
  _inherits(OpeningHours, _ApiObject);

  function OpeningHours() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OpeningHours);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpeningHours.__proto__ || Object.getPrototypeOf(OpeningHours)).call.apply(_ref, [this].concat(args))), _this), _this.monday = [], _this.tuesday = [], _this.wednesday = [], _this.thursday = [], _this.friday = [], _this.saturday = [], _this.sunday = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OpeningHours, [{
    key: 'getForDay',


    // -- tools
    value: function getForDay(day) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          return this.monday;
        case _ApiConstants2.default.Day.TUESDAY:
          return this.tuesday;
        case _ApiConstants2.default.Day.WEDNESDAY:
          return this.wednesday;
        case _ApiConstants2.default.Day.THURSDAY:
          return this.thursday;
        case _ApiConstants2.default.Day.FRIDAY:
          return this.friday;
        case _ApiConstants2.default.Day.SATURDAY:
          return this.saturday;
        case _ApiConstants2.default.Day.SUNDAY:
          return this.sunday;
        default:
          return [];
      }
    }
  }, {
    key: 'addForDay',
    value: function addForDay(day, openingHour) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          this.monday.push(openingHour);
          break;
        case _ApiConstants2.default.Day.TUESDAY:
          this.tuesday.push(openingHour);
          break;
        case _ApiConstants2.default.Day.WEDNESDAY:
          this.wednesday.push(openingHour);
          break;
        case _ApiConstants2.default.Day.THURSDAY:
          this.thursday.push(openingHour);
          break;
        case _ApiConstants2.default.Day.FRIDAY:
          this.friday.push(openingHour);
          break;
        case _ApiConstants2.default.Day.SATURDAY:
          this.saturday.push(openingHour);
          break;
        case _ApiConstants2.default.Day.SUNDAY:
          this.sunday.push(openingHour);
          break;
        default:
      }
    }
  }, {
    key: 'removeForDay',
    value: function removeForDay(day, openingHour) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          this.monday = this.removeOpeningHourOnArray(this.monday, openingHour);
          break;
        case _ApiConstants2.default.Day.TUESDAY:
          this.tuesday = this.removeOpeningHourOnArray(this.tuesday, openingHour);
          break;
        case _ApiConstants2.default.Day.WEDNESDAY:
          this.wednesday = this.removeOpeningHourOnArray(this.wednesday, openingHour);
          break;
        case _ApiConstants2.default.Day.THURSDAY:
          this.thursday = this.removeOpeningHourOnArray(this.thursday, openingHour);
          break;
        case _ApiConstants2.default.Day.FRIDAY:
          this.friday = this.removeOpeningHourOnArray(this.friday, openingHour);
          break;
        case _ApiConstants2.default.Day.SATURDAY:
          this.saturday = this.removeOpeningHourOnArray(this.saturday, openingHour);
          break;
        case _ApiConstants2.default.Day.SUNDAY:
          this.sunday = this.removeOpeningHourOnArray(this.sunday, openingHour);
          break;
        default:
      }
    }
  }, {
    key: 'removeOpeningHourOnArray',
    value: function removeOpeningHourOnArray(list, toRemove) {
      var res = [];

      _lodash2.default.each(list, function (openingHour) {
        if (openingHour.opening !== toRemove.opening && openingHour.closing !== toRemove.closing) {
          res.push(openingHour);
        }
      });

      return res;
    }
  }, {
    key: 'getSuggestOpeningHourForDay',
    value: function getSuggestOpeningHourForDay(day) {
      var allOpeningsHours = this.getAllOpeningsHours();
      var openingHoursForDay = this.getForDay(day);

      var result = {};
      _lodash2.default.each(allOpeningsHours, function (openingHour) {
        var key = openingHour.opening + '_' + openingHour.closing;
        if (_lodash2.default.isUndefined(result[key])) {
          result[key] = {
            openingHour: openingHour,
            count: 1
          };
        } else {
          result[key].count++;
        }
      });

      // lower count for already used opening hours for this day.
      if (!_lodash2.default.isEmpty(openingHoursForDay)) {
        _lodash2.default.each(openingHoursForDay, function (openingHour) {
          var key = openingHour.opening + '_' + openingHour.closing;
          result[key].count = -1;
        });
      }

      // find most present
      if (!_lodash2.default.isEmpty(result)) {
        var maxCount = 0;
        var max = !_lodash2.default.isEmpty(openingHoursForDay) ? openingHoursForDay[0] : allOpeningsHours[0];

        _lodash2.default.forIn(result, function (value) {
          if (value.count > maxCount) {
            maxCount = value.count;
            max = value.openingHour;
          }
        });

        // return a copy, not a reference.
        return max.copy();
      }

      return new _OpeningHour2.default();
    }
  }, {
    key: 'getSuggestOpeningHour',
    value: function getSuggestOpeningHour() {
      var allOpeningsHours = this.getAllOpeningsHours();

      var result = {};
      _lodash2.default.each(allOpeningsHours, function (openingHour) {
        var key = openingHour.opening + '_' + openingHour.closing;
        if (_lodash2.default.isUndefined(result[key])) {
          result[key] = {
            openingHour: openingHour,
            count: 1
          };
        } else {
          result[key].count++;
        }
      });

      // find most present
      if (!_lodash2.default.isEmpty(result)) {
        var maxCount = 0;
        var max = new _OpeningHour2.default();

        _lodash2.default.forIn(result, function (value) {
          if (value.count > maxCount) {
            maxCount = value.count;
            max = value.openingHour;
          }
        });

        // return a copy, not a reference
        return max.copy();
      }

      return new _OpeningHour2.default();
    }
  }, {
    key: 'getAllOpeningsHours',
    value: function getAllOpeningsHours() {
      return _lodash2.default.concat(this.monday, this.tuesday, this.wednesday, this.thursday, this.friday, this.saturday, this.sunday);
    }

    /**
     * Warning: moment.js week start at sunday, not monday
     */

  }, {
    key: 'isDayOpen',
    value: function isDayOpen(dayIndex) {
      var openingHours = this.getForDay(dayIndex);

      if (!_lodash2.default.isEmpty(openingHours)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isOpenForDate',
    value: function isOpenForDate(date) {
      var openingHours = this.getForDay(_DateUtils2.default.getPmtDayIndex(date));

      return _ArrayUtils2.default.exists(openingHours, function (openingHour) {
        return _DateUtils2.default.getTimestampForHourWithDate(date) >= openingHour.opening && _DateUtils2.default.getTimestampForHourWithDate(date) <= openingHour.closing;
      });
    }

    /**
     * Warning: moment.js week start at sunday, not monday
     */

  }, {
    key: 'generateHoursForDay',
    value: function generateHoursForDay(dayIndex) {
      var minuteInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

      var openingHours = this.getForDay(dayIndex);
      var hours = [];

      _lodash2.default.each(openingHours, function (openingHour) {
        hours = _lodash2.default.concat(hours, openingHour.getInterval(minuteInterval));
      });

      // delete doublons
      var finalHours = _lodash2.default.uniq(hours);

      // sort by date
      finalHours = _lodash2.default.sortBy(finalHours, function (slot) {
        return slot;
      });

      return finalHours;
    }

    // -- serialization

  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(OpeningHours.prototype.__proto__ || Object.getPrototypeOf(OpeningHours.prototype), 'postJsonAssignation', this).call(this, data);

      this.monday = [];
      _lodash2.default.each(data.monday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.monday.push(openingHour);
      });

      this.tuesday = [];
      _lodash2.default.each(data.tuesday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.tuesday.push(openingHour);
      });

      this.wednesday = [];
      _lodash2.default.each(data.wednesday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.wednesday.push(openingHour);
      });

      this.thursday = [];
      _lodash2.default.each(data.thursday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.thursday.push(openingHour);
      });

      this.friday = [];
      _lodash2.default.each(data.friday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.friday.push(openingHour);
      });

      this.saturday = [];
      _lodash2.default.each(data.saturday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.saturday.push(openingHour);
      });

      this.sunday = [];
      _lodash2.default.each(data.sunday, function (openingHourData) {
        var openingHour = new _OpeningHour2.default();
        openingHour.fromJson(openingHourData);
        _this2.sunday.push(openingHour);
      });
    }
  }]);

  return OpeningHours;
}(_ApiObject3.default);

exports.default = OpeningHours;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Payin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Payin = function (_ApiObject) {
  _inherits(Payin, _ApiObject);

  function Payin() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Payin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Payin.__proto__ || Object.getPrototypeOf(Payin)).call.apply(_ref, [this].concat(args))), _this), _this.amount = 0, _this.checkId = '', _this.date = 0, _this.fees = 0, _this.tips = 0, _this.userCheckId = '', _this.waiterName = '', _this.totalTable = 0, _temp), _possibleConstructorReturn(_this, _ret);
  } // TODO: replace by date object.

  _createClass(Payin, [{
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return _DateUtils2.default.fromSecondsTimestampToString(this.date, format);
    }
  }, {
    key: 'getFormattedHour',
    value: function getFormattedHour() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HH:mm';

      return _DateUtils2.default.fromSecondsTimestampToString(this.date, format);
    }
  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.date = Math.floor(this.date / 1000);
    }
  }]);

  return Payin;
}(_ApiObject3.default);

exports.default = Payin;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/PayinList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PayinList = function (_ApiObject) {
  _inherits(PayinList, _ApiObject);

  function PayinList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PayinList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PayinList.__proto__ || Object.getPrototypeOf(PayinList)).call.apply(_ref, [this].concat(args))), _this), _this.timelapse = new _Timelapse2.default(), _this.payins = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PayinList, [{
    key: 'postJsonAssignation',
    // Array of Payin

    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(PayinList.prototype.__proto__ || Object.getPrototypeOf(PayinList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize timelapse
      this.timelapse = new _Timelapse2.default();
      this.timelapse.setFromTime(data.fromTime / 1000);
      this.timelapse.setToTime(data.toTime / 1000);

      // -- deserialize payins
      this.payins = [];

      _lodash2.default.each(data.payins, function (payinData) {
        var payin = new _Payin2.default();
        payin.fromJson(payinData);
        _this2.payins.push(payin);
      });
    }
  }]);

  return PayinList;
}(_ApiObject3.default);

exports.default = PayinList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Payment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Payment = function (_ApiObject) {
  _inherits(Payment, _ApiObject);

  function Payment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Payment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Payment.__proto__ || Object.getPrototypeOf(Payment)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.cardId = '', _this.amount = 0, _this.tip = 0, _this.credit = 0, _this.type = 0, _this.checkId = '', _this.credit = 0, _this.currency = null, _this.date = 0, _this.fees = 0, _this.payIn3DSecureUrl = '', _this.payInId = '', _this.payInIdPmt = '', _this.payInRefundId = '', _this.restId = '', _this.restaurantName = '', _this.sDate = 0, _this.sNumTicket = '', _this.status = Payment.Status.CREATED, _this.tips = 0, _this.transferIdPmt = '', _this.transferRefundIdPmt = '', _this.userId = '', _this.reference = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  // TODO: set default to '' after api changement.


  /**
   * TODO
   * For now front only for acrelec sdk
   * A transaction identifier value used for a futher payment matching (bank or debug purposes)
   */


  _createClass(Payment, [{
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return _DateUtils2.default.fromSecondsTimestampToString(this.date, format);
    }
  }, {
    key: 'getFormattedHour',
    value: function getFormattedHour() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HH:mm';

      return _DateUtils2.default.fromSecondsTimestampToString(this.date, format);
    }
  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.date = Math.floor(this.date / 1000);
      this.tip = this.tips;
    }
  }]);

  return Payment;
}(_ApiObject3.default);

Payment.Type = {
  EVERYTHING: 1,

  EQUAL_SHARE: 2,

  SPECIFIC_AMOUNT: 3,

  SELECT_ITEMS: 4,

  DISTANT_PAYMENT: 5,

  PAYMENT_WITH_ORDER: 6
};
Payment.Status = {
  CREATED: 'CREATED',
  PAID: 'PAID',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED'
};
exports.default = Payment;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/PaymentStatistics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _Payin = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin2 = _interopRequireDefault(_Payin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentStatistics = function (_ApiObject) {
  _inherits(PaymentStatistics, _ApiObject);

  function PaymentStatistics() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, PaymentStatistics);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = PaymentStatistics.__proto__ || Object.getPrototypeOf(PaymentStatistics)).call.apply(_ref, [this].concat(args))), _this2), _this2.paymentsNumber = 0, _this2.checksNumber = 0, _this2.timelapse = new _Timelapse2.default(), _this2.payins = [], _this2.tips = [], _this2.totalAmountPaid = 0, _this2.totalTipsPaid = 0, _temp), _possibleConstructorReturn(_this2, _ret);
  }
  // fromTime: number = 0;
  // toTime: number = 0;

  // Array of Payin


  /**
   * Include tips
   */


  _createClass(PaymentStatistics, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(PaymentStatistics.prototype.__proto__ || Object.getPrototypeOf(PaymentStatistics.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize timelapse
      this.timelapse = new _Timelapse2.default();
      this.timelapse.setFromTime(data.fromTime / 1000);
      this.timelapse.setToTime(data.toTime / 1000);

      // -- deserialize payins
      this.payins = [];
      var _this = this;

      _lodash2.default.each(data.payins, function (payinData) {
        var payin = new _Payin2.default();
        payin.fromJson(payinData);
        _this.payins.push(payin);
      });
    }
  }]);

  return PaymentStatistics;
}(_ApiObject3.default);

exports.default = PaymentStatistics;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/PaymentsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Payment = __webpack_require__("./sdk/scripts/entities/Payment.js");

var _Payment2 = _interopRequireDefault(_Payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentsList = function (_ApiObject) {
  _inherits(PaymentsList, _ApiObject);

  function PaymentsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentsList.__proto__ || Object.getPrototypeOf(PaymentsList)).call.apply(_ref, [this].concat(args))), _this), _this.payments = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(PaymentsList.prototype.__proto__ || Object.getPrototypeOf(PaymentsList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize payments
      this.payments = [];

      // -- handle the case were the api responds a json with the array directly.
      var dataPayments = [];
      if (!_lodash2.default.isUndefined(data.payments)) {
        dataPayments = data.payments;
      } else {
        dataPayments = data;
      }

      _lodash2.default.each(dataPayments, function (paymentData) {
        var payment = new _Payment2.default();
        payment.fromJson(paymentData);
        _this2.payments.push(payment);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      var found = _lodash2.default.find(this.payments, function (payment) {
        return payment.id === idToFind;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }, {
    key: 'count',
    value: function count() {
      return this.payments.length;
    }
  }, {
    key: 'getLastVisitFormatted',
    value: function getLastVisitFormatted() {
      return this.payments[0].getFormattedDate() + ' - ' + this.payments[0].getFormattedHour();
    }
  }, {
    key: 'getAveragePayment',
    value: function getAveragePayment() {
      var total = 0;
      _lodash2.default.each(this.payments, function (payment) {
        total += payment.amount;
      });

      if (this.count() === 0) {
        return 0;
      }

      return total / this.count();
    }
  }, {
    key: 'getAverageTip',
    value: function getAverageTip() {
      var total = 0;
      _lodash2.default.each(this.payments, function (payment) {
        total += payment.tip;
      });

      if (this.count() === 0) {
        return 0;
      }
      return total / this.count();
    }
  }]);

  return PaymentsList;
}(_ApiObject3.default);

exports.default = PaymentsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Payout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _Types = __webpack_require__("./sdk/scripts/utils/Types.js");

var _Types2 = _interopRequireDefault(_Types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Payout = function (_ApiObject) {
  _inherits(Payout, _ApiObject);

  function Payout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Payout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Payout.__proto__ || Object.getPrototypeOf(Payout)).call.apply(_ref, [this].concat(args))), _this), _this.payOutId = '', _this.amount = 0, _this.date = 0, _this.status = '', _this.creationDate = null, _this.dateOfFirstPayment = null, _this.dateOfLastPayment = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // deprecated.


  // deprecated see creationDate


  /**
   * the VAT percent used to calculate the feesFixed and feesVariable from the restaurant's values which are excluding taxes
   */


  /**
   * the VAT percent used to calculate the feesFixed and feesVariable from the restaurant's values which are excluding taxes.
   * Rounded.
   */


  /**
   * the fixed unit price (per payin)
   */


  /**
   * the fixed amount of fees taken on the total amount to transfer to the restaurant, excludng vat
   */


  /**
   * the variable amount of fees taken on the total amount to transfer to the restaurant, includng vat
   */


  /**
   * the variable amount of fees taken on the total amount to transfer to the restaurant, includng vat
   */


  /**
   * total sum of user payments to the restaurant
   */


  /**
   * amount transfered to the restaurant's bank account, equals to amountIncludingFees - feesFixed - feesVariable
   */


  /**
   * Date of the first payment concerned by this payout
   */


  /**
   * Date of the last payment concerned by this payout
   */


  _createClass(Payout, [{
    key: 'postJsonAssignation',


    //
    //
    //

    value: function postJsonAssignation(data) {
      this.creationDate = _DateUtils2.default.fromMsTimestamp(data.creationDate);
      this.dateOfFirstPayment = _DateUtils2.default.fromMsTimestamp(data.dateOfFirstPayment);
      this.dateOfLastPayment = _DateUtils2.default.fromMsTimestamp(data.dateOfLastPayment);
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return this.creationDate.format(format);
    }
  }, {
    key: 'getFormattedStatus',
    value: function getFormattedStatus() {
      switch (this.status) {
        case Payout.Status.CREATED:
          return 'Crée';
        case Payout.Status.FAILED:
          return 'Erreur';
        case Payout.Status.SUCCEEDED:
          return 'Finalisée';
        default:
          return '';
      }
    }
  }, {
    key: 'getCommissionExcludingTax',
    value: function getCommissionExcludingTax() {
      return this.feesFixedAmountExcludingVat + this.feesVariableAmountExcludingVat;
    }
  }, {
    key: 'getCommissionWithTax',
    value: function getCommissionWithTax() {
      return this.feesFixedAmountExcludingVat + this.feesVariableAmountExcludingVat + this.vatAmount;
    }
  }]);

  return Payout;
}(_ApiObject3.default);

Payout.Status = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  SUCCEEDED: 'SUCCEEDED'
};
exports.default = Payout;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/PayoutList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

var _Payout = __webpack_require__("./sdk/scripts/entities/Payout.js");

var _Payout2 = _interopRequireDefault(_Payout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PayoutList = function (_ApiObject) {
  _inherits(PayoutList, _ApiObject);

  function PayoutList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PayoutList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PayoutList.__proto__ || Object.getPrototypeOf(PayoutList)).call.apply(_ref, [this].concat(args))), _this), _this.timelapse = new _Timelapse2.default(), _this.payouts = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PayoutList, [{
    key: 'postJsonAssignation',
    // Array of Payin

    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(PayoutList.prototype.__proto__ || Object.getPrototypeOf(PayoutList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize timelapse
      this.timelapse = new _Timelapse2.default();
      this.timelapse.setFromTime(data.fromTime / 1000);
      this.timelapse.setToTime(data.toTime / 1000);

      // -- deserialize payins
      this.payouts = [];

      _lodash2.default.each(data.payouts, function (payoutData) {
        var payout = new _Payout2.default();
        payout.fromJson(payoutData);
        _this2.payouts.push(payout);
      });
    }
  }]);

  return PayoutList;
}(_ApiObject3.default);

exports.default = PayoutList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Restaurant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _OpeningHours = __webpack_require__("./sdk/scripts/entities/OpeningHours.js");

var _OpeningHours2 = _interopRequireDefault(_OpeningHours);

var _Address = __webpack_require__("./sdk/scripts/entities/Address.js");

var _Address2 = _interopRequireDefault(_Address);

var _RestaurantColors = __webpack_require__("./sdk/scripts/entities/RestaurantColors.js");

var _RestaurantColors2 = _interopRequireDefault(_RestaurantColors);

var _RestaurantLegal = __webpack_require__("./sdk/scripts/entities/RestaurantLegal.js");

var _RestaurantLegal2 = _interopRequireDefault(_RestaurantLegal);

var _GeoPt = __webpack_require__("./sdk/scripts/entities/GeoPt.js");

var _GeoPt2 = _interopRequireDefault(_GeoPt);

var _CRMSettings = __webpack_require__("./sdk/scripts/entities/CRMSettings.js");

var _CRMSettings2 = _interopRequireDefault(_CRMSettings);

var _BookingSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSettings.js");

var _BookingSettings2 = _interopRequireDefault(_BookingSettings);

var _OrderSettings = __webpack_require__("./sdk/scripts/entities/order/OrderSettings.js");

var _OrderSettings2 = _interopRequireDefault(_OrderSettings);

var _ViewConstants = __webpack_require__("./sdk/scripts/constants/ViewConstants.js");

var _ViewConstants2 = _interopRequireDefault(_ViewConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Restaurant = function (_ApiObject) {
  _inherits(Restaurant, _ApiObject);

  function Restaurant() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Restaurant);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Restaurant.__proto__ || Object.getPrototypeOf(Restaurant)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _this.externalId = '', _this.logo = '', _this.picture = '', _this.phonePub = '', _this.webSitePub = '', _this.emailPub = '', _this.tag = '', _this.facebookPub = '', _this.twitterPub = '', _this.legal = new _RestaurantLegal2.default(), _this.desc = '', _this.address = new _Address2.default(), _this.colors = new _RestaurantColors2.default(), _this.openingHours = new _OpeningHours2.default(), _this.password = '', _this.pos = '', _this.posUrl = null, _this.posId = null, _this.posCustomerId = null, _this.posCommentId = null, _this.posTipArticleId = null, _this.posPriceLevelId = null, _this.posUseQsrOrderNumber = null, _this.posSendArticleLineNum = null, _this.posEncryptionKey = null, _this.menuPicture = null, _this.menuPdf = null, _this.bookingSettings = new _BookingSettings2.default(), _this.orderSettings = new _OrderSettings2.default(), _this.crmSettings = new _CRMSettings2.default(), _this.acquirer = null, _this.psp = null, _this.pspSettings = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Ratio 254x254
   */


  /**
   * Ratio 640x425
   */
  // int

  // float

  // long

  /**
   * Bitefield. The features enabled for the restaurant (pay, order, ).
   */
  // long

  /**
   * The type of check-in. Bite field
   */
  // long

  // -- menu

  // -- booking

  // -- Order

  // -- crm settings

  // -- bank


  _createClass(Restaurant, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(Restaurant.prototype.__proto__ || Object.getPrototypeOf(Restaurant.prototype), 'postJsonAssignation', this).call(this, data);

      this.openingHours = new _OpeningHours2.default();
      this.openingHours.fromJson(data.openingHours);

      this.address = new _Address2.default();
      this.address.fromJson(data.address);

      this.colors = new _RestaurantColors2.default();
      this.colors.fromJson(data.colors);

      this.legal = new _RestaurantLegal2.default();
      this.legal.fromJson(data.legal);

      this.crmSettings = new _CRMSettings2.default();
      this.crmSettings.fromJson(data.crmSettings);

      this.geoPt = new _GeoPt2.default();
      this.geoPt.fromJson(data.geoPt);

      this.orderSettings = new _OrderSettings2.default();
      this.orderSettings.fromJson(data.orderSettings);
    }

    // -- tools

  }, {
    key: 'getCoverPicture',
    value: function getCoverPicture() {
      if (_lodash2.default.isNull(this.picture) || _lodash2.default.isEmpty(this.picture)) {
        return _ViewConstants2.default.IMAGE_DEFAULT_RESTAURANT();
      }
      return this.picture;
    }
  }, {
    key: 'getLogoPicture',
    value: function getLogoPicture() {
      if (_lodash2.default.isNull(this.logo) || _lodash2.default.isEmpty(this.logo)) {
        return _ViewConstants2.default.IMAGE_DEFAULT_RESTAURANT_LOGO();
      }
      return this.logo;
    }

    // -- Credit card

  }, {
    key: 'isAcceptingCreditCardType',
    value: function isAcceptingCreditCardType(creditCardType) {
      return (creditCardType & this.payMode) !== 0;
    }
  }, {
    key: 'isAcceptingVisa',
    value: function isAcceptingVisa() {
      return this.isAcceptingCreditCardType(_ApiConstants2.default.CreditCardType.VISA);
    }
  }, {
    key: 'isAcceptingAmex',
    value: function isAcceptingAmex() {
      return this.isAcceptingCreditCardType(_ApiConstants2.default.CreditCardType.AMERICAN_EXPRESS);
    }
  }, {
    key: 'isAcceptingMastercard',
    value: function isAcceptingMastercard() {
      return this.isAcceptingCreditCardType(_ApiConstants2.default.CreditCardType.MASTERCARD);
    }

    // -- features

  }, {
    key: 'haveFeature',
    value: function haveFeature(feature) {
      return (feature & this.features) !== 0;
    }
  }, {
    key: 'haveFeatureOrder',
    value: function haveFeatureOrder() {
      return this.haveFeature(Restaurant.Features.ORDER);
    }
  }, {
    key: 'haveFeaturePayment',
    value: function haveFeaturePayment() {
      return this.haveFeature(Restaurant.Features.PAYMENT);
    }
  }, {
    key: 'haveFeatureBooking',
    value: function haveFeatureBooking() {
      return this.haveFeature(Restaurant.Features.BOOKING);
    }
  }, {
    key: 'haveFeatureReview',
    value: function haveFeatureReview() {
      return this.haveFeature(Restaurant.Features.REVIEW);
    }
  }, {
    key: 'haveFeatureNews',
    value: function haveFeatureNews() {
      return this.haveFeature(Restaurant.Features.NEWS);
    }
  }]);

  return Restaurant;
}(_ApiObject3.default);

Restaurant.Features = _ApiConstants2.default.RestaurantFeatures;
exports.default = Restaurant;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/RestaurantColors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ViewUtils = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils2 = _interopRequireDefault(_ViewUtils);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantColors = function (_ApiObject) {
  _inherits(RestaurantColors, _ApiObject);

  function RestaurantColors() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantColors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantColors.__proto__ || Object.getPrototypeOf(RestaurantColors)).call.apply(_ref, [this].concat(args))), _this), _this.backgroundColor = _ApiConstants2.default.RestaurantTheme.DEFAULT_BACKGROUND_COLOR, _this.fontColor = _ApiConstants2.default.RestaurantTheme.DEFAULT_FONT_COLOR, _this.titleBackgroundColor = _ApiConstants2.default.RestaurantTheme.DEFAULT_TITLE_BACKGROUND_COLOR, _this.titleFontColor = _ApiConstants2.default.RestaurantTheme.DEFAULT_TITLE_FONT_COLOR, _this.actionBackgroundColor = _ApiConstants2.default.RestaurantTheme.DEFAULT_ACTION_BACKGROUND_COLOR, _this.actionFontColor = _ApiConstants2.default.RestaurantTheme.DEFAULT_ACTION_FONT_COLOR, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantColors, [{
    key: 'getBackgroundColorFormat',


    // -- RGB format

    /**
     * Return a rgba(r,g,b,a) string for css.
     * @returns {String}
     */
    value: function getBackgroundColorFormat() {
      return _ViewUtils2.default.uintColorToRgbaFormat(this.backgroundColor);
    }

    /**
     * Return a rgba(r,g,b,a) string for css.
     * @returns {String}
     */

  }, {
    key: 'getFontColorFormat',
    value: function getFontColorFormat() {
      return _ViewUtils2.default.uintColorToRgbaFormat(this.fontColor);
    }
  }, {
    key: 'getTitleBackgroundColorFormat',
    value: function getTitleBackgroundColorFormat() {
      return _ViewUtils2.default.uintColorToRgbaFormat(this.titleBackgroundColor);
    }
  }, {
    key: 'getTitleFontColorFormat',
    value: function getTitleFontColorFormat() {
      return _ViewUtils2.default.uintColorToRgbaFormat(this.titleFontColor);
    }
  }, {
    key: 'getActionBackgroundColorFormat',
    value: function getActionBackgroundColorFormat() {
      return _ViewUtils2.default.uintColorToRgbaFormat(this.actionBackgroundColor);
    }
  }, {
    key: 'getActionFontColorFormat',
    value: function getActionFontColorFormat() {
      return _ViewUtils2.default.uintColorToRgbaFormat(this.actionFontColor);
    }

    // -- get hexa

  }, {
    key: 'getBackgroundColorAsHexadecimal',
    value: function getBackgroundColorAsHexadecimal() {
      return _ViewUtils2.default.uintColorToHexadecimal(this.backgroundColor);
    }
  }, {
    key: 'getFontColorAsHexadecimal',
    value: function getFontColorAsHexadecimal() {
      return _ViewUtils2.default.uintColorToHexadecimal(this.fontColor);
    }
  }, {
    key: 'getTitleBackgroundColor',
    value: function getTitleBackgroundColor() {
      return _ViewUtils2.default.uintColorToHexadecimal(this.titleBackgroundColor);
    }
  }, {
    key: 'getTitleFontColor',
    value: function getTitleFontColor() {
      return _ViewUtils2.default.uintColorToHexadecimal(this.titleFontColor);
    }
  }, {
    key: 'getActionBackgroundColor',
    value: function getActionBackgroundColor() {
      return _ViewUtils2.default.uintColorToHexadecimal(this.actionBackgroundColor);
    }
  }, {
    key: 'getActionFontColor',
    value: function getActionFontColor() {
      return _ViewUtils2.default.uintColorToHexadecimal(this.actionFontColor);
    }

    // -- set hexa

  }, {
    key: 'setBackgroundColorAsHexadecimal',
    value: function setBackgroundColorAsHexadecimal(color) {
      this.backgroundColor = _ViewUtils2.default.hexadecimalColorToUint(color);
    }
  }, {
    key: 'setFontColorAsHexadecimal',
    value: function setFontColorAsHexadecimal(color) {
      this.fontColor = _ViewUtils2.default.hexadecimalColorToUint(color);
    }
  }, {
    key: 'setTitleBackgroundColor',
    value: function setTitleBackgroundColor(color) {
      this.titleBackgroundColor = _ViewUtils2.default.hexadecimalColorToUint(color);
    }
  }, {
    key: 'setTitleFontColor',
    value: function setTitleFontColor(color) {
      this.titleFontColor = _ViewUtils2.default.hexadecimalColorToUint(color);
    }
  }, {
    key: 'setActionBackgroundColor',
    value: function setActionBackgroundColor(color) {
      this.actionBackgroundColor = _ViewUtils2.default.hexadecimalColorToUint(color);
    }
  }, {
    key: 'setActionFontColor',
    value: function setActionFontColor(color) {
      this.actionFontColor = _ViewUtils2.default.hexadecimalColorToUint(color);
    }
  }]);

  return RestaurantColors;
}(_ApiObject3.default);

exports.default = RestaurantColors;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/RestaurantLegal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _RestaurantLegalRepresentative = __webpack_require__("./sdk/scripts/entities/RestaurantLegalRepresentative.js");

var _RestaurantLegalRepresentative2 = _interopRequireDefault(_RestaurantLegalRepresentative);

var _RestaurantLegalBank = __webpack_require__("./sdk/scripts/entities/RestaurantLegalBank.js");

var _RestaurantLegalBank2 = _interopRequireDefault(_RestaurantLegalBank);

var _Address = __webpack_require__("./sdk/scripts/entities/Address.js");

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantLegal = function (_ApiObject) {
  _inherits(RestaurantLegal, _ApiObject);

  function RestaurantLegal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantLegal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantLegal.__proto__ || Object.getPrototypeOf(RestaurantLegal)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _this.managerName = '', _this.managerPhone = '', _this.address = new _Address2.default(), _this.siren = '', _this.vatNumber = '', _this.statute = '', _this.email = '', _this.registrationProof = '', _this.shareholderDeclaration = '', _this.representative = new _RestaurantLegalRepresentative2.default(), _this.bank = new _RestaurantLegalBank2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantLegal, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.bank = new _RestaurantLegalBank2.default();
      this.bank.fromJson(data.bank);

      this.address = new _Address2.default();
      this.address.fromJson(data.address);

      this.representative = new _RestaurantLegalRepresentative2.default();
      this.representative.fromJson(data.representative);
    }
  }]);

  return RestaurantLegal;
}(_ApiObject3.default);

exports.default = RestaurantLegal;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/RestaurantLegalBank.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantLegalBank = function (_ApiObject) {
  _inherits(RestaurantLegalBank, _ApiObject);

  function RestaurantLegalBank() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantLegalBank);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantLegalBank.__proto__ || Object.getPrototypeOf(RestaurantLegalBank)).call.apply(_ref, [this].concat(args))), _this), _this.iban = '', _this.bic = '', _this.transferFrequency = 'DAILY', _this.identityDocument = '', _this.feeFixed = 0, _this.feeVariable = 0, _this.feeVatPercentage = 0.0, _this.pspRestaurantId = null, _this.acquirerWalletId = null, _this.acquirerBankAccountId = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * String
   * See constants/TransferFrequency
   */


  // the amount in euros taken on each payment


  // the percent taken on each payment


  return RestaurantLegalBank;
}(_ApiObject3.default);

exports.default = RestaurantLegalBank;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/RestaurantLegalRepresentative.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _Address = __webpack_require__("./sdk/scripts/entities/Address.js");

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantLegalRepresentative = function (_ApiObject) {
  _inherits(RestaurantLegalRepresentative, _ApiObject);

  function RestaurantLegalRepresentative() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantLegalRepresentative);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantLegalRepresentative.__proto__ || Object.getPrototypeOf(RestaurantLegalRepresentative)).call.apply(_ref, [this].concat(args))), _this), _this.firstName = '', _this.lastName = '', _this.birthday = 0, _this.nationality = '', _this.countryOfResidence = '', _this.email = '', _this.address = new _Address2.default(), _this.identityDocument = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantLegalRepresentative, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.address = new _Address2.default();
      this.address.fromJson(data.address);
    }
  }]);

  return RestaurantLegalRepresentative;
}(_ApiObject3.default);

exports.default = RestaurantLegalRepresentative;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/RestaurantMultipart.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _OpeningHours = __webpack_require__("./sdk/scripts/entities/OpeningHours.js");

var _OpeningHours2 = _interopRequireDefault(_OpeningHours);

var _RestaurantColors = __webpack_require__("./sdk/scripts/entities/RestaurantColors.js");

var _RestaurantColors2 = _interopRequireDefault(_RestaurantColors);

var _Address = __webpack_require__("./sdk/scripts/entities/Address.js");

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Simple entity to update parts of a restaurant.
 */
var RestaurantMultipart = function (_ApiObject) {
  _inherits(RestaurantMultipart, _ApiObject);

  function RestaurantMultipart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantMultipart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantMultipart.__proto__ || Object.getPrototypeOf(RestaurantMultipart)).call.apply(_ref, [this].concat(args))), _this), _this.name = null, _this.webSitePub = null, _this.externalId = null, _this.desc = null, _this.tag = null, _this.facebookPub = null, _this.twitterPub = null, _this.phonePub = null, _this.emailPub = null, _this.openingHours = null, _this.colors = null, _this.address = null, _this.timeZone = null, _this.password = null, _this.passwordVerification = null, _this.pos = null, _this.posUrl = null, _this.posId = null, _this.posMenuId = null, _this.posCustomerId = null, _this.posCommentId = null, _this.posCredentials = null, _this.posEncryptionKey = null, _this.geoPt = null, _this.serviceType = null, _this.features = null, _this.valided = null, _this.allowTips = null, _this.coverPicture = null, _this.coverPictureFullSize = null, _this.logo = null, _this.menuPdf = null, _this.menuPicture = null, _this.legal = null, _this.legalBankIdentityDocument = null, _this.legalShareholderDeclarationFile = null, _this.legalStatuteFile = null, _this.legalRegistrationProofFile = null, _this.legalRepresentativeIdentityDocument = null, _this.proofOfIncome = null, _this.acquirer = null, _this.psp = null, _this.pspSettings = null, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // -- otherParameters

  // -- files

  /**
   * Must be a png file.
   * @param coverPicture
   */


  /**
   * Must be a png file.
   * @param coverPicture
   */


  /**
   * Must be a png file.
   * @param coverPicture
   */


  // -- bank


  _createClass(RestaurantMultipart, [{
    key: 'getOtherParameters',


    // -- get data for request

    value: function getOtherParameters() {
      var otherParameters = {};

      if (!_lodash2.default.isNil(this.name)) {
        otherParameters.name = this.name;
      }

      if (!_lodash2.default.isNil(this.externalId)) {
        otherParameters.externalId = this.externalId;
      }

      if (!_lodash2.default.isNil(this.webSitePub)) {
        otherParameters.webSitePub = this.webSitePub;
      }

      if (!_lodash2.default.isNil(this.desc)) {
        otherParameters.desc = this.desc;
      }

      if (!_lodash2.default.isNil(this.tag)) {
        otherParameters.tag = this.tag;
      }

      if (!_lodash2.default.isNil(this.facebookPub)) {
        otherParameters.facebookPub = this.facebookPub;
      }

      if (!_lodash2.default.isNil(this.twitterPub)) {
        otherParameters.twitterPub = this.twitterPub;
      }

      if (!_lodash2.default.isNil(this.phonePub)) {
        otherParameters.phonePub = this.phonePub;
      }

      if (!_lodash2.default.isNil(this.emailPub)) {
        otherParameters.emailPub = this.emailPub;
      }

      if (!_lodash2.default.isNil(this.address)) {
        otherParameters.address = this.address;
      }

      if (!_lodash2.default.isNil(this.timeZone)) {
        otherParameters.timeZone = this.timeZone;
      }

      if (!_lodash2.default.isNil(this.locale)) {
        otherParameters.locale = this.locale;
      }

      if (!_lodash2.default.isEmpty(this.password)) {
        otherParameters.password = this.password;
      }

      if (!_lodash2.default.isEmpty(this.password) && !_lodash2.default.isEmpty(this.passwordVerification)) {
        otherParameters.passwordVerification = this.passwordVerification;
      }

      if (!_lodash2.default.isNil(this.openingHours)) {
        otherParameters.openingHours = this.openingHours;
      }

      if (!_lodash2.default.isNil(this.colors)) {
        otherParameters.colors = this.colors;
      }

      if (!_lodash2.default.isNil(this.pos)) {
        otherParameters.pos = this.pos;
      }

      if (!_lodash2.default.isNil(this.posId)) {
        otherParameters.posId = this.posId;
      }

      if (!_lodash2.default.isNil(this.posUrl)) {
        otherParameters.posUrl = this.posUrl;
      }

      if (!_lodash2.default.isNil(this.posMenuId)) {
        otherParameters.posMenuId = this.posMenuId;
      }

      if (!_lodash2.default.isNil(this.posCustomerId)) {
        otherParameters.posCustomerId = this.posCustomerId;
      }

      if (!_lodash2.default.isNil(this.posCommentId)) {
        otherParameters.posCommentId = this.posCommentId;
      }

      if (!_lodash2.default.isNil(this.posPriceLevelId)) {
        otherParameters.posPriceLevelId = this.posPriceLevelId;
      }

      if (!_lodash2.default.isNil(this.posUseQsrOrderNumber)) {
        otherParameters.posUseQsrOrderNumber = this.posUseQsrOrderNumber;
      }

      if (!_lodash2.default.isNil(this.posSendArticleLineNum)) {
        otherParameters.posSendArticleLineNum = this.posSendArticleLineNum;
      }

      if (!_lodash2.default.isNil(this.posTipArticleId)) {
        otherParameters.posTipArticleId = this.posTipArticleId;
      }

      if (!_lodash2.default.isNil(this.posCredentials)) {
        otherParameters.posCredentials = this.posCredentials;
      }

      if (!_lodash2.default.isNil(this.posEncryptionKey)) {
        otherParameters.posEncryptionKey = this.posEncryptionKey;
      }

      if (!_lodash2.default.isNil(this.legal)) {
        otherParameters.legal = this.legal;
      }

      if (!_lodash2.default.isNil(this.allowTips)) {
        otherParameters.allowTips = this.allowTips;
      }

      if (!_lodash2.default.isNil(this.serviceType)) {
        otherParameters.serviceType = this.serviceType;
      }

      if (!_lodash2.default.isNil(this.features)) {
        otherParameters.features = this.features;
      }

      if (!_lodash2.default.isNil(this.status)) {
        otherParameters.status = this.status;
      }

      if (!_lodash2.default.isNil(this.geoPt)) {
        otherParameters.geoPt = this.geoPt;
      }

      if (!_lodash2.default.isNil(this.psp)) {
        otherParameters.psp = this.psp;
      }

      if (!_lodash2.default.isNil(this.acquirer)) {
        otherParameters.acquirer = this.acquirer;
      }

      if (!_lodash2.default.isNil(this.pspSettings)) {
        otherParameters.pspSettings = this.pspSettings;
      }

      return otherParameters;
    }
  }, {
    key: 'getData',
    value: function getData() {
      var data = {};

      var otherParameters = this.getOtherParameters();

      if (!_lodash2.default.isEmpty(otherParameters)) {
        data.otherParameters = JSON.stringify(otherParameters);
      }

      return data;
    }
  }, {
    key: 'getFiles',
    value: function getFiles() {
      var filesData = {};

      if (!_lodash2.default.isNull(this.coverPicture)) {
        /**
         * with content-type “image/png” and containing the cropped image for the mobile app to display
         * @type {null}
         */
        filesData.picture = this.coverPicture;
      }

      if (!_lodash2.default.isNull(this.coverPictureFullSize)) {
        /**
         *  with content-type “image/png” or “image/jpg” and containing the original full size
         *  (non-cropped) version of the picture image
         * @type {null}
         */
        filesData.pictureFullSize = this.coverPictureFullSize;
      }

      if (!_lodash2.default.isNull(this.logo)) {
        /**
         *  with content-type “image/png” and containing the logo of the restaurant
         * @type {null}
         */
        filesData.logo = this.logo;
      }

      if (!_lodash2.default.isNil(this.menuPdf)) {
        filesData.menuPdf = this.menuPdf;
      }

      if (!_lodash2.default.isNil(this.menuPicture)) {
        filesData.menuPicture = this.menuPicture;
      }

      // -- legal
      if (!_lodash2.default.isNull(this.legalStatuteFile)) {
        /**
         * with content-type “application/pdf” and containing the statute document of the legal business
         * @type {null}
         */
        filesData['legal.statute'] = this.legalStatuteFile;
      }

      if (!_lodash2.default.isNull(this.legalRegistrationProofFile)) {
        /**
         * with content-type “application/pdf” and containing the proof of registration for
         * the legal business (k-bis)
         * @type {null}
         */
        filesData['legal.registrationProof'] = this.legalRegistrationProofFile;
      }

      if (!_lodash2.default.isNull(this.legalShareholderDeclarationFile)) {
        /**
         *
         * @type {null}
         */
        filesData['legal.shareholderDeclaration'] = this.legalShareholderDeclarationFile;
      }

      // -- legal representative

      if (!_lodash2.default.isNull(this.legalRepresentativeIdentityDocument)) {
        /**
         * with content-type “application/pdf” and containing a copy of the identity card or passport
         * of the legal representative of the legal business
         * @type {null}
         */
        filesData['legal.representative.identityDocument'] = this.legalRepresentativeIdentityDocument;
      }

      // -- legal bank

      if (!_lodash2.default.isNull(this.legalBankIdentityDocument)) {
        /**
         * with content-type “application/pdf” and containing a copy of the bank identity of the legal
         * business (the document must match the IBAN, BIC and Business Legal Name informations).
         * There are no verifications though.
         */
        filesData['legal.bank.identityDocument'] = this.legalBankIdentityDocument;
      }

      if (!_lodash2.default.isNull(this.proofOfIncome)) {
        filesData['legal.PROOF_OF_INCOME'] = this.proofOfIncome;
      }

      return filesData;
    }
  }]);

  return RestaurantMultipart;
}(_ApiObject3.default);

exports.default = RestaurantMultipart;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/RestaurantsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _GeolocUtils = __webpack_require__("./sdk/scripts/utils/GeolocUtils.js");

var _GeolocUtils2 = _interopRequireDefault(_GeolocUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _GeoPt = __webpack_require__("./sdk/scripts/entities/GeoPt.js");

var _GeoPt2 = _interopRequireDefault(_GeoPt);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantsList = function (_ApiObject) {
  _inherits(RestaurantsList, _ApiObject);

  function RestaurantsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantsList.__proto__ || Object.getPrototypeOf(RestaurantsList)).call.apply(_ref, [this].concat(args))), _this), _this.restaurants = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(RestaurantsList.prototype.__proto__ || Object.getPrototypeOf(RestaurantsList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize restaurants
      this.restaurants = [];

      // -- handle the case were the api responds a json with the array directly.
      var dataRestaurants = [];
      if (!_lodash2.default.isUndefined(data.restaurants)) {
        dataRestaurants = data.restaurants;
      } else {
        dataRestaurants = data;
      }

      _lodash2.default.each(dataRestaurants, function (restaurantData) {
        var restaurant = new _Restaurant2.default();
        restaurant.fromJson(restaurantData);
        _this2.restaurants.push(restaurant);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      var found = _lodash2.default.find(this.restaurants, function (restaurant) {
        return restaurant.id === idToFind;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }, {
    key: 'count',
    value: function count() {
      return this.restaurants.length;
    }
  }, {
    key: 'getWithOrderModeAvailable',
    value: function getWithOrderModeAvailable(orderMode) {
      var restaurants = [];

      _lodash2.default.each(this.restaurants, function (restaurant) {
        if (!_lodash2.default.isNil(restaurant.orderSettings)) {
          if (restaurant.haveFeatureOrder() && restaurant.orderSettings.isEnabledForMode(orderMode)) {
            restaurants.push(restaurant);
          }
        }
      });

      return restaurants;
    }
  }, {
    key: 'getWithAtLeastOneOrderModeAvailable',
    value: function getWithAtLeastOneOrderModeAvailable() {
      var restaurants = [];

      _lodash2.default.each(this.restaurants, function (restaurant) {
        if (!_lodash2.default.isNil(restaurant.orderSettings)) {
          if (restaurant.haveFeatureOrder()) {
            var delivery = restaurant.orderSettings.isDeliveryEnabled();
            var onSite = restaurant.orderSettings.isOnSiteEnabled();
            var takeAway = restaurant.orderSettings.isDeliveryEnabled();

            if (delivery || onSite || takeAway) {
              restaurants.push(restaurant);
            }
          }
        }
      });

      return restaurants;
    }
  }, {
    key: 'sortByLocation',
    value: function sortByLocation(location) {
      this.restaurants = _lodash2.default.sortBy(this.restaurants, function (restaurant) {
        return _GeolocUtils2.default.getDistanceBetweenPoints(location, restaurant.geoPt);
      });
    }
  }]);

  return RestaurantsList;
}(_ApiObject3.default);

exports.default = RestaurantsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Review.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _Check = __webpack_require__("./sdk/scripts/entities/Check.js");

var _Check2 = _interopRequireDefault(_Check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- entities


var Review = function (_ApiObject) {
  _inherits(Review, _ApiObject);

  function Review() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Review);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Review.__proto__ || Object.getPrototypeOf(Review)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.restaurantId = '', _this.comment = '', _this.userId = '', _this.rate = 0, _this.checkId = '', _this.paymentId = '', _this.reasons = [], _this.comment = '', _this.creationDate = 0, _this.userName = '', _this.check = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Is deserialized, we populate him. See ApiReview #getReviewsSummary
   */


  _createClass(Review, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.creationDate = Math.floor(this.creationDate / 1000);
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return _DateUtils2.default.fromSecondsTimestampToString(this.creationDate, format);
    }
  }, {
    key: 'getFormattedHour',
    value: function getFormattedHour() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HH:mm';

      return _DateUtils2.default.fromSecondsTimestampToString(this.creationDate, format);
    }
  }, {
    key: 'getFormattedReasons',
    value: function getFormattedReasons() {
      var formattedReasons = [];
      var reasonsValues = _ApiConstants2.default.Review.REASONS;

      _lodash2.default.each(this.reasons, function (reasonKey) {
        var reasonValue = reasonsValues[reasonKey];

        if (!_lodash2.default.isUndefined(reasonValue)) {
          formattedReasons.push(reasonValue);
        } else {
          // TODO: send a message to the dev to handle this.
          console.error('reason key not found', reasonKey);
          formattedReasons.push(reasonKey);
        }
      });

      return formattedReasons;
    }
  }, {
    key: 'havePayment',
    value: function havePayment() {
      return !_lodash2.default.isNull(this.paymentId) && !_lodash2.default.isNaN(this.paymentId);
    }
  }]);

  return Review;
}(_ApiObject3.default);

exports.default = Review;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/ReviewsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Review = __webpack_require__("./sdk/scripts/entities/Review.js");

var _Review2 = _interopRequireDefault(_Review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReviewsList = function (_ApiObject) {
  _inherits(ReviewsList, _ApiObject);

  function ReviewsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewsList.__proto__ || Object.getPrototypeOf(ReviewsList)).call.apply(_ref, [this].concat(args))), _this), _this.reviews = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(ReviewsList.prototype.__proto__ || Object.getPrototypeOf(ReviewsList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize reviews
      this.reviews = [];

      // -- handle the case were the api responds a json with the array directly.
      var dataReviews = [];
      if (!_lodash2.default.isUndefined(data.reviews)) {
        dataReviews = data.reviews;
      } else {
        dataReviews = data;
      }

      _lodash2.default.each(dataReviews, function (reviewData) {
        var review = new _Review2.default();
        review.fromJson(reviewData);
        _this2.reviews.push(review);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      var found = _lodash2.default.find(this.reviews, function (review) {
        return review.id === idToFind;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }, {
    key: 'findByPaymentId',
    value: function findByPaymentId(idToFind) {
      var found = _lodash2.default.find(this.reviews, function (review) {
        return review.paymentId === idToFind;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }, {
    key: 'count',
    value: function count() {
      return this.reviews.length;
    }
  }]);

  return ReviewsList;
}(_ApiObject3.default);

exports.default = ReviewsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/ReviewsSummary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _Review = __webpack_require__("./sdk/scripts/entities/Review.js");

var _Review2 = _interopRequireDefault(_Review);

var _ReviewsList = __webpack_require__("./sdk/scripts/entities/ReviewsList.js");

var _ReviewsList2 = _interopRequireDefault(_ReviewsList);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReviewsSummary = function (_ApiObject) {
  _inherits(ReviewsSummary, _ApiObject);

  function ReviewsSummary() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewsSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewsSummary.__proto__ || Object.getPrototypeOf(ReviewsSummary)).call.apply(_ref, [this].concat(args))), _this), _this.timelapse = new _Timelapse2.default(), _this.reviewsList = new _ReviewsList2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewsSummary, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(ReviewsSummary.prototype.__proto__ || Object.getPrototypeOf(ReviewsSummary.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize timelapse
      this.timelapse = new _Timelapse2.default();
      this.timelapse.setFromTime(data.fromTime / 1000);
      this.timelapse.setToTime(data.toTime / 1000);

      // -- deserialize reviews list
      this.reviewsList = new _ReviewsList2.default();
      this.reviewsList.fromJson(data); // TODO: change for data.reviews
    }
  }, {
    key: 'getStarDistributionForGraph',
    value: function getStarDistributionForGraph() {
      var starDistribution = this.getStarDistribution();
      var totalOfVotes = this.reviewsList.reviews.length;

      // empty array, there is max 5 stars
      var data = [{ label: '1/5', value: 0 }, { label: '2/5', value: 0 }, { label: '3/5', value: 0 }, { label: '4/5', value: 0 }, { label: '5/5', value: 0 }];

      _lodash2.default.each(this.reviewsList.reviews, function (review) {
        var nbVotes = starDistribution[review.rate - 1];
        data[review.rate - 1].value = nbVotes / totalOfVotes * 100;
      });

      return data;
    }
  }, {
    key: 'getStarDistribution',
    value: function getStarDistribution() {
      // empty array, there is max 5 stars
      var data = [0, 0, 0, 0, 0];

      _lodash2.default.each(this.reviewsList.reviews, function (review) {
        data[review.rate - 1] += 1;
      });

      return data;
    }
  }, {
    key: 'getAverageRate',
    value: function getAverageRate() {
      var total = 0;
      _lodash2.default.each(this.reviewsList.reviews, function (review) {
        total += review.rate;
      });

      return Math.floor(total / this.reviewsList.reviews.length);
    }
  }]);

  return ReviewsSummary;
}(_ApiObject3.default);

exports.default = ReviewsSummary;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/Timelapse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Timelapse = function (_ApiObject) {
  _inherits(Timelapse, _ApiObject);

  function Timelapse() {
    _classCallCheck(this, Timelapse);

    var _this = _possibleConstructorReturn(this, (Timelapse.__proto__ || Object.getPrototypeOf(Timelapse)).call(this));

    _this.setFromTime((0, _moment2.default)().subtract(1, 'months').unix()); // 1 months before now
    _this.setToTime((0, _moment2.default)().unix());
    return _this;
  }

  /**
   * Default fromTime / toTime value to indicate an non init timestamp.
   * @type {number}
   */


  _createClass(Timelapse, [{
    key: 'setFromTime',
    value: function setFromTime(givenValue) {
      var newValue = parseInt(givenValue, 10);
      if (newValue.toString().length > 11) {
        console.error('time set to ms', newValue);
      }
      // we set the new value as a timestamp in seconds.
      this._fromTime = newValue;
    }
  }, {
    key: 'setToTime',
    value: function setToTime(givenValue) {
      var newValue = parseInt(givenValue, 10);
      if (newValue.toString().length > 11) {
        console.error('time set to ms', newValue);
      }
      // we set the new value as a timestamp in seconds.
      this._toTime = newValue;
    }
  }, {
    key: 'getFromTime',
    value: function getFromTime() {
      return this._fromTime;
    }
  }, {
    key: 'getToTime',
    value: function getToTime() {
      return this._toTime;
    }
  }, {
    key: 'getFromTimeAsDate',
    value: function getFromTimeAsDate() {
      return (0, _moment2.default)(this.getFromTime(), 'X'); // 'X' -> Unix timestamp
    }
  }, {
    key: 'getToTimeAsDate',
    value: function getToTimeAsDate() {
      return (0, _moment2.default)(this.getToTime(), 'X'); // 'X' -> Unix timestamp
    }

    // -- milliseconds timestamp

  }, {
    key: 'getFromTimeAsMilliseconds',
    value: function getFromTimeAsMilliseconds() {
      //    return this.getFromTimeAsDate().valueOf();
      return this.getFromTimeAsDate().valueOf();
    }
  }, {
    key: 'getToTimeAsMilliseconds',
    value: function getToTimeAsMilliseconds() {
      return this.getToTimeAsDate().valueOf();
    }

    // -- seconds timestamp

  }, {
    key: 'getFromTimeAsSeconds',
    value: function getFromTimeAsSeconds() {
      return this.getFromTimeAsDate().unix();
    }
  }, {
    key: 'getToTimeAsSeconds',
    value: function getToTimeAsSeconds() {
      //    return this.getToTimeAsDate().valueOf();
      return this.getToTimeAsDate().unix();
    }

    // -- format

  }, {
    key: 'getFromTimeAsFormattedDate',
    value: function getFromTimeAsFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return this.getFromTimeAsDate().format(format);
    }
  }, {
    key: 'getToTimeAsFormattedDate',
    value: function getToTimeAsFormattedDate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD/MM/Y';

      return this.getToTimeAsDate().format(format);
    }

    // -- utils

  }, {
    key: 'isSameDay',
    value: function isSameDay() {
      var diff = this.getFromTimeAsDate().diff(this.getToTimeAsDate(), 'days');
      return diff === 0;
    }
  }]);

  return Timelapse;
}(_ApiObject3.default);

Timelapse.DEFAULT_VALUE = -1;
exports.default = Timelapse;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingDayRoomSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

var _BookingSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSettings.js");

var _BookingSettings2 = _interopRequireDefault(_BookingSettings);

var _BookingSlotCapacitySettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSlotCapacitySettings.js");

var _BookingSlotCapacitySettings2 = _interopRequireDefault(_BookingSlotCapacitySettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- constants


// -- entities


/**
 * Define the settings for the booking on a day.
 * It defines the capacities and the opening and closing hour.
 */
var BookingDayRoomSettings = function (_ApiObject) {
  _inherits(BookingDayRoomSettings, _ApiObject);

  function BookingDayRoomSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingDayRoomSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingDayRoomSettings.__proto__ || Object.getPrototypeOf(BookingDayRoomSettings)).call.apply(_ref, [this].concat(args))), _this), _this.roomId = '', _this.capacity = 0, _this.rules = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BookingDayRoomSettings, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.rules = [];
      _lodash2.default.each(data.rules, function (ruleData) {
        var rule = new _BookingSlotCapacitySettings2.default();
        rule.fromJson(ruleData);
        _this2.rules.push(rule);
      });
    }
  }, {
    key: 'isValid',
    value: function isValid(bookingSettings, openingHour, closingHour) {
      var _this3 = this;

      if (this.capacity > bookingSettings.maximumCapacity) {
        console.log('BookingDaySettings is invalid (capacity) with the room settings', this);
        return false; // quit loop
      }

      var res = true;
      _lodash2.default.each(this.rules, function (slotSetting) {
        if (slotSetting.capacity > bookingSettings.maximumCapacity) {
          res = false;
          console.log('BookingDaySettings is invalid (capacity) with the room settings', _this3);
          return false; // quit loop
        }

        if (slotSetting.hour < openingHour || slotSetting.hour > closingHour) {
          res = false;
          console.log('BookingDaySettings is invalid (hour) with the room settings', _this3);
          return false; // quit loop
        }
      });

      return res;
    }

    // -- rules accessor.

  }, {
    key: 'getCapacityForHour',
    value: function getCapacityForHour(hour) {
      var res = this.capacity;
      _lodash2.default.each(this.rules, function (rule) {
        if (rule.hour === hour) {
          res = rule.capacity;
        }
      });

      return res;
    }
  }, {
    key: 'setHourCapacity',
    value: function setHourCapacity(hour, capacity) {
      this.removeCapacityForHour(hour);

      var rule = new _BookingSlotCapacitySettings2.default();
      rule.hour = hour;
      rule.capacity = capacity;

      this.rules.push(rule);
    }
  }, {
    key: 'removeCapacityForHour',
    value: function removeCapacityForHour(hour) {
      var tmp = [];
      _lodash2.default.each(this.rules, function (rule) {
        if (rule.hour !== hour) {
          tmp.push(rule);
        }
      });

      this.rules = tmp;
    }

    // -- rules

  }, {
    key: 'addBookingSlotCapacitySettings',
    value: function addBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      this.rules.push(bookingSlotCapacitySetting);
    }
  }, {
    key: 'updateBookingSlotCapacitySettings',
    value: function updateBookingSlotCapacitySettings(bookingSlotCapacitySettingToUpdate) {
      this.rules = _ArrayUtils2.default.updateObjectOrAdd(this.rules, bookingSlotCapacitySettingToUpdate, function (bookingSlotCapacitySetting) {
        return bookingSlotCapacitySettingToUpdate.id === bookingSlotCapacitySetting.id;
      });
    }
  }, {
    key: 'deleteBookingSlotCapacitySettings',
    value: function deleteBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      var tmp = [];

      _lodash2.default.each(this.rules, function (rule) {
        if (rule.id !== bookingSlotCapacitySetting.id) {
          tmp.push(rule);
        }
      });

      this.rules = tmp;
    }
  }]);

  return BookingDayRoomSettings;
}(_ApiObject3.default);

exports.default = BookingDayRoomSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingDaySettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _BookingSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSettings.js");

var _BookingSettings2 = _interopRequireDefault(_BookingSettings);

var _BookingDayRoomSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingDayRoomSettings.js");

var _BookingDayRoomSettings2 = _interopRequireDefault(_BookingDayRoomSettings);

var _BookingSettingsRoom = __webpack_require__("./sdk/scripts/entities/booking/BookingSettingsRoom.js");

var _BookingSettingsRoom2 = _interopRequireDefault(_BookingSettingsRoom);

var _BookingSlotCapacitySettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSlotCapacitySettings.js");

var _BookingSlotCapacitySettings2 = _interopRequireDefault(_BookingSlotCapacitySettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- utils


// -- entities


/**
 * Define the settings for the booking on a day.
 * It defines the capacities and the opening and closing hour.
 */
var BookingDaySettings = function (_ApiObject) {
  _inherits(BookingDaySettings, _ApiObject);

  function BookingDaySettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingDaySettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingDaySettings.__proto__ || Object.getPrototypeOf(BookingDaySettings)).call.apply(_ref, [this].concat(args))), _this), _this.state = _BookingConstants2.default.State.CLOSED, _this.openingHour = 0, _this.closingHour = 0, _this.averageDurationOfMeal = _DateUtils2.default.HOUR_AS_MILLISECONDS, _this.roomsSettings = [], _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * Define the state for the day (Can be open or closed).
   * See BookingConstants.State
   */


  /**
   * The opening hour for the day on the part.
   * Time in ms.
   */


  /**
   * The closing hour for the day on the part.
   * Time in ms.
   */


  /**
   *
   */


  /**
   * The key is the id of the room. It contains the settings for the room for the day.
   */


  _createClass(BookingDaySettings, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.roomsSettings = [];
      _lodash2.default.each(data.roomsSettings, function (roomSettingData) {
        var roomSetting = new _BookingDayRoomSettings2.default();
        roomSetting.fromJson(roomSettingData);
        _this2.roomsSettings.push(roomSetting);
      });
    }

    // validation

  }, {
    key: 'isValid',
    value: function isValid(bookingSettings) {
      var _this3 = this;

      if (!(this.openingHour < this.closingHour && _DateUtils2.default.isHour(this.openingHour) && _DateUtils2.default.isHour(this.closingHour))) {
        return false;
      }

      var res = true;
      _lodash2.default.each(this.roomsSettings, function (roomSettings) {
        if (!roomSettings.isValid(bookingSettings, _this3.openingHour, _this3.closingHour)) {
          res = false;
          return false; // quit loop
        }
      });

      return res;
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.state === _BookingConstants2.default.State.OPEN;
    }

    /**
     *
     * @param day The day where we are to set it to the rule.
     * @returns {Array}
     */

  }, {
    key: 'getSpecificsSettingsForRooms',
    value: function getSpecificsSettingsForRooms(day) {
      var list = [];

      _lodash2.default.each(this.roomsSettings, function (roomSetting) {
        _lodash2.default.each(roomSetting.rules, function (rule) {

          var ruleCopy = rule.copy();
          ruleCopy.roomId = roomSetting.roomId;
          ruleCopy.day = day;

          list.push(ruleCopy);
        });
      });

      list.sort(function (a, b) {
        return a.date - b.date;
      });

      return list;
    }
  }, {
    key: 'getRoomSettings',
    value: function getRoomSettings(room) {
      return this.getRoomSettingsWithRoomId(room.id);
    }
  }, {
    key: 'getRoomSettingsWithRoomId',
    value: function getRoomSettingsWithRoomId(roomId) {
      var dayRoomSettingsSettings = _lodash2.default.find(this.roomsSettings, function (roomSettings) {
        return roomSettings.roomId === roomId;
      });

      if (_lodash2.default.isUndefined(dayRoomSettingsSettings) || _lodash2.default.isNull(dayRoomSettingsSettings)) {
        dayRoomSettingsSettings = new _BookingDayRoomSettings2.default();
        dayRoomSettingsSettings.roomId = roomId;
      }

      return dayRoomSettingsSettings;
    }
  }, {
    key: 'setRoomSettings',
    value: function setRoomSettings(dayRoomSettingsToSet) {
      var tmp = [];
      var pushed = false;

      _lodash2.default.each(this.roomsSettings, function (dayRoomSettings) {
        if (dayRoomSettings.roomId === dayRoomSettingsToSet.roomId) {
          tmp.push(dayRoomSettingsToSet);
          pushed = true;
        } else {
          tmp.push(dayRoomSettings);
        }
      });

      if (!pushed) {
        tmp.push(dayRoomSettingsToSet);
      }

      this.roomsSettings = tmp;
    }
  }, {
    key: 'addBookingSlotCapacitySettings',
    value: function addBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      var room = this.getRoomSettingsWithRoomId(bookingSlotCapacitySetting.roomId);
      room.addBookingSlotCapacitySettings(bookingSlotCapacitySetting);
      this.setRoomSettings(room);
    }
  }, {
    key: 'updateBookingSlotCapacitySettings',
    value: function updateBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      var room = this.getRoomSettingsWithRoomId(bookingSlotCapacitySetting.roomId);
      room.updateBookingSlotCapacitySettings(bookingSlotCapacitySetting);
      this.setRoomSettings(room);
    }
  }, {
    key: 'deleteBookingSlotCapacitySettings',
    value: function deleteBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      var room = this.getRoomSettingsWithRoomId(bookingSlotCapacitySetting.roomId);
      room.deleteBookingSlotCapacitySettings(bookingSlotCapacitySetting);
      this.setRoomSettings(room);
    }

    /**
     * Returns the capacity of all the rooms combined.
     * @param day
     */

  }, {
    key: 'getTotalCapacity',
    value: function getTotalCapacity() {
      var total = 0;
      _lodash2.default.each(this.roomsSettings, function (roomSetting) {
        total += roomSetting.capacity;
      });

      return total;
    }
  }]);

  return BookingDaySettings;
}(_ApiObject3.default);

exports.default = BookingDaySettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingNotificationSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


var BookingNotificationSettings = function (_ApiObject) {
  _inherits(BookingNotificationSettings, _ApiObject);

  function BookingNotificationSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingNotificationSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingNotificationSettings.__proto__ || Object.getPrototypeOf(BookingNotificationSettings)).call.apply(_ref, [this].concat(args))), _this), _this.emails = [], _this.phones = [], _this.phoneEnabled = false, _this.emailEnabled = false, _this.type = _BookingConstants2.default.NotificationType.FOR_ALL, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BookingNotificationSettings, [{
    key: 'isDisabled',
    value: function isDisabled() {
      return !this.phoneEnabled && !this.emailEnabled;
    }
  }]);

  return BookingNotificationSettings;
}(_ApiObject3.default);

exports.default = BookingNotificationSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _BookingUtils = __webpack_require__("./sdk/scripts/utils/BookingUtils.js");

var _BookingUtils2 = _interopRequireDefault(_BookingUtils);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _Types = __webpack_require__("./sdk/scripts/utils/Types.js");

var _Types2 = _interopRequireDefault(_Types);

var _BookingNotificationSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingNotificationSettings.js");

var _BookingNotificationSettings2 = _interopRequireDefault(_BookingNotificationSettings);

var _BookingSettingsPeriod = __webpack_require__("./sdk/scripts/entities/booking/BookingSettingsPeriod.js");

var _BookingSettingsPeriod2 = _interopRequireDefault(_BookingSettingsPeriod);

var _BookingSettingsRoom = __webpack_require__("./sdk/scripts/entities/booking/BookingSettingsRoom.js");

var _BookingSettingsRoom2 = _interopRequireDefault(_BookingSettingsRoom);

var _BookingSettingsSpecific = __webpack_require__("./sdk/scripts/entities/booking/BookingSettingsSpecific.js");

var _BookingSettingsSpecific2 = _interopRequireDefault(_BookingSettingsSpecific);

var _BookingSettingsSalesContact = __webpack_require__("./sdk/scripts/entities/booking/BookingSettingsSalesContact.js");

var _BookingSettingsSalesContact2 = _interopRequireDefault(_BookingSettingsSalesContact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- constants


// -- entities


var BookingSettings = function (_ApiObject) {
  _inherits(BookingSettings, _ApiObject);

  function BookingSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingSettings.__proto__ || Object.getPrototypeOf(BookingSettings)).call.apply(_ref, [this].concat(args))), _this), _this.maxNumberOfGuestsForAutomaticValidation = 0, _this.maxNumberOfGuestsForBooking = 100, _this.maxTimeAhead = 0, _this.timeBeforeNoShow = 0, _this.maxTimeAheadFromNow = 0, _this.minTimeAhead = 0, _this.periods = [], _this.rooms = [], _this.notificationSettings = new _BookingNotificationSettings2.default(), _this.maximumCapacity = 0, _this.slotInterval = 0, _this.salesContact = new _BookingSettingsSalesContact2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Number of guests to automatically validate the new booking.
   */


  /**
  * Define the maximum number of guests allowed to book. If the user wants more guests, he will
  * have to contact the group.
  * The value 0 means that there is no limitation.
  * Have to be superior to the maxNumberOfGuestsForAutomaticValidation value (or 0)
  * We throw an error if a booking guest number is > to this value. We don't throw the error if
  * the booking is made via the restaurant BO.
  */


  /**
   * Maximum time ahead to create a new booking.
   */


  /**
   * Maximum time ahead to create a new booking. Read-only value from the API.
   */


  /**
   * Minimum time ahead to create a new booking.
   */


  /**
   * Time after the beginning of the booking to consider a booking as no show if the booking is
   * still set to NOT_ARRIVED.
   * Timestamp in ms.
   * This feature is disabled.
   */
  //		private Date timeBeforeNoShow                        = 0;

  /**
   * Contains the maximum capacity of the restaurant. We use it to verify that the custom
   * capacities set on the settings are not too high. They must not be higher than this value.
   */


  /**
   * The interval between each slots of reservation.
   * Can be 15 or 30 minutes.
   */


  /**
   * The time (mostly in hours) where the reminder have to be send, before the booking date.
   */


  /**
   * The minimum time between now and the booking date to create a reminder.
   */


  _createClass(BookingSettings, [{
    key: 'postJsonAssignation',


    // --

    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.periods = [];
      _lodash2.default.each(data.periods, function (periodData) {
        var period = new _BookingSettingsPeriod2.default();
        period.fromJson(periodData);

        _this2.periods.push(period);
      });

      this.rooms = [];
      _lodash2.default.each(data.rooms, function (roomData) {
        var room = new _BookingSettingsRoom2.default();
        room.fromJson(roomData);

        _this2.rooms.push(room);
      });

      this.notificationSettings = new _BookingNotificationSettings2.default();
      this.notificationSettings.fromJson(data.notificationSettings);
    }

    // -- utils

  }, {
    key: 'isAhead',
    value: function isAhead() {
      // TODO.
    }
  }, {
    key: 'getReminderTimeGapDate',
    value: function getReminderTimeGapDate() {
      return _DateUtils2.default.fromMsTimestamp(this.reminderTimeGap);
    }
  }, {
    key: 'getTimeForReminderBeforeBookingDate',
    value: function getTimeForReminderBeforeBookingDate() {
      return _DateUtils2.default.fromMsTimestamp(this.timeForReminderBeforeBooking);
    }

    // -- format

  }, {
    key: 'getFormattedMaxTimeAhead',
    value: function getFormattedMaxTimeAhead() {
      return this.maxTimeAhead / 60 / 60 / 24 / 1000 + ' jours';
    }

    // -- rooms

  }, {
    key: 'findRoomByName',
    value: function findRoomByName(name) {
      var found = _lodash2.default.find(this.rooms, function (room) {
        return room.name === name;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }, {
    key: 'addRoom',
    value: function addRoom(roomToAdd) {
      this.rooms.push(roomToAdd);
    }
  }, {
    key: 'updateRoom',
    value: function updateRoom(roomToUpdate) {
      _ArrayUtils2.default.updateObjectOrAdd(this.rooms, roomToUpdate, function (room) {
        return room.id === roomToUpdate.id;
      });
    }
  }, {
    key: 'deleteRoom',
    value: function deleteRoom(roomToDelete) {
      this.rooms = _lodash2.default.filter(this.rooms, function (room) {
        return room.id !== roomToDelete.id;
      });

      this.specifics = _lodash2.default.filter(this.specifics, function (specific) {
        return specific.roomId !== roomToDelete.id;
      });

      // -- TODO: remove on periods -> each day -> roomsSettings
    }

    // -- periods

  }, {
    key: 'getPeriodSettings',
    value: function getPeriodSettings(periodId) {
      var found = _lodash2.default.find(this.periods, function (period) {
        return period.period === periodId;
      });

      return _lodash2.default.isUndefined(found) ? null : found;
    }
  }, {
    key: 'addPeriodSettings',
    value: function addPeriodSettings(periodToAdd) {
      this.setPeriodSettings(periodToAdd);
    }
  }, {
    key: 'setPeriodSettings',
    value: function setPeriodSettings(periodToSet) {
      var tmp = [];

      _lodash2.default.each(this.periods, function (period) {
        if (period.period !== periodToSet.period) {
          tmp.push(period);
        }
      });

      tmp.push(periodToSet);

      // -- sort periods. We use the period enum number to sort (0: morning -> to night)
      tmp.sort(function (a, b) {
        return a.period - b.period;
      });

      this.periods = tmp;
    }
  }, {
    key: 'deletePeriodSettings',
    value: function deletePeriodSettings(periodSettingsToDelete) {
      this.periods = _lodash2.default.filter(this.periods, function (periodSettings) {
        return periodSettings.period !== periodSettingsToDelete.period;
      });

      this.specifics = _lodash2.default.filter(this.specifics, function (specific) {
        return specific.period !== periodSettingsToDelete.period;
      });
    }

    // -- slots

  }, {
    key: 'getSlotsAvailableForDayOnPeriod',
    value: function getSlotsAvailableForDayOnPeriod(day, period) {
      var daySettings = this.getPeriodSettings(period).getSettingsForDay(day);

      if (_lodash2.default.isNull(daySettings)) {
        return [];
      }

      return _BookingUtils2.default.generateSlotsForInterval(daySettings.openingHour, daySettings.closingHour, this.slotInterval);
    }
  }, {
    key: 'getDayWithSlotsOnPeriod',
    value: function getDayWithSlotsOnPeriod(period) {
      return this.getPeriodSettings(period).getDayWithSlots();
    }

    // -- is valid ?

  }, {
    key: 'isValid',
    value: function isValid() {
      var _this3 = this;

      if (this.maxTimeAhead === 0) {
        console.log('BookingSettings is invalid (maxTime or minTime)');
        return false;
      }

      if (_lodash2.default.isEmpty(this.rooms)) {
        return false;
      }

      if (_lodash2.default.isEmpty(this.periods)) {
        return false;
      }

      var res = true;
      _lodash2.default.each(this.periods, function (period) {
        if (!period.isValid(_this3)) {
          res = false;
          return false; // quit the loop
        }
      });

      return res;
    }
  }, {
    key: 'getPeriodsSettingsForDate',
    value: function getPeriodsSettingsForDate(date) {
      if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== 'object') {
        date = _DateUtils2.default.fromMsTimestamp(date);
      }

      var periods = [];
      var day = date.weekday();

      _lodash2.default.each(this.periods, function (period) {
        if (period.isEnableForDay(day)) {
          periods.push(period);
        }
      });

      return periods;
    }

    /**
     * This method should be use with BookingSettingsSpecificsList#periodIsEnableForDate.
     * @param  {[type]} period: number [description]
     * @param  {[type]} date          [description]
     * @return {[type]}               [description]
     */

  }, {
    key: 'periodIsEnableForDate',
    value: function periodIsEnableForDate(period, date) {
      if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== 'object') {
        date = _DateUtils2.default.fromMsTimestamp(date);
      }

      var periodSettings = this.getPeriodSettings(period);

      if (!periodSettings.isEnableForDay(date.weekday())) {
        return false;
      }

      return true;
    }
  }]);

  return BookingSettings;
}(_ApiObject3.default);

exports.default = BookingSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingSettingsPeriod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _BookingUtils = __webpack_require__("./sdk/scripts/utils/BookingUtils.js");

var _BookingUtils2 = _interopRequireDefault(_BookingUtils);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

var _BookingSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSettings.js");

var _BookingSettings2 = _interopRequireDefault(_BookingSettings);

var _BookingDaySettings = __webpack_require__("./sdk/scripts/entities/booking/BookingDaySettings.js");

var _BookingDaySettings2 = _interopRequireDefault(_BookingDaySettings);

var _BookingSettingsRoom = __webpack_require__("./sdk/scripts/entities/booking/BookingSettingsRoom.js");

var _BookingSettingsRoom2 = _interopRequireDefault(_BookingSettingsRoom);

var _BookingDayRoomSettings = __webpack_require__("./sdk/scripts/entities/booking/BookingDayRoomSettings.js");

var _BookingDayRoomSettings2 = _interopRequireDefault(_BookingDayRoomSettings);

var _BookingSlotCapacitySettings = __webpack_require__("./sdk/scripts/entities/booking/BookingSlotCapacitySettings.js");

var _BookingSlotCapacitySettings2 = _interopRequireDefault(_BookingSlotCapacitySettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- constants


// -- entities


var BookingSettingsPeriod = function (_ApiObject) {
  _inherits(BookingSettingsPeriod, _ApiObject);

  function BookingSettingsPeriod() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingSettingsPeriod);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingSettingsPeriod.__proto__ || Object.getPrototypeOf(BookingSettingsPeriod)).call.apply(_ref, [this].concat(args))), _this), _this.period = 0, _this.averageDurationOfMeal = _DateUtils2.default.HOUR_AS_MILLISECONDS, _this.monday = new _BookingDaySettings2.default(), _this.tuesday = new _BookingDaySettings2.default(), _this.wednesday = new _BookingDaySettings2.default(), _this.thursday = new _BookingDaySettings2.default(), _this.friday = new _BookingDaySettings2.default(), _this.saturday = new _BookingDaySettings2.default(), _this.sunday = new _BookingDaySettings2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  // BookingConstants.BookingPeriod


  /**
   * The average duration of the meal for the period.
   * In milliseconds
   * @type {number}
   */


  _createClass(BookingSettingsPeriod, [{
    key: 'postJsonAssignation',


    // -- serialization
    value: function postJsonAssignation(data) {
      this.monday = new _BookingDaySettings2.default();
      this.monday.fromJson(data.monday);

      this.tuesday = new _BookingDaySettings2.default();
      this.tuesday.fromJson(data.tuesday);

      this.wednesday = new _BookingDaySettings2.default();
      this.wednesday.fromJson(data.wednesday);

      this.thursday = new _BookingDaySettings2.default();
      this.thursday.fromJson(data.thursday);

      this.friday = new _BookingDaySettings2.default();
      this.friday.fromJson(data.friday);

      this.saturday = new _BookingDaySettings2.default();
      this.saturday.fromJson(data.saturday);

      this.sunday = new _BookingDaySettings2.default();
      this.sunday.fromJson(data.sunday);
    }

    // -- Basic utils

  }, {
    key: 'getSettingsForDay',
    value: function getSettingsForDay(day) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          return this.monday;
        case _ApiConstants2.default.Day.TUESDAY:
          return this.tuesday;
        case _ApiConstants2.default.Day.WEDNESDAY:
          return this.wednesday;
        case _ApiConstants2.default.Day.THURSDAY:
          return this.thursday;
        case _ApiConstants2.default.Day.FRIDAY:
          return this.friday;
        case _ApiConstants2.default.Day.SATURDAY:
          return this.saturday;
        case _ApiConstants2.default.Day.SUNDAY:
          return this.sunday;
        default:
          return null;
      }
    }
  }, {
    key: 'setSettingsForDay',
    value: function setSettingsForDay(bookingDaySettings, day) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          this.monday = bookingDaySettings;
          break;
        case _ApiConstants2.default.Day.TUESDAY:
          this.tuesday = bookingDaySettings;
          break;
        case _ApiConstants2.default.Day.WEDNESDAY:
          this.wednesday = bookingDaySettings;
          break;
        case _ApiConstants2.default.Day.THURSDAY:
          this.thursday = bookingDaySettings;
          break;
        case _ApiConstants2.default.Day.FRIDAY:
          this.friday = bookingDaySettings;
          break;
        case _ApiConstants2.default.Day.SATURDAY:
          this.saturday = bookingDaySettings;
          break;
        case _ApiConstants2.default.Day.SUNDAY:
          this.sunday = bookingDaySettings;
          break;
        default:
          return null;
      }
    }

    // validation

  }, {
    key: 'isValid',
    value: function isValid(bookingSettings) {
      var _this2 = this;

      var res = true;

      if (this.averageDurationOfMeal === 0) {
        console.log('BookingSettingsPeriod is invalid (averageDurationOfMeal)');
        return false;
      }
      _lodash2.default.forIn(_ApiConstants2.default.Day, function (day) {
        var settingsForDay = _this2.getSettingsForDay(day);

        var totalCapacityForDay = _this2.getTotalCapacityForDay(day);
        if (totalCapacityForDay > bookingSettings.maximumCapacity) {
          res = false;
          console.log('BookingSettingsPeriod is invalid capacity:' + totalCapacityForDay + ' max:' + bookingSettings.maximumCapacity);
          return false;
        }

        if (settingsForDay.isOpen() && !settingsForDay.isValid(bookingSettings)) {
          res = false;
          console.log('BookingSettingsPeriod is invalid period:' + _this2.period + ' day: ' + day);
          return false; // quit the loop
        }
      });

      return res;
    }

    // -- Status utils

  }, {
    key: 'getStateForDay',
    value: function getStateForDay(day) {
      var settingsForDay = this.getSettingsForDay(day);

      if (_lodash2.default.isNull(settingsForDay)) {
        console.error('[getStateForDay] Invalid day', day);
        return 0;
      }

      return settingsForDay.state;
    }
  }, {
    key: 'setStateForDay',
    value: function setStateForDay(status, day) {
      var bookingDaySettings = this.getSettingsForDay(day);

      bookingDaySettings.state = status;

      this.setSettingsForDay(bookingDaySettings, day);
    }

    // -- average duration of meal

  }, {
    key: 'getAverageDurationOfMealForDay',
    value: function getAverageDurationOfMealForDay(day) {
      var settingsForDay = this.getSettingsForDay(day);

      if (_lodash2.default.isNull(settingsForDay)) {
        console.error('[getAverageDurationOfMealForDay] Invalid day', day);
        return 0;
      }

      return settingsForDay.averageDurationOfMeal;
    }
  }, {
    key: 'setAverageDurationOfMealForDay',
    value: function setAverageDurationOfMealForDay(averageDuration, day) {
      var bookingDaySettings = this.getSettingsForDay(day);

      bookingDaySettings.averageDurationOfMeal = averageDuration;

      this.setSettingsForDay(bookingDaySettings, day);
    }

    // -- opening hour utils

  }, {
    key: 'getOpeningHourForDay',
    value: function getOpeningHourForDay(day) {
      var settingsForDay = this.getSettingsForDay(day);

      if (_lodash2.default.isNull(settingsForDay)) {
        console.error('[getOpeningHourForDay] Invalid day', day);
        return 0;
      }

      return settingsForDay.openingHour;
    }
  }, {
    key: 'setOpeningHourForDay',
    value: function setOpeningHourForDay(hour, day) {
      console.log('set opening hour', hour);
      var bookingDaySettings = this.getSettingsForDay(day);

      bookingDaySettings.openingHour = hour;

      this.setSettingsForDay(bookingDaySettings, day);
    }

    // -- capacity

  }, {
    key: 'getRoomCapacityForDay',
    value: function getRoomCapacityForDay(room, day) {
      var daySettings = this.getSettingsForDay(day);
      return daySettings.getRoomSettings(room).capacity;
    }

    /**
     * Returns the capacity of all the rooms combined.
     * @param day
     */

  }, {
    key: 'getTotalCapacityForDay',
    value: function getTotalCapacityForDay(day) {
      var daySettings = this.getSettingsForDay(day);
      return daySettings.getTotalCapacity();
    }
  }, {
    key: 'setRoomCapacityForDay',
    value: function setRoomCapacityForDay(room, capacity, day) {
      var daySettings = this.getSettingsForDay(day);

      var roomSettings = daySettings.getRoomSettings(room);
      roomSettings.capacity = capacity;
      roomSettings.roomId = room.id;

      daySettings.setRoomSettings(roomSettings);

      this.setSettingsForDay(daySettings, day);
    }

    // -- closing hour utils

  }, {
    key: 'getClosingHourForDay',
    value: function getClosingHourForDay(day) {
      return this.getSettingsForDay(day).closingHour;
    }
  }, {
    key: 'setClosingHourForDay',
    value: function setClosingHourForDay(hour, day) {
      console.log('set closing hour', hour);
      var bookingDaySettings = this.getSettingsForDay(day);

      bookingDaySettings.closingHour = hour;

      this.setSettingsForDay(bookingDaySettings, day);
    }
  }, {
    key: 'isValidHourForDay',
    value: function isValidHourForDay(hour, day) {
      var opening = this.getOpeningHourForDay(day);
      var closing = this.getClosingHourForDay(day);
      return hour.unix() * 1000 >= opening && hour.unix() * 1000 <= closing;
    }
  }, {
    key: 'isOpeningHoursValidForDay',
    value: function isOpeningHoursValidForDay(day) {
      var opening = this.getOpeningHourForDay(day);
      var closing = this.getClosingHourForDay(day);

      return opening < closing;
    }

    // -- specifics

  }, {
    key: 'getAllBookingSlotCapacitySettings',
    value: function getAllBookingSlotCapacitySettings() {
      var list = [];

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.MONDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.MONDAY));

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.TUESDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.TUESDAY));

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.WEDNESDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.WEDNESDAY));

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.THURSDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.THURSDAY));

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.FRIDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.FRIDAY));

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.SATURDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.SATURDAY));

      list = list.concat(this.getSettingsForDay(_ApiConstants2.default.Day.SUNDAY).getSpecificsSettingsForRooms(_ApiConstants2.default.Day.SUNDAY));

      return list;
    }
  }, {
    key: 'addBookingSlotCapacitySettings',
    value: function addBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      var daySettings = this.getSettingsForDay(bookingSlotCapacitySetting.day);
      daySettings.addBookingSlotCapacitySettings(bookingSlotCapacitySetting);
      this.setSettingsForDay(daySettings, bookingSlotCapacitySetting.day);
    }
  }, {
    key: 'updateBookingSlotCapacitySettings',
    value: function updateBookingSlotCapacitySettings(old, bookingSlotCapacitySetting) {
      // remove the old one that is on another day / room.
      this.deleteBookingSlotCapacitySettings(old);

      var daySettings = this.getSettingsForDay(bookingSlotCapacitySetting.day);
      daySettings.updateBookingSlotCapacitySettings(bookingSlotCapacitySetting);
      this.setSettingsForDay(daySettings, bookingSlotCapacitySetting.day);
    }
  }, {
    key: 'deleteBookingSlotCapacitySettings',
    value: function deleteBookingSlotCapacitySettings(bookingSlotCapacitySetting) {
      var daySettings = this.getSettingsForDay(bookingSlotCapacitySetting.day);
      daySettings.deleteBookingSlotCapacitySettings(bookingSlotCapacitySetting);
      this.setSettingsForDay(daySettings, bookingSlotCapacitySetting.day);
    }

    /**
     * Returns the first day with slots. Used to set the default day of a BookingSlotCapacitySettings
     *
     * @param slotInterval
     * @returns {number}
     */

  }, {
    key: 'getFirstDayWithSlots',
    value: function getFirstDayWithSlots(slotInterval) {
      var _this3 = this;

      var dayResult = null;
      _lodash2.default.forIn(_ApiConstants2.default.Day, function (day) {
        var daySettings = _this3.getSettingsForDay(day);
        if (daySettings.state === _BookingConstants2.default.State.OPEN) {

          var slots = _BookingUtils2.default.generateSlotsForInterval(daySettings.openingHour, daySettings.closingHour, slotInterval);

          if (!_lodash2.default.isEmpty(slots)) {
            dayResult = day;
            return false;
          }
        }
      });

      return dayResult;
    }

    /**
     * Returns true if the period have all its days deactivated.
     *
     * Used because we don't display the specifics if all the days are deactivated
     * @returns {boolean}
     */

  }, {
    key: 'isAllDaysDisabled',
    value: function isAllDaysDisabled() {
      var _this4 = this;

      var res = true;
      _lodash2.default.each(_ApiConstants2.default.Day, function (value) {
        var daySettings = _this4.getSettingsForDay(value);
        if (daySettings.state === _BookingConstants2.default.State.OPEN) {
          res = false;
          return false;
        }
      });
      return res;
    }
  }, {
    key: 'isEnableForDay',
    value: function isEnableForDay(day) {
      var daySettings = this.getSettingsForDay(day);

      if (daySettings.state === _BookingConstants2.default.State.OPEN) {
        return true;
      }

      return false;
    }
  }]);

  return BookingSettingsPeriod;
}(_ApiObject3.default);

exports.default = BookingSettingsPeriod;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingSettingsRoom.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- constants


// -- entities

var BookingSettingsRoom = function (_ApiObject) {
  _inherits(BookingSettingsRoom, _ApiObject);

  function BookingSettingsRoom() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingSettingsRoom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingSettingsRoom.__proto__ || Object.getPrototypeOf(BookingSettingsRoom)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Id of the room. Defined by the front.
   */


  /**
   * The room name. Ex: Patio
   */


  return BookingSettingsRoom;
}(_ApiObject3.default);

exports.default = BookingSettingsRoom;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingSettingsSalesContact.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSettingsSalesContact = function (_ApiObject) {
  _inherits(BookingSettingsSalesContact, _ApiObject);

  function BookingSettingsSalesContact() {
    _classCallCheck(this, BookingSettingsSalesContact);

    return _possibleConstructorReturn(this, (BookingSettingsSalesContact.__proto__ || Object.getPrototypeOf(BookingSettingsSalesContact)).apply(this, arguments));
  }

  return BookingSettingsSalesContact;
}(_ApiObject3.default);

exports.default = BookingSettingsSalesContact;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingSettingsSpecific.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// -- utils


// -- constants


// -- entities


var BookingSettingsSpecific = function (_ApiObject) {
  _inherits(BookingSettingsSpecific, _ApiObject);

  function BookingSettingsSpecific() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingSettingsSpecific);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingSettingsSpecific.__proto__ || Object.getPrototypeOf(BookingSettingsSpecific)).call.apply(_ref, [this].concat(args))), _this), _this.state = _BookingConstants2.default.State.CLOSED, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Set by the front
   */
  // = Utils.generateUID();

  /**
   * The date where the specific takes place.
   */


  /**
   * The period to impact.
   *
   * see BookingConstants.BookingPeriod
   */


  /**
   * The state of the specific.
   *
   * see BookingConstants.State
   */


  _createClass(BookingSettingsSpecific, [{
    key: 'getUniqueIdentifier',
    value: function getUniqueIdentifier() {
      return this.id;
    }
  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {}
  }, {
    key: 'isClosed',
    value: function isClosed() {
      return this.state === _BookingConstants2.default.State.CLOSED;
    }
  }, {
    key: 'isClosedForPeriod',
    value: function isClosedForPeriod(period) {
      return this.isClosed() && this.period === period;
    }
  }, {
    key: 'isImpactingDate',
    value: function isImpactingDate(date) {
      var impactedDate = _DateUtils2.default.fromMsTimestamp(this.date);

      if (_DateUtils2.default.isSameDay(impactedDate, date)) {
        return true;
      }

      return false;
    }
  }]);

  return BookingSettingsSpecific;
}(_ApiObject3.default);

exports.default = BookingSettingsSpecific;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/booking/BookingSlotCapacitySettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Defines a custom capacity for a slot.
 * See BookingDaySettings.
 */
var BookingSlotCapacitySettings = function (_ApiObject) {
  _inherits(BookingSlotCapacitySettings, _ApiObject);

  function BookingSlotCapacitySettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingSlotCapacitySettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingSlotCapacitySettings.__proto__ || Object.getPrototypeOf(BookingSlotCapacitySettings)).call.apply(_ref, [this].concat(args))), _this), _this.id = _Utils2.default.generateUID(), _this.hour = 0, _this.capacity = 0, _this.roomId = null, _this.day = null, _this.date = (0, _moment2.default)().unix(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * This value is front only.
   * @type {null}
   */


  /**
   * Ms timestamp that represents the hour and minute.
   */


  /**
   * The specific capacity for the slot.
   */


  /**
   * This value is front only. Help use to know at which room this setting is attached.
   * @type {null}
   */


  /**
   * This value is front only. Help us to know at which day this setting is attached.
   * @type {null}
   */


  /**
   * This value is front only. Help us to sort in the array.
   * @type {null}
   */


  return BookingSlotCapacitySettings;
}(_ApiObject3.default);

exports.default = BookingSlotCapacitySettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/dashboard/InfoBookingForDate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoBookingForDate = function (_ApiObject) {
  _inherits(InfoBookingForDate, _ApiObject);

  function InfoBookingForDate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InfoBookingForDate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfoBookingForDate.__proto__ || Object.getPrototypeOf(InfoBookingForDate)).call.apply(_ref, [this].concat(args))), _this), _this.date = 0, _this.occupancy = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * The date as ms.
   * @type {number}
   */


  /**
   * Hashmap with
   * - enum Period
   * - number of clients
   */


  _createClass(InfoBookingForDate, [{
    key: 'haveNoBooking',
    value: function haveNoBooking() {
      var res = 0;
      _lodash2.default.forIn(this.occupancy, function (value) {
        res += value;
      });

      return res === 0;
    }
  }]);

  return InfoBookingForDate;
}(_ApiObject3.default);

exports.default = InfoBookingForDate;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/dashboard/RestaurantDashboardInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _RestaurantDashboardInfoBooking = __webpack_require__("./sdk/scripts/entities/dashboard/RestaurantDashboardInfoBooking.js");

var _RestaurantDashboardInfoBooking2 = _interopRequireDefault(_RestaurantDashboardInfoBooking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantDashboardInfo = function (_ApiObject) {
  _inherits(RestaurantDashboardInfo, _ApiObject);

  function RestaurantDashboardInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantDashboardInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantDashboardInfo.__proto__ || Object.getPrototypeOf(RestaurantDashboardInfo)).call.apply(_ref, [this].concat(args))), _this), _this.booking = new _RestaurantDashboardInfoBooking2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantDashboardInfo, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(RestaurantDashboardInfo.prototype.__proto__ || Object.getPrototypeOf(RestaurantDashboardInfo.prototype), 'postJsonAssignation', this).call(this, data);

      this.booking = new _RestaurantDashboardInfoBooking2.default();
      this.booking.fromJson(data.booking);
    }
  }]);

  return RestaurantDashboardInfo;
}(_ApiObject3.default);

exports.default = RestaurantDashboardInfo;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/dashboard/RestaurantDashboardInfoBooking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _InfoBookingForDate = __webpack_require__("./sdk/scripts/entities/dashboard/InfoBookingForDate.js");

var _InfoBookingForDate2 = _interopRequireDefault(_InfoBookingForDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantDashboardInfoBooking = function (_ApiObject) {
  _inherits(RestaurantDashboardInfoBooking, _ApiObject);

  function RestaurantDashboardInfoBooking() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantDashboardInfoBooking);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantDashboardInfoBooking.__proto__ || Object.getPrototypeOf(RestaurantDashboardInfoBooking)).call.apply(_ref, [this].concat(args))), _this), _this.dates = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantDashboardInfoBooking, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(RestaurantDashboardInfoBooking.prototype.__proto__ || Object.getPrototypeOf(RestaurantDashboardInfoBooking.prototype), 'postJsonAssignation', this).call(this, data);

      this.dates = [];
      _lodash2.default.each(data.dates, function (dateInfoData) {
        var infoBookingForDate = new _InfoBookingForDate2.default();
        infoBookingForDate.fromJson(dateInfoData);
        _this2.dates.push(infoBookingForDate);
      });
    }
  }]);

  return RestaurantDashboardInfoBooking;
}(_ApiObject3.default);

exports.default = RestaurantDashboardInfoBooking;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timelapse = exports.ReviewsSummary = exports.ReviewsList = exports.Review = exports.RestaurantMultipart = exports.RestaurantLegalRepresentative = exports.RestaurantLegalBank = exports.RestaurantLegal = exports.RestaurantColors = exports.Restaurant = exports.PayoutList = exports.Payout = exports.PaymentsList = exports.PaymentStatistics = exports.Payment = exports.PayinList = exports.Payin = exports.OpeningHours = exports.OpeningHour = exports.NewsList = exports.News = exports.ClaimsDiscussionsSettings = exports.ChecksList = exports.Check = exports.ApiError = exports.Address = undefined;

var _Address2 = __webpack_require__("./sdk/scripts/entities/Address.js");

var _Address3 = _interopRequireDefault(_Address2);

var _ApiError2 = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError3 = _interopRequireDefault(_ApiError2);

var _Check2 = __webpack_require__("./sdk/scripts/entities/Check.js");

var _Check3 = _interopRequireDefault(_Check2);

var _ChecksList2 = __webpack_require__("./sdk/scripts/entities/ChecksList.js");

var _ChecksList3 = _interopRequireDefault(_ChecksList2);

var _ClaimsDiscussionsSettings2 = __webpack_require__("./sdk/scripts/entities/ClaimsDiscussionsSettings.js");

var _ClaimsDiscussionsSettings3 = _interopRequireDefault(_ClaimsDiscussionsSettings2);

var _News2 = __webpack_require__("./sdk/scripts/entities/News.js");

var _News3 = _interopRequireDefault(_News2);

var _NewsList2 = __webpack_require__("./sdk/scripts/entities/NewsList.js");

var _NewsList3 = _interopRequireDefault(_NewsList2);

var _OpeningHour2 = __webpack_require__("./sdk/scripts/entities/OpeningHour.js");

var _OpeningHour3 = _interopRequireDefault(_OpeningHour2);

var _OpeningHours2 = __webpack_require__("./sdk/scripts/entities/OpeningHours.js");

var _OpeningHours3 = _interopRequireDefault(_OpeningHours2);

var _Payin2 = __webpack_require__("./sdk/scripts/entities/Payin.js");

var _Payin3 = _interopRequireDefault(_Payin2);

var _PayinList2 = __webpack_require__("./sdk/scripts/entities/PayinList.js");

var _PayinList3 = _interopRequireDefault(_PayinList2);

var _Payment2 = __webpack_require__("./sdk/scripts/entities/Payment.js");

var _Payment3 = _interopRequireDefault(_Payment2);

var _PaymentStatistics2 = __webpack_require__("./sdk/scripts/entities/PaymentStatistics.js");

var _PaymentStatistics3 = _interopRequireDefault(_PaymentStatistics2);

var _PaymentsList2 = __webpack_require__("./sdk/scripts/entities/PaymentsList.js");

var _PaymentsList3 = _interopRequireDefault(_PaymentsList2);

var _Payout2 = __webpack_require__("./sdk/scripts/entities/Payout.js");

var _Payout3 = _interopRequireDefault(_Payout2);

var _PayoutList2 = __webpack_require__("./sdk/scripts/entities/PayoutList.js");

var _PayoutList3 = _interopRequireDefault(_PayoutList2);

var _Restaurant2 = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant3 = _interopRequireDefault(_Restaurant2);

var _RestaurantColors2 = __webpack_require__("./sdk/scripts/entities/RestaurantColors.js");

var _RestaurantColors3 = _interopRequireDefault(_RestaurantColors2);

var _RestaurantLegal2 = __webpack_require__("./sdk/scripts/entities/RestaurantLegal.js");

var _RestaurantLegal3 = _interopRequireDefault(_RestaurantLegal2);

var _RestaurantLegalBank2 = __webpack_require__("./sdk/scripts/entities/RestaurantLegalBank.js");

var _RestaurantLegalBank3 = _interopRequireDefault(_RestaurantLegalBank2);

var _RestaurantLegalRepresentative2 = __webpack_require__("./sdk/scripts/entities/RestaurantLegalRepresentative.js");

var _RestaurantLegalRepresentative3 = _interopRequireDefault(_RestaurantLegalRepresentative2);

var _RestaurantMultipart2 = __webpack_require__("./sdk/scripts/entities/RestaurantMultipart.js");

var _RestaurantMultipart3 = _interopRequireDefault(_RestaurantMultipart2);

var _Review2 = __webpack_require__("./sdk/scripts/entities/Review.js");

var _Review3 = _interopRequireDefault(_Review2);

var _ReviewsList2 = __webpack_require__("./sdk/scripts/entities/ReviewsList.js");

var _ReviewsList3 = _interopRequireDefault(_ReviewsList2);

var _ReviewsSummary2 = __webpack_require__("./sdk/scripts/entities/ReviewsSummary.js");

var _ReviewsSummary3 = _interopRequireDefault(_ReviewsSummary2);

var _Timelapse2 = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse3 = _interopRequireDefault(_Timelapse2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Address = _Address3.default;
exports.ApiError = _ApiError3.default;
exports.Check = _Check3.default;
exports.ChecksList = _ChecksList3.default;
exports.ClaimsDiscussionsSettings = _ClaimsDiscussionsSettings3.default;
exports.News = _News3.default;
exports.NewsList = _NewsList3.default;
exports.OpeningHour = _OpeningHour3.default;
exports.OpeningHours = _OpeningHours3.default;
exports.Payin = _Payin3.default;
exports.PayinList = _PayinList3.default;
exports.Payment = _Payment3.default;
exports.PaymentStatistics = _PaymentStatistics3.default;
exports.PaymentsList = _PaymentsList3.default;
exports.Payout = _Payout3.default;
exports.PayoutList = _PayoutList3.default;
exports.Restaurant = _Restaurant3.default;
exports.RestaurantColors = _RestaurantColors3.default;
exports.RestaurantLegal = _RestaurantLegal3.default;
exports.RestaurantLegalBank = _RestaurantLegalBank3.default;
exports.RestaurantLegalRepresentative = _RestaurantLegalRepresentative3.default;
exports.RestaurantMultipart = _RestaurantMultipart3.default;
exports.Review = _Review3.default;
exports.ReviewsList = _ReviewsList3.default;
exports.ReviewsSummary = _ReviewsSummary3.default;
exports.Timelapse = _Timelapse3.default;

/***/ }),

/***/ "./sdk/scripts/entities/map/RestaurantMarkerInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Restaurant = __webpack_require__("./sdk/scripts/entities/Restaurant.js");

var _Restaurant2 = _interopRequireDefault(_Restaurant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RestaurantMarkerInfo = function () {
  function RestaurantMarkerInfo() {
    _classCallCheck(this, RestaurantMarkerInfo);

    this.position = {
      lat: 0,
      lng: 0
    };
    this.defaultAnimation = 2;
    this.showInfo = false;
    this.isSelectable = false;
  }

  /**
   *
   */


  _createClass(RestaurantMarkerInfo, [{
    key: 'fromRestaurant',
    value: function fromRestaurant(restaurant) {
      this.id = restaurant.id;
      this.restaurant = restaurant;

      if (!_lodash2.default.isNil(restaurant.geoPt)) {
        this.position = {
          lat: restaurant.geoPt.latitude,
          lng: restaurant.geoPt.longitude
        };
      }

      return this;
    }
  }]);

  return RestaurantMarkerInfo;
}();

exports.default = RestaurantMarkerInfo;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/AvailabilityDate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AvailabilityDate = function (_ApiObject) {
  _inherits(AvailabilityDate, _ApiObject);

  function AvailabilityDate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityDate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityDate.__proto__ || Object.getPrototypeOf(AvailabilityDate)).call.apply(_ref, [this].concat(args))), _this), _this.fromDate = null, _this.toDate = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvailabilityDate, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(AvailabilityDate.prototype.__proto__ || Object.getPrototypeOf(AvailabilityDate.prototype), 'postJsonAssignation', this).call(this, data);

      this.fromDate = (0, _moment2.default)(data.fromDate);
      this.toDate = (0, _moment2.default)(data.toDate);
    }
  }]);

  return AvailabilityDate;
}(_ApiObject3.default);

exports.default = AvailabilityDate;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/AvailabilityDates.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _each = __webpack_require__("./sdk/node_modules/lodash/each.js");

var _each2 = _interopRequireDefault(_each);

var _isNil = __webpack_require__("./sdk/node_modules/lodash/isNil.js");

var _isNil2 = _interopRequireDefault(_isNil);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _AvailabilityDate = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDate.js");

var _AvailabilityDate2 = _interopRequireDefault(_AvailabilityDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AvailabilityDates = function (_ApiObject) {
  _inherits(AvailabilityDates, _ApiObject);

  function AvailabilityDates() {
    _classCallCheck(this, AvailabilityDates);

    return _possibleConstructorReturn(this, (AvailabilityDates.__proto__ || Object.getPrototypeOf(AvailabilityDates)).apply(this, arguments));
  }

  _createClass(AvailabilityDates, [{
    key: 'add',
    value: function add(fromDate, toDate) {
      this.dates = this.dates || [];
      this.dates.push(new _AvailabilityDate2.default().fromJson({
        fromDate: fromDate,
        toDate: toDate
      }));
    }
  }, {
    key: 'isAvailableForDate',
    value: function isAvailableForDate(date) {
      date = _moment2.default.isMoment(date) ? date : (0, _moment2.default)(date);

      var isAvailable = this.dates.filter(function (availabilityDate) {
        return date.isBetween(availabilityDate.fromDate, availabilityDate.toDate);
      });

      return isAvailable.length;
    }

    /**
     * api expects directly an array of AvailabilityDate
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(AvailabilityDates.prototype.__proto__ || Object.getPrototypeOf(AvailabilityDates.prototype), 'toJSON', this).call(this);

      if (!(0, _isNil2.default)(json['dates'])) {
        return json['dates'].map(function (availabilityDate) {
          return {
            fromDate: availabilityDate.fromDate.valueOf(),
            toDate: availabilityDate.toDate.valueOf()
          };
        });
      }

      return null;
    }
  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(AvailabilityDates.prototype.__proto__ || Object.getPrototypeOf(AvailabilityDates.prototype), 'postJsonAssignation', this).call(this, data);

      this.dates = [];

      (0, _each2.default)(data, function (availabilityDateData) {
        var availabilityDate = new _AvailabilityDate2.default().fromJson(availabilityDateData);
        _this2.dates.push(availabilityDate);
      });
    }
  }]);

  return AvailabilityDates;
}(_ApiObject3.default);

exports.default = AvailabilityDates;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/AvailabilityHour.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AvailabilityHour = function (_ApiObject) {
  _inherits(AvailabilityHour, _ApiObject);

  function AvailabilityHour() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityHour);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityHour.__proto__ || Object.getPrototypeOf(AvailabilityHour)).call.apply(_ref, [this].concat(args))), _this), _this.opening = 0, _this.closing = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvailabilityHour, [{
    key: 'getOpeningHourAsDate',
    value: function getOpeningHourAsDate() {
      return (0, _moment2.default)(this.opening, _DateUtils2.default.MS_FORMAT);
    }
  }, {
    key: 'getClosingHourAsDate',
    value: function getClosingHourAsDate() {
      return (0, _moment2.default)(this.closing, _DateUtils2.default.MS_FORMAT);
    }
  }, {
    key: 'isWholeDay',
    value: function isWholeDay() {
      return this.opening === _DateUtils2.default.BEGIN_DAY_TIEMSTAMP && this.closing === _DateUtils2.default.END_DAY_TIMESTAMP;
    }
  }, {
    key: 'setToWholeDay',
    value: function setToWholeDay() {
      this.opening = _DateUtils2.default.BEGIN_DAY_TIEMSTAMP;
      this.closing = _DateUtils2.default.END_DAY_TIMESTAMP;
    }
  }, {
    key: 'setAvailableOnDay',
    value: function setAvailableOnDay() {
      this.opening = null;
      this.closing = null;
    }

    //
    // format
    //

  }, {
    key: 'getOpeningHour',
    value: function getOpeningHour() {
      return _DateUtils2.default.getHourFromMsHourTimestamp(this.opening);
    }
  }, {
    key: 'getOpeningMinute',
    value: function getOpeningMinute() {
      return _DateUtils2.default.getMinuteFromMsHourTimestamp(this.opening);
    }
  }, {
    key: 'getClosingHour',
    value: function getClosingHour() {
      return _DateUtils2.default.getHourFromMsHourTimestamp(this.closing);
    }
  }, {
    key: 'getClosingMinute',
    value: function getClosingMinute() {
      return _DateUtils2.default.getMinuteFromMsHourTimestamp(this.closing);
    }
  }, {
    key: 'getFormatted',
    value: function getFormatted() {
      return this.getOpeningHourAsFormattedDate() + ' - ' + this.getClosingHourAsFormattedDate();
    }
  }, {
    key: 'formatTwoDigits',
    value: function formatTwoDigits(number) {
      return number > 9 ? '' + number : '0' + number;
    }
  }, {
    key: 'getOpeningHourAsFormattedDate',
    value: function getOpeningHourAsFormattedDate() {
      return _DateUtils2.default.getFormattedHourWithMsHour(this.opening);
    }
  }, {
    key: 'getClosingHourAsFormattedDate',
    value: function getClosingHourAsFormattedDate() {
      return _DateUtils2.default.getFormattedHourWithMsHour(this.closing);
    }
  }, {
    key: 'getInterval',
    value: function getInterval() {
      var minuteInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;

      var hours = [];

      var intervalAsMs = minuteInterval * _DateUtils2.default.MINUTE_AS_MILLISECONDS;

      for (var i = this.opening; i <= this.closing; i += intervalAsMs) {
        hours.push(i);
      }

      return hours;
    }
  }]);

  return AvailabilityHour;
}(_ApiObject3.default);

exports.default = AvailabilityHour;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/AvailabilityHours.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _AvailabilityHour = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour2 = _interopRequireDefault(_AvailabilityHour);

var _AvailabilityHoursForDay = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHoursForDay.js");

var _AvailabilityHoursForDay2 = _interopRequireDefault(_AvailabilityHoursForDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AvailabilityHours = function (_ApiObject) {
  _inherits(AvailabilityHours, _ApiObject);

  function AvailabilityHours() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityHours);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityHours.__proto__ || Object.getPrototypeOf(AvailabilityHours)).call.apply(_ref, [this].concat(args))), _this), _this.monday = new _AvailabilityHoursForDay2.default(), _this.tuesday = new _AvailabilityHoursForDay2.default(), _this.wednesday = new _AvailabilityHoursForDay2.default(), _this.thursday = new _AvailabilityHoursForDay2.default(), _this.friday = new _AvailabilityHoursForDay2.default(), _this.saturday = new _AvailabilityHoursForDay2.default(), _this.sunday = new _AvailabilityHoursForDay2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvailabilityHours, [{
    key: 'getForDay',


    // -- tools
    value: function getForDay(day) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          return this.monday;
        case _ApiConstants2.default.Day.TUESDAY:
          return this.tuesday;
        case _ApiConstants2.default.Day.WEDNESDAY:
          return this.wednesday;
        case _ApiConstants2.default.Day.THURSDAY:
          return this.thursday;
        case _ApiConstants2.default.Day.FRIDAY:
          return this.friday;
        case _ApiConstants2.default.Day.SATURDAY:
          return this.saturday;
        case _ApiConstants2.default.Day.SUNDAY:
          return this.sunday;
        default:
          return new _AvailabilityHoursForDay2.default();
      }
    }
  }, {
    key: 'setForDay',
    value: function setForDay(day, availabilityHoursForDay) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          this.monday = availabilityHoursForDay;
          break;
        case _ApiConstants2.default.Day.TUESDAY:
          this.tuesday = availabilityHoursForDay;
          break;
        case _ApiConstants2.default.Day.WEDNESDAY:
          this.wednesday = availabilityHoursForDay;
          break;
        case _ApiConstants2.default.Day.THURSDAY:
          this.thursday = availabilityHoursForDay;
          break;
        case _ApiConstants2.default.Day.FRIDAY:
          this.friday = availabilityHoursForDay;
          break;
        case _ApiConstants2.default.Day.SATURDAY:
          this.saturday = availabilityHoursForDay;
          break;
        case _ApiConstants2.default.Day.SUNDAY:
          this.sunday = availabilityHoursForDay;
          break;
        default:
      }
    }
  }, {
    key: 'addForDay',
    value: function addForDay(day, availabilityHour) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          this.monday.addHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.TUESDAY:
          this.tuesday.addHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.WEDNESDAY:
          this.wednesday.addHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.THURSDAY:
          this.thursday.addHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.FRIDAY:
          this.friday.addHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.SATURDAY:
          this.saturday.addHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.SUNDAY:
          this.sunday.addHour(availabilityHour);
          break;
        default:
      }
    }
  }, {
    key: 'removeForDay',
    value: function removeForDay(day, availabilityHour) {
      switch (day) {
        case _ApiConstants2.default.Day.MONDAY:
          this.monday.deleteHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.TUESDAY:
          this.tuesday.deleteHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.WEDNESDAY:
          this.wednesday.deleteHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.THURSDAY:
          this.thursday.deleteHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.FRIDAY:
          this.friday.deleteHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.SATURDAY:
          this.saturday.deleteHour(availabilityHour);
          break;
        case _ApiConstants2.default.Day.SUNDAY:
          this.sunday.deleteHour(availabilityHour);
          break;
        default:
      }
    }
  }, {
    key: 'getSuggestAvailabilityHourForDay',
    value: function getSuggestAvailabilityHourForDay(day) {
      var allOpeningsHours = this.getAllOpeningsHours();
      var availabilityHoursForDay = this.getForDay(day).hours;

      var result = {};
      _lodash2.default.each(allOpeningsHours, function (availabilityHour) {
        var key = availabilityHour.opening + '_' + availabilityHour.closing;
        if (_lodash2.default.isUndefined(result[key])) {
          result[key] = {
            availabilityHour: availabilityHour,
            count: 1
          };
        } else {
          result[key].count++;
        }
      });

      // lower count for already used opening hours for this day.
      if (!_lodash2.default.isEmpty(availabilityHoursForDay)) {
        _lodash2.default.each(availabilityHoursForDay, function (availabilityHour) {
          var key = availabilityHour.opening + '_' + availabilityHour.closing;
          result[key].count = -1;
        });
      }

      // find most present
      if (!_lodash2.default.isEmpty(result)) {
        var maxCount = 0;
        var max = !_lodash2.default.isEmpty(availabilityHoursForDay) ? availabilityHoursForDay[0] : allOpeningsHours[0];

        _lodash2.default.forIn(result, function (value) {
          if (value.count > maxCount) {
            maxCount = value.count;
            max = value.availabilityHour;
          }
        });

        // return a copy, not a reference.
        return max.copy();
      }

      return this.getDefaultAvailabilityHour();
    }
  }, {
    key: 'getSuggestAvailabilityHour',
    value: function getSuggestAvailabilityHour() {
      var allOpeningsHours = this.getAllOpeningsHours();

      var result = {};
      _lodash2.default.each(allOpeningsHours, function (availabilityHour) {
        var key = availabilityHour.opening + '_' + availabilityHour.closing;
        if (_lodash2.default.isUndefined(result[key])) {
          result[key] = {
            availabilityHour: availabilityHour,
            count: 1
          };
        } else {
          result[key].count++;
        }
      });

      // find most present
      if (!_lodash2.default.isEmpty(result)) {
        var maxCount = 0;
        var max = new _AvailabilityHour2.default();

        _lodash2.default.forIn(result, function (value) {
          if (value.count > maxCount) {
            maxCount = value.count;
            max = value.availabilityHour;
          }
        });

        // return a copy, not a reference
        return max.copy();
      }

      return this.getDefaultAvailabilityHour();
    }
  }, {
    key: 'getDefaultAvailabilityHour',
    value: function getDefaultAvailabilityHour() {
      var newAvailabilityHour = new _AvailabilityHour2.default();
      newAvailabilityHour.setAvailableOnDay();
      return newAvailabilityHour;
    }
  }, {
    key: 'getAllOpeningsHours',
    value: function getAllOpeningsHours() {
      return _lodash2.default.concat(this.monday.hours, this.tuesday.hours, this.wednesday.hours, this.thursday.hours, this.friday.hours, this.saturday.hours, this.sunday.hours);
    }
  }, {
    key: 'isAvailableForDate',
    value: function isAvailableForDate(date) {
      var dayIndex = _DateUtils2.default.getPmtDayIndex(date);

      var availabilityHoursForDay = this.getForDay(dayIndex);

      return availabilityHoursForDay.isAvailableForDate(date);
    }

    /**
     * Warning: moment.js week start at sunday, not monday
     */

  }, {
    key: 'haveAvailabilityForDay',
    value: function haveAvailabilityForDay(dayIndex) {
      return this.getForDay(dayIndex).haveAvailibility();
    }
  }, {
    key: 'isAvailableForWholeDay',
    value: function isAvailableForWholeDay(dayIndex) {
      return this.getForDay(dayIndex).isAvailableForWholeDay();
    }
  }, {
    key: 'setAvailableForWholeDayForDay',
    value: function setAvailableForWholeDayForDay(dayIndex) {
      var availabilityHoursForDay = this.getForDay(dayIndex);
      availabilityHoursForDay.setAvailableForWholeDay();
      this.setForDay(dayIndex, availabilityHoursForDay);
    }

    // -- serialization

  }, {
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(AvailabilityHours.prototype.__proto__ || Object.getPrototypeOf(AvailabilityHours.prototype), 'postJsonAssignation', this).call(this, data);

      this.monday = new _AvailabilityHoursForDay2.default().fromJson(data.monday);
      this.tuesday = new _AvailabilityHoursForDay2.default().fromJson(data.tuesday);
      this.wednesday = new _AvailabilityHoursForDay2.default().fromJson(data.wednesday);
      this.thursday = new _AvailabilityHoursForDay2.default().fromJson(data.thursday);
      this.friday = new _AvailabilityHoursForDay2.default().fromJson(data.friday);
      this.saturday = new _AvailabilityHoursForDay2.default().fromJson(data.saturday);
      this.sunday = new _AvailabilityHoursForDay2.default().fromJson(data.sunday);
    }
  }]);

  return AvailabilityHours;
}(_ApiObject3.default);

exports.default = AvailabilityHours;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/AvailabilityHoursForDay.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _AvailabilityHour = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour2 = _interopRequireDefault(_AvailabilityHour);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AvailabilityHoursForDay = function (_ApiObject) {
  _inherits(AvailabilityHoursForDay, _ApiObject);

  function AvailabilityHoursForDay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilityHoursForDay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilityHoursForDay.__proto__ || Object.getPrototypeOf(AvailabilityHoursForDay)).call.apply(_ref, [this].concat(args))), _this), _this.hours = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvailabilityHoursForDay, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.hours = [];

      // change to data.hours if api change. See toJSON comment
      _lodash2.default.each(!_lodash2.default.isNil(data.hours) ? data.hours : data, function (availabilityHourData) {
        var availabilityHour = new _AvailabilityHour2.default().fromJson(availabilityHourData);
        _this2.hours.push(availabilityHour);
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      // For now we use a sub object AvailabilityHoursForDay but the api does not have similar object,
      // it expects directly an array of AvailabilityHour.
      var json = _get(AvailabilityHoursForDay.prototype.__proto__ || Object.getPrototypeOf(AvailabilityHoursForDay.prototype), 'toJSON', this).call(this);
      return json['hours'];
    }
  }, {
    key: 'setHours',
    value: function setHours(hours) {
      this.hours = hours;
    }
  }, {
    key: 'addHour',
    value: function addHour(hours) {
      this.hours.push(hours);
    }
  }, {
    key: 'deleteHour',
    value: function deleteHour(toRemove) {
      var res = [];

      res = this.hours.filter(function (availabilityHour) {
        return !_lodash2.default.isEqual(availabilityHour, toRemove);
      });

      this.hours = res;

      if (_lodash2.default.isEmpty(this.hours)) {
        this.setAvailableOnDay();
      }
    }
  }, {
    key: 'resetHours',
    value: function resetHours() {
      this.hours = [];
    }
  }, {
    key: 'haveAvailibility',
    value: function haveAvailibility() {
      return !_lodash2.default.isEmpty(this.hours) || this.isAvailableForWholeDay();
    }
  }, {
    key: 'isAvailableForDate',
    value: function isAvailableForDate(date) {
      var slot = _DateUtils2.default.getTimestampForHourWithDate(date);

      var res = false;
      _lodash2.default.each(this.hours, function (hour) {
        if (hour.opening <= slot && hour.closing >= slot) {
          res = true;
          return false; // quit loop
        }
      });

      return res;
    }
  }, {
    key: 'isAvailableForWholeDay',
    value: function isAvailableForWholeDay() {
      var res = false;

      _lodash2.default.each(this.hours, function (hour) {
        if (hour.isWholeDay()) {
          res = true;
          return false; // quit loop
        }
      });

      return res;
    }
  }, {
    key: 'setAvailableForWholeDay',
    value: function setAvailableForWholeDay() {
      this.hours = [];
      var hour = new _AvailabilityHour2.default();
      hour.setToWholeDay();
      this.hours.push(hour);
    }
  }, {
    key: 'setAvailableOnDay',
    value: function setAvailableOnDay() {
      this.hours = [];
      var hour = new _AvailabilityHour2.default();
      hour.setAvailableOnDay();
      this.hours.push(hour);
    }
  }, {
    key: 'setNotAvailableForWholeDay',
    value: function setNotAvailableForWholeDay() {
      this.hours = [];
    }
  }, {
    key: 'isDisable',
    value: function isDisable() {
      return !this.isAvailableForWholeDay() && _lodash2.default.isEmpty(this.hours);
    }
  }, {
    key: 'isEnable',
    value: function isEnable() {
      return !this.isDisable();
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.setNotAvailableForWholeDay();
      // this.hours = [];
    }
  }]);

  return AvailabilityHoursForDay;
}(_ApiObject3.default);

exports.default = AvailabilityHoursForDay;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/CartModifier.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _AvailabilityHours = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHours.js");

var _AvailabilityHours2 = _interopRequireDefault(_AvailabilityHours);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartModifier = function (_ApiObject) {
  _inherits(CartModifier, _ApiObject);

  function CartModifier() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CartModifier);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CartModifier.__proto__ || Object.getPrototypeOf(CartModifier)).call.apply(_ref, [this].concat(args))), _this), _this.action = {}, _this.id = null, _this.restaurantId = null, _this.name = '', _this.localizedNames = [], _this.tag = '', _this.localizedTags = [], _this.code = null, _this.description = '', _this.localizedDescriptions = [], _this.image = '', _this.enabled = true, _this.archived = false, _this.combinable = false, _this.condition = {
      amountCondition: {
        includeShippingCostInMaxOrderAmount: false,
        includeShippingCostInMinOrderAmount: false,
        maxOrderAmount: 0,
        minOrderAmount: 0
      },
      frontCondition: {
        apiConsumerIds: null,
        platforms: null
      },
      orderModes: null,
      dateCondition: {
        beginningDate: null,
        endDate: null,
        weeklyAvailabilities: null
      },
      itemCondition: null
    }, _this.target = {
      // TODO: remove after V1.
      // for now we only handle SPECIFIC_ITEMS
      type: CartModifier.TargetType.SPECIFIC_ITEMS,
      // type: null,
      items: null
    }, _this.action = {
      // TODO: remove default value after V1?
      type: CartModifier.ActionType.DISCOUNT_PERCENTAGE,
      // type: null,
      value: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CartModifier, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(CartModifier.prototype.__proto__ || Object.getPrototypeOf(CartModifier.prototype), 'postJsonAssignation', this).call(this, data);

      if (!_lodash2.default.isNil(data.condition) && !_lodash2.default.isNil(data.condition.dateCondition) && !_lodash2.default.isNil(data.condition.dateCondition.weeklyAvailabilities)) {
        this.condition.dateCondition.weeklyAvailabilities = new _AvailabilityHours2.default().fromJson(data.condition.dateCondition.weeklyAvailabilities);
      }
    }
  }, {
    key: 'getPrice',
    value: function getPrice(price) {
      return this.action.type === CartModifier.ActionType.DISCOUNT_PERCENTAGE ? parseFloat((price * (100 - this.action.value) / 100).toFixed(2)) : parseFloat((price - this.action.value).toFixed(2));
    }

    // TODO: handle valid per actions type (percent, amount)
    // - hasValue (percent, amount)
    // - hasType
    // - has list of items

  }, {
    key: 'isFormValid',
    value: function isFormValid() {
      return this.validateName() && this.validateTag();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateTag',
    value: function validateTag() {
      if (_lodash2.default.isEmpty(this.localizedTags)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedTags, function (localizedTag) {
        if (!_lodash2.default.isEmpty(localizedTag.text) && localizedTag.text.length <= CartModifier.TAG_LIMIT) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'isAvailable',
    value: function isAvailable(mode, dueDate) {
      return this.isAvailableForMode(mode) && this.isAvailableForDate(dueDate);
    }
  }, {
    key: 'isAvailableForMode',
    value: function isAvailableForMode(mode) {
      return this.condition.orderModes === null || _lodash2.default.indexOf(this.condition.orderModes, mode) !== -1;
    }
  }, {
    key: 'isAvailableForDate',
    value: function isAvailableForDate(date) {
      return (_lodash2.default.isNil(this.condition.dateCondition.weeklyAvailabilities) || this.condition.dateCondition.weeklyAvailabilities.isAvailableForDate(date)) && (!this.hasDefinedDateCondition() || this.isAvailableBetween(date, this.condition.dateCondition.beginningDate, this.condition.dateCondition.endDate));
    }
  }, {
    key: 'hasDefinedDateCondition',
    value: function hasDefinedDateCondition() {
      return !_lodash2.default.isNull(this.condition.dateCondition.beginningDate) && !_lodash2.default.isNull(this.condition.dateCondition.endDate);
    }
  }, {
    key: 'isAvailableBetween',
    value: function isAvailableBetween(date, beginningDate, endDate) {
      return date.isAfter(_DateUtils2.default.fromMsTimestamp(beginningDate)) && date.isBefore(_DateUtils2.default.fromMsTimestamp(endDate));
    }
  }, {
    key: 'hasDefinedWeeklyAvailabilities',
    value: function hasDefinedWeeklyAvailabilities() {
      return !_lodash2.default.isNull(this.condition.dateCondition.weeklyAvailabilities);
    }
  }, {
    key: 'hasDefinedComposition',
    value: function hasDefinedComposition() {
      return !_lodash2.default.isNull(this.condition.itemCondition) && (!_lodash2.default.isNull(this.condition.itemCondition.itemsRequired) || !_lodash2.default.isNull(this.condition.itemCondition.itemsForbidden));
    }
  }, {
    key: 'hasDefinedApiConsumerIds',
    value: function hasDefinedApiConsumerIds() {
      return !_lodash2.default.isNull(this.condition.frontCondition) && !_lodash2.default.isNull(this.condition.frontCondition.apiConsumerIds);
    }
  }, {
    key: 'hasDefinedTargetType',
    value: function hasDefinedTargetType() {
      return !_lodash2.default.isNull(this.target) && !_lodash2.default.isNull(this.target.type);
    }
  }, {
    key: 'hasActionType',
    value: function hasActionType(type) {
      return this.hasDefinedActionType() && this.action.type === type;
    }
  }, {
    key: 'hasDefinedActionType',
    value: function hasDefinedActionType() {
      return !_lodash2.default.isNil(this.action) && !_lodash2.default.isEmpty(this.action.type);
    }
  }, {
    key: 'isFocusOnCheapestItems',
    value: function isFocusOnCheapestItems() {
      return !_lodash2.default.isNil(this.target.focusOnCheapestItems) && this.target.focusOnCheapestItems;
    }
  }, {
    key: 'isOfferingShippingCost',
    value: function isOfferingShippingCost() {
      return this.target.type === CartModifier.TargetType.SHIPPING_COST;
    }
  }, {
    key: 'getItemInformation',
    value: function getItemInformation(mode, dueDate) {
      return {
        id: this.id,
        tag: this.tag,
        description: this.description,
        type: this.action.type,
        priority: this.priority,
        value: this.action.value,
        combinable: this.combinable,
        modes: this.condition.orderModes,
        isHandled: !this.hasDefinedComposition(),
        isAvailable: this.isAvailable(mode, dueDate)
      };
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }, {
    key: 'description',
    set: function set(description) {
      this._description = description;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedDescriptions) || this._description || '';
    }
  }, {
    key: 'tag',
    set: function set(tag) {
      this._tag = tag;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedTags) || this._tag || '';
    }
  }]);

  return CartModifier;
}(_ApiObject3.default);

CartModifier.ActionType = {
  DISCOUNT_PERCENTAGE: 'DISCOUNT_PERCENTAGE',
  DISCOUNT_AMOUNT: 'DISCOUNT_AMOUNT'
};
CartModifier.TargetType = {
  SPECIFIC_ITEMS: 'SPECIFIC_ITEMS',
  // ALL_ITEMS_EXCEPT: 'ALL_ITEMS_EXCEPT',
  // SHIPPING_COST: 'SHIPPING_COST',
  TOTAL: 'TOTAL'
};
CartModifier.TAG_LIMIT = 20;
exports.default = CartModifier;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/CategoryItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryItem = function (_ApiObject) {
  _inherits(CategoryItem, _ApiObject);

  function CategoryItem() {
    _classCallCheck(this, CategoryItem);

    return _possibleConstructorReturn(this, (CategoryItem.__proto__ || Object.getPrototypeOf(CategoryItem)).apply(this, arguments));
  }

  _createClass(CategoryItem, [{
    key: 'setTypeForObject',
    value: function setTypeForObject(item) {
      this.type = item instanceof _Menu2.default ? CategoryItem.Type.MENU : CategoryItem.Type.PRODUCT;
    }

    /**
     *
     * @type {{CATEGORY: number, MENU: number, PRODUCT: number}}
     */

  }, {
    key: 'isCategory',
    value: function isCategory() {
      return this.type === CategoryItem.Type.CATEGORY;
    }
  }, {
    key: 'isMenu',
    value: function isMenu() {
      return this.type === CategoryItem.Type.MENU;
    }
  }, {
    key: 'isProduct',
    value: function isProduct() {
      return this.type === CategoryItem.Type.PRODUCT;
    }
  }, {
    key: 'fromCategory',
    value: function fromCategory(category) {
      this.id = category.id;
      this.type = CategoryItem.Type.CATEGORY;
    }
  }]);

  return CategoryItem;
}(_ApiObject3.default);

CategoryItem.Type = {
  CATEGORY: 0,

  MENU: 1,

  PRODUCT: 2
};
exports.default = CategoryItem;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/ItemSuggestion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _SuggestedItem = __webpack_require__("./sdk/scripts/entities/menu/SuggestedItem.js");

var _SuggestedItem2 = _interopRequireDefault(_SuggestedItem);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemSuggestion = function (_ApiObject) {
  _inherits(ItemSuggestion, _ApiObject);

  function ItemSuggestion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemSuggestion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemSuggestion.__proto__ || Object.getPrototypeOf(ItemSuggestion)).call.apply(_ref, [this].concat(args))), _this), _this.linkedItems = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemSuggestion, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.linkedItems = [];
      _lodash2.default.each(data.linkedItems, function (itemData) {
        var item = new _SuggestedItem2.default();
        item.fromJson(itemData);
        _this2.linkedItems.push(item);
      });

      this.item = new _CategoryItem2.default();
      this.item.fromJson(data.item);
    }
  }, {
    key: 'setItem',
    value: function setItem(categoryItem) {
      this.item = categoryItem;
    }
  }, {
    key: 'addLinkedItem',
    value: function addLinkedItem(categoryItem) {
      this.linkedItems.push(categoryItem);
    }
  }, {
    key: 'removeLinkedItemWithId',
    value: function removeLinkedItemWithId(id) {
      this.linkedItems = _lodash2.default.remove(this.linkedItems, function (item) {
        return item.id !== id;
      });
    }
  }, {
    key: 'addLinkedProduct',
    value: function addLinkedProduct(product) {
      var item = new _CategoryItem2.default();
      item.id = product.id;
      item.type = _CategoryItem2.default.Type.PRODUCT;
      this.linkedItems.push(item);
    }
  }, {
    key: 'addLinkedMenu',
    value: function addLinkedMenu(menu) {
      var item = new _CategoryItem2.default();
      item.id = menu.id;
      item.type = _CategoryItem2.default.Type.MENU;
      this.linkedItems.push(item);
    }
  }, {
    key: 'getLinkedItemWithId',
    value: function getLinkedItemWithId(id) {
      return _ArrayUtils2.default.find(this.linkedItems, { id: id });
    }
  }, {
    key: 'id',
    get: function get() {
      if (_lodash2.default.isNil(this.item)) {
        return '';
      }
      return this.item.id;
    }
  }]);

  return ItemSuggestion;
}(_ApiObject3.default);

exports.default = ItemSuggestion;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/Menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _ProductPrices = __webpack_require__("./sdk/scripts/entities/menu/ProductPrices.js");

var _ProductPrices2 = _interopRequireDefault(_ProductPrices);

var _MenuPart = __webpack_require__("./sdk/scripts/entities/menu/MenuPart.js");

var _MenuPart2 = _interopRequireDefault(_MenuPart);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _AvailabilityDates = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDates.js");

var _AvailabilityDates2 = _interopRequireDefault(_AvailabilityDates);

var _AvailabilityHours = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHours.js");

var _AvailabilityHours2 = _interopRequireDefault(_AvailabilityHours);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Menu = function (_ApiObject) {
  _inherits(Menu, _ApiObject);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.type = _CategoryItem2.default.Type.MENU, _this.id = '', _this.name = '', _this.localizedNames = [], _this.description = '', _this.localizedDescriptions = [], _this.image = '', _this.parts = [], _this.prices = new _ProductPrices2.default(), _this.availabilityDates = null, _this.availabilityHours = null, _this.cartModifiers = [], _this.unavailable = false, _this.allergen = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  // a front only var set by RestaurantMenu when filtered to indicate that the menu should be
  // display as unavailable


  _createClass(Menu, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.prices = new _ProductPrices2.default();
      this.prices.fromJson(data.prices);

      if (!_lodash2.default.isNil(data.availabilityDates)) {
        this.availabilityDates = new _AvailabilityDates2.default().fromJson(data.availabilityDates);
      }

      if (!_lodash2.default.isNil(data.availabilityHours)) {
        this.availabilityHours = new _AvailabilityHours2.default().fromJson(data.availabilityHours);
      }

      this.parts = [];
      _lodash2.default.each(data.parts, function (partData) {
        var part = new _MenuPart2.default();
        part.fromJson(partData);
        _this2.parts.push(part);
      });
    }

    // ---- utils

  }, {
    key: 'isActivatedForMode',
    value: function isActivatedForMode(mode) {
      return this.prices.getMode(mode).available;
    }
  }, {
    key: 'isAvailableForMode',
    value: function isAvailableForMode(mode, products) {
      // TODO: verify that at least one product by part is `isAvailableForMode`.
      return this.isActivatedForMode(mode);
    }
  }, {
    key: 'toggleActivationForMode',
    value: function toggleActivationForMode(mode) {
      this.prices.getMode(mode).available = !this.prices.getMode(mode).available;
    }
  }, {
    key: 'getPriceForMode',
    value: function getPriceForMode(mode) {
      return this.prices.getMode(mode).priceIncludingTax;
    }
  }, {
    key: 'getCartModifiersPrice',
    value: function getCartModifiersPrice(mode) {
      var price = this.getPriceForMode(mode);

      if (this.cartModifiers.length > 0) {
        var priceTemp = 0,
            firstCartModifier = true;

        this.cartModifiers.map(function (cartModifier) {
          if (priceTemp === 0) {
            priceTemp = price;
          }

          if (cartModifier.isHandled && cartModifier.isAvailable) {
            if (cartModifier.type === _CartModifier2.default.ActionType.DISCOUNT_PERCENTAGE) {
              priceTemp = parseFloat((priceTemp * (100 - cartModifier.value) / 100).toFixed(2));
            } else {
              priceTemp = parseFloat((priceTemp - cartModifier.value).toFixed(2));
            }
          }

          if (!cartModifier.combinable && firstCartModifier) {
            firstCartModifier = false;
            return false;
          }
        });

        price = priceTemp;
      }

      return Math.max(0, price);
    }
  }, {
    key: 'haveProduct',
    value: function haveProduct(productId) {
      var res = false;
      _lodash2.default.forEach(this.parts, function (part) {
        var found = _lodash2.default.find(part.products, function (partProduct) {
          return productId === partProduct.id;
        });

        if (!_lodash2.default.isUndefined(found)) {
          res = true;
          return; // quit the loop
        }
      });

      return res;
    }
  }, {
    key: 'getPartWithId',
    value: function getPartWithId(partId) {
      return _ArrayUtils2.default.find(this.parts, { id: partId });
    }

    /**
     *
     */

  }, {
    key: 'haveStock',
    value: function haveStock() {
      return this.stock !== 0;
    }
  }, {
    key: 'haveStockAndIsActivated',
    value: function haveStockAndIsActivated() {
      return this.haveStock() && this.isActivatedForOneMode();
    }
  }, {
    key: 'isActivatedForDate',
    value: function isActivatedForDate(date) {
      return _lodash2.default.isNil(this.availabilityDates) || this.availabilityDates.isAvailableForDate(date);
    }
  }, {
    key: 'isAvailableForDate',
    value: function isAvailableForDate(date) {
      var available = _lodash2.default.isNil(this.availabilityHours) || this.availabilityHours.isAvailableForDate(date);

      if (!available) {
        console.log('menu unavailable', this);
      }

      return available;
    }

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return this.validateName() && this.validateDescription() && this.validatePrices() && this.validateParts();
    }
  }, {
    key: 'isValidManagedByPos',
    value: function isValidManagedByPos() {
      return this.validateName() && this.validateDescription();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateDescription',
    value: function validateDescription() {
      var isValid = true;

      _lodash2.default.forEach(this.localizedDescriptions, function (localizedDescription) {
        if (!_lodash2.default.isEmpty(localizedDescription.text) && localizedDescription.text.length < 5) {
          isValid = false;
        }
      });

      return isValid;
    }
  }, {
    key: 'validatePrices',
    value: function validatePrices() {
      return this.prices.isValid();
    }
  }, {
    key: 'validateParts',
    value: function validateParts() {
      return !_lodash2.default.isEmpty(this.parts) && this.parts[0].isValid();
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = Menu.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateDescription()) {
        errors.description = validationErrors.description;
      }

      if (!this.validatePrices()) {
        errors.price = validationErrors.price;
      }

      if (!this.validateParts()) {
        errors.parts = validationErrors.parts;
      }

      return errors;
    }

    //
    //
    //

  }, {
    key: 'updatePart',
    value: function updatePart(partToUpdate) {
      this.parts = _ArrayUtils2.default.updateObject(this.parts, partToUpdate, {
        id: partToUpdate.id
      });
    }
  }, {
    key: 'addPart',
    value: function addPart(partToAdd) {
      this.parts.push(partToAdd);
    }
  }, {
    key: 'deletePart',
    value: function deletePart(partToDelete) {
      this.parts = _ArrayUtils2.default.deleteObject(this.parts, { id: partToDelete.id });
    }
  }, {
    key: 'movePartUp',
    value: function movePartUp(menuPartToUp) {
      this.parts = _ArrayUtils2.default.moveUpObjectOnArray(this.parts, menuPartToUp, {
        id: menuPartToUp.id
      });
    }
  }, {
    key: 'movePartDown',
    value: function movePartDown(menuPartToDown) {
      this.parts = _ArrayUtils2.default.moveDownObjectOnArray(this.parts, menuPartToDown, {
        id: menuPartToDown.id
      });
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }, {
    key: 'description',
    set: function set(description) {
      this._description = description;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedDescriptions) || this._description || '';
    }
  }]);

  return Menu;
}(_ApiObject3.default);

Menu.validationErrors = {
  name: 'Le nom ne peut être vide',
  description: 'La description doit être vide ou contenir plus de 5 caractères',
  price: 'Un prix et/ou une taxe sont valides',
  parts: 'Il faut au moins une partie valide'
};
exports.default = Menu;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/MenuPart.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _MenuPartCategory = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory2 = _interopRequireDefault(_MenuPartCategory);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuPart = function (_ApiObject) {
  _inherits(MenuPart, _ApiObject);

  function MenuPart() {
    _classCallCheck(this, MenuPart);

    var _this = _possibleConstructorReturn(this, (MenuPart.__proto__ || Object.getPrototypeOf(MenuPart)).call(this));

    _this.id = '';
    _this.name = '';
    _this.localizedNames = [];
    _this.max = 1;
    _this.min = 1;
    _this.additionalPrice = 0;
    _this.baseAdditionalPrice = 0;
    _this.products = [];
    _this.categories = [];

    _this.createDefaultCategory();
    return _this;
  }

  _createClass(MenuPart, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      // TODO: postJsonAssignation
      this.products = [];
      _lodash2.default.each(data.products, function (partProductData) {
        var partProduct = new _MenuPartProduct2.default();
        partProduct.fromJson(partProductData);
        _this2.products.push(partProduct);
      });

      this.categories = [];
      _lodash2.default.each(data.categories, function (categoryData) {
        var category = new _MenuPartCategory2.default();
        category.fromJson(categoryData);
        _this2.categories.push(category);
      });
    }
  }, {
    key: 'createDefaultCategory',
    value: function createDefaultCategory() {
      var category = new _MenuPartCategory2.default();
      category.id = _MenuPartCategory2.default.ROOT_CATEGORY_ID;
      category.name = _MenuPartCategory2.default.ROOT_NAME;
      category.items = [];
      this.categories.push(category);
    }

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return this.validateName() && this.validateMin() && this.validateMax() && this.validateProducts() && this.validateAdditionalPrice();
    }
  }, {
    key: 'isValidToCreate',
    value: function isValidToCreate() {
      return this.validateName() && this.validateMin() && this.validateMax() &&
      // && this.validateProducts()
      this.validateAdditionalPrice();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateMin',
    value: function validateMin() {
      return !_lodash2.default.isNil(this.min) && !_lodash2.default.isNaN(this.min) && this.min >= 0 && this.min <= this.max;
    }
  }, {
    key: 'validateMax',
    value: function validateMax() {
      return !_lodash2.default.isNil(this.max) && !_lodash2.default.isNaN(this.max) && this.max >= 0 && this.max >= this.min;
    }
  }, {
    key: 'validateProducts',
    value: function validateProducts() {
      return !_lodash2.default.isEmpty(this.products);
    }
  }, {
    key: 'validateAdditionalPrice',
    value: function validateAdditionalPrice() {
      return this.additionalPrice >= 0;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = MenuPart.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateMin()) {
        errors.min = validationErrors.min;
      }

      if (!this.validateMax()) {
        errors.max = validationErrors.max;
      }

      if (!this.validateProducts()) {
        errors.products = validationErrors.products;
      }

      if (!this.validateAdditionalPrice()) {
        errors.additionalPrice = validationErrors.additionalPrice;
      }

      return errors;
    }

    //
    //
    //

  }, {
    key: 'getRootCategory',
    value: function getRootCategory() {
      return _ArrayUtils2.default.find(this.categories, function (category) {
        return category.id === _MenuPartCategory2.default.ROOT_CATEGORY_ID;
      });
    }
  }, {
    key: 'getCategoryWithId',
    value: function getCategoryWithId(id) {
      return _ArrayUtils2.default.find(this.categories, function (category) {
        return category.id === id;
      });
    }
  }, {
    key: 'addCategory',
    value: function addCategory(category) {
      this.categories.push(category);
    }
  }, {
    key: 'cleanCategories',
    value: function cleanCategories() {
      var _this3 = this;

      this.categories = this.categories.map(function (category) {
        category.items = category.items.map(function (item) {
          if (item.isCategory()) {
            return item;
          }

          // is product, exists on part?
          if (_ArrayUtils2.default.exists(_this3.products, function (p) {
            return p.id === item.id;
          })) {
            // exists. keep it.
            return item;
          }

          return null;
        }).filter(function (a) {
          return a !== null;
        });
        return category;
      });
    }
  }, {
    key: 'updateCategory',
    value: function updateCategory(categoryItem) {
      this.categories = _ArrayUtils2.default.updateObject(this.categories, categoryItem, function (category) {
        return category.id === categoryItem.id;
      });
    }
  }, {
    key: 'deleteCategory',
    value: function deleteCategory(categoryItem) {
      this.categories = _ArrayUtils2.default.deleteObject(this.categories, function (category) {
        return category.id === categoryItem.id;
      });
    }

    //
    //
    //

  }, {
    key: 'findPartProductById',
    value: function findPartProductById(id) {
      return _ArrayUtils2.default.find(this.products, { id: id });
    }
  }, {
    key: 'havePartProductById',
    value: function havePartProductById(id) {
      return _ArrayUtils2.default.exists(this.products, { id: id });
    }

    //
    //
    //

  }, {
    key: 'addProducts',
    value: function addProducts(products) {
      var _this4 = this;

      var partProducts = [];

      // create new MenuPartProduct array
      _lodash2.default.each(products, function (product) {
        var partProduct = new _MenuPartProduct2.default();
        partProduct.id = product.id;

        // search for already set MenuPartProduct for the Product.
        // we don't want to erase the additionalPrice.
        var found = _ArrayUtils2.default.find(_this4.products, { id: product.id });
        if (!_lodash2.default.isNull(found)) {
          partProduct.additionalPrice = found.additionalPrice;
        }

        partProducts.push(partProduct);

        // product is added, we add it to the root category
        if (_lodash2.default.isNull(found)) {
          _this4.getRootCategory().addProduct(partProduct);
        }
      });

      this.products = partProducts;
      this.cleanCategories();
    }
  }, {
    key: 'addProduct',
    value: function addProduct(product) {
      this.products.push(product);
      this.getRootCategory().addProduct(product);
    }
  }, {
    key: 'deleteProduct',
    value: function deleteProduct(productToDelete) {
      this.products = _ArrayUtils2.default.removeObject(this.products, {
        id: productToDelete.id
      });

      this.categories = this.categories.map(function (category) {
        category.removeProductWithId(productToDelete.id);
        return category;
      });
    }
  }, {
    key: 'updateProduct',
    value: function updateProduct(productToUpdate) {
      this.products = _ArrayUtils2.default.updateObject(this.products, productToUpdate, {
        id: productToUpdate.id
      });
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }]);

  return MenuPart;
}(_ApiObject3.default);

MenuPart.validationErrors = {
  name: 'Le nom ne peut être vide',
  min: 'Le minimum doit être positif et inférieur ou égal au maximum',
  max: 'Le maximum doit être positif et supérieur ou égal au minimum',
  products: 'Il faut au moins un produit',
  additionalPrice: 'Le prix additionnel doit être positif'
};
exports.default = MenuPart;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/MenuPartCategory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _MenuPartItem = __webpack_require__("./sdk/scripts/entities/menu/MenuPartItem.js");

var _MenuPartItem2 = _interopRequireDefault(_MenuPartItem);

var _MenuPartItemType = __webpack_require__("./sdk/scripts/entities/menu/MenuPartItemType.js");

var _MenuPartItemType2 = _interopRequireDefault(_MenuPartItemType);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuPartCategory = function (_ApiObject) {
  _inherits(MenuPartCategory, _ApiObject);

  function MenuPartCategory() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartCategory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartCategory.__proto__ || Object.getPrototypeOf(MenuPartCategory)).call.apply(_ref, [this].concat(args))), _this), _this.localizedNames = [], _this.items = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartCategory, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.items = [];
      _lodash2.default.each(data.items, function (partItemData) {
        var item = new _MenuPartItem2.default();
        item.fromJson(partItemData);
        _this2.items.push(item);
      });
    }
  }, {
    key: 'isRootCategory',
    value: function isRootCategory() {
      return this.id === MenuPartCategory.ROOT_CATEGORY_ID;
    }
  }, {
    key: 'addProduct',
    value: function addProduct(product) {
      this.items.push(_MenuPartItem2.default.fromProduct(product));
    }
  }, {
    key: 'removeProductWithId',
    value: function removeProductWithId(id) {
      this.items = _ArrayUtils2.default.removeObject(this.items, function (item) {
        return item.id === id && item.isProduct();
      });
    }
  }, {
    key: 'addCategory',
    value: function addCategory(category) {
      this.items.push(_MenuPartItem2.default.fromCategory(category));
    }
  }, {
    key: 'removeCategoryWithId',
    value: function removeCategoryWithId(id) {
      this.items = _ArrayUtils2.default.removeObject(this.items, function (item) {
        return item.id === id && item.isCategory();
      });
    }
  }, {
    key: 'getItemsWithoutEmptyCategories',
    value: function getItemsWithoutEmptyCategories(menuPart) {
      return this.items.filter(function (item) {
        return item.type === _MenuPartItemType2.default.CATEGORY ? menuPart.getCategoryWithId(item.id).getItemsWithoutEmptyCategories(menuPart).length : true;
      });
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }]);

  return MenuPartCategory;
}(_ApiObject3.default);

MenuPartCategory.ROOT_CATEGORY_ID = 'root';
MenuPartCategory.ROOT_NAME = 'root';
exports.default = MenuPartCategory;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/MenuPartItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _MenuPartItemType = __webpack_require__("./sdk/scripts/entities/menu/MenuPartItemType.js");

var _MenuPartItemType2 = _interopRequireDefault(_MenuPartItemType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuPartItem = function (_ApiObject) {
  _inherits(MenuPartItem, _ApiObject);

  function MenuPartItem() {
    _classCallCheck(this, MenuPartItem);

    return _possibleConstructorReturn(this, (MenuPartItem.__proto__ || Object.getPrototypeOf(MenuPartItem)).apply(this, arguments));
  }

  _createClass(MenuPartItem, [{
    key: 'isProduct',


    //
    //
    //

    value: function isProduct() {
      return this.type === _MenuPartItemType2.default.PRODUCT;
    }
  }, {
    key: 'isCategory',
    value: function isCategory() {
      return this.type === _MenuPartItemType2.default.CATEGORY;
    }
  }], [{
    key: 'fromProduct',

    //
    //
    //

    value: function fromProduct(product) {
      return new MenuPartItem().fromJson({
        id: product.id,
        type: _MenuPartItemType2.default.PRODUCT
      });
    }

    // shortcut

  }, {
    key: 'fromCategory',
    value: function fromCategory(category) {
      return new MenuPartItem().fromJson({
        id: category.id,
        type: _MenuPartItemType2.default.CATEGORY
      });
    }
  }]);

  return MenuPartItem;
}(_ApiObject3.default);

MenuPartItem.Type = _MenuPartItemType2.default;
exports.default = MenuPartItem;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/MenuPartItemType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MenuPartItemType = {
  CATEGORY: 0,

  // no 1, we want to correspond to the ItemType

  PRODUCT: 2
};

exports.default = MenuPartItemType;
module.exports = exports["default"];

/***/ }),

/***/ "./sdk/scripts/entities/menu/MenuPartProduct.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuPartProduct = function (_ApiObject) {
  _inherits(MenuPartProduct, _ApiObject);

  function MenuPartProduct() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPartProduct);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuPartProduct.__proto__ || Object.getPrototypeOf(MenuPartProduct)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.additionalPrice = 0, _this.baseAdditionalPrice = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPartProduct, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      // TODO: postJsonAssignation
    }
  }]);

  return MenuPartProduct;
}(_ApiObject3.default);

exports.default = MenuPartProduct;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/Product.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _ProductPrices = __webpack_require__("./sdk/scripts/entities/menu/ProductPrices.js");

var _ProductPrices2 = _interopRequireDefault(_ProductPrices);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _AvailabilityDates = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDates.js");

var _AvailabilityDates2 = _interopRequireDefault(_AvailabilityDates);

var _AvailabilityHours = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHours.js");

var _AvailabilityHours2 = _interopRequireDefault(_AvailabilityHours);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Product = function (_ApiObject) {
  _inherits(Product, _ApiObject);

  function Product() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Product);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Product.__proto__ || Object.getPrototypeOf(Product)).call.apply(_ref, [this].concat(args))), _this), _this.type = _CategoryItem2.default.Type.PRODUCT, _this.id = '', _this.name = '', _this.localizedNames = [], _this.description = '', _this.localizedDescriptions = [], _this.image = '', _this.prices = new _ProductPrices2.default(), _this.optionsIds = [], _this.defaultSequence = 0, _this.stock = Product.DEFAULT_STOCK, _this.availabilityDates = null, _this.availabilityHours = null, _this.cartModifiers = [], _this.unavailable = false, _this.allergen = [], _this.reclaimLaterEnabled = false, _temp), _possibleConstructorReturn(_this, _ret);
  } // Isn't used for the moment.

  /**
   * array of options' id.
   * @type {Array<String>}
   */


  // a front only var set by RestaurantMenu when filtered to indicate that the menu should be
  // display as unavailable


  _createClass(Product, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.prices = new _ProductPrices2.default();
      this.prices.fromJson(data.prices);

      if (!_lodash2.default.isNil(data.availabilityHours)) {
        this.availabilityHours = new _AvailabilityHours2.default().fromJson(data.availabilityHours);
      }

      if (!_lodash2.default.isNil(data.availabilityDates)) {
        this.availabilityDates = new _AvailabilityDates2.default().fromJson(data.availabilityDates);
      }
    }

    //
    // utils
    //

  }, {
    key: 'isActivatedForMode',
    value: function isActivatedForMode(mode) {
      return this.prices.getMode(mode).available;
    }
  }, {
    key: 'toggleActivationForMode',
    value: function toggleActivationForMode(mode) {
      this.prices.getMode(mode).available = !this.prices.getMode(mode).available;
    }
  }, {
    key: 'getPriceForMode',
    value: function getPriceForMode(mode) {
      return this.prices.getMode(mode).priceIncludingTax;
    }
  }, {
    key: 'getCartModifiersPrice',
    value: function getCartModifiersPrice(mode) {
      var price = this.getPriceForMode(mode);

      if (this.cartModifiers.length > 0) {
        var priceTemp = 0;

        this.cartModifiers.map(function (cartModifier) {
          if (priceTemp === 0) {
            priceTemp = price;
          }

          if (cartModifier.isHandled && cartModifier.isAvailable) {
            if (cartModifier.type === _CartModifier2.default.ActionType.DISCOUNT_PERCENTAGE) {
              priceTemp = parseFloat((priceTemp * (100 - cartModifier.value) / 100).toFixed(2));
            } else {
              priceTemp = parseFloat((priceTemp - cartModifier.value).toFixed(2));
            }
          }
        });

        price = priceTemp;
      }

      return Math.max(0, price);
    }
  }, {
    key: 'isActivatedForOneMode',
    value: function isActivatedForOneMode() {
      return this.isActivatedForMode(_Order2.default.OrderMode.DELIVERY) || this.isActivatedForMode(_Order2.default.OrderMode.TAKE_AWAY) || this.isActivatedForMode(_Order2.default.OrderMode.ON_SITE);
    }
  }, {
    key: 'toggleAvailibility',
    value: function toggleAvailibility() {
      if (this.stock === 0) {
        this.stock = Product.DEFAULT_STOCK;
      } else {
        this.stock = 0;
      }
    }
  }, {
    key: 'isAvailableForMode',
    value: function isAvailableForMode(mode) {
      return this.isActivatedForMode(mode) && this.haveStock();
    }
  }, {
    key: 'haveOptions',
    value: function haveOptions() {
      return !_lodash2.default.isEmpty(this.optionsIds);
    }
  }, {
    key: 'haveOptionWithId',
    value: function haveOptionWithId(id) {
      return _ArrayUtils2.default.exists(this.optionsIds, function (optionId) {
        return id === optionId;
      });
    }

    /**
     *
     */

  }, {
    key: 'haveStock',
    value: function haveStock() {
      return this.stock !== 0;
    }
  }, {
    key: 'haveStockAndIsActivated',
    value: function haveStockAndIsActivated() {
      return this.haveStock() && this.isActivatedForOneMode();
    }
  }, {
    key: 'isActivatedForDate',
    value: function isActivatedForDate(date) {
      return _lodash2.default.isNil(this.availabilityDates) || this.availabilityDates.isAvailableForDate(date);
    }
  }, {
    key: 'isAvailableForDate',
    value: function isAvailableForDate(date) {
      return _lodash2.default.isNil(this.availabilityHours) || this.availabilityHours.isAvailableForDate(date);
    }

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      // TODO: update
      return this.validateName() && this.validateDescription() && this.validatePrices();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateDescription',
    value: function validateDescription() {
      var isValid = true;

      _lodash2.default.forEach(this.localizedDescriptions, function (localizedDescription) {
        if (!_lodash2.default.isEmpty(localizedDescription.text) && localizedDescription.text.length < 5) {
          isValid = false;
        }
      });

      return isValid;
    }
  }, {
    key: 'validatePrices',
    value: function validatePrices() {
      return this.prices.isValid();
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = Product.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateDescription()) {
        errors.description = validationErrors.description;
      }

      if (!this.validatePrices()) {
        errors.price = validationErrors.price;
      }

      return errors;
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }, {
    key: 'description',
    set: function set(description) {
      this._description = description;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedDescriptions) || this._description || '';
    }
  }]);

  return Product;
}(_ApiObject3.default);

Product.DEFAULT_STOCK = 999;
Product.validationErrors = {
  name: 'Le nom ne peut être vide',
  description: 'La description doit être vide ou contenir plus de 5 caractères',
  price: 'Un prix et/ou une taxe sont valides'
};
exports.default = Product;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/ProductCategory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductCategory = function (_ApiObject) {
  _inherits(ProductCategory, _ApiObject);

  function ProductCategory() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductCategory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductCategory.__proto__ || Object.getPrototypeOf(ProductCategory)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _this.localizedNames = [], _this.image = '', _this.description = '', _this.localizedDescriptions = [], _this.items = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductCategory, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.items = [];

      _lodash2.default.each(data.items, function (itemData) {
        var item = new _CategoryItem2.default();
        item.fromJson(itemData);
        _this2.items.push(item);
      });

      if (_lodash2.default.isNull(this.id)) {
        this.id = _Utils2.default.generateUID();
      }
    }
  }, {
    key: 'removeItemWithId',
    value: function removeItemWithId(id) {
      this.items = _lodash2.default.remove(this.items, function (item) {
        return item.id !== id;
      });
    }
  }, {
    key: 'moveUpWithId',
    value: function moveUpWithId(id) {
      var fromIndex = _lodash2.default.findIndex(this.items, function (item) {
        return item.id === id;
      });

      var size = this.items.length;
      var toIndex = fromIndex - 1 >= 0 ? fromIndex - 1 : size - 1;
      this.items = _ArrayUtils2.default.moveOnArray(this.items, fromIndex, toIndex);
    }
  }, {
    key: 'moveDownWithId',
    value: function moveDownWithId(id) {
      var fromIndex = _lodash2.default.findIndex(this.items, function (item) {
        return item.id === id;
      });

      var size = this.items.length;
      var toIndex = fromIndex + 1 < size ? fromIndex + 1 : 0;
      this.items = _ArrayUtils2.default.moveOnArray(this.items, fromIndex, toIndex);
    }
  }, {
    key: 'haveChildCategory',
    value: function haveChildCategory(category) {
      return _ArrayUtils2.default.exists(this.items, function (item) {
        return item.isCategory() && item.id === category.id;
      });
    }

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return this.validateName();
      // &&
      //   this.validateDescription();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateDescription',
    value: function validateDescription() {
      var isValid = true;

      _lodash2.default.forEach(this.localizedDescriptions, function (localizedDescription) {
        if (!_lodash2.default.isEmpty(localizedDescription.text) && localizedDescription.text.length < ProductCategory.DESCRIPTION_MIN_LENGTH) {
          isValid = false;
        }
      });

      return isValid;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = ProductCategory.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateDescription()) {
        errors.description = validationErrors.description;
      }

      return errors;
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }, {
    key: 'description',
    set: function set(description) {
      this._description = description;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedDescriptions) || this._description || '';
    }
  }]);

  return ProductCategory;
}(_ApiObject3.default);

ProductCategory.DESCRIPTION_MIN_LENGTH = 5;
ProductCategory.validationErrors = {
  name: 'Le nom ne peut être vide',
  description: 'La description doit \xEAtre vide ou contenir plus de ' + ProductCategory.DESCRIPTION_MIN_LENGTH + ' caract\xE8res'
};
exports.default = ProductCategory;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/ProductOption.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProductOptionValue = __webpack_require__("./sdk/scripts/entities/menu/ProductOptionValue.js");

var _ProductOptionValue2 = _interopRequireDefault(_ProductOptionValue);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductOption = function (_ApiObject) {
  _inherits(ProductOption, _ApiObject);

  function ProductOption() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOption.__proto__ || Object.getPrototypeOf(ProductOption)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _this.localizedNames = [], _this.image = '', _this.quantityMin = 0, _this.quantityMax = 0, _this.values = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOption, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.values = [];
      _lodash2.default.each(data.values, function (valueData) {
        var productOptionValue = new _ProductOptionValue2.default();
        productOptionValue.fromJson(valueData);
        _this2.values.push(productOptionValue);
      });
    }
  }, {
    key: 'updateProductOptionValue',
    value: function updateProductOptionValue(productOptionValueToUpdate) {
      this.values = _ArrayUtils2.default.updateObject(this.values, productOptionValueToUpdate, function (productOptionValue) {
        return productOptionValueToUpdate.id === productOptionValue.id;
      });
    }

    //
    //
    //

  }, {
    key: 'isRequired',
    value: function isRequired() {
      return this.quantityMin >= 1;
    }

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      // TODO: update
      return this.validateName() && this.validateQuantity() && this.validateValues();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateQuantity',
    value: function validateQuantity() {
      return this.quantityMin >= 0 && this.quantityMax >= 1 && this.quantityMin <= this.quantityMax;
    }
  }, {
    key: 'validateValues',
    value: function validateValues() {
      return this.values.length >= this.quantityMin;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = ProductOption.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateQuantity()) {
        errors.quantity = validationErrors.quantity;
      }

      if (!this.validateValues()) {
        errors.values = validationErrors.values;
      }

      return errors;
    }

    //
    //
    //

  }, {
    key: 'addValue',
    value: function addValue(value) {
      this.values.push(value);
    }
  }, {
    key: 'updateValue',
    value: function updateValue(value) {
      this.values = _ArrayUtils2.default.updateObject(this.values, value, { id: value.id });
    }
  }, {
    key: 'deleteValue',
    value: function deleteValue(value) {
      this.values = _ArrayUtils2.default.deleteObject(this.values, { id: value.id });
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }]);

  return ProductOption;
}(_ApiObject3.default);

ProductOption.validationErrors = {
  name: 'Le nom ne peut être vide',
  quantity: 'La quantité est invalide',
  values: 'Le nombre de choix offerts est invalide. Il doit être au moins égal a la quantité minimum.'
};
exports.default = ProductOption;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/ProductOptionValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductOptionValue = function (_ApiObject) {
  _inherits(ProductOptionValue, _ApiObject);

  function ProductOptionValue() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductOptionValue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductOptionValue.__proto__ || Object.getPrototypeOf(ProductOptionValue)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _this.localizedNames = [], _this.additionalPrice = 0, _this.baseAdditionalPrice = 0, _this.stock = ProductOptionValue.DEFAULT_STOCK, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductOptionValue, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {}

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      // TODO: update
      return this.validateName() && this.validateAdditionalPrice();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateAdditionalPrice',
    value: function validateAdditionalPrice() {
      return !_lodash2.default.isNaN(parseFloat(this.additionalPrice)) && this.additionalPrice >= 0;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = ProductOptionValue.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateAdditionalPrice()) {
        errors.price = validationErrors.additionalPrice;
      }

      return errors;
    }
  }, {
    key: 'toggleAvailibility',
    value: function toggleAvailibility() {
      if (this.stock === 0) {
        this.stock = ProductOptionValue.DEFAULT_STOCK;
      } else {
        this.stock = 0;
      }
    }
  }, {
    key: 'haveStock',
    value: function haveStock() {
      return this.stock !== 0;
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }]);

  return ProductOptionValue;
}(_ApiObject3.default);

ProductOptionValue.DEFAULT_STOCK = 999;
ProductOptionValue.validationErrors = {
  name: 'Le nom ne peut être vide',
  additionalPrice: 'Le prix additionnel est invalide'
};
exports.default = ProductOptionValue;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/ProductPrice.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _TaxesType = __webpack_require__("./sdk/scripts/constants/TaxesType.js");

var _TaxesType2 = _interopRequireDefault(_TaxesType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductPrice = function (_ApiObject) {
  _inherits(ProductPrice, _ApiObject);

  function ProductPrice() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductPrice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductPrice.__proto__ || Object.getPrototypeOf(ProductPrice)).call.apply(_ref, [this].concat(args))), _this), _this.available = false, _this.vat = 5.5, _this.priceIncludingTax = 0, _this.happyHoursAvailable = false, _this.priceIncludingTaxHappyHours = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * true if this product can be bought for the mode described by this Price object
   */


  /**
   * VAT in percent, 10.0 is 10.00%
   */


  _createClass(ProductPrice, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {}
  }, {
    key: 'isValid',
    value: function isValid() {
      return this.available === false || !_lodash2.default.isNaN(parseFloat(this.priceIncludingTax))
      // Deactivate vat verification for now because POS menu returns null
      // TODO: vat isValid POS PayMyTable
      // && TaxesType.isValid(this.vat)
      ;
    }

    /**
     * Set the given price on priceIncludingTax by adding the tax
     */

  }, {
    key: 'setPriceWithoutTax',
    value: function setPriceWithoutTax(price) {
      var vatAdd = _lodash2.default.isNull(this.vat) ? 0 : price * (this.vat / 100);
      this.priceIncludingTax = price + vatAdd;
    }

    /**
     * Set the given price on priceIncludingTax
     */

  }, {
    key: 'setPriceWithTax',
    value: function setPriceWithTax(price) {
      this.priceIncludingTax = price;
    }
  }]);

  return ProductPrice;
}(_ApiObject3.default);

exports.default = ProductPrice;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/ProductPrices.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProductPrice = __webpack_require__("./sdk/scripts/entities/menu/ProductPrice.js");

var _ProductPrice2 = _interopRequireDefault(_ProductPrice);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductPrices = function (_ApiObject) {
  _inherits(ProductPrices, _ApiObject);

  function ProductPrices() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductPrices);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductPrices.__proto__ || Object.getPrototypeOf(ProductPrices)).call.apply(_ref, [this].concat(args))), _this), _this.onSite = new _ProductPrice2.default(), _this.takeAway = new _ProductPrice2.default(), _this.delivery = new _ProductPrice2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductPrices, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.onSite = new _ProductPrice2.default();
      this.onSite.fromJson(data.onSite);

      this.takeAway = new _ProductPrice2.default();
      this.takeAway.fromJson(data.takeAway);

      this.delivery = new _ProductPrice2.default();
      this.delivery.fromJson(data.delivery);
    }

    // -- utils

  }, {
    key: 'getMode',
    value: function getMode(mode) {
      switch (mode) {
        case _Order2.default.OrderMode.ON_SITE:
          return this.onSite;
        case _Order2.default.OrderMode.TAKE_AWAY:
          return this.takeAway;
        case _Order2.default.OrderMode.DELIVERY:
          return this.delivery;
        default:
          console.log('ProductPrices#getMode invalid mode provided', mode);
          // TODO: send error to logger
          return null;
      }
    }
  }, {
    key: 'isModeActivated',
    value: function isModeActivated(mode) {
      return this.getMode(mode).available;
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return this.onSite.isValid() && this.takeAway.isValid() && this.delivery.isValid();
    }
  }]);

  return ProductPrices;
}(_ApiObject3.default);

exports.default = ProductPrices;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/RestaurantMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProductCategory = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _CartModifier = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier2 = _interopRequireDefault(_CartModifier);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _MenuPart = __webpack_require__("./sdk/scripts/entities/menu/MenuPart.js");

var _MenuPart2 = _interopRequireDefault(_MenuPart);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _UpsellingCategory = __webpack_require__("./sdk/scripts/entities/menu/UpsellingCategory.js");

var _UpsellingCategory2 = _interopRequireDefault(_UpsellingCategory);

var _ItemSuggestion = __webpack_require__("./sdk/scripts/entities/menu/ItemSuggestion.js");

var _ItemSuggestion2 = _interopRequireDefault(_ItemSuggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantMenu = function (_ApiObject) {
  _inherits(RestaurantMenu, _ApiObject);

  function RestaurantMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantMenu.__proto__ || Object.getPrototypeOf(RestaurantMenu)).call.apply(_ref, [this].concat(args))), _this), _this.restaurantId = '', _this.rootCategoryId = '', _this.categories = [], _this.products = [], _this.options = [], _this.menus = [], _this.cartModifiers = [], _this.upsellingCategories = [], _this.suggestions = [], _this.posSyncDate = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RestaurantMenu, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      // -- deserialize categories
      this.categories = [];
      _lodash2.default.each(data.categories, function (orderCategoryData) {
        var orderCategory = new _ProductCategory2.default();
        orderCategory.fromJson(orderCategoryData);
        _this2.categories.push(orderCategory);
      });

      // -- deserialize options
      this.options = [];
      _lodash2.default.each(data.options, function (optionData) {
        var productOption = new _ProductOption2.default();
        productOption.fromJson(optionData);
        _this2.options.push(productOption);
      });

      // -- deserialize product
      this.products = [];
      _lodash2.default.each(data.products, function (productData) {
        var product = new _Product2.default();
        product.fromJson(productData);
        _this2.products.push(product);
      });

      // -- menus
      this.menus = [];
      _lodash2.default.each(data.menus, function (menuData) {
        var menu = new _Menu2.default();
        menu.fromJson(menuData);
        _this2.menus.push(menu);
      });

      // -- cartModifiers
      this.cartModifiers = [];
      _lodash2.default.each(data.cartModifiers, function (cartModifierData) {
        var cartModifier = new _CartModifier2.default();
        cartModifier.fromJson(cartModifierData);
        _this2.cartModifiers.push(cartModifier);
      });

      // --
      this.upsellingCategories = [];
      _lodash2.default.each(data.upsellingCategories, function (orderCategoryData) {
        var orderCategory = new _UpsellingCategory2.default();
        orderCategory.fromJson(orderCategoryData);
        _this2.upsellingCategories.push(orderCategory);
      });

      // --
      this.suggestions = [];
      _lodash2.default.each(data.suggestions, function (suggestionData) {
        var suggestion = new _ItemSuggestion2.default();
        suggestion.fromJson(suggestionData);
        _this2.suggestions.push(suggestion);
      });

      this.posSyncDate = _DateUtils2.default.fromMsTimestamp(data.posSyncDate);
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(RestaurantMenu.prototype.__proto__ || Object.getPrototypeOf(RestaurantMenu.prototype), 'toJSON', this).call(this);

      // no need to send this value
      json.posSyncDate = null;

      return json;
    }

    //
    // Get Menu Restaurant for mode
    //

    /**
     * The differents filters that exists.
     * Warning: The order is important. This enum display each possibility in the good order.
     */

  }, {
    key: 'getRestaurantMenuForModeWithFilters',
    value: function getRestaurantMenuForModeWithFilters(mode) {
      var dueDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var filtersParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var filters = filtersParams;
      if (_lodash2.default.isEmpty(filters)) {
        filters = [RestaurantMenu.EFilterMenuRestaurantItems.REMOVE_UNAVAILABLE_ITEMS, RestaurantMenu.EFilterMenuRestaurantItems.REMOVE_EMPTY_CATEGORIES, RestaurantMenu.EFilterMenuRestaurantItems.PUSH_BACK_NOT_IN_STOCK_ITEMS, RestaurantMenu.EFilterMenuRestaurantItems.PUSH_BACK_NOT_IN_HOUR_ITEMS, RestaurantMenu.EFilterMenuRestaurantItems.APPLY_CART_MODIFIERS_ON_ITEMS];
      }

      var menuRestaurantFiltered = this.copy();
      _lodash2.default.each(filters, function (filter) {
        switch (filter) {
          case RestaurantMenu.EFilterMenuRestaurantItems.REMOVE_EMPTY_CATEGORIES:
            menuRestaurantFiltered.removeEmptyCategories(mode);
            break;

          case RestaurantMenu.EFilterMenuRestaurantItems.REMOVE_UNAVAILABLE_ITEMS:
            menuRestaurantFiltered.removeUnavailableItems(mode, dueDate);
            break;
          case RestaurantMenu.EFilterMenuRestaurantItems.PUSH_BACK_NOT_IN_STOCK_ITEMS:
            menuRestaurantFiltered.pushBackNotInStockItems(mode);
            break;

          case RestaurantMenu.EFilterMenuRestaurantItems.PUSH_BACK_NOT_IN_HOUR_ITEMS:
            if (!_lodash2.default.isNull(dueDate)) {
              menuRestaurantFiltered.pushBackNotInHoursItems(mode, dueDate);
            }
            break;

          case RestaurantMenu.EFilterMenuRestaurantItems.APPLY_CART_MODIFIERS_ON_ITEMS:
            if (!_lodash2.default.isNull(dueDate)) {
              menuRestaurantFiltered.applyCartModifiersOnItems(mode, dueDate);
            }
            break;
        }
      });

      return menuRestaurantFiltered;
    }

    /**
     * Remove the items that are not available for the given `mode`.
     */

  }, {
    key: 'removeUnavailableItems',
    value: function removeUnavailableItems(mode, dueDate) {
      var _this3 = this;

      var productsIdsToRemove = [];

      // all the ids of the menus removed from this.menu and to remove on the categories.
      var menusIdsToRemove = [];

      this.products = _lodash2.default.filter(this.products, function (product) {
        if (!product.isActivatedForMode(mode) || !product.isActivatedForDate(dueDate)) {
          productsIdsToRemove.push(product.id);
          return false;
        }

        return true;
      });

      var menus = [];

      // -- remove not activated menus
      menus = _lodash2.default.filter(this.menus, function (menu) {
        if (!menu.isActivatedForMode(mode) || !menu.isActivatedForDate(dueDate)) {
          console.info('remove ' + menu.name + ': not activated for mode');
          menusIdsToRemove.push(menu.id);
          return false;
        }

        return true;
      });

      // We remove products that are not available from parts
      // if a part does not longer have products, we remove the menu
      var menusWithProductsFiltered = [];
      _lodash2.default.each(menus, function (menu) {
        var haveEmptyPart = false;

        _lodash2.default.each(menu.parts, function (part) {
          var items = [];
          var nbProductsAvailable = 0;

          _lodash2.default.each(part.products, function (menuPartProduct) {
            var product = _this3.getProductWithId(menuPartProduct.id);

            if (!_lodash2.default.isNil(product)) {
              if (!_lodash2.default.includes(productsIdsToRemove, menuPartProduct.id)) {
                items.push(menuPartProduct);
              }

              var isAvailable = product.isAvailableForMode(mode) && product.isActivatedForDate(dueDate);
              if (!isAvailable) {
                nbProductsAvailable++;
              }
            }
          });

          part.products = items;

          if (_lodash2.default.isEmpty(part.products)) {
            console.info(menu.name + ': have empty part ' + part.name);
            haveEmptyPart = true;
            return false; // quit loop because the menu will be remove
          }

          // all the remaining products are products that are not available.
          if (nbProductsAvailable === part.products.length) {
            console.info(menu.name + ': have part with no available products ' + part.name);
            haveEmptyPart = true;
            return false; // quit loop because the menu will be remove
          }
        });

        // if part is empty, remove menu
        if (haveEmptyPart) {
          console.info('remove ' + menu.name + ': have empty part');
          menusIdsToRemove.push(menu.id);
        } else {
          menusWithProductsFiltered.push(menu);
        }
      });

      this.menus = menusWithProductsFiltered;

      // -- remove menus from categories

      var categories = [];
      _lodash2.default.each(this.categories, function (category) {
        var items = [];
        _lodash2.default.each(category.items, function (item) {
          // is a menu
          if (item.isMenu()) {
            // id not in `menusIdsToRemove`.
            if (!_lodash2.default.includes(menusIdsToRemove, item.id)) {
              items.push(item);
            }
          }
          if (item.isCategory()) {
            items.push(item);
          }
          if (item.isProduct()) {
            // id not in `productsIdsToRemove`.
            if (!_lodash2.default.includes(productsIdsToRemove, item.id)) {
              items.push(item);
            }
          }
        });

        if (!_lodash2.default.isEmpty(items)) {
          category.items = items;
          categories.push(category);
        }
      });

      this.categories = categories;
    }

    /**
     * Remove the categories where there is no items
     */

  }, {
    key: 'removeEmptyCategories',
    value: function removeEmptyCategories(mode) {
      var categories = [];
      _lodash2.default.each(this.categories, function (category) {
        if (!_lodash2.default.isEmpty(category.items)) {
          categories.push(category);
        }
      });

      this.categories = categories;
    }

    /**
     * Push to the end of the list the items that are not in stock
     * For now the menus has no stock information
     * so we handle only the products
     */

  }, {
    key: 'pushBackNotInStockItems',
    value: function pushBackNotInStockItems(mode) {
      var predicate = function predicate(item) {
        return !item.haveStock();
      };

      this.pushBackWithPredicate(predicate, 'notInStock');
    }

    /**
     * Push to the end of the list the items that are not in available for the given dueDate
     */

  }, {
    key: 'pushBackNotInHoursItems',
    value: function pushBackNotInHoursItems(mode, dueDate) {
      var predicate = function predicate(item) {
        return !item.isAvailableForDate(dueDate);
      };

      this.pushBackWithPredicate(predicate, 'not in hours for date ' + dueDate.format());
    }
  }, {
    key: 'getAllSubCategories',
    value: function getAllSubCategories(item) {
      var _this4 = this;

      var categoryIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (categoryIds.indexOf(item.id) === -1) {
        var category = this.getCategoryWithId(item.id);

        if (!_lodash2.default.isNull(category)) {
          categoryIds.push(category.id);

          category.items.map(function (item) {
            var result = _this4.getAllSubCategories(item, categoryIds);
            categoryIds = _lodash2.default.merge(categoryIds, result);
          });
        }
      }

      return categoryIds;
    }
  }, {
    key: 'getCartModifiersForItem',
    value: function getCartModifiersForItem(cartModifiers, item, itemType, mode, dueDate, allSubCategories) {
      var _this5 = this;

      var cartModifiersItem = [];

      cartModifiers.forEach(function (cartModifier) {
        switch (cartModifier.target.type) {
          case _CartModifier2.default.TargetType.SPECIFIC_ITEMS:
            if (!_lodash2.default.isNil(cartModifier.target.items) && !_lodash2.default.isNil(cartModifier.target.items.itemsList)) {
              cartModifier.target.items.itemsList.forEach(function (itemTarget) {
                switch (itemTarget.type) {
                  case _CategoryItem2.default.Type.PRODUCT:
                    if (itemTarget.id === item.id) {
                      cartModifiersItem.push(cartModifier.getItemInformation(mode, dueDate));
                    }
                    break;
                  case _CategoryItem2.default.Type.MENU:
                    if (itemTarget.id === item.id) {
                      cartModifiersItem.push(cartModifier.getItemInformation(mode, dueDate));
                    }
                    break;
                  case _CategoryItem2.default.Type.CATEGORY:
                    // apply cart modifier to the menu if it belongs to the category required
                    var categories = itemType === _CategoryItem2.default.Type.MENU ? _this5.getCategoriesWithMenuId(item.id) : _this5.getCategoriesWithProductId(item.id);
                    var categoriesId = [];
                    categoriesId = categories.map(function (category) {
                      return category.id;
                    });
                    if (categoriesId.indexOf(itemTarget.id) > -1) {
                      cartModifiersItem.push(cartModifier.getItemInformation(mode, dueDate));
                    }

                    // apply cart modifier if the menu belong to a sub-category that is contained in the category required
                    allSubCategories.forEach(function (parentCategory) {
                      if (itemTarget.id === parentCategory.id) {
                        parentCategory.items.forEach(function (itemIdFromSubCategory) {
                          if (item.id === itemIdFromSubCategory) {
                            cartModifiersItem.push(cartModifier.getItemInformation(mode, dueDate));
                            return;
                          }
                        });
                      }
                    });
                    break;
                  default:
                    return null;
                    break;
                }
              });
            }
            break;

          default:
            return null;
            break;
        }
      });

      return cartModifiersItem;
    }
  }, {
    key: 'getFinalCartModifiers',
    value: function getFinalCartModifiers(cartModifiers, mode) {
      var firstCartModifier = true,
          skipCartModifiers = false,
          cartModifiersReturned = [];

      if (cartModifiers.length > 1) {
        // removing duplicated cart modifier for each product
        cartModifiers = cartModifiers.filter(function (cartModifier, pos, cartModifiersArray) {
          return cartModifiersArray.map(function (mapCartModifier) {
            return mapCartModifier.id;
          }).indexOf(cartModifier.id) === pos;
        });

        // sort cart modifiers array by priority
        cartModifiers.sort(function (cartModifierFirst, cartModifierSecond) {
          return cartModifierFirst.priority - cartModifierSecond.priority;
        });

        // mapping the cart modifiers array to check if we have to keep or not cart modifier
        cartModifiers.forEach(function (cartModifier) {
          if (_lodash2.default.isNil(cartModifier.modes) || cartModifier.modes.indexOf(mode) !== -1) {
            // if the cart modifier is for the order mode selected
            if (!cartModifier.combinable && firstCartModifier) {
              // if the first one is not combinable, we keep it and skip the rest
              cartModifiersReturned.push(cartModifier);
              firstCartModifier = false;
              skipCartModifiers = true;
            } else if (!skipCartModifiers && cartModifier.combinable) {
              // if we don't skip cart modifiers and it's combinable, we add it
              firstCartModifier = false;
              cartModifiersReturned.push(cartModifier);
            }
          }
        });
      } else {
        cartModifiersReturned = cartModifiers;
      }

      return cartModifiersReturned;
    }
  }, {
    key: 'applyCartModifiersOnItems',
    value: function applyCartModifiersOnItems(mode, dueDate) {
      var _this6 = this;

      var products = [],
          menus = [];
      var cartModifiers = this.cartModifiers.filter(function (cartModifier) {
        return cartModifier.enabled === true;
      });

      if (cartModifiers.length > 0) {
        var allSubCategories = this.categories.map(function (item) {
          return {
            id: item.id,
            categories: _this6.getAllSubCategories(item).slice(1),
            items: []
          };
        });

        allSubCategories.forEach(function (parentCategory, mainIndex) {
          parentCategory.categories.forEach(function (subCategory, subIndex) {
            var category = _this6.getCategoryWithId(subCategory);

            category.items.forEach(function (item, index) {
              if (!item.isCategory()) {
                allSubCategories[mainIndex].items.push(item.id);
              }
            });
          });
        });

        this.products.forEach(function (product) {
          var cartModifiersProduct = _this6.getCartModifiersForItem(cartModifiers, product, _CategoryItem2.default.Type.PRODUCT, mode, dueDate, allSubCategories);
          product.cartModifiers = _this6.getFinalCartModifiers(cartModifiersProduct, mode);
          products.push(product);
        });
        this.products = products;

        this.menus.forEach(function (menu) {
          var cartModifiersMenu = _this6.getCartModifiersForItem(cartModifiers, menu, _CategoryItem2.default.Type.MENU, mode, dueDate, allSubCategories);
          menu.cartModifiers = _this6.getFinalCartModifiers(cartModifiersMenu, mode);
          menus.push(menu);
        });
        this.menus = menus;
      }
    }

    /**
     * @param predicate A function that returns true if we have to push back the product / menu
     * We set to true the `unavailable` of Menu / Product if the filtered consider them as unavailable
     * in order to simplify the front.
     */

  }, {
    key: 'pushBackWithPredicate',
    value: function pushBackWithPredicate(predicate) {
      var unavailableDebug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // Here we save all the products id that are unavailable
      var unavailableItemsId = [];

      _lodash2.default.each(this.products, function (product) {
        if (predicate(product)) {
          product.unavailable = true;
          product.unavailableDebug = unavailableDebug;
          unavailableItemsId.push(product.id);
        }
      });

      _lodash2.default.each(this.menus, function (menu) {
        if (predicate(menu)) {
          menu.unavailable = true;
          menu.unavailableDebug = unavailableDebug;
          unavailableItemsId.push(menu.id);
        }
      });

      // Now for each item we check if it should be push to the end of the list
      // ie if its id is not in the unavailableItemsId list
      // Therefore we should have now first the items with stock then products without it.

      // We push back the items not available from the categories
      _lodash2.default.each(this.categories, function (category) {
        var availableItems = [];
        var unavailableItems = [];

        _lodash2.default.each(category.items, function (item) {
          if (_lodash2.default.includes(unavailableItemsId, item.id)) {
            unavailableItems.push(item);
          } else {
            availableItems.push(item);
          }
        });

        category.items = _lodash2.default.concat(availableItems, unavailableItems);
      });

      // We push back the items not available from the categories
      _lodash2.default.each(this.upsellingCategories, function (upsellingCategory) {
        var availableItems = [];
        var unavailableItems = [];

        _lodash2.default.each(upsellingCategory.items, function (item) {
          if (_lodash2.default.includes(unavailableItemsId, item.id)) {
            unavailableItems.push(item);
          } else {
            availableItems.push(item);
          }
        });

        upsellingCategory.items = _lodash2.default.concat(availableItems, unavailableItems);
      });

      // We push back the items not available from the menu parts
      _lodash2.default.each(this.menus, function (menu) {
        _lodash2.default.each(menu.parts, function (part) {
          var availableItems = [];
          var unavailableItems = [];

          _lodash2.default.each(part.products, function (product) {
            if (_lodash2.default.includes(unavailableItemsId, product.id)) {
              unavailableItems.push(product);
            } else {
              availableItems.push(product);
            }
          });

          part.products = _lodash2.default.concat(availableItems, unavailableItems);
        });
      });
    }

    //
    // utils
    //

  }, {
    key: 'getItem',
    value: function getItem(item) {
      var res = null;
      switch (item.type) {
        case _CategoryItem2.default.Type.MENU:
          res = _lodash2.default.find(this.menus, function (menu) {
            return menu.id === item.id;
          });
          break;

        case _CategoryItem2.default.Type.PRODUCT:
          res = _lodash2.default.find(this.products, function (product) {
            return product.id === item.id;
          });
          break;

        case _CategoryItem2.default.Type.CATEGORY:
          res = _lodash2.default.find(this.categories, function (category) {
            return category.id === item.id;
          });
          break;

        default:
      }

      return _lodash2.default.isUndefined(res) ? null : res;
    }
  }, {
    key: 'getItemById',
    value: function getItemById(id) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var res = null;

      if (!type || type === _CategoryItem2.default.Type.PRODUCT) {
        res = _lodash2.default.find(this.products, function (product) {
          return product.id === id;
        });
        if (!_lodash2.default.isNil(res)) {
          return res;
        }
      }

      if (!type || type === _CategoryItem2.default.Type.MENU) {
        res = _lodash2.default.find(this.menus, function (menu) {
          return menu.id === id;
        });
        if (!_lodash2.default.isNil(res)) {
          return res;
        }
      }

      if (!type || type === _CategoryItem2.default.Type.CATEGORY) {
        res = _lodash2.default.find(this.categories, function (category) {
          return category.id === id;
        });

        return _lodash2.default.isUndefined(res) ? null : res;
      }

      return null;
    }
  }, {
    key: 'getProductOptionWithId',
    value: function getProductOptionWithId(optionId) {
      return _ArrayUtils2.default.find(this.options, { id: optionId });
    }
  }, {
    key: 'getProductOptionsWithIds',
    value: function getProductOptionsWithIds(optionsIds) {
      var _this7 = this;

      var options = [];

      _lodash2.default.each(optionsIds, function (optionId) {
        var option = _this7.getProductOptionWithId(optionId);
        if (!_lodash2.default.isNull(option)) {
          options.push(option);
        }
      });

      return options;
    }
  }, {
    key: 'getRequiredProductOptionsWithIds',
    value: function getRequiredProductOptionsWithIds(optionsIds) {
      var _this8 = this;

      var options = [];

      _lodash2.default.each(optionsIds, function (optionId) {
        var option = _this8.getProductOptionWithId(optionId);
        if (!_lodash2.default.isNull(option)) {
          options.push(option);
        }
      });

      var requiredOptions = _lodash2.default.filter(options, function (option) {
        return option.isRequired();
      });

      return requiredOptions;
    }
  }, {
    key: 'getProductWithId',
    value: function getProductWithId(id) {
      var item = new _CategoryItem2.default();
      item.id = id;
      item.type = _CategoryItem2.default.Type.PRODUCT;
      return this.getItem(item);
    }
  }, {
    key: 'getProductsWithoutCategories',
    value: function getProductsWithoutCategories() {
      var itemsWithCategory = [];
      _lodash2.default.each(this.categories, function (category) {
        itemsWithCategory = itemsWithCategory.concat(category.items);
      });

      itemsWithCategory = _lodash2.default.uniqBy(itemsWithCategory, function (e) {
        return e.id;
      });

      var productsIdsWithCategory = [];
      _lodash2.default.each(itemsWithCategory, function (item) {
        if (item.isProduct()) {
          productsIdsWithCategory.push(item.id);
        }
      });

      var productsWithoutCategory = [];
      _lodash2.default.each(this.products, function (product) {
        var found = _lodash2.default.find(productsIdsWithCategory, function (productId) {
          return productId === product.id;
        });

        if (!found) {
          productsWithoutCategory.push(product);
        }
      });

      return productsWithoutCategory;
    }
  }, {
    key: 'getCategoriesWithProductId',
    value: function getCategoriesWithProductId(productId) {
      var categories = [];
      _lodash2.default.each(this.categories, function (category) {
        var found = _lodash2.default.find(category.items, function (item) {
          return item.isProduct() && productId === item.id;
        });

        if (!_lodash2.default.isUndefined(found)) {
          categories.push(category);
        }
      });

      return categories;
    }
  }, {
    key: 'getCategoriesWithMenuId',
    value: function getCategoriesWithMenuId(menuId) {
      var categories = [];
      _lodash2.default.each(this.categories, function (category) {
        var found = _lodash2.default.find(category.items, function (item) {
          return item.isMenu() && menuId === item.id;
        });

        if (!_lodash2.default.isUndefined(found)) {
          categories.push(category);
        }
      });

      return categories;
    }
  }, {
    key: 'getProductsWithOptionId',
    value: function getProductsWithOptionId(optionId) {
      var products = [];
      _lodash2.default.each(this.products, function (product) {
        var found = _lodash2.default.find(product.optionsIds, function (itemId) {
          return itemId === optionId;
        });

        if (!_lodash2.default.isUndefined(found)) {
          products.push(product);
        }
      });

      return products;
    }
  }, {
    key: 'getMenusWithProductId',
    value: function getMenusWithProductId(productId) {
      var menus = [];
      _lodash2.default.each(this.menus, function (menu) {
        if (menu.haveProduct(productId)) {
          menus.push(menu);
        }
      });

      return menus;
    }
  }, {
    key: 'getMenuWithId',
    value: function getMenuWithId(id) {
      var item = new _CategoryItem2.default();
      item.id = id;
      item.type = _CategoryItem2.default.Type.MENU;
      return this.getItem(item);
    }
  }, {
    key: 'getCategoryWithId',
    value: function getCategoryWithId(id) {
      var item = new _CategoryItem2.default();
      item.id = id;
      item.type = _CategoryItem2.default.Type.CATEGORY;
      return this.getItem(item);
    }

    //
    // products
    //

  }, {
    key: 'addProduct',
    value: function addProduct(productToAdd) {
      this.products.push(productToAdd);
    }
  }, {
    key: 'updateProduct',
    value: function updateProduct(productToUpdate) {
      this.products = _ArrayUtils2.default.updateObject(this.products, productToUpdate, {
        id: productToUpdate.id
      });
    }
  }, {
    key: 'deleteProduct',
    value: function deleteProduct(productToRemove) {
      this.products = _ArrayUtils2.default.deleteObject(this.products, {
        id: productToRemove.id
      });

      // TODO: delete product from menus parts.
    }

    //
    //  products options
    //

  }, {
    key: 'addProductOption',
    value: function addProductOption(productOptionToAdd) {
      this.options.push(productOptionToAdd);
    }
  }, {
    key: 'updateProductOption',
    value: function updateProductOption(productOptionToUpdate) {
      this.options = _ArrayUtils2.default.updateObject(this.options, productOptionToUpdate, { id: productOptionToUpdate.id });
    }
  }, {
    key: 'deleteProductOption',
    value: function deleteProductOption(productOptionToRemove) {
      _lodash2.default.pull(this.options, productOptionToRemove);

      // TODO: delete from products
    }

    //
    // menu
    //

  }, {
    key: 'addMenu',
    value: function addMenu(menuToAdd) {
      this.menus.push(menuToAdd);
    }
  }, {
    key: 'updateMenu',
    value: function updateMenu(menuToUpdate) {
      this.menus = _ArrayUtils2.default.updateObject(this.menus, menuToUpdate, function (menu) {
        return menu.id === menuToUpdate.id;
      });
    }
  }, {
    key: 'deleteMenu',
    value: function deleteMenu(menuToDelete) {
      this.menus = _ArrayUtils2.default.deleteObject(this.menus, { id: menuToDelete.id });

      // TODO: delete from categories
    }

    //
    // category
    //

  }, {
    key: 'createCategoryWithName',
    value: function createCategoryWithName(categoryName) {
      var newCategory = new _ProductCategory2.default();

      newCategory.name = categoryName;
      newCategory.id = _Utils2.default.generateUID();

      this.categories.unshift(newCategory);
    }
  }, {
    key: 'addCategory',
    value: function addCategory(categoryToAdd) {
      this.categories.push(categoryToAdd);
    }
  }, {
    key: 'updateCategory',
    value: function updateCategory(categoryToUpdate) {
      this.categories = _ArrayUtils2.default.updateObject(this.categories, categoryToUpdate, { id: categoryToUpdate.id });
    }
  }, {
    key: 'deleteCategory',
    value: function deleteCategory(categoryToDelete) {
      this.categories = _ArrayUtils2.default.deleteObject(this.categories, {
        id: categoryToDelete.id
      });
    }
  }, {
    key: 'moveUpCategory',
    value: function moveUpCategory(categoryToMove) {
      var fromIndex = _lodash2.default.findIndex(this.categories, function (category) {
        return category.id === categoryToMove.id;
      });

      var size = this.categories.length;
      var toIndex = fromIndex - 1 >= 0 ? fromIndex - 1 : size - 1;
      this.categories = _ArrayUtils2.default.moveOnArray(this.categories, fromIndex, toIndex);
    }
  }, {
    key: 'moveDownCategory',
    value: function moveDownCategory(categoryToMove) {
      var fromIndex = _lodash2.default.findIndex(this.categories, function (category) {
        return category.id === categoryToMove.id;
      });

      var size = this.categories.length;
      var toIndex = fromIndex + 1 < size ? fromIndex + 1 : 0;
      this.categories = _ArrayUtils2.default.moveOnArray(this.categories, fromIndex, toIndex);
    }
  }, {
    key: 'removeCategory',
    value: function removeCategory(categoryToRemove) {
      this.categories = _lodash2.default.remove(this.categories, function (category) {
        return category.id !== categoryToRemove.id;
      });

      _lodash2.default.each(this.categories, function (category) {
        category.removeItemWithId(categoryToRemove.id);
      });
    }
  }, {
    key: 'getRootCategory',
    value: function getRootCategory() {
      return this.getCategoryWithId(this.rootCategoryId);
    }
  }, {
    key: 'getFirstLevelCategories',
    value: function getFirstLevelCategories() {
      var _this9 = this;

      var rootCategory = this.getRootCategory();
      if (!_lodash2.default.isNull(rootCategory)) {
        var categories = [];
        _lodash2.default.each(rootCategory.items, function (item) {
          if (item.isCategory()) {
            var category = _this9.getCategoryWithId(item.id);
            if (!_lodash2.default.isNull(category)) {
              categories.push(category);
            }
          }
        });
        return categories;
      }

      console.warn('Restaurant menu does not have a root category');
      return this.categories;
    }
  }, {
    key: 'getFirstLevelCategoriesWithoutEmptyCategories',
    value: function getFirstLevelCategoriesWithoutEmptyCategories() {
      var _this10 = this;

      var rootCategory = this.getRootCategory();
      if (!_lodash2.default.isNull(rootCategory)) {
        var categories = [];
        _lodash2.default.each(rootCategory.items, function (item) {
          if (item.isCategory()) {
            var category = _this10.getCategoryWithId(item.id);
            if (!_lodash2.default.isNull(category)) {
              _lodash2.default.each(category.items, function (itemCategory) {
                if (itemCategory.isCategory()) {
                  var categoryChild = _this10.getCategoryWithId(itemCategory.id);
                  if (!_lodash2.default.isNil(categoryChild)) {
                    categories.push(category);
                    return false;
                  }
                } else {
                  categories.push(category);
                  return false;
                }
              });
            }
          }
        });
        return categories;
      }

      console.warn('Restaurant menu does not have a root category');
      return this.categories;
    }
  }, {
    key: 'getUnusedCategoriesIds',
    value: function getUnusedCategoriesIds() {
      var categoriesIds = this.categories.map(function (category) {
        return category.id;
      });

      var childCategoriesIds = [];
      _lodash2.default.each(this.categories, function (category) {
        _lodash2.default.each(category.items, function (item) {
          if (item.isCategory()) {
            childCategoriesIds.push(item.id);
          }
        });
      });

      var usedCategories = childCategoriesIds;
      usedCategories.push(this.rootCategoryId);
      usedCategories = _lodash2.default.uniq(childCategoriesIds);

      var diff = _lodash2.default.difference(categoriesIds, usedCategories);

      return diff;
    }
  }, {
    key: 'removeCategoryFromRoot',
    value: function removeCategoryFromRoot(category) {
      var rootCategory = this.getRootCategory();

      rootCategory.removeItemWithId(category.id);
    }
  }, {
    key: 'getAllImages',
    value: function getAllImages() {
      var images = [];

      images.push.apply(images, _toConsumableArray(this.categories.map(function (category) {
        return category.image;
      }).filter(function (image) {
        return !_lodash2.default.isEmpty(image);
      })));
      images.push.apply(images, _toConsumableArray(this.menus.map(function (menu) {
        return menu.image;
      }).filter(function (image) {
        return !_lodash2.default.isEmpty(image);
      })));
      images.push.apply(images, _toConsumableArray(this.products.map(function (product) {
        return product.image;
      }).filter(function (image) {
        return !_lodash2.default.isEmpty(image);
      })));

      return images;
    }

    //
    // upselling category
    //

  }, {
    key: 'haveUpselling',
    value: function haveUpselling() {
      if (_lodash2.default.isEmpty(this.upsellingCategories)) {
        return false;
      }

      return this.getAvailableUpsellingCategories().length > 0;
    }
  }, {
    key: 'getAvailableUpsellingCategories',
    value: function getAvailableUpsellingCategories() {
      var _this11 = this;

      var categories = [];

      _lodash2.default.each(this.upsellingCategories, function (upsellingCategory) {
        if (upsellingCategory.enabled) {
          var oneItemAvailable = false;

          _lodash2.default.each(upsellingCategory.items, function (categoryItem) {
            var item = _this11.getItem(categoryItem);

            if (!_lodash2.default.isNull(item) && !item.unavailable) {
              oneItemAvailable = true;
              return false; // quit loop
            }
          });

          if (oneItemAvailable) {
            categories.push(upsellingCategory);
          }
        }
      });

      return categories;
    }
  }, {
    key: 'getUpsellingCategoryWithId',
    value: function getUpsellingCategoryWithId(id) {
      return _ArrayUtils2.default.find(this.upsellingCategories, { id: id });
    }
  }, {
    key: 'createUpsellingCategoryWithName',
    value: function createUpsellingCategoryWithName(upsellingCategoryName) {
      var newUpsellingCategory = new _UpsellingCategory2.default();

      newUpsellingCategory.name = upsellingCategoryName;
      newUpsellingCategory.id = _Utils2.default.generateUID();

      this.upsellingCategories.unshift(newUpsellingCategory);
    }
  }, {
    key: 'addUpsellingCategory',
    value: function addUpsellingCategory(upsellingCategoryToAdd) {
      this.upsellingCategories.push(upsellingCategoryToAdd);
    }
  }, {
    key: 'toggleUpsellingCategory',
    value: function toggleUpsellingCategory(upsellingCategoryToUpdate) {
      this.upsellingCategories = this.upsellingCategories.map(function (upsellingCategory) {
        upsellingCategory.enabled = upsellingCategory.id !== upsellingCategoryToUpdate.id ? false : upsellingCategoryToUpdate.enabled;
        return upsellingCategory;
      });
    }
  }, {
    key: 'updateUpsellingCategory',
    value: function updateUpsellingCategory(upsellingCategoryToUpdate) {
      this.upsellingCategories = _ArrayUtils2.default.updateObject(this.upsellingCategories, upsellingCategoryToUpdate, { id: upsellingCategoryToUpdate.id });
    }
  }, {
    key: 'deleteUpsellingCategory',
    value: function deleteUpsellingCategory(upsellingCategoryToDelete) {
      this.upsellingCategories = _ArrayUtils2.default.deleteObject(this.upsellingCategories, { id: upsellingCategoryToDelete.id });
    }
  }, {
    key: 'moveUpUpsellingCategory',
    value: function moveUpUpsellingCategory(upsellingCategoryToMove) {
      var fromIndex = _lodash2.default.findIndex(this.upsellingCategories, function (upsellingCategory) {
        return upsellingCategory.id === upsellingCategoryToMove.id;
      });

      var size = this.upsellingCategories.length;
      var toIndex = fromIndex - 1 >= 0 ? fromIndex - 1 : size - 1;
      this.upsellingCategories = _ArrayUtils2.default.moveOnArray(this.upsellingCategories, fromIndex, toIndex);
    }
  }, {
    key: 'moveDownUpsellingCategory',
    value: function moveDownUpsellingCategory(upsellingCategoryToMove) {
      var fromIndex = _lodash2.default.findIndex(this.upsellingCategories, function (upsellingCategory) {
        return upsellingCategory.id === upsellingCategoryToMove.id;
      });

      var size = this.upsellingCategories.length;
      var toIndex = fromIndex + 1 < size ? fromIndex + 1 : 0;
      this.upsellingCategories = _ArrayUtils2.default.moveOnArray(this.upsellingCategories, fromIndex, toIndex);
    }
  }, {
    key: 'removeUpsellingCategory',
    value: function removeUpsellingCategory(upsellingCategoryToRemove) {
      this.upsellingCategories = _lodash2.default.remove(this.upsellingCategories, function (upsellingCategory) {
        return upsellingCategory.id !== upsellingCategoryToRemove.id;
      });
    }

    //
    // Item suggestion
    //

  }, {
    key: 'getItemSuggestionForItemId',
    value: function getItemSuggestionForItemId(id) {
      return _ArrayUtils2.default.find(this.suggestions, { id: id });
    }
  }, {
    key: 'getAvailableItemSuggestionForItemId',
    value: function getAvailableItemSuggestionForItemId(id) {
      var _this12 = this;

      var itemSuggestion = this.getItemSuggestionForItemId(id);
      if (_lodash2.default.isNil(itemSuggestion)) {
        return null;
      }

      var oneItemAvailable = false;
      _lodash2.default.each(itemSuggestion.linkedItems, function (suggestedItem) {
        var item = _this12.getItemById(suggestedItem.id, suggestedItem.type);

        if (!_lodash2.default.isNull(item) && !item.unavailable) {
          oneItemAvailable = true;
          return false; // quit loop
        }
      });

      return oneItemAvailable ? itemSuggestion : null;
    }
  }, {
    key: 'haveItemSuggestionForItemId',
    value: function haveItemSuggestionForItemId(id) {
      var itemSuggestion = this.getItemSuggestionForItemId(id);
      return !_lodash2.default.isUndefined(itemSuggestion) && !_lodash2.default.isEmpty(itemSuggestion.linkedItems);
    }
  }, {
    key: 'haveAvailableItemSuggestionForItemId',
    value: function haveAvailableItemSuggestionForItemId(id) {
      return !_lodash2.default.isNull(this.getAvailableItemSuggestionForItemId(id));
    }
  }, {
    key: 'addItemSuggetion',
    value: function addItemSuggetion(suggestion) {
      this.suggestions.push(suggestion);
    }
  }, {
    key: 'updateItemSuggetion',
    value: function updateItemSuggetion(suggestion) {
      this.suggestions = _ArrayUtils2.default.updateObject(this.suggestions, suggestion, {
        id: suggestion.id
      });
    }
  }, {
    key: 'deleteItemSuggetion',
    value: function deleteItemSuggetion(suggestion) {
      this.suggestions = _ArrayUtils2.default.deleteObject(this.suggestions, suggestion, {
        id: suggestion.id
      });
    }
  }]);

  return RestaurantMenu;
}(_ApiObject3.default);

RestaurantMenu.EFilterMenuRestaurantItems = {
  REMOVE_UNAVAILABLE_ITEMS: 'REMOVE_UNAVAILABLE_ITEMS',

  /**
   * Should be set on `filters` param after REMOVE_UNAVAILABLE_ITEMS
   */
  REMOVE_EMPTY_CATEGORIES: 'REMOVE_EMPTY_CATEGORIES',

  PUSH_BACK_NOT_IN_STOCK_ITEMS: 'PUSH_BACK_NOT_IN_STOCK_ITEMS',

  PUSH_BACK_NOT_IN_HOUR_ITEMS: 'PUSH_BACK_NOT_IN_HOUR_ITEMS',

  APPLY_CART_MODIFIERS_ON_ITEMS: 'APPLY_CART_MODIFIERS_ON_ITEMS'
};
exports.default = RestaurantMenu;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/SuggestedItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuggestedItem = function (_ApiObject) {
  _inherits(SuggestedItem, _ApiObject);

  function SuggestedItem() {
    _classCallCheck(this, SuggestedItem);

    return _possibleConstructorReturn(this, (SuggestedItem.__proto__ || Object.getPrototypeOf(SuggestedItem)).apply(this, arguments));
  }

  _createClass(SuggestedItem, [{
    key: 'setTypeForObject',
    value: function setTypeForObject(item) {
      this.type = item instanceof _Menu2.default ? SuggestedItem.Type.MENU : SuggestedItem.Type.PRODUCT;
    }

    /**
     *
     * @type {{CMENU: number, PRODUCT: number}}
     */

  }, {
    key: 'isActionReplace',
    value: function isActionReplace() {
      return this.action === SuggestedItem.Action.REPLACE;
    }
  }, {
    key: 'isActionAdd',
    value: function isActionAdd() {
      return this.action === SuggestedItem.Action.ADD;
    }
  }, {
    key: 'isMenu',
    value: function isMenu() {
      return this.type === SuggestedItem.Type.MENU;
    }
  }, {
    key: 'isProduct',
    value: function isProduct() {
      return this.type === SuggestedItem.Type.PRODUCT;
    }
  }]);

  return SuggestedItem;
}(_ApiObject3.default);

SuggestedItem.Type = {
  MENU: 1,

  PRODUCT: 2
};
SuggestedItem.Action = {
  REPLACE: 0,

  ADD: 1
};
exports.default = SuggestedItem;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/UpsellingCategory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

var _CatalogUtils = __webpack_require__("./sdk/scripts/utils/CatalogUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpsellingCategory = function (_ApiObject) {
  _inherits(UpsellingCategory, _ApiObject);

  function UpsellingCategory() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpsellingCategory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpsellingCategory.__proto__ || Object.getPrototypeOf(UpsellingCategory)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _this.localizedNames = [], _this.description = '', _this.localizedDescriptions = [], _this.items = [], _this.enabled = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpsellingCategory, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.items = [];
      _lodash2.default.each(data.items, function (itemData) {
        var item = new _CategoryItem2.default();
        item.fromJson(itemData);
        _this2.items.push(item);
      });

      if (_lodash2.default.isNull(this.id)) {
        this.id = _Utils2.default.generateUID();
      }
    }
  }, {
    key: 'removeItemWithId',
    value: function removeItemWithId(id) {
      this.items = _lodash2.default.remove(this.items, function (item) {
        return item.id !== id;
      });
    }
  }, {
    key: 'moveUpWithId',
    value: function moveUpWithId(id) {
      var fromIndex = _lodash2.default.findIndex(this.items, function (item) {
        return item.id === id;
      });

      var size = this.items.length;
      var toIndex = fromIndex - 1 >= 0 ? fromIndex - 1 : size - 1;
      this.items = _ArrayUtils2.default.moveOnArray(this.items, fromIndex, toIndex);
    }
  }, {
    key: 'moveDownWithId',
    value: function moveDownWithId(id) {
      var fromIndex = _lodash2.default.findIndex(this.items, function (item) {
        return item.id === id;
      });

      var size = this.items.length;
      var toIndex = fromIndex + 1 < size ? fromIndex + 1 : 0;
      this.items = _ArrayUtils2.default.moveOnArray(this.items, fromIndex, toIndex);
    }

    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return this.validateName() && this.validateDescription();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      if (_lodash2.default.isEmpty(this.localizedNames)) {
        return false;
      }

      var isValid = false;

      _lodash2.default.forEach(this.localizedNames, function (localizedName) {
        if (!_lodash2.default.isEmpty(localizedName.text)) {
          isValid = true;
        }
      });

      return isValid;
    }
  }, {
    key: 'validateDescription',
    value: function validateDescription() {
      var isValid = true;

      _lodash2.default.forEach(this.localizedDescriptions, function (localizedDescription) {
        if (!_lodash2.default.isEmpty(localizedDescription.text) && localizedDescription.text.length < UpsellingCategory.DESCRIPTION_MIN_LENGTH) {
          isValid = false;
        }
      });

      return isValid;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = UpsellingCategory.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validateDescription()) {
        errors.description = validationErrors.description;
      }

      return errors;
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = name;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedNames) || this._name || '';
    }
  }, {
    key: 'description',
    set: function set(description) {
      this._description = description;
    },
    get: function get() {
      return (0, _CatalogUtils.getLocalizedData)(this.localizedDescriptions) || this._description || '';
    }
  }]);

  return UpsellingCategory;
}(_ApiObject3.default);

UpsellingCategory.DESCRIPTION_MIN_LENGTH = 5;
UpsellingCategory.validationErrors = {
  name: 'Le nom ne peut être vide',
  description: 'La description doit \xEAtre vide ou contenir plus de ' + UpsellingCategory.DESCRIPTION_MIN_LENGTH + ' caract\xE8res'
};
exports.default = UpsellingCategory;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/menu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpsellingCategory = exports.SuggestedItem = exports.RestaurantMenu = exports.ProductPrices = exports.ProductPrice = exports.ProductOptionValue = exports.ProductOption = exports.ProductCategory = exports.Product = exports.MenuPartProduct = exports.MenuPartItemType = exports.MenuPartItem = exports.MenuPartCategory = exports.MenuPart = exports.Menu = exports.ItemSuggestion = exports.CategoryItem = exports.CartModifier = exports.AvailabilityHour = exports.AvailabilityHours = exports.AvailabilityDate = exports.AvailabilityDates = undefined;

var _AvailabilityDates2 = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDates.js");

var _AvailabilityDates3 = _interopRequireDefault(_AvailabilityDates2);

var _AvailabilityDate2 = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityDate.js");

var _AvailabilityDate3 = _interopRequireDefault(_AvailabilityDate2);

var _AvailabilityHours2 = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHours.js");

var _AvailabilityHours3 = _interopRequireDefault(_AvailabilityHours2);

var _AvailabilityHour2 = __webpack_require__("./sdk/scripts/entities/menu/AvailabilityHour.js");

var _AvailabilityHour3 = _interopRequireDefault(_AvailabilityHour2);

var _CartModifier2 = __webpack_require__("./sdk/scripts/entities/menu/CartModifier.js");

var _CartModifier3 = _interopRequireDefault(_CartModifier2);

var _CategoryItem2 = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem3 = _interopRequireDefault(_CategoryItem2);

var _ItemSuggestion2 = __webpack_require__("./sdk/scripts/entities/menu/ItemSuggestion.js");

var _ItemSuggestion3 = _interopRequireDefault(_ItemSuggestion2);

var _Menu2 = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuPart2 = __webpack_require__("./sdk/scripts/entities/menu/MenuPart.js");

var _MenuPart3 = _interopRequireDefault(_MenuPart2);

var _MenuPartCategory2 = __webpack_require__("./sdk/scripts/entities/menu/MenuPartCategory.js");

var _MenuPartCategory3 = _interopRequireDefault(_MenuPartCategory2);

var _MenuPartItem2 = __webpack_require__("./sdk/scripts/entities/menu/MenuPartItem.js");

var _MenuPartItem3 = _interopRequireDefault(_MenuPartItem2);

var _MenuPartProduct2 = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct3 = _interopRequireDefault(_MenuPartProduct2);

var _Product2 = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product3 = _interopRequireDefault(_Product2);

var _ProductCategory2 = __webpack_require__("./sdk/scripts/entities/menu/ProductCategory.js");

var _ProductCategory3 = _interopRequireDefault(_ProductCategory2);

var _ProductOption2 = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption3 = _interopRequireDefault(_ProductOption2);

var _ProductOptionValue2 = __webpack_require__("./sdk/scripts/entities/menu/ProductOptionValue.js");

var _ProductOptionValue3 = _interopRequireDefault(_ProductOptionValue2);

var _ProductPrice2 = __webpack_require__("./sdk/scripts/entities/menu/ProductPrice.js");

var _ProductPrice3 = _interopRequireDefault(_ProductPrice2);

var _ProductPrices2 = __webpack_require__("./sdk/scripts/entities/menu/ProductPrices.js");

var _ProductPrices3 = _interopRequireDefault(_ProductPrices2);

var _RestaurantMenu2 = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu3 = _interopRequireDefault(_RestaurantMenu2);

var _SuggestedItem2 = __webpack_require__("./sdk/scripts/entities/menu/SuggestedItem.js");

var _SuggestedItem3 = _interopRequireDefault(_SuggestedItem2);

var _UpsellingCategory2 = __webpack_require__("./sdk/scripts/entities/menu/UpsellingCategory.js");

var _UpsellingCategory3 = _interopRequireDefault(_UpsellingCategory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AvailabilityDates = _AvailabilityDates3.default;
exports.AvailabilityDate = _AvailabilityDate3.default;
exports.AvailabilityHours = _AvailabilityHours3.default;
exports.AvailabilityHour = _AvailabilityHour3.default;
exports.CartModifier = _CartModifier3.default;
exports.CategoryItem = _CategoryItem3.default;
exports.ItemSuggestion = _ItemSuggestion3.default;
exports.Menu = _Menu3.default;
exports.MenuPart = _MenuPart3.default;
exports.MenuPartCategory = _MenuPartCategory3.default;
exports.MenuPartItem = _MenuPartItem3.default;
exports.MenuPartItemType = _MenuPartItem3.default;
exports.MenuPartProduct = _MenuPartProduct3.default;
exports.Product = _Product3.default;
exports.ProductCategory = _ProductCategory3.default;
exports.ProductOption = _ProductOption3.default;
exports.ProductOptionValue = _ProductOptionValue3.default;
exports.ProductPrice = _ProductPrice3.default;
exports.ProductPrices = _ProductPrices3.default;
exports.RestaurantMenu = _RestaurantMenu3.default;
exports.SuggestedItem = _SuggestedItem3.default;
exports.UpsellingCategory = _UpsellingCategory3.default;

/***/ }),

/***/ "./sdk/scripts/entities/order/AbstractOrderModeSetting.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AbstractOrderModeSetting = function (_ApiObject) {
  _inherits(AbstractOrderModeSetting, _ApiObject);

  function AbstractOrderModeSetting() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractOrderModeSetting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractOrderModeSetting.__proto__ || Object.getPrototypeOf(AbstractOrderModeSetting)).call.apply(_ref, [this].concat(args))), _this), _this.orderPaymentMethodsAllowed = _ApiConstants2.default.OrderPaymentMethodsAllowed, _this.enabled = false, _this.maxTimeAhead = 0, _this.minimumPrice = 0, _this.irlPaymentAllowed = false, _this.paymentMethodsAllowed = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * true if the on-site order mode is enabled.
   *
   * @type Boolean
   */


  /**
   * The max time ahead to order.
   * Mostly in days.
   */


  /**
   * The minimum order total required for a delivery.
   */


  _createClass(AbstractOrderModeSetting, [{
    key: 'getMaxTimeAheadAsDays',
    // long

    value: function getMaxTimeAheadAsDays() {
      return _DateUtils2.default.millisecondsToDays(this.maxTimeAhead);
    }
  }, {
    key: 'setMaxTimeAheadWithDays',
    value: function setMaxTimeAheadWithDays(days) {
      this.maxTimeAhead = _DateUtils2.default.daysToMilliseconds(days);
    }

    // -- features

  }, {
    key: 'havePaymentMethodAllowed',
    value: function havePaymentMethodAllowed(paymentMethodsAllowed) {
      return (paymentMethodsAllowed & this.paymentMethodsAllowed) !== 0;
    }
  }, {
    key: 'havePaymentMethodAllowedIrl',
    value: function havePaymentMethodAllowedIrl() {
      return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.IRL);
    }
  }, {
    key: 'havePaymentMethodAllowedCreditCard',
    value: function havePaymentMethodAllowedCreditCard() {
      return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.CREDIT_CARD);
    }
  }, {
    key: 'havePaymentMethodAllowedTRD',
    value: function havePaymentMethodAllowedTRD() {
      return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.TRD);
    }
  }, {
    key: 'havePaymentMethodAllowedUserAccount',
    value: function havePaymentMethodAllowedUserAccount() {
      return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.USER_ACCOUNT);
    }
  }]);

  return AbstractOrderModeSetting;
}(_ApiObject3.default);

exports.default = AbstractOrderModeSetting;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/DeliveryAdaptableTimeSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The settings allowing to calculate an adaptable delivery time settings.
 *
 * Calculation:
 * orderSettings.manufactureDelay + deliveryManArrivalDuration + deliveryTime
 */
var DeliveryAdaptableTimeSettings = function (_ApiObject) {
  _inherits(DeliveryAdaptableTimeSettings, _ApiObject);

  function DeliveryAdaptableTimeSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeliveryAdaptableTimeSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliveryAdaptableTimeSettings.__proto__ || Object.getPrototypeOf(DeliveryAdaptableTimeSettings)).call.apply(_ref, [this].concat(args))), _this), _this.deliveryManArrivalDuration = _DateUtils2.default.MINUTE_AS_MS * 20, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeliveryAdaptableTimeSettings, [{
    key: 'getdeliveryManArrivalDurationAsMinutes',


    /**
    * must be calculate by the front. The distance time between the restaurant and the delivery
    * address.
    */
    // deliveryTime = 0;
    //

    value: function getdeliveryManArrivalDurationAsMinutes() {
      return _DateUtils2.default.millisecondsToMinutes(this.deliveryManArrivalDuration);
    }
  }, {
    key: 'setdeliveryManArrivalDurationFromMinutes',
    value: function setdeliveryManArrivalDurationFromMinutes(minutes) {
      this.deliveryManArrivalDuration = _DateUtils2.default.minutesToMilliseconds(minutes);
    }
  }]);

  return DeliveryAdaptableTimeSettings;
}(_ApiObject3.default);

exports.default = DeliveryAdaptableTimeSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/DeliveryFixTimeSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeliveryFixTimeSettings = function (_ApiObject) {
  _inherits(DeliveryFixTimeSettings, _ApiObject);

  function DeliveryFixTimeSettings() {
    _classCallCheck(this, DeliveryFixTimeSettings);

    return _possibleConstructorReturn(this, (DeliveryFixTimeSettings.__proto__ || Object.getPrototypeOf(DeliveryFixTimeSettings)).apply(this, arguments));
  }

  _createClass(DeliveryFixTimeSettings, [{
    key: 'getTimeAsMinutes',
    value: function getTimeAsMinutes() {
      return _DateUtils2.default.millisecondsToMinutes(this.time);
    }
  }, {
    key: 'setTimeFromMinutes',
    value: function setTimeFromMinutes(minutes) {
      this.time = _DateUtils2.default.minutesToMilliseconds(minutes);
    }
  }]);

  return DeliveryFixTimeSettings;
}(_ApiObject3.default);

exports.default = DeliveryFixTimeSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/DeliveryOrderSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject2 = _interopRequireDefault(_ApiObject);

var _AbstractOrderModeSetting = __webpack_require__("./sdk/scripts/entities/order/AbstractOrderModeSetting.js");

var _AbstractOrderModeSetting2 = _interopRequireDefault(_AbstractOrderModeSetting);

var _DeliveryTimeSettings = __webpack_require__("./sdk/scripts/entities/order/DeliveryTimeSettings.js");

var _DeliveryTimeSettings2 = _interopRequireDefault(_DeliveryTimeSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeliveryOrderSettings = function (_AbstractOrderModeSet) {
	_inherits(DeliveryOrderSettings, _AbstractOrderModeSet);

	function DeliveryOrderSettings() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, DeliveryOrderSettings);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliveryOrderSettings.__proto__ || Object.getPrototypeOf(DeliveryOrderSettings)).call.apply(_ref, [this].concat(args))), _this), _this.maxRangeInMeters = 0, _this.deliveryPrice = 0, _this.minimumPriceForFreeDelivery = 0, _this.deliveryTimeSettings = new _DeliveryTimeSettings2.default(), _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
 * maximum range the restaurant can deliver to.
 * @type Number
 */


	/**
 * The price of the delivery. It bacame 0 when the order total price is equal or greater than the `minimumPriceForFreeDelivery`
 */


	/**
 * If the order total price is equal or greater than the `minimumPriceForFreeDelivery`, the
 * deliveryPrice became 0.
 */


	_createClass(DeliveryOrderSettings, [{
		key: 'postJsonAsssignation',
		value: function postJsonAsssignation(data) {
			this.deliveryTimeSettings = new _DeliveryTimeSettings2.default().fromJson(data.deliveryTimeSettings);
		}
	}, {
		key: 'isTooFarToDelivery',
		value: function isTooFarToDelivery(distance) {
			return distance > this.maxRangeInMeters;
		}
	}]);

	return DeliveryOrderSettings;
}(_AbstractOrderModeSetting2.default);

exports.default = DeliveryOrderSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/DeliveryTimeSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DeliveryAdaptableTimeSettings = __webpack_require__("./sdk/scripts/entities/order/DeliveryAdaptableTimeSettings.js");

var _DeliveryAdaptableTimeSettings2 = _interopRequireDefault(_DeliveryAdaptableTimeSettings);

var _DeliveryFixTimeSettings = __webpack_require__("./sdk/scripts/entities/order/DeliveryFixTimeSettings.js");

var _DeliveryFixTimeSettings2 = _interopRequireDefault(_DeliveryFixTimeSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeliveryTimeSettings = function (_ApiObject) {
  _inherits(DeliveryTimeSettings, _ApiObject);

  function DeliveryTimeSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeliveryTimeSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliveryTimeSettings.__proto__ || Object.getPrototypeOf(DeliveryTimeSettings)).call.apply(_ref, [this].concat(args))), _this), _this.settingsType = DeliveryTimeSettings.Type.FIXED, _this.adaptableTimeSettings = new _DeliveryAdaptableTimeSettings2.default(), _this.fixTimeSettings = new _DeliveryFixTimeSettings2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeliveryTimeSettings, [{
    key: 'postJsonAsssignation',
    value: function postJsonAsssignation(data) {
      this.adaptableTimeSettings = new _DeliveryAdaptableTimeSettings2.default().fromJson(data.adaptableTimeSettings);
      this.fixTimeSettings = new _DeliveryFixTimeSettings2.default().fromJson(data.fixTimeSettings);
    }
  }]);

  return DeliveryTimeSettings;
}(_ApiObject3.default);

DeliveryTimeSettings.Type = {
  FIXED: 0,

  ADAPTABLE: 1
};
exports.default = DeliveryTimeSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OnSiteOrderSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _AbstractOrderModeSetting = __webpack_require__("./sdk/scripts/entities/order/AbstractOrderModeSetting.js");

var _AbstractOrderModeSetting2 = _interopRequireDefault(_AbstractOrderModeSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnSiteOrderSettings = function (_AbstractOrderModeSet) {
  _inherits(OnSiteOrderSettings, _AbstractOrderModeSet);

  function OnSiteOrderSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OnSiteOrderSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnSiteOrderSettings.__proto__ || Object.getPrototypeOf(OnSiteOrderSettings)).call.apply(_ref, [this].concat(args))), _this), _this.enabled = false, _this.orderAtBarAvailable = false, _this.preOrderAvailable = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * true if the on-site order mode is enabled.
   *
   * @type Boolean
   */


  /**
   * true if the on-site order mode is enabled for the bar.
   *
   * @type Boolean
   */


  return OnSiteOrderSettings;
}(_AbstractOrderModeSetting2.default);

exports.default = OnSiteOrderSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/Order.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _desc, _value, _class;

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _keymirror = __webpack_require__("./node_modules/keymirror/index.js");

var _keymirror2 = _interopRequireDefault(_keymirror);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _deprecated = __webpack_require__("./sdk/scripts/decorators/deprecated.js");

var _deprecated2 = _interopRequireDefault(_deprecated);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

var _Check = __webpack_require__("./sdk/scripts/entities/Check.js");

var _Check2 = _interopRequireDefault(_Check);

var _User = __webpack_require__("./sdk/scripts/entities/user/User.js");

var _User2 = _interopRequireDefault(_User);

var _OrderProduct = __webpack_require__("./sdk/scripts/entities/order/OrderProduct.js");

var _OrderProduct2 = _interopRequireDefault(_OrderProduct);

var _OrderMenu = __webpack_require__("./sdk/scripts/entities/order/OrderMenu.js");

var _OrderMenu2 = _interopRequireDefault(_OrderMenu);

var _UserAddress = __webpack_require__("./sdk/scripts/entities/user/UserAddress.js");

var _UserAddress2 = _interopRequireDefault(_UserAddress);

var _OrderSettings = __webpack_require__("./sdk/scripts/entities/order/OrderSettings.js");

var _OrderSettings2 = _interopRequireDefault(_OrderSettings);

var _OrderSource = __webpack_require__("./sdk/scripts/entities/order/OrderSource.js");

var _OrderSource2 = _interopRequireDefault(_OrderSource);

var _UserAccountPayment = __webpack_require__("./sdk/scripts/entities/order/UserAccountPayment.js");

var _UserAccountPayment2 = _interopRequireDefault(_UserAccountPayment);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Order = (_class = function (_ApiObject) {
  _inherits(Order, _ApiObject);

  function Order() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Order);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Order.__proto__ || Object.getPrototypeOf(Order)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.mode = Order.OrderMode.ON_SITE, _this.products = [], _this.menus = [], _this.status = Order.OrderStatus.CREATED, _this.userId = '', _this.restaurantId = '', _this.checkId = '', _this.paymentId = '', _this.dueDate = null, _this.modifiers = [], _this.creationDate = null, _this.modificationDate = null, _this.check = null, _this.user = null, _this.address = null, _this.userAccountPayment = null, _this.tableNumber = '', _this.deliveryTime = 0, _this.listItemsCart = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * See Order.OrderStatus
   * @type {string}
   */


  /**
   * distinct weither the user pays at the counter or with credit card
   * front only for now
   * @type {int}
   */

  /**
   * moment instance
   * @type {moment}
   */


  /**
   * moment instance
   * @type {moment}
   */


  /**
   * moment instance
   * @type {moment}
   */


  /*
   * front only
   */


  /*
   * front only
   */


  /**
   * In case of DELIVERY, contains the user's address where the delivery have to be made.
   */


  /**
   *
   */


  /**
   * an id generated by the api consumer to avoid the order/payment to be sent multiple times to the API. If the order request fails, the next order request should be sent with the same clientKey value. This value could be the timestamp of when the api consumer created the Order object on its side
   */


  /**
   * In case of DELIVERY mode, contains the delivery price to add.
   * Note: In the plugin, this var must be 0 until we sent the order.
   */
  /**
   * delivery time, set by the front.
   */


  /**
   * List of all items orderId (order products and menu) in the cart (sorted by add)
   * @type {Array}
   */


  _createClass(Order, [{
    key: 'postJsonAssignation',


    //
    //
    //

    value: function postJsonAssignation(data) {
      var _this2 = this;

      if (!_lodash2.default.isNil(data.id)) {
        this.id = data.id.toString();
      }

      this.dueDate = (0, _moment2.default)(data.dueDate);
      this.creationDate = (0, _moment2.default)(data.creationDate);
      this.modificationDate = (0, _moment2.default)(data.modificationDate);

      if (!_lodash2.default.isNil(data.userAccountPayment)) {
        this.userAccountPayment = new _UserAccountPayment2.default().fromJson(data.userAccountPayment);
      }

      this.products = [];
      _lodash2.default.each(data.products, function (productData) {
        var product = new _OrderProduct2.default();
        product.fromJson(productData);
        _this2.products.push(product);
      });

      this.menus = [];
      _lodash2.default.each(data.menus, function (menuData) {
        var menu = new _OrderMenu2.default();
        menu.fromJson(menuData);
        _this2.menus.push(menu);
      });

      this.source = new _OrderSource2.default().fromJson(data.source);
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(Order.prototype.__proto__ || Object.getPrototypeOf(Order.prototype), 'toJSON', this).call(this);

      if (!_lodash2.default.isNull(this.dueDate)) {
        json.dueDate = this.dueDate.valueOf();
      }
      delete json['creationDate'];
      delete json['modificationDate'];

      // split products per quantity
      var productsDetached = [];
      _lodash2.default.each(this.products, function (product) {
        for (var i = 0; i < product.quantity; i++) {
          var splittedProduct = product.copy();

          // to handle preview and reconstruct listItemsCart, we don't want to change the orderId
          // that is currently saved on listItemsCart.
          if (i !== 0) {
            splittedProduct.populateOrderId();
          }
          productsDetached.push(splittedProduct);
        }
      });

      json['products'] = productsDetached;

      // split menu per quantity
      var menusDetached = [];
      _lodash2.default.each(this.menus, function (menu) {
        for (var i = 0; i < menu.quantity; i++) {
          var splittedMenu = menu.copy();

          // to handle preview and reconstruct listItemsCart, we don't want to change the orderId
          // that is currently saved on listItemsCart.
          if (i !== 0) {
            splittedMenu.populateOrderId();
          }
          menusDetached.push(splittedMenu);
        }
      });

      json['menus'] = menusDetached;

      return json;
    }

    /**
     * get the current products and menus, and populate the listItemsCart with it.
     * Used for order preview.
     * We regroup products / menus that are equals.
     * We sort the listItemsCart in the same order than the ids given in parameter.
     * @param  {[type]} orderBy an array of orderId, to order our listItemsCart in the same order
     */

  }, {
    key: 'populateListItemsCart',
    value: function populateListItemsCart(orderByIds) {
      var _this3 = this;

      // contains all the current order ids.
      var allOrderIds = [];

      // contains the new listItemsCart
      var listItemsCart = [];

      // contains all products without double
      var productsUnique = [];
      this.products.forEach(function (product) {
        if (productsUnique.length > 0) {
          var loopFlag = true,
              pushFlag = false,
              pushProduct = void 0;

          productsUnique.forEach(function (baseProduct, index) {
            if (loopFlag) {
              if (baseProduct.equals(product)) {
                loopFlag = false;
                pushFlag = false;
                productsUnique[index].quantity++;
              } else {
                pushFlag = true;
                pushProduct = product;
              }
            }
          });

          if (pushFlag) {
            productsUnique.push(pushProduct);
          }
        } else {
          productsUnique.push(product);
        }
      });

      this.products = productsUnique;

      // contains all products without double
      var menusUnique = [];
      this.menus.forEach(function (menu) {
        if (menusUnique.length > 0) {
          var pushFlag = false;
          var pushMenu = void 0;
          menusUnique.forEach(function (baseMenu, index) {
            if (baseMenu.equals(menu)) {
              pushFlag = false;
              menusUnique[index].quantity++;
            } else {
              pushFlag = true;
              pushMenu = menu;
            }
          });

          if (pushFlag) {
            menusUnique.push(pushMenu);
          }
        } else {
          menusUnique.push(menu);
        }
      });

      this.menus = menusUnique;

      // get all the current order ids (products and menus are degrouped)
      allOrderIds = _lodash2.default.map(_lodash2.default.concat(this.products, this.menus), function (item) {
        return item.orderId;
      });

      // begin to put the old order ids on our new listItemsCart.
      listItemsCart = _lodash2.default.filter(orderByIds, function (orderId) {
        // if we can't find the item, then the API removed id, or an error occured somewhere.
        // so we don't add the id.
        return !_lodash2.default.isNull(_this3.getItemWithOrderId(orderId));
      });

      // contains all ids that are not on the param orderByIds.
      // all the new ids -> degroupate products / menus, products / menus that has been changed.
      var diff = _lodash2.default.difference(allOrderIds, listItemsCart);

      // our new products / menus array.
      var products = [];
      var menus = [];

      // populate our products / menus array with our items that we already have.
      _lodash2.default.each(listItemsCart, function (orderId) {
        var item = _this3.getItemWithOrderId(orderId);
        // item could not be null since `listItemsCart` is filtered and remove null objects.
        if (item instanceof _OrderMenu2.default) {
          menus.push(item.copy());
        } else {
          products.push(item.copy());
        }
      });

      // for all non matching order id with the given one in param, we search for an equal item
      // and merge it -> REGROUP menus / products
      _lodash2.default.each(diff, function (orderId) {
        var item = _this3.getItemWithOrderId(orderId);
        if (!_lodash2.default.isNil(item)) {
          if (item instanceof _OrderMenu2.default) {
            // find a menu that is equal
            var menu = _this3.findEqualsMenu(item);

            if (_lodash2.default.isNull(menu)) {
              // it is not a regroup, we add it.
              listItemsCart.push(orderId);
              menus.push(item.copy());
            } else {
              // we regroup.
              // obj is the menu that we already add on our new products array, if exists.
              var obj = _ArrayUtils2.default.find(menus, function (m) {
                return m.orderId === menu.orderId;
              });

              if (!_lodash2.default.isNull(obj)) {
                // already exists on our new array, update quantity
                obj.quantity++;
              } else {
                // do not exists, add it.
                var menuToUse = menu.copy();
                listItemsCart.push(menuToUse.orderId);
                menus.push(menuToUse);
              }
            }
          } else {
            // find a product that is equal
            var product = _this3.findEqualsProduct(item);

            if (_lodash2.default.isNull(product)) {
              // it is not a regroup, we add it.
              listItemsCart.push(orderId);
              products.push(item.copy());
            } else {
              // we regroup
              // obj is the product that we already add on our new products array, if exists.
              var _obj = _ArrayUtils2.default.find(products, function (p) {
                return p.orderId === product.orderId;
              });

              if (!_lodash2.default.isNull(_obj)) {
                // already exists on our new array, update quantity
                _obj.quantity++;
              } else {
                // do not exists, add it.
                var productToUse = product.copy();
                listItemsCart.push(productToUse.orderId);
                products.push(productToUse);
              }
            }
          }
        }
      });

      // in case there is a problem on our algorithm.
      if (products.length + menus.length !== listItemsCart.length) {
        _Logger2.default.error('Order.populateListItemsCart', 'error in algorithm');
      }

      // sort
      this.listItemsCart = listItemsCart;
      this.products = products;
      this.menus = menus;
    }
  }, {
    key: 'mergeUiDatas',
    value: function mergeUiDatas(previousOrder) {
      this.products.forEach(function (product) {
        var previousProduct = previousOrder.getProductWithId(product.id);
        if (!_lodash2.default.isEmpty(previousProduct)) {
          product.ui = previousProduct.ui;
        }
      });

      this.menus.forEach(function (menu) {
        var previousMenu = previousOrder.getMenuWithId(menu.id);
        if (!_lodash2.default.isEmpty(previousMenu)) {
          menu.ui = previousMenu.ui;
        }
      });
    }
  }, {
    key: 'getFormattedPickupDate',
    value: function getFormattedPickupDate() {
      return this.getFormattedDueDate();
    }

    /**
     * Returns the pickup date as a complete string.
     * @returns {String}
     */

  }, {
    key: 'getFormattedDueDate',
    value: function getFormattedDueDate() {
      var begin = '';
      var today = (0, _moment2.default)();
      var tomorrow = (0, _moment2.default)().add(1, 'days');

      if (_DateUtils2.default.isSameDay(this.dueDate, tomorrow)) {
        begin = _I18n2.default.tr('order.tomorrow_at');
      } else if (_DateUtils2.default.isSameDay(this.dueDate, today)) {
        begin = ''; //'Aujourd\'hui à';
      } else {
        begin = this.dueDate.format('DD/MM') + ' ' + _I18n2.default.tr('order.at');
      }

      return begin + ' ' + this.dueDate.format('HH:mm');
    }
  }, {
    key: 'getTableNumberString',
    value: function getTableNumberString() {
      if (this.isOnBar()) {
        return _I18n2.default.tr('order.at_bar');
      }

      return this.tableNumber;
    }
  }, {
    key: 'isOnBar',
    value: function isOnBar() {
      return !_lodash2.default.isNull(this.tableNumber) && this.tableNumber.toLowerCase() === 'bar';
    }
  }, {
    key: 'isDeliveryMode',
    value: function isDeliveryMode() {
      return this.mode === Order.OrderMode.DELIVERY;
    }
  }, {
    key: 'isTakeAwayMode',
    value: function isTakeAwayMode() {
      return this.mode === Order.OrderMode.TAKE_AWAY;
    }
  }, {
    key: 'isOnSiteMode',
    value: function isOnSiteMode() {
      return this.mode === Order.OrderMode.ON_SITE;
    }
  }, {
    key: 'isPayed',
    value: function isPayed() {
      if (this.userAccountPayment !== null) {
        return true;
      }

      if (this.paymentId === Order.ON_SITE_PAYMENT_ID) {
        return false;
      }

      if (_lodash2.default.isNil(this.check)) {
        return false;
      }

      return this.check.outstandingBalance === 0;
    }
  }, {
    key: 'isOnSitePayment',
    value: function isOnSitePayment() {
      return this.paymentId === Order.ON_SITE_PAYMENT_ID;
    }

    //
    // Status
    //

  }, {
    key: 'isOnGoing',
    value: function isOnGoing() {
      return !this.isCanceled() && !this.isFailed() && !this.isDelivered() && !this.isCreated();
    }
  }, {
    key: 'isForHistory',
    value: function isForHistory() {
      return this.isCanceled() || this.isDelivered();
    }
  }, {
    key: 'isCreated',
    value: function isCreated() {
      return this.status === Order.OrderStatus.CREATED;
    }
  }, {
    key: 'isFailed',
    value: function isFailed() {
      return this.status === Order.OrderStatus.FAILED;
    }
  }, {
    key: 'isCanceled',
    value: function isCanceled() {
      return this.status === Order.OrderStatus.CANCELED;
    }
  }, {
    key: 'isDelivered',
    value: function isDelivered() {
      return this.status === Order.OrderStatus.DELIVERED;
    }
  }, {
    key: 'isReceived',
    value: function isReceived() {
      return this.status === Order.OrderStatus.RECEIVED;
    }
  }, {
    key: 'isSent',
    value: function isSent() {
      return this.status === Order.OrderStatus.SENT;
    }

    /**
     * Returns the last 3 digits of the order number.
     * If the check is null or does not contains any pos check number, we use the order id.
     */

  }, {
    key: 'getOrderNumber',
    value: function getOrderNumber() {
      if (_lodash2.default.isNull(this.check) || _lodash2.default.isEmpty(this.check.posCheckNumber)) {
        return this.id.substr(this.id.length - 3);
      }

      return this.check.posCheckNumber.substr(this.check.posCheckNumber.length - 3);
    }

    /**
     * Returns the last 4 digits of the order number.
     * If the check is null or does not contains any pos check number, we use the order id.
     */

  }, {
    key: 'getOrderNumberMedium',
    value: function getOrderNumberMedium() {
      if (_lodash2.default.isNull(this.check) || _lodash2.default.isEmpty(this.check.posCheckNumber)) {
        return this.id.substr(this.id - 4);
      }

      return this.check.posCheckNumber.substr(this.check.posCheckNumber.length - 4);
    }

    /**
     * Returns the entire order number.
     * If the check is null or does not contains any pos check number, we use the order id.
     */

  }, {
    key: 'getFullOrderNumber',
    value: function getFullOrderNumber() {
      if (_lodash2.default.isNull(this.check) || _lodash2.default.isEmpty(this.check.posCheckNumber)) {
        return this.id;
      }

      return this.check.posCheckNumber;
    }

    //
    //
    //

  }, {
    key: 'haveReachMinimumPriceWithOrderSettings',
    value: function haveReachMinimumPriceWithOrderSettings(orderSettings) {
      var minimumPrice = orderSettings.getForMode(this.mode).minimumPrice;

      return minimumPrice === 0 || this.getTotalPrice() >= minimumPrice;
    }

    //
    //
    //

  }, {
    key: 'countItems',
    value: function countItems() {
      var products = { quantity: 0 },
          menus = { quantity: 0 };
      if (this.products.length > 0) {
        products = this.products.reduce(function (a, b) {
          return {
            quantity: a.quantity + b.quantity
          };
        });
      }

      if (this.menus.length > 0) {
        menus = this.menus.reduce(function (a, b) {
          return {
            quantity: a.quantity + b.quantity
          };
        });
      }

      return products.quantity + menus.quantity;
    }

    /**
     * Warning: do not use for DELIVERY mode when creating the order since the fees
     * depends of the orderSettings. 
     */

  }, {
    key: 'getTotalPrice',
    value: function getTotalPrice() {
      var total = 0;

      _lodash2.default.each(this.menus, function (orderMenu) {
        total += orderMenu.getTotalPriceWithQuantity();
      });

      _lodash2.default.each(this.products, function (orderProduct) {
        total += orderProduct.getTotalPriceWithQuantity();
      });

      _lodash2.default.each(this.fees, function (fee) {
        total += fee.amountIncludingTax;
      });

      /**
       * operations on double/float values results on total 10.100000000000001
       * so we round it
       */
      return Math.round(total * 100) / 100;
    }
  }, {
    key: 'getTotalPriceWhithoutTax',
    value: function getTotalPriceWhithoutTax() {
      if (_lodash2.default.isEmpty(this.check) || _lodash2.default.isEmpty(this.check.tax)) {
        return this.getTotalPrice();
      }

      var totalPriceWhithoutTax = 0;
      _lodash2.default.forEach(this.check.tax, function (tax) {
        totalPriceWhithoutTax += parseFloat(tax.amoutExclTax);
      });

      return totalPriceWhithoutTax;
    }

    /**
     * Returns the total price without the delivery fee.
     */

  }, {
    key: 'getTotalCartPrice',
    value: function getTotalCartPrice() {
      var total = 0;

      _lodash2.default.each(this.menus, function (orderMenu) {
        total += orderMenu.getTotalPriceWithQuantity();
      });

      _lodash2.default.each(this.products, function (orderProduct) {
        total += orderProduct.getTotalPriceWithQuantity();
      });

      return total;
    }

    //
    // used on BO for ticket print
    //

  }, {
    key: 'getMenusWithQuantities',
    value: function getMenusWithQuantities() {
      // contains the list of products, with the quantity for each
      return _lodash2.default.map(this.menus, function (orderMenu) {
        return {
          quantity: orderMenu.quantity,
          orderMenu: orderMenu
        };
      });
    }

    //
    // used on BO for ticket print
    //

  }, {
    key: 'getProductsWithQuantities',
    value: function getProductsWithQuantities() {
      // contains the list of products, with the quantity for each
      return _lodash2.default.map(this.products, function (orderProduct) {
        return {
          quantity: orderProduct.quantity,
          orderProduct: orderProduct
        };
      });
    }

    /**
     * Returns the cart content items, as an array of Product / Menus, sort by the added time.
     */

  }, {
    key: 'getCartItems',
    value: function getCartItems() {
      var _this4 = this;

      return _lodash2.default.map(this.listItemsCart, function (itemOrderId) {
        return _this4.getItemWithOrderId(itemOrderId);
      });
    }
  }, {
    key: 'getRemainingTime',
    value: function getRemainingTime() {
      return _moment2.default.duration(this.dueDate.valueOf() - (0, _moment2.default)().valueOf(), 'ms');
    }
  }, {
    key: 'getRemainingTimeLabel',
    value: function getRemainingTimeLabel() {
      var remainingTime = this.getRemainingTime();

      if (remainingTime.hours() < 0 || remainingTime.minutes() < 0 || remainingTime.hours() > 2 || remainingTime.days() > 0) {
        return this.getFormattedDueDate();
      }

      if (remainingTime.hours() === 0) {
        return remainingTime.minutes() + ' min';
      }

      if (remainingTime.minutes() === 0) {
        return remainingTime.hours() + 'h';
      }

      return remainingTime.hours() + 'h ' + remainingTime.minutes();
    }

    /**
     * Give a priority based on the dueDate and the delay.
     * The delay can be:
     * - the manufactureDelay
     * - in delivery mode, the calculate delay set on the order. don't need delay param here.
     *
     * @return  URGENT | WARNING | LATER | WAITING
     */

  }, {
    key: 'getPriority',
    value: function getPriority() {
      var delayParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      // create dates for calculs
      // const dateLimitToPrepare = moment().add(delay, 'ms');
      var now = (0, _moment2.default)();

      var delay = this.isDeliveryMode() && _lodash2.default.isNull(delayParam) ? this.deliveryTime : delayParam;

      // copy to not screw the real
      var dueDate = (0, _moment2.default)(this.dueDate);

      var dueDateMinusFive = (0, _moment2.default)(dueDate).subtract(5, 'minutes');

      if (this.isDeliveryMode()) {
        var beginPreparationDate = _DateUtils2.default.fromMsTimestamp(dueDate.valueOf() - delay);
        if (dueDate.isBefore(now)) {
          // same as other modes
          return Order.Priority.URGENT;
        } else if (now.isAfter(dueDateMinusFive)) {
          // same as other modes
          // 5 minutes before the due date
          return Order.Priority.WARNING;
        } else if (beginPreparationDate.isBefore(now)) {
          return Order.Priority.WAITING;
        }

        return Order.Priority.LATER;
      }

      // due Date have been reached
      if (dueDate.isBefore(now)) {
        return Order.Priority.URGENT;
      } else if (now.isAfter(dueDateMinusFive)) {
        // 5 minutes before the due date
        return Order.Priority.WARNING;
      } else if (dueDate.valueOf() > now.valueOf() + delay) {
        // far in the future.
        return Order.Priority.LATER;
      }

      return Order.Priority.WAITING;
    }

    //
    //
    //

  }, {
    key: 'getProductWithId',
    value: function getProductWithId(id) {
      return _ArrayUtils2.default.find(this.products, { id: id });
    }
  }, {
    key: 'getMenuWithId',
    value: function getMenuWithId(id) {
      return _ArrayUtils2.default.find(this.menus, { id: id });
    }
  }, {
    key: 'getProductWithOrderId',
    value: function getProductWithOrderId(orderId) {
      return _ArrayUtils2.default.find(this.products, function (orderProduct) {
        return orderProduct.orderId === orderId;
      });
    }
  }, {
    key: 'getMenuWithOrderId',
    value: function getMenuWithOrderId(orderId) {
      return _ArrayUtils2.default.find(this.menus, function (orderMenu) {
        return orderMenu.orderId === orderId;
      });
    }
  }, {
    key: 'getItemWithOrderId',
    value: function getItemWithOrderId(orderId) {
      var product = this.getProductWithOrderId(orderId);

      if (_lodash2.default.isNull(product)) {
        return this.getMenuWithOrderId(orderId);
      }

      return product;
    }
  }, {
    key: 'addOnListItemsCart',
    value: function addOnListItemsCart(orderId) {
      var exists = _ArrayUtils2.default.find(this.listItemsCart, function (orderIdToCompare) {
        return orderIdToCompare === orderId;
      });

      if (!exists) {
        this.listItemsCart.push(orderId);
      }
    }
  }, {
    key: 'updateOnListItemsCart',
    value: function updateOnListItemsCart(oldOrderId, orderId) {
      this.listItemsCart = _ArrayUtils2.default.updateObject(this.listItemsCart, orderId, function (orderIdToCompare) {
        return orderIdToCompare === oldOrderId;
      });
    }
  }, {
    key: 'removeOnListItemsCart',
    value: function removeOnListItemsCart(orderId) {
      this.listItemsCart = _ArrayUtils2.default.removeObject(this.listItemsCart, function (orderIdToCompare) {
        return orderIdToCompare === orderId;
      });
    }

    /**
     * Search for an orderProduct that is the same as the given one for the comment, options, etc.
     * @param  {[type]} orderProductToFind [description]
     * @return {[type]}                    [description]
     */

  }, {
    key: 'findEqualsProduct',
    value: function findEqualsProduct(orderProductToFind) {
      return _ArrayUtils2.default.find(this.products, function (orderProduct) {
        return orderProductToFind.equals(orderProduct);
      });
    }
  }, {
    key: 'addProduct',
    value: function addProduct(orderProduct) {
      var existingOrderProduct = this.findEqualsProduct(orderProduct);

      if (_lodash2.default.isNull(existingOrderProduct)) {
        // new orderProduct
        if (_lodash2.default.isNil(orderProduct.orderId) || _lodash2.default.isEmpty(orderProduct.orderId)) {
          orderProduct.populateOrderId();
        }
        this.products.push(orderProduct);
        this.addOnListItemsCart(orderProduct.orderId);
      } else {
        var orderProductWithNewQuantity = existingOrderProduct.copy();
        orderProductWithNewQuantity.quantity += 1;
        this.updateProduct(existingOrderProduct, orderProductWithNewQuantity);
      }
    }
  }, {
    key: 'updateProduct',
    value: function updateProduct(oldOrderProduct, orderProduct) {
      var _this5 = this;

      this.products = _ArrayUtils2.default.updateObject(this.products, orderProduct, function (orderProductToCompare) {
        if (orderProductToCompare.orderId === oldOrderProduct.orderId) {
          _this5.updateOnListItemsCart(oldOrderProduct.orderId, orderProduct.orderId);
          return true;
        }
        return false;
      });
    }

    /**
     * Remove a product from the cart.
     * Note: If the product quantity is greater than 1, we reduce the quantity by 1 if the
     * removeAll parameter is set to false.
     * @param  {[type]} orderProduct [description]
     * @return {[type]}              [description]
     */

  }, {
    key: 'removeProduct',
    value: function removeProduct(orderProduct) {
      var removeAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var existingOrderProduct = this.getProductWithOrderId(orderProduct.orderId);
      if (!_lodash2.default.isNull(existingOrderProduct)) {
        var orderProductWithNewQuantity = existingOrderProduct.copy();
        orderProductWithNewQuantity.quantity -= 1;

        if (orderProductWithNewQuantity.quantity >= 1 && removeAll === false) {
          this.updateProduct(existingOrderProduct, orderProductWithNewQuantity);
        } else {
          this.removeOnListItemsCart(orderProduct.orderId);
          this.products = _ArrayUtils2.default.removeObject(this.products, function (orderProductToCompare) {
            return orderProduct.orderId === orderProductToCompare.orderId;
          });
        }
      }
    }
  }, {
    key: 'removeProducts',
    value: function removeProducts(orderProducts) {
      var _this6 = this;

      _lodash2.default.each(orderProducts, function (orderProduct) {
        _this6.removeProduct(orderProduct);
      });
    }

    /**
     * Search for an orderMenu that is the same as the given one for the comment, options, etc.
     * @param  {[type]} orderMenuToFind [description]
     * @return {[type]}                 [description]
     */

  }, {
    key: 'findEqualsMenu',
    value: function findEqualsMenu(orderMenuToFind) {
      return _ArrayUtils2.default.find(this.menus, function (orderMenu) {
        return orderMenuToFind.equals(orderMenu);
      });
    }
  }, {
    key: 'addMenu',
    value: function addMenu(orderMenu) {
      var existingOrderMenu = this.findEqualsMenu(orderMenu);

      if (_lodash2.default.isNull(existingOrderMenu)) {
        // new orderMenu
        if (_lodash2.default.isNil(orderMenu.orderId) || _lodash2.default.isEmpty(orderMenu.orderId)) {
          orderMenu.populateOrderId();
        }
        this.menus.push(orderMenu);
        this.addOnListItemsCart(orderMenu.orderId);
      } else {
        var orderMenuWithNewQuantity = existingOrderMenu.copy();
        orderMenuWithNewQuantity.quantity += 1;
        this.updateMenu(existingOrderMenu, orderMenuWithNewQuantity);
      }
    }
  }, {
    key: 'updateMenu',
    value: function updateMenu(oldOrderMenu, orderMenu) {
      var _this7 = this;

      this.menus = _ArrayUtils2.default.updateObject(this.menus, orderMenu, function (orderMenuToCompare) {
        if (orderMenuToCompare.orderId === oldOrderMenu.orderId) {
          _this7.updateOnListItemsCart(oldOrderMenu.orderId, orderMenu.orderId);
          return true;
        }
        return false;
      });
    }

    /**
     * Remove a menu from the cart.
     * Note: If the menu quantity is greater than 1, we reduce the quantity by 1 if the
     * removeAll parameter is set to false.
     * @param  {[type]} orderMenu [description]
     * @return {[type]}              [description]
     */

  }, {
    key: 'removeMenu',
    value: function removeMenu(orderMenu) {
      var removeAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var existingOrderMenu = this.getMenuWithOrderId(orderMenu.orderId);

      if (!_lodash2.default.isNull(existingOrderMenu)) {
        var orderMenuWithNewQuantity = existingOrderMenu.copy();
        orderMenuWithNewQuantity.quantity -= 1;

        if (orderMenuWithNewQuantity.quantity >= 1 && removeAll === false) {
          this.updateMenu(existingOrderMenu, orderMenuWithNewQuantity);
        } else {
          this.removeOnListItemsCart(orderMenu.orderId);
          this.menus = _ArrayUtils2.default.removeObject(this.menus, function (orderMenuToCompare) {
            return orderMenu.orderId === orderMenuToCompare.orderId;
          });
        }
      }
    }
  }, {
    key: 'removeMenus',
    value: function removeMenus(orderMenus) {
      var _this8 = this;

      _lodash2.default.each(orderMenus, function (orderMenu) {
        _this8.removeMenu(orderMenu);
      });
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return _lodash2.default.isEmpty(this.products) && _lodash2.default.isEmpty(this.menus);
    }

    // check if max cancelable date is in the future

  }, {
    key: 'isCancelable',
    value: function isCancelable() {
      if (this.isCanceled() || this.isFailed()) {
        return false;
      }
      if (_lodash2.default.isNil(this.limitRefundDate)) {
        return false;
      }
      return Date.now() < this.limitRefundDate;
    }

    //
    //
    //

  }, {
    key: 'verifyItemsForDueDate',
    value: function verifyItemsForDueDate(dueDateParam, restaurantMenu) {
      var items = {
        products: [], // OrderProduct
        menus: [] // OrderMenu
      };

      var dueDate = (0, _moment2.default)(dueDateParam);

      _lodash2.default.each(this.products, function (orderProduct) {
        var product = restaurantMenu.getProductWithId(orderProduct.id);

        if (!product.isAvailableForDate(dueDate)) {
          items.products.push(orderProduct);
        }
      });

      _lodash2.default.each(this.menus, function (orderMenu) {
        var menu = restaurantMenu.getMenuWithId(orderMenu.id);

        if (!menu.isAvailableForDate(dueDate)) {
          items.menus.push(orderMenu);
        }
      });

      return items;
    }

    /**
     * Genere the deliveryTime
     * @param orderSettings
     * @param deliveryDistanceTime in case the DeliveryTimeSettings.settingsType === DeliveryTimeSettings.Type.ADAPTABLE, the front have to calculate the distance time between the
     * delivery address and the restaurant address.
     */

  }, {
    key: 'generateDeliveryTime',
    value: function generateDeliveryTime(orderSettings) {
      var deliveryDistanceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.deliveryTime = orderSettings.getDeliveryTime(deliveryDistanceTime);
    }
  }], [{
    key: 'getNextStatus',
    value: function getNextStatus(status, mode) {
      switch (status) {
        case Order.OrderStatus.CREATED:
          return Order.OrderStatus.SENT;

        case Order.OrderStatus.SENT:
          return Order.OrderStatus.RECEIVED;

        case Order.OrderStatus.RECEIVED:
          return Order.OrderStatus.PRODUCING;

        case Order.OrderStatus.PRODUCING:
          return Order.OrderStatus.READY;

        case Order.OrderStatus.READY:
          if (mode === Order.OrderMode.DELIVERY) {
            return Order.OrderStatus.IN_DELIVERY;
          } else {
            return Order.OrderStatus.DELIVERED;
          }

        case Order.OrderStatus.IN_DELIVERY:
          return Order.OrderStatus.DELIVERED;

        case Order.OrderStatus.DELIVERED:
          return '';

        case Order.OrderStatus.CANCELED:
          return '';

        default:
          _Logger2.default.warning('Order', 'getNextStatus: invalid mode ' + mode);
          return '';
      }
    }
  }, {
    key: 'getNextStatusForRestaurateur',
    value: function getNextStatusForRestaurateur(status, mode) {
      switch (status) {
        case Order.OrderStatus.CREATED:
          return Order.OrderStatus.RECEIVED;

        case Order.OrderStatus.SENT:
          return Order.OrderStatus.RECEIVED;

        case Order.OrderStatus.RECEIVED:
          return Order.OrderStatus.READY;

        // case Order.OrderStatus.PRODUCING:
        //   return Order.OrderStatus.READY;

        case Order.OrderStatus.READY:
          if (mode === Order.OrderMode.DELIVERY) {
            return Order.OrderStatus.IN_DELIVERY;
          }
          return Order.OrderStatus.DELIVERED;

        case Order.OrderStatus.IN_DELIVERY:
          return Order.OrderStatus.DELIVERED;

        case Order.OrderStatus.DELIVERED:
          return '';

        case Order.OrderStatus.CANCELED:
          return '';

        default:
          _Logger2.default.warning('Order', 'getNextStatus: invalid mode ' + mode);
          return '';
      }
    }
  }, {
    key: 'getStepsWithDelivery',
    value: function getStepsWithDelivery() {
      return [Order.OrderStatus.SENT, Order.OrderStatus.RECEIVED,
      // Order.OrderStatus.PRODUCING,
      Order.OrderStatus.READY, Order.OrderStatus.IN_DELIVERY, Order.OrderStatus.DELIVERED];
    }
  }, {
    key: 'getStepsWithoutDelivery',
    value: function getStepsWithoutDelivery() {
      return [Order.OrderStatus.SENT, Order.OrderStatus.RECEIVED,
      // Order.OrderStatus.PRODUCING,
      Order.OrderStatus.READY, Order.OrderStatus.DELIVERED];
    }
  }, {
    key: 'isStatusBefore',
    value: function isStatusBefore(statusToCheck, status) {
      var indexStatus = _lodash2.default.findIndex(Order.getStepsWithDelivery(), function (a) {
        return status === a;
      });

      var indexStatusToCheck = _lodash2.default.findIndex(Order.getStepsWithDelivery(), function (a) {
        return statusToCheck === a;
      });

      return indexStatusToCheck < indexStatus;
    }
  }]);

  return Order;
}(_ApiObject3.default), (_applyDecoratedDescriptor(_class.prototype, 'getFormattedPickupDate', [_deprecated2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'getFormattedPickupDate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getMenusWithQuantities', [_deprecated2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'getMenusWithQuantities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getProductsWithQuantities', [_deprecated2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'getProductsWithQuantities'), _class.prototype)), _class);
Order.Priority = (0, _keymirror2.default)({
  URGENT: null,
  WARNING: null,
  WAITING: null,
  LATER: null
});
Order.OrderMode = {
  ON_SITE: 0,

  TAKE_AWAY: 1,

  DELIVERY: 2
};
Order.PaymentMode = {
  CREDIT_CARD: 0,

  ON_SITE: 1,

  USER_ACCOUNT: 2
};
Order.ON_SITE_PAYMENT_ID = 0;
Order.OrderStatus = _ApiConstants2.default.OrderStatus;
exports.default = Order;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _StringUtils = __webpack_require__("./sdk/scripts/utils/StringUtils.js");

var _StringUtils2 = _interopRequireDefault(_StringUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _OrderMenuPart = __webpack_require__("./sdk/scripts/entities/order/OrderMenuPart.js");

var _OrderMenuPart2 = _interopRequireDefault(_OrderMenuPart);

var _OrderProduct = __webpack_require__("./sdk/scripts/entities/order/OrderProduct.js");

var _OrderProduct2 = _interopRequireDefault(_OrderProduct);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuPart = __webpack_require__("./sdk/scripts/entities/menu/MenuPart.js");

var _MenuPart2 = _interopRequireDefault(_MenuPart);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderMenu = function (_ApiObject) {
  _inherits(OrderMenu, _ApiObject);

  function OrderMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderMenu.__proto__ || Object.getPrototypeOf(OrderMenu)).call.apply(_ref, [this].concat(args))), _this), _this.parts = [], _this.price = 0, _this.basePrice = 0, _this.quantity = 1, _this.ui = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
    * Sets the quantity of the same product. Front only
    * Before sending the order, we split the OrderProduct with the quantity
    */


  // used to store ui data, will be merged back with order-preview


  _createClass(OrderMenu, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.parts = [];
      _lodash2.default.each(data.parts, function (partData) {
        var orderMenuPart = new _OrderMenuPart2.default();
        orderMenuPart.fromJson(partData);
        _this2.parts.push(orderMenuPart);
      });
    }
  }, {
    key: 'fromMenu',
    value: function fromMenu(menu, mode) {
      this.id = menu.id;
      this.name = menu.name;
      this.basePrice = menu.getPriceForMode(mode);
      this.price = this.basePrice;

      if (!_lodash2.default.isEmpty(menu.cartModifiers)) {
        this.price = menu.getCartModifiersPrice(mode);
      }
      return this;
    }
  }, {
    key: 'equals',
    value: function equals(other) {
      return this.id === other.id && this.comment === other.comment && this.partsEquals(other.parts) && this.price === other.price;
    }
  }, {
    key: 'partsEquals',
    value: function partsEquals(otherParts) {
      if (otherParts.length !== this.parts.length) {
        return false;
      }

      for (var i = 0; i < this.parts.length; i++) {
        if (!this.parts[i].equals(otherParts[i])) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: 'getAllProducts',
    value: function getAllProducts() {
      var allProducts = [];

      _lodash2.default.each(this.parts, function (part) {
        allProducts = _lodash2.default.concat(allProducts, part.products);
      });

      return allProducts;
    }

    /**
     * Merge options of `other` Order Product on this
     */

  }, {
    key: 'mergeWithOrderMenu',
    value: function mergeWithOrderMenu(menuInfo, other) {
      var _this3 = this;

      if (_lodash2.default.isNil(other)) {
        return;
      }

      var otherAllOrderProducts = other.getAllProducts();

      _lodash2.default.each(menuInfo.parts, function (part) {
        _lodash2.default.each(part.products, function (menuPartProduct) {
          var productOnOther = _ArrayUtils2.default.find(otherAllOrderProducts, function (orderProduct) {
            return orderProduct.id === menuPartProduct.id;
          });

          if (!_lodash2.default.isNull(productOnOther)) {
            var orderProductToPart = productOnOther.copy();
            orderProductToPart.baseAdditionalPrice = menuPartProduct.additionalPrice;
            orderProductToPart.additionalPrice = menuPartProduct.additionalPrice;

            // the product is on the menu and have been set on the other order menu.
            // we add it to hour part.
            _this3.addProductToPart(orderProductToPart, part);
          }
        });
      });
    }

    /**
     * Merge options of `other` Order Product on this
     */

  }, {
    key: 'mergeWithOrderProduct',
    value: function mergeWithOrderProduct(menuInfo, orderProductToMerge) {
      var _this4 = this;

      if (_lodash2.default.isNil(orderProductToMerge)) {
        return;
      }

      // find product on menu
      _lodash2.default.each(menuInfo.parts, function (part) {
        _lodash2.default.each(part.products, function (menuPartProduct) {
          if (menuPartProduct.id === orderProductToMerge.id) {
            var orderProductToPart = orderProductToMerge.copy();
            orderProductToPart.baseAdditionalPrice = menuPartProduct.additionalPrice;
            orderProductToPart.additionalPrice = menuPartProduct.additionalPrice;

            // the product to merge can be set on this part
            _this4.addProductToPart(orderProductToPart, part);
          }
        });
      });
    }

    //
    //
    //

  }, {
    key: 'getDescription',
    value: function getDescription() {
      var description = '';
      var separator = ', ';

      _lodash2.default.each(this.parts, function (part) {
        description += part.getDescription() + separator;
      });

      // remove last separator.
      return description.substring(0, description.length - separator.length);
    }
  }, {
    key: 'getProductsComment',
    value: function getProductsComment() {
      var comment = '';
      var separator = ', ';

      _lodash2.default.each(this.parts, function (part) {
        var productsComment = part.getProductsComment();
        if (!_lodash2.default.isEmpty(productsComment)) {
          comment += productsComment + separator;
        }
      });

      // remove last separator.
      return _StringUtils2.default.removeAtEnd(comment, separator);
    }
  }, {
    key: 'getDescriptionWithComments',
    value: function getDescriptionWithComments() {
      var description = '';
      var separator = ', ';

      _lodash2.default.each(this.parts, function (part) {
        description += part.getDescriptionWithProductComments() + separator;
      });

      // remove last separator.
      return description.substring(0, description.length - separator.length);
    }
  }, {
    key: 'getProductsWithCommentArray',
    value: function getProductsWithCommentArray() {
      var products = [];

      _lodash2.default.each(this.parts, function (part) {
        products = _lodash2.default.concat(products, part.getProductsWithCommentArray());
      });

      return products;
    }

    //
    //
    //

  }, {
    key: 'getPartWithId',
    value: function getPartWithId(partId) {
      return _ArrayUtils2.default.find(this.parts, { id: partId });
    }

    //
    //
    //

  }, {
    key: 'isValidWithRestaurantMenu',
    value: function isValidWithRestaurantMenu(restaurantMenu) {
      var _this5 = this;

      var res = true;

      if (_lodash2.default.isEmpty(this.parts)) {
        return false;
      }

      var menu = restaurantMenu.getMenuWithId(this.id);

      // verify all parts are here
      _lodash2.default.each(menu.parts, function (menuPart) {
        var found = _this5.getPartWithId(menuPart.id);

        // if not found and at least on product is required.
        if (!found && menuPart.min !== 0) {
          res = false;
          return false; // quit loop.
        }
      });

      if (!res) {
        return false;
      }

      // verify all parts are valid
      _lodash2.default.each(this.parts, function (part) {
        if (!part.isValidWithRestaurantMenu(restaurantMenu, _this5.id)) {
          res = false;
          return false; // quit loop.
        }
      });

      return res;
    }
  }, {
    key: 'isPartWithIdValidWithRestaurantMenu',
    value: function isPartWithIdValidWithRestaurantMenu(partId, restaurantMenu) {
      var part = this.getPartWithId(partId);

      if (_lodash2.default.isNil(part)) {
        return false;
      }

      return part.isValidWithRestaurantMenu(restaurantMenu, this.id);
    }

    //
    // Prices
    //

  }, {
    key: 'getTotalPrice',
    value: function getTotalPrice() {
      return this.price + this.getTotalPartsAdditionnalPrice();
    }
  }, {
    key: 'getTotalPriceWithQuantity',
    value: function getTotalPriceWithQuantity() {
      return this.getTotalPrice() * this.quantity;
    }
  }, {
    key: 'getTotalPartsAdditionnalPrice',
    value: function getTotalPartsAdditionnalPrice() {
      var total = 0;
      _lodash2.default.each(this.parts, function (part) {
        total += part.getTotalAdditionnalPrice();
      });
      return total;
    }

    //
    //
    //

  }, {
    key: 'populateOrderId',
    value: function populateOrderId() {
      this.orderId = 'm' + _Utils2.default.generateUID();
    }

    //
    //
    //

  }, {
    key: 'addProductToPart',
    value: function addProductToPart(orderProduct, menuPart) {
      var orderMenuPart = this.getPartWithId(menuPart.id);

      if (_lodash2.default.isNull(orderMenuPart)) {
        orderMenuPart = new _OrderMenuPart2.default().fromMenuPart(menuPart);
        this.parts.push(orderMenuPart);
      }

      orderMenuPart.addProduct(orderProduct);
    }
  }, {
    key: 'updateProductOnPart',
    value: function updateProductOnPart(orderProduct, menuPart) {
      var orderMenuPart = this.getPartWithId(menuPart.id);

      if (_lodash2.default.isNull(orderMenuPart)) {
        orderMenuPart = new _OrderMenuPart2.default().fromMenuPart(menuPart);
        this.parts.push(orderMenuPart);
      }

      orderMenuPart.updateProduct(orderProduct);
    }
  }, {
    key: 'removeProductWithIdFromPart',
    value: function removeProductWithIdFromPart(orderProductId, menuPart) {
      var orderMenuPart = this.getPartWithId(menuPart.id);

      if (_lodash2.default.isNull(orderMenuPart)) {
        orderMenuPart = new _OrderMenuPart2.default().fromMenuPart(menuPart);
        this.parts.push(orderMenuPart);
      }

      orderMenuPart.removeProductWithId(orderProductId);
    }
  }, {
    key: 'haveProductWithIdForPartWithId',
    value: function haveProductWithIdForPartWithId(productId, partId) {
      var orderMenuPart = this.getPartWithId(partId);

      if (_lodash2.default.isNull(orderMenuPart)) {
        return false;
      }

      return orderMenuPart.haveProductWithId(productId);
    }
  }]);

  return OrderMenu;
}(_ApiObject3.default);

exports.default = OrderMenu;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderMenuPart.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _StringUtils = __webpack_require__("./sdk/scripts/utils/StringUtils.js");

var _StringUtils2 = _interopRequireDefault(_StringUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _OrderProduct = __webpack_require__("./sdk/scripts/entities/order/OrderProduct.js");

var _OrderProduct2 = _interopRequireDefault(_OrderProduct);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _Menu = __webpack_require__("./sdk/scripts/entities/menu/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuPart = __webpack_require__("./sdk/scripts/entities/menu/MenuPart.js");

var _MenuPart2 = _interopRequireDefault(_MenuPart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderMenuPart = function (_ApiObject) {
  _inherits(OrderMenuPart, _ApiObject);

  function OrderMenuPart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderMenuPart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderMenuPart.__proto__ || Object.getPrototypeOf(OrderMenuPart)).call.apply(_ref, [this].concat(args))), _this), _this.products = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderMenuPart, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.products = [];
      _lodash2.default.each(data.products, function (productData) {
        var orderProduct = new _OrderProduct2.default();
        orderProduct.fromJson(productData);
        _this2.products.push(orderProduct);
      });
    }
  }, {
    key: 'fromMenuPart',
    value: function fromMenuPart(menuPart) {
      this.id = menuPart.id;
      this.name = menuPart.name;
      return this;
    }

    //
    //
    //

  }, {
    key: 'isValidWithRestaurantMenu',
    value: function isValidWithRestaurantMenu(restaurantMenu, menuId) {
      var menu = restaurantMenu.getMenuWithId(menuId);
      var menuPart = menu.getPartWithId(this.id);

      var quantityMin = menuPart.min;
      var quantityMax = menuPart.max;

      if (this.products.length < quantityMin || this.products.length > quantityMax) {
        return false;
      }

      var res = true;
      _lodash2.default.each(this.products, function (product) {
        if (!product.isValidWithRestaurantMenu(restaurantMenu)) {
          res = false;
          return false; // quit loop
        }
      });

      return res;
    }

    //
    //
    //

  }, {
    key: 'equals',
    value: function equals(other) {
      return this.id === other.id && this.productsEquals(other.products);
    }
  }, {
    key: 'productsEquals',
    value: function productsEquals(otherProducts) {
      if (otherProducts.length !== this.products.length) {
        return false;
      }

      // TODO: Handle not same order.
      for (var i = 0; i < this.products.length; i++) {
        if (!this.products[i].equals(otherProducts[i])) {
          return false;
        }
      }

      return true;
    }

    //
    //
    //

  }, {
    key: 'getDescription',
    value: function getDescription() {
      var description = '';
      var separator = ', ';

      _lodash2.default.each(this.products, function (product) {
        description += product.name + separator;
      });

      // remove last separator.
      return description.substring(0, description.length - separator.length);
    }
  }, {
    key: 'getProductsComment',
    value: function getProductsComment() {
      var comment = '';
      var separator = ', ';

      _lodash2.default.each(this.products, function (product) {
        if (!_lodash2.default.isEmpty(product.comment)) {
          comment += product.comment + separator;
        }
      });

      // remove last separator.
      return _StringUtils2.default.removeAtEnd(comment, separator);
    }
  }, {
    key: 'getDescriptionWithProductComments',
    value: function getDescriptionWithProductComments() {
      var description = '';
      var separator = ', ';

      _lodash2.default.each(this.products, function (product) {
        description += product.name;
        if (!_lodash2.default.isEmpty(product.comment)) {
          description += ' (' + product.comment + ')';
        }
        description += separator;
      });

      // remove last separator.
      return description.substring(0, description.length - separator.length);
    }
  }, {
    key: 'getProductsWithCommentArray',
    value: function getProductsWithCommentArray() {
      var productsWithComment = [];

      _lodash2.default.each(this.products, function (product) {
        productsWithComment.push({
          productName: product.name,
          comment: product.comment,
          product: product
        });
      });

      return productsWithComment;
    }

    //
    //
    //

  }, {
    key: 'getTotalAdditionnalPrice',
    value: function getTotalAdditionnalPrice() {
      var total = 0;
      _lodash2.default.each(this.products, function (orderProduct) {
        total += orderProduct.getTotalAdditionnalPriceForMenu();
      });
      return total;
    }

    //
    //
    //

  }, {
    key: 'addProduct',
    value: function addProduct(orderProduct) {
      this.products.push(orderProduct);
    }
  }, {
    key: 'updateProduct',
    value: function updateProduct(orderProduct) {
      this.products = _ArrayUtils2.default.updateObject(this.products, { id: orderProduct.id });
    }
  }, {
    key: 'removeProductWithId',
    value: function removeProductWithId(orderProductId) {
      this.products = _ArrayUtils2.default.removeObject(this.products, { id: orderProductId });
    }
  }, {
    key: 'getProductById',
    value: function getProductById(productId) {
      return _ArrayUtils2.default.find(this.products, { id: productId });
    }
  }, {
    key: 'haveProductWithId',
    value: function haveProductWithId(productId) {
      return _ArrayUtils2.default.exists(this.products, { id: productId });
    }
  }]);

  return OrderMenuPart;
}(_ApiObject3.default);

exports.default = OrderMenuPart;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderNotificationSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingNotificationSettings = function (_ApiObject) {
  _inherits(BookingNotificationSettings, _ApiObject);

  function BookingNotificationSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingNotificationSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingNotificationSettings.__proto__ || Object.getPrototypeOf(BookingNotificationSettings)).call.apply(_ref, [this].concat(args))), _this), _this.emails = [], _this.phones = [], _this.phoneEnabled = false, _this.emailEnabled = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BookingNotificationSettings, [{
    key: 'isDisabled',
    value: function isDisabled() {
      return !this.phoneEnabled && !this.emailEnabled;
    }
  }]);

  return BookingNotificationSettings;
}(_ApiObject3.default);

exports.default = BookingNotificationSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderProduct.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _OrderProductOption = __webpack_require__("./sdk/scripts/entities/order/OrderProductOption.js");

var _OrderProductOption2 = _interopRequireDefault(_OrderProductOption);

var _Product = __webpack_require__("./sdk/scripts/entities/menu/Product.js");

var _Product2 = _interopRequireDefault(_Product);

var _RestaurantMenu = __webpack_require__("./sdk/scripts/entities/menu/RestaurantMenu.js");

var _RestaurantMenu2 = _interopRequireDefault(_RestaurantMenu);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

var _MenuPartProduct = __webpack_require__("./sdk/scripts/entities/menu/MenuPartProduct.js");

var _MenuPartProduct2 = _interopRequireDefault(_MenuPartProduct);

var _CategoryItem = __webpack_require__("./sdk/scripts/entities/menu/CategoryItem.js");

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderProduct = function (_ApiObject) {
  _inherits(OrderProduct, _ApiObject);

  function OrderProduct() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderProduct);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderProduct.__proto__ || Object.getPrototypeOf(OrderProduct)).call.apply(_ref, [this].concat(args))), _this), _this.options = [], _this.comment = '', _this.price = 0, _this.basePrice = 0, _this.additionalPrice = 0, _this.baseAdditionalPrice = 0, _this.quantity = 1, _this.ui = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
    * Sets the quantity of the same product. Front only
    * Before sending the order, we split the OrderProduct with the quantity
    */


  // used to store ui data, will be merged back with order-preview


  _createClass(OrderProduct, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.options = [];
      _lodash2.default.each(data.options, function (optionData) {
        var orderProductOption = new _OrderProductOption2.default();
        orderProductOption.fromJson(optionData);
        _this2.options.push(orderProductOption);
      });
    }
  }, {
    key: 'fromProduct',
    value: function fromProduct(product, mode) {
      this.id = product.id;
      this.name = product.name;
      this.basePrice = product.getPriceForMode(mode);
      this.price = this.basePrice;

      if (!_lodash2.default.isEmpty(product.cartModifiers)) {
        this.price = product.getCartModifiersPrice(mode);
      }

      return this;
    }
  }, {
    key: 'fromProductAndMenuPartProduct',
    value: function fromProductAndMenuPartProduct(product, menuPartProduct, mode) {
      this.fromProduct(product, mode);

      this.baseAdditionalPrice = menuPartProduct.additionalPrice;
      this.additionalPrice = this.baseAdditionalPrice;

      return this;
    }

    //
    //
    //

  }, {
    key: 'isValidWithRestaurantMenu',
    value: function isValidWithRestaurantMenu(restaurantMenu) {
      var _this3 = this;

      var product = restaurantMenu.getProductWithId(this.id);

      // const options = restaurantMenu.getProductOptionsWithIds(product.optionsIds);
      var requiredOptions = restaurantMenu.getRequiredProductOptionsWithIds(product.optionsIds);

      // verify all required options are set.
      var res = true;
      _lodash2.default.each(requiredOptions, function (requiredProductOption) {
        var option = _ArrayUtils2.default.find(_this3.options, { 'id': requiredProductOption.id });

        if (_lodash2.default.isNil(option)) {
          res = false;
          return false; // quit loop.
        } else {
          // verify values are ok.
          if (option.values.length < requiredProductOption.quantityMin) {
            res = false;
            return false; // quit loop.
          }
        }
      });

      return res;
    }

    //
    //
    //

  }, {
    key: 'equals',
    value: function equals(other) {
      return this.id === other.id && this.comment === other.comment && this.optionsEquals(other.options) && this.price === other.price;
    }
  }, {
    key: 'optionsEquals',
    value: function optionsEquals(otherOptions) {
      if (otherOptions.length !== this.options.length) {
        return false;
      }

      // TODO: Handle not same order.
      for (var i = 0; i < this.options.length; i++) {
        if (!this.options[i].equals(otherOptions[i])) {
          return false;
        }
      }

      return true;
    }

    /**
     * Merge options of `other` Order Product on this
     */

  }, {
    key: 'mergeWithOrderProduct',
    value: function mergeWithOrderProduct(productInfo, other) {
      var _this4 = this;

      _lodash2.default.each(other.options, function (otherOption) {
        if (productInfo.haveOptionWithId(otherOption.id)) {
          // our product have the option, we copy the option to our current object
          _this4.options.push(otherOption.copy());
        }
      });
    }

    //
    //
    //

  }, {
    key: 'getDescription',
    value: function getDescription() {
      var description = '';
      var separator = ', ';

      _lodash2.default.each(this.options, function (option) {
        description += option.getDescription() + separator;
      });

      // remove last separator.
      return description.substring(0, description.length - separator.length);
    }
  }, {
    key: 'getTotalPrice',
    value: function getTotalPrice() {
      return this.price + this.getTotalOptionsAdditionnalPrice();
    }
  }, {
    key: 'getTotalPriceWithQuantity',
    value: function getTotalPriceWithQuantity() {
      return this.getTotalPrice() * this.quantity;
    }
  }, {
    key: 'getTotalAdditionnalPriceForMenu',
    value: function getTotalAdditionnalPriceForMenu() {
      return this.additionalPrice + this.getTotalOptionsAdditionnalPrice();
    }
  }, {
    key: 'getTotalOptionsAdditionnalPrice',
    value: function getTotalOptionsAdditionnalPrice() {
      var price = 0;
      _lodash2.default.each(this.options, function (orderProductOption) {
        price += orderProductOption.getTotalAdditionnalPrice();
      });

      return price;
    }

    //
    //
    //

  }, {
    key: 'getOptionWithId',
    value: function getOptionWithId(optionId) {
      return _ArrayUtils2.default.find(this.options, { 'id': optionId });
    }

    //
    //
    //

  }, {
    key: 'populateOrderId',
    value: function populateOrderId() {
      this.orderId = 'p' + _Utils2.default.generateUID();
    }

    //
    //
    //

  }, {
    key: 'addOption',
    value: function addOption(orderProductOption) {
      this.options.push(orderProductOption);
    }
  }, {
    key: 'deleteOption',
    value: function deleteOption(orderProductOption) {
      this.options = _ArrayUtils2.default.removeObject(this.options, { 'id': orderProductOption.id });
    }
  }, {
    key: 'updateOrAddOption',
    value: function updateOrAddOption(orderProductOption) {
      this.options = _ArrayUtils2.default.updateObjectOrAdd(this.options, orderProductOption, { 'id': orderProductOption.id });
    }
  }, {
    key: 'updateOption',
    value: function updateOption(orderProductOption) {
      this.options = _ArrayUtils2.default.updateObject(this.options, orderProductOption, { 'id': orderProductOption.id });
    }
  }]);

  return OrderProduct;
}(_ApiObject3.default);

exports.default = OrderProduct;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderProductOption.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _OrderProductOptionValue = __webpack_require__("./sdk/scripts/entities/order/OrderProductOptionValue.js");

var _OrderProductOptionValue2 = _interopRequireDefault(_OrderProductOptionValue);

var _ProductOption = __webpack_require__("./sdk/scripts/entities/menu/ProductOption.js");

var _ProductOption2 = _interopRequireDefault(_ProductOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderProductOption = function (_ApiObject) {
  _inherits(OrderProductOption, _ApiObject);

  function OrderProductOption() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderProductOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderProductOption.__proto__ || Object.getPrototypeOf(OrderProductOption)).call.apply(_ref, [this].concat(args))), _this), _this.values = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderProductOption, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.values = [];
      _lodash2.default.each(data.values, function (valueData) {
        var orderProductOptionValue = new _OrderProductOptionValue2.default();
        orderProductOptionValue.fromJson(valueData);
        _this2.values.push(orderProductOptionValue);
      });
    }
  }, {
    key: 'equals',
    value: function equals(other) {
      return this.id === other.id && this.valuesEquals(other.values);
    }
  }, {
    key: 'valuesEquals',
    value: function valuesEquals(otherValues) {
      // TODO: Handle not same order.
      if (otherValues.length !== this.values.length) {
        return false;
      }
      for (var i = 0; i < this.values.length; i++) {
        if (!this.values[i].equals(otherValues[i])) {
          return false;
        }
      }

      return true;
    }

    //
    //
    //

  }, {
    key: 'getDescription',
    value: function getDescription() {
      var description = '';
      var separator = ', ';

      _lodash2.default.each(this.values, function (optionValue) {
        description += optionValue.name + separator;
      });

      // remove last separator.
      return description.substring(0, description.length - separator.length);
    }
  }, {
    key: 'getQuantity',
    value: function getQuantity() {
      return this.values.length;
    }
  }, {
    key: 'getTotalAdditionnalPrice',
    value: function getTotalAdditionnalPrice() {
      return this.getTotalValuesAdditionnalPrice();
    }
  }, {
    key: 'getTotalValuesAdditionnalPrice',
    value: function getTotalValuesAdditionnalPrice() {
      var price = 0;
      _lodash2.default.each(this.values, function (orderProductOptionValue) {
        price += orderProductOptionValue.getTotalAdditionnalPrice();
      });

      return price;
    }
  }, {
    key: 'getValuesWithQuantities',
    value: function getValuesWithQuantities() {
      // contains the list of products, with the quantity for each
      var valuesWithQuantities = [];

      _lodash2.default.each(this.values, function (orderProductOptionValue, index) {
        // search for an already set orderProduct.
        var found = _lodash2.default.find(valuesWithQuantities, function (valueWithQuantity) {
          var optionValueToCompare = valueWithQuantity.orderProductOptionValue;

          return optionValueToCompare.equals(orderProductOptionValue);
        });

        // not found
        if (_lodash2.default.isUndefined(found)) {
          valuesWithQuantities.push({
            quantity: 1,
            orderProductOptionValue: orderProductOptionValue
          });
        } else {
          // update array
          found.quantity++;
        }
      });

      return valuesWithQuantities;
    }
  }, {
    key: 'haveValueWithId',
    value: function haveValueWithId(valueId) {
      return _ArrayUtils2.default.exists(this.values, { 'id': valueId });
    }
  }, {
    key: 'haveValue',
    value: function haveValue(optionValue) {
      return _ArrayUtils2.default.exists(this.values, { 'id': optionValue.id });
    }

    //
    //
    //

  }, {
    key: 'toggleOptionValue',
    value: function toggleOptionValue(optionValue) {
      if (this.haveValue(optionValue)) {
        this.deleteValue(optionValue);
      } else {
        this.addValue(optionValue);
      }
    }
  }, {
    key: 'addValue',
    value: function addValue(optionValue) {
      this.values.push(optionValue);
    }
  }, {
    key: 'deleteValue',
    value: function deleteValue(optionValue) {
      this.values = _ArrayUtils2.default.removeObject(this.values, { 'id': optionValue.id });
    }
  }, {
    key: 'replaceOlderValueWith',
    value: function replaceOlderValueWith(optionValue) {
      // TODO: test
      this.deleteValue(this.values[0]);
      this.addValue(optionValue);
    }
  }, {
    key: 'fromProductOption',
    value: function fromProductOption(option) {
      this.id = option.id;
      this.name = option.name;
    }
  }]);

  return OrderProductOption;
}(_ApiObject3.default);

exports.default = OrderProductOption;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderProductOptionValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProductOptionValue = __webpack_require__("./sdk/scripts/entities/menu/ProductOptionValue.js");

var _ProductOptionValue2 = _interopRequireDefault(_ProductOptionValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderProductOptionValue = function (_ApiObject) {
  _inherits(OrderProductOptionValue, _ApiObject);

  function OrderProductOptionValue() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderProductOptionValue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderProductOptionValue.__proto__ || Object.getPrototypeOf(OrderProductOptionValue)).call.apply(_ref, [this].concat(args))), _this), _this.additionalPrice = 0, _this.baseAdditionalPrice = 0, _this.name = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderProductOptionValue, [{
    key: 'getTotalAdditionnalPrice',
    value: function getTotalAdditionnalPrice() {
      return this.additionalPrice;
    }
  }, {
    key: 'equals',
    value: function equals(other) {
      return this.id === other.id;
    }
  }, {
    key: 'fromProductOptionValue',
    value: function fromProductOptionValue(value) {
      this.id = value.id;
      this.name = value.name;
      this.baseAdditionalPrice = value.additionalPrice;
      this.additionalPrice = value.additionalPrice;

      return this;
    }
  }]);

  return OrderProductOptionValue;
}(_ApiObject3.default);

exports.default = OrderProductOptionValue;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _OpeningHours = __webpack_require__("./sdk/scripts/entities/OpeningHours.js");

var _OpeningHours2 = _interopRequireDefault(_OpeningHours);

var _OnSiteOrderSettings = __webpack_require__("./sdk/scripts/entities/order/OnSiteOrderSettings.js");

var _OnSiteOrderSettings2 = _interopRequireDefault(_OnSiteOrderSettings);

var _TakeAwayOrderSettings = __webpack_require__("./sdk/scripts/entities/order/TakeAwayOrderSettings.js");

var _TakeAwayOrderSettings2 = _interopRequireDefault(_TakeAwayOrderSettings);

var _DeliveryOrderSettings = __webpack_require__("./sdk/scripts/entities/order/DeliveryOrderSettings.js");

var _DeliveryOrderSettings2 = _interopRequireDefault(_DeliveryOrderSettings);

var _DeliveryTimeSettings = __webpack_require__("./sdk/scripts/entities/order/DeliveryTimeSettings.js");

var _DeliveryTimeSettings2 = _interopRequireDefault(_DeliveryTimeSettings);

var _OrderNotificationSettings = __webpack_require__("./sdk/scripts/entities/order/OrderNotificationSettings.js");

var _OrderNotificationSettings2 = _interopRequireDefault(_OrderNotificationSettings);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderSettings = function (_ApiObject) {
  _inherits(OrderSettings, _ApiObject);

  function OrderSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderSettings.__proto__ || Object.getPrototypeOf(OrderSettings)).call.apply(_ref, [this].concat(args))), _this), _this.menuManagedByPos = false, _this.openingHours = new _OpeningHours2.default(), _this.onSiteSettings = new _OnSiteOrderSettings2.default(), _this.takeAwaySettings = new _TakeAwayOrderSettings2.default(), _this.deliverySettings = new _DeliveryOrderSettings2.default(), _this.notificationSettings = new _OrderNotificationSettings2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
  * the list of openned periods for which to allow the order
  */


  /**
  * The time needed by the restaurant to prepare some more food.
  * This should be taken into consideration when ordering food for a specific date
  */


  /**
  * Contains the description of all the order settings specific to the On-Site order mode
  */


  /**
   * Contains the description of all the order settings specific to the Take-Away order mode
   */


  /**
  * Contains the description of all the order settings specific to the Delivery order mode
  */


  _createClass(OrderSettings, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.openingHours = new _OpeningHours2.default();
      this.openingHours.fromJson(data.openingHours);

      this.onSiteSettings = new _OnSiteOrderSettings2.default();
      this.onSiteSettings.fromJson(data.onSiteSettings);

      this.takeAwaySettings = new _TakeAwayOrderSettings2.default();
      this.takeAwaySettings.fromJson(data.takeAwaySettings);

      this.deliverySettings = new _DeliveryOrderSettings2.default();
      this.deliverySettings.fromJson(data.deliverySettings);

      this.notificationSettings = new _OrderNotificationSettings2.default();
      this.notificationSettings.fromJson(data.notificationSettings);
    }
  }, {
    key: 'getForMode',
    value: function getForMode(orderMode) {
      switch (orderMode) {
        case _Order2.default.OrderMode.ON_SITE:
          return this.onSiteSettings;
        case _Order2.default.OrderMode.TAKE_AWAY:
          return this.takeAwaySettings;
        case _Order2.default.OrderMode.DELIVERY:
          return this.deliverySettings;
        default:
          return null;
      }
    }
  }, {
    key: 'isEnabledForMode',
    value: function isEnabledForMode(orderMode) {
      var settings = this.getForMode(orderMode);

      if (_lodash2.default.isNil(settings)) {
        return false;
      }

      return settings.enabled;
    }
  }, {
    key: 'isOnSiteEnabled',
    value: function isOnSiteEnabled() {
      return this.onSiteSettings.enabled;
    }
  }, {
    key: 'isTakeAwayEnabled',
    value: function isTakeAwayEnabled() {
      return this.takeAwaySettings.enabled;
    }
  }, {
    key: 'isDeliveryEnabled',
    value: function isDeliveryEnabled() {
      return this.deliverySettings.enabled;
    }
  }, {
    key: 'getManufactureDelayAsMinutes',
    value: function getManufactureDelayAsMinutes() {
      return _DateUtils2.default.millisecondsToMinutes(this.manufactureDelay);
    }
  }, {
    key: 'generateSlotsForDate',
    value: function generateSlotsForDate(date) {
      var delayParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var isOpen = this.openingHours.isDayOpen(_DateUtils2.default.getPmtDayIndex(date));

      var delay = delayParam;
      if (_lodash2.default.isNull(delayParam)) {
        delay = this.manufactureDelay;
      }

      var nowHourTimestamp = _DateUtils2.default.getTimestampForHourWithDate((0, _moment2.default)().add(1, 'minute'));

      if (isOpen) {
        var slots = this.getSlotsForDay(_DateUtils2.default.getPmtDayIndex(date));
        var finalSlots = [];

        // is today, remove past slots
        finalSlots = _lodash2.default.filter(slots, function (slot) {
          return !_DateUtils2.default.isToday(date) || slot > nowHourTimestamp + delay;
        });

        return {
          date: _DateUtils2.default.toStartOfDay(date),
          slots: finalSlots
        };
      }

      return {
        date: _DateUtils2.default.toStartOfDay(date),
        slots: []
      };
    }

    /**
     * Note: moment.js .day() use sunday as first day.
     * We use monday as first day on the API
     *
     * @param numberOfDays: 0 is just today 2 is today and the 2 following days
     */

  }, {
    key: 'generateSlotsForNextDays',
    value: function generateSlotsForNextDays(numberOfDays) {
      var delayParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var date = _DateUtils2.default.toStartOfDay((0, _moment2.default)());
      var slotsDates = [];

      for (var i = 0; i < numberOfDays + 1; i++) {
        slotsDates.push(this.generateSlotsForDate((0, _moment2.default)(date), delayParam));

        // reset to start of day just in case.
        date = (0, _moment2.default)(date).add(1, 'days');
      }

      // remove days with no slots
      var slots = [];
      _lodash2.default.each(slotsDates, function (slotDate) {
        if (!_lodash2.default.isEmpty(slotDate.slots)) {
          slots.push(slotDate);
        }
      });

      return slots;
    }

    /**
     * Warning: moment.js week start at sunday, not monday
     */

  }, {
    key: 'getSlotsForDay',
    value: function getSlotsForDay(dayIndex) {
      return this.openingHours.generateHoursForDay(dayIndex);
    }
  }, {
    key: 'isDateBeforeMinTime',
    value: function isDateBeforeMinTime(date) {
      if (!_DateUtils2.default.isToday(date.valueOf())) {
        return false;
      }

      var firstSlotHour = this.getNextSlotHour();

      if (firstSlotHour === -1) {
        return true; // TODO: handle error
      }

      var todayTimestamp = _DateUtils2.default.toStartOfDay((0, _moment2.default)());

      var firstSlot = todayTimestamp + firstSlotHour;

      if (firstSlot > date.valueOf()) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isValidDate',
    value: function isValidDate(date) {
      var delayParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var slotsForDay = this.generateSlotsForDate(date, delayParam);
      var dateSlot = _DateUtils2.default.getSlotFromDate(date);

      var res = false;

      _lodash2.default.each(slotsForDay.slots, function (slot) {
        if (slot === dateSlot) {
          res = true;
          return false; // quit loop
        }
      });

      return res;
    }
  }, {
    key: 'getNextSlotHour',
    value: function getNextSlotHour() {
      var delayParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var slotsForDays = this.generateSlotsForNextDays(7, delayParam); // in case today is finished.

      if (_lodash2.default.isEmpty(slotsForDays)) {
        return -1;
      }

      var daySlots = slotsForDays[0].slots;

      if (_lodash2.default.isEmpty(daySlots)) {
        return -1;
      }

      var firstSlotHour = daySlots[0];

      return firstSlotHour;
    }
  }, {
    key: 'getNextSlotDate',
    value: function getNextSlotDate() {
      var delayParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var slotsForDays = this.generateSlotsForNextDays(7, delayParam); // in case today is finished.

      if (_lodash2.default.isEmpty(slotsForDays)) {
        return -1;
      }

      var daySlots = slotsForDays[0].slots;

      if (_lodash2.default.isEmpty(daySlots)) {
        return -1;
      }

      var firstSlotHour = daySlots[0];

      var nextSlotDate = (0, _moment2.default)(slotsForDays[0].date.valueOf() + firstSlotHour);

      return nextSlotDate;
    }

    //
    // Delivery
    //

    /**
     * Returns the delivery price according to the given amount.
     * The delivery can be free when the minimumPriceForFreeDelivery is reached.
     */

  }, {
    key: 'getDeliveryPriceForAmount',
    value: function getDeliveryPriceForAmount(amount) {
      if (_lodash2.default.isNil(this.deliverySettings)) {
        return 0;
      }

      // if the minimumPriceForFreeDelivery, there is no possibility to have a free delivery
      // if (this.deliverySettings.minimumPriceForFreeDelivery) {
      //   return this.deliverySettings.deliveryPrice;
      // }

      return amount >= this.deliverySettings.minimumPriceForFreeDelivery ? 0 : this.deliverySettings.deliveryPrice;
    }
  }, {
    key: 'getDeliveryMinimumPriceForFreeDelivery',
    value: function getDeliveryMinimumPriceForFreeDelivery() {
      return this.deliverySettings.minimumPriceForFreeDelivery;
    }
  }, {
    key: 'haveDeliveryMinimumPriceForFreeDelivery',
    value: function haveDeliveryMinimumPriceForFreeDelivery() {
      return this.deliverySettings.minimumPriceForFreeDelivery > 0;
    }
  }, {
    key: 'isTooFarToDelivery',
    value: function isTooFarToDelivery(distance) {
      return this.deliverySettings.isTooFarToDelivery(distance);
    }

    //
    // Shortcuts to access AbstractOrderModeSetting data
    //

  }, {
    key: 'getMinimumPriceForMode',
    value: function getMinimumPriceForMode(mode) {
      return this.getForMode(mode).minimumPrice;
    }
  }, {
    key: 'getMaxTimeAheadAsDaysOnMode',
    value: function getMaxTimeAheadAsDaysOnMode(mode) {
      return this.getForMode(mode).getMaxTimeAheadAsDays();
    }
  }, {
    key: 'getOrderDelay',
    value: function getOrderDelay(mode) {
      var deliveryDistanceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _DateUtils2.default.MINUTE_AS_MS * 15;

      switch (mode) {
        case _Order2.default.OrderMode.TAKE_AWAY:
          return this.manufactureDelay;
        case _Order2.default.OrderMode.DELIVERY:
          return this.getDeliveryTime(deliveryDistanceTime);
      }
      return null;
    }
  }, {
    key: 'getDeliveryTime',
    value: function getDeliveryTime() {
      var deliveryDistanceTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _DateUtils2.default.MINUTE_AS_MS * 15;

      switch (this.deliverySettings.deliveryTimeSettings.settingsType) {
        case _DeliveryTimeSettings2.default.Type.FIXED:
          return this.manufactureDelay + this.deliverySettings.deliveryTimeSettings.fixTimeSettings.time;

        case _DeliveryTimeSettings2.default.Type.ADAPTABLE:
          return this.manufactureDelay + this.deliverySettings.deliveryTimeSettings.adaptableTimeSettings.deliveryManArrivalDuration + deliveryDistanceTime;

        default:
          return this.deliverySettings.deliveryTimeSettings.fixTimeSettings;
      }
    }
  }]);

  return OrderSettings;
}(_ApiObject3.default);

exports.default = OrderSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrderSource.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderSource = function (_ApiObject) {
  _inherits(OrderSource, _ApiObject);

  function OrderSource() {
    _classCallCheck(this, OrderSource);

    return _possibleConstructorReturn(this, (OrderSource.__proto__ || Object.getPrototypeOf(OrderSource)).apply(this, arguments));
  }

  _createClass(OrderSource, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {}
  }, {
    key: 'getIdentifier',
    value: function getIdentifier() {
      return this.identifier;
    }
  }, {
    key: 'getPlatform',
    value: function getPlatform() {
      return this.identifier;
    }
  }]);

  return OrderSource;
}(_ApiObject3.default);

exports.default = OrderSource;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/OrdersList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Filter = function Filter() {
  _classCallCheck(this, Filter);
};

Filter.STATUS_NOT_READY = 0;
Filter.STATUS_READY = 1;
Filter.ON_GOING = 2;
Filter.NOT_ON_GOING = 3;
Filter.HISTORY = 4;

var OrdersList = function (_ApiObject) {
  _inherits(OrdersList, _ApiObject);

  function OrdersList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrdersList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrdersList.__proto__ || Object.getPrototypeOf(OrdersList)).call.apply(_ref, [this].concat(args))), _this), _this.orders = [], _this.haveNewOrders = false, _temp), _possibleConstructorReturn(_this, _ret);
  } // Array of Order

  /**
   * Front only. See OrdersListStore.
   * Set to true if the ajax api request retrieved new orders to take care.
   */


  _createClass(OrdersList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(OrdersList.prototype.__proto__ || Object.getPrototypeOf(OrdersList.prototype), 'postJsonAssignation', this).call(this, data);

      this.orders = [];

      // -- handle the case were the api responds a json with the array directly.
      var dataOrders = [];
      if (!_lodash2.default.isUndefined(data.orders)) {
        // old format, maybe not used anymore
        dataOrders = data.orders;
      } else if (!_lodash2.default.isUndefined(data.data)) {
        // paginated data
        dataOrders = data.data;
      } else {
        dataOrders = data;
      }

      _lodash2.default.each(dataOrders, function (orderData) {
        var order = new _Order2.default();
        order.fromJson(orderData);

        _this2.orders.push(order);
      });
    }
  }, {
    key: 'addOrder',
    value: function addOrder(orderToAdd) {
      this.orders.push(orderToAdd);
    }
  }, {
    key: 'updateOrder',
    value: function updateOrder(orderToUpdate) {
      this.orders = _ArrayUtils2.default.updateObject(this.orders, orderToUpdate, { id: orderToUpdate.id });
    }
  }, {
    key: 'getOrdersReady',
    value: function getOrdersReady() {
      return this.getOrdersWithFilters(Filter.STATUS_READY);
    }
  }, {
    key: 'getOrdersNotReady',
    value: function getOrdersNotReady() {
      return this.getOrdersWithFilters(Filter.STATUS_NOT_READY);
    }
  }, {
    key: 'getOnGoingOrders',
    value: function getOnGoingOrders() {
      return this.getOrdersWithFilters(Filter.ON_GOING);
    }
  }, {
    key: 'getNotOnGoingOrders',
    value: function getNotOnGoingOrders() {
      return this.getOrdersWithFilters(Filter.NOT_ON_GOING);
    }
  }, {
    key: 'getHistoryOrders',
    value: function getHistoryOrders() {
      return this.getOrdersWithFilters(Filter.HISTORY);
    }

    /**
     * @param filter the Filter
     */

  }, {
    key: 'getOrdersWithFilters',
    value: function getOrdersWithFilters(filter) {
      var results = [];

      _lodash2.default.each(this.orders, function (order) {

        if (filter === Filter.STATUS_READY && order.isReady()) {
          results.push(order);
        } else if (filter === Filter.STATUS_NOT_READY && order.isNotReady()) {
          results.push(order);
        } else if (filter === Filter.ON_GOING && order.isOnGoing()) {
          results.push(order);
        } else if (filter === Filter.NOT_ON_GOING && !order.isOnGoing()) {
          results.push(order);
        } else if (filter === Filter.HISTORY && order.isForHistory()) {
          results.push(order);
        }
      });

      return results;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return _lodash2.default.isEmpty(this.orders);
    }
  }, {
    key: 'getLastUpdateOrder',
    value: function getLastUpdateOrder() {
      var lastUpdateOrder = null;
      _lodash2.default.each(this.orders, function (order) {
        if (_lodash2.default.isNull(lastUpdateOrder) || order.modificationDate.isAfter(lastUpdateOrder.modificationDate)) {
          lastUpdateOrder = order;
        }
      });

      return lastUpdateOrder;
    }
  }]);

  return OrdersList;
}(_ApiObject3.default);

exports.default = OrdersList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/TakeAwayOrderSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _AbstractOrderModeSetting = __webpack_require__("./sdk/scripts/entities/order/AbstractOrderModeSetting.js");

var _AbstractOrderModeSetting2 = _interopRequireDefault(_AbstractOrderModeSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TakeAwayOrderSettings = function (_AbstractOrderModeSet) {
  _inherits(TakeAwayOrderSettings, _AbstractOrderModeSet);

  function TakeAwayOrderSettings() {
    _classCallCheck(this, TakeAwayOrderSettings);

    return _possibleConstructorReturn(this, (TakeAwayOrderSettings.__proto__ || Object.getPrototypeOf(TakeAwayOrderSettings)).apply(this, arguments));
  }

  return TakeAwayOrderSettings;
}(_AbstractOrderModeSetting2.default);

exports.default = TakeAwayOrderSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/UserAccountPayment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeliveryTimeSettings = function (_ApiObject) {
  _inherits(DeliveryTimeSettings, _ApiObject);

  function DeliveryTimeSettings() {
    _classCallCheck(this, DeliveryTimeSettings);

    return _possibleConstructorReturn(this, (DeliveryTimeSettings.__proto__ || Object.getPrototypeOf(DeliveryTimeSettings)).apply(this, arguments));
  }

  _createClass(DeliveryTimeSettings, [{
    key: 'postJsonAsssignation',
    value: function postJsonAsssignation(data) {}
  }, {
    key: 'toJSON',
    value: function toJSON() {
      // custom serialization,
      // handle new format of the data (subsidies)
      // since the order preview returns a subsidies to us, we have it on our data
      // we our v1 fronts only use the old data (defined on this object)
      // so the api receive correct old data but new data from the order preview that is incorrect
      // The Api will recalculate the subsidies information, so no need to add additionnal data. We 
      // just need to have only the old data, only the new data, are both data the same
      return _extends({}, this, {
        // soluce 1: better since it represent the old data model, not a trick to have both models
        subsidies: undefined
        // soluce 2
        // subsidies: {
        //   grantAmount: this.grantAmount,
        //   label: this.grantLabel,
        //   tax: this.grantTax,
        // }
      });
    }
  }]);

  return DeliveryTimeSettings;
}(_ApiObject3.default);

exports.default = DeliveryTimeSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/order/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TakeAwayOrderSettings = exports.OrdersList = exports.OrderSource = exports.OrderSettings = exports.OrderProductOptionValue = exports.OrderProductOption = exports.OrderProduct = exports.OrderNotificationSettings = exports.OrderMenuPart = exports.OrderMenu = exports.Order = exports.DeliveryTimeSettings = exports.OnSiteOrderSettings = exports.DeliveryFixTimeSettings = exports.DeliveryAdaptableTimeSettings = exports.DeliveryOrderSettings = undefined;

var _DeliveryOrderSettings2 = __webpack_require__("./sdk/scripts/entities/order/DeliveryOrderSettings.js");

var _DeliveryOrderSettings3 = _interopRequireDefault(_DeliveryOrderSettings2);

var _DeliveryAdaptableTimeSettings2 = __webpack_require__("./sdk/scripts/entities/order/DeliveryAdaptableTimeSettings.js");

var _DeliveryAdaptableTimeSettings3 = _interopRequireDefault(_DeliveryAdaptableTimeSettings2);

var _DeliveryFixTimeSettings2 = __webpack_require__("./sdk/scripts/entities/order/DeliveryFixTimeSettings.js");

var _DeliveryFixTimeSettings3 = _interopRequireDefault(_DeliveryFixTimeSettings2);

var _OnSiteOrderSettings2 = __webpack_require__("./sdk/scripts/entities/order/OnSiteOrderSettings.js");

var _OnSiteOrderSettings3 = _interopRequireDefault(_OnSiteOrderSettings2);

var _DeliveryTimeSettings2 = __webpack_require__("./sdk/scripts/entities/order/DeliveryTimeSettings.js");

var _DeliveryTimeSettings3 = _interopRequireDefault(_DeliveryTimeSettings2);

var _Order2 = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order3 = _interopRequireDefault(_Order2);

var _OrderMenu2 = __webpack_require__("./sdk/scripts/entities/order/OrderMenu.js");

var _OrderMenu3 = _interopRequireDefault(_OrderMenu2);

var _OrderMenuPart2 = __webpack_require__("./sdk/scripts/entities/order/OrderMenuPart.js");

var _OrderMenuPart3 = _interopRequireDefault(_OrderMenuPart2);

var _OrderNotificationSettings2 = __webpack_require__("./sdk/scripts/entities/order/OrderNotificationSettings.js");

var _OrderNotificationSettings3 = _interopRequireDefault(_OrderNotificationSettings2);

var _OrderProduct2 = __webpack_require__("./sdk/scripts/entities/order/OrderProduct.js");

var _OrderProduct3 = _interopRequireDefault(_OrderProduct2);

var _OrderProductOption2 = __webpack_require__("./sdk/scripts/entities/order/OrderProductOption.js");

var _OrderProductOption3 = _interopRequireDefault(_OrderProductOption2);

var _OrderProductOptionValue2 = __webpack_require__("./sdk/scripts/entities/order/OrderProductOptionValue.js");

var _OrderProductOptionValue3 = _interopRequireDefault(_OrderProductOptionValue2);

var _OrderSettings2 = __webpack_require__("./sdk/scripts/entities/order/OrderSettings.js");

var _OrderSettings3 = _interopRequireDefault(_OrderSettings2);

var _OrderSource2 = __webpack_require__("./sdk/scripts/entities/order/OrderSource.js");

var _OrderSource3 = _interopRequireDefault(_OrderSource2);

var _OrdersList2 = __webpack_require__("./sdk/scripts/entities/order/OrdersList.js");

var _OrdersList3 = _interopRequireDefault(_OrdersList2);

var _TakeAwayOrderSettings2 = __webpack_require__("./sdk/scripts/entities/order/TakeAwayOrderSettings.js");

var _TakeAwayOrderSettings3 = _interopRequireDefault(_TakeAwayOrderSettings2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DeliveryOrderSettings = _DeliveryOrderSettings3.default;
exports.DeliveryAdaptableTimeSettings = _DeliveryAdaptableTimeSettings3.default;
exports.DeliveryFixTimeSettings = _DeliveryFixTimeSettings3.default;
exports.OnSiteOrderSettings = _OnSiteOrderSettings3.default;
exports.DeliveryTimeSettings = _DeliveryTimeSettings3.default;
exports.Order = _Order3.default;
exports.OrderMenu = _OrderMenu3.default;
exports.OrderMenuPart = _OrderMenuPart3.default;
exports.OrderNotificationSettings = _OrderNotificationSettings3.default;
exports.OrderProduct = _OrderProduct3.default;
exports.OrderProductOption = _OrderProductOption3.default;
exports.OrderProductOptionValue = _OrderProductOptionValue3.default;
exports.OrderSettings = _OrderSettings3.default;
exports.OrderSource = _OrderSource3.default;
exports.OrdersList = _OrdersList3.default;
exports.TakeAwayOrderSettings = _TakeAwayOrderSettings3.default;

/***/ }),

/***/ "./sdk/scripts/entities/restaurant/KioskOrderSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _KioskOrderTicketSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskOrderTicketSettings.js");

var _KioskOrderTicketSettings2 = _interopRequireDefault(_KioskOrderTicketSettings);

var _Order = __webpack_require__("./sdk/scripts/entities/order/Order.js");

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KioskOrderSettings = function (_ApiObject) {
  _inherits(KioskOrderSettings, _ApiObject);

  function KioskOrderSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KioskOrderSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KioskOrderSettings.__proto__ || Object.getPrototypeOf(KioskOrderSettings)).call.apply(_ref, [this].concat(args))), _this), _this.modes = [_Order2.default.OrderMode.ON_SITE], _this.irlPaymentAllowd = true, _this.locales = ['fr_FR', 'en_GB'], _this.serviceAtTableEnabled = true, _this.rooms = [], _this.ticketSettings = new _KioskOrderTicketSettings2.default(), _this.backgroundImage = '', _this.advertisingImage = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * An array of Locale string.
   * @type Array<Locale>
   */


  /**
   * Array of RestaurantRoom ids
   */


  _createClass(KioskOrderSettings, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.locales = data.locales;
      this.modes = data.modes;

      this.ticketSettings = new _KioskOrderTicketSettings2.default();
      this.ticketSettings.fromJson(data.ticketSettings);
    }

    //
    // rooms
    //

  }, {
    key: 'getRoomById',
    value: function getRoomById(roomId) {
      return _ArrayUtils2.default.find(this.rooms, function (other) {
        return other === roomId;
      });
    }
  }, {
    key: 'addRoom',
    value: function addRoom(roomId) {
      this.rooms.push(roomId);
    }
  }, {
    key: 'deleteRoom',
    value: function deleteRoom(roomId) {
      this.rooms = _ArrayUtils2.default.deleteObject(this.rooms, function (other) {
        return other === roomId;
      });
    }
  }]);

  return KioskOrderSettings;
}(_ApiObject3.default);

exports.default = KioskOrderSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/restaurant/KioskOrderTicketSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KioskOrderTicketSettings = function (_ApiObject) {
  _inherits(KioskOrderTicketSettings, _ApiObject);

  function KioskOrderTicketSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KioskOrderTicketSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KioskOrderTicketSettings.__proto__ || Object.getPrototypeOf(KioskOrderTicketSettings)).call.apply(_ref, [this].concat(args))), _this), _this.customText = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  return KioskOrderTicketSettings;
}(_ApiObject3.default);

KioskOrderTicketSettings.CUSTOM_TEXT_MAX_LENGTH = 400;
exports.default = KioskOrderTicketSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/restaurant/KioskSettings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _KioskOrderSettings = __webpack_require__("./sdk/scripts/entities/restaurant/KioskOrderSettings.js");

var _KioskOrderSettings2 = _interopRequireDefault(_KioskOrderSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KioskSettings = function (_ApiObject) {
  _inherits(KioskSettings, _ApiObject);

  function KioskSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KioskSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KioskSettings.__proto__ || Object.getPrototypeOf(KioskSettings)).call.apply(_ref, [this].concat(args))), _this), _this.order = new _KioskOrderSettings2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KioskSettings, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.order = new _KioskOrderSettings2.default();
      this.order.fromJson(data.order);
    }
  }]);

  return KioskSettings;
}(_ApiObject3.default);

exports.default = KioskSettings;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/restaurant/RestaurantRoom.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantRoom = function (_ApiObject) {
  _inherits(RestaurantRoom, _ApiObject);

  function RestaurantRoom() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantRoom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantRoom.__proto__ || Object.getPrototypeOf(RestaurantRoom)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.name = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  return RestaurantRoom;
}(_ApiObject3.default);

RestaurantRoom.NAME_MAX_LENGTH = 30;
exports.default = RestaurantRoom;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/restaurantsGroup/RestaurantsGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantsGroup = function (_ApiObject) {
  _inherits(RestaurantsGroup, _ApiObject);

  function RestaurantsGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RestaurantsGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestaurantsGroup.__proto__ || Object.getPrototypeOf(RestaurantsGroup)).call.apply(_ref, [this].concat(args))), _this), _this.restaurantsIds = [], _this.children = [], _this.creatorRestaurantsGroupId = null, _this.creationDate = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   *
   * @type string
   */


  /**
   *
   */


  _createClass(RestaurantsGroup, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(RestaurantsGroup.prototype.__proto__ || Object.getPrototypeOf(RestaurantsGroup.prototype), 'postJsonAssignation', this).call(this, data);

      this.children = [];
      _lodash2.default.each(data.children, function (dataChildren) {
        var restaurantsGroup = new RestaurantsGroup();
        restaurantsGroup.fromJson(dataChildren);
        _this2.children.push(restaurantsGroup);
      });

      this.creationDate = _DateUtils2.default.fromMsTimestamp(data.creationDate);
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(RestaurantsGroup.prototype.__proto__ || Object.getPrototypeOf(RestaurantsGroup.prototype), 'toJSON', this).call(this);

      if (!_lodash2.default.isNull(this.creationDate)) {
        json.creationDate = this.creationDate.valueOf();
      }

      return json;
    }
  }, {
    key: 'haveChilds',
    value: function haveChilds() {
      return !_lodash2.default.isEmpty(this.children);
    }
  }, {
    key: 'haveMultipleRestaurants',
    value: function haveMultipleRestaurants() {
      return !_lodash2.default.isEmpty(this.restaurantsId);
    }
  }, {
    key: 'findWithId',
    value: function findWithId(id) {
      var result = null;
      if (this.id === id) {
        return this;
      }

      _lodash2.default.each(this.children, function (children) {
        var childrenRes = children.findWithId(id);
        if (!_lodash2.default.isNull(childrenRes)) {
          result = childrenRes;
          return false; // quit loop.
        }
      });

      return result;
    }
  }, {
    key: 'addRestaurantId',
    value: function addRestaurantId(restaurantId) {
      // handle duplicate.
      var exists = _ArrayUtils2.default.exists(this.restaurantsIds, function (id) {
        return id === restaurantId;
      });
      if (!exists) {
        this.restaurantsIds.push(restaurantId);
      }
    }
  }, {
    key: 'removeRestaurantId',
    value: function removeRestaurantId(restaurantId) {
      this.restaurantsIds = _ArrayUtils2.default.removeObject(this.restaurantsIds, function (id) {
        return restaurantId === id;
      });

      _lodash2.default.each(this.children, function (child) {
        child.removeRestaurantId(restaurantId);
      });
    }
  }, {
    key: 'updateRestaurantsGroup',
    value: function updateRestaurantsGroup(restaurantsGroupToUpdate) {
      var objectExists = _ArrayUtils2.default.exists(this.children, function (child) {
        return child.id === restaurantsGroupToUpdate.id;
      });

      if (!_lodash2.default.isNull(objectExists)) {
        this.children = _ArrayUtils2.default.updateObject(this.children, restaurantsGroupToUpdate, { id: restaurantsGroupToUpdate.id });
      } else {
        _lodash2.default.each(this.children, function (child) {
          child.updateRestaurantsGroup(restaurantsGroupToUpdate);
        });
      }
    }

    //
    //
    //

  }, {
    key: 'getRecursiveChildren',
    value: function getRecursiveChildren() {
      var result = [].concat(this.children);

      _lodash2.default.each(this.children, function (child) {
        result = result.concat(child.getRecursiveChildren());
      });

      return result;
    }
  }, {
    key: 'getRecursiveChildrenIds',
    value: function getRecursiveChildrenIds() {
      var childs = this.getRecursiveChildren();
      var ids = [];

      _lodash2.default.each(childs, function (restaurantsGroup) {
        ids.push(restaurantsGroup.id);
      });

      return ids;
    }
  }, {
    key: 'getRecursiveParentsWithRoot',
    value: function getRecursiveParentsWithRoot(root, current) {
      var res = [].concat(current);

      var parent = root.findWithId(current.parentId);

      if (!_lodash2.default.isNull(parent)) {
        res = res.concat(this.getRecursiveParentsWithRoot(root, parent));
        return res;
      }

      return res;
    }
  }, {
    key: 'getRecursiveParentsIdsWithRoot',
    value: function getRecursiveParentsIdsWithRoot(root) {
      var parents = this.getRecursiveParentsWithRoot(root, this);
      var ids = [];

      _lodash2.default.each(parents, function (restaurantsGroup) {
        ids.push(restaurantsGroup.id);
      });

      return ids;
    }

    // TODO: to be tested

  }, {
    key: 'haveRestaurantWithId',
    value: function haveRestaurantWithId(restaurantIdToFind) {
      var found = false;

      _lodash2.default.each(this.restaurantsIds, function (restaurantId) {
        if (restaurantIdToFind === restaurantId) {
          found = true;
          return false; // quit loop
        }
      });

      if (!found) {
        _lodash2.default.each(this.children, function (children) {
          if (children.haveRestaurantWithId(restaurantIdToFind)) {
            found = true;
            return false; // quit loop
          }
        });
      }

      return found;
    }

    /**
     * Return true if the restaurant group contains only one restaurant, with the given id.
     */

  }, {
    key: 'isOnlyForTheRestaurantWithId',
    value: function isOnlyForTheRestaurantWithId(restaurantIdToFind) {
      return this.haveRestaurantWithId(restaurantIdToFind) && this.restaurantsIds.length === 1 && this.children.length === 0;
    }
  }, {
    key: 'updateRestaurantsGroups',
    value: function updateRestaurantsGroups(restaurantsGroupToUpdate) {
      var tmpChildren = [];

      _lodash2.default.each(this.children, function (restaurantsGroup) {
        if (restaurantsGroup.id === restaurantsGroupToUpdate.id) {
          tmpChildren.push(restaurantsGroupToUpdate);
        } else {
          tmpChildren.push(restaurantsGroup.updateRestaurantsGroups(restaurantsGroupToUpdate));
        }
      });

      this.children = tmpChildren;
    }
  }, {
    key: 'getAllRestaurantsGroupsIdsWithRestaurantId',
    value: function getAllRestaurantsGroupsIdsWithRestaurantId(restaurantId) {
      var groups = this.getAllRestaurantsGroupsWithRestaurantId(restaurantId);

      var ids = [];
      _lodash2.default.each(groups, function (restaurantsGroup) {
        ids.push(restaurantsGroup.id);
      });
      return ids;
    }
  }, {
    key: 'getAllRestaurantsGroupsWithRestaurantId',
    value: function getAllRestaurantsGroupsWithRestaurantId(restaurantId) {
      var res = RestaurantsGroup.getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup(this, restaurantId);

      if (this.haveRestaurantWithId(restaurantId)) {
        res.push(this);
      }

      return res;
    }
  }], [{
    key: 'getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup',
    value: function getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup(currentRestaurantsGroup, restaurantId) {
      var res = [];

      _lodash2.default.each(currentRestaurantsGroup.children, function (restaurantsGroup) {
        if (restaurantsGroup.haveRestaurantWithId(restaurantId)) {
          res.push(restaurantsGroup);
          res = res.concat(RestaurantsGroup.getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup(restaurantsGroup, restaurantId));
        }
      });

      return res;
    }
  }]);

  return RestaurantsGroup;
}(_ApiObject3.default);

exports.default = RestaurantsGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/restaurantsGroup/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestaurantsGroup = undefined;

var _RestaurantsGroup2 = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/RestaurantsGroup.js");

var _RestaurantsGroup3 = _interopRequireDefault(_RestaurantsGroup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RestaurantsGroup = _RestaurantsGroup3.default;

/***/ }),

/***/ "./sdk/scripts/entities/security/ProAccount.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _Validation = __webpack_require__("./sdk/scripts/utils/Validation.js");

var _Validation2 = _interopRequireDefault(_Validation);

var _ProDomainsList = __webpack_require__("./sdk/scripts/entities/security/ProDomainsList.js");

var _ProDomainsList2 = _interopRequireDefault(_ProDomainsList);

var _ProRole = __webpack_require__("./sdk/scripts/entities/security/ProRole.js");

var _ProRole2 = _interopRequireDefault(_ProRole);

var _RestaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/RestaurantsGroup.js");

var _RestaurantsGroup2 = _interopRequireDefault(_RestaurantsGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents an account for a B2B user of PayMyTable. An Account should be unique for each person.
 * A person can have an Account containing multiple Domains.
 */
var ProAccount = function (_ApiObject) {
  _inherits(ProAccount, _ApiObject);

  function ProAccount() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProAccount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProAccount.__proto__ || Object.getPrototypeOf(ProAccount)).call.apply(_ref, [this].concat(args))), _this), _this.domainsList = null, _this.role = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // long


  /**
   * The Api does no send the domains list with the pro account object.
   * We have to retrieve it later.
   *
   * front only
   */


  // restaurantsGroup: RestaurantsGroup = null;

  /**
   * Front only
   */


  _createClass(ProAccount, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      if (!_lodash2.default.isNull(data.domainsList)) {
        this.domainsList = new _ProDomainsList2.default();
        this.domainsList.fromJson(data.domainsList);
      }
    }

    /**
     * Do not handle password here, we don't want to return false if the user does not want to change
     * the password.
     * Note: elevationCode isn't required for now.
     * @See isValidPassword
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return !_lodash2.default.isEmpty(this.firstName) && !_lodash2.default.isEmpty(this.lastName) && !_lodash2.default.isEmpty(this.email) && _Validation2.default.email(this.email);
    }
  }, {
    key: 'isValidPassword',
    value: function isValidPassword() {
      return !_lodash2.default.isEmpty(this.password) && this.password === this.passwordVerification && this.password.length >= ProAccount.MINIMUM_PASSWORD_LENGTH;
    }
  }, {
    key: 'getName',
    value: function getName() {
      return this.firstName + ' ' + this.lastName;
    }
  }]);

  return ProAccount;
}(_ApiObject3.default);

ProAccount.MINIMUM_PASSWORD_LENGTH = 6;
exports.default = ProAccount;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/ProAccountsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProRole = __webpack_require__("./sdk/scripts/entities/security/ProRole.js");

var _ProRole2 = _interopRequireDefault(_ProRole);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountsList = function (_ApiObject) {
  _inherits(AccountsList, _ApiObject);

  function AccountsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AccountsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccountsList.__proto__ || Object.getPrototypeOf(AccountsList)).call.apply(_ref, [this].concat(args))), _this), _this.accounts = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AccountsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.accounts = [];
      _lodash2.default.each(data.accounts, function (roleData) {
        var proRole = new _ProRole2.default();
        proRole.fromJson(roleData);
        _this2.roles.push(proRole);
      });
    }
  }]);

  return AccountsList;
}(_ApiObject3.default);

exports.default = AccountsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/ProDomain.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProAccount = __webpack_require__("./sdk/scripts/entities/security/ProAccount.js");

var _ProAccount2 = _interopRequireDefault(_ProAccount);

var _ProRole = __webpack_require__("./sdk/scripts/entities/security/ProRole.js");

var _ProRole2 = _interopRequireDefault(_ProRole);

var _RestaurantsGroup = __webpack_require__("./sdk/scripts/entities/restaurantsGroup/RestaurantsGroup.js");

var _RestaurantsGroup2 = _interopRequireDefault(_RestaurantsGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProDomain = function (_ApiObject) {
  _inherits(ProDomain, _ApiObject);

  function ProDomain() {
    _classCallCheck(this, ProDomain);

    return _possibleConstructorReturn(this, (ProDomain.__proto__ || Object.getPrototypeOf(ProDomain)).apply(this, arguments));
  }

  _createClass(ProDomain, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.restaurantsGroup = new _RestaurantsGroup2.default();
      this.restaurantsGroup.fromJson(data.restaurantsGroup);

      this.role = new _ProRole2.default();
      this.role.fromJson(data.role);
    }

    /**
     * front only.
     */

  }]);

  return ProDomain;
}(_ApiObject3.default);

exports.default = ProDomain;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/ProDomainsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProDomain = __webpack_require__("./sdk/scripts/entities/security/ProDomain.js");

var _ProDomain2 = _interopRequireDefault(_ProDomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProDomainsList = function (_ApiObject) {
  _inherits(ProDomainsList, _ApiObject);

  function ProDomainsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProDomainsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProDomainsList.__proto__ || Object.getPrototypeOf(ProDomainsList)).call.apply(_ref, [this].concat(args))), _this), _this.domains = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProDomainsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.domains = [];
      _lodash2.default.each(data, function (domainData) {
        var proDomain = new _ProDomain2.default();
        proDomain.fromJson(domainData);

        // fix some weird bug where a wrong pro domain object is created.
        if (!_lodash2.default.isUndefined(proDomain.id)) {
          _this2.domains.push(proDomain);
        }
      });
    }
  }, {
    key: 'getDomainWithId',
    value: function getDomainWithId(domainIdToFind) {
      var foundDomain = _lodash2.default.find(this.domains, function (domain) {
        return domain.id === domainIdToFind;
      });

      return _lodash2.default.isUndefined(foundDomain) ? null : foundDomain;
    }
  }, {
    key: 'numberOfDomains',
    value: function numberOfDomains() {
      return this.domains.length;
    }
  }]);

  return ProDomainsList;
}(_ApiObject3.default);

exports.default = ProDomainsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/ProPermissionsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Define the pro permissions.
 * All first sub-permissions must be declared as null here.
 */
var ProPermissionsList = function (_ApiObject) {
  _inherits(ProPermissionsList, _ApiObject);

  function ProPermissionsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProPermissionsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProPermissionsList.__proto__ || Object.getPrototypeOf(ProPermissionsList)).call.apply(_ref, [this].concat(args))), _this), _this.booking = {
      book: null,

      settings: null
    }, _this.proAccount = {
      self: null,

      role: null,

      domain: null,

      restaurantsGroup: null,

      restaurant: null
    }, _this.restaurantMenu = {
      settings: null
    }, _this.order = {
      settings: null
    }, _this.restaurantSettings = {
      publicInfo: null,

      menu: null,

      openingHours: null,

      legal: null,

      finance: null,

      features: null,

      configuration: null,

      theme: null
    }, _this.export = {
      canExport: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ProPermissionsList;
}(_ApiObject3.default);

exports.default = ProPermissionsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/ProRole.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ProPermissionsList = __webpack_require__("./sdk/scripts/entities/security/ProPermissionsList.js");

var _ProPermissionsList2 = _interopRequireDefault(_ProPermissionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProRole = function (_ApiObject) {
  _inherits(ProRole, _ApiObject);

  function ProRole() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProRole);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProRole.__proto__ || Object.getPrototypeOf(ProRole)).call.apply(_ref, [this].concat(args))), _this), _this.name = '', _this.permissions = new _ProPermissionsList2.default(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProRole, [{
    key: 'isValid',


    //
    // Validation
    //

    /**
     * Verify that the object is correct
     */
    value: function isValid() {
      return this.validateName() && this.validatePermissions();
    }
  }, {
    key: 'validateName',
    value: function validateName() {
      return !_lodash2.default.isEmpty(this.name);
    }
  }, {
    key: 'validatePermissions',
    value: function validatePermissions() {
      return true;
    }
  }, {
    key: 'getValidationErrors',
    value: function getValidationErrors() {
      var validationErrors = ProRole.validationErrors;
      var errors = {};

      if (!this.validateName()) {
        errors.name = validationErrors.name;
      }

      if (!this.validatePermissions()) {
        errors.description = validationErrors.permissions;
      }

      return errors;
    }
  }]);

  return ProRole;
}(_ApiObject3.default);

ProRole.validationErrors = {
  name: 'Le nom ne peut être vide',
  permissions: 'Les permissions sont invalides :('
};
exports.default = ProRole;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/ProRolesList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ProRole = __webpack_require__("./sdk/scripts/entities/security/ProRole.js");

var _ProRole2 = _interopRequireDefault(_ProRole);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProRolesList = function (_ApiObject) {
  _inherits(ProRolesList, _ApiObject);

  function ProRolesList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProRolesList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProRolesList.__proto__ || Object.getPrototypeOf(ProRolesList)).call.apply(_ref, [this].concat(args))), _this), _this.roles = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProRolesList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      this.roles = [];
      _lodash2.default.each(data, function (roleData) {
        var proRole = new _ProRole2.default();
        proRole.fromJson(roleData);
        _this2.roles.push(proRole);
      });
    }
  }, {
    key: 'getWithId',
    value: function getWithId(roleId) {
      var found = _lodash2.default.find(this.roles, function (role) {
        // let ==
        return role.id == roleId;
      });

      return _lodash2.default.isUndefined(found) ? null : found;
    }
  }, {
    key: 'push',
    value: function push(role) {
      this.roles.push(role);
    }
  }, {
    key: 'update',
    value: function update(role) {
      this.roles = _ArrayUtils2.default.updateObjectOrAdd(this.roles, role, function (other) {
        return role.id === other.id;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(role) {
      this.roles = _ArrayUtils2.default.deleteObject(this.roles, function (other) {
        return role.id === other.id;
      });
    }
  }]);

  return ProRolesList;
}(_ApiObject3.default);

exports.default = ProRolesList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/security/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProRolesList = exports.ProDomainsList = exports.ProDomain = exports.ProAccountsList = exports.ProAccount = exports.ProPermissionsList = exports.ProRole = undefined;

var _ProRole2 = __webpack_require__("./sdk/scripts/entities/security/ProRole.js");

var _ProRole3 = _interopRequireDefault(_ProRole2);

var _ProPermissionsList2 = __webpack_require__("./sdk/scripts/entities/security/ProPermissionsList.js");

var _ProPermissionsList3 = _interopRequireDefault(_ProPermissionsList2);

var _ProAccount2 = __webpack_require__("./sdk/scripts/entities/security/ProAccount.js");

var _ProAccount3 = _interopRequireDefault(_ProAccount2);

var _ProAccountsList2 = __webpack_require__("./sdk/scripts/entities/security/ProAccountsList.js");

var _ProAccountsList3 = _interopRequireDefault(_ProAccountsList2);

var _ProDomain2 = __webpack_require__("./sdk/scripts/entities/security/ProDomain.js");

var _ProDomain3 = _interopRequireDefault(_ProDomain2);

var _ProDomainsList2 = __webpack_require__("./sdk/scripts/entities/security/ProDomainsList.js");

var _ProDomainsList3 = _interopRequireDefault(_ProDomainsList2);

var _ProRolesList2 = __webpack_require__("./sdk/scripts/entities/security/ProRolesList.js");

var _ProRolesList3 = _interopRequireDefault(_ProRolesList2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProRole = _ProRole3.default;
exports.ProPermissionsList = _ProPermissionsList3.default;
exports.ProAccount = _ProAccount3.default;
exports.ProAccountsList = _ProAccountsList3.default;
exports.ProDomain = _ProDomain3.default;
exports.ProDomainsList = _ProDomainsList3.default;
exports.ProRolesList = _ProRolesList3.default;

/***/ }),

/***/ "./sdk/scripts/entities/user/CreditCard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCard = function (_ApiObject) {
  _inherits(CreditCard, _ApiObject);

  function CreditCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreditCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreditCard.__proto__ || Object.getPrototypeOf(CreditCard)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.currency = 'EUR', _this.number = '', _this.name = '', _this.cvv = '', _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   *  Define the different types of credit cards.
   *  Support only Visa and mastercard due to API limitations
   */


  /**
   * ISO_4217 format
   * @link https://www.wikiwand.com/en/ISO_4217
   */


  _createClass(CreditCard, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      this.expirationDate = _DateUtils2.default.fromMsTimestamp(data.expirationDate);
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(CreditCard.prototype.__proto__ || Object.getPrototypeOf(CreditCard.prototype), 'toJSON', this).call(this);

      if (!_lodash2.default.isNil(this.expirationDate)) {
        json.expirationDate = this.expirationDate.valueOf();
      }

      json.number = _lodash2.default.replace(json.number, /\s/g, '');

      return json;
    }
  }, {
    key: 'getCleanNumber',
    value: function getCleanNumber() {
      return _lodash2.default.replace(this.number, /\s/g, '');
    }
  }, {
    key: 'getFormattedExpirationDate',
    value: function getFormattedExpirationDate() {
      if (_lodash2.default.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
        return 'N/A';
      }

      return this.expirationDate.format('MM/YYYY');
    }
  }, {
    key: 'getShortFormattedExpirationDate',
    value: function getShortFormattedExpirationDate() {
      if (_lodash2.default.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
        return 'N/A';
      }

      return this.expirationDate.format('MM/YY');
    }

    //
    //
    //

  }, {
    key: 'setExpirationYear',
    value: function setExpirationYear(expirationYear) {
      if (_lodash2.default.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
        this.expirationDate = (0, _moment2.default)(0);
      }
      this.expirationDate = this.expirationDate.year(expirationYear);
    }

    /**
     *
     * @expirationMonth the month index where january is 1 and december 12.
     * note that moment().month() months are zero indexed so january is 0 and december 11.
     */

  }, {
    key: 'setExpirationMonth',
    value: function setExpirationMonth(expirationMonth) {
      if (_lodash2.default.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
        this.expirationDate = (0, _moment2.default)(0);
      }
      // Accepts numbers from 0 to 11. If the range is exceeded, it will bubble up to the year.
      // Months are zero indexed, so January is month 0.
      this.expirationDate = this.expirationDate.month(expirationMonth - 1);
    }
  }, {
    key: 'getExpirationMonth',
    value: function getExpirationMonth() {
      if (_lodash2.default.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
        return null;
      }
      return this.expirationDate.format('MM');
    }
  }, {
    key: 'getExpirationYear',
    value: function getExpirationYear() {
      if (_lodash2.default.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
        return null;
      }
      return this.expirationDate.format('YYYY');
    }

    //
    //
    //

  }, {
    key: 'getType',
    value: function getType() {
      if (_lodash2.default.isEmpty(this.number)) {
        return CreditCard.Type.UNKNOWN;
      }

      switch (this.number[0]) {
        case '3':
          return CreditCard.Type.AMEX;
        case '4':
          return CreditCard.Type.VISA;
        case '5':
          return CreditCard.Type.MASTERCARD;
        default:
          return CreditCard.Type.UNKNOWN;
      }
    }
  }]);

  return CreditCard;
}(_ApiObject3.default);

CreditCard.Type = {

  /**
   * The card type does not exists or is not supported
   */
  UNKNOWN: 0,

  /**
   *  The visa.
   * A visa always begin by '4'.
   */
  VISA: 1,

  /**
   * The mastercard.
   * A mastercard always begin by '5'.
   */
  MASTERCARD: 2,

  /**
   * The american express.
   * Warning: The American express is not supported by the API.
   * An american express always begin by '3'.
   */
  AMEX: 3
};
exports.default = CreditCard;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/CreditCardsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CreditCard = __webpack_require__("./sdk/scripts/entities/user/CreditCard.js");

var _CreditCard2 = _interopRequireDefault(_CreditCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCardsList = function (_ApiObject) {
  _inherits(CreditCardsList, _ApiObject);

  function CreditCardsList() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, CreditCardsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = CreditCardsList.__proto__ || Object.getPrototypeOf(CreditCardsList)).call.apply(_ref, [this].concat(args))), _this2), _this2.cards = [], _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(CreditCardsList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(CreditCardsList.prototype.__proto__ || Object.getPrototypeOf(CreditCardsList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize cards
      this.cards = [];
      var _this = this;

      // -- handle the case were the api responds a json with the array directly.
      var dataCreditCards = [];
      if (!_lodash2.default.isUndefined(data.cards)) {
        dataCreditCards = data.cards;
      } else {
        dataCreditCards = data;
      }

      _lodash2.default.each(dataCreditCards, function (creditCardData) {
        var creditCard = new _CreditCard2.default();
        creditCard.fromJson(creditCardData);
        _this.cards.push(creditCard);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      var found = _lodash2.default.find(this.cards, function (creditCard) {
        return creditCard.id === idToFind;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }, {
    key: 'addCreditCard',
    value: function addCreditCard(creditCard) {
      this.cards.push(creditCard);
    }
  }, {
    key: 'deleteCreditCard',
    value: function deleteCreditCard(creditCard) {
      this.cards = _ArrayUtils2.default.deleteObject(this.cards, { id: creditCard.id });
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return _lodash2.default.isEmpty(this.cards);
    }
  }]);

  return CreditCardsList;
}(_ApiObject3.default);

exports.default = CreditCardsList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/User.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _UserAccount = __webpack_require__("./sdk/scripts/entities/user/UserAccount.js");

var _UserAccount2 = _interopRequireDefault(_UserAccount);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _DateUtils = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var User = function (_ApiObject) {
  _inherits(User, _ApiObject);

  function User() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, User);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = User.__proto__ || Object.getPrototypeOf(User)).call.apply(_ref, [this].concat(args))), _this), _this.id = '', _this.firstName = '', _this.lastName = '', _this.phone = '', _this.email = '', _this.emailVerified = true, _this.fid = '', _this.phone = '', _this.phoneVerified = true, _this.sponsorship = '', _this.nationality = '', _this.countryOfResidence = '', _this.locale = '', _this.country = '', _this.picture = '', _this.birthdate = User.DEFAULT_BIRTHDATE, _this.registrationDate = 0, _this.credit = 0, _this.walletId = '', _this.promotionsUsed = [], _this.userAccounts = [], _this.registerId = null, _temp), _possibleConstructorReturn(_this, _ret);
  } // +33630252000. See RFC ? TODO: RFC

  // Two letters: FR. See RFC ? TODO: RFC

  // Two letters: FR. See RFC ? TODO: RFC

  // fr

  // Two letters: FR. See RFC ? TODO: RFC

  // timestamp as milliseconds

  // timestamp as milliseconds

  // used to track a user who orders after a registration


  _createClass(User, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {}
  }, {
    key: 'haveBirthdate',
    value: function haveBirthdate() {
      return this.birthdate !== User.DEFAULT_BIRTHDATE;
    }
  }, {
    key: 'getFormattedBirthdate',
    value: function getFormattedBirthdate() {
      return _DateUtils2.default.fromMsTimestamp(this.birthdate).format('DD/MM/YYYY');
    }
  }, {
    key: 'getEnabledUserAccounts',
    value: function getEnabledUserAccounts() {
      return this.userAccounts.filter(function (userAccount) {
        return userAccount.enabled;
      });
    }
  }, {
    key: 'findUserAccountById',
    value: function findUserAccountById(id) {
      return _ArrayUtils2.default.find(this.userAccounts, { id: id });
    }
  }, {
    key: 'generateRegisterId',
    value: function generateRegisterId() {
      this.registerId = _Utils2.default.generateUID();
    }
  }]);

  return User;
}(_ApiObject3.default);

User.DEFAULT_BIRTHDATE = -2208988800000;
exports.default = User;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/UserAccount.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _isNil = __webpack_require__("./sdk/node_modules/lodash/isNil.js");

var _isNil2 = _interopRequireDefault(_isNil);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserAccount = function (_ApiObject) {
  _inherits(UserAccount, _ApiObject);

  function UserAccount() {
    _classCallCheck(this, UserAccount);

    return _possibleConstructorReturn(this, (UserAccount.__proto__ || Object.getPrototypeOf(UserAccount)).apply(this, arguments));
  }

  _createClass(UserAccount, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(UserAccount.prototype.__proto__ || Object.getPrototypeOf(UserAccount.prototype), 'postJsonAssignation', this).call(this, data);
    }
  }]);

  return UserAccount;
}(_ApiObject3.default);

exports.default = UserAccount;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/UserAddress.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _GmapUtils = __webpack_require__("./sdk/scripts/utils/GmapUtils.js");

var _GmapUtils2 = _interopRequireDefault(_GmapUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserAddress = function (_ApiObject) {
  _inherits(UserAddress, _ApiObject);

  function UserAddress() {
    _classCallCheck(this, UserAddress);

    return _possibleConstructorReturn(this, (UserAddress.__proto__ || Object.getPrototypeOf(UserAddress)).apply(this, arguments));
  }

  _createClass(UserAddress, [{
    key: 'getLiteral',


    /**
     * a label describing this address (Home, Work, ...)
     */


    /**
     * The country (full name)
     */


    /**
     * The city
     * @type string
     */


    /**
     * the number and the name of the street
     * @type string
     */
    value: function getLiteral() {
      if (!_lodash2.default.isEmpty(this.street) && !_lodash2.default.isEmpty(this.city)) {
        var literal = this.street + ', ' + this.city;
        if (!_lodash2.default.isEmpty(this.country)) {
          literal += ', ' + this.country;
        }
        return literal;
      } else if (!_lodash2.default.isEmpty(this.formattedAddress)) {
        return this.formattedAddress;
      }

      return null;
    }

    /**
     * @type string
     */


    /**
     * More instructions like digicode, ringtone, etc)
     */


    /**
     * The zip code
     */


    /**
     * some more information (ie building, floor, apt #)
     * @type string
     */

  }, {
    key: 'fromLatitudeAndLongitude',
    value: function fromLatitudeAndLongitude(latitude, longitude, formattedAddress) {
      this.geoPt = {
        longitude: longitude,
        latitude: latitude
      };
      this.formattedAddress = formattedAddress;
    }
  }, {
    key: 'fromGeolocatorLocation',
    value: function fromGeolocatorLocation(geolocatorLocation) {

      if (!_lodash2.default.isNil(geolocatorLocation.address)) {
        this.street = geolocatorLocation.address.streetNumber + ' ' + geolocatorLocation.address.street;
        this.city = geolocatorLocation.address.town; // city give Paris-8E-Arrondissement ..
        this.postCode = geolocatorLocation.address.postalCode;
        this.country = geolocatorLocation.address.country;
      }

      if (!_lodash2.default.isNil(geolocatorLocation.coords)) {
        this.geoPt = {
          longitude: geolocatorLocation.coords.longitude,
          latitude: geolocatorLocation.coords.latitude
        };
      }
    }
  }, {
    key: 'fromGmapAddressComponents',
    value: function fromGmapAddressComponents(addressComponents) {
      var geometry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var streetNumberComponent = _GmapUtils2.default.getTypeOnGmapAddressComponents('street_number', addressComponents);

      var streetNameComponent = _GmapUtils2.default.getTypeOnGmapAddressComponents('route', addressComponents);

      this.street = streetNumberComponent.long_name + ' ' + streetNameComponent.long_name;

      this.city = _GmapUtils2.default.getTypeOnGmapAddressComponents('locality', addressComponents).short_name;

      this.postCode = _GmapUtils2.default.getTypeOnGmapAddressComponents('postal_code', addressComponents).long_name;

      this.country = _GmapUtils2.default.getTypeOnGmapAddressComponents('country', addressComponents).long_name;

      if (!_lodash2.default.isNil(geometry)) {
        this.geoPt = {
          longitude: geometry.location.lng(),
          latitude: geometry.location.lat()
        };
      }
    }
  }]);

  return UserAddress;
}(_ApiObject3.default);

exports.default = UserAddress;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/UserAddressesList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _UserAddress = __webpack_require__("./sdk/scripts/entities/user/UserAddress.js");

var _UserAddress2 = _interopRequireDefault(_UserAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserAddressessList = function (_ApiObject) {
  _inherits(UserAddressessList, _ApiObject);

  function UserAddressessList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserAddressessList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserAddressessList.__proto__ || Object.getPrototypeOf(UserAddressessList)).call.apply(_ref, [this].concat(args))), _this), _this.addresses = [], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserAddressessList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      var _this2 = this;

      _get(UserAddressessList.prototype.__proto__ || Object.getPrototypeOf(UserAddressessList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize checks
      this.addresses = [];

      // -- handle the case were the api responds a json with the array directly.
      var dataAddresses = [];
      if (!_lodash2.default.isUndefined(data.addresses)) {
        dataAddresses = data.addresses;
      } else {
        dataAddresses = data;
      }

      _lodash2.default.each(dataAddresses, function (checkData) {
        var address = new _UserAddress2.default();
        address.fromJson(checkData);
        _this2.addresses.push(address);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      return _ArrayUtils2.default.find(this.addresses, { id: idToFind });
    }
  }, {
    key: 'update',
    value: function update(address) {
      this.addresses = _ArrayUtils2.default.updateObject(this.addresses, address, { id: address.id });
    }
  }, {
    key: 'unshift',
    value: function unshift(address) {
      this.addresses.unshift(address);
    }
  }, {
    key: 'delete',
    value: function _delete(address) {
      this.addresses = _ArrayUtils2.default.deleteObject(this.addresses, address, { id: address.id });
    }
  }]);

  return UserAddressessList;
}(_ApiObject3.default);

exports.default = UserAddressessList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/UsersList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiObject2 = __webpack_require__("./sdk/scripts/entities/ApiObject.js");

var _ApiObject3 = _interopRequireDefault(_ApiObject2);

var _User = __webpack_require__("./sdk/scripts/entities/user/User.js");

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersList = function (_ApiObject) {
  _inherits(UsersList, _ApiObject);

  function UsersList() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, UsersList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = UsersList.__proto__ || Object.getPrototypeOf(UsersList)).call.apply(_ref, [this].concat(args))), _this2), _this2.users = [], _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(UsersList, [{
    key: 'postJsonAssignation',
    value: function postJsonAssignation(data) {
      _get(UsersList.prototype.__proto__ || Object.getPrototypeOf(UsersList.prototype), 'postJsonAssignation', this).call(this, data);

      // -- deserialize users
      this.users = [];
      var _this = this;

      // -- handle the case were the api responds a json with the array directly.
      var dataUsers = [];
      if (!_lodash2.default.isUndefined(data.users)) {
        dataUsers = data.users;
      } else {
        dataUsers = data;
      }

      _lodash2.default.each(dataUsers, function (userData) {
        var user = new _User2.default();
        user.fromJson(userData);
        _this.users.push(user);
      });
    }
  }, {
    key: 'findById',
    value: function findById(idToFind) {
      var found = _lodash2.default.find(this.users, function (user) {
        return user.id === idToFind;
      });

      if (_lodash2.default.isUndefined(found)) {
        return null;
      }

      return found;
    }
  }]);

  return UsersList;
}(_ApiObject3.default);

exports.default = UsersList;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/entities/user/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAccount = exports.UsersList = exports.UserAddressesList = exports.UserAddress = exports.User = exports.CreditCardsList = exports.CreditCard = undefined;

var _CreditCard2 = __webpack_require__("./sdk/scripts/entities/user/CreditCard.js");

var _CreditCard3 = _interopRequireDefault(_CreditCard2);

var _CreditCardsList2 = __webpack_require__("./sdk/scripts/entities/user/CreditCardsList.js");

var _CreditCardsList3 = _interopRequireDefault(_CreditCardsList2);

var _User2 = __webpack_require__("./sdk/scripts/entities/user/User.js");

var _User3 = _interopRequireDefault(_User2);

var _UserAddress2 = __webpack_require__("./sdk/scripts/entities/user/UserAddress.js");

var _UserAddress3 = _interopRequireDefault(_UserAddress2);

var _UserAddressesList2 = __webpack_require__("./sdk/scripts/entities/user/UserAddressesList.js");

var _UserAddressesList3 = _interopRequireDefault(_UserAddressesList2);

var _UsersList2 = __webpack_require__("./sdk/scripts/entities/user/UsersList.js");

var _UsersList3 = _interopRequireDefault(_UsersList2);

var _UserAccount2 = __webpack_require__("./sdk/scripts/entities/user/UserAccount.js");

var _UserAccount3 = _interopRequireDefault(_UserAccount2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CreditCard = _CreditCard3.default;
exports.CreditCardsList = _CreditCardsList3.default;
exports.User = _User3.default;
exports.UserAddress = _UserAddress3.default;
exports.UserAddressesList = _UserAddressesList3.default;
exports.UsersList = _UsersList3.default;
exports.UserAccount = _UserAccount3.default;

/***/ }),

/***/ "./sdk/scripts/flux/AppDispatcher.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _flux = __webpack_require__("./node_modules/flux/index.js");

var _deprecated = __webpack_require__("./sdk/scripts/decorators/deprecated.js");

var _deprecated2 = _interopRequireDefault(_deprecated);

var _PayloadSources = __webpack_require__("./sdk/scripts/flux/PayloadSources.js");

var _PayloadSources2 = _interopRequireDefault(_PayloadSources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * The dispatcher is the core of the app
 * it’s the central hub for the messages (actions)
 * Two main methods, one will handle the dispatch of server-initiated action,
 * the other one the view-initiated actions.
 */
var AppDispatcher = (_class = function (_Dispatcher) {
  _inherits(AppDispatcher, _Dispatcher);

  function AppDispatcher() {
    _classCallCheck(this, AppDispatcher);

    return _possibleConstructorReturn(this, (AppDispatcher.__proto__ || Object.getPrototypeOf(AppDispatcher)).apply(this, arguments));
  }

  _createClass(AppDispatcher, [{
    key: 'handleServerAction',


    /**
     * A bridge function between the actions create by an Api call and the dispatcher, marking
     * the action as a view action.
     * @param  {object} action The data coming from the API.
     */
    value: function handleServerAction(action) {
      var _this2 = this;

      // TODO: remove payload in favor of just dispatch the action.
      var payload = {
        source: _PayloadSources2.default.SERVER_ACTION,
        action: action
      };

      if (this.isDispatching()) {
        console.error('[ACTION] ' + action.type, 'is dispatching could not dispatch', action);
        // TODO: find another fix.
        setTimeout(function () {
          console.log('retry in 100 milliseconds');
          _this2.handleServerAction(action);
        }, 100);
      } else {
        console.info('[ACTION] ' + action.type, action);
        this.dispatch(payload);
      }
    }
  }, {
    key: 'handleViewAction',
    value: function handleViewAction(action) {
      this.handleServerAction(action);
    }
  }]);

  return AppDispatcher;
}(_flux.Dispatcher), (_applyDecoratedDescriptor(_class.prototype, 'handleViewAction', [_deprecated2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleViewAction'), _class.prototype)), _class);
exports.default = new AppDispatcher();
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/flux/GlobalState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GlobalState = function () {
  function GlobalState() {
    var _this = this;

    _classCallCheck(this, GlobalState);

    this.globalState = {};
    this.stores = [];
    this.appEvents = [];

    this.devToolsListener = function (message) {
      // see https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Methods.md
      if (message.type === 'DISPATCH' && message.state) {
        console.log('DevTools requested to change the state');

        var newState = _lodash2.default.cloneDeepWith(_this.globalState); // TODO = {};

        var newStateJson = JSON.parse(message.state);
        console.log('newState', newState);
        //
        // Note: disabled because message.state is a json, and our globalState contains object..
        // TODO: find magic way to recreate the state with objects..
        //
        // this.globalState = {};
        //

        // for each store, recreate the objects
        _lodash2.default.each(_this.stores, function (store) {
          // no need to try to restore a store that does not handle it.
          if (!_lodash2.default.isFunction(store.getStateObjectsMap)) {
            // TODO: add dev warning.
            return;
          }

          // const storeInitialState = store.getInitialState();

          // TODO: in debug, diff storeInitialState keys and getStateObjectsMap keys in order to
          // find forgetten state keys on getStateObjectsMap.

          // the json that represent the state for this store.
          var storeStateJson = newStateJson[store._id];

          // The store handle `getStateObjectsMap` function.
          if (!_lodash2.default.isUndefined(store.getStateObjectsMap)) {
            // retrieve data to map json to objects
            var mapJsonStateToObjectData = store.getStateObjectsMap();

            // for each key of the state
            for (var k in mapJsonStateToObjectData) {
              var objectJson = storeStateJson[k];
              var classToRecreate = mapJsonStateToObjectData[k];
              console.log('classToRecreate', classToRecreate);

              if (!_lodash2.default.isNil(objectJson) && !_lodash2.default.isNil(classToRecreate) && _lodash2.default.isFunction(classToRecreate.fromJson)) {
                // the object have a fromJson function, so it's an instance of ApiObject, we recreate
                // the data
                storeStateJson[k] = classToRecreate.fromJson(objectJson);
              } else {
                // TODO: handle arrays of objects.. See ReviewStore usersReviewsSummary
                storeStateJson[k] = objectJson;
              }
            }
          }

          console.log('storeStateJson', storeStateJson);
          newState[store._id] = storeStateJson;
        });

        // update global state
        _this.globalState = newState;

        // notify all the stores that the state changed.

        _lodash2.default.each(_this.stores, function (store) {
          // no need to try to restore a store that does not handle it.
          if (!_lodash2.default.isFunction(store.getStateObjectsMap)) {
            return;
          }

          if (!store.isEmitingCustomEvents()) {
            store.__onGlobalStateChange();
          } else {
            // Old store.
            // For now we send all the appEvents :/
            _lodash2.default.each(_this.appEvents, function (event) {
              if (event.endsWith('SUCCESS')) {
                store.__emitter.emit(event);
              }
            });
          }
        });
      }
    };
  }

  /**
   * To ensure a Redux-like global state, and facilitate the debug with
   * Redux DevTools, we use a global state.
   * We use the store class name as key, and put the store's state as value.
   */


  /**
   * contains all the defined app events (usually in constants/Events)
   * We use it to force update the old stores that use custom events
   */


  _createClass(GlobalState, [{
    key: 'getGlobalState',


    /**
     * static function to retrieve the global state
     * Used to init the React DevTools on DevelopmentUtils for example.
     */
    value: function getGlobalState() {
      return this.globalState;
    }
  }, {
    key: 'setForId',
    value: function setForId(id, state) {
      this.globalState[id] = state;
    }
  }, {
    key: 'getForId',
    value: function getForId(id) {
      return this.globalState[id];
    }
  }, {
    key: 'registerStore',
    value: function registerStore(store) {
      this.stores.push(store);
    }
  }]);

  return GlobalState;
}();

exports.default = new GlobalState();
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/flux/Listener.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Listener = function Listener(event, func) {
  _classCallCheck(this, Listener);

  this.event = event;
  this.func = func;
};

exports.default = Listener;
module.exports = exports["default"];

/***/ }),

/***/ "./sdk/scripts/flux/PMTEventEmitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _events = __webpack_require__("./node_modules/events/events.js");

var _events2 = _interopRequireDefault(_events);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Listener = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener2 = _interopRequireDefault(_Listener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PMTEventEmitter = function (_EventEmitter) {
  _inherits(PMTEventEmitter, _EventEmitter);

  function PMTEventEmitter() {
    _classCallCheck(this, PMTEventEmitter);

    return _possibleConstructorReturn(this, (PMTEventEmitter.__proto__ || Object.getPrototypeOf(PMTEventEmitter)).apply(this, arguments));
  }

  _createClass(PMTEventEmitter, [{
    key: 'addListener',
    value: function addListener(event, callback) {
      // console.info('[Listener] ADD - ' + event + ' ' + callback);
      this.on(event, callback);
    }
  }, {
    key: 'emitEvent',
    value: function emitEvent(event) {
      console.info('[EVENT]', event);
      _get(PMTEventEmitter.prototype.__proto__ || Object.getPrototypeOf(PMTEventEmitter.prototype), 'emit', this).call(this, event);
    }
  }, {
    key: 'emit',
    value: function emit(event) {
      console.info('[EVENT]', event);
      _get(PMTEventEmitter.prototype.__proto__ || Object.getPrototypeOf(PMTEventEmitter.prototype), 'emit', this).call(this, event);
    }
  }, {
    key: 'addListeners',
    value: function addListeners(listeners) {
      var _this2 = this;

      _lodash2.default.each(listeners, function (listener) {
        if (!_lodash2.default.isFunction(listener.func)) {
          console.error('[Listener] ADD - Invalid listener for event ' + listener.event);
        }
        _this2.addListener(listener.event, listener.func);
      });
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners(listeners) {
      var _this3 = this;

      _lodash2.default.each(listeners, function (listener) {
        if (!_lodash2.default.isFunction(listener.func)) {
          console.error('[Listener] REMOVE - Invalid listener for event ' + listener.event);
        }
        _this3.removeListener(listener.event, listener.func);
      });
    }
  }]);

  return PMTEventEmitter;
}(_events2.default);

exports.default = PMTEventEmitter;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/flux/PayloadSources.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keymirror = __webpack_require__("./node_modules/keymirror/index.js");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PayloadSources = (0, _keymirror2.default)({
  SERVER_ACTION: null,
  VIEW_ACTION: null
});

exports.default = PayloadSources;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/flux/ReduceStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _Store2 = __webpack_require__("./sdk/scripts/flux/Store.js");

var _Store3 = _interopRequireDefault(_Store2);

var _invariant = __webpack_require__("./sdk/scripts/utils/invariant.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _abstractMethod = __webpack_require__("./sdk/scripts/utils/abstractMethod.js");

var _abstractMethod2 = _interopRequireDefault(_abstractMethod);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _DevelopmentUtils = __webpack_require__("./sdk/scripts/utils/DevelopmentUtils.js");

var _DevelopmentUtils2 = _interopRequireDefault(_DevelopmentUtils);

var _Utils = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils2 = _interopRequireDefault(_Utils);

var _GlobalState = __webpack_require__("./sdk/scripts/flux/GlobalState.js");

var _GlobalState2 = _interopRequireDefault(_GlobalState);

var _deprecated = __webpack_require__("./sdk/scripts/decorators/deprecated.js");

var _deprecated2 = _interopRequireDefault(_deprecated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// on production build, with uglify, the constructor.name is the same. So we increment an id
// in order to have a unique store._id.
var storeId = 0;

/**
* This is the basic building block of a Flux application. All of your stores
* should extend this class.
*
*   class CounterStore extends ReduceStore<number> {
*     getInitialState(): number {
*       return 1;
*     }
*
*     reduce(state: number, action: Object): number {
*       switch(action.type) {
*         case: 'add':
*           return state + action.value;
*         case: 'double':
*           return state * 2;
*         default:
*           return state;
*       }
*     }
*   }
*
*
*  Inspired by https://github.com/facebook/flux/blob/master/src/stores/FluxReduceStore.js
*  We add some PayMyTable code for legacy and transition.
*/
var ReduceStore = (_class = function (_Store) {
  _inherits(ReduceStore, _Store);

  _createClass(ReduceStore, [{
    key: '_state',
    get: function get() {
      return _GlobalState2.default.getForId(this._id);
    }

    /**
    * The store can use emitEvent. We save the event and run it after the state is updated.
    */

  }]);

  function ReduceStore(dispatcher) {
    _classCallCheck(this, ReduceStore);

    var _this = _possibleConstructorReturn(this, (ReduceStore.__proto__ || Object.getPrototypeOf(ReduceStore)).call(this, dispatcher));

    _this._eventsToSend = [];

    _this.__onGlobalStateChange = function () {
      console.log('__onGlobalStateChange', _this._id);
      _this.__emitter.emit(_this.__changeEvent);
    };

    _this._id = _this.constructor.name + '_' + storeId;
    storeId++;
    // this._state = this.getInitialState();

    // globalState[this._id] = this._state;
    _GlobalState2.default.setForId(_this._id, _this.getInitialState());

    _GlobalState2.default.registerStore(_this);
    return _this;
  }

  /**
  * Getter that exposes the entire state of this store. If your state is not
  * immutable you should override this and not expose _state directly.
  */


  _createClass(ReduceStore, [{
    key: 'getState',
    value: function getState() {
      return this._state;
    }
  }, {
    key: 'reset',
    value: function reset() {
      _GlobalState2.default.setForId(this._id, this.getInitialState());
    }

    /**
    * Handle legacy stores that can send multiple events for one action.
    * We save the event to send and send it when the store is update.
    */

  }, {
    key: 'emitEvent',
    value: function emitEvent(event) {
      this._eventsToSend.push(event);
    }

    /**
     * Must be override by old stores that does not handle uniq 'onchange' event yet.
     * In those case, must return true
     */

  }, {
    key: 'isEmitingCustomEvents',
    value: function isEmitingCustomEvents() {
      return false;
    }

    /**
    * Constructs the initial state for this store. This is called once during
    * construction of the store.
    */

  }, {
    key: 'getInitialState',
    value: function getInitialState() {
      return (0, _abstractMethod2.default)('FluxReduceStore', 'getInitialState');
    }

    /**
    * Used to reduce a stream of actions coming from the dispatcher into a
    * single state object.
    */

  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      return (0, _abstractMethod2.default)('FluxReduceStore', 'reduce');
    }

    /**
    * Checks if two versions of state are the same. You do not need to override
    * this if your state is immutable.
    */

  }, {
    key: 'areEqual',
    value: function areEqual(one, two) {
      var isEqual = _lodash2.default.isEqual(one, two);
      return isEqual;
      // return one === two;
    }
  }, {
    key: '__invokeOnDispatch',
    value: function __invokeOnDispatch(action) {
      var _this2 = this;

      this.__changed = false;

      this._eventsToSend = []; // reset event to send

      // Reduce the stream of incoming actions to state, update when necessary.
      var startingState = this._state;

      var endingState = void 0;

      var nextState = _lodash2.default.cloneDeepWith(startingState);

      /**
      * PMT legacy.
      * With our dispatcher, we have an object `action` like the payload on AppDispatcher
      * const payload = {  source, action }
      * instead of the action directly..
      *
      */
      if (_lodash2.default.isUndefined(action.type)) {
        endingState = this.reduce(startingState, action.action, nextState);
      } else {
        endingState = this.reduce(startingState, action, nextState);
      }

      // This means your ending state should never be undefined.
      (0, _invariant2.default)(endingState !== undefined, '%s returned undefined from reduce(...), did you forget to return ' + 'state in the default case? (use null if this was intentional)', this.constructor.name);

      if (!this.areEqual(startingState, endingState)) {
        // `__emitChange()` sets `this.__changed` to true and then the actual
        // change will be fired from the emitter at the end of the dispatch, this
        // is required in order to support methods like `hasChanged()`
        this.__emitChange();

        if (_lodash2.default.isUndefined(action.type)) {
          this.updateGlobalState(action.action, endingState);
        } else {
          this.updateGlobalState(action, endingState);
        }
      }

      if (this.__changed) {
        if (!_lodash2.default.isEmpty(this._eventsToSend)) {
          _lodash2.default.each(this._eventsToSend, function (event) {
            _this2.__emitter.emit(event);
          });
        } else if (!this.isEmitingCustomEvents()) {
          this.__emitter.emit(this.__changeEvent);
        }
      } else if (!_lodash2.default.isEmpty(this._eventsToSend)) {
        console.warn('ReduceStore.areEqual maybe not implemented on ' + this._id, this._eventsToSend);
        _lodash2.default.each(this._eventsToSend, function (event) {
          _this2.__emitter.emit(event);
        });
      }
    }
  }, {
    key: 'updateGlobalState',
    value: function updateGlobalState(action, state) {
      var actionToSendToDevTools = _lodash2.default.cloneDeepWith(action);
      _GlobalState2.default.setForId(this._id, state);

      // add store name to know where the action is handle
      actionToSendToDevTools.type = action.type + ' (' + this._id + ')';

      _DevelopmentUtils2.default.sendToDevTools(actionToSendToDevTools, _GlobalState2.default.getGlobalState());
    }
  }]);

  return ReduceStore;
}(_Store3.default), (_applyDecoratedDescriptor(_class.prototype, 'reset', [_deprecated2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'reset'), _class.prototype)), _class);
exports.default = ReduceStore;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/flux/Route.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Define a route.
 */
var Route = function () {

  /**
   * Construct a new Route object.
   * @param name The name (identifier) of the route.
   * @param path The path of the route. Ex: /home or /restaurants/:id
   * @param handler The handler for this route. A null handler disable the route
   * @param handler Define if the route is restrict to loggedIn user
   * @param disable
   */


  // The path of the route. Ex: /home or /restaurants/:id
  function Route(name, path, handler) {
    var authRequired = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var disable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, Route);

    this.name = '';
    this.path = '';
    this.handler = '';
    this.disable = false;
    this.authRequired = true;

    this.name = name;
    this.path = path;
    this.handler = handler;
    this.authRequired = authRequired;
    // disable if the handler is null.
    this.disable = handler === null ? false : disable;
  }

  /*
   * Replace params. On url definition, params start with ':'
   */


  // The handler for this route.


  // The name (identifier) of the route.


  _createClass(Route, [{
    key: 'generatePathWithParams',
    value: function generatePathWithParams(params) {
      var path = this.path;
      _lodash2.default.forIn(params, function (param, key) {
        path = path.replace(':' + key, param);
      });

      return path;
    }
  }]);

  return Route;
}();

exports.default = Route;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/flux/Store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PMTEventEmitter = __webpack_require__("./sdk/scripts/flux/PMTEventEmitter.js");

var _PMTEventEmitter2 = _interopRequireDefault(_PMTEventEmitter);

var _AppDispatcher = __webpack_require__("./sdk/scripts/flux/AppDispatcher.js");

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _invariant = __webpack_require__("./sdk/scripts/utils/invariant.js");

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class represents the most basic functionality for a FluxStore. Do not
 * extend this store directly; instead extend FluxReduceStore when creating a
 * new store.
 *
 * Inspired by https://github.com/facebook/flux/blob/master/src/stores/FluxStore.js
 * We add some PayMyTable code for legacy and transition.
 */
var Store = function () {

  // private
  function Store() {
    var _this = this;

    var dispatcher = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, Store);

    this.__className = this.constructor.name;

    this.__changed = false;
    this.__changeEvent = 'change';

    this.__emitter = new _PMTEventEmitter2.default();

    if (dispatcher == null) {
      // pmt flux implementation
      this.__dispatcher = _AppDispatcher2.default;
      this._dispatchToken = this.__dispatcher.register(function (payload) {
        _this.__invokeOnDispatch(payload);
      });
    } else {
      // real flux
      this.__dispatcher = dispatcher;
      this._dispatchToken = this.__dispatcher.register(function (payload) {
        _this.__invokeOnDispatch(payload);
      });
    }
  }

  /**
   * Should be named addListener, but we use our custom, so we rename it to `addListenerFlux`
   */


  // protected, available to subclasses


  _createClass(Store, [{
    key: 'addListenerFlux',
    value: function addListenerFlux(callback) {
      return this.__emitter.addListener(this.__changeEvent, callback);
    }
  }, {
    key: 'addListener',
    value: function addListener(event, callback) {
      if (_lodash2.default.isFunction(event)) {
        this.addListenerFlux(event);
      } else {
        this.__emitter.addListener(event, callback);
      }
    }
  }, {
    key: 'removeListener',
    value: function removeListener(event, callback) {
      if (_lodash2.default.isFunction(event)) {
        this.addListenerFlux(event);
      } else {
        this.__emitter.removeListener(event, callback);
      }
    }

    //
    // PayMyTable legacy code
    //


  }, {
    key: 'addListeners',
    value: function addListeners(listeners) {
      var _this2 = this;

      _lodash2.default.each(listeners, function (listener) {
        _this2.__emitter.addListener(listener.event, listener.func);
      });
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners(listeners) {
      var _this3 = this;

      _lodash2.default.each(listeners, function (listener) {
        (0, _invariant2.default)(_lodash2.default.isFunction(listener.func), '[Listener] REMOVE - Invalid listener for event ' + listener.event);
        _this3.__emitter.removeListener(listener.event, listener.func);
      });
    }
  }, {
    key: 'emitEvent',
    value: function emitEvent(event) {
      this.__emitter.emit(event);
    }

    //

  }, {
    key: 'getDispatcher',
    value: function getDispatcher() {
      return this.__dispatcher;
    }

    /**
     * This exposes a unique string to identify each store's registered callback.
     * This is used with the dispatcher's waitFor method to declaratively depend
     * on other stores updating themselves first.
     */

  }, {
    key: 'getDispatchToken',
    value: function getDispatchToken() {
      return this._dispatchToken;
    }
  }, {
    key: 'waitFor',
    value: function waitFor(tokens) {
      this.__dispatcher.waitFor(tokens);
    }

    /**
     * Returns whether the store has changed during the most recent dispatch.
     */

  }, {
    key: 'hasChanged',
    value: function hasChanged() {
      (0, _invariant2.default)(this.__dispatcher.isDispatching(), '%s.hasChanged(): Must be invoked while dispatching.', this.__className);
      return this.__changed;
    }
  }, {
    key: '__emitChange',
    value: function __emitChange() {
      (0, _invariant2.default)(this.__dispatcher.isDispatching(), '%s.__emitChange(): Must be invoked while dispatching.', this.__className);
      this.__changed = true;
    }

    /**
     * This method encapsulates all logic for invoking __onDispatch. It should
     * be used for things like catching changes and emitting them after the
     * subclass has handled a payload.
     */

  }, {
    key: '__invokeOnDispatch',
    value: function __invokeOnDispatch(payload) {
      this.__changed = false;
      this.__onDispatch(payload);
      if (this.__changed) {
        this.__emitter.emit(this.__changeEvent);
      }
    }

    /**
     * The callback that will be registered with the dispatcher during
     * instantiation. Subclasses must override this method. This callback is the
     * only way the store receives new data.
     */

  }, {
    key: '__onDispatch',
    value: function __onDispatch(payload) {
      (0, _invariant2.default)(false, '%s has not overridden FluxStore.__onDispatch(), which is required', this.__className);
    }
  }]);

  return Store;
}();

exports.default = Store;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/i18n/I18n.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _startsWith = __webpack_require__("./sdk/node_modules/lodash/startsWith.js");

var _startsWith2 = _interopRequireDefault(_startsWith);

var _isEmpty = __webpack_require__("./sdk/node_modules/lodash/isEmpty.js");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _intlMessageformat = __webpack_require__("./node_modules/intl-messageformat/index.js");

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _de = __webpack_require__("./node_modules/react-intl/locale-data/de.js");

var _de2 = _interopRequireDefault(_de);

var _en = __webpack_require__("./node_modules/react-intl/locale-data/en.js");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./node_modules/react-intl/locale-data/fr.js");

var _fr2 = _interopRequireDefault(_fr);

var _UrlUtils = __webpack_require__("./sdk/scripts/utils/UrlUtils.js");

var _UrlUtils2 = _interopRequireDefault(_UrlUtils);

var _de3 = __webpack_require__("./sdk/scripts/i18n/locales/de.json");

var _de4 = _interopRequireDefault(_de3);

var _en3 = __webpack_require__("./sdk/scripts/i18n/locales/en.json");

var _en4 = _interopRequireDefault(_en3);

var _fr3 = __webpack_require__("./sdk/scripts/i18n/locales/fr.json");

var _fr4 = _interopRequireDefault(_fr3);

var _de5 = __webpack_require__("./sdk/scripts/i18n/data/currencies/de.json");

var _de6 = _interopRequireDefault(_de5);

var _en5 = __webpack_require__("./sdk/scripts/i18n/data/currencies/en.json");

var _en6 = _interopRequireDefault(_en5);

var _fr5 = __webpack_require__("./sdk/scripts/i18n/data/currencies/fr.json");

var _fr6 = _interopRequireDefault(_fr5);

var _de7 = __webpack_require__("./sdk/scripts/i18n/data/countries/de.json");

var _de8 = _interopRequireDefault(_de7);

var _en7 = __webpack_require__("./sdk/scripts/i18n/data/countries/en.json");

var _en8 = _interopRequireDefault(_en7);

var _fr7 = __webpack_require__("./sdk/scripts/i18n/data/countries/fr.json");

var _fr8 = _interopRequireDefault(_fr7);

var _de9 = __webpack_require__("./sdk/scripts/i18n/data/languages/de.json");

var _de10 = _interopRequireDefault(_de9);

var _en9 = __webpack_require__("./sdk/scripts/i18n/data/languages/en.json");

var _en10 = _interopRequireDefault(_en9);

var _fr9 = __webpack_require__("./sdk/scripts/i18n/data/languages/fr.json");

var _fr10 = _interopRequireDefault(_fr9);

var _de11 = __webpack_require__("./sdk/scripts/i18n/data/locales/de.json");

var _de12 = _interopRequireDefault(_de11);

var _en11 = __webpack_require__("./sdk/scripts/i18n/data/locales/en.json");

var _en12 = _interopRequireDefault(_en11);

var _fr11 = __webpack_require__("./sdk/scripts/i18n/data/locales/fr.json");

var _fr12 = _interopRequireDefault(_fr11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Currencies = {
  de: _de6.default,
  en: _en6.default,
  fr: _fr6.default
};

var Countries = {
  de: _de8.default,
  en: _en8.default,
  fr: _fr8.default
};

var Languages = {
  de: _de10.default,
  en: _en10.default,
  fr: _fr10.default
};

var Locales = {
  de: _de12.default,
  en: _en12.default,
  fr: _fr12.default
};

/**
 * @Singleton
 *
 * @link https://medium.freecodecamp.com/internationalization-in-react-7264738274a0#.nqpzdmp66
 */

var I18n = function () {
  function I18n() {
    _classCallCheck(this, I18n);

    this.defaultLocale = 'en';
    this.locale = '';
    this.localeData = {};
    this.messages = {};
  }

  /**
   * The locale to use by default.
   * This locale is used if the user locale is not available on `localeData`.
   */


  /**
   * Contains the current locale.
   */


  /**
   * Contains all the messages for all the locales.
   */


  /**
   * Contains all the messages for the current selected locale.
   */


  _createClass(I18n, [{
    key: 'configure',
    value: function configure(localeData) {
      if (!global.Intl) {
        console.error('Required intl Polyfill');
      }

      this.localeData = localeData;

      // TODO: in dev mode, verify there is no keys missing between languages and fr

      // TODO: in dev mode, verify there is no key conflict between localeData and sdk

      // merge sdk locales with given localeData
      this.localeData.de = _lodash2.default.merge(this.localeData.de, _de4.default);
      this.localeData.en = _lodash2.default.merge(this.localeData.en, _en4.default);
      this.localeData.fr = _lodash2.default.merge(this.localeData.fr, _fr4.default);

      this.changeLocale(this.getDefaultLocale());
    }
  }, {
    key: 'languageWithoutRegionCode',
    value: function languageWithoutRegionCode(language) {
      if (_lodash2.default.isEmpty(language)) {
        return 'fr';
      }

      // Split locales with a region code
      var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

      return languageWithoutRegionCode;
    }
  }, {
    key: 'getCurrentLanguageWithoutRegionCode',
    value: function getCurrentLanguageWithoutRegionCode() {
      return this.languageWithoutRegionCode(this.locale);
    }
  }, {
    key: 'isSupportedLocale',
    value: function isSupportedLocale(locale) {
      return _lodash2.default.indexOf(_lodash2.default.keys(Locales), locale) !== -1;
    }
  }, {
    key: 'getDefaultLocale',
    value: function getDefaultLocale() {
      var l = _UrlUtils2.default.getQueryParam('l');
      if (!_lodash2.default.isEmpty(l) && this.isSupportedLocale(l)) {
        return l;
      }

      // Define user's language. Different browsers have the user locale defined
      // on different fields on the `navigator` object, so we make sure to account
      // for these different by checking all of them
      var language = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;

      return language;
    }
  }, {
    key: 'changeLocale',
    value: function changeLocale(locale) {
      this.locale = locale;

      (0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default), _toConsumableArray(_fr2.default), _toConsumableArray(_de2.default)));

      // Split locales with a region code
      var languageWithoutRegionCode = this.languageWithoutRegionCode(this.locale);

      // Try full locale, try locale without region code, fallback to the default locale.
      this.messages = this.localeData[languageWithoutRegionCode] || this.localeData[this.locale] || this.localeData[this.defaultLocale];

      // TODO: in dev mode, verify all keys exists in differents locales.

      // Register messages. TODO: test
      (0, _reactIntl.defineMessages)(this.messages);
    }
  }, {
    key: 'tr',
    value: function tr(key) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.trWithLocale(this.locale, key, params);
    }
  }, {
    key: 'trWithLocale',
    value: function trWithLocale(locale, key) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (_lodash2.default.isEmpty(key)) {
        // TODO: in dev, error
        return '';
      }

      var message = this.findForKey(key);

      try {
        var msg = new _intlMessageformat2.default(message, locale);

        // TODO: handle key does not exists.

        return msg.format(params);
      } catch (e) {
        // Note: Sometimes strings contains params that does not need to be handle here, like
        // components.select.add_label_text `Ajouter {label} ?`
        // Here our IntlMessageFormat.format try to format the label, but don't have any param.
        // For those case, we have to try / catch the error. The tricks to avoid errors consists to
        // set as parameter the same string. Example here:
        // `I18n.tr('components.select.add_label_text', { label: '{label}'})`
        console.warn('I18n: ' + key + ' error when formatting for locale ' + this.locale, params);
      }

      return message;
    }
  }, {
    key: 'findForKey',
    value: function findForKey(key) {
      var _this = this;

      var printErrorMessage = function printErrorMessage(key) {
        // TODO: log error.
        console.warn('I18n: Impossible to find ' + key + ' for locale ' + _this.locale);
      };

      try {
        var message = this.messages[key];

        if (_lodash2.default.isNil(message)) {
          printErrorMessage(key);
          return this.getDefaultForKey(key);
        }

        return message;
      } catch (e) {
        printErrorMessage(key);
        return this.getDefaultForKey(key);
      }
    }
  }, {
    key: 'getDefaultForKey',
    value: function getDefaultForKey(key) {
      return key;
      try {
        // we use the 'fr' locale to find default message because it is the most up-to-date language
        // when developing.
        var message = this.localeData['fr'][key];

        if (!_lodash2.default.isNil(message)) {
          return message;
        }
      } catch (e) {
        // just in case, should not happened.
      }

      return key;
    }

    /**
     * Example: flatpickr.init.prototype.l10n = I18n.localizeFlatpickr(flatpickr.init.prototype.l10n)
     *
     * @param flatpickr.init.prototype.l10n
     */

  }, {
    key: 'localizeFlatpickr',
    value: function localizeFlatpickr(l10n) {
      // list here https://github.com/cdnjs/cdnjs/tree/master/ajax/libs/flatpickr/1.8.8
      switch (this.getCurrentLanguageWithoutRegionCode().toLowerCase()) {
        case 'de':
          l10n.weekdays = {
            shorthand: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            longhand: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
          };

          l10n.months = {
            shorthand: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            longhand: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
          };
          break;
        case 'fr':
          // Localize. See https://github.com/cdnjs/cdnjs/blob/master/ajax/libs/flatpickr/1.8.8/flatpickr.l10n.fr.js
          l10n.weekdays = {
            shorthand: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            longhand: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
          };

          l10n.months = {
            shorthand: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
            longhand: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
          };

          l10n.ordinal = function (nth) {
            if (nth > 1) {
              return 'ème';
            }

            return 'er';
          };

          break;
        case 'en':
          break;
        default:
        // TODO: logger
      }

      return l10n;
    }
  }, {
    key: 'getCurrencyName',
    value: function getCurrencyName(currencyCode) {
      return Currencies[this.getCurrentLanguageWithoutRegionCode()][currencyCode];
    }
  }, {
    key: 'getCountry',
    value: function getCountry(countryCode) {
      return Countries[this.getCurrentLanguageWithoutRegionCode()][countryCode];
    }
  }, {
    key: 'getLanguage',
    value: function getLanguage(locale) {
      return Languages[this.getCurrentLanguageWithoutRegionCode()][locale];
    }
  }, {
    key: 'getLocale',
    value: function getLocale(locale) {
      return Locales[this.getCurrentLanguageWithoutRegionCode()][locale];
    }
  }, {
    key: 'getForCurrentLocale',
    value: function getForCurrentLocale(locales) {
      if (!locales) {
        return '';
      }

      // try to find for current language
      var currentLanguage = this.getCurrentLanguageWithoutRegionCode().toUpperCase();
      var locale = _ArrayUtils2.default.find(locales, function (locale) {
        return locale.locale && (0, _startsWith2.default)(locale.locale.toLowerCase(), currentLanguage.toLowerCase());
      });

      // try to find for default language
      if (!locale) {
        var defaultLanguage = this.getDefaultLocale().substr(0, 2).toUpperCase();

        if (defaultLanguage !== currentLanguage) {
          locale = _ArrayUtils2.default.find(locales, function (locale) {
            return locale.locale && (0, _startsWith2.default)(locale.locale.toLowerCase(), defaultLanguage.toLowerCase());
          });
        }
      }

      // none found, fallback to a default
      if (!locale && !(0, _isEmpty2.default)(locales)) {
        locale = locales[0];
      }

      // avoid crash
      return locale ? locale.text : '';
    }
  }]);

  return I18n;
}();

var _I18nInstance = new I18n();

exports.default = _I18nInstance;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./sdk/scripts/i18n/data/countries/de.json":
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","EG":"Ägypten","AX":"Åland-Inseln","AL":"Albanien","DZ":"Algerien","UM":"Amerikanisch-Ozeanien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua und Barbuda","GQ":"Äquatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AC":"Ascension","AZ":"Aserbaidschan","ET":"Äthiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Belarus","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BA":"Bosnien und Herzegowina","BW":"Botsuana","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","EA":"Ceuta und Melilla","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Côte d’Ivoire","CW":"Curaçao","DK":"Dänemark","KP":"Demokratische Volksrepublik Korea","DE":"Deutschland","DG":"Diego Garcia","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"Färöer","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Französisch-Guayana","PF":"Französisch-Polynesien","TF":"Französische Süd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Grönland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HN":"Honduras","IN":"Indien","ID":"Indonesien","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IM":"Isle of Man","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","IC":"Kanarische Inseln","CV":"Kap Verde","BQ":"Karibische Niederlande","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CG":"Kongo-Brazzaville","CD":"Kongo-Kinshasa","XK":"Kosovo","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MK":"Mazedonien","MX":"Mexiko","FM":"Mikronesien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MP":"Nördliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"Österreich","PK":"Pakistan","PS":"Palästinensische Autonomiegebiete","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","KR":"Republik Korea","MD":"Republik Moldau","RE":"Réunion","RW":"Ruanda","RO":"Rumänien","RU":"Russische Föderation","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"São Tomé und Príncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","MO":"Sonderverwaltungsregion Macau","HK":"Sonderverwaltungszone Hongkong","ES":"Spanien","LK":"Sri Lanka","BL":"St. Barthélemy","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","MF":"St. Martin","PM":"St. Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"Südafrika","SD":"Sudan","GS":"Südgeorgien und die Südlichen Sandwichinseln","SS":"Südsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Swasiland","SY":"Syrien","TJ":"Tadschikistan","TW":"Taiwan","TZ":"Tansania","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TA":"Tristan da Cunha","TD":"Tschad","CZ":"Tschechische Republik","TN":"Tunesien","TR":"Türkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":"Vereinigte Staaten","GB":"Vereinigtes Königreich","VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/countries/en.json":
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua & Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AC":"Ascension Island","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia & Herzegovina","BW":"Botswana","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"British Virgin Islands","BN":"Brunei","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","IC":"Canary Islands","CV":"Cape Verde","BQ":"Caribbean Netherlands","KY":"Cayman Islands","CF":"Central African Republic","EA":"Ceuta & Melilla","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo - Brazzaville","CD":"Congo - Kinshasa","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d’Ivoire","HR":"Croatia","CU":"Cuba","CW":"Curaçao","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DG":"Diego Garcia","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HN":"Honduras","HK":"Hong Kong SAR China","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","XK":"Kosovo","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Laos","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macau SAR China","MK":"Macedonia","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia","MD":"Moldova","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar (Burma)","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"North Korea","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territories","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn Islands","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russia","RW":"Rwanda","WS":"Samoa","SM":"San Marino","ST":"São Tomé & Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia & South Sandwich Islands","KR":"South Korea","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","BL":"St. Barthélemy","SH":"St. Helena","KN":"St. Kitts & Nevis","LC":"St. Lucia","MF":"St. Martin","PM":"St. Pierre & Miquelon","VC":"St. Vincent & Grenadines","SD":"Sudan","SR":"Suriname","SJ":"Svalbard & Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syria","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad & Tobago","TA":"Tristan da Cunha","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks & Caicos Islands","TV":"Tuvalu","UM":"U.S. Outlying Islands","VI":"U.S. Virgin Islands","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Vatican City","VE":"Venezuela","VN":"Vietnam","WF":"Wallis & Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/countries/fr.json":
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","ZA":"Afrique du Sud","AL":"Albanie","DZ":"Algérie","DE":"Allemagne","AD":"Andorre","AO":"Angola","AI":"Anguilla","AQ":"Antarctique","AG":"Antigua-et-Barbuda","SA":"Arabie saoudite","AR":"Argentine","AM":"Arménie","AW":"Aruba","AU":"Australie","AT":"Autriche","AZ":"Azerbaïdjan","BS":"Bahamas","BH":"Bahreïn","BD":"Bangladesh","BB":"Barbade","BE":"Belgique","BZ":"Belize","BJ":"Bénin","BM":"Bermudes","BT":"Bhoutan","BY":"Biélorussie","BO":"Bolivie","BA":"Bosnie-Herzégovine","BW":"Botswana","BR":"Brésil","BN":"Brunéi Darussalam","BG":"Bulgarie","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodge","CM":"Cameroun","CA":"Canada","CV":"Cap-Vert","EA":"Ceuta et Melilla","CL":"Chili","CN":"Chine","CY":"Chypre","CO":"Colombie","KM":"Comores","CG":"Congo-Brazzaville","CD":"Congo-Kinshasa","KP":"Corée du Nord","KR":"Corée du Sud","CR":"Costa Rica","CI":"Côte d’Ivoire","HR":"Croatie","CU":"Cuba","CW":"Curaçao","DK":"Danemark","DG":"Diego Garcia","DJ":"Djibouti","DM":"Dominique","EG":"Égypte","SV":"El Salvador","AE":"Émirats arabes unis","EC":"Équateur","ER":"Érythrée","ES":"Espagne","EE":"Estonie","VA":"État de la Cité du Vatican","FM":"États fédérés de Micronésie","US":"États-Unis","ET":"Éthiopie","FJ":"Fidji","FI":"Finlande","FR":"France","GA":"Gabon","GM":"Gambie","GE":"Géorgie","GH":"Ghana","GI":"Gibraltar","GR":"Grèce","GD":"Grenade","GL":"Groenland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernesey","GN":"Guinée","GQ":"Guinée équatoriale","GW":"Guinée-Bissau","GY":"Guyana","GF":"Guyane française","HT":"Haïti","HN":"Honduras","HU":"Hongrie","CX":"Île Christmas","AC":"Île de l’Ascension","IM":"Île de Man","NF":"Île Norfolk","AX":"Îles Åland","KY":"Îles Caïmans","IC":"Îles Canaries","CC":"Îles Cocos","CK":"Îles Cook","FO":"Îles Féroé","GS":"Îles Géorgie du Sud et Sandwich du Sud","FK":"Îles Malouines","MP":"Îles Mariannes du Nord","MH":"Îles Marshall","UM":"Îles mineures éloignées des États-Unis","SB":"Îles Salomon","TC":"Îles Turques-et-Caïques","VG":"Îles Vierges britanniques","VI":"Îles Vierges des États-Unis","IN":"Inde","ID":"Indonésie","IQ":"Irak","IR":"Iran","IE":"Irlande","IS":"Islande","IL":"Israël","IT":"Italie","JM":"Jamaïque","JP":"Japon","JE":"Jersey","JO":"Jordanie","KZ":"Kazakhstan","KE":"Kenya","KG":"Kirghizistan","KI":"Kiribati","XK":"Kosovo","KW":"Koweït","RE":"La Réunion","LA":"Laos","LS":"Lesotho","LV":"Lettonie","LB":"Liban","LR":"Libéria","LY":"Libye","LI":"Liechtenstein","LT":"Lituanie","LU":"Luxembourg","MK":"Macédoine","MG":"Madagascar","MY":"Malaisie","MW":"Malawi","MV":"Maldives","ML":"Mali","MT":"Malte","MA":"Maroc","MQ":"Martinique","MU":"Maurice","MR":"Mauritanie","YT":"Mayotte","MX":"Mexique","MD":"Moldavie","MC":"Monaco","MN":"Mongolie","ME":"Monténégro","MS":"Montserrat","MZ":"Mozambique","MM":"Myanmar","NA":"Namibie","NR":"Nauru","NP":"Népal","NI":"Nicaragua","NE":"Niger","NG":"Nigéria","NU":"Niue","NO":"Norvège","NC":"Nouvelle-Calédonie","NZ":"Nouvelle-Zélande","OM":"Oman","UG":"Ouganda","UZ":"Ouzbékistan","PK":"Pakistan","PW":"Palaos","PA":"Panama","PG":"Papouasie-Nouvelle-Guinée","PY":"Paraguay","NL":"Pays-Bas","BQ":"Pays-Bas caribéens","PE":"Pérou","PH":"Philippines","PN":"Pitcairn","PL":"Pologne","PF":"Polynésie française","PR":"Porto Rico","PT":"Portugal","QA":"Qatar","HK":"R.A.S. chinoise de Hong Kong","MO":"R.A.S. chinoise de Macao","CF":"République centrafricaine","DO":"République dominicaine","CZ":"République tchèque","RO":"Roumanie","GB":"Royaume-Uni","RU":"Russie","RW":"Rwanda","EH":"Sahara occidental","BL":"Saint-Barthélemy","KN":"Saint-Christophe-et-Niévès","SM":"Saint-Marin","MF":"Saint-Martin (partie française)","SX":"Saint-Martin (partie néerlandaise)","PM":"Saint-Pierre-et-Miquelon","VC":"Saint-Vincent-et-les-Grenadines","SH":"Sainte-Hélène","LC":"Sainte-Lucie","WS":"Samoa","AS":"Samoa américaines","ST":"Sao Tomé-et-Principe","SN":"Sénégal","RS":"Serbie","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapour","SK":"Slovaquie","SI":"Slovénie","SO":"Somalie","SD":"Soudan","SS":"Soudan du Sud","LK":"Sri Lanka","SE":"Suède","CH":"Suisse","SR":"Suriname","SJ":"Svalbard et Jan Mayen","SZ":"Swaziland","SY":"Syrie","TJ":"Tadjikistan","TW":"Taïwan","TZ":"Tanzanie","TD":"Tchad","TF":"Terres australes françaises","IO":"Territoire britannique de l’océan Indien","PS":"Territoires palestiniens","TH":"Thaïlande","TL":"Timor oriental","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinité-et-Tobago","TA":"Tristan da Cunha","TN":"Tunisie","TM":"Turkménistan","TR":"Turquie","TV":"Tuvalu","UA":"Ukraine","UY":"Uruguay","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","WF":"Wallis-et-Futuna","YE":"Yémen","ZM":"Zambie","ZW":"Zimbabwe"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/currencies/de.json":
/***/ (function(module, exports) {

module.exports = {"AFA":"Afghanische Afghani (1927–2002)","AFN":"Afghanischer Afghani","EGP":"Ägyptisches Pfund","ALL":"Albanischer Lek","ALK":"Albanischer Lek (1946–1965)","DZD":"Algerischer Dinar","ADP":"Andorranische Pesete","AOA":"Angolanischer Kwanza","AOK":"Angolanischer Kwanza (1977–1990)","AOR":"Angolanischer Kwanza Reajustado (1995–1999)","AON":"Angolanischer Neuer Kwanza (1990–2000)","GQE":"Äquatorialguinea-Ekwele","ARA":"Argentinischer Austral","ARS":"Argentinischer Peso","ARM":"Argentinischer Peso (1881–1970)","ARP":"Argentinischer Peso (1983–1985)","ARL":"Argentinischer Peso Ley (1970–1983)","AMD":"Armenischer Dram","AWG":"Aruba-Florin","AZN":"Aserbaidschan-Manat","AZM":"Aserbaidschan-Manat (1993–2006)","ETB":"Äthiopischer Birr","AUD":"Australischer Dollar","BSD":"Bahamas-Dollar","BHD":"Bahrain-Dinar","BDT":"Bangladesch-Taka","BBD":"Barbados-Dollar","BYB":"Belarus-Rubel (1994–1999)","BEL":"Belgischer Finanz-Franc","BEF":"Belgischer Franc","BEC":"Belgischer Franc (konvertibel)","BZD":"Belize-Dollar","BMD":"Bermuda-Dollar","BTN":"Bhutan-Ngultrum","BUK":"Birmanischer Kyat","BOB":"Bolivanischer Boliviano","BOL":"Bolivianischer Boliviano (1863–1963)","BOP":"Bolivianischer Peso","BOV":"Boliviansiche Mvdol","BAD":"Bosnien und Herzegowina Dinar (1992–1994)","BAM":"Bosnien und Herzegowina Konvertierbare Mark","BAN":"Bosnien und Herzegowina Neuer Dinar (1994–1997)","BWP":"Botswanischer Pula","BRC":"Brasilianischer Cruzado (1986–1989)","BRN":"Brasilianischer Cruzado Novo (1989–1990)","BRZ":"Brasilianischer Cruzeiro (1942–1967)","BRE":"Brasilianischer Cruzeiro (1990–1993)","BRR":"Brasilianischer Cruzeiro (1993–1994)","BRB":"Brasilianischer Cruzeiro Novo (1967–1986)","BRL":"Brasilianischer Real","GBP":"Britisches Pfund Sterling","BND":"Brunei-Dollar","BGL":"Bulgarische Lew (1962–1999)","BGN":"Bulgarischer Lew","BGO":"Bulgarischer Lew (1879–1952)","BGM":"Bulgarischer Lew (1952–1962)","BIF":"Burundi-Franc","XOF":"CFA-Franc (BCEAO)","XAF":"CFA-Franc (BEAC)","XPF":"CFP-Franc","CLF":"Chilenische Unidades de Fomento","CLE":"Chilenischer Escudo","CLP":"Chilenischer Peso","CRC":"Costa-Rica-Colón","DKK":"Dänische Krone","DEM":"Deutsche Mark","CNX":"Dollar der Chinesischen Volksbank","DOP":"Dominikanischer Peso","DJF":"Dschibuti-Franc","ECS":"Ecuadorianischer Sucre","SVC":"El Salvador Colon","ERN":"Eritreischer Nakfa","EEK":"Estnische Krone","EUR":"Euro","XEU":"Europäische Währungseinheit (XEU)","FKP":"Falkland-Pfund","FJD":"Fidschi-Dollar","FIM":"Finnische Mark","FRF":"Französischer Franc","XFO":"Französischer Gold-Franc","XFU":"Französischer UIC-Franc","GMD":"Gambia-Dalasi","GEK":"Georgischer Kupon Larit","GEL":"Georgischer Lari","GHS":"Ghanaischer Cedi","GHC":"Ghanaischer Cedi (1979–2007)","GIP":"Gibraltar-Pfund","GRD":"Griechische Drachme","GTQ":"Guatemaltekischer Quetzal","GWP":"Guinea-Bissau Peso","GNF":"Guinea-Franc","GNS":"Guineischer Syli","GYD":"Guyana-Dollar","HTG":"Haitianische Gourde","HNL":"Honduras-Lempira","HKD":"Hongkong-Dollar","INR":"Indische Rupie","IDR":"Indonesische Rupiah","IQD":"Irakischer Dinar","IRR":"Iranischer Rial","IEP":"Irisches Pfund","ISK":"Isländische Krone","ISJ":"Isländische Krone (1918–1981)","ILS":"Israelischer Neuer Schekel","ILR":"Israelischer Schekel (1980–1985)","ILP":"Israelisches Pfund","ITL":"Italienische Lira","JMD":"Jamaika-Dollar","JPY":"Japanischer Yen","YDD":"Jemen-Dinar","YER":"Jemen-Rial","JOD":"Jordanischer Dinar","YUD":"Jugoslawischer Dinar (1966–1990)","YUN":"Jugoslawischer Dinar (konvertibel)","YUM":"Jugoslawischer Neuer Dinar (1994–2002)","YUR":"Jugoslawischer reformierter Dinar (1992–1993)","KYD":"Kaiman-Dollar","KHR":"Kambodschanischer Riel","CAD":"Kanadischer Dollar","CVE":"Kap-Verde-Escudo","KZT":"Kasachischer Tenge","QAR":"Katar-Riyal","KES":"Kenia-Schilling","KGS":"Kirgisischer Som","COU":"Kolumbianische Unidades de valor real","COP":"Kolumbianischer Peso","KMF":"Komoren-Franc","CDF":"Kongo-Franc","HRD":"Kroatischer Dinar","HRK":"Kroatischer Kuna","CUP":"Kubanischer Peso","CUC":"Kubanischer Peso (konvertibel)","KWD":"Kuwait-Dinar","ZMW":"Kwacha","ZMK":"Kwacha (1968–2012)","LAK":"Laotischer Kip","LVL":"Lettischer Lats","LVR":"Lettischer Rubel","LBP":"Libanesisches Pfund","LRD":"Liberianischer Dollar","LYD":"Libyscher Dinar","LTL":"Litauischer Litas","LTT":"Litauischer Talonas","LSL":"Loti","LUL":"Luxemburgischer Finanz-Franc","LUF":"Luxemburgischer Franc","LUC":"Luxemburgischer Franc (konvertibel)","MOP":"Macao-Pataca","MGA":"Madagaskar-Ariary","MGF":"Madagaskar-Franc","MWK":"Malawi-Kwacha","MYR":"Malaysischer Ringgit","MVR":"Malediven-Rufiyaa","MVP":"Malediven-Rupie (alt)","MLF":"Malischer Franc","MTL":"Maltesische Lira","MTP":"Maltesisches Pfund","DDM":"Mark der DDR","MAD":"Marokkanischer Dirham","MAF":"Marokkanischer Franc","MRO":"Mauretanischer Ouguiya","MUR":"Mauritius-Rupie","MKD":"Mazedonischer Denar","MKN":"Mazedonischer Denar (1992–1993)","MXV":"Mexicanischer Unidad de Inversion (UDI)","MXN":"Mexikanischer Peso","MXP":"Mexikanischer Silber-Peso (1861–1992)","MDC":"Moldau-Cupon","MDL":"Moldau-Leu","MCF":"Monegassischer Franc","MNT":"Mongolischer Tögrög","MZE":"Mosambikanischer Escudo","MZN":"Mosambikanischer Metical","MZM":"Mosambikanischer Metical (1980–2006)","MMK":"Myanmarischer Kyat","NAD":"Namibia-Dollar","NPR":"Nepalesische Rupie","TWD":"Neuer Taiwan-Dollar","NZD":"Neuseeland-Dollar","NIO":"Nicaragua-Córdoba","NIC":"Nicaraguanischer Córdoba (1988–1991)","ANG":"Niederländische-Antillen-Gulden","NLG":"Niederländischer Gulden","NGN":"Nigerianischer Naira","KPW":"Nordkoreanischer Won","NOK":"Norwegische Krone","OMR":"Omanischer Rial","ATS":"Österreichischer Schilling","XCD":"Ostkaribischer Dollar","PKR":"Pakistanische Rupie","PAB":"Panamaischer Balboa","PGK":"Papua-Neuguineischer Kina","PYG":"Paraguayischer Guaraní","PEI":"Peruanischer Inti","PEN":"Peruanischer Neuer Sol","PES":"Peruanischer Sol (1863–1965)","PHP":"Philippinischer Peso","PLN":"Polnischer Złoty","PLZ":"Polnischer Zloty (1950–1995)","GWE":"Portugiesisch Guinea Escudo","PTE":"Portugiesischer Escudo","CNY":"Renminbi Yuan","RHD":"Rhodesischer Dollar","XRE":"RINET Funds","RWF":"Ruanda-Franc","RON":"Rumänischer Leu","ROL":"Rumänischer Leu (1952–2006)","RUB":"Russischer Rubel","RUR":"Russischer Rubel (1991–1998)","SBD":"Salomonen-Dollar","WST":"Samoanischer Tala","STD":"São-toméischer Dobra","SAR":"Saudi-Rial","SEK":"Schwedische Krone","CHF":"Schweizer Franken","RSD":"Serbischer Dinar","CSD":"Serbischer Dinar (2002–2006)","SCR":"Seychellen-Rupie","SLL":"Sierra-leonischer Leone","ZWD":"Simbabwe-Dollar (1980–2008)","ZWR":"Simbabwe-Dollar (2008)","ZWL":"Simbabwe-Dollar (2009)","SGD":"Singapur-Dollar","SKK":"Slowakische Krone","SIT":"Slowenischer Tolar","SOS":"Somalia-Schilling","SUR":"Sowjetischer Rubel","ESP":"Spanische Peseta","ESA":"Spanische Peseta (A–Konten)","ESB":"Spanische Peseta (konvertibel)","LKR":"Sri-Lanka-Rupie","SHP":"St. Helena-Pfund","ZAR":"Südafrikanischer Rand","ZAL":"Südafrikanischer Rand (Finanz)","SDD":"Sudanesischer Dinar (1992–2007)","SDG":"Sudanesisches Pfund","SDP":"Sudanesisches Pfund (1957–1998)","KRH":"Südkoreanischer Hwan (1953–1962)","KRW":"Südkoreanischer Won","KRO":"Südkoreanischer Won (1945–1953)","SSP":"Südsudanesisches Pfund","SRG":"Suriname Gulden","SRD":"Suriname-Dollar","SZL":"Swasiländischer Lilangeni","SYP":"Syrisches Pfund","TJR":"Tadschikistan Rubel","TJS":"Tadschikistan-Somoni","TZS":"Tansania-Schilling","THB":"Thailändischer Baht","TPE":"Timor-Escudo","TOP":"Tongaischer Paʻanga","TTD":"Trinidad und Tobago-Dollar","CZK":"Tschechische Krone","CSK":"Tschechoslowakische Krone","TND":"Tunesischer Dinar","TRY":"Türkische Lira","TRL":"Türkische Lira (1922–2005)","TMT":"Turkmenistan-Manat","TMM":"Turkmenistan-Manat (1993–2009)","UGX":"Uganda-Schilling","UGS":"Uganda-Schilling (1966–1987)","UAH":"Ukrainische Hrywnja","UAK":"Ukrainischer Karbovanetz","HUF":"Ungarischer Forint","UYU":"Uruguayischer Peso","UYP":"Uruguayischer Peso (1975–1993)","UYI":"Uruguayischer Peso (Indexierte Rechnungseinheiten)","USS":"US Dollar (Gleicher Tag)","USN":"US Dollar (Nächster Tag)","USD":"US-Dollar","UZS":"Usbekistan-Sum","AED":"VAE-Dirham","VUV":"Vanuatu-Vatu","VEF":"Venezolanischer Bolívar","VEB":"Venezolanischer Bolívar (1871–2008)","ECV":"Verrechnungseinheit für Ecuador","VND":"Vietnamesischer Dong","VNN":"Vietnamesischer Dong(1978–1985)","BYR":"Weißrussischer Rubel","CHW":"WIR Franken","CHE":"WIR-Euro","ZRN":"Zaire-Neuer Zaïre (1993–1998)","ZRZ":"Zaire-Zaïre (1971–1993)","CYP":"Zypern-Pfund"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/currencies/en.json":
/***/ (function(module, exports) {

module.exports = {"AFN":"Afghan Afghani","AFA":"Afghan Afghani (1927–2002)","ALL":"Albanian Lek","ALK":"Albanian Lek (1946–1965)","DZD":"Algerian Dinar","ADP":"Andorran Peseta","AOA":"Angolan Kwanza","AOK":"Angolan Kwanza (1977–1991)","AON":"Angolan New Kwanza (1990–2000)","AOR":"Angolan Readjusted Kwanza (1995–1999)","ARA":"Argentine Austral","ARS":"Argentine Peso","ARM":"Argentine Peso (1881–1970)","ARP":"Argentine Peso (1983–1985)","ARL":"Argentine Peso Ley (1970–1983)","AMD":"Armenian Dram","AWG":"Aruban Florin","AUD":"Australian Dollar","ATS":"Austrian Schilling","AZN":"Azerbaijani Manat","AZM":"Azerbaijani Manat (1993–2006)","BSD":"Bahamian Dollar","BHD":"Bahraini Dinar","BDT":"Bangladeshi Taka","BBD":"Barbadian Dollar","BYB":"Belarusian New Ruble (1994–1999)","BYR":"Belarusian Ruble","BEF":"Belgian Franc","BEC":"Belgian Franc (convertible)","BEL":"Belgian Franc (financial)","BZD":"Belize Dollar","BMD":"Bermudan Dollar","BTN":"Bhutanese Ngultrum","BOB":"Bolivian Boliviano","BOL":"Bolivian Boliviano (1863–1963)","BOV":"Bolivian Mvdol","BOP":"Bolivian Peso","BAM":"Bosnia-Herzegovina Convertible Mark","BAD":"Bosnia-Herzegovina Dinar (1992–1994)","BAN":"Bosnia-Herzegovina New Dinar (1994–1997)","BWP":"Botswanan Pula","BRC":"Brazilian Cruzado (1986–1989)","BRZ":"Brazilian Cruzeiro (1942–1967)","BRE":"Brazilian Cruzeiro (1990–1993)","BRR":"Brazilian Cruzeiro (1993–1994)","BRN":"Brazilian New Cruzado (1989–1990)","BRB":"Brazilian New Cruzeiro (1967–1986)","BRL":"Brazilian Real","GBP":"British Pound Sterling","BND":"Brunei Dollar","BGL":"Bulgarian Hard Lev","BGN":"Bulgarian Lev","BGO":"Bulgarian Lev (1879–1952)","BGM":"Bulgarian Socialist Lev","BUK":"Burmese Kyat","BIF":"Burundian Franc","KHR":"Cambodian Riel","CAD":"Canadian Dollar","CVE":"Cape Verdean Escudo","KYD":"Cayman Islands Dollar","XOF":"CFA Franc BCEAO","XAF":"CFA Franc BEAC","XPF":"CFP Franc","CLE":"Chilean Escudo","CLP":"Chilean Peso","CLF":"Chilean Unit of Account (UF)","CNX":"Chinese People’s Bank Dollar","CNY":"Chinese Yuan","COP":"Colombian Peso","COU":"Colombian Real Value Unit","KMF":"Comorian Franc","CDF":"Congolese Franc","CRC":"Costa Rican Colón","HRD":"Croatian Dinar","HRK":"Croatian Kuna","CUC":"Cuban Convertible Peso","CUP":"Cuban Peso","CYP":"Cypriot Pound","CZK":"Czech Republic Koruna","CSK":"Czechoslovak Hard Koruna","DKK":"Danish Krone","DJF":"Djiboutian Franc","DOP":"Dominican Peso","NLG":"Dutch Guilder","XCD":"East Caribbean Dollar","DDM":"East German Mark","ECS":"Ecuadorian Sucre","ECV":"Ecuadorian Unit of Constant Value","EGP":"Egyptian Pound","GQE":"Equatorial Guinean Ekwele","ERN":"Eritrean Nakfa","EEK":"Estonian Kroon","ETB":"Ethiopian Birr","EUR":"Euro","XEU":"European Currency Unit","FKP":"Falkland Islands Pound","FJD":"Fijian Dollar","FIM":"Finnish Markka","FRF":"French Franc","XFO":"French Gold Franc","XFU":"French UIC-Franc","GMD":"Gambian Dalasi","GEK":"Georgian Kupon Larit","GEL":"Georgian Lari","DEM":"German Mark","GHS":"Ghanaian Cedi","GHC":"Ghanaian Cedi (1979–2007)","GIP":"Gibraltar Pound","GRD":"Greek Drachma","GTQ":"Guatemalan Quetzal","GWP":"Guinea-Bissau Peso","GNF":"Guinean Franc","GNS":"Guinean Syli","GYD":"Guyanaese Dollar","HTG":"Haitian Gourde","HNL":"Honduran Lempira","HKD":"Hong Kong Dollar","HUF":"Hungarian Forint","ISK":"Icelandic Króna","ISJ":"Icelandic Króna (1918–1981)","INR":"Indian Rupee","IDR":"Indonesian Rupiah","IRR":"Iranian Rial","IQD":"Iraqi Dinar","IEP":"Irish Pound","ILS":"Israeli New Sheqel","ILP":"Israeli Pound","ILR":"Israeli Sheqel (1980–1985)","ITL":"Italian Lira","JMD":"Jamaican Dollar","JPY":"Japanese Yen","JOD":"Jordanian Dinar","KZT":"Kazakhstani Tenge","KES":"Kenyan Shilling","KWD":"Kuwaiti Dinar","KGS":"Kyrgystani Som","LAK":"Laotian Kip","LVL":"Latvian Lats","LVR":"Latvian Ruble","LBP":"Lebanese Pound","LSL":"Lesotho Loti","LRD":"Liberian Dollar","LYD":"Libyan Dinar","LTL":"Lithuanian Litas","LTT":"Lithuanian Talonas","LUL":"Luxembourg Financial Franc","LUC":"Luxembourgian Convertible Franc","LUF":"Luxembourgian Franc","MOP":"Macanese Pataca","MKD":"Macedonian Denar","MKN":"Macedonian Denar (1992–1993)","MGA":"Malagasy Ariary","MGF":"Malagasy Franc","MWK":"Malawian Kwacha","MYR":"Malaysian Ringgit","MVR":"Maldivian Rufiyaa","MVP":"Maldivian Rupee (1947–1981)","MLF":"Malian Franc","MTL":"Maltese Lira","MTP":"Maltese Pound","MRO":"Mauritanian Ouguiya","MUR":"Mauritian Rupee","MXV":"Mexican Investment Unit","MXN":"Mexican Peso","MXP":"Mexican Silver Peso (1861–1992)","MDC":"Moldovan Cupon","MDL":"Moldovan Leu","MCF":"Monegasque Franc","MNT":"Mongolian Tugrik","MAD":"Moroccan Dirham","MAF":"Moroccan Franc","MZE":"Mozambican Escudo","MZN":"Mozambican Metical","MZM":"Mozambican Metical (1980–2006)","MMK":"Myanmar Kyat","NAD":"Namibian Dollar","NPR":"Nepalese Rupee","ANG":"Netherlands Antillean Guilder","TWD":"New Taiwan Dollar","NZD":"New Zealand Dollar","NIO":"Nicaraguan Córdoba","NIC":"Nicaraguan Córdoba (1988–1991)","NGN":"Nigerian Naira","KPW":"North Korean Won","NOK":"Norwegian Krone","OMR":"Omani Rial","PKR":"Pakistani Rupee","PAB":"Panamanian Balboa","PGK":"Papua New Guinean Kina","PYG":"Paraguayan Guarani","PEI":"Peruvian Inti","PEN":"Peruvian Nuevo Sol","PES":"Peruvian Sol (1863–1965)","PHP":"Philippine Peso","PLN":"Polish Zloty","PLZ":"Polish Zloty (1950–1995)","PTE":"Portuguese Escudo","GWE":"Portuguese Guinea Escudo","QAR":"Qatari Rial","RHD":"Rhodesian Dollar","XRE":"RINET Funds","RON":"Romanian Leu","ROL":"Romanian Leu (1952–2006)","RUB":"Russian Ruble","RUR":"Russian Ruble (1991–1998)","RWF":"Rwandan Franc","SVC":"Salvadoran Colón","WST":"Samoan Tala","STD":"São Tomé & Príncipe Dobra","SAR":"Saudi Riyal","RSD":"Serbian Dinar","CSD":"Serbian Dinar (2002–2006)","SCR":"Seychellois Rupee","SLL":"Sierra Leonean Leone","SGD":"Singapore Dollar","SKK":"Slovak Koruna","SIT":"Slovenian Tolar","SBD":"Solomon Islands Dollar","SOS":"Somali Shilling","ZAR":"South African Rand","ZAL":"South African Rand (financial)","KRH":"South Korean Hwan (1953–1962)","KRW":"South Korean Won","KRO":"South Korean Won (1945–1953)","SSP":"South Sudanese Pound","SUR":"Soviet Rouble","ESP":"Spanish Peseta","ESA":"Spanish Peseta (A account)","ESB":"Spanish Peseta (convertible account)","LKR":"Sri Lankan Rupee","SHP":"St. Helena Pound","SDD":"Sudanese Dinar (1992–2007)","SDG":"Sudanese Pound","SDP":"Sudanese Pound (1957–1998)","SRD":"Surinamese Dollar","SRG":"Surinamese Guilder","SZL":"Swazi Lilangeni","SEK":"Swedish Krona","CHF":"Swiss Franc","SYP":"Syrian Pound","TJR":"Tajikistani Ruble","TJS":"Tajikistani Somoni","TZS":"Tanzanian Shilling","THB":"Thai Baht","TPE":"Timorese Escudo","TOP":"Tongan Paʻanga","TTD":"Trinidad & Tobago Dollar","TND":"Tunisian Dinar","TRY":"Turkish Lira","TRL":"Turkish Lira (1922–2005)","TMT":"Turkmenistani Manat","TMM":"Turkmenistani Manat (1993–2009)","UGX":"Ugandan Shilling","UGS":"Ugandan Shilling (1966–1987)","UAH":"Ukrainian Hryvnia","UAK":"Ukrainian Karbovanets","AED":"United Arab Emirates Dirham","UYU":"Uruguayan Peso","UYP":"Uruguayan Peso (1975–1993)","UYI":"Uruguayan Peso (Indexed Units)","USD":"US Dollar","USN":"US Dollar (Next day)","USS":"US Dollar (Same day)","UZS":"Uzbekistan Som","VUV":"Vanuatu Vatu","VEF":"Venezuelan Bolívar","VEB":"Venezuelan Bolívar (1871–2008)","VND":"Vietnamese Dong","VNN":"Vietnamese Dong (1978–1985)","CHE":"WIR Euro","CHW":"WIR Franc","YDD":"Yemeni Dinar","YER":"Yemeni Rial","YUN":"Yugoslavian Convertible Dinar (1990–1992)","YUD":"Yugoslavian Hard Dinar (1966–1990)","YUM":"Yugoslavian New Dinar (1994–2002)","YUR":"Yugoslavian Reformed Dinar (1992–1993)","ZRN":"Zairean New Zaire (1993–1998)","ZRZ":"Zairean Zaire (1971–1993)","ZMW":"Zambian Kwacha","ZMK":"Zambian Kwacha (1968–2012)","ZWD":"Zimbabwean Dollar (1980–2008)","ZWR":"Zimbabwean Dollar (2008)","ZWL":"Zimbabwean Dollar (2009)"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/currencies/fr.json":
/***/ (function(module, exports) {

module.exports = {"AFA":"afghani (1927–2002)","AFN":"afghani afghan","ROL":"ancien leu roumain","ARM":"Argentine Peso (1881–1970)","ARL":"Argentine Peso Ley (1970–1983)","MGA":"ariary malgache","ARA":"austral argentin","THB":"baht thaïlandais","PAB":"balboa panaméen","ETB":"birr éthiopien","VEF":"bolivar vénézuélien","VEB":"bolivar vénézuélien (1871–2008)","BOL":"Bolivian Boliviano (1863–1963)","BOB":"boliviano bolivien","BAN":"Bosnia-Herzegovina New Dinar (1994–1997)","BRZ":"Brazilian Cruzeiro (1942–1967)","BGO":"Bulgarian Lev (1879–1952)","BGM":"Bulgarian Socialist Lev","GHC":"cédi","GHS":"cédi ghanéen","CLE":"Chilean Escudo","CNX":"Chinese People’s Bank Dollar","CRC":"colón costaricain","SVC":"colón salvadorien","NIC":"cordoba","NIO":"córdoba oro nicaraguayen","GEK":"coupon de lari géorgien","DKK":"couronne danoise","EEK":"couronne estonienne","CSK":"couronne forte tchécoslovaque","ISK":"couronne islandaise","NOK":"couronne norvégienne","SKK":"couronne slovaque","SEK":"couronne suédoise","CZK":"couronne tchèque","BRC":"cruzado brésilien (1986–1989)","BRR":"cruzeiro","BRE":"cruzeiro brésilien (1990–1993)","GMD":"dalasi gambien","MKD":"denar macédonien","DZD":"dinar algérien","BHD":"dinar bahreïni","BAD":"dinar bosniaque","HRD":"dinar croate","YDD":"dinar du Yémen","IQD":"dinar irakien","JOD":"dinar jordanien","KWD":"dinar koweïtien","LYD":"dinar libyen","RSD":"dinar serbe","CSD":"dinar serbo-monténégrin","SDD":"dinar soudanais","TND":"dinar tunisien","YUN":"dinar yougoslave convertible","YUM":"dinar yougoslave Noviy","AED":"dirham des Émirats arabes unis","MAD":"dirham marocain","STD":"dobra santoméen","AUD":"dollar australien","BSD":"dollar bahaméen","BBD":"dollar barbadien","BZD":"dollar bélizéen","BMD":"dollar bermudien","BND":"dollar brunéien","CAD":"dollar canadien","HKD":"dollar de Hong Kong","SGD":"dollar de Singapour","XCD":"dollar des Caraïbes orientales","USD":"dollar des États-Unis","USS":"dollar des Etats-Unis (jour même)","USN":"dollar des Etats-Unis (jour suivant)","KYD":"dollar des îles Caïmans","SBD":"dollar des îles Salomon","GYD":"dollar du Guyana","FJD":"dollar fidjien","JMD":"dollar jamaïcain","LRD":"dollar libérien","NAD":"dollar namibien","NZD":"dollar néo-zélandais","RHD":"dollar rhodésien","SRD":"dollar surinamais","TTD":"dollar trinidadien","ZWD":"dollar zimbabwéen","ZWR":"dollar zimbabwéen (2008)","ZWL":"dollar zimbabwéen (2009)","VND":"dông vietnamien","GRD":"drachme grecque","AMD":"dram arménien","GQE":"ekwélé équatoguinéen","CVE":"escudo capverdien","GWE":"escudo de Guinée portugaise","MZE":"escudo mozambicain","PTE":"escudo portugais","TPE":"escudo timorais","EUR":"euro","CHE":"euro WIR","ANG":"florin antillais","AWG":"florin arubais","NLG":"florin néerlandais","SRG":"florin surinamais","HUF":"forint hongrois","BEF":"franc belge","BEC":"franc belge (convertible)","BEL":"franc belge (financier)","BIF":"franc burundais","XOF":"franc CFA (BCEAO)","XAF":"franc CFA (BEAC)","XPF":"franc CFP","KMF":"franc comorien","CDF":"franc congolais","LUC":"franc convertible luxembourgeois","DJF":"franc djiboutien","LUL":"franc financier luxembourgeois","FRF":"franc français","GNF":"franc guinéen","LUF":"franc luxembourgeois","MGF":"franc malgache","MLF":"franc malien","MAF":"franc marocain","XFO":"franc or","RWF":"franc rwandais","CHF":"franc suisse","XFU":"franc UIC","CHW":"franc WIR","HTG":"gourde haïtienne","PYG":"guaraní paraguayen","UAH":"hryvnia ukrainienne","ISJ":"Icelandic Króna (1918–1981)","PEI":"inti péruvien","ILR":"Israeli Sheqel (1980–1985)","UAK":"karbovanetz","PGK":"kina papouan-néo-guinéen","LAK":"kip loatien","HRK":"kuna croate","MWK":"kwacha malawite","ZMW":"kwacha zambien","ZMK":"kwacha zambien (1968–2012)","AOA":"kwanza angolais","AOK":"kwanza angolais (1977–1990)","AOR":"kwanza angolais réajusté (1995–1999)","BUK":"kyat birman","MMK":"kyat myanmarais","GEL":"lari géorgien","LVL":"lats letton","ALL":"lek albanais","ALK":"lek albanais (1947–1961)","HNL":"lempira hondurien","SLL":"leone sierra-léonais","MDL":"leu moldave","RON":"leu roumain","BGN":"lev bulgare","BGL":"lev bulgare (1962–1999)","SZL":"lilangeni swazi","ITL":"lire italienne","MTL":"lire maltaise","LTL":"litas lituanien","CYP":"livre chypriote","GIP":"livre de Gibraltar","SHP":"livre de Sainte-Hélène","FKP":"livre des Falkland","EGP":"livre égyptienne","IEP":"livre irlandaise","ILP":"livre israélienne","LBP":"livre libanaise","MTP":"livre maltaise","SDG":"livre soudanaise","SDP":"livre soudanaise (1956–2007)","GBP":"livre sterling","SSP":"livre sud-soudanaise","SYP":"livre syrienne","TRY":"livre turque","TRL":"livre turque (1844–2005)","LSL":"loti lesothan","MKN":"Macedonian Denar (1992–1993)","MVP":"Maldivian Rupee (1947–1981)","AZN":"manat azéri","AZM":"manat azéri (1993–2006)","TMM":"manat turkmène","DEM":"mark allemand","BAM":"mark convertible bosniaque","DDM":"mark est-allemand","FIM":"mark finlandais","MZM":"métical","MZN":"metical mozambicain","MDC":"Moldovan Cupon","MCF":"Monegasque Franc","BOV":"mvdol bolivien","ERN":"nafka érythréen","NGN":"naira nigérian","BTN":"ngultrum bouthanais","BRN":"nouveau cruzado","BRB":"nouveau cruzeiro brésilien (1967–1986)","YUD":"nouveau dinar yougoslave","TWD":"nouveau dollar taïwanais","AON":"nouveau kwanza angolais (1990–2000)","TMT":"nouveau manat turkmène","BYB":"nouveau rouble biélorusse (1994–1999)","ILS":"nouveau shekel israélien","PEN":"nouveau sol péruvien","ZRN":"nouveau zaïre zaïrien","MRO":"ouguiya mauritanien","TOP":"pa’anga tongan","MOP":"pataca macanaise","ADP":"peseta andorrane","ESP":"peseta espagnole","ESA":"peseta espagnole (compte A)","ESB":"peseta espagnole (compte convertible)","ARS":"peso argentin","ARP":"peso argentin (1983–1985)","GWP":"peso bissau-guinéen","BOP":"peso bolivien","CLP":"peso chilien","COP":"peso colombien","CUP":"peso cubain","CUC":"peso cubain convertible","MXP":"peso d’argent mexicain (1861–1992)","DOP":"peso dominicain","MXN":"peso mexicain","PHP":"peso philippin","UYU":"peso uruguayen","UYP":"peso uruguayen (1975–1993)","UYI":"peso uruguayen (unités indexées)","BWP":"pula botswanais","GTQ":"quetzal guatémaltèque","ZAR":"rand sud-africain","ZAL":"rand sud-africain (financier)","BRL":"réal brésilien","IRR":"rial iranien","OMR":"rial omanais","QAR":"rial qatari","SAR":"rial saoudien","YER":"rial yéménite","KHR":"riel cambodgien","MYR":"ringgit malais","BYR":"rouble biélorusse","LVR":"rouble letton","RUB":"rouble russe","RUR":"rouble russe (1991–1998)","SUR":"rouble soviétique","TJR":"rouble tadjik","SCR":"roupie des Seychelles","INR":"roupie indienne","IDR":"roupie indonésienne","MUR":"roupie mauricienne","NPR":"roupie népalaise","PKR":"roupie pakistanaise","LKR":"roupie srilankaise","MVR":"rufiyaa maldivien","ATS":"schilling autrichien","KES":"shilling kényan","UGX":"shilling ougandais","UGS":"shilling ougandais (1966–1987)","SOS":"shilling somalien","TZS":"shilling tanzanien","PES":"sol péruvien","KGS":"som kirghize","TJS":"somoni tadjik","KRH":"South Korean Hwan (1953–1962)","KRO":"South Korean Won (1945–1953)","ECS":"sucre équatorien","UZS":"sum ouzbek","GNS":"syli guinéen","BDT":"taka bangladeshi","WST":"tala samoan","LTT":"talonas lituanien","KZT":"tenge kazakh","SIT":"tolar slovène","MNT":"tugrik mongol","XRE":"type de fonds RINET","CLF":"unité d’investissement chilienne","XEU":"unité de compte européenne (ECU)","MXV":"unité de conversion mexicaine (UDI)","ECV":"unité de valeur constante équatoriale (UVC)","COU":"unité de valeur réelle colombienne","VUV":"vatu vanuatuan","VNN":"Vietnamese Dong (1978–1985)","KPW":"won nord-coréen","KRW":"won sud-coréen","JPY":"yen japonais","CNY":"yuan renminbi chinois","YUR":"Yugoslavian Reformed Dinar (1992–1993)","ZRZ":"zaïre zaïrois","PLZ":"zloty (1950–1995)","PLN":"zloty polonais"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/languages/de.json":
/***/ (function(module, exports) {

module.exports = {"ab":"Abkhazian","ace":"Achinese","ach":"Acoli","ada":"Adangme","ady":"Adyghe","aa":"Afar","afh":"Afrihili","af":"Afrikaans","agq":"Aghem","ain":"Ainu","ak":"Akan","akk":"Akkadian","bss":"Akoose","akz":"Alabama","sq":"Albanian","ale":"Aleut","arq":"Algerian Arabic","en_US":"American English","ase":"American Sign Language","am":"Amharic","egy":"Ancient Egyptian","grc":"Ancient Greek","anp":"Angika","njo":"Ao Naga","ar":"Arabic","an":"Aragonese","arc":"Aramaic","aro":"Araona","arp":"Arapaho","arw":"Arawak","hy":"Armenian","rup":"Aromanian","frp":"Arpitan","as":"Assamese","ast":"Asturian","asa":"Asu","cch":"Atsam","en_AU":"Australian English","de_AT":"Austrian German","av":"Avaric","ae":"Avestan","awa":"Awadhi","ay":"Aymara","az":"Azerbaijani","bfq":"Badaga","ksf":"Bafia","bfd":"Bafut","bqi":"Bakhtiari","ban":"Balinese","bal":"Baluchi","bm":"Bambara","bax":"Bamun","bjn":"Banjar","bas":"Basaa","ba":"Bashkir","eu":"Basque","bbc":"Batak Toba","bar":"Bavarian","bej":"Beja","be":"Belarusian","bem":"Bemba","bez":"Bena","bn":"Bengali","bew":"Betawi","bho":"Bhojpuri","bik":"Bikol","bin":"Bini","bpy":"Bishnupriya","bi":"Bislama","byn":"Blin","zbl":"Blissymbols","brx":"Bodo","bs":"Bosnian","brh":"Brahui","bra":"Braj","pt_BR":"Brazilian Portuguese","br":"Breton","en_GB":"British English","bug":"Buginese","bg":"Bulgarian","bum":"Bulu","bua":"Buriat","my":"Burmese","cad":"Caddo","frc":"Cajun French","en_CA":"Canadian English","fr_CA":"Canadian French","yue":"Cantonese","cps":"Capiznon","car":"Carib","ca":"Catalan","cay":"Cayuga","ceb":"Cebuano","tzm":"Central Atlas Tamazight","dtp":"Central Dusun","esu":"Central Yupik","shu":"Chadian Arabic","chg":"Chagatai","ch":"Chamorro","ce":"Chechen","chr":"Cherokee","chy":"Cheyenne","chb":"Chibcha","cgg":"Chiga","qug":"Chimborazo Highland Quichua","zh":"Chinese","chn":"Chinook Jargon","chp":"Chipewyan","cho":"Choctaw","cu":"Church Slavic","chk":"Chuukese","cv":"Chuvash","nwc":"Classical Newari","syc":"Classical Syriac","ksh":"Colognian","swb":"Comorian","swc":"Congo Swahili","cop":"Coptic","kw":"Cornish","co":"Corsican","cr":"Cree","mus":"Creek","crh":"Crimean Turkish","hr":"Croatian","cs":"Czech","dak":"Dakota","da":"Danish","dar":"Dargwa","dzg":"Dazaga","del":"Delaware","din":"Dinka","dv":"Divehi","doi":"Dogri","dgr":"Dogrib","dua":"Duala","nl":"Dutch","dyu":"Dyula","dz":"Dzongkha","frs":"Eastern Frisian","efi":"Efik","arz":"Egyptian Arabic","eka":"Ekajuk","elx":"Elamite","ebu":"Embu","egl":"Emilian","en":"English","myv":"Erzya","eo":"Esperanto","et":"Estonian","pt_PT":"European Portuguese","es_ES":"European Spanish","ee":"Ewe","ewo":"Ewondo","ext":"Extremaduran","fan":"Fang","fat":"Fanti","fo":"Faroese","hif":"Fiji Hindi","fj":"Fijian","fil":"Filipino","fi":"Finnish","nl_BE":"Flemish","fon":"Fon","gur":"Frafra","fr":"French","fur":"Friulian","ff":"Fulah","gaa":"Ga","gag":"Gagauz","gl":"Galician","gan":"Gan Chinese","lg":"Ganda","gay":"Gayo","gba":"Gbaya","gez":"Geez","ka":"Georgian","de":"German","aln":"Gheg Albanian","bbj":"Ghomala","glk":"Gilaki","gil":"Gilbertese","gom":"Goan Konkani","gon":"Gondi","gor":"Gorontalo","got":"Gothic","grb":"Grebo","el":"Greek","gn":"Guarani","gu":"Gujarati","guz":"Gusii","gwi":"Gwichʼin","hai":"Haida","ht":"Haitian","hak":"Hakka Chinese","ha":"Hausa","haw":"Hawaiian","he":"Hebrew","hz":"Herero","hil":"Hiligaynon","hi":"Hindi","ho":"Hiri Motu","hit":"Hittite","hmn":"Hmong","hu":"Hungarian","hup":"Hupa","iba":"Iban","ibb":"Ibibio","is":"Icelandic","io":"Ido","ig":"Igbo","ilo":"Iloko","smn":"Inari Sami","id":"Indonesian","izh":"Ingrian","inh":"Ingush","ia":"Interlingua","ie":"Interlingue","iu":"Inuktitut","ik":"Inupiaq","ga":"Irish","it":"Italian","jam":"Jamaican Creole English","ja":"Japanese","jv":"Javanese","kaj":"Jju","dyo":"Jola-Fonyi","jrb":"Judeo-Arabic","jpr":"Judeo-Persian","jut":"Jutish","kbd":"Kabardian","kea":"Kabuverdianu","kab":"Kabyle","kac":"Kachin","kgp":"Kaingang","kkj":"Kako","kl":"Kalaallisut","kln":"Kalenjin","xal":"Kalmyk","kam":"Kamba","kbl":"Kanembu","kn":"Kannada","kr":"Kanuri","kaa":"Kara-Kalpak","krc":"Karachay-Balkar","krl":"Karelian","ks":"Kashmiri","csb":"Kashubian","kaw":"Kawi","kk":"Kazakh","ken":"Kenyang","kha":"Khasi","km":"Khmer","kho":"Khotanese","khw":"Khowar","ki":"Kikuyu","kmb":"Kimbundu","krj":"Kinaray-a","rw":"Kinyarwanda","kiu":"Kirmanjki","tlh":"Klingon","bkm":"Kom","kv":"Komi","koi":"Komi-Permyak","kg":"Kongo","kok":"Konkani","ko":"Korean","kfo":"Koro","kos":"Kosraean","avk":"Kotava","khq":"Koyra Chiini","ses":"Koyraboro Senni","kpe":"Kpelle","kri":"Krio","kj":"Kuanyama","kum":"Kumyk","ku":"Kurdish","kru":"Kurukh","kut":"Kutenai","nmg":"Kwasio","ky":"Kyrgyz","quc":"Kʼicheʼ","lad":"Ladino","lah":"Lahnda","lkt":"Lakota","lam":"Lamba","lag":"Langi","lo":"Lao","ltg":"Latgalian","la":"Latin","es_419":"Latin American Spanish","lv":"Latvian","lzz":"Laz","lez":"Lezghian","lij":"Ligurian","li":"Limburgish","ln":"Lingala","lfn":"Lingua Franca Nova","lzh":"Literary Chinese","lt":"Lithuanian","liv":"Livonian","jbo":"Lojban","lmo":"Lombard","nds":"Low German","sli":"Lower Silesian","dsb":"Lower Sorbian","loz":"Lozi","lu":"Luba-Katanga","lua":"Luba-Lulua","lui":"Luiseno","smj":"Lule Sami","lun":"Lunda","luo":"Luo","lb":"Luxembourgish","luy":"Luyia","mde":"Maba","mk":"Macedonian","jmc":"Machame","mad":"Madurese","maf":"Mafa","mag":"Magahi","vmf":"Main-Franconian","mai":"Maithili","mak":"Makasar","mgh":"Makhuwa-Meetto","kde":"Makonde","mg":"Malagasy","ms":"Malay","ml":"Malayalam","mt":"Maltese","mnc":"Manchu","mdr":"Mandar","man":"Mandingo","mni":"Manipuri","gv":"Manx","mi":"Maori","arn":"Mapuche","mr":"Marathi","chm":"Mari","mh":"Marshallese","mwr":"Marwari","mas":"Masai","mzn":"Mazanderani","byv":"Medumba","men":"Mende","mwv":"Mentawai","mer":"Meru","mgo":"Metaʼ","es_MX":"Mexican Spanish","mic":"Micmac","dum":"Middle Dutch","enm":"Middle English","frm":"Middle French","gmh":"Middle High German","mga":"Middle Irish","nan":"Min Nan Chinese","min":"Minangkabau","xmf":"Mingrelian","mwl":"Mirandese","lus":"Mizo","ar_001":"Modern Standard Arabic","moh":"Mohawk","mdf":"Moksha","ro_MD":"Moldavian","lol":"Mongo","mn":"Mongolian","mfe":"Morisyen","ary":"Moroccan Arabic","mos":"Mossi","mul":"Multiple Languages","mua":"Mundang","ttt":"Muslim Tat","mye":"Myene","naq":"Nama","na":"Nauru","nv":"Navajo","ng":"Ndonga","nap":"Neapolitan","ne":"Nepali","new":"Newari","sba":"Ngambay","nnh":"Ngiemboon","jgo":"Ngomba","yrl":"Nheengatu","nia":"Nias","niu":"Niuean","zxx":"No linguistic content","nog":"Nogai","nd":"North Ndebele","frr":"Northern Frisian","se":"Northern Sami","nso":"Northern Sotho","no":"Norwegian","nb":"Norwegian Bokmål","nn":"Norwegian Nynorsk","nov":"Novial","nus":"Nuer","nym":"Nyamwezi","ny":"Nyanja","nyn":"Nyankole","tog":"Nyasa Tonga","nyo":"Nyoro","nzi":"Nzima","nqo":"NʼKo","oc":"Occitan","oj":"Ojibwa","ang":"Old English","fro":"Old French","goh":"Old High German","sga":"Old Irish","non":"Old Norse","peo":"Old Persian","pro":"Old Provençal","or":"Oriya","om":"Oromo","osa":"Osage","os":"Ossetic","ota":"Ottoman Turkish","pal":"Pahlavi","pfl":"Palatine German","pau":"Palauan","pi":"Pali","pam":"Pampanga","pag":"Pangasinan","pap":"Papiamento","ps":"Pashto","pdc":"Pennsylvania German","fa":"Persian","phn":"Phoenician","pcd":"Picard","pms":"Piedmontese","pdt":"Plautdietsch","pon":"Pohnpeian","pl":"Polish","pnt":"Pontic","pt":"Portuguese","prg":"Prussian","pa":"Punjabi","qu":"Quechua","raj":"Rajasthani","rap":"Rapanui","rar":"Rarotongan","rif":"Riffian","rgn":"Romagnol","ro":"Romanian","rm":"Romansh","rom":"Romany","rof":"Rombo","root":"Root","rtm":"Rotuman","rug":"Roviana","rn":"Rundi","ru":"Russian","rue":"Rusyn","rwk":"Rwa","ssy":"Saho","sah":"Sakha","sam":"Samaritan Aramaic","saq":"Samburu","sm":"Samoan","sgs":"Samogitian","sad":"Sandawe","sg":"Sango","sbp":"Sangu","sa":"Sanskrit","sat":"Santali","sc":"Sardinian","sas":"Sasak","sdc":"Sassarese Sardinian","stq":"Saterland Frisian","saz":"Saurashtra","sco":"Scots","gd":"Scottish Gaelic","sly":"Selayar","sel":"Selkup","seh":"Sena","see":"Seneca","sr":"Serbian","sh":"Serbo-Croatian","srr":"Serer","sei":"Seri","ksb":"Shambala","shn":"Shan","sn":"Shona","ii":"Sichuan Yi","scn":"Sicilian","sid":"Sidamo","bla":"Siksika","szl":"Silesian","zh_Hans":"Simplified Chinese","sd":"Sindhi","si":"Sinhala","sms":"Skolt Sami","den":"Slave","sk":"Slovak","sl":"Slovenian","xog":"Soga","sog":"Sogdien","so":"Somali","snk":"Soninke","ckb":"Sorani Kurdish","azb":"South Azerbaijani","nr":"South Ndebele","alt":"Southern Altai","sma":"Southern Sami","st":"Southern Sotho","es":"Spanish","srn":"Sranan Tongo","zgh":"Standard Moroccan Tamazight","suk":"Sukuma","sux":"Sumerian","su":"Sundanese","sus":"Susu","sw":"Swahili","ss":"Swati","sv":"Swedish","fr_CH":"Swiss French","gsw":"Swiss German","de_CH":"Swiss High German","syr":"Syriac","shi":"Tachelhit","tl":"Tagalog","ty":"Tahitian","dav":"Taita","tg":"Tajik","tly":"Talysh","tmh":"Tamashek","ta":"Tamil","trv":"Taroko","twq":"Tasawaq","tt":"Tatar","te":"Telugu","ter":"Tereno","teo":"Teso","tet":"Tetum","th":"Thai","bo":"Tibetan","tig":"Tigre","ti":"Tigrinya","tem":"Timne","tiv":"Tiv","tli":"Tlingit","tpi":"Tok Pisin","tkl":"Tokelau","to":"Tongan","fit":"Tornedalen Finnish","zh_Hant":"Traditional Chinese","tkr":"Tsakhur","tsd":"Tsakonian","tsi":"Tsimshian","ts":"Tsonga","tn":"Tswana","tcy":"Tulu","tum":"Tumbuka","aeb":"Tunisian Arabic","tr":"Turkish","tk":"Turkmen","tru":"Turoyo","tvl":"Tuvalu","tyv":"Tuvinian","tw":"Twi","kcg":"Tyap","udm":"Udmurt","uga":"Ugaritic","uk":"Ukrainian","umb":"Umbundu","und":"Unknown Language","hsb":"Upper Sorbian","ur":"Urdu","ug":"Uyghur","uz":"Uzbek","vai":"Vai","ve":"Venda","vec":"Venetian","vep":"Veps","vi":"Vietnamese","vo":"Volapük","vro":"Võro","vot":"Votic","vun":"Vunjo","wa":"Walloon","wae":"Walser","war":"Waray","was":"Washo","guc":"Wayuu","cy":"Welsh","vls":"West Flemish","fy":"Western Frisian","mrj":"Western Mari","wal":"Wolaytta","wo":"Wolof","wuu":"Wu Chinese","xh":"Xhosa","hsn":"Xiang Chinese","yav":"Yangben","yao":"Yao","yap":"Yapese","ybb":"Yemba","yi":"Yiddish","yo":"Yoruba","zap":"Zapotec","dje":"Zarma","zza":"Zaza","zea":"Zeelandic","zen":"Zenaga","za":"Zhuang","gbz":"Zoroastrian Dari","zu":"Zulu","zun":"Zuni"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/languages/en.json":
/***/ (function(module, exports) {

module.exports = {"ab":"Abkhazian","ace":"Achinese","ach":"Acoli","ada":"Adangme","ady":"Adyghe","aa":"Afar","afh":"Afrihili","af":"Afrikaans","agq":"Aghem","ain":"Ainu","ak":"Akan","akk":"Akkadian","bss":"Akoose","akz":"Alabama","sq":"Albanian","ale":"Aleut","arq":"Algerian Arabic","en_US":"American English","ase":"American Sign Language","am":"Amharic","egy":"Ancient Egyptian","grc":"Ancient Greek","anp":"Angika","njo":"Ao Naga","ar":"Arabic","an":"Aragonese","arc":"Aramaic","aro":"Araona","arp":"Arapaho","arw":"Arawak","hy":"Armenian","rup":"Aromanian","frp":"Arpitan","as":"Assamese","ast":"Asturian","asa":"Asu","cch":"Atsam","en_AU":"Australian English","de_AT":"Austrian German","av":"Avaric","ae":"Avestan","awa":"Awadhi","ay":"Aymara","az":"Azerbaijani","bfq":"Badaga","ksf":"Bafia","bfd":"Bafut","bqi":"Bakhtiari","ban":"Balinese","bal":"Baluchi","bm":"Bambara","bax":"Bamun","bjn":"Banjar","bas":"Basaa","ba":"Bashkir","eu":"Basque","bbc":"Batak Toba","bar":"Bavarian","bej":"Beja","be":"Belarusian","bem":"Bemba","bez":"Bena","bn":"Bengali","bew":"Betawi","bho":"Bhojpuri","bik":"Bikol","bin":"Bini","bpy":"Bishnupriya","bi":"Bislama","byn":"Blin","zbl":"Blissymbols","brx":"Bodo","bs":"Bosnian","brh":"Brahui","bra":"Braj","pt_BR":"Brazilian Portuguese","br":"Breton","en_GB":"British English","bug":"Buginese","bg":"Bulgarian","bum":"Bulu","bua":"Buriat","my":"Burmese","cad":"Caddo","frc":"Cajun French","en_CA":"Canadian English","fr_CA":"Canadian French","yue":"Cantonese","cps":"Capiznon","car":"Carib","ca":"Catalan","cay":"Cayuga","ceb":"Cebuano","tzm":"Central Atlas Tamazight","dtp":"Central Dusun","esu":"Central Yupik","shu":"Chadian Arabic","chg":"Chagatai","ch":"Chamorro","ce":"Chechen","chr":"Cherokee","chy":"Cheyenne","chb":"Chibcha","cgg":"Chiga","qug":"Chimborazo Highland Quichua","zh":"Chinese","chn":"Chinook Jargon","chp":"Chipewyan","cho":"Choctaw","cu":"Church Slavic","chk":"Chuukese","cv":"Chuvash","nwc":"Classical Newari","syc":"Classical Syriac","ksh":"Colognian","swb":"Comorian","swc":"Congo Swahili","cop":"Coptic","kw":"Cornish","co":"Corsican","cr":"Cree","mus":"Creek","crh":"Crimean Turkish","hr":"Croatian","cs":"Czech","dak":"Dakota","da":"Danish","dar":"Dargwa","dzg":"Dazaga","del":"Delaware","din":"Dinka","dv":"Divehi","doi":"Dogri","dgr":"Dogrib","dua":"Duala","nl":"Dutch","dyu":"Dyula","dz":"Dzongkha","frs":"Eastern Frisian","efi":"Efik","arz":"Egyptian Arabic","eka":"Ekajuk","elx":"Elamite","ebu":"Embu","egl":"Emilian","en":"English","myv":"Erzya","eo":"Esperanto","et":"Estonian","pt_PT":"European Portuguese","es_ES":"European Spanish","ee":"Ewe","ewo":"Ewondo","ext":"Extremaduran","fan":"Fang","fat":"Fanti","fo":"Faroese","hif":"Fiji Hindi","fj":"Fijian","fil":"Filipino","fi":"Finnish","nl_BE":"Flemish","fon":"Fon","gur":"Frafra","fr":"French","fur":"Friulian","ff":"Fulah","gaa":"Ga","gag":"Gagauz","gl":"Galician","gan":"Gan Chinese","lg":"Ganda","gay":"Gayo","gba":"Gbaya","gez":"Geez","ka":"Georgian","de":"German","aln":"Gheg Albanian","bbj":"Ghomala","glk":"Gilaki","gil":"Gilbertese","gom":"Goan Konkani","gon":"Gondi","gor":"Gorontalo","got":"Gothic","grb":"Grebo","el":"Greek","gn":"Guarani","gu":"Gujarati","guz":"Gusii","gwi":"Gwichʼin","hai":"Haida","ht":"Haitian","hak":"Hakka Chinese","ha":"Hausa","haw":"Hawaiian","he":"Hebrew","hz":"Herero","hil":"Hiligaynon","hi":"Hindi","ho":"Hiri Motu","hit":"Hittite","hmn":"Hmong","hu":"Hungarian","hup":"Hupa","iba":"Iban","ibb":"Ibibio","is":"Icelandic","io":"Ido","ig":"Igbo","ilo":"Iloko","smn":"Inari Sami","id":"Indonesian","izh":"Ingrian","inh":"Ingush","ia":"Interlingua","ie":"Interlingue","iu":"Inuktitut","ik":"Inupiaq","ga":"Irish","it":"Italian","jam":"Jamaican Creole English","ja":"Japanese","jv":"Javanese","kaj":"Jju","dyo":"Jola-Fonyi","jrb":"Judeo-Arabic","jpr":"Judeo-Persian","jut":"Jutish","kbd":"Kabardian","kea":"Kabuverdianu","kab":"Kabyle","kac":"Kachin","kgp":"Kaingang","kkj":"Kako","kl":"Kalaallisut","kln":"Kalenjin","xal":"Kalmyk","kam":"Kamba","kbl":"Kanembu","kn":"Kannada","kr":"Kanuri","kaa":"Kara-Kalpak","krc":"Karachay-Balkar","krl":"Karelian","ks":"Kashmiri","csb":"Kashubian","kaw":"Kawi","kk":"Kazakh","ken":"Kenyang","kha":"Khasi","km":"Khmer","kho":"Khotanese","khw":"Khowar","ki":"Kikuyu","kmb":"Kimbundu","krj":"Kinaray-a","rw":"Kinyarwanda","kiu":"Kirmanjki","tlh":"Klingon","bkm":"Kom","kv":"Komi","koi":"Komi-Permyak","kg":"Kongo","kok":"Konkani","ko":"Korean","kfo":"Koro","kos":"Kosraean","avk":"Kotava","khq":"Koyra Chiini","ses":"Koyraboro Senni","kpe":"Kpelle","kri":"Krio","kj":"Kuanyama","kum":"Kumyk","ku":"Kurdish","kru":"Kurukh","kut":"Kutenai","nmg":"Kwasio","ky":"Kyrgyz","quc":"Kʼicheʼ","lad":"Ladino","lah":"Lahnda","lkt":"Lakota","lam":"Lamba","lag":"Langi","lo":"Lao","ltg":"Latgalian","la":"Latin","es_419":"Latin American Spanish","lv":"Latvian","lzz":"Laz","lez":"Lezghian","lij":"Ligurian","li":"Limburgish","ln":"Lingala","lfn":"Lingua Franca Nova","lzh":"Literary Chinese","lt":"Lithuanian","liv":"Livonian","jbo":"Lojban","lmo":"Lombard","nds":"Low German","sli":"Lower Silesian","dsb":"Lower Sorbian","loz":"Lozi","lu":"Luba-Katanga","lua":"Luba-Lulua","lui":"Luiseno","smj":"Lule Sami","lun":"Lunda","luo":"Luo","lb":"Luxembourgish","luy":"Luyia","mde":"Maba","mk":"Macedonian","jmc":"Machame","mad":"Madurese","maf":"Mafa","mag":"Magahi","vmf":"Main-Franconian","mai":"Maithili","mak":"Makasar","mgh":"Makhuwa-Meetto","kde":"Makonde","mg":"Malagasy","ms":"Malay","ml":"Malayalam","mt":"Maltese","mnc":"Manchu","mdr":"Mandar","man":"Mandingo","mni":"Manipuri","gv":"Manx","mi":"Maori","arn":"Mapuche","mr":"Marathi","chm":"Mari","mh":"Marshallese","mwr":"Marwari","mas":"Masai","mzn":"Mazanderani","byv":"Medumba","men":"Mende","mwv":"Mentawai","mer":"Meru","mgo":"Metaʼ","es_MX":"Mexican Spanish","mic":"Micmac","dum":"Middle Dutch","enm":"Middle English","frm":"Middle French","gmh":"Middle High German","mga":"Middle Irish","nan":"Min Nan Chinese","min":"Minangkabau","xmf":"Mingrelian","mwl":"Mirandese","lus":"Mizo","ar_001":"Modern Standard Arabic","moh":"Mohawk","mdf":"Moksha","ro_MD":"Moldavian","lol":"Mongo","mn":"Mongolian","mfe":"Morisyen","ary":"Moroccan Arabic","mos":"Mossi","mul":"Multiple Languages","mua":"Mundang","ttt":"Muslim Tat","mye":"Myene","naq":"Nama","na":"Nauru","nv":"Navajo","ng":"Ndonga","nap":"Neapolitan","ne":"Nepali","new":"Newari","sba":"Ngambay","nnh":"Ngiemboon","jgo":"Ngomba","yrl":"Nheengatu","nia":"Nias","niu":"Niuean","zxx":"No linguistic content","nog":"Nogai","nd":"North Ndebele","frr":"Northern Frisian","se":"Northern Sami","nso":"Northern Sotho","no":"Norwegian","nb":"Norwegian Bokmål","nn":"Norwegian Nynorsk","nov":"Novial","nus":"Nuer","nym":"Nyamwezi","ny":"Nyanja","nyn":"Nyankole","tog":"Nyasa Tonga","nyo":"Nyoro","nzi":"Nzima","nqo":"NʼKo","oc":"Occitan","oj":"Ojibwa","ang":"Old English","fro":"Old French","goh":"Old High German","sga":"Old Irish","non":"Old Norse","peo":"Old Persian","pro":"Old Provençal","or":"Oriya","om":"Oromo","osa":"Osage","os":"Ossetic","ota":"Ottoman Turkish","pal":"Pahlavi","pfl":"Palatine German","pau":"Palauan","pi":"Pali","pam":"Pampanga","pag":"Pangasinan","pap":"Papiamento","ps":"Pashto","pdc":"Pennsylvania German","fa":"Persian","phn":"Phoenician","pcd":"Picard","pms":"Piedmontese","pdt":"Plautdietsch","pon":"Pohnpeian","pl":"Polish","pnt":"Pontic","pt":"Portuguese","prg":"Prussian","pa":"Punjabi","qu":"Quechua","raj":"Rajasthani","rap":"Rapanui","rar":"Rarotongan","rif":"Riffian","rgn":"Romagnol","ro":"Romanian","rm":"Romansh","rom":"Romany","rof":"Rombo","root":"Root","rtm":"Rotuman","rug":"Roviana","rn":"Rundi","ru":"Russian","rue":"Rusyn","rwk":"Rwa","ssy":"Saho","sah":"Sakha","sam":"Samaritan Aramaic","saq":"Samburu","sm":"Samoan","sgs":"Samogitian","sad":"Sandawe","sg":"Sango","sbp":"Sangu","sa":"Sanskrit","sat":"Santali","sc":"Sardinian","sas":"Sasak","sdc":"Sassarese Sardinian","stq":"Saterland Frisian","saz":"Saurashtra","sco":"Scots","gd":"Scottish Gaelic","sly":"Selayar","sel":"Selkup","seh":"Sena","see":"Seneca","sr":"Serbian","sh":"Serbo-Croatian","srr":"Serer","sei":"Seri","ksb":"Shambala","shn":"Shan","sn":"Shona","ii":"Sichuan Yi","scn":"Sicilian","sid":"Sidamo","bla":"Siksika","szl":"Silesian","zh_Hans":"Simplified Chinese","sd":"Sindhi","si":"Sinhala","sms":"Skolt Sami","den":"Slave","sk":"Slovak","sl":"Slovenian","xog":"Soga","sog":"Sogdien","so":"Somali","snk":"Soninke","ckb":"Sorani Kurdish","azb":"South Azerbaijani","nr":"South Ndebele","alt":"Southern Altai","sma":"Southern Sami","st":"Southern Sotho","es":"Spanish","srn":"Sranan Tongo","zgh":"Standard Moroccan Tamazight","suk":"Sukuma","sux":"Sumerian","su":"Sundanese","sus":"Susu","sw":"Swahili","ss":"Swati","sv":"Swedish","fr_CH":"Swiss French","gsw":"Swiss German","de_CH":"Swiss High German","syr":"Syriac","shi":"Tachelhit","tl":"Tagalog","ty":"Tahitian","dav":"Taita","tg":"Tajik","tly":"Talysh","tmh":"Tamashek","ta":"Tamil","trv":"Taroko","twq":"Tasawaq","tt":"Tatar","te":"Telugu","ter":"Tereno","teo":"Teso","tet":"Tetum","th":"Thai","bo":"Tibetan","tig":"Tigre","ti":"Tigrinya","tem":"Timne","tiv":"Tiv","tli":"Tlingit","tpi":"Tok Pisin","tkl":"Tokelau","to":"Tongan","fit":"Tornedalen Finnish","zh_Hant":"Traditional Chinese","tkr":"Tsakhur","tsd":"Tsakonian","tsi":"Tsimshian","ts":"Tsonga","tn":"Tswana","tcy":"Tulu","tum":"Tumbuka","aeb":"Tunisian Arabic","tr":"Turkish","tk":"Turkmen","tru":"Turoyo","tvl":"Tuvalu","tyv":"Tuvinian","tw":"Twi","kcg":"Tyap","udm":"Udmurt","uga":"Ugaritic","uk":"Ukrainian","umb":"Umbundu","und":"Unknown Language","hsb":"Upper Sorbian","ur":"Urdu","ug":"Uyghur","uz":"Uzbek","vai":"Vai","ve":"Venda","vec":"Venetian","vep":"Veps","vi":"Vietnamese","vo":"Volapük","vro":"Võro","vot":"Votic","vun":"Vunjo","wa":"Walloon","wae":"Walser","war":"Waray","was":"Washo","guc":"Wayuu","cy":"Welsh","vls":"West Flemish","fy":"Western Frisian","mrj":"Western Mari","wal":"Wolaytta","wo":"Wolof","wuu":"Wu Chinese","xh":"Xhosa","hsn":"Xiang Chinese","yav":"Yangben","yao":"Yao","yap":"Yapese","ybb":"Yemba","yi":"Yiddish","yo":"Yoruba","zap":"Zapotec","dje":"Zarma","zza":"Zaza","zea":"Zeelandic","zen":"Zenaga","za":"Zhuang","gbz":"Zoroastrian Dari","zu":"Zulu","zun":"Zuni"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/languages/fr.json":
/***/ (function(module, exports) {

module.exports = {"ab":"abkhaze","ace":"aceh","ach":"acoli","ada":"adangme","ady":"adyghéen","aa":"afar","afh":"afrihili","af":"afrikaans","agq":"aghem","ain":"aïnou","ak":"akan","akk":"akkadien","bss":"akoose","akz":"Alabama","sq":"albanais","gsw":"alémanique","ale":"aléoute","arq":"Algerian Arabic","de":"allemand","de_AT":"allemand autrichien","de_CH":"allemand suisse","alt":"altaï du Sud","zgh":"amazighe standard marocain","ase":"American Sign Language","am":"amharique","ang":"ancien anglais","fro":"ancien français","goh":"ancien haut allemand","sga":"ancien irlandais","anp":"angika","en":"anglais","en_US":"anglais américain","en_AU":"anglais australien","en_GB":"anglais britannique","en_CA":"anglais canadien","njo":"Ao Naga","ar":"arabe","ar_001":"arabe standard moderne","shu":"arabe tchadien","an":"aragonais","arc":"araméen","sam":"araméen samaritain","aro":"Araona","arp":"arapaho","arn":"araukan","arw":"arawak","hy":"arménien","as":"assamais","asa":"assou","ast":"asturien","cch":"atsam","av":"avar","ae":"avestique","awa":"awadhi","ay":"aymara","az":"azéri","ba":"bachkir","bfq":"Badaga","ksf":"bafia","bfd":"bafut","bqi":"Bakhtiari","ban":"balinais","bal":"baloutchi","bm":"bambara","bax":"bamoun","bjn":"Banjar","nds":"bas-allemand","dsb":"bas-sorabe","eu":"basque","bas":"bassa","bbc":"Batak Toba","bar":"Bavarian","bej":"bedja","bem":"bemba","bez":"béna","bn":"bengali","bew":"Betawi","bho":"bhojpuri","bi":"bichelamar","be":"biélorusse","bik":"bikol","bin":"bini","my":"birman","bpy":"Bishnupriya","byn":"blin","brx":"bodo","bs":"bosniaque","bum":"boulou","bua":"bouriate","brh":"Brahui","bra":"braj","br":"breton","bug":"bugi","bg":"bulgare","cad":"caddo","frc":"Cajun French","yue":"cantonais","cps":"Capiznon","kea":"capverdien","krl":"carélien","car":"caribe","ca":"catalan","cay":"cayuga","ceb":"cebuano","dtp":"Central Dusun","esu":"Central Yupik","ksb":"chambala","ch":"chamorro","chr":"cherokee","chy":"cheyenne","chb":"chibcha","qug":"Chimborazo Highland Quichua","zh":"chinois","zh_Hans":"chinois simplifié","zh_Hant":"chinois traditionnel","chp":"chipewyan","shi":"chleuh","cho":"choctaw","chk":"chuuk","si":"cinghalais","swb":"comorien","cop":"copte","ko":"coréen","kw":"cornique","co":"corse","cr":"cree","mus":"creek","mfe":"créole mauricien","hr":"croate","dak":"dakota","da":"danois","dar":"dargwa","dzg":"dazaga","del":"delaware","din":"dinka","dyo":"diola-fogny","dyu":"dioula","doi":"dogri","dgr":"dogrib","dua":"douala","dz":"dzongkha","sco":"écossais","efi":"efik","arz":"Egyptian Arabic","egy":"égyptien ancien","eka":"ekajuk","elx":"élamite","ebu":"embou","egl":"Emilian","myv":"erzya","es":"espagnol","es_ES":"espagnol d’Europe","es_419":"espagnol latino-américain","es_MX":"espagnol mexicain","eo":"espéranto","et":"estonien","ee":"éwé","ewo":"éwondo","ext":"Extremaduran","fan":"fang","fat":"fanti","fo":"féroïen","fj":"fidjien","hif":"Fiji Hindi","fil":"filipino","fi":"finnois","nl_BE":"flamand","fon":"fon","gur":"Frafra","fr":"français","fr_CA":"français canadien","fr_CH":"français suisse","ksh":"francique ripuaire","frp":"franco-provençal","fur":"frioulan","frr":"frison du Nord","fy":"frison occidental","frs":"frison oriental","gaa":"ga","gd":"gaélique écossais","gag":"gagaouze","gl":"galicien","cy":"gallois","gan":"Gan Chinese","lg":"ganda","gay":"gayo","gba":"gbaya","ka":"géorgien","aln":"Gheg Albanian","bbj":"ghomala","glk":"Gilaki","gil":"gilbertais","gom":"Goan Konkani","gon":"gondi","gor":"gorontalo","got":"gotique","grb":"grebo","el":"grec","grc":"grec ancien","kl":"groenlandais","gn":"guarani","gez":"guèze","gu":"gujarati","guz":"gusii","gwi":"gwichʼin","hai":"haida","ht":"haïtien","hak":"Hakka Chinese","ha":"haoussa","hsb":"haut-sorabe","haw":"hawaïen","he":"hébreu","hz":"héréro","hil":"hiligaynon","hi":"hindi","ho":"hiri motu","hit":"hittite","hmn":"hmong","hu":"hongrois","hup":"hupa","sah":"iakoute","iba":"iban","ibb":"ibibio","io":"ido","ig":"igbo","ilo":"ilokano","id":"indonésien","inh":"ingouche","izh":"Ingrian","ia":"interlingua","ie":"interlingue","iu":"inuktitut","ik":"inupiaq","ga":"irlandais","is":"islandais","it":"italien","jam":"Jamaican Creole English","ja":"japonais","chn":"jargon chinook","jv":"javanais","kaj":"jju","jrb":"judéo-arabe","jpr":"judéo-persan","jut":"Jutish","quc":"k’iche’","kbd":"kabardin","kab":"kabyle","kac":"kachin","csb":"kachoube","kgp":"Kaingang","kkj":"kako","kln":"kalenjin","xal":"kalmouk","kam":"kamba","kbl":"kanembou","kn":"kannada","kr":"kanouri","kaa":"karakalpak","krc":"karatchaï balkar","ks":"kashmiri","kaw":"kawi","kk":"kazakh","ken":"Kenyang","kha":"khasi","km":"khmer","kho":"khotanais","khw":"Khowar","cgg":"kiga","ki":"kikuyu","kmb":"kiMboundou","krj":"Kinaray-a","ky":"kirghize","kiu":"Kirmanjki","tlh":"klingon","bkm":"kom","kv":"komi","koi":"komi-permiak","kg":"kongo","kok":"konkani","kfo":"koro","avk":"Kotava","kum":"koumyk","khq":"koyra chiini","ses":"koyraboro senni","kpe":"kpellé","kri":"Krio","kj":"kuanyama","ku":"kurde","kru":"kurukh","kos":"kusaien","kut":"kutenai","nmg":"kwasio","lad":"ladino","lah":"lahnda","lkt":"lakota","lam":"lamba","lag":"langi","und":"langue indéterminée","lo":"lao","ltg":"Latgalian","la":"latin","lzz":"Laz","lv":"letton","lez":"lezghien","lij":"Ligurian","li":"limbourgeois","ln":"lingala","lfn":"Lingua Franca Nova","lzh":"Literary Chinese","lt":"lituanien","liv":"Livonian","jbo":"lojban","lmo":"Lombard","sli":"Lower Silesian","loz":"lozi","lu":"luba-katanga","lua":"luba-lulua","lui":"luiseno","lun":"lunda","luo":"luo","lus":"lushai","lb":"luxembourgeois","mde":"maba","mk":"macédonien","jmc":"machame","mad":"madurais","maf":"mafa","mag":"magahi","vmf":"Main-Franconian","mai":"maithili","mak":"makassar","mgh":"makhuwa-meetto","kde":"makonde","ms":"malais","ml":"malayalam","dv":"maldivien","mg":"malgache","mt":"maltais","mdr":"mandar","mnc":"mandchou","man":"mandingue","mni":"manipuri","gv":"manx","mi":"maori","mr":"marathe","chm":"mari","mh":"marshall","mwr":"marwarî","mas":"masai","mzn":"Mazanderani","byv":"medumba","men":"mendé","mwv":"Mentawai","mer":"merou","mgo":"méta’","mic":"micmac","nan":"Min Nan Chinese","min":"minangkabau","xmf":"Mingrelian","mwl":"mirandais","moh":"mohawk","mdf":"moksa","ro_MD":"moldave","lol":"mongo","mn":"mongol","mos":"moré","ary":"Moroccan Arabic","enm":"moyen anglais","frm":"moyen français","gmh":"moyen haut-allemand","mga":"moyen irlandais","dum":"moyen néerlandais","mul":"multilingue","mua":"mundang","ttt":"Muslim Tat","mye":"myènè","nqo":"n’ko","naq":"nama","nap":"napolitain","na":"nauruan","nv":"navaho","nd":"ndébélé du Nord","nr":"ndébélé du Sud","ng":"ndonga","nl":"néerlandais","ne":"népalais","new":"newari","nwc":"newarî classique","sba":"ngambay","nnh":"ngiemboon","jgo":"ngomba","yrl":"Nheengatu","nia":"nias","niu":"niué","nog":"nogaï","no":"norvégien","nb":"norvégien bokmål","nn":"norvégien nynorsk","nov":"Novial","nus":"nuer","nym":"nyamwezi","ny":"nyanja","nyn":"nyankolé","nyo":"nyoro","nzi":"nzema","oc":"occitan","oj":"ojibwa","luy":"oluluyia","or":"oriya","om":"oromo","osa":"osage","os":"ossète","udm":"oudmourte","uga":"ougaritique","ug":"ouïghour","ur":"ourdou","uz":"ouzbek","ps":"pachto","pal":"pahlavi","pfl":"Palatine German","pau":"palau","pi":"pali","pam":"pampangan","pag":"pangasinan","pap":"papiamento","pa":"pendjabi","pdc":"Pennsylvania German","fa":"persan","peo":"persan ancien","ff":"peul","phn":"phénicien","pcd":"Picard","pms":"Piedmontese","pdt":"Plautdietsch","pon":"pohnpei","pl":"polonais","pnt":"Pontic","pt":"portugais","pt_BR":"portugais brésilien","pt_PT":"portugais d’Europe","pro":"provençal ancien","prg":"Prussian","qu":"quechua","root":"racine","raj":"rajasthani","rap":"rapanui","rar":"rarotongien","rif":"Riffian","rgn":"Romagnol","rm":"romanche","rof":"rombo","rtm":"Rotuman","ro":"roumain","rn":"roundi","rug":"Roviana","ru":"russe","rue":"Rusyn","rwk":"rwa","rw":"rwanda","ssy":"saho","saq":"samburu","smn":"sami d’Inari","smj":"sami de Lule","se":"sami du Nord","sma":"sami du Sud","sms":"sami skolt","sm":"samoan","sgs":"Samogitian","sad":"sandawe","sg":"sangho","sbp":"sangu","zxx":"sans contenu linguistique","sa":"sanskrit","sat":"santal","sc":"sarde","sas":"sasak","sdc":"Sassarese Sardinian","stq":"Saterland Frisian","saz":"Saurashtra","sly":"Selayar","sel":"selkoupe","seh":"sena","see":"seneca","sr":"serbe","sh":"serbo-croate","srr":"sérère","sei":"Seri","st":"sesotho","shn":"shan","sn":"shona","scn":"sicilien","sid":"sidamo","bla":"siksika","szl":"Silesian","sd":"sindhi","den":"slavey","cu":"slavon d’église","sk":"slovaque","sl":"slovène","xog":"soga","sog":"sogdien","so":"somali","snk":"soninké","ckb":"sorani","nso":"sotho du Nord","su":"soundanais","sus":"soussou","azb":"South Azerbaijani","srn":"sranan tongo","sv":"suédois","suk":"sukuma","sux":"sumérien","sw":"swahili","swc":"swahili du Congo","ss":"swati","zbl":"symboles Bliss","syr":"syriaque","syc":"syriaque classique","tg":"tadjik","tl":"tagalog","ty":"tahitien","dav":"taita","tly":"Talysh","tmh":"tamacheq","tzm":"tamazight","ta":"tamoul","trv":"taroko","twq":"tasawaq","tt":"tatar","chg":"tchaghataï","cs":"tchèque","ce":"tchétchène","cv":"tchouvache","te":"télougou","tem":"temne","ter":"tereno","teo":"teso","tet":"tetum","th":"thaï","bo":"tibétain","tig":"tigré","ti":"tigrigna","tiv":"tiv","tli":"tlingit","tpi":"tok pisin","tkl":"tokelau","tog":"tonga nyasa","to":"tonguien","fit":"Tornedalen Finnish","tyv":"touva","tkr":"Tsakhur","tsd":"Tsakonian","tsi":"tsimshian","ts":"tsonga","tn":"tswana","tcy":"Tulu","tum":"tumbuka","aeb":"Tunisian Arabic","tr":"turc","crh":"turc de Crimée","ota":"turc ottoman","tk":"turkmène","tru":"Turoyo","tvl":"tuvalu","tw":"twi","kcg":"tyap","rom":"tzigane","uk":"ukrainien","umb":"umbundu","vai":"vaï","rup":"valaque","ve":"venda","vec":"Venetian","vep":"Veps","vi":"vietnamien","non":"vieux norrois","vo":"volapuk","vro":"Võro","vot":"vote","vun":"vunjo","wal":"walamo","wa":"wallon","wae":"walser","war":"waray","was":"washo","guc":"Wayuu","vls":"West Flemish","mrj":"Western Mari","wo":"wolof","wuu":"Wu Chinese","xh":"xhosa","hsn":"Xiang Chinese","yav":"yangben","yao":"yao","yap":"yapois","ybb":"yemba","ii":"yi du Sichuan","yi":"yiddish","yo":"yoruba","zap":"zapotèque","dje":"zarma","zza":"zazaki","zea":"Zeelandic","zen":"zenaga","za":"zhuang","gbz":"Zoroastrian Dari","zu":"zoulou","zun":"zuni"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/locales/de.json":
/***/ (function(module, exports) {

module.exports = {"af":"Afrikaans","af_NA":"Afrikaans (Namibia)","af_ZA":"Afrikaans (Südafrika)","ak":"Akan","ak_GH":"Akan (Ghana)","sq":"Albanisch","sq_AL":"Albanisch (Albanien)","sq_XK":"Albanisch (Kosovo)","sq_MK":"Albanisch (Mazedonien)","am":"Amharisch","am_ET":"Amharisch (Äthiopien)","ar":"Arabisch","ar_EG":"Arabisch (Ägypten)","ar_DZ":"Arabisch (Algerien)","ar_BH":"Arabisch (Bahrain)","ar_DJ":"Arabisch (Dschibuti)","ar_ER":"Arabisch (Eritrea)","ar_IQ":"Arabisch (Irak)","ar_IL":"Arabisch (Israel)","ar_YE":"Arabisch (Jemen)","ar_JO":"Arabisch (Jordanien)","ar_QA":"Arabisch (Katar)","ar_KM":"Arabisch (Komoren)","ar_KW":"Arabisch (Kuwait)","ar_LB":"Arabisch (Libanon)","ar_LY":"Arabisch (Libyen)","ar_MA":"Arabisch (Marokko)","ar_MR":"Arabisch (Mauretanien)","ar_OM":"Arabisch (Oman)","ar_PS":"Arabisch (Palästinensische Autonomiegebiete)","ar_SA":"Arabisch (Saudi-Arabien)","ar_SO":"Arabisch (Somalia)","ar_SD":"Arabisch (Sudan)","ar_SS":"Arabisch (Südsudan)","ar_SY":"Arabisch (Syrien)","ar_TD":"Arabisch (Tschad)","ar_TN":"Arabisch (Tunesien)","ar_AE":"Arabisch (Vereinigte Arabische Emirate)","ar_EH":"Arabisch (Westsahara)","hy":"Armenisch","hy_AM":"Armenisch (Armenien)","az":"Aserbaidschanisch","az_AZ":"Aserbaidschanisch (Aserbaidschan)","az_Cyrl_AZ":"Aserbaidschanisch (Kyrillisch, Aserbaidschan)","az_Cyrl":"Aserbaidschanisch (Kyrillisch)","az_Latn_AZ":"Aserbaidschanisch (Lateinisch, Aserbaidschan)","az_Latn":"Aserbaidschanisch (Lateinisch)","as":"Assamesisch","as_IN":"Assamesisch (Indien)","bm":"Bambara-Sprache","bm_Latn_ML":"Bambara-Sprache (Lateinisch, Mali)","bm_Latn":"Bambara-Sprache (Lateinisch)","eu":"Baskisch","eu_ES":"Baskisch (Spanien)","bn":"Bengalisch","bn_BD":"Bengalisch (Bangladesch)","bn_IN":"Bengalisch (Indien)","dz":"Bhutanisch","dz_BT":"Bhutanisch (Bhutan)","my":"Birmanisch","my_MM":"Birmanisch (Myanmar)","bs":"Bosnisch","bs_BA":"Bosnisch (Bosnien und Herzegowina)","bs_Cyrl_BA":"Bosnisch (Kyrillisch, Bosnien und Herzegowina)","bs_Cyrl":"Bosnisch (Kyrillisch)","bs_Latn_BA":"Bosnisch (Lateinisch, Bosnien und Herzegowina)","bs_Latn":"Bosnisch (Lateinisch)","br":"Bretonisch","br_FR":"Bretonisch (Frankreich)","bg":"Bulgarisch","bg_BG":"Bulgarisch (Bulgarien)","zh":"Chinesisch","zh_CN":"Chinesisch (China)","zh_SG":"Chinesisch (Singapur)","zh_MO":"Chinesisch (Sonderverwaltungsregion Macau)","zh_HK":"Chinesisch (Sonderverwaltungszone Hongkong)","zh_TW":"Chinesisch (Taiwan)","zh_Hant_MO":"Chinesisch (Traditionell, Sonderverwaltungsregion Macau)","zh_Hant_HK":"Chinesisch (Traditionell, Sonderverwaltungszone Hongkong)","zh_Hant_TW":"Chinesisch (Traditionell, Taiwan)","zh_Hant":"Chinesisch (Traditionell)","zh_Hans_CN":"Chinesisch (Vereinfacht, China)","zh_Hans_SG":"Chinesisch (Vereinfacht, Singapur)","zh_Hans_MO":"Chinesisch (Vereinfacht, Sonderverwaltungsregion Macau)","zh_Hans_HK":"Chinesisch (Vereinfacht, Sonderverwaltungszone Hongkong)","zh_Hans":"Chinesisch (Vereinfacht)","da":"Dänisch","da_DK":"Dänisch (Dänemark)","da_GL":"Dänisch (Grönland)","de":"Deutsch","de_BE":"Deutsch (Belgien)","de_DE":"Deutsch (Deutschland)","de_LI":"Deutsch (Liechtenstein)","de_LU":"Deutsch (Luxemburg)","de_AT":"Deutsch (Österreich)","de_CH":"Deutsch (Schweiz)","en":"Englisch","en_UM":"Englisch (Amerikanisch-Ozeanien)","en_AS":"Englisch (Amerikanisch-Samoa)","en_VI":"Englisch (Amerikanische Jungferninseln)","en_AI":"Englisch (Anguilla)","en_AG":"Englisch (Antigua und Barbuda)","en_AU":"Englisch (Australien)","en_BS":"Englisch (Bahamas)","en_BB":"Englisch (Barbados)","en_BE":"Englisch (Belgien)","en_BZ":"Englisch (Belize)","en_BM":"Englisch (Bermuda)","en_BW":"Englisch (Botsuana)","en_VG":"Englisch (Britische Jungferninseln)","en_IO":"Englisch (Britisches Territorium im Indischen Ozean)","en_CK":"Englisch (Cookinseln)","en_DG":"Englisch (Diego Garcia)","en_DM":"Englisch (Dominica)","en_ER":"Englisch (Eritrea)","en_FK":"Englisch (Falklandinseln)","en_FJ":"Englisch (Fidschi)","en_GM":"Englisch (Gambia)","en_GH":"Englisch (Ghana)","en_GI":"Englisch (Gibraltar)","en_GD":"Englisch (Grenada)","en_GU":"Englisch (Guam)","en_GG":"Englisch (Guernsey)","en_GY":"Englisch (Guyana)","en_IN":"Englisch (Indien)","en_IE":"Englisch (Irland)","en_IM":"Englisch (Isle of Man)","en_JM":"Englisch (Jamaika)","en_JE":"Englisch (Jersey)","en_KY":"Englisch (Kaimaninseln)","en_CM":"Englisch (Kamerun)","en_CA":"Englisch (Kanada)","en_KE":"Englisch (Kenia)","en_KI":"Englisch (Kiribati)","en_CC":"Englisch (Kokosinseln)","en_LS":"Englisch (Lesotho)","en_LR":"Englisch (Liberia)","en_MG":"Englisch (Madagaskar)","en_MW":"Englisch (Malawi)","en_MY":"Englisch (Malaysia)","en_MT":"Englisch (Malta)","en_MH":"Englisch (Marshallinseln)","en_MU":"Englisch (Mauritius)","en_FM":"Englisch (Mikronesien)","en_MS":"Englisch (Montserrat)","en_NA":"Englisch (Namibia)","en_NR":"Englisch (Nauru)","en_NZ":"Englisch (Neuseeland)","en_NG":"Englisch (Nigeria)","en_NU":"Englisch (Niue)","en_MP":"Englisch (Nördliche Marianen)","en_NF":"Englisch (Norfolkinsel)","en_PK":"Englisch (Pakistan)","en_PW":"Englisch (Palau)","en_PG":"Englisch (Papua-Neuguinea)","en_PH":"Englisch (Philippinen)","en_PN":"Englisch (Pitcairninseln)","en_PR":"Englisch (Puerto Rico)","en_RW":"Englisch (Ruanda)","en_SB":"Englisch (Salomonen)","en_ZM":"Englisch (Sambia)","en_WS":"Englisch (Samoa)","en_SC":"Englisch (Seychellen)","en_SL":"Englisch (Sierra Leone)","en_ZW":"Englisch (Simbabwe)","en_SG":"Englisch (Singapur)","en_SX":"Englisch (Sint Maarten)","en_MO":"Englisch (Sonderverwaltungsregion Macau)","en_HK":"Englisch (Sonderverwaltungszone Hongkong)","en_SH":"Englisch (St. Helena)","en_KN":"Englisch (St. Kitts und Nevis)","en_LC":"Englisch (St. Lucia)","en_VC":"Englisch (St. Vincent und die Grenadinen)","en_ZA":"Englisch (Südafrika)","en_SD":"Englisch (Sudan)","en_SS":"Englisch (Südsudan)","en_SZ":"Englisch (Swasiland)","en_TZ":"Englisch (Tansania)","en_TK":"Englisch (Tokelau)","en_TO":"Englisch (Tonga)","en_TT":"Englisch (Trinidad und Tobago)","en_TC":"Englisch (Turks- und Caicosinseln)","en_TV":"Englisch (Tuvalu)","en_UG":"Englisch (Uganda)","en_VU":"Englisch (Vanuatu)","en_US":"Englisch (Vereinigte Staaten)","en_GB":"Englisch (Vereinigtes Königreich)","en_CX":"Englisch (Weihnachtsinsel)","eo":"Esperanto","et":"Estnisch","et_EE":"Estnisch (Estland)","ee":"Ewe","ee_GH":"Ewe (Ghana)","ee_TG":"Ewe (Togo)","fo":"Färöisch","fo_FO":"Färöisch (Färöer)","fi":"Finnisch","fi_FI":"Finnisch (Finnland)","fr":"Französisch","fr_DZ":"Französisch (Algerien)","fr_GQ":"Französisch (Äquatorialguinea)","fr_BE":"Französisch (Belgien)","fr_BJ":"Französisch (Benin)","fr_BF":"Französisch (Burkina Faso)","fr_BI":"Französisch (Burundi)","fr_CI":"Französisch (Côte d’Ivoire)","fr_DJ":"Französisch (Dschibuti)","fr_FR":"Französisch (Frankreich)","fr_GF":"Französisch (Französisch-Guayana)","fr_PF":"Französisch (Französisch-Polynesien)","fr_GA":"Französisch (Gabun)","fr_GP":"Französisch (Guadeloupe)","fr_GN":"Französisch (Guinea)","fr_HT":"Französisch (Haiti)","fr_CM":"Französisch (Kamerun)","fr_CA":"Französisch (Kanada)","fr_KM":"Französisch (Komoren)","fr_CG":"Französisch (Kongo-Brazzaville)","fr_CD":"Französisch (Kongo-Kinshasa)","fr_LU":"Französisch (Luxemburg)","fr_MG":"Französisch (Madagaskar)","fr_ML":"Französisch (Mali)","fr_MA":"Französisch (Marokko)","fr_MQ":"Französisch (Martinique)","fr_MR":"Französisch (Mauretanien)","fr_MU":"Französisch (Mauritius)","fr_YT":"Französisch (Mayotte)","fr_MC":"Französisch (Monaco)","fr_NC":"Französisch (Neukaledonien)","fr_NE":"Französisch (Niger)","fr_RE":"Französisch (Réunion)","fr_RW":"Französisch (Ruanda)","fr_CH":"Französisch (Schweiz)","fr_SN":"Französisch (Senegal)","fr_SC":"Französisch (Seychellen)","fr_BL":"Französisch (St. Barthélemy)","fr_MF":"Französisch (St. Martin)","fr_PM":"Französisch (St. Pierre und Miquelon)","fr_SY":"Französisch (Syrien)","fr_TG":"Französisch (Togo)","fr_TD":"Französisch (Tschad)","fr_TN":"Französisch (Tunesien)","fr_VU":"Französisch (Vanuatu)","fr_WF":"Französisch (Wallis und Futuna)","fr_CF":"Französisch (Zentralafrikanische Republik)","ff":"Ful","ff_GN":"Ful (Guinea)","ff_CM":"Ful (Kamerun)","ff_MR":"Ful (Mauretanien)","ff_SN":"Ful (Senegal)","gl":"Galizisch","gl_ES":"Galizisch (Spanien)","lg":"Ganda","lg_UG":"Ganda (Uganda)","ka":"Georgisch","ka_GE":"Georgisch (Georgien)","el":"Griechisch","el_GR":"Griechisch (Griechenland)","el_CY":"Griechisch (Zypern)","kl":"Grönländisch","kl_GL":"Grönländisch (Grönland)","gu":"Gujarati","gu_IN":"Gujarati (Indien)","ha":"Hausa","ha_GH":"Hausa (Ghana)","ha_Latn_GH":"Hausa (Lateinisch, Ghana)","ha_Latn_NE":"Hausa (Lateinisch, Niger)","ha_Latn_NG":"Hausa (Lateinisch, Nigeria)","ha_Latn":"Hausa (Lateinisch)","ha_NE":"Hausa (Niger)","ha_NG":"Hausa (Nigeria)","he":"Hebräisch","he_IL":"Hebräisch (Israel)","hi":"Hindi","hi_IN":"Hindi (Indien)","ig":"Igbo","ig_NG":"Igbo (Nigeria)","id":"Indonesisch","id_ID":"Indonesisch (Indonesien)","ga":"Irisch","ga_IE":"Irisch (Irland)","is":"Isländisch","is_IS":"Isländisch (Island)","it":"Italienisch","it_IT":"Italienisch (Italien)","it_SM":"Italienisch (San Marino)","it_CH":"Italienisch (Schweiz)","ja":"Japanisch","ja_JP":"Japanisch (Japan)","yi":"Jiddisch","km":"Kambodschanisch","km_KH":"Kambodschanisch (Kambodscha)","kn":"Kannada","kn_IN":"Kannada (Indien)","kk":"Kasachisch","kk_KZ":"Kasachisch (Kasachstan)","kk_Cyrl_KZ":"Kasachisch (Kyrillisch, Kasachstan)","kk_Cyrl":"Kasachisch (Kyrillisch)","ks":"Kaschmirisch","ks_Arab_IN":"Kaschmirisch (Arabisch, Indien)","ks_Arab":"Kaschmirisch (Arabisch)","ks_IN":"Kaschmirisch (Indien)","ca":"Katalanisch","ca_AD":"Katalanisch (Andorra)","ca_FR":"Katalanisch (Frankreich)","ca_IT":"Katalanisch (Italien)","ca_ES":"Katalanisch (Spanien)","ki":"Kikuyu","ki_KE":"Kikuyu (Kenia)","ky":"Kirgisisch","ky_KG":"Kirgisisch (Kirgisistan)","ky_Cyrl_KG":"Kirgisisch (Kyrillisch, Kirgisistan)","ky_Cyrl":"Kirgisisch (Kyrillisch)","ko":"Koreanisch","ko_KP":"Koreanisch (Demokratische Volksrepublik Korea)","ko_KR":"Koreanisch (Republik Korea)","kw":"Kornisch","kw_GB":"Kornisch (Vereinigtes Königreich)","hr":"Kroatisch","hr_BA":"Kroatisch (Bosnien und Herzegowina)","hr_HR":"Kroatisch (Kroatien)","lo":"Laotisch","lo_LA":"Laotisch (Laos)","lv":"Lettisch","lv_LV":"Lettisch (Lettland)","ln":"Lingala","ln_AO":"Lingala (Angola)","ln_CG":"Lingala (Kongo-Brazzaville)","ln_CD":"Lingala (Kongo-Kinshasa)","ln_CF":"Lingala (Zentralafrikanische Republik)","lt":"Litauisch","lt_LT":"Litauisch (Litauen)","lu":"Luba-Katanga","lu_CD":"Luba-Katanga (Kongo-Kinshasa)","lb":"Luxemburgisch","lb_LU":"Luxemburgisch (Luxemburg)","mg":"Madagassisch","mg_MG":"Madagassisch (Madagaskar)","ms":"Malaiisch","ms_BN":"Malaiisch (Brunei Darussalam)","ms_Latn_BN":"Malaiisch (Lateinisch, Brunei Darussalam)","ms_Latn_MY":"Malaiisch (Lateinisch, Malaysia)","ms_Latn_SG":"Malaiisch (Lateinisch, Singapur)","ms_Latn":"Malaiisch (Lateinisch)","ms_MY":"Malaiisch (Malaysia)","ms_SG":"Malaiisch (Singapur)","ml":"Malayalam","ml_IN":"Malayalam (Indien)","mt":"Maltesisch","mt_MT":"Maltesisch (Malta)","gv":"Manx","gv_IM":"Manx (Isle of Man)","mr":"Marathi","mr_IN":"Marathi (Indien)","mk":"Mazedonisch","mk_MK":"Mazedonisch (Mazedonien)","mn":"Mongolisch","mn_Cyrl_MN":"Mongolisch (Kyrillisch, Mongolei)","mn_Cyrl":"Mongolisch (Kyrillisch)","mn_MN":"Mongolisch (Mongolei)","ne":"Nepalesisch","ne_IN":"Nepalesisch (Indien)","ne_NP":"Nepalesisch (Nepal)","nl":"Niederländisch","nl_AW":"Niederländisch (Aruba)","nl_BE":"Niederländisch (Belgien)","nl_CW":"Niederländisch (Curaçao)","nl_BQ":"Niederländisch (Karibische Niederlande)","nl_NL":"Niederländisch (Niederlande)","nl_SX":"Niederländisch (Sint Maarten)","nl_SR":"Niederländisch (Suriname)","nd":"Nord-Ndebele-Sprache","nd_ZW":"Nord-Ndebele-Sprache (Simbabwe)","se":"Nord-Samisch","se_FI":"Nord-Samisch (Finnland)","se_NO":"Nord-Samisch (Norwegen)","se_SE":"Nord-Samisch (Schweden)","no":"Norwegisch","no_NO":"Norwegisch (Norwegen)","nb":"Norwegisch Bokmål","nb_NO":"Norwegisch Bokmål (Norwegen)","nb_SJ":"Norwegisch Bokmål (Svalbard und Jan Mayen)","nn":"Norwegisch Nynorsk","nn_NO":"Norwegisch Nynorsk (Norwegen)","or":"Oriya","or_IN":"Oriya (Indien)","om":"Oromo","om_ET":"Oromo (Äthiopien)","om_KE":"Oromo (Kenia)","os":"Ossetisch","os_GE":"Ossetisch (Georgien)","os_RU":"Ossetisch (Russische Föderation)","pa":"Panjabi","pa_Arab_PK":"Panjabi (Arabisch, Pakistan)","pa_Arab":"Panjabi (Arabisch)","pa_Guru_IN":"Panjabi (Gurmukhi, Indien)","pa_Guru":"Panjabi (Gurmukhi)","pa_IN":"Panjabi (Indien)","pa_PK":"Panjabi (Pakistan)","ps":"Paschtu","ps_AF":"Paschtu (Afghanistan)","fa":"Persisch","fa_AF":"Persisch (Afghanistan)","fa_IR":"Persisch (Iran)","pl":"Polnisch","pl_PL":"Polnisch (Polen)","pt":"Portugiesisch","pt_AO":"Portugiesisch (Angola)","pt_BR":"Portugiesisch (Brasilien)","pt_GW":"Portugiesisch (Guinea-Bissau)","pt_CV":"Portugiesisch (Kap Verde)","pt_MZ":"Portugiesisch (Mosambik)","pt_PT":"Portugiesisch (Portugal)","pt_ST":"Portugiesisch (São Tomé und Príncipe)","pt_MO":"Portugiesisch (Sonderverwaltungsregion Macau)","pt_TL":"Portugiesisch (Timor-Leste)","qu":"Quechua","qu_BO":"Quechua (Bolivien)","qu_EC":"Quechua (Ecuador)","qu_PE":"Quechua (Peru)","rm":"Rätoromanisch","rm_CH":"Rätoromanisch (Schweiz)","rw":"Ruandisch","rw_RW":"Ruandisch (Ruanda)","ro":"Rumänisch","ro_MD":"Rumänisch (Republik Moldau)","ro_RO":"Rumänisch (Rumänien)","rn":"Rundi-Sprache","rn_BI":"Rundi-Sprache (Burundi)","ru":"Russisch","ru_BY":"Russisch (Belarus)","ru_KZ":"Russisch (Kasachstan)","ru_KG":"Russisch (Kirgisistan)","ru_MD":"Russisch (Republik Moldau)","ru_RU":"Russisch (Russische Föderation)","ru_UA":"Russisch (Ukraine)","sg":"Sango","sg_CF":"Sango (Zentralafrikanische Republik)","gd":"Schottisches Gälisch","gd_GB":"Schottisches Gälisch (Vereinigtes Königreich)","sv":"Schwedisch","sv_AX":"Schwedisch (Åland-Inseln)","sv_FI":"Schwedisch (Finnland)","sv_SE":"Schwedisch (Schweden)","sr":"Serbisch","sr_BA":"Serbisch (Bosnien und Herzegowina)","sr_XK":"Serbisch (Kosovo)","sr_Cyrl_BA":"Serbisch (Kyrillisch, Bosnien und Herzegowina)","sr_Cyrl_XK":"Serbisch (Kyrillisch, Kosovo)","sr_Cyrl_ME":"Serbisch (Kyrillisch, Montenegro)","sr_Cyrl_RS":"Serbisch (Kyrillisch, Serbien)","sr_Cyrl":"Serbisch (Kyrillisch)","sr_Latn_BA":"Serbisch (Lateinisch, Bosnien und Herzegowina)","sr_Latn_XK":"Serbisch (Lateinisch, Kosovo)","sr_Latn_ME":"Serbisch (Lateinisch, Montenegro)","sr_Latn_RS":"Serbisch (Lateinisch, Serbien)","sr_Latn":"Serbisch (Lateinisch)","sr_ME":"Serbisch (Montenegro)","sr_RS":"Serbisch (Serbien)","sh":"Serbo-Kroatisch","sh_BA":"Serbo-Kroatisch (Bosnien und Herzegowina)","sn":"Shona","sn_ZW":"Shona (Simbabwe)","si":"Singhalesisch","si_LK":"Singhalesisch (Sri Lanka)","sk":"Slowakisch","sk_SK":"Slowakisch (Slowakei)","sl":"Slowenisch","sl_SI":"Slowenisch (Slowenien)","so":"Somali","so_ET":"Somali (Äthiopien)","so_DJ":"Somali (Dschibuti)","so_KE":"Somali (Kenia)","so_SO":"Somali (Somalia)","es":"Spanisch","es_GQ":"Spanisch (Äquatorialguinea)","es_AR":"Spanisch (Argentinien)","es_BO":"Spanisch (Bolivien)","es_EA":"Spanisch (Ceuta und Melilla)","es_CL":"Spanisch (Chile)","es_CR":"Spanisch (Costa Rica)","es_DO":"Spanisch (Dominikanische Republik)","es_EC":"Spanisch (Ecuador)","es_SV":"Spanisch (El Salvador)","es_GT":"Spanisch (Guatemala)","es_HN":"Spanisch (Honduras)","es_IC":"Spanisch (Kanarische Inseln)","es_CO":"Spanisch (Kolumbien)","es_CU":"Spanisch (Kuba)","es_MX":"Spanisch (Mexiko)","es_NI":"Spanisch (Nicaragua)","es_PA":"Spanisch (Panama)","es_PY":"Spanisch (Paraguay)","es_PE":"Spanisch (Peru)","es_PH":"Spanisch (Philippinen)","es_PR":"Spanisch (Puerto Rico)","es_ES":"Spanisch (Spanien)","es_UY":"Spanisch (Uruguay)","es_VE":"Spanisch (Venezuela)","es_US":"Spanisch (Vereinigte Staaten)","sw":"Suaheli","sw_KE":"Suaheli (Kenia)","sw_TZ":"Suaheli (Tansania)","sw_UG":"Suaheli (Uganda)","tl":"Tagalog","tl_PH":"Tagalog (Philippinen)","ta":"Tamilisch","ta_IN":"Tamilisch (Indien)","ta_MY":"Tamilisch (Malaysia)","ta_SG":"Tamilisch (Singapur)","ta_LK":"Tamilisch (Sri Lanka)","te":"Telugu","te_IN":"Telugu (Indien)","th":"Thailändisch","th_TH":"Thailändisch (Thailand)","bo":"Tibetisch","bo_CN":"Tibetisch (China)","bo_IN":"Tibetisch (Indien)","ti":"Tigrinja","ti_ET":"Tigrinja (Äthiopien)","ti_ER":"Tigrinja (Eritrea)","to":"Tongaisch","to_TO":"Tongaisch (Tonga)","cs":"Tschechisch","cs_CZ":"Tschechisch (Tschechische Republik)","tr":"Türkisch","tr_TR":"Türkisch (Türkei)","tr_CY":"Türkisch (Zypern)","ug":"Uigurisch","ug_Arab_CN":"Uigurisch (Arabisch, China)","ug_Arab":"Uigurisch (Arabisch)","ug_CN":"Uigurisch (China)","uk":"Ukrainisch","uk_UA":"Ukrainisch (Ukraine)","hu":"Ungarisch","hu_HU":"Ungarisch (Ungarn)","ur":"Urdu","ur_IN":"Urdu (Indien)","ur_PK":"Urdu (Pakistan)","uz":"Usbekisch","uz_AF":"Usbekisch (Afghanistan)","uz_Arab_AF":"Usbekisch (Arabisch, Afghanistan)","uz_Arab":"Usbekisch (Arabisch)","uz_Cyrl_UZ":"Usbekisch (Kyrillisch, Usbekistan)","uz_Cyrl":"Usbekisch (Kyrillisch)","uz_Latn_UZ":"Usbekisch (Lateinisch, Usbekistan)","uz_Latn":"Usbekisch (Lateinisch)","uz_UZ":"Usbekisch (Usbekistan)","vi":"Vietnamesisch","vi_VN":"Vietnamesisch (Vietnam)","cy":"Walisisch","cy_GB":"Walisisch (Vereinigtes Königreich)","be":"Weißrussisch","be_BY":"Weißrussisch (Belarus)","fy":"Westfriesisch","fy_NL":"Westfriesisch (Niederlande)","ii":"Yi","ii_CN":"Yi (China)","yo":"Yoruba","yo_BJ":"Yoruba (Benin)","yo_NG":"Yoruba (Nigeria)","zu":"Zulu","zu_ZA":"Zulu (Südafrika)"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/locales/en.json":
/***/ (function(module, exports) {

module.exports = {"af":"Afrikaans","af_NA":"Afrikaans (Namibia)","af_ZA":"Afrikaans (South Africa)","ak":"Akan","ak_GH":"Akan (Ghana)","sq":"Albanian","sq_AL":"Albanian (Albania)","sq_XK":"Albanian (Kosovo)","sq_MK":"Albanian (Macedonia)","am":"Amharic","am_ET":"Amharic (Ethiopia)","ar":"Arabic","ar_DZ":"Arabic (Algeria)","ar_BH":"Arabic (Bahrain)","ar_TD":"Arabic (Chad)","ar_KM":"Arabic (Comoros)","ar_DJ":"Arabic (Djibouti)","ar_EG":"Arabic (Egypt)","ar_ER":"Arabic (Eritrea)","ar_IQ":"Arabic (Iraq)","ar_IL":"Arabic (Israel)","ar_JO":"Arabic (Jordan)","ar_KW":"Arabic (Kuwait)","ar_LB":"Arabic (Lebanon)","ar_LY":"Arabic (Libya)","ar_MR":"Arabic (Mauritania)","ar_MA":"Arabic (Morocco)","ar_OM":"Arabic (Oman)","ar_PS":"Arabic (Palestinian Territories)","ar_QA":"Arabic (Qatar)","ar_SA":"Arabic (Saudi Arabia)","ar_SO":"Arabic (Somalia)","ar_SS":"Arabic (South Sudan)","ar_SD":"Arabic (Sudan)","ar_SY":"Arabic (Syria)","ar_TN":"Arabic (Tunisia)","ar_AE":"Arabic (United Arab Emirates)","ar_EH":"Arabic (Western Sahara)","ar_YE":"Arabic (Yemen)","hy":"Armenian","hy_AM":"Armenian (Armenia)","as":"Assamese","as_IN":"Assamese (India)","az":"Azerbaijani","az_AZ":"Azerbaijani (Azerbaijan)","az_Cyrl_AZ":"Azerbaijani (Cyrillic, Azerbaijan)","az_Cyrl":"Azerbaijani (Cyrillic)","az_Latn_AZ":"Azerbaijani (Latin, Azerbaijan)","az_Latn":"Azerbaijani (Latin)","bm":"Bambara","bm_Latn_ML":"Bambara (Latin, Mali)","bm_Latn":"Bambara (Latin)","eu":"Basque","eu_ES":"Basque (Spain)","be":"Belarusian","be_BY":"Belarusian (Belarus)","bn":"Bengali","bn_BD":"Bengali (Bangladesh)","bn_IN":"Bengali (India)","bs":"Bosnian","bs_BA":"Bosnian (Bosnia and Herzegovina)","bs_Cyrl_BA":"Bosnian (Cyrillic, Bosnia and Herzegovina)","bs_Cyrl":"Bosnian (Cyrillic)","bs_Latn_BA":"Bosnian (Latin, Bosnia and Herzegovina)","bs_Latn":"Bosnian (Latin)","br":"Breton","br_FR":"Breton (France)","bg":"Bulgarian","bg_BG":"Bulgarian (Bulgaria)","my":"Burmese","my_MM":"Burmese (Myanmar (Burma))","ca":"Catalan","ca_AD":"Catalan (Andorra)","ca_FR":"Catalan (France)","ca_IT":"Catalan (Italy)","ca_ES":"Catalan (Spain)","zh":"Chinese","zh_CN":"Chinese (China)","zh_HK":"Chinese (Hong Kong SAR China)","zh_MO":"Chinese (Macau SAR China)","zh_Hans_CN":"Chinese (Simplified, China)","zh_Hans_HK":"Chinese (Simplified, Hong Kong SAR China)","zh_Hans_MO":"Chinese (Simplified, Macau SAR China)","zh_Hans_SG":"Chinese (Simplified, Singapore)","zh_Hans":"Chinese (Simplified)","zh_SG":"Chinese (Singapore)","zh_TW":"Chinese (Taiwan)","zh_Hant_HK":"Chinese (Traditional, Hong Kong SAR China)","zh_Hant_MO":"Chinese (Traditional, Macau SAR China)","zh_Hant_TW":"Chinese (Traditional, Taiwan)","zh_Hant":"Chinese (Traditional)","kw":"Cornish","kw_GB":"Cornish (United Kingdom)","hr":"Croatian","hr_BA":"Croatian (Bosnia and Herzegovina)","hr_HR":"Croatian (Croatia)","cs":"Czech","cs_CZ":"Czech (Czech Republic)","da":"Danish","da_DK":"Danish (Denmark)","da_GL":"Danish (Greenland)","nl":"Dutch","nl_AW":"Dutch (Aruba)","nl_BE":"Dutch (Belgium)","nl_BQ":"Dutch (Caribbean Netherlands)","nl_CW":"Dutch (Curaçao)","nl_NL":"Dutch (Netherlands)","nl_SX":"Dutch (Sint Maarten)","nl_SR":"Dutch (Suriname)","dz":"Dzongkha","dz_BT":"Dzongkha (Bhutan)","en":"English","en_AS":"English (American Samoa)","en_AI":"English (Anguilla)","en_AG":"English (Antigua and Barbuda)","en_AU":"English (Australia)","en_BS":"English (Bahamas)","en_BB":"English (Barbados)","en_BE":"English (Belgium)","en_BZ":"English (Belize)","en_BM":"English (Bermuda)","en_BW":"English (Botswana)","en_IO":"English (British Indian Ocean Territory)","en_VG":"English (British Virgin Islands)","en_CM":"English (Cameroon)","en_CA":"English (Canada)","en_KY":"English (Cayman Islands)","en_CX":"English (Christmas Island)","en_CC":"English (Cocos (Keeling) Islands)","en_CK":"English (Cook Islands)","en_DG":"English (Diego Garcia)","en_DM":"English (Dominica)","en_ER":"English (Eritrea)","en_FK":"English (Falkland Islands)","en_FJ":"English (Fiji)","en_GM":"English (Gambia)","en_GH":"English (Ghana)","en_GI":"English (Gibraltar)","en_GD":"English (Grenada)","en_GU":"English (Guam)","en_GG":"English (Guernsey)","en_GY":"English (Guyana)","en_HK":"English (Hong Kong SAR China)","en_IN":"English (India)","en_IE":"English (Ireland)","en_IM":"English (Isle of Man)","en_JM":"English (Jamaica)","en_JE":"English (Jersey)","en_KE":"English (Kenya)","en_KI":"English (Kiribati)","en_LS":"English (Lesotho)","en_LR":"English (Liberia)","en_MO":"English (Macau SAR China)","en_MG":"English (Madagascar)","en_MW":"English (Malawi)","en_MY":"English (Malaysia)","en_MT":"English (Malta)","en_MH":"English (Marshall Islands)","en_MU":"English (Mauritius)","en_FM":"English (Micronesia)","en_MS":"English (Montserrat)","en_NA":"English (Namibia)","en_NR":"English (Nauru)","en_NZ":"English (New Zealand)","en_NG":"English (Nigeria)","en_NU":"English (Niue)","en_NF":"English (Norfolk Island)","en_MP":"English (Northern Mariana Islands)","en_PK":"English (Pakistan)","en_PW":"English (Palau)","en_PG":"English (Papua New Guinea)","en_PH":"English (Philippines)","en_PN":"English (Pitcairn Islands)","en_PR":"English (Puerto Rico)","en_RW":"English (Rwanda)","en_SH":"English (Saint Helena)","en_KN":"English (Saint Kitts and Nevis)","en_LC":"English (Saint Lucia)","en_WS":"English (Samoa)","en_SC":"English (Seychelles)","en_SL":"English (Sierra Leone)","en_SG":"English (Singapore)","en_SX":"English (Sint Maarten)","en_SB":"English (Solomon Islands)","en_ZA":"English (South Africa)","en_SS":"English (South Sudan)","en_VC":"English (St. Vincent & Grenadines)","en_SD":"English (Sudan)","en_SZ":"English (Swaziland)","en_TZ":"English (Tanzania)","en_TK":"English (Tokelau)","en_TO":"English (Tonga)","en_TT":"English (Trinidad and Tobago)","en_TC":"English (Turks and Caicos Islands)","en_TV":"English (Tuvalu)","en_UM":"English (U.S. Outlying Islands)","en_VI":"English (U.S. Virgin Islands)","en_UG":"English (Uganda)","en_GB":"English (United Kingdom)","en_US":"English (United States)","en_VU":"English (Vanuatu)","en_ZM":"English (Zambia)","en_ZW":"English (Zimbabwe)","eo":"Esperanto","et":"Estonian","et_EE":"Estonian (Estonia)","ee":"Ewe","ee_GH":"Ewe (Ghana)","ee_TG":"Ewe (Togo)","fo":"Faroese","fo_FO":"Faroese (Faroe Islands)","fi":"Finnish","fi_FI":"Finnish (Finland)","fr":"French","fr_DZ":"French (Algeria)","fr_BE":"French (Belgium)","fr_BJ":"French (Benin)","fr_BF":"French (Burkina Faso)","fr_BI":"French (Burundi)","fr_CM":"French (Cameroon)","fr_CA":"French (Canada)","fr_CF":"French (Central African Republic)","fr_TD":"French (Chad)","fr_KM":"French (Comoros)","fr_CG":"French (Congo - Brazzaville)","fr_CD":"French (Congo - Kinshasa)","fr_CI":"French (Côte d’Ivoire)","fr_DJ":"French (Djibouti)","fr_GQ":"French (Equatorial Guinea)","fr_FR":"French (France)","fr_GF":"French (French Guiana)","fr_PF":"French (French Polynesia)","fr_GA":"French (Gabon)","fr_GP":"French (Guadeloupe)","fr_GN":"French (Guinea)","fr_HT":"French (Haiti)","fr_LU":"French (Luxembourg)","fr_MG":"French (Madagascar)","fr_ML":"French (Mali)","fr_MQ":"French (Martinique)","fr_MR":"French (Mauritania)","fr_MU":"French (Mauritius)","fr_YT":"French (Mayotte)","fr_MC":"French (Monaco)","fr_MA":"French (Morocco)","fr_NC":"French (New Caledonia)","fr_NE":"French (Niger)","fr_RE":"French (Réunion)","fr_RW":"French (Rwanda)","fr_BL":"French (Saint Barthélemy)","fr_MF":"French (Saint Martin)","fr_PM":"French (Saint Pierre and Miquelon)","fr_SN":"French (Senegal)","fr_SC":"French (Seychelles)","fr_CH":"French (Switzerland)","fr_SY":"French (Syria)","fr_TG":"French (Togo)","fr_TN":"French (Tunisia)","fr_VU":"French (Vanuatu)","fr_WF":"French (Wallis and Futuna)","ff":"Fulah","ff_CM":"Fulah (Cameroon)","ff_GN":"Fulah (Guinea)","ff_MR":"Fulah (Mauritania)","ff_SN":"Fulah (Senegal)","gl":"Galician","gl_ES":"Galician (Spain)","lg":"Ganda","lg_UG":"Ganda (Uganda)","ka":"Georgian","ka_GE":"Georgian (Georgia)","de":"German","de_AT":"German (Austria)","de_BE":"German (Belgium)","de_DE":"German (Germany)","de_LI":"German (Liechtenstein)","de_LU":"German (Luxembourg)","de_CH":"German (Switzerland)","el":"Greek","el_CY":"Greek (Cyprus)","el_GR":"Greek (Greece)","gu":"Gujarati","gu_IN":"Gujarati (India)","ha":"Hausa","ha_GH":"Hausa (Ghana)","ha_Latn_GH":"Hausa (Latin, Ghana)","ha_Latn_NE":"Hausa (Latin, Niger)","ha_Latn_NG":"Hausa (Latin, Nigeria)","ha_Latn":"Hausa (Latin)","ha_NE":"Hausa (Niger)","ha_NG":"Hausa (Nigeria)","he":"Hebrew","he_IL":"Hebrew (Israel)","hi":"Hindi","hi_IN":"Hindi (India)","hu":"Hungarian","hu_HU":"Hungarian (Hungary)","is":"Icelandic","is_IS":"Icelandic (Iceland)","ig":"Igbo","ig_NG":"Igbo (Nigeria)","id":"Indonesian","id_ID":"Indonesian (Indonesia)","ga":"Irish","ga_IE":"Irish (Ireland)","it":"Italian","it_IT":"Italian (Italy)","it_SM":"Italian (San Marino)","it_CH":"Italian (Switzerland)","ja":"Japanese","ja_JP":"Japanese (Japan)","kl":"Kalaallisut","kl_GL":"Kalaallisut (Greenland)","kn":"Kannada","kn_IN":"Kannada (India)","ks":"Kashmiri","ks_Arab_IN":"Kashmiri (Arabic, India)","ks_Arab":"Kashmiri (Arabic)","ks_IN":"Kashmiri (India)","kk":"Kazakh","kk_Cyrl_KZ":"Kazakh (Cyrillic, Kazakhstan)","kk_Cyrl":"Kazakh (Cyrillic)","kk_KZ":"Kazakh (Kazakhstan)","km":"Khmer","km_KH":"Khmer (Cambodia)","ki":"Kikuyu","ki_KE":"Kikuyu (Kenya)","rw":"Kinyarwanda","rw_RW":"Kinyarwanda (Rwanda)","ko":"Korean","ko_KP":"Korean (North Korea)","ko_KR":"Korean (South Korea)","ky":"Kyrgyz","ky_Cyrl_KG":"Kyrgyz (Cyrillic, Kyrgyzstan)","ky_Cyrl":"Kyrgyz (Cyrillic)","ky_KG":"Kyrgyz (Kyrgyzstan)","lo":"Lao","lo_LA":"Lao (Laos)","lv":"Latvian","lv_LV":"Latvian (Latvia)","ln":"Lingala","ln_AO":"Lingala (Angola)","ln_CF":"Lingala (Central African Republic)","ln_CG":"Lingala (Congo - Brazzaville)","ln_CD":"Lingala (Congo - Kinshasa)","lt":"Lithuanian","lt_LT":"Lithuanian (Lithuania)","lu":"Luba-Katanga","lu_CD":"Luba-Katanga (Congo - Kinshasa)","lb":"Luxembourgish","lb_LU":"Luxembourgish (Luxembourg)","mk":"Macedonian","mk_MK":"Macedonian (Macedonia)","mg":"Malagasy","mg_MG":"Malagasy (Madagascar)","ms":"Malay","ms_BN":"Malay (Brunei)","ms_Latn_BN":"Malay (Latin, Brunei)","ms_Latn_MY":"Malay (Latin, Malaysia)","ms_Latn_SG":"Malay (Latin, Singapore)","ms_Latn":"Malay (Latin)","ms_MY":"Malay (Malaysia)","ms_SG":"Malay (Singapore)","ml":"Malayalam","ml_IN":"Malayalam (India)","mt":"Maltese","mt_MT":"Maltese (Malta)","gv":"Manx","gv_IM":"Manx (Isle of Man)","mr":"Marathi","mr_IN":"Marathi (India)","mn":"Mongolian","mn_Cyrl_MN":"Mongolian (Cyrillic, Mongolia)","mn_Cyrl":"Mongolian (Cyrillic)","mn_MN":"Mongolian (Mongolia)","ne":"Nepali","ne_IN":"Nepali (India)","ne_NP":"Nepali (Nepal)","nd":"North Ndebele","nd_ZW":"North Ndebele (Zimbabwe)","se":"Northern Sami","se_FI":"Northern Sami (Finland)","se_NO":"Northern Sami (Norway)","se_SE":"Northern Sami (Sweden)","no":"Norwegian","no_NO":"Norwegian (Norway)","nb":"Norwegian Bokmål","nb_NO":"Norwegian Bokmål (Norway)","nb_SJ":"Norwegian Bokmål (Svalbard and Jan Mayen)","nn":"Norwegian Nynorsk","nn_NO":"Norwegian Nynorsk (Norway)","or":"Oriya","or_IN":"Oriya (India)","om":"Oromo","om_ET":"Oromo (Ethiopia)","om_KE":"Oromo (Kenya)","os":"Ossetic","os_GE":"Ossetic (Georgia)","os_RU":"Ossetic (Russia)","ps":"Pashto","ps_AF":"Pashto (Afghanistan)","fa":"Persian","fa_AF":"Persian (Afghanistan)","fa_IR":"Persian (Iran)","pl":"Polish","pl_PL":"Polish (Poland)","pt":"Portuguese","pt_AO":"Portuguese (Angola)","pt_BR":"Portuguese (Brazil)","pt_CV":"Portuguese (Cape Verde)","pt_GW":"Portuguese (Guinea-Bissau)","pt_MO":"Portuguese (Macau SAR China)","pt_MZ":"Portuguese (Mozambique)","pt_PT":"Portuguese (Portugal)","pt_ST":"Portuguese (São Tomé and Príncipe)","pt_TL":"Portuguese (Timor-Leste)","pa":"Punjabi","pa_Arab_PK":"Punjabi (Arabic, Pakistan)","pa_Arab":"Punjabi (Arabic)","pa_Guru_IN":"Punjabi (Gurmukhi, India)","pa_Guru":"Punjabi (Gurmukhi)","pa_IN":"Punjabi (India)","pa_PK":"Punjabi (Pakistan)","qu":"Quechua","qu_BO":"Quechua (Bolivia)","qu_EC":"Quechua (Ecuador)","qu_PE":"Quechua (Peru)","ro":"Romanian","ro_MD":"Romanian (Moldova)","ro_RO":"Romanian (Romania)","rm":"Romansh","rm_CH":"Romansh (Switzerland)","rn":"Rundi","rn_BI":"Rundi (Burundi)","ru":"Russian","ru_BY":"Russian (Belarus)","ru_KZ":"Russian (Kazakhstan)","ru_KG":"Russian (Kyrgyzstan)","ru_MD":"Russian (Moldova)","ru_RU":"Russian (Russia)","ru_UA":"Russian (Ukraine)","sg":"Sango","sg_CF":"Sango (Central African Republic)","gd":"Scottish Gaelic","gd_GB":"Scottish Gaelic (United Kingdom)","sr":"Serbian","sr_BA":"Serbian (Bosnia and Herzegovina)","sr_Cyrl_BA":"Serbian (Cyrillic, Bosnia and Herzegovina)","sr_Cyrl_XK":"Serbian (Cyrillic, Kosovo)","sr_Cyrl_ME":"Serbian (Cyrillic, Montenegro)","sr_Cyrl_RS":"Serbian (Cyrillic, Serbia)","sr_Cyrl":"Serbian (Cyrillic)","sr_XK":"Serbian (Kosovo)","sr_Latn_BA":"Serbian (Latin, Bosnia and Herzegovina)","sr_Latn_XK":"Serbian (Latin, Kosovo)","sr_Latn_ME":"Serbian (Latin, Montenegro)","sr_Latn_RS":"Serbian (Latin, Serbia)","sr_Latn":"Serbian (Latin)","sr_ME":"Serbian (Montenegro)","sr_RS":"Serbian (Serbia)","sh":"Serbo-Croatian","sh_BA":"Serbo-Croatian (Bosnia and Herzegovina)","sn":"Shona","sn_ZW":"Shona (Zimbabwe)","ii":"Sichuan Yi","ii_CN":"Sichuan Yi (China)","si":"Sinhala","si_LK":"Sinhala (Sri Lanka)","sk":"Slovak","sk_SK":"Slovak (Slovakia)","sl":"Slovenian","sl_SI":"Slovenian (Slovenia)","so":"Somali","so_DJ":"Somali (Djibouti)","so_ET":"Somali (Ethiopia)","so_KE":"Somali (Kenya)","so_SO":"Somali (Somalia)","es":"Spanish","es_AR":"Spanish (Argentina)","es_BO":"Spanish (Bolivia)","es_IC":"Spanish (Canary Islands)","es_EA":"Spanish (Ceuta and Melilla)","es_CL":"Spanish (Chile)","es_CO":"Spanish (Colombia)","es_CR":"Spanish (Costa Rica)","es_CU":"Spanish (Cuba)","es_DO":"Spanish (Dominican Republic)","es_EC":"Spanish (Ecuador)","es_SV":"Spanish (El Salvador)","es_GQ":"Spanish (Equatorial Guinea)","es_GT":"Spanish (Guatemala)","es_HN":"Spanish (Honduras)","es_MX":"Spanish (Mexico)","es_NI":"Spanish (Nicaragua)","es_PA":"Spanish (Panama)","es_PY":"Spanish (Paraguay)","es_PE":"Spanish (Peru)","es_PH":"Spanish (Philippines)","es_PR":"Spanish (Puerto Rico)","es_ES":"Spanish (Spain)","es_US":"Spanish (United States)","es_UY":"Spanish (Uruguay)","es_VE":"Spanish (Venezuela)","sw":"Swahili","sw_KE":"Swahili (Kenya)","sw_TZ":"Swahili (Tanzania)","sw_UG":"Swahili (Uganda)","sv":"Swedish","sv_AX":"Swedish (Åland Islands)","sv_FI":"Swedish (Finland)","sv_SE":"Swedish (Sweden)","tl":"Tagalog","tl_PH":"Tagalog (Philippines)","ta":"Tamil","ta_IN":"Tamil (India)","ta_MY":"Tamil (Malaysia)","ta_SG":"Tamil (Singapore)","ta_LK":"Tamil (Sri Lanka)","te":"Telugu","te_IN":"Telugu (India)","th":"Thai","th_TH":"Thai (Thailand)","bo":"Tibetan","bo_CN":"Tibetan (China)","bo_IN":"Tibetan (India)","ti":"Tigrinya","ti_ER":"Tigrinya (Eritrea)","ti_ET":"Tigrinya (Ethiopia)","to":"Tongan","to_TO":"Tongan (Tonga)","tr":"Turkish","tr_CY":"Turkish (Cyprus)","tr_TR":"Turkish (Turkey)","uk":"Ukrainian","uk_UA":"Ukrainian (Ukraine)","ur":"Urdu","ur_IN":"Urdu (India)","ur_PK":"Urdu (Pakistan)","ug":"Uyghur","ug_Arab_CN":"Uyghur (Arabic, China)","ug_Arab":"Uyghur (Arabic)","ug_CN":"Uyghur (China)","uz":"Uzbek","uz_AF":"Uzbek (Afghanistan)","uz_Arab_AF":"Uzbek (Arabic, Afghanistan)","uz_Arab":"Uzbek (Arabic)","uz_Cyrl_UZ":"Uzbek (Cyrillic, Uzbekistan)","uz_Cyrl":"Uzbek (Cyrillic)","uz_Latn_UZ":"Uzbek (Latin, Uzbekistan)","uz_Latn":"Uzbek (Latin)","uz_UZ":"Uzbek (Uzbekistan)","vi":"Vietnamese","vi_VN":"Vietnamese (Vietnam)","cy":"Welsh","cy_GB":"Welsh (United Kingdom)","fy":"Western Frisian","fy_NL":"Western Frisian (Netherlands)","yi":"Yiddish","yo":"Yoruba","yo_BJ":"Yoruba (Benin)","yo_NG":"Yoruba (Nigeria)","zu":"Zulu","zu_ZA":"Zulu (South Africa)"}

/***/ }),

/***/ "./sdk/scripts/i18n/data/locales/fr.json":
/***/ (function(module, exports) {

module.exports = {"af":"afrikaans","af_ZA":"afrikaans (Afrique du Sud)","af_NA":"afrikaans (Namibie)","ak":"akan","ak_GH":"akan (Ghana)","sq":"albanais","sq_AL":"albanais (Albanie)","sq_XK":"albanais (Kosovo)","sq_MK":"albanais (Macédoine)","de":"allemand","de_DE":"allemand (Allemagne)","de_AT":"allemand (Autriche)","de_BE":"allemand (Belgique)","de_LI":"allemand (Liechtenstein)","de_LU":"allemand (Luxembourg)","de_CH":"allemand (Suisse)","am":"amharique","am_ET":"amharique (Éthiopie)","en":"anglais","en_ZA":"anglais (Afrique du Sud)","en_AI":"anglais (Anguilla)","en_AG":"anglais (Antigua-et-Barbuda)","en_AU":"anglais (Australie)","en_BS":"anglais (Bahamas)","en_BB":"anglais (Barbade)","en_BE":"anglais (Belgique)","en_BZ":"anglais (Belize)","en_BM":"anglais (Bermudes)","en_BW":"anglais (Botswana)","en_CM":"anglais (Cameroun)","en_CA":"anglais (Canada)","en_DG":"anglais (Diego Garcia)","en_DM":"anglais (Dominique)","en_ER":"anglais (Érythrée)","en_FM":"anglais (États fédérés de Micronésie)","en_US":"anglais (États-Unis)","en_FJ":"anglais (Fidji)","en_GM":"anglais (Gambie)","en_GH":"anglais (Ghana)","en_GI":"anglais (Gibraltar)","en_GD":"anglais (Grenade)","en_GU":"anglais (Guam)","en_GG":"anglais (Guernesey)","en_GY":"anglais (Guyana)","en_CX":"anglais (Île Christmas)","en_IM":"anglais (Île de Man)","en_NF":"anglais (Île Norfolk)","en_KY":"anglais (Îles Caïmans)","en_CC":"anglais (Îles Cocos)","en_CK":"anglais (Îles Cook)","en_FK":"anglais (Îles Malouines)","en_MP":"anglais (Îles Mariannes du Nord)","en_MH":"anglais (Îles Marshall)","en_UM":"anglais (Îles mineures éloignées des États-Unis)","en_SB":"anglais (Îles Salomon)","en_TC":"anglais (Îles Turques-et-Caïques)","en_VG":"anglais (Îles Vierges britanniques)","en_VI":"anglais (Îles Vierges des États-Unis)","en_IN":"anglais (Inde)","en_IE":"anglais (Irlande)","en_JM":"anglais (Jamaïque)","en_JE":"anglais (Jersey)","en_KE":"anglais (Kenya)","en_KI":"anglais (Kiribati)","en_LS":"anglais (Lesotho)","en_LR":"anglais (Libéria)","en_MG":"anglais (Madagascar)","en_MY":"anglais (Malaisie)","en_MW":"anglais (Malawi)","en_MT":"anglais (Malte)","en_MU":"anglais (Maurice)","en_MS":"anglais (Montserrat)","en_NA":"anglais (Namibie)","en_NR":"anglais (Nauru)","en_NG":"anglais (Nigéria)","en_NU":"anglais (Niue)","en_NZ":"anglais (Nouvelle-Zélande)","en_UG":"anglais (Ouganda)","en_PK":"anglais (Pakistan)","en_PW":"anglais (Palaos)","en_PG":"anglais (Papouasie-Nouvelle-Guinée)","en_PH":"anglais (Philippines)","en_PN":"anglais (Pitcairn)","en_PR":"anglais (Porto Rico)","en_HK":"anglais (R.A.S. chinoise de Hong Kong)","en_MO":"anglais (R.A.S. chinoise de Macao)","en_GB":"anglais (Royaume-Uni)","en_RW":"anglais (Rwanda)","en_KN":"anglais (Saint-Christophe-et-Niévès)","en_SX":"anglais (Saint-Martin (partie néerlandaise))","en_VC":"anglais (Saint-Vincent-et-les-Grenadines)","en_SH":"anglais (Sainte-Hélène)","en_LC":"anglais (Sainte-Lucie)","en_AS":"anglais (Samoa américaines)","en_WS":"anglais (Samoa)","en_SC":"anglais (Seychelles)","en_SL":"anglais (Sierra Leone)","en_SG":"anglais (Singapour)","en_SS":"anglais (Soudan du Sud)","en_SD":"anglais (Soudan)","en_SZ":"anglais (Swaziland)","en_TZ":"anglais (Tanzanie)","en_IO":"anglais (Territoire britannique de l’océan Indien)","en_TK":"anglais (Tokelau)","en_TO":"anglais (Tonga)","en_TT":"anglais (Trinité-et-Tobago)","en_TV":"anglais (Tuvalu)","en_VU":"anglais (Vanuatu)","en_ZM":"anglais (Zambie)","en_ZW":"anglais (Zimbabwe)","ar":"arabe","ar_DZ":"arabe (Algérie)","ar_SA":"arabe (Arabie saoudite)","ar_BH":"arabe (Bahreïn)","ar_KM":"arabe (Comores)","ar_DJ":"arabe (Djibouti)","ar_EG":"arabe (Égypte)","ar_AE":"arabe (Émirats arabes unis)","ar_ER":"arabe (Érythrée)","ar_IQ":"arabe (Irak)","ar_IL":"arabe (Israël)","ar_JO":"arabe (Jordanie)","ar_KW":"arabe (Koweït)","ar_LB":"arabe (Liban)","ar_LY":"arabe (Libye)","ar_MA":"arabe (Maroc)","ar_MR":"arabe (Mauritanie)","ar_OM":"arabe (Oman)","ar_QA":"arabe (Qatar)","ar_EH":"arabe (Sahara occidental)","ar_SO":"arabe (Somalie)","ar_SS":"arabe (Soudan du Sud)","ar_SD":"arabe (Soudan)","ar_SY":"arabe (Syrie)","ar_TD":"arabe (Tchad)","ar_PS":"arabe (Territoires palestiniens)","ar_TN":"arabe (Tunisie)","ar_YE":"arabe (Yémen)","hy":"arménien","hy_AM":"arménien (Arménie)","as":"assamais","as_IN":"assamais (Inde)","az":"azéri","az_AZ":"azéri (Azerbaïdjan)","az_Cyrl_AZ":"azéri (cyrillique, Azerbaïdjan)","az_Cyrl":"azéri (cyrillique)","az_Latn_AZ":"azéri (latin, Azerbaïdjan)","az_Latn":"azéri (latin)","bm":"bambara","bm_Latn_ML":"bambara (latin, Mali)","bm_Latn":"bambara (latin)","eu":"basque","eu_ES":"basque (Espagne)","bn":"bengali","bn_BD":"bengali (Bangladesh)","bn_IN":"bengali (Inde)","be":"biélorusse","be_BY":"biélorusse (Biélorussie)","my":"birman","my_MM":"birman (Myanmar)","bs":"bosniaque","bs_BA":"bosniaque (Bosnie-Herzégovine)","bs_Cyrl_BA":"bosniaque (cyrillique, Bosnie-Herzégovine)","bs_Cyrl":"bosniaque (cyrillique)","bs_Latn_BA":"bosniaque (latin, Bosnie-Herzégovine)","bs_Latn":"bosniaque (latin)","br":"breton","br_FR":"breton (France)","bg":"bulgare","bg_BG":"bulgare (Bulgarie)","ca":"catalan","ca_AD":"catalan (Andorre)","ca_ES":"catalan (Espagne)","ca_FR":"catalan (France)","ca_IT":"catalan (Italie)","zh":"chinois","zh_CN":"chinois (Chine)","zh_HK":"chinois (R.A.S. chinoise de Hong Kong)","zh_MO":"chinois (R.A.S. chinoise de Macao)","zh_Hans_CN":"chinois (simplifié, Chine)","zh_Hans_HK":"chinois (simplifié, R.A.S. chinoise de Hong Kong)","zh_Hans_MO":"chinois (simplifié, R.A.S. chinoise de Macao)","zh_Hans_SG":"chinois (simplifié, Singapour)","zh_Hans":"chinois (simplifié)","zh_SG":"chinois (Singapour)","zh_TW":"chinois (Taïwan)","zh_Hant_HK":"chinois (traditionnel, R.A.S. chinoise de Hong Kong)","zh_Hant_MO":"chinois (traditionnel, R.A.S. chinoise de Macao)","zh_Hant_TW":"chinois (traditionnel, Taïwan)","zh_Hant":"chinois (traditionnel)","si":"cinghalais","si_LK":"cinghalais (Sri Lanka)","ko":"coréen","ko_KP":"coréen (Corée du Nord)","ko_KR":"coréen (Corée du Sud)","kw":"cornique","kw_GB":"cornique (Royaume-Uni)","hr":"croate","hr_BA":"croate (Bosnie-Herzégovine)","hr_HR":"croate (Croatie)","da":"danois","da_DK":"danois (Danemark)","da_GL":"danois (Groenland)","dz":"dzongkha","dz_BT":"dzongkha (Bhoutan)","es":"espagnol","es_AR":"espagnol (Argentine)","es_BO":"espagnol (Bolivie)","es_EA":"espagnol (Ceuta et Melilla)","es_CL":"espagnol (Chili)","es_CO":"espagnol (Colombie)","es_CR":"espagnol (Costa Rica)","es_CU":"espagnol (Cuba)","es_SV":"espagnol (El Salvador)","es_EC":"espagnol (Équateur)","es_ES":"espagnol (Espagne)","es_US":"espagnol (États-Unis)","es_GT":"espagnol (Guatemala)","es_GQ":"espagnol (Guinée équatoriale)","es_HN":"espagnol (Honduras)","es_IC":"espagnol (Îles Canaries)","es_MX":"espagnol (Mexique)","es_NI":"espagnol (Nicaragua)","es_PA":"espagnol (Panama)","es_PY":"espagnol (Paraguay)","es_PE":"espagnol (Pérou)","es_PH":"espagnol (Philippines)","es_PR":"espagnol (Porto Rico)","es_DO":"espagnol (République dominicaine)","es_UY":"espagnol (Uruguay)","es_VE":"espagnol (Venezuela)","eo":"espéranto","et":"estonien","et_EE":"estonien (Estonie)","ee":"éwé","ee_GH":"éwé (Ghana)","ee_TG":"éwé (Togo)","fo":"féroïen","fo_FO":"féroïen (Îles Féroé)","fi":"finnois","fi_FI":"finnois (Finlande)","fr":"français","fr_DZ":"français (Algérie)","fr_BE":"français (Belgique)","fr_BJ":"français (Bénin)","fr_BF":"français (Burkina Faso)","fr_BI":"français (Burundi)","fr_CM":"français (Cameroun)","fr_CA":"français (Canada)","fr_KM":"français (Comores)","fr_CG":"français (Congo-Brazzaville)","fr_CD":"français (Congo-Kinshasa)","fr_CI":"français (Côte d’Ivoire)","fr_DJ":"français (Djibouti)","fr_FR":"français (France)","fr_GA":"français (Gabon)","fr_GP":"français (Guadeloupe)","fr_GQ":"français (Guinée équatoriale)","fr_GN":"français (Guinée)","fr_GF":"français (Guyane française)","fr_HT":"français (Haïti)","fr_RE":"français (La Réunion)","fr_LU":"français (Luxembourg)","fr_MG":"français (Madagascar)","fr_ML":"français (Mali)","fr_MA":"français (Maroc)","fr_MQ":"français (Martinique)","fr_MU":"français (Maurice)","fr_MR":"français (Mauritanie)","fr_YT":"français (Mayotte)","fr_MC":"français (Monaco)","fr_NE":"français (Niger)","fr_NC":"français (Nouvelle-Calédonie)","fr_PF":"français (Polynésie française)","fr_CF":"français (République centrafricaine)","fr_RW":"français (Rwanda)","fr_BL":"français (Saint-Barthélemy)","fr_MF":"français (Saint-Martin (partie française))","fr_PM":"français (Saint-Pierre-et-Miquelon)","fr_SN":"français (Sénégal)","fr_SC":"français (Seychelles)","fr_CH":"français (Suisse)","fr_SY":"français (Syrie)","fr_TD":"français (Tchad)","fr_TG":"français (Togo)","fr_TN":"français (Tunisie)","fr_VU":"français (Vanuatu)","fr_WF":"français (Wallis-et-Futuna)","fy":"frison occidental","fy_NL":"frison occidental (Pays-Bas)","gd":"gaélique écossais","gd_GB":"gaélique écossais (Royaume-Uni)","gl":"galicien","gl_ES":"galicien (Espagne)","cy":"gallois","cy_GB":"gallois (Royaume-Uni)","lg":"ganda","lg_UG":"ganda (Ouganda)","ka":"géorgien","ka_GE":"géorgien (Géorgie)","el":"grec","el_CY":"grec (Chypre)","el_GR":"grec (Grèce)","kl":"groenlandais","kl_GL":"groenlandais (Groenland)","gu":"gujarati","gu_IN":"gujarati (Inde)","ha":"haoussa","ha_GH":"haoussa (Ghana)","ha_Latn_GH":"haoussa (latin, Ghana)","ha_Latn_NE":"haoussa (latin, Niger)","ha_Latn_NG":"haoussa (latin, Nigéria)","ha_Latn":"haoussa (latin)","ha_NE":"haoussa (Niger)","ha_NG":"haoussa (Nigéria)","he":"hébreu","he_IL":"hébreu (Israël)","hi":"hindi","hi_IN":"hindi (Inde)","hu":"hongrois","hu_HU":"hongrois (Hongrie)","ig":"igbo","ig_NG":"igbo (Nigéria)","id":"indonésien","id_ID":"indonésien (Indonésie)","ga":"irlandais","ga_IE":"irlandais (Irlande)","is":"islandais","is_IS":"islandais (Islande)","it":"italien","it_IT":"italien (Italie)","it_SM":"italien (Saint-Marin)","it_CH":"italien (Suisse)","ja":"japonais","ja_JP":"japonais (Japon)","kn":"kannada","kn_IN":"kannada (Inde)","ks":"kashmiri","ks_Arab_IN":"kashmiri (arabe, Inde)","ks_Arab":"kashmiri (arabe)","ks_IN":"kashmiri (Inde)","kk":"kazakh","kk_Cyrl_KZ":"kazakh (cyrillique, Kazakhstan)","kk_Cyrl":"kazakh (cyrillique)","kk_KZ":"kazakh (Kazakhstan)","km":"khmer","km_KH":"khmer (Cambodge)","ki":"kikuyu","ki_KE":"kikuyu (Kenya)","ky":"kirghize","ky_Cyrl_KG":"kirghize (cyrillique, Kirghizistan)","ky_Cyrl":"kirghize (cyrillique)","ky_KG":"kirghize (Kirghizistan)","lo":"lao","lo_LA":"lao (Laos)","lv":"letton","lv_LV":"letton (Lettonie)","ln":"lingala","ln_AO":"lingala (Angola)","ln_CG":"lingala (Congo-Brazzaville)","ln_CD":"lingala (Congo-Kinshasa)","ln_CF":"lingala (République centrafricaine)","lt":"lituanien","lt_LT":"lituanien (Lituanie)","lu":"luba-katanga","lu_CD":"luba-katanga (Congo-Kinshasa)","lb":"luxembourgeois","lb_LU":"luxembourgeois (Luxembourg)","mk":"macédonien","mk_MK":"macédonien (Macédoine)","ms":"malais","ms_BN":"malais (Brunéi Darussalam)","ms_Latn_BN":"malais (latin, Brunéi Darussalam)","ms_Latn_MY":"malais (latin, Malaisie)","ms_Latn_SG":"malais (latin, Singapour)","ms_Latn":"malais (latin)","ms_MY":"malais (Malaisie)","ms_SG":"malais (Singapour)","ml":"malayalam","ml_IN":"malayalam (Inde)","mg":"malgache","mg_MG":"malgache (Madagascar)","mt":"maltais","mt_MT":"maltais (Malte)","gv":"manx","gv_IM":"manx (Île de Man)","mr":"marathe","mr_IN":"marathe (Inde)","mn":"mongol","mn_Cyrl_MN":"mongol (cyrillique, Mongolie)","mn_Cyrl":"mongol (cyrillique)","mn_MN":"mongol (Mongolie)","nd":"ndébélé du Nord","nd_ZW":"ndébélé du Nord (Zimbabwe)","nl":"néerlandais","nl_AW":"néerlandais (Aruba)","nl_BE":"néerlandais (Belgique)","nl_CW":"néerlandais (Curaçao)","nl_BQ":"néerlandais (Pays-Bas caribéens)","nl_NL":"néerlandais (Pays-Bas)","nl_SX":"néerlandais (Saint-Martin (partie néerlandaise))","nl_SR":"néerlandais (Suriname)","ne":"népalais","ne_IN":"népalais (Inde)","ne_NP":"népalais (Népal)","no":"norvégien","no_NO":"norvégien (Norvège)","nb":"norvégien bokmål","nb_NO":"norvégien bokmål (Norvège)","nb_SJ":"norvégien bokmål (Svalbard et Jan Mayen)","nn":"norvégien nynorsk","nn_NO":"norvégien nynorsk (Norvège)","or":"oriya","or_IN":"oriya (Inde)","om":"oromo","om_ET":"oromo (Éthiopie)","om_KE":"oromo (Kenya)","os":"ossète","os_GE":"ossète (Géorgie)","os_RU":"ossète (Russie)","ug":"ouïghour","ug_Arab_CN":"ouïghour (arabe, Chine)","ug_Arab":"ouïghour (arabe)","ug_CN":"ouïghour (Chine)","ur":"ourdou","ur_IN":"ourdou (Inde)","ur_PK":"ourdou (Pakistan)","uz":"ouzbek","uz_AF":"ouzbek (Afghanistan)","uz_Arab_AF":"ouzbek (arabe, Afghanistan)","uz_Arab":"ouzbek (arabe)","uz_Cyrl_UZ":"ouzbek (cyrillique, Ouzbékistan)","uz_Cyrl":"ouzbek (cyrillique)","uz_Latn_UZ":"ouzbek (latin, Ouzbékistan)","uz_Latn":"ouzbek (latin)","uz_UZ":"ouzbek (Ouzbékistan)","ps":"pachto","ps_AF":"pachto (Afghanistan)","pa":"pendjabi","pa_Arab_PK":"pendjabi (arabe, Pakistan)","pa_Arab":"pendjabi (arabe)","pa_Guru_IN":"pendjabi (gourmoukhî, Inde)","pa_Guru":"pendjabi (gourmoukhî)","pa_IN":"pendjabi (Inde)","pa_PK":"pendjabi (Pakistan)","fa":"persan","fa_AF":"persan (Afghanistan)","fa_IR":"persan (Iran)","ff":"peul","ff_CM":"peul (Cameroun)","ff_GN":"peul (Guinée)","ff_MR":"peul (Mauritanie)","ff_SN":"peul (Sénégal)","pl":"polonais","pl_PL":"polonais (Pologne)","pt":"portugais","pt_AO":"portugais (Angola)","pt_BR":"portugais (Brésil)","pt_CV":"portugais (Cap-Vert)","pt_GW":"portugais (Guinée-Bissau)","pt_MZ":"portugais (Mozambique)","pt_PT":"portugais (Portugal)","pt_MO":"portugais (R.A.S. chinoise de Macao)","pt_ST":"portugais (Sao Tomé-et-Principe)","pt_TL":"portugais (Timor oriental)","qu":"quechua","qu_BO":"quechua (Bolivie)","qu_EC":"quechua (Équateur)","qu_PE":"quechua (Pérou)","rm":"romanche","rm_CH":"romanche (Suisse)","ro":"roumain","ro_MD":"roumain (Moldavie)","ro_RO":"roumain (Roumanie)","rn":"roundi","rn_BI":"roundi (Burundi)","ru":"russe","ru_BY":"russe (Biélorussie)","ru_KZ":"russe (Kazakhstan)","ru_KG":"russe (Kirghizistan)","ru_MD":"russe (Moldavie)","ru_RU":"russe (Russie)","ru_UA":"russe (Ukraine)","rw":"rwanda","rw_RW":"rwanda (Rwanda)","se":"sami du Nord","se_FI":"sami du Nord (Finlande)","se_NO":"sami du Nord (Norvège)","se_SE":"sami du Nord (Suède)","sg":"sangho","sg_CF":"sangho (République centrafricaine)","sr":"serbe","sr_BA":"serbe (Bosnie-Herzégovine)","sr_Cyrl_BA":"serbe (cyrillique, Bosnie-Herzégovine)","sr_Cyrl_XK":"serbe (cyrillique, Kosovo)","sr_Cyrl_ME":"serbe (cyrillique, Monténégro)","sr_Cyrl_RS":"serbe (cyrillique, Serbie)","sr_Cyrl":"serbe (cyrillique)","sr_XK":"serbe (Kosovo)","sr_Latn_BA":"serbe (latin, Bosnie-Herzégovine)","sr_Latn_XK":"serbe (latin, Kosovo)","sr_Latn_ME":"serbe (latin, Monténégro)","sr_Latn_RS":"serbe (latin, Serbie)","sr_Latn":"serbe (latin)","sr_ME":"serbe (Monténégro)","sr_RS":"serbe (Serbie)","sh":"serbo-croate","sh_BA":"serbo-croate (Bosnie-Herzégovine)","sn":"shona","sn_ZW":"shona (Zimbabwe)","sk":"slovaque","sk_SK":"slovaque (Slovaquie)","sl":"slovène","sl_SI":"slovène (Slovénie)","so":"somali","so_DJ":"somali (Djibouti)","so_ET":"somali (Éthiopie)","so_KE":"somali (Kenya)","so_SO":"somali (Somalie)","sv":"suédois","sv_FI":"suédois (Finlande)","sv_AX":"suédois (Îles Åland)","sv_SE":"suédois (Suède)","sw":"swahili","sw_KE":"swahili (Kenya)","sw_UG":"swahili (Ouganda)","sw_TZ":"swahili (Tanzanie)","tl":"tagalog","tl_PH":"tagalog (Philippines)","ta":"tamoul","ta_IN":"tamoul (Inde)","ta_MY":"tamoul (Malaisie)","ta_SG":"tamoul (Singapour)","ta_LK":"tamoul (Sri Lanka)","cs":"tchèque","cs_CZ":"tchèque (République tchèque)","te":"télougou","te_IN":"télougou (Inde)","th":"thaï","th_TH":"thaï (Thaïlande)","bo":"tibétain","bo_CN":"tibétain (Chine)","bo_IN":"tibétain (Inde)","ti":"tigrigna","ti_ER":"tigrigna (Érythrée)","ti_ET":"tigrigna (Éthiopie)","to":"tonguien","to_TO":"tonguien (Tonga)","tr":"turc","tr_CY":"turc (Chypre)","tr_TR":"turc (Turquie)","uk":"ukrainien","uk_UA":"ukrainien (Ukraine)","vi":"vietnamien","vi_VN":"vietnamien (Vietnam)","ii":"yi du Sichuan","ii_CN":"yi du Sichuan (Chine)","yi":"yiddish","yo":"yoruba","yo_BJ":"yoruba (Bénin)","yo_NG":"yoruba (Nigéria)","zu":"zoulou","zu_ZA":"zoulou (Afrique du Sud)"}

/***/ }),

/***/ "./sdk/scripts/i18n/locales/de.json":
/***/ (function(module, exports) {

module.exports = {"api_error.no_internet":"Keine Internetverbindung","api.error.address.post.101":"Benutzerunstimmigkeit","api.error.address.post.102":"Nicht erlaubt","api.error.address.post.103":"Unbekannte Adresse","api.error.address.post.104":"Adresskörper fehlt","api.error.address.post.105":"Adresse nicht gefunden.","api.error.address.put.101":"Benutzerunstimmigkeiten","api.error.address.put.102":"Nicht erlaubt","api.error.address.put.103":"Unbekannte Adresse","api.error.address.put.104":"Adresskörper fehlt","api.error.address.put.105":"Adresse nicht gefunden.","api.error.booking_settings.get.101":"Sie müssen mindestens einen Raum erstellen.","api.error.booking_settings.get.102":"Sie müssen mindestens eine verfügbare Essenszeit angeben.","api.error.booking_settings.get.103":"Kapazität muss positiv sein.","api.error.booking_settings.get.105":"Die minimale Verzögerung für sofortige Buchung muss positiv sein.","api.error.booking_settings.get.106":"Buchungszeiten aus der Vergangenheit können nicht geöffnet werden.","api.error.booking_settings.get.107":"Telefonnummer ungültig.","api.error.booking_settings.get.108":"Email-Adresse ungültig.","api.error.booking_settings.get.112":"Die maximale Anzahl der Gäste für automatische Bestätigung ist ungültig.","api.error.booking_settings.get.115":"Ein Öffnungszeitraum ist ungültig","api.error.booking_settings.get.117":"In einem Zeitraum sind zwei spezifische Parameter doppelt.","api.error.booking_settings.get.118":"Kapazität ungültig.","api.error.booking_settings.get.121":"Öffnungszeiträume müssen größer sein als eine Stunde.","api.error.booking_settings.get.122":"Die Raumkapazität ist größer als die maximale Kapazität des Restaurants.","api.error.booking_settings.get.123":"Die Raumkapazität ist größer als die maximale Kapazität des Restaurants.","api.error.booking_settings.get.127":"Die Kapazität eines Raumes fehlt.","api.error.booking_settings.get.128":"Die zeitliche Lücke des spezifischen Parameters ist ungültig.","api.error.booking_settings.get.129":"Die Kapazität ist für einen spezifischen Parameter ungültig","api.error.booking_settings.get.131":"Die Anzahl der Gäste ist ungültig","api.error.booking_settings.get.132":"Die Telefonnumer der Geschäftsabteilung ist ungültig","api.error.booking_settings.get.133":"Die Email-Adresse der Geschäftsabteilung ist ungültig","api.error.booking.get_booking_slots.200":"Buchungen sind für das ausgewählte Datum geschlossen","api.error.booking.get_booking_slots.201":"Ausgewähltes Datum ist ungültig (in der Vergangenheit)","api.error.booking.post_booking.202":"Anzahl der Gäste muss positiv sein","api.error.booking.post_booking.203":"Einstellungen der Buchung ungültig","api.error.booking.post_booking.204":"Datum der Buchung ist zu weit in der Zukunft.","api.error.booking.post_booking.205":"Daum der Buchung ist zu kurzfristig.","api.error.booking.post_booking.206":"Datum der Buchung ist in der Vergangenheit.","api.error.booking.post_booking.210":"Es wurde bereits eine Buchung zu dieser Zeit erstellt.","api.error.booking.post_booking.211":"Es gibt an diesem Datum keine verfügbaren Zeiträume.","api.error.booking.post_booking.212":"Es gibt an diesem Datum keine verfügbaren Zeiträume.","api.error.booking.post_booking.213":"Im ausgewählten Raum sind zu diesem Zeitpunkt nicht genügend Sitzplätze verfügbar","api.error.booking.post_booking.214":"In diesem Zeitraum stehen nicht genügend Sitzplätze zur Verfügung","api.error.booking.post_booking.215":"Nachname fehlt","api.error.booking.post_booking.216":"Vorname fehlt","api.error.booking.post_booking.218":"Sie müssen eine Email-Adresse und/oder eine Telefonnummer angeben","api.error.booking.post_booking.219":"Ungültige Email-Adresse","api.error.booking.post_booking.220":"Ungültige Telefonnummer","api.error.booking.post_booking.221":"Die Anzahl der Gäste ist zu hoch. Bitte kontaktieren sie die Geschäftsabteilung","api.error.menu.get.103":"Die Kasse ist nicht kompatibel.","api.error.menu.get.104":"Menü kann von Kasse nicht abgerufen werden.","api.error.menu.get.105":"Die Kasse ist nicht kmpatibel. Menü kann nicht abgerufen werden.","api.error.menu.get.401":"Menü kann von Kasse nicht abgerufen werden. Bitte versuchen sie es erneut. Wenn das Problem immernoch auftaucht, überprüfen sie die Verbindung zur Kasse.","api.error.order.post.101":"Der Benutzer ist nicht authorisiert eine Bestellung aufzugeben","api.error.order.post.102":"Adresse fehlt","api.error.order.post.103":"Adresse nicht gefunden","api.error.order.post.104":"Adresse konnte nicht geortet werden","api.error.order.post.106":"Sie müssen ihre Telefonnummer verifizieren um das Guthaben nutzen zu können","api.error.order.post.107":"Die Karte kann für diese Währung nicht genutzt werden. Bitte fügen sie eine neue Karte hinzu.","api.error.order.post.109":"Karte nicht gefunden","api.error.order.post.110":"Restaurant nicht gefunden","api.error.order.post.112":"Sie besitzen nicht genug Guthaben","api.error.order.post.114":"Das Guthaben ist höher als der Gesamtpreis","api.error.order.post.115":"Die Gesamtsumme ist zu niedrig für die Verarbeitung dieser Zahlung","api.error.order.post.117":"Sie können nur Euro als Währung für Guthaben nutzen","api.error.order.post.118":"Fehler von Restaurantkasse","api.error.order.post.119":"Die Zahlung schlug in den letzten 5 Minuten zu oft fehl. Versuchen sie es später nochmal.","api.error.order.post.121":"Kommunikation mit ihrer Bank nicht möglich","api.error.order.post.124":"Ein Fehler ist aufgetreten. Bitte kontaktieren sie uns, wenn der Fehler immernoch auftritt.","api.error.order.post.125":"Ein Fehler ist während des Zahlungsprozesses aufgetreten. Versuchen sie es erneut.","api.error.order.post.126":"Ihre Bank hat die Zahlung abgelehnt. Bitte kontaktieren sie ihre Bank.","api.error.order.post.127":"Ihre Bank hat die Zahlung abgelehnt: Maximum erreicht. Bitte kontaktieren sie ihre Bank.","api.error.order.post.128":"Ihre Bank hat die Zahlung abgelehnt. Bitte kontaktieren sie ihre Bank.","api.error.order.post.129":"Ihre Bank hat die Zahlung abgelehnt: Maximum erreicht. Bitte kontaktieren sie ihre Bank.","api.error.order.post.130":"Ihre Karte ist abgelaufen","api.error.order.post.131":"Ihre Karte ist inaktiv","api.error.order.post.132":"Ihre Karte ist inaktiv","api.error.order.post.133":"Maximale Anzahl an Versuchen erreicht. Bitte kontaktieren sie ihre Bank.","api.error.order.post.134":"Ihre Bank hat die Zahlung abgelehnt: Maximum erreicht. Bitte kontaktieren sie ihre Bank.","api.error.order.post.135":"Ihre Bank hat die Zahlung abgelehnt: Maximum erreicht. Bitte kontaktieren sie ihre Bank.","api.error.order.post.136":"Ihre Bank hat die Zahlung abgelehnt: Maximum erreicht. Bitte kontaktieren sie ihre Bank.","api.error.order.post.137":"Ihre Bank hat die Zahlung abgelehnt. Bitte kontaktieren sie ihre Bank.","api.error.order.post.141":"Fehler von Restaurantkasse","api.error.order.post.142":"Manche Artikel in ihrem Warenkorb passen nicht in das Restaurantmenü. Aktualisieren sie bitte ihr Restaurantmenü.","api.error.order.post.401":"Fehler von Restaurantkasse","api.error.order.post.402":"Der Tisch existiert nicht. Bitte ändern.","api.error.order.post.405":"Ein oder mehrere Artikel sind nicht mehr vorrätig","api.error.order.post.406":"Keine Restaurantkasse gefunden","api.error.order.post.407":"Das Restaurant ist geschlossen","api.error.order.post.408":"Ihr Profil wurde nicht gefunden","api.error.order.post.409":"Ein Fehler in ihrem Profil ist aufgetreten","api.error.order.put.100":"Ein Fehler ist aufgetreten. Diese Bestellung konnte nicht storniert werden. Bitte aktualisieren Sie diese Seite und versuchen Sie es erneut.","api.error.order.put.101":"Ein Fehler ist aufgetreten. Diese Bestellung konnte nicht storniert werden. Bitte aktualisieren Sie diese Seite und versuchen Sie es erneut.","api.error.order.put.103":"Ein Fehler ist aufgetreten. Diese Bestellung konnte nicht storniert werden. Bitte aktualisieren Sie diese Seite und versuchen Sie es erneut.","api.error.order.put.104":"Ein Fehler ist aufgetreten. Diese Bestellung konnte nicht storniert werden. Bitte aktualisieren Sie diese Seite und versuchen Sie es erneut.","api.error.order.put.105":"Diese Bestellung wurde storniert. Sie können nichts mehr verändern.","api.error.order.put.106":"Ein Fehler ist aufgetreten. Diese Bestellung konnte nicht storniert werden. Bitte aktualisieren Sie diese Seite und versuchen Sie es erneut.","api.error.order.put.107":"Die Widerrufsfrist ist abgelaufen. Diese Bestellung kann nicht storniert werden. Bitte zögern Sie nicht uns für Fragen zu kontaktieren.","api.error.order.put.110":"Ein Fehler ist aufgetreten. Diese Bestellung konnte nicht storniert werden. Bitte aktualisieren Sie diese Seite und versuchen Sie es erneut.","api.error.user.credit_card.post.140":"Ein Fehler ist aufgetreten","api.error.user.login.100":"Login oder Passwort nicht korrekt","api.error.user.post.100":"Email wird bereits genutzt","api.error.user.post.101":"Profil unvollständig","api.error.user.post.103":"Bankverbindung kann nicht erstellt werden","api.error.user.post.104":"Facebook Account wird bereits genutzt","api.error.user.post.105":"Sponsor-Code ungültig","api.error.user.post.106":"Geldbörse kann nicht erstellt werden","api.error.user.post.107":"Telefonnummer wird bereits genutzt","api.error.user.post.122":"Bei der Aktualisierung Ihres Profils ist ein Fehler aufgetreten.","api.error.user.put.100":"Email wird bereits genutzt","api.error.user.put.101":"Ungültiges E-Mail-Format","api.error.user.put.103":"Telefonnummer wird bereits genutzt","api.error.user.put.104":"Ungültiges Telefonnummernformat","api.error.user.put.117":"Bei der Passwortverifizierung ist ein Fehler aufgetreten","api.error.user.put.120":"Bei der Aktualisierung Ihres Profils ist ein Fehler aufgetreten.","booking.action.canceled":"Storniert","booking.action.no_show":"Nicht anzeigen","booking.action.not_arrived":"Nicht eingetroffen","booking.action.seated":"Platziert","booking.all":"Alles","booking.brunch":"Brunch","booking.evening":"Abendessen","booking.morning":"Frühstück","booking.noon":"Mittagessen","booking.source.mobile_app":"Mobile app","booking.source.phone":"Telefon","booking.source.restaurant":"Restaurant","booking.source.third":"Dritte","booking.source.website":"Webseite","booking.state.confirmed":"Bestätigt","booking.state.waiting":"Warten","components.crop_image.submit":"Bestätigen","components.crop_image.title":"Bildgröße ändern","components.emails_list.add_email":"Email hinzufügen","components.emails_list.are_you_sure":"Sind sie sicher?","components.fixed_submit_area.cancel":"Änderungen verwerfen","components.fixed_submit_area.save":"Speichern","components.frequency.DAILY":"Täglich","components.image_dropzone.delete":"Löschen des gespeicherten Bildes","components.image_dropzone.edit":"Aktuelles Bild bearbeiten","components.image_dropzone.restore":"Standardbild wiederherstellen","components.numner_input_modal.submit":"Bestätigen","components.phones_list.add_number":"Telefonnummer hinzufügen","components.phones_list.are_you_sure":"Sind sie sicher?","components.pos_chooser.placeholder":"Auswählen","components.search_box.search":"Suche","components.select.add_label_text":" {label} hinzufügen?","components.select.clear_all_text":"Alles löschen","components.select.clear_value_text":"Werte löschen","components.select.no_results_text":"Keine Ergebnisse","components.select.placeholder":"Suche","components.select.search_prompt_text":"Tippe um zu suchen","components.select.searching_text":"Suche läuft ...","components.submit_area.cancel":"Änderungen verwerfen","components.submit_area.save":"Speichern","components.transfer_frequency_chooser.placeholder":"Auswählen","components.vat_chooser.bank.0":"0% - Mehrwertsteuer nicht anwendbar","components.vat_chooser.bank.8":"8.5% - MwSt. France DOM/TOM","components.vat_chooser.bank.20":"20% - MwSt. Metropolitan France","components.vat_chooser.countries.be":"Belgien","components.vat_chooser.countries.de":"Deutschland","components.vat_chooser.countries.fr":"Frankreich","components.vat_chooser.countries.lu":"Luxemburg","components.vat_chooser.placeholder":"Auswählen","global.add":"Hinzufügen","global.add_to_cart":"Zum Warenkorb hinzugefügt","global.are_you_sure":"Sind sie sicher?","global.back":"Zurück","global.cancel":"Abbrechen","global.cgu":"die Nutzungsbedingungen","global.confirm":"Bestätigen","global.days.friday":"Freitag","global.days.monday":"Montag","global.days.saturday":"Samstag","global.days.sunday":"Sonntag","global.days.thursday":"Donnerstag","global.days.tuesday":"Dienstag","global.days.wednesday":"Mittwoch","global.delete":"Löschen","global.email":"Email","global.error":"Fehler","global.i_have_read_and_accept":"Ich habe gelesen und akzeptiere","global.loading":"Lädt","global.max":"Max","global.meters":"Meter","global.min":"Min","global.minutes":"Minuten","global.modify":"Bearbeiten","global.next":"Nächste","global.no":"nein","global.password":"Passwort","global.previous":"Vorherige","global.quit":"Beenden","global.sms":"SMS","global.today":"Heute","global.validate":"Bestätigen","global.validation":"Validierung","global.yes":"Ja","order.at":"bei","order.at_bar":"An der Bar","order.cart_modifiers.target_type.ALL_ITEMS_EXCEPT":"Alle Artikel ausgenommen","order.cart_modifiers.target_type.SHIPPING_COST":"Lieferkosten","order.cart_modifiers.target_type.SPECIFIC_ITEMS":"Artikelliste","order.cart_modifiers.target_type.TOTAL":"Gesamte Bestellung (inkl. Lieferkosten)","order.delivery":"Lieferung","order.on_site":"Im Haus","order.status.canceled":"Storniert","order.status.created":"Erstellt","order.status.delivered":"Ausgeliefert","order.status.in_delivery":"Wird geliefert","order.status.ready":"Bereit","order.status.received":"Akzeptiert","order.status.sent":"Warten","order.take_away":"Zum Mitnehmen","order.tomorrow_at":"Morgen um","payments.method.IRL_PAYMENT":"TPE Kiosk","payments.method.NOT_PRE_PAYED":"Bezahlen am Schalter","payments.method.PAYMENT":"PMT Kreditkarte","payments.method.USER_ACCOUNT":"Benutzerkonto","restaurant.tag.africain":"Afrikanisch","restaurant.tag.algerien":"Algerien","restaurant.tag.allemand":"Deutsch","restaurant.tag.americain":"Amerikanisch","restaurant.tag.amerique_latine":"Lateinamerikanisch","restaurant.tag.anglais":"Englisch","restaurant.tag.apero":"Aperitif","restaurant.tag.argentin":"Argentinisch","restaurant.tag.asiatique":"Asiatisch","restaurant.tag.autrichien":"Österreichisch","restaurant.tag.bagel":"Bagel","restaurant.tag.bar":"Bar","restaurant.tag.bbq":"BBQ","restaurant.tag.belge":"Belgisch","restaurant.tag.bio":"Bio","restaurant.tag.boulettes":"Frikadellen","restaurant.tag.brasserie":"Brasserie","restaurant.tag.bresilien":"Brasilianisch","restaurant.tag.brunch_and_petit_dejeuner":"Brunch & Frühstück","restaurant.tag.bubble_tea":"Bubble Tea","restaurant.tag.burger":"Burger","restaurant.tag.cafétéria":"Cafeteria","restaurant.tag.canadien":"Kanadisch","restaurant.tag.casher":"Koscher","restaurant.tag.ceviche":"Ceviche","restaurant.tag.chilien":"Chilenisch","restaurant.tag.chinois":"Chinesisch","restaurant.tag.cocktail":"Cocktail","restaurant.tag.colombien":"Kolumbianisch","restaurant.tag.coreen":"Koreanisch","restaurant.tag.corse":"Korsisch","restaurant.tag.creole":"Kreolisch","restaurant.tag.croque_monsieur":"Croque","restaurant.tag.cubain":"Kubanisch","restaurant.tag.cuisine_du_marche":"Marktküche","restaurant.tag.dim_sum":"Dim Sum","restaurant.tag.epice":"Scharf","restaurant.tag.espagnol":"Spanisch","restaurant.tag.europe__est":"Osteuropa","restaurant.tag.fish_and_chips":"Fish And Chips","restaurant.tag.francais":"Französisch","restaurant.tag.frozen_yoghurt":"Frozen Yoghurt","restaurant.tag.fruits_de_mer_crustacés":"Frische Marktprodukte & Schalentiere","restaurant.tag.grand_groupe":"Hauptgruppe","restaurant.tag.grec":"Griechisch","restaurant.tag.halal":"Halal","restaurant.tag.healthy":"Gesund","restaurant.tag.homard":"Hummer","restaurant.tag.hot_dog":"Hot Dog","restaurant.tag.indien":"Indisch","restaurant.tag.indonesien":"Indonesisch","restaurant.tag.iranien":"Iranisch","restaurant.tag.italien":"Italienisch","restaurant.tag.japonais":"Japanisch","restaurant.tag.jus_smoothies":"Säfte & Smoothies","restaurant.tag.laotien":"Laotisch","restaurant.tag.libanais":"Libanesisch","restaurant.tag.marocain":"Marokkanisch","restaurant.tag.mediterranéen":"mediterran","restaurant.tag.mexicain":"Mexikanisch","restaurant.tag.moyen_orient":"Nahost","restaurant.tag.oriental":"Orientalisch","restaurant.tag.patisserie":"Konditorei","restaurant.tag.peruvien":"Peruanisch","restaurant.tag.pizza":"Pizza","restaurant.tag.polonais":"Polnisch","restaurant.tag.portugais":"Portugisisch","restaurant.tag.rotisserie":"Grill","restaurant.tag.russe":"Russisch","restaurant.tag.salade":"Salat","restaurant.tag.sandwich":"Sandwich","restaurant.tag.sans_gluten":"Glutenfrei","restaurant.tag.scandinave":"Skandinavisch","restaurant.tag.soupe":"Suppe","restaurant.tag.suisse":"Schweizerisch","restaurant.tag.sushi":"Sushi","restaurant.tag.syrien":"Syrisch","restaurant.tag.tapas":"Tapas","restaurant.tag.tarte_salée":"Salzige Torte","restaurant.tag.terroir":"Regional","restaurant.tag.thailandais":"Thailändisch","restaurant.tag.tibetain":"Tibetanisch","restaurant.tag.tunisien":"Tunesisch","restaurant.tag.turc":"Türkisch","restaurant.tag.vegan":"Vegan","restaurant.tag.veggie":"Veggie","restaurant.tag.venezuelien":"Venezolanisch","restaurant.tag.vietnamien":"Vietnamesisch"}

/***/ }),

/***/ "./sdk/scripts/i18n/locales/en.json":
/***/ (function(module, exports) {

module.exports = {"api_error.no_internet":"No Internet connexion","api.error.address.post.101":"User mismatch","api.error.address.post.102":"Not allowed","api.error.address.post.103":"Unknown address","api.error.address.post.104":"Missing address body","api.error.address.post.105":"Cannot find the address.","api.error.address.put.101":"User mismatch","api.error.address.put.102":"Not allowed","api.error.address.put.103":"Unknown address","api.error.address.put.104":"Missing address body","api.error.address.put.105":"Cannot find the address.","api.error.booking_settings.get.101":"You must create at least one room.","api.error.booking_settings.get.102":"You must add at least one mealtime available for booking.","api.error.booking_settings.get.103":"Capacity must be positive.","api.error.booking_settings.get.105":"The minimum delay for an immediate booking must be positive.","api.error.booking_settings.get.106":"Booking slots can not be opened in the past.","api.error.booking_settings.get.107":"Invalid phone number.","api.error.booking_settings.get.108":"Invalid Email address.","api.error.booking_settings.get.112":"The maximum guests number for automatic validation is invalid.","api.error.booking_settings.get.115":"An opening time slot is invalid","api.error.booking_settings.get.117":"There are twice the specific parameters on a time range","api.error.booking_settings.get.118":"Invalid capacity.","api.error.booking_settings.get.121":"Opening time slots must be bigger than one hour.","api.error.booking_settings.get.122":"The room capacity is bigger than the maximum capacity of the restaurant.","api.error.booking_settings.get.123":"The rooms capacity is bigger than the maximum capacity of the restaurant.","api.error.booking_settings.get.127":"The capacity parameter of a room is missing.","api.error.booking_settings.get.128":"The time gap of the specific parameter is invalid.","api.error.booking_settings.get.129":"The capacity is invalid for a specific parameter","api.error.booking_settings.get.131":"The guests number is invalid","api.error.booking_settings.get.132":"The phone number of the commercial department is invalid","api.error.booking_settings.get.133":"The Email address of the commercial department is invalid","api.error.booking.get_booking_slots.200":"Booking are closed on the selected date","api.error.booking.get_booking_slots.201":"Selected date is invalid (in the past)","api.error.booking.post_booking.202":"Guests number must be positive","api.error.booking.post_booking.203":"Invalid booking settings","api.error.booking.post_booking.204":"Booking date is too far in the future.","api.error.booking.post_booking.205":"Booking date is too close from now.","api.error.booking.post_booking.206":"Booking date is in the past.","api.error.booking.post_booking.210":"A booking has already been made by the user at this mealtime.","api.error.booking.post_booking.211":"There is no available slot at this date.","api.error.booking.post_booking.212":"There is no available slot at this date.","api.error.booking.post_booking.213":"There is not enough seats available at this time slot for the selected room","api.error.booking.post_booking.214":"There is not enough seats available at this time slot","api.error.booking.post_booking.215":"Missing last name","api.error.booking.post_booking.216":"Missing first name","api.error.booking.post_booking.218":"You must enter an email address and/or a mobile phone number","api.error.booking.post_booking.219":"Invalid Email","api.error.booking.post_booking.220":"Invalid mobile phone number","api.error.booking.post_booking.221":"The number of guests is too high. Please contact the commercial department","api.error.menu.get.103":"The cash register is incompatible.","api.error.menu.get.104":"Cannot retrieve the menu from the cash register.","api.error.menu.get.105":"The cash register is incompatible. Cannot retrieve the menu","api.error.menu.get.401":"Cannot retrieve the menu from the cash register. Please try again. If the problem still shows up, check that your cash register is properly connected.","api.error.order.post.101":"The user is not authorized to order","api.error.order.post.102":"Missing address","api.error.order.post.103":"Cannot find the address","api.error.order.post.104":"The address is not geolocated","api.error.order.post.106":"You must verify your phone number to use the credit","api.error.order.post.107":"The card cannot be used with this currency. Please add a new card.","api.error.order.post.109":"Cannot find the card","api.error.order.post.110":"Restaurant not found","api.error.order.post.112":"You do not have enough credit","api.error.order.post.114":"The credit is higher than the total price","api.error.order.post.115":"The total is too low to process the payment","api.error.order.post.117":"You can only use euro currency credit","api.error.order.post.118":"Error from the restaurant cash register","api.error.order.post.119":"The payment failed too many times in the past 5 minutes. Please try again later.","api.error.order.post.121":"Communication with your bank impossible","api.error.order.post.124":"An error occurred… Please contact us if the error still shows up.","api.error.order.post.125":"An error has occurred during the payment process. Please try again.","api.error.order.post.126":"Your bank declined the payment. Please contact your bank.","api.error.order.post.127":"Your bank declined the payment: maximum reached. Please contact your bank.","api.error.order.post.128":"Your bank declined the payment. Please contact your bank.","api.error.order.post.129":"Your bank declined the payment: maximum reached. Please contact your bank.","api.error.order.post.130":"Your card expired","api.error.order.post.131":"Your card is inactive","api.error.order.post.132":"Your card is inactive","api.error.order.post.133":"Maximum number of attempts reached. Please contact your bank.","api.error.order.post.134":"Your bank declined the payment: maximum reached. Please contact your bank.","api.error.order.post.135":"Your bank declined the payment: maximum reached. Please contact your bank.","api.error.order.post.136":"Your bank declined the payment: maximum reached. Please contact your bank.","api.error.order.post.137":"Your bank declined the payment. Please contact your bank.","api.error.order.post.141":"Error from the restaurant cash register","api.error.order.post.142":"Some items in your basket do not match the restaurant menu. Please refresh the restaurant menu.","api.error.order.post.401":"Error from the restaurant cash register","api.error.order.post.402":"The table does not exist. Please change it.","api.error.order.post.405":"One or several items are now out of stock","api.error.order.post.406":"The restaurant cash register could not be found","api.error.order.post.407":"The restaurant is closed","api.error.order.post.408":"Your profile has not been found","api.error.order.post.409":"An error has occurred in your profile","api.error.order.put.100":"An error occurred. This order couldn’t be cancelled. Please refresh this page and try again.","api.error.order.put.101":"An error occurred. This order couldn’t be cancelled. Please refresh this page and try again.","api.error.order.put.103":"An error occurred. This order couldn’t be cancelled. Please refresh this page and try again.","api.error.order.put.104":"An error occurred. This order couldn’t be cancelled. Please refresh this page and try again.","api.error.order.put.105":"This order has been cancelled. You can't make any action on it.","api.error.order.put.106":"An error occurred. This order couldn’t be cancelled. Please refresh this page and try again.","api.error.order.put.107":"The cancellation delay is over. This order cannot be canceled. Please feel free to contact us for any question.","api.error.order.put.110":"An error occurred. This order couldn’t be cancelled. Please refresh this page and try again.","api.error.user.credit_card.post.140":"An error has occurred","api.error.user.login.100":"Incorrect login or password","api.error.user.post.100":"Email already used","api.error.user.post.101":"Incomplete profile","api.error.user.post.103":"Cannot create the bank account","api.error.user.post.104":"Facebook account already used","api.error.user.post.105":"Invalid sponsor code","api.error.user.post.106":"Cannot create the wallet","api.error.user.post.107":"Phone number already used","api.error.user.post.122":"An error occured during your profile's update","api.error.user.put.100":"Email already used","api.error.user.put.101":"Invalid email format","api.error.user.put.103":"Phone number already used","api.error.user.put.104":"Invalid phone number format","api.error.user.put.117":"An error occurred during password verification","api.error.user.put.120":"An error occurred during your profile update","booking.action.canceled":"Canceled","booking.action.no_show":"No show","booking.action.not_arrived":"Not arrived","booking.action.seated":"Seated","booking.all":"All","booking.brunch":"Brunch","booking.evening":"Diner","booking.morning":"Breakfast","booking.noon":"Lunch","booking.source.mobile_app":"Mobile app","booking.source.phone":"Phone","booking.source.restaurant":"Restaurant","booking.source.third":"Third","booking.source.website":"Website","booking.state.confirmed":"Confirmed","booking.state.waiting":"Waiting","components.crop_image.submit":"Validate","components.crop_image.title":"Resize picture","components.emails_list.add_email":"Add an email","components.emails_list.are_you_sure":"Are you sure?","components.fixed_submit_area.cancel":"Cancel changes","components.fixed_submit_area.save":"Save","components.frequency.DISABLED":"Disabled","components.frequency.DAILY":"Daily","components.image_dropzone.delete":"Delete saved picture","components.image_dropzone.edit":"Edit current picture","components.image_dropzone.restore":"Restore default picture","components.numner_input_modal.submit":"Validate","components.phones_list.add_number":"Add a phone number","components.phones_list.are_you_sure":"Are you sure?","components.pos_chooser.placeholder":"Select","components.search_box.search":"Search","components.select.add_label_text":"Add {label}?","components.select.clear_all_text":"Clear all","components.select.clear_value_text":"Clear value","components.select.no_results_text":"No result","components.select.placeholder":"Search","components.select.search_prompt_text":"Type to search","components.select.searching_text":"Search in progress…","components.submit_area.cancel":"Cancel changes","components.submit_area.save":"Save","components.transfer_frequency_chooser.placeholder":"Select","components.vat_chooser.bank.0":"0% - VAT not applicable","components.vat_chooser.bank.8":"8.5% - VAT France DOM/TOM","components.vat_chooser.bank.20":"20% - VAT Metropolitan France","components.vat_chooser.countries.be":"Belgium","components.vat_chooser.countries.de":"Germany","components.vat_chooser.countries.fr":"France","components.vat_chooser.countries.lu":"Luxembourg","components.vat_chooser.placeholder":"Select","global.add":"Add","global.add_to_cart":"Added to cart","global.are_you_sure":"Are you sure?","global.back":"Back","global.cancel":"Cancel","global.cgu":"the use terms","global.confirm":"Confirm","global.days.friday":"friday","global.days.monday":"monday","global.days.saturday":"saturday","global.days.sunday":"sunday","global.days.thursday":"thursday","global.days.tuesday":"tuesday","global.days.wednesday":"wednesday","global.delete":"Delete","global.email":"Email","global.error":"Error","global.i_have_read_and_accept":"I have read and accept","global.loading":"Loading","global.max":"Max","global.meters":"meters","global.min":"Min","global.minutes":"minutes","global.modify":"Modify","global.next":"Next","global.no":"no","global.password":"Password","global.previous":"Previous","global.quit":"Quit","global.sms":"SMS","global.today":"Today","global.validate":"Validate","global.validation":"Validation","global.yes":"yes","order.at":"at","order.at_bar":"At bar","order.cart_modifiers.target_type.ALL_ITEMS_EXCEPT":"All items excluding","order.cart_modifiers.target_type.SHIPPING_COST":"Delivery fee","order.cart_modifiers.target_type.SPECIFIC_ITEMS":"Item list","order.cart_modifiers.target_type.TOTAL":"Total order (inc. delivery fee)","order.delivery":"Delivery","order.on_site":"On site","order.status.canceled":"Canceled","order.status.created":"Creted","order.status.delivered":"Delivered","order.status.in_delivery":"In delivery","order.status.ready":"Ready","order.status.received":"Accepted","order.status.sent":"Waiting","order.take_away":"Take away","order.tomorrow_at":"Tomorrow at","payments.method.IRL_PAYMENT":"TPE Kiosk","payments.method.NOT_PRE_PAYED":"Payment at the counter","payments.method.PAYMENT":"PMT Credit card","payments.method.USER_ACCOUNT":"User account","restaurant.tag.africain":"African","restaurant.tag.algerien":"Algerian","restaurant.tag.allemand":"German","restaurant.tag.americain":"American","restaurant.tag.amerique_latine":"South America","restaurant.tag.anglais":"English","restaurant.tag.apero":"Aperitif","restaurant.tag.argentin":"Argentinian","restaurant.tag.asiatique":"Asian","restaurant.tag.autrichien":"Austrian","restaurant.tag.bagel":"Bagel","restaurant.tag.bar":"Bar","restaurant.tag.bbq":"BBQ","restaurant.tag.belge":"Belgian","restaurant.tag.bio":"Organic","restaurant.tag.boulettes":"Meatballs","restaurant.tag.brasserie":"Brasserie","restaurant.tag.bresilien":"Brazilian","restaurant.tag.brunch_and_petit_dejeuner":"Brunch & Breakfast","restaurant.tag.bubble_tea":"Bubble Tea","restaurant.tag.burger":"Burger","restaurant.tag.cafétéria":"Cafeteria","restaurant.tag.canadien":"Canadian","restaurant.tag.casher":"Kosher","restaurant.tag.ceviche":"Ceviche","restaurant.tag.chilien":"Chilean","restaurant.tag.chinois":"Chinese","restaurant.tag.cocktail":"Cocktail","restaurant.tag.colombien":"Colombian","restaurant.tag.coreen":"Korean","restaurant.tag.corse":"Corsican","restaurant.tag.creole":"Creole","restaurant.tag.croque_monsieur":"Croque-monsieur","restaurant.tag.cubain":"Cuban","restaurant.tag.cuisine_du_marche":"Fresh market","restaurant.tag.dim_sum":"Dim Sum","restaurant.tag.epice":"Spicy","restaurant.tag.espagnol":"Spanish","restaurant.tag.europe__est":"Eastern Europe","restaurant.tag.fish_and_chips":"Fish And Chips","restaurant.tag.francais":"French","restaurant.tag.frozen_yoghurt":"Frozen Yoghurt","restaurant.tag.fruits_de_mer_crustacés":"Fresh market produce & shellfish","restaurant.tag.grand_groupe":"Large company","restaurant.tag.grec":"Greek","restaurant.tag.halal":"Halal","restaurant.tag.healthy":"Healthy","restaurant.tag.homard":"Lobster","restaurant.tag.hot_dog":"Hot-Dog","restaurant.tag.indien":"Indian","restaurant.tag.indonesien":"Indonesian","restaurant.tag.iranien":"Iranian","restaurant.tag.italien":"Italian","restaurant.tag.japonais":"Japonese","restaurant.tag.jus_smoothies":"Juces & Smoothies","restaurant.tag.laotien":"Laotian","restaurant.tag.libanais":"Lebanese","restaurant.tag.marocain":"Moroccan","restaurant.tag.mediterranéen":"Méditerranean","restaurant.tag.mexicain":"Mexican","restaurant.tag.moyen_orient":"Middle East","restaurant.tag.oriental":"Oriental","restaurant.tag.patisserie":"Patisserie","restaurant.tag.peruvien":"Peruvian","restaurant.tag.pizza":"Pizza","restaurant.tag.polonais":"Polish","restaurant.tag.portugais":"Portuguese","restaurant.tag.rotisserie":"Grill","restaurant.tag.russe":"Russian","restaurant.tag.salade":"Salad","restaurant.tag.sandwich":"Sandwich","restaurant.tag.sans_gluten":"Gluten free","restaurant.tag.scandinave":"Scandinavian","restaurant.tag.soupe":"Soup","restaurant.tag.suisse":"Swiss","restaurant.tag.sushi":"Sushi","restaurant.tag.syrien":"Syrian","restaurant.tag.tapas":"Tapas","restaurant.tag.tarte_salée":"Salty tart","restaurant.tag.terroir":"Regional cooking","restaurant.tag.thailandais":"Thai","restaurant.tag.tibetain":"Tibetan","restaurant.tag.tunisien":"Tunisian","restaurant.tag.turc":"Turkish","restaurant.tag.vegan":"Vegan","restaurant.tag.veggie":"Veggie","restaurant.tag.venezuelien":"Venezuelan","restaurant.tag.vietnamien":"Vietnamese"}

/***/ }),

/***/ "./sdk/scripts/i18n/locales/fr.json":
/***/ (function(module, exports) {

module.exports = {"api_error.no_internet":"Pas de connexion internet","api.error.address.post.101":"User mismatch","api.error.address.post.102":"Not allowed","api.error.address.post.103":"Adresse inconnue","api.error.address.post.104":"Missing address body","api.error.address.post.105":"L'adresse n'a pas pu être retrouvée.","api.error.address.put.101":"User mismatch","api.error.address.put.102":"Not allowed","api.error.address.put.103":"Adresse inconnue","api.error.address.put.104":"Missing address body","api.error.address.put.105":"L'adresse n'a pas pu être retrouvée.","api.error.booking_settings.get.101":"Vous devez créer au moins une salle.","api.error.booking_settings.get.102":"Vous devez ajouter au moins un repas disponible à la réservation.","api.error.booking_settings.get.103":"La capacité doit-être positive.","api.error.booking_settings.get.105":"Le délai minimum pour réservation immédiate doit être positif.","api.error.booking_settings.get.106":"Les réservations ne peuvent être ouvertes dans le passé.","api.error.booking_settings.get.107":"Le numéro de téléphone est invalide.","api.error.booking_settings.get.108":"L'adresse email est invalide.","api.error.booking_settings.get.112":"Le nombre de couvert maximum pour validation automatique est invalide.","api.error.booking_settings.get.115":"Une heure d'ouverture est invalide","api.error.booking_settings.get.117":"Il y a deux fois les mêmes paramètres spécifiques à jour d'une période","api.error.booking_settings.get.118":"Capacité invalide.","api.error.booking_settings.get.121":"Les heures d'ouverture doivent être supérieurs à une heure.","api.error.booking_settings.get.122":"La capacité de la pièce est plus grande que la capacité maximum du restaurant.","api.error.booking_settings.get.123":"La capacité des pièces est plus grande que la capacité maximum du restaurant.","api.error.booking_settings.get.127":"Il manque la paramètre de capacité d'une pièce.","api.error.booking_settings.get.128":"L'interval de temps du spécifique est invalide.","api.error.booking_settings.get.129":"La capacité est invalide pour un spécifique","api.error.booking_settings.get.131":"Le nombre maximum d'invité est invalid","api.error.booking_settings.get.132":"Le numéro de téléphone de contact du service commercial est invalide","api.error.booking_settings.get.133":"L'email de contact du service commercial est invalide","api.error.booking.get_booking_slots.200":"Les réservations sont fermées à cette date","api.error.booking.get_booking_slots.201":"La date donnée est invalide (dans le passé)","api.error.booking.post_booking.202":"Le nombre d'invités doit être positif","api.error.booking.post_booking.203":"Invalid booking settings","api.error.booking.post_booking.204":"La date de la réservation est trop dans le futur.","api.error.booking.post_booking.205":"La date de réservation est trop proche.","api.error.booking.post_booking.206":"La date du booking est dans le passé","api.error.booking.post_booking.210":"Une réservation à déja été faite par l'utilisateur pour ce repas","api.error.booking.post_booking.211":"Il n'y a pas d'horaires disponibles pour cette date.","api.error.booking.post_booking.212":"Il n'y a pas d'horaires disponibles pour cette date.","api.error.booking.post_booking.213":"Il n'y a pas assez de places disponibles à cet horaire pour la salle sélectionée","api.error.booking.post_booking.214":"Il n'y a pas assez de places disponibles à cet horaire","api.error.booking.post_booking.215":"Nom manquant","api.error.booking.post_booking.216":"Prénom manquant","api.error.booking.post_booking.218":"Vous devez entrer un email et/ou un numéro de mobile","api.error.booking.post_booking.219":"Email invalide","api.error.booking.post_booking.220":"Numéro de mobile invalide","api.error.booking.post_booking.221":"Le nombre d'invités est trop élevé. Veuillez prendre contact avec le service commercial","api.error.menu.get.103":"La caisse est incompatible.","api.error.menu.get.104":"Impossible de récupérer la carte depuis la caisse.","api.error.menu.get.105":"La caisse est incompatible. Impossible de récupérer la carte","api.error.menu.get.401":"Impossible de récupérer la carte sur la caisse. Veuillez réessayer. Si le problème persiste, verifiez que votre caisse est bien connectée.","api.error.order.post.101":"Lutilisateur n'est pas autorisé a commander","api.error.order.post.102":"Adresse manquante","api.error.order.post.103":"L'adresse est introuvable","api.error.order.post.104":"L'adresse n'est pas géolocalisée","api.error.order.post.106":"Vous devez vérifier votre numéro pour utiliser du crédit","api.error.order.post.107":"La carte ne peut pas être utilisée pour cette devise. Merci d'ajouter une nouvelle carte.","api.error.order.post.109":"La carte est introuvable","api.error.order.post.110":"Le restaurant n'a pas été trouvé","api.error.order.post.112":"Vous n'avez pas assez de crédit","api.error.order.post.114":"Le crédit est supérieur au prix total","api.error.order.post.115":"Le total est trop faible pour être payé","api.error.order.post.117":"Vous pouvez seulement utiliser du crédit en euros","api.error.order.post.118":"Erreur de la caisse du restaurant","api.error.order.post.119":"Le paiement a échoué trop de fois dans les dernières 5 minutes. Veuillez rééssayer plus tard.","api.error.order.post.121":"Impossible de communiquer avec votre banque","api.error.order.post.124":"Une erreur est survenue… Contactez nous si l'erreur persiste.","api.error.order.post.125":"Erreur lors du paiement. Veuillez rééssayer.","api.error.order.post.126":"Votre banque a refusé le paiement. Merci de la contacter.","api.error.order.post.127":"Votre banque a refusé le paiement : maximum atteint. Merci de la contacter.","api.error.order.post.128":"Votre banque a refusé le paiement. Merci de la contacter.","api.error.order.post.129":"Votre banque a refusé le paiement : maximum atteint. Merci de la contacter.","api.error.order.post.130":"Votre carte a expiré","api.error.order.post.131":"Votre carte n'est pas active","api.error.order.post.132":"Votre carte n'est pas active","api.error.order.post.133":"Nombre d'essais maximum atteint. Merci de contacter votre banque.","api.error.order.post.134":"Votre banque a refusé le paiement : maximum atteint. Merci de la contacter.","api.error.order.post.135":"Votre banque a refusé le paiement : maximum atteint. Merci de la contacter.","api.error.order.post.136":"Votre banque a refusé le paiement : maximum atteint. Merci de la contacter.","api.error.order.post.137":"Votre banque a refusé le paiement. Merci de la contacter.","api.error.order.post.141":"Erreur de la caisse du restaurant","api.error.order.post.142":"Des produits dans votre panier ne correspondent pas au menu du restaurant. Veuillez recharger le menu du restaurant.","api.error.order.post.401":"Erreur de la caisse du restaurant","api.error.order.post.402":"La table n'existe pas. Merci de la changer.","api.error.order.post.405":"Un ou plusieurs produits ne sont plus en stock désormais","api.error.order.post.406":"La caisse du restaurant n'a pas pu être trouvée","api.error.order.post.407":"Le restaurant est fermé","api.error.order.post.408":"Votre profile n'a pas été trouvé","api.error.order.post.409":"Un problème est survenu dans votre profil","api.error.order.put.100":"Une erreur est survenue, nous n’avons pas pu annuler cette commande. Merci de rafraichir la page et de réessayer.","api.error.order.put.101":"Une erreur est survenue, nous n’avons pas pu annuler cette commande. Merci de rafraichir la page et de réessayer.","api.error.order.put.103":"Une erreur est survenue, nous n’avons pas pu annuler cette commande. Merci de rafraichir la page et de réessayer.","api.error.order.put.104":"Une erreur est survenue, nous n’avons pas pu annuler cette commande. Merci de rafraichir la page et de réessayer.","api.error.order.put.105":"Cette commande a été annulée. Vous ne pouvez plus effectuer d'autres actions.","api.error.order.put.106":"Une erreur est survenue, nous n’avons pas pu annuler cette commande. Merci de rafraichir la page et de réessayer.","api.error.order.put.107":"Le délai d’annulation de cette commande est dépassé. Elle ne peut plus être annulée. Pour toute question, n’hésitez pas à nous contacter.","api.error.order.put.110":"Une erreur est survenue, nous n’avons pas pu annuler cette commande. Merci de rafraichir la page et de réessayer.","api.error.user.credit_card.post.140":"Une erreur est survenue","api.error.user.login.100":"Identifiant ou mot de passe incorrect","api.error.user.post.100":"Email déja utilisé","api.error.user.post.101":"Profil incomplet","api.error.user.post.103":"Impossible de créer le compte bancaire","api.error.user.post.104":"Compte Facebook déja utilisé","api.error.user.post.105":"Code sponsor invalide","api.error.user.post.106":"Impossible de créer le wallet","api.error.user.post.107":"Téléphone déja utilisé","api.error.user.post.122":"Une erreur est survenue lors de la mise à jour de votre profil","api.error.user.put.100":"Email déja utilisé","api.error.user.put.101":"Format d'email invalide","api.error.user.put.103":"Téléphone déja utilisé","api.error.user.put.104":"Format du numéro de téléphone invalide","api.error.user.put.117":"Erreur lors de la vérification du mot de passe","api.error.user.put.120":"Une erreur est survenue lors de la mise à jour de votre profil","booking.action.canceled":"Annulé","booking.action.no_show":"Pas venu","booking.action.not_arrived":"Pas arrivé","booking.action.seated":"Placé","booking.all":"Tous","booking.brunch":"Brunch","booking.evening":"Diner","booking.morning":"Petit déjeuner","booking.noon":"Déjeuner","booking.source.mobile_app":"App mobile","booking.source.phone":"Téléphone","booking.source.restaurant":"Restaurant","booking.source.third":"Tierce","booking.source.website":"Site internet","booking.state.confirmed":"Confirmée","booking.state.waiting":"En attente","components.crop_image.submit":"Valider","components.crop_image.title":"Redimensionner l'image","components.emails_list.add_email":"Ajouter un email","components.emails_list.are_you_sure":"Êtes-vous sûr ?","components.fixed_submit_area.cancel":"Annuler les changements","components.fixed_submit_area.save":"Sauvegarder","components.frequency.DISABLED":"Désactivé","components.frequency.DAILY":"Journalier","components.image_dropzone.delete":"Effacer l'image sauvegardée","components.image_dropzone.edit":"Editer l'image actuelle","components.image_dropzone.restore":"Restaurer l'image par défaut","components.numner_input_modal.submit":"Valider","components.phones_list.add_number":"Ajouter un numéro","components.phones_list.are_you_sure":"Êtes-vous sûr ?","components.pos_chooser.placeholder":"Choisir","components.search_box.search":"Rechercher","components.select.add_label_text":"Ajouter {label} ?","components.select.clear_all_text":"Tout effacer","components.select.clear_value_text":"Supprimer la valeur","components.select.no_results_text":"Pas de résultats","components.select.placeholder":"Rechercher","components.select.search_prompt_text":"Tapez pour rechercher","components.select.searching_text":"Recherche en cours...","components.submit_area.cancel":"Annuler les changements","components.submit_area.save":"Sauvegarder","components.transfer_frequency_chooser.placeholder":"Choisir","components.vat_chooser.bank.0":"0% - TVA non applicable","components.vat_chooser.bank.8":"8.5% - TVA France DOM/TOM","components.vat_chooser.bank.20":"20% - TVA France métropole","components.vat_chooser.countries.be":"Belgique","components.vat_chooser.countries.de":"Allemagne","components.vat_chooser.countries.fr":"France","components.vat_chooser.countries.lu":"Luxembourg","components.vat_chooser.placeholder":"Choisir","global.add":"Ajouter","global.add_to_cart":"Ajouté au panier","global.are_you_sure":"Êtes-vous sûr ?","global.back":"Retour","global.cancel":"Annuler","global.cgu":"les conditions générales d'utilisation","global.confirm":"Confirmer","global.days.friday":"vendredi","global.days.monday":"lundi","global.days.saturday":"samedi","global.days.sunday":"dimanche","global.days.thursday":"jeudi","global.days.tuesday":"mardi","global.days.wednesday":"mercredi","global.delete":"Supprimer","global.email":"Email","global.error":"Erreur","global.i_have_read_and_accept":"J'ai lu et j'accepte","global.loading":"Chargement","global.max":"Max","global.meters":"mètres","global.min":"Min","global.minutes":"minutes","global.modify":"Modifier","global.next":"Suivant","global.no":"non","global.password":"Mot de passe","global.previous":"Précédent","global.quit":"Quitter","global.sms":"SMS","global.today":"Aujourd'hui","global.validate":"Valider","global.validation":"Validation","global.yes":"oui","order.at":"à","order.at_bar":"Au bar","order.cart_modifiers.target_type.ALL_ITEMS_EXCEPT":"Tous les articles sauf","order.cart_modifiers.target_type.SHIPPING_COST":"Frais de livraison","order.cart_modifiers.target_type.SPECIFIC_ITEMS":"Liste d'articles","order.cart_modifiers.target_type.TOTAL":"Total de la commande, frais de livraison inclus","order.delivery":"Livraison","order.on_site":"Sur place","order.status.canceled":"Annulée","order.status.created":"Créée","order.status.delivered":"Récupérée","order.status.in_delivery":"En livraison","order.status.ready":"Prête","order.status.received":"Acceptée","order.status.sent":"En attente","order.take_away":"À emporter","order.tomorrow_at":"Demain à","payments.method.IRL_PAYMENT":"TPE Borne","payments.method.NOT_PRE_PAYED":"Paiment au comptoir","payments.method.PAYMENT":"PMT CB","payments.method.USER_ACCOUNT":"Compte client","restaurant.tag.africain":"Africain","restaurant.tag.algerien":"Algérien","restaurant.tag.allemand":"Allemand","restaurant.tag.americain":"Américain","restaurant.tag.amerique_latine":"Amérique Latine","restaurant.tag.anglais":"Anglais","restaurant.tag.apero":"Apéro","restaurant.tag.argentin":"Argentin","restaurant.tag.asiatique":"Asiatique","restaurant.tag.autrichien":"Autrichien","restaurant.tag.bagel":"Bagel","restaurant.tag.bar":"Bar","restaurant.tag.bbq":"BBQ","restaurant.tag.belge":"Belge","restaurant.tag.bio":"Bio","restaurant.tag.boulettes":"Boulettes","restaurant.tag.brasserie":"Brasserie","restaurant.tag.bresilien":"Brésilien","restaurant.tag.brunch_and_petit_dejeuner":"Brunch & Petit-déjeuner","restaurant.tag.bubble_tea":"Bubble Tea","restaurant.tag.burger":"Burger","restaurant.tag.cafétéria":"Cafétéria","restaurant.tag.canadien":"Canadien","restaurant.tag.casher":"Casher","restaurant.tag.ceviche":"Ceviche","restaurant.tag.chilien":"Chilien","restaurant.tag.chinois":"Chinois","restaurant.tag.cocktail":"Cocktail","restaurant.tag.colombien":"Colombien","restaurant.tag.coreen":"Coréen","restaurant.tag.corse":"Corse","restaurant.tag.creole":"Créole","restaurant.tag.croque_monsieur":"Croque-monsieur","restaurant.tag.cubain":"Cubain","restaurant.tag.cuisine_du_marche":"Cuisine Du Marché","restaurant.tag.dim_sum":"Dim Sum","restaurant.tag.epice":"Epicé","restaurant.tag.espagnol":"Espagnol","restaurant.tag.europe__est":"Europe De L'est","restaurant.tag.fish_and_chips":"Fish And Chips","restaurant.tag.francais":"Français","restaurant.tag.frozen_yoghurt":"Frozen Yoghurt","restaurant.tag.fruits_de_mer_crustacés":"Fruits De Mer & Crustacés","restaurant.tag.grand_groupe":"Grand groupe","restaurant.tag.grec":"Grec","restaurant.tag.halal":"Halal","restaurant.tag.healthy":"Healthy","restaurant.tag.homard":"Homard","restaurant.tag.hot_dog":"Hot Dog","restaurant.tag.indien":"Indien","restaurant.tag.indonesien":"Indonésien","restaurant.tag.iranien":"Iranien","restaurant.tag.italien":"Italien","restaurant.tag.japonais":"Japonais","restaurant.tag.jus_smoothies":"Jus & Smoothies","restaurant.tag.laotien":"Laotien","restaurant.tag.libanais":"Libanais","restaurant.tag.marocain":"Marocain","restaurant.tag.mediterranéen":"Méditerranéen","restaurant.tag.mexicain":"Mexicain","restaurant.tag.moyen_orient":"Moyen-orient","restaurant.tag.oriental":"Oriental","restaurant.tag.patisserie":"Pâtisserie","restaurant.tag.peruvien":"Péruvien","restaurant.tag.pizza":"Pizza","restaurant.tag.polonais":"Polonais","restaurant.tag.portugais":"Portugais","restaurant.tag.rotisserie":"Rôtisserie","restaurant.tag.russe":"Russe","restaurant.tag.salade":"Salade","restaurant.tag.sandwich":"Sandwich","restaurant.tag.sans_gluten":"Sans Gluten","restaurant.tag.scandinave":"Scandinave","restaurant.tag.soupe":"Soupe","restaurant.tag.suisse":"Suisse","restaurant.tag.sushi":"Sushi","restaurant.tag.syrien":"Syrien","restaurant.tag.tapas":"Tapas","restaurant.tag.tarte_salée":"Tarte Salée","restaurant.tag.terroir":"Terroir","restaurant.tag.thailandais":"Thailandais","restaurant.tag.tibetain":"Tibétain","restaurant.tag.tunisien":"Tunisien","restaurant.tag.turc":"Turc","restaurant.tag.vegan":"Vegan","restaurant.tag.veggie":"Veggie","restaurant.tag.venezuelien":"Vénézuélien","restaurant.tag.vietnamien":"Vietnamien","security.hibp.pwned.checking":"Vérification de la sécurité du mot de passe en cours...","security.hibp.pwned.is_secure":"Ce mot de passe est sécurisé"}

/***/ }),

/***/ "./sdk/scripts/utils/ApiErrorUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiErrorUtils = function () {
  function ApiErrorUtils() {
    _classCallCheck(this, ApiErrorUtils);
  }

  _createClass(ApiErrorUtils, null, [{
    key: 'getGenericErrors',


    /**
     * Define the Generic errors of the API (cf GenericApiErrors file on the API).
     */
    value: function getGenericErrors() {
      // TODO: I18n
      return {
        '1001': 'invalid cursors', // should not happen

        '1002': 'Le code d\'élévation est invalide'
      };
    }

    /**
     * @private
     *
     * @param apiError
     * @param errors
     * @param label
     */

  }, {
    key: 'findErrorOnArray',
    value: function findErrorOnArray(apiError, errors, label) {
      var message = errors[apiError.code];
      if (!_lodash2.default.isUndefined(message)) {
        return message;
      }

      var genericMessage = ApiErrorUtils.getGenericErrors()[apiError.code];
      if (!_lodash2.default.isUndefined(genericMessage)) {
        return genericMessage;
      }

      _Logger2.default.notImplemented(label + ' Unknown api error', apiError);

      var codeMsg = !_lodash2.default.isNil(apiError.code) ? '[' + apiError.code + ']' : '';
      var messageMsg = !_lodash2.default.isNil(apiError.message) ? '' + apiError.message : '';

      // TODO: I18n.
      return 'Erreur inconnue: ' + codeMsg + ' ' + messageMsg;
    }
  }]);

  return ApiErrorUtils;
}();

exports.default = ApiErrorUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/ArrayUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArrayUtils = function () {
  function ArrayUtils() {
    _classCallCheck(this, ArrayUtils);
  }

  _createClass(ArrayUtils, null, [{
    key: 'moveOnArray',
    value: function moveOnArray(array, fromIndex, toIndex) {
      array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
      return array;
    }
  }, {
    key: 'moveUpObjectOnArray',
    value: function moveUpObjectOnArray(array, object, comparator) {
      var fromIndex = _lodash2.default.findIndex(array, comparator);

      var size = array.length;
      var toIndex = fromIndex - 1 >= 0 ? fromIndex - 1 : size - 1;
      return ArrayUtils.moveOnArray(array, fromIndex, toIndex);
    }
  }, {
    key: 'moveDownObjectOnArray',
    value: function moveDownObjectOnArray(array, object, comparator) {
      var fromIndex = _lodash2.default.findIndex(array, comparator);

      var size = array.length;
      var toIndex = fromIndex + 1 < size ? fromIndex + 1 : 0;
      return ArrayUtils.moveOnArray(array, fromIndex, toIndex);
    }
  }, {
    key: 'exists',
    value: function exists(array, comparator) {
      var match = _lodash2.default.find(array, comparator);

      return !_lodash2.default.isUndefined(match);
    }
  }, {
    key: 'find',
    value: function find(array, comparator) {
      var match = _lodash2.default.find(array, comparator);

      return _lodash2.default.isUndefined(match) ? null : match;
    }
  }, {
    key: 'findIndex',
    value: function findIndex(array, comparator) {
      var index = _lodash2.default.findIndex(array, comparator);

      return index;
    }

    /**
     * Update an object on the given array. If the object is not found, we add it to the array.
     *
     * @param array: The array where update the object
     * @param obj: The object to update
     * @param comparator: Can be a string that represent the key to compare, or a function.
     * see http://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
     */

  }, {
    key: 'updateObjectOrAdd',
    value: function updateObjectOrAdd(array, obj, comparator) {
      var match = _lodash2.default.find(array, comparator);

      if (match) {
        // Find item index using indexOf+find
        var index = _lodash2.default.indexOf(array, match);

        // Replace item at index using native splice
        array.splice(index, 1, obj);
      } else {
        array.push(obj);
      }

      return array;
    }

    /**
     * Update an object on the given array if found on the array.
     *
     * @param array: The array where update the object
     * @param obj: The object to update
     * @param comparator: Can be a string that represent the key to compare, or a function.
     * see http://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
     */

  }, {
    key: 'updateObject',
    value: function updateObject(array, obj, comparator) {
      var match = _lodash2.default.find(array, comparator);

      if (match) {
        // Find item index using indexOf+find
        var index = _lodash2.default.indexOf(array, match);

        // Replace item at index using native splice
        array.splice(index, 1, obj);
      }

      return array;
    }

    /**
     * Remove an object on the given array if found on the array.
     *
     * @param array: The array where remove the object
     * @param obj: The object to remove
     * @param comparator: Can be a string that represent the key to compare, or a function.
     * see http://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
     */

  }, {
    key: 'removeObject',
    value: function removeObject(array, comparator) {
      var match = _lodash2.default.find(array, comparator);

      if (match) {
        // Find item index using indexOf+find
        var index = _lodash2.default.indexOf(array, match);

        // Replace item at index using native splice
        array.splice(index, 1);
      }

      return array;
    }
  }, {
    key: 'removeObjectAtIndex',
    value: function removeObjectAtIndex(array, index) {
      if (array.length > index) {
        // Replace item at index using native splice
        array.splice(index, 1);
      }

      return array;
    }
  }, {
    key: 'deleteObject',
    value: function deleteObject(array, comparator) {
      return ArrayUtils.removeObject(array, comparator);
    }
  }, {
    key: 'createArrayOfNull',
    value: function createArrayOfNull(size) {
      return Array.apply(null, Array(size)).map(function () {
        return null;
      });
    }
  }, {
    key: 'getObjectKeys',
    value: function getObjectKeys(obj) {
      var keys = [];
      Object.keys(obj).map(function (key) {
        keys.push(key);
      });

      return keys;
    }

    /**
     * Add the value if it's not on the given array, otherwise remove it.
     */

  }, {
    key: 'toggleObject',
    value: function toggleObject(array, obj, comparator) {
      if (ArrayUtils.exists(array, comparator)) {
        return ArrayUtils.deleteObject(array, comparator);
      }

      array.push(obj);
      return array;
    }
  }, {
    key: 'toggleValue',
    value: function toggleValue(array, value) {
      if (_lodash2.default.includes(array, value)) {
        array.splice(_lodash2.default.indexOf(array, value), 1);
      } else {
        array.push(value);
      }

      return array;
    }
  }]);

  return ArrayUtils;
}();

exports.default = ArrayUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/BitUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * http://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators
 */
var BitUtils = function () {
  function BitUtils() {
    _classCallCheck(this, BitUtils);
  }

  _createClass(BitUtils, null, [{
    key: "isSet",
    value: function isSet(mask, flag) {
      return (flag & mask) !== 0;
    }
  }, {
    key: "set",
    value: function set(mask, flag) {
      return flag | mask;
    }
  }, {
    key: "toggle",
    value: function toggle(mask, flag) {
      return flag ^ mask;
    }
  }, {
    key: "remove",
    value: function remove(mask, flag) {
      return flag & ~mask;
    }
  }]);

  return BitUtils;
}();

exports.default = BitUtils;
module.exports = exports["default"];

/***/ }),

/***/ "./sdk/scripts/utils/BookingUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BookingUtils = function () {
  function BookingUtils() {
    _classCallCheck(this, BookingUtils);
  }

  _createClass(BookingUtils, null, [{
    key: 'getPeriodList',
    value: function getPeriodList() {
      var list = [];
      _lodash2.default.forIn(_BookingConstants2.default.Period, function (value, key) {
        list.push(value);
      });

      return list;
    }
  }, {
    key: 'generateSlotsForInterval',
    value: function generateSlotsForInterval(begin, end, interval) {
      var res = [];

      for (var i = begin; i <= end; i += interval) {
        res.push(i);
      }

      return res;
    }
  }]);

  return BookingUtils;
}();

exports.default = BookingUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/BookingViewUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _BookingConstants = __webpack_require__("./sdk/scripts/constants/BookingConstants.js");

var _BookingConstants2 = _interopRequireDefault(_BookingConstants);

var _Logger = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BookingViewUtils = function () {
  function BookingViewUtils() {
    _classCallCheck(this, BookingViewUtils);
  }

  _createClass(BookingViewUtils, null, [{
    key: 'getActionLabel',
    value: function getActionLabel(action) {
      switch (action) {
        case _BookingConstants2.default.Action.NOT_ARRIVED:
          return _I18n2.default.tr('booking.action.not_arrived');
        case _BookingConstants2.default.Action.SEATED:
          return _I18n2.default.tr('booking.action.placed');
        case _BookingConstants2.default.Action.CANCELED:
          return _I18n2.default.tr('booking.action.canceled');
        case _BookingConstants2.default.Action.NO_SHOW:
          return _I18n2.default.tr('booking.action.not_come');
        default:
          _Logger2.default.notImplemented('[BookingUtils.getActionLabel] Unknown action label', action);
          return '';
      }
    }
  }, {
    key: 'getSourceLabel',
    value: function getSourceLabel(source) {
      switch (source) {
        case _BookingConstants2.default.Source.APP:
          return _I18n2.default.tr('booking.source.mobile_app');
        case _BookingConstants2.default.Source.WEBSITE:
          return _I18n2.default.tr('booking.source.website');
        case _BookingConstants2.default.Source.RESTAURANT:
          return _I18n2.default.tr('booking.source.restaurant');
        case _BookingConstants2.default.Source.PHONE:
          return _I18n2.default.tr('booking.source.phone');
        case _BookingConstants2.default.Source.THIRD_PARTY:
          return _I18n2.default.tr('booking.source.third');
        case _BookingConstants2.default.Source.PLUGIN:
          return _I18n2.default.tr('booking.source.website');
        default:
          _Logger2.default.notImplemented('[BookingUtils.getSourceLabel] Unknown source label', source);
          return '';
      }
    }
  }, {
    key: 'getStatusLabel',
    value: function getStatusLabel(status) {
      switch (status) {
        case _BookingConstants2.default.Status.CONFIRMED:
          return _I18n2.default.tr('booking.state.confirmed');
        case _BookingConstants2.default.Status.WAITING:
          return _I18n2.default.tr('booking.state.waiting');
        default:
          _Logger2.default.notImplemented('[BookingUtils.getStatusLabel] Unknown status label', status);
          return '';
      }
    }
  }, {
    key: 'getPeriodLabel',
    value: function getPeriodLabel(period) {
      switch (period) {
        case _BookingConstants2.default.Period.ALL:
          return _I18n2.default.tr('booking.all');
        case _BookingConstants2.default.Period.MORNING:
          return _I18n2.default.tr('booking.morning');
        case _BookingConstants2.default.Period.NOON:
          return _I18n2.default.tr('booking.noon');
        case _BookingConstants2.default.Period.EVENING:
          return _I18n2.default.tr('booking.evening');
        case _BookingConstants2.default.Period.BRUNCH:
          return _I18n2.default.tr('booking.brunch');
        default:
          _Logger2.default.notImplemented('BookingUtils.getPeriodLabel', 'Unknown period label ' + period);
          return '';
      }
    }
  }, {
    key: 'getPeriodListForPicker',
    value: function getPeriodListForPicker() {
      var _this = this;

      var list = [];
      _lodash2.default.forIn(_BookingConstants2.default.Period, function (value, key) {
        // BRUNCH have been deactivated.
        if (value !== _BookingConstants2.default.Period.BRUNCH) {
          list.push({
            label: _this.getPeriodLabel(value),
            value: value
          });
        }
      });

      return list;
    }
  }]);

  return BookingViewUtils;
}();

exports.default = BookingViewUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/CatalogUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalizedData = undefined;

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * get localized string
 */
var getLocalizedData = exports.getLocalizedData = function getLocalizedData(localizedDatas) {
  localizedDatas = localizedDatas || [];

  // get asked locale
  var localizedData = _lodash2.default.find(localizedDatas, function (data) {
    return data.locale.indexOf(_I18n2.default.getCurrentLanguageWithoutRegionCode()) > -1;
  });

  // no translation found, try default locale
  if (_lodash2.default.isEmpty(localizedData)) {
    localizedData = _lodash2.default.find(localizedDatas, function (data) {
      return data.locale.indexOf(_I18n2.default.defaultLocale) > -1;
    });
  }

  // no translation found, get the first available
  if (_lodash2.default.isEmpty(localizedData)) {
    localizedData = localizedDatas[0];
  }

  return localizedData && localizedData.text;
};

/***/ }),

/***/ "./sdk/scripts/utils/CountryData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// So each country array has the following information:
// [
//    Country name,
//    iso2 code,
//    International dial code,
//    Format (if available),
//    Order (if >1 country with same dial code),
//    Area codes (if >1 country with same dial code)
// ]

var allCountries = [['Afghanistan', 'af', '93'], ['Albania', 'al', '355'], ['Algeria ', 'dz', '213'], ['American Samoa', 'as', '1684'], ['Andorra', 'ad', '376'], ['Angola', 'ao', '244'], ['Anguilla', 'ai', '1264'], ['Antigua and Barbuda', 'ag', '1268'], ['Argentina', 'ar', '54'], ['Armenia', 'am', '374'], ['Aruba', 'aw', '297'], ['Australia', 'au', '61', '+.. ... ... ...'], ['Austria', 'at', '43'], ['Azerbaijan', 'az', '994'], ['Bahamas', 'bs', '1242'], ['Bahrain', 'bh', '973'], ['Bangladesh', 'bd', '880'], ['Barbados', 'bb', '1246'], ['Belarus', 'by', '375'], ['Belgium', 'be', '32', '+.. ... .. .. ..'], ['Belize', 'bz', '501'], ['Benin', 'bj', '229'], ['Bermuda', 'bm', '1441'], ['Bhutan', 'bt', '975'], ['Bolivia', 'bo', '591'], ['Bosnia and Herzegovina', 'ba', '387'], ['Botswana', 'bw', '267'], ['Brazil', 'br', '55'], ['British Indian Ocean Territory', 'io', '246'], ['British Virgin Islands', 'vg', '1284'], ['Brunei', 'bn', '673'], ['Bulgaria', 'bg', '359'], ['Burkina Faso', 'bf', '226'], ['Burundi', 'bi', '257'], ['Cambodia', 'kh', '855'], ['Cameroon', 'cm', '237'], ['Canada', 'ca', '1', '+. (...) ...-....', 1, ['204', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Cape Verde', 'cv', '238'], ['Caribbean Netherlands', 'bq', '599', '', 1], ['Cayman Islands', 'ky', '1345'], ['Central African Republic', 'cf', '236'], ['Chad', 'td', '235'], ['Chile', 'cl', '56'], ['China', 'cn', '86', '+.. ..-........'], ['Colombia', 'co', '57'], ['Comoros', 'km', '269'], ['Congo', 'cd', '243'], ['Congo', 'cg', '242'], ['Cook Islands', 'ck', '682'], ['Costa Rica', 'cr', '506', '+... ....-....'], ['Côte d’Ivoire', 'ci', '225'], ['Croatia', 'hr', '385'], ['Cuba', 'cu', '53'], ['Curaçao', 'cw', '599', '', 0], ['Cyprus', 'cy', '357'], ['Czech Republic', 'cz', '420'], ['Denmark', 'dk', '45', '+.. .. .. .. ..'], ['Djibouti', 'dj', '253'], ['Dominica', 'dm', '1767'], ['Dominican Republic', 'do', '1', '', 2, ['809', '829', '849']], ['Ecuador', 'ec', '593'], ['Egypt', 'eg', '20'], ['El Salvador', 'sv', '503', '+... ....-....'], ['Equatorial Guinea', 'gq', '240'], ['Eritrea', 'er', '291'], ['Estonia', 'ee', '372'], ['Ethiopia', 'et', '251'], ['Falkland Islands', 'fk', '500'], ['Faroe Islands', 'fo', '298'], ['Fiji', 'fj', '679'], ['Finland', 'fi', '358', '+... .. ... .. ..'], ['France', 'fr', '33', '+.. . .. .. .. ..'], ['French Guiana', 'gf', '594'], ['French Polynesia', 'pf', '689'], ['Gabon', 'ga', '241'], ['Gambia', 'gm', '220'], ['Georgia', 'ge', '995'], ['Germany', 'de', '49', '+.. ... .......'], ['Ghana', 'gh', '233'], ['Gibraltar', 'gi', '350'], ['Greece', 'gr', '30'], ['Greenland', 'gl', '299'], ['Grenada', 'gd', '1473'], ['Guadeloupe', 'gp', '590', '', 0], ['Guam', 'gu', '1671'], ['Guatemala', 'gt', '502', '+... ....-....'], ['Guinea', 'gn', '224'], ['Guinea-Bissau', 'gw', '245'], ['Guyana', 'gy', '592'], ['Haiti', 'ht', '509', '+... ....-....'], ['Honduras', 'hn', '504'], ['Hong Kong', 'hk', '852', '+... .... ....'], ['Hungary', 'hu', '36'], ['Iceland', 'is', '354', '+... ... ....'], ['India', 'in', '91', '+.. .....-.....'], ['Indonesia', 'id', '62'], ['Iran', 'ir', '98'], ['Iraq', 'iq', '964'], ['Ireland', 'ie', '353', '+... .. .......'], ['Israel', 'il', '972'], ['Italy', 'it', '39', '+.. ... ......', 0], ['Jamaica', 'jm', '1876'], ['Japan', 'jp', '81', '+.. ... .. ....'], ['Jordan', 'jo', '962'], ['Kazakhstan', 'kz', '7', '+. ... ...-..-..', 1], ['Kenya', 'ke', '254'], ['Kiribati', 'ki', '686'], ['Kuwait', 'kw', '965'], ['Kyrgyzstan', 'kg', '996'], ['Laos', 'la', '856'], ['Latvia', 'lv', '371'], ['Lebanon', 'lb', '961'], ['Lesotho', 'ls', '266'], ['Liberia', 'lr', '231'], ['Libya', 'ly', '218'], ['Liechtenstein', 'li', '423'], ['Lithuania', 'lt', '370'], ['Luxembourg', 'lu', '352'], ['Macau', 'mo', '853'], ['Macedonia', 'mk', '389'], ['Madagascar', 'mg', '261'], ['Malawi', 'mw', '265'], ['Malaysia', 'my', '60', '+.. ..-....-....'], ['Maldives', 'mv', '960'], ['Mali', 'ml', '223'], ['Malta', 'mt', '356'], ['Marshall Islands', 'mh', '692'], ['Martinique', 'mq', '596'], ['Mauritania', 'mr', '222'], ['Mauritius', 'mu', '230'], ['Mexico', 'mx', '52'], ['Micronesia', 'fm', '691'], ['Moldova', 'md', '373'], ['Monaco', 'mc', '377'], ['Mongolia', 'mn', '976'], ['Montenegro', 'me', '382'], ['Montserrat', 'ms', '1664'], ['Morocco', 'ma', '212'], ['Mozambique', 'mz', '258'], ['Myanmar', 'mm', '95'], ['Namibia', 'na', '264'], ['Nauru', 'nr', '674'], ['Nepal', 'np', '977'], ['Netherlands', 'nl', '31', '+.. .. ........'], ['New Caledonia', 'nc', '687'], ['New Zealand', 'nz', '64', '+.. ...-...-....'], ['Nicaragua', 'ni', '505'], ['Niger', 'ne', '227'], ['Nigeria', 'ng', '234'], ['Niue', 'nu', '683'], ['Norfolk Island', 'nf', '672'], ['North Korea', 'kp', '850'], ['Northern Mariana Islands', 'mp', '1670'], ['Norway', 'no', '47', '+.. ... .. ...'], ['Oman', 'om', '968'], ['Pakistan', 'pk', '92', '+.. ...-.......'], ['Palau', 'pw', '680'], ['Palestine', 'ps', '970'], ['Panama', 'pa', '507'], ['Papua New Guinea', 'pg', '675'], ['Paraguay', 'py', '595'], ['Peru', 'pe', '51'], ['Philippines', 'ph', '63', '+.. ... ....'], ['Poland', 'pl', '48', '+.. ...-...-...'], ['Portugal', 'pt', '351'], ['Puerto Rico', 'pr', '1', '', 3, ['787', '939']], ['Qatar', 'qa', '974'], ['Réunion', 're', '262'], ['Romania', 'ro', '40'], ['Russia', 'ru', '7', '+. ... ...-..-..', 0], ['Rwanda', 'rw', '250'], ['Saint Barthélemy', 'bl', '590', '', 1], ['Saint Helena', 'sh', '290'], ['Saint Kitts and Nevis', 'kn', '1869'], ['Saint Lucia', 'lc', '1758'], ['Saint Martin', 'mf', '590', '', 2], ['Saint Pierre and Miquelon', 'pm', '508'], ['Saint Vincent and the Grenadines', 'vc', '1784'], ['Samoa', 'ws', '685'], ['San Marino', 'sm', '378'], ['São Tomé and Príncipe', 'st', '239'], ['Saudi Arabia', 'sa', '966'], ['Senegal', 'sn', '221'], ['Serbia', 'rs', '381'], ['Seychelles', 'sc', '248'], ['Sierra Leone', 'sl', '232'], ['Singapore', 'sg', '65', '+.. ....-....'], ['Sint Maarten', 'sx', '1721'], ['Slovakia', 'sk', '421'], ['Slovenia', 'si', '386'], ['Solomon Islands', 'sb', '677'], ['Somalia', 'so', '252'], ['South Africa', 'za', '27'], ['South Korea', 'kr', '82'], ['South Sudan', 'ss', '211'], ['Spain', 'es', '34', '+.. ... ... ...'], ['Sri Lanka', 'lk', '94'], ['Sudan', 'sd', '249'], ['Suriname', 'sr', '597'], ['Swaziland', 'sz', '268'], ['Sweden', 'se', '46', '+.. .. ... .. ..'], ['Switzerland', 'ch', '41', '+.. .. ... .. ..'], ['Syria', 'sy', '963'], ['Taiwan', 'tw', '886'], ['Tajikistan', 'tj', '992'], ['Tanzania', 'tz', '255'], ['Thailand', 'th', '66'], ['Timor-Leste', 'tl', '670'], ['Togo', 'tg', '228'], ['Tokelau', 'tk', '690'], ['Tonga', 'to', '676'], ['Trinidad and Tobago', 'tt', '1868'], ['Tunisia', 'tn', '216'], ['Turkey', 'tr', '90', '+.. ... ... .. ..'], ['Turkmenistan', 'tm', '993'], ['Turks and Caicos Islands', 'tc', '1649'], ['Tuvalu', 'tv', '688'], ['U.S. Virgin Islands', 'vi', '1340'], ['Uganda', 'ug', '256'], ['Ukraine', 'ua', '380'], ['United Arab Emirates', 'ae', '971'], ['United Kingdom', 'gb', '44', '+.. .... ......'], ['United States', 'us', '1', '+. (...) ...-....', 0], ['Uruguay', 'uy', '598'], ['Uzbekistan', 'uz', '998'], ['Vanuatu', 'vu', '678'], ['Vatican City', 'va', '39', '+.. .. .... ....', 1], ['Venezuela', 've', '58'], ['Vietnam', 'vn', '84'], ['Wallis and Futuna', 'wf', '681'], ['Yemen', 'ye', '967'], ['Zambia', 'zm', '260'], ['Zimbabwe', 'zw', '263']];

// we will build this in the loop below
var allCountryCodes = {};
function addCountryCode(iso2, dialCode, priority) {
  if (!(dialCode in allCountryCodes)) {
    allCountryCodes[dialCode] = [];
  }
  var index = priority || 0;
  allCountryCodes[dialCode][index] = iso2;
}

for (var i = 0; i < allCountries.length; i++) {
  // countries
  var c = allCountries[i];
  allCountries[i] = {
    name: c[0],
    iso2: c[1],
    dialCode: c[2],
    priority: c[4] || 0
  };
  // format
  if (c[3]) {
    allCountries[i].format = c[3];
  }

  // area codes
  if (c[5]) {
    allCountries[i].hasAreaCodes = true;
    for (var j = 0; j < c[5].length; j++) {
      // full dial code is country code + dial code
      var dialCode = c[2] + c[5][j];
      addCountryCode(c[1], dialCode);
    }
  }

  // dial codes
  addCountryCode(c[1], c[2], c[4]);
}

module.exports = {
  allCountries: allCountries,
  allCountryCodes: allCountryCodes
};

/***/ }),

/***/ "./sdk/scripts/utils/CurrencyUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CurrencyUtils = function () {
  function CurrencyUtils() {
    _classCallCheck(this, CurrencyUtils);
  }

  _createClass(CurrencyUtils, null, [{
    key: 'formatPriceWithCurrency',
    value: function formatPriceWithCurrency(price) {
      var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EUR';

      return Intl.NumberFormat(undefined, // use current locale
      { currency: currencyCode, style: 'currency' }).format(price);
    }
  }, {
    key: 'formatPrice',
    value: function formatPrice(price) {
      var priceAsFloat = parseFloat(price);
      return priceAsFloat.toFixed(2);
    }
  }, {
    key: 'formatMillionPrice',
    value: function formatMillionPrice(price) {
      var priceAsFloat = parseFloat(price / 1000000);
      return priceAsFloat.toFixed(2);
    }
  }, {
    key: 'formatMillionPriceWithCurrency',
    value: function formatMillionPriceWithCurrency(price) {
      var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EUR';

      var priceAsFloat = parseFloat(price / 1000000);
      return CurrencyUtils.formatPriceWithCurrency(priceAsFloat, currencyCode);
    }
  }, {
    key: 'formatTax',
    value: function formatTax(tax) {
      var taxAsFloat = parseFloat(tax);
      return taxAsFloat.toFixed(1) + ' %';
    }
  }, {
    key: 'getCodeNameCorrespondance',
    value: function getCodeNameCorrespondance() {
      return {
        EUR: _I18n2.default.getCurrencyName('EUR'),
        USD: _I18n2.default.getCurrencyName('USD'),
        GBP: _I18n2.default.getCurrencyName('GBP'),
        PLN: _I18n2.default.getCurrencyName('PLN'),
        CHF: _I18n2.default.getCurrencyName('CHF'),
        NOK: _I18n2.default.getCurrencyName('NOK'),
        SEK: _I18n2.default.getCurrencyName('SEK'),
        DKK: _I18n2.default.getCurrencyName('DKK')
      };
    }
  }, {
    key: 'getCodeSymbolCorrespondance',
    value: function getCodeSymbolCorrespondance() {
      return {
        EUR: '€',
        USD: 'USD',
        GBP: 'GBP',
        PLN: 'PLN',
        CHF: 'CHF',
        NOK: 'NOK',
        SEK: 'SEK',
        DKK: 'DKK'
      };
    }
  }, {
    key: 'getNameForCode',
    value: function getNameForCode(code) {
      var res = code;
      _lodash2.default.forIn(CurrencyUtils.getCodeNameCorrespondance(), function (value, key) {
        if (code === key) {
          res = value;
          return false; // quit loop
        }
      });

      return res;
    }

    /**
     * Prefer using formatPriceWithCurrency if you have an associated amount.
     * Use this method only if you need the symbol without having associated amount
     */

  }, {
    key: 'getCurrencySymbol',
    value: function getCurrencySymbol() {
      var currencyCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EUR';

      var res = currencyCode;
      _lodash2.default.forIn(CurrencyUtils.getCodeSymbolCorrespondance(), function (value, key) {
        if (currencyCode === key) {
          res = value;
          return false; // quit loop
        }
      });

      return res;
    }
  }, {
    key: 'getNameForSymbol',
    value: function getNameForSymbol(symbol) {
      var res = symbol;
      _lodash2.default.forIn(CurrencyUtils.getCodeSymbolCorrespondance(), function (value, key) {
        if (value === symbol) {
          res = key;
          return false; // quit loop
        }
      });

      return res;
    }

    /**
     * Return all the currency available on the API.
     */

  }, {
    key: 'getApiCurrencyOptions',
    value: function getApiCurrencyOptions() {
      return [{ value: 'EUR', label: _I18n2.default.getCurrencyName('EUR') }, { value: 'USD', label: _I18n2.default.getCurrencyName('USD') }, { value: 'GBP', label: _I18n2.default.getCurrencyName('GBP') }, { value: 'PLN', label: _I18n2.default.getCurrencyName('PLN') }, { value: 'CHF', label: _I18n2.default.getCurrencyName('CHF') }, { value: 'NOK', label: _I18n2.default.getCurrencyName('NOK') }, { value: 'SEK', label: _I18n2.default.getCurrencyName('SEK') }, { value: 'DKK', label: _I18n2.default.getCurrencyName('DKK') }];
    }
  }]);

  return CurrencyUtils;
}();

exports.default = CurrencyUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/DateUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _Timelapse = __webpack_require__("./sdk/scripts/entities/Timelapse.js");

var _Timelapse2 = _interopRequireDefault(_Timelapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__("./node_modules/moment/locale/fr.js");
__webpack_require__("./node_modules/moment/locale/de.js");

var DateUtils = function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }

  _createClass(DateUtils, null, [{
    key: 'anyToDate',


    /**
     * Take a Moment or an MsTimestamp and return a moment
     * @type {[type]}
     */


    //


    /**
     * @deprecated
     */
    value: function anyToDate(date) {
      if (_lodash2.default.isNumber(date)) {
        return this.fromMsTimestamp(date);
      }

      return (0, _moment2.default)(date); // copy in order to not change the reference data.
    }

    /**
     * Return a moment instance for the given timestamp.
     * @param timestamp
     * @param format Define if the timestamp is in second or milliseconds.
     * @returns moment instance.
     */


    // -- formats


    /**
     * @deprecated
     */


    /**
     * @deprecated
     */

  }, {
    key: 'fromTimestamp',
    value: function fromTimestamp(timestamp) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DateUtils.SECOND_FORMAT;


      return (0, _moment2.default)(timestamp, format).locale(_I18n2.default.getCurrentLanguageWithoutRegionCode());
    }
  }, {
    key: 'fromMsTimestamp',
    value: function fromMsTimestamp(timestamp) {
      return (0, _moment2.default)(timestamp, DateUtils.MS_FORMAT).locale(_I18n2.default.getCurrentLanguageWithoutRegionCode());
    }
  }, {
    key: 'stringDateWithFormatToUnix',
    value: function stringDateWithFormatToUnix(stringDate, format) {
      return (0, _moment2.default)(stringDate, format).locale(_I18n2.default.getCurrentLanguageWithoutRegionCode()).unix();
    }
  }, {
    key: 'stringDateWithFormatToMs',
    value: function stringDateWithFormatToMs(stringDate, format) {
      return (0, _moment2.default)(stringDate, format).locale(_I18n2.default.getCurrentLanguageWithoutRegionCode()).valueOf();
    }
  }, {
    key: 'getTimestampAsMilliseconds',
    value: function getTimestampAsMilliseconds(date) {
      return (0, _moment2.default)(date).locale(_I18n2.default.getCurrentLanguageWithoutRegionCode()).valueOf();
    }
  }, {
    key: 'fromSecondsTimestampToString',
    value: function fromSecondsTimestampToString(timestamp) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/Y';

      return (0, _moment2.default)(timestamp, DateUtils.SECOND_FORMAT).locale(_I18n2.default.getCurrentLanguageWithoutRegionCode()).format(format);
    }
  }, {
    key: 'getTodayTimestampAsSeconds',
    value: function getTodayTimestampAsSeconds() {
      return (0, _moment2.default)().unix();
    }
  }, {
    key: 'getTodayTimestampAsMilliseconds',
    value: function getTodayTimestampAsMilliseconds() {
      return (0, _moment2.default)().unix() * 1000;
    }
  }, {
    key: 'getTimelapseDayInterval',
    value: function getTimelapseDayInterval() {
      var timelapse = new _Timelapse2.default();

      var fromTime = (0, _moment2.default)().startOf('day');
      var toTime = (0, _moment2.default)().endOf('day');

      timelapse.setFromTime(fromTime.unix());
      timelapse.setToTime(toTime.unix());

      return timelapse;
    }
  }, {
    key: 'getTimelapseWeekInterval',
    value: function getTimelapseWeekInterval() {
      var timelapse = new _Timelapse2.default();

      var fromTime = (0, _moment2.default)().subtract(1, 'weeks').startOf('day');
      var toTime = (0, _moment2.default)().endOf('day');

      timelapse.setFromTime(fromTime.unix());
      timelapse.setToTime(toTime.unix());

      return timelapse;
    }
  }, {
    key: 'getTimelapseWeekIntervalInFuture',
    value: function getTimelapseWeekIntervalInFuture() {
      var timelapse = new _Timelapse2.default();

      var fromTime = (0, _moment2.default)().startOf('day');
      var toTime = (0, _moment2.default)().add(1, 'weeks').endOf('day');

      timelapse.setFromTime(fromTime.unix());
      timelapse.setToTime(toTime.unix());

      return timelapse;
    }
  }, {
    key: 'getTimelapseMonthInterval',
    value: function getTimelapseMonthInterval() {
      var timelapse = new _Timelapse2.default();

      var fromTime = (0, _moment2.default)().subtract(1, 'months').startOf('day');
      var toTime = (0, _moment2.default)().endOf('day');

      timelapse.setFromTime(fromTime.unix());
      timelapse.setToTime(toTime.unix());

      return timelapse;
    }
  }, {
    key: 'getTimelapseMonthIntervalInFuture',
    value: function getTimelapseMonthIntervalInFuture() {
      var timelapse = new _Timelapse2.default();

      var fromTime = (0, _moment2.default)().startOf('day');
      var toTime = (0, _moment2.default)().add(1, 'months').endOf('day');

      timelapse.setFromTime(fromTime.unix());
      timelapse.setToTime(toTime.unix());

      return timelapse;
    }
  }, {
    key: 'millisecondsToMinutes',
    value: function millisecondsToMinutes(timestamp) {
      return Math.round(timestamp / this.MINUTE_AS_MILLISECONDS);
    }
  }, {
    key: 'millisecondsToDays',
    value: function millisecondsToDays(timestamp) {
      return Math.round(timestamp / this.DAY_AS_MILLISECONDS);
    }
  }, {
    key: 'minutesToMilliseconds',
    value: function minutesToMilliseconds(minutes) {
      return minutes * this.MINUTE_AS_MILLISECONDS;
    }
  }, {
    key: 'daysToMilliseconds',
    value: function daysToMilliseconds(days) {
      return days * this.DAY_AS_MILLISECONDS;
    }

    /**
     * Get a timestamp and return it with only hour and minutes in seconds.
     * Note that it does not handle timezones :/
     * @param value
     * @param timestampFormat
     * @param returnFormat default same as timestamp format.
     * @returns {number}
     */

  }, {
    key: 'getTimestampForHour',
    value: function getTimestampForHour(value) {
      var timestampFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DateUtils.SECOND_FORMAT;
      var returnFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (value.toString().length > 11 && timestampFormat === DateUtils.SECOND_FORMAT) {
        console.error('time set to ms', value);
      }
      var date = (0, _moment2.default)(value, timestampFormat);

      var timestampAsSeconds = this.getTimestampForHourWithDate(date) / 1000;

      var format = returnFormat;
      if (_lodash2.default.isNull(format)) {
        format = timestampFormat;
      }
      if (format === DateUtils.SECOND_FORMAT) {
        return timestampAsSeconds;
      }
      // DateUtils.MS_FORMAT
      return timestampAsSeconds * 1000;
    }
  }, {
    key: 'getTimestampForHourWithDate',
    value: function getTimestampForHourWithDate(dateParam) {
      var date = this.anyToDate(dateParam);
      return (date.hour() * 3600 + date.minute() * 60) * 1000;
    }

    /**
     * Return a timestamp as seconds with the given hour and minute.
     * @param hour
     * @param minute
     * @returns {number}
     */

  }, {
    key: 'getTimestampForHourAndMinute',
    value: function getTimestampForHourAndMinute(hour, minute) {
      return hour * 3600 + minute * 60;
    }
  }, {
    key: 'getMsTimestampForHourAndMinute',
    value: function getMsTimestampForHourAndMinute(hour, minute) {
      return (hour * 3600 + minute * 60) * 1000;
    }
  }, {
    key: 'isHour',
    value: function isHour(timestamp) {
      return timestamp <= DateUtils.DAY_AS_MILLISECONDS;
    }
  }, {
    key: 'getHourFromMsHourTimestamp',
    value: function getHourFromMsHourTimestamp(date) {
      return parseInt(date / 1000 / 3600, 10);
    }
  }, {
    key: 'getMinuteFromMsHourTimestamp',
    value: function getMinuteFromMsHourTimestamp(date) {
      return parseInt(date / 1000 % 3600 / 60, 10);
    }
  }, {
    key: 'getHourAndMinuteFromMsTimestamp',
    value: function getHourAndMinuteFromMsTimestamp(date) {
      return {
        hour: DateUtils.getHourFromMsHourTimestamp(date),
        minute: DateUtils.getMinuteFromMsHourTimestamp(date)
      };
    }
  }, {
    key: 'getSlotFromDate',
    value: function getSlotFromDate(dateParam) {
      var date = this.anyToDate(dateParam);
      return this.getMsTimestampForHourAndMinute(date.hour(), date.minute());
    }
  }, {
    key: 'formatTwoDigits',
    value: function formatTwoDigits(number) {
      return number > 9 ? '' + number : '0' + number;
    }
  }, {
    key: 'getFormattedHourWithMsHour',
    value: function getFormattedHourWithMsHour(date) {
      return DateUtils.formatTwoDigits(DateUtils.getHourFromMsHourTimestamp(date)) + ':' + DateUtils.formatTwoDigits(DateUtils.getMinuteFromMsHourTimestamp(date));
    }
  }, {
    key: 'differenceBetweenDatesInDays',
    value: function differenceBetweenDatesInDays(date1, date2) {
      return this.anyToDate(date1).diff(this.anyToDate(date2), 'days');
    }
  }, {
    key: 'differenceBetweenDatesInMinutes',
    value: function differenceBetweenDatesInMinutes(date1, date2) {
      return this.anyToDate(date1).diff(this.anyToDate(date2), 'minutes');
    }

    /**
     * @param date1 Moment|number|MsTimestamp
     * @type {[type]}
     */

  }, {
    key: 'isSameDay',
    value: function isSameDay(date1Param, date2Param) {
      if (_lodash2.default.isNil(date1Param) || _lodash2.default.isNil(date1Param)) {
        return false;
      }

      var date1 = DateUtils.anyToDate(date1Param);
      var date2 = DateUtils.anyToDate(date2Param);

      return date1.isSame(date2, 'day') && date1.isSame(date2, 'month') && date1.isSame(date2, 'year');
    }
  }, {
    key: 'isSameDayWithTimestamp',
    value: function isSameDayWithTimestamp(tm1, tm2) {
      var date1 = this.fromMsTimestamp(tm1);
      var date2 = this.fromMsTimestamp(tm2);
      return date1.isSame(date2, 'day') && date1.isSame(date2, 'month') && date1.isSame(date2, 'year');
    }

    /**
     * @param date Moment|number|MsTimestamp
     */

  }, {
    key: 'isToday',
    value: function isToday(dateParam) {
      var date = this.anyToDate(dateParam);
      return this.isSameDay(date, (0, _moment2.default)());
    }
  }, {
    key: 'isTomorrow',
    value: function isTomorrow(dateParam) {
      var date = this.anyToDate(dateParam);

      var tomorrow = (0, _moment2.default)().add(1, 'day');
      return tomorrow.isSame(date, 'day') && tomorrow.isSame(date, 'month') && tomorrow.isSame(date, 'year');
    }
  }, {
    key: 'getDateString',
    value: function getDateString(dateParam) {
      var date = this.anyToDate(dateParam);
      if (this.isToday(date)) {
        return 'Aujourd\'hui';
      }
      if (this.isTomorrow(date)) {
        return 'Demain';
      }

      return date.format('DD/MM');
    }
  }, {
    key: 'getMonthWeeks',
    value: function getMonthWeeks(year, month) {
      var dates = DateUtils.getMonthDateRange(year, month);

      if (_lodash2.default.isEmpty(dates)) {
        return [];
      }

      var weeks = [];
      var firstWeekYear = dates[0].week();

      _lodash2.default.each(dates, function (date) {
        // get week index from 0
        var weekIndex = date.week() - firstWeekYear;

        // handle January
        if (weekIndex < 0) {
          weekIndex = date.week();
        }

        if (_lodash2.default.isUndefined(weeks[weekIndex])) {
          weeks[weekIndex] = _ArrayUtils2.default.createArrayOfNull(7);
        }

        weeks[weekIndex][date.weekday()] = date;
      });

      return weeks;
    }

    /**
     * @param month the month. January is 0.
     */

  }, {
    key: 'getMonthDateRange',
    value: function getMonthDateRange(year, month) {
      var startDate = (0, _moment2.default)([year, month]);

      // Clone the value before .endOf()
      var endDate = (0, _moment2.default)(startDate).endOf('month');

      var dates = [];
      var date = (0, _moment2.default)(startDate);

      while (date.isBefore(endDate)) {
        dates.push((0, _moment2.default)(date));
        date = date.add(1, 'day');
      }

      return dates;
    }

    /**
     * moment.js .day() use sunday as first day.
     * We use monday as first day on the API.
     * Use this function to convert.
     *
     * @link http://momentjs.com/docs/#/get-set/iso-weekday/
     */

  }, {
    key: 'getPmtDayIndex',
    value: function getPmtDayIndex(dateParam) {
      var date = this.anyToDate(dateParam);

      // In moment: 7 is Monday or Sunday, depending of the iso weekday
      // If the locale assigns Monday as the first day of the week, moment().weekday(0) will be Monday. If Sunday is the first day of the week, moment().weekday(0) will be Sunday.

      /**
       * isoWeekday: Gets or sets the ISO day of the week with 1 being Monday and 7 being Sunday.
       * day: This method can be used to set the day of the week, with Sunday as 0 and Saturday as 6.
       */
      var day = (0, _moment2.default)(date).day();

      var daysMomentToPmt = {
        '0': _ApiConstants2.default.Day.SUNDAY,
        '1': _ApiConstants2.default.Day.MONDAY,
        '2': _ApiConstants2.default.Day.TUESDAY,
        '3': _ApiConstants2.default.Day.WEDNESDAY,
        '4': _ApiConstants2.default.Day.THURSDAY,
        '5': _ApiConstants2.default.Day.FRIDAY,
        '6': _ApiConstants2.default.Day.SATURDAY
      };

      return daysMomentToPmt[day];
    }
  }, {
    key: 'toStartOfDay',
    value: function toStartOfDay(dateParam) {
      var date = this.anyToDate(dateParam);
      return (0, _moment2.default)(date).hour(0).minute(0).second(0).millisecond(0);
    }

    /**
     * get number of weekdays between two timestamp
     */

  }, {
    key: 'nbWeekdaysBetween',
    value: function nbWeekdaysBetween(d1, d2, isoWeekday) {
      d1 = (0, _moment2.default)(d1);
      d2 = (0, _moment2.default)(d2);

      var daysToAdd = (7 + isoWeekday - d1.isoWeekday()) % 7;

      var nextDay = d1.clone().add(daysToAdd, 'days');
      if (nextDay.isAfter(d2)) {
        return 0;
      }

      var weeksBetween = d2.diff(nextDay, 'weeks');

      return weeksBetween + 1;
    }
  }]);

  return DateUtils;
}();

// Format string
/*
 Month
 -----------------------------
 M: 1 2 ... 11 12
 Mo: 1st 2nd ... 11th 12th
 MM: 01 02 ... 11 12
 MMM Jan Feb ... Nov Dec
 MMMM: January February ... November December

 Day of Month
 -----------------------------
 D: 1 2 ... 30 31
 Do: 1st 2nd ... 30th 31st
 DD: 01 02 ... 30 31
 Day of Year DDD 1 2 ... 364 365
 DDDo: 1st 2nd ... 364th 365th
 DDDD: 001 002 ... 364 365

 Day of Week
 -----------------------------
 d: 0 1 ... 5 6
 do: 0th 1st ... 5th 6th
 dd: Su Mo ... Fr Sa
 ddd: Sun Mon ... Fri Sat
 dddd: Sunday Monday ... Friday Saturday
 Day of Week (Locale): e 0 1 ... 5 6
 Day of Week (ISO): E 1 2 ... 6 7

 Week of Year
 -----------------------------
 w: 1 2 ... 52 53
 wo: 1st 2nd ... 52nd 53rd
 ww: 01 02 ... 52 53

 Week of Year (ISO)
 -----------------------------
 W: 1 2 ... 52 53
 Wo: 1st 2nd ... 52nd 53rd
 WW: 01 02 ... 52 53

 Year
 -----------------------------
 YY: 70 71 ... 29 30
 YYYY: 1970 1971 ... 2029 2030

 Week Year
 -----------------------------
 gg: 70 71 ... 29 30
 gggg: 1970 1971 ... 2029 2030

 Week Year (ISO)
 -----------------------------
 GG: 70 71 ... 29 30
 GGGG: 1970 1971 ... 2029 2030

 AM/PM
 -----------------------------
 A: AM PM
 a: am pm

 Hour:
 -----------------------------
 H: 0 1 ... 22 23
 HH: 00 01 ... 22 23
 h: 1 2 ... 11 12
 hh: 01 02 ... 11 12

 Minute
 -----------------------------
 m: 0 1 ... 58 59
 mm: 00 01 ... 58 59

 Second
 -----------------------------
 s: 0 1 ... 58 59
 ss: 00 01 ... 58 59

 Fractional Second
 -----------------------------
 S: 0 1 ... 8 9
 SS: 0 1 ... 98 99
 SSS 0 1 ... 998 999

 Timezone
 -----------------------------
 z or zz: EST CST ... MST PST
 Z: -07:00 -06:00 ... +06:00 +07:00
 ZZ: -0700 -0600 ... +0600 +0700

 Unix Timestamp
 -----------------------------
 X: 1360013296
 */


DateUtils.MINUTE_AS_MILLISECONDS = 60 * 1000;
DateUtils.HOUR_AS_MILLISECONDS = 3600 * 1000;
DateUtils.DAY_AS_MILLISECONDS = 86400 * 1000;
DateUtils.MINUTE_AS_MS = 60 * 1000;
DateUtils.HOUR_AS_MS = 3600 * 1000;
DateUtils.DAY_AS_MS = 86400 * 1000;
DateUtils.DMY_FORMAT = 'L';
DateUtils.SECOND_FORMAT = 'X';
DateUtils.MS_FORMAT = 'x';
DateUtils.BEGIN_DAY_TIEMSTAMP = 0;
DateUtils.END_DAY_TIMESTAMP = DateUtils.DAY_AS_MILLISECONDS;
exports.default = DateUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/DevelopmentUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _GlobalState = __webpack_require__("./sdk/scripts/flux/GlobalState.js");

var _GlobalState2 = _interopRequireDefault(_GlobalState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _isDev = false;
var devTools = null;

var DevelopmentUtils = function () {
  function DevelopmentUtils() {
    _classCallCheck(this, DevelopmentUtils);
  }

  _createClass(DevelopmentUtils, null, [{
    key: 'setDevMode',
    value: function setDevMode() {
      _isDev = true;
    }
  }, {
    key: 'isDev',
    value: function isDev() {
      return _isDev;
    }
  }, {
    key: 'isLocalhost',
    value: function isLocalhost() {
      return window.location.hostname === 'localhost';
    }

    /**
     * On atom, Nuclide > React > Toggle inspector
     */

  }, {
    key: 'initializeAtomReactInspector',
    value: function initializeAtomReactInspector() {
      // on locahost only
      if (DevelopmentUtils.isDev() && DevelopmentUtils.isLocalhost()) {
        $('body').append('<script src="http://localhost:8097"></script>');
      }
    }
  }, {
    key: 'haveDevTools',
    value: function haveDevTools() {
      return DevelopmentUtils.isDev() && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    }
  }, {
    key: 'initializeDevTools',
    value: function initializeDevTools() {
      var optionsParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var appEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (DevelopmentUtils.haveDevTools()) {
        var defaultOptions = {};

        var options = _lodash2.default.merge(defaultOptions, optionsParam);
        devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(options);

        _GlobalState2.default.appEvents = appEvents;

        // init dev tools with the globalState
        devTools.init(_GlobalState2.default.getGlobalState());

        // adds a change listener. It will be called any time an action is dispatched form the monitor. Returns a function to unsubscribe the current listener.
        devTools.subscribe(_GlobalState2.default.devToolsListener);
      } else {
        console.warn('No Redux dev tools found');
      }
    }
  }, {
    key: 'sendToDevTools',
    value: function sendToDevTools(action, state) {
      if (DevelopmentUtils.haveDevTools()) {
        // weird bug without this :/
        var jsonState = JSON.parse(JSON.stringify(state));
        DevelopmentUtils.getDevTools().send(action, jsonState);
      }
    }
  }, {
    key: 'getDevTools',
    value: function getDevTools() {
      return devTools;
    }
  }]);

  return DevelopmentUtils;
}();

exports.default = DevelopmentUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Diacritics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utils to remove accents on letters.
 * See http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
 */

var defaultDiacriticsRemovalMap = [{
  base: 'A',
  letters: 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
}, {
  base: 'AA', letters: '\uA732'
}, {
  base: 'AE', letters: '\xC6\u01FC\u01E2'
}, {
  base: 'AO', letters: '\uA734'
}, {
  base: 'AU', letters: '\uA736'
}, {
  base: 'AV', letters: '\uA738\uA73A'
}, {
  base: 'AY', letters: '\uA73C'
}, {
  base: 'B', letters: 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
}, {
  base: 'C',
  letters: 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E'
}, {
  base: 'D',
  letters: 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
}, {
  base: 'DZ', letters: '\u01F1\u01C4'
}, {
  base: 'Dz', letters: '\u01F2\u01C5'
}, {
  base: 'E',
  letters: 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
}, {
  base: 'F', letters: 'F\u24BB\uFF26\u1E1E\u0191\uA77B'
}, {
  base: 'G',
  letters: 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
}, {
  base: 'H',
  letters: 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
}, {
  base: 'I',
  letters: 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
}, {
  base: 'J', letters: 'J\u24BF\uFF2A\u0134\u0248'
}, {
  base: 'K',
  letters: 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
}, {
  base: 'L',
  letters: 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
}, {
  base: 'LJ', letters: '\u01C7'
}, {
  base: 'Lj', letters: '\u01C8'
}, {
  base: 'M', letters: 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
}, {
  base: 'N',
  letters: 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
}, {
  base: 'NJ', letters: '\u01CA'
}, {
  base: 'Nj', letters: '\u01CB'
}, {
  base: 'O',
  letters: 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C'
}, {
  base: 'OI', letters: '\u01A2'
}, {
  base: 'OO', letters: '\uA74E'
}, {
  base: 'OU', letters: '\u0222'
}, {
  base: 'OE', letters: '\x8C\u0152'
}, {
  base: 'oe', letters: '\x9C\u0153'
}, {
  base: 'P', letters: 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
}, {
  base: 'Q', letters: 'Q\u24C6\uFF31\uA756\uA758\u024A'
}, {
  base: 'R',
  letters: 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
}, {
  base: 'S',
  letters: 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
}, {
  base: 'T',
  letters: 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
}, {
  base: 'TZ', letters: '\uA728'
}, {
  base: 'U',
  letters: 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
}, {
  base: 'V', letters: 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
}, {
  base: 'VY', letters: '\uA760'
}, {
  base: 'W', letters: 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
}, {
  base: 'X', letters: 'X\u24CD\uFF38\u1E8A\u1E8C'
}, {
  base: 'Y',
  letters: 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
}, {
  base: 'Z',
  letters: 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
}, {
  base: 'a',
  letters: 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
}, {
  base: 'aa', letters: '\uA733'
}, {
  base: 'ae', letters: '\xE6\u01FD\u01E3'
}, {
  base: 'ao', letters: '\uA735'
}, {
  base: 'au', letters: '\uA737'
}, {
  base: 'av', letters: '\uA739\uA73B'
}, {
  base: 'ay', letters: '\uA73D'
}, {
  base: 'b', letters: 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
}, {
  base: 'c',
  letters: 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184'
}, {
  base: 'd',
  letters: 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
}, {
  base: 'dz', letters: '\u01F3\u01C6'
}, {
  base: 'e',
  letters: 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
}, {
  base: 'f', letters: 'f\u24D5\uFF46\u1E1F\u0192\uA77C'
}, {
  base: 'g',
  letters: 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
}, {
  base: 'h',
  letters: 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
}, {
  base: 'hv', letters: '\u0195'
}, {
  base: 'i',
  letters: 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
}, {
  base: 'j', letters: 'j\u24D9\uFF4A\u0135\u01F0\u0249'
}, {
  base: 'k',
  letters: 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
}, {
  base: 'l',
  letters: 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
}, {
  base: 'lj', letters: '\u01C9'
}, {
  base: 'm', letters: 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
}, {
  base: 'n',
  letters: 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
}, {
  base: 'nj', letters: '\u01CC'
}, {
  base: 'o',
  letters: 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275'
}, {
  base: 'oi', letters: '\u01A3'
}, {
  base: 'ou', letters: '\u0223'
}, {
  base: 'oo', letters: '\uA74F'
}, {
  base: 'p', letters: 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
}, {
  base: 'q', letters: 'q\u24E0\uFF51\u024B\uA757\uA759'
}, {
  base: 'r',
  letters: 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
}, {
  base: 's',
  letters: 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
}, {
  base: 't',
  letters: 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
}, {
  base: 'tz', letters: '\uA729'
}, {
  base: 'u',
  letters: 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
}, {
  base: 'v', letters: 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
}, {
  base: 'vy', letters: '\uA761'
}, {
  base: 'w', letters: 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
}, {
  base: 'x', letters: 'x\u24E7\uFF58\u1E8B\u1E8D'
}, {
  base: 'y',
  letters: 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
}, {
  base: 'z',
  letters: 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
}];

function getDiacriticsMap() {
  var diacriticsMap = {};
  for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    var letters = defaultDiacriticsRemovalMap[i].letters;
    for (var j = 0; j < letters.length; j++) {
      diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap[i].base;
    }
  }

  return diacriticsMap;
}

var Diacritics = function () {
  function Diacritics() {
    _classCallCheck(this, Diacritics);
  }

  _createClass(Diacritics, null, [{
    key: 'removeDiacritics',
    value: function removeDiacritics(str) {
      return str.replace(/[^\u0000-\u007E]/g, function (a) {
        return Diacritics.diacriticsMap[a] || a;
      });
    }
  }, {
    key: 'replaceDiacritics',
    value: function replaceDiacritics(str) {
      var result = str;
      _lodash2.default.each(defaultDiacriticsRemovalMap, function (letterDetail) {
        for (var i = 0; i < letterDetail.letters.length; i++) {
          result = result.replace(letterDetail.letters[i], letterDetail.base);
        }
      });

      return result;
    }
  }]);

  return Diacritics;
}();

Diacritics.diacriticsMap = getDiacriticsMap();
exports.default = Diacritics;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Equals.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Source: http://stackoverflow.com/questions/13142968/deep-comparison-of-objects-arrays
 *
 * @param o
 * @param p
 * @returns {boolean}
 */
var Equals = function () {
  function Equals() {
    _classCallCheck(this, Equals);
  }

  _createClass(Equals, null, [{
    key: 'objectEquals',
    value: function objectEquals(o, p) {

      return _lodash2.default.isEqual(o, p);

      // if (_.isNil(o) || _.isNil(p)) {
      //   return false;
      // }
      //
      // const keysO = Object.keys(o).sort();
      // const keysP = Object.keys(p).sort();
      //
      // if (keysO.length !== keysP.length) {
      //   return false; // not the same nr of keys
      // }
      // if (keysO.join('') !== keysP.join('')) {
      //   return false; // different keys
      // }
      // for (let i = 0; i < keysO.length; ++i) {
      //   const key = keysO[i];
      //   const oValue = o[key];
      //   const pValue = p[key];
      //
      //   if (oValue instanceof Array) {
      //     if (!(pValue instanceof Array)) {
      //       return false;
      //     }
      //     // if (compareObjects(oValue, pValue === false) return false
      //     // would work, too, and perhaps is a better fit, still, this is easy, too
      //     if (pValue.sort().join('') !== oValue.sort().join('')) {
      //       return false;
      //     }
      //   } else if (oValue instanceof Date) {
      //     if (!(pValue instanceof Date)) {
      //       return false;
      //     }
      //     if (('' + oValue) !== ('' + pValue)) {
      //       return false;
      //     }
      //   } else if (oValue instanceof Function) {
      //     if (!(pValue instanceof Function)) {
      //       return false;
      //     }
      //     // ignore functions
      //   } else if (oValue instanceof Object) {
      //     if (!(pValue instanceof Object)) {
      //       return false;
      //     }
      //     if (oValue === o) { // self reference?
      //       if (pValue !== p) {
      //         return false;
      //       }
      //     } else if (Equals.objectEquals(oValue, pValue) === false) {
      //       return false; // WARNING: does not deal with circular refs other than ^^
      //     }
      //   }
      //   if (oValue !== pValue) { // change !== to != for loose comparison
      //     return false; // not the same value
      //   }
      // }
      // return true;
    }
  }]);

  return Equals;
}();

exports.default = Equals;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/GeolocUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global geolocator */

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeolocUtils = function () {
  function GeolocUtils() {
    _classCallCheck(this, GeolocUtils);
  }

  _createClass(GeolocUtils, null, [{
    key: 'getDistanceBetweenPoints',


    /**
     *
     * Returns the distance between the two given `GeoPt` as kilometers
     */
    value: function getDistanceBetweenPoints(from, to) {

      if (_lodash2.default.isNil(from) || _lodash2.default.isNil(to)) {
        return GeolocUtils.NULL_VALUE;
      }

      /**
       * http://onury.github.io/geolocator/
       */
      if (!_lodash2.default.isNil(geolocator)) {
        return geolocator.calcDistance({
          from: from,
          to: to,
          formula: geolocator.DistanceFormula.HAVERSINE,
          unitSystem: geolocator.UnitSystem.METRIC
        });
      }

      console.warn('GeolocUtils:getDistanceBetweenPoints without global geolocator is not implemented. see http://onury.github.io/geolocator/');

      return -1;
    }
  }, {
    key: 'shortGeoPtToGeoPt',
    value: function shortGeoPtToGeoPt(shortGeoPt) {
      if (_lodash2.default.isNil(shortGeoPt)) {
        return {
          latitude: 0,
          longitude: 0
        };
      }
      return {
        latitude: shortGeoPt.lat,
        longitude: shortGeoPt.lng
      };
    }
  }, {
    key: 'geoPtToShortGeoPt',
    value: function geoPtToShortGeoPt(geoPt) {
      if (_lodash2.default.isNil(geoPt)) {
        return {
          latitude: 0,
          longitude: 0
        };
      }
      return {
        lat: geoPt.latitude,
        lng: geoPt.longitude
      };
    }
  }, {
    key: 'getLabelForDistanceInKm',
    value: function getLabelForDistanceInKm(distance) {
      if (_lodash2.default.isNaN(distance)) {
        return '';
      }
      if (distance > 1) {
        // more than 1 km
        return distance.toFixed(1) + ' km';
      }

      // meters
      return Math.floor(distance * 1000) + ' m';
    }
  }, {
    key: 'kmToMeters',
    value: function kmToMeters(distanceInKm) {
      return distanceInKm / 1000;
    }
  }]);

  return GeolocUtils;
}();

GeolocUtils.PARIS_LOCATION = {
  latitude: 48.864716,
  longitude: 2.349014
};
GeolocUtils.NULL_VALUE = -1;
exports.default = GeolocUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/GmapUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _ArrayUtils = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils2 = _interopRequireDefault(_ArrayUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GmapUtils = {

  /**
   * flow: GmapType
   */
  MapType: {
    MAP: 'm',
    SATTELITE: 'k',
    HYBRID: 'h',
    TERRAIN: 'p',
    GOOGLE_EARTH: 'e'
  },

  //
  // Note: zoom
  // * 1: World
  // * 5: Landmass/continent
  // * 10: City
  // * 15: Streets
  // * 20: Buildings
  //

  getTypeOnGmapAddressComponents: function getTypeOnGmapAddressComponents(type, components) {
    var res = null;

    _lodash2.default.each(components, function (component) {
      var index = _lodash2.default.indexOf(component.types, type);

      if (index != -1) {
        res = component;
        return false; // quit loop
      }
    });

    if (_lodash2.default.isNil(res)) {
      // return empty GmapAddressComponent to avoid errors
      return {
        long_name: '',
        short_name: '',
        types: []
      };
    }

    return res;
  },

  /**
   * @see https://stackoverflow.com/questions/2660201/what-parameters-should-i-use-in-a-google-maps-url-to-go-to-a-lat-lon
   * @type {[type]}
   */
  getGoogleMapsUrl: function getGoogleMapsUrl(position) {
    var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var mapType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GmapUtils.MapType.MAP;

    return 'http://maps.google.com/maps?z=' + zoom + '&t={mapType}&q=loc:' + position.latitude + '+' + position.longitude;
  },

  getGoogleMapsDirectionUrl: function getGoogleMapsDirectionUrl(from, to) {
    var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var mapType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : GmapUtils.MapType.MAP;

    var fromFormat = from.latitude + ',' + from.longitude;
    var toFormat = to.latitude + ',' + to.longitude;
    return 'https://www.google.com/maps/dir/' + fromFormat + '/' + toFormat;
  }

};

exports.default = GmapUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/GoogleApi.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleApi = undefined;

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
  opts = opts || {};

  var apiKey = opts.apiKey;
  var libraries = opts.libraries || [];
  var client = opts.client;
  var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';

  var googleVersion = opts.version || '3.25';
  var script = null;

  // let google = window.google = null; // this set window.google to null when reloading the GoogleApiComponent...
  var google = null;

  var loading = false;
  var channel = null;
  var language = null;
  var region = null;

  var onLoadEvents = [];

  var url = function url() {
    var url = URL;
    var params = {
      key: apiKey,
      callback: 'CALLBACK_NAME',
      libraries: libraries.join(','),
      client: client,
      v: googleVersion,
      channel: channel,
      language: language,
      region: region
    };

    var paramStr = Object.keys(params).filter(function (k) {
      return !!params[k];
    }).map(function (k) {
      return k + '=' + params[k];
    }).join('&');

    var res = url + '?' + paramStr;

    console.log('Google Api', res);

    return res;
  };

  return url();
}; /**
    * https://gist.github.com/auser/1d55aa3897f15d17caf21dc39b85b663#file-googleapi-js-L1-Lundefined
    */
exports.default = GoogleApi;

/***/ }),

/***/ "./sdk/scripts/utils/Logger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// use require not import!
// see https://docs.getsentry.com/hosted/clients/javascript/install/
var Raven = __webpack_require__("./node_modules/raven-js/src/singleton.js");

var _loggerConfig = {
  SENTRY_URL: '',

  DISPLAY_REPORT_DIALOG: true,

  APP_VERSION: ''
};

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: 'notImplemented',
    value: function notImplemented(key, detail) {
      console.error(key, detail);

      if (Raven.isSetup()) {
        var message = '[' + key + '] ' + Logger.formatObject(detail);
        Raven.captureMessage(message, {
          level: Logger.LoggerLevel.WARNING
        });
      }
    }
  }, {
    key: 'warning',
    value: function warning(key, detail) {
      console.warn(key, detail);

      if (Raven.isSetup()) {
        var message = '[' + key + '] ' + Logger.formatObject(detail);
        Raven.captureMessage(message, {
          level: Logger.LoggerLevel.WARNING
        });
      }
    }
  }, {
    key: 'error',
    value: function error(key, detail) {
      console.error(key, detail);

      if (Raven.isSetup()) {
        var message = '[' + key + '] ' + Logger.formatObject(detail);
        Raven.captureMessage(message, {
          level: Logger.LoggerLevel.WARNING
        });
      }
    }
  }, {
    key: 'formatObject',
    value: function formatObject(object) {
      try {
        return JSON.stringify(object);
      } catch (e) {}

      return object;
    }
  }, {
    key: 'configure',
    value: function configure(config) {
      _loggerConfig = config;

      if (!Raven.isSetup()) {
        // Do not send errors to sentry if we are on localhost.
        if (document.location.hostname !== 'localhost') {
          Raven.config(_loggerConfig.SENTRY_URL).install();
          Raven.setTagsContext({
            version: _loggerConfig.VERSION
          });
        }
      }
    }

    /**
     * Log an exception to the console and send it to our tracker (raven).
     * @see https://github.com/getsentry/raven-js/blob/master/docs/integrations/react.rst
     *
     * @param ex
     * @param context
     */

  }, {
    key: 'logException',
    value: function logException(ex, context) {
      if (Raven.isSetup()) {
        // see https://docs.getsentry.com/hosted/clients/javascript/usage/#raven-js-additional-context
        Raven.captureException(ex, {
          extra: context
        });

        if (_loggerConfig.DISPLAY_REPORT_DIALOG) {
          console.log('DISPLAY_REPORT_DIALOG');
          // see https://docs.getsentry.com/hosted/clients/javascript/usage/#user-feedback
          Raven.showReportDialog();
        }
      }
      /* eslint no-console:0 */
      if (window.console && console.error) {
        console.error(ex);
      }
    }

    /**
     *
     * @param see Logger.UserRole
     * @param userId
     */

  }, {
    key: 'setUserContext',
    value: function setUserContext(userRole, userId) {
      if (Raven.isSetup()) {
        // https://docs.getsentry.com/hosted/clients/javascript/#adding-context
        Raven.setUserContext({
          userRole: userRole,
          id: userId
        });
      }
    }
  }, {
    key: 'clearUserContext',
    value: function clearUserContext() {
      if (Raven.isSetup()) {
        // https://docs.getsentry.com/hosted/clients/javascript/#adding-context
        Raven.setUserContext();
      }
    }
  }, {
    key: 'lastEventId',
    value: function lastEventId() {
      if (Raven.isSetup()) {
        return Raven.lastEventId();
      }
      return null;
    }
  }]);

  return Logger;
}();

Logger.UserRole = {
  RESTAURANT: 'restaurant', // TODO: change for pro.
  ANONYMOUS: 'anonymous'
};
Logger.LoggerLevel = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};
exports.default = Logger;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Notify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Notify = function () {
  function Notify() {
    _classCallCheck(this, Notify);
  }

  _createClass(Notify, null, [{
    key: 'error',
    value: function error(title) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      bootbox.alert({
        title: title,
        message: message,
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-danger'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'alert',
    value: function alert(message) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      bootbox.alert({
        title: 'Attention',
        message: message,
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-primary'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'confirmDelete',
    value: function confirmDelete(message, callback) {
      bootbox.confirm({
        message: message,
        buttons: {
          cancel: {
            label: _I18n2.default.tr('global.cancel')
          },
          confirm: {
            label: _I18n2.default.tr('global.delete'),
            className: 'btn-danger'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'confirmDeleteWithTitle',
    value: function confirmDeleteWithTitle(title, message, callback) {
      bootbox.confirm({
        title: title,
        message: message,
        buttons: {
          cancel: {
            label: _I18n2.default.tr('global.cancel')
          },
          confirm: {
            label: _I18n2.default.tr('global.delete'),
            className: 'btn-danger'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'confirmDeleteWithContent',
    value: function confirmDeleteWithContent(title, message, callback) {
      bootbox.confirm({
        title: title,
        message: _lodash2.default.isEmpty(message) ? ' ' : message,
        buttons: {
          cancel: {
            label: _I18n2.default.tr('global.cancel')
          },
          confirm: {
            label: _I18n2.default.tr('global.delete'),
            className: 'btn-danger'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'confirm',
    value: function confirm(message, callback) {
      bootbox.confirm({
        message: message,
        buttons: {
          cancel: {
            label: _I18n2.default.tr('global.cancel')
          },
          confirm: {
            label: _I18n2.default.tr('global.confirm'),
            className: 'btn-primary'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'message',
    value: function message(_message, callback) {
      bootbox.alert({
        message: _message,
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-primary'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'messageWithTitle',
    value: function messageWithTitle(title, message, callback) {
      bootbox.alert({
        title: title,
        message: message,
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-primary'
          }
        },
        callback: callback
      });
    }
  }, {
    key: 'prompt',
    value: function prompt(title, callback) {
      bootbox.prompt({
        title: title,
        callback: callback,
        buttons: {
          cancel: {
            label: _I18n2.default.tr('global.cancel')
          },
          confirm: {
            label: 'Ok',
            className: 'btn-primary'
          }
        }
      });
    }
  }, {
    key: 'promptWithValue',
    value: function promptWithValue(title, value, callback) {
      bootbox.prompt({
        title: title,
        value: value,
        callback: callback,
        buttons: {
          cancel: {
            label: _I18n2.default.tr('global.cancel')
          },
          confirm: {
            label: 'Ok',
            className: 'btn-primary'
          }
        }
      });
    }
  }]);

  return Notify;
}();

exports.default = Notify;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/ObjectUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var setForPath = function setForPath(obj, arr, val) {
  if (typeof arr == 'string') {
    arr = arr.split(".");
  }

  obj[arr[0]] = obj[arr[0]] || {};

  var tmpObj = obj[arr[0]];

  if (arr.length > 1) {
    arr.shift();
    setForPath(tmpObj, arr, val);
  } else {
    obj[arr[0]] = val;
  }

  return obj;
};

var getForPath = function getForPath(obj, arr) {
  if (typeof arr == 'string') {
    arr = arr.split(".");
  }

  if (!obj) {
    return null;
  }

  var tmpObj = obj[arr[0]];

  if (arr.length > 1) {
    arr.shift();
    return getForPath(tmpObj, arr);
  }

  return obj[arr];
};

exports.default = {

  setForPath: setForPath,

  getForPath: getForPath

};
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/OrderViewUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _order = __webpack_require__("./sdk/scripts/entities/order/index.js");

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiConstants = __webpack_require__("./sdk/scripts/constants/ApiConstants.js");

var _ApiConstants2 = _interopRequireDefault(_ApiConstants);

var _utils = __webpack_require__("./sdk/scripts/utils/index.js");

var _SvgIcon = __webpack_require__("./sdk/scripts/components/SvgIcon.js");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderViewUtils = function () {
  function OrderViewUtils() {
    _classCallCheck(this, OrderViewUtils);
  }

  _createClass(OrderViewUtils, null, [{
    key: 'getLabelForPlatform',
    value: function getLabelForPlatform(platform) {
      switch (platform) {
        case _ApiConstants2.default.Platform.IOS:
          return _I18n2.default.tr('order.source.platform.IOS');
        case _ApiConstants2.default.Platform.ANDROID:
          return _I18n2.default.tr('order.source.platform.ANDROID');
        case _ApiConstants2.default.Platform.BACK_OFFICE_WEB:
          return _I18n2.default.tr('order.source.platform.BACK_OFFICE_WEB');
        case _ApiConstants2.default.Platform.PLUGIN_WEB:
          return _I18n2.default.tr('order.source.platform.PLUGIN_WEB');
        case _ApiConstants2.default.Platform.BOT:
          return _I18n2.default.tr('order.source.platform.BOT');
        case _ApiConstants2.default.Platform.POS:
          return _I18n2.default.tr('order.source.platform.POS');
        case _ApiConstants2.default.Platform.KIOSK:
          return _I18n2.default.tr('order.source.platform.KIOSK');
        case _ApiConstants2.default.Platform.OTHER:
          return _I18n2.default.tr('order.source.platform.OTHER');
        default:
          return null;
      }
    }
  }, {
    key: 'getLabelForMode',
    value: function getLabelForMode(mode) {
      switch (mode) {
        case _order.Order.OrderMode.ON_SITE:
          return _I18n2.default.tr('order.on_site');
        case _order.Order.OrderMode.TAKE_AWAY:
          return _I18n2.default.tr('order.take_away');
        case _order.Order.OrderMode.DELIVERY:
          return _I18n2.default.tr('order.delivery');
        default:
          _utils.Logger.warning('OrderViewUtils', 'getLabelForMode: invalid mode ' + mode);
          return '';
      }
    }
  }, {
    key: 'getIconForMode',
    value: function getIconForMode(mode) {
      switch (mode) {
        case _order.Order.OrderMode.ON_SITE:
          return _SvgIcon2.default.ORDER_ON_SITE;
        case _order.Order.OrderMode.TAKE_AWAY:
          return _SvgIcon2.default.ORDER_TAKE_AWAY;
        case _order.Order.OrderMode.DELIVERY:
          return _SvgIcon2.default.ORDER_DELIVERY;
        default:
          _utils.Logger.warning('OrderViewUtils', 'getIconForMode: invalid mode ' + mode);
          return '';
      }
    }
  }, {
    key: 'getStatusLabel',
    value: function getStatusLabel(status) {
      switch (status) {
        case _order.Order.OrderStatus.CREATED:
          return 'CREATED';
        case _order.Order.OrderStatus.SENT:
          return 'En attente';
        case _order.Order.OrderStatus.RECEIVED:
          return 'Acceptée';
        // case Order.OrderStatus.PRODUCING:
        // return 'En production';
        case _order.Order.OrderStatus.READY:
          return 'Prête';
        case _order.Order.OrderStatus.IN_DELIVERY:
          return 'En livraison';
        case _order.Order.OrderStatus.DELIVERED:
          return 'Récupérée';
        case _order.Order.OrderStatus.CANCELED:
          return 'Annulée';
        case _order.Order.OrderStatus.FAILED:
          return 'Erreur';
        default:
          _utils.Logger.warning('OrderViewUtils', 'getStatusLabel: invalid status ' + status);
          return '';
      }
    }
  }]);

  return OrderViewUtils;
}();

exports.default = OrderViewUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/PhoneUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _StringUtils = __webpack_require__("./sdk/scripts/utils/StringUtils.js");

var _StringUtils2 = _interopRequireDefault(_StringUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PhoneNumberFormat = __webpack_require__("./node_modules/google-libphonenumber/dist/browser/libphonenumber.js").PhoneNumberFormat;
var PhoneNumberUtil = __webpack_require__("./node_modules/google-libphonenumber/dist/browser/libphonenumber.js").PhoneNumberUtil.getInstance();

/**
 * Tools to manipulate phone numbers.
 * Use https://github.com/seegno/google-libphonenumber, abstract of
 * https://github.com/googlei18n/libphonenumber
 */
var PhoneUtils = function () {
  function PhoneUtils() {
    _classCallCheck(this, PhoneUtils);
  }

  _createClass(PhoneUtils, null, [{
    key: 'format',
    value: function format(number) {
      if (_lodash2.default.isNull(number) || number.length <= PhoneUtils.MIN_LENGHT_FOR_NUMBER) {
        return number;
      }
      try {
        var phoneNumber = PhoneNumberUtil.parse(number);
        return PhoneNumberUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
      } catch (e) {
        console.log(e);
      }

      return number;
    }
  }, {
    key: 'isValid',
    value: function isValid(number) {
      if (_lodash2.default.isNull(number) || number.length <= PhoneUtils.MIN_LENGHT_FOR_NUMBER) {
        return false;
      }

      try {
        var phoneNumber = PhoneNumberUtil.parse(number);
        return PhoneNumberUtil.isValidNumber(phoneNumber);
      } catch (e) {
        console.log(e);
      }

      return false;
    }

    /**
     *
     * @param number
     * @param countryIso
     * @returns {*}
     */

  }, {
    key: 'parseWithIso',
    value: function parseWithIso(number, countryIso) {
      var countryCode = PhoneNumberUtil.getCountryCodeForRegion(countryIso);
      var parsedPhone = number;

      if (!_lodash2.default.isEmpty(number)) {
        try {
          var phoneNumber = PhoneNumberUtil.parse(number, countryIso.toUpperCase());
          parsedPhone = PhoneNumberUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
        } catch (e) {
          console.log(e);
        }
      }

      return {
        country_code: countryCode,
        national_number: parsedPhone
      };
    }
  }, {
    key: 'getCountryIndicatorFromNumber',
    value: function getCountryIndicatorFromNumber(number) {
      if (!_lodash2.default.isEmpty(number)) {
        try {
          var phoneNumber = PhoneNumberUtil.parse(number, '');
          return phoneNumber.getCountryCode();
        } catch (e) {
          console.log(e);
        }
      }
      return null;
    }
  }, {
    key: 'getCountryIsoForNumber',
    value: function getCountryIsoForNumber(number) {
      if (!_lodash2.default.isEmpty(number)) {
        try {
          var phoneNumber = PhoneNumberUtil.parse(number, '');
          https: //github.com/googlei18n/libphonenumber/blob/master/javascript/i18n/phonenumbers/phonenumberutil.js#L2851

          return PhoneNumberUtil.getRegionCodeForNumber(phoneNumber);
        } catch (e) {
          console.log(e);
        }
      }

      return null;
    }
  }, {
    key: 'removeIndicatorOnPhoneNumber',
    value: function removeIndicatorOnPhoneNumber(phoneNumber) {
      if (!_lodash2.default.isEmpty(phoneNumber)) {
        var haveIndicator = phoneNumber.indexOf('+') !== -1;

        if (haveIndicator !== -1) {
          var firstSpaceIndex = phoneNumber.indexOf(' ');
          return phoneNumber.substring(firstSpaceIndex + 1);
        }
      }

      return phoneNumber;
    }

    /**
     * Inspired by https://github.com/PayMyTable/pmt_AppEngine/blob/develop/ws/src/main/java/com/paymytable/utils/PhoneUtils.java
     */

  }, {
    key: 'cleanForApi',
    value: function cleanForApi(phoneNumber) {
      if (_lodash2.default.isNil(phoneNumber)) {
        return '';
      }
      var cleanPhoneNumber = PhoneUtils.format(phoneNumber);
      console.log('after format', cleanPhoneNumber);

      if (cleanPhoneNumber.indexOf("+330") === 0) {
        cleanPhoneNumber = cleanPhoneNumber.replace("+330", "+33");
      }

      if (cleanPhoneNumber.indexOf("06") === 0) {
        cleanPhoneNumber = cleanPhoneNumber.replace("06", "+336");
      }

      if (cleanPhoneNumber.indexOf("07") === 0) {
        cleanPhoneNumber = cleanPhoneNumber.replace("07", "+337");
      }

      // removeAllSpaces
      cleanPhoneNumber = _StringUtils2.default.replaceAll(cleanPhoneNumber, ' ', '');

      return cleanPhoneNumber;
    }
  }]);

  return PhoneUtils;
}();

PhoneUtils.MIN_LENGHT_FOR_NUMBER = 3;
exports.default = PhoneUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/ScriptCache.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * See https://gist.github.com/auser/1d55aa3897f15d17caf21dc39b85b663
 *  The backbone of this method which asynchronously loads JavaScript <script> tags on a page. It will only load a single <script> tag on a page per-script tag declaration. If it's already loaded on a page, it calls the callback from the onLoad event immediately.
 */
var counter = 0;
var scriptMap = new Map();

var ScriptCache = exports.ScriptCache = function (global) {
  return function ScriptCache(scripts) {
    var Cache = {};

    Cache._onLoad = function (key) {
      return function (cb) {
        var stored = scriptMap.get(key);
        if (stored) {
          stored.promise.then(function () {
            stored.error ? cb(stored.error) : cb(null, stored);
          });
        } else {
          // TODO:
        }
      };
    };

    Cache._scriptTag = function (key, src) {
      if (!scriptMap.has(key)) {
        var tag = document.createElement('script');
        var promise = new Promise(function (resolve, reject) {
          var resolved = false,
              errored = false,
              body = document.getElementsByTagName('body')[0];

          tag.type = 'text/javascript';
          tag.async = false; // Load in order

          var cbName = 'loaderCB' + counter++ + Date.now();
          var cb = void 0;

          var handleResult = function handleResult(state) {
            return function (evt) {
              console.log('script cache handleResult: ', key, state);

              var stored = scriptMap.get(key);
              if (state === 'loaded') {
                stored.resolved = true;
                resolve(src);
                // stored.handlers.forEach(h => h.call(null, stored))
                // stored.handlers = []
              } else if (state === 'error') {
                stored.errored = true;
                // stored.handlers.forEach(h => h.call(null, stored))
                // stored.handlers = [];
                reject(evt);
              }

              cleanup();
            };
          };

          var cleanup = function cleanup() {
            if (global[cbName] && typeof global[cbName] === 'function') {
              global[cbName] = null;
            }
          };

          tag.onload = handleResult('loaded');
          tag.onerror = handleResult('error');
          tag.onreadystatechange = function () {
            handleResult(tag.readyState);
          };

          // Pick off callback, if there is one
          if (src.match(/callback=CALLBACK_NAME/)) {
            src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
            cb = window[cbName] = tag.onload;
          } else {
            tag.addEventListener('load', tag.onload);
          }
          tag.addEventListener('error', tag.onerror);

          tag.src = src;
          body.appendChild(tag);
          return tag;
        });
        var initialState = {
          loaded: false,
          error: false,
          promise: promise,
          tag: tag
        };
        scriptMap.set(key, initialState);
      }
      return scriptMap.get(key);
    };

    Object.keys(scripts).forEach(function (key) {
      var script = scripts[key];
      Cache[key] = {
        tag: Cache._scriptTag(key, script),
        onLoad: Cache._onLoad(key)
      };
    });

    return Cache;
  };
}(window);

exports.default = ScriptCache;

/***/ }),

/***/ "./sdk/scripts/utils/SdkConfiguration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class contains all the configuration for the sdk.
 */
var SdkConfiguration = function () {
  function SdkConfiguration() {
    _classCallCheck(this, SdkConfiguration);
  }

  _createClass(SdkConfiguration, [{
    key: "setDomainUrl",


    /**
     * Contains the current domain of the front.
     * Used to set absolute path for resources (pictures, etc)
     */
    value: function setDomainUrl(domain) {
      this.domainUrl = domain;
    }
  }, {
    key: "getDomainUrl",
    value: function getDomainUrl() {
      return this.domainUrl;
    }
  }]);

  return SdkConfiguration;
}();

exports.default = new SdkConfiguration();
module.exports = exports["default"];

/***/ }),

/***/ "./sdk/scripts/utils/SessionUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionUtils = function () {
  function SessionUtils() {
    _classCallCheck(this, SessionUtils);
  }

  _createClass(SessionUtils, null, [{
    key: 'saveObjectToSession',
    value: function saveObjectToSession(key, object) {
      var json = JSON.stringify(object);
      localStorage.setItem(key, json);
    }

    /**
     * @param key see Constant.Session
     * @param value the value to save on the session
     */

  }, {
    key: 'saveItemToSession',
    value: function saveItemToSession(key, value) {
      //    console.log('[SESSION] SAVE ', key, ' : ', value);
      SessionUtils.saveObjectToSession(key, value);
    }

    /**
     * @param key see Constant.Session
     * @param defaultValue
     */

  }, {
    key: 'getItemFromSession',
    value: function getItemFromSession(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var value = SessionUtils.getObjectFromSession(key, defaultValue);
      //    console.log('[SESSION] GET ', key, ' : ', value);
      return value;
    }
  }, {
    key: 'getObjectFromSession',
    value: function getObjectFromSession(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var obj = localStorage.getItem(key);

      var value = null;

      // default value
      if (_lodash2.default.isUndefined(obj) || _lodash2.default.isNull(obj)) {
        if (!_lodash2.default.isUndefined(defaultValue) && !_lodash2.default.isNull(defaultValue)) {
          value = defaultValue;
        }
      } else {
        try {
          value = JSON.parse(obj);
        } catch (e) {
          value = obj;
        }
      }

      return value;
    }
  }, {
    key: 'getFloatItemFromSession',
    value: function getFloatItemFromSession(key) {
      var defaultReturn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var value = this.getObjectFromSession(key);

      // default value
      if (_lodash2.default.isNil(value) || _lodash2.default.isNaN(value)) {
        if (!_lodash2.default.isUndefined(defaultReturn) && !_lodash2.default.isNull(defaultReturn)) {
          value = defaultReturn;
        } else {
          value = 0;
        }
      }
      //    console.log('[SESSION] GET ', key, ' : ', value);
      var intValue = parseFloat(value);
      if (_lodash2.default.isNaN(intValue)) {
        return defaultReturn;
      }
      return intValue;
    }
  }, {
    key: 'getIntItemFromSession',
    value: function getIntItemFromSession(key) {
      var defaultReturn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var value = localStorage.getItem(key);

      // default value
      if (_lodash2.default.isUndefined(value) || _lodash2.default.isNull(value) || _lodash2.default.isNaN(value)) {
        if (!_lodash2.default.isUndefined(defaultReturn) && !_lodash2.default.isNull(defaultReturn)) {
          value = defaultReturn;
        } else {
          value = 0;
        }
      }

      var intValue = parseInt(value, 10);
      if (_lodash2.default.isNaN(intValue)) {
        return defaultReturn;
      }
      return intValue;
    }
  }]);

  return SessionUtils;
}();

exports.default = SessionUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Sha1.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
/*  SHA-1 implementation in JavaScript | (c) Chris Veness 2002-2010 | www.movable-type.co.uk      */
/*   - see http://csrc.nist.gov/groups/ST/toolkit/secure_hashing.html                             */
/*         http://csrc.nist.gov/groups/ST/toolkit/examples.html                                   */
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

var Sha1 = {}; // Sha1 namespace

/**
 * Generates SHA-1 hash of string
 *
 * @param {String} msg                String to be hashed
 * @param {Boolean} [utf8encode=true] Encode msg as UTF-8 before generating hash
 * @returns {String}                  Hash of msg as hex character string
 */
Sha1.hash = function (msg, utf8encode) {
  utf8encode = typeof utf8encode == 'undefined' ? true : utf8encode;

  // convert string to UTF-8, as SHA only deals with byte-streams
  if (utf8encode) msg = Utf8.encode(msg);

  // constants [§4.2.1]
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];

  // PREPROCESSING

  msg += String.fromCharCode(0x80); // add trailing '1' bit (+ 0's padding) to string [§5.1.1]

  // convert string msg into 512-bit/16-integer blocks arrays of ints [§5.2.1]
  var l = msg.length / 4 + 2; // length (in 32-bit integers) of msg + ‘1’ + appended length
  var N = Math.ceil(l / 16); // number of 16-integer-blocks required to hold 'l' ints
  var M = new Array(N);

  for (var i = 0; i < N; i++) {
    M[i] = new Array(16);
    for (var j = 0; j < 16; j++) {
      // encode 4 chars per integer, big-endian encoding
      M[i][j] = msg.charCodeAt(i * 64 + j * 4) << 24 | msg.charCodeAt(i * 64 + j * 4 + 1) << 16 | msg.charCodeAt(i * 64 + j * 4 + 2) << 8 | msg.charCodeAt(i * 64 + j * 4 + 3);
    } // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
  }
  // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
  // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
  // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
  M[N - 1][14] = (msg.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (msg.length - 1) * 8 & 0xffffffff;

  // set initial hash value [§5.3.1]
  var H0 = 0x67452301;
  var H1 = 0xefcdab89;
  var H2 = 0x98badcfe;
  var H3 = 0x10325476;
  var H4 = 0xc3d2e1f0;

  // HASH COMPUTATION [§6.1.2]

  var W = new Array(80);
  var a, b, c, d, e;
  for (var _i = 0; _i < N; _i++) {
    // 1 - prepare message schedule 'W'
    for (var t = 0; t < 16; t++) {
      W[t] = M[_i][t];
    }for (var u = 16; u < 80; u++) {
      W[u] = Sha1.ROTL(W[u - 3] ^ W[u - 8] ^ W[u - 14] ^ W[u - 16], 1);
    } // 2 - initialise five working variables a, b, c, d, e with previous hash value
    a = H0;
    b = H1;
    c = H2;
    d = H3;
    e = H4;

    // 3 - main loop
    for (var v = 0; v < 80; v++) {
      var s = Math.floor(v / 20); // seq for blocks of 'f' functions and 'K' constants
      var T = Sha1.ROTL(a, 5) + Sha1.f(s, b, c, d) + e + K[s] + W[v] & 0xffffffff;
      e = d;
      d = c;
      c = Sha1.ROTL(b, 30);
      b = a;
      a = T;
    }

    // 4 - compute the new intermediate hash value
    H0 = H0 + a & 0xffffffff; // note 'addition modulo 2^32'
    H1 = H1 + b & 0xffffffff;
    H2 = H2 + c & 0xffffffff;
    H3 = H3 + d & 0xffffffff;
    H4 = H4 + e & 0xffffffff;
  }

  return Sha1.toHexStr(H0) + Sha1.toHexStr(H1) + Sha1.toHexStr(H2) + Sha1.toHexStr(H3) + Sha1.toHexStr(H4);
};

//
// function 'f' [§4.1.1]
//
Sha1.f = function (s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z; // Ch()
    case 1:
      return x ^ y ^ z; // Parity()
    case 2:
      return x & y ^ x & z ^ y & z; // Maj()
    case 3:
      return x ^ y ^ z; // Parity()
    default:
      return null;
  }
};

//
// rotate left (circular left shift) value x by n positions [§3.2.5]
//
Sha1.ROTL = function (x, n) {
  return x << n | x >>> 32 - n;
};

//
// hexadecimal representation of a number
//   (note toString(16) is implementation-dependant, and
//   in IE returns signed numbers when used on full words)
//
Sha1.toHexStr = function (n) {
  var s = '',
      v;
  for (var i = 7; i >= 0; i--) {
    v = n >>> i * 4 & 0xf;
    s += v.toString(16);
  }
  return s;
};

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
/*  Utf8 class: encode / decode between multi-byte Unicode characters and UTF-8 multiple          */
/*              single-byte character encoding (c) Chris Veness 2002-2010                         */
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

var Utf8 = {}; // Utf8 namespace

/**
 * Encode multi-byte Unicode string into utf-8 multiple single-byte characters
 * (BMP / basic multilingual plane only)
 *
 * Chars in range U+0080 - U+07FF are encoded in 2 chars, U+0800 - U+FFFF in 3 chars
 *
 * @param {String} strUni Unicode string to be encoded as UTF-8
 * @returns {String} encoded string
 */
Utf8.encode = function (strUni) {
  // use regular expressions & String.replace callback function for better efficiency
  // than procedural approaches
  var strUtf = strUni.replace(/[\u0080-\u07ff]/g, // U+0080 - U+07FF => 2 bytes 110yyyyy, 10zzzzzz
  function (c) {
    var cc = c.charCodeAt(0);
    return String.fromCharCode(0xc0 | cc >> 6, 0x80 | cc & 0x3f);
  });
  strUtf = strUtf.replace(/[\u0800-\uffff]/g, // U+0800 - U+FFFF => 3 bytes 1110xxxx, 10yyyyyy, 10zzzzzz
  function (c) {
    var cc = c.charCodeAt(0);
    return String.fromCharCode(0xe0 | cc >> 12, 0x80 | cc >> 6 & 0x3f, 0x80 | cc & 0x3f);
  });
  return strUtf;
};

/**
 * Decode utf-8 encoded string back into multi-byte Unicode characters
 *
 * @param {String} strUtf UTF-8 string to be decoded back to Unicode
 * @returns {String} decoded string
 */
Utf8.decode = function (strUtf) {
  // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
  var strUni = strUtf.replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g, // 3-byte chars
  function (c) {
    // (note parentheses for precence)
    var cc = (c.charCodeAt(0) & 0x0f) << 12 | (c.charCodeAt(1) & 0x3f) << 6 | c.charCodeAt(2) & 0x3f;
    return String.fromCharCode(cc);
  });
  strUni = strUni.replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, // 2-byte chars
  function (c) {
    // (note parentheses for precence)
    var cc = (c.charCodeAt(0) & 0x1f) << 6 | c.charCodeAt(1) & 0x3f;
    return String.fromCharCode(cc);
  });
  return strUni;
};

exports.default = Sha1;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/StringUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Diacritics = __webpack_require__("./sdk/scripts/utils/Diacritics.js");

var _Diacritics2 = _interopRequireDefault(_Diacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StringUtils = function () {
  function StringUtils() {
    _classCallCheck(this, StringUtils);
  }

  _createClass(StringUtils, null, [{
    key: 'toAlphaNum',


    /**
     * Remove all non-alphanumeric chars.
     * @type {[type]}
     */
    value: function toAlphaNum(str) {
      if (_lodash2.default.isEmpty(str)) {
        return '';
      }
      // see http://stackoverflow.com/questions/9364400/remove-not-alphanumeric-characters-from-string-having-trouble-with-the-char
      return str.replace(/\W/g, '');
    }

    /**
     * Remove all non-numeric chars.
     * @type {[type]}
     */

  }, {
    key: 'toNum',
    value: function toNum(str) {
      if (_lodash2.default.isEmpty(str)) {
        return '';
      }

      // see http://stackoverflow.com/questions/1862130/strip-non-numeric-characters-from-string
      return str.replace(/\D/g, '');
    }
  }, {
    key: 'searchStringOn',
    value: function searchStringOn(search, value) {
      if (_lodash2.default.isEmpty(search)) {
        return true;
      }

      // to lower case, replace accents by the corresponding letter and then remove all non-alpha characters.
      var searchFormatted = _Diacritics2.default.replaceDiacritics(search.toLowerCase()).replace(/\W/g, '');
      var valueFormatted = _Diacritics2.default.replaceDiacritics(value.toLowerCase()).replace(/\W/g, '');

      return valueFormatted.indexOf(searchFormatted) >= 0;
    }
  }, {
    key: 'replaceAll',
    value: function replaceAll(target, search, replacement) {
      if (_lodash2.default.isEmpty(target)) {
        return '';
      }
      return target.replace(new RegExp(search, 'g'), replacement);
    }
  }, {
    key: 'removeAtEnd',
    value: function removeAtEnd(target, search) {
      if (_lodash2.default.isEmpty(target)) {
        return '';
      }
      if (target.lastIndexOf(search) === target.length - search.length) {
        return target.substring(0, target.length - search.length);
      }

      return target;
    }
  }]);

  return StringUtils;
}();

exports.default = StringUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Old way: TODO: migrate to flow syntax on /flow/directory
//

exports.SuccessCallback = Function; // (json:Object) => void;
exports.FailureCallback = Function; // (apiError: ApiError) => void;

exports.Moment = Object; // moment object

// To specify the enum (see BookingConstants#BookingPeriod)
exports.BookingPeriod = Number;

/***/ }),

/***/ "./sdk/scripts/utils/UrlUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UrlUtils = function () {
  function UrlUtils() {
    _classCallCheck(this, UrlUtils);
  }

  _createClass(UrlUtils, null, [{
    key: 'getPrettyUrl',


    /**
     * Different params that can be handled by our apps
     */
    value: function getPrettyUrl(url) {
      if (_lodash2.default.isEmpty(url)) {
        return '';
      }
      if (url.indexOf('https://') === 0) {
        return url.slice('https://'.length);
      }
      if (url.indexOf('http://') === 0) {
        return url.slice('http://'.length);
      }
      return url;
    }

    /**
     * Used to notify an event when redirect to the callback_uri
     */

  }, {
    key: 'getDomainUrl',
    value: function getDomainUrl(url) {
      if (_lodash2.default.isEmpty(url)) {
        return '';
      }
      var domain = '';

      // find & remove protocol (http, ftp, etc.) and get domain
      if (url.indexOf('://') > -1) {
        domain = url.split('/')[2];
      } else {
        domain = url.split('/')[0];
      }

      // find & remove port number
      domain = domain.split(':')[0];

      return domain;
    }

    /**
     * Add `https://` on the given url if not exists.
     */

  }, {
    key: 'toValidUrl',
    value: function toValidUrl(url) {
      if (url.indexOf('://') === -1) {
        return 'https://' + url;
      }

      return url;
    }
  }, {
    key: 'getQueryParam',
    value: function getQueryParam(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

      name = name.replace(/[\[\]]/g, '\\$&');

      var regex = new RegExp("[?&]" + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }, {
    key: 'formatCallbackUri',
    value: function formatCallbackUri(callbackUri, event) {
      return callbackUri.indexOf('?') === -1 ? callbackUri + '?event=' + event : callbackUri + '&event=' + event;
    }
  }]);

  return UrlUtils;
}();

UrlUtils.params = {
  CALLBACK_URI: 'callbackUri',
  ACCESS_TOKEN: 'accessToken',
  CLIENT_ID: 'clientId' };
UrlUtils.callbackEvents = {
  NO_PREVIOUS_PAGE: 'NO_PREVIOUS_PAGE',
  INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
  NEW_ORDER: 'NEW_ORDER'
};
exports.default = UrlUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utils = function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: 'generateUID',
    value: function generateUID() {
      return ((0, _moment2.default)().unix() + '_' + Math.floor((1 + Math.random()) * 0x10000).toString(16)).replace('.', '');
    }
  }]);

  return Utils;
}();

exports.default = Utils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/Validation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validation = function () {
  function Validation() {
    _classCallCheck(this, Validation);
  }

  _createClass(Validation, null, [{
    key: 'url',
    value: function url(value) {
      // Copyright (c) 2010-2013 Diego Perini, MIT licensed
      // https://gist.github.com/dperini/729294
      // see also https://mathiasbynens.be/demo/url-regex
      // modified to allow protocol-relative URLs
      return Validation.regexWebUrl.test(value);
    }
  }, {
    key: 'email',
    value: function email(value) {
      return Validation.regexEmail.test(value);
    }
  }, {
    key: 'phone',
    value: function phone(value) {
      return Validation.regexPhone.test(value);
    }
  }, {
    key: 'phonePrefixed',
    value: function phonePrefixed(value) {
      return Validation.regexPhonePrefixed.test(value);
    }
  }]);

  return Validation;
}();

Validation.regexEmail = new RegExp('.+@([A-Za-z0-9-]+\\.)+[A-Za-z]{2}[A-Za-z]*');
Validation.regexPhone = new RegExp('^\\+(?:[0-9]●?){6,14}[0-9]$');
Validation.regexPhonePrefixed = new RegExp('[0-9]{9,14}');
Validation.regexWebUrl = new RegExp('^' +
// protocol identifier
'(?:(?:https?|ftp)://)' +
// user:pass authentication
'(?:\\S+(?::\\S*)?@)?' + '(?:' +
// IP address exclusion
// private & local networks
'(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
// IP address dotted notation octets
// excludes loopback network 0.0.0.0
// excludes reserved space >= 224.0.0.0
// excludes network & broacast addresses
// (first & last IP address of each class)
'(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' +
// host name
'(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
// domain name
'(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
// TLD identifier
'(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
// TLD may end with dot
'\\.?' + ')' +
// port number
'(?::\\d{2,5})?' +
// resource path
'(?:[/?#]\\S*)?' + '$', 'i');
exports.default = Validation;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/ViewUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

// TODO: SDK
// import ViewConstants from '../constants/ViewConstants';

var _lodash = __webpack_require__("./sdk/node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _PhoneUtils = __webpack_require__("./sdk/scripts/utils/PhoneUtils.js");

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

var _CurrencyUtils = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _decorators = __webpack_require__("./sdk/scripts/decorators/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ViewUtils = (_class = function () {
  function ViewUtils() {
    _classCallCheck(this, ViewUtils);
  }

  _createClass(ViewUtils, null, [{
    key: 'formatPriceWithCurrency',
    value: function formatPriceWithCurrency(price, currency) {
      return _CurrencyUtils2.default.formatPriceWithCurrency(price, currency);
    }
  }, {
    key: 'formatPrice',
    value: function formatPrice(price) {
      return _CurrencyUtils2.default.formatPrice(price);
    }
  }, {
    key: 'formatTax',
    value: function formatTax(tax) {
      return _CurrencyUtils2.default.formatTax(tax);
    }
  }, {
    key: 'cutString',
    value: function cutString(str, length) {
      if (_lodash2.default.isUndefined(str) || _lodash2.default.isNull(str)) {
        return '';
      }
      var res = str.substring(0, length);
      if (str.length > length) {
        res += '...';
      }
      return res;
    }
  }, {
    key: 'isValidColor',
    value: function isValidColor(color) {
      return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color)
      );
    }
  }, {
    key: 'isVeryLightColor',
    value: function isVeryLightColor(color) {
      return this.getHsp(color) > 230;
    }
  }, {
    key: 'isLightColor',
    value: function isLightColor(color) {
      return this.getHsp(color) > 190; //127.5;
    }
  }, {
    key: 'isDarkColor',
    value: function isDarkColor(color) {
      return !this.isLightColor(color);
    }
  }, {
    key: 'getHsp',
    value: function getHsp(color) {
      var validColor = color;
      // handle is not hexa color but uint.
      if (!isNaN(parseInt(color, 10))) {
        validColor = this.uintColorToHexadecimal(color);
      } else if (_lodash2.default.isNull(color) || _lodash2.default.isEmpty(color)) {
        console.error('invalid color string', color);
        return 360 / 2; // median
      }

      var rgbColor = this.hexadecimalColorToRgba(validColor);
      var r = rgbColor.r;
      var b = rgbColor.b;
      var g = rgbColor.g;

      var hsp = Math.sqrt( // HSP equation from http://alienryderflex.com/hsp.html
      0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

      return hsp;
    }

    // -- Color conversion

    /**
     * see http://stackoverflow.com/questions/57803/how-to-convert-decimal-to-hex-in-javascript
     * @param color
     * @returns {String}
     */

  }, {
    key: 'uintColorToHexadecimal',
    value: function uintColorToHexadecimal(color) {
      return '#' + ('000000' + (color & 0xFFFFFF).toString(16)).slice(-6);
    }
  }, {
    key: 'rgbaToUint',
    value: function rgbaToUint(rgba) {
      // TODO: alpha value does not work here.
      return rgba.a << 24 | rgba.r << 16 | rgba.g << 8 | rgba.b;
    }
  }, {
    key: 'hexadecimalColorToUint',
    value: function hexadecimalColorToUint(hex) {
      var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var rgba = this.hexadecimalColorToRgba(hex, opacity);
      return this.rgbaToUint(rgba);
    }
  }, {
    key: 'hexadecimalColorToRgba',
    value: function hexadecimalColorToRgba(hex) {
      var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (_lodash2.default.isEmpty(hex)) {
        return {
          r: 0,
          g: 0,
          b: 0,
          a: 1
        };
      }
      if (hex[0] !== '#') {
        // in case we pass a uint value.
        return hex;
      }
      var hexString = hex.replace('#', '');
      var r = parseInt(hexString.substring(0, 2), 16);
      var g = parseInt(hexString.substring(2, 4), 16);
      var b = parseInt(hexString.substring(4, 6), 16);

      return {
        r: r,
        g: g,
        b: b,
        a: opacity
      };
    }
  }, {
    key: 'hexadecimalColorToRgbaCssFormat',
    value: function hexadecimalColorToRgbaCssFormat(hex) {
      var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var rgba = this.hexadecimalColorToRgba(hex, opacity);
      return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a + ')';
    }
  }, {
    key: 'uintToRgba',
    value: function uintToRgba(color) {
      var a = color >> 24 & 255;
      var r = color >> 16 & 255;
      var g = color >> 8 & 255;
      var b = color >> 0 & 255;

      return {
        r: r,
        g: g,
        b: b,
        a: a
      };
    }
  }, {
    key: 'uintColorToRgbaFormat',
    value: function uintColorToRgbaFormat(value) {
      var rgba = this.uintToRgba(value);
      return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a + ')';
    }

    // --

    // TODO: SDK
    // static getDefaultColorListUint() {
    //   const hexList = ViewConstants.ColorPicker.DEFAULT_COLORS_LIST;
    //   const uintList = [];
    //
    //   _.each(hexList, (hexValue) => {
    //     uintList.push(ViewUtils.hexadecimalColorToUint(hexValue));
    //   });
    //
    //   return uintList;
    // }

    // -- Images

    /**
     * Transform a base64 string to a file.
     * see http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
     * @param dataUri
     */

  }, {
    key: 'dataUriToFile',
    value: function dataUriToFile(dataUri) {
      if (_lodash2.default.isNull(dataUri) || _lodash2.default.isUndefined(dataUri)) {
        console.error('invalid data uri to transform to file');
        return new Blob([], { type: 'picture/png' });
      }
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString = void 0;
      if (dataUri.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataUri.split(',')[1]);
      } else {
        byteString = unescape(dataUri.split(',')[1]);
      }

      // separate out the mime component
      var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    }
  }, {
    key: 'fileToDataUri',
    value: function fileToDataUri(file, callback) {
      var reader = new FileReader();

      reader.addEventListener('load', function () {
        // the result attribute contains  the data as a URL representing the file's data as a base64 encoded string
        callback(reader.result);
      }, false);

      reader.readAsDataURL(file);
    }
  }, {
    key: 'resizeBase64Img',
    value: function resizeBase64Img(base64, width, height) {
      var deferred = $.Deferred();

      function resize() {
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext('2d');

        // in case we receive a dataUri instead of a base64.
        var realBase64 = ViewUtils.dataUriToBase64(base64);

        $('<img/>').attr('src', 'data:image/png;base64,' + realBase64).on('load', function () {
          if (!_lodash2.default.isNil(context)) {
            context.drawImage(this, 0, 0, width, height);
          }
          deferred.resolve(canvas.toDataURL());
        });
      }

      resize();

      return deferred.promise();
    }
  }, {
    key: 'resizeCanvasImg',
    value: function resizeCanvasImg(canvas, width, height) {
      return ViewUtils.resizeBase64Img(canvas.toDataURL(), width, height);
    }
  }, {
    key: 'dataUriToBase64',
    value: function dataUriToBase64(dataURL) {
      return dataURL.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, '');
    }

    /*
     * @returns
     * true  - if page is currently using the breakpoint specified as argument
     * false - if otherwise
     */

  }, {
    key: 'isBreakpoint',
    value: function isBreakpoint(alias) {
      var className = 'device-breakpoint';
      var testingDiv = '\n      <div class=\'' + className + '\'><!-- mandatory -->\n      <div class="device-xs visible-xs"></div>\n      <div class="device-sm visible-sm"></div>\n      <div class="device-md visible-md"></div>\n      <div class="device-lg visible-lg"></div>\n      <!-- end mandatory --></div>\n    ';

      if (!$('body').find('.' + className).length) {
        $('body').append(testingDiv);
      }

      var result = $('.device-' + alias).is(':visible');

      return result;
    }
  }]);

  return ViewUtils;
}(), (_applyDecoratedDescriptor(_class, 'formatPriceWithCurrency', [_decorators.deprecated], Object.getOwnPropertyDescriptor(_class, 'formatPriceWithCurrency'), _class), _applyDecoratedDescriptor(_class, 'formatPrice', [_decorators.deprecated], Object.getOwnPropertyDescriptor(_class, 'formatPrice'), _class), _applyDecoratedDescriptor(_class, 'formatTax', [_decorators.deprecated], Object.getOwnPropertyDescriptor(_class, 'formatTax'), _class)), _class);
exports.default = ViewUtils;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/abstractMethod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _invariant = __webpack_require__("./sdk/scripts/utils/invariant.js");

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function abstractMethod(className, methodName) {
  (0, _invariant2.default)(false, 'Subclasses of %s must override %s() with their own implementation.', className, methodName);
}

/***/ }),

/***/ "./sdk/scripts/utils/apiErrors/KioskApiErrors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiErrorUtils = __webpack_require__("./sdk/scripts/utils/ApiErrorUtils.js");

var _ApiErrorUtils2 = _interopRequireDefault(_ApiErrorUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KioskApiErrors = function () {
  function KioskApiErrors() {
    _classCallCheck(this, KioskApiErrors);
  }

  _createClass(KioskApiErrors, null, [{
    key: 'put',
    value: function put(apiError) {
      var errors = {};

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'KioskApiErrors:put');
    }
  }, {
    key: 'get',
    value: function get(apiError) {
      var errors = {
        '102': 'Error while saving background image'
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'KioskApiErrors:get');
    }
  }]);

  return KioskApiErrors;
}();

exports.default = KioskApiErrors;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/apiErrors/MangoPayApiErrors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiErrorUtils = __webpack_require__("./sdk/scripts/utils/ApiErrorUtils.js");

var _ApiErrorUtils2 = _interopRequireDefault(_ApiErrorUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MangoPayApiErrors = function () {
  function MangoPayApiErrors() {
    _classCallCheck(this, MangoPayApiErrors);
  }

  _createClass(MangoPayApiErrors, null, [{
    key: 'registerCreditCart',


    /**
     * See https://docs.mangopay.com/guide/errors
     * Section: Tokenization / Card registration errors
     *
     * TODO: I18n
     */
    value: function registerCreditCart(apiError) {
      var errors = {
        '02625': 'Invalid card number',
        '02626': 'Invalid date',
        '02627': 'Invalid CCV number',
        '02101': 'Internal error',
        '01902': 'This card is not active',
        '02624': 'Card expired',
        '02631': 'Delay exceeded'
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'MangoPayApiErrors:registerCreditCart');
    }
  }]);

  return MangoPayApiErrors;
}();

exports.default = MangoPayApiErrors;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/apiErrors/OrderApiErrors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _ApiErrorUtils = __webpack_require__("./sdk/scripts/utils/ApiErrorUtils.js");

var _ApiErrorUtils2 = _interopRequireDefault(_ApiErrorUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderApiErrors = function () {
  function OrderApiErrors() {
    _classCallCheck(this, OrderApiErrors);
  }

  _createClass(OrderApiErrors, null, [{
    key: 'post',
    value: function post(apiError) {
      // General errors:
      // 101 - missing right to post order on behalf of someone else
      // 102 - Missing user address
      // 103 - User address not found
      // 104 - User address missing geoPt
      // 106 - user needs to verify his phone to use credit
      // 107 - payment card was not registered for currency
      // 109 - payment card not found
      // 110 - restaurant not found or restaurant legal not found
      // 112 - not enough credit
      // 114 - credit bigger than amount
      // 115 - amount + tips too low (<0.50)
      // 116 - amount + tips too high (>200.0)
      // 117 - cannot use credit when currency != EUR
      // 118 - unsupported POS
      // 118 - Restaurant menu not found
      // 118 - POS method not supported
      // 119 - Payment failed too many times in the last 5 minutes
      // 121 - Can't get Bank User with id
      // 124 - PayMyTable bank account doesn't exist
      // 124 - PayMyTable credit payment failed
      // 141 - POS rejected order
      // 142 - One or more items ordered does not match the restaurant menu
      //
      // Payment errors:
      // 125 - Payment failed (generic error)
      // 126 - Transaction refused by the bank (Do not honor)
      // 127 - Transaction refused by the bank (Amount limit)
      // 128 - Transaction refused by the terminal
      // 129 - Transaction refused by the bank (card limit reached)
      // 130 - The card has expired
      // 131 - The card is inactive
      // 132 - The card is not active
      // 133 - Maximum number of attempts reached
      // 134 - Maximum amount exceeded
      // 135 - Debit limit exceeded
      // 136 - Amount limit
      // 137 - Transaction refused
      // 138 - Payment failed
      //
      // POS errors:
      // 401 - POS generic error
      // 402 - POS error: table does not exist
      // 405 - POS error: product(s) out of stock
      // 406 - POS error: the till cannot be reached
      // 407 - POS error: the restaurant is closed
      // 408 - POS error: user account not found
      // 409 - POS error: user account problem

      var errors = {
        // General errors:
        '101': _I18n2.default.tr('api.error.order.post.101'),
        '102': _I18n2.default.tr('api.error.order.post.102'),
        '103': _I18n2.default.tr('api.error.order.post.103'),
        '104': _I18n2.default.tr('api.error.order.post.104'),
        '106': _I18n2.default.tr('api.error.order.post.106'),
        '107': _I18n2.default.tr('api.error.order.post.107'),
        '109': _I18n2.default.tr('api.error.order.post.109'),
        '110': _I18n2.default.tr('api.error.order.post.110'),
        '112': _I18n2.default.tr('api.error.order.post.112'),
        '114': _I18n2.default.tr('api.error.order.post.114'),
        '115': _I18n2.default.tr('api.error.order.post.115'),
        '117': _I18n2.default.tr('api.error.order.post.117'),
        '118': _I18n2.default.tr('api.error.order.post.118'),
        '119': _I18n2.default.tr('api.error.order.post.119'),
        '121': _I18n2.default.tr('api.error.order.post.121'),
        '124': _I18n2.default.tr('api.error.order.post.124'),
        '141': _I18n2.default.tr('api.error.order.post.141'),
        '142': _I18n2.default.tr('api.error.order.post.142'),

        // Payment errors:
        '125': _I18n2.default.tr('api.error.order.post.125'),
        '126': _I18n2.default.tr('api.error.order.post.126'),
        '127': _I18n2.default.tr('api.error.order.post.127'),
        '128': _I18n2.default.tr('api.error.order.post.128'),
        '129': _I18n2.default.tr('api.error.order.post.129'),
        '130': _I18n2.default.tr('api.error.order.post.130'),
        '131': _I18n2.default.tr('api.error.order.post.131'),
        '132': _I18n2.default.tr('api.error.order.post.132'),
        '133': _I18n2.default.tr('api.error.order.post.133'),
        '134': _I18n2.default.tr('api.error.order.post.134'),
        '135': _I18n2.default.tr('api.error.order.post.135'),
        '136': _I18n2.default.tr('api.error.order.post.136'),
        '137': _I18n2.default.tr('api.error.order.post.137'),

        // POS errors:
        '401': _I18n2.default.tr('api.error.order.post.401'),
        '402': _I18n2.default.tr('api.error.order.post.402'),
        '405': _I18n2.default.tr('api.error.order.post.405'),
        '406': _I18n2.default.tr('api.error.order.post.406'),
        '407': _I18n2.default.tr('api.error.order.post.407'),
        '408': _I18n2.default.tr('api.error.order.post.408'),
        '409': _I18n2.default.tr('api.error.order.post.409')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'OrderApiErrors:post');
    }
  }, {
    key: 'put',
    value: function put(apiError) {
      var errors = {
        '100': _I18n2.default.tr('api.error.order.put.100'), //Order not found
        '105': _I18n2.default.tr('api.error.order.put.105'), //Cannot change status of a canceled order
        '110': _I18n2.default.tr('api.error.order.put.110'), //No restaurant found
        '101': _I18n2.default.tr('api.error.order.put.101'), //Not your restaurant's order
        '103': _I18n2.default.tr('api.error.order.put.103'), //Payment not found for order
        '104': _I18n2.default.tr('api.error.order.put.104'), //User not found for order's payment
        '107': _I18n2.default.tr('api.error.order.put.107'), //Order payment cannot be refunded because money has been transferred to the restaurant already
        '106': _I18n2.default.tr('api.error.order.put.106') //User account not found for order's userAccountPayment
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'OrderApiErrors:put');
    }
  }, {
    key: 'delete',
    value: function _delete(apiError) {
      var errors = {};

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'OrderApiErrors:delete');
    }
  }]);

  return OrderApiErrors;
}();

exports.default = OrderApiErrors;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/apiErrors/ProRoleApiErrors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiErrorUtils = __webpack_require__("./sdk/scripts/utils/ApiErrorUtils.js");

var _ApiErrorUtils2 = _interopRequireDefault(_ApiErrorUtils);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProRoleApiErrors = function () {
  function ProRoleApiErrors() {
    _classCallCheck(this, ProRoleApiErrors);
  }

  _createClass(ProRoleApiErrors, null, [{
    key: 'getOne',
    value: function getOne(apiError) {
      var errors = {};

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'ProRoleApiErrors:getOne');
    }
  }]);

  return ProRoleApiErrors;
}();

exports.default = ProRoleApiErrors;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/apiErrors/UserApiErrors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiError = __webpack_require__("./sdk/scripts/entities/ApiError.js");

var _ApiError2 = _interopRequireDefault(_ApiError);

var _ApiErrorUtils = __webpack_require__("./sdk/scripts/utils/ApiErrorUtils.js");

var _ApiErrorUtils2 = _interopRequireDefault(_ApiErrorUtils);

var _I18n = __webpack_require__("./sdk/scripts/i18n/I18n.js");

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserApiErrors = function () {
  function UserApiErrors() {
    _classCallCheck(this, UserApiErrors);
  }

  _createClass(UserApiErrors, null, [{
    key: 'login',
    value: function login(apiError) {
      var errors = {
        '100': _I18n2.default.tr('api.error.user.login.100')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:login');
    }
  }, {
    key: 'postUser',
    value: function postUser(apiError) {
      // 100 - email already used
      // 104 - fid already used
      // 101 - incomplete profile
      // 103 - can’t create bank account
      // 106 - can’t create bank wallet
      // 105 - Unknow sponsorship
      // 107 - Phone already used

      var errors = {
        '100': _I18n2.default.tr('api.error.user.post.100'),
        '104': _I18n2.default.tr('api.error.user.post.104'),
        '101': _I18n2.default.tr('api.error.user.post.101'),
        '103': _I18n2.default.tr('api.error.user.post.103'),
        '106': _I18n2.default.tr('api.error.user.post.106'),
        '105': _I18n2.default.tr('api.error.user.post.105'),
        '107': _I18n2.default.tr('api.error.user.post.107'),
        '122': _I18n2.default.tr('api.error.user.post.122')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:postUser');
    }
  }, {
    key: 'putUser',
    value: function putUser(apiError) {
      // 120 - missing right to get user
      // 100 - email already used by another user
      // 101 - invalid email format
      // 117 - invalid password verification (wrong old password or password recovery)
      // 104 - invalid international phone number format
      // 103 - phone number already used by another user

      var errors = {
        '120': _I18n2.default.tr('api.error.user.put.120'),
        '100': _I18n2.default.tr('api.error.user.put.100'),
        '101': _I18n2.default.tr('api.error.user.put.101'),
        '117': _I18n2.default.tr('api.error.user.put.117'),
        '104': _I18n2.default.tr('api.error.user.put.104'),
        '103': _I18n2.default.tr('api.error.user.put.103')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:putUser');
    }
  }, {
    key: 'postCreditCard',
    value: function postCreditCard(apiError) {

      // 101 - User not found
      // 102 - User mismatch
      // 140 - Card registration exception
      // 141 - User card registration and User mismatch
      // 142 - Card registration status not VALIDATED
      // 143 - Card pre-authorization status not SUCCEEDED

      var errors = {
        '140': _I18n2.default.tr('api.error.user.credit_card.post.140')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:postCreditCard');
    }
  }, {
    key: 'getAddresses',
    value: function getAddresses(apiError) {
      var errors = {};

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:getAddresses');
    }
  }, {
    key: 'postAddress',
    value: function postAddress(apiError) {

      // 101 - User mismatch
      // 102 - Not allowed
      // 103 - User address not found
      // 104 - Missing address body
      // 105 - Address cannot be geocoded

      var errors = {
        '101': _I18n2.default.tr('api.error.address.post.101'),
        '102': _I18n2.default.tr('api.error.address.post.102'),
        '103': _I18n2.default.tr('api.error.address.post.103'),
        '104': _I18n2.default.tr('api.error.address.post.104'),
        '105': _I18n2.default.tr('api.error.address.post.105')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:postAddress');
    }
  }, {
    key: 'deleteCreditCard',
    value: function deleteCreditCard(apiError) {
      var errors = {};

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:deleteCreditCard');
    }
  }, {
    key: 'putAddress',
    value: function putAddress(apiError) {

      // 101 - User mismatch
      // 102 - Not allowed
      // 103 - User address not found
      // 104 - Missing address body
      // 105 - Address cannot be geocoded

      var errors = {
        '101': _I18n2.default.tr('api.error.address.put.101'),
        '102': _I18n2.default.tr('api.error.address.put.102'),
        '103': _I18n2.default.tr('api.error.address.put.103'),
        '104': _I18n2.default.tr('api.error.address.put.104'),
        '105': _I18n2.default.tr('api.error.address.put.105')
      };

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:putAddress');
    }
  }, {
    key: 'deleteAddress',
    value: function deleteAddress(apiError) {
      var errors = {};

      return _ApiErrorUtils2.default.findErrorOnArray(apiError, errors, 'UserApiErrors:deleteAddress');
    }
  }]);

  return UserApiErrors;
}();

exports.default = UserApiErrors;
module.exports = exports['default'];

/***/ }),

/***/ "./sdk/scripts/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewUtils = exports.Validation = exports.Utils = exports.UrlUtils = exports.Types = exports.StringUtils = exports.SessionUtils = exports.ScriptCache = exports.PhoneUtils = exports.OrderViewUtils = exports.Listener = exports.Notify = exports.Logger = exports.GoogleApi = exports.GmapUtils = exports.GeolocUtils = exports.Equals = exports.Diacritics = exports.DateUtils = exports.CurrencyUtils = exports.CountryData = exports.BookingViewUtils = exports.BookingUtils = exports.BitUtils = exports.ArrayUtils = exports.ApiErrorUtils = undefined;

var _ApiErrorUtils2 = __webpack_require__("./sdk/scripts/utils/ApiErrorUtils.js");

var _ApiErrorUtils3 = _interopRequireDefault(_ApiErrorUtils2);

var _ArrayUtils2 = __webpack_require__("./sdk/scripts/utils/ArrayUtils.js");

var _ArrayUtils3 = _interopRequireDefault(_ArrayUtils2);

var _BitUtils2 = __webpack_require__("./sdk/scripts/utils/BitUtils.js");

var _BitUtils3 = _interopRequireDefault(_BitUtils2);

var _BookingUtils2 = __webpack_require__("./sdk/scripts/utils/BookingUtils.js");

var _BookingUtils3 = _interopRequireDefault(_BookingUtils2);

var _BookingViewUtils2 = __webpack_require__("./sdk/scripts/utils/BookingViewUtils.js");

var _BookingViewUtils3 = _interopRequireDefault(_BookingViewUtils2);

var _CountryData2 = __webpack_require__("./sdk/scripts/utils/CountryData.js");

var _CountryData3 = _interopRequireDefault(_CountryData2);

var _CurrencyUtils2 = __webpack_require__("./sdk/scripts/utils/CurrencyUtils.js");

var _CurrencyUtils3 = _interopRequireDefault(_CurrencyUtils2);

var _DateUtils2 = __webpack_require__("./sdk/scripts/utils/DateUtils.js");

var _DateUtils3 = _interopRequireDefault(_DateUtils2);

var _Diacritics2 = __webpack_require__("./sdk/scripts/utils/Diacritics.js");

var _Diacritics3 = _interopRequireDefault(_Diacritics2);

var _Equals2 = __webpack_require__("./sdk/scripts/utils/Equals.js");

var _Equals3 = _interopRequireDefault(_Equals2);

var _GeolocUtils2 = __webpack_require__("./sdk/scripts/utils/GeolocUtils.js");

var _GeolocUtils3 = _interopRequireDefault(_GeolocUtils2);

var _GmapUtils2 = __webpack_require__("./sdk/scripts/utils/GmapUtils.js");

var _GmapUtils3 = _interopRequireDefault(_GmapUtils2);

var _GoogleApi2 = __webpack_require__("./sdk/scripts/utils/GoogleApi.js");

var _GoogleApi3 = _interopRequireDefault(_GoogleApi2);

var _Logger2 = __webpack_require__("./sdk/scripts/utils/Logger.js");

var _Logger3 = _interopRequireDefault(_Logger2);

var _Notify2 = __webpack_require__("./sdk/scripts/utils/Notify.js");

var _Notify3 = _interopRequireDefault(_Notify2);

var _Listener2 = __webpack_require__("./sdk/scripts/flux/Listener.js");

var _Listener3 = _interopRequireDefault(_Listener2);

var _OrderViewUtils2 = __webpack_require__("./sdk/scripts/utils/OrderViewUtils.js");

var _OrderViewUtils3 = _interopRequireDefault(_OrderViewUtils2);

var _PhoneUtils2 = __webpack_require__("./sdk/scripts/utils/PhoneUtils.js");

var _PhoneUtils3 = _interopRequireDefault(_PhoneUtils2);

var _ScriptCache2 = __webpack_require__("./sdk/scripts/utils/ScriptCache.js");

var _ScriptCache3 = _interopRequireDefault(_ScriptCache2);

var _SessionUtils2 = __webpack_require__("./sdk/scripts/utils/SessionUtils.js");

var _SessionUtils3 = _interopRequireDefault(_SessionUtils2);

var _StringUtils2 = __webpack_require__("./sdk/scripts/utils/StringUtils.js");

var _StringUtils3 = _interopRequireDefault(_StringUtils2);

var _Types2 = __webpack_require__("./sdk/scripts/utils/Types.js");

var _Types3 = _interopRequireDefault(_Types2);

var _UrlUtils2 = __webpack_require__("./sdk/scripts/utils/UrlUtils.js");

var _UrlUtils3 = _interopRequireDefault(_UrlUtils2);

var _Utils2 = __webpack_require__("./sdk/scripts/utils/Utils.js");

var _Utils3 = _interopRequireDefault(_Utils2);

var _Validation2 = __webpack_require__("./sdk/scripts/utils/Validation.js");

var _Validation3 = _interopRequireDefault(_Validation2);

var _ViewUtils2 = __webpack_require__("./sdk/scripts/utils/ViewUtils.js");

var _ViewUtils3 = _interopRequireDefault(_ViewUtils2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ApiErrorUtils = _ApiErrorUtils3.default;
exports.ArrayUtils = _ArrayUtils3.default;
exports.BitUtils = _BitUtils3.default;
exports.BookingUtils = _BookingUtils3.default;
exports.BookingViewUtils = _BookingViewUtils3.default;
exports.CountryData = _CountryData3.default;
exports.CurrencyUtils = _CurrencyUtils3.default;
exports.DateUtils = _DateUtils3.default;
exports.Diacritics = _Diacritics3.default;
exports.Equals = _Equals3.default;
exports.GeolocUtils = _GeolocUtils3.default;
exports.GmapUtils = _GmapUtils3.default;
exports.GoogleApi = _GoogleApi3.default;
exports.Logger = _Logger3.default;
exports.Notify = _Notify3.default;
exports.Listener = _Listener3.default; // TODO: deprecated

exports.OrderViewUtils = _OrderViewUtils3.default;
exports.PhoneUtils = _PhoneUtils3.default;
exports.ScriptCache = _ScriptCache3.default;
exports.SessionUtils = _SessionUtils3.default;
exports.StringUtils = _StringUtils3.default;
exports.Types = _Types3.default;
exports.UrlUtils = _UrlUtils3.default;
exports.Utils = _Utils3.default;
exports.Validation = _Validation3.default;
exports.ViewUtils = _ViewUtils3.default;

/***/ }),

/***/ "./sdk/scripts/utils/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = "production";

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "./styles/main.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},["./scripts/app.js"]);


// WEBPACK FOOTER //
// app.bundle.js